var Yl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Hy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Py = "Expected a function", jB = 0 / 0, L1 = "[object Symbol]", U1 = /^\s+|\s+$/g, O1 = /^[-+]0x[0-9a-f]+$/i, H1 = /^0b[01]+$/i, P1 = /^0o[0-7]+$/i, Y1 = parseInt, J1 = typeof Yl == "object" && Yl && Yl.Object === Object && Yl, K1 = typeof self == "object" && self && self.Object === Object && self, W1 = J1 || K1 || Function("return this")(), V1 = Object.prototype, j1 = V1.toString, q1 = Math.max, z1 = Math.min, Ku = function() {
  return W1.Date.now();
};
function Z1(e, t, i) {
  var n, A, s, o, r, a, l = 0, c = !1, g = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError(Py);
  t = qB(t) || 0, rg(i) && (c = !!i.leading, g = "maxWait" in i, s = g ? q1(qB(i.maxWait) || 0, t) : s, h = "trailing" in i ? !!i.trailing : h);
  function u(D) {
    var Q = n, p = A;
    return n = A = void 0, l = D, o = e.apply(p, Q), o;
  }
  function d(D) {
    return l = D, r = setTimeout(C, t), c ? u(D) : o;
  }
  function f(D) {
    var Q = D - a, p = D - l, w = t - Q;
    return g ? z1(w, s - p) : w;
  }
  function I(D) {
    var Q = D - a, p = D - l;
    return a === void 0 || Q >= t || Q < 0 || g && p >= s;
  }
  function C() {
    var D = Ku();
    if (I(D))
      return E(D);
    r = setTimeout(C, f(D));
  }
  function E(D) {
    return r = void 0, h && n ? u(D) : (n = A = void 0, o);
  }
  function B() {
    r !== void 0 && clearTimeout(r), l = 0, n = a = A = r = void 0;
  }
  function m() {
    return r === void 0 ? o : E(Ku());
  }
  function y() {
    var D = Ku(), Q = I(D);
    if (n = arguments, A = this, a = D, Q) {
      if (r === void 0)
        return d(a);
      if (g)
        return r = setTimeout(C, t), u(a);
    }
    return r === void 0 && (r = setTimeout(C, t)), o;
  }
  return y.cancel = B, y.flush = m, y;
}
function $1(e, t, i) {
  var n = !0, A = !0;
  if (typeof e != "function")
    throw new TypeError(Py);
  return rg(i) && (n = "leading" in i ? !!i.leading : n, A = "trailing" in i ? !!i.trailing : A), Z1(e, t, {
    leading: n,
    maxWait: t,
    trailing: A
  });
}
function rg(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function X1(e) {
  return !!e && typeof e == "object";
}
function tF(e) {
  return typeof e == "symbol" || X1(e) && j1.call(e) == L1;
}
function qB(e) {
  if (typeof e == "number")
    return e;
  if (tF(e))
    return jB;
  if (rg(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = rg(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(U1, "");
  var i = H1.test(e);
  return i || P1.test(e) ? Y1(e.slice(2), i ? 2 : 8) : O1.test(e) ? jB : +e;
}
var eF = $1;
const Vd = /* @__PURE__ */ Hy(eF);
var dn;
(function(e) {
  e.FLAT_JSON = "FlatJSON", e.DSV_STR = "DSVStr", e.DSV_ARR = "DSVArr", e.AUTO = "Auto";
})(dn || (dn = {}));
function ne(e) {
  return e instanceof Date ? e : new Date(e);
}
function Jl(e) {
  return e < 10 ? `0${e}` : e;
}
RegExp.escape = function(e) {
  return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};
function mt(e) {
  this.format = e, this.dtParams = void 0, this.nativeDate = void 0;
}
mt.TOKEN_PREFIX = "%";
mt.DATETIME_PARAM_SEQUENCE = {
  YEAR: 0,
  MONTH: 1,
  DAY: 2,
  HOUR: 3,
  MINUTE: 4,
  SECOND: 5,
  MILLISECOND: 6
};
mt.defaultNumberParser = function(e) {
  return function(t) {
    let i;
    return isFinite(i = parseInt(t, 10)) ? i : e;
  };
};
mt.defaultRangeParser = function(e, t) {
  return (i) => {
    let n, A;
    if (!i)
      return t;
    const s = i.toLowerCase();
    for (n = 0, A = e.length; n < A; n++)
      if (e[n].toLowerCase() === s)
        return n;
    return n === void 0 ? t : null;
  };
};
mt.getTokenDefinitions = function() {
  const e = {
    short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    long: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, t = {
    short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    long: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  };
  return {
    H: {
      // 24 hours format
      name: "H",
      index: 3,
      extract() {
        return "(\\d+)";
      },
      parser: mt.defaultNumberParser(),
      formatter(n, A) {
        const s = ne(n);
        return A ? s.getUTCHours().toString() : s.getHours().toString();
      }
    },
    l: {
      // 12 hours format
      name: "l",
      index: 3,
      extract() {
        return "(\\d+)";
      },
      parser: mt.defaultNumberParser(),
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCHours() % 12 : s.getHours() % 12;
        return (o === 0 ? 12 : o).toString();
      }
    },
    p: {
      // AM or PM
      name: "p",
      index: 3,
      extract() {
        return "(AM|PM)";
      },
      parser: (n) => n ? n.toLowerCase() : null,
      formatter: (n, A) => {
        const s = ne(n);
        return (A ? s.getUTCHours() : s.getHours()) < 12 ? "AM" : "PM";
      }
    },
    P: {
      // am or pm
      name: "P",
      index: 3,
      extract() {
        return "(am|pm)";
      },
      parser: (n) => n ? n.toLowerCase() : null,
      formatter: (n, A) => {
        const s = ne(n);
        return (A ? s.getUTCHours() : s.getHours()) < 12 ? "am" : "pm";
      }
    },
    M: {
      // Two digit minutes 00 - 59
      name: "M",
      index: 4,
      extract() {
        return "(\\d+)";
      },
      parser: mt.defaultNumberParser(),
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCMinutes() : s.getMinutes();
        return Jl(o);
      }
    },
    S: {
      // Two digit seconds 00 - 59
      name: "S",
      index: 5,
      extract() {
        return "(\\d+)";
      },
      parser: mt.defaultNumberParser(),
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCSeconds() : s.getSeconds();
        return Jl(o);
      }
    },
    K: {
      // Milliseconds
      name: "K",
      index: 6,
      extract() {
        return "(\\d+)";
      },
      parser: mt.defaultNumberParser(),
      formatter(n) {
        return ne(n).getMilliseconds().toString();
      }
    },
    a: {
      // Short name of day, like Mon
      name: "a",
      index: 2,
      extract() {
        return `(${e.short.join("|")})`;
      },
      parser: mt.defaultRangeParser(e.short),
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCDay() : s.getDay();
        return e.short[o].toString();
      }
    },
    A: {
      // Long name of day, like Monday
      name: "A",
      index: 2,
      extract() {
        return `(${e.long.join("|")})`;
      },
      parser: mt.defaultRangeParser(e.long),
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCDay() : s.getDay();
        return e.long[o].toString();
      }
    },
    e: {
      // 8 of March, 11 of November
      name: "e",
      index: 2,
      extract() {
        return `(\\d+) of (${t.long.join("|")})`;
      },
      parser: mt.defaultNumberParser(),
      formatter(n, A) {
        const s = ne(n);
        return (A ? s.getUTCDate() : s.getDate()).toString();
      }
    },
    d: {
      // 08 of March, 11 of November, 8 of March
      name: "d",
      index: 2,
      extract() {
        return "(\\d+)";
      },
      parser: mt.defaultNumberParser(),
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCDate() : s.getDate();
        return Jl(o);
      }
    },
    b: {
      // Short month, like Jan
      name: "b",
      index: 1,
      extract() {
        return `(${t.short.join("|")})`;
      },
      parser: mt.defaultRangeParser(t.short),
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCMonth() : s.getMonth();
        return t.short[o].toString();
      }
    },
    B: {
      // Long month, like January
      name: "B",
      index: 1,
      extract() {
        return `(${t.long.join("|")})`;
      },
      parser: mt.defaultRangeParser(t.long),
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCMonth() : s.getMonth();
        return t.long[o].toString();
      }
    },
    m: {
      // Two digit month of year like 01 for January
      name: "m",
      index: 1,
      extract() {
        return "(\\d+)";
      },
      parser(n) {
        return mt.defaultNumberParser()(n) - 1;
      },
      formatter(n, A) {
        const s = ne(n), o = A ? s.getUTCMonth() : s.getMonth();
        return Jl(o + 1);
      }
    },
    y: {
      // Short year like 90 for 1990
      name: "y",
      index: 0,
      extract() {
        return "(\\d{2})";
      },
      parser(n) {
        let A;
        if (n) {
          const a = n.length;
          n = n.substring(a - 2, a);
        }
        const s = mt.defaultNumberParser()(n), o = /* @__PURE__ */ new Date(), r = Math.trunc(o.getFullYear() / 100);
        return A = `${r}${s}`, ne(A).getFullYear() > o.getFullYear() && (A = `${r - 1}${s}`), ne(A).getFullYear();
      },
      formatter(n, A) {
        const s = ne(n);
        let o = A ? s.getUTCFullYear().toString() : s.getFullYear().toString(), r;
        return o && (r = o.length, o = o.substring(r - 2, r)), o;
      }
    },
    Y: {
      // Long year like 1990
      name: "Y",
      index: 0,
      extract() {
        return "(\\d{4})";
      },
      parser: mt.defaultNumberParser(),
      formatter(n, A) {
        const s = ne(n);
        return A ? s.getUTCFullYear().toString() : s.getFullYear().toString();
      }
    }
  };
};
mt.getTokenFormalNames = function() {
  const e = mt.getTokenDefinitions();
  return {
    HOUR: e.H,
    HOUR_12: e.l,
    AMPM_UPPERCASE: e.p,
    AMPM_LOWERCASE: e.P,
    MINUTE: e.M,
    SECOND: e.S,
    SHORT_DAY: e.a,
    LONG_DAY: e.A,
    DAY_OF_MONTH: e.e,
    DAY_OF_MONTH_CONSTANT_WIDTH: e.d,
    SHORT_MONTH: e.b,
    LONG_MONTH: e.B,
    MONTH_OF_YEAR: e.m,
    SHORT_YEAR: e.y,
    LONG_YEAR: e.Y
  };
};
mt.tokenResolver = function() {
  const e = mt.getTokenDefinitions(), t = (...i) => {
    let n = 0, A, s;
    const o = i.length;
    for (; n < o; n++)
      A = i[n], i[n] && (s = A);
    return s ? s[0].parser(s[1]) : null;
  };
  return {
    YEAR: [e.y, e.Y, t],
    MONTH: [e.b, e.B, e.m, t],
    DAY: [e.a, e.A, e.d, t],
    HOUR: [
      e.H,
      e.l,
      e.p,
      e.P,
      function(i, n, A, s) {
        let o, r, a, l;
        return n && (r = A || s) ? (r[0].parser(r[1]) === "pm" && (a = !0), o = n) : n ? o = n : o = i, o ? (l = o[0].parser(o[1]), a && (l += 12), l) : null;
      }
    ],
    MINUTE: [e.M, t],
    SECOND: [e.S, t],
    MILLISECOND: [e.K, t]
  };
};
mt.findTokens = function(e) {
  const t = mt.TOKEN_PREFIX, i = mt.getTokenDefinitions(), n = Object.keys(i), A = [];
  let s, o;
  for (; (s = e.indexOf(t, s + 1)) >= 0; )
    o = e[s + 1], n.indexOf(o) !== -1 && A.push({
      index: s,
      token: o
    });
  return A;
};
mt.formatAs = function(e, t, i = {}) {
  const n = ne(e), A = mt.findTokens(t), s = mt.getTokenDefinitions();
  let o = String(t);
  const r = mt.TOKEN_PREFIX;
  let a, l, c, g;
  for (c = 0, g = A.length; c < g; c++)
    a = A[c].token, l = s[a].formatter(n, i.useUTC), o = o.replace(new RegExp(r + a, "g"), l);
  return o;
};
mt.prototype.parse = function(e, t) {
  const i = mt.tokenResolver(), n = this.extractTokenValue(e), A = mt.DATETIME_PARAM_SEQUENCE, s = t && t.noBreak, o = [], r = [];
  let a, l, c, g, h, u, d, f;
  const I = [];
  for (a in i)
    if ({}.hasOwnProperty.call(i, a)) {
      for (r.length = 0, l = i[a], c = l.splice(l.length - 1, 1)[0], h = 0, f = l.length; h < f; h++)
        u = l[h], g = n[u.name], g === void 0 ? r.push(null) : r.push([u, g]);
      if (d = c.apply(this, r), d == null && !s)
        break;
      o[A[a]] = d;
    }
  return o.length && this.checkIfOnlyYear(o.length) ? I.unshift(o[0], 0, 1) : I.unshift(...o), I;
};
mt.prototype.extractTokenValue = function(e) {
  const t = this.format, i = mt.getTokenDefinitions(), n = mt.TOKEN_PREFIX, A = mt.findTokens(t), s = {};
  let o, r, a, l, c, g, h;
  c = String(t);
  const u = A.map((I) => I.token), d = A.length;
  for (h = d - 1; h >= 0; h--) {
    if (a = A[h].index, a + 1 === c.length - 1) {
      o = a;
      continue;
    }
    o === void 0 && (o = c.length), l = c.substring(a + 2, o), c = c.substring(0, a + 2) + RegExp.escape(l) + c.substring(o, c.length), o = a;
  }
  for (h = 0; h < d; h++)
    r = A[h], c = c.replace(n + r.token, i[r.token].extract());
  const f = e?.match(new RegExp(c)) || [];
  for (f.shift(), h = 0, g = u.length; h < g; h++)
    s[u[h]] = f[h];
  return s;
};
mt.prototype.getNativeDate = function(e) {
  let t = null, i = !this.format || typeof this.format != "string";
  if (Number.isFinite(e) && i)
    t = new Date(e);
  else if (i)
    t = new Date(e);
  else {
    const n = this.dtParams = this.parse(e);
    n.length && (this.nativeDate = new Date(...n), t = this.nativeDate);
  }
  return t;
};
mt.prototype.checkIfOnlyYear = function(e) {
  return e === 1 && this.format.match(/y|Y/g).length;
};
const Yy = (e) => {
  let t = 0;
  return (...i) => {
    i.forEach((n, A) => {
      e[A] instanceof Array || (e[A] = Array.from({ length: t })), e[A].push(n);
    }), t++;
  };
};
function Wu(e) {
  return Array.isArray(e);
}
function iF(e) {
  return e === Object(e);
}
function nF(e) {
  return typeof e == "string";
}
const AF = (e) => nF(e) ? dn.DSV_STR : Wu(e) && Wu(e[0]) ? dn.DSV_ARR : Wu(e) && (e.length === 0 || iF(e[0])) ? dn.FLAT_JSON : null;
var yA = /* @__PURE__ */ new Map(), sF = function(e) {
  if (e == null || e === "")
    throw new Error("Please give a promise id");
  if (yA.has(e))
    throw new Error("A promise with " + e + " id already exists, please destroy or resolve or reject it first");
  return new Promise(function(t, i) {
    yA.set(e, {
      doResolve: t,
      doReject: i
    });
  });
}, oF = function(e, t) {
  if (yA.has(e)) {
    var i = yA.get(e), n = i.doResolve, A = i.doReject;
    yA.delete(e), Promise.resolve(t).then(function(s) {
      n(s);
    }).catch(function(s) {
      A(s);
    });
  }
}, rF = function(e, t) {
  if (yA.has(e)) {
    var i = yA.get(e).doReject;
    yA.delete(e), i(t);
  }
};
let Kl;
const aF = new Uint8Array(16);
function lF() {
  if (!Kl && (Kl = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Kl))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Kl(aF);
}
const pe = [];
for (let e = 0; e < 256; ++e)
  pe.push((e + 256).toString(16).slice(1));
function cF(e, t = 0) {
  return pe[e[t + 0]] + pe[e[t + 1]] + pe[e[t + 2]] + pe[e[t + 3]] + "-" + pe[e[t + 4]] + pe[e[t + 5]] + "-" + pe[e[t + 6]] + pe[e[t + 7]] + "-" + pe[e[t + 8]] + pe[e[t + 9]] + "-" + pe[e[t + 10]] + pe[e[t + 11]] + pe[e[t + 12]] + pe[e[t + 13]] + pe[e[t + 14]] + pe[e[t + 15]];
}
const gF = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), zB = {
  randomUUID: gF
};
function hF(e, t, i) {
  if (zB.randomUUID && !t && !e)
    return zB.randomUUID();
  e = e || {};
  const n = e.random || (e.rng || lF)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, t) {
    i = i || 0;
    for (let A = 0; A < 16; ++A)
      t[i + A] = n[A];
    return t;
  }
  return cF(n);
}
const uF = 64, dF = (e) => e.isFree, fF = (e) => {
  const t = () => e.find(dF), i = () => {
    const A = t();
    return new Promise((s) => {
      if (A == null) {
        const o = setInterval(() => {
          const r = t();
          r != null && (r.isFree = !1, clearInterval(o), s(r));
        }, uF);
      } else
        A.isFree = !1, s(A);
    });
  };
  return (A) => {
    const s = hF(), o = sF(s);
    return i().then((r) => {
      const { worker: a } = r;
      a.addEventListener("message", (l) => {
        const { reqId: c, data: g } = l.data;
        r.isFree = !0, g.error ? rF(c, new Error(g.error)) : oF(c, g.data);
      }), a.postMessage({
        data: A,
        reqId: s,
        type: "transform-data"
      });
    }), o;
  };
}, IF = (e, t) => fF(t)(e);
var ZB = {}, Vu = {}, ju = 34, Ur = 10, qu = 13;
function Jy(e) {
  return new Function("d", "return {" + e.map(function(t, i) {
    return JSON.stringify(t) + ": d[" + i + '] || ""';
  }).join(",") + "}");
}
function CF(e, t) {
  var i = Jy(e);
  return function(n, A) {
    return t(i(n), A, e);
  };
}
function $B(e) {
  var t = /* @__PURE__ */ Object.create(null), i = [];
  return e.forEach(function(n) {
    for (var A in n)
      A in t || i.push(t[A] = A);
  }), i;
}
function ti(e, t) {
  var i = e + "", n = i.length;
  return n < t ? new Array(t - n + 1).join(0) + i : i;
}
function EF(e) {
  return e < 0 ? "-" + ti(-e, 6) : e > 9999 ? "+" + ti(e, 6) : ti(e, 4);
}
function BF(e) {
  var t = e.getUTCHours(), i = e.getUTCMinutes(), n = e.getUTCSeconds(), A = e.getUTCMilliseconds();
  return isNaN(e) ? "Invalid Date" : EF(e.getUTCFullYear()) + "-" + ti(e.getUTCMonth() + 1, 2) + "-" + ti(e.getUTCDate(), 2) + (A ? "T" + ti(t, 2) + ":" + ti(i, 2) + ":" + ti(n, 2) + "." + ti(A, 3) + "Z" : n ? "T" + ti(t, 2) + ":" + ti(i, 2) + ":" + ti(n, 2) + "Z" : i || t ? "T" + ti(t, 2) + ":" + ti(i, 2) + "Z" : "");
}
function mF(e) {
  var t = new RegExp('["' + e + `
\r]`), i = e.charCodeAt(0);
  function n(g, h) {
    var u, d, f = A(g, function(I, C) {
      if (u)
        return u(I, C - 1);
      d = I, u = h ? CF(I, h) : Jy(I);
    });
    return f.columns = d || [], f;
  }
  function A(g, h) {
    var u = [], d = g.length, f = 0, I = 0, C, E = d <= 0, B = !1;
    g.charCodeAt(d - 1) === Ur && --d, g.charCodeAt(d - 1) === qu && --d;
    function m() {
      if (E)
        return Vu;
      if (B)
        return B = !1, ZB;
      var D, Q = f, p;
      if (g.charCodeAt(Q) === ju) {
        for (; f++ < d && g.charCodeAt(f) !== ju || g.charCodeAt(++f) === ju; )
          ;
        return (D = f) >= d ? E = !0 : (p = g.charCodeAt(f++)) === Ur ? B = !0 : p === qu && (B = !0, g.charCodeAt(f) === Ur && ++f), g.slice(Q + 1, D - 1).replace(/""/g, '"');
      }
      for (; f < d; ) {
        if ((p = g.charCodeAt(D = f++)) === Ur)
          B = !0;
        else if (p === qu)
          B = !0, g.charCodeAt(f) === Ur && ++f;
        else if (p !== i)
          continue;
        return g.slice(Q, D);
      }
      return E = !0, g.slice(Q, d);
    }
    for (; (C = m()) !== Vu; ) {
      for (var y = []; C !== ZB && C !== Vu; )
        y.push(C), C = m();
      h && (y = h(y, I++)) == null || u.push(y);
    }
    return u;
  }
  function s(g, h) {
    return g.map(function(u) {
      return h.map(function(d) {
        return c(u[d]);
      }).join(e);
    });
  }
  function o(g, h) {
    return h == null && (h = $B(g)), [h.map(c).join(e)].concat(s(g, h)).join(`
`);
  }
  function r(g, h) {
    return h == null && (h = $B(g)), s(g, h).join(`
`);
  }
  function a(g) {
    return g.map(l).join(`
`);
  }
  function l(g) {
    return g.map(c).join(e);
  }
  function c(g) {
    return g == null ? "" : g instanceof Date ? BF(g) : t.test(g += "") ? '"' + g.replace(/"/g, '""') + '"' : g;
  }
  return {
    parse: n,
    parseRows: A,
    format: o,
    formatBody: r,
    formatRows: a,
    formatRow: l,
    formatValue: c
  };
}
var Ct;
(function(e) {
  e.MEASURE = "measure", e.DIMENSION = "dimension";
})(Ct || (Ct = {}));
var it;
(function(e) {
  e.CATEGORICAL = "categorical", e.TEMPORAL = "temporal", e.BINNED = "binned", e.CONTINUOUS = "continuous", e.ROWID = "__id";
})(it || (it = {}));
const jd = "__id__", QF = (e) => e === Ct.MEASURE ? 1 : 0, pF = {
  categorical: 0,
  continuous: 1,
  temporal: 2,
  __id: 3,
  binned: 4
}, yF = (e) => pF[e], DF = (e) => e === Ct.MEASURE ? it.CONTINUOUS : it.CATEGORICAL;
class wF {
  constructor() {
    this._type = it.CATEGORICAL;
  }
  get type() {
    return this._type;
  }
  /**
   * Parses a single value to string if not already in string format
   *
   * @public
   * @param {string|number} val - The value of the field.
   * @return {string} Returns the string representation of the value.
   */
  parse(t) {
    return typeof t == "number" ? String(t) : t;
  }
}
const Ky = (e) => !e && e !== 0 ? NaN : (typeof e == "string" && e.includes(",") && (e = e.replace(/,/g, "")), Number(e));
class xF {
  constructor() {
    this._type = it.CONTINUOUS;
  }
  get type() {
    return this._type;
  }
  /*
   * Parses a single value to number if not already in number format
   *
   * @public
   * @param {string|number} val - The value of the field.
   * @return {number} Returns the number representation of the value.
   */
  parse(t) {
    return Ky(t);
  }
}
var Gt;
(function(e) {
  e.SELECT = "select", e.GROUPBY = "groupBy", e.PROJECT = "project", e.SPLIT = "split", e.SORT = "sort", e.CALCULATE = "calculate_variable";
})(Gt || (Gt = {}));
const SF = "default", MF = "b29153703d1b02bf5f662b2a10f00c2af68d728fa52fd3af777cd6f7c3b59b7e";
class _F {
  constructor() {
    this._type = it.TEMPORAL;
  }
  get type() {
    return this._type;
  }
  /**
   * Parses a single value of a field and returns the millisecond value.
   *
   * @public
   * @param {string|number} val - The value of the field.
   * @return {number} Returns the millisecond value.
   */
  parse(t, i) {
    let n = SF;
    if (this._dtf = {}, !t && typeof t != "number")
      return NaN;
    let A = t;
    i && typeof i == "string" ? (A = String(t), n = i, (!this._dtf || !this._dtf[n]) && (this._dtf[n] = new mt(n))) : (A = Number(t), (!this._dtf || !this._dtf.default) && (this._dtf.default = new mt()));
    const s = this._dtf[n].getNativeDate(A);
    return s ? s.getTime() : NaN;
  }
}
class bF {
  constructor() {
    this._type = it.BINNED;
  }
  get type() {
    return this._type;
  }
  /*
   * Parses a single value to number if not already in number format
   *
   * @public
   * @param {string|number} val - The value of the field.
   * @return {number} Returns the number representation of the value.
   */
  parse(t) {
    return Ky(t);
  }
}
class NF {
  constructor() {
    this.store = /* @__PURE__ */ new Map(), this.parsers(this._getDefaultParsers());
  }
  _getDefaultParsers() {
    return [new wF(), new xF(), new _F(), new bF()];
  }
  /**
   * Sets the given parsers in the store and returns the store
   * @param  {Array<FieldContract>} parsers : contains array of parsers instance
   * @return {Map<string, FieldContract>}
   */
  parsers(t) {
    return t.forEach((i) => this.register(i)), this.store;
  }
  /**
   * Registers a parsers
   * @param {DataConverter} parser : parser Instance
   */
  register(t) {
    return this.store.set(t._type, t), this;
  }
  /**
   * Removes a parser from store
   * @param {FieldContract} parser : parser Instance
   */
  unregister(t) {
    return this.store.delete(t._type), this;
  }
  get(t) {
    return t && this.store.has(t) ? this.store.get(t) : null;
  }
}
const yo = (() => {
  let e = null;
  function t() {
    return e = new NF(), e;
  }
  return e || t();
})();
function bI(e, t, i) {
  if (!Array.isArray(t))
    throw new Error("Schema missing or is in an unsupported format");
  const n = {
    firstRowHeader: !0
  }, A = t.map((l) => l.name);
  i = Object.assign({}, n, i);
  const s = [[]], o = Yy(s);
  let r = A;
  i.firstRowHeader && (r = e.splice(0, 1)[0]);
  const a = r.reduce((l, c, g) => (Object.assign(l, { [c]: g }), l), {});
  return e.forEach((l) => {
    const c = [];
    return t.forEach((g) => {
      const { name: h, type: u, format: d = (B) => B } = g;
      let { subtype: f = it.CATEGORICAL } = g;
      u === Ct.MEASURE && (f = it.CONTINUOUS);
      const I = yo.get(f), C = a[h], E = I ? I.parse(l[C], d) : l[C];
      c.push(E);
    }), o(...c);
  }), {
    data: s,
    schema: t
  };
}
function Wy(e, t, i) {
  if (i = Object.assign({}, {
    firstRowHeader: !0,
    fieldSeparator: ","
  }, i), i.fieldSeparator) {
    const A = mF(i.fieldSeparator);
    return bI(A.parseRows(e), t, i);
  }
  return { schema: [], data: [] };
}
class FF {
  constructor() {
    this._type = dn.DSV_STR;
  }
  get type() {
    return this._type;
  }
  convert(t, i, n) {
    return Wy(t, i, n);
  }
}
function Vy(e, t) {
  if (!Array.isArray(t))
    throw new Error("Schema missing or is in an unsupported format");
  const i = {};
  let n = 0, A;
  const s = [[]], o = Yy(s);
  return e.forEach((r) => {
    const a = [];
    t.forEach((l) => {
      const { name: c, type: g, format: h = (I) => I } = l;
      let { subtype: u = it.CATEGORICAL } = l;
      g === Ct.MEASURE && (u = it.CONTINUOUS);
      const d = yo.get(u);
      c in i ? A = i[c] : (i[c] = n++, A = n - 1);
      const f = d ? d.parse(r[c], h) : r[c];
      a[A] = f;
    }), o(...a);
  }), {
    data: s,
    schema: t
  };
}
class RF {
  constructor() {
    this._type = dn.FLAT_JSON;
  }
  get type() {
    return this._type;
  }
  convert(t, i) {
    return Vy(t, i);
  }
}
class kF {
  constructor() {
    this._type = dn.DSV_ARR;
  }
  get type() {
    return this._type;
  }
  convert(t, i, n) {
    return bI(t, i, n);
  }
}
function TF(e, t, i) {
  const n = { FlatJSON: Vy, DSVStr: Wy, DSVArr: bI }, A = AF(e);
  if (!A)
    throw new Error("Could not detect the data format");
  return n[A](e, t, i);
}
class vF {
  constructor() {
    this._type = dn.AUTO;
  }
  get type() {
    return this._type;
  }
  convert(t, i, n) {
    return TF(t, i, n);
  }
}
class GF {
  constructor() {
    this.store = /* @__PURE__ */ new Map(), this.converters(this._getDefaultConverters());
  }
  _getDefaultConverters() {
    return [new FF(), new kF(), new RF(), new vF()];
  }
  /**
   * Sets the given converters in the store and returns the store
   * @param  {Array<DataConverter>} converters : contains array of converter instance
   * @return { Map<String,DataConverter> }
   */
  converters(t) {
    return t.forEach((i) => this.store.set(i._type, i)), this.store;
  }
  /**
   * Registers a Converter of type DataConverter
   * @param {DataConverter} converter : converter Instance
   * @returns self
   */
  register(t) {
    return this.store.set(t._type, t), this;
  }
  /**
   * Removes a converter from store
   * @param {DataConverter} converter : converter Instance
   * @returns self
   */
  unregister(t) {
    return this.store.delete(t._type), this;
  }
  get(t) {
    return t && this.store.has(t) ? this.store.get(t) : null;
  }
}
const LF = (() => {
  let e = null;
  function t() {
    return e = new GF(), e;
  }
  return e || t();
})(), jy = (e) => {
  const { data: t, schema: i, options: n } = e, A = LF.get(n.dataFormat);
  return A ? A.convert(t, i, n) : { data: [], schema: i };
}, UF = (e, t) => {
  const { options: i } = e;
  return t && i.useWorker !== !1 ? IF(e, t) : new Promise((n, A) => {
    setTimeout(() => {
      try {
        n(jy(e));
      } catch (s) {
        A(s);
      }
    }, 0);
  });
}, OF = async (e, t, i, n) => {
  const A = {
    dataFormat: dn.AUTO
  };
  return i = Object.assign(Object.assign({}, A), i), await UF({ data: e, schema: t, options: i }, n);
}, XB = async (e, t) => {
  const { data: i, schema: n, options: A } = e;
  return await OF(i, n, A, t);
}, HF = (e, t, i = {}) => {
  const n = [], A = t.map((r) => {
    n.push({ ...r });
    const a = { ...r }, { format: l } = a;
    return l && typeof l == "function" && delete a.format, a;
  }), s = {
    dataFormat: dn.AUTO
  };
  i = Object.assign(Object.assign({}, s), i);
  const o = jy({ data: e, schema: A, options: i });
  return o.schema = n, o;
};
class Ft {
  // static _defaults: Record<InvalidAwareType, Function>;
  /**
   * Initialize a new instance.
   *
   * @public
   * @param {string} value - The value of the invalid data type.
   */
  constructor(t) {
    this._value = t;
  }
  /**
   * Returns the current value of the instance.
   *
   * @public
   * @return {string} Returns the value of the invalid data type.
   */
  value() {
    return this._value;
  }
  /**
   * Returns the current value of the instance in string format.
   *
   * @public
   * @return {string} Returns the value of the invalid data type.
   */
  toString() {
    return String(this._value);
  }
}
var Vn;
(function(e) {
  e.ASC = "asc", e.DESC = "desc", e.NO_ORDER = "";
})(Vn || (Vn = {}));
const qy = (e) => e === Vn.DESC ? 1 : e === Vn.NO_ORDER ? 3 : 0;
var ve;
(function(e) {
  e.NORMAL = "normal", e.INVERSE = "inverse", e.ALL = "all";
})(ve || (ve = {}));
const tm = (e) => ({
  normal: 1,
  inverse: 2,
  all: 3
})[e];
var ag;
(function(e) {
  e.SUM = "sum", e.AVG = "avg", e.MIN = "min", e.MAX = "max", e.FIRST = "first", e.LAST = "last", e.COUNT = "count", e.STD = "std";
})(ag || (ag = {}));
const zy = (e) => ({
  sum: 0,
  avg: 1,
  count: 3,
  min: 4,
  max: 5,
  std: 6
})[e];
var ni;
(function(e) {
  e.EQUAL = "eq", e.NOT_EQUAL = "neq", e.GREATER_THAN = "gt", e.LESS_THAN = "lt", e.GREATER_THAN_EQUAL = "gte", e.LESS_THAN_EQUAL = "lte", e.IN = "in", e.NIN = "nin", e.EQUAL_TO = "eq", e.NOT_EQUAL_TO = "neq";
})(ni || (ni = {}));
var Hn;
(function(e) {
  e.AND = "and", e.OR = "or";
})(Hn || (Hn = {}));
const em = (e) => {
  const i = {
    eq: 1,
    neq: 2,
    gt: 3,
    lt: 4,
    gte: 5,
    lte: 6,
    in: 9,
    nin: 10,
    and: 7,
    or: 8
  }[e];
  return i !== void 0 ? i : -1;
}, PF = 1;
function YF() {
  var e, t;
  if (typeof window < "u") {
    const i = Math.min((t = (e = window.navigator) === null || e === void 0 ? void 0 : e.hardwareConcurrency) !== null && t !== void 0 ? t : PF, 4);
    return window.Worker != null ? Array.from({ length: i }).map(() => ({
      isFree: !0,
      worker: new Worker(new URL("/assets/transform-data-worker-e5e32f12.js", self.location), {
        type: "module"
      })
    })) : void 0;
  }
}
const JF = "data:application/wasm;base64,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", KF = async (e = {}, t) => {
  let i;
  if (t.startsWith("data:")) {
    const n = t.replace(/^data:.*?base64,/, "");
    let A;
    if (typeof Buffer == "function" && typeof Buffer.from == "function")
      A = Buffer.from(n, "base64");
    else if (typeof atob == "function") {
      const s = atob(n);
      A = new Uint8Array(s.length);
      for (let o = 0; o < s.length; o++)
        A[o] = s.charCodeAt(o);
    } else
      throw new Error("Cannot decode base64-encoded data URL");
    i = await WebAssembly.instantiate(A, e);
  } else {
    const n = await fetch(t), A = n.headers.get("Content-Type") || "";
    if ("instantiateStreaming" in WebAssembly && A.startsWith("application/wasm"))
      i = await WebAssembly.instantiateStreaming(n, e);
    else {
      const s = await n.arrayBuffer();
      i = await WebAssembly.instantiate(s, e);
    }
  }
  return i.instance.exports;
};
let X;
function WF(e) {
  X = e;
}
const Ki = new Array(128).fill(void 0);
Ki.push(void 0, null, !0, !1);
function Zy(e) {
  return Ki[e];
}
let pa = Ki.length;
function VF(e) {
  e < 132 || (Ki[e] = pa, pa = e);
}
function jF(e) {
  const t = Zy(e);
  return VF(e), t;
}
let Zo = 0, Wl = null;
function Tc() {
  return (Wl === null || Wl.byteLength === 0) && (Wl = new Uint8Array(X.memory.buffer)), Wl;
}
const qF = typeof TextEncoder > "u" ? (0, module.require)("util").TextEncoder : TextEncoder;
let vc = new qF("utf-8");
const zF = typeof vc.encodeInto == "function" ? function(e, t) {
  return vc.encodeInto(e, t);
} : function(e, t) {
  const i = vc.encode(e);
  return t.set(i), {
    read: e.length,
    written: i.length
  };
};
function ZF(e, t, i) {
  if (i === void 0) {
    const r = vc.encode(e), a = t(r.length, 1) >>> 0;
    return Tc().subarray(a, a + r.length).set(r), Zo = r.length, a;
  }
  let n = e.length, A = t(n, 1) >>> 0;
  const s = Tc();
  let o = 0;
  for (; o < n; o++) {
    const r = e.charCodeAt(o);
    if (r > 127)
      break;
    s[A + o] = r;
  }
  if (o !== n) {
    o !== 0 && (e = e.slice(o)), A = i(A, n, n = o + e.length * 3, 1) >>> 0;
    const r = Tc().subarray(A + o, A + n), a = zF(e, r);
    o += a.written;
  }
  return Zo = o, A;
}
let Vl = null;
function jt() {
  return (Vl === null || Vl.byteLength === 0) && (Vl = new Int32Array(X.memory.buffer)), Vl;
}
const $F = typeof TextDecoder > "u" ? (0, module.require)("util").TextDecoder : TextDecoder;
let $y = new $F("utf-8", { ignoreBOM: !0, fatal: !0 });
$y.decode();
function yr(e, t) {
  return e = e >>> 0, $y.decode(Tc().subarray(e, e + t));
}
function qd(e, t) {
  if (!(e instanceof t))
    throw new Error(`expected instance of ${t.name}`);
  return e.ptr;
}
let jl = null;
function Xy() {
  return (jl === null || jl.byteLength === 0) && (jl = new Float64Array(X.memory.buffer)), jl;
}
function im(e, t) {
  const i = t(e.length * 8, 8) >>> 0;
  return Xy().set(e, i / 8), Zo = e.length, i;
}
function ql(e) {
  return e == null;
}
function XF(e, t, i, n, A, s, o, r, a) {
  qd(e, Ta);
  const l = im(s, X.__wbindgen_malloc), c = Zo, g = im(r, X.__wbindgen_malloc), h = Zo, u = X.stack_by(
    e.__wbg_ptr,
    t,
    i,
    n,
    A,
    l,
    c,
    !ql(o),
    ql(o) ? 0 : o,
    g,
    h,
    !ql(a),
    ql(a) ? 0 : a
  );
  return GI.__wrap(u);
}
function JA(e) {
  pa === Ki.length && Ki.push(Ki.length + 1);
  const t = pa;
  return pa = Ki[t], Ki[t] = e, t;
}
let ya = 128;
function nm(e) {
  if (ya == 1)
    throw new Error("out of js stack");
  return Ki[--ya] = e, ya;
}
function tR(e, t) {
  return e = e >>> 0, jt().subarray(e / 4, e / 4 + t);
}
let zl = null;
function eR() {
  return (zl === null || zl.byteLength === 0) && (zl = new Uint32Array(X.memory.buffer)), zl;
}
function iR(e, t) {
  return e = e >>> 0, eR().subarray(e / 4, e / 4 + t);
}
function lg(e, t) {
  return e = e >>> 0, Xy().subarray(e / 8, e / 8 + t);
}
const Am = new FinalizationRegistry((e) => X.__wbg_binnedfieldwrapper_free(e >>> 0));
class NI {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(NI.prototype);
    return i.__wbg_ptr = t, Am.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, Am.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_binnedfieldwrapper_free(t);
  }
  /**
   * @returns {string}
   */
  get_name() {
    let t, i;
    try {
      const s = X.__wbindgen_add_to_stack_pointer(-16);
      X.binnedfieldwrapper_get_name(s, this.__wbg_ptr);
      var n = jt()[s / 4 + 0], A = jt()[s / 4 + 1];
      return t = n, i = A, yr(n, A);
    } finally {
      X.__wbindgen_add_to_stack_pointer(16), X.__wbindgen_free(t, i, 1);
    }
  }
  /**
   * @returns {number}
   */
  get_data_ptr() {
    return X.binnedfieldwrapper_get_data_ptr(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_indices() {
    return X.binnedfieldwrapper_get_data_indices(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_info() {
    return X.binnedfieldwrapper_get_data_info(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_rows_count() {
    return X.binnedfieldwrapper_get_rows_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {number} row_index
   * @returns {number}
   */
  get_value_at_index(t) {
    return X.binnedfieldwrapper_get_value_at_index(this.__wbg_ptr, t);
  }
  /**
   * @returns {Float64Array}
   */
  get_domain() {
    try {
      const A = X.__wbindgen_add_to_stack_pointer(-16);
      X.binnedfieldwrapper_get_domain(A, this.__wbg_ptr);
      var t = jt()[A / 4 + 0], i = jt()[A / 4 + 1], n = lg(t, i).slice();
      return X.__wbindgen_free(t, i * 8), n;
    } finally {
      X.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * @returns {Float64Array}
   */
  get_uniques() {
    try {
      const A = X.__wbindgen_add_to_stack_pointer(-16);
      X.binnedfieldwrapper_get_uniques(A, this.__wbg_ptr);
      var t = jt()[A / 4 + 0], i = jt()[A / 4 + 1], n = lg(t, i).slice();
      return X.__wbindgen_free(t, i * 8), n;
    } finally {
      X.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const sm = new FinalizationRegistry(
  (e) => X.__wbg_categoricaldomainmeta_free(e >>> 0)
);
class FI {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(FI.prototype);
    return i.__wbg_ptr = t, sm.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, sm.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_categoricaldomainmeta_free(t);
  }
  /**
   * @returns {number}
   */
  get data_ptr() {
    return X.__wbg_get_categoricaldomainmeta_data_ptr(this.__wbg_ptr);
  }
  /**
   * @param {number} arg0
   */
  set data_ptr(t) {
    X.__wbg_set_categoricaldomainmeta_data_ptr(this.__wbg_ptr, t);
  }
  /**
   * @returns {number}
   */
  get data_len() {
    return X.__wbg_get_categoricaldomainmeta_data_len(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {number} arg0
   */
  set data_len(t) {
    X.__wbg_set_categoricaldomainmeta_data_len(this.__wbg_ptr, t);
  }
}
const om = new FinalizationRegistry(
  (e) => X.__wbg_categoricalfieldwrapper_free(e >>> 0)
);
class RI {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(RI.prototype);
    return i.__wbg_ptr = t, om.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, om.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_categoricalfieldwrapper_free(t);
  }
  /**
   * @returns {string}
   */
  get_name() {
    let t, i;
    try {
      const s = X.__wbindgen_add_to_stack_pointer(-16);
      X.categoricalfieldwrapper_get_name(s, this.__wbg_ptr);
      var n = jt()[s / 4 + 0], A = jt()[s / 4 + 1];
      return t = n, i = A, yr(n, A);
    } finally {
      X.__wbindgen_add_to_stack_pointer(16), X.__wbindgen_free(t, i, 1);
    }
  }
  /**
   * @returns {number}
   */
  get_data_indices() {
    return X.categoricalfieldwrapper_get_data_indices(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_info() {
    return X.categoricalfieldwrapper_get_data_info(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_rows_count() {
    return X.categoricalfieldwrapper_get_rows_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {number} row_index
   * @returns {number}
   */
  get_value_at_index(t) {
    return X.categoricalfieldwrapper_get_value_at_index(this.__wbg_ptr, t);
  }
  /**
   * @param {number} min_max_domain
   * @returns {CategoricalDomainMeta}
   */
  get_domain(t) {
    const i = X.categoricalfieldwrapper_get_domain(this.__wbg_ptr, t);
    return FI.__wrap(i);
  }
  /**
   * @returns {boolean}
   */
  is_naturally_numeric() {
    return X.categoricalfieldwrapper_is_naturally_numeric(this.__wbg_ptr) !== 0;
  }
}
const rm = new FinalizationRegistry(
  (e) => X.__wbg_continuousfieldwrapper_free(e >>> 0)
);
class kI {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(kI.prototype);
    return i.__wbg_ptr = t, rm.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, rm.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_continuousfieldwrapper_free(t);
  }
  /**
   * @returns {string}
   */
  get_name() {
    let t, i;
    try {
      const s = X.__wbindgen_add_to_stack_pointer(-16);
      X.continuousfieldwrapper_get_name(s, this.__wbg_ptr);
      var n = jt()[s / 4 + 0], A = jt()[s / 4 + 1];
      return t = n, i = A, yr(n, A);
    } finally {
      X.__wbindgen_add_to_stack_pointer(16), X.__wbindgen_free(t, i, 1);
    }
  }
  /**
   * @returns {number}
   */
  get_data_ptr() {
    return X.continuousfieldwrapper_get_data_ptr(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_indices() {
    return X.continuousfieldwrapper_get_data_indices(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_info() {
    return X.continuousfieldwrapper_get_data_info(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_rows_count() {
    return X.continuousfieldwrapper_get_rows_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {number} row_index
   * @returns {number}
   */
  get_value_at_index(t) {
    return X.continuousfieldwrapper_get_value_at_index(this.__wbg_ptr, t);
  }
  /**
   * @param {number} unique
   * @returns {Float64Array}
   */
  get_domain(t) {
    try {
      const s = X.__wbindgen_add_to_stack_pointer(-16);
      X.continuousfieldwrapper_get_domain(s, this.__wbg_ptr, t);
      var i = jt()[s / 4 + 0], n = jt()[s / 4 + 1], A = lg(i, n).slice();
      return X.__wbindgen_free(i, n * 8), A;
    } finally {
      X.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const am = new FinalizationRegistry((e) => X.__wbg_datamodel_free(e >>> 0));
let Ta = class zA {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(zA.prototype);
    return i.__wbg_ptr = t, am.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, am.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_datamodel_free(t);
  }
  /**
   * Public API to create new DataModel Instance
   * @param {DataModelMeta} meta
   */
  constructor(t) {
    qd(t, va);
    var i = t.__destroy_into_raw();
    const n = X.datamodel_new(i);
    return zA.__wrap(n);
  }
  /**
   * @returns {DataModel}
   */
  clone() {
    const t = X.datamodel_clone(this.__wbg_ptr);
    return zA.__wrap(t);
  }
  /**
   * @param {any} schema
   * @param {any} data
   * @returns {number}
   */
  add_field(t, i) {
    return X.datamodel_add_field(this.__wbg_ptr, JA(t), JA(i)) >>> 0;
  }
  /**
   * @param {number} index
   * @returns {CategoricalFieldWrapper}
   */
  get_categorical_field(t) {
    const i = X.datamodel_get_categorical_field(this.__wbg_ptr, t);
    return RI.__wrap(i);
  }
  /**
   * @param {number} index
   * @returns {BinnedFieldWrapper}
   */
  get_binned_field(t) {
    const i = X.datamodel_get_binned_field(this.__wbg_ptr, t);
    return NI.__wrap(i);
  }
  /**
   * @param {number} index
   * @returns {ContinuousFieldWrapper}
   */
  get_continuous_field(t) {
    const i = X.datamodel_get_continuous_field(this.__wbg_ptr, t);
    return kI.__wrap(i);
  }
  /**
   * @param {number} index
   * @returns {TemporalFieldWrapper}
   */
  get_temporal_field(t) {
    const i = X.datamodel_get_temporal_field(this.__wbg_ptr, t);
    return LI.__wrap(i);
  }
  /**
   * @param {number} index
   * @returns {IdFieldWrapper}
   */
  get_id_field(t) {
    const i = X.datamodel_get_id_field(this.__wbg_ptr, t);
    return TI.__wrap(i);
  }
  /**
   * @param {any} obj
   * @param {number} mode
   * @returns {ProjectDataModel}
   */
  select(t, i) {
    const n = X.datamodel_select(this.__wbg_ptr, JA(t), i);
    return cg.__wrap(n);
  }
  /**
   * @param {any} details
   * @returns {DataModel}
   */
  sort(t) {
    try {
      const i = X.datamodel_sort(this.__wbg_ptr, nm(t));
      return zA.__wrap(i);
    } finally {
      Ki[ya++] = void 0;
    }
  }
  /**
   * @param {any} details
   * @returns {ProjectDataModel}
   */
  project(t) {
    try {
      const i = X.datamodel_project(this.__wbg_ptr, nm(t));
      return cg.__wrap(i);
    } finally {
      Ki[ya++] = void 0;
    }
  }
  /**
   * @param {any} details
   * @param {any} options
   * @returns {DataModel}
   */
  group_by(t, i) {
    const n = X.datamodel_group_by(this.__wbg_ptr, JA(t), JA(i));
    return zA.__wrap(n);
  }
  /**
   * @param {any} options
   * @returns {SplitDataModel}
   */
  split_by_row(t) {
    const i = X.datamodel_split_by_row(this.__wbg_ptr, JA(t));
    return vI.__wrap(i);
  }
  /**
   * @param {any} fields
   */
  dispose(t) {
    X.datamodel_dispose(this.__wbg_ptr, JA(t));
  }
  /**
   * @returns {number}
   */
  row_count() {
    return X.datamodel_row_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @returns {number}
   */
  column_count() {
    return X.datamodel_column_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @returns {Int32Array}
   */
  get_eligible_rows() {
    try {
      const A = X.__wbindgen_add_to_stack_pointer(-16);
      X.datamodel_get_eligible_rows(A, this.__wbg_ptr);
      var t = jt()[A / 4 + 0], i = jt()[A / 4 + 1], n = tR(t, i).slice();
      return X.__wbindgen_free(t, i * 4), n;
    } finally {
      X.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * @returns {number}
   */
  get_partial_column_count() {
    return X.datamodel_get_partial_column_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @returns {number}
   */
  get_partial_row_count() {
    return X.datamodel_get_partial_row_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {DataModel} dm2
   * @returns {Uint32Array}
   */
  get_matching_ids(t) {
    try {
      const s = X.__wbindgen_add_to_stack_pointer(-16);
      qd(t, zA), X.datamodel_get_matching_ids(s, this.__wbg_ptr, t.__wbg_ptr);
      var i = jt()[s / 4 + 0], n = jt()[s / 4 + 1], A = iR(i, n).slice();
      return X.__wbindgen_free(i, n * 4), A;
    } finally {
      X.__wbindgen_add_to_stack_pointer(16);
    }
  }
};
const lm = new FinalizationRegistry((e) => X.__wbg_datamodelmeta_free(e >>> 0));
class va {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(va.prototype);
    return i.__wbg_ptr = t, lm.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, lm.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_datamodelmeta_free(t);
  }
  /**
   * @returns {number}
   */
  get rows() {
    return X.__wbg_get_datamodelmeta_rows(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {number} arg0
   */
  set rows(t) {
    X.__wbg_set_datamodelmeta_rows(this.__wbg_ptr, t);
  }
  /**
   * @returns {number}
   */
  get columns() {
    return X.__wbg_get_datamodelmeta_columns(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {number} arg0
   */
  set columns(t) {
    X.__wbg_set_datamodelmeta_columns(this.__wbg_ptr, t);
  }
  /**
   * @param {number} rows
   * @param {number} columns
   */
  constructor(t, i) {
    const n = X.datamodelmeta_new(t, i);
    return va.__wrap(n);
  }
}
const cm = new FinalizationRegistry((e) => X.__wbg_idfieldwrapper_free(e >>> 0));
class TI {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(TI.prototype);
    return i.__wbg_ptr = t, cm.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, cm.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_idfieldwrapper_free(t);
  }
  /**
   * @returns {string}
   */
  get_name() {
    let t, i;
    try {
      const s = X.__wbindgen_add_to_stack_pointer(-16);
      X.idfieldwrapper_get_name(s, this.__wbg_ptr);
      var n = jt()[s / 4 + 0], A = jt()[s / 4 + 1];
      return t = n, i = A, yr(n, A);
    } finally {
      X.__wbindgen_add_to_stack_pointer(16), X.__wbindgen_free(t, i, 1);
    }
  }
  /**
   * @returns {number}
   */
  get_data_ptr() {
    return X.idfieldwrapper_get_data_ptr(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_indices() {
    return X.idfieldwrapper_get_data_indices(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_info() {
    return X.idfieldwrapper_get_data_info(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_rows_count() {
    return X.idfieldwrapper_get_rows_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {number} row_index
   * @returns {number}
   */
  get_value_at_index(t) {
    return X.idfieldwrapper_get_value_at_index(this.__wbg_ptr, t);
  }
}
const gm = new FinalizationRegistry((e) => X.__wbg_projectdatamodel_free(e >>> 0));
class cg {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(cg.prototype);
    return i.__wbg_ptr = t, gm.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, gm.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_projectdatamodel_free(t);
  }
  /**
   * @returns {DataModel | undefined}
   */
  get_filtered_dm() {
    const t = X.projectdatamodel_get_filtered_dm(this.__wbg_ptr);
    return t === 0 ? void 0 : Ta.__wrap(t);
  }
  /**
   * @returns {DataModel | undefined}
   */
  get_unfiltered_dm() {
    const t = X.projectdatamodel_get_unfiltered_dm(this.__wbg_ptr);
    return t === 0 ? void 0 : Ta.__wrap(t);
  }
}
const hm = new FinalizationRegistry((e) => X.__wbg_splitdatamodel_free(e >>> 0));
class vI {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(vI.prototype);
    return i.__wbg_ptr = t, hm.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, hm.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_splitdatamodel_free(t);
  }
  /**
   * @returns {DataModel}
   */
  get_dm() {
    const t = X.splitdatamodel_get_dm(this.__wbg_ptr);
    return Ta.__wrap(t);
  }
  /**
   * @returns {number}
   */
  get_count() {
    return X.splitdatamodel_get_count(this.__wbg_ptr) >>> 0;
  }
}
const um = new FinalizationRegistry((e) => X.__wbg_stackdata_free(e >>> 0));
class GI {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(GI.prototype);
    return i.__wbg_ptr = t, um.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, um.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_stackdata_free(t);
  }
  /**
   * @returns {number}
   */
  get_y_0() {
    return X.stackdata_get_y_0(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_y_1() {
    return X.stackdata_get_y_1(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_id() {
    return X.stackdata_get_id(this.__wbg_ptr);
  }
  /**
   */
  free_data() {
    X.stackdata_free_data(this.__wbg_ptr);
  }
}
const dm = new FinalizationRegistry(
  (e) => X.__wbg_temporalfieldwrapper_free(e >>> 0)
);
class LI {
  static __wrap(t) {
    t = t >>> 0;
    const i = Object.create(LI.prototype);
    return i.__wbg_ptr = t, dm.register(i, i.__wbg_ptr, i), i;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, dm.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    X.__wbg_temporalfieldwrapper_free(t);
  }
  /**
   * @returns {string}
   */
  get_name() {
    let t, i;
    try {
      const s = X.__wbindgen_add_to_stack_pointer(-16);
      X.idfieldwrapper_get_name(s, this.__wbg_ptr);
      var n = jt()[s / 4 + 0], A = jt()[s / 4 + 1];
      return t = n, i = A, yr(n, A);
    } finally {
      X.__wbindgen_add_to_stack_pointer(16), X.__wbindgen_free(t, i, 1);
    }
  }
  /**
   * @returns {number}
   */
  get_data_ptr() {
    return X.temporalfieldwrapper_get_data_ptr(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_indices() {
    return X.temporalfieldwrapper_get_data_indices(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_data_info() {
    return X.temporalfieldwrapper_get_data_info(this.__wbg_ptr);
  }
  /**
   * @returns {number}
   */
  get_rows_count() {
    return X.temporalfieldwrapper_get_rows_count(this.__wbg_ptr) >>> 0;
  }
  /**
   * @param {number} row_index
   * @returns {number}
   */
  get_value_at_index(t) {
    return X.temporalfieldwrapper_get_value_at_index(this.__wbg_ptr, t);
  }
  /**
   * @returns {number}
   */
  min_consecutive_diff() {
    return X.temporalfieldwrapper_min_consecutive_diff(this.__wbg_ptr);
  }
  /**
   * @param {number} unique
   * @returns {Float64Array}
   */
  get_domain(t) {
    try {
      const s = X.__wbindgen_add_to_stack_pointer(-16);
      X.temporalfieldwrapper_get_domain(s, this.__wbg_ptr, t);
      var i = jt()[s / 4 + 0], n = jt()[s / 4 + 1], A = lg(i, n).slice();
      return X.__wbindgen_free(i, n * 8), A;
    } finally {
      X.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
function nR(e) {
  jF(e);
}
function AR(e, t) {
  const i = Zy(t), n = JSON.stringify(i === void 0 ? null : i), A = ZF(n, X.__wbindgen_malloc, X.__wbindgen_realloc), s = Zo;
  jt()[e / 4 + 1] = s, jt()[e / 4 + 0] = A;
}
function sR(e, t) {
  throw new Error(yr(e, t));
}
URL = globalThis.URL;
const At = await KF({ "./datamodel_bg.js": { __wbindgen_object_drop_ref: nR, __wbindgen_json_serialize: AR, __wbindgen_throw: sR } }, JF), cl = At.memory, oR = At.__wbg_stackdata_free, rR = At.stackdata_get_y_0, aR = At.stackdata_get_y_1, lR = At.stackdata_get_id, cR = At.stackdata_free_data, gR = At.stack_by, hR = At.__wbg_categoricalfieldwrapper_free, uR = At.categoricalfieldwrapper_get_name, dR = At.categoricalfieldwrapper_get_data_indices, fR = At.categoricalfieldwrapper_get_data_info, IR = At.categoricalfieldwrapper_get_rows_count, CR = At.categoricalfieldwrapper_get_value_at_index, ER = At.categoricalfieldwrapper_get_domain, BR = At.categoricalfieldwrapper_is_naturally_numeric, mR = At.__wbg_datamodelmeta_free, QR = At.__wbg_get_datamodelmeta_rows, pR = At.__wbg_set_datamodelmeta_rows, yR = At.__wbg_get_datamodelmeta_columns, DR = At.__wbg_set_datamodelmeta_columns, wR = At.datamodelmeta_new, xR = At.__wbg_datamodel_free, SR = At.datamodel_new, MR = At.datamodel_clone, _R = At.datamodel_add_field, bR = At.datamodel_get_categorical_field, NR = At.datamodel_get_binned_field, FR = At.datamodel_get_continuous_field, RR = At.datamodel_get_temporal_field, kR = At.datamodel_get_id_field, TR = At.datamodel_select, vR = At.datamodel_sort, GR = At.datamodel_project, LR = At.datamodel_group_by, UR = At.datamodel_split_by_row, OR = At.datamodel_dispose, HR = At.datamodel_row_count, PR = At.datamodel_column_count, YR = At.datamodel_get_eligible_rows, JR = At.datamodel_get_partial_column_count, KR = At.datamodel_get_partial_row_count, WR = At.datamodel_get_matching_ids, VR = At.__wbg_binnedfieldwrapper_free, jR = At.binnedfieldwrapper_get_name, qR = At.binnedfieldwrapper_get_data_ptr, zR = At.binnedfieldwrapper_get_data_indices, ZR = At.binnedfieldwrapper_get_data_info, $R = At.binnedfieldwrapper_get_rows_count, XR = At.binnedfieldwrapper_get_value_at_index, tk = At.binnedfieldwrapper_get_domain, ek = At.binnedfieldwrapper_get_uniques, ik = At.__wbg_splitdatamodel_free, nk = At.splitdatamodel_get_dm, Ak = At.splitdatamodel_get_count, sk = At.main_js, ok = At.__wbg_categoricaldomainmeta_free, rk = At.__wbg_get_categoricaldomainmeta_data_ptr, ak = At.__wbg_set_categoricaldomainmeta_data_ptr, lk = At.__wbg_get_categoricaldomainmeta_data_len, ck = At.__wbg_set_categoricaldomainmeta_data_len, gk = At.__wbg_continuousfieldwrapper_free, hk = At.continuousfieldwrapper_get_name, uk = At.continuousfieldwrapper_get_data_ptr, dk = At.continuousfieldwrapper_get_data_indices, fk = At.continuousfieldwrapper_get_data_info, Ik = At.continuousfieldwrapper_get_rows_count, Ck = At.continuousfieldwrapper_get_value_at_index, Ek = At.continuousfieldwrapper_get_domain, Bk = At.__wbg_projectdatamodel_free, mk = At.projectdatamodel_get_filtered_dm, Qk = At.projectdatamodel_get_unfiltered_dm, pk = At.__wbg_temporalfieldwrapper_free, yk = At.temporalfieldwrapper_get_data_ptr, Dk = At.temporalfieldwrapper_get_data_indices, wk = At.temporalfieldwrapper_get_data_info, xk = At.temporalfieldwrapper_get_rows_count, Sk = At.temporalfieldwrapper_get_value_at_index, Mk = At.temporalfieldwrapper_min_consecutive_diff, _k = At.temporalfieldwrapper_get_domain, bk = At.__wbg_idfieldwrapper_free, Nk = At.idfieldwrapper_get_name, Fk = At.idfieldwrapper_get_data_ptr, Rk = At.idfieldwrapper_get_data_indices, kk = At.idfieldwrapper_get_data_info, Tk = At.idfieldwrapper_get_rows_count, vk = At.idfieldwrapper_get_value_at_index, Gk = At.temporalfieldwrapper_get_name, Lk = At.__wbindgen_malloc, Uk = At.__wbindgen_realloc, Ok = At.__wbindgen_add_to_stack_pointer, Hk = At.__wbindgen_free, tD = At.__wbindgen_start, Pk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __wbg_binnedfieldwrapper_free: VR,
  __wbg_categoricaldomainmeta_free: ok,
  __wbg_categoricalfieldwrapper_free: hR,
  __wbg_continuousfieldwrapper_free: gk,
  __wbg_datamodel_free: xR,
  __wbg_datamodelmeta_free: mR,
  __wbg_get_categoricaldomainmeta_data_len: lk,
  __wbg_get_categoricaldomainmeta_data_ptr: rk,
  __wbg_get_datamodelmeta_columns: yR,
  __wbg_get_datamodelmeta_rows: QR,
  __wbg_idfieldwrapper_free: bk,
  __wbg_projectdatamodel_free: Bk,
  __wbg_set_categoricaldomainmeta_data_len: ck,
  __wbg_set_categoricaldomainmeta_data_ptr: ak,
  __wbg_set_datamodelmeta_columns: DR,
  __wbg_set_datamodelmeta_rows: pR,
  __wbg_splitdatamodel_free: ik,
  __wbg_stackdata_free: oR,
  __wbg_temporalfieldwrapper_free: pk,
  __wbindgen_add_to_stack_pointer: Ok,
  __wbindgen_free: Hk,
  __wbindgen_malloc: Lk,
  __wbindgen_realloc: Uk,
  __wbindgen_start: tD,
  binnedfieldwrapper_get_data_indices: zR,
  binnedfieldwrapper_get_data_info: ZR,
  binnedfieldwrapper_get_data_ptr: qR,
  binnedfieldwrapper_get_domain: tk,
  binnedfieldwrapper_get_name: jR,
  binnedfieldwrapper_get_rows_count: $R,
  binnedfieldwrapper_get_uniques: ek,
  binnedfieldwrapper_get_value_at_index: XR,
  categoricalfieldwrapper_get_data_indices: dR,
  categoricalfieldwrapper_get_data_info: fR,
  categoricalfieldwrapper_get_domain: ER,
  categoricalfieldwrapper_get_name: uR,
  categoricalfieldwrapper_get_rows_count: IR,
  categoricalfieldwrapper_get_value_at_index: CR,
  categoricalfieldwrapper_is_naturally_numeric: BR,
  continuousfieldwrapper_get_data_indices: dk,
  continuousfieldwrapper_get_data_info: fk,
  continuousfieldwrapper_get_data_ptr: uk,
  continuousfieldwrapper_get_domain: Ek,
  continuousfieldwrapper_get_name: hk,
  continuousfieldwrapper_get_rows_count: Ik,
  continuousfieldwrapper_get_value_at_index: Ck,
  datamodel_add_field: _R,
  datamodel_clone: MR,
  datamodel_column_count: PR,
  datamodel_dispose: OR,
  datamodel_get_binned_field: NR,
  datamodel_get_categorical_field: bR,
  datamodel_get_continuous_field: FR,
  datamodel_get_eligible_rows: YR,
  datamodel_get_id_field: kR,
  datamodel_get_matching_ids: WR,
  datamodel_get_partial_column_count: JR,
  datamodel_get_partial_row_count: KR,
  datamodel_get_temporal_field: RR,
  datamodel_group_by: LR,
  datamodel_new: SR,
  datamodel_project: GR,
  datamodel_row_count: HR,
  datamodel_select: TR,
  datamodel_sort: vR,
  datamodel_split_by_row: UR,
  datamodelmeta_new: wR,
  idfieldwrapper_get_data_indices: Rk,
  idfieldwrapper_get_data_info: kk,
  idfieldwrapper_get_data_ptr: Fk,
  idfieldwrapper_get_name: Nk,
  idfieldwrapper_get_rows_count: Tk,
  idfieldwrapper_get_value_at_index: vk,
  main_js: sk,
  memory: cl,
  projectdatamodel_get_filtered_dm: mk,
  projectdatamodel_get_unfiltered_dm: Qk,
  splitdatamodel_get_count: Ak,
  splitdatamodel_get_dm: nk,
  stack_by: gR,
  stackdata_free_data: cR,
  stackdata_get_id: lR,
  stackdata_get_y_0: rR,
  stackdata_get_y_1: aR,
  temporalfieldwrapper_get_data_indices: Dk,
  temporalfieldwrapper_get_data_info: wk,
  temporalfieldwrapper_get_data_ptr: yk,
  temporalfieldwrapper_get_domain: _k,
  temporalfieldwrapper_get_name: Gk,
  temporalfieldwrapper_get_rows_count: xk,
  temporalfieldwrapper_get_value_at_index: Sk,
  temporalfieldwrapper_min_consecutive_diff: Mk
}, Symbol.toStringTag, { value: "Module" }));
WF(Pk);
tD();
var Ms;
(function(e) {
  e.WASM = "wasm";
})(Ms || (Ms = {}));
var fm;
(function(e) {
  e.UNDEFINED = "";
})(fm || (fm = {}));
var gg;
(function(e) {
  e.NULL = "null", e.UNDEFINED = "undefined", e.NAN = "NaN", e.NIL = "nil", e.NA = "na", e.EMPTY_STRING = "", e.INVALID = "_invalid";
})(gg || (gg = {}));
const Yk = String(gg.INVALID), Jk = "_#-", Kk = {
  [it.TEMPORAL]: (e, t) => {
    let i = e;
    if (typeof e != "number") {
      const n = yo.get(it.TEMPORAL);
      i = n ? n.parse(e, t) : e;
    }
    return i;
  },
  [it.CATEGORICAL]: (e, t) => {
    const i = yo.get(it.CATEGORICAL), n = i ? i.parse(e, t) : e;
    return aD(n) ? n : Jk;
  },
  [it.BINNED]: (e, t) => {
    const i = yo.get(it.CONTINUOUS);
    return i?.parse(e, t);
  },
  [it.CONTINUOUS]: (e, t) => {
    const i = yo.get(it.CONTINUOUS);
    return i?.parse(e, t);
  }
}, eD = (e, t, i) => {
  const n = Kk[e];
  return n ? n(t, i) : t;
}, iD = (e, t, i = {}) => {
  const n = e.conditions, { operator: A } = e;
  if (n && A && n.length > 0) {
    i.conditions = [];
    for (let s = 0; s < n.length; s++) {
      let o = i.conditions[s] = {};
      const r = iD(n[s], t, o);
      r.operator ? o = r : i.conditions.pop();
    }
    if (i.operator = em(A), i.operator === -1)
      i = {};
    else if (i.conditions.length === 1)
      i.conditions[0] ? i = i.conditions[0] : i = {};
    else {
      const s = [];
      for (const o in i.conditions)
        i.conditions[o] && s.push(i.conditions[o]);
      i.conditions = s, i.conditions.length === 1 && (i = i.conditions[0]);
    }
  } else if (e.field) {
    const { field: s, value: o } = e, r = t.get(s || {});
    if (r && r.index != null) {
      const { index: a, field: l } = r;
      i.field = a;
      const { subtype: c = it.CATEGORICAL, format: g = (u) => u } = l.schema(), h = eD(c, o, g);
      i.value = h, i.operator = em(A), i.operator == -1 && (i = {});
    }
  }
  return i;
};
const {
  entries: nD,
  setPrototypeOf: Im,
  isFrozen: Wk,
  getPrototypeOf: Vk,
  getOwnPropertyDescriptor: jk
} = Object;
let {
  freeze: qe,
  seal: zi,
  create: AD
} = Object, {
  apply: zd,
  construct: Zd
} = typeof Reflect < "u" && Reflect;
qe || (qe = function(t) {
  return t;
});
zi || (zi = function(t) {
  return t;
});
zd || (zd = function(t, i, n) {
  return t.apply(i, n);
});
Zd || (Zd = function(t, i) {
  return new t(...i);
});
const Zl = ki(Array.prototype.forEach), Cm = ki(Array.prototype.pop), Or = ki(Array.prototype.push), Gc = ki(String.prototype.toLowerCase), zu = ki(String.prototype.toString), Em = ki(String.prototype.match), Hr = ki(String.prototype.replace), qk = ki(String.prototype.indexOf), zk = ki(String.prototype.trim), An = ki(Object.prototype.hasOwnProperty), He = ki(RegExp.prototype.test), Pr = Zk(TypeError);
function ki(e) {
  return function(t) {
    for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), A = 1; A < i; A++)
      n[A - 1] = arguments[A];
    return zd(e, t, n);
  };
}
function Zk(e) {
  return function() {
    for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++)
      i[n] = arguments[n];
    return Zd(e, i);
  };
}
function wt(e, t) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Gc;
  Im && Im(e, null);
  let n = t.length;
  for (; n--; ) {
    let A = t[n];
    if (typeof A == "string") {
      const s = i(A);
      s !== A && (Wk(t) || (t[n] = s), A = s);
    }
    e[A] = !0;
  }
  return e;
}
function $k(e) {
  for (let t = 0; t < e.length; t++)
    An(e, t) || (e[t] = null);
  return e;
}
function ZA(e) {
  const t = AD(null);
  for (const [i, n] of nD(e))
    An(e, i) && (Array.isArray(n) ? t[i] = $k(n) : n && typeof n == "object" && n.constructor === Object ? t[i] = ZA(n) : t[i] = n);
  return t;
}
function Yr(e, t) {
  for (; e !== null; ) {
    const n = jk(e, t);
    if (n) {
      if (n.get)
        return ki(n.get);
      if (typeof n.value == "function")
        return ki(n.value);
    }
    e = Vk(e);
  }
  function i() {
    return null;
  }
  return i;
}
const Bm = qe(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Zu = qe(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), $u = qe(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Xk = qe(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Xu = qe(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), tT = qe(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), mm = qe(["#text"]), Qm = qe(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), td = qe(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), pm = qe(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), $l = qe(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), eT = zi(/\{\{[\w\W]*|[\w\W]*\}\}/gm), iT = zi(/<%[\w\W]*|[\w\W]*%>/gm), nT = zi(/\${[\w\W]*}/gm), AT = zi(/^data-[\-\w.\u00B7-\uFFFF]/), sT = zi(/^aria-[\-\w]+$/), sD = zi(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), oT = zi(/^(?:\w+script|data):/i), rT = zi(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), oD = zi(/^html$/i), aT = zi(/^[a-z][.\w]*(-[.\w]+)+$/i);
var ym = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: eT,
  ERB_EXPR: iT,
  TMPLIT_EXPR: nT,
  DATA_ATTR: AT,
  ARIA_ATTR: sT,
  IS_ALLOWED_URI: sD,
  IS_SCRIPT_OR_DATA: oT,
  ATTR_WHITESPACE: rT,
  DOCTYPE_NAME: oD,
  CUSTOM_ELEMENT: aT
});
const Jr = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, lT = function() {
  return typeof window > "u" ? null : window;
}, cT = function(t, i) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let n = null;
  const A = "data-tt-policy-suffix";
  i && i.hasAttribute(A) && (n = i.getAttribute(A));
  const s = "dompurify" + (n ? "#" + n : "");
  try {
    return t.createPolicy(s, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
};
function rD() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lT();
  const t = (It) => rD(It);
  if (t.version = "3.1.6", t.removed = [], !e || !e.document || e.document.nodeType !== Jr.document)
    return t.isSupported = !1, t;
  let {
    document: i
  } = e;
  const n = i, A = n.currentScript, {
    DocumentFragment: s,
    HTMLTemplateElement: o,
    Node: r,
    Element: a,
    NodeFilter: l,
    NamedNodeMap: c = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: g,
    DOMParser: h,
    trustedTypes: u
  } = e, d = a.prototype, f = Yr(d, "cloneNode"), I = Yr(d, "remove"), C = Yr(d, "nextSibling"), E = Yr(d, "childNodes"), B = Yr(d, "parentNode");
  if (typeof o == "function") {
    const It = i.createElement("template");
    It.content && It.content.ownerDocument && (i = It.content.ownerDocument);
  }
  let m, y = "";
  const {
    implementation: D,
    createNodeIterator: Q,
    createDocumentFragment: p,
    getElementsByTagName: w
  } = i, {
    importNode: x
  } = n;
  let S = {};
  t.isSupported = typeof nD == "function" && typeof B == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: _,
    ERB_EXPR: M,
    TMPLIT_EXPR: k,
    DATA_ATTR: T,
    ARIA_ATTR: G,
    IS_SCRIPT_OR_DATA: N,
    ATTR_WHITESPACE: b,
    CUSTOM_ELEMENT: F
  } = ym;
  let {
    IS_ALLOWED_URI: R
  } = ym, v = null;
  const O = wt({}, [...Bm, ...Zu, ...$u, ...Xu, ...mm]);
  let L = null;
  const U = wt({}, [...Qm, ...td, ...pm, ...$l]);
  let H = Object.seal(AD(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), z = null, et = null, Z = !0, Y = !0, q = !1, $ = !0, P = !1, st = !0, nt = !1, ot = !1, Et = !1, ct = !1, ht = !1, Mt = !1, Ue = !0, at = !1;
  const Ot = "user-content-";
  let Vt = !0, pi = !1, he = {}, oA = null;
  const rA = wt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let eo = null;
  const io = wt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Qt = null;
  const kt = wt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), $e = "http://www.w3.org/1998/Math/MathML", ue = "http://www.w3.org/2000/svg", Gn = "http://www.w3.org/1999/xhtml";
  let no = Gn, Pu = !1, Yu = null;
  const N1 = wt({}, [$e, ue, Gn], zu);
  let Gr = null;
  const F1 = ["application/xhtml+xml", "text/html"], R1 = "text/html";
  let de = null, Ao = null;
  const k1 = i.createElement("form"), RB = function(K) {
    return K instanceof RegExp || K instanceof Function;
  }, Ju = function() {
    let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Ao && Ao === K)) {
      if ((!K || typeof K != "object") && (K = {}), K = ZA(K), Gr = // eslint-disable-next-line unicorn/prefer-includes
      F1.indexOf(K.PARSER_MEDIA_TYPE) === -1 ? R1 : K.PARSER_MEDIA_TYPE, de = Gr === "application/xhtml+xml" ? zu : Gc, v = An(K, "ALLOWED_TAGS") ? wt({}, K.ALLOWED_TAGS, de) : O, L = An(K, "ALLOWED_ATTR") ? wt({}, K.ALLOWED_ATTR, de) : U, Yu = An(K, "ALLOWED_NAMESPACES") ? wt({}, K.ALLOWED_NAMESPACES, zu) : N1, Qt = An(K, "ADD_URI_SAFE_ATTR") ? wt(
        ZA(kt),
        // eslint-disable-line indent
        K.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        de
        // eslint-disable-line indent
      ) : kt, eo = An(K, "ADD_DATA_URI_TAGS") ? wt(
        ZA(io),
        // eslint-disable-line indent
        K.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        de
        // eslint-disable-line indent
      ) : io, oA = An(K, "FORBID_CONTENTS") ? wt({}, K.FORBID_CONTENTS, de) : rA, z = An(K, "FORBID_TAGS") ? wt({}, K.FORBID_TAGS, de) : {}, et = An(K, "FORBID_ATTR") ? wt({}, K.FORBID_ATTR, de) : {}, he = An(K, "USE_PROFILES") ? K.USE_PROFILES : !1, Z = K.ALLOW_ARIA_ATTR !== !1, Y = K.ALLOW_DATA_ATTR !== !1, q = K.ALLOW_UNKNOWN_PROTOCOLS || !1, $ = K.ALLOW_SELF_CLOSE_IN_ATTR !== !1, P = K.SAFE_FOR_TEMPLATES || !1, st = K.SAFE_FOR_XML !== !1, nt = K.WHOLE_DOCUMENT || !1, ct = K.RETURN_DOM || !1, ht = K.RETURN_DOM_FRAGMENT || !1, Mt = K.RETURN_TRUSTED_TYPE || !1, Et = K.FORCE_BODY || !1, Ue = K.SANITIZE_DOM !== !1, at = K.SANITIZE_NAMED_PROPS || !1, Vt = K.KEEP_CONTENT !== !1, pi = K.IN_PLACE || !1, R = K.ALLOWED_URI_REGEXP || sD, no = K.NAMESPACE || Gn, H = K.CUSTOM_ELEMENT_HANDLING || {}, K.CUSTOM_ELEMENT_HANDLING && RB(K.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (H.tagNameCheck = K.CUSTOM_ELEMENT_HANDLING.tagNameCheck), K.CUSTOM_ELEMENT_HANDLING && RB(K.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (H.attributeNameCheck = K.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), K.CUSTOM_ELEMENT_HANDLING && typeof K.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (H.allowCustomizedBuiltInElements = K.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), P && (Y = !1), ht && (ct = !0), he && (v = wt({}, mm), L = [], he.html === !0 && (wt(v, Bm), wt(L, Qm)), he.svg === !0 && (wt(v, Zu), wt(L, td), wt(L, $l)), he.svgFilters === !0 && (wt(v, $u), wt(L, td), wt(L, $l)), he.mathMl === !0 && (wt(v, Xu), wt(L, pm), wt(L, $l))), K.ADD_TAGS && (v === O && (v = ZA(v)), wt(v, K.ADD_TAGS, de)), K.ADD_ATTR && (L === U && (L = ZA(L)), wt(L, K.ADD_ATTR, de)), K.ADD_URI_SAFE_ATTR && wt(Qt, K.ADD_URI_SAFE_ATTR, de), K.FORBID_CONTENTS && (oA === rA && (oA = ZA(oA)), wt(oA, K.FORBID_CONTENTS, de)), Vt && (v["#text"] = !0), nt && wt(v, ["html", "head", "body"]), v.table && (wt(v, ["tbody"]), delete z.tbody), K.TRUSTED_TYPES_POLICY) {
        if (typeof K.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Pr('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof K.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Pr('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        m = K.TRUSTED_TYPES_POLICY, y = m.createHTML("");
      } else
        m === void 0 && (m = cT(u, A)), m !== null && typeof y == "string" && (y = m.createHTML(""));
      qe && qe(K), Ao = K;
    }
  }, kB = wt({}, ["mi", "mo", "mn", "ms", "mtext"]), TB = wt({}, ["foreignobject", "annotation-xml"]), T1 = wt({}, ["title", "style", "font", "a", "script"]), vB = wt({}, [...Zu, ...$u, ...Xk]), GB = wt({}, [...Xu, ...tT]), v1 = function(K) {
    let rt = B(K);
    (!rt || !rt.tagName) && (rt = {
      namespaceURI: no,
      tagName: "template"
    });
    const ut = Gc(K.tagName), Wt = Gc(rt.tagName);
    return Yu[K.namespaceURI] ? K.namespaceURI === ue ? rt.namespaceURI === Gn ? ut === "svg" : rt.namespaceURI === $e ? ut === "svg" && (Wt === "annotation-xml" || kB[Wt]) : !!vB[ut] : K.namespaceURI === $e ? rt.namespaceURI === Gn ? ut === "math" : rt.namespaceURI === ue ? ut === "math" && TB[Wt] : !!GB[ut] : K.namespaceURI === Gn ? rt.namespaceURI === ue && !TB[Wt] || rt.namespaceURI === $e && !kB[Wt] ? !1 : !GB[ut] && (T1[ut] || !vB[ut]) : !!(Gr === "application/xhtml+xml" && Yu[K.namespaceURI]) : !1;
  }, Qn = function(K) {
    Or(t.removed, {
      element: K
    });
    try {
      B(K).removeChild(K);
    } catch {
      I(K);
    }
  }, Pl = function(K, rt) {
    try {
      Or(t.removed, {
        attribute: rt.getAttributeNode(K),
        from: rt
      });
    } catch {
      Or(t.removed, {
        attribute: null,
        from: rt
      });
    }
    if (rt.removeAttribute(K), K === "is" && !L[K])
      if (ct || ht)
        try {
          Qn(rt);
        } catch {
        }
      else
        try {
          rt.setAttribute(K, "");
        } catch {
        }
  }, LB = function(K) {
    let rt = null, ut = null;
    if (Et)
      K = "<remove></remove>" + K;
    else {
      const Qe = Em(K, /^[\r\n\t ]+/);
      ut = Qe && Qe[0];
    }
    Gr === "application/xhtml+xml" && no === Gn && (K = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + K + "</body></html>");
    const Wt = m ? m.createHTML(K) : K;
    if (no === Gn)
      try {
        rt = new h().parseFromString(Wt, Gr);
      } catch {
      }
    if (!rt || !rt.documentElement) {
      rt = D.createDocument(no, "template", null);
      try {
        rt.documentElement.innerHTML = Pu ? y : Wt;
      } catch {
      }
    }
    const be = rt.body || rt.documentElement;
    return K && ut && be.insertBefore(i.createTextNode(ut), be.childNodes[0] || null), no === Gn ? w.call(rt, nt ? "html" : "body")[0] : nt ? rt.documentElement : be;
  }, UB = function(K) {
    return Q.call(
      K.ownerDocument || K,
      K,
      // eslint-disable-next-line no-bitwise
      l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION,
      null
    );
  }, OB = function(K) {
    return K instanceof g && (typeof K.nodeName != "string" || typeof K.textContent != "string" || typeof K.removeChild != "function" || !(K.attributes instanceof c) || typeof K.removeAttribute != "function" || typeof K.setAttribute != "function" || typeof K.namespaceURI != "string" || typeof K.insertBefore != "function" || typeof K.hasChildNodes != "function");
  }, HB = function(K) {
    return typeof r == "function" && K instanceof r;
  }, Ln = function(K, rt, ut) {
    S[K] && Zl(S[K], (Wt) => {
      Wt.call(t, rt, ut, Ao);
    });
  }, PB = function(K) {
    let rt = null;
    if (Ln("beforeSanitizeElements", K, null), OB(K))
      return Qn(K), !0;
    const ut = de(K.nodeName);
    if (Ln("uponSanitizeElement", K, {
      tagName: ut,
      allowedTags: v
    }), K.hasChildNodes() && !HB(K.firstElementChild) && He(/<[/\w]/g, K.innerHTML) && He(/<[/\w]/g, K.textContent) || K.nodeType === Jr.progressingInstruction || st && K.nodeType === Jr.comment && He(/<[/\w]/g, K.data))
      return Qn(K), !0;
    if (!v[ut] || z[ut]) {
      if (!z[ut] && JB(ut) && (H.tagNameCheck instanceof RegExp && He(H.tagNameCheck, ut) || H.tagNameCheck instanceof Function && H.tagNameCheck(ut)))
        return !1;
      if (Vt && !oA[ut]) {
        const Wt = B(K) || K.parentNode, be = E(K) || K.childNodes;
        if (be && Wt) {
          const Qe = be.length;
          for (let Xe = Qe - 1; Xe >= 0; --Xe) {
            const pn = f(be[Xe], !0);
            pn.__removalCount = (K.__removalCount || 0) + 1, Wt.insertBefore(pn, C(K));
          }
        }
      }
      return Qn(K), !0;
    }
    return K instanceof a && !v1(K) || (ut === "noscript" || ut === "noembed" || ut === "noframes") && He(/<\/no(script|embed|frames)/i, K.innerHTML) ? (Qn(K), !0) : (P && K.nodeType === Jr.text && (rt = K.textContent, Zl([_, M, k], (Wt) => {
      rt = Hr(rt, Wt, " ");
    }), K.textContent !== rt && (Or(t.removed, {
      element: K.cloneNode()
    }), K.textContent = rt)), Ln("afterSanitizeElements", K, null), !1);
  }, YB = function(K, rt, ut) {
    if (Ue && (rt === "id" || rt === "name") && (ut in i || ut in k1))
      return !1;
    if (!(Y && !et[rt] && He(T, rt))) {
      if (!(Z && He(G, rt))) {
        if (!L[rt] || et[rt]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(JB(K) && (H.tagNameCheck instanceof RegExp && He(H.tagNameCheck, K) || H.tagNameCheck instanceof Function && H.tagNameCheck(K)) && (H.attributeNameCheck instanceof RegExp && He(H.attributeNameCheck, rt) || H.attributeNameCheck instanceof Function && H.attributeNameCheck(rt)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            rt === "is" && H.allowCustomizedBuiltInElements && (H.tagNameCheck instanceof RegExp && He(H.tagNameCheck, ut) || H.tagNameCheck instanceof Function && H.tagNameCheck(ut)))
          )
            return !1;
        } else if (!Qt[rt]) {
          if (!He(R, Hr(ut, b, ""))) {
            if (!((rt === "src" || rt === "xlink:href" || rt === "href") && K !== "script" && qk(ut, "data:") === 0 && eo[K])) {
              if (!(q && !He(N, Hr(ut, b, "")))) {
                if (ut)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, JB = function(K) {
    return K !== "annotation-xml" && Em(K, F);
  }, KB = function(K) {
    Ln("beforeSanitizeAttributes", K, null);
    const {
      attributes: rt
    } = K;
    if (!rt)
      return;
    const ut = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: L
    };
    let Wt = rt.length;
    for (; Wt--; ) {
      const be = rt[Wt], {
        name: Qe,
        namespaceURI: Xe,
        value: pn
      } = be, Lr = de(Qe);
      let Oe = Qe === "value" ? pn : zk(pn);
      if (ut.attrName = Lr, ut.attrValue = Oe, ut.keepAttr = !0, ut.forceKeepAttr = void 0, Ln("uponSanitizeAttribute", K, ut), Oe = ut.attrValue, st && He(/((--!?|])>)|<\/(style|title)/i, Oe)) {
        Pl(Qe, K);
        continue;
      }
      if (ut.forceKeepAttr || (Pl(Qe, K), !ut.keepAttr))
        continue;
      if (!$ && He(/\/>/i, Oe)) {
        Pl(Qe, K);
        continue;
      }
      P && Zl([_, M, k], (VB) => {
        Oe = Hr(Oe, VB, " ");
      });
      const WB = de(K.nodeName);
      if (YB(WB, Lr, Oe)) {
        if (at && (Lr === "id" || Lr === "name") && (Pl(Qe, K), Oe = Ot + Oe), m && typeof u == "object" && typeof u.getAttributeType == "function" && !Xe)
          switch (u.getAttributeType(WB, Lr)) {
            case "TrustedHTML": {
              Oe = m.createHTML(Oe);
              break;
            }
            case "TrustedScriptURL": {
              Oe = m.createScriptURL(Oe);
              break;
            }
          }
        try {
          Xe ? K.setAttributeNS(Xe, Qe, Oe) : K.setAttribute(Qe, Oe), OB(K) ? Qn(K) : Cm(t.removed);
        } catch {
        }
      }
    }
    Ln("afterSanitizeAttributes", K, null);
  }, G1 = function It(K) {
    let rt = null;
    const ut = UB(K);
    for (Ln("beforeSanitizeShadowDOM", K, null); rt = ut.nextNode(); )
      Ln("uponSanitizeShadowNode", rt, null), !PB(rt) && (rt.content instanceof s && It(rt.content), KB(rt));
    Ln("afterSanitizeShadowDOM", K, null);
  };
  return t.sanitize = function(It) {
    let K = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, rt = null, ut = null, Wt = null, be = null;
    if (Pu = !It, Pu && (It = "<!-->"), typeof It != "string" && !HB(It))
      if (typeof It.toString == "function") {
        if (It = It.toString(), typeof It != "string")
          throw Pr("dirty is not a string, aborting");
      } else
        throw Pr("toString is not a function");
    if (!t.isSupported)
      return It;
    if (ot || Ju(K), t.removed = [], typeof It == "string" && (pi = !1), pi) {
      if (It.nodeName) {
        const pn = de(It.nodeName);
        if (!v[pn] || z[pn])
          throw Pr("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (It instanceof r)
      rt = LB("<!---->"), ut = rt.ownerDocument.importNode(It, !0), ut.nodeType === Jr.element && ut.nodeName === "BODY" || ut.nodeName === "HTML" ? rt = ut : rt.appendChild(ut);
    else {
      if (!ct && !P && !nt && // eslint-disable-next-line unicorn/prefer-includes
      It.indexOf("<") === -1)
        return m && Mt ? m.createHTML(It) : It;
      if (rt = LB(It), !rt)
        return ct ? null : Mt ? y : "";
    }
    rt && Et && Qn(rt.firstChild);
    const Qe = UB(pi ? It : rt);
    for (; Wt = Qe.nextNode(); )
      PB(Wt) || (Wt.content instanceof s && G1(Wt.content), KB(Wt));
    if (pi)
      return It;
    if (ct) {
      if (ht)
        for (be = p.call(rt.ownerDocument); rt.firstChild; )
          be.appendChild(rt.firstChild);
      else
        be = rt;
      return (L.shadowroot || L.shadowrootmode) && (be = x.call(n, be, !0)), be;
    }
    let Xe = nt ? rt.outerHTML : rt.innerHTML;
    return nt && v["!doctype"] && rt.ownerDocument && rt.ownerDocument.doctype && rt.ownerDocument.doctype.name && He(oD, rt.ownerDocument.doctype.name) && (Xe = "<!DOCTYPE " + rt.ownerDocument.doctype.name + `>
` + Xe), P && Zl([_, M, k], (pn) => {
      Xe = Hr(Xe, pn, " ");
    }), m && Mt ? m.createHTML(Xe) : Xe;
  }, t.setConfig = function() {
    let It = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Ju(It), ot = !0;
  }, t.clearConfig = function() {
    Ao = null, ot = !1;
  }, t.isValidAttribute = function(It, K, rt) {
    Ao || Ju({});
    const ut = de(It), Wt = de(K);
    return YB(ut, Wt, rt);
  }, t.addHook = function(It, K) {
    typeof K == "function" && (S[It] = S[It] || [], Or(S[It], K));
  }, t.removeHook = function(It) {
    if (S[It])
      return Cm(S[It]);
  }, t.removeHooks = function(It) {
    S[It] && (S[It] = []);
  }, t.removeAllHooks = function() {
    S = {};
  }, t;
}
var gT = rD();
const gl = (e, t) => {
  new Int32Array(cl.buffer, e, t.length).set(t);
}, UI = (e, t) => {
  new Float64Array(cl.buffer, e, t.length).set(t);
}, OI = (e = []) => {
  const t = [], i = [];
  return e.forEach((n) => {
    typeof n == "number" && Number.isFinite(n) ? (t.push(n), i.push(1)) : (t.push(NaN), i.push(-1));
  }), {
    indices: i,
    values: t
  };
}, Pn = (e, t) => {
  const i = new Int32Array(cl.buffer, e, t), n = new Array(t);
  for (let A = 0; A < i.length; A++)
    n[A] = i[A];
  return n;
}, Dm = (e, t) => {
  const i = new Float64Array(cl.buffer, e, t), n = new Array(t);
  for (let A = 0; A < i.length; A++)
    n[A] = i[A];
  return n;
}, aD = (e) => {
  let t = "";
  const i = Ht.defaults.getInvalidStore();
  if (e == null)
    return !1;
  if (typeof e == "number") {
    if (isNaN(e))
      return !1;
    t = String(e);
  } else
    t = e;
  return !i.isInvalid(t);
}, hT = (e = []) => {
  const t = /* @__PURE__ */ new Map(), i = [], n = [];
  let A = 0;
  for (let s = 0; s < e.length; s++) {
    const o = aD(e[s]);
    o && !t.has(e[s]) ? (t.set(e[s], A), i.push(A), A++, n.push(String(e[s]))) : i.push(o ? t.get(e[s]) : -1);
  }
  return {
    uniqueStrings: n,
    indices: i
  };
}, hl = (e) => ({
  name: e.name,
  type: QF(e.type),
  subtype: yF(e.subtype),
  aggregation_function: zy(e.defAggFn)
}), lD = (e) => e.map((t) => gT.sanitize(t));
function Th(e) {
  return e instanceof Ft ? parseFloat(String(e.value())) : e;
}
function vh(e) {
  return e instanceof Ft ? String(e.value()) : e;
}
function uT(e) {
  return e instanceof Ft || e === null || e === void 0 || isNaN(e);
}
var $d;
(function(e) {
  e.NORMALIZE = "normalize";
})($d || ($d = {}));
const dT = (e) => e === $d.NORMALIZE ? 1 : 0, fT = {
  stackBy: (e, t, i, n, A, s = [], o, r = [], a) => {
    const l = { y0: [], y1: [], id: [] }, c = e.context();
    switch (Ht._contextType) {
      case Ms.WASM: {
        const g = c.context(), h = c.getSchema().findIndex((y) => t === y.name), u = c.getSchema().findIndex((y) => i === y.name), d = o ? c.getSchema().findIndex((y) => o === y.name) : void 0, f = c.getSchema().findIndex((y) => n === y.name), I = c.getField(i), C = o ? c.getField(o) : void 0;
        let E = Float64Array.from([]), B = Float64Array.from([]);
        I?.subtype() === it.CATEGORICAL ? E = Float64Array.from(s.map((y) => y instanceof Ft ? -1 : I._getMeta().findIndex((D) => D === y))) : E = Float64Array.from(s.map((y) => y instanceof Ft ? NaN : y)), C?.subtype() === it.CATEGORICAL ? B = Float64Array.from(r.map((y) => y instanceof Ft ? -1 : C._getMeta().findIndex((D) => D === y))) : B = Float64Array.from(r.map((y) => y instanceof Ft ? NaN : y));
        const m = XF(g, h, u, f, qy(A), E, d, B, dT(a));
        l.y0 = Dm(m.get_y_0(), c.getDataMeta().rows), l.y1 = Dm(m.get_y_1(), c.getDataMeta().rows), l.id = Pn(m.get_id(), c.getDataMeta().rows), m.free_data(), m.free();
      }
    }
    return l;
  }
};
class Gi {
  static loadData(t, i, n = {}) {
    const A = [], s = i.map((o) => {
      A.push({ ...o });
      const r = { ...o }, { format: a } = r;
      return a && typeof a == "function" && delete r.format, r;
    });
    return n.useWorker !== !1 ? XB({ data: t, schema: s, options: n }, YF()).then((o) => (o.schema = A, o)) : XB({ data: t, schema: s, options: n }).then((o) => (o.schema = A, o));
  }
}
Gi.AggregationFunctions = ag;
Gi.ComparisonOperators = ni;
Gi.FilteringModes = ve;
Gi.LogicalOperators = Hn;
Gi.DateTimeFormatter = mt;
Gi.FieldType = Ct;
Gi.FieldSubtype = it;
Gi.DerivationOperations = Gt;
Gi.SortOrder = Vn;
Gi.Invalid = Ft;
Gi.DataWranglers = fT;
Gi.loadDataSync = HF;
class ul {
  constructor(t) {
    this._schema = t;
  }
  name() {
    return this._schema.name;
  }
  type() {
    return this._schema.type;
  }
  schema() {
    return this._schema;
  }
  displayName() {
    return this._schema.displayName || this._schema.name;
  }
  subtype() {
    return this._schema.subtype;
  }
}
class cD extends ul {
  constructor(t, i) {
    super(t), this._cachedStringDomain = [], this._cachedNumericDomain = [], this._cachedStringData = [], this._cachedNumericData = [], this._cachedFormattedData = [], this._isNaturallyNumeric = null, this._wasmField = i, this._uniqueStrings = [];
  }
  _setMeta(t) {
    this._uniqueStrings = t;
  }
  _getMeta() {
    return this._uniqueStrings;
  }
  uniques() {
    if (this._wasmField && this._cachedStringDomain.length === 0) {
      const t = this._wasmField.get_domain(0), i = Pn(t.data_ptr, t.data_len);
      t.free(), i.forEach((n) => {
        n !== -1 ? this._cachedStringDomain.push(this._uniqueStrings[n]) : this._cachedStringDomain.push(new Ft(Ht.defaultInvalidValue()));
      });
    }
    return this._cachedStringDomain;
  }
  isNaturallyNumeric() {
    var t;
    return this._isNaturallyNumeric == null && (this._isNaturallyNumeric = !!(!((t = this._wasmField) === null || t === void 0) && t.is_naturally_numeric())), this._isNaturallyNumeric;
  }
  minMax() {
    if (this._wasmField && this._cachedNumericDomain.length === 0) {
      const t = this._wasmField.get_domain(1), i = Pn(t.data_ptr, t.data_len);
      t.free(), i.forEach((n) => {
        n !== -1 && this._cachedNumericDomain.push(parseFloat(this._uniqueStrings[n]));
      });
    }
    return this._cachedNumericDomain;
  }
  domain() {
    return this.uniques();
  }
  data(t, i) {
    if (t = t || "string", t == "string") {
      const n = (A, s) => Pn(A.get_data_info(), A.get_rows_count()).map((r) => {
        let a;
        const l = this._uniqueStrings[A.get_value_at_index(r)];
        return l === void 0 ? a = new Ft(Ht.defaultInvalidValue()) : a = l, s && (a = vh(a)), a;
      });
      return i ? this._wasmField ? n(this._wasmField, !0) : [] : (this._wasmField && this._cachedStringData.length === 0 && (this._cachedStringData = n(this._wasmField, !1)), this._cachedStringData);
    } else {
      const n = (A, s) => Pn(A.get_data_info(), A.get_rows_count()).map((r) => {
        let a;
        const l = this._uniqueStrings[A.get_value_at_index(r)];
        return l === void 0 ? a = new Ft(NaN) : a = isNaN(parseFloat(l)) ? new Ft(NaN) : parseFloat(l), s && (a = Th(a)), a;
      });
      return i ? this._wasmField ? n(this._wasmField, !0) : [] : (this._wasmField && this._cachedNumericData.length === 0 && (this._cachedNumericData = n(this._wasmField, !1)), this._cachedNumericData);
    }
  }
  formattedData(t) {
    if (t) {
      const i = this.data(), n = t || this._schema.format, A = [];
      return this._cachedFormattedData = i, n instanceof Function && (i.forEach((s) => {
        let o;
        s instanceof Ft ? o = s : o = n(s), A.push(o);
      }), this._cachedFormattedData = A), this._cachedFormattedData;
    }
    return this.data();
  }
  getRowsCount() {
    return this._wasmField ? this._wasmField.get_rows_count() : 0;
  }
  dispose() {
    this._cachedStringData = [], this._cachedNumericData = [], this._cachedStringDomain = [], this._cachedNumericDomain = [], this._cachedFormattedData = [], this._wasmField && this._wasmField.free();
  }
}
const IT = (e, t, i, n) => {
  const A = hT(e), { indices: s } = A;
  let { uniqueStrings: o } = A;
  n?.sanitizeString && (o = lD(o));
  let r;
  const a = Number.MAX_VALUE;
  if (i) {
    const c = i.add_field(hl(t), o);
    r = i.get_categorical_field(c);
    const g = r.get_data_indices();
    gl(g, s);
  }
  const l = new cD(t, r);
  return l._setMeta(o), { field: l, index: a };
};
class Xd extends ul {
  constructor(t, i) {
    super(t), this._cachedStringDomain = [], this._uniques = [], this._cachedNumericDomain = [], this._cachedStringData = [], this._cachedNumericData = [], this._cachedFormattedData = [], this._wasmField = i, this._cachedFormattedData = [];
  }
  uniques() {
    return this._wasmField && this._uniques.length === 0 && this._wasmField.get_domain(1).forEach((i) => isNaN(i) ? this._uniques.push(new Ft(NaN)) : this._uniques.push(i)), this._uniques;
  }
  minMax() {
    return this._wasmField && this._cachedNumericDomain.length === 0 && this._wasmField.get_domain(0).forEach((i) => this._cachedNumericDomain.push(i)), this._cachedNumericDomain;
  }
  domain() {
    return this.minMax();
  }
  getEligibleIndecies(t) {
    return Pn(t.get_data_info(), t.get_rows_count());
  }
  data(t, i) {
    if (t = t || "numeric", t == "numeric") {
      const n = (A, s) => this.getEligibleIndecies(A).map((o) => {
        const r = A.get_value_at_index(o);
        let a;
        return Number.isFinite(r) ? a = r : a = new Ft(NaN), s && (a = Th(a)), a;
      });
      return i ? this._wasmField ? n(this._wasmField, !0) : [] : (this._wasmField && this._cachedNumericData.length === 0 && (this._cachedNumericData = n(this._wasmField, !1)), this._cachedNumericData);
    } else {
      const n = (A, s) => this.getEligibleIndecies(A).map((o) => {
        const r = A.get_value_at_index(o);
        let a;
        return Number.isFinite(r) ? a = r + "" : a = new Ft(Ht.defaultInvalidValue()), s && (a = vh(a)), a;
      });
      return i ? this._wasmField ? n(this._wasmField, !0) : [] : (this._wasmField && this._cachedStringData.length === 0 && (this._cachedStringData = n(this._wasmField, !1)), this._cachedStringData);
    }
  }
  formattedData(t) {
    if (this._cachedFormattedData.length === 0 || t) {
      const i = this.data(), n = t || this._schema.format, A = [];
      this._cachedFormattedData = i, n instanceof Function && (i.forEach((s) => {
        let o;
        s instanceof Ft ? o = s : o = n(s), A.push(o);
      }), this._cachedFormattedData = A);
    }
    return this._cachedFormattedData;
  }
  getRowsCount() {
    return this._wasmField ? this._wasmField.get_rows_count() : 0;
  }
  dispose() {
    this._cachedStringData = [], this._cachedNumericData = [], this._cachedStringDomain = [], this._cachedNumericDomain = [], this._cachedFormattedData = [], this._wasmField && this._wasmField.free();
  }
}
const CT = (e, t, i) => {
  const { indices: n, values: A } = OI(e);
  let s, o = Number.MAX_VALUE;
  return i && (o = i.add_field(hl(t), []), s = i.get_continuous_field(o), gl(s.get_data_indices(), n), UI(s.get_data_ptr(), A)), { field: new Xd(t, s), index: o };
};
class gD extends ul {
  constructor(t, i) {
    super(t), this._cachedStringDomain = [], this._uniques = [], this._cachedNumericDomain = [], this._cachedStringData = [], this._cachedNumericData = [], this._wasmField = i, this._cachedFormattedData = [];
  }
  uniques() {
    return this._wasmField && this._uniques.length === 0 && this._wasmField.get_domain(1).forEach((i) => isNaN(i) ? this._uniques.push(new Ft(NaN)) : this._uniques.push(i)), this._uniques;
  }
  minMax() {
    return this._wasmField && this._cachedNumericDomain.length === 0 && this._wasmField.get_domain(0).forEach((i) => this._cachedNumericDomain.push(i)), this._cachedNumericDomain;
  }
  domain() {
    return this.minMax();
  }
  getEligibleIndecies(t) {
    return Pn(t.get_data_info(), t.get_rows_count());
  }
  data(t, i) {
    if (t = t || "numeric", t == "numeric") {
      const n = (A, s) => this.getEligibleIndecies(A).map((o) => {
        const r = A.get_value_at_index(o);
        let a;
        return Number.isFinite(r) ? a = r : a = new Ft(NaN), s && (a = Th(a)), a;
      });
      return i ? this._wasmField ? n(this._wasmField, !0) : [] : (this._wasmField && this._cachedNumericData.length === 0 && (this._cachedNumericData = n(this._wasmField, !1)), this._cachedNumericData);
    } else {
      const n = (A, s) => this.getEligibleIndecies(A).map((o) => {
        const r = A.get_value_at_index(o);
        let a;
        return Number.isFinite(r) ? a = mt.formatAs(new Date(r), this._schema.format) : a = new Ft(Ht.defaultInvalidValue()), s && (a = vh(a)), a;
      });
      return i ? this._wasmField ? n(this._wasmField, !0) : [] : (this._wasmField && this._cachedStringData.length === 0 && (this._cachedStringData = n(this._wasmField, !1)), this._cachedStringData);
    }
  }
  formattedData(t) {
    if (this._cachedFormattedData.length === 0 || t) {
      const i = this.data(), n = t || this._schema.format;
      if (this._cachedFormattedData = i, n instanceof Function) {
        const A = [];
        i.forEach((s) => {
          let o;
          s instanceof Ft ? o = s : o = n(s), A.push(o);
        }), this._cachedFormattedData = A;
      } else if (typeof n == "string" || n instanceof String) {
        const A = [];
        i.forEach((s) => {
          let o;
          s instanceof Ft ? o = s : o = mt.formatAs(new Date(s), n), A.push(o);
        }), this._cachedFormattedData = A;
      }
    }
    return this._cachedFormattedData;
  }
  getRowsCount() {
    return this._wasmField ? this._wasmField.get_rows_count() : 0;
  }
  dispose() {
    this._cachedStringData = [], this._cachedNumericData = [], this._cachedStringDomain = [], this._cachedNumericDomain = [], this._cachedFormattedData = [], this._wasmField && this._wasmField.free();
  }
  minimumConsecutiveDifference() {
    const t = this._wasmField ? this._wasmField.min_consecutive_diff() : 1 / 0;
    return isFinite(t) ? t : NaN;
  }
}
const ET = (e, t, i) => {
  const { indices: n, values: A } = OI(e);
  let s = Number.MAX_VALUE, o;
  return i && (s = i.add_field(hl(t), []), o = i.get_temporal_field(s), gl(o.get_data_indices(), n), UI(o.get_data_ptr(), A)), { field: new gD(t, o), index: s };
};
class hD extends ul {
  constructor(t, i) {
    super(t), this._cachedStringDomain = [], this._cachedNumericDomain = [], this._cachedStringData = [], this._cachedNumericData = [], this._wasmField = i;
  }
  displayName() {
    return this._schema.name;
  }
  domain() {
    return [];
  }
  formattedData() {
    return [];
  }
  uniques() {
    return [];
  }
  minMax() {
    return [];
  }
  data() {
    if (this._cachedNumericData.length === 0 && this._wasmField) {
      const i = Pn(this._wasmField.get_data_info(), this._wasmField.get_rows_count()).map((n) => this._wasmField.get_value_at_index(n));
      this._cachedNumericData = i;
    }
    return this._cachedNumericData;
  }
  getRowsCount() {
    return this._wasmField ? this._wasmField.get_rows_count() : 0;
  }
  getValueAtIndex(t) {
    return this.data()[t];
  }
  dispose() {
    this._cachedStringData = [], this._cachedNumericData = [], this._cachedStringDomain = [], this._cachedNumericDomain = [], this._wasmField && this._wasmField.free();
  }
}
const BT = (e, t, i) => {
  let n, A = Number.MAX_VALUE;
  return i && (A = i.add_field(hl(t), []), n = i.get_id_field(A), gl(n.get_data_ptr(), e)), { field: new hD(t, n), index: A };
}, ed = () => ({
  name: jd,
  format: (e) => e,
  displayName: jd,
  type: Ct.MEASURE,
  subtype: it.ROWID,
  defAggFn: "sum"
});
class mT extends ul {
  constructor(t) {
    super(t), this._schema = t;
  }
}
class uD extends mT {
  constructor(t, i, n) {
    super(t), this._uniques = [], this._allBins = [], this._cachedNumericDomain = [], this._cachedStringData = [], this._cachedNumericData = [], this._cachedFormattedData = [], this._cachedStringDomain = [], this._wasmField = i, this._config = n;
  }
  _setMeta(t) {
    this._config = t;
  }
  _getMeta() {
    return this._config;
  }
  uniques() {
    return this._wasmField && this._uniques.length === 0 && this._wasmField.get_uniques().forEach((i) => isNaN(i) ? this._uniques.push(new Ft(NaN)) : this._uniques.push(i)), this._uniques;
  }
  getAllBins() {
    var t;
    if (this._wasmField && this._allBins.length === 0) {
      const i = this.uniques(), [n, A] = i.reduce(
        ([r, a], l) => (uT(l) || !Number.isFinite(l) ? a.push(l) : r.push(l), [r, a]),
        [[], []]
      ), s = this.getBinSize();
      let o = [];
      if (!((t = this._config) === null || t === void 0) && t.enableDomainCompletion)
        if (s !== void 0) {
          n.sort((a, l) => a - l);
          let r = null;
          for (let a = 0; a < n.length; a++) {
            const l = n[a];
            if (r === null) {
              o.push(l), r = l;
              continue;
            }
            const c = Math.abs(l - r), g = Math.max(Math.round(c / s) - 1, 0);
            for (let h = 0; h < g; h++) {
              const u = r + s;
              o.push(u), r = u;
            }
            o.push(l), r = l;
          }
          o.push(...A);
        } else
          o = i;
      else
        n.sort((r, a) => r - a), o = n, o.push(...A);
      this._allBins = o;
    }
    return this._allBins;
  }
  minMax() {
    if (this._wasmField && this._cachedNumericDomain.length === 0) {
      const t = this._wasmField.get_domain();
      Number.isFinite(t[0]) && Number.isFinite(t[1]) && (this._cachedNumericDomain[0] = t[0], this._cachedNumericDomain[1] = t[1] + (this.getBinSize() || 0));
    }
    return this._cachedNumericDomain;
  }
  domain() {
    return this.minMax();
  }
  data(t, i) {
    if (t = t || "numeric", t == "numeric") {
      const n = (A, s) => this.getEligibleIndecies(A).map((o) => {
        const r = A.get_value_at_index(o);
        let a;
        return Number.isFinite(r) ? a = r : a = new Ft(NaN), s && (a = Th(a)), a;
      });
      return i ? this._wasmField ? n(this._wasmField, !0) : [] : (this._wasmField && this._cachedNumericData.length === 0 && (this._cachedNumericData = n(this._wasmField, !1)), this._cachedNumericData);
    } else {
      const n = (A, s) => this.getEligibleIndecies(A).map((o) => {
        const r = A.get_value_at_index(o);
        let a;
        return Number.isFinite(r) ? a = r + "" : a = new Ft(Ht.defaultInvalidValue()), s && (a = vh(a)), a;
      });
      return i ? this._wasmField ? n(this._wasmField, !0) : [] : (this._wasmField && this._cachedStringData.length === 0 && (this._cachedStringData = n(this._wasmField, !1)), this._cachedStringData);
    }
  }
  getEligibleIndecies(t) {
    return Pn(t.get_data_info(), t.get_rows_count());
  }
  formattedData(t) {
    if (t) {
      const i = this.data(), n = [];
      return t instanceof Function && (i.forEach((A) => {
        let s;
        A instanceof Ft ? s = A : s = t(A), n.push(s);
      }), this._cachedFormattedData = n), this._cachedFormattedData;
    }
    return this.data();
  }
  getRowsCount() {
    return this._wasmField ? this._wasmField.get_rows_count() : 0;
  }
  dispose() {
    this._cachedStringData = [], this._cachedNumericData = [], this._cachedNumericDomain = [], this._cachedFormattedData = [], this._cachedStringDomain = [], this._wasmField && this._wasmField.free();
  }
  getBinSize() {
    return this._schema.binSize;
  }
}
const QT = (e, t, i, n) => {
  const { indices: A, values: s } = OI(e);
  let o, r = Number.MAX_VALUE;
  return i && (r = i.add_field(hl(t), []), o = i.get_binned_field(r), gl(o.get_data_indices(), A), UI(o.get_data_ptr(), s)), {
    field: new uD(t, o, {
      enableDomainCompletion: n?.enableDomainCompletion
    }),
    index: r
  };
};
class hg {
  constructor(t, i, n) {
    if (this._contextName = Ms.WASM, this._fieldOrder = [], this._fieldMap = /* @__PURE__ */ new Map(), this._dataMeta = { rows: 0, columns: 0 }, this._config = {
      sanitizeString: !1,
      enableDomainCompletion: !0
    }, n && (this._config = n), t instanceof hg)
      this._context = t._context, this._fieldOrder = t._fieldOrder, this._fieldMap = t._fieldMap;
    else {
      const { data: A, schema: s } = t, { rows: o, columns: r } = i;
      this._dataMeta = i, o && (this._context = new Ta(new va(o, r))), this.createFields(A, s);
    }
    this._partialFieldsDisposed = !1;
  }
  updateFieldMap({ field: t, index: i }) {
    const n = t.name(), A = i === Number.MAX_VALUE ? this._fieldMap.size : i;
    this._fieldMap.set(n, { field: t, index: A });
  }
  createFields(t, i) {
    i.forEach((n, A) => {
      this.createField(t[A], n);
    }), this.createField(
      new Array(t[0].length).fill(0).map((n, A) => A),
      ed()
    );
  }
  createField(t, i) {
    const { subtype: n } = i;
    switch (n) {
      case it.CATEGORICAL:
        this.updateFieldMap(
          IT(t, i, this._context, {
            sanitizeString: this._config.sanitizeString
          })
        );
        break;
      case it.BINNED:
        this.updateFieldMap(
          QT(t, i, this._context, {
            enableDomainCompletion: this._config.enableDomainCompletion
          })
        );
        break;
      case it.CONTINUOUS:
        this.updateFieldMap(CT(t, i, this._context));
        break;
      case it.TEMPORAL:
        this.updateFieldMap(ET(t, i, this._context));
        break;
      case it.ROWID:
        this.updateFieldMap(BT(t, i, this._context));
        break;
    }
    this._fieldOrder.push(i.name);
  }
  updateFields(t) {
    this._fieldOrder.forEach((i) => {
      const { field: n, index: A } = t.get(i), s = n.schema();
      switch (s.subtype) {
        case it.CATEGORICAL: {
          const o = new cD(
            s,
            this._context.get_categorical_field(A)
          );
          o._setMeta(n._getMeta()), this.updateFieldMap({
            field: o,
            index: A
          });
          break;
        }
        case it.CONTINUOUS:
          this.updateFieldMap({
            index: A,
            field: new Xd(s, this._context.get_continuous_field(A))
          });
          break;
        case it.BINNED: {
          const o = new uD(s, this._context.get_binned_field(A));
          o._setMeta(n._getMeta()), this.updateFieldMap({
            index: A,
            field: o
          });
          break;
        }
        case it.TEMPORAL:
          this.updateFieldMap({
            field: new gD(s, this._context.get_temporal_field(A)),
            index: A
          });
          break;
        case it.ROWID:
          this.updateFieldMap({
            field: new hD(s, this._context.get_id_field(A)),
            index: A
          });
          break;
      }
    });
  }
  setContextInfo(t = this._context, i = [...this._fieldOrder], n = this._fieldMap) {
    this._context ? (this._context = t, this._dataMeta = {
      rows: t.row_count(),
      columns: t.column_count()
    }, this._fieldOrder = i, this._fieldMap = /* @__PURE__ */ new Map(), this.updateFields(n)) : (this._fieldOrder = i, this._fieldMap = n);
  }
  getClonedFieldMap(t, i) {
    const n = /* @__PURE__ */ new Map();
    return i.forEach((A, s) => {
      const { field: o } = t._fieldMap.get(A);
      n.set(A, { field: o, index: s });
    }), n;
  }
  getField(t) {
    const { field: i = void 0 } = this._fieldMap.get(t) || {};
    return i;
  }
  getData(t, i, n, A) {
    t = t || 0, n = n || [];
    let s = [];
    const o = [], r = this._fieldMap.get(this._fieldOrder[0]);
    if (r) {
      const { field: a } = r, l = a.getRowsCount(), c = i || l, g = this._fieldOrder.map((h) => {
        const { field: u } = this._fieldMap.get(h), d = n?.find((I) => I.name === u.name());
        return d ? u.data(
          d.as,
          A?.shouldSanitize
        ) : u.data(void 0, A?.shouldSanitize);
      });
      for (let h = t; h < c; h++)
        o.push([]), this._fieldOrder.forEach((u, d) => {
          const f = o.length - 1, I = g[d];
          o[f][d] = I[h];
        });
      return s = this.getSchema(), { schema: s, data: o };
    }
    return { schema: s, data: [] };
  }
  getSchema() {
    return this._fieldOrder.map((t) => this._fieldMap.get(t).field.schema());
  }
  getDataMeta() {
    return this._dataMeta;
  }
  sort(t) {
    const i = this.clone();
    if (this._context) {
      const n = [];
      t.forEach((s) => {
        const o = this._fieldMap.get(s[0]);
        o && n.push([o.index, qy(s[1])]);
      });
      const A = this._context.sort(n);
      i.setContextInfo(A);
    }
    return i;
  }
  groupBy(t, i = [], n = { createId: !0 }) {
    const A = this.clone(), [s, o] = t.reduce(
      (g, h) => {
        const u = this._fieldMap.get(h);
        return u && (g[0].push(h), g[1].push(u.index)), g;
      },
      [[], []]
    ), r = [];
    i.map((g) => {
      const h = this._fieldMap.get(g.field);
      h && r.push([h.index, zy(g.aggn)]);
    });
    const a = this._context ? this._context.group_by(o, r) : void 0;
    let l = this._fieldOrder.filter((g) => {
      var h, u;
      return ((h = this._fieldMap.get(g)) === null || h === void 0 ? void 0 : h.field) instanceof Xd && !s.includes(g) && ((u = this._fieldMap.get(g)) === null || u === void 0 ? void 0 : u.field.schema().type) !== Ct.DIMENSION;
    });
    l = [...s, ...l];
    const c = this.getClonedFieldMap(A, l);
    if (A.setContextInfo(a, l, c), n.createId !== !1) {
      const { field: g } = A._fieldMap.get(A._fieldOrder[0]), h = g.getRowsCount();
      A.createField(
        new Array(h).fill(0).map((u, d) => d),
        ed()
      );
    }
    return A;
  }
  select(t, i) {
    const n = this.clone();
    let A = n;
    if (this._context) {
      const s = iD(t, this._fieldMap);
      if (s.operator) {
        const { mode: o = ve.NORMAL } = i || {}, r = tm(o), a = this._context.select(s, r);
        switch (o) {
          case ve.ALL: {
            n.setContextInfo(a.get_filtered_dm());
            const l = this.clone();
            l.setContextInfo(a.get_unfiltered_dm()), A = [n, l];
            break;
          }
          case ve.INVERSE:
            n.setContextInfo(a.get_unfiltered_dm()), A = n;
            break;
          default:
            n.setContextInfo(a.get_filtered_dm()), A = n;
            break;
        }
        a.free();
      } else
        A.setContextInfo(A._context && A._context.clone());
    }
    return A;
  }
  project(t, i) {
    const n = this.clone();
    let A = n;
    const { mode: s = ve.NORMAL } = i || {}, o = [], r = [];
    t.map((h) => {
      const u = this._fieldMap.get(h);
      u && (o.push(h), r.push(u.index));
    }), o.push(jd);
    const a = this._fieldOrder.filter((h, u) => !r.includes(u)), l = tm(s), c = this._context ? this._context.project({ columns: r, mode: l }) : void 0;
    let g;
    switch (s) {
      case ve.ALL: {
        g = this.getClonedFieldMap(n, o), n.setContextInfo(c ? c.get_filtered_dm() : void 0, o, g);
        const h = this.clone();
        g = this.getClonedFieldMap(h, a), h.setContextInfo(
          c ? c.get_unfiltered_dm() : void 0,
          a,
          g
        ), A = [n, h];
        break;
      }
      case ve.INVERSE:
        g = this.getClonedFieldMap(n, a), n.setContextInfo(
          c ? c.get_unfiltered_dm() : void 0,
          a,
          g
        ), A = n;
        break;
      default:
        g = this.getClonedFieldMap(n, o), n.setContextInfo(c ? c.get_filtered_dm() : void 0, o, g), A = n;
    }
    return c && c.free(), A;
  }
  splitByRow(t) {
    let i = [];
    if (this._context) {
      const n = [];
      t.forEach((o) => {
        const r = this._fieldMap.get(o);
        r && n.push(r.index);
      });
      const A = this._context.split_by_row(n), s = A.get_count();
      i = [];
      for (let o = 0; o < s; o++) {
        const r = this.clone();
        r.setContextInfo(A.get_dm()), i.push(r);
      }
      A.free();
    }
    return i.reverse();
  }
  clone() {
    return new hg(this);
  }
  dispose(t) {
    const { disposePartialFields: i, disposeFields: n } = t, { dispose: A, values: s = [] } = i;
    if (A && this._context) {
      const o = s.map((r) => {
        const { index: a } = this._fieldMap.get(r);
        return a;
      });
      this._partialFieldsDisposed = !0, this._context.dispose(o);
    }
    n && this._fieldOrder.forEach((o) => {
      const { field: r } = this._fieldMap.get(o);
      r.dispose();
    }), this._context && this._context.free();
  }
  addIdField(t) {
    return this.createField(Array.from(t), ed()), this;
  }
  calculateVariable(t, i, n) {
    const A = this.clone();
    if (this._context) {
      const s = i.map((g) => this._fieldMap.get(g).field.data()), { subtype: o = it.CATEGORICAL, format: r } = t, a = new Array(this._context.get_partial_row_count());
      a.fill(NaN);
      const l = this._context.get_eligible_rows();
      for (let g = 0; g < this._dataMeta.rows; g++) {
        const h = n(...s.map((u) => u[g]));
        o === it.TEMPORAL ? a[l[g]] = eD(o, h, r || ((u) => u)) : a[l[g]] = h;
      }
      const c = this._context.clone();
      A.setContextInfo(c), A.createField(a, t);
    }
    return A;
  }
  getMatchingIds(t) {
    return Array.from(this._context && t._context ? this._context.get_matching_ids(t._context) : []);
  }
  context() {
    return this._context;
  }
}
const pT = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  [Gt.SELECT]: (e) => ({
    disposeFields: !0,
    disposePartialFields: {
      dispose: !1,
      values: []
    }
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  [Gt.PROJECT]: (e) => ({
    disposeFields: !0,
    disposePartialFields: {
      dispose: !1,
      values: []
    }
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  [Gt.GROUPBY]: (e) => ({
    disposeFields: !0,
    disposePartialFields: {
      dispose: !0,
      values: []
    }
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  [Gt.SORT]: (e) => ({
    disposeFields: !0,
    disposePartialFields: {
      dispose: !1,
      values: []
    }
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  [Gt.SPLIT]: (e) => ({
    disposeFields: !0,
    disposePartialFields: {
      dispose: !1,
      values: []
    }
  }),
  [Gt.CALCULATE]: (e) => ({
    disposeFields: !0,
    disposePartialFields: {
      dispose: !0,
      values: [e.fieldInfo.name]
    }
  })
}, yT = (e, t, i, n) => {
  const { listeners: A } = n._propagationInfo;
  return i && A.length ? (A.forEach((s) => {
    s(e, t);
  }), !0) : !1;
}, wm = (e, t) => {
  for (; e; )
    e._refCount = Math.max(e._refCount + (t ? 1 : -1), 0), e = e?.getParent();
}, DT = (e) => {
  for (; e; ) {
    const t = e?.getParent();
    !e._refCount && e.disposeResources(), e = t;
  }
}, xm = (e) => {
  for (; e; ) {
    const t = e?.getParent();
    if (!t)
      break;
    e = t;
  }
  return e;
}, wT = (e, t) => {
  const i = /* @__PURE__ */ new Map();
  return e.forEach((n) => {
    const { dm: A = t, criteria: s, fields: o } = n;
    let r = A, a = o.slice();
    const l = o.some((c) => {
      var g;
      return ((g = A.getField(c)) === null || g === void 0 ? void 0 : g.type()) === Ct.MEASURE;
    });
    for (; r; ) {
      const c = r?.getParent(), g = r.getDerivations();
      if (g.length) {
        const { operation: h } = g[0], u = h === Gt.GROUPBY && l, d = a.filter((f) => c.getField(f));
        if (u) {
          i.set(r?.id(), s);
          break;
        } else
          d.length < a.length && (a = d, i.set(r?.id(), s));
      }
      r = c;
    }
  }), i;
}, xT = (e, t) => {
  const { operation: i, params: n } = t.getDerivations()[0];
  let A;
  switch (i) {
    case Gt.SELECT:
      A = e.select(n.query);
      break;
    case Gt.GROUPBY: {
      A = e.groupBy(n.fields, n.reducers, {
        createId: !1
      });
      const s = A._context.getMatchingIds(t._context);
      A._context.addIdField(s);
      break;
    }
    case Gt.PROJECT:
      A = e.project(n.fields);
      break;
    case Gt.SORT:
      A = e.sort(n);
      break;
    case Gt.CALCULATE:
      A = e.calculateVariable(n.fieldInfo, n.fields, n.fn);
      break;
  }
  return A;
}, dD = (e, t, i, n) => {
  const { info: A, query: s, targetMap: o, nonPropagationDms: r } = t, { targetDms: a = /* @__PURE__ */ new Set(), payload: l, exclude: c = !0 } = A;
  if (o.get(e.id()) === !1)
    return;
  let g = n;
  const h = t.info.payload ? t.info.payload.propagateDm !== !1 : !0;
  if (s && h) {
    const C = e.id();
    (i.get(C) || !g) && (g = e.select(s), e.removeChild(g), g.detachParent());
  }
  const u = a.has(e.id());
  yT(g, l, c ? !u : u, e) === !1 && (r.push(g), n !== g && r.push(n)), e.getChildren().filter((C) => o.get(C.id()) !== !1).forEach((C) => {
    let E;
    const B = t.info.payload ? t.info.payload.propagateDm !== !1 : !0;
    g && B && (E = xT(g, C)), dD(C, t, i, E);
  });
}, fD = (e, t = /* @__PURE__ */ new Set(), i = !0, n = /* @__PURE__ */ new Map()) => {
  const A = e.getChildren();
  let s = !1;
  A.forEach((r) => {
    const a = fD(r, t, i, n);
    s = s || a;
  });
  const o = t.has(e.id());
  return s = s || (i ? !o : o), n.set(e.id(), s), s;
}, Sm = (e, t) => ({
  operator: ni.EQUAL,
  value: e === Ht.defaultInvalidValue() || e instanceof Ft ? void 0 : e,
  field: t
}), ST = (e, t) => {
  let i = {};
  const n = t.length;
  if (n === 1) {
    const A = e.getField(t[0]);
    A ? i = Sm(A.domain()[0], t[0]) : i = {};
  } else
    n > 1 && (i.conditions = [], t.forEach((A, s) => {
      const o = e.getField(A);
      o && (i.operator = Hn.AND, i.conditions[s] = Sm(o.domain()[0], A));
    }));
  return i;
};
class MT {
  constructor() {
    this._defaultInvalids = /* @__PURE__ */ new Set();
    const t = Object.values(gg);
    for (const i in t) {
      const n = t[i];
      this._defaultInvalids.add(n);
    }
  }
  setInvalids(t) {
    t.forEach((i) => this._defaultInvalids.add(i));
  }
  getInvalids() {
    return this._defaultInvalids;
  }
  unsetInvalids(t) {
    for (const i in t)
      this._defaultInvalids.delete(t[i]);
  }
  isInvalid(t) {
    return this._defaultInvalids.has(t);
  }
}
const _T = () => {
  let e = ag.SUM;
  const t = new MT();
  let i = Yk;
  return {
    setDefaultAggregation: (n) => {
      e = n;
    },
    getDefaultAggregation: () => e,
    setInvalids: (n) => {
      t.setInvalids(n);
    },
    unsetInvalids: (n) => {
      t.unsetInvalids(n);
    },
    getInvalidStore: () => t,
    setDefaultInvalidValue: (n) => {
      i = n;
    },
    getDefaultInvalidValue: () => i
  };
}, bT = (() => {
  let e = 0;
  return () => e++;
})();
class Ht extends Gi {
  static setContext(t = Ms.WASM) {
    Ht._contextType = t;
  }
  constructor(t, i) {
    if (super(), this._children = [], this._derivations = [], this._preDisposeTasks = [], this._config = {
      sanitizeString: !1,
      enableDomainCompletion: !0
    }, i && (this._config = i), this._broadcastChannel = null, t instanceof Ht)
      this._context = t._context, this._derivations = [...t._derivations], this._commonDerivation = null;
    else {
      const { data: n, schema: A } = t, s = this.sanitizeSchema(A);
      switch (Ht._contextType) {
        case Ms.WASM:
          this._context = this.setWasmContext({ data: n, schema: s }, { rows: n[0].length, columns: s.length }, this._config);
          break;
        default:
          this._context = this.setWasmContext({ data: n, schema: s }, { rows: n[0].length, columns: s.length }, this._config);
      }
      this._commonDerivation = null;
    }
    this._id = bT(), this._propagationInfo = {
      listeners: [],
      propagationCriterias: /* @__PURE__ */ new Map()
    }, this._refCount = 1;
  }
  setWasmContext(t, i, n) {
    return new hg(t, i, n);
  }
  setContextInfo(t) {
    this._context = t;
  }
  sanitizeSchema(t) {
    const i = Ht.defaultAggregation();
    return t.map((A) => {
      const { format: s = (o) => o } = A;
      return {
        name: A.name,
        type: A.type,
        subtype: A.subtype || DF(A.type),
        defAggFn: A.defAggFn || i,
        format: s,
        displayName: A.displayName || A.name,
        binSize: A.binSize
      };
    });
  }
  cloneFromContext(t) {
    if (Array.isArray(t)) {
      const i = t, n = [];
      return i.forEach((A) => {
        const s = this.clone();
        s.setContextInfo(A), s._derivations = [], n.push(s);
      }), n;
    } else {
      const i = this.clone();
      return i._derivations = [], i.setContextInfo(t), i;
    }
  }
  static setInvalids(t) {
    t && Ht.defaults.setInvalids(t);
  }
  static unsetInvalids(t) {
    t && Ht.defaults.unsetInvalids(t);
  }
  static defaultInvalidValue(t) {
    return t && Ht.defaults.setDefaultInvalidValue(t), Ht.defaults.getDefaultInvalidValue();
  }
  static defaultAggregation(t) {
    return t && Ht.defaults.setDefaultAggregation(t), Ht.defaults.getDefaultAggregation();
  }
  static get defaults() {
    return Ht._defaults || (Ht._defaults = _T()), Ht._defaults;
  }
  id() {
    return this._id;
  }
  setCreatorIdentifier(t) {
    return this._creatorIdentifier = t, this;
  }
  getCreatorIdentifier() {
    return this._creatorIdentifier;
  }
  getField(t) {
    return this._context.getField(t);
  }
  getParent() {
    return this._parent;
  }
  getChildren() {
    return [...this._children];
  }
  getDerivations() {
    return [...this._derivations];
  }
  removeChild(t) {
    const i = this._children.findIndex((n) => n === t);
    i > -1 && this._children.splice(i, 1);
  }
  detachParent() {
    return this._parent = void 0, this;
  }
  getData(t, i) {
    return this._context.getData(i?.start, i?.end, t, i);
  }
  getDataMeta() {
    return this._context.getDataMeta();
  }
  getSchema() {
    return this._context.getSchema();
  }
  clone(t = !0) {
    const i = new Ht(this);
    return i.setCreatorIdentifier(this.getCreatorIdentifier()), t && (wm(this, !0), this._children.push(i), i._parent = this), i;
  }
  sort(t) {
    const i = this._context.sort(t), n = this.cloneFromContext(i);
    return n._derivations.push({ operation: Gt.SORT, params: t }), n;
  }
  select(t, i) {
    const { mode: n = ve.NORMAL } = i || {}, A = this._context.select(t, { mode: n }), s = this.cloneFromContext(A);
    return s instanceof Array ? (s[0]._derivations.push({
      operation: Gt.SELECT,
      params: { query: t, options: { mode: ve.NORMAL } }
    }), s[1]._derivations.push({
      operation: Gt.SELECT,
      params: { query: t, options: { mode: ve.INVERSE } }
    })) : s._derivations.push({
      operation: Gt.SELECT,
      params: { query: t, options: { mode: n } }
    }), s;
  }
  splitByRow(t) {
    const i = this._context.splitByRow(t), n = this.cloneFromContext(i);
    return n.map((A) => {
      const s = ST(A, t);
      return A._commonDerivation = {
        operation: Gt.SPLIT,
        params: { fields: t }
      }, A._derivations.push({
        operation: Gt.SELECT,
        params: { query: s, options: { mode: ve.NORMAL } }
      });
    }), n;
  }
  project(t, i) {
    const { mode: n = ve.NORMAL } = i || {}, A = this._context.project(t, { mode: n }), s = this.cloneFromContext(A);
    return s instanceof Array ? (s[0]._derivations.push({
      operation: Gt.PROJECT,
      params: { fields: t, options: { mode: ve.NORMAL } }
    }), s[1]._derivations.push({
      operation: Gt.PROJECT,
      params: { fields: t, options: { mode: ve.INVERSE } }
    })) : s._derivations.push({ operation: Gt.PROJECT, params: { fields: t, options: i } }), s;
  }
  groupBy(t, i = [], n = {}) {
    const A = this._context.groupBy(t, i, n), s = this.cloneFromContext(A);
    return s._derivations.push({ operation: Gt.GROUPBY, params: { fields: t, reducers: i } }), s;
  }
  disposeRecursive(t = !0) {
    this._refCount = Math.max(this._refCount - 1, 0), (this._refCount === 0 || t) && (this.preDispose(), this.disposeResources(), this.getChildren().forEach((n) => {
      n.disposeRecursive(t);
    }));
  }
  getPropagationCriterias() {
    return this._propagationInfo.propagationCriterias;
  }
  registerPreDisposeTask(t) {
    return this._preDisposeTasks.push(t), () => {
      this.delistPreDisposeTask(t);
    };
  }
  delistPreDisposeTask(t) {
    const i = this._preDisposeTasks.findIndex((n) => n === t);
    this._preDisposeTasks.splice(i, 1);
  }
  preDispose() {
    this._preDisposeTasks.forEach((t) => {
      t();
    });
  }
  dispose(t = !0) {
    if (!this._disposed) {
      const i = this.getParent();
      this.disposeRecursive(t), wm(i, !1), DT(i);
    }
    return this;
  }
  disposeResources() {
    var t;
    if (this._disposed)
      return this;
    const i = this._derivations[this._derivations.length - 1];
    if (this.closeBroadcastChannel(), i) {
      const n = i.operation;
      this._context.dispose(pT[n](i.params));
    } else
      this._context.dispose({
        disposeFields: !0,
        disposePartialFields: {
          dispose: !0,
          values: []
        }
      });
    return (t = this._parent) === null || t === void 0 || t.removeChild(this), this.detachParent(), this._disposed = !0, this;
  }
  openBroadcastChannel() {
    const t = xm(this);
    return this._broadcastChannel == null && this === t && globalThis.BroadcastChannel != null && (this._broadcastChannel = new globalThis.BroadcastChannel(MF), this._broadcastChannel.addEventListener("message", (i) => {
      i.data.creatorIdentifier != null && this.getCreatorIdentifier() != null && i.data.creatorIdentifier === this.getCreatorIdentifier() && this.propagate(i.data.queries, i.data.info, { preventBroadcast: !0 });
    })), this;
  }
  closeBroadcastChannel() {
    return this._broadcastChannel != null && (this._broadcastChannel.close(), this._broadcastChannel = null), this;
  }
  propagate(t, i, { preventBroadcast: n = !1, creatorIdentifier: A } = {
    preventBroadcast: !1
  }) {
    var s;
    const o = xm(this);
    if (!n && A != null)
      try {
        (s = o._broadcastChannel) === null || s === void 0 || s.postMessage({ queries: t, info: i, creatorIdentifier: A });
      } catch {
      }
    const r = t.map((h) => h.criteria).filter((h) => h !== null), a = r.length ? {
      operator: i.queryOperator || "and",
      conditions: r
    } : null, l = wT(t, this), c = /* @__PURE__ */ new Map();
    fD(o, i.targetDms, i.exclude, c);
    const g = [];
    return dD(o, {
      query: a,
      info: i,
      targetMap: c,
      nonPropagationDms: g
    }, l), g.forEach((h) => {
      h && h.dispose(!1);
    }), this;
  }
  onPropagation(t) {
    return this._propagationInfo.listeners.push(t), this;
  }
  unsubscribePropagationListeners() {
    return this._propagationInfo.listeners = [], this;
  }
  calculateVariable(t, i, n) {
    const A = this._context.calculateVariable(this.sanitizeSchema([t])[0], i, n), s = this.cloneFromContext(A);
    return s._derivations.push({ operation: Gt.CALCULATE, params: { fieldInfo: t, fields: i, fn: n } }), s;
  }
  context() {
    return this._context;
  }
  static sanitizeStringVals(t) {
    return lD(t);
  }
}
Ht._contextType = Ms.WASM;
var St = /* @__PURE__ */ ((e) => (e.ROW_ID = "__id__", e.MEASURE_NAMES = "__measure_names__", e))(St || {}), $o = /* @__PURE__ */ ((e) => (e.ACTION_INF = "actionInf", e.MATRIX_CREATED = "matrixCreated", e))($o || {}), Xo = /* @__PURE__ */ ((e) => (e.POLAR = "polar", e.CARTESIAN = "cartesian", e))(Xo || {}), ID = /* @__PURE__ */ ((e) => (e.FUNCTION = "function", e.STRING = "string", e.NUMBER = "number", e.BOOLEAN = "Boolean", e))(ID || {});
const CD = "asc", ED = "desc", Mm = "horizontal", ug = "binned", BD = "SimpleVar", HI = "ComposedVar", mD = "NullVar";
var lt = /* @__PURE__ */ ((e) => (e.DISCRETE = "discrete", e.CONTINUOUS = "continuous", e))(lt || {});
const QD = "backgroundColor", pD = "color", yD = "size", Da = " ", PI = 5, Hs = "_blank", Ps = "nofollow", Ys = {}, Js = "", DD = "", wD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BACKGROUND_COLOR: QD,
  COLOR: pD,
  COL_HTML_FACET_AND_HEADER_TOP_PADDING: PI,
  DEFAULT_HYP_CLASSNAMES: Js,
  DEFAULT_HYP_REL: Ps,
  DEFAULT_HYP_STYLES: Ys,
  DEFAULT_HYP_TARGET: Hs,
  DEFAULT_HYP_URL: DD,
  EMPTY_CELL_CONTENT: Da,
  SCALES: lt,
  SIZE: yD
}, Symbol.toStringTag, { value: "Module" })), dg = "__id__", bt = "8bc7333f_a088_4b34_b02a_b5a6064f9b85", NT = "step";
class Zi extends Error {
  name;
  constructor(t, i) {
    super(t, i), this.name = "MuzeError";
  }
}
const { DISCRETE: FT, CONTINUOUS: RT } = lt;
class J {
  static _dataModelCls;
  _model;
  _propagationListeners;
  _id;
  _disposeListeners;
  _disposed = !1;
  _prevPayload;
  _uidMap;
  _parent;
  _fieldsConfig;
  _propagation;
  propagationState;
  constructor(t, i) {
    const n = J.DataModel();
    if (t instanceof n ? this._model = t : i ? this._model = new n(t, {
      sanitizeString: i.sanitizeString,
      enableDomainCompletion: i.enableDomainCompletion
    }) : this._model = new n(t), i) {
      const { creatorIdentifier: A } = i;
      A && this.setCreatorIdentifier(A);
    }
    this._fieldsConfig = null, this.propagationState = /* @__PURE__ */ new Map(), this._propagationListeners = [], this._id = this.model.id();
  }
  static get ComparisonOperators() {
    return this.DataModel().ComparisonOperators;
  }
  static get FilteringModes() {
    return this.DataModel().FilteringModes;
  }
  static get LogicalOperators() {
    return this.DataModel().LogicalOperators;
  }
  static get SortOrder() {
    return this.DataModel().SortOrder;
  }
  static get DateTimeFormatter() {
    return this.DataModel().DateTimeFormatter;
  }
  static get FieldType() {
    return this.DataModel().FieldType;
  }
  static get FieldSubtype() {
    return this.DataModel().FieldSubtype;
  }
  static get DerivationOperations() {
    return this.DataModel().DerivationOperations;
  }
  static Invalid(t) {
    return new Ft(t);
  }
  static get AggregationFunctions() {
    return this.DataModel().AggregationFunctions;
  }
  static DataModel() {
    return Ht;
  }
  static loadData(t, i, n) {
    return this.DataModel().loadData(t, i, n);
  }
  static isInvalid(t) {
    return t instanceof Ft;
  }
  static createInvalid(t) {
    const i = this.DataModel();
    return t === it.CONTINUOUS || t === it.TEMPORAL ? new Ft(NaN) : new Ft(i.defaultInvalidValue());
  }
  static getActualValue(t) {
    return this.isInvalid(t) ? t.value() : t;
  }
  get model() {
    return this._model;
  }
  static sanitiseStrings(t) {
    return this.DataModel().sanitizeStringVals(t);
  }
  setCreatorIdentifier(t) {
    return this.model.setCreatorIdentifier(t), this;
  }
  getCreatorIdentifier() {
    return this.model.getCreatorIdentifier();
  }
  getField(t) {
    return this.model.getField(t);
  }
  getFieldData(t) {
    return this.model.getField(t).data();
  }
  select(t, i) {
    if (!this.isDisposed())
      try {
        const n = this.model.select(t, i);
        return n instanceof Array ? n.map((A) => this.clone(A)) : this.clone(n);
      } catch {
        throw new Zi(
          "select operation on datamodel after it has been disposed"
        );
      }
    return null;
  }
  groupBy(t, i, n) {
    const A = this.model.groupBy(t, i, n);
    return this.clone(A);
  }
  sort(t) {
    const i = this.model._context._fieldMap, n = t.reduce(
      (s, [o, r = "asc"]) => i.get(o) === void 0 ? s : [...s, [o, r]],
      []
    );
    if (!n.length)
      return this;
    const A = this.model.sort(n);
    return this.clone(A);
  }
  getData(t = {}) {
    const { fieldMeta: i, shouldSanitize: n, excludeFields: A, start: s, end: o } = t, { data: r, schema: a } = this.model.getData(i, {
      start: s,
      end: o,
      shouldSanitize: n
    });
    if (A) {
      let l = r, c = a;
      return A.forEach((g) => {
        const h = c.findIndex(
          (u) => u.name === g
        );
        l = l.map(
          (u) => u.filter((d, f) => f !== h)
        ), c = c.filter(
          (u, d) => d !== h
        );
      }), { data: l, schema: c };
    }
    return { data: r, schema: a };
  }
  isEmpty() {
    const { rows: t } = this.model.getDataMeta();
    return !t;
  }
  isDimension(t) {
    const i = this.getField(t);
    return i && i.type() === Ct.DIMENSION;
  }
  isMeasure(t) {
    const i = this.getField(t);
    return i && i.type() === Ct.MEASURE;
  }
  isTemporal(t) {
    const i = this.getField(t);
    return i && i.subtype() === it.TEMPORAL;
  }
  isBinned(t) {
    const i = this.getField(t);
    return i && i.subtype() === it.BINNED;
  }
  isCategorical(t) {
    const i = this.getField(t);
    return i && i.subtype() === it.CATEGORICAL;
  }
  isFieldPresent(t) {
    return !!this.getField(t);
  }
  removeChild(t) {
    this.model.removeChild(t.model);
  }
  getSchema(t) {
    const i = this.model.getSchema();
    return t && t.excludeFields ? i.filter((n) => {
      const A = n.name;
      return !t.excludeFields.includes(A);
    }) : i;
  }
  getValueAtIndex(t, i) {
    const n = this.getField(t);
    return n ? n.data()[i] : null;
  }
  // @todo remove this once dm supports timestamp in selection
  getFormattedValueAtIndex(t, i) {
    return this.getField(t).data()[i];
  }
  getFieldNames() {
    return this.getSchema().map((t) => t.name);
  }
  getFieldIndex(t) {
    return t && this.isFieldPresent(t) ? this.model._context._fieldMap.get(t).index : null;
  }
  getRowsCount() {
    return this.model.getDataMeta().rows;
  }
  getDimensions() {
    return this.getSchema().filter((t) => t.type === Ct.DIMENSION).map((t) => t.name);
  }
  hasOneValue() {
    let t = !1;
    const i = this.getFieldNames();
    for (let n = 0, A = this.getRowsCount(); n < A && !t && (t = i.some((s) => {
      const o = this.getValueAtIndex(s, n);
      return !o || J.isInvalid(o) ? !1 : o;
    }), !t); n++)
      ;
    return t;
  }
  openBroadcastChannel() {
    return this.model.openBroadcastChannel(), this;
  }
  closeBroadcastChannel() {
    return this.model.closeBroadcastChannel(), this;
  }
  dispose(t) {
    if (typeof t != "boolean" && (t = !0), this._disposeListeners && this._disposeListeners(), this._disposed = !0, !this.model._disposed)
      try {
        this.model.dispose(t);
      } catch (i) {
        throw new Zi(
          `attempt to dispose a already disposed datamodel: (${i.message})`
        );
      }
  }
  isDisposed() {
    return this.model._disposed;
  }
  project(t) {
    const i = [
      ...new Set(
        t.filter(
          (s) => this.getField(s) && s !== St.ROW_ID
        )
      )
    ], n = this.model.project(i);
    return Array.isArray(n) ? n.map((s) => this.clone(s)) : this.clone(n);
  }
  calculateVariable(t, i, n) {
    const A = this.model.calculateVariable(t, i, n);
    return this.clone(A);
  }
  clone(t) {
    return new J(t, t._config);
  }
  getSubtype(t) {
    const i = this.getField(t);
    return i ? i.subtype() : null;
  }
  getMeasures() {
    return this.getSchema().filter(
      (t) => t.type === Ct.MEASURE && t.name !== St.ROW_ID
    ).map((t) => t.name);
  }
  splitByRow(t) {
    return this.model.splitByRow(t).map((n) => this.clone(n));
  }
  splitByColumn(t, i) {
    const n = [];
    return t = t.length ? t : [[]], t.forEach((A) => {
      n.push(
        this.project(
          new Array(.../* @__PURE__ */ new Set([...A, ...i]))
        )
      );
    }), n;
  }
  getQueryFromIds(t, i, n = !0) {
    const A = this.getUidMap(), s = [], o = {}, r = this.isTemporal(i[0]);
    if (i.length === 1 && n && !r) {
      const a = t.map((l) => {
        let c = this.getFormattedValueAtIndex(i[0], A[l]);
        return J.isInvalid(c) && (c = J.getActualValue(c)), c;
      });
      return {
        operator: ni.IN,
        field: i[0],
        value: a
      };
    }
    return t.forEach((a) => {
      const l = [];
      if (n) {
        let c = "";
        if (i.forEach((g) => {
          let h = this.getFormattedValueAtIndex(g, A[a]);
          J.isInvalid(h) && (h = J.getActualValue(h)), l.push({
            field: g,
            operator: ni.EQUAL,
            value: h
          }), c += h;
        }), o[c])
          return;
        o[c] = !0;
      } else
        l.push({
          field: i[0],
          operator: ni.EQUAL,
          value: a
        });
      s.push({
        conditions: l,
        operator: Hn.AND
      });
    }), {
      conditions: s,
      operator: Hn.OR
    };
  }
  getPropagationQuery(t, i) {
    const { fields: n, interpolated: A } = i;
    let s;
    return t ? i.isQuery ? s = t : A ? s = this.getFilterRangeQuery(
      t,
      i.type,
      i.domain
    ) : s = this.getQueryFromIds(
      t,
      n,
      i.resolveId
    ) : s = null, s;
  }
  // @TODO: remove any
  propagate(t, i, n = {}) {
    const A = Object.assign(
      {},
      {
        payload: i
      },
      n
    );
    return i.resetAllInteractions ? (this._prevPayload && i.sourceAction === this._prevPayload.sourceAction ? this.model.propagate(t, A, {
      preventBroadcast: !0,
      creatorIdentifier: this._model.getCreatorIdentifier()
    }) : this.model.propagate(t, A, {
      creatorIdentifier: this._model.getCreatorIdentifier()
    }), this._prevPayload = i) : this.model.propagate(t, A, {
      creatorIdentifier: this._model.getCreatorIdentifier()
    }), this;
  }
  getFilterRangeQuery(t, i = "", n = []) {
    const A = Object.keys(t).map((s) => {
      let o;
      return this.isCategorical(s) ? o = [
        {
          field: s,
          value: t[s],
          operator: ni.IN
        }
      ] : o = (t[s][0] instanceof Array ? t[s] : [t[s]]).map((a) => ({
        conditions: [
          {
            field: s,
            operator: ni.GREATER_THAN_EQUAL,
            value: a[0]
          },
          {
            field: s,
            operator: i === NT && typeof n[1] == "number" && a[1] < n[n.length - 1] ? ni.LESS_THAN : ni.LESS_THAN_EQUAL,
            value: a[1]
          }
        ],
        operator: Hn.AND
      })), {
        conditions: o,
        operator: Hn.OR
      };
    });
    return {
      operator: Hn.AND,
      conditions: A
    };
  }
  onPropagation(t) {
    return this._propagationListeners.push(t), this.model.unsubscribePropagationListeners().onPropagation((i, n) => {
      if (this._propagationListeners.length) {
        let A;
        i ? (A = this.clone(i), this.removeChild(A)) : A = null, A && (A._propagation = !0), this._propagationListeners.forEach(
          /* eslint-disable-next-line no-unused-vars */
          (s) => s(A, n)
        );
      }
    }), this;
  }
  unsubscribe(t) {
    return t && (this._propagationListeners = this._propagationListeners.filter(
      (i) => i !== t
    )), this;
  }
  getDerivations() {
    return this.model.getDerivations();
  }
  getAncestorDerivations() {
    const t = this.model.getParent();
    return t ? t.getDerivations() : [];
  }
  isParent(t) {
    const i = (n, A) => {
      const s = n.getParent();
      return s ? s === A ? !0 : i(s, A) : !1;
    };
    return i(this._model, t._model);
  }
  getUids() {
    return this.model.getField(dg).data();
  }
  getTemporalFields() {
    return this.getSchema().filter((t) => t.subtype === "temporal").map((t) => t.name);
  }
  getUidMap() {
    if (this._uidMap)
      return this._uidMap;
    const t = this.getUids();
    return this._uidMap = t.reduce(
      (i, n, A) => (i[n] = A, i),
      {}
    ), this._uidMap;
  }
  getDomain(t, i) {
    if (this.isEmpty())
      return null;
    const n = this.getField(t), A = n.subtype();
    return n ? i === FT ? A === ug ? n.getAllBins().slice() : n.uniques().slice() : i === RT ? n.minMax().slice() : n.domain().slice() : null;
  }
  id() {
    return this._id;
  }
  getParent() {
    return this._parent;
  }
  breakLink(t) {
    return t.removeChild(this), this.detachParent();
  }
  detachParent() {
    return this._parent = null, this.model.detachParent(), this;
  }
  replica() {
    const t = this.getFieldNames();
    return this.project(
      t.filter((i) => i !== St.ROW_ID)
    );
  }
  createEmptyDm() {
    return this.select({
      field: dg,
      value: Number.MAX_SAFE_INTEGER,
      operator: ni.EQUAL
    });
  }
  sanitiseStrings(t) {
    return J.sanitiseStrings(t);
  }
}
const kT = () => J;
function YI(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function xD(e) {
  return e.length === 1 && (e = TT(e)), {
    left: function(t, i, n, A) {
      for (n == null && (n = 0), A == null && (A = t.length); n < A; ) {
        var s = n + A >>> 1;
        e(t[s], i) < 0 ? n = s + 1 : A = s;
      }
      return n;
    },
    right: function(t, i, n, A) {
      for (n == null && (n = 0), A == null && (A = t.length); n < A; ) {
        var s = n + A >>> 1;
        e(t[s], i) > 0 ? A = s : n = s + 1;
      }
      return n;
    }
  };
}
function TT(e) {
  return function(t, i) {
    return YI(e(t), i);
  };
}
var vT = xD(YI), Gh = vT.right;
function GT(e) {
  return e === null ? NaN : +e;
}
function LT(e, t, i) {
  e = +e, t = +t, i = (A = arguments.length) < 2 ? (t = e, e = 0, 1) : A < 3 ? 1 : +i;
  for (var n = -1, A = Math.max(0, Math.ceil((t - e) / i)) | 0, s = new Array(A); ++n < A; )
    s[n] = e + n * i;
  return s;
}
var tf = Math.sqrt(50), ef = Math.sqrt(10), nf = Math.sqrt(2);
function SD(e, t, i) {
  var n, A = -1, s, o, r;
  if (t = +t, e = +e, i = +i, e === t && i > 0)
    return [e];
  if ((n = t < e) && (s = e, e = t, t = s), (r = Lc(e, t, i)) === 0 || !isFinite(r))
    return [];
  if (r > 0)
    for (e = Math.ceil(e / r), t = Math.floor(t / r), o = new Array(s = Math.ceil(t - e + 1)); ++A < s; )
      o[A] = (e + A) * r;
  else
    for (e = Math.floor(e * r), t = Math.ceil(t * r), o = new Array(s = Math.ceil(e - t + 1)); ++A < s; )
      o[A] = (e - A) / r;
  return n && o.reverse(), o;
}
function Lc(e, t, i) {
  var n = (t - e) / Math.max(0, i), A = Math.floor(Math.log(n) / Math.LN10), s = n / Math.pow(10, A);
  return A >= 0 ? (s >= tf ? 10 : s >= ef ? 5 : s >= nf ? 2 : 1) * Math.pow(10, A) : -Math.pow(10, -A) / (s >= tf ? 10 : s >= ef ? 5 : s >= nf ? 2 : 1);
}
function Af(e, t, i) {
  var n = Math.abs(t - e) / Math.max(0, i), A = Math.pow(10, Math.floor(Math.log(n) / Math.LN10)), s = n / A;
  return s >= tf ? A *= 10 : s >= ef ? A *= 5 : s >= nf && (A *= 2), t < e ? -A : A;
}
function UT(e, t, i) {
  if (i == null && (i = GT), !!(n = e.length)) {
    if ((t = +t) <= 0 || n < 2)
      return +i(e[0], 0, e);
    if (t >= 1)
      return +i(e[n - 1], n - 1, e);
    var n, A = (n - 1) * t, s = Math.floor(A), o = +i(e[s], s, e), r = +i(e[s + 1], s + 1, e);
    return o + (r - o) * (A - s);
  }
}
var Oi = "$";
function fg() {
}
fg.prototype = tr.prototype = {
  constructor: fg,
  has: function(e) {
    return Oi + e in this;
  },
  get: function(e) {
    return this[Oi + e];
  },
  set: function(e, t) {
    return this[Oi + e] = t, this;
  },
  remove: function(e) {
    var t = Oi + e;
    return t in this && delete this[t];
  },
  clear: function() {
    for (var e in this)
      e[0] === Oi && delete this[e];
  },
  keys: function() {
    var e = [];
    for (var t in this)
      t[0] === Oi && e.push(t.slice(1));
    return e;
  },
  values: function() {
    var e = [];
    for (var t in this)
      t[0] === Oi && e.push(this[t]);
    return e;
  },
  entries: function() {
    var e = [];
    for (var t in this)
      t[0] === Oi && e.push({ key: t.slice(1), value: this[t] });
    return e;
  },
  size: function() {
    var e = 0;
    for (var t in this)
      t[0] === Oi && ++e;
    return e;
  },
  empty: function() {
    for (var e in this)
      if (e[0] === Oi)
        return !1;
    return !0;
  },
  each: function(e) {
    for (var t in this)
      t[0] === Oi && e(this[t], t.slice(1), this);
  }
};
function tr(e, t) {
  var i = new fg();
  if (e instanceof fg)
    e.each(function(r, a) {
      i.set(a, r);
    });
  else if (Array.isArray(e)) {
    var n = -1, A = e.length, s;
    if (t == null)
      for (; ++n < A; )
        i.set(n, e[n]);
    else
      for (; ++n < A; )
        i.set(t(s = e[n], n, e), s);
  } else if (e)
    for (var o in e)
      i.set(o, e[o]);
  return i;
}
function MD() {
  var e = [], t = [], i, n, A;
  function s(r, a, l, c) {
    if (a >= e.length)
      return i != null && r.sort(i), n != null ? n(r) : r;
    for (var g = -1, h = r.length, u = e[a++], d, f, I = tr(), C, E = l(); ++g < h; )
      (C = I.get(d = u(f = r[g]) + "")) ? C.push(f) : I.set(d, [f]);
    return I.each(function(B, m) {
      c(E, m, s(B, a, l, c));
    }), E;
  }
  function o(r, a) {
    if (++a > e.length)
      return r;
    var l, c = t[a - 1];
    return n != null && a >= e.length ? l = r.entries() : (l = [], r.each(function(g, h) {
      l.push({ key: h, values: o(g, a) });
    })), c != null ? l.sort(function(g, h) {
      return c(g.key, h.key);
    }) : l;
  }
  return A = {
    object: function(r) {
      return s(r, 0, OT, HT);
    },
    map: function(r) {
      return s(r, 0, _m, bm);
    },
    entries: function(r) {
      return o(s(r, 0, _m, bm), 0);
    },
    key: function(r) {
      return e.push(r), A;
    },
    sortKeys: function(r) {
      return t[e.length - 1] = r, A;
    },
    sortValues: function(r) {
      return i = r, A;
    },
    rollup: function(r) {
      return n = r, A;
    }
  };
}
function OT() {
  return {};
}
function HT(e, t, i) {
  e[t] = i;
}
function _m() {
  return tr();
}
function bm(e, t, i) {
  e.set(t, i);
}
function Nm() {
}
var KA = tr.prototype;
Nm.prototype = {
  constructor: Nm,
  has: KA.has,
  add: function(e) {
    return e += "", this[Oi + e] = e, this;
  },
  remove: KA.remove,
  clear: KA.clear,
  values: KA.keys,
  size: KA.size,
  empty: KA.empty,
  each: KA.each
};
var _D = Array.prototype, JI = _D.map, MA = _D.slice, Fm = { name: "implicit" };
function KI(e) {
  var t = tr(), i = [], n = Fm;
  e = e == null ? [] : MA.call(e);
  function A(s) {
    var o = s + "", r = t.get(o);
    if (!r) {
      if (n !== Fm)
        return n;
      t.set(o, r = i.push(s));
    }
    return e[(r - 1) % e.length];
  }
  return A.domain = function(s) {
    if (!arguments.length)
      return i.slice();
    i = [], t = tr();
    for (var o = -1, r = s.length, a, l; ++o < r; )
      t.has(l = (a = s[o]) + "") || t.set(l, i.push(a));
    return A;
  }, A.range = function(s) {
    return arguments.length ? (e = MA.call(s), A) : e.slice();
  }, A.unknown = function(s) {
    return arguments.length ? (n = s, A) : n;
  }, A.copy = function() {
    return KI().domain(i).range(e).unknown(n);
  }, A;
}
function WI() {
  var e = KI().unknown(void 0), t = e.domain, i = e.range, n = [0, 1], A, s, o = !1, r = 0, a = 0, l = 0.5;
  delete e.unknown;
  function c() {
    var g = t().length, h = n[1] < n[0], u = n[h - 0], d = n[1 - h];
    A = (d - u) / Math.max(1, g - r + a * 2), o && (A = Math.floor(A)), u += (d - u - A * (g - r)) * l, s = A * (1 - r), o && (u = Math.round(u), s = Math.round(s));
    var f = LT(g).map(function(I) {
      return u + A * I;
    });
    return i(h ? f.reverse() : f);
  }
  return e.domain = function(g) {
    return arguments.length ? (t(g), c()) : t();
  }, e.range = function(g) {
    return arguments.length ? (n = [+g[0], +g[1]], c()) : n.slice();
  }, e.rangeRound = function(g) {
    return n = [+g[0], +g[1]], o = !0, c();
  }, e.bandwidth = function() {
    return s;
  }, e.step = function() {
    return A;
  }, e.round = function(g) {
    return arguments.length ? (o = !!g, c()) : o;
  }, e.padding = function(g) {
    return arguments.length ? (r = a = Math.max(0, Math.min(1, g)), c()) : r;
  }, e.paddingInner = function(g) {
    return arguments.length ? (r = Math.max(0, Math.min(1, g)), c()) : r;
  }, e.paddingOuter = function(g) {
    return arguments.length ? (a = Math.max(0, Math.min(1, g)), c()) : a;
  }, e.align = function(g) {
    return arguments.length ? (l = Math.max(0, Math.min(1, g)), c()) : l;
  }, e.copy = function() {
    return WI().domain(t()).range(n).round(o).paddingInner(r).paddingOuter(a).align(l);
  }, e.invertExtent = function(g, h) {
    var u = +g, d = arguments.length > 1 ? +h : u, f = n[1] < n[0], I = f ? i().reverse() : i(), C = I.length - 1, E, B, m, y;
    if (I.push(I[C] + this.step()), d < u && (m = u, u = d, d = m), !(d < I[0] || u > n[1 - f]))
      return E = Math.max(0, id(I, u)), y = id(I, d), B = u === d ? E : Math.max(E, y - 1), f && (m = E, E = C - B, B = C - m), E > B ? void 0 : t().slice(E, B + 1);
  }, e.invert = function(g, h) {
    var u = +g, d = arguments.length > 1 ? +h : u, f = n[1] < n[0], I = f ? i().reverse() : i(), C = I.length - 1, E, B;
    if (d < u && (B = u, u = d, d = B), !(d < I[0] || u > n[1 - f]))
      return E = Math.max(0, id(I, u, "left")), t()[f ? C - E : E];
  }, c();
}
function id(e, t, i) {
  for (var n = 0, A = e.length, s = A - 1, o, r, a, l; n < s; )
    r = Math.floor((n + s) / 2), a = Math.abs(e[r] - t), l = Math.abs(e[r + 1] - t), l <= a ? n = r + 1 : s = r;
  return !i || (o = e[s], o === t) ? s : o > t ? s === 0 ? s : i === "left" ? s - 1 : s : s === e.length - 1 || i === "left" ? s : s + 1;
}
function Lh(e, t, i) {
  e.prototype = t.prototype = i, i.constructor = e;
}
function VI(e, t) {
  var i = Object.create(e.prototype);
  for (var n in t)
    i[n] = t[n];
  return i;
}
function Dr() {
}
var _s = 0.7, er = 1 / _s, vo = "\\s*([+-]?\\d+)\\s*", Ga = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", xn = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", PT = /^#([0-9a-f]{3,8})$/, YT = new RegExp("^rgb\\(" + [vo, vo, vo] + "\\)$"), JT = new RegExp("^rgb\\(" + [xn, xn, xn] + "\\)$"), KT = new RegExp("^rgba\\(" + [vo, vo, vo, Ga] + "\\)$"), WT = new RegExp("^rgba\\(" + [xn, xn, xn, Ga] + "\\)$"), VT = new RegExp("^hsl\\(" + [Ga, xn, xn] + "\\)$"), jT = new RegExp("^hsla\\(" + [Ga, xn, xn, Ga] + "\\)$"), Rm = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Lh(Dr, _A, {
  copy: function(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: km,
  // Deprecated! Use color.formatHex.
  formatHex: km,
  formatHsl: qT,
  formatRgb: Tm,
  toString: Tm
});
function km() {
  return this.rgb().formatHex();
}
function qT() {
  return ND(this).formatHsl();
}
function Tm() {
  return this.rgb().formatRgb();
}
function _A(e) {
  var t, i;
  return e = (e + "").trim().toLowerCase(), (t = PT.exec(e)) ? (i = t[1].length, t = parseInt(t[1], 16), i === 6 ? vm(t) : i === 3 ? new We(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : i === 8 ? Xl(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : i === 4 ? Xl(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = YT.exec(e)) ? new We(t[1], t[2], t[3], 1) : (t = JT.exec(e)) ? new We(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = KT.exec(e)) ? Xl(t[1], t[2], t[3], t[4]) : (t = WT.exec(e)) ? Xl(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = VT.exec(e)) ? Um(t[1], t[2] / 100, t[3] / 100, 1) : (t = jT.exec(e)) ? Um(t[1], t[2] / 100, t[3] / 100, t[4]) : Rm.hasOwnProperty(e) ? vm(Rm[e]) : e === "transparent" ? new We(NaN, NaN, NaN, 0) : null;
}
function vm(e) {
  return new We(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Xl(e, t, i, n) {
  return n <= 0 && (e = t = i = NaN), new We(e, t, i, n);
}
function bD(e) {
  return e instanceof Dr || (e = _A(e)), e ? (e = e.rgb(), new We(e.r, e.g, e.b, e.opacity)) : new We();
}
function La(e, t, i, n) {
  return arguments.length === 1 ? bD(e) : new We(e, t, i, n ?? 1);
}
function We(e, t, i, n) {
  this.r = +e, this.g = +t, this.b = +i, this.opacity = +n;
}
Lh(We, La, VI(Dr, {
  brighter: function(e) {
    return e = e == null ? er : Math.pow(er, e), new We(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? _s : Math.pow(_s, e), new We(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Gm,
  // Deprecated! Use color.formatHex.
  formatHex: Gm,
  formatRgb: Lm,
  toString: Lm
}));
function Gm() {
  return "#" + nd(this.r) + nd(this.g) + nd(this.b);
}
function Lm() {
  var e = this.opacity;
  return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (e === 1 ? ")" : ", " + e + ")");
}
function nd(e) {
  return e = Math.max(0, Math.min(255, Math.round(e) || 0)), (e < 16 ? "0" : "") + e.toString(16);
}
function Um(e, t, i, n) {
  return n <= 0 ? e = t = i = NaN : i <= 0 || i >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Dn(e, t, i, n);
}
function ND(e) {
  if (e instanceof Dn)
    return new Dn(e.h, e.s, e.l, e.opacity);
  if (e instanceof Dr || (e = _A(e)), !e)
    return new Dn();
  if (e instanceof Dn)
    return e;
  e = e.rgb();
  var t = e.r / 255, i = e.g / 255, n = e.b / 255, A = Math.min(t, i, n), s = Math.max(t, i, n), o = NaN, r = s - A, a = (s + A) / 2;
  return r ? (t === s ? o = (i - n) / r + (i < n) * 6 : i === s ? o = (n - t) / r + 2 : o = (t - i) / r + 4, r /= a < 0.5 ? s + A : 2 - s - A, o *= 60) : r = a > 0 && a < 1 ? 0 : o, new Dn(o, r, a, e.opacity);
}
function bA(e, t, i, n) {
  return arguments.length === 1 ? ND(e) : new Dn(e, t, i, n ?? 1);
}
function Dn(e, t, i, n) {
  this.h = +e, this.s = +t, this.l = +i, this.opacity = +n;
}
Lh(Dn, bA, VI(Dr, {
  brighter: function(e) {
    return e = e == null ? er : Math.pow(er, e), new Dn(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? _s : Math.pow(_s, e), new Dn(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, i = this.l, n = i + (i < 0.5 ? i : 1 - i) * t, A = 2 * i - n;
    return new We(
      Ad(e >= 240 ? e - 240 : e + 120, A, n),
      Ad(e, A, n),
      Ad(e < 120 ? e + 240 : e - 120, A, n),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var e = this.opacity;
    return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (e === 1 ? ")" : ", " + e + ")");
  }
}));
function Ad(e, t, i) {
  return (e < 60 ? t + (i - t) * e / 60 : e < 180 ? i : e < 240 ? t + (i - t) * (240 - e) / 60 : t) * 255;
}
var zT = Math.PI / 180, ZT = 180 / Math.PI, FD = -0.14861, jI = 1.78277, qI = -0.29227, Uh = -0.90649, Ua = 1.97294, Om = Ua * Uh, Hm = Ua * jI, Pm = jI * qI - Uh * FD;
function $T(e) {
  if (e instanceof fs)
    return new fs(e.h, e.s, e.l, e.opacity);
  e instanceof We || (e = bD(e));
  var t = e.r / 255, i = e.g / 255, n = e.b / 255, A = (Pm * n + Om * t - Hm * i) / (Pm + Om - Hm), s = n - A, o = (Ua * (i - A) - qI * s) / Uh, r = Math.sqrt(o * o + s * s) / (Ua * A * (1 - A)), a = r ? Math.atan2(o, s) * ZT - 120 : NaN;
  return new fs(a < 0 ? a + 360 : a, r, A, e.opacity);
}
function xe(e, t, i, n) {
  return arguments.length === 1 ? $T(e) : new fs(e, t, i, n ?? 1);
}
function fs(e, t, i, n) {
  this.h = +e, this.s = +t, this.l = +i, this.opacity = +n;
}
Lh(fs, xe, VI(Dr, {
  brighter: function(e) {
    return e = e == null ? er : Math.pow(er, e), new fs(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? _s : Math.pow(_s, e), new fs(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * zT, t = +this.l, i = isNaN(this.s) ? 0 : this.s * t * (1 - t), n = Math.cos(e), A = Math.sin(e);
    return new We(
      255 * (t + i * (FD * n + jI * A)),
      255 * (t + i * (qI * n + Uh * A)),
      255 * (t + i * (Ua * n)),
      this.opacity
    );
  }
}));
function XT(e, t, i, n, A) {
  var s = e * e, o = s * e;
  return ((1 - 3 * e + 3 * s - o) * t + (4 - 6 * s + 3 * o) * i + (1 + 3 * e + 3 * s - 3 * o) * n + o * A) / 6;
}
function tv(e) {
  var t = e.length - 1;
  return function(i) {
    var n = i <= 0 ? i = 0 : i >= 1 ? (i = 1, t - 1) : Math.floor(i * t), A = e[n], s = e[n + 1], o = n > 0 ? e[n - 1] : 2 * A - s, r = n < t - 1 ? e[n + 2] : 2 * s - A;
    return XT((i - n / t) * t, o, A, s, r);
  };
}
function Oh(e) {
  return function() {
    return e;
  };
}
function RD(e, t) {
  return function(i) {
    return e + i * t;
  };
}
function ev(e, t, i) {
  return e = Math.pow(e, i), t = Math.pow(t, i) - e, i = 1 / i, function(n) {
    return Math.pow(e + n * t, i);
  };
}
function iv(e, t) {
  var i = t - e;
  return i ? RD(e, i > 180 || i < -180 ? i - 360 * Math.round(i / 360) : i) : Oh(isNaN(e) ? t : e);
}
function nv(e) {
  return (e = +e) == 1 ? Sn : function(t, i) {
    return i - t ? ev(t, i, e) : Oh(isNaN(t) ? i : t);
  };
}
function Sn(e, t) {
  var i = t - e;
  return i ? RD(e, i) : Oh(isNaN(e) ? t : e);
}
const Oa = function e(t) {
  var i = nv(t);
  function n(A, s) {
    var o = i((A = La(A)).r, (s = La(s)).r), r = i(A.g, s.g), a = i(A.b, s.b), l = Sn(A.opacity, s.opacity);
    return function(c) {
      return A.r = o(c), A.g = r(c), A.b = a(c), A.opacity = l(c), A + "";
    };
  }
  return n.gamma = e, n;
}(1);
function Av(e) {
  return function(t) {
    var i = t.length, n = new Array(i), A = new Array(i), s = new Array(i), o, r;
    for (o = 0; o < i; ++o)
      r = La(t[o]), n[o] = r.r || 0, A[o] = r.g || 0, s[o] = r.b || 0;
    return n = e(n), A = e(A), s = e(s), r.opacity = 1, function(a) {
      return r.r = n(a), r.g = A(a), r.b = s(a), r + "";
    };
  };
}
var sv = Av(tv);
function ov(e, t) {
  t || (t = []);
  var i = e ? Math.min(t.length, e.length) : 0, n = t.slice(), A;
  return function(s) {
    for (A = 0; A < i; ++A)
      n[A] = e[A] * (1 - s) + t[A] * s;
    return n;
  };
}
function rv(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function av(e, t) {
  var i = t ? t.length : 0, n = e ? Math.min(i, e.length) : 0, A = new Array(n), s = new Array(i), o;
  for (o = 0; o < n; ++o)
    A[o] = Hh(e[o], t[o]);
  for (; o < i; ++o)
    s[o] = t[o];
  return function(r) {
    for (o = 0; o < n; ++o)
      s[o] = A[o](r);
    return s;
  };
}
function lv(e, t) {
  var i = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return i.setTime(e * (1 - n) + t * n), i;
  };
}
function Di(e, t) {
  return e = +e, t = +t, function(i) {
    return e * (1 - i) + t * i;
  };
}
function cv(e, t) {
  var i = {}, n = {}, A;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (A in t)
    A in e ? i[A] = Hh(e[A], t[A]) : n[A] = t[A];
  return function(s) {
    for (A in i)
      n[A] = i[A](s);
    return n;
  };
}
var sf = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, sd = new RegExp(sf.source, "g");
function gv(e) {
  return function() {
    return e;
  };
}
function hv(e) {
  return function(t) {
    return e(t) + "";
  };
}
function kD(e, t) {
  var i = sf.lastIndex = sd.lastIndex = 0, n, A, s, o = -1, r = [], a = [];
  for (e = e + "", t = t + ""; (n = sf.exec(e)) && (A = sd.exec(t)); )
    (s = A.index) > i && (s = t.slice(i, s), r[o] ? r[o] += s : r[++o] = s), (n = n[0]) === (A = A[0]) ? r[o] ? r[o] += A : r[++o] = A : (r[++o] = null, a.push({ i: o, x: Di(n, A) })), i = sd.lastIndex;
  return i < t.length && (s = t.slice(i), r[o] ? r[o] += s : r[++o] = s), r.length < 2 ? a[0] ? hv(a[0].x) : gv(t) : (t = a.length, function(l) {
    for (var c = 0, g; c < t; ++c)
      r[(g = a[c]).i] = g.x(l);
    return r.join("");
  });
}
function Hh(e, t) {
  var i = typeof t, n;
  return t == null || i === "boolean" ? Oh(t) : (i === "number" ? Di : i === "string" ? (n = _A(t)) ? (t = n, Oa) : kD : t instanceof _A ? Oa : t instanceof Date ? lv : rv(t) ? ov : Array.isArray(t) ? av : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? cv : Di)(e, t);
}
function uv(e, t) {
  return e = +e, t = +t, function(i) {
    return Math.round(e * (1 - i) + t * i);
  };
}
var Ym = 180 / Math.PI, of = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function TD(e, t, i, n, A, s) {
  var o, r, a;
  return (o = Math.sqrt(e * e + t * t)) && (e /= o, t /= o), (a = e * i + t * n) && (i -= e * a, n -= t * a), (r = Math.sqrt(i * i + n * n)) && (i /= r, n /= r, a /= r), e * n < t * i && (e = -e, t = -t, a = -a, o = -o), {
    translateX: A,
    translateY: s,
    rotate: Math.atan2(t, e) * Ym,
    skewX: Math.atan(a) * Ym,
    scaleX: o,
    scaleY: r
  };
}
var Kr, od, Jm, tc;
function dv(e) {
  return e === "none" ? of : (Kr || (Kr = document.createElement("DIV"), od = document.documentElement, Jm = document.defaultView), Kr.style.transform = e, e = Jm.getComputedStyle(od.appendChild(Kr), null).getPropertyValue("transform"), od.removeChild(Kr), e = e.slice(7, -1).split(","), TD(+e[0], +e[1], +e[2], +e[3], +e[4], +e[5]));
}
function fv(e) {
  return e == null || (tc || (tc = document.createElementNS("http://www.w3.org/2000/svg", "g")), tc.setAttribute("transform", e), !(e = tc.transform.baseVal.consolidate())) ? of : (e = e.matrix, TD(e.a, e.b, e.c, e.d, e.e, e.f));
}
function vD(e, t, i, n) {
  function A(l) {
    return l.length ? l.pop() + " " : "";
  }
  function s(l, c, g, h, u, d) {
    if (l !== g || c !== h) {
      var f = u.push("translate(", null, t, null, i);
      d.push({ i: f - 4, x: Di(l, g) }, { i: f - 2, x: Di(c, h) });
    } else
      (g || h) && u.push("translate(" + g + t + h + i);
  }
  function o(l, c, g, h) {
    l !== c ? (l - c > 180 ? c += 360 : c - l > 180 && (l += 360), h.push({ i: g.push(A(g) + "rotate(", null, n) - 2, x: Di(l, c) })) : c && g.push(A(g) + "rotate(" + c + n);
  }
  function r(l, c, g, h) {
    l !== c ? h.push({ i: g.push(A(g) + "skewX(", null, n) - 2, x: Di(l, c) }) : c && g.push(A(g) + "skewX(" + c + n);
  }
  function a(l, c, g, h, u, d) {
    if (l !== g || c !== h) {
      var f = u.push(A(u) + "scale(", null, ",", null, ")");
      d.push({ i: f - 4, x: Di(l, g) }, { i: f - 2, x: Di(c, h) });
    } else
      (g !== 1 || h !== 1) && u.push(A(u) + "scale(" + g + "," + h + ")");
  }
  return function(l, c) {
    var g = [], h = [];
    return l = e(l), c = e(c), s(l.translateX, l.translateY, c.translateX, c.translateY, g, h), o(l.rotate, c.rotate, g, h), r(l.skewX, c.skewX, g, h), a(l.scaleX, l.scaleY, c.scaleX, c.scaleY, g, h), l = c = null, function(u) {
      for (var d = -1, f = h.length, I; ++d < f; )
        g[(I = h[d]).i] = I.x(u);
      return g.join("");
    };
  };
}
var Iv = vD(dv, "px, ", "px)", "deg)"), Cv = vD(fv, ", ", ")", ")");
function Ev(e) {
  return function(t, i) {
    var n = e((t = bA(t)).h, (i = bA(i)).h), A = Sn(t.s, i.s), s = Sn(t.l, i.l), o = Sn(t.opacity, i.opacity);
    return function(r) {
      return t.h = n(r), t.s = A(r), t.l = s(r), t.opacity = o(r), t + "";
    };
  };
}
var Bv = Ev(Sn);
function GD(e) {
  return function t(i) {
    i = +i;
    function n(A, s) {
      var o = e((A = xe(A)).h, (s = xe(s)).h), r = Sn(A.s, s.s), a = Sn(A.l, s.l), l = Sn(A.opacity, s.opacity);
      return function(c) {
        return A.h = o(c), A.s = r(c), A.l = a(Math.pow(c, i)), A.opacity = l(c), A + "";
      };
    }
    return n.gamma = t, n;
  }(1);
}
GD(iv);
var wr = GD(Sn);
function mv(e, t) {
  for (var i = 0, n = t.length - 1, A = t[0], s = new Array(n < 0 ? 0 : n); i < n; )
    s[i] = e(A, A = t[++i]);
  return function(o) {
    var r = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return s[r](o - r);
  };
}
function zI(e) {
  return function() {
    return e;
  };
}
function LD(e) {
  return +e;
}
var Km = [0, 1];
function ZI(e, t) {
  return (t -= e = +e) ? function(i) {
    return (i - e) / t;
  } : zI(t);
}
function Qv(e) {
  return function(t, i) {
    var n = e(t = +t, i = +i);
    return function(A) {
      return A <= t ? 0 : A >= i ? 1 : n(A);
    };
  };
}
function pv(e) {
  return function(t, i) {
    var n = e(t = +t, i = +i);
    return function(A) {
      return A <= 0 ? t : A >= 1 ? i : n(A);
    };
  };
}
function yv(e, t, i, n) {
  var A = e[0], s = e[1], o = t[0], r = t[1];
  return s < A ? (A = i(s, A), o = n(r, o)) : (A = i(A, s), o = n(o, r)), function(a) {
    return o(A(a));
  };
}
function Dv(e, t, i, n) {
  var A = Math.min(e.length, t.length) - 1, s = new Array(A), o = new Array(A), r = -1;
  for (e[A] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++r < A; )
    s[r] = i(e[r], e[r + 1]), o[r] = n(t[r], t[r + 1]);
  return function(a) {
    var l = Gh(e, a, 1, A) - 1;
    return o[l](s[l](a));
  };
}
function Ph(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp());
}
function Yh(e, t) {
  var i = Km, n = Km, A = Hh, s = !1, o, r, a;
  function l() {
    return o = Math.min(i.length, n.length) > 2 ? Dv : yv, r = a = null, c;
  }
  function c(g) {
    return (r || (r = o(i, n, s ? Qv(e) : e, A)))(+g);
  }
  return c.invert = function(g) {
    return (a || (a = o(n, i, ZI, s ? pv(t) : t)))(+g);
  }, c.domain = function(g) {
    return arguments.length ? (i = JI.call(g, LD), l()) : i.slice();
  }, c.range = function(g) {
    return arguments.length ? (n = MA.call(g), l()) : n.slice();
  }, c.rangeRound = function(g) {
    return n = MA.call(g), A = uv, l();
  }, c.clamp = function(g) {
    return arguments.length ? (s = !!g, l()) : s;
  }, c.interpolate = function(g) {
    return arguments.length ? (A = g, l()) : A;
  }, l();
}
function wv(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Ig(e, t) {
  if ((i = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var i, n = e.slice(0, i);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(i + 1)
  ];
}
function ir(e) {
  return e = Ig(Math.abs(e)), e ? e[1] : NaN;
}
function xv(e, t) {
  return function(i, n) {
    for (var A = i.length, s = [], o = 0, r = e[0], a = 0; A > 0 && r > 0 && (a + r + 1 > n && (r = Math.max(1, n - a)), s.push(i.substring(A -= r, A + r)), !((a += r + 1) > n)); )
      r = e[o = (o + 1) % e.length];
    return s.reverse().join(t);
  };
}
function Sv(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(i) {
      return e[+i];
    });
  };
}
var Mv = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Cg(e) {
  if (!(t = Mv.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new $I({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Cg.prototype = $I.prototype;
function $I(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
$I.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function _v(e) {
  t:
    for (var t = e.length, i = 1, n = -1, A; i < t; ++i)
      switch (e[i]) {
        case ".":
          n = A = i;
          break;
        case "0":
          n === 0 && (n = i), A = i;
          break;
        default:
          if (!+e[i])
            break t;
          n > 0 && (n = 0);
          break;
      }
  return n > 0 ? e.slice(0, n) + e.slice(A + 1) : e;
}
var UD;
function bv(e, t) {
  var i = Ig(e, t);
  if (!i)
    return e + "";
  var n = i[0], A = i[1], s = A - (UD = Math.max(-8, Math.min(8, Math.floor(A / 3))) * 3) + 1, o = n.length;
  return s === o ? n : s > o ? n + new Array(s - o + 1).join("0") : s > 0 ? n.slice(0, s) + "." + n.slice(s) : "0." + new Array(1 - s).join("0") + Ig(e, Math.max(0, t + s - 1))[0];
}
function Wm(e, t) {
  var i = Ig(e, t);
  if (!i)
    return e + "";
  var n = i[0], A = i[1];
  return A < 0 ? "0." + new Array(-A).join("0") + n : n.length > A + 1 ? n.slice(0, A + 1) + "." + n.slice(A + 1) : n + new Array(A - n.length + 2).join("0");
}
const Vm = {
  "%": function(e, t) {
    return (e * 100).toFixed(t);
  },
  b: function(e) {
    return Math.round(e).toString(2);
  },
  c: function(e) {
    return e + "";
  },
  d: wv,
  e: function(e, t) {
    return e.toExponential(t);
  },
  f: function(e, t) {
    return e.toFixed(t);
  },
  g: function(e, t) {
    return e.toPrecision(t);
  },
  o: function(e) {
    return Math.round(e).toString(8);
  },
  p: function(e, t) {
    return Wm(e * 100, t);
  },
  r: Wm,
  s: bv,
  X: function(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function(e) {
    return Math.round(e).toString(16);
  }
};
function jm(e) {
  return e;
}
var qm = Array.prototype.map, zm = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Nv(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? jm : xv(qm.call(e.grouping, Number), e.thousands + ""), i = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", A = e.decimal === void 0 ? "." : e.decimal + "", s = e.numerals === void 0 ? jm : Sv(qm.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", r = e.minus === void 0 ? "-" : e.minus + "", a = e.nan === void 0 ? "NaN" : e.nan + "";
  function l(g) {
    g = Cg(g);
    var h = g.fill, u = g.align, d = g.sign, f = g.symbol, I = g.zero, C = g.width, E = g.comma, B = g.precision, m = g.trim, y = g.type;
    y === "n" ? (E = !0, y = "g") : Vm[y] || (B === void 0 && (B = 12), m = !0, y = "g"), (I || h === "0" && u === "=") && (I = !0, h = "0", u = "=");
    var D = f === "$" ? i : f === "#" && /[boxX]/.test(y) ? "0" + y.toLowerCase() : "", Q = f === "$" ? n : /[%p]/.test(y) ? o : "", p = Vm[y], w = /[defgprs%]/.test(y);
    B = B === void 0 ? 6 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, B)) : Math.max(0, Math.min(20, B));
    function x(S) {
      var _ = D, M = Q, k, T, G;
      if (y === "c")
        M = p(S) + M, S = "";
      else {
        S = +S;
        var N = S < 0 || 1 / S < 0;
        if (S = isNaN(S) ? a : p(Math.abs(S), B), m && (S = _v(S)), N && +S == 0 && d !== "+" && (N = !1), _ = (N ? d === "(" ? d : r : d === "-" || d === "(" ? "" : d) + _, M = (y === "s" ? zm[8 + UD / 3] : "") + M + (N && d === "(" ? ")" : ""), w) {
          for (k = -1, T = S.length; ++k < T; )
            if (G = S.charCodeAt(k), 48 > G || G > 57) {
              M = (G === 46 ? A + S.slice(k + 1) : S.slice(k)) + M, S = S.slice(0, k);
              break;
            }
        }
      }
      E && !I && (S = t(S, 1 / 0));
      var b = _.length + S.length + M.length, F = b < C ? new Array(C - b + 1).join(h) : "";
      switch (E && I && (S = t(F + S, F.length ? C - M.length : 1 / 0), F = ""), u) {
        case "<":
          S = _ + S + M + F;
          break;
        case "=":
          S = _ + F + S + M;
          break;
        case "^":
          S = F.slice(0, b = F.length >> 1) + _ + S + M + F.slice(b);
          break;
        default:
          S = F + _ + S + M;
          break;
      }
      return s(S);
    }
    return x.toString = function() {
      return g + "";
    }, x;
  }
  function c(g, h) {
    var u = l((g = Cg(g), g.type = "f", g)), d = Math.max(-8, Math.min(8, Math.floor(ir(h) / 3))) * 3, f = Math.pow(10, -d), I = zm[8 + d / 3];
    return function(C) {
      return u(f * C) + I;
    };
  }
  return {
    format: l,
    formatPrefix: c
  };
}
var ec, XI, OD;
Fv({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});
function Fv(e) {
  return ec = Nv(e), XI = ec.format, OD = ec.formatPrefix, ec;
}
function Rv(e) {
  return Math.max(0, -ir(Math.abs(e)));
}
function kv(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(ir(t) / 3))) * 3 - ir(Math.abs(e)));
}
function Tv(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, ir(t) - ir(e)) + 1;
}
function vv(e, t, i) {
  var n = e[0], A = e[e.length - 1], s = Af(n, A, t ?? 10), o;
  switch (i = Cg(i ?? ",f"), i.type) {
    case "s": {
      var r = Math.max(Math.abs(n), Math.abs(A));
      return i.precision == null && !isNaN(o = kv(s, r)) && (i.precision = o), OD(i, r);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      i.precision == null && !isNaN(o = Tv(s, Math.max(Math.abs(n), Math.abs(A)))) && (i.precision = o - (i.type === "e"));
      break;
    }
    case "f":
    case "%": {
      i.precision == null && !isNaN(o = Rv(s)) && (i.precision = o - (i.type === "%") * 2);
      break;
    }
  }
  return XI(i);
}
function dl(e) {
  var t = e.domain;
  return e.ticks = function(i) {
    var n = t();
    return SD(n[0], n[n.length - 1], i ?? 10);
  }, e.tickFormat = function(i, n) {
    return vv(t(), i, n);
  }, e.nice = function(i) {
    i == null && (i = 10);
    var n = t(), A = 0, s = n.length - 1, o = n[A], r = n[s], a;
    return r < o && (a = o, o = r, r = a, a = A, A = s, s = a), a = Lc(o, r, i), a > 0 ? (o = Math.floor(o / a) * a, r = Math.ceil(r / a) * a, a = Lc(o, r, i)) : a < 0 && (o = Math.ceil(o * a) / a, r = Math.floor(r * a) / a, a = Lc(o, r, i)), a > 0 ? (n[A] = Math.floor(o / a) * a, n[s] = Math.ceil(r / a) * a, t(n)) : a < 0 && (n[A] = Math.ceil(o * a) / a, n[s] = Math.floor(r * a) / a, t(n)), e;
  }, e;
}
function HD() {
  var e = Yh(ZI, Di);
  return e.copy = function() {
    return Ph(e, HD());
  }, dl(e);
}
function PD() {
  var e = [0, 1];
  function t(i) {
    return +i;
  }
  return t.invert = t, t.domain = t.range = function(i) {
    return arguments.length ? (e = JI.call(i, LD), t) : e.slice();
  }, t.copy = function() {
    return PD().domain(e);
  }, dl(t);
}
function YD(e, t) {
  e = e.slice();
  var i = 0, n = e.length - 1, A = e[i], s = e[n], o;
  return s < A && (o = i, i = n, n = o, o = A, A = s, s = o), e[i] = t.floor(A), e[n] = t.ceil(s), e;
}
function Gv(e, t) {
  return (t = Math.log(t / e)) ? function(i) {
    return Math.log(i / e) / t;
  } : zI(t);
}
function Lv(e, t) {
  return e < 0 ? function(i) {
    return -Math.pow(-t, i) * Math.pow(-e, 1 - i);
  } : function(i) {
    return Math.pow(t, i) * Math.pow(e, 1 - i);
  };
}
function Uv(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function Zm(e) {
  return e === 10 ? Uv : e === Math.E ? Math.exp : function(t) {
    return Math.pow(e, t);
  };
}
function $m(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), function(t) {
    return Math.log(t) / e;
  });
}
function Xm(e) {
  return function(t) {
    return -e(-t);
  };
}
function JD() {
  var e = Yh(Gv, Lv).domain([1, 10]), t = e.domain, i = 10, n = $m(10), A = Zm(10);
  function s() {
    return n = $m(i), A = Zm(i), t()[0] < 0 && (n = Xm(n), A = Xm(A)), e;
  }
  return e.base = function(o) {
    return arguments.length ? (i = +o, s()) : i;
  }, e.domain = function(o) {
    return arguments.length ? (t(o), s()) : t();
  }, e.ticks = function(o) {
    var r = t(), a = r[0], l = r[r.length - 1], c;
    (c = l < a) && (g = a, a = l, l = g);
    var g = n(a), h = n(l), u, d, f, I = o == null ? 10 : +o, C = [];
    if (!(i % 1) && h - g < I) {
      if (g = Math.round(g) - 1, h = Math.round(h) + 1, a > 0) {
        for (; g < h; ++g)
          for (d = 1, u = A(g); d < i; ++d)
            if (f = u * d, !(f < a)) {
              if (f > l)
                break;
              C.push(f);
            }
      } else
        for (; g < h; ++g)
          for (d = i - 1, u = A(g); d >= 1; --d)
            if (f = u * d, !(f < a)) {
              if (f > l)
                break;
              C.push(f);
            }
    } else
      C = SD(g, h, Math.min(h - g, I)).map(A);
    return c ? C.reverse() : C;
  }, e.tickFormat = function(o, r) {
    if (r == null && (r = i === 10 ? ".0e" : ","), typeof r != "function" && (r = XI(r)), o === 1 / 0)
      return r;
    o == null && (o = 10);
    var a = Math.max(1, i * o / e.ticks().length);
    return function(l) {
      var c = l / A(Math.round(n(l)));
      return c * i < i - 0.5 && (c *= i), c <= a ? r(l) : "";
    };
  }, e.nice = function() {
    return t(YD(t(), {
      floor: function(o) {
        return A(Math.floor(n(o)));
      },
      ceil: function(o) {
        return A(Math.ceil(n(o)));
      }
    }));
  }, e.copy = function() {
    return Ph(e, JD().base(i));
  }, e;
}
function so(e, t) {
  return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
}
function KD() {
  var e = 1, t = Yh(n, A), i = t.domain;
  function n(s, o) {
    return (o = so(o, e) - (s = so(s, e))) ? function(r) {
      return (so(r, e) - s) / o;
    } : zI(o);
  }
  function A(s, o) {
    return o = so(o, e) - (s = so(s, e)), function(r) {
      return so(s + o * r, 1 / e);
    };
  }
  return t.exponent = function(s) {
    return arguments.length ? (e = +s, i(i())) : e;
  }, t.copy = function() {
    return Ph(t, KD().exponent(e));
  }, dl(t);
}
function WD() {
  var e = [], t = [], i = [];
  function n() {
    var s = 0, o = Math.max(1, t.length);
    for (i = new Array(o - 1); ++s < o; )
      i[s - 1] = UT(e, s / o);
    return A;
  }
  function A(s) {
    if (!isNaN(s = +s))
      return t[Gh(i, s)];
  }
  return A.invertExtent = function(s) {
    var o = t.indexOf(s);
    return o < 0 ? [NaN, NaN] : [
      o > 0 ? i[o - 1] : e[0],
      o < i.length ? i[o] : e[e.length - 1]
    ];
  }, A.domain = function(s) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (var o = 0, r = s.length, a; o < r; ++o)
      a = s[o], a != null && !isNaN(a = +a) && e.push(a);
    return e.sort(YI), n();
  }, A.range = function(s) {
    return arguments.length ? (t = MA.call(s), n()) : t.slice();
  }, A.quantiles = function() {
    return i.slice();
  }, A.copy = function() {
    return WD().domain(e).range(t);
  }, A;
}
function tC() {
  var e = 0, t = 1, i = 1, n = [0.5], A = [0, 1];
  function s(r) {
    if (r <= r)
      return A[Gh(n, r, 0, i)];
  }
  function o() {
    var r = -1;
    for (n = new Array(i); ++r < i; )
      n[r] = ((r + 1) * t - (r - i) * e) / (i + 1);
    return s;
  }
  return s.domain = function(r) {
    return arguments.length ? (e = +r[0], t = +r[1], o()) : [e, t];
  }, s.range = function(r) {
    return arguments.length ? (i = (A = MA.call(r)).length - 1, o()) : A.slice();
  }, s.invertExtent = function(r) {
    var a = A.indexOf(r);
    return a < 0 ? [NaN, NaN] : a < 1 ? [e, n[0]] : a >= i ? [n[i - 1], t] : [n[a - 1], n[a]];
  }, s.copy = function() {
    return tC().domain([e, t]).range(A);
  }, dl(s);
}
function VD() {
  var e = [0.5], t = [0, 1], i = 1;
  function n(A) {
    if (A <= A)
      return t[Gh(e, A, 0, i)];
  }
  return n.domain = function(A) {
    return arguments.length ? (e = MA.call(A), i = Math.min(e.length, t.length - 1), n) : e.slice();
  }, n.range = function(A) {
    return arguments.length ? (t = MA.call(A), i = Math.min(e.length, t.length - 1), n) : t.slice();
  }, n.invertExtent = function(A) {
    var s = t.indexOf(A);
    return [e[s - 1], e[s]];
  }, n.copy = function() {
    return VD().domain(e).range(t);
  }, n;
}
var rd = /* @__PURE__ */ new Date(), ad = /* @__PURE__ */ new Date();
function Jt(e, t, i, n) {
  function A(s) {
    return e(s = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+s)), s;
  }
  return A.floor = function(s) {
    return e(s = /* @__PURE__ */ new Date(+s)), s;
  }, A.ceil = function(s) {
    return e(s = new Date(s - 1)), t(s, 1), e(s), s;
  }, A.round = function(s) {
    var o = A(s), r = A.ceil(s);
    return s - o < r - s ? o : r;
  }, A.offset = function(s, o) {
    return t(s = /* @__PURE__ */ new Date(+s), o == null ? 1 : Math.floor(o)), s;
  }, A.range = function(s, o, r) {
    var a = [], l;
    if (s = A.ceil(s), r = r == null ? 1 : Math.floor(r), !(s < o) || !(r > 0))
      return a;
    do
      a.push(l = /* @__PURE__ */ new Date(+s)), t(s, r), e(s);
    while (l < s && s < o);
    return a;
  }, A.filter = function(s) {
    return Jt(function(o) {
      if (o >= o)
        for (; e(o), !s(o); )
          o.setTime(o - 1);
    }, function(o, r) {
      if (o >= o)
        if (r < 0)
          for (; ++r <= 0; )
            for (; t(o, -1), !s(o); )
              ;
        else
          for (; --r >= 0; )
            for (; t(o, 1), !s(o); )
              ;
    });
  }, i && (A.count = function(s, o) {
    return rd.setTime(+s), ad.setTime(+o), e(rd), e(ad), Math.floor(i(rd, ad));
  }, A.every = function(s) {
    return s = Math.floor(s), !isFinite(s) || !(s > 0) ? null : s > 1 ? A.filter(n ? function(o) {
      return n(o) % s === 0;
    } : function(o) {
      return A.count(0, o) % s === 0;
    }) : A;
  }), A;
}
var Eg = Jt(function() {
}, function(e, t) {
  e.setTime(+e + t);
}, function(e, t) {
  return t - e;
});
Eg.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Jt(function(t) {
    t.setTime(Math.floor(t / e) * e);
  }, function(t, i) {
    t.setTime(+t + i * e);
  }, function(t, i) {
    return (i - t) / e;
  }) : Eg;
};
const NA = Eg;
Eg.range;
var Bg = 1e3, bs = 6e4, mg = 36e5, jD = 864e5, qD = 6048e5, zD = Jt(function(e) {
  e.setTime(e - e.getMilliseconds());
}, function(e, t) {
  e.setTime(+e + t * Bg);
}, function(e, t) {
  return (t - e) / Bg;
}, function(e) {
  return e.getUTCSeconds();
});
const FA = zD;
zD.range;
var ZD = Jt(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Bg);
}, function(e, t) {
  e.setTime(+e + t * bs);
}, function(e, t) {
  return (t - e) / bs;
}, function(e) {
  return e.getMinutes();
});
const Jh = ZD;
ZD.range;
var $D = Jt(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Bg - e.getMinutes() * bs);
}, function(e, t) {
  e.setTime(+e + t * mg);
}, function(e, t) {
  return (t - e) / mg;
}, function(e) {
  return e.getHours();
});
const Kh = $D;
$D.range;
var XD = Jt(function(e) {
  e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * bs) / jD;
}, function(e) {
  return e.getDate() - 1;
});
const Wh = XD;
XD.range;
function Ks(e) {
  return Jt(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, i) {
    t.setDate(t.getDate() + i * 7);
  }, function(t, i) {
    return (i - t - (i.getTimezoneOffset() - t.getTimezoneOffset()) * bs) / qD;
  });
}
var nr = Ks(0), Ar = Ks(1), eC = Ks(2), iC = Ks(3), RA = Ks(4), nC = Ks(5), AC = Ks(6);
nr.range;
Ar.range;
eC.range;
iC.range;
RA.range;
nC.range;
AC.range;
var tw = Jt(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
const sC = tw;
tw.range;
var oC = Jt(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
oC.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Jt(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, i) {
    t.setFullYear(t.getFullYear() + i * e);
  });
};
const kA = oC;
oC.range;
var ew = Jt(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * bs);
}, function(e, t) {
  return (t - e) / bs;
}, function(e) {
  return e.getUTCMinutes();
});
const Vh = ew;
ew.range;
var iw = Jt(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * mg);
}, function(e, t) {
  return (t - e) / mg;
}, function(e) {
  return e.getUTCHours();
});
const jh = iw;
iw.range;
var nw = Jt(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / jD;
}, function(e) {
  return e.getUTCDate() - 1;
});
const qh = nw;
nw.range;
function Ws(e) {
  return Jt(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, i) {
    t.setUTCDate(t.getUTCDate() + i * 7);
  }, function(t, i) {
    return (i - t) / qD;
  });
}
var sr = Ws(0), or = Ws(1), rC = Ws(2), aC = Ws(3), TA = Ws(4), lC = Ws(5), cC = Ws(6);
sr.range;
or.range;
rC.range;
aC.range;
TA.range;
lC.range;
cC.range;
var Aw = Jt(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
});
const gC = Aw;
Aw.range;
var hC = Jt(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
hC.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Jt(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, i) {
    t.setUTCFullYear(t.getUTCFullYear() + i * e);
  });
};
const vA = hC;
hC.range;
function ld(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function cd(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Wr(e, t, i) {
  return { y: e, m: t, d: i, H: 0, M: 0, S: 0, L: 0 };
}
function Ov(e) {
  var t = e.dateTime, i = e.date, n = e.time, A = e.periods, s = e.days, o = e.shortDays, r = e.months, a = e.shortMonths, l = Vr(A), c = jr(A), g = Vr(s), h = jr(s), u = Vr(o), d = jr(o), f = Vr(r), I = jr(r), C = Vr(a), E = jr(a), B = {
    a: N,
    A: b,
    b: F,
    B: R,
    c: null,
    d: sQ,
    e: sQ,
    f: l2,
    g: B2,
    G: Q2,
    H: o2,
    I: r2,
    j: a2,
    L: sw,
    m: c2,
    M: g2,
    p: v,
    q: O,
    Q: aQ,
    s: lQ,
    S: h2,
    u: u2,
    U: d2,
    V: f2,
    w: I2,
    W: C2,
    x: null,
    X: null,
    y: E2,
    Y: m2,
    Z: p2,
    "%": rQ
  }, m = {
    a: L,
    A: U,
    b: H,
    B: z,
    c: null,
    d: oQ,
    e: oQ,
    f: x2,
    g: v2,
    G: L2,
    H: y2,
    I: D2,
    j: w2,
    L: rw,
    m: S2,
    M: M2,
    p: et,
    q: Z,
    Q: aQ,
    s: lQ,
    S: _2,
    u: b2,
    U: N2,
    V: F2,
    w: R2,
    W: k2,
    x: null,
    X: null,
    y: T2,
    Y: G2,
    Z: U2,
    "%": rQ
  }, y = {
    a: x,
    A: S,
    b: _,
    B: M,
    c: k,
    d: nQ,
    e: nQ,
    f: i2,
    g: iQ,
    G: eQ,
    H: AQ,
    I: AQ,
    j: $v,
    L: e2,
    m: Zv,
    M: Xv,
    p: w,
    q: zv,
    Q: A2,
    s: s2,
    S: t2,
    u: Kv,
    U: Wv,
    V: Vv,
    w: Jv,
    W: jv,
    x: T,
    X: G,
    y: iQ,
    Y: eQ,
    Z: qv,
    "%": n2
  };
  B.x = D(i, B), B.X = D(n, B), B.c = D(t, B), m.x = D(i, m), m.X = D(n, m), m.c = D(t, m);
  function D(Y, q) {
    return function($) {
      var P = [], st = -1, nt = 0, ot = Y.length, Et, ct, ht;
      for ($ instanceof Date || ($ = /* @__PURE__ */ new Date(+$)); ++st < ot; )
        Y.charCodeAt(st) === 37 && (P.push(Y.slice(nt, st)), (ct = tQ[Et = Y.charAt(++st)]) != null ? Et = Y.charAt(++st) : ct = Et === "e" ? " " : "0", (ht = q[Et]) && (Et = ht($, ct)), P.push(Et), nt = st + 1);
      return P.push(Y.slice(nt, st)), P.join("");
    };
  }
  function Q(Y, q) {
    return function($) {
      var P = Wr(1900, void 0, 1), st = p(P, Y, $ += "", 0), nt, ot;
      if (st != $.length)
        return null;
      if ("Q" in P)
        return new Date(P.Q);
      if ("s" in P)
        return new Date(P.s * 1e3 + ("L" in P ? P.L : 0));
      if (q && !("Z" in P) && (P.Z = 0), "p" in P && (P.H = P.H % 12 + P.p * 12), P.m === void 0 && (P.m = "q" in P ? P.q : 0), "V" in P) {
        if (P.V < 1 || P.V > 53)
          return null;
        "w" in P || (P.w = 1), "Z" in P ? (nt = cd(Wr(P.y, 0, 1)), ot = nt.getUTCDay(), nt = ot > 4 || ot === 0 ? or.ceil(nt) : or(nt), nt = qh.offset(nt, (P.V - 1) * 7), P.y = nt.getUTCFullYear(), P.m = nt.getUTCMonth(), P.d = nt.getUTCDate() + (P.w + 6) % 7) : (nt = ld(Wr(P.y, 0, 1)), ot = nt.getDay(), nt = ot > 4 || ot === 0 ? Ar.ceil(nt) : Ar(nt), nt = Wh.offset(nt, (P.V - 1) * 7), P.y = nt.getFullYear(), P.m = nt.getMonth(), P.d = nt.getDate() + (P.w + 6) % 7);
      } else
        ("W" in P || "U" in P) && ("w" in P || (P.w = "u" in P ? P.u % 7 : "W" in P ? 1 : 0), ot = "Z" in P ? cd(Wr(P.y, 0, 1)).getUTCDay() : ld(Wr(P.y, 0, 1)).getDay(), P.m = 0, P.d = "W" in P ? (P.w + 6) % 7 + P.W * 7 - (ot + 5) % 7 : P.w + P.U * 7 - (ot + 6) % 7);
      return "Z" in P ? (P.H += P.Z / 100 | 0, P.M += P.Z % 100, cd(P)) : ld(P);
    };
  }
  function p(Y, q, $, P) {
    for (var st = 0, nt = q.length, ot = $.length, Et, ct; st < nt; ) {
      if (P >= ot)
        return -1;
      if (Et = q.charCodeAt(st++), Et === 37) {
        if (Et = q.charAt(st++), ct = y[Et in tQ ? q.charAt(st++) : Et], !ct || (P = ct(Y, $, P)) < 0)
          return -1;
      } else if (Et != $.charCodeAt(P++))
        return -1;
    }
    return P;
  }
  function w(Y, q, $) {
    var P = l.exec(q.slice($));
    return P ? (Y.p = c[P[0].toLowerCase()], $ + P[0].length) : -1;
  }
  function x(Y, q, $) {
    var P = u.exec(q.slice($));
    return P ? (Y.w = d[P[0].toLowerCase()], $ + P[0].length) : -1;
  }
  function S(Y, q, $) {
    var P = g.exec(q.slice($));
    return P ? (Y.w = h[P[0].toLowerCase()], $ + P[0].length) : -1;
  }
  function _(Y, q, $) {
    var P = C.exec(q.slice($));
    return P ? (Y.m = E[P[0].toLowerCase()], $ + P[0].length) : -1;
  }
  function M(Y, q, $) {
    var P = f.exec(q.slice($));
    return P ? (Y.m = I[P[0].toLowerCase()], $ + P[0].length) : -1;
  }
  function k(Y, q, $) {
    return p(Y, t, q, $);
  }
  function T(Y, q, $) {
    return p(Y, i, q, $);
  }
  function G(Y, q, $) {
    return p(Y, n, q, $);
  }
  function N(Y) {
    return o[Y.getDay()];
  }
  function b(Y) {
    return s[Y.getDay()];
  }
  function F(Y) {
    return a[Y.getMonth()];
  }
  function R(Y) {
    return r[Y.getMonth()];
  }
  function v(Y) {
    return A[+(Y.getHours() >= 12)];
  }
  function O(Y) {
    return 1 + ~~(Y.getMonth() / 3);
  }
  function L(Y) {
    return o[Y.getUTCDay()];
  }
  function U(Y) {
    return s[Y.getUTCDay()];
  }
  function H(Y) {
    return a[Y.getUTCMonth()];
  }
  function z(Y) {
    return r[Y.getUTCMonth()];
  }
  function et(Y) {
    return A[+(Y.getUTCHours() >= 12)];
  }
  function Z(Y) {
    return 1 + ~~(Y.getUTCMonth() / 3);
  }
  return {
    format: function(Y) {
      var q = D(Y += "", B);
      return q.toString = function() {
        return Y;
      }, q;
    },
    parse: function(Y) {
      var q = Q(Y += "", !1);
      return q.toString = function() {
        return Y;
      }, q;
    },
    utcFormat: function(Y) {
      var q = D(Y += "", m);
      return q.toString = function() {
        return Y;
      }, q;
    },
    utcParse: function(Y) {
      var q = Q(Y += "", !0);
      return q.toString = function() {
        return Y;
      }, q;
    }
  };
}
var tQ = { "-": "", _: " ", 0: "0" }, me = /^\s*\d+/, Hv = /^%/, Pv = /[\\^$*+?|[\]().{}]/g;
function Rt(e, t, i) {
  var n = e < 0 ? "-" : "", A = (n ? -e : e) + "", s = A.length;
  return n + (s < i ? new Array(i - s + 1).join(t) + A : A);
}
function Yv(e) {
  return e.replace(Pv, "\\$&");
}
function Vr(e) {
  return new RegExp("^(?:" + e.map(Yv).join("|") + ")", "i");
}
function jr(e) {
  for (var t = {}, i = -1, n = e.length; ++i < n; )
    t[e[i].toLowerCase()] = i;
  return t;
}
function Jv(e, t, i) {
  var n = me.exec(t.slice(i, i + 1));
  return n ? (e.w = +n[0], i + n[0].length) : -1;
}
function Kv(e, t, i) {
  var n = me.exec(t.slice(i, i + 1));
  return n ? (e.u = +n[0], i + n[0].length) : -1;
}
function Wv(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.U = +n[0], i + n[0].length) : -1;
}
function Vv(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.V = +n[0], i + n[0].length) : -1;
}
function jv(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.W = +n[0], i + n[0].length) : -1;
}
function eQ(e, t, i) {
  var n = me.exec(t.slice(i, i + 4));
  return n ? (e.y = +n[0], i + n[0].length) : -1;
}
function iQ(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i + n[0].length) : -1;
}
function qv(e, t, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(i, i + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function zv(e, t, i) {
  var n = me.exec(t.slice(i, i + 1));
  return n ? (e.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function Zv(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.m = n[0] - 1, i + n[0].length) : -1;
}
function nQ(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.d = +n[0], i + n[0].length) : -1;
}
function $v(e, t, i) {
  var n = me.exec(t.slice(i, i + 3));
  return n ? (e.m = 0, e.d = +n[0], i + n[0].length) : -1;
}
function AQ(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.H = +n[0], i + n[0].length) : -1;
}
function Xv(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.M = +n[0], i + n[0].length) : -1;
}
function t2(e, t, i) {
  var n = me.exec(t.slice(i, i + 2));
  return n ? (e.S = +n[0], i + n[0].length) : -1;
}
function e2(e, t, i) {
  var n = me.exec(t.slice(i, i + 3));
  return n ? (e.L = +n[0], i + n[0].length) : -1;
}
function i2(e, t, i) {
  var n = me.exec(t.slice(i, i + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), i + n[0].length) : -1;
}
function n2(e, t, i) {
  var n = Hv.exec(t.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}
function A2(e, t, i) {
  var n = me.exec(t.slice(i));
  return n ? (e.Q = +n[0], i + n[0].length) : -1;
}
function s2(e, t, i) {
  var n = me.exec(t.slice(i));
  return n ? (e.s = +n[0], i + n[0].length) : -1;
}
function sQ(e, t) {
  return Rt(e.getDate(), t, 2);
}
function o2(e, t) {
  return Rt(e.getHours(), t, 2);
}
function r2(e, t) {
  return Rt(e.getHours() % 12 || 12, t, 2);
}
function a2(e, t) {
  return Rt(1 + Wh.count(kA(e), e), t, 3);
}
function sw(e, t) {
  return Rt(e.getMilliseconds(), t, 3);
}
function l2(e, t) {
  return sw(e, t) + "000";
}
function c2(e, t) {
  return Rt(e.getMonth() + 1, t, 2);
}
function g2(e, t) {
  return Rt(e.getMinutes(), t, 2);
}
function h2(e, t) {
  return Rt(e.getSeconds(), t, 2);
}
function u2(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function d2(e, t) {
  return Rt(nr.count(kA(e) - 1, e), t, 2);
}
function ow(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? RA(e) : RA.ceil(e);
}
function f2(e, t) {
  return e = ow(e), Rt(RA.count(kA(e), e) + (kA(e).getDay() === 4), t, 2);
}
function I2(e) {
  return e.getDay();
}
function C2(e, t) {
  return Rt(Ar.count(kA(e) - 1, e), t, 2);
}
function E2(e, t) {
  return Rt(e.getFullYear() % 100, t, 2);
}
function B2(e, t) {
  return e = ow(e), Rt(e.getFullYear() % 100, t, 2);
}
function m2(e, t) {
  return Rt(e.getFullYear() % 1e4, t, 4);
}
function Q2(e, t) {
  var i = e.getDay();
  return e = i >= 4 || i === 0 ? RA(e) : RA.ceil(e), Rt(e.getFullYear() % 1e4, t, 4);
}
function p2(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Rt(t / 60 | 0, "0", 2) + Rt(t % 60, "0", 2);
}
function oQ(e, t) {
  return Rt(e.getUTCDate(), t, 2);
}
function y2(e, t) {
  return Rt(e.getUTCHours(), t, 2);
}
function D2(e, t) {
  return Rt(e.getUTCHours() % 12 || 12, t, 2);
}
function w2(e, t) {
  return Rt(1 + qh.count(vA(e), e), t, 3);
}
function rw(e, t) {
  return Rt(e.getUTCMilliseconds(), t, 3);
}
function x2(e, t) {
  return rw(e, t) + "000";
}
function S2(e, t) {
  return Rt(e.getUTCMonth() + 1, t, 2);
}
function M2(e, t) {
  return Rt(e.getUTCMinutes(), t, 2);
}
function _2(e, t) {
  return Rt(e.getUTCSeconds(), t, 2);
}
function b2(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function N2(e, t) {
  return Rt(sr.count(vA(e) - 1, e), t, 2);
}
function aw(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? TA(e) : TA.ceil(e);
}
function F2(e, t) {
  return e = aw(e), Rt(TA.count(vA(e), e) + (vA(e).getUTCDay() === 4), t, 2);
}
function R2(e) {
  return e.getUTCDay();
}
function k2(e, t) {
  return Rt(or.count(vA(e) - 1, e), t, 2);
}
function T2(e, t) {
  return Rt(e.getUTCFullYear() % 100, t, 2);
}
function v2(e, t) {
  return e = aw(e), Rt(e.getUTCFullYear() % 100, t, 2);
}
function G2(e, t) {
  return Rt(e.getUTCFullYear() % 1e4, t, 4);
}
function L2(e, t) {
  var i = e.getUTCDay();
  return e = i >= 4 || i === 0 ? TA(e) : TA.ceil(e), Rt(e.getUTCFullYear() % 1e4, t, 4);
}
function U2() {
  return "+0000";
}
function rQ() {
  return "%";
}
function aQ(e) {
  return +e;
}
function lQ(e) {
  return Math.floor(+e / 1e3);
}
var oo, lw, cw;
O2({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function O2(e) {
  return oo = Ov(e), lw = oo.format, oo.parse, cw = oo.utcFormat, oo.utcParse, oo;
}
var oa = 1e3, ra = oa * 60, aa = ra * 60, Ha = aa * 24, H2 = Ha * 7, cQ = Ha * 30, gd = Ha * 365;
function P2(e) {
  return new Date(e);
}
function Y2(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function uC(e, t, i, n, A, s, o, r, a) {
  var l = Yh(ZI, Di), c = l.invert, g = l.domain, h = a(".%L"), u = a(":%S"), d = a("%I:%M"), f = a("%I %p"), I = a("%a %d"), C = a("%b %d"), E = a("%B"), B = a("%Y"), m = [
    [o, 1, oa],
    [o, 5, 5 * oa],
    [o, 15, 15 * oa],
    [o, 30, 30 * oa],
    [s, 1, ra],
    [s, 5, 5 * ra],
    [s, 15, 15 * ra],
    [s, 30, 30 * ra],
    [A, 1, aa],
    [A, 3, 3 * aa],
    [A, 6, 6 * aa],
    [A, 12, 12 * aa],
    [n, 1, Ha],
    [n, 2, 2 * Ha],
    [i, 1, H2],
    [t, 1, cQ],
    [t, 3, 3 * cQ],
    [e, 1, gd]
  ];
  function y(Q) {
    return (o(Q) < Q ? h : s(Q) < Q ? u : A(Q) < Q ? d : n(Q) < Q ? f : t(Q) < Q ? i(Q) < Q ? I : C : e(Q) < Q ? E : B)(Q);
  }
  function D(Q, p, w, x) {
    if (Q == null && (Q = 10), typeof Q == "number") {
      var S = Math.abs(w - p) / Q, _ = xD(function(M) {
        return M[2];
      }).right(m, S);
      _ === m.length ? (x = Af(p / gd, w / gd, Q), Q = e) : _ ? (_ = m[S / m[_ - 1][2] < m[_][2] / S ? _ - 1 : _], x = _[1], Q = _[0]) : (x = Math.max(Af(p, w, Q), 1), Q = r);
    }
    return x == null ? Q : Q.every(x);
  }
  return l.invert = function(Q) {
    return new Date(c(Q));
  }, l.domain = function(Q) {
    return arguments.length ? g(JI.call(Q, Y2)) : g().map(P2);
  }, l.ticks = function(Q, p) {
    var w = g(), x = w[0], S = w[w.length - 1], _ = S < x, M;
    return _ && (M = x, x = S, S = M), M = D(Q, x, S, p), M = M ? M.range(x, S + 1) : [], _ ? M.reverse() : M;
  }, l.tickFormat = function(Q, p) {
    return p == null ? y : a(p);
  }, l.nice = function(Q, p) {
    var w = g();
    return (Q = D(Q, w[0], w[w.length - 1], p)) ? g(YD(w, Q)) : l;
  }, l.copy = function() {
    return Ph(l, uC(e, t, i, n, A, s, o, r, a));
  }, l;
}
function J2() {
  return uC(kA, sC, nr, Wh, Kh, Jh, FA, NA, lw).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]);
}
function K2() {
  return uC(vA, gC, sr, qh, jh, Vh, FA, NA, cw).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]);
}
function PA(e) {
  return e.match(/.{6}/g).map(function(t) {
    return "#" + t;
  });
}
const W2 = PA("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), V2 = PA("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
PA("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
const j2 = PA("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
wr(xe(300, 0.5, 0), xe(-240, 0.5, 1));
wr(xe(-100, 0.75, 0.35), xe(80, 1.5, 0.8));
wr(xe(260, 0.75, 0.35), xe(80, 1.5, 0.8));
xe();
function zh(e) {
  var t = e.length;
  return function(i) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(i * t)))];
  };
}
zh(PA("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
zh(PA("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
zh(PA("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
zh(PA("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function gw(e) {
  var t = 0, i = 1, n = !1;
  function A(s) {
    var o = (s - t) / (i - t);
    return e(n ? Math.max(0, Math.min(1, o)) : o);
  }
  return A.domain = function(s) {
    return arguments.length ? (t = +s[0], i = +s[1], A) : [t, i];
  }, A.clamp = function(s) {
    return arguments.length ? (n = !!s, A) : n;
  }, A.interpolator = function(s) {
    return arguments.length ? (e = s, A) : e;
  }, A.copy = function() {
    return gw(e).domain([t, i]).clamp(n);
  }, dl(A);
}
const hw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: WI,
  scaleIdentity: PD,
  scaleLinear: HD,
  scaleLog: JD,
  scaleOrdinal: KI,
  scalePow: KD,
  scaleQuantile: WD,
  scaleQuantize: tC,
  scaleSequential: gw,
  scaleThreshold: VD,
  scaleTime: J2,
  scaleUtc: K2,
  schemeCategory10: W2,
  schemeCategory20: j2,
  schemeCategory20b: V2
}, Symbol.toStringTag, { value: "Module" }));
function Dt(e) {
  for (var t = e.length / 6 | 0, i = new Array(t), n = 0; n < t; )
    i[n] = "#" + e.slice(n * 6, ++n * 6);
  return i;
}
const q2 = Dt("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), z2 = Dt("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), Z2 = Dt("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), $2 = Dt("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), X2 = Dt("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), tG = Dt("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), eG = Dt("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), iG = Dt("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
function Kt(e) {
  return sv(e[e.length - 1]);
}
var uw = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(Dt);
const nG = Kt(uw);
var dw = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(Dt);
const AG = Kt(dw);
var fw = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(Dt);
const sG = Kt(fw);
var oG = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(Dt);
const rG = Kt(oG);
var aG = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(Dt);
const lG = Kt(aG);
var cG = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(Dt);
const gG = Kt(cG);
var hG = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(Dt);
const uG = Kt(hG);
var dG = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(Dt);
const fG = Kt(dG);
var IG = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(Dt);
const CG = Kt(IG);
var EG = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(Dt);
const BG = Kt(EG);
var mG = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(Dt);
const QG = Kt(mG);
var pG = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(Dt);
const yG = Kt(pG);
var DG = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(Dt);
const wG = Kt(DG);
var xG = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(Dt);
const SG = Kt(xG);
var MG = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(Dt);
const _G = Kt(MG);
var bG = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(Dt);
const NG = Kt(bG);
var FG = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(Dt);
const RG = Kt(FG);
var kG = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(Dt);
const TG = Kt(kG);
var vG = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(Dt);
const GG = Kt(vG);
var LG = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(Dt);
const UG = Kt(LG);
var OG = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(Dt);
const HG = Kt(OG);
var Iw = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(Dt);
const PG = Kt(Iw);
var YG = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(Dt);
const JG = Kt(YG);
var KG = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(Dt);
const WG = Kt(KG);
var VG = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(Dt);
const jG = Kt(VG);
var qG = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(Dt);
const zG = Kt(qG);
var ZG = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(Dt);
const $G = Kt(ZG), XG = wr(xe(300, 0.5, 0), xe(-240, 0.5, 1));
var tL = wr(xe(-100, 0.75, 0.35), xe(80, 1.5, 0.8)), eL = wr(xe(260, 0.75, 0.35), xe(80, 1.5, 0.8)), ic = xe();
function iL(e) {
  (e < 0 || e > 1) && (e -= Math.floor(e));
  var t = Math.abs(e - 0.5);
  return ic.h = 360 * e - 100, ic.s = 1.5 - 1.5 * t, ic.l = 0.8 - 0.9 * t, ic + "";
}
function Zh(e) {
  var t = e.length;
  return function(i) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(i * t)))];
  };
}
const nL = Zh(Dt("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var AL = Zh(Dt("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), sL = Zh(Dt("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), oL = Zh(Dt("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
const rf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  interpolateBlues: PG,
  interpolateBrBG: nG,
  interpolateBuGn: BG,
  interpolateBuPu: QG,
  interpolateCool: eL,
  interpolateCubehelixDefault: XG,
  interpolateGnBu: yG,
  interpolateGreens: JG,
  interpolateGreys: WG,
  interpolateInferno: sL,
  interpolateMagma: AL,
  interpolateOrRd: wG,
  interpolateOranges: $G,
  interpolatePRGn: AG,
  interpolatePiYG: sG,
  interpolatePlasma: oL,
  interpolatePuBu: _G,
  interpolatePuBuGn: SG,
  interpolatePuOr: rG,
  interpolatePuRd: NG,
  interpolatePurples: jG,
  interpolateRainbow: iL,
  interpolateRdBu: lG,
  interpolateRdGy: gG,
  interpolateRdPu: RG,
  interpolateRdYlBu: uG,
  interpolateRdYlGn: fG,
  interpolateReds: zG,
  interpolateSpectral: CG,
  interpolateViridis: nL,
  interpolateWarm: tL,
  interpolateYlGn: GG,
  interpolateYlGnBu: TG,
  interpolateYlOrBr: UG,
  interpolateYlOrRd: HG,
  schemeAccent: q2,
  schemeBlues: Iw,
  schemeBrBG: uw,
  schemeDark2: z2,
  schemePRGn: dw,
  schemePaired: Z2,
  schemePastel1: $2,
  schemePastel2: X2,
  schemePiYG: fw,
  schemeSet1: tG,
  schemeSet2: eG,
  schemeSet3: iG
}, Symbol.toStringTag, { value: "Module" })), $h = "app.units", rL = "local.units", aL = "local.layers", Cw = "app.layers", rr = "app.group", lL = "local.group", dC = "local.canvas", cL = "app.canvas", Yt = "virtualScrolling", gL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CANVAS_GLOBAL_NAMESPACE: cL,
  CANVAS_LOCAL_NAMESPACE: dC,
  GROUP_GLOBAL_NAMESPACE: rr,
  GROUP_LOCAL_NAMESPACE: lL,
  LAYER_GLOBAL_NAMESPACE: Cw,
  LAYER_LOCAL_NAMESPACE: aL,
  UNIT_GLOBAL_NAMESPACE: $h,
  UNIT_LOCAL_NAMESPACE: rL,
  VIRTUAL_SCROLLING_NAMESPACE: Yt
}, Symbol.toStringTag, { value: "Module" })), qr = (e, t, i) => {
  const n = e[t];
  e[t] = e[i], e[i] = n;
}, hL = (e, t) => e > t ? -1 : e > t ? 1 : 0, Ew = (e, t, i, n, A) => {
  for (; n > i; ) {
    if (n - i > 600) {
      const a = n - i + 1, l = t - i + 1, c = Math.log(a), g = 0.5 * Math.exp(2 * c / 3), h = 0.5 * Math.sqrt(c * g * (a - g) / a) * (l - a / 2 < 0 ? -1 : 1), u = Math.max(i, Math.floor(t - l * g / a + h)), d = Math.min(n, Math.floor(t + (a - l) * g / a + h));
      Ew(e, t, u, d, A);
    }
    const s = e[t];
    let o = i, r = n;
    for (qr(e, i, t), A(e[n], s) > 0 && qr(e, i, n); o < r; ) {
      for (qr(e, o, r), o++, r--; A(e[o], s) < 0; )
        o++;
      for (; A(e[r], s) > 0; )
        r--;
    }
    A(e[i], s) === 0 ? qr(e, i, r) : (r++, qr(e, r, n)), r <= t && (i = r + 1), t <= r && (n = r - 1);
  }
}, uL = (e, t, i, n, A) => {
  Ew(
    e,
    t,
    i || 0,
    n || e.length - 1,
    A || hL
  );
}, Bo = (e) => ({
  children: e,
  height: 1,
  leaf: !0,
  minX: 1 / 0,
  minY: 1 / 0,
  maxX: -1 / 0,
  maxY: -1 / 0
}), la = (e, t) => (e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), e), ca = (e, t, i, n, A) => {
  A || (A = Bo(null)), A.minX = 1 / 0, A.minY = 1 / 0, A.maxX = -1 / 0, A.maxY = -1 / 0;
  for (let s = t; s < i; s++) {
    const o = e.children[s];
    la(A, e.leaf ? n(o) : o);
  }
  return A;
}, ro = (e, t) => {
  ca(e, 0, e.children.length, t, e);
}, dL = (e, t) => e.minX - t.minX, fL = (e, t) => e.minY - t.minY, hd = (e) => (e.maxX - e.minX) * (e.maxY - e.minY), nc = (e) => e.maxX - e.minX + (e.maxY - e.minY), IL = (e, t) => (Math.max(t.maxX, e.maxX) - Math.min(t.minX, e.minX)) * (Math.max(t.maxY, e.maxY) - Math.min(t.minY, e.minY)), CL = (e, t) => {
  const i = Math.max(e.minX, t.minX), n = Math.max(e.minY, t.minY), A = Math.min(e.maxX, t.maxX), s = Math.min(e.maxY, t.maxY);
  return Math.max(0, A - i) * Math.max(0, s - n);
}, gQ = (e, t) => e.minX <= t.minX && e.minY <= t.minY && t.maxX <= e.maxX && t.maxY <= e.maxY, hQ = (e, t) => t.minX <= e.maxX && t.minY <= e.maxY && t.maxX >= e.minX && t.maxY >= e.minY, EL = (e, t, i) => {
  if (!i)
    return t.indexOf(e);
  for (let n = 0; n < t.length; n++)
    if (i(e, t[n]))
      return n;
  return -1;
}, uQ = (e, t, i, n, A) => {
  const s = [t, i];
  for (; s.length; ) {
    if (i = s.pop(), t = s.pop(), i - t <= n)
      continue;
    const o = t + Math.ceil((i - t) / n / 2) * n;
    uL(e, o, t, i, A), s.push(t, o, o, i);
  }
}, dQ = (e, t) => {
  const i = [];
  for (; e; )
    e.leaf ? t.push(...e.children) : i.push(...e.children), e = i.pop();
  return t;
};
class Ns {
  _maxEntries;
  _minEntries;
  data;
  constructor(t = 9) {
    this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4)), this.clear();
  }
  all() {
    return dQ(this.data, []);
  }
  search(t) {
    let i = this.data;
    const n = [];
    if (!hQ(t, i))
      return n;
    const A = this.toBBox, s = [];
    for (; i; ) {
      for (const o of i.children) {
        const r = i.leaf ? A(o) : o;
        hQ(t, r) && (i.leaf ? n.push(o) : gQ(t, r) ? dQ(o, n) : s.push(o));
      }
      i = s.pop();
    }
    return n;
  }
  load(t) {
    if (!(t && t.length))
      return this;
    if (t.length < this._minEntries) {
      for (let n = 0; n < t.length; n++)
        this.insert(t[n]);
      return this;
    }
    let i = this.build(t.slice(), 0, t.length - 1, 0);
    if (!this.data.children.length)
      this.data = i;
    else if (this.data.height === i.height)
      this.splitRoot(this.data, i);
    else {
      if (this.data.height < i.height) {
        const n = this.data;
        this.data = i, i = n;
      }
      this.insertSingleItem(i, this.data.height - i.height - 1, !0);
    }
    return this;
  }
  insert(t) {
    return t && this.insertSingleItem(t, this.data.height - 1), this;
  }
  clear() {
    return this.data = Bo([]), this;
  }
  remove(t, i) {
    if (!t)
      return this;
    let n, A, s, o = this.data;
    const r = this.toBBox(t), a = [], l = [];
    for (; o || a.length; ) {
      if (o || (o = a.pop(), A = a[a.length - 1], n = l.pop(), s = !0), o.leaf) {
        const c = EL(t, o.children, i);
        if (c !== -1)
          return o.children.splice(c, 1), a.push(o), this.condense(a), this;
      }
      !s && !o.leaf && gQ(o, r) ? (a.push(o), l.push(n), n = 0, A = o, o = o.children[0]) : A ? (n++, o = A.children[n], s = !1) : o = null;
    }
    return this;
  }
  toJSON() {
    return this.data;
  }
  fromJSON(t) {
    return this.data = t, this;
  }
  toBBox(t) {
    return t;
  }
  compareMinX(t, i) {
    return t.minX - i.minX;
  }
  compareMinY(t, i) {
    return t.minY - i.minY;
  }
  build(t, i, n, A) {
    const s = n - i + 1;
    let o = this._maxEntries, r;
    if (s <= o)
      return r = Bo(t.slice(i, n + 1)), ro(r, this.toBBox), r;
    A || (A = Math.ceil(Math.log(s) / Math.log(o)), o = Math.ceil(s / o ** (A - 1))), r = Bo([]), r.leaf = !1, r.height = A;
    const a = Math.ceil(s / o), l = a * Math.ceil(Math.sqrt(o));
    uQ(t, i, n, l, this.compareMinX);
    for (let c = i; c <= n; c += l) {
      const g = Math.min(c + l - 1, n);
      uQ(t, c, g, a, this.compareMinY);
      for (let h = c; h <= g; h += a) {
        const u = Math.min(h + a - 1, g);
        r.children.push(this.build(t, h, u, A - 1));
      }
    }
    return ro(r, this.toBBox), r;
  }
  chooseSubtree(t, i, n, A) {
    for (; A.push(i), !(i.leaf || A.length - 1 === n); ) {
      let s = 1 / 0, o = 1 / 0, r;
      for (const a of i.children) {
        const l = hd(a), c = IL(t, a) - l;
        c < o ? (o = c, s = l < s ? l : s, r = a) : c === o && l < s && (s = l, r = a);
      }
      i = r || i.children[0];
    }
    return i;
  }
  insertSingleItem(t, i, n) {
    const A = n ? t : this.toBBox(t), s = [], o = this.chooseSubtree(A, this.data, i, s);
    for (o.children.push(t), la(o, A); i >= 0 && s[i].children.length > this._maxEntries; )
      this.split(s, i), i--;
    this.adjustParentBoxes(A, s, i);
  }
  // split overflowed node into two
  split(t, i) {
    const n = t[i], A = n.children.length, s = this._minEntries;
    this.chooseSplitAxis(n, s, A);
    const o = this.chooseSplitIndex(n, s, A), r = Bo(
      n.children.splice(o, n.children.length - o)
    );
    r.height = n.height, r.leaf = n.leaf, ro(n, this.toBBox), ro(r, this.toBBox), i ? t[i - 1].children.push(r) : this.splitRoot(n, r);
  }
  splitRoot(t, i) {
    this.data = Bo([t, i]), this.data.height = t.height + 1, this.data.leaf = !1, ro(this.data, this.toBBox);
  }
  chooseSplitIndex(t, i, n) {
    let A, s = 1 / 0, o = 1 / 0;
    for (let r = i; r <= n - i; r++) {
      const a = ca(t, 0, r, this.toBBox), l = ca(t, r, n, this.toBBox), c = CL(a, l), g = hd(a) + hd(l);
      c < s ? (s = c, A = r, o = g < o ? g : o) : c === s && g < o && (o = g, A = r);
    }
    return A || n - i;
  }
  // sorts node children by the best axis for split
  chooseSplitAxis(t, i, n) {
    const A = t.leaf ? this.compareMinX : dL, s = t.leaf ? this.compareMinY : fL, o = this.allDistMargin(t, i, n, A), r = this.allDistMargin(t, i, n, s);
    o < r && t.children.sort(A);
  }
  // total margin of all possible split distributions where each node is at least m full
  allDistMargin(t, i, n, A) {
    t.children.sort(A);
    const s = this.toBBox, o = ca(t, 0, i, s), r = ca(t, n - i, n, s);
    let a = nc(o) + nc(r);
    for (let l = i; l < n - i; l++) {
      const c = t.children[l];
      la(o, t.leaf ? s(c) : c), a += nc(o);
    }
    for (let l = n - i - 1; l >= i; l--) {
      const c = t.children[l];
      la(r, t.leaf ? s(c) : c), a += nc(r);
    }
    return a;
  }
  adjustParentBoxes(t, i, n) {
    for (let A = n; A >= 0; A--)
      la(i[A], t);
  }
  condense(t) {
    for (let i = t.length - 1, n; i >= 0; i--)
      t[i].children.length === 0 ? i > 0 ? (n = t[i - 1].children, n.splice(n.indexOf(t[i]), 1)) : this.clear() : ro(t[i], this.toBBox);
  }
}
const Ve = (e) => e && (e.subtype() === lt.CONTINUOUS || e.subtype() === "temporal") ? lt.CONTINUOUS : lt.DISCRETE;
var gi = /* @__PURE__ */ ((e) => (e.NATURAL_ORDER = "natural", e.ALPHABETICAL_ORDER = "alphabetical", e.FIELD_ORDER = "field", e.NESTED_ORDER = "nested", e.CUSTOM_VALUES_ORDER = "custom", e))(gi || {});
const xr = {
  type: "natural",
  direction: Vn.ASC,
  field: {
    name: null,
    aggregation: null
  },
  nested: {
    filters: [],
    field: {
      name: null,
      aggregation: null
    }
  },
  values: null
};
var ud = Array.prototype.slice;
function BL(e) {
  return e;
}
var Uc = 1, Oc = 2, af = 3, ga = 4, fQ = 1e-6;
function mL(e) {
  return "translate(" + (e + 0.5) + ",0)";
}
function QL(e) {
  return "translate(0," + (e + 0.5) + ")";
}
function pL(e) {
  return function(t) {
    return +e(t);
  };
}
function yL(e) {
  var t = Math.max(0, e.bandwidth() - 1) / 2;
  return e.round() && (t = Math.round(t)), function(i) {
    return +e(i) + t;
  };
}
function DL() {
  return !this.__axis;
}
function Xh(e, t) {
  var i = [], n = null, A = null, s = null, o = 6, r = 6, a = 3, l = e === Uc || e === ga ? -1 : 1, c = e === ga || e === Oc ? "x" : "y", g = e === Uc || e === af ? mL : QL;
  function h(u) {
    var d = n ?? (t.ticks ? t.ticks.apply(t, i) : t.domain()), f = A ?? (t.tickFormat ? t.tickFormat.apply(t, i) : BL), I = Math.max(o, 0) + a, C = t.range(), E = +C[0] + 0.5, B = +C[C.length - 1] + 0.5, m = (t.bandwidth ? yL : pL)(t.copy()), y = u.selection ? u.selection() : u, D = y.selectAll(".domain").data([null]), Q = y.selectAll(".tick").data(d, t).order(), p = Q.exit(), w = Q.enter().append("g").attr("class", "tick"), x = Q.select("line"), S = Q.select("text");
    D = D.merge(D.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "#000")), Q = Q.merge(w), x = x.merge(w.append("line").attr("stroke", "#000").attr(c + "2", l * o)), S = S.merge(w.append("text").attr("fill", "#000").attr(c, l * I).attr("dy", e === Uc ? "0em" : e === af ? "0.71em" : "0.32em")).style("transform", s), u !== y && (D = D.transition(u), Q = Q.transition(u), x = x.transition(u), S = S.transition(u), p = p.transition(u).attr("opacity", fQ).attr("transform", function(_) {
      return isFinite(_ = m(_)) ? g(_) : this.getAttribute("transform");
    }), w.attr("opacity", fQ).attr("transform", function(_) {
      var M = this.parentNode.__axis;
      return g(M && isFinite(M = M(_)) ? M : m(_));
    })), p.remove(), D.attr("d", e === ga || e == Oc ? "M" + l * r + "," + E + "H0.5V" + B + "H" + l * r : "M" + E + "," + l * r + "V0.5H" + B + "V" + l * r), Q.attr("opacity", 1).attr("transform", function(_) {
      return g(m(_));
    }), x.attr(c + "2", l * o), S.attr(c, l * I).text(f), y.filter(DL).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", e === Oc ? "start" : e === ga ? "end" : "middle"), y.each(function() {
      this.__axis = m;
    });
  }
  return h.scale = function(u) {
    return arguments.length ? (t = u, h) : t;
  }, h.tickTransform = function(u) {
    return arguments.length ? (s = u, h) : s;
  }, h.ticks = function() {
    return i = ud.call(arguments), h;
  }, h.tickArguments = function(u) {
    return arguments.length ? (i = u == null ? [] : ud.call(u), h) : i.slice();
  }, h.tickValues = function(u) {
    return arguments.length ? (n = u == null ? null : ud.call(u), h) : n && n.slice();
  }, h.tickFormat = function(u) {
    return arguments.length ? (A = u, h) : A;
  }, h.tickSize = function(u) {
    return arguments.length ? (o = r = +u, h) : o;
  }, h.tickSizeInner = function(u) {
    return arguments.length ? (o = +u, h) : o;
  }, h.tickSizeOuter = function(u) {
    return arguments.length ? (r = +u, h) : r;
  }, h.tickPadding = function(u) {
    return arguments.length ? (a = +u, h) : a;
  }, h;
}
function wL(e) {
  return Xh(Uc, e);
}
function xL(e) {
  return Xh(Oc, e);
}
function SL(e) {
  return Xh(af, e);
}
function ML(e) {
  return Xh(ga, e);
}
var lf = Math.PI, cf = 2 * lf, $A = 1e-6, _L = cf - $A;
function gf() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function fl() {
  return new gf();
}
gf.prototype = fl.prototype = {
  constructor: gf,
  moveTo: function(e, t) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(e, t) {
    this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +t);
  },
  quadraticCurveTo: function(e, t, i, n) {
    this._ += "Q" + +e + "," + +t + "," + (this._x1 = +i) + "," + (this._y1 = +n);
  },
  bezierCurveTo: function(e, t, i, n, A, s) {
    this._ += "C" + +e + "," + +t + "," + +i + "," + +n + "," + (this._x1 = +A) + "," + (this._y1 = +s);
  },
  arcTo: function(e, t, i, n, A) {
    e = +e, t = +t, i = +i, n = +n, A = +A;
    var s = this._x1, o = this._y1, r = i - e, a = n - t, l = s - e, c = o - t, g = l * l + c * c;
    if (A < 0)
      throw new Error("negative radius: " + A);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = e) + "," + (this._y1 = t);
    else if (g > $A)
      if (!(Math.abs(c * r - a * l) > $A) || !A)
        this._ += "L" + (this._x1 = e) + "," + (this._y1 = t);
      else {
        var h = i - s, u = n - o, d = r * r + a * a, f = h * h + u * u, I = Math.sqrt(d), C = Math.sqrt(g), E = A * Math.tan((lf - Math.acos((d + g - f) / (2 * I * C))) / 2), B = E / C, m = E / I;
        Math.abs(B - 1) > $A && (this._ += "L" + (e + B * l) + "," + (t + B * c)), this._ += "A" + A + "," + A + ",0,0," + +(c * h > l * u) + "," + (this._x1 = e + m * r) + "," + (this._y1 = t + m * a);
      }
  },
  arc: function(e, t, i, n, A, s) {
    e = +e, t = +t, i = +i, s = !!s;
    var o = i * Math.cos(n), r = i * Math.sin(n), a = e + o, l = t + r, c = 1 ^ s, g = s ? n - A : A - n;
    if (i < 0)
      throw new Error("negative radius: " + i);
    this._x1 === null ? this._ += "M" + a + "," + l : (Math.abs(this._x1 - a) > $A || Math.abs(this._y1 - l) > $A) && (this._ += "L" + a + "," + l), i && (g < 0 && (g = g % cf + cf), g > _L ? this._ += "A" + i + "," + i + ",0,1," + c + "," + (e - o) + "," + (t - r) + "A" + i + "," + i + ",0,1," + c + "," + (this._x1 = a) + "," + (this._y1 = l) : g > $A && (this._ += "A" + i + "," + i + ",0," + +(g >= lf) + "," + c + "," + (this._x1 = e + i * Math.cos(A)) + "," + (this._y1 = t + i * Math.sin(A))));
  },
  rect: function(e, t, i, n) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t) + "h" + +i + "v" + +n + "h" + -i + "Z";
  },
  toString: function() {
    return this._;
  }
};
function _t(e) {
  return function() {
    return e;
  };
}
var IQ = Math.abs, Ne = Math.atan2, WA = Math.cos, bL = Math.max, dd = Math.min, yn = Math.sin, Do = Math.sqrt, Re = 1e-12, GA = Math.PI, Qg = GA / 2, DA = 2 * GA;
function NL(e) {
  return e > 1 ? 0 : e < -1 ? GA : Math.acos(e);
}
function CQ(e) {
  return e >= 1 ? Qg : e <= -1 ? -Qg : Math.asin(e);
}
function FL(e) {
  return e.innerRadius;
}
function RL(e) {
  return e.outerRadius;
}
function kL(e) {
  return e.startAngle;
}
function TL(e) {
  return e.endAngle;
}
function vL(e) {
  return e && e.padAngle;
}
function GL(e, t, i, n, A, s, o, r) {
  var a = i - e, l = n - t, c = o - A, g = r - s, h = g * a - c * l;
  if (!(h * h < Re))
    return h = (c * (t - s) - g * (e - A)) / h, [e + h * a, t + h * l];
}
function Ac(e, t, i, n, A, s, o) {
  var r = e - i, a = t - n, l = (o ? s : -s) / Do(r * r + a * a), c = l * a, g = -l * r, h = e + c, u = t + g, d = i + c, f = n + g, I = (h + d) / 2, C = (u + f) / 2, E = d - h, B = f - u, m = E * E + B * B, y = A - s, D = h * f - d * u, Q = (B < 0 ? -1 : 1) * Do(bL(0, y * y * m - D * D)), p = (D * B - E * Q) / m, w = (-D * E - B * Q) / m, x = (D * B + E * Q) / m, S = (-D * E + B * Q) / m, _ = p - I, M = w - C, k = x - I, T = S - C;
  return _ * _ + M * M > k * k + T * T && (p = x, w = S), {
    cx: p,
    cy: w,
    x01: -c,
    y01: -g,
    x11: p * (A / y - 1),
    y11: w * (A / y - 1)
  };
}
function LL() {
  var e = FL, t = RL, i = _t(0), n = null, A = kL, s = TL, o = vL, r = null;
  function a() {
    var l, c, g = +e.apply(this, arguments), h = +t.apply(this, arguments), u = A.apply(this, arguments) - Qg, d = s.apply(this, arguments) - Qg, f = IQ(d - u), I = d > u;
    if (r || (r = l = fl()), h < g && (c = h, h = g, g = c), !(h > Re))
      r.moveTo(0, 0);
    else if (f > DA - Re)
      r.moveTo(h * WA(u), h * yn(u)), r.arc(0, 0, h, u, d, !I), g > Re && (r.moveTo(g * WA(d), g * yn(d)), r.arc(0, 0, g, d, u, I));
    else {
      var C = u, E = d, B = u, m = d, y = f, D = f, Q = o.apply(this, arguments) / 2, p = Q > Re && (n ? +n.apply(this, arguments) : Do(g * g + h * h)), w = dd(IQ(h - g) / 2, +i.apply(this, arguments)), x = w, S = w, _, M;
      if (p > Re) {
        var k = CQ(p / g * yn(Q)), T = CQ(p / h * yn(Q));
        (y -= k * 2) > Re ? (k *= I ? 1 : -1, B += k, m -= k) : (y = 0, B = m = (u + d) / 2), (D -= T * 2) > Re ? (T *= I ? 1 : -1, C += T, E -= T) : (D = 0, C = E = (u + d) / 2);
      }
      var G = h * WA(C), N = h * yn(C), b = g * WA(m), F = g * yn(m);
      if (w > Re) {
        var R = h * WA(E), v = h * yn(E), O = g * WA(B), L = g * yn(B), U;
        if (f < GA && (U = GL(G, N, O, L, R, v, b, F))) {
          var H = G - U[0], z = N - U[1], et = R - U[0], Z = v - U[1], Y = 1 / yn(NL((H * et + z * Z) / (Do(H * H + z * z) * Do(et * et + Z * Z))) / 2), q = Do(U[0] * U[0] + U[1] * U[1]);
          x = dd(w, (g - q) / (Y - 1)), S = dd(w, (h - q) / (Y + 1));
        }
      }
      D > Re ? S > Re ? (_ = Ac(O, L, G, N, h, S, I), M = Ac(R, v, b, F, h, S, I), r.moveTo(_.cx + _.x01, _.cy + _.y01), S < w ? r.arc(_.cx, _.cy, S, Ne(_.y01, _.x01), Ne(M.y01, M.x01), !I) : (r.arc(_.cx, _.cy, S, Ne(_.y01, _.x01), Ne(_.y11, _.x11), !I), r.arc(0, 0, h, Ne(_.cy + _.y11, _.cx + _.x11), Ne(M.cy + M.y11, M.cx + M.x11), !I), r.arc(M.cx, M.cy, S, Ne(M.y11, M.x11), Ne(M.y01, M.x01), !I))) : (r.moveTo(G, N), r.arc(0, 0, h, C, E, !I)) : r.moveTo(G, N), !(g > Re) || !(y > Re) ? r.lineTo(b, F) : x > Re ? (_ = Ac(b, F, R, v, g, -x, I), M = Ac(G, N, O, L, g, -x, I), r.lineTo(_.cx + _.x01, _.cy + _.y01), x < w ? r.arc(_.cx, _.cy, x, Ne(_.y01, _.x01), Ne(M.y01, M.x01), !I) : (r.arc(_.cx, _.cy, x, Ne(_.y01, _.x01), Ne(_.y11, _.x11), !I), r.arc(0, 0, g, Ne(_.cy + _.y11, _.cx + _.x11), Ne(M.cy + M.y11, M.cx + M.x11), I), r.arc(M.cx, M.cy, x, Ne(M.y11, M.x11), Ne(M.y01, M.x01), !I))) : r.arc(0, 0, g, m, B, I);
    }
    if (r.closePath(), l)
      return r = null, l + "" || null;
  }
  return a.centroid = function() {
    var l = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, c = (+A.apply(this, arguments) + +s.apply(this, arguments)) / 2 - GA / 2;
    return [WA(c) * l, yn(c) * l];
  }, a.innerRadius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : _t(+l), a) : e;
  }, a.outerRadius = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : _t(+l), a) : t;
  }, a.cornerRadius = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : _t(+l), a) : i;
  }, a.padRadius = function(l) {
    return arguments.length ? (n = l == null ? null : typeof l == "function" ? l : _t(+l), a) : n;
  }, a.startAngle = function(l) {
    return arguments.length ? (A = typeof l == "function" ? l : _t(+l), a) : A;
  }, a.endAngle = function(l) {
    return arguments.length ? (s = typeof l == "function" ? l : _t(+l), a) : s;
  }, a.padAngle = function(l) {
    return arguments.length ? (o = typeof l == "function" ? l : _t(+l), a) : o;
  }, a.context = function(l) {
    return arguments.length ? (r = l ?? null, a) : r;
  }, a;
}
function Bw(e) {
  this._context = e;
}
Bw.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function pg(e) {
  return new Bw(e);
}
function mw(e) {
  return e[0];
}
function Qw(e) {
  return e[1];
}
function pw() {
  var e = mw, t = Qw, i = _t(!0), n = null, A = pg, s = null;
  function o(r) {
    var a, l = r.length, c, g = !1, h;
    for (n == null && (s = A(h = fl())), a = 0; a <= l; ++a)
      !(a < l && i(c = r[a], a, r)) === g && ((g = !g) ? s.lineStart() : s.lineEnd()), g && s.point(+e(c, a, r), +t(c, a, r));
    if (h)
      return s = null, h + "" || null;
  }
  return o.x = function(r) {
    return arguments.length ? (e = typeof r == "function" ? r : _t(+r), o) : e;
  }, o.y = function(r) {
    return arguments.length ? (t = typeof r == "function" ? r : _t(+r), o) : t;
  }, o.defined = function(r) {
    return arguments.length ? (i = typeof r == "function" ? r : _t(!!r), o) : i;
  }, o.curve = function(r) {
    return arguments.length ? (A = r, n != null && (s = A(n)), o) : A;
  }, o.context = function(r) {
    return arguments.length ? (r == null ? n = s = null : s = A(n = r), o) : n;
  }, o;
}
function UL() {
  var e = mw, t = null, i = _t(0), n = Qw, A = _t(!0), s = null, o = pg, r = null;
  function a(c) {
    var g, h, u, d = c.length, f, I = !1, C, E = new Array(d), B = new Array(d);
    for (s == null && (r = o(C = fl())), g = 0; g <= d; ++g) {
      if (!(g < d && A(f = c[g], g, c)) === I)
        if (I = !I)
          h = g, r.areaStart(), r.lineStart();
        else {
          for (r.lineEnd(), r.lineStart(), u = g - 1; u >= h; --u)
            r.point(E[u], B[u]);
          r.lineEnd(), r.areaEnd();
        }
      I && (E[g] = +e(f, g, c), B[g] = +i(f, g, c), r.point(t ? +t(f, g, c) : E[g], n ? +n(f, g, c) : B[g]));
    }
    if (C)
      return r = null, C + "" || null;
  }
  function l() {
    return pw().defined(A).curve(o).context(s);
  }
  return a.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : _t(+c), t = null, a) : e;
  }, a.x0 = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : _t(+c), a) : e;
  }, a.x1 = function(c) {
    return arguments.length ? (t = c == null ? null : typeof c == "function" ? c : _t(+c), a) : t;
  }, a.y = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : _t(+c), n = null, a) : i;
  }, a.y0 = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : _t(+c), a) : i;
  }, a.y1 = function(c) {
    return arguments.length ? (n = c == null ? null : typeof c == "function" ? c : _t(+c), a) : n;
  }, a.lineX0 = a.lineY0 = function() {
    return l().x(e).y(i);
  }, a.lineY1 = function() {
    return l().x(e).y(n);
  }, a.lineX1 = function() {
    return l().x(t).y(i);
  }, a.defined = function(c) {
    return arguments.length ? (A = typeof c == "function" ? c : _t(!!c), a) : A;
  }, a.curve = function(c) {
    return arguments.length ? (o = c, s != null && (r = o(s)), a) : o;
  }, a.context = function(c) {
    return arguments.length ? (c == null ? s = r = null : r = o(s = c), a) : s;
  }, a;
}
function OL(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function HL(e) {
  return e;
}
function PL() {
  var e = HL, t = OL, i = null, n = _t(0), A = _t(DA), s = _t(0);
  function o(r) {
    var a, l = r.length, c, g, h = 0, u = new Array(l), d = new Array(l), f = +n.apply(this, arguments), I = Math.min(DA, Math.max(-DA, A.apply(this, arguments) - f)), C, E = Math.min(Math.abs(I) / l, s.apply(this, arguments)), B = E * (I < 0 ? -1 : 1), m;
    for (a = 0; a < l; ++a)
      (m = d[u[a] = a] = +e(r[a], a, r)) > 0 && (h += m);
    for (t != null ? u.sort(function(y, D) {
      return t(d[y], d[D]);
    }) : i != null && u.sort(function(y, D) {
      return i(r[y], r[D]);
    }), a = 0, g = h ? (I - l * B) / h : 0; a < l; ++a, f = C)
      c = u[a], m = d[c], C = f + (m > 0 ? m * g : 0) + B, d[c] = {
        data: r[c],
        index: a,
        value: m,
        startAngle: f,
        endAngle: C,
        padAngle: E
      };
    return d;
  }
  return o.value = function(r) {
    return arguments.length ? (e = typeof r == "function" ? r : _t(+r), o) : e;
  }, o.sortValues = function(r) {
    return arguments.length ? (t = r, i = null, o) : t;
  }, o.sort = function(r) {
    return arguments.length ? (i = r, t = null, o) : i;
  }, o.startAngle = function(r) {
    return arguments.length ? (n = typeof r == "function" ? r : _t(+r), o) : n;
  }, o.endAngle = function(r) {
    return arguments.length ? (A = typeof r == "function" ? r : _t(+r), o) : A;
  }, o.padAngle = function(r) {
    return arguments.length ? (s = typeof r == "function" ? r : _t(+r), o) : s;
  }, o;
}
var EQ = Array.prototype.slice;
const yw = {
  draw: function(e, t) {
    var i = Math.sqrt(t / GA);
    e.moveTo(i, 0), e.arc(0, 0, i, 0, DA);
  }
}, YL = {
  draw: function(e, t) {
    var i = Math.sqrt(t / 5) / 2;
    e.moveTo(-3 * i, -i), e.lineTo(-i, -i), e.lineTo(-i, -3 * i), e.lineTo(i, -3 * i), e.lineTo(i, -i), e.lineTo(3 * i, -i), e.lineTo(3 * i, i), e.lineTo(i, i), e.lineTo(i, 3 * i), e.lineTo(-i, 3 * i), e.lineTo(-i, i), e.lineTo(-3 * i, i), e.closePath();
  }
};
var Dw = Math.sqrt(1 / 3), JL = Dw * 2;
const KL = {
  draw: function(e, t) {
    var i = Math.sqrt(t / JL), n = i * Dw;
    e.moveTo(0, -i), e.lineTo(n, 0), e.lineTo(0, i), e.lineTo(-n, 0), e.closePath();
  }
};
var WL = 0.8908130915292852, ww = Math.sin(GA / 10) / Math.sin(7 * GA / 10), VL = Math.sin(DA / 10) * ww, jL = -Math.cos(DA / 10) * ww;
const qL = {
  draw: function(e, t) {
    var i = Math.sqrt(t * WL), n = VL * i, A = jL * i;
    e.moveTo(0, -i), e.lineTo(n, A);
    for (var s = 1; s < 5; ++s) {
      var o = DA * s / 5, r = Math.cos(o), a = Math.sin(o);
      e.lineTo(a * i, -r * i), e.lineTo(r * n - a * A, a * n + r * A);
    }
    e.closePath();
  }
}, zL = {
  draw: function(e, t) {
    var i = Math.sqrt(t), n = -i / 2;
    e.rect(n, n, i, i);
  }
};
var fd = Math.sqrt(3);
const ZL = {
  draw: function(e, t) {
    var i = -Math.sqrt(t / (fd * 3));
    e.moveTo(0, i * 2), e.lineTo(-fd * i, -i), e.lineTo(fd * i, -i), e.closePath();
  }
};
var Li = -0.5, Ui = Math.sqrt(3) / 2, hf = 1 / Math.sqrt(12), $L = (hf / 2 + 1) * 3;
const XL = {
  draw: function(e, t) {
    var i = Math.sqrt(t / $L), n = i / 2, A = i * hf, s = n, o = i * hf + i, r = -s, a = o;
    e.moveTo(n, A), e.lineTo(s, o), e.lineTo(r, a), e.lineTo(Li * n - Ui * A, Ui * n + Li * A), e.lineTo(Li * s - Ui * o, Ui * s + Li * o), e.lineTo(Li * r - Ui * a, Ui * r + Li * a), e.lineTo(Li * n + Ui * A, Li * A - Ui * n), e.lineTo(Li * s + Ui * o, Li * o - Ui * s), e.lineTo(Li * r + Ui * a, Li * a - Ui * r), e.closePath();
  }
};
function tU() {
  var e = _t(yw), t = _t(64), i = null;
  function n() {
    var A;
    if (i || (i = A = fl()), e.apply(this, arguments).draw(i, +t.apply(this, arguments)), A)
      return i = null, A + "" || null;
  }
  return n.type = function(A) {
    return arguments.length ? (e = typeof A == "function" ? A : _t(A), n) : e;
  }, n.size = function(A) {
    return arguments.length ? (t = typeof A == "function" ? A : _t(+A), n) : t;
  }, n.context = function(A) {
    return arguments.length ? (i = A ?? null, n) : i;
  }, n;
}
function BQ(e, t, i) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - i),
    e._x2,
    e._y2
  );
}
function fC(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
fC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        BQ(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      default:
        BQ(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
(function e(t) {
  function i(n) {
    return new fC(n, t);
  }
  return i.tension = function(n) {
    return e(+n);
  }, i;
})(0);
function eU(e, t, i) {
  var n = e._x1, A = e._y1, s = e._x2, o = e._y2;
  if (e._l01_a > Re) {
    var r = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, a = 3 * e._l01_a * (e._l01_a + e._l12_a);
    n = (n * r - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / a, A = (A * r - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / a;
  }
  if (e._l23_a > Re) {
    var l = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, c = 3 * e._l23_a * (e._l23_a + e._l12_a);
    s = (s * l + e._x1 * e._l23_2a - t * e._l12_2a) / c, o = (o * l + e._y1 * e._l23_2a - i * e._l12_2a) / c;
  }
  e._context.bezierCurveTo(n, A, s, o, e._x2, e._y2);
}
function xw(e, t) {
  this._context = e, this._alpha = t;
}
xw.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var i = this._x2 - e, n = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(i * i + n * n, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        eU(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const mQ = function e(t) {
  function i(n) {
    return t ? new xw(n, t) : new fC(n, 0);
  }
  return i.alpha = function(n) {
    return e(+n);
  }, i;
}(0.5);
function tu(e, t) {
  this._context = e, this._t = t;
}
tu.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var i = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(i, this._y), this._context.lineTo(i, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function QQ(e) {
  return new tu(e, 0.5);
}
function pQ(e) {
  return new tu(e, 0);
}
function yQ(e) {
  return new tu(e, 1);
}
function Pa(e, t) {
  if ((o = e.length) > 1)
    for (var i = 1, n, A, s = e[t[0]], o, r = s.length; i < o; ++i)
      for (A = s, s = e[t[i]], n = 0; n < r; ++n)
        s[n][1] += s[n][0] = isNaN(A[n][1]) ? A[n][0] : A[n][1];
}
function yg(e) {
  for (var t = e.length, i = new Array(t); --t >= 0; )
    i[t] = t;
  return i;
}
function iU(e, t) {
  return e[t];
}
function nU() {
  var e = _t([]), t = yg, i = Pa, n = iU;
  function A(s) {
    var o = e.apply(this, arguments), r, a = s.length, l = o.length, c = new Array(l), g;
    for (r = 0; r < l; ++r) {
      for (var h = o[r], u = c[r] = new Array(a), d = 0, f; d < a; ++d)
        u[d] = f = [0, +n(s[d], h, d, s)], f.data = s[d];
      u.key = h;
    }
    for (r = 0, g = t(c); r < l; ++r)
      c[g[r]].index = r;
    return i(c, g), c;
  }
  return A.keys = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : _t(EQ.call(s)), A) : e;
  }, A.value = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : _t(+s), A) : n;
  }, A.order = function(s) {
    return arguments.length ? (t = s == null ? yg : typeof s == "function" ? s : _t(EQ.call(s)), A) : t;
  }, A.offset = function(s) {
    return arguments.length ? (i = s ?? Pa, A) : i;
  }, A;
}
function AU(e, t) {
  if ((n = e.length) > 0) {
    for (var i, n, A = 0, s = e[0].length, o; A < s; ++A) {
      for (o = i = 0; i < n; ++i)
        o += e[i][A][1] || 0;
      if (o)
        for (i = 0; i < n; ++i)
          e[i][A][1] /= o;
    }
    Pa(e, t);
  }
}
function sU(e, t) {
  if ((a = e.length) > 0)
    for (var i, n = 0, A, s, o, r, a, l = e[t[0]].length; n < l; ++n)
      for (o = r = 0, i = 0; i < a; ++i)
        (s = (A = e[t[i]][n])[1] - A[0]) > 0 ? (A[0] = o, A[1] = o += s) : s < 0 ? (A[1] = r, A[0] = r += s) : (A[0] = 0, A[1] = s);
}
function oU(e, t) {
  if (!(!((o = e.length) > 0) || !((s = (A = e[t[0]]).length) > 0))) {
    for (var i = 0, n = 1, A, s, o; n < s; ++n) {
      for (var r = 0, a = 0, l = 0; r < o; ++r) {
        for (var c = e[t[r]], g = c[n][1] || 0, h = c[n - 1][1] || 0, u = (g - h) / 2, d = 0; d < r; ++d) {
          var f = e[t[d]], I = f[n][1] || 0, C = f[n - 1][1] || 0;
          u += I - C;
        }
        a += g, l += u * g;
      }
      A[n - 1][1] += A[n - 1][0] = i, a && (i -= l / a);
    }
    A[n - 1][1] += A[n - 1][0] = i, Pa(e, t);
  }
}
function Sw(e) {
  var t = e.map(rU);
  return yg(e).sort(function(i, n) {
    return t[i] - t[n];
  });
}
function rU(e) {
  for (var t = 0, i = -1, n = e.length, A; ++i < n; )
    (A = +e[i][1]) && (t += A);
  return t;
}
function aU(e) {
  return Sw(e).reverse();
}
function lU(e) {
  return +e;
}
function Mw(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var IC = 3;
(function e(t) {
  t = +t;
  function i(n) {
    return Math.pow(n, t);
  }
  return i.exponent = e, i;
})(IC);
(function e(t) {
  t = +t;
  function i(n) {
    return 1 - Math.pow(1 - n, t);
  }
  return i.exponent = e, i;
})(IC);
var cU = function e(t) {
  t = +t;
  function i(n) {
    return ((n *= 2) <= 1 ? Math.pow(n, t) : 2 - Math.pow(2 - n, t)) / 2;
  }
  return i.exponent = e, i;
}(IC);
function Dg(e) {
  return (Math.pow(2, -10 * e) - 9765625e-10) * 1.0009775171065494;
}
function gU(e) {
  return ((e *= 2) <= 1 ? 1 - Math.sqrt(1 - e * e) : Math.sqrt(1 - (e -= 2) * e) + 1) / 2;
}
var uf = 4 / 11, hU = 6 / 11, uU = 8 / 11, dU = 3 / 4, fU = 9 / 11, IU = 10 / 11, CU = 15 / 16, EU = 21 / 22, BU = 63 / 64, sc = 1 / uf / uf;
function mU(e) {
  return (e = +e) < uf ? sc * e * e : e < uU ? sc * (e -= hU) * e + dU : e < IU ? sc * (e -= fU) * e + CU : sc * (e -= EU) * e + BU;
}
var CC = 1.70158;
(function e(t) {
  t = +t;
  function i(n) {
    return (n = +n) * n * (t * (n - 1) + n);
  }
  return i.overshoot = e, i;
})(CC);
(function e(t) {
  t = +t;
  function i(n) {
    return --n * n * ((n + 1) * t + n) + 1;
  }
  return i.overshoot = e, i;
})(CC);
var QU = function e(t) {
  t = +t;
  function i(n) {
    return ((n *= 2) < 1 ? n * n * ((t + 1) * n - t) : (n -= 2) * n * ((t + 1) * n + t) + 2) / 2;
  }
  return i.overshoot = e, i;
}(CC), ar = 2 * Math.PI, EC = 1, BC = 0.3;
(function e(t, i) {
  var n = Math.asin(1 / (t = Math.max(1, t))) * (i /= ar);
  function A(s) {
    return t * Dg(- --s) * Math.sin((n - s) / i);
  }
  return A.amplitude = function(s) {
    return e(s, i * ar);
  }, A.period = function(s) {
    return e(t, s);
  }, A;
})(EC, BC);
var pU = function e(t, i) {
  var n = Math.asin(1 / (t = Math.max(1, t))) * (i /= ar);
  function A(s) {
    return 1 - t * Dg(s = +s) * Math.sin((s + n) / i);
  }
  return A.amplitude = function(s) {
    return e(s, i * ar);
  }, A.period = function(s) {
    return e(t, s);
  }, A;
}(EC, BC);
(function e(t, i) {
  var n = Math.asin(1 / (t = Math.max(1, t))) * (i /= ar);
  function A(s) {
    return ((s = s * 2 - 1) < 0 ? t * Dg(-s) * Math.sin((n - s) / i) : 2 - t * Dg(s) * Math.sin((n + s) / i)) / 2;
  }
  return A.amplitude = function(s) {
    return e(s, i * ar);
  }, A.period = function(s) {
    return e(t, s);
  }, A;
})(EC, BC);
function DQ(e) {
  return function() {
    return e;
  };
}
function yU(e) {
  return e[0];
}
function DU(e) {
  return e[1];
}
function wg() {
  this._ = null;
}
function eu(e) {
  e.U = // parent node
  e.C = // color - true for red, false for black
  e.L = // left node
  e.R = // right node
  e.P = // previous node
  e.N = null;
}
wg.prototype = {
  constructor: wg,
  insert: function(e, t) {
    var i, n, A;
    if (e) {
      if (t.P = e, t.N = e.N, e.N && (e.N.P = t), e.N = t, e.R) {
        for (e = e.R; e.L; )
          e = e.L;
        e.L = t;
      } else
        e.R = t;
      i = e;
    } else
      this._ ? (e = wQ(this._), t.P = null, t.N = e, e.P = e.L = t, i = e) : (t.P = t.N = null, this._ = t, i = null);
    for (t.L = t.R = null, t.U = i, t.C = !0, e = t; i && i.C; )
      n = i.U, i === n.L ? (A = n.R, A && A.C ? (i.C = A.C = !1, n.C = !0, e = n) : (e === i.R && (zr(this, i), e = i, i = e.U), i.C = !1, n.C = !0, Zr(this, n))) : (A = n.L, A && A.C ? (i.C = A.C = !1, n.C = !0, e = n) : (e === i.L && (Zr(this, i), e = i, i = e.U), i.C = !1, n.C = !0, zr(this, n))), i = e.U;
    this._.C = !1;
  },
  remove: function(e) {
    e.N && (e.N.P = e.P), e.P && (e.P.N = e.N), e.N = e.P = null;
    var t = e.U, i, n = e.L, A = e.R, s, o;
    if (n ? A ? s = wQ(A) : s = n : s = A, t ? t.L === e ? t.L = s : t.R = s : this._ = s, n && A ? (o = s.C, s.C = e.C, s.L = n, n.U = s, s !== A ? (t = s.U, s.U = e.U, e = s.R, t.L = e, s.R = A, A.U = s) : (s.U = t, t = s, e = s.R)) : (o = e.C, e = s), e && (e.U = t), !o) {
      if (e && e.C) {
        e.C = !1;
        return;
      }
      do {
        if (e === this._)
          break;
        if (e === t.L) {
          if (i = t.R, i.C && (i.C = !1, t.C = !0, zr(this, t), i = t.R), i.L && i.L.C || i.R && i.R.C) {
            (!i.R || !i.R.C) && (i.L.C = !1, i.C = !0, Zr(this, i), i = t.R), i.C = t.C, t.C = i.R.C = !1, zr(this, t), e = this._;
            break;
          }
        } else if (i = t.L, i.C && (i.C = !1, t.C = !0, Zr(this, t), i = t.L), i.L && i.L.C || i.R && i.R.C) {
          (!i.L || !i.L.C) && (i.R.C = !1, i.C = !0, zr(this, i), i = t.L), i.C = t.C, t.C = i.L.C = !1, Zr(this, t), e = this._;
          break;
        }
        i.C = !0, e = t, t = t.U;
      } while (!e.C);
      e && (e.C = !1);
    }
  }
};
function zr(e, t) {
  var i = t, n = t.R, A = i.U;
  A ? A.L === i ? A.L = n : A.R = n : e._ = n, n.U = A, i.U = n, i.R = n.L, i.R && (i.R.U = i), n.L = i;
}
function Zr(e, t) {
  var i = t, n = t.L, A = i.U;
  A ? A.L === i ? A.L = n : A.R = n : e._ = n, n.U = A, i.U = n, i.L = n.R, i.L && (i.L.U = i), n.R = i;
}
function wQ(e) {
  for (; e.L; )
    e = e.L;
  return e;
}
function ha(e, t, i, n) {
  var A = [null, null], s = ke.push(A) - 1;
  return A.left = e, A.right = t, i && xg(A, e, t, i), n && xg(A, t, e, n), wi[e.index].halfedges.push(s), wi[t.index].halfedges.push(s), A;
}
function $r(e, t, i) {
  var n = [t, i];
  return n.left = e, n;
}
function xg(e, t, i, n) {
  !e[0] && !e[1] ? (e[0] = n, e.left = t, e.right = i) : e.left === i ? e[1] = n : e[0] = n;
}
function wU(e, t, i, n, A) {
  var s = e[0], o = e[1], r = s[0], a = s[1], l = o[0], c = o[1], g = 0, h = 1, u = l - r, d = c - a, f;
  if (f = t - r, !(!u && f > 0)) {
    if (f /= u, u < 0) {
      if (f < g)
        return;
      f < h && (h = f);
    } else if (u > 0) {
      if (f > h)
        return;
      f > g && (g = f);
    }
    if (f = n - r, !(!u && f < 0)) {
      if (f /= u, u < 0) {
        if (f > h)
          return;
        f > g && (g = f);
      } else if (u > 0) {
        if (f < g)
          return;
        f < h && (h = f);
      }
      if (f = i - a, !(!d && f > 0)) {
        if (f /= d, d < 0) {
          if (f < g)
            return;
          f < h && (h = f);
        } else if (d > 0) {
          if (f > h)
            return;
          f > g && (g = f);
        }
        if (f = A - a, !(!d && f < 0)) {
          if (f /= d, d < 0) {
            if (f > h)
              return;
            f > g && (g = f);
          } else if (d > 0) {
            if (f < g)
              return;
            f < h && (h = f);
          }
          return !(g > 0) && !(h < 1) || (g > 0 && (e[0] = [r + g * u, a + g * d]), h < 1 && (e[1] = [r + h * u, a + h * d])), !0;
        }
      }
    }
  }
}
function xU(e, t, i, n, A) {
  var s = e[1];
  if (s)
    return !0;
  var o = e[0], r = e.left, a = e.right, l = r[0], c = r[1], g = a[0], h = a[1], u = (l + g) / 2, d = (c + h) / 2, f, I;
  if (h === c) {
    if (u < t || u >= n)
      return;
    if (l > g) {
      if (!o)
        o = [u, i];
      else if (o[1] >= A)
        return;
      s = [u, A];
    } else {
      if (!o)
        o = [u, A];
      else if (o[1] < i)
        return;
      s = [u, i];
    }
  } else if (f = (l - g) / (h - c), I = d - f * u, f < -1 || f > 1)
    if (l > g) {
      if (!o)
        o = [(i - I) / f, i];
      else if (o[1] >= A)
        return;
      s = [(A - I) / f, A];
    } else {
      if (!o)
        o = [(A - I) / f, A];
      else if (o[1] < i)
        return;
      s = [(i - I) / f, i];
    }
  else if (c < h) {
    if (!o)
      o = [t, f * t + I];
    else if (o[0] >= n)
      return;
    s = [n, f * n + I];
  } else {
    if (!o)
      o = [n, f * n + I];
    else if (o[0] < t)
      return;
    s = [t, f * t + I];
  }
  return e[0] = o, e[1] = s, !0;
}
function SU(e, t, i, n) {
  for (var A = ke.length, s; A--; )
    (!xU(s = ke[A], e, t, i, n) || !wU(s, e, t, i, n) || !(Math.abs(s[0][0] - s[1][0]) > Tt || Math.abs(s[0][1] - s[1][1]) > Tt)) && delete ke[A];
}
function MU(e) {
  return wi[e.index] = {
    site: e,
    halfedges: []
  };
}
function _U(e, t) {
  var i = e.site, n = t.left, A = t.right;
  return i === A && (A = n, n = i), A ? Math.atan2(A[1] - n[1], A[0] - n[0]) : (i === n ? (n = t[1], A = t[0]) : (n = t[0], A = t[1]), Math.atan2(n[0] - A[0], A[1] - n[1]));
}
function _w(e, t) {
  return t[+(t.left !== e.site)];
}
function bU(e, t) {
  return t[+(t.left === e.site)];
}
function NU() {
  for (var e = 0, t = wi.length, i, n, A, s; e < t; ++e)
    if ((i = wi[e]) && (s = (n = i.halfedges).length)) {
      var o = new Array(s), r = new Array(s);
      for (A = 0; A < s; ++A)
        o[A] = A, r[A] = _U(i, ke[n[A]]);
      for (o.sort(function(a, l) {
        return r[l] - r[a];
      }), A = 0; A < s; ++A)
        r[A] = n[o[A]];
      for (A = 0; A < s; ++A)
        n[A] = r[A];
    }
}
function FU(e, t, i, n) {
  var A = wi.length, s, o, r, a, l, c, g, h, u, d, f, I, C = !0;
  for (s = 0; s < A; ++s)
    if (o = wi[s]) {
      for (r = o.site, l = o.halfedges, a = l.length; a--; )
        ke[l[a]] || l.splice(a, 1);
      for (a = 0, c = l.length; a < c; )
        d = bU(o, ke[l[a]]), f = d[0], I = d[1], g = _w(o, ke[l[++a % c]]), h = g[0], u = g[1], (Math.abs(f - h) > Tt || Math.abs(I - u) > Tt) && (l.splice(a, 0, ke.push($r(
          r,
          d,
          Math.abs(f - e) < Tt && n - I > Tt ? [e, Math.abs(h - e) < Tt ? u : n] : Math.abs(I - n) < Tt && i - f > Tt ? [Math.abs(u - n) < Tt ? h : i, n] : Math.abs(f - i) < Tt && I - t > Tt ? [i, Math.abs(h - i) < Tt ? u : t] : Math.abs(I - t) < Tt && f - e > Tt ? [Math.abs(u - t) < Tt ? h : e, t] : null
        )) - 1), ++c);
      c && (C = !1);
    }
  if (C) {
    var E, B, m, y = 1 / 0;
    for (s = 0, C = null; s < A; ++s)
      (o = wi[s]) && (r = o.site, E = r[0] - e, B = r[1] - t, m = E * E + B * B, m < y && (y = m, C = o));
    if (C) {
      var D = [e, t], Q = [e, n], p = [i, n], w = [i, t];
      C.halfedges.push(
        ke.push($r(r = C.site, D, Q)) - 1,
        ke.push($r(r, Q, p)) - 1,
        ke.push($r(r, p, w)) - 1,
        ke.push($r(r, w, D)) - 1
      );
    }
  }
  for (s = 0; s < A; ++s)
    (o = wi[s]) && (o.halfedges.length || delete wi[s]);
}
var bw = [], mC;
function RU() {
  eu(this), this.x = this.y = this.arc = this.site = this.cy = null;
}
function wo(e) {
  var t = e.P, i = e.N;
  if (!(!t || !i)) {
    var n = t.site, A = e.site, s = i.site;
    if (n !== s) {
      var o = A[0], r = A[1], a = n[0] - o, l = n[1] - r, c = s[0] - o, g = s[1] - r, h = 2 * (a * g - l * c);
      if (!(h >= -LU)) {
        var u = a * a + l * l, d = c * c + g * g, f = (g * u - l * d) / h, I = (a * d - c * u) / h, C = bw.pop() || new RU();
        C.arc = e, C.site = A, C.x = f + o, C.y = (C.cy = I + r) + Math.sqrt(f * f + I * I), e.circle = C;
        for (var E = null, B = Ya._; B; )
          if (C.y < B.y || C.y === B.y && C.x <= B.x)
            if (B.L)
              B = B.L;
            else {
              E = B.P;
              break;
            }
          else if (B.R)
            B = B.R;
          else {
            E = B;
            break;
          }
        Ya.insert(E, C), E || (mC = C);
      }
    }
  }
}
function Go(e) {
  var t = e.circle;
  t && (t.P || (mC = t.N), Ya.remove(t), bw.push(t), eu(t), e.circle = null);
}
var Nw = [];
function kU() {
  eu(this), this.edge = this.site = this.circle = null;
}
function xQ(e) {
  var t = Nw.pop() || new kU();
  return t.site = e, t;
}
function Id(e) {
  Go(e), Lo.remove(e), Nw.push(e), eu(e);
}
function TU(e) {
  var t = e.circle, i = t.x, n = t.cy, A = [i, n], s = e.P, o = e.N, r = [e];
  Id(e);
  for (var a = s; a.circle && Math.abs(i - a.circle.x) < Tt && Math.abs(n - a.circle.cy) < Tt; )
    s = a.P, r.unshift(a), Id(a), a = s;
  r.unshift(a), Go(a);
  for (var l = o; l.circle && Math.abs(i - l.circle.x) < Tt && Math.abs(n - l.circle.cy) < Tt; )
    o = l.N, r.push(l), Id(l), l = o;
  r.push(l), Go(l);
  var c = r.length, g;
  for (g = 1; g < c; ++g)
    l = r[g], a = r[g - 1], xg(l.edge, a.site, l.site, A);
  a = r[0], l = r[c - 1], l.edge = ha(a.site, l.site, null, A), wo(a), wo(l);
}
function vU(e) {
  for (var t = e[0], i = e[1], n, A, s, o, r = Lo._; r; )
    if (s = Fw(r, i) - t, s > Tt)
      r = r.L;
    else if (o = t - GU(r, i), o > Tt) {
      if (!r.R) {
        n = r;
        break;
      }
      r = r.R;
    } else {
      s > -Tt ? (n = r.P, A = r) : o > -Tt ? (n = r, A = r.N) : n = A = r;
      break;
    }
  MU(e);
  var a = xQ(e);
  if (Lo.insert(n, a), !(!n && !A)) {
    if (n === A) {
      Go(n), A = xQ(n.site), Lo.insert(a, A), a.edge = A.edge = ha(n.site, a.site), wo(n), wo(A);
      return;
    }
    if (!A) {
      a.edge = ha(n.site, a.site);
      return;
    }
    Go(n), Go(A);
    var l = n.site, c = l[0], g = l[1], h = e[0] - c, u = e[1] - g, d = A.site, f = d[0] - c, I = d[1] - g, C = 2 * (h * I - u * f), E = h * h + u * u, B = f * f + I * I, m = [(I * E - u * B) / C + c, (h * B - f * E) / C + g];
    xg(A.edge, l, d, m), a.edge = ha(l, e, null, m), A.edge = ha(e, d, null, m), wo(n), wo(A);
  }
}
function Fw(e, t) {
  var i = e.site, n = i[0], A = i[1], s = A - t;
  if (!s)
    return n;
  var o = e.P;
  if (!o)
    return -1 / 0;
  i = o.site;
  var r = i[0], a = i[1], l = a - t;
  if (!l)
    return r;
  var c = r - n, g = 1 / s - 1 / l, h = c / l;
  return g ? (-h + Math.sqrt(h * h - 2 * g * (c * c / (-2 * l) - a + l / 2 + A - s / 2))) / g + n : (n + r) / 2;
}
function GU(e, t) {
  var i = e.N;
  if (i)
    return Fw(i, t);
  var n = e.site;
  return n[1] === t ? n[0] : 1 / 0;
}
var Tt = 1e-6, LU = 1e-12, Lo, wi, Ya, ke;
function UU(e, t, i) {
  return (e[0] - i[0]) * (t[1] - e[1]) - (e[0] - t[0]) * (i[1] - e[1]);
}
function OU(e, t) {
  return t[1] - e[1] || t[0] - e[0];
}
function df(e, t) {
  var i = e.sort(OU).pop(), n, A, s;
  for (ke = [], wi = new Array(e.length), Lo = new wg(), Ya = new wg(); ; )
    if (s = mC, i && (!s || i[1] < s.y || i[1] === s.y && i[0] < s.x))
      (i[0] !== n || i[1] !== A) && (vU(i), n = i[0], A = i[1]), i = e.pop();
    else if (s)
      TU(s.arc);
    else
      break;
  if (NU(), t) {
    var o = +t[0][0], r = +t[0][1], a = +t[1][0], l = +t[1][1];
    SU(o, r, a, l), FU(o, r, a, l);
  }
  this.edges = ke, this.cells = wi, Lo = Ya = ke = wi = null;
}
df.prototype = {
  constructor: df,
  polygons: function() {
    var e = this.edges;
    return this.cells.map(function(t) {
      var i = t.halfedges.map(function(n) {
        return _w(t, e[n]);
      });
      return i.data = t.site.data, i;
    });
  },
  triangles: function() {
    var e = [], t = this.edges;
    return this.cells.forEach(function(i, n) {
      if (r = (s = i.halfedges).length)
        for (var A = i.site, s, o = -1, r, a, l = t[s[r - 1]], c = l.left === A ? l.right : l.left; ++o < r; )
          a = c, l = t[s[o]], c = l.left === A ? l.right : l.left, a && c && n < a.index && n < c.index && UU(A, a, c) < 0 && e.push([A.data, a.data, c.data]);
    }), e;
  },
  links: function() {
    return this.edges.filter(function(e) {
      return e.right;
    }).map(function(e) {
      return {
        source: e.left.data,
        target: e.right.data
      };
    });
  },
  find: function(e, t, i) {
    for (var n = this, A, s = n._found || 0, o = n.cells.length, r; !(r = n.cells[s]); )
      if (++s >= o)
        return null;
    var a = e - r.site[0], l = t - r.site[1], c = a * a + l * l;
    do
      r = n.cells[A = s], s = null, r.halfedges.forEach(function(g) {
        var h = n.edges[g], u = h.left;
        if (!((u === r.site || !u) && !(u = h.right))) {
          var d = e - u[0], f = t - u[1], I = d * d + f * f;
          I < c && (c = I, s = u.index);
        }
      });
    while (s !== null);
    return n._found = A, i == null || c <= i * i ? r.site : null;
  }
};
function HU() {
  var e = yU, t = DU, i = null;
  function n(A) {
    return new df(A.map(function(s, o) {
      var r = [Math.round(e(s, o, A) / Tt) * Tt, Math.round(t(s, o, A) / Tt) * Tt];
      return r.index = o, r.data = s, r;
    }), i);
  }
  return n.polygons = function(A) {
    return n(A).polygons();
  }, n.links = function(A) {
    return n(A).links();
  }, n.triangles = function(A) {
    return n(A).triangles();
  }, n.x = function(A) {
    return arguments.length ? (e = typeof A == "function" ? A : DQ(+A), n) : e;
  }, n.y = function(A) {
    return arguments.length ? (t = typeof A == "function" ? A : DQ(+A), n) : t;
  }, n.extent = function(A) {
    return arguments.length ? (i = A == null ? null : [[+A[0][0], +A[0][1]], [+A[1][0], +A[1][1]]], n) : i && [[i[0][0], i[0][1]], [i[1][0], i[1][1]]];
  }, n.size = function(A) {
    return arguments.length ? (i = A == null ? null : [[0, 0], [+A[0], +A[1]]], n) : i && [i[1][0] - i[0][0], i[1][1] - i[0][1]];
  }, n;
}
class PU extends Map {
  constructor(t, i = Tw) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: i } }), t != null)
      for (const [n, A] of t)
        this.set(n, A);
  }
  get(t) {
    return super.get(ff(this, t));
  }
  has(t) {
    return super.has(ff(this, t));
  }
  set(t, i) {
    return super.set(Rw(this, t), i);
  }
  delete(t) {
    return super.delete(kw(this, t));
  }
}
class YU extends Set {
  constructor(t, i = Tw) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: i } }), t != null)
      for (const n of t)
        this.add(n);
  }
  has(t) {
    return super.has(ff(this, t));
  }
  add(t) {
    return super.add(Rw(this, t));
  }
  delete(t) {
    return super.delete(kw(this, t));
  }
}
function ff({ _intern: e, _key: t }, i) {
  const n = t(i);
  return e.has(n) ? e.get(n) : i;
}
function Rw({ _intern: e, _key: t }, i) {
  const n = t(i);
  return e.has(n) ? e.get(n) : (e.set(n, i), i);
}
function kw({ _intern: e, _key: t }, i) {
  const n = t(i);
  return e.has(n) && (i = e.get(n), e.delete(n)), i;
}
function Tw(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function SQ(e) {
  return e;
}
function Uo(e, ...t) {
  return JU(e, SQ, SQ, t);
}
function JU(e, t, i, n) {
  return function A(s, o) {
    if (o >= n.length)
      return i(s);
    const r = new PU(), a = n[o++];
    let l = -1;
    for (const c of s) {
      const g = a(c, ++l, s), h = r.get(g);
      h ? h.push(c) : r.set(g, [c]);
    }
    for (const [c, g] of r)
      r.set(c, A(g, o));
    return t(r);
  }(e, 0);
}
function Ye(e, t) {
  let i;
  if (t === void 0)
    for (const n of e)
      n != null && (i < n || i === void 0 && n >= n) && (i = n);
  else {
    let n = -1;
    for (let A of e)
      (A = t(A, ++n, e)) != null && (i < A || i === void 0 && A >= A) && (i = A);
  }
  return i;
}
function vw(e, t) {
  let i;
  if (t === void 0)
    for (const n of e)
      n != null && (i > n || i === void 0 && n >= n) && (i = n);
  else {
    let n = -1;
    for (let A of e)
      (A = t(A, ++n, e)) != null && (i > A || i === void 0 && A >= A) && (i = A);
  }
  return i;
}
function Oo(e, t, i) {
  e = +e, t = +t, i = (A = arguments.length) < 2 ? (t = e, e = 0, 1) : A < 3 ? 1 : +i;
  for (var n = -1, A = Math.max(0, Math.ceil((t - e) / i)) | 0, s = new Array(A); ++n < A; )
    s[n] = e + n * i;
  return s;
}
function Te(e, t) {
  let i = 0;
  if (t === void 0)
    for (let n of e)
      (n = +n) && (i += n);
  else {
    let n = -1;
    for (let A of e)
      (A = +t(A, ++n, e)) && (i += A);
  }
  return i;
}
function ae(e) {
  if (!(s = e.length))
    return [];
  for (var t = -1, i = vw(e, KU), n = new Array(i); ++t < i; )
    for (var A = -1, s, o = n[t] = new Array(s); ++A < s; )
      o[A] = e[A][t];
  return n;
}
function KU(e) {
  return e.length;
}
function If() {
  return ae(arguments);
}
function lr(e, ...t) {
  e = new YU(e);
  for (const i of t)
    for (const n of i)
      e.delete(n);
  return e;
}
const Cf = Math.PI, Ef = 2 * Cf, XA = 1e-6, WU = Ef - XA;
function Bf() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function Gw() {
  return new Bf();
}
Bf.prototype = Gw.prototype = {
  constructor: Bf,
  moveTo: function(e, t) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(e, t) {
    this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +t);
  },
  quadraticCurveTo: function(e, t, i, n) {
    this._ += "Q" + +e + "," + +t + "," + (this._x1 = +i) + "," + (this._y1 = +n);
  },
  bezierCurveTo: function(e, t, i, n, A, s) {
    this._ += "C" + +e + "," + +t + "," + +i + "," + +n + "," + (this._x1 = +A) + "," + (this._y1 = +s);
  },
  arcTo: function(e, t, i, n, A) {
    e = +e, t = +t, i = +i, n = +n, A = +A;
    var s = this._x1, o = this._y1, r = i - e, a = n - t, l = s - e, c = o - t, g = l * l + c * c;
    if (A < 0)
      throw new Error("negative radius: " + A);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = e) + "," + (this._y1 = t);
    else if (g > XA)
      if (!(Math.abs(c * r - a * l) > XA) || !A)
        this._ += "L" + (this._x1 = e) + "," + (this._y1 = t);
      else {
        var h = i - s, u = n - o, d = r * r + a * a, f = h * h + u * u, I = Math.sqrt(d), C = Math.sqrt(g), E = A * Math.tan((Cf - Math.acos((d + g - f) / (2 * I * C))) / 2), B = E / C, m = E / I;
        Math.abs(B - 1) > XA && (this._ += "L" + (e + B * l) + "," + (t + B * c)), this._ += "A" + A + "," + A + ",0,0," + +(c * h > l * u) + "," + (this._x1 = e + m * r) + "," + (this._y1 = t + m * a);
      }
  },
  arc: function(e, t, i, n, A, s) {
    e = +e, t = +t, i = +i, s = !!s;
    var o = i * Math.cos(n), r = i * Math.sin(n), a = e + o, l = t + r, c = 1 ^ s, g = s ? n - A : A - n;
    if (i < 0)
      throw new Error("negative radius: " + i);
    this._x1 === null ? this._ += "M" + a + "," + l : (Math.abs(this._x1 - a) > XA || Math.abs(this._y1 - l) > XA) && (this._ += "L" + a + "," + l), i && (g < 0 && (g = g % Ef + Ef), g > WU ? this._ += "A" + i + "," + i + ",0,1," + c + "," + (e - o) + "," + (t - r) + "A" + i + "," + i + ",0,1," + c + "," + (this._x1 = a) + "," + (this._y1 = l) : g > XA && (this._ += "A" + i + "," + i + ",0," + +(g >= Cf) + "," + c + "," + (this._x1 = e + i * Math.cos(A)) + "," + (this._y1 = t + i * Math.sin(A))));
  },
  rect: function(e, t, i, n) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t) + "h" + +i + "v" + +n + "h" + -i + "Z";
  },
  toString: function() {
    return this._;
  }
};
const jn = 11102230246251565e-32, Fe = 134217729, VU = (3 + 8 * jn) * jn;
function Cd(e, t, i, n, A) {
  let s, o, r, a, l = t[0], c = n[0], g = 0, h = 0;
  c > l == c > -l ? (s = l, l = t[++g]) : (s = c, c = n[++h]);
  let u = 0;
  if (g < e && h < i)
    for (c > l == c > -l ? (o = l + s, r = s - (o - l), l = t[++g]) : (o = c + s, r = s - (o - c), c = n[++h]), s = o, r !== 0 && (A[u++] = r); g < e && h < i; )
      c > l == c > -l ? (o = s + l, a = o - s, r = s - (o - a) + (l - a), l = t[++g]) : (o = s + c, a = o - s, r = s - (o - a) + (c - a), c = n[++h]), s = o, r !== 0 && (A[u++] = r);
  for (; g < e; )
    o = s + l, a = o - s, r = s - (o - a) + (l - a), l = t[++g], s = o, r !== 0 && (A[u++] = r);
  for (; h < i; )
    o = s + c, a = o - s, r = s - (o - a) + (c - a), c = n[++h], s = o, r !== 0 && (A[u++] = r);
  return (s !== 0 || u === 0) && (A[u++] = s), u;
}
function jU(e, t) {
  let i = t[0];
  for (let n = 1; n < e; n++)
    i += t[n];
  return i;
}
function Il(e) {
  return new Float64Array(e);
}
const qU = (3 + 16 * jn) * jn, zU = (2 + 12 * jn) * jn, ZU = (9 + 64 * jn) * jn * jn, ao = Il(4), MQ = Il(8), _Q = Il(12), bQ = Il(16), Pe = Il(4);
function $U(e, t, i, n, A, s, o) {
  let r, a, l, c, g, h, u, d, f, I, C, E, B, m, y, D, Q, p;
  const w = e - A, x = i - A, S = t - s, _ = n - s;
  m = w * _, h = Fe * w, u = h - (h - w), d = w - u, h = Fe * _, f = h - (h - _), I = _ - f, y = d * I - (m - u * f - d * f - u * I), D = S * x, h = Fe * S, u = h - (h - S), d = S - u, h = Fe * x, f = h - (h - x), I = x - f, Q = d * I - (D - u * f - d * f - u * I), C = y - Q, g = y - C, ao[0] = y - (C + g) + (g - Q), E = m + C, g = E - m, B = m - (E - g) + (C - g), C = B - D, g = B - C, ao[1] = B - (C + g) + (g - D), p = E + C, g = p - E, ao[2] = E - (p - g) + (C - g), ao[3] = p;
  let M = jU(4, ao), k = zU * o;
  if (M >= k || -M >= k || (g = e - w, r = e - (w + g) + (g - A), g = i - x, l = i - (x + g) + (g - A), g = t - S, a = t - (S + g) + (g - s), g = n - _, c = n - (_ + g) + (g - s), r === 0 && a === 0 && l === 0 && c === 0) || (k = ZU * o + VU * Math.abs(M), M += w * c + _ * r - (S * l + x * a), M >= k || -M >= k))
    return M;
  m = r * _, h = Fe * r, u = h - (h - r), d = r - u, h = Fe * _, f = h - (h - _), I = _ - f, y = d * I - (m - u * f - d * f - u * I), D = a * x, h = Fe * a, u = h - (h - a), d = a - u, h = Fe * x, f = h - (h - x), I = x - f, Q = d * I - (D - u * f - d * f - u * I), C = y - Q, g = y - C, Pe[0] = y - (C + g) + (g - Q), E = m + C, g = E - m, B = m - (E - g) + (C - g), C = B - D, g = B - C, Pe[1] = B - (C + g) + (g - D), p = E + C, g = p - E, Pe[2] = E - (p - g) + (C - g), Pe[3] = p;
  const T = Cd(4, ao, 4, Pe, MQ);
  m = w * c, h = Fe * w, u = h - (h - w), d = w - u, h = Fe * c, f = h - (h - c), I = c - f, y = d * I - (m - u * f - d * f - u * I), D = S * l, h = Fe * S, u = h - (h - S), d = S - u, h = Fe * l, f = h - (h - l), I = l - f, Q = d * I - (D - u * f - d * f - u * I), C = y - Q, g = y - C, Pe[0] = y - (C + g) + (g - Q), E = m + C, g = E - m, B = m - (E - g) + (C - g), C = B - D, g = B - C, Pe[1] = B - (C + g) + (g - D), p = E + C, g = p - E, Pe[2] = E - (p - g) + (C - g), Pe[3] = p;
  const G = Cd(T, MQ, 4, Pe, _Q);
  m = r * c, h = Fe * r, u = h - (h - r), d = r - u, h = Fe * c, f = h - (h - c), I = c - f, y = d * I - (m - u * f - d * f - u * I), D = a * l, h = Fe * a, u = h - (h - a), d = a - u, h = Fe * l, f = h - (h - l), I = l - f, Q = d * I - (D - u * f - d * f - u * I), C = y - Q, g = y - C, Pe[0] = y - (C + g) + (g - Q), E = m + C, g = E - m, B = m - (E - g) + (C - g), C = B - D, g = B - C, Pe[1] = B - (C + g) + (g - D), p = E + C, g = p - E, Pe[2] = E - (p - g) + (C - g), Pe[3] = p;
  const N = Cd(G, _Q, 4, Pe, bQ);
  return bQ[N - 1];
}
function oc(e, t, i, n, A, s) {
  const o = (t - s) * (i - A), r = (e - A) * (n - s), a = o - r, l = Math.abs(o + r);
  return Math.abs(a) >= qU * l ? a : -$U(e, t, i, n, A, s, l);
}
const NQ = Math.pow(2, -52), rc = new Uint32Array(512);
class Sg {
  static from(t, i = nO, n = AO) {
    const A = t.length, s = new Float64Array(A * 2);
    for (let o = 0; o < A; o++) {
      const r = t[o];
      s[2 * o] = i(r), s[2 * o + 1] = n(r);
    }
    return new Sg(s);
  }
  constructor(t) {
    const i = t.length >> 1;
    if (i > 0 && typeof t[0] != "number")
      throw new Error("Expected coords to contain numbers.");
    this.coords = t;
    const n = Math.max(2 * i - 5, 0);
    this._triangles = new Uint32Array(n * 3), this._halfedges = new Int32Array(n * 3), this._hashSize = Math.ceil(Math.sqrt(i)), this._hullPrev = new Uint32Array(i), this._hullNext = new Uint32Array(i), this._hullTri = new Uint32Array(i), this._hullHash = new Int32Array(this._hashSize), this._ids = new Uint32Array(i), this._dists = new Float64Array(i), this.update();
  }
  update() {
    const { coords: t, _hullPrev: i, _hullNext: n, _hullTri: A, _hullHash: s } = this, o = t.length >> 1;
    let r = 1 / 0, a = 1 / 0, l = -1 / 0, c = -1 / 0;
    for (let w = 0; w < o; w++) {
      const x = t[2 * w], S = t[2 * w + 1];
      x < r && (r = x), S < a && (a = S), x > l && (l = x), S > c && (c = S), this._ids[w] = w;
    }
    const g = (r + l) / 2, h = (a + c) / 2;
    let u, d, f;
    for (let w = 0, x = 1 / 0; w < o; w++) {
      const S = Ed(g, h, t[2 * w], t[2 * w + 1]);
      S < x && (u = w, x = S);
    }
    const I = t[2 * u], C = t[2 * u + 1];
    for (let w = 0, x = 1 / 0; w < o; w++) {
      if (w === u)
        continue;
      const S = Ed(I, C, t[2 * w], t[2 * w + 1]);
      S < x && S > 0 && (d = w, x = S);
    }
    let E = t[2 * d], B = t[2 * d + 1], m = 1 / 0;
    for (let w = 0; w < o; w++) {
      if (w === u || w === d)
        continue;
      const x = eO(I, C, E, B, t[2 * w], t[2 * w + 1]);
      x < m && (f = w, m = x);
    }
    let y = t[2 * f], D = t[2 * f + 1];
    if (m === 1 / 0) {
      for (let S = 0; S < o; S++)
        this._dists[S] = t[2 * S] - t[0] || t[2 * S + 1] - t[1];
      xo(this._ids, this._dists, 0, o - 1);
      const w = new Uint32Array(o);
      let x = 0;
      for (let S = 0, _ = -1 / 0; S < o; S++) {
        const M = this._ids[S], k = this._dists[M];
        k > _ && (w[x++] = M, _ = k);
      }
      this.hull = w.subarray(0, x), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (oc(I, C, E, B, y, D) < 0) {
      const w = d, x = E, S = B;
      d = f, E = y, B = D, f = w, y = x, D = S;
    }
    const Q = iO(I, C, E, B, y, D);
    this._cx = Q.x, this._cy = Q.y;
    for (let w = 0; w < o; w++)
      this._dists[w] = Ed(t[2 * w], t[2 * w + 1], Q.x, Q.y);
    xo(this._ids, this._dists, 0, o - 1), this._hullStart = u;
    let p = 3;
    n[u] = i[f] = d, n[d] = i[u] = f, n[f] = i[d] = u, A[u] = 0, A[d] = 1, A[f] = 2, s.fill(-1), s[this._hashKey(I, C)] = u, s[this._hashKey(E, B)] = d, s[this._hashKey(y, D)] = f, this.trianglesLen = 0, this._addTriangle(u, d, f, -1, -1, -1);
    for (let w = 0, x, S; w < this._ids.length; w++) {
      const _ = this._ids[w], M = t[2 * _], k = t[2 * _ + 1];
      if (w > 0 && Math.abs(M - x) <= NQ && Math.abs(k - S) <= NQ || (x = M, S = k, _ === u || _ === d || _ === f))
        continue;
      let T = 0;
      for (let R = 0, v = this._hashKey(M, k); R < this._hashSize && (T = s[(v + R) % this._hashSize], !(T !== -1 && T !== n[T])); R++)
        ;
      T = i[T];
      let G = T, N;
      for (; N = n[G], oc(M, k, t[2 * G], t[2 * G + 1], t[2 * N], t[2 * N + 1]) >= 0; )
        if (G = N, G === T) {
          G = -1;
          break;
        }
      if (G === -1)
        continue;
      let b = this._addTriangle(G, _, n[G], -1, -1, A[G]);
      A[_] = this._legalize(b + 2), A[G] = b, p++;
      let F = n[G];
      for (; N = n[F], oc(M, k, t[2 * F], t[2 * F + 1], t[2 * N], t[2 * N + 1]) < 0; )
        b = this._addTriangle(F, _, N, A[_], -1, A[F]), A[_] = this._legalize(b + 2), n[F] = F, p--, F = N;
      if (G === T)
        for (; N = i[G], oc(M, k, t[2 * N], t[2 * N + 1], t[2 * G], t[2 * G + 1]) < 0; )
          b = this._addTriangle(N, _, G, -1, A[G], A[N]), this._legalize(b + 2), A[N] = b, n[G] = G, p--, G = N;
      this._hullStart = i[_] = G, n[G] = i[F] = _, n[_] = F, s[this._hashKey(M, k)] = _, s[this._hashKey(t[2 * G], t[2 * G + 1])] = G;
    }
    this.hull = new Uint32Array(p);
    for (let w = 0, x = this._hullStart; w < p; w++)
      this.hull[w] = x, x = n[x];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(t, i) {
    return Math.floor(XU(t - this._cx, i - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(t) {
    const { _triangles: i, _halfedges: n, coords: A } = this;
    let s = 0, o = 0;
    for (; ; ) {
      const r = n[t], a = t - t % 3;
      if (o = a + (t + 2) % 3, r === -1) {
        if (s === 0)
          break;
        t = rc[--s];
        continue;
      }
      const l = r - r % 3, c = a + (t + 1) % 3, g = l + (r + 2) % 3, h = i[o], u = i[t], d = i[c], f = i[g];
      if (tO(
        A[2 * h],
        A[2 * h + 1],
        A[2 * u],
        A[2 * u + 1],
        A[2 * d],
        A[2 * d + 1],
        A[2 * f],
        A[2 * f + 1]
      )) {
        i[t] = f, i[r] = h;
        const C = n[g];
        if (C === -1) {
          let B = this._hullStart;
          do {
            if (this._hullTri[B] === g) {
              this._hullTri[B] = t;
              break;
            }
            B = this._hullPrev[B];
          } while (B !== this._hullStart);
        }
        this._link(t, C), this._link(r, n[o]), this._link(o, g);
        const E = l + (r + 1) % 3;
        s < rc.length && (rc[s++] = E);
      } else {
        if (s === 0)
          break;
        t = rc[--s];
      }
    }
    return o;
  }
  _link(t, i) {
    this._halfedges[t] = i, i !== -1 && (this._halfedges[i] = t);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(t, i, n, A, s, o) {
    const r = this.trianglesLen;
    return this._triangles[r] = t, this._triangles[r + 1] = i, this._triangles[r + 2] = n, this._link(r, A), this._link(r + 1, s), this._link(r + 2, o), this.trianglesLen += 3, r;
  }
}
function XU(e, t) {
  const i = e / (Math.abs(e) + Math.abs(t));
  return (t > 0 ? 3 - i : 1 + i) / 4;
}
function Ed(e, t, i, n) {
  const A = e - i, s = t - n;
  return A * A + s * s;
}
function tO(e, t, i, n, A, s, o, r) {
  const a = e - o, l = t - r, c = i - o, g = n - r, h = A - o, u = s - r, d = a * a + l * l, f = c * c + g * g, I = h * h + u * u;
  return a * (g * I - f * u) - l * (c * I - f * h) + d * (c * u - g * h) < 0;
}
function eO(e, t, i, n, A, s) {
  const o = i - e, r = n - t, a = A - e, l = s - t, c = o * o + r * r, g = a * a + l * l, h = 0.5 / (o * l - r * a), u = (l * c - r * g) * h, d = (o * g - a * c) * h;
  return u * u + d * d;
}
function iO(e, t, i, n, A, s) {
  const o = i - e, r = n - t, a = A - e, l = s - t, c = o * o + r * r, g = a * a + l * l, h = 0.5 / (o * l - r * a), u = e + (l * c - r * g) * h, d = t + (o * g - a * c) * h;
  return { x: u, y: d };
}
function xo(e, t, i, n) {
  if (n - i <= 20)
    for (let A = i + 1; A <= n; A++) {
      const s = e[A], o = t[s];
      let r = A - 1;
      for (; r >= i && t[e[r]] > o; )
        e[r + 1] = e[r--];
      e[r + 1] = s;
    }
  else {
    const A = i + n >> 1;
    let s = i + 1, o = n;
    Xr(e, A, s), t[e[i]] > t[e[n]] && Xr(e, i, n), t[e[s]] > t[e[n]] && Xr(e, s, n), t[e[i]] > t[e[s]] && Xr(e, i, s);
    const r = e[s], a = t[r];
    for (; ; ) {
      do
        s++;
      while (t[e[s]] < a);
      do
        o--;
      while (t[e[o]] > a);
      if (o < s)
        break;
      Xr(e, s, o);
    }
    e[i + 1] = e[o], e[o] = r, n - s + 1 >= o - i ? (xo(e, t, s, n), xo(e, t, i, o - 1)) : (xo(e, t, i, o - 1), xo(e, t, s, n));
  }
}
function Xr(e, t, i) {
  const n = e[t];
  e[t] = e[i], e[i] = n;
}
function nO(e) {
  return e[0];
}
function AO(e) {
  return e[1];
}
const FQ = 1e-6;
let as = class {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(t, i) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +i}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(t, i) {
    this._ += `L${this._x1 = +t},${this._y1 = +i}`;
  }
  arc(t, i, n) {
    t = +t, i = +i, n = +n;
    const A = t + n, s = i;
    if (n < 0)
      throw new Error("negative radius");
    this._x1 === null ? this._ += `M${A},${s}` : (Math.abs(this._x1 - A) > FQ || Math.abs(this._y1 - s) > FQ) && (this._ += "L" + A + "," + s), n && (this._ += `A${n},${n},0,1,1,${t - n},${i}A${n},${n},0,1,1,${this._x1 = A},${this._y1 = s}`);
  }
  rect(t, i, n, A) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +i}h${+n}v${+A}h${-n}Z`;
  }
  value() {
    return this._ || null;
  }
};
class mf {
  constructor() {
    this._ = [];
  }
  moveTo(t, i) {
    this._.push([t, i]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(t, i) {
    this._.push([t, i]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
let sO = class {
  constructor(t, [i, n, A, s] = [0, 0, 960, 500]) {
    if (!((A = +A) >= (i = +i)) || !((s = +s) >= (n = +n)))
      throw new Error("invalid bounds");
    this.delaunay = t, this._circumcenters = new Float64Array(t.points.length * 2), this.vectors = new Float64Array(t.points.length * 2), this.xmax = A, this.xmin = i, this.ymax = s, this.ymin = n, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: t, hull: i, triangles: n }, vectors: A } = this;
    let s, o;
    const r = this.circumcenters = this._circumcenters.subarray(0, n.length / 3 * 2);
    for (let f = 0, I = 0, C = n.length, E, B; f < C; f += 3, I += 2) {
      const m = n[f] * 2, y = n[f + 1] * 2, D = n[f + 2] * 2, Q = t[m], p = t[m + 1], w = t[y], x = t[y + 1], S = t[D], _ = t[D + 1], M = w - Q, k = x - p, T = S - Q, G = _ - p, N = (M * G - k * T) * 2;
      if (Math.abs(N) < 1e-9) {
        if (s === void 0) {
          s = o = 0;
          for (const F of i)
            s += t[F * 2], o += t[F * 2 + 1];
          s /= i.length, o /= i.length;
        }
        const b = 1e9 * Math.sign((s - Q) * G - (o - p) * T);
        E = (Q + S) / 2 - b * G, B = (p + _) / 2 + b * T;
      } else {
        const b = 1 / N, F = M * M + k * k, R = T * T + G * G;
        E = Q + (G * F - k * R) * b, B = p + (M * R - T * F) * b;
      }
      r[I] = E, r[I + 1] = B;
    }
    let a = i[i.length - 1], l, c = a * 4, g, h = t[2 * a], u, d = t[2 * a + 1];
    A.fill(0);
    for (let f = 0; f < i.length; ++f)
      a = i[f], l = c, g = h, u = d, c = a * 4, h = t[2 * a], d = t[2 * a + 1], A[l + 2] = A[c] = u - d, A[l + 3] = A[c + 1] = h - g;
  }
  render(t) {
    const i = t == null ? t = new as() : void 0, { delaunay: { halfedges: n, inedges: A, hull: s }, circumcenters: o, vectors: r } = this;
    if (s.length <= 1)
      return null;
    for (let c = 0, g = n.length; c < g; ++c) {
      const h = n[c];
      if (h < c)
        continue;
      const u = Math.floor(c / 3) * 2, d = Math.floor(h / 3) * 2, f = o[u], I = o[u + 1], C = o[d], E = o[d + 1];
      this._renderSegment(f, I, C, E, t);
    }
    let a, l = s[s.length - 1];
    for (let c = 0; c < s.length; ++c) {
      a = l, l = s[c];
      const g = Math.floor(A[l] / 3) * 2, h = o[g], u = o[g + 1], d = a * 4, f = this._project(h, u, r[d + 2], r[d + 3]);
      f && this._renderSegment(h, u, f[0], f[1], t);
    }
    return i && i.value();
  }
  renderBounds(t) {
    const i = t == null ? t = new as() : void 0;
    return t.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), i && i.value();
  }
  renderCell(t, i) {
    const n = i == null ? i = new as() : void 0, A = this._clip(t);
    if (A === null || !A.length)
      return;
    i.moveTo(A[0], A[1]);
    let s = A.length;
    for (; A[0] === A[s - 2] && A[1] === A[s - 1] && s > 1; )
      s -= 2;
    for (let o = 2; o < s; o += 2)
      (A[o] !== A[o - 2] || A[o + 1] !== A[o - 1]) && i.lineTo(A[o], A[o + 1]);
    return i.closePath(), n && n.value();
  }
  *cellPolygons() {
    const { delaunay: { points: t } } = this;
    for (let i = 0, n = t.length / 2; i < n; ++i) {
      const A = this.cellPolygon(i);
      A && (A.index = i, yield A);
    }
  }
  cellPolygon(t) {
    const i = new mf();
    return this.renderCell(t, i), i.value();
  }
  _renderSegment(t, i, n, A, s) {
    let o;
    const r = this._regioncode(t, i), a = this._regioncode(n, A);
    r === 0 && a === 0 ? (s.moveTo(t, i), s.lineTo(n, A)) : (o = this._clipSegment(t, i, n, A, r, a)) && (s.moveTo(o[0], o[1]), s.lineTo(o[2], o[3]));
  }
  contains(t, i, n) {
    return i = +i, i !== i || (n = +n, n !== n) ? !1 : this.delaunay._step(t, i, n) === t;
  }
  *neighbors(t) {
    const i = this._clip(t);
    if (i)
      for (const n of this.delaunay.neighbors(t)) {
        const A = this._clip(n);
        if (A) {
          t:
            for (let s = 0, o = i.length; s < o; s += 2)
              for (let r = 0, a = A.length; r < a; r += 2)
                if (i[s] === A[r] && i[s + 1] === A[r + 1] && i[(s + 2) % o] === A[(r + a - 2) % a] && i[(s + 3) % o] === A[(r + a - 1) % a]) {
                  yield n;
                  break t;
                }
        }
      }
  }
  _cell(t) {
    const { circumcenters: i, delaunay: { inedges: n, halfedges: A, triangles: s } } = this, o = n[t];
    if (o === -1)
      return null;
    const r = [];
    let a = o;
    do {
      const l = Math.floor(a / 3);
      if (r.push(i[l * 2], i[l * 2 + 1]), a = a % 3 === 2 ? a - 2 : a + 1, s[a] !== t)
        break;
      a = A[a];
    } while (a !== o && a !== -1);
    return r;
  }
  _clip(t) {
    if (t === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const i = this._cell(t);
    if (i === null)
      return null;
    const { vectors: n } = this, A = t * 4;
    return this._simplify(n[A] || n[A + 1] ? this._clipInfinite(t, i, n[A], n[A + 1], n[A + 2], n[A + 3]) : this._clipFinite(t, i));
  }
  _clipFinite(t, i) {
    const n = i.length;
    let A = null, s, o, r = i[n - 2], a = i[n - 1], l, c = this._regioncode(r, a), g, h = 0;
    for (let u = 0; u < n; u += 2)
      if (s = r, o = a, r = i[u], a = i[u + 1], l = c, c = this._regioncode(r, a), l === 0 && c === 0)
        g = h, h = 0, A ? A.push(r, a) : A = [r, a];
      else {
        let d, f, I, C, E;
        if (l === 0) {
          if ((d = this._clipSegment(s, o, r, a, l, c)) === null)
            continue;
          [f, I, C, E] = d;
        } else {
          if ((d = this._clipSegment(r, a, s, o, c, l)) === null)
            continue;
          [C, E, f, I] = d, g = h, h = this._edgecode(f, I), g && h && this._edge(t, g, h, A, A.length), A ? A.push(f, I) : A = [f, I];
        }
        g = h, h = this._edgecode(C, E), g && h && this._edge(t, g, h, A, A.length), A ? A.push(C, E) : A = [C, E];
      }
    if (A)
      g = h, h = this._edgecode(A[0], A[1]), g && h && this._edge(t, g, h, A, A.length);
    else if (this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return A;
  }
  _clipSegment(t, i, n, A, s, o) {
    const r = s < o;
    for (r && ([t, i, n, A, s, o] = [n, A, t, i, o, s]); ; ) {
      if (s === 0 && o === 0)
        return r ? [n, A, t, i] : [t, i, n, A];
      if (s & o)
        return null;
      let a, l, c = s || o;
      c & 8 ? (a = t + (n - t) * (this.ymax - i) / (A - i), l = this.ymax) : c & 4 ? (a = t + (n - t) * (this.ymin - i) / (A - i), l = this.ymin) : c & 2 ? (l = i + (A - i) * (this.xmax - t) / (n - t), a = this.xmax) : (l = i + (A - i) * (this.xmin - t) / (n - t), a = this.xmin), s ? (t = a, i = l, s = this._regioncode(t, i)) : (n = a, A = l, o = this._regioncode(n, A));
    }
  }
  _clipInfinite(t, i, n, A, s, o) {
    let r = Array.from(i), a;
    if ((a = this._project(r[0], r[1], n, A)) && r.unshift(a[0], a[1]), (a = this._project(r[r.length - 2], r[r.length - 1], s, o)) && r.push(a[0], a[1]), r = this._clipFinite(t, r))
      for (let l = 0, c = r.length, g, h = this._edgecode(r[c - 2], r[c - 1]); l < c; l += 2)
        g = h, h = this._edgecode(r[l], r[l + 1]), g && h && (l = this._edge(t, g, h, r, l), c = r.length);
    else
      this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (r = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return r;
  }
  _edge(t, i, n, A, s) {
    for (; i !== n; ) {
      let o, r;
      switch (i) {
        case 5:
          i = 4;
          continue;
        case 4:
          i = 6, o = this.xmax, r = this.ymin;
          break;
        case 6:
          i = 2;
          continue;
        case 2:
          i = 10, o = this.xmax, r = this.ymax;
          break;
        case 10:
          i = 8;
          continue;
        case 8:
          i = 9, o = this.xmin, r = this.ymax;
          break;
        case 9:
          i = 1;
          continue;
        case 1:
          i = 5, o = this.xmin, r = this.ymin;
          break;
      }
      (A[s] !== o || A[s + 1] !== r) && this.contains(t, o, r) && (A.splice(s, 0, o, r), s += 2);
    }
    return s;
  }
  _project(t, i, n, A) {
    let s = 1 / 0, o, r, a;
    if (A < 0) {
      if (i <= this.ymin)
        return null;
      (o = (this.ymin - i) / A) < s && (a = this.ymin, r = t + (s = o) * n);
    } else if (A > 0) {
      if (i >= this.ymax)
        return null;
      (o = (this.ymax - i) / A) < s && (a = this.ymax, r = t + (s = o) * n);
    }
    if (n > 0) {
      if (t >= this.xmax)
        return null;
      (o = (this.xmax - t) / n) < s && (r = this.xmax, a = i + (s = o) * A);
    } else if (n < 0) {
      if (t <= this.xmin)
        return null;
      (o = (this.xmin - t) / n) < s && (r = this.xmin, a = i + (s = o) * A);
    }
    return [r, a];
  }
  _edgecode(t, i) {
    return (t === this.xmin ? 1 : t === this.xmax ? 2 : 0) | (i === this.ymin ? 4 : i === this.ymax ? 8 : 0);
  }
  _regioncode(t, i) {
    return (t < this.xmin ? 1 : t > this.xmax ? 2 : 0) | (i < this.ymin ? 4 : i > this.ymax ? 8 : 0);
  }
  _simplify(t) {
    if (t && t.length > 4) {
      for (let i = 0; i < t.length; i += 2) {
        const n = (i + 2) % t.length, A = (i + 4) % t.length;
        (t[i] === t[n] && t[n] === t[A] || t[i + 1] === t[n + 1] && t[n + 1] === t[A + 1]) && (t.splice(n, 2), i -= 2);
      }
      t.length || (t = null);
    }
    return t;
  }
};
const oO = 2 * Math.PI, lo = Math.pow;
function rO(e) {
  return e[0];
}
function aO(e) {
  return e[1];
}
function lO(e) {
  const { triangles: t, coords: i } = e;
  for (let n = 0; n < t.length; n += 3) {
    const A = 2 * t[n], s = 2 * t[n + 1], o = 2 * t[n + 2];
    if ((i[o] - i[A]) * (i[s + 1] - i[A + 1]) - (i[s] - i[A]) * (i[o + 1] - i[A + 1]) > 1e-10)
      return !1;
  }
  return !0;
}
function cO(e, t, i) {
  return [e + Math.sin(e + t) * i, t + Math.cos(e - t) * i];
}
class iu {
  static from(t, i = rO, n = aO, A) {
    return new iu("length" in t ? gO(t, i, n, A) : Float64Array.from(hO(t, i, n, A)));
  }
  constructor(t) {
    this._delaunator = new Sg(t), this.inedges = new Int32Array(t.length / 2), this._hullIndex = new Int32Array(t.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const t = this._delaunator, i = this.points;
    if (t.hull && t.hull.length > 2 && lO(t)) {
      this.collinear = Int32Array.from({ length: i.length / 2 }, (h, u) => u).sort((h, u) => i[2 * h] - i[2 * u] || i[2 * h + 1] - i[2 * u + 1]);
      const a = this.collinear[0], l = this.collinear[this.collinear.length - 1], c = [i[2 * a], i[2 * a + 1], i[2 * l], i[2 * l + 1]], g = 1e-8 * Math.hypot(c[3] - c[1], c[2] - c[0]);
      for (let h = 0, u = i.length / 2; h < u; ++h) {
        const d = cO(i[2 * h], i[2 * h + 1], g);
        i[2 * h] = d[0], i[2 * h + 1] = d[1];
      }
      this._delaunator = new Sg(i);
    } else
      delete this.collinear;
    const n = this.halfedges = this._delaunator.halfedges, A = this.hull = this._delaunator.hull, s = this.triangles = this._delaunator.triangles, o = this.inedges.fill(-1), r = this._hullIndex.fill(-1);
    for (let a = 0, l = n.length; a < l; ++a) {
      const c = s[a % 3 === 2 ? a - 2 : a + 1];
      (n[a] === -1 || o[c] === -1) && (o[c] = a);
    }
    for (let a = 0, l = A.length; a < l; ++a)
      r[A[a]] = a;
    A.length <= 2 && A.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = A[0], o[A[0]] = 1, A.length === 2 && (o[A[1]] = 0, this.triangles[1] = A[1], this.triangles[2] = A[1]));
  }
  voronoi(t) {
    return new sO(this, t);
  }
  *neighbors(t) {
    const { inedges: i, hull: n, _hullIndex: A, halfedges: s, triangles: o, collinear: r } = this;
    if (r) {
      const g = r.indexOf(t);
      g > 0 && (yield r[g - 1]), g < r.length - 1 && (yield r[g + 1]);
      return;
    }
    const a = i[t];
    if (a === -1)
      return;
    let l = a, c = -1;
    do {
      if (yield c = o[l], l = l % 3 === 2 ? l - 2 : l + 1, o[l] !== t)
        return;
      if (l = s[l], l === -1) {
        const g = n[(A[t] + 1) % n.length];
        g !== c && (yield g);
        return;
      }
    } while (l !== a);
  }
  find(t, i, n = 0) {
    if (t = +t, t !== t || (i = +i, i !== i))
      return -1;
    const A = n;
    let s;
    for (; (s = this._step(n, t, i)) >= 0 && s !== n && s !== A; )
      n = s;
    return s;
  }
  _step(t, i, n) {
    const { inedges: A, hull: s, _hullIndex: o, halfedges: r, triangles: a, points: l } = this;
    if (A[t] === -1 || !l.length)
      return (t + 1) % (l.length >> 1);
    let c = t, g = lo(i - l[t * 2], 2) + lo(n - l[t * 2 + 1], 2);
    const h = A[t];
    let u = h;
    do {
      let d = a[u];
      const f = lo(i - l[d * 2], 2) + lo(n - l[d * 2 + 1], 2);
      if (f < g && (g = f, c = d), u = u % 3 === 2 ? u - 2 : u + 1, a[u] !== t)
        break;
      if (u = r[u], u === -1) {
        if (u = s[(o[t] + 1) % s.length], u !== d && lo(i - l[u * 2], 2) + lo(n - l[u * 2 + 1], 2) < g)
          return u;
        break;
      }
    } while (u !== h);
    return c;
  }
  render(t) {
    const i = t == null ? t = new as() : void 0, { points: n, halfedges: A, triangles: s } = this;
    for (let o = 0, r = A.length; o < r; ++o) {
      const a = A[o];
      if (a < o)
        continue;
      const l = s[o] * 2, c = s[a] * 2;
      t.moveTo(n[l], n[l + 1]), t.lineTo(n[c], n[c + 1]);
    }
    return this.renderHull(t), i && i.value();
  }
  renderPoints(t, i) {
    i === void 0 && (!t || typeof t.moveTo != "function") && (i = t, t = null), i = i == null ? 2 : +i;
    const n = t == null ? t = new as() : void 0, { points: A } = this;
    for (let s = 0, o = A.length; s < o; s += 2) {
      const r = A[s], a = A[s + 1];
      t.moveTo(r + i, a), t.arc(r, a, i, 0, oO);
    }
    return n && n.value();
  }
  renderHull(t) {
    const i = t == null ? t = new as() : void 0, { hull: n, points: A } = this, s = n[0] * 2, o = n.length;
    t.moveTo(A[s], A[s + 1]);
    for (let r = 1; r < o; ++r) {
      const a = 2 * n[r];
      t.lineTo(A[a], A[a + 1]);
    }
    return t.closePath(), i && i.value();
  }
  hullPolygon() {
    const t = new mf();
    return this.renderHull(t), t.value();
  }
  renderTriangle(t, i) {
    const n = i == null ? i = new as() : void 0, { points: A, triangles: s } = this, o = s[t *= 3] * 2, r = s[t + 1] * 2, a = s[t + 2] * 2;
    return i.moveTo(A[o], A[o + 1]), i.lineTo(A[r], A[r + 1]), i.lineTo(A[a], A[a + 1]), i.closePath(), n && n.value();
  }
  *trianglePolygons() {
    const { triangles: t } = this;
    for (let i = 0, n = t.length / 3; i < n; ++i)
      yield this.trianglePolygon(i);
  }
  trianglePolygon(t) {
    const i = new mf();
    return this.renderTriangle(t, i), i.value();
  }
}
function gO(e, t, i, n) {
  const A = e.length, s = new Float64Array(A * 2);
  for (let o = 0; o < A; ++o) {
    const r = e[o];
    s[o * 2] = t.call(n, r, o, e), s[o * 2 + 1] = i.call(n, r, o, e);
  }
  return s;
}
function* hO(e, t, i, n) {
  let A = 0;
  for (const s of e)
    yield t.call(n, s, A, e), yield i.call(n, s, A, e), ++A;
}
function uO(e) {
  var t = 0, i = e.children, n = i && i.length;
  if (!n)
    t = 1;
  else
    for (; --n >= 0; )
      t += i[n].value;
  e.value = t;
}
function dO() {
  return this.eachAfter(uO);
}
function fO(e, t) {
  let i = -1;
  for (const n of this)
    e.call(t, n, ++i, this);
  return this;
}
function IO(e, t) {
  for (var i = this, n = [i], A, s, o = -1; i = n.pop(); )
    if (e.call(t, i, ++o, this), A = i.children)
      for (s = A.length - 1; s >= 0; --s)
        n.push(A[s]);
  return this;
}
function CO(e, t) {
  for (var i = this, n = [i], A = [], s, o, r, a = -1; i = n.pop(); )
    if (A.push(i), s = i.children)
      for (o = 0, r = s.length; o < r; ++o)
        n.push(s[o]);
  for (; i = A.pop(); )
    e.call(t, i, ++a, this);
  return this;
}
function EO(e, t) {
  let i = -1;
  for (const n of this)
    if (e.call(t, n, ++i, this))
      return n;
}
function BO(e) {
  return this.eachAfter(function(t) {
    for (var i = +e(t.data) || 0, n = t.children, A = n && n.length; --A >= 0; )
      i += n[A].value;
    t.value = i;
  });
}
function mO(e) {
  return this.eachBefore(function(t) {
    t.children && t.children.sort(e);
  });
}
function QO(e) {
  for (var t = this, i = pO(t, e), n = [t]; t !== i; )
    t = t.parent, n.push(t);
  for (var A = n.length; e !== i; )
    n.splice(A, 0, e), e = e.parent;
  return n;
}
function pO(e, t) {
  if (e === t)
    return e;
  var i = e.ancestors(), n = t.ancestors(), A = null;
  for (e = i.pop(), t = n.pop(); e === t; )
    A = e, e = i.pop(), t = n.pop();
  return A;
}
function yO() {
  for (var e = this, t = [e]; e = e.parent; )
    t.push(e);
  return t;
}
function DO() {
  return Array.from(this);
}
function wO() {
  var e = [];
  return this.eachBefore(function(t) {
    t.children || e.push(t);
  }), e;
}
function xO() {
  var e = this, t = [];
  return e.each(function(i) {
    i !== e && t.push({ source: i.parent, target: i });
  }), t;
}
function* SO() {
  var e = this, t, i = [e], n, A, s;
  do
    for (t = i.reverse(), i = []; e = t.pop(); )
      if (yield e, n = e.children)
        for (A = 0, s = n.length; A < s; ++A)
          i.push(n[A]);
  while (i.length);
}
function Mi(e, t) {
  e instanceof Map ? (e = [void 0, e], t === void 0 && (t = bO)) : t === void 0 && (t = _O);
  for (var i = new Mg(e), n, A = [i], s, o, r, a; n = A.pop(); )
    if ((o = t(n.data)) && (a = (o = Array.from(o)).length))
      for (n.children = o, r = a - 1; r >= 0; --r)
        A.push(s = o[r] = new Mg(o[r])), s.parent = n, s.depth = n.depth + 1;
  return i.eachBefore(FO);
}
function MO() {
  return Mi(this).eachBefore(NO);
}
function _O(e) {
  return e.children;
}
function bO(e) {
  return Array.isArray(e) ? e[1] : null;
}
function NO(e) {
  e.data.value !== void 0 && (e.value = e.data.value), e.data = e.data.data;
}
function FO(e) {
  var t = 0;
  do
    e.height = t;
  while ((e = e.parent) && e.height < ++t);
}
function Mg(e) {
  this.data = e, this.depth = this.height = 0, this.parent = null;
}
Mg.prototype = Mi.prototype = {
  constructor: Mg,
  count: dO,
  each: fO,
  eachAfter: CO,
  eachBefore: IO,
  find: EO,
  sum: BO,
  sort: mO,
  path: QO,
  ancestors: yO,
  descendants: DO,
  leaves: wO,
  links: xO,
  copy: MO,
  [Symbol.iterator]: SO
};
function Lw(e) {
  for (var t = -1, i = e.length, n, A = e[i - 1], s = 0; ++t < i; )
    n = A, A = e[t], s += n[1] * A[0] - n[0] * A[1];
  return s / 2;
}
function Qf(e) {
  for (var t = -1, i = e.length, n = 0, A = 0, s, o = e[i - 1], r, a = 0; ++t < i; )
    s = o, o = e[t], a += r = s[0] * o[1] - o[0] * s[1], n += (s[0] + o[0]) * r, A += (s[1] + o[1]) * r;
  return a *= 3, [n / a, A / a];
}
const RO = "ascending", kO = "descending", TO = "none", vO = "diverging", GO = "none", LO = "expand", UO = "wiggle", OO = (e, t, i) => (n, A) => {
  const s = n[0], o = A[0];
  return i(
    [n[0], e.get(s), t.get(s)],
    [o, e.get(o), t.get(o)]
  );
};
let HO = class ua {
  /**
   * Creates an instance of Selection.
   * @param {Array<DataObject>} data Array of DataObjects.
   * @memberof Selection
   */
  constructor(t) {
    this._dataObjects = /* @__PURE__ */ new Map(), this._updateData = /* @__PURE__ */ new Map(), this._enterData = /* @__PURE__ */ new Map(), this._exitData = /* @__PURE__ */ new Map(), this._idGetter = t;
  }
  /**
   * This method is used to supply seed data to a selection.
   *
   * @param {Array} newData Seed data to create the enter selection.
   * @param {Functon | undefined } idGetter This function is used to uniqely identify a data entry.
   * @return {Selection} Modified selection.
   * @memberof Selection
   */
  data(t) {
    const i = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), o = this._updateData, r = this._idGetter;
    t.forEach((...g) => {
      const h = r ? r(...g) : g[1];
      A.has(h) ? s.push(h, g[0]) : A.set(h, g[0]);
    });
    let a, l = A.entries();
    for (; a = l.next().value; )
      o.has(a[0]) ? o.set(a[0], a[1]) : i.set(a[0], a[1]);
    for (l = o.entries(); a = l.next().value; )
      A.has(a[0]) || n.set(a[0], a[1]);
    for (l = s.entries(); a = l.next().value; )
      n.set(a[0], a[1]);
    const c = new ua(this._idGetter);
    return c._updateData = o, c._dataObjects = this._dataObjects, c._enterData = i, c._exitData = n, c;
  }
  /**
   * Applies the supplied callback to each data element
   * and returns a new selection.
   *
   * @param {Function} callback Callback to execute on each item.
   * @return {Selection} New selection with data created using callback.
   * @memberof Selection
   */
  append(t) {
    let i;
    const n = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Map(), s = ft(this._mode, "update"), r = this[`_${s}Data`].entries();
    for (; i = r.next().value; )
      n.set(i[0], t(i[1])), A.set(i[0], i[1]);
    const a = new ua(this._idGetter);
    return a._updateData = A, a._dataObjects = n, a;
  }
  /**
   * This method returns an enter selection that
   * allows or update operations.
   *
   * @return {Selection} Instance of enter selection.
   * @memberof Selection
   */
  enter() {
    return this._mode = "enter", this;
  }
  /**
   * Returns a selection with exit data.
   *
   * @return {Selection} Instance of selection.
   * @memberof Selection
   */
  exit() {
    return this._mode = "exit", this;
  }
  /**
   * This method merges the data of one selection with another.
   *
   * @param {Selection} selection Instance of selection.
   * @return {Selection} Modified selection.
   * @memberof Selection
   */
  merge(t) {
    const i = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    let A, s;
    for (s = this._updateData.entries(); A = s.next().value; )
      this._exitData.has(A[0]) || (n.set(A[0], A[1]), i.set(A[0], this._dataObjects.get(A[0])));
    for (s = t._updateData.entries(); A = s.next().value; )
      n.has(A[0]) || t._exitData.has(A[0]) || (n.set(A[0], A[1]), i.set(A[0], t._dataObjects.get(A[0])));
    const o = new ua(this._idGetter);
    return o._updateData = n, o._dataObjects = i, o;
  }
  each(t) {
    let i;
    const n = this._dataObjects.entries();
    for (; i = n.next().value; )
      t(i[1], this._updateData.get(i[0]), i[0]);
  }
  map(t) {
    const i = /* @__PURE__ */ new Map();
    let n;
    const A = this._dataObjects.entries();
    for (; n = A.next().value; )
      i.set(n[0], t(n[1], this._updateData.get(n[0]), n[0]));
    const s = new ua(this._idGetter);
    return s._updateData = this._updateData, s._dataObjects = i, s;
  }
  remove() {
    const t = ft(this._mode, "update");
    return this[`_${t}Data`].clear(), this;
  }
  sort(t) {
    const i = this._updateData, n = this._dataObjects, A = OO(n, i, t);
    return this._updateData = new Map([...i.entries()].sort(A)), this._dataObjects = new Map([...n.entries()].sort(A)), this;
  }
  /**
   *  Gets the object bound to a class
   *
   * @return {Object} current data set bound to the class
   * @memberof Selection
   */
  getObjects() {
    let t;
    const i = [], n = this._dataObjects, A = ft(this._mode, "update"), o = this[`_${A}Data`].entries();
    for (; t = o.next().value; )
      n.has(t[0]) && i.push(n.get(t[0]));
    return i;
  }
};
function Uw(e) {
  return new HO(e);
}
const { STRING: Ow, FUNCTION: Hw } = ID, { DISCRETE: Hc, CONTINUOUS: Bd } = lt, Pw = window.HTMLElement;
function we(e) {
  if (typeof e == "object") {
    if (e === null)
      return !1;
    if (Object.prototype.toString.call(e) === "[object Object]")
      return (e.constructor.toString().match(/^function (.*)\(\)/m) || [])[1] === "Object";
  }
  return !1;
}
function Ut() {
  return `id-${(/* @__PURE__ */ new Date()).getTime()}-${Math.round(Math.random() * 1e4)}`;
}
function QC(e) {
  const t = {};
  let i;
  for (const n in e)
    ({}).hasOwnProperty.call(e, n) && (i = e[n], t[n] = we(i) ? QC(i) : i);
  return t;
}
function Yw(e, t) {
  const i = [];
  return e.forEach((n) => {
    n in t || i.push(n);
  }), i;
}
const Jw = {
  typeObj: (e, t) => {
    if (typeof t != "object")
      return Error("Argument type object expected");
    const i = Yw(e, t);
    return i.length ? Error(`Missing keys from parameter ${i.join(", ")}`) : t;
  },
  // NOTE: not used
  /* istanbul ignore next */
  htmlElem: (e) => e instanceof Pw ? e : Error("HTMLElement required")
};
function Cn(e, t) {
  let i = -1 / 0;
  return e.forEach((n) => {
    i = Math.max(t && typeof n == "object" ? n[t] : n, i);
  }), i;
}
function Zn(e, t) {
  let i = 1 / 0;
  return e.forEach((n) => {
    i = Math.min(t && typeof n == "object" ? n[t] : n, i);
  }), i;
}
function PO(e, t, i) {
  let n;
  const A = [];
  switch (e = e[0] instanceof Array ? e : [e], i === "categorical" && (i = Ct.DIMENSION), i) {
    case Ct.DIMENSION:
      n = [].concat(
        ...e.map(
          (s) => s.map((o) => o[t[0]]).filter((o) => o !== void 0)
        )
      );
      break;
    default:
      for (let s = 0, o = e.length; s < o; s++) {
        const r = e[s], [a, l] = t, c = r.filter((h) => !isNaN(h[a])), g = r.filter((h) => !isNaN(h[l]));
        if (c.length || g.length) {
          const h = Zn(c, a), u = Zn(g, l), d = Cn(c, a), f = Cn(g, l);
          A.push([
            Math.min(h, u),
            Math.max(d, f)
          ]);
        }
      }
      n = A.length ? [
        Math.min(...A.map((s) => s[0])),
        Math.max(...A.map((s) => s[1]))
      ] : [];
      break;
  }
  return n;
}
function Cl(e) {
  return e[0] === e[1] && (e[0] = +e[0] > 0 ? 0 : e[0], e[1] = +e[1] > 0 ? e[1] : 0), e;
}
function te(e, t) {
  if (e = e.filter((i) => i && i.length), e.length)
    if (t === Hc && e) {
      const i = [], n = /* @__PURE__ */ new Set();
      return e.flat().forEach((A) => {
        J.isInvalid(A) ? A instanceof Ft && !n.has(A.value()) && (i.push(A), n.add(A.value())) : i.push(A);
      }), [...new Set(i)];
    } else
      return [
        Math.min(...e.map((i) => i[0])),
        Math.max(...e.map((i) => i[i.length - 1]))
      ];
  return [];
}
function yi(e) {
  let t = [0, 0];
  return e = e.filter((i) => i && i.length), e.length && (t = [
    Math.max(...e.map((i) => i[0])),
    Math.max(...e.map((i) => i[1]))
  ]), t;
}
function YO(e, ...t) {
  return t.forEach((i) => {
    e[i] || (e[i] = {}), e = e[i];
  }), e;
}
function _g(e) {
  const t = {};
  return e.forEach((n) => {
    Object.keys(n).forEach((A) => {
      const s = n[A];
      t[A] || (t[A] = {
        [Hc]: [],
        [Bd]: []
      }), [Hc, Bd].forEach((o) => {
        const r = s[o] && s[o].splitDomains;
        if (r) {
          t[A][o].splitDomains || (t[A][o].splitDomains = {});
          for (const a in r)
            t[A][o].splitDomains[a] || (t[A][o].splitDomains[a] = []), t[A][o].splitDomains[a].push(s[o].splitDomains[a]);
        } else
          s[o] && t[A][o].push(
            s[o]
          );
      });
    });
  }), Object.keys(t).reduce(
    (n, A) => ([Hc, Bd].forEach((s) => {
      const o = t[A][s], r = t[A][s].splitDomains;
      if (r) {
        const a = YO(
          n,
          A,
          s,
          "splitDomains"
        );
        for (const l in r)
          a[l] = te(
            r[l],
            s
          );
      } else
        o.length && (n[A] = Object.assign({}, n[A], {
          [s]: te(o, s)
        }));
    }), n),
    {}
  );
}
const Kw = {
  circle: yw,
  cross: YL,
  diamond: KL,
  square: zL,
  star: qL,
  wye: XL,
  triangle: ZL
}, El = {
  cubic: Mw,
  bounce: mU,
  linear: lU,
  elastic: pU,
  back: QU,
  poly: cU,
  circle: gU
};
function Ww(e, t, i) {
  let n, A = e[0];
  const s = e.length;
  let o = i === "max" ? -1 / 0 : 1 / 0, r;
  for (let a = 0; a < s; a++)
    A = e[a], r = A[t], (i === "min" ? r < o : r > o) && (o = r, n = A);
  return n;
}
function JO(e, t) {
  return Ww(e, t, "min");
}
function pf(e, t) {
  return Ww(e, t, "max");
}
function pC(e, t, i) {
  let n = 0, s = e.length - 1, o, r, a;
  for (; n < s; )
    o = Math.floor((n + s) / 2), r = Math.abs(e[o] - t), a = Math.abs(e[o + 1] - t), a <= r ? n = o + 1 : s = o;
  if (!i)
    return s;
  const l = e[s];
  return l === t ? s : l > t ? s === 0 ? s : i === "left" ? s - 1 : s : s === e.length - 1 || i === "left" ? s : s + 1;
}
function yf(e, t) {
  const i = e.filter((n) => typeof n == "number");
  return i[pC(i, t)];
}
function Vw() {
  return window;
}
const KO = (() => requestAnimationFrame)(), WO = (() => cancelAnimationFrame)();
function VO(e) {
  return e = e.toLowerCase(), e.replace(
    /\w\S*/g,
    (t) => t.charAt(0).toUpperCase() + t.substr(1)
  );
}
function bg(e, t = (i) => i) {
  const i = e.reduce((n, A) => (n[t(A)] = A, n), {});
  return Object.values(i);
}
function jO(e, t) {
  let i, n;
  if (t !== void 0 ? n = bg(e.map((A) => A[t])) : n = bg(e), n.length > 1) {
    i = Math.abs(n[1] - n[0]);
    for (let A = 2, s = n.length; A < s; A++)
      i = Math.min(i, Math.abs(n[A] - n[A - 1]));
  } else
    i = n[0];
  return i;
}
function _n(e, t, i) {
  return e = e.replace(/^\.*/, ""), [`${i}-${e}`, `${i}-${e}-${t}`];
}
function ft(...e) {
  return e.find(
    (t) => !(typeof t > "u" || typeof t == "object" && !t)
  );
}
function jw(e) {
  const t = [], i = {}, n = Object.keys(e), A = (s) => {
    if (t.length === n.length)
      return !0;
    i[s] = !0;
    const o = e[s];
    for (let r = 0; r < o.length; r++) {
      const a = o[r];
      i[a] || A(a);
    }
    return t.push(s), !1;
  };
  for (let s = 0; s < n.length && !A(n[s]); s++)
    ;
  return t;
}
function yC(e, t) {
  for (const i in e)
    Object.hasOwnProperty.call(e, i) && t(i, e);
}
class DC {
  /**
   * Initialize the voronoi with the data given.
   * @param {Array.<Object>} data Array of points.
   */
  _voronoi;
  _voronoiFn;
  constructor(t) {
    this._voronoi = HU().x((i) => i.x).y((i) => i.y), this.data(t);
  }
  data(t) {
    return t && (this._voronoiFn = this._voronoi(t)), this;
  }
  find(t, i, n) {
    return this._voronoiFn.find(t, i, n);
  }
}
function W(e, ...t) {
  if (e == null)
    return e;
  let i = e;
  for (let n = 0, A = t.length; n < A && (i = i[t[n]], i != null); n++)
    ;
  return i;
}
function da(e) {
  const t = e.toString().match(/(\d+)(px)*/g);
  return t ? parseInt(t[0], 10) : null;
}
function ge(e, t) {
  Object.entries(t).forEach((i) => {
    const n = i[0], {
      sanitization: A,
      preset: s,
      onset: o,
      typeChecker: r,
      defaultValue: a
    } = i[1], l = e.constructor.prototype;
    Object.hasOwnProperty.call(l, n) || (a && (e[`_${n}`] = a), e[n] = (...c) => {
      if (c.length) {
        let g = c[0];
        return A && (g = A(e, c[0], e[`_${n}`])), s && s(e, g), r && !r(g) ? e[`_${n}`] : (e[`_${n}`] = g, o && o(e, g), e);
      }
      return e[`_${n}`];
    });
  });
}
function qw(e, t) {
  return e.reduce(
    (i, n) => (i += typeof n == "object" ? n[t] : n, i),
    0
  );
}
function wC(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let i = e.length; i >= 0; i--)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
const Is = (e) => (t, i) => e === "Array" ? t ? wC(t, i) : !1 : e === "Object" ? Object.is(t, i) : t === i, qO = (e) => e instanceof Pw, dt = {
  INTERFACE_IMPL: "Method not implemented"
};
function tt(e, ...t) {
  for (const i of t)
    if (i)
      for (const n in i)
        we(e[n]) && we(i[n]) ? tt(e[n], i[n]) : i[n] instanceof Object && i[n].constructor === Object ? (e[n] = {}, tt(e[n], i[n])) : e[n] = i[n];
  return e;
}
function zw(...e) {
  let t = e[0];
  for (let i = 1; i < e.length; i++)
    t = tt(t, e[i]);
  return t;
}
function Zw(e, t, i, n) {
  let A = e || Uw(n);
  A = A.data(i);
  const o = A.enter().append(t).merge(A), r = A.exit();
  return r.getObjects().forEach((a) => a.remove()), r.remove(), o;
}
function zO(e, t) {
  const i = function(s, o, r) {
    return s + (o - s) * r;
  }, n = [], A = (e.length - 1) / (t - 1);
  n[0] = e[0];
  for (let s = 1; s < t - 1; s++) {
    const o = s * A, r = parseFloat(Math.floor(o).toFixed()), a = parseFloat(Math.ceil(o).toFixed()), l = o - r;
    n[s] = i(e[r], e[a], l);
  }
  return n[t - 1] = e[e.length - 1], n;
}
const ZO = (e) => {
  setTimeout(() => {
    e();
  }, 0);
};
function ls(e) {
  return e * Math.PI / 180;
}
const $O = () => {
}, $w = () => Hh, xC = () => Di, Xw = () => Oa, XO = () => Bv;
function tH() {
  return {
    color: _A,
    rgb: La,
    hsl: bA
  };
}
const SC = () => mv;
function md(e, t, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e + (t - e) * 6 * i : i < 1 / 2 ? t : i < 2 / 3 ? e + (t - e) * (2 / 3 - i) * 6 : e;
}
function tx(e, t, i, n) {
  n || (n = 1);
  let A, s, o;
  if (t === 0)
    A = s = o = i;
  else {
    const r = i < 0.5 ? i * (1 + t) : i + t - i * t, a = 2 * i - r;
    A = md(a, r, e + 1 / 3), s = md(a, r, e), o = md(a, r, e - 1 / 3);
  }
  return [A * 255, s * 255, o * 255, n];
}
function Ho(e, t, i, n) {
  e = +e, t = +t, i = +i, n = +n, e /= 255, t /= 255, i /= 255;
  const A = Math.max(e, t, i), s = Math.min(e, t, i);
  let o, r;
  const a = (A + s) / 2;
  if (A === s)
    o = r = 0;
  else {
    const l = A - s;
    switch (r = a > 0.5 ? l / (2 - A - s) : l / (A + s), A) {
      case e:
        o = (t - i) / l + (t < i ? 6 : 0);
        break;
      case t:
        o = (i - e) / l + 2;
        break;
      case i:
        o = (e - t) / l + 4;
        break;
    }
    o /= 6;
  }
  return [o, r, a, n];
}
function ex(e, t, i, n) {
  let A, s, o;
  const r = Math.floor(e * 6), a = e * 6 - r, l = i * (1 - t), c = i * (1 - a * t), g = i * (1 - (1 - a) * t);
  switch (r % 6) {
    case 0:
      A = i, s = g, o = l;
      break;
    case 1:
      A = c, s = i, o = l;
      break;
    case 2:
      A = l, s = i, o = g;
      break;
    case 3:
      A = l, s = c, o = i;
      break;
    case 4:
      A = g, s = l, o = i;
      break;
    case 5:
      A = i, s = l, o = c;
      break;
  }
  return [A * 255, s * 255, o * 255, n];
}
function ix(e) {
  const t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(t, (n, A, s, o) => A + A + s + s + o + o);
  const i = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return i ? Ho(
    parseInt(i[1], 16),
    parseInt(i[2], 16),
    parseInt(i[3], 16)
  ) : "";
}
function eH(e, t, i, n, A, s, o) {
  n || (n = 1), A || (A = 255), s || (s = 255), o || (o = 255);
  const r = Math.round((1 - n) * A + n * e), a = Math.round((1 - n) * s + n * t), l = Math.round((1 - n) * o + n * i);
  return `rgb(${r},${a},${l})`;
}
function iH(e, t, i, n) {
  const [A, s, o, r] = tx(e, t, i, n);
  return eH(A, s, o, r);
}
function fa(e) {
  const t = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/, i = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g, n = /rgba?\(((25[0-5]|2[0-4]\d|1\d{1,2}|\d\d?)\s*,\s*?){2}(25[0-5]|2[0-4]\d|1\d{1,2}|\d\d?)\s*,?\s*([01]\.?\d*?)?\)/, A = /^hsla\(([\d.]+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/, s = /^#([0-9a-f]{3}){1,2}$/i;
  return t.test(e) || n.test(e) ? "rgb" : i.test(e) || A.test(e) ? "hsl" : s.test(e) ? "hex" : e;
}
function nH(e) {
  return e.reduce(
    (t, i, n) => (t[i] = n, t),
    {}
  );
}
function nx(e) {
  return !isNaN(e) && e !== -1 / 0 && e !== 1 / 0;
}
function Ax(e) {
  const t = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "/": "&#x2F;"
  }, i = /[&<>"'/]/g;
  return `${e}`.replace(i, (n) => t[n]);
}
function AH(e) {
  return e[0].map((t, i) => e.map((n) => n[i]));
}
function Fi(e) {
  return Array.isArray(e) ? e : [e];
}
function sx(e, t, i) {
  if (!e)
    return !1;
  typeof i != "boolean" && (i = !1);
  const n = e.prototype;
  return n instanceof t ? i = !0 : i = sx(n, t, i), i;
}
function Bl(e) {
  return tU().type(Kw[e]);
}
const sH = {
  [TO]: yg,
  [RO]: Sw,
  [kO]: aU
}, oH = {
  [vO]: sU,
  [GO]: Pa,
  [LO]: AU,
  [UO]: oU
}, rH = (e) => nU().keys(e.keys).offset(oH[e.offset]).order(sH[e.order])(e.data);
function ox(e) {
  const t = MD();
  return e.keys.forEach(
    (i) => t.key((n) => n[i])
  ), t.entries(e.data);
}
function aH(e, t) {
  return e.filter((i) => t.indexOf(i) < 0);
}
const ml = {
  curveLinear: pg,
  curveStepAfter: yQ,
  curveStepBefore: pQ,
  curveStep: QQ,
  curveCatmullRom: mQ,
  stepAfter: yQ,
  catmullRom: mQ,
  step: QQ,
  stepBefore: pQ,
  linear: pg
}, _i = {
  axisLeft: ML,
  axisRight: xL,
  axisTop: wL,
  axisBottom: SL,
  line: pw,
  area: UL,
  pie: PL,
  arc: LL,
  nest: MD
}, MC = {
  band: WI
}, nu = {
  path: Gw
};
function Au(e) {
  e = e.sort((i, n) => i - n);
  let t = e[1] - e[0];
  for (let i = 2; i < e.length; i++)
    t = Math.min(t, e[i] - e[i - 1]);
  return t;
}
const rx = {
  millisecond: "%A, %b %e, %H:%M:%S.%L",
  second: "%A, %b %e, %H:%M:%S",
  minute: "%A, %b %e, %H:%M",
  hour: "%A, %b %e, %H:%M",
  day: "%A, %b %e, %Y",
  month: "%B %Y",
  year: "%Y"
}, lH = {
  millisecond: "%b %e, %H:%M:%S.%L",
  second: "%b %e, %H:%M:%S",
  minute: "%b %e, %H:%M",
  hour: "%b %e, %H:%M",
  day: "%b %e, %Y",
  month: "%B %Y",
  year: "%Y"
}, Qd = [
  ["millisecond", "second", "minute", "hour", "day", "month", "year"],
  [1, 1e3, 6e4, 36e5, 864e5, 2592e6, 31536e6]
];
function cH(e) {
  e < 0 && (e = Qd[1][6]);
  const t = pC(Qd[1], e);
  return Qd[0][t];
}
function Vs(e, t, i) {
  const n = cH(t), A = i?.useShortFormatter ? lH : rx;
  return js(e, A[n], i);
}
function gH(e, t) {
  const i = +J.getActualValue(e), n = J.isInvalid(e) ? i : i + t;
  return [i, n];
}
function _C(e, t) {
  let i = t.slice();
  return i = i.filter((n) => !Ee(n)), i.push(e[1]), i;
}
const hH = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(e) {
  setTimeout(e, 16);
};
function bC(e) {
  return (t) => J.isInvalid(t) && t in e ? e[t] : t;
}
function Ql(e, t) {
  const i = {};
  if (e instanceof J) {
    const A = [
      ...e.getDerivations().reverse(),
      ...e.getAncestorDerivations().reverse()
    ].find(
      (r) => r.op === Gt.GROUPBY
    ), s = ft(W(A, "criteria"), {}), o = e.getMeasures();
    t = t.length ? t : o, t.forEach((r) => {
      if (s[r])
        i[r] = s[r];
      else {
        const a = e.getField(r);
        a && (i[r] = a.schema().defAggFn);
      }
    });
  }
  return i;
}
function pl(e, t) {
  return e.getField(t).displayName();
}
function Df(e, t, i, n = 1, A = "All") {
  return J.isInvalid(e) && J.isInvalid(t) ? n = 0 : J.isInvalid(e) ? t === A ? n = i ? -1 : 1 : n = -1 : J.isInvalid(t) ? e === A ? n = i ? 1 : -1 : n = 1 : e === A ? n = i ? 1 : -1 : t === A ? n = i ? -1 : 1 : n = String(e).localeCompare(String(t)), n;
}
function uH(e, t, i = 1) {
  if (J.isInvalid(e) && J.isInvalid(t))
    i = 0;
  else if (J.isInvalid(e))
    i = -1;
  else if (J.isInvalid(t))
    i = 1;
  else {
    const n = parseFloat(`${e}`), A = parseFloat(`${t}`);
    i = n === A ? 0 : n > A ? 1 : -1;
  }
  return i;
}
function wf(e, t) {
  return e.some((i) => J.isInvalid(i) && J.isInvalid(t) ? !0 : Array.isArray(i) && Array.isArray(t) ? wC(i, t) : i == t);
}
const RQ = {
  [CD]: (e, t, i = "All") => Df(e, t, !0, 1, i),
  [ED]: (e, t, i = "All") => Df(t, e, !1, -1, i)
};
function NC(e, t, i, n = "All") {
  const A = typeof e;
  return A === Hw ? e(t, i, n) : A === Ow && RQ[e] ? RQ[e](t, i, n) : null;
}
function kQ(e, t, i = !0) {
  let n = 1;
  return J.isInvalid(e) && J.isInvalid(t) ? n = 0 : J.isInvalid(e) ? isNaN(Number(t)) ? n = i ? -1 : 1 : n = -1 : J.isInvalid(t) ? isNaN(Number(e)) ? n = i ? 1 : -1 : n = 1 : (e = Number(e), t = Number(t), isNaN(e) && isNaN(t) ? n = 0 : isNaN(e) ? n = i ? 1 : -1 : isNaN(t) ? n = i ? -1 : 1 : n = e - t), n;
}
const TQ = {
  [CD]: (e, t) => kQ(e, t, !0),
  [ED]: (e, t) => kQ(t, e, !1)
};
function FC(e, t, i) {
  const n = typeof e;
  return n === Hw ? e(t, i) : n === Ow && TQ[e] ? TQ[e](t, i) : null;
}
function su(e, t, i = [(n) => n, (n) => n]) {
  const [n, A] = i, s = new Set(t.map((o) => A(o)));
  return e.filter((o) => s.has(n(o)));
}
function dH(e, t, i = [(n) => n, (n) => n]) {
  const [n, A] = i, s = new Set(t.map((o) => A(o)));
  return e.filter((o) => !s.has(n(o)));
}
function ax(e, t) {
  return e.reduce(
    (i, n, A) => (t(n, A, e) ? i[0].push(n) : i[1].push(n), i),
    [[], []]
  );
}
const _e = (e) => ({
  with: (...t) => t.reduce((i, n) => n(i), e || Object)
});
function wa(e) {
  const t = Object.assign({}, e), i = {
    register: (n, A) => {
      if (we(n))
        for (const s in n)
          t[s] = n[s];
      else {
        const s = A || n.formalName();
        t[s] = n;
      }
      return i;
    },
    get: () => t
  };
  return i;
}
function fH(e, t) {
  for (let i = 0; i < e.length; i++)
    if (t.has(e[i]))
      return !0;
  return !1;
}
function Sr(e, t, i = !1, n = [], A = !0) {
  const s = [Math.min(...e), Math.max(...e)];
  let o = tC().domain(s);
  if (A && (o = o.nice()), n && n.length > 2 || i) {
    const l = o.domain(), c = (l[1] - l[0]) / (i ? t : t - 1), g = Oo(l[0], l[1], c);
    return g.push(l[1]), g;
  }
  if (t < 3)
    return s;
  let r = null, a = null;
  return r = _i.axisBottom().scale(o), a = r.scale().ticks(t), Math.max(...a) < s[1] && a.push(s[1]), Math.min(...a) > s[0] && a.unshift(s[0]), a;
}
function lx({ h: e, s: t, l: i, a: n }, { h: A = 0, s = 0, l: o = 0, a: r }, a, l) {
  const c = e + "," + t + "," + i + "," + n + "," + A + "," + s + "," + o + "," + r, g = l.get(c);
  if (g)
    return g;
  const h = parseFloat(`${r || n}`), u = e + A;
  let d = t + s, f = i + o, I = h + 1;
  a || (I = h - 1), d = +(d * 100).toFixed(1), f = +(f * 100).toFixed(1);
  const C = `hsla(${Number.isNaN(u) ? 0 : u},${Number.isNaN(d) ? 0 : d}%,${Number.isNaN(f) ? 0 : f}%,${Number.isNaN(I) ? 0 : I})`;
  return l.set(c, C), C;
}
function cx(e, t) {
  const { x: i, y: n, r: A } = e, { x: s, y: o } = t;
  return Math.sqrt((i - s) ** 2 + (n - o) ** 2) <= A;
}
function Mr(e, t, i = "eq", n = "and") {
  const A = t.getFieldNames(), s = e[0].reduce(
    (o, r, a) => (A.includes(r) && (o[r] = e[1][a]), o),
    {}
  );
  return Object.keys(s).length ? {
    conditions: Object.keys(s).map((o) => ({
      field: o,
      value: J.isInvalid(s[o]) ? null : s[o],
      operator: i
    })),
    operator: n
  } : {
    field: A[0],
    value: [],
    operator: "in"
  };
}
function IH(e, t) {
  return e.reduce(
    (i, n, A) => {
      const s = t ? n[t] : n;
      return i[s] = A, i;
    },
    {}
  );
}
function Ja(e, t) {
  function i(n) {
    return typeof n == "object" && n != null;
  }
  if (e === t)
    return !0;
  if (i(e) && i(t)) {
    if (Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const n in e)
      if (!Ja(e[n], t[n]))
        return !1;
    return !0;
  }
  return !1;
}
function CH(e) {
  return e == null ? e : typeof e == "object" ? e.field : e;
}
function Pc(e, t) {
  e = e || [], t = t || {};
  const i = {};
  return e.forEach((n) => {
    t.hasOwnProperty(n) && (i[n] = t[n]);
  }), i;
}
function gx(e, t) {
  e = e || [], t = t || {};
  const i = {};
  return Object.keys(t).forEach((n) => {
    e.includes(n) || (i[n] = t[n]);
  }), i;
}
function xf(e, t) {
  return e - t;
}
function EH(e, t) {
  return t - e;
}
const BH = function() {
  const e = {}, t = {};
  return {
    startMeasure: (i) => {
      t[i] = performance.now();
    },
    endMeasure: (i) => {
      i in e || (e[i] = 0), e[i] += performance.now() - t[i];
    },
    getTimings: () => e
  };
}();
function ou(e, t) {
  return new Set([...e].filter((i) => !t.has(i)));
}
function RC(e, t) {
  return new Set([...e].filter((i) => t.has(i)));
}
function cr(e, t) {
  return e >= t[0] && e <= t[1];
}
function mH(...e) {
  return () => {
    const t = e.length;
    for (let i = 0; i < t; i++)
      e[i].call(void 0);
  };
}
function QH(e, t, i) {
  const n = e.length;
  return t < n || (e.length = t, e.fill(i, n)), e;
}
function Ka(e, t) {
  const i = [];
  let n, A;
  return e.forEach(({ type: s, domains: o, fieldSubType: r }) => {
    const a = o.map((c) => c.primary.domain), l = o.map((c) => c.secondary.domain);
    r === it.BINNED && t ? (n = te(
      [n || [], te(a, s)],
      s
    ), A = te(
      [
        A || [],
        te(l, s)
      ],
      s
    )) : (n = te(a, s), A = te(l, s)), i.push([n, A]);
  }), i;
}
function hx(e) {
  return e == null;
}
function Ei(e) {
  return J.isInvalid(e) || e === null || e === void 0 ? e : String(e);
}
function js(e, t, i) {
  let n;
  i || (i = {});
  const A = parseInt(e.toString());
  return isNaN(A) ? e.toString() : (typeof t == "function" ? n = t(e, i) : typeof t == "string" ? n = J.isInvalid(e) ? e : J.DateTimeFormatter.formatAs(Number(e), t, i) : n = String(e), J.isInvalid(n) ? n.value() : String(n));
}
function Yn(e, t) {
  return typeof e == "object" && e !== null && t in e;
}
function Ee(e) {
  return J.isInvalid(e) || e === null || e === void 0 || Number.isNaN(e);
}
function Wa(e, t) {
  const i = Ee(e), n = Ee(t);
  return i && n ? !0 : e === t;
}
function pH(e, t, i, n, A, s, o, r) {
  const a = (i - e) * (r - s) - (o - A) * (n - t);
  if (a === 0)
    return !1;
  const l = ((r - s) * (o - e) + (A - o) * (r - t)) / a, c = ((t - n) * (o - e) + (i - e) * (r - t)) / a;
  return 0 < l && l < 1 && 0 < c && c < 1;
}
function Ng(e, t) {
  return e.empty() ? null : e.style(t);
}
function yH(e, t, i = { lineDirection: Mm }) {
  let n = 0;
  const A = t.x, s = t.y, o = i.lineDirection === Mm ? {
    x1: 0,
    y1: s,
    x2: A,
    y2: s
  } : {
    x1: A,
    y1: 0,
    x2: A,
    y2: s
  };
  for (let r = 0; r < e.length - 1; r++) {
    const a = e[r].x, l = e[r].y, c = e[r + 1].x, g = e[r + 1].y;
    pH(
      o.x1,
      o.y1,
      o.x2,
      o.y2,
      a,
      l,
      c,
      g
    ) && (n += 1);
  }
  return n % 2 !== 0;
}
function Fg(e, t) {
  return new Array(e).fill(t).join("");
}
const Rg = " , ";
function _r(e) {
  return e.map((t) => Number.isInteger(t) ? t : t.toFixed(2)).join(Rg);
}
function br(e) {
  return !!(e && e.varType() === HI);
}
function ux(e, t) {
  const i = (e[1] - e[0]) / (t - 1), n = Oo(e[0], e[1], i);
  return n?.length && parseFloat((e[1] - n[n.length - 1]).toFixed(5)) < parseFloat(i.toFixed(5)) && n.pop(), n.push(e[1]), n;
}
const Ji = (e, t, i = {
  preserveNullColumns: !1,
  dmSchema: null
}) => {
  if (e = e.filter((c) => c && c.getRowsCount()), !e.length)
    return null;
  const n = /* @__PURE__ */ new Map();
  if (i.dmSchema)
    i.dmSchema.forEach((c) => {
      c.name !== St.ROW_ID && n.set(c.name, c);
    });
  else
    for (let c = 0; c < e.length; c++)
      e[c].getSchema().forEach((u) => {
        u.name !== St.ROW_ID && n.set(u.name, u);
      });
  const A = [];
  for (let c = 0; c < e.length; c++) {
    const g = e[c], h = g.getRowsCount();
    for (let u = 0; u < h; u++) {
      const d = [];
      n.forEach((f, I) => {
        const C = f.subtype, E = g.getValueAtIndex(I, u);
        Ee(E) ? d.push(null) : C === it.CATEGORICAL ? d.push(`${E}`) : d.push(E);
      }), A.push(d);
    }
  }
  const s = A.length ? ae(A) : [[]], o = [...n.values()], r = [], a = [];
  if (s.forEach((c, g) => {
    const h = c.every((u) => u === null);
    (i.preserveNullColumns || !h) && (r.push(o[g]), a.push(c));
  }), t && a.length) {
    const c = a[0].length;
    for (const g in t.data)
      r.find((h) => h.name === g) || (a.push(
        new Array(c).fill(0).map(() => t.data[g])
      ), r.push(t.schema.find(({ name: h }) => h === g)));
  }
  return new J(
    {
      data: a.length ? a : [[]],
      schema: r
    },
    {
      creatorIdentifier: e[0]?.getCreatorIdentifier(),
      ...e[0]?._model._config,
      ...i
    }
  );
}, qn = (e) => {
  if (J.isInvalid(e))
    return e;
  const t = parseInt(e.toString());
  return isNaN(t) ? e.toString() : t;
}, vQ = (e, t) => !(e === lt.CONTINUOUS && (t === it.BINNED || t === it.TEMPORAL)), dx = (e, t, i) => {
  const { field: n, type: A, subtype: s } = e;
  if (t.colFacets[n] === t.rowTotalString || t.rowFacets[n] === t.columnTotalString)
    return !0;
  const o = i.y.findIndex((a) => `${a}` === n);
  if (t.isRowCollapsed && o !== -1) {
    const a = i.y[o].as();
    return vQ(a, s);
  }
  const r = i.x.findIndex((a) => `${a}` === n);
  if (t.isColCollapsed && r !== -1) {
    const a = i.x[r].as();
    return vQ(a, s);
  }
  return (t.isCollapsed || t.totals) && A === lt.CONTINUOUS && s === it.CONTINUOUS;
}, fx = (e, t) => {
  let i = 0;
  return [QD, pD, yD].forEach((n) => {
    e.totalsAxis[n] && t && i++;
  }), i > 0;
}, yl = (e, t, i) => {
  if (!t.hyperlinkInfo)
    return;
  const {
    hyperlinkInfo: { rel: n, target: A, url: s, styles: o, classNames: r }
  } = t, { defaultClassName: a } = i;
  e.attr("href", s), e.attr("target", A), e.attr("rel", n), e.classed(`${a} ${r}`, !0);
  for (const l in o)
    e.style(l, o[l]);
};
function ru(e, t, i, n) {
  const { totalString: A, subTotalsPosition: s } = n || {
    totalString: "All",
    subTotalsPosition: "end"
  }, { name: o } = e, r = i.getField(o), a = r.type(), l = r.subtype();
  let c = [];
  if (t.type !== gi.NESTED_ORDER) {
    const g = a === "dimension" && l === ug ? r.getAllBins() : r.uniques();
    c = Yc(
      g,
      o,
      t,
      { totalString: A, subTotalsPosition: s },
      i,
      null
    );
  }
  return (g, h) => {
    const u = g.includes(t.totalString) ? g.map((I) => I.toString()) : g, d = g.includes(t.totalString) ? c.map((I) => I.toString()) : c;
    let f;
    return a === "measure" ? f = Yc(
      u,
      o,
      t,
      { totalString: A, subTotalsPosition: s },
      i,
      d,
      h
    ) : a === "dimension" ? d.length === 0 || u.length <= d.length * 0.5 ? f = Yc(
      u,
      o,
      t,
      { totalString: A, subTotalsPosition: s },
      i,
      d,
      h
    ) : f = kg(
      u,
      d
    ) : f = u, s === "start" && f[f.length - 1] === A && (f.pop(), f.unshift(A)), f;
  };
}
function Yc(e, t, i, n, A, s, o = []) {
  const r = A.getField(t), a = r.subtype(), {
    type: l,
    direction: c,
    field: { name: g, aggregation: h },
    nested: {
      filters: u,
      field: { name: d, aggregation: f }
    },
    values: I
  } = i;
  if (l === gi.NATURAL_ORDER) {
    const C = a === it.CONTINUOUS || a === it.TEMPORAL || a === it.CATEGORICAL && r.isNaturallyNumeric() || a === it.BINNED;
    return Ix(e, {
      isNumericalData: C,
      sortDirection: c,
      totalString: n.totalString
    });
  } else {
    if (l === gi.ALPHABETICAL_ORDER)
      return Cx(e, {
        fieldSubtype: a,
        sortDirection: c,
        temporalFieldFormat: a === "temporal" ? r.schema().format : null,
        totalString: n.totalString
      });
    if (l === gi.FIELD_ORDER)
      if (g) {
        if (!s) {
          const C = h ? [{ field: g, aggn: h }] : [];
          s = A.project([t, g]).groupBy([t], C).sort([[g, c]]).getField(t).uniques();
        }
        return kg(e, s);
      } else
        return [...e];
    else {
      if (l === gi.CUSTOM_VALUES_ORDER)
        return Ex(e, {
          fieldSubtype: a,
          customValues: I || []
        });
      if (l === gi.NESTED_ORDER) {
        const C = [...u, ...o], E = C.map(({ field: m }) => m);
        let B;
        if (C.length > 0 && (B = Mr(
          [E, C.map(({ value: m }) => m)],
          A
        )), d) {
          const m = A.project([
            ...E,
            t,
            d
          ]), Q = (B == null ? m : m.select(B)).groupBy(
            [...E, t],
            f ? [{ field: d, aggn: f }] : []
          ).sort([[d, c]]).getField(t).uniques();
          return kg(e, Q);
        } else
          return [...e];
      } else
        return [...e];
    }
  }
}
function kg(e, t) {
  const i = e.find((s) => J.isInvalid(s)), n = new Set(e), A = [];
  for (let s = 0; s < t.length; s++) {
    const o = t[s];
    if (!J.isInvalid(o) && n.has(o) ? (A.push(o), n.delete(o)) : J.isInvalid(o) && i && (A.push(i), n.delete(i)), A.length === e.length)
      break;
  }
  return n.size && A.push(...n), A;
}
function Ix(e, t) {
  const { isNumericalData: i, sortDirection: n } = t, A = [...e];
  return i ? A.sort(
    (s, o) => FC(
      n,
      s,
      o
    )
  ) : A.sort(
    (s, o) => NC(
      n,
      s,
      o,
      t.totalString
    )
  );
}
function Cx(e, t) {
  const { fieldSubtype: i, sortDirection: n, temporalFieldFormat: A } = t, s = [...e];
  if (i === it.TEMPORAL) {
    const o = s.reduce((r, a) => (J.isInvalid(a) ? r.set(a, a) : r.set(a, js(a, A)), r), /* @__PURE__ */ new Map());
    return s.sort((r, a) => {
      if (J.isInvalid(r) && J.isInvalid(a))
        return 0;
      if (!J.isInvalid(r) && J.isInvalid(a))
        return n === Vn.ASC ? 1 : -1;
      if (J.isInvalid(r) && !J.isInvalid(a))
        return n === Vn.ASC ? -1 : 1;
      {
        const l = o.get(r), c = o.get(a);
        return n === Vn.ASC ? l.localeCompare(c) : c.localeCompare(l);
      }
    });
  } else
    return s.sort(
      (o, r) => NC(
        n,
        o,
        r,
        t.totalString
      )
    );
}
function Ex(e, t) {
  const { fieldSubtype: i, customValues: n } = t, A = [...e], s = n.reduce((o, r, a) => {
    let l;
    return r === null ? l = r : i === it.CONTINUOUS || i === it.TEMPORAL ? l = Number(r) : i === it.CATEGORICAL ? l = String(r) : l = r, o.set(l, a), o;
  }, /* @__PURE__ */ new Map());
  return A.sort((o, r) => {
    J.isInvalid(o) && (o = null), J.isInvalid(r) && (r = null);
    const a = s.get(o), l = s.get(r);
    return a === void 0 && l === void 0 ? 0 : a === void 0 && l !== void 0 ? 1 : a !== void 0 && l === void 0 ? -1 : a - l;
  });
}
function Nr(e, t) {
  const i = tt(
    {},
    t,
    e || {}
  );
  return ["type", "direction", "field"].forEach((n) => {
    i[n] || (i[n] = t[n]);
  }), i;
}
var Bx = /* @__PURE__ */ ((e) => (e.DISCRETE = "discrete", e.CONTINOUS = "continuous", e))(Bx || {}), mx = /* @__PURE__ */ ((e) => (e.SUM = "sum", e.AVG = "avg", e.MIN = "min", e.MAX = "max", e.FIRST = "first", e.LAST = "last", e.COUNT = "count", e.STD = "std", e))(mx || {});
function ei(e, t) {
  return t ? e.children[0].children[0].data[e.children[0].children[0].data.length - 2] : e.children[0].data[e.children[0].data.length - 1];
}
const Va = (e) => e.value === Da, xa = (e) => {
  const t = e.config().priority === 2;
  return (i) => {
    const n = i.ancestors().slice(0, -1).reverse().map((A) => {
      if (A.height <= (t ? 2 : 1)) {
        const s = ei(
          i,
          i.height > 1
        ).source();
        return typeof s == "object" && s !== null ? {
          field: s.config().field,
          sourceType: s.config().metaInf.sourceType
        } : e.getNodeInfo(A, "muze-row-header");
      } else
        return e.getNodeInfo(A, "muze-corner");
    }).filter((A) => A != null);
    return n.length > 0 && Va(n[n.length - 1]) ? n : n.filter((A) => !Va(A));
  };
}, kC = (e, t) => {
  const i = J.isInvalid(e) ? null : e, n = J.isInvalid(t) ? null : t;
  return i === n;
}, DH = (e, t) => typeof e.value < "u" && typeof t.value < "u" ? e.field === t.field && kC(e.value, t.value) && e.sourceType === t.sourceType : e.sourceType != null ? e.field === t.field && e.sourceType === t.sourceType : !1, wH = (e, t) => e.field === t.field && kC(e.value, t.value) && e.sourceType === t.sourceType, So = (e, t, { strict: i } = { strict: !1 }) => e.every((n, A) => {
  const s = t[A] == null ? {} : t[A];
  return i ? wH(n, s) : DH(n, s);
}), Tg = (e, t) => typeof e.find(
  (i) => kC(i, t)
) < "u";
var Sf = "http://www.w3.org/1999/xhtml";
const GQ = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Sf,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function au(e) {
  var t = e += "", i = t.indexOf(":");
  return i >= 0 && (t = e.slice(0, i)) !== "xmlns" && (e = e.slice(i + 1)), GQ.hasOwnProperty(t) ? { space: GQ[t], local: e } : e;
}
function xH(e) {
  return function() {
    var t = this.ownerDocument, i = this.namespaceURI;
    return i === Sf && t.documentElement.namespaceURI === Sf ? t.createElement(e) : t.createElementNS(i, e);
  };
}
function SH(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function Qx(e) {
  var t = au(e);
  return (t.local ? SH : xH)(t);
}
function MH() {
}
function TC(e) {
  return e == null ? MH : function() {
    return this.querySelector(e);
  };
}
function _H(e) {
  typeof e != "function" && (e = TC(e));
  for (var t = this._groups, i = t.length, n = new Array(i), A = 0; A < i; ++A)
    for (var s = t[A], o = s.length, r = n[A] = new Array(o), a, l, c = 0; c < o; ++c)
      (a = s[c]) && (l = e.call(a, a.__data__, c, s)) && ("__data__" in a && (l.__data__ = a.__data__), r[c] = l);
  return new Ti(n, this._parents);
}
function bH() {
  return [];
}
function px(e) {
  return e == null ? bH : function() {
    return this.querySelectorAll(e);
  };
}
function NH(e) {
  typeof e != "function" && (e = px(e));
  for (var t = this._groups, i = t.length, n = [], A = [], s = 0; s < i; ++s)
    for (var o = t[s], r = o.length, a, l = 0; l < r; ++l)
      (a = o[l]) && (n.push(e.call(a, a.__data__, l, o)), A.push(a));
  return new Ti(n, A);
}
function yx(e) {
  return function() {
    return this.matches(e);
  };
}
function FH(e) {
  typeof e != "function" && (e = yx(e));
  for (var t = this._groups, i = t.length, n = new Array(i), A = 0; A < i; ++A)
    for (var s = t[A], o = s.length, r = n[A] = [], a, l = 0; l < o; ++l)
      (a = s[l]) && e.call(a, a.__data__, l, s) && r.push(a);
  return new Ti(n, this._parents);
}
function Dx(e) {
  return new Array(e.length);
}
function RH() {
  return new Ti(this._enter || this._groups.map(Dx), this._parents);
}
function vg(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
vg.prototype = {
  constructor: vg,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function kH(e) {
  return function() {
    return e;
  };
}
var LQ = "$";
function TH(e, t, i, n, A, s) {
  for (var o = 0, r, a = t.length, l = s.length; o < l; ++o)
    (r = t[o]) ? (r.__data__ = s[o], n[o] = r) : i[o] = new vg(e, s[o]);
  for (; o < a; ++o)
    (r = t[o]) && (A[o] = r);
}
function vH(e, t, i, n, A, s, o) {
  var r, a, l = {}, c = t.length, g = s.length, h = new Array(c), u;
  for (r = 0; r < c; ++r)
    (a = t[r]) && (h[r] = u = LQ + o.call(a, a.__data__, r, t), u in l ? A[r] = a : l[u] = a);
  for (r = 0; r < g; ++r)
    u = LQ + o.call(e, s[r], r, s), (a = l[u]) ? (n[r] = a, a.__data__ = s[r], l[u] = null) : i[r] = new vg(e, s[r]);
  for (r = 0; r < c; ++r)
    (a = t[r]) && l[h[r]] === a && (A[r] = a);
}
function GH(e, t) {
  if (!e)
    return u = new Array(this.size()), l = -1, this.each(function(D) {
      u[++l] = D;
    }), u;
  var i = t ? vH : TH, n = this._parents, A = this._groups;
  typeof e != "function" && (e = kH(e));
  for (var s = A.length, o = new Array(s), r = new Array(s), a = new Array(s), l = 0; l < s; ++l) {
    var c = n[l], g = A[l], h = g.length, u = e.call(c, c && c.__data__, l, n), d = u.length, f = r[l] = new Array(d), I = o[l] = new Array(d), C = a[l] = new Array(h);
    i(c, g, f, I, C, u, t);
    for (var E = 0, B = 0, m, y; E < d; ++E)
      if (m = f[E]) {
        for (E >= B && (B = E + 1); !(y = I[B]) && ++B < d; )
          ;
        m._next = y || null;
      }
  }
  return o = new Ti(o, n), o._enter = r, o._exit = a, o;
}
function LH() {
  return new Ti(this._exit || this._groups.map(Dx), this._parents);
}
function UH(e, t, i) {
  var n = this.enter(), A = this, s = this.exit();
  return n = typeof e == "function" ? e(n) : n.append(e + ""), t != null && (A = t(A)), i == null ? s.remove() : i(s), n && A ? n.merge(A).order() : A;
}
function OH(e) {
  for (var t = this._groups, i = e._groups, n = t.length, A = i.length, s = Math.min(n, A), o = new Array(n), r = 0; r < s; ++r)
    for (var a = t[r], l = i[r], c = a.length, g = o[r] = new Array(c), h, u = 0; u < c; ++u)
      (h = a[u] || l[u]) && (g[u] = h);
  for (; r < n; ++r)
    o[r] = t[r];
  return new Ti(o, this._parents);
}
function HH() {
  for (var e = this._groups, t = -1, i = e.length; ++t < i; )
    for (var n = e[t], A = n.length - 1, s = n[A], o; --A >= 0; )
      (o = n[A]) && (s && o.compareDocumentPosition(s) ^ 4 && s.parentNode.insertBefore(o, s), s = o);
  return this;
}
function PH(e) {
  e || (e = YH);
  function t(g, h) {
    return g && h ? e(g.__data__, h.__data__) : !g - !h;
  }
  for (var i = this._groups, n = i.length, A = new Array(n), s = 0; s < n; ++s) {
    for (var o = i[s], r = o.length, a = A[s] = new Array(r), l, c = 0; c < r; ++c)
      (l = o[c]) && (a[c] = l);
    a.sort(t);
  }
  return new Ti(A, this._parents).order();
}
function YH(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function JH() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function KH() {
  var e = new Array(this.size()), t = -1;
  return this.each(function() {
    e[++t] = this;
  }), e;
}
function WH() {
  for (var e = this._groups, t = 0, i = e.length; t < i; ++t)
    for (var n = e[t], A = 0, s = n.length; A < s; ++A) {
      var o = n[A];
      if (o)
        return o;
    }
  return null;
}
function VH() {
  var e = 0;
  return this.each(function() {
    ++e;
  }), e;
}
function jH() {
  return !this.node();
}
function qH(e) {
  for (var t = this._groups, i = 0, n = t.length; i < n; ++i)
    for (var A = t[i], s = 0, o = A.length, r; s < o; ++s)
      (r = A[s]) && e.call(r, r.__data__, s, A);
  return this;
}
function zH(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function ZH(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function $H(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function XH(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function tP(e, t) {
  return function() {
    var i = t.apply(this, arguments);
    i == null ? this.removeAttribute(e) : this.setAttribute(e, i);
  };
}
function eP(e, t) {
  return function() {
    var i = t.apply(this, arguments);
    i == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, i);
  };
}
function iP(e, t) {
  var i = au(e);
  if (arguments.length < 2) {
    var n = this.node();
    return i.local ? n.getAttributeNS(i.space, i.local) : n.getAttribute(i);
  }
  return this.each((t == null ? i.local ? ZH : zH : typeof t == "function" ? i.local ? eP : tP : i.local ? XH : $H)(i, t));
}
function wx(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function nP(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function AP(e, t, i) {
  return function() {
    this.style.setProperty(e, t, i);
  };
}
function sP(e, t, i) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.style.removeProperty(e) : this.style.setProperty(e, n, i);
  };
}
function oP(e, t, i) {
  return arguments.length > 1 ? this.each((t == null ? nP : typeof t == "function" ? sP : AP)(e, t, i ?? "")) : gr(this.node(), e);
}
function gr(e, t) {
  return e.style.getPropertyValue(t) || wx(e).getComputedStyle(e, null).getPropertyValue(t);
}
function rP(e) {
  return function() {
    delete this[e];
  };
}
function aP(e, t) {
  return function() {
    this[e] = t;
  };
}
function lP(e, t) {
  return function() {
    var i = t.apply(this, arguments);
    i == null ? delete this[e] : this[e] = i;
  };
}
function cP(e, t) {
  return arguments.length > 1 ? this.each((t == null ? rP : typeof t == "function" ? lP : aP)(e, t)) : this.node()[e];
}
function xx(e) {
  return e.trim().split(/^|\s+/);
}
function vC(e) {
  return e.classList || new Sx(e);
}
function Sx(e) {
  this._node = e, this._names = xx(e.getAttribute("class") || "");
}
Sx.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function Mx(e, t) {
  for (var i = vC(e), n = -1, A = t.length; ++n < A; )
    i.add(t[n]);
}
function _x(e, t) {
  for (var i = vC(e), n = -1, A = t.length; ++n < A; )
    i.remove(t[n]);
}
function gP(e) {
  return function() {
    Mx(this, e);
  };
}
function hP(e) {
  return function() {
    _x(this, e);
  };
}
function uP(e, t) {
  return function() {
    (t.apply(this, arguments) ? Mx : _x)(this, e);
  };
}
function dP(e, t) {
  var i = xx(e + "");
  if (arguments.length < 2) {
    for (var n = vC(this.node()), A = -1, s = i.length; ++A < s; )
      if (!n.contains(i[A]))
        return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? uP : t ? gP : hP)(i, t));
}
function fP() {
  this.textContent = "";
}
function IP(e) {
  return function() {
    this.textContent = e;
  };
}
function CP(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function EP(e) {
  return arguments.length ? this.each(e == null ? fP : (typeof e == "function" ? CP : IP)(e)) : this.node().textContent;
}
function BP() {
  this.innerHTML = "";
}
function mP(e) {
  return function() {
    this.innerHTML = e;
  };
}
function QP(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function pP(e) {
  return arguments.length ? this.each(e == null ? BP : (typeof e == "function" ? QP : mP)(e)) : this.node().innerHTML;
}
function yP() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function DP() {
  return this.each(yP);
}
function wP() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function xP() {
  return this.each(wP);
}
function SP(e) {
  var t = typeof e == "function" ? e : Qx(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function MP() {
  return null;
}
function _P(e, t) {
  var i = typeof e == "function" ? e : Qx(e), n = t == null ? MP : typeof t == "function" ? t : TC(t);
  return this.select(function() {
    return this.insertBefore(i.apply(this, arguments), n.apply(this, arguments) || null);
  });
}
function bP() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function NP() {
  return this.each(bP);
}
function FP() {
  var e = this.cloneNode(!1), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function RP() {
  var e = this.cloneNode(!0), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function kP(e) {
  return this.select(e ? RP : FP);
}
function TP(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
var bx = {}, vt = null;
if (typeof document < "u") {
  var vP = document.documentElement;
  "onmouseenter" in vP || (bx = { mouseenter: "mouseover", mouseleave: "mouseout" });
}
function GP(e, t, i) {
  return e = Nx(e, t, i), function(n) {
    var A = n.relatedTarget;
    (!A || A !== this && !(A.compareDocumentPosition(this) & 8)) && e.call(this, n);
  };
}
function Nx(e, t, i) {
  return function(n) {
    var A = vt;
    vt = n;
    try {
      e.call(this, this.__data__, t, i);
    } finally {
      vt = A;
    }
  };
}
function LP(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var i = "", n = t.indexOf(".");
    return n >= 0 && (i = t.slice(n + 1), t = t.slice(0, n)), { type: t, name: i };
  });
}
function UP(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var i = 0, n = -1, A = t.length, s; i < A; ++i)
        s = t[i], (!e.type || s.type === e.type) && s.name === e.name ? this.removeEventListener(s.type, s.listener, s.capture) : t[++n] = s;
      ++n ? t.length = n : delete this.__on;
    }
  };
}
function OP(e, t, i) {
  var n = bx.hasOwnProperty(e.type) ? GP : Nx;
  return function(A, s, o) {
    var r = this.__on, a, l = n(t, s, o);
    if (r) {
      for (var c = 0, g = r.length; c < g; ++c)
        if ((a = r[c]).type === e.type && a.name === e.name) {
          this.removeEventListener(a.type, a.listener, a.capture), this.addEventListener(a.type, a.listener = l, a.capture = i), a.value = t;
          return;
        }
    }
    this.addEventListener(e.type, l, i), a = { type: e.type, name: e.name, value: t, listener: l, capture: i }, r ? r.push(a) : this.__on = [a];
  };
}
function HP(e, t, i) {
  var n = LP(e + ""), A, s = n.length, o;
  if (arguments.length < 2) {
    var r = this.node().__on;
    if (r) {
      for (var a = 0, l = r.length, c; a < l; ++a)
        for (A = 0, c = r[a]; A < s; ++A)
          if ((o = n[A]).type === c.type && o.name === c.name)
            return c.value;
    }
    return;
  }
  for (r = t ? OP : UP, i == null && (i = !1), A = 0; A < s; ++A)
    this.each(r(n[A], t, i));
  return this;
}
function UQ(e, t, i, n) {
  var A = vt;
  e.sourceEvent = vt, vt = e;
  try {
    return t.apply(i, n);
  } finally {
    vt = A;
  }
}
function Fx(e, t, i) {
  var n = wx(e), A = n.CustomEvent;
  typeof A == "function" ? A = new A(t, i) : (A = n.document.createEvent("Event"), i ? (A.initEvent(t, i.bubbles, i.cancelable), A.detail = i.detail) : A.initEvent(t, !1, !1)), e.dispatchEvent(A);
}
function PP(e, t) {
  return function() {
    return Fx(this, e, t);
  };
}
function YP(e, t) {
  return function() {
    return Fx(this, e, t.apply(this, arguments));
  };
}
function JP(e, t) {
  return this.each((typeof t == "function" ? YP : PP)(e, t));
}
var Rx = [null];
function Ti(e, t) {
  this._groups = e, this._parents = t;
}
function qs() {
  return new Ti([[document.documentElement]], Rx);
}
Ti.prototype = qs.prototype = {
  constructor: Ti,
  select: _H,
  selectAll: NH,
  filter: FH,
  data: GH,
  enter: RH,
  exit: LH,
  join: UH,
  merge: OH,
  order: HH,
  sort: PH,
  call: JH,
  nodes: KH,
  node: WH,
  size: VH,
  empty: jH,
  each: qH,
  attr: iP,
  style: oP,
  property: cP,
  classed: dP,
  text: EP,
  html: pP,
  raise: DP,
  lower: xP,
  append: SP,
  insert: _P,
  remove: NP,
  clone: kP,
  datum: TP,
  on: HP,
  dispatch: JP
};
function ze(e) {
  return typeof e == "string" ? new Ti([[document.querySelector(e)]], [document.documentElement]) : new Ti([[e]], Rx);
}
function kx() {
  for (var e = vt, t; t = e.sourceEvent; )
    e = t;
  return e;
}
function GC(e, t) {
  var i = e.ownerSVGElement || e;
  if (i.createSVGPoint) {
    var n = i.createSVGPoint();
    return n.x = t.clientX, n.y = t.clientY, n = n.matrixTransform(e.getScreenCTM().inverse()), [n.x, n.y];
  }
  var A = e.getBoundingClientRect();
  return [t.clientX - A.left - e.clientLeft, t.clientY - A.top - e.clientTop];
}
function LC(e) {
  var t = kx();
  return t.changedTouches && (t = t.changedTouches[0]), GC(e, t);
}
function KP(e, t, i) {
  arguments.length < 3 && (i = t, t = kx().changedTouches);
  for (var n = 0, A = t ? t.length : 0, s; n < A; ++n)
    if ((s = t[n]).identifier === i)
      return GC(e, s);
  return null;
}
var WP = { value: function() {
} };
function UC() {
  for (var e = 0, t = arguments.length, i = {}, n; e < t; ++e) {
    if (!(n = arguments[e] + "") || n in i || /[\s.]/.test(n))
      throw new Error("illegal type: " + n);
    i[n] = [];
  }
  return new Jc(i);
}
function Jc(e) {
  this._ = e;
}
function VP(e, t) {
  return e.trim().split(/^|\s+/).map(function(i) {
    var n = "", A = i.indexOf(".");
    if (A >= 0 && (n = i.slice(A + 1), i = i.slice(0, A)), i && !t.hasOwnProperty(i))
      throw new Error("unknown type: " + i);
    return { type: i, name: n };
  });
}
Jc.prototype = UC.prototype = {
  constructor: Jc,
  on: function(e, t) {
    var i = this._, n = VP(e + "", i), A, s = -1, o = n.length;
    if (arguments.length < 2) {
      for (; ++s < o; )
        if ((A = (e = n[s]).type) && (A = jP(i[A], e.name)))
          return A;
      return;
    }
    if (t != null && typeof t != "function")
      throw new Error("invalid callback: " + t);
    for (; ++s < o; )
      if (A = (e = n[s]).type)
        i[A] = OQ(i[A], e.name, t);
      else if (t == null)
        for (A in i)
          i[A] = OQ(i[A], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var i in t)
      e[i] = t[i].slice();
    return new Jc(e);
  },
  call: function(e, t) {
    if ((A = arguments.length - 2) > 0)
      for (var i = new Array(A), n = 0, A, s; n < A; ++n)
        i[n] = arguments[n + 2];
    if (!this._.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    for (s = this._[e], n = 0, A = s.length; n < A; ++n)
      s[n].value.apply(t, i);
  },
  apply: function(e, t, i) {
    if (!this._.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    for (var n = this._[e], A = 0, s = n.length; A < s; ++A)
      n[A].value.apply(t, i);
  }
};
function jP(e, t) {
  for (var i = 0, n = e.length, A; i < n; ++i)
    if ((A = e[i]).name === t)
      return A.value;
}
function OQ(e, t, i) {
  for (var n = 0, A = e.length; n < A; ++n)
    if (e[n].name === t) {
      e[n] = WP, e = e.slice(0, n).concat(e.slice(n + 1));
      break;
    }
  return i != null && e.push({ name: t, value: i }), e;
}
function pd() {
  vt.stopImmediatePropagation();
}
function Po() {
  vt.preventDefault(), vt.stopImmediatePropagation();
}
function qP(e) {
  var t = e.document.documentElement, i = ze(e).on("dragstart.drag", Po, !0);
  "onselectstart" in t ? i.on("selectstart.drag", Po, !0) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
}
function zP(e, t) {
  var i = e.document.documentElement, n = ze(e).on("dragstart.drag", null);
  t && (n.on("click.drag", Po, !0), setTimeout(function() {
    n.on("click.drag", null);
  }, 0)), "onselectstart" in i ? n.on("selectstart.drag", null) : (i.style.MozUserSelect = i.__noselect, delete i.__noselect);
}
function ac(e) {
  return function() {
    return e;
  };
}
function Mf(e, t, i, n, A, s, o, r, a, l) {
  this.target = e, this.type = t, this.subject = i, this.identifier = n, this.active = A, this.x = s, this.y = o, this.dx = r, this.dy = a, this._ = l;
}
Mf.prototype.on = function() {
  var e = this._.on.apply(this._, arguments);
  return e === this._ ? this : e;
};
function ZP() {
  return !vt.ctrlKey && !vt.button;
}
function $P() {
  return this.parentNode;
}
function XP(e) {
  return e ?? { x: vt.x, y: vt.y };
}
function tY() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function eY() {
  var e = ZP, t = $P, i = XP, n = tY, A = {}, s = UC("start", "drag", "end"), o = 0, r, a, l, c, g = 0;
  function h(m) {
    m.on("mousedown.drag", u).filter(n).on("touchstart.drag", I).on("touchmove.drag", C).on("touchend.drag touchcancel.drag", E).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function u() {
    if (!(c || !e.apply(this, arguments))) {
      var m = B("mouse", t.apply(this, arguments), LC, this, arguments);
      m && (ze(vt.view).on("mousemove.drag", d, !0).on("mouseup.drag", f, !0), qP(vt.view), pd(), l = !1, r = vt.clientX, a = vt.clientY, m("start"));
    }
  }
  function d() {
    if (Po(), !l) {
      var m = vt.clientX - r, y = vt.clientY - a;
      l = m * m + y * y > g;
    }
    A.mouse("drag");
  }
  function f() {
    ze(vt.view).on("mousemove.drag mouseup.drag", null), zP(vt.view, l), Po(), A.mouse("end");
  }
  function I() {
    if (e.apply(this, arguments)) {
      var m = vt.changedTouches, y = t.apply(this, arguments), D = m.length, Q, p;
      for (Q = 0; Q < D; ++Q)
        (p = B(m[Q].identifier, y, KP, this, arguments)) && (pd(), p("start"));
    }
  }
  function C() {
    var m = vt.changedTouches, y = m.length, D, Q;
    for (D = 0; D < y; ++D)
      (Q = A[m[D].identifier]) && (Po(), Q("drag"));
  }
  function E() {
    var m = vt.changedTouches, y = m.length, D, Q;
    for (c && clearTimeout(c), c = setTimeout(function() {
      c = null;
    }, 500), D = 0; D < y; ++D)
      (Q = A[m[D].identifier]) && (pd(), Q("end"));
  }
  function B(m, y, D, Q, p) {
    var w = D(y, m), x, S, _, M = s.copy();
    if (UQ(new Mf(h, "beforestart", x, m, o, w[0], w[1], 0, 0, M), function() {
      return (vt.subject = x = i.apply(Q, p)) == null ? !1 : (S = x.x - w[0] || 0, _ = x.y - w[1] || 0, !0);
    }))
      return function k(T) {
        var G = w, N;
        switch (T) {
          case "start":
            A[m] = k, N = o++;
            break;
          case "end":
            delete A[m], --o;
          case "drag":
            w = D(y, m), N = o;
            break;
        }
        UQ(new Mf(h, T, x, m, N, w[0] + S, w[1] + _, w[0] - G[0], w[1] - G[1], M), M.apply, M, [T, Q, p]);
      };
  }
  return h.filter = function(m) {
    return arguments.length ? (e = typeof m == "function" ? m : ac(!!m), h) : e;
  }, h.container = function(m) {
    return arguments.length ? (t = typeof m == "function" ? m : ac(m), h) : t;
  }, h.subject = function(m) {
    return arguments.length ? (i = typeof m == "function" ? m : ac(m), h) : i;
  }, h.touchable = function(m) {
    return arguments.length ? (n = typeof m == "function" ? m : ac(!!m), h) : n;
  }, h.on = function() {
    var m = s.on.apply(s, arguments);
    return m === s ? h : m;
  }, h.clickDistance = function(m) {
    return arguments.length ? (g = (m = +m) * m, h) : Math.sqrt(g);
  }, h;
}
var hr = 0, Ia = 0, ta = 0, Tx = 1e3, Gg, Ca, Lg = 0, Fs = 0, lu = 0, ja = typeof performance == "object" && performance.now ? performance : Date, vx = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function cu() {
  return Fs || (vx(iY), Fs = ja.now() + lu);
}
function iY() {
  Fs = 0;
}
function Ug() {
  this._call = this._time = this._next = null;
}
Ug.prototype = Gx.prototype = {
  constructor: Ug,
  restart: function(e, t, i) {
    if (typeof e != "function")
      throw new TypeError("callback is not a function");
    i = (i == null ? cu() : +i) + (t == null ? 0 : +t), !this._next && Ca !== this && (Ca ? Ca._next = this : Gg = this, Ca = this), this._call = e, this._time = i, _f();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, _f());
  }
};
function Gx(e, t, i) {
  var n = new Ug();
  return n.restart(e, t, i), n;
}
function nY() {
  cu(), ++hr;
  for (var e = Gg, t; e; )
    (t = Fs - e._time) >= 0 && e._call.call(null, t), e = e._next;
  --hr;
}
function HQ() {
  Fs = (Lg = ja.now()) + lu, hr = Ia = 0;
  try {
    nY();
  } finally {
    hr = 0, sY(), Fs = 0;
  }
}
function AY() {
  var e = ja.now(), t = e - Lg;
  t > Tx && (lu -= t, Lg = e);
}
function sY() {
  for (var e, t = Gg, i, n = 1 / 0; t; )
    t._call ? (n > t._time && (n = t._time), e = t, t = t._next) : (i = t._next, t._next = null, t = e ? e._next = i : Gg = i);
  Ca = e, _f(n);
}
function _f(e) {
  if (!hr) {
    Ia && (Ia = clearTimeout(Ia));
    var t = e - Fs;
    t > 24 ? (e < 1 / 0 && (Ia = setTimeout(HQ, e - ja.now() - lu)), ta && (ta = clearInterval(ta))) : (ta || (Lg = ja.now(), ta = setInterval(AY, Tx)), hr = 1, vx(HQ));
  }
}
function PQ(e, t, i) {
  var n = new Ug();
  return t = t == null ? 0 : +t, n.restart(function(A) {
    n.stop(), e(A + t);
  }, t, i), n;
}
var oY = UC("start", "end", "cancel", "interrupt"), rY = [], Lx = 0, YQ = 1, bf = 2, Kc = 3, JQ = 4, Nf = 5, Wc = 6;
function gu(e, t, i, n, A, s) {
  var o = e.__transition;
  if (!o)
    e.__transition = {};
  else if (i in o)
    return;
  aY(e, i, {
    name: t,
    index: n,
    // For context during callback.
    group: A,
    // For context during callback.
    on: oY,
    tween: rY,
    time: s.time,
    delay: s.delay,
    duration: s.duration,
    ease: s.ease,
    timer: null,
    state: Lx
  });
}
function OC(e, t) {
  var i = Bn(e, t);
  if (i.state > Lx)
    throw new Error("too late; already scheduled");
  return i;
}
function tA(e, t) {
  var i = Bn(e, t);
  if (i.state > Kc)
    throw new Error("too late; already running");
  return i;
}
function Bn(e, t) {
  var i = e.__transition;
  if (!i || !(i = i[t]))
    throw new Error("transition not found");
  return i;
}
function aY(e, t, i) {
  var n = e.__transition, A;
  n[t] = i, i.timer = Gx(s, 0, i.time);
  function s(l) {
    i.state = YQ, i.timer.restart(o, i.delay, i.time), i.delay <= l && o(l - i.delay);
  }
  function o(l) {
    var c, g, h, u;
    if (i.state !== YQ)
      return a();
    for (c in n)
      if (u = n[c], u.name === i.name) {
        if (u.state === Kc)
          return PQ(o);
        u.state === JQ ? (u.state = Wc, u.timer.stop(), u.on.call("interrupt", e, e.__data__, u.index, u.group), delete n[c]) : +c < t && (u.state = Wc, u.timer.stop(), u.on.call("cancel", e, e.__data__, u.index, u.group), delete n[c]);
      }
    if (PQ(function() {
      i.state === Kc && (i.state = JQ, i.timer.restart(r, i.delay, i.time), r(l));
    }), i.state = bf, i.on.call("start", e, e.__data__, i.index, i.group), i.state === bf) {
      for (i.state = Kc, A = new Array(h = i.tween.length), c = 0, g = -1; c < h; ++c)
        (u = i.tween[c].value.call(e, e.__data__, i.index, i.group)) && (A[++g] = u);
      A.length = g + 1;
    }
  }
  function r(l) {
    for (var c = l < i.duration ? i.ease.call(null, l / i.duration) : (i.timer.restart(a), i.state = Nf, 1), g = -1, h = A.length; ++g < h; )
      A[g].call(e, c);
    i.state === Nf && (i.on.call("end", e, e.__data__, i.index, i.group), a());
  }
  function a() {
    i.state = Wc, i.timer.stop(), delete n[t];
    for (var l in n)
      return;
    delete e.__transition;
  }
}
function lY(e, t) {
  var i = e.__transition, n, A, s = !0, o;
  if (i) {
    t = t == null ? null : t + "";
    for (o in i) {
      if ((n = i[o]).name !== t) {
        s = !1;
        continue;
      }
      A = n.state > bf && n.state < Nf, n.state = Wc, n.timer.stop(), n.on.call(A ? "interrupt" : "cancel", e, e.__data__, n.index, n.group), delete i[o];
    }
    s && delete e.__transition;
  }
}
function cY(e) {
  return this.each(function() {
    lY(this, e);
  });
}
function gY(e, t) {
  var i, n;
  return function() {
    var A = tA(this, e), s = A.tween;
    if (s !== i) {
      n = i = s;
      for (var o = 0, r = n.length; o < r; ++o)
        if (n[o].name === t) {
          n = n.slice(), n.splice(o, 1);
          break;
        }
    }
    A.tween = n;
  };
}
function hY(e, t, i) {
  var n, A;
  if (typeof i != "function")
    throw new Error();
  return function() {
    var s = tA(this, e), o = s.tween;
    if (o !== n) {
      A = (n = o).slice();
      for (var r = { name: t, value: i }, a = 0, l = A.length; a < l; ++a)
        if (A[a].name === t) {
          A[a] = r;
          break;
        }
      a === l && A.push(r);
    }
    s.tween = A;
  };
}
function uY(e, t) {
  var i = this._id;
  if (e += "", arguments.length < 2) {
    for (var n = Bn(this.node(), i).tween, A = 0, s = n.length, o; A < s; ++A)
      if ((o = n[A]).name === e)
        return o.value;
    return null;
  }
  return this.each((t == null ? gY : hY)(i, e, t));
}
function HC(e, t, i) {
  var n = e._id;
  return e.each(function() {
    var A = tA(this, n);
    (A.value || (A.value = {}))[t] = i.apply(this, arguments);
  }), function(A) {
    return Bn(A, n).value[t];
  };
}
function Ux(e, t) {
  var i;
  return (typeof t == "number" ? Di : t instanceof _A ? Oa : (i = _A(t)) ? (t = i, Oa) : kD)(e, t);
}
function dY(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function fY(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function IY(e, t, i) {
  var n, A = i + "", s;
  return function() {
    var o = this.getAttribute(e);
    return o === A ? null : o === n ? s : s = t(n = o, i);
  };
}
function CY(e, t, i) {
  var n, A = i + "", s;
  return function() {
    var o = this.getAttributeNS(e.space, e.local);
    return o === A ? null : o === n ? s : s = t(n = o, i);
  };
}
function EY(e, t, i) {
  var n, A, s;
  return function() {
    var o, r = i(this), a;
    return r == null ? void this.removeAttribute(e) : (o = this.getAttribute(e), a = r + "", o === a ? null : o === n && a === A ? s : (A = a, s = t(n = o, r)));
  };
}
function BY(e, t, i) {
  var n, A, s;
  return function() {
    var o, r = i(this), a;
    return r == null ? void this.removeAttributeNS(e.space, e.local) : (o = this.getAttributeNS(e.space, e.local), a = r + "", o === a ? null : o === n && a === A ? s : (A = a, s = t(n = o, r)));
  };
}
function mY(e, t) {
  var i = au(e), n = i === "transform" ? Cv : Ux;
  return this.attrTween(e, typeof t == "function" ? (i.local ? BY : EY)(i, n, HC(this, "attr." + e, t)) : t == null ? (i.local ? fY : dY)(i) : (i.local ? CY : IY)(i, n, t));
}
function QY(e, t) {
  return function(i) {
    this.setAttribute(e, t.call(this, i));
  };
}
function pY(e, t) {
  return function(i) {
    this.setAttributeNS(e.space, e.local, t.call(this, i));
  };
}
function yY(e, t) {
  var i, n;
  function A() {
    var s = t.apply(this, arguments);
    return s !== n && (i = (n = s) && pY(e, s)), i;
  }
  return A._value = t, A;
}
function DY(e, t) {
  var i, n;
  function A() {
    var s = t.apply(this, arguments);
    return s !== n && (i = (n = s) && QY(e, s)), i;
  }
  return A._value = t, A;
}
function wY(e, t) {
  var i = "attr." + e;
  if (arguments.length < 2)
    return (i = this.tween(i)) && i._value;
  if (t == null)
    return this.tween(i, null);
  if (typeof t != "function")
    throw new Error();
  var n = au(e);
  return this.tween(i, (n.local ? yY : DY)(n, t));
}
function xY(e, t) {
  return function() {
    OC(this, e).delay = +t.apply(this, arguments);
  };
}
function SY(e, t) {
  return t = +t, function() {
    OC(this, e).delay = t;
  };
}
function MY(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? xY : SY)(t, e)) : Bn(this.node(), t).delay;
}
function _Y(e, t) {
  return function() {
    tA(this, e).duration = +t.apply(this, arguments);
  };
}
function bY(e, t) {
  return t = +t, function() {
    tA(this, e).duration = t;
  };
}
function NY(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? _Y : bY)(t, e)) : Bn(this.node(), t).duration;
}
function FY(e, t) {
  if (typeof t != "function")
    throw new Error();
  return function() {
    tA(this, e).ease = t;
  };
}
function RY(e) {
  var t = this._id;
  return arguments.length ? this.each(FY(t, e)) : Bn(this.node(), t).ease;
}
function kY(e) {
  typeof e != "function" && (e = yx(e));
  for (var t = this._groups, i = t.length, n = new Array(i), A = 0; A < i; ++A)
    for (var s = t[A], o = s.length, r = n[A] = [], a, l = 0; l < o; ++l)
      (a = s[l]) && e.call(a, a.__data__, l, s) && r.push(a);
  return new $n(n, this._parents, this._name, this._id);
}
function TY(e) {
  if (e._id !== this._id)
    throw new Error();
  for (var t = this._groups, i = e._groups, n = t.length, A = i.length, s = Math.min(n, A), o = new Array(n), r = 0; r < s; ++r)
    for (var a = t[r], l = i[r], c = a.length, g = o[r] = new Array(c), h, u = 0; u < c; ++u)
      (h = a[u] || l[u]) && (g[u] = h);
  for (; r < n; ++r)
    o[r] = t[r];
  return new $n(o, this._parents, this._name, this._id);
}
function vY(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    return i >= 0 && (t = t.slice(0, i)), !t || t === "start";
  });
}
function GY(e, t, i) {
  var n, A, s = vY(t) ? OC : tA;
  return function() {
    var o = s(this, e), r = o.on;
    r !== n && (A = (n = r).copy()).on(t, i), o.on = A;
  };
}
function LY(e, t) {
  var i = this._id;
  return arguments.length < 2 ? Bn(this.node(), i).on.on(e) : this.each(GY(i, e, t));
}
function UY(e) {
  return function() {
    var t = this.parentNode;
    for (var i in this.__transition)
      if (+i !== e)
        return;
    t && t.removeChild(this);
  };
}
function OY() {
  return this.on("end.remove", UY(this._id));
}
function HY(e) {
  var t = this._name, i = this._id;
  typeof e != "function" && (e = TC(e));
  for (var n = this._groups, A = n.length, s = new Array(A), o = 0; o < A; ++o)
    for (var r = n[o], a = r.length, l = s[o] = new Array(a), c, g, h = 0; h < a; ++h)
      (c = r[h]) && (g = e.call(c, c.__data__, h, r)) && ("__data__" in c && (g.__data__ = c.__data__), l[h] = g, gu(l[h], t, i, h, l, Bn(c, i)));
  return new $n(s, this._parents, t, i);
}
function PY(e) {
  var t = this._name, i = this._id;
  typeof e != "function" && (e = px(e));
  for (var n = this._groups, A = n.length, s = [], o = [], r = 0; r < A; ++r)
    for (var a = n[r], l = a.length, c, g = 0; g < l; ++g)
      if (c = a[g]) {
        for (var h = e.call(c, c.__data__, g, a), u, d = Bn(c, i), f = 0, I = h.length; f < I; ++f)
          (u = h[f]) && gu(u, t, i, f, h, d);
        s.push(h), o.push(c);
      }
  return new $n(s, o, t, i);
}
var YY = qs.prototype.constructor;
function JY() {
  return new YY(this._groups, this._parents);
}
function KY(e, t) {
  var i, n, A;
  return function() {
    var s = gr(this, e), o = (this.style.removeProperty(e), gr(this, e));
    return s === o ? null : s === i && o === n ? A : A = t(i = s, n = o);
  };
}
function Ox(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function WY(e, t, i) {
  var n, A = i + "", s;
  return function() {
    var o = gr(this, e);
    return o === A ? null : o === n ? s : s = t(n = o, i);
  };
}
function VY(e, t, i) {
  var n, A, s;
  return function() {
    var o = gr(this, e), r = i(this), a = r + "";
    return r == null && (a = r = (this.style.removeProperty(e), gr(this, e))), o === a ? null : o === n && a === A ? s : (A = a, s = t(n = o, r));
  };
}
function jY(e, t) {
  var i, n, A, s = "style." + t, o = "end." + s, r;
  return function() {
    var a = tA(this, e), l = a.on, c = a.value[s] == null ? r || (r = Ox(t)) : void 0;
    (l !== i || A !== c) && (n = (i = l).copy()).on(o, A = c), a.on = n;
  };
}
function qY(e, t, i) {
  var n = (e += "") == "transform" ? Iv : Ux;
  return t == null ? this.styleTween(e, KY(e, n)).on("end.style." + e, Ox(e)) : typeof t == "function" ? this.styleTween(e, VY(e, n, HC(this, "style." + e, t))).each(jY(this._id, e)) : this.styleTween(e, WY(e, n, t), i).on("end.style." + e, null);
}
function zY(e, t, i) {
  return function(n) {
    this.style.setProperty(e, t.call(this, n), i);
  };
}
function ZY(e, t, i) {
  var n, A;
  function s() {
    var o = t.apply(this, arguments);
    return o !== A && (n = (A = o) && zY(e, o, i)), n;
  }
  return s._value = t, s;
}
function $Y(e, t, i) {
  var n = "style." + (e += "");
  if (arguments.length < 2)
    return (n = this.tween(n)) && n._value;
  if (t == null)
    return this.tween(n, null);
  if (typeof t != "function")
    throw new Error();
  return this.tween(n, ZY(e, t, i ?? ""));
}
function XY(e) {
  return function() {
    this.textContent = e;
  };
}
function t8(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function e8(e) {
  return this.tween("text", typeof e == "function" ? t8(HC(this, "text", e)) : XY(e == null ? "" : e + ""));
}
function i8(e) {
  return function(t) {
    this.textContent = e.call(this, t);
  };
}
function n8(e) {
  var t, i;
  function n() {
    var A = e.apply(this, arguments);
    return A !== i && (t = (i = A) && i8(A)), t;
  }
  return n._value = e, n;
}
function A8(e) {
  var t = "text";
  if (arguments.length < 1)
    return (t = this.tween(t)) && t._value;
  if (e == null)
    return this.tween(t, null);
  if (typeof e != "function")
    throw new Error();
  return this.tween(t, n8(e));
}
function s8() {
  for (var e = this._name, t = this._id, i = Hx(), n = this._groups, A = n.length, s = 0; s < A; ++s)
    for (var o = n[s], r = o.length, a, l = 0; l < r; ++l)
      if (a = o[l]) {
        var c = Bn(a, t);
        gu(a, e, i, l, o, {
          time: c.time + c.delay + c.duration,
          delay: 0,
          duration: c.duration,
          ease: c.ease
        });
      }
  return new $n(n, this._parents, e, i);
}
function o8() {
  var e, t, i = this, n = i._id, A = i.size();
  return new Promise(function(s, o) {
    var r = { value: o }, a = { value: function() {
      --A === 0 && s();
    } };
    i.each(function() {
      var l = tA(this, n), c = l.on;
      c !== e && (t = (e = c).copy(), t._.cancel.push(r), t._.interrupt.push(r), t._.end.push(a)), l.on = t;
    });
  });
}
var r8 = 0;
function $n(e, t, i, n) {
  this._groups = e, this._parents = t, this._name = i, this._id = n;
}
function Hx() {
  return ++r8;
}
var co = qs.prototype;
$n.prototype = {
  constructor: $n,
  select: HY,
  selectAll: PY,
  filter: kY,
  merge: TY,
  selection: JY,
  transition: s8,
  call: co.call,
  nodes: co.nodes,
  node: co.node,
  size: co.size,
  empty: co.empty,
  each: co.each,
  on: LY,
  attr: mY,
  attrTween: wY,
  style: qY,
  styleTween: $Y,
  text: e8,
  textTween: A8,
  remove: OY,
  tween: uY,
  delay: MY,
  duration: NY,
  ease: RY,
  end: o8
};
var Ff = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: Mw
};
function a8(e, t) {
  for (var i; !(i = e.__transition) || !(i = i[t]); )
    if (!(e = e.parentNode))
      return Ff.time = cu(), Ff;
  return i;
}
function l8(e) {
  var t, i;
  e instanceof $n ? (t = e._id, e = e._name) : (t = Hx(), (i = Ff).time = cu(), e = e == null ? null : e + "");
  for (var n = this._groups, A = n.length, s = 0; s < A; ++s)
    for (var o = n[s], r = o.length, a, l = 0; l < r; ++l)
      (a = o[l]) && gu(a, e, t, l, o, i || a8(a, t));
  return new $n(n, this._parents, e, t);
}
qs.prototype.interrupt = cY;
qs.prototype.transition = l8;
const V = (e) => ze(e), j = (e, t, i, n, A = [], s) => {
  const o = e instanceof HTMLElement || e instanceof SVGElement ? V(e) : e, r = n ? n[0] : null;
  let a = null, l = null, c = null, g = null, h = null, u;
  r ? r === "#" ? (a = "id", l = n) : (a = "class", l = n[0] === "." ? n : `.${n}`) : (l = t, u = !0), c = o.selectAll(l), u && (c = c.filter(function() {
    return this.parentNode === o.node();
  })), c = c.data(i, s), g = c.enter().append(t || "div"), A.enter && g.each(function(...f) {
    A.enter(V(this), ...f);
  }), h = g.merge(c), A.update && h.each(function(...f) {
    A.update(V(this), ...f);
  }), a === "class" ? h.classed(
    r === "." ? n.substring(1, n.length) : n,
    !0
  ) : a === "id" && h.attr("id", n.substring(1, n.length));
  const d = c.exit();
  return A.exit ? d.each(function(...f) {
    A.exit(V(this), ...f);
  }) : d.remove(), h;
}, li = (e, t) => (Object.entries(t).forEach((i) => {
  e.style(i[0], i[1]);
}, void 0), e), Px = (e, t) => {
  e.appendChild(t);
}, KQ = (e, t) => {
  for (const i in t)
    ({}).hasOwnProperty.call(t, i) && e.attr(i, t[i]);
}, wA = (e, t, i) => (e instanceof qs || (e = V(e)), i !== void 0 ? e.selectAll(`.${i}`).each(function() {
  KQ(ze(this), t);
}) : KQ(e, t), e), c8 = (e, t, i, n) => {
  ze(e).selectAll(i).each(function(A) {
    const s = ze(this);
    n ? n(A) && s.classed(t, !0) : s.classed(t, !0);
  });
}, g8 = (e, t, i, n) => {
  ze(e).selectAll(i).each(function(A) {
    const s = ze(this);
    n ? n(A) && s.classed(t, !1) : s.classed(t, !1);
  });
}, Pt = (e, t) => {
  e instanceof qs || (e = V(e));
  for (const i in t)
    ({}).hasOwnProperty.call(t, i) && e.style(i, t[i]);
  return e;
}, PC = (e) => {
  const t = ze(e.container);
  let i;
  i = e.data, typeof i == "number" && (i = Array(i).fill(0).map((s, o) => o));
  const n = t.selectAll(e.selector).filter(function() {
    return this.parentNode === t.node();
  }).data(i), A = n.enter().append(e.append).merge(n).each(function(s, o) {
    e.each(s, ze(this), o);
  });
  e.className && A.attr("class", e.className || ""), n.exit().remove();
}, Yx = (e, t, i) => {
  const n = j(
    ze(e),
    "clipPath",
    [1],
    `#${i}`
  );
  j(n, "rect", [1]).attr("x", t.x).attr("y", t.x).attr("width", t.width).attr("height", t.height), n.attr("clip-path", `url(#${i})`);
}, h8 = (e, t) => ze(e).selectAll(t).nodes(), Og = (e, t) => {
  const i = e.getBoundingClientRect();
  return {
    x: t.clientX - i.x,
    y: t.clientY - i.y
  };
}, Cs = (e, t) => {
  const i = GC(e, t);
  return {
    x: i[0],
    y: i[1]
  };
}, Wi = (e) => {
  const t = e.getBoundingClientRect(), i = window.pageXOffset || document.documentElement.scrollLeft, n = window.pageYOffset || document.documentElement.scrollTop;
  return {
    x: t.x + i,
    y: t.y + n,
    width: t.width,
    height: t.height
  };
}, Jx = (e, t) => ze(t).append(e), Bt = () => vt, Fr = () => eY, zn = (e, t) => {
  let i;
  const n = "W", A = {
    "fill-opacity": 0
  }, s = typeof t == "string" ? t : t instanceof Array ? t.join(" ") : void 0;
  e.node() instanceof HTMLElement ? i = e.append("div").html(n) : i = e.append("text").text(n), s ? i.attr("class", s) : typeof t == "object" && (delete t["fill-opacity"], tt(A, t)), li(i, A);
  const o = window.getComputedStyle(i.node()), r = {
    fontSize: o.fontSize,
    fontFamily: o.fontFamily,
    fontWeight: o.fontWeight,
    fontStyle: o.fontStyle,
    fontVariant: o.fontVariant
  };
  return i.remove(), r;
}, YC = () => "ontouchstart" in document.documentElement;
var Kx = { exports: {} };
(function(e, t) {
  (function(i, n) {
    e.exports = n();
  })(window, function() {
    return function(i) {
      var n = {};
      function A(s) {
        if (n[s])
          return n[s].exports;
        var o = n[s] = { i: s, l: !1, exports: {} };
        return i[s].call(o.exports, o, o.exports, A), o.l = !0, o.exports;
      }
      return A.m = i, A.c = n, A.d = function(s, o, r) {
        A.o(s, o) || Object.defineProperty(s, o, { enumerable: !0, get: r });
      }, A.r = function(s) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
      }, A.t = function(s, o) {
        if (1 & o && (s = A(s)), 8 & o || 4 & o && typeof s == "object" && s && s.__esModule)
          return s;
        var r = /* @__PURE__ */ Object.create(null);
        if (A.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: s }), 2 & o && typeof s != "string")
          for (var a in s)
            A.d(r, a, function(l) {
              return s[l];
            }.bind(null, a));
        return r;
      }, A.n = function(s) {
        var o = s && s.__esModule ? function() {
          return s.default;
        } : function() {
          return s;
        };
        return A.d(o, "a", o), o;
      }, A.o = function(s, o) {
        return Object.prototype.hasOwnProperty.call(s, o);
      }, A.p = "", A(A.s = 0);
    }([function(i, n, A) {
      A.r(n);
      var s = function() {
        function N(b, F) {
          for (var R = 0; R < F.length; R++) {
            var v = F[R];
            v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(b, v.key, v);
          }
        }
        return function(b, F, R) {
          return F && N(b.prototype, F), R && N(b, R), b;
        };
      }(), o = function(N, b) {
        N.forEach(function(F) {
          F != null && (b[F] = 1);
        });
      }, r = function() {
        function N(b) {
          (function(F, R) {
            if (!(F instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, N), this._set = {}, o(b, this._set);
        }
        return s(N, [{ key: "append", value: function(b) {
          return o(b, this._set), this;
        } }, { key: "toArray", value: function() {
          return Object.keys(this._set);
        } }], [{ key: "difference", value: function(b, F) {
          var R = void 0, v = [], O = b._set, L = F._set;
          for (R in O)
            ({}).hasOwnProperty.call(O, R) && (R in L || v.push(R));
          return new N(v);
        } }]), N;
      }(), a = function() {
        function N(b, F) {
          for (var R = 0; R < F.length; R++) {
            var v = F[R];
            v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(b, v.key, v);
          }
        }
        return function(b, F, R) {
          return F && N(b.prototype, F), R && N(b, R), b;
        };
      }(), l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
        return typeof N;
      } : function(N) {
        return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
      };
      function c(N) {
        if (Array.isArray(N)) {
          for (var b = 0, F = Array(N.length); b < N.length; b++)
            F[b] = N[b];
          return F;
        }
        return Array.from(N);
      }
      var g = function(N) {
        if ((N === void 0 ? "undefined" : l(N)) === "object") {
          if (N === null)
            return !1;
          if (Object.prototype.toString.call(N) === "[object Object]")
            return (N.constructor.toString().match(/^function (.*)\(\)/m) || [])[1] === "Object";
        }
        return !1;
      }, h = typeof window > "u" ? {} : window, u = h.requestAnimationFrame || h.webkitRequestAnimationFrame || h.mozRequestAnimationFrame || h.oRequestAnimationFrame || h.msRequestAnimationFrame || function(N) {
        setTimeout(N, 16);
      }, d = function N() {
        return N.__lastTime === (/* @__PURE__ */ new Date()).getTime() ? N.__lastTime.toString() + (N.__id++).toString() : (N.__id = 0, (N.__lastTime = (/* @__PURE__ */ new Date()).getTime()).toString() + (N.__id++).toString());
      }, f = function(N) {
        var b = [];
        return N.forEach(function(F) {
          return b.push.apply(b, c(F));
        }), b;
      }, I = function(N) {
        var b = [], F = null;
        return N = N && typeof N == "function" && N || function() {
        }, function(R, v) {
          [].push.apply(b, R), F === null && (F = u(function() {
            var O = b.slice(0);
            b.length = 0, F = null, function(L) {
              return L.reduce(function(U, H) {
                return H.__id in U.map || (U.map[H.__id] = 1, U.unique.push(H)), U;
              }, { map: {}, unique: [] }).unique;
            }(O).forEach(function(L) {
              return L();
            }), N(v);
          }));
        };
      }, C = function(N) {
        return function() {
          for (var b = arguments.length, F = Array(b), R = 0; R < b; R++)
            F[R] = arguments[R];
          return F.map(function(v) {
            var O = N[v];
            return { name: O.name, qualifiedName: O.qualifiedName, value: O.seed };
          });
        };
      }, E = function() {
        for (var N = arguments.length, b = Array(N), F = 0; F < N; F++)
          b[F] = arguments[F];
        return { dependencies: b.slice(0, b.length - 1), fn: b[b.length - 1] };
      }, B = function(N) {
        var b = [], F = {};
        return N.forEach(function(R) {
          return F[R.qualifiedName] = -1;
        }), function R(v) {
          v.forEach(function(O) {
            var L, U = void 0, H = void 0, z = void 0;
            (L = O.qualifiedName) in F ? (U = F[L]) !== -1 && U !== b.length - 1 && (H = b.slice(0, U), z = b.slice(U + 1), b = H.concat(z), z.forEach(function(et, Z) {
              return F[et.qualifiedName] = Z + H.length;
            }), F[L] = b.push(O) - 1) : F[L] = b.push(O) - 1, R(O.outgoingEdges);
          });
        }(N), b;
      }, m = { accumulate: function() {
        for (var N = arguments.length, b = Array(N), F = 0; F < N; F++)
          b[F] = arguments[F];
        var R = {};
        return b.forEach(function(v) {
          Object.assign(R, function(O, L, U) {
            return L in O ? Object.defineProperty(O, L, { value: U, enumerable: !0, configurable: !0, writable: !0 }) : O[L] = U, O;
          }({}, v.name, v.value));
        }), R;
      }, identity: function(N) {
        return N.value;
      } }, y = function() {
        function N(b) {
          (function(F, R) {
            if (!(F instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, N), this.fn = b, this.dep = [];
        }
        return a(N, [{ key: "addDependencies", value: function() {
          var b;
          return (b = this.dep).push.apply(b, arguments), this;
        } }, { key: "getDependencies", value: function() {
          return this.dep;
        } }, { key: "get", value: function() {
          return this.fn;
        } }]), N;
      }(), D = function() {
        function N(b, F) {
          for (var R = 0; R < F.length; R++) {
            var v = F[R];
            v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(b, v.key, v);
          }
        }
        return function(b, F, R) {
          return F && N(b.prototype, F), R && N(b, R), b;
        };
      }();
      function Q(N) {
        if (Array.isArray(N)) {
          for (var b = 0, F = Array(N.length); b < N.length; b++)
            F[b] = N[b];
          return F;
        }
        return Array.from(N);
      }
      var p = function() {
        function N(b, F, R) {
          (function(v, O) {
            if (!(v instanceof O))
              throw new TypeError("Cannot call a class as a function");
          })(this, N), R = R || {}, this.name = b, this.qualifiedName = F, this.edges = [], this.outgoingEdges = [], this._seed = null, this.requireResolve = !0, this.retriever = R.retriever, this.history = [], this.resolver = null, this.electricEdges = [];
        }
        return D(N, [{ key: "addDependencies", value: function() {
          for (var b, F = this, R = arguments.length, v = Array(R), O = 0; O < R; O++)
            v[O] = arguments[O];
          return (b = this.edges).push.apply(b, v), v.forEach(function(L) {
            return L.outgoingEdges.push(F);
          }), this;
        } }, { key: "addElectricNode", value: function(b) {
          return this.electricEdges.push(b), this;
        } }, { key: "resolve", value: function() {
          return this.seed = this.resolver.apply(this, Q(this.retrieveDetails())), this.history.push(this.seed), this.requireResolve = !1, this;
        } }, { key: "retrieveDetails", value: function() {
          return this.edges.length === 0 ? [{ name: this.name, qualifiedName: this.qualifiedName, value: this.seed }] : this.retriever.apply(this, Q(this.edges.map(function(b) {
            return b.qualifiedName;
          })));
        } }, { key: "repeatHead", value: function() {
          var b = this.history, F = b[b.length - 1];
          return b.length === 0 ? this : (b.push(F), this);
        } }, { key: "flush", value: function() {
          var b = this.history, F = b[b.length - 1];
          return b.length = 0, b.push(F), this;
        } }, { key: "isRoot", value: function() {
          return this.name === null;
        } }, { key: "seed", get: function() {
          return this._seed;
        }, set: function(b) {
          return this._seed = b, this.requireResolve = !0, this;
        } }]), N;
      }(), w = function() {
        function N(b, F) {
          for (var R = 0; R < F.length; R++) {
            var v = F[R];
            v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(b, v.key, v);
          }
        }
        return function(b, F, R) {
          return F && N(b.prototype, F), R && N(b, R), b;
        };
      }(), x = function() {
        function N() {
          (function(b, F) {
            if (!(b instanceof F))
              throw new TypeError("Cannot call a class as a function");
          })(this, N), this.edges = [], this.listeners = { nextFrame: [], currentFrame: [] };
        }
        return w(N, [{ key: "addEdges", value: function() {
          var b;
          return (b = this.edges).push.apply(b, arguments), this;
        } }, { key: "regListenerForCurrFrame", value: function(b) {
          var F = this, R = this.listeners.currentFrame, v = R.push(function(O, L) {
            var U = function() {
              L.apply(void 0, c(O.map(function(H) {
                var z = H.history, et = z.length - 1;
                return [z[et - 1 < 0 ? 0 : et - 1], z[et]];
              })));
            };
            return U.__id = d(), U;
          }(this.edges, b)) - 1;
          return function() {
            F.listeners.currentFrame = R.filter(function(O, L) {
              return L !== v;
            });
          };
        } }, { key: "regListenerForNextFrame", value: function(b) {
          var F = this, R = this.listeners.nextFrame, v = R.push(function(O, L) {
            var U = function() {
              L.apply(void 0, c(O.map(function(H) {
                var z = H.history;
                return [z[0], z[z.length - 1]];
              })));
            };
            return U.__id = d(), U;
          }(this.edges, b)) - 1;
          return function() {
            F.listeners.nextFrame = R.filter(function(O, L) {
              return L !== v;
            });
          };
        } }, { key: "hasNextFrameListener", value: function() {
          return !!this.listeners.nextFrame.length;
        } }]), N;
      }(), S = function() {
        function N(b, F) {
          for (var R = 0; R < F.length; R++) {
            var v = F[R];
            v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(b, v.key, v);
          }
        }
        return function(b, F, R) {
          return F && N(b.prototype, F), R && N(b, R), b;
        };
      }();
      function _(N) {
        if (Array.isArray(N)) {
          for (var b = 0, F = Array(N.length); b < N.length; b++)
            F[b] = N[b];
          return F;
        }
        return Array.from(N);
      }
      var M = function() {
        function N() {
          var b = this;
          (function(F, R) {
            if (!(F instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, N), this.qualifiedNodeMap = {}, this.retriever = C(this.qualifiedNodeMap), this.root = new p(null, null, { retriever: this.retriever }), this.root.resolver = m.accumulate, this._wholeSet = null, this._propagate = !0, this.propagationOverride = { currentFrameListeners: !1, nextFrameListeners: !1 }, this._schedule = I(function(F) {
            var R = void 0;
            for (R in F.flushTarget) {
              if (!{}.hasOwnProperty.call(b.qualifiedNodeMap, R))
                return;
              b.qualifiedNodeMap[R].flush();
            }
          });
        }
        return S(N, [{ key: "createNodesFrom", value: function(b, F) {
          var R = void 0, v = void 0, O = this.qualifiedNodeMap, L = this.root, U = this.retriever;
          return function H(z, et, Z) {
            var Y = void 0, q = void 0, $ = void 0, P = void 0;
            for (Y in z)
              if ({}.hasOwnProperty.call(z, Y))
                if (P = new p(Y, q = "" + et + Y, { retriever: U }), O[q] = P, ($ = Z.perv) !== void 0 ? $.addDependencies(P) : L.addDependencies(P), g(R = z[Y]))
                  H(R, "" + et + Y + ".", { perv: P }), P.resolver = m.accumulate;
                else if (R instanceof y) {
                  var st;
                  P.resolver = R.get(), (st = P).addDependencies.apply(st, _(R.getDependencies().map(function(nt) {
                    return O[nt];
                  })));
                } else
                  P.resolver = m.identity, P.seed = R;
          }(b, F === null ? "" : F + ".", { perv: O[F] }), this._wholeSet = new r(Object.keys(this.qualifiedNodeMap)), (v = this.constructor.getResolvedList(L).concat(L).filter(function(H) {
            return H.requireResolve;
          })).forEach(function(H) {
            return H.resolve();
          }), B(v).forEach(function(H) {
            return H.resolve();
          }), this;
        } }, { key: "getNodeValue", value: function(b) {
          if (b in this.qualifiedNodeMap)
            return this.qualifiedNodeMap[b].seed;
        } }, { key: "createElectricNodeOf", value: function(b, F) {
          var R, v = this, O = b.map(function(U) {
            return v.qualifiedNodeMap[U];
          }), L = (R = new x()).addEdges.apply(R, _(O));
          return O.forEach(function(U) {
            return U.addElectricNode(L);
          }), L["regListenerFor" + F.type](F.fn);
        } }, { key: "update", value: function(b) {
          var F = void 0, R = void 0, v = [], O = b.map(function(ot) {
            return ot[0].seed = ot[1], ot[0];
          });
          O.forEach(function(ot) {
            return ot.resolve();
          });
          var L = !0, U = !1, H = void 0;
          try {
            for (var z, et = f(O.map(function(ot) {
              return ot.electricEdges;
            }))[Symbol.iterator](); !(L = (z = et.next()).done); L = !0) {
              var Z = z.value;
              v.push(Z);
            }
          } catch (ot) {
            U = !0, H = ot;
          } finally {
            try {
              !L && et.return && et.return();
            } finally {
              if (U)
                throw H;
            }
          }
          if (F = new r(O.map(function(ot) {
            return ot.qualifiedName;
          })), !this._propagate)
            return this.__execUniqueElectricEdges(v), this._propagate = !0, this;
          (R = B(O)).forEach(function(ot) {
            return ot.resolve();
          }), F.append(R.map(function(ot) {
            return ot.qualifiedName;
          }));
          var Y = !0, q = !1, $ = void 0;
          try {
            for (var P, st = f(R.map(function(ot) {
              return ot.electricEdges;
            }))[Symbol.iterator](); !(Y = (P = st.next()).done); Y = !0) {
              var nt = P.value;
              v.push(nt);
            }
          } catch (ot) {
            q = !0, $ = ot;
          } finally {
            try {
              !Y && st.return && st.return();
            } finally {
              if (q)
                throw $;
            }
          }
          return this.__execUniqueElectricEdges(Array.from(new Set(v)), F), this;
        } }, { key: "__execUniqueElectricEdges", value: function(b, F) {
          var R = this, v = [], O = [];
          return F && r.difference(this._wholeSet, F).toArray().forEach(function(L) {
            return R.qualifiedNodeMap[L].repeatHead();
          }), b.forEach(function(L) {
            v.push.apply(v, _(L.listeners.currentFrame));
          }), b.forEach(function(L) {
            O.push.apply(O, _(L.listeners.nextFrame));
          }), !this.propagationOverride.currentFrameListeners && v.forEach(function(L) {
            return L();
          }), !this.propagationOverride.nextFrameListeners && this._schedule(O, { flushTarget: F }), this.resetPropagationOverride(), this;
        } }, { key: "resetNodeValue", value: function() {
          for (var b = this, F = arguments.length, R = Array(F), v = 0; v < F; v++)
            R[v] = arguments[v];
          var O = R.map(function(L) {
            return b.qualifiedNodeMap[L];
          }).map(function(L) {
            return [L, L.seed];
          });
          return this.update(O), this;
        } }, { key: "stopPropagation", value: function() {
          return this._propagate = !1, this;
        } }, { key: "resetPropagationOverride", value: function() {
          return this.propagationOverride.currentFrameListeners = !1, this.propagationOverride.nextFrameListeners = !1, this;
        } }, { key: "setPropagationOverride", value: function(b) {
          return this.propagationOverride[b + "Listeners"] = !0, this;
        } }, { key: "getNodeFromQualifiedName", value: function(b) {
          return this.qualifiedNodeMap[b];
        } }], [{ key: "getResolvedList", value: function(b) {
          var F = [];
          return function R(v, O, L) {
            var U = void 0;
            v.edges.forEach(function(H) {
              R(H, O, L);
            }), v.isRoot() || (U = v.qualifiedName) in L || (O.push(v), L[U] = 1);
          }(b, F, {}), F;
        } }]), N;
      }(), k = function() {
        function N(b, F) {
          for (var R = 0; R < F.length; R++) {
            var v = F[R];
            v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(b, v.key, v);
          }
        }
        return function(b, F, R) {
          return F && N(b.prototype, F), R && N(b, R), b;
        };
      }();
      function T(N) {
        if (Array.isArray(N)) {
          for (var b = 0, F = Array(N.length); b < N.length; b++)
            F[b] = N[b];
          return F;
        }
        return Array.from(N);
      }
      var G = function() {
        function N() {
          (function(b, F) {
            if (!(b instanceof F))
              throw new TypeError("Cannot call a class as a function");
          })(this, N), this._graph = new M(), this._lockFlag = !1, this._reqQ = [];
        }
        return k(N, [{ key: "append", value: function() {
          var b = void 0, F = void 0;
          return arguments.length === 1 ? (b = null, F = arguments.length <= 0 ? void 0 : arguments[0]) : (b = arguments.length <= 0 ? void 0 : arguments[0], F = arguments.length <= 1 ? void 0 : arguments[1]), this._addPropInModel(b, F), this;
        } }, { key: "calculatedProp", value: function() {
          var b, F, R, v = void 0, O = void 0, L = void 0;
          return arguments.length > 2 ? (O = arguments.length <= 0 ? void 0 : arguments[0], v = arguments.length <= 1 ? void 0 : arguments[1], L = arguments.length <= 2 ? void 0 : arguments[2]) : (O = null, v = arguments.length <= 0 ? void 0 : arguments[0], L = arguments.length <= 1 ? void 0 : arguments[1]), F = L(E), (b = R = new y(F.fn)).addDependencies.apply(b, T(F.dependencies)), this._addPropInModel(O, function(U, H, z) {
            return H in U ? Object.defineProperty(U, H, { value: z, enumerable: !0, configurable: !0, writable: !0 }) : U[H] = z, U;
          }({}, v, R)), this;
        } }, { key: "_addPropInModel", value: function(b, F) {
          return this._graph.createNodesFrom(F, b), this;
        } }, { key: "on", value: function(b, F, R) {
          var v, O = b instanceof Array ? b : [b], L = this._graph.createElectricNodeOf(O, { type: "CurrFrame", fn: F });
          return R && (v = this._graph.stopPropagation().setPropagationOverride("nextFrame")).resetNodeValue.apply(v, T(b)), L;
        } }, { key: "next", value: function(b, F, R) {
          var v, O = b instanceof Array ? b : [b], L = this._graph.createElectricNodeOf(O, { type: "NextFrame", fn: F });
          return R && (v = this._graph.stopPropagation().setPropagationOverride("currentFrame")).resetNodeValue.apply(v, T(b)), L;
        } }, { key: "lock", value: function() {
          return this._lockFlag = !0, this._reqQ.length = 0, this;
        } }, { key: "unlock", value: function() {
          return this._lockFlag = !1, this.setProp(this._reqQ), this._reqQ.length = 0, this;
        } }, { key: "prop", value: function() {
          var b, F = void 0, R = void 0;
          switch (b = arguments.length) {
            case 1:
              F = arguments.length <= 0 ? void 0 : arguments[0];
              break;
            case 2:
              F = arguments.length <= 0 ? void 0 : arguments[0], R = arguments.length <= 1 ? void 0 : arguments[1];
              break;
            default:
              return this;
          }
          return b === 2 ? (this._lockFlag ? this._reqQ.push([F, R]) : this.setProp([[F, R]]), this) : this._graph.getNodeValue(F);
        } }, { key: "setProp", value: function(b) {
          var F = this;
          return b.length === 0 ? this : (this._graph.update(b.map(function(R) {
            return [F._graph.getNodeFromQualifiedName(R[0]), R[1]];
          })), this);
        } }, { key: "graph", value: function() {
          return this._graph;
        } }, { key: "serialize", value: function() {
          return this._graph.root.seed;
        } }], [{ key: "create", value: function(b) {
          return new N()._addPropInModel(null, b);
        } }]), N;
      }();
      n.default = G;
    }]);
  });
})(Kx);
var u8 = Kx.exports;
const d8 = /* @__PURE__ */ Hy(u8), WQ = (e, t, i, n, A, s) => {
  let o = i;
  Array.isArray(i) || (o = [i]);
  const r = e.model[t](
    o,
    (...l) => {
      e._listeners.size && n(...l);
    },
    A
  ), a = ft(s, e._listeners.size);
  e._listeners.set(a, r);
};
class qa {
  /**
   * Creates an instance of Store.
   * @param {Object} config The object to create the state store with.
   * @memberof Store
   */
  model;
  _listeners;
  _queue;
  _locked;
  constructor(t) {
    this.model = d8.create(t), this._listeners = /* @__PURE__ */ new Map(), this._queue = /* @__PURE__ */ new Map(), this._locked = !1;
  }
  lockModel() {
    return this.model.lock(), this._locked = !0, this;
  }
  unlockModel() {
    return this._locked = !1, this.model.unlock(), this.flushQueue(), this;
  }
  flushQueue() {
    this._queue.forEach((i, n) => {
      const A = i.reduce((s, o) => o(s), this.model.prop(n));
      this.model.prop(n, A);
    }), this._queue.clear();
  }
  /**
   * This method returns a plain JSON object
   * with all the fields in the state store.
   *
   * @return {Object} Serialized representation of state store.
   * @memberof Store
   */
  serialize() {
    return this.model.serialize();
  }
  commit(t, i) {
    if (i instanceof Function)
      if (this._locked) {
        let n = this._queue.get(t);
        n || (n = [], this._queue.set(t, n)), n.push(i);
      } else {
        const n = this.model.prop(t);
        this.model.prop(t, i(n));
      }
    else
      this.model.prop(t, i);
    return this;
  }
  /**
   * This method is used to register a callback that will execute
   * when one or more properties change.
   *
   * @param {string | Array} propNames name of property or array of props.
   * @param {Function} callBack The callback to execute.
   * @memberof Store
   */
  registerChangeListener(t, i, n, A) {
    return WQ(this, "next", t, i, n, A), this;
  }
  /**
   * This method is used to register a callback that will execute
   * when one or more properties change.
   *
   * @param {string | Array} propNames name of property or array of props.
   * @param {Function} callBack The callback to execute.
   * @memberof Store
   */
  registerImmediateListener(t, i, n, A) {
    WQ(this, "on", t, i, n, A);
  }
  /**
   * This method is used to get the name of the property
   * from the state store.
   *
   * @param {string} propName The name of the field in state store.
   * @return {any} The value of the field.
   * @memberof Store
   */
  get(t, i) {
    const n = this.model.prop(t);
    return i ? n && n[i] : n;
  }
  /**
   * This method is used to register a computed property that is computed every time
   * the store value changes.
   *
   * @param {string} propName The name of the property to create.
   * @param {Function} callBack The function to execute when depemdent props change.
   * @memberof Store
   */
  computed(t, i) {
    return this.model.calculatedProp(t, i);
  }
  append(...t) {
    return this.model.append(...t), this;
  }
  unsubscribeAll() {
    return this._listeners.forEach((t) => t()), this._listeners.clear(), this;
  }
  unsubscribe(t) {
    const i = this._listeners.get(t);
    return i && i(), this._listeners.delete(t), this;
  }
}
const Wx = (e, t, i, n = {}) => {
  let A;
  const s = i instanceof qa ? i : new qa({}), o = {}, { namespace: r, subNamespace: a } = n;
  for (const l in t)
    if ({}.hasOwnProperty.call(t, l)) {
      A = t[l];
      const c = r ? `${r}.${l}` : l;
      if (a) {
        const g = ft(s.get(c));
        g[a] = A.value, o[c] = g;
      } else
        o[l] = A.value;
      e[l] = ((g, h, u) => (...d) => {
        if (d.length) {
          const { takesMultipleParams: I = !1 } = h || {};
          let C = I ? d : d[0];
          if (h) {
            let E;
            const B = g.get(u, a), { sanitization: m, typeCheck: y, typeExpected: D } = h;
            typeof m == "function" && (C = m(C, B, e)), typeof y == "function" ? y(C) && (E = C) : typeof y == "string" && y === "constructor" ? C && C.constructor.name === D && (E = C) : E = C;
            const Q = h.preset, p = Fi(g.get(u, a));
            Q && Q(E, e), I && p.forEach((w, x) => {
              E[x] === void 0 && (E[x] = w);
            }), E && g.commit(u, E);
          } else
            g.commit(u, C);
          return e;
        }
        return g.get(u, a);
      })(s, A.meta, c);
    }
  if (a)
    for (const l in o)
      s.commit(l, o[l][a]);
  else
    r === void 0 ? s.append(o) : s.append(r, o);
  return [e, s];
};
var On = { init: function(t) {
  var i = t.document, n = t.navigator, A = n.userAgent, s = "DIV", o = Math.ceil, r = Math.floor, a = "fusioncharts-smartlabel-", l = a + "container", c = a + "tag", g = a + "br";
  return On = { win: t, containerClass: l, classNameWithTag: c, classNameWithTagBR: g, maxDefaultCacheLimit: 1e3, classNameReg: /\bfusioncharts-smartlabel-tag\b/, classNameBrReg: /\bfusioncharts-smartlabel-br\b/, spanAdditionRegx: /(<[^<\>]+?\>)|(&(?:[a-z]+|#[0-9]+);|.)/ig, spanAdditionReplacer: '$1<span class="' + c + '">$2</span>', spanRemovalRegx: new RegExp("\\<span[^\\>]+?" + c + "[^\\>]{0,}\\>(.*?)\\<\\/span\\>", "ig"), xmlTagRegEx: new RegExp("<[^>][^<]*[^>]+>", "i"), brRegex: new RegExp("({br[ ]*})|(<br[ ]*>)|(<br[ ]*/>)|(<BR[ ]*/>)|(<br\\>)", "g"), ltgtquotRegex: /&lt;|&gt;|&quot;|&#034;|&#039;/g, nbspRegex: /&nbsp;|&#160;|&#xA0;/g, htmlSpecialEntityRegex: /&amp;|&quot;|&lt;|&gt;/g, brReplaceRegex: /<br\/>/ig, testStrAvg: "WgI", parentContainerStyle: { position: "absolute", top: "-9999em", whiteSpace: "nowrap", padding: "0px", width: "1px", height: "1px", overflow: "hidden" }, supportedStyle: { font: "font", fontFamily: "font-family", "font-family": "font-family", fontWeight: "font-weight", "font-weight": "font-weight", fontSize: "font-size", "font-size": "font-size", lineHeight: "line-height", "line-height": "line-height", fontStyle: "font-style", "font-style": "font-style" }, getDocumentSupport: function() {
    var u, d, f;
    return i.getElementsByClassName ? (u = "getElementsByClassName", d = c, f = !0) : (u = "getElementsByTagName", d = "span", f = !1), { isIE: /msie/i.test(A) && !t.opera, hasSVG: !!(t.SVGAngle || i.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")), isHeadLess: new RegExp(" HtmlUnit").test(A), isWebKit: new RegExp(" AppleWebKit/").test(A), childRetriverFn: u, childRetriverString: d, noClassTesting: f };
  }, createContainer: function(u) {
    var d, f;
    if (u && (u.offsetWidth || u.offsetHeight)) {
      if (u.appendChild)
        return u.appendChild(f = i.createElement(s)), f.className = l, f.setAttribute("aria-hidden", "true"), f.setAttribute("role", "presentation"), f;
    } else if (d = i.getElementsByTagName("body")[0], d && d.appendChild)
      return f = i.createElement(s), f.className = l, f.setAttribute("aria-hidden", "true"), f.setAttribute("role", "presentation"), d.appendChild(f), f;
  }, getNearestBreakIndex: function(u, d, f) {
    if (!u || !u.length)
      return 0;
    var I, C = f._getWidthFn(), E = 0, B = 0, m = C(u), y = m / u.length;
    if (I = d, E = o(d / y), m < d)
      return u.length - 1;
    for (E > u.length && (I = d - m, E = u.length); I > 0; )
      if (I = d - C(u.substr(0, E)), B = r(I / y), B)
        E += B;
      else
        return E;
    for (; I < 0; )
      if (I = d - C(u.substr(0, E)), B = r(I / y), B)
        E += B;
      else
        return E;
    return E;
  }, parseStyle: function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = {};
    return d.fontSize = (u.fontSize || u["font-size"] || "12px") + "", d.fontVariant = u.fontVariant || u["font-variant"] || "normal", d.fontWeight = u.fontWeight || u["font-weight"] || "normal", d.fontStyle = u.fontStyle || u["font-style"] || "normal", d.fontFamily = u.fontFamily || u["font-family"] || "Verdana,sans", d.fontSize += d.fontSize.indexOf("px") === -1 ? "px" : "", d;
  }, setLineHeight: function(u) {
    var d = u.fontSize;
    return u.lineHeight = u.lineHeight || u["line-height"] || parseInt(d, 10) * 1.2 + "px", u;
  }, _getCleanHeight: function(u) {
    return u = u.replace(/px/g, ""), Number(u);
  }, _getDimentionUsingDiv: function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", d = arguments.length > 1 ? arguments[1] : void 0, f = d._container;
    return u instanceof Array && (u = u.join("")), f.innerHTML = u, { width: f.offsetWidth, height: f.offsetHeight };
  }, _getDimentionUsingCanvas: function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", d = arguments.length > 1 ? arguments[1] : void 0, f = d.ctx, I = d.style, C = On._getCleanHeight(I.lineHeight);
    return u instanceof Array ? (u = u.join(""), u = u.replace(/<br \/>/g, "")) : u = u.replace(/<br \/>/g, ""), { width: f.measureText(u).width, height: C };
  }, _hasOnlyBRTag: function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return !On.xmlTagRegEx.test(u) && On.brRegex.test(u);
  }, _getDimentionOfMultiLineText: function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", d = arguments.length > 1 ? arguments[1] : void 0, f, I, C = u.replace(On.brRegex, "<br />"), E = On._getTextArray(C), B = 0, m = 0, y = d._getWidthFn(), D = On._getCleanHeight(d.style.lineHeight), Q = D, p, w = {};
    for (f = 0, I = E.length; f < I; f++)
      E[f] === "<br />" ? (m = Math.max(m, B), B = 0, Q += D) : (p = y(E[f]), B += p, w[E[f]] = p);
    return m = Math.max(m, B), { height: Q, width: m, detailObj: w };
  }, _getTextArray: function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", d, f, I, C, E, B, m = [];
    for (E = u.split("<br />"), I = E.length, d = 0; d < I; d++) {
      for (B = E[d].split(""), C = B.length, f = 0; f < C; f++)
        m.push(B[f]);
      d !== I - 1 && m.push("<br />");
    }
    return m;
  }, _findLastIndex: function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], d = arguments.length > 1 ? arguments[1] : void 0, f, I = u.length;
    for (f = I - 1; f >= 0; f--)
      if (u[f] === d)
        return f;
    return -1;
  } }, On;
} };
const Vx = On;
var ur = Vx.init(window), Rf = ur.win.document, Vc = ur.getDocumentSupport(), yd = Vc.isWebKit ? 0 : 4.5;
function Rr(e, t, i) {
  var n;
  i = i > 5 ? i : 5, i = i < 20 ? i : 20, this.maxContainers = i, this.first = null, this.last = null, this.containers = {}, this.length = 0, this.rootNode = e, t && (n = Rf.createElementNS("http://www.w3.org/2000/svg", "svg"), n.setAttributeNS("http://www.w3.org/2000/svg", "xlink", "http://www.w3.org/1999/xlink"), n.setAttributeNS("http://www.w3.org/2000/svg", "height", "0"), n.setAttributeNS("http://www.w3.org/2000/svg", "width", "0"), this.svgRoot = n, this.rootNode.appendChild(n));
}
Rr.prototype.get = function(e) {
  var t, i, n, A = this.containers, s = this.length, o = this.maxContainers, r = "";
  for (i in ur.supportedStyle)
    e[i] !== void 0 && (r += ur.supportedStyle[i] + ":" + e[i] + ";");
  if (!r)
    return !1;
  if (n = A[r])
    this.first !== n && (n.prev && (n.prev.next = n.next), n.next && (n.next.prev = n.prev), n.next = this.first, n.next.prev = n, this.last === n && (this.last = n.prev), n.prev = null, this.first = n);
  else {
    if (s >= o)
      for (t = s - o + 1; t--; )
        this.removeContainer(this.last);
    n = this.addContainer(r);
  }
  return n;
};
Rr.prototype._makeDivNode = function(e) {
  var t, i = e.keyStr;
  e.node || (e.node = Rf.createElement("div"), e.node.className = "fusioncharts-div", this.rootNode.appendChild(e.node)), t = e.node, Vc.isIE && !Vc.hasSVG ? t.style.setAttribute("cssText", i) : t.setAttribute("style", i), t.setAttribute("aria-hidden", "true"), t.setAttribute("role", "presentation"), t.style.display = "inline-block", t.innerHTML = ur.testStrAvg, e.lineHeight = t.offsetHeight, e.avgCharWidth = t.offsetWidth / 3, Vc.isBrowserLess ? (e.svgText || (e.svgText = Rf.createElementNS("http://www.w3.org/2000/svg", "text"), this.svgRoot.appendChild(t)), t = e.svgText, t.setAttribute("style", i), t.textContent = ur.testStrAvg, e.lineHeight = t.getBBox().height, e.avgCharWidth = (t.getBBox().width - yd) / 3, t.textContent = "...", e.ellipsesWidth = t.getBBox().width - yd, t.textContent = ".", e.dotWidth = t.getBBox().width - yd) : (t.innerHTML = "...", e.ellipsesWidth = t.offsetWidth, t.innerHTML = ".", e.dotWidth = t.offsetWidth, t.innerHTML = "");
};
Rr.prototype.addContainer = function(e) {
  var t;
  return this.containers[e] = t = { next: null, prev: null, node: null, ellipsesWidth: 0, lineHeight: 0, dotWidth: 0, avgCharWidth: 4, keyStr: e, charCache: {} }, t.next = this.first, t.next && (t.next.prev = t), this.first = t, this.last || (this.last = t), this.length += 1, t;
};
Rr.prototype.removeContainer = function(e) {
  var t = e.keyStr;
  !t || !this.length || !e || (this.length -= 1, e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), this.first === e && (this.first = e.next), this.last === e && (this.last = e.prev), e.node && e.node.parentNode.removeChild(e.node), delete this.containers[t]);
};
Rr.prototype.dispose = function() {
  var e, t = this.containers;
  this.maxContainers = null;
  for (e in t)
    this.removeContainer(t[e]);
  this.rootNode.parentNode.removeChild(this.rootNode), this.rootNode = null, this.first = null, this.last = null;
};
function VQ(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(e, A).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function jQ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VQ(Object(i), !0).forEach(function(n) {
      f8(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : VQ(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function f8(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var pt = Vx.init(window), jx = pt.win.document, qx = pt.win.Math, ts = qx.max, I8 = qx.round, qQ = { " ": "&nbsp;" }, cs = pt.getDocumentSupport(), C8 = cs.isWebKit ? 0 : 4.5;
function Le(e, t, i) {
  var n, A, s, o = !1, r = window.document.createElement("canvas");
  i = i || {}, i.maxCacheLimit = isFinite(s = i.maxCacheLimit) ? s : pt.maxDefaultCacheLimit, typeof e == "string" && (e = jx.getElementById(e)), n = pt.createContainer(e), n.innerHTML = pt.testStrAvg, (cs.isHeadLess || !cs.isIE && !n.offsetHeight && !n.offsetWidth) && (o = !0), n.innerHTML = "";
  for (A in pt.parentContainerStyle)
    n.style[A] = pt.parentContainerStyle[A];
  this.parentContainer = n, this.ctx = r && r.getContext && r.getContext("2d"), this._containerManager = new Rr(n, o, 10), this._showNoEllipses = !t, this._init = !0, this.style = {}, this.oldStyle = {}, this.options = i, this.setStyle();
}
function E8(e, t, i, n, A) {
  for (var s = [], o, r, a, l = []; o = e.exec(i); )
    r = document.createElement("p"), a = o[0] + "Dummy</abbr>", r.innerHTML = a, s.push({ tagName: o[0], index: o.index, title: r.childNodes[0].title ? r.childNodes[0].title : "", endTagName: A });
  for (; o = t.exec(i); )
    l.push({ tagName: A, index: o.index });
  return { tag: s, endtag: l };
}
function B8(e) {
  var t = {};
  if (!e || !e.style || !e.style.cssText)
    return t;
  for (var i = function(l) {
    return l.replace(/(?:^|[-])(\w)/g, function(c, g) {
      return g = c.substr(0, 1) === "-" ? g.toUpperCase() : g, g || "";
    });
  }, n = e.style.cssText.split(";"), A = 0; A < n.length; ++A) {
    var s = n[A].trim();
    if (s) {
      var o = s.split(":"), r = i(o[0].trim());
      t[r] = o[1].trim();
    }
  }
  return t;
}
function m8(e, t, i, n, A) {
  for (var s = [], o, r, a, l, c = []; o = e.exec(i); )
    r = document.createElement("p"), a = o[0] + "Dummy</span>", r.innerHTML = a, l = B8(r.childNodes[0]), s.push({ tagName: o[0], index: o.index, style: l || "", endTagName: A });
  for (; o = t.exec(i); )
    c.push({ tagName: A, index: o.index });
  return { tag: s, endtag: c };
}
function Q8(e, t, i, n, A) {
  for (var s = [], o, r, a, l = []; o = e.exec(i); )
    r = document.createElement("p"), a = o[0] + "</a>", r.innerHTML = a, s.push({ tagName: o[0], index: o.index, href: r.childNodes[0].href ? r.childNodes[0].href : "", target: r.childNodes[0].target ? r.childNodes[0].target : "", hreflang: r.childNodes[0].hreflang ? r.childNodes[0].hreflang : "", referrerpolicy: r.childNodes[0].referrerpolicy ? r.childNodes[0].referrerpolicy : "", rel: r.childNodes[0].rel ? r.childNodes[0].rel : "", endTagName: A });
  for (; o = t.exec(i); )
    l.push({ tagName: A, index: o.index });
  return { tag: s, endtag: l };
}
function Hi(e, t, i, n, A) {
  var s = [], o, r = [];
  if (e)
    for (; o = e.exec(i); )
      s.push({ tagName: n, index: o.index, endTagName: A });
  if (t)
    for (; o = t.exec(i); )
      r.push({ tagName: A, index: o.index });
  return { tag: s, endtag: r };
}
function zx(e, t, i, n, A, s, o, r, a, l, c, g, h, u) {
  var d, f, I = [e, t, i, n, A, s, o, r, a, l, c, g, h, u], C = [];
  for (f = 0; f < I.length; f++)
    for (var E in I[f])
      if (I[f][E].length)
        for (d = 0; d < I[f][E].length; d++)
          C.push(I[f][E][d]);
  return C = C.sort(function(B, m) {
    return B.index - m.index;
  }), C;
}
function jc(e) {
  var t = /<br\s*\/?>/g, i = Hi(t, void 0, e, "<br />", ""), n = zx({}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, i);
  return n;
}
function Yo(e) {
  var t = /<u>/g, i = /<\/u>/g, n = /<b>/g, A = /<\/b>/g, s = /<strong>/g, o = /<\/strong>/g, r = /<em>/g, a = /<\/em>/g, l = /<i>/g, c = /<\/i>/g, g = /<del>/g, h = /<\/del>/g, u = /<s>/g, d = /<\/s>/g, f = /<strike>/g, I = /<\/strike>/g, C = /<sub>/g, E = /<\/sub>/g, B = /<sup>/g, m = /<\/sup>/g, y = /<abbr[\s]+([^>]+)>/g, D = /<\/abbr>/g, Q = /<span[\s]+([^>]+)>/g, p = /<\/span>/g, w = /<a[\s]+([^>]+)>/g, x = /<\/a>/g, S = /<br\s*\/?>/g, _ = Hi(t, i, e, "<u>", "</u>"), M = Hi(n, A, e, "<b>", "</b>"), k = Hi(r, a, e, "<em>", "</em>"), T = Hi(f, I, e, "<strike>", "</strike>"), G = Hi(C, E, e, "<sub>", "</sub>"), N = Hi(B, m, e, "<sup>", "</sup>"), b = E8(y, D, e, "<abbr>", "</abbr>"), F = Q8(w, x, e, "<a>", "</a>"), R = m8(Q, p, e, "<span>", "</span>"), v = Hi(s, o, e, "<strong>", "</strong>"), O = Hi(l, c, e, "<i>", "</i>"), L = Hi(g, h, e, "<del>", "</del>"), U = Hi(u, d, e, "<s>", "</s>"), H = Hi(S, void 0, e, "<br />", ""), z = zx(_, M, k, T, G, N, b, F, R, v, O, L, U, H);
  return z;
}
function CA(e, t, i, n) {
  return t < 0 && (t = e.length + t, t < 0 && (t = 0)), e.slice(0, t) + (n || "") + e.slice(t + i);
}
function p8(e, t, i, n) {
  var A, s, o, r = e, a = i.index, l = i.index, c = i.index + 6;
  if (!t.length)
    return { text: e, charOffset: n };
  for (s = 0, o = t.length - 1, t[s].endTagName && (c = l + t[s].endTagName.length + 6); s <= o; )
    if (t[s].endTagName)
      if (s === o)
        r = CA(r, l, 0, t[s].endTagName), r = CA(r, c, 0, t[s].tagName), a = a + t[s].endTagName.length, l = a - t[s].endTagName.length, c = a + t[s].endTagName.length + 6 + t[s].tagName.length, n += t[s].endTagName.length, n += t[s].tagName.length, s++, o--;
      else if (t[s].endTagName !== t[o].tagName) {
        for (A = s; A <= o; A++)
          if (t[A + 1] && t[s].endTagName === t[A + 1].tagName) {
            s = A + 2;
            break;
          }
        A > o && (r = CA(r, l, 0, t[s].endTagName), r = CA(r, l + t[s].endTagName.length + 6, 0, t[s].tagName), a = a + t[s].endTagName.length, l = l + t[s].endTagName.length, c = a + t[s].endTagName.length + 6 + t[s].tagName.length, n += t[s].endTagName.length, n += t[s].tagName.length, s++);
      } else
        s++, o--;
    else
      s++, o--;
  return { text: r, charOffset: n, newBrIndex: a };
}
function y8(e) {
  var t = jc(e), i, n = 0, A = {}, s, o, r = 0, a;
  if (!e)
    return "";
  if (!t.length)
    return e;
  for (s = t[0].index, i = 0; i < t.length; i++)
    A.charOffset && A.charOffset > 0 ? (s = t[i].index + A.charOffset, t[i].index = s) : s = t[i].index, o = e.substring(r, s), a = Yo(o), n = A.charOffset ? A.charOffset : n, A = p8(e, a, t[i], n), A.newBrIndex && (r = A.newBrIndex + 6), e = A.text;
  return e;
}
function D8(e, t) {
  var i, n = 0, A = e, s = t.length - 1, o = e.length;
  if (!t.length)
    return e;
  for (; n <= s; )
    if (t[n].endTagName)
      if (n === s)
        A = CA(A, o, 0, t[n].endTagName), n++, s--;
      else if (t[n].endTagName !== t[s].tagName) {
        for (i = n; i <= s; i++)
          if (t[i + 1] && t[n].endTagName === t[i + 1].tagName) {
            n = i + 2;
            break;
          }
        i > s && (A = CA(A, o, 0, t[n].endTagName), n++);
      } else
        n++, s--;
    else
      n++, s--;
  return A;
}
function w8(e, t) {
  var i = e, n = t, A = "", s, o = "", r = 0, a, l;
  if (i === n)
    return i;
  if (i === "" && n !== "")
    return n;
  if (n === "" && i !== "")
    return i;
  for (a = 0, l = 0; a < i.length; )
    if (i[a] && !n[l]) {
      A += i.substring(a, i.length);
      break;
    } else if (n[l] && !i[a]) {
      A += n.substring(l, n.length);
      break;
    } else if (i[a] === n[l])
      if (i[a] === "<") {
        for (o = i[a], r = a + 1; r < i.length; ) {
          if (i[r] === ">") {
            o += i[r];
            break;
          }
          o += i[r], r++;
        }
        r >= i.length ? (A += i[a], a++, l++) : (s = Yo(o), s && s.length ? (A += o, a += o.length) : (A += o, a += o.length, l += o.length));
      } else
        A += i[a], a++, l++;
    else if (i[a] === "<") {
      for (o = i[a], r = a + 1; r < i.length; ) {
        if (i[r] === ">") {
          o += i[r];
          break;
        }
        o += i[r], r++;
      }
      r >= i.length ? (A += i[a], a++, l++) : (s = Yo(o), s && s.length ? (A += o, a += o.length) : (A += o, a += o.length, l += o.length));
    } else if (n[l] === "<") {
      for (o = n[l], r = l + 1; r < n.length; ) {
        if (n[r] === ">") {
          o += n[r];
          break;
        }
        o += n[r], r++;
      }
      r >= n.length ? (A += n[l], a++, l++) : (s = Yo(o), s && s.length ? (A += o, l += o.length) : (A += o, a += o.length, l += o.length));
    } else
      i[a] === " " ? a++ : n[l] === " " && l++;
  return A;
}
function zQ(e, t) {
  var i = e, n = Yo(e), A = jc(t), s = jc(e), o, r, a = t, l, c = 0;
  if (e === t)
    return e;
  if (s.length) {
    for (l = 0; l < s.length; l++) {
      for (c = 0, o = s[l].index; e[o] !== ">"; )
        c++, o++;
      e = CA(e, s[l].index, c + 1, ""), s[l + 1] && (r = l + 1, s[l + 1].index -= r * (c + 1));
    }
    if (A.length)
      for (l = 0; l < A.length; l++) {
        for (c = 0, o = A[l].index; a[o] !== ">"; )
          c++, o++;
        a = CA(a, A[l].index, c + 1, "<br />"), A[l + 1] && (r = l + 1, A[l + 1].index -= r * (c + 1), A[l + 1].index += r * 6);
      }
    t = a, i = e, n = Yo(e), A = jc(t);
  }
  if (n.length)
    if (A.length)
      i = w8(e, t), i = y8(i);
    else
      return D8(e, n);
  else
    return t;
  return i;
}
Le.textToLines = function(e) {
  return e = e || {}, e.text ? typeof e.text != "string" && (e.text = e.text.toString()) : e.text = "", e.lines = e.text.split(/\n|<br\s*?\/?>/ig), e;
};
Le.prototype._calCharDimWithCache = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0, i = arguments.length > 2 ? arguments[2] : void 0;
  if (!this._init)
    return !1;
  var n, A, s, o, r, a = this.options.maxCacheLimit, l = this.style || {}, c, g, h, u;
  return c = this._advancedCache = this._advancedCache || (this._advancedCache = {}), g = this._advancedCacheKey || (this._advancedCacheKey = []), h = e + l.fontSize + l.fontFamily + l.fontWeight + l.fontStyle, u = e + "init" + l.fontSize + l.fontFamily + l.fontWeight + l.fontStyle, !this.ctx && qQ[e] && (e = qQ[e]), t ? (r = c[u]) === void 0 && (A = this._getDimention(e.repeat ? e.repeat(i) : Array(i + 1).join(e)).width, s = this._getDimention(e).width, r = c[u] = (A - i * s) / (i + 1), g.push(u), g.length > a && delete c[g.shift()]) : r = 0, (o = c[h]) ? { width: o.width, height: o.height } : (n = this._getDimention(e), n.width += r, c[h] = { width: n.width, height: n.height }, g.push(h), g.length > a && delete c[g.shift()], n);
};
Le.prototype._getDimention = function(e) {
  return this.requireDiv || !this.ctx ? pt._getDimentionUsingDiv(e, this) : pt._getDimentionUsingCanvas(e, this);
};
Le.prototype._getWidthFn = function() {
  var e = this, t = e._containerObj, i = t.svgText;
  return i ? function(n) {
    var A, s;
    return i.textContent = n, A = i.getBBox(), s = A.width - C8, s < 1 && (s = A.width), s;
  } : function(n) {
    return e.requireDiv || !e.ctx ? pt._getDimentionUsingDiv(n, e).width : pt._getDimentionUsingCanvas(n, e).width;
  };
};
Le.prototype._isSameStyle = function() {
  var e = this, t = e.oldStyle || {}, i = e.style;
  return !(i.fontSize !== t.fontSize || i.fontFamily !== t.fontFamily || i.fontStyle !== t.fontStyle || i.fontWeight !== t.fontWeight || i.fontVariant !== t.fontVariant);
};
Le.prototype._setStyleOfCanvas = function() {
  if (!this._isSameStyle()) {
    var e = this, t = e.style, i, n, A = t.fontStyle, s = t.fontVariant, o = t.fontWeight, r = t.fontSize, a = t.fontFamily;
    r += r.indexOf("px") === -1 ? "px" : "", i = A + " " + s + " " + o + " " + r + " " + a, e.ctx.font = i, n = this._containerObj = this._containerManager.get(t), this._containerObj ? (this._container = n.node, this._context = n.context, this._cache = n.charCache, this._lineHeight = n.lineHeight, this._styleNotSet = !1) : this._styleNotSet = !0, n.ellipsesWidth = e._calCharDimWithCache("...", !1).width, n.dotWidth = e._calCharDimWithCache(".", !1).width, n.lineHeight = this._lineHeight = n.lineHeight || pt._getCleanHeight(t.lineHeight), this.oldStyle = t;
  }
};
Le.prototype._setStyleOfDiv = function() {
  var e, t = this.style;
  this._containerObj = e = this._containerManager.get(t), e.node || this._containerManager._makeDivNode(this._containerObj), this._containerObj ? (this._container = e.node, this._context = e.context, this._cache = e.charCache, this._lineHeight = e.lineHeight, this._styleNotSet = !1) : this._styleNotSet = !0;
};
Le.prototype._updateStyle = function() {
  return this.requireDiv || !this.ctx ? this._setStyleOfDiv() : this._setStyleOfCanvas();
};
Le.prototype.setStyle = function(e) {
  return this.style = pt.parseStyle(e), pt.setLineHeight(this.style), this;
};
Le.prototype.useEllipsesOnOverflow = function(e) {
  return this._init ? (this._showNoEllipses = !e, this) : this;
};
Le.prototype.getSmartText = function(e, t, i, n) {
  var A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
  if (!this._init)
    return !1;
  e == null ? e = "" : typeof e != "string" && (e = e.toString());
  var s, o, r, a, l, c, g, h, u, d, f, I, C, E, B, m, y, D, Q, p, w, x, S, _, M, k, T = !1, G = 0, N = -1, b = -1, F = -1, R = 0, v = 0, O = [], L = "", U = 0, H, z = this._showNoEllipses ? "" : "...", et, Z, Y, q, $, P, st = this.ctx, nt = [], ot = -1, Et = -1, ct = -1, ht, Mt, Ue = function(Vt) {
    Vt = Vt.replace(/^\s\s*/, "");
    for (var pi = /\s/, he = Vt.length; pi.test(Vt.charAt(he -= 1)); )
      ;
    return Vt.slice(0, he + 1);
  }, at = { text: e, maxWidth: t, maxHeight: i, width: null, height: null, oriTextWidth: null, oriTextHeight: null, oriText: e, isTruncated: !1 };
  if (T = A.hasHTMLTag !== void 0 ? A.hasHTMLTag : pt.xmlTagRegEx.test(e) || pt.nbspRegex.test(e), ht = pt._hasOnlyBRTag(e), this.requireDiv = T && !ht, this._updateStyle(), et = this._lineHeight, Z = this._context, Y = this._container, q = this._containerObj, $ = q.ellipsesWidth, P = q.dotWidth, c = e.replace(pt.spanAdditionRegx, "$2"), I = this._getWidthFn(), et - i <= 1 && et - i >= 0 && (i *= 1.2), st || Y) {
    if (!cs.isBrowserLess) {
      if (A.cleanText !== !0 ? (a = e = e.replace(pt.ltgtquotRegex, function(Ot) {
        switch (Ot) {
          case "&lt;":
            return "<";
          case "&gt;":
            return ">";
          case "&quot;":
            return '"';
          case "&#034;":
            return '"';
          case "&#039;":
            return "'";
        }
      }), H = e, a = e = a.replace(/<u>/g, "").replace(/<\/u>/g, "").replace(/<b>/g, "").replace(/<\/b>/g, "").replace(/<strong>/g, "").replace(/<\/strong>/g, "").replace(/<em>/g, "").replace(/<\/em>/g, "").replace(/<i>/g, "").replace(/<\/i>/g, "").replace(/<strike>/g, "").replace(/<\/strike>/g, "").replace(/<s>/g, "").replace(/<\/s>/g, "").replace(/<del>/g, "").replace(/<\/del>/g, "").replace(/<sub>/g, "").replace(/<\/sub>/g, "").replace(/<sup>/g, "").replace(/<\/sup>/g, "").replace(/<a[\s]+([^>]+)>/g, "").replace(/<\/a>/g, "").replace(/<abbr[\s]+([^>]+)>/g, "").replace(/<\/abbr>/g, "").replace(/<span[\s]+([^>]+)>/g, "").replace(/<\/span>/g, "")) : (a = e, H = e), T ? ht ? (e = e.replace(pt.brRegex, "<br />"), Mt = pt._getDimentionOfMultiLineText(e, this), at.oriTextWidth = g = Mt.width, at.oriTextHeight = h = Mt.height) : (Y.innerHTML = e, at.oriTextWidth = g = Y.offsetWidth, at.oriTextHeight = h = Y.offsetHeight) : (a = e, A.cleanText !== !0 && (a = e = e.replace(pt.ltgtquotRegex, function(Ot) {
        switch (Ot) {
          case "&lt;":
            return "<";
          case "&gt;":
            return ">";
          case "&quot;":
            return '"';
          case "&#034;":
            return '"';
          case "&#039;":
            return "'";
        }
      }), a = e = a.replace(/<u>/g, "").replace(/<\/u>/g, "").replace(/<b>/g, "").replace(/<\/b>/g, "").replace(/<strong>/g, "").replace(/<\/strong>/g, "").replace(/<em>/g, "").replace(/<\/em>/g, "").replace(/<i>/g, "").replace(/<\/i>/g, "").replace(/<strike>/g, "").replace(/<\/strike>/g, "").replace(/<s>/g, "").replace(/<\/s>/g, "").replace(/<del>/g, "").replace(/<\/del>/g, "").replace(/<sub>/g, "").replace(/<\/sub>/g, "").replace(/<sup>/g, "").replace(/<\/sup>/g, "").replace(/<a[\s]+([^>]+)>/g, "").replace(/<\/a>/g, "").replace(/<abbr[\s]+([^>]+)>/g, "").replace(/<\/abbr>/g, "").replace(/<span[\s]+([^>]+)>/g, "").replace(/<\/span>/g, "")), B = this.getSize(a, !0, { hasHTMLTag: T, hasOnlyBrTag: ht, cleanText: !0 }), at.oriTextWidth = g = B.width, at.oriTextHeight = h = B.height), h <= i && g <= t)
        return L = zQ(H, e), at.text = L, at.width = at.oriTextWidth = g, at.height = at.oriTextHeight = h, at;
      if (et > i)
        return at.text = "", at.width = at.oriTextWidth = 0, at.height = at.oriTextHeight = 0, at;
    }
    if (e = Ue(e).replace(/(\s+)/g, " "), l = this._showNoEllipses ? t : t - $, !T || ht) {
      if (O = pt._getTextArray(e), s = O.length, o = "", r = [], f = O[0], this._cache[f] ? Q = this._cache[f].width : (Q = I(f), this._cache[f] = { width: Q }), l > Q && !ht)
        r = e.substr(0, pt.getNearestBreakIndex(e, l, this)).split("");
      else {
        if (Q > t)
          return at.text = "", at.width = at.oriTextWidth = at.height = at.oriTextHeight = 0, at;
        z && (l = t - 2 * P, l > Q ? z = ".." : (l = t - P, l > Q ? z = "." : (l = 0, z = "")));
      }
      if (U = r.length, R = I(r.join("")), v = this._lineHeight, n) {
        for (; U < s; U += 1) {
          if (f = r[U] = O[U], r[U] === "<br />") {
            v += this._lineHeight, F = U, G = ts(G, R), R = 0, o = null;
            continue;
          }
          if (this._cache[f] ? Q = this._cache[f].width : ((!B || !(Q = B.detailObj[f])) && (Q = I(f)), this._cache[f] = { width: Q }), R += Q, R > l && (o || (o = r.slice(0, -1).join("")), R > t))
            return at.text = Ue(o) + z, at.tooltext = at.oriText, at.width = ts(G, R), at.height = v, at.isTruncated = !0, at;
        }
        return at.text = r.join(""), at.width = ts(G, R), at.height = v, at;
      } else {
        for (; U < s; U += 1) {
          if (f = r[U] = O[U], f === " " && !Z && (f = this.ctx ? " " : "&nbsp;"), r[U] === "<br />") {
            if (G = ts(G, R), v += this._lineHeight, v <= i) {
              F = U, R = 0, o = null;
              continue;
            } else if (v > i)
              return o = r.slice(0, -1).join(""), at.text = Ue(o) + z, at.tooltext = c, at.width = G, at.height = v - this._lineHeight, at.isTruncated = !0, at;
          }
          if (this._cache[f] ? Q = this._cache[f].width : ((!B || !(Q = B.detailObj[f])) && (Q = I(f)), this._cache[f] = { width: Q }), R += Q, R > l && (o || (o = r.slice(0, -1).join("")), R > t)) {
            if (O[U + 1] === "<br />")
              continue;
            if (b = pt._findLastIndex(O.slice(0, r.length), " "), N = pt._findLastIndex(O.slice(0, r.length), "-"), b > F ? (R = I(r.slice(F + 1, b).join("")), r.splice(b, 1, "<br />"), F = b, u = b + 1) : N > F ? (N === r.length - 1 ? (R = I(r.slice(F + 1, b).join("")), r.splice(N, 1, "<br />-")) : (R = I(r.slice(F + 1, b).join("")), r.splice(N, 1, "-<br />")), F = N, u = N + 1) : (r.splice(r.length - 1, 1, "<br />" + O[U]), ct = r.length - 2, R = I(r.slice(F + 1, ct + 1).join("")), F = ct, u = U), v += this._lineHeight, v > i)
              return at.text = Ue(o) + z, at.tooltext = at.oriText, at.width = t, at.height = v - this._lineHeight, at.isTruncated = !0, at;
            G = ts(G, R), o = null, ht ? R = pt._getDimentionOfMultiLineText(r.slice(F + 1).join(""), this).width : (d = pt.getNearestBreakIndex(e.substr(u), l, this), R = I(e.substr(u, d || 1)), r.length < u + d && (r = r.concat(e.substr(r.length, u + d - r.length).split("")), U = r.length - 1));
          }
        }
        return G = ts(G, R), L = zQ(H, r.join("")), at.text = L, at.width = G, at.height = v, at;
      }
    } else {
      for (c = e.replace(pt.spanAdditionRegx, "$2"), e = e.replace(pt.spanAdditionRegx, pt.spanAdditionReplacer), e = e.replace(/(<br\s*\/*\>)/g, '<span class="' + [pt.classNameWithTag, " ", pt.classNameWithTagBR].join("") + '">$1</span>'), Y.innerHTML = e, m = Y[cs.childRetriverFn](cs.childRetriverString), y = 0, D = m.length; y < D; y += 1)
        p = m[y], (cs.noClassTesting || pt.classNameReg.test(p.className)) && (w = p.innerHTML, w !== "" && (w === " " ? Et = nt.length : w === "-" && (ot = nt.length), nt.push({ spaceIdx: Et, dashIdx: ot, elem: p }), O.push(w)));
      if (U = 0, s = nt.length, Q = s && nt[0].elem.offsetWidth, Q > t || !s)
        return at.text = "", at.width = at.oriTextWidth = at.height = at.oriTextHeight = 0, at;
      if (Q > l && !this._showNoEllipses && (l = t - 2 * P, l > Q ? z = ".." : (l = t - P, l > Q ? z = "." : (l = 0, z = ""))), C = nt[0].elem.offsetLeft, E = nt[0].elem.offsetTop, n)
        for (; U < s; U += 1)
          p = nt[U].elem, x = p.offsetLeft - C + p.offsetWidth, x > l && (k || (k = U), Y.offsetWidth > t && (M = U, U = s));
      else
        for (; U < s; U += 1)
          p = nt[U].elem, S = p.offsetHeight + (p.offsetTop - E), x = p.offsetLeft - C + p.offsetWidth, _ = null, x > l ? (k || (k = U), x > t && (b = nt[U].spaceIdx, N = nt[U].dashIdx, b > F ? (nt[b].elem.innerHTML = "<br/>", F = b) : N > F ? (N === U ? nt[N].elem.innerHTML = "<br/>-" : nt[N].elem.innerHTML = "-<br/>", F = N) : p.parentNode.insertBefore(_ = jx.createElement("br"), p), p.offsetHeight + p.offsetTop > i ? (_ ? _.parentNode.removeChild(_) : F === N ? nt[N].elem.innerHTML = "-" : nt[b].elem.innerHTML = " ", M = U, U = s) : k = null)) : S > i && (M = U, U = s);
      if (M < s) {
        for (at.isTruncated = !0, k = k || M, U = s - 1; U >= k; U -= 1)
          p = nt[U].elem, p.parentNode.removeChild(p);
        for (; U >= 0; U -= 1)
          p = nt[U].elem, pt.classNameBrReg.test(p.className) ? p.parentNode.removeChild(p) : U = 0;
      }
      at.text = Y.innerHTML.replace(pt.spanRemovalRegx, "$1").replace(/\&amp\;/g, "&"), at.isTruncated && (at.text += z, at.tooltext = c);
    }
    return at.height = Y.offsetHeight, at.width = Y.offsetWidth, at;
  } else
    return at.error = new Error("Body Tag Missing!"), at;
};
Le.prototype.getSize = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!this._init)
    return !1;
  e == null ? e = "" : typeof e != "string" && (e = e.toString());
  var n, A, s, o, r, a = 0, l = 0, c, g = {}, h = i.hasHTMLTag, u = i.hasOnlyBrTag;
  if (typeof h > "u" && (h = pt.xmlTagRegEx.test(e) || pt.nbspRegex.test(e)), typeof u > "u" && (u = pt._hasOnlyBRTag(e)), this.requireDiv = h && !u, i.cleanText || (e = e.replace(pt.ltgtquotRegex, function(d) {
    switch (d) {
      case "&lt;":
        return "<";
      case "&gt;":
        return ">";
      case "&quot;":
        return '"';
      case "&#034;":
        return '"';
      case "&#039;":
        return "'";
    }
  }), e = e.replace(/<u>/g, "").replace(/<\/u>/g, "").replace(/<b>/g, "").replace(/<\/b>/g, "").replace(/<strong>/g, "").replace(/<\/strong>/g, "").replace(/<em>/g, "").replace(/<\/em>/g, "").replace(/<i>/g, "").replace(/<\/i>/g, "").replace(/<strike>/g, "").replace(/<\/strike>/g, "").replace(/<s>/g, "").replace(/<\/s>/g, "").replace(/<del>/g, "").replace(/<\/del>/g, "").replace(/<sub>/g, "").replace(/<\/sub>/g, "").replace(/<sup>/g, "").replace(/<\/sup>/g, "").replace(/<a[\s]+([^>]+)>/g, "").replace(/<\/a>/g, "").replace(/<abbr[\s]+([^>]+)>/g, "").replace(/<\/abbr>/g, "").replace(/<span[\s]+([^>]+)>/g, "").replace(/<\/span>/g, "")), this._updateStyle(), c = this._container, t)
    for (n = e.split(""), o = 0, r = n.length; o < r; o++)
      A = n[o], s = this._calCharDimWithCache(A, !1, n.length), l = ts(l, s.height), a += s.width, g[A] = s.width;
  else
    return this._calCharDimWithCache(e);
  return u ? jQ(jQ({}, pt._getDimentionOfMultiLineText(e, this)), {}, { detailObj: g }) : h ? (c.innerHTML = e, { width: c.offsetWidth, height: c.offsetHeight, detailObj: g }) : { width: I8(a), height: l, detailObj: g };
};
Le.prototype.getOriSize = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return this.getSize(e, t, i);
};
Le.prototype.dispose = function() {
  return this._init ? (this._containerManager && this._containerManager.dispose && this._containerManager.dispose(), delete this._container, delete this._context, delete this._cache, delete this._containerManager, delete this._containerObj, delete this.id, delete this.style, delete this.parentContainer, delete this._showNoEllipses, this) : this;
};
const x8 = {
  cleanText: !0,
  hasHTMLTag: !1
};
let S8 = class {
  labelManager;
  constructor(t = 1, i = "body") {
    this.labelManager = new Le(t, i);
  }
  static textToLines(t) {
    return Le.textToLines(t);
  }
  getOriSize(t = "") {
    return this.labelManager.getOriSize(t, !0, x8);
  }
  setStyle(t = {}) {
    return this.labelManager.setStyle(t), this;
  }
  useEllipsesOnOverflow(t = !1) {
    return this.labelManager.useEllipsesOnOverflow(t), this;
  }
  getSmartText(t, i, n, A, s = { hasHTMLTag: !1, cleanText: !0 }) {
    return this.labelManager.getSmartText(
      t,
      i,
      n,
      A,
      s
    );
  }
};
const Zx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AggregationType: mx,
  CONSTANTS: wD,
  COORD_TYPES: Xo,
  CommonProps: $o,
  DEFAULT_SORT_CONFIG: xr,
  DUMMY_FIELD_NAME: bt,
  DataModel: Ht,
  DataStore: J,
  Delaunay: iu,
  ERROR_MSG: dt,
  FieldAs: Bx,
  get FieldSubtype() {
    return it;
  },
  get FieldType() {
    return Ct;
  },
  ID_FIELD_NAME: dg,
  Invalid: Ft,
  LabelManager: S8,
  MuzeError: Zi,
  get Operations() {
    return Gt;
  },
  Path: nu,
  RTree: Ns,
  ReservedFields: St,
  SORT_ORDERING_TYPE: gi,
  STATE_NAMESPACES: gL,
  Scales: MC,
  Store: qa,
  Symbols: _i,
  VARIABLE_TYPE_COMPOSED_VAR: HI,
  VARIABLE_TYPE_NULL_VAR: mD,
  VARIABLE_TYPE_SIMPLE_VAR: BD,
  Voronoi: DC,
  addClass: c8,
  angleToRadian: ls,
  appendElement: Px,
  applyHyperLink: yl,
  applyStyle: li,
  arraysEqual: wC,
  cancelAnimFrame: WO,
  capitalizeFirst: VO,
  cellFromLeaf: ei,
  checkExistence: Yw,
  clipElement: Yx,
  clone: QC,
  colorInterpolator: Xw,
  colorSchemes: rf,
  componentRegistry: wa,
  containsTotalsAxis: fx,
  createElement: Jx,
  createElements: PC,
  createSelection: Zw,
  createValuesSorter: ru,
  d3Difference: lr,
  d3Group: Uo,
  d3Hierarchy: Mi,
  d3Hsl: bA,
  d3Max: Ye,
  d3Min: vw,
  d3Mouse: LC,
  d3Range: Oo,
  d3Sum: Te,
  d3Transpose: ae,
  d3Zip: If,
  dataSelect: Uw,
  deepClone: zw,
  deepEquals: Ja,
  defaultValue: ft,
  detectColor: fa,
  difference: dH,
  easeFns: El,
  escapeHTML: Ax,
  extendArray: QH,
  extendsClass: sx,
  extractExcludingKeyValues: gx,
  extractKeyValues: Pc,
  formatTemporal: Vs,
  formatTimestampAs: js,
  genStringOfLength: Fg,
  generateGetterSetters: ge,
  getArrayDiff: aH,
  getArrayIndexMap: nH,
  getArraySum: qw,
  getBinRange: gH,
  getClientPoint: Cs,
  getClosestIndexOf: pC,
  getD3Drag: Fr,
  getDataStore: kT,
  getDependencyOrder: jw,
  getDomainForBinnedField: _C,
  getDomainFromData: PO,
  getElementPosition: Wi,
  getElementsByClassName: h8,
  getEvent: Bt,
  getFormattedBinValue: _r,
  getIndexMap: IH,
  getMax: Cn,
  getMaxPoint: pf,
  getMin: Zn,
  getMinDiff: jO,
  getMinPoint: JO,
  getMousePos: Og,
  getNearestValue: yf,
  getNodeTargetDeterminator: xa,
  getNormalizedFieldName: CH,
  getObjProp: W,
  getQualifiedClassName: _n,
  getQueryFromTarget: Mr,
  getRangeWithSteps: ux,
  getReadableTicks: Sr,
  getSelectionStyle: Ng,
  getSmallestDiff: Au,
  getSmartComputedStyle: zn,
  getSymbol: Bl,
  getUniqueId: Ut,
  getValueParser: bC,
  getWindow: Vw,
  hasMatchingTarget: So,
  hasTargetDomainValue: Tg,
  hasTouch: YC,
  hexToHsv: ix,
  hslInterpolator: XO,
  hslToRgb: tx,
  hslaToRgb: iH,
  hsvToRgb: ex,
  intSanitizer: da,
  interpolateArray: zO,
  interpolator: $w,
  intersect: su,
  intersectAny: fH,
  isComposedVariable: br,
  isEmptyCellTarget: Va,
  isEqual: Is,
  isHTMLElem: qO,
  isIncludesInArray: wf,
  isInvalidValue: Ee,
  isNullOrUndefined: hx,
  isObjectWithKey: Yn,
  isPointInsidePolygon: yH,
  isRetinalFieldCollapsed: dx,
  isSameValue: Wa,
  isSimpleObject: we,
  isValidValue: nx,
  isValueWithinRange: cr,
  makeElement: j,
  mergeFns: mH,
  mergeRecursive: tt,
  mix: _e,
  multiFieldUnionDomain: _g,
  nestCollection: ox,
  nextAnimFrame: hH,
  nextFrame: ZO,
  numberInterpolator: xC,
  numericAsc: xf,
  numericDesc: EH,
  objectIterator: yC,
  parseNumberFromString: qn,
  partition: ax,
  pathInterpolators: ml,
  perfCalculator: BH,
  piecewiseInterpolator: SC,
  pointWithinCircle: cx,
  polygonArea: Lw,
  polygonCentroid: Qf,
  removeClass: g8,
  replaceCSSPrefix: $O,
  reqAnimFrame: KO,
  resolveFieldView: Ve,
  retrieveFieldDisplayName: pl,
  retrieveNearestGroupByReducers: Ql,
  rgbToHsv: Ho,
  sanitizeDomainWhenEqual: Cl,
  sanitizeIP: Jw,
  sanitizeSortConfig: Nr,
  scales: hw,
  selectElement: V,
  setAttrs: wA,
  setDifference: ou,
  setIntersection: RC,
  setStyles: Pt,
  sortCategoricalData: Df,
  sortCategoricalField: NC,
  sortContinuousField: FC,
  sortNumericData: uH,
  sortValues: Yc,
  sortValuesBasedOnOtherValues: kg,
  sortValuesWithAlphabeticalOrderingType: Cx,
  sortValuesWithCustomValuesOrderingType: Ex,
  sortValuesWithNaturalOrderingType: Ix,
  stack: rH,
  symbolFns: Kw,
  throttle: Vd,
  timeDay: Wh,
  timeFormats: rx,
  timeFriday: nC,
  timeHour: Kh,
  timeInterval: Jt,
  timeMillisecond: NA,
  timeMinute: Jh,
  timeMonday: Ar,
  timeMonth: sC,
  timeSaturday: AC,
  timeSecond: FA,
  timeSunday: nr,
  timeThursday: RA,
  timeTuesday: eC,
  timeWednesday: iC,
  timeWeek: nr,
  timeYear: kA,
  toArray: Fi,
  toTextualValue: Ei,
  transactor: Wx,
  transformColor: lx,
  transformColors: tH,
  transposeArray: AH,
  unionAxisDomainsRowColumnWise: Ka,
  unionDomain: te,
  unionExtendDomainDiff: yi,
  unionModels: Ji,
  unique: bg,
  utcDay: qh,
  utcFriday: lC,
  utcHour: jh,
  utcMillisecond: NA,
  utcMinute: Vh,
  utcMonday: or,
  utcMonth: gC,
  utcSaturday: cC,
  utcSecond: FA,
  utcSunday: sr,
  utcThursday: TA,
  utcTuesday: rC,
  utcWednesday: aC,
  utcWeek: sr,
  utcYear: vA
}, Symbol.toStringTag, { value: "Module" })), en = "muze", Nt = "stack", Lt = "stack100percent", gn = "group", En = "identity", M8 = "angle", _8 = "radius", JC = "size", KC = "color", WC = "backgroundColor", VC = "shape", jC = "text", b8 = "detail", N8 = "outerRadiusValue", $x = "middle", yt = {
  X: "x",
  Y: "y",
  X0: "x0",
  Y0: "y0",
  RADIUS: "radius",
  RADIUS0: "radius0",
  ANGLE: "angle",
  ANGLE0: "angle0",
  COLOR: "color",
  BACKGROUND_COLOR: "backgroundColor",
  SHAPE: "shape",
  SIZE: "size",
  TEXT: "text",
  DETAIL: "detail"
}, F8 = "stroke-dasharray", Xx = "asc", qC = "sum", tS = "area", eS = "arc", iS = "line", R8 = "text", nS = "point", zC = "bar", k8 = "tick", T8 = "simple", AS = "base", ZC = "left", $C = "right", mn = "center", XC = "auto", Je = "outside-top", hi = "outside-right", Xn = "outside-bottom", ji = "outside-left", dr = "inside-top", fr = "inside-right", Ir = "inside-bottom", Cr = "inside-left", tE = [
  Je,
  hi,
  Xn,
  ji
], eE = [
  mn,
  dr,
  fr,
  Ir,
  Cr
], sS = 5, oS = 5, rS = 10, aS = 20, lS = 50, cS = 0.35, gS = 0.9, hS = 0.7, uS = 0.5, v8 = "#393945", dS = en + "-text-cell-prop-color-default-dark", fS = en + "-text-cell-prop-color-default-light", IS = en + "-area-border", kf = 2, Jo = 3, ns = 5, za = 1, Hg = "groupPlotHover", Rs = "group-highlight", hu = "group-plot-highlighter", G8 = "vertical", L8 = "horizontal", Er = "percentage", U8 = "value", O8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AGG_FN_SUM: qC,
  ANCHORS_INSIDE: eE,
  ANCHORS_OUTSIDE: tE,
  ANGLE: M8,
  ARC_LAYER: eS,
  AREA_BORDERS_PATH_CLASSNAME: IS,
  AREA_LAYER: tS,
  ASCENDING: Xx,
  AUTO: XC,
  BACKGROUND_COLOR: WC,
  BAR_LAYER: zC,
  BASE_LAYER: AS,
  CENTER: mn,
  CLASSPREFIX: en,
  COLOR: KC,
  DARK_BACKGROUND_FONT_COLOR: v8,
  DETAIL: b8,
  ENCODING: yt,
  EXTRA_RADIUS_PERC: cS,
  GROUP: gn,
  GROUP_HIGHLIGHT_BEHAVIOUR: Rs,
  GROUP_PLOT_HIGHLIGHTER_SIDE_EFFECT: hu,
  GROUP_PLOT_HOVER_PHYSICAL_ACTION: Hg,
  HORIZONTAL: L8,
  IDENTITY: En,
  INSIDE_BOTTOM: Ir,
  INSIDE_LEFT: Cr,
  INSIDE_RIGHT: fr,
  INSIDE_TOP: dr,
  LABEL_PADDING: kf,
  LEFT: ZC,
  LINE_LAYER: iS,
  MAX_ALLOWED_RADIUS_REDUCE_FOR_CLIPPING_IN_PERC: uS,
  MAX_EXTRA_RADIUS: lS,
  MAX_ITERATION_COUNT_ON_GROUPING: sS,
  MAX_LENGTH_FOR_CONNECTOR: gS,
  MAX_LENGTH_FOR_OVERLAPPING_CONNECTOR: hS,
  MIN_EXTRA_RADIUS: aS,
  OUTER_RADIUS_VALUE: N8,
  OUTSIDE_BOTTOM: Xn,
  OUTSIDE_LEFT: ji,
  OUTSIDE_RIGHT: hi,
  OUTSIDE_TOP: Je,
  PERCENTAGE: Er,
  PIVOT_MULTI_TEXT_INNER_CELL_DISTANCE: Jo,
  PIVOT_MULTI_TEXT_OUTER_CELL_BORDER_WIDTH: za,
  PIVOT_MULTI_TEXT_OUTER_CELL_DISTANCE: ns,
  POINT_LAYER: nS,
  RADIUS: _8,
  RIGHT: $C,
  SHAPE: VC,
  SIMPLE_LAYER: T8,
  SIZE: JC,
  STACK: Nt,
  STACK100PERCENT: Lt,
  STROKE_DASHARRAY: F8,
  TEXT: jC,
  TEXT_ANCHOR_MIDDLE: $x,
  TEXT_CELL_CLASSNAME_DARK_FONT_COLOR: dS,
  TEXT_CELL_CLASSNAME_LIGHT_FONT_COLOR: fS,
  TEXT_LABEL_CONNECTOR_CROOK_DISTANCE: rS,
  TEXT_LABEL_VERTICAL_PADDING: oS,
  TEXT_LAYER: R8,
  TICK_LAYER: k8,
  VALUE: U8,
  VERTICAL: G8
}, Symbol.toStringTag, { value: "Module" })), H8 = {}, P8 = {
  executePostPropagation: !1
}, xt = {
  CANVAS: "canvas",
  VISUAL_GROUP: "visualGroup",
  UNIT: "unit",
  LAYER: "layer",
  AXIS: "axis",
  LEGEND: "legend"
}, fe = {
  ALL: "all",
  EACH: "each"
}, gt = {
  INITIALIZED: "initialized",
  BEFORE_RENDERED: "beforeRendered",
  AFTER_RENDERED: "afterRendered",
  BEFORE_LAYOUT: "beforeLayout",
  AFTER_LAYOUT: "afterLayout",
  BEFORE_DISPOSED: "beforeDisposed",
  AFTER_DISPOSED: "afterDisposed",
  ANIMATION_END: "animationEnd"
}, lc = "canvas-aggregate-event-tag", cc = "visual-group-aggregate-event-tag", gc = "visual-unit-aggregate-event-tag";
class Ie {
  constructor(t) {
    const { componentPath: i, modifier: n, hookName: A } = typeof t == "object" ? t : CS(String(t));
    if (!(Array.isArray(i) && i.length && n && A))
      throw new Error("Invalid event name syntax!");
    this.componentPath = i, this.modifier = n, this.hookName = A;
  }
  stringify() {
    return `${this.componentPath.join(":")}.${this.modifier}.${this.hookName}`;
  }
}
const CS = (e) => {
  const t = e.trim().split(".");
  let i, n, A;
  if (t.length === 1)
    i = [], n = fe.EACH, A = t[0];
  else if (t.length === 2)
    i = t[0].split(":"), n = fe.ALL, A = t[1];
  else if (t.length === 3)
    i = t[0].split(":"), n = t[1], A = t[2];
  else
    throw new Error(`Invalid event name, could not parse: ${e}`);
  return {
    componentPath: i,
    modifier: n,
    hookName: A
  };
};
class iE {
  constructor(t, i) {
    this._parent = t || null, this._events = /* @__PURE__ */ new Map(), this._config = tt({}, H8, i || {});
  }
  addListener(t, i, n, A) {
    return this._addAnyListener(t, i, !1, !1, n, A), this;
  }
  on(t, i, n, A) {
    return this.addListener(t, i, n, A), this;
  }
  once(t, i, n, A) {
    return this._addAnyListener(t, i, !0, !1, n, A), this;
  }
  prependListener(t, i, n, A) {
    return this._addAnyListener(t, i, !1, !0, n, A), this;
  }
  prependOnceListener(t, i, n, A) {
    return this._addAnyListener(t, i, !0, !0, n, A), this;
  }
  _addAnyListener(t, i, n, A, s, o) {
    const { executePostPropagation: r } = tt(
      {},
      P8,
      o
    ), a = t.stringify(), l = {
      listener: i,
      once: n,
      meta: s || null,
      executePostPropagation: r
    }, c = this._events.get(a);
    c ? A ? c.unshift(l) : c.push(l) : this._events.set(a, [l]);
  }
  removeListener(t, i) {
    const n = t.stringify(), A = this._events.get(n);
    if (A) {
      for (let s = A.length - 1; s >= 0; s--)
        if (A[s].listener === i) {
          A.splice(s, 1);
          break;
        }
    }
    return this;
  }
  off(t, i) {
    return this.removeListener(t, i), this;
  }
  removeAllListeners(t) {
    const i = t.stringify();
    return this._events.delete(i), this;
  }
  listeners(t) {
    const i = t.stringify();
    return (this._events.get(i) || []).slice();
  }
  eventNames() {
    return [...this._events.keys()].map((t) => new Ie(t));
  }
  listenerCount(t) {
    const i = t.stringify();
    return (this._events.get(i) || []).length;
  }
  emit(t) {
    const i = t.name.stringify(), A = (this._events.get(i) || []).slice(), s = [];
    for (let o = 0; o < A.length; o++) {
      const r = A[o];
      if (r.executePostPropagation) {
        s.push(r);
        continue;
      }
      if (this._triggerSingleListener(r, t), t.isStoppedImmediatePropagation())
        return this;
    }
    t.isStoppedPropagation() || this._parent && this._parent.emit(t);
    for (let o = 0; o < s.length; o++) {
      const r = s[o];
      if (this._triggerSingleListener(r, t), t.isStoppedImmediatePropagation())
        return this;
    }
    return this;
  }
  _triggerSingleListener(t, i) {
    const n = i.name.stringify();
    if (t.once) {
      const A = this._events.get(n) || [], s = A.findIndex(
        (o) => o.listener === t.listener
      );
      A.splice(s, 1);
    }
    try {
      t.listener.call(this, i, t.meta);
    } catch (A) {
      console.error(A);
    }
  }
  remove() {
    this._events.clear();
  }
  createChild(t) {
    return new iE(this, t);
  }
  parent(...t) {
    return t.length ? (this._parent = t[0], this) : this._parent;
  }
  config(...t) {
    return t.length ? (this._config = t[0], this) : this._config;
  }
}
const Y8 = {
  name: null,
  emitter: null,
  target: null,
  data: null,
  virtualScrolling: { viewportRange: null, partialRange: null }
};
class J8 {
  constructor(t) {
    t = tt({}, Y8, t), this.name = t.name, this.emitter = t.emitter, this.target = t.target, this.data = t.data, this.virtualScrolling = t.virtualScrolling, this.timestamp = Date.now(), this._stopPropagation = !1, this._stopImmediatePropagation = !1;
  }
  stopPropagation() {
    this._stopPropagation = !0;
  }
  stopImmediatePropagation() {
    this._stopImmediatePropagation = !0;
  }
  isStoppedPropagation() {
    return this._stopPropagation;
  }
  isStoppedImmediatePropagation() {
    return this._stopImmediatePropagation;
  }
}
const ZQ = (e, t, i, n, A, s) => {
  let o = [null, null], r = [null, null], a, l, c = !1;
  t.forEach((g, h) => {
    g.forEach((u, d) => {
      u && u.eventManager()[s ? "prependListener" : "on"](
        e,
        (f) => {
          const { rowRange: I, colRange: C } = n(), E = (m) => {
            i.call(void 0, {
              eventObjects: m ? [...a, ...m] : a,
              ranges: { rowRange: I, colRange: C }
            });
          };
          if (!($Q(o, I) && $Q(r, C))) {
            o = [...I], r = [...C], a = [], l = /* @__PURE__ */ new Set();
            for (let m = o[0]; m <= o[1]; m++)
              for (let y = r[0]; y <= r[1]; y++)
                t[m] && t[m][y] && l.add(`${m}-${y}`);
            c = !1;
          }
          if (c) {
            E([f]);
            return;
          }
          const B = `${h}-${d}`;
          l.has(B) && (a.push(f), l.delete(B)), l.size === 0 && (E(), c = !0);
        },
        A,
        {
          executePostPropagation: !0
        }
      );
    });
  });
}, $Q = (e, t) => e[0] === t[0] && e[1] === t[1], K8 = (e, t, i, n) => {
  let A, s;
  const o = t.filter((a) => !!a), r = () => {
    A = [], s = /* @__PURE__ */ new Set();
  };
  r(), o.forEach((a) => {
    a.eventManager().on(
      e,
      (l) => {
        s.has(a) && r(), A.push(l), s.add(a), A.length >= o.length && (i.call(void 0, A), r());
      },
      n,
      {
        executePostPropagation: !0
      }
    );
  });
}, eA = () => {
  const e = [];
  return {
    newCallback: () => {
      let t;
      const i = new Promise((n) => {
        t = n;
      });
      return e.push(i), () => {
        t();
      };
    },
    onAllCallbacksCalled: () => Promise.all(e)
  };
}, zs = (e) => class extends e {
  constructor(...t) {
    super(...t), this._eventManager = null;
  }
  eventManager(...t) {
    return t.length ? (this._eventManager = t[0], this) : this._eventManager;
  }
  createChildEventManager(t) {
    return this._eventManager.createChild(t);
  }
  emitEvent(t) {
    if (this._eventManager) {
      const i = tt(
        { emitter: this, target: [this] },
        t
      ), n = new J8(i);
      this._eventManager.emit(n);
    }
  }
  associatedHookComponentPaths() {
    throw new Error("Please implement this method!");
  }
  emitSelfHooks(t, i, n) {
    const A = Array.isArray(t) ? t : [t], s = n || this.associatedHookComponentPaths();
    A.forEach((o) => {
      s.forEach((r) => {
        const a = tt({}, i, {
          name: new Ie({
            componentPath: r,
            modifier: fe.EACH,
            hookName: o
          })
        });
        this.emitEvent(a);
      });
    });
  }
}, ES = (e) => (t) => class extends _e(t).with(zs) {
  constructor(...i) {
    super(...i);
  }
  addListener(i, n, A) {
    return this.eventManager().addListener(
      this._resolveEventName(i),
      n,
      A
    ), this;
  }
  on(i, n, A) {
    return this.eventManager().on(
      this._resolveEventName(i),
      n,
      A
    ), this;
  }
  once(i, n, A) {
    return this.eventManager().once(
      this._resolveEventName(i),
      n,
      A
    ), this;
  }
  prependListener(i, n, A) {
    return this.eventManager().prependListener(
      this._resolveEventName(i),
      n,
      A
    ), this;
  }
  prependOnceListener(i, n, A) {
    return this.eventManager().prependOnceListener(
      this._resolveEventName(i),
      n,
      A
    ), this;
  }
  removeListener(i, n) {
    return this.eventManager().removeListener(
      this._resolveEventName(i),
      n
    ), this;
  }
  off(i, n) {
    return this.eventManager().off(this._resolveEventName(i), n), this;
  }
  removeAllListeners(i) {
    return this.eventManager().removeAllListeners(
      this._resolveEventName(i)
    ), this;
  }
  listeners(i) {
    return this.eventManager().listeners(
      this._resolveEventName(i)
    );
  }
  eventNames() {
    return this.eventManager().eventNames();
  }
  listenerCount(i) {
    return this.eventManager().listenerCount(
      this._resolveEventName(i)
    );
  }
  _resolveEventName(i) {
    const n = CS(i);
    return n.componentPath.length || (n.componentPath = [e]), new Ie(n);
  }
};
class BS {
  formalName() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Sets or gets the dependencies.
   * @param {Object} dependencies Dependencies needed by layer
   * @return {BaseLayer} Instance of base layer.
   */
  dependencies() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Returns the config of the layer
   *
   * @param {Object} config Configuration of layer
   * @return {Object} configuration of layer
   */
  config() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Acts as a getter or setter function
   * When setter
   * Returns the datamodel of the layer
   * @param { DataModel } dataModel instance of DataModel
   * @return { DataModel } DataModel instance of the layer
   */
  data() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Returns a serialized schema of the layer
   * @return {Object} Serialized schema
   */
  serialize() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Returns the unique identifier of this layer
   * @return {string} id of the layer
   */
  id() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /*
   * This method resolves the x, y, x0 and y0 values from the transformed data.
   * It also checks the type of transformed data for example, if it is a stacked data
   * then it fetches the y and y0 values from the stacked data.
   * @param {Array.<Array>} transformedData transformed data
   * @param {Object} fieldMap field definitions
   * @param {string} transformType type of transformed data - stack, group or identity.
   * @return {Array.<Object>} Normalized data
   * @private
   */
  normalizeTransformedData() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Gets the transform method from transform factory based on type of transform. It then calls the
   * transform method with the data and passes the configuration parameters of transform such as
   * groupBy, value field, etc.
   *
   * @param {DataModel} dataModel Instance of dataModel
   * @param {Object} config configuration for transforming data
   * @return {Array.<Array>} Transformed data.
   * @private
   */
  getTransformedData() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Calculates the domain from the data.
   * It checks the type of field and calculates the domain based on that. For example, if it
   * is a quantitative or temporal field, then it calculates the min and max from the data or
   * if it is a nominal field then it gets all the values from the data of that field.
   * @param {Array} data DataArray
   * @return {Array} Domain values array.
   */
  _calculateDomainFromData() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Returns the domain for the axis.
   *
   * @param {string} encodingType type of encoding x, y, color, etc.
   * @return {Object} Axis domains
   */
  getDomain() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Abstract method for getting nearest point
   * @return {BaseLayer} Instance of base layer
   */
  getNearestPoint() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Abstract method for highlighting points
   * @return {BaseLayer} Instance of base layer
   */
  highlightPoint() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Abstract method for deselecting points
   * @return {BaseLayer} Instance of base layer
   */
  dehighlightPoint() {
    return this;
  }
  linkLayerStore() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Sets the container element for the layer to be renderered.
   * @param {SVGElement} mountPoint SVG element or group element.
   */
  mount() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  render() {
    throw new Error(dt.INTERFACE_IMPL);
  }
}
const Ce = "bottom", ie = "top", Se = "left", vi = "right", W8 = {
  [Se]: _i.axisLeft,
  [Ce]: _i.axisBottom,
  [vi]: _i.axisRight,
  [ie]: _i.axisTop
}, ce = "linear", bn = "band", LA = "temporal", nE = "temporalUTC", mS = "color", Mo = "ordinal", QS = "quantize", AE = "quantile", uu = "log", du = "pow", pS = "identity", hA = "sequential", sE = "threshold", yS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAND: bn,
  COLOR: mS,
  IDENTITY: pS,
  LINEAR: ce,
  LOG: uu,
  ORDINAL: Mo,
  POW: du,
  QUANTILE: AE,
  QUANTIZE: QS,
  SEQUENTIAL: hA,
  THRESHOLD: sE,
  TIME: LA,
  UTCTIME: nE
}, Symbol.toStringTag, { value: "Module" })), V8 = "dimension", fu = "categorical", j8 = "measure", Iu = "temporal", fi = "binned", q8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BINNED: fi,
  CATEGORICAL: fu,
  DIMENSION: V8,
  MEASURE: j8,
  TEMPORAL: Iu
}, Symbol.toStringTag, { value: "Module" }));
const Dd = "muze", z8 = "continuous", ci = "continous", oe = "discrete", Z8 = "sequential", Tf = "ordinal", oE = "linear", DS = "band", $8 = "quantize", X8 = "color", t3 = "shape", e3 = "size", i3 = "hidden", Vi = "bottom", cn = "top", n3 = "rgb", A3 = "hex", s3 = "hsla", o3 = "hsl", r3 = [1], Pg = 2, wS = 10, a3 = 6, l3 = 10, As = "right", ss = "left", Pi = "padding", c3 = 6, rE = "direct-sort-target-row-headers", aE = "direct-sort-target-row-band-axis", lE = "direct-sort-target-column-band-axis", xS = "direct-sort-target-row-continuous-axis", SS = "direct-sort-target-column-continuous-axis", MS = "_directSortContainer", _S = "_directSortTarget", bS = 5, g3 = PI, {
  scaleLinear: XQ,
  scaleThreshold: h3,
  scaleLog: u3,
  scalePow: d3,
  scaleIdentity: f3,
  scaleOrdinal: NS,
  scaleSequential: FS,
  scaleQuantize: I3,
  scaleQuantile: C3,
  schemeCategory10: ctt,
  schemeCategory20: gtt,
  schemeCategory20b: htt,
  scaleBand: E3,
  scaleTime: B3,
  scaleUtc: m3
} = hw, Es = {
  [ce]: XQ,
  [bn]: E3,
  [QS]: I3,
  [AE]: C3,
  [sE]: h3,
  [hA]: FS,
  [uu]: u3,
  [du]: d3,
  [pS]: f3,
  [LA]: B3,
  [nE]: m3,
  [mS]: XQ,
  [Mo]: NS
};
function Q3(e) {
  return e[0] === "i" ? FS(rf[e]) : NS(rf[e]);
}
function p3(e) {
  let t = "";
  return e && typeof e == "string" ? t = e[0] === "i" ? Z8 : Tf : t = Tf, t;
}
function YA(e) {
  let t = e.range;
  if (!e.type || !Es[e.type])
    throw new Error(`${e.type} is not a valid scale type`);
  if (!Array.isArray(e.range))
    throw new Error("range parameter must be an array");
  let i = null;
  if (e.type === oE && e.interpolator) {
    if (i = Es[e.interpolator], e.interpolator === du)
      return i().range(t).exponent(e.exponent);
    if (e.interpolator === uu)
      return i().range(t).base([e.base]);
  } else
    i = Es[e.type];
  return e.type === $8 && i().nice(), i().range(t);
}
const Cu = {
  id: Ut(),
  adjustRange: !1,
  axisName: {
    defClassName: "axis-name"
  },
  axisNamePadding: 5,
  base: 10,
  classPrefix: Dd,
  className: `${Dd}-axis`,
  exponent: 1,
  interpolator: "linear",
  fixedBaseline: !0,
  labels: {
    rotation: null,
    smartTicks: null,
    className: ""
  },
  orientation: "left",
  format: (e) => e,
  padding: 0.3,
  paddingInner: null,
  paddingOuter: null,
  nice: !0,
  numberOfTicks: null,
  rotate: !1,
  show: !0,
  showAxisName: !0,
  showInnerTicks: !0,
  showOuterTicks: !0,
  tickSize: 6,
  style: {},
  type: "linear",
  tickFormat: null,
  tickValues: null,
  tickInterval: {
    step: null,
    multiplier: 1,
    start: 0
  },
  xOffset: 0,
  yOffset: 0,
  defaultSort: "asc",
  transition: {
    disabled: !1
  },
  ticks: {
    labels: {
      rotation: 45,
      style: {
        "font-size": "12px",
        "font-family": '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
        "font-weight": "400",
        "font-style": "normal",
        "text-align": "center",
        fill: "#858585"
      },
      "&:highlight": {
        style: {
          "font-weight": "bold",
          fill: "#595959"
        }
      }
    }
  },
  title: {
    style: {
      "font-size": "14px",
      "font-family": '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
      "font-weight": "400",
      "font-style": "normal",
      fill: "#5f5f5f"
    }
  },
  ordering: tt({}, xr),
  hyperlink: {
    enabled: !1,
    sanitizeHyperlink: !0,
    encode: !0,
    defaultClassName: `${Dd}-hyperlink-text`,
    generateHref: (e) => ({
      target: Hs,
      rel: Ps,
      url: e.formattedValue,
      styles: Ys,
      classNames: Js
    })
  }
}, y3 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuOTk3MDcgNkg3Ljk5NzA3VjVIOS45OTcwN1Y2WiIgZmlsbD0iIzYzNjU2RSIvPgo8cGF0aCBkPSJNNy45OTcwNyA4VjlIMTEuOTk3MVY4SDcuOTk3MDdaIiBmaWxsPSIjNjM2NTZFIi8+CjxwYXRoIGQ9Ik03Ljk5NzA3IDEySDEzLjk5NzFWMTFINy45OTcwN1YxMloiIGZpbGw9IiM2MzY1NkUiLz4KPHBhdGggZD0iTTQuOTk4NjkgOS40OTk3OEg2Ljc0NTc2QzYuODgzODMgOS40OTk3OCA2Ljk5NTc2IDkuNjExNyA2Ljk5NTc2IDkuNzQ5NzhDNi45OTU3NiA5LjgxMTQ5IDYuOTcyOTMgOS44NzEwMyA2LjkzMTY3IDkuOTE2OTJMNC42ODM3OSAxMi40MTcxQzQuNTkxNDggMTIuNTE5OCA0LjQzMzQxIDEyLjUyODIgNC4zMzA3NCAxMi40MzU5QzQuMzI0MTUgMTIuNDMgNC4zMTc4OSAxMi40MjM3IDQuMzExOTcgMTIuNDE3MUwyLjA2NDA5IDkuOTE2OTJDMS45NzE3OCA5LjgxNDI1IDEuOTgwMTggOS42NTYxOCAyLjA4Mjg2IDkuNTYzODdDMi4xMjg3NSA5LjUyMjYgMi4xODgyOSA5LjQ5OTc4IDIuMjUgOS40OTk3OEgzLjk5ODY5TDMuOTk4NjkgNUg0Ljk5ODY5TDQuOTk4NjkgOS40OTk3OFoiIGZpbGw9IiM2MzY1NkUiLz4KPC9zdmc+Cg==", tp = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjQ2NjI2IDMuMjI2NTZMMyA3LjYxMzA2SDMuNzY2ODdMNC4xMTA0MyA2LjUyNzE3SDUuNzg1MjdMNi4xMzQ5NiA3LjYxMzA2SDYuOTgxNTlMNS41MzM3NCAzLjIyNjU2SDQuNDY2MjZaTTQuMzAwNjEgNS45MzIwOEw0Ljk1MDkyIDMuODk1MjdMNS41OTUwOSA1LjkzMjA4SDQuMzAwNjFaTTMgMTIuODg5M1YxMi45OTk4SDYuMzMxMjhWMTIuMzQzM0g0LjIwMjQ1TDYuMzkyNjMgOC43MTc1OFY4LjYxMzI4SDMuMjI2OTlWOS4yNTc0NUg1LjIzOTI2TDMgMTIuODg5M1oiIGZpbGw9IiM2MzY1NkUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjA2Mzk0IDkuNjQzNDhMMTEuMzExOCAxMi4xNDM3QzExLjMxNzcgMTIuMTUwMyAxMS4zMjQgMTIuMTU2NiAxMS4zMzA2IDEyLjE2MjVDMTEuNDMzMyAxMi4yNTQ4IDExLjU5MTMgMTIuMjQ2NCAxMS42ODM2IDEyLjE0MzdMMTMuOTMxNSA5LjY0MzQ4QzEzLjk3MjggOS41OTc1OSAxMy45OTU2IDkuNTM4MDUgMTMuOTk1NiA5LjQ3NjM0QzEzLjk5NTYgOS4zMzgyNyAxMy44ODM3IDkuMjI2MzQgMTMuNzQ1NiA5LjIyNjM0SDExLjk5OUwxMS45OTkgNC43MjY1NkgxMC45OTlMMTAuOTk5IDkuMjI2MzRMOS4yNDk4NCA5LjIyNjM0QzkuMTg4MTMgOS4yMjYzNCA5LjEyODU5IDkuMjQ5MTcgOS4wODI3IDkuMjkwNDNDOC45ODAwMiA5LjM4Mjc0IDguOTcxNjIgOS41NDA4MSA5LjA2Mzk0IDkuNjQzNDhaIiBmaWxsPSIjNjM2NTZFIi8+Cjwvc3ZnPgo=", D3 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDguMDExNzJWMi4wMTE3MkgxMFY4LjAxMTcySDExWiIgZmlsbD0iIzYzNjU2RSIvPgo8cGF0aCBkPSJNOCA4LjAxMTcyVjQuMDExNzJIN1Y4LjAxMTcySDhaIiBmaWxsPSIjNjM2NTZFIi8+CjxwYXRoIGQ9Ik01IDYuMDExNzJWOC4wMTE3Mkg0VjYuMDExNzJINVoiIGZpbGw9IiM2MzY1NkUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40MTY5IDEzLjkzNTZMMTIuOTE3MSAxMS42ODc3QzEyLjkyMzcgMTEuNjgxOCAxMi45MyAxMS42NzU1IDEyLjkzNTkgMTEuNjY4OUMxMy4wMjgyIDExLjU2NjMgMTMuMDE5OCAxMS40MDgyIDEyLjkxNzEgMTEuMzE1OUwxMC40MTY5IDkuMDY4QzEwLjM3MSA5LjAyNjczIDEwLjMxMTUgOS4wMDM5MSAxMC4yNDk4IDkuMDAzOTFDMTAuMTExNyA5LjAwMzkxIDkuOTk5NzggOS4xMTU4NCA5Ljk5OTc4IDkuMjUzOTFWMTEuMDAzOUw0IDExLjAwMzlWMTIuMDAzOUw5Ljk5OTc4IDEyLjAwMzlWMTMuNzQ5N0M5Ljk5OTc4IDEzLjgxMTQgMTAuMDIyNiAxMy44NzA5IDEwLjA2MzkgMTMuOTE2OEMxMC4xNTYyIDE0LjAxOTUgMTAuMzE0MiAxNC4wMjc5IDEwLjQxNjkgMTMuOTM1NloiIGZpbGw9IiM2MzY1NkUiLz4KPC9zdmc+Cg==", w3 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4wMDI5IDUuNUg4LjAwMjkzVjQuNUgxNC4wMDI5VjUuNVpNNy45OTcwNyA4LjVIMTEuOTk3MVY3LjVINy45OTcwN1Y4LjVaTTguMDAyOTMgMTEuNUgxMC4wMDI5VjEwLjVIOC4wMDI5M1YxMS41WiIgZmlsbD0iIzYzNjU2RSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuMDYzNiA5LjQxNjkyTDQuMzExNDggMTEuOTE3MUM0LjMxNzQgMTEuOTIzNyA0LjMyMzY3IDExLjkzIDQuMzMwMjUgMTEuOTM1OUM0LjQzMjkyIDEyLjAyODIgNC41OTA5OSAxMi4wMTk4IDQuNjgzMyAxMS45MTcxTDYuOTMxMTggOS40MTY5MkM2Ljk3MjQ1IDkuMzcxMDMgNi45OTUyNyA5LjMxMTQ5IDYuOTk1MjggOS4yNDk3OEM2Ljk5NTI4IDkuMTExNzEgNi44ODMzNSA4Ljk5OTc4IDYuNzQ1MjggOC45OTk3OEw0Ljk5ODIgOC45OTk3OEw0Ljk5ODIgNC41SDMuOTk4MkwzLjk5ODIgOC45OTk3OEwyLjI0OTUxIDguOTk5NzhDMi4xODc4IDguOTk5NzggMi4xMjgyNiA5LjAyMjYgMi4wODIzNyA5LjA2Mzg3QzEuOTc5NjkgOS4xNTYxOCAxLjk3MTI5IDkuMzE0MjUgMi4wNjM2IDkuNDE2OTJaIiBmaWxsPSIjNjM2NTZFIi8+Cjwvc3ZnPgo=", ep = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjI5NDQzIDcuNTAyNjNWNy42MTMwNkg2LjYyNTcyVjYuOTU2NjJINC40OTY4OUw2LjY4NzA3IDMuMzMwODZWMy4yMjY1NkgzLjUyMTQzVjMuODcwNzNINS41MzM2OUwzLjI5NDQzIDcuNTAyNjNaTTQuNDY2MjYgOC42MTMyOEwzIDEyLjk5OThIMy43NjY4N0w0LjExMDQzIDExLjkxMzlINS43ODUyN0w2LjEzNDk2IDEyLjk5OThINi45ODE1OUw1LjUzMzc0IDguNjEzMjhINC40NjYyNlpNNC4zMDA2MSAxMS4zMTg4TDQuOTUwOTIgOS4yODE5OUw1LjU5NTA5IDExLjMxODhINC4zMDA2MVoiIGZpbGw9IiM2MzY1NkUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS45ODA2IDkuMjI2MzRIMTMuNzI3N0MxMy44NjU4IDkuMjI2MzQgMTMuOTc3NyA5LjMzODI3IDEzLjk3NzcgOS40NzYzNEMxMy45Nzc3IDkuNTM4MDUgMTMuOTU0OSA5LjU5NzU5IDEzLjkxMzYgOS42NDM0OEwxMS42NjU3IDEyLjE0MzdDMTEuNTczNCAxMi4yNDY0IDExLjQxNTMgMTIuMjU0OCAxMS4zMTI3IDEyLjE2MjVDMTEuMzA2MSAxMi4xNTY2IDExLjI5OTggMTIuMTUwMyAxMS4yOTM5IDEyLjE0MzdMOS4wNDYwMyA5LjY0MzQ4QzguOTUzNzEgOS41NDA4MSA4Ljk2MjEyIDkuMzgyNzQgOS4wNjQ3OSA5LjI5MDQzQzkuMTEwNjggOS4yNDkxNyA5LjE3MDIyIDkuMjI2MzQgOS4yMzE5NCA5LjIyNjM0SDEwLjk4MDZWNC43MjY1NkgxMS45ODA2VjkuMjI2MzRaIiBmaWxsPSIjNjM2NTZFIi8+Cjwvc3ZnPgo=", x3 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ljk5NjA5IDIuMDAzOTFMNC45OTYwOSA4LjAwMzkxSDMuOTk2MDlWMi4wMDM5MUg0Ljk5NjA5Wk03Ljk5NjU4IDguMDExNzJWNC4wMTE3Mkg2Ljk5NjU4VjguMDExNzJINy45OTY1OFpNMTAuOTk2MSA4LjAwMzkxVjYuMDAzOTFIOS45OTYwOVY4LjAwMzkxSDEwLjk5NjFaIiBmaWxsPSIjNjM2NTZFIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNDE2OSAxMy45MzU2TDEyLjkxNzEgMTEuNjg3N0MxMi45MjM3IDExLjY4MTggMTIuOTMgMTEuNjc1NSAxMi45MzU5IDExLjY2ODlDMTMuMDI4MiAxMS41NjYzIDEzLjAxOTggMTEuNDA4MiAxMi45MTcxIDExLjMxNTlMMTAuNDE2OSA5LjA2OEMxMC4zNzEgOS4wMjY3MyAxMC4zMTE1IDkuMDAzOTEgMTAuMjQ5OCA5LjAwMzkxQzEwLjExMTcgOS4wMDM5MSA5Ljk5OTc4IDkuMTE1ODQgOS45OTk3OCA5LjI1MzkxVjExLjAwMzlMNCAxMS4wMDM5VjEyLjAwMzlMOS45OTk3OCAxMi4wMDM5VjEzLjc0OTdDOS45OTk3OCAxMy44MTE0IDEwLjAyMjYgMTMuODcwOSAxMC4wNjM5IDEzLjkxNjhDMTAuMTU2MiAxNC4wMTk1IDEwLjMxNDIgMTQuMDI3OSAxMC40MTY5IDEzLjkzNTZaIiBmaWxsPSIjNjM2NTZFIi8+Cjwvc3ZnPgo=", RS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTggMC4xNjY5OTJMNC4wMTQxMyA0LjE2Njk5TDAgMC4xNjY5OTJMOCAwLjE2Njk5MloiIGZpbGw9IiM2MzY1NkUiLz4KPC9zdmc+Cg==", S3 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgOCA0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTggMi4xNzg3ZS0wOUw0LjAxNDEzIDRMMCAwTDggMi4xNzg3ZS0wOVoiIGZpbGw9IiMxOEEwRkIiLz4KPC9zdmc+Cg==", M3 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMgNkM0LjY1Njg1IDYgNiA0LjY1Njg1IDYgM0M2IDEuMzQzMTUgNC42NTY4NSAwIDMgMEMxLjM0MzE1IDAgMCAxLjM0MzE1IDAgM0MwIDQuNjU2ODUgMS4zNDMxNSA2IDMgNloiIGZpbGw9IiM2OEMzRUMiLz4KPC9zdmc+Cg==", _3 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNjg2NzIgMy4yMjU3OUM0LjEwMjY4IDMuNjUyOSA0LjEwNjE3IDQuMzQxODEgMy42ODY3MiA0Ljc3MjUxTDAuNzUzMTY2IDcuNzg0NzFDMC4zMzcyMDQgOC4yMTE4MyAwIDcuOTg3NzEgMCA3LjI1MTcxTDAgMC43NDY1ODdDMCAwLjAyNTEwMTQgMC4zMzM3MTMgLTAuMjE3MTE4IDAuNzUzMTY2IDAuMjEzNTgxIiBmaWxsPSIjNjM2NTZFIi8+Cjwvc3ZnPgo=", b3 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMzEzMjgyIDMuMjI1NzlDLTAuMTAyNjggMy42NTI5IC0wLjEwNjE3MSA0LjM0MTgxIDAuMzEzMjgyIDQuNzcyNTFMMy4yNDY4MyA3Ljc4NDcxQzMuNjYyOCA4LjIxMTgzIDQgNy45ODc3MSA0IDcuMjUxNzFMNCAwLjc0NjU4N0M0IDAuMDI1MTAxMiAzLjY2NjI5IC0wLjIxNzExOCAzLjI0NjgzIDAuMjEzNTgxIiBmaWxsPSIjNjM2NTZFIi8+Cjwvc3ZnPgo=", wd = "sort-label", xd = "sort-menu", hc = "asc", N3 = 16, kS = (e, t) => {
  const {
    target: { type: i, data: n, meta: A },
    targets: s,
    container: o,
    sortStatus: r,
    text: a,
    isOverlay: l,
    cellRender: c,
    directSortEnabled: g,
    hyperlinkInfo: h,
    hyperLinkConfig: u
  } = t;
  Pt(o, {
    display: "grid",
    "grid-auto-flow": "column",
    "grid-template-columns": "1fr",
    position: "relative"
  });
  let d;
  if (!r)
    d = RS;
  else {
    const C = r.sortInfo.direction;
    i === rE ? d = C === hc ? tp : ep : i === aE ? d = C === hc ? D3 : x3 : i === lE ? d = C === hc ? y3 : w3 : d = C === hc ? tp : ep;
  }
  const f = [];
  a && f.push({
    type: wd,
    className: wd,
    data: {
      label: a.label,
      originalText: a.originalText
    }
  }), f.push({
    type: xd,
    className: xd,
    contextData: {
      type: i,
      data: n,
      meta: A
    },
    icon: d,
    sortStatus: r,
    directSortEnabled: g
  }), j(
    o,
    "div",
    f,
    null,
    {},
    (C) => C.type
  ).each(function(C) {
    const E = V(this), { type: B } = C;
    if (E.classed(C.className, !0), B === wd) {
      Pt(E, {
        display: "flex",
        "align-items": s.length > 1 ? "center" : "start",
        "justify-content": a.align,
        overflow: "hidden"
      });
      let m = E;
      h && (m = j(E, "a", (D) => [D]), yl(
        m,
        {
          hyperlinkInfo: h
        },
        u
      ));
      const y = j(m, "span", [C.data]).text((D) => D.label).classed("tick-label", !0);
      Pt(
        y,
        Object.assign({
          "white-space": "nowrap",
          overflow: "hidden",
          "text-overflow": "ellipsis",
          "line-height": "normal"
        })
      );
    } else if (B === xd) {
      Pt(E, {
        display: "flex",
        "align-items": s.length > 1 ? "center" : "start",
        "justify-content": "center",
        cursor: "pointer"
      }), l && !r && Pt(E, {
        position: "absolute",
        right: "3px",
        top: "50%",
        transform: "translateY(-50%)"
      });
      const m = j(E, "div", [1]);
      m.classed("icon-holder", !0), Pt(m, {
        display: "flex",
        "align-items": "center",
        "justify-content": "center"
      }), j(m, "img", [C.icon]).attr("src", (y) => y), E.style("display", r ? "flex" : "none");
    }
  }), c === "html" && TS(o);
}, cE = (e) => {
  const t = e.node()[MS];
  return (t ? V(t) : e).selectAll(".sort-menu");
}, Eu = (e) => {
  const t = e.node()[_S];
  return t ? V(t) : e;
}, TS = (e) => {
  const { height: t } = e.node().getBoundingClientRect(), i = Math.min(t, N3);
  if (i > 0) {
    const A = cE(e).select(".icon-holder");
    Pt(A, {
      width: i + "px",
      height: i + "px"
    });
  }
}, gE = ({
  baseTargets: e,
  directSortEnabledInfo: t
}) => {
  const i = [];
  t.rowsHeaders && i.push(e.rowsHeaders);
  const n = e.axis;
  return t.axes.x && n.forEach((A) => {
    i.push(`.muze-axis-cell-top ${A}`), i.push(`.muze-axis-cell-bottom ${A}`);
  }), t.axes.y && n.forEach((A) => {
    i.push(`.muze-axis-cell-left ${A}`), i.push(`.muze-axis-cell-right ${A}`);
  }), i;
}, Bu = (e, t) => t, Yg = (e, t, i) => {
  switch (W(e, "constructor")) {
    case Function:
      return e(t, i);
    case Array:
      return e;
    default:
      return t;
  }
}, F3 = (e) => e || 5, vS = (e, t) => {
  const i = e.config().orientation, { axisDomainRanges: n } = t, A = e.domain();
  let s = null, o, r;
  switch (i) {
    case "top":
      o = n.x[1], r = !0;
      break;
    case "bottom":
      o = n.x[0], r = !0;
      break;
    case "left":
      o = n.y[0], r = !1;
      break;
    case "right":
      o = n.y[1], r = !1;
      break;
  }
  return r && o ? s = {
    ...o,
    absStartIdx: o.startIdx,
    absEndIdx: o.endIdx
  } : !r && o && (s = {
    ...o,
    absStartIdx: A.length - 1 - o.endIdx,
    absEndIdx: A.length - 1 - o.startIdx
  }), s;
}, GS = (e) => {
  const {
    axisInst: t,
    directSortContainer: i,
    targetElemData: n,
    allTargetElems: A,
    textInfo: s,
    isOverlay: o,
    cellRender: r,
    hyperlinkInfo: a,
    hyperLinkConfig: l
  } = e, c = t.currentNestedSortInfo(), g = {
    [t.config().field]: (d) => t.getFormattedText(d)
  };
  if (c) {
    const { facetsPath: d } = c;
    d.forEach(({ field: f, formatter: I }) => {
      g[f] = (...C) => I(...C);
    });
  }
  let h = null;
  t instanceof ee || t instanceof qt ? c && Wa(
    c.axisTarget.value,
    n.rawValue
  ) ? h = {
    sortInfo: c.sortInfo,
    targetField: c.targetField,
    metaInfo: {
      sourceType: t.config().sourceType
    },
    formatterByFields: g
  } : h = null : t instanceof $i && (c && Wa(
    c.axisTarget.value,
    n.fieldName
  ) ? h = {
    sortInfo: c.sortInfo,
    targetField: c.targetField,
    metaInfo: {
      sourceType: t.config().sourceType
    },
    formatterByFields: g
  } : h = null);
  let u;
  t instanceof ee || t instanceof qt ? u = t.isYAxis() ? aE : lE : t instanceof $i && (u = t.isYAxis() ? xS : SS), kS(t, {
    target: {
      type: u,
      data: n,
      meta: {
        axisFieldName: t.config().field
      }
    },
    targets: A,
    container: i,
    sortStatus: h,
    text: s,
    isOverlay: o,
    cellRender: r,
    directSortEnabled: t.directSortEnabled(),
    hyperlinkInfo: a,
    hyperLinkConfig: l
  });
}, uc = {
  [cn]: {
    [Pi]: {
      [cn]: 3,
      [Vi]: 0,
      [ss]: 5,
      [As]: 5
    }
  },
  [Vi]: {
    [Pi]: {
      [cn]: 4,
      [Vi]: 0,
      [ss]: 5,
      [As]: 5
    }
  },
  [ss]: {
    [Pi]: {
      [cn]: 0,
      [Vi]: 0,
      [ss]: 6,
      [As]: 6
    }
  },
  [As]: {
    [Pi]: {
      [cn]: 0,
      [Vi]: 0,
      [ss]: 6,
      [As]: 6
    }
  }
}, Sa = 3, LS = 28;
function R3(e) {
  return e = Math.max(Math.min(e, LS), 1), Jt(
    (t) => {
      t.getDate() >= e || t.setMonth(t.getMonth() - 1), t.setDate(e), t.setHours(0, 0, 0, 0);
    },
    (t, i) => {
      t.setMonth(t.getMonth() + i);
    },
    (t, i) => i.getMonth() - t.getMonth() + (i.getFullYear() - t.getFullYear()) * 12,
    (t) => t.getMonth()
  );
}
function k3(e) {
  return e = Math.max(Math.min(e, LS), 1), Jt(
    (t) => {
      t.getUTCDate() >= e || t.setUTCMonth(t.getUTCMonth() - 1), t.setUTCDate(e), t.setUTCHours(0, 0, 0, 0);
    },
    (t, i) => {
      t.setUTCMonth(t.getUTCMonth() + i);
    },
    (t, i) => i.getUTCMonth() - t.getUTCMonth() + (i.getUTCFullYear() - t.getUTCFullYear()) * 12,
    (t) => t.getUTCMonth()
  );
}
function T3(e) {
  e = Math.max(Math.min(e, 11), 0);
  const t = Jt(
    (i) => {
      i.getMonth() < e && i.setFullYear(i.getFullYear() - 1), i.setMonth(e, 1), i.setHours(0, 0, 0, 0);
    },
    (i, n) => {
      i.setFullYear(i.getFullYear() + n);
    },
    (i, n) => n.getFullYear() - i.getFullYear(),
    (i) => i.getFullYear()
  );
  return t.every = (i) => !isFinite(i = Math.floor(i)) || !(i > 0) ? null : Jt(
    (n) => {
      const A = Math.floor(n.getFullYear() / i) * i;
      A === n.getFullYear() && n.getMonth() < e ? n.setFullYear(A - i) : n.setFullYear(A), n.setMonth(e, 1), n.setHours(0, 0, 0, 0);
    },
    (n, A) => {
      n.setFullYear(n.getFullYear() + A * i);
    }
  ), t;
}
function v3(e) {
  e = Math.max(Math.min(e, 11), 0);
  const t = Jt(
    (i) => {
      i.getUTCMonth() < e && i.setUTCFullYear(i.getUTCFullYear() - 1), i.setUTCMonth(e, 1), i.setUTCHours(0, 0, 0, 0);
    },
    (i, n) => {
      i.setUTCFullYear(i.getUTCFullYear() + n);
    },
    (i, n) => n.getUTCFullYear() - i.getUTCFullYear(),
    (i) => i.getUTCFullYear()
  );
  return t.every = (i) => !isFinite(i = Math.floor(i)) || !(i > 0) ? null : Jt(
    (n) => {
      const A = Math.floor(n.getUTCFullYear() / i) * i;
      A === n.getUTCFullYear() && n.getUTCMonth() < e ? n.setUTCFullYear(A - i) : n.setUTCFullYear(A), n.setUTCMonth(e, 1), n.setUTCHours(0, 0, 0, 0);
    },
    (n, A) => {
      n.setUTCFullYear(n.getUTCFullYear() + A * i);
    }
  ), t;
}
const hE = 1, uE = hE * 1e3, mu = uE * 60, dE = mu * 60, ks = dE * 24, US = ks * 30, OS = ks * 365, G3 = 0.7, HS = [1, 2, 3, 5, 6, 7, 10, 14], L3 = [
  nr,
  Ar,
  eC,
  iC,
  RA,
  nC,
  AC
], U3 = [
  sr,
  or,
  rC,
  aC,
  TA,
  lC,
  cC
];
function PS() {
  return Jt(
    (e) => e.setHours(0, 0, 0, 0),
    (e, t) => e.setDate(e.getDate() + t),
    (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * mu) / ks
  );
}
function YS() {
  return Jt(
    (e) => e.setUTCHours(0, 0, 0, 0),
    (e, t) => e.setUTCDate(e.getUTCDate() + t),
    (e, t) => (t - e) / ks
  );
}
function EA(e, t, i) {
  let n, A;
  e === "millisecond" ? (n = i ? Date.prototype.getUTCMilliseconds : Date.prototype.getMilliseconds, A = 999) : e === "second" ? (n = i ? Date.prototype.getUTCSeconds : Date.prototype.getSeconds, A = 59) : e === "minute" ? (n = i ? Date.prototype.getUTCMinutes : Date.prototype.getMinutes, A = 59) : e === "hour" && (n = i ? Date.prototype.getUTCHours : Date.prototype.getHours, A = 23);
  const s = t * G3, o = A % t, r = A - o;
  return o + 1 < s ? (a) => n.call(a) !== r : () => !0;
}
const JS = {
  millisecond: [
    hE,
    () => NA,
    () => NA,
    EA.bind(void 0, "millisecond"),
    1e3,
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    (e) => 1e3 % e === 0
  ],
  second: [
    uE,
    () => FA,
    () => FA,
    EA.bind(void 0, "second"),
    60,
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    (e) => 60 % e === 0
  ],
  minute: [
    mu,
    () => Jh,
    () => Vh,
    EA.bind(void 0, "minute"),
    60,
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    (e) => 60 % e === 0
  ],
  hour: [
    dE,
    () => Kh,
    () => jh,
    EA.bind(void 0, "hour"),
    24,
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    (e) => 24 % e === 0
  ],
  day: [
    ks,
    () => PS(),
    () => YS(),
    null,
    30,
    (e) => HS.includes(e)
  ],
  week: [
    ks * 7,
    (e) => L3[e],
    (e) => U3[e],
    null,
    1 / 0,
    () => !0
  ],
  month: [
    US,
    (e) => R3(e),
    (e) => k3(e),
    null,
    12,
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    (e) => 12 % e === 0
  ],
  year: [
    OS,
    (e) => T3(e),
    (e) => v3(e),
    null,
    1 / 0,
    () => !0
  ]
}, KS = (e, t, i, n, A, s) => [
  A > 1 ? `every ${A} ${e}s` : `every ${e}`,
  n * A,
  A > 1 && s ? t.every(A).filter(s(A, !1)) : t.every(A),
  A > 1 && s ? i.every(A).filter(s(A, !0)) : i.every(A)
], ip = {
  millisecond: {
    baseDuration: hE,
    filterFn: EA.bind(void 0, "millisecond"),
    intervalInst: NA,
    utcIntervalInst: NA,
    // Should meet this condition: 1000 % multiplier === 0.
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    multipliers: [1, 100, 200, 500]
  },
  second: {
    baseDuration: uE,
    filterFn: EA.bind(void 0, "second"),
    intervalInst: FA,
    utcIntervalInst: FA,
    // Should meet this condition: 60 % multiplier === 0.
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    multipliers: [1, 2, 3, 4, 5, 10, 15, 20, 30]
  },
  minute: {
    baseDuration: mu,
    filterFn: EA.bind(void 0, "minute"),
    intervalInst: Jh,
    utcIntervalInst: Vh,
    // Should meet this condition: 60 % multiplier === 0.
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    multipliers: [1, 2, 3, 4, 5, 10, 15, 20, 30]
  },
  hour: {
    baseDuration: dE,
    filterFn: EA.bind(void 0, "hour"),
    intervalInst: Kh,
    utcIntervalInst: jh,
    // Should meet this condition: 24 % multiplier === 0.
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    multipliers: [1, 2, 3, 4, 6, 12]
  },
  day: {
    baseDuration: ks,
    filterFn: null,
    intervalInst: PS(),
    utcIntervalInst: YS(),
    multipliers: HS.slice()
  },
  month: {
    baseDuration: US,
    filterFn: null,
    intervalInst: sC,
    utcIntervalInst: gC,
    // Should meet this condition: 12 % multiplier === 0.
    // The multiplier should be such that the ticks are evenly spaced and no irregular intervals.
    multipliers: [1, 2, 3, 4, 6]
  },
  year: {
    baseDuration: OS,
    filterFn: null,
    intervalInst: kA,
    utcIntervalInst: vA,
    multipliers: [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      15,
      20,
      25,
      30,
      35,
      40,
      45,
      50,
      60,
      70,
      80,
      90,
      100,
      200,
      300,
      400,
      500,
      600,
      700,
      800,
      900,
      1e3
    ]
  }
}, WS = [];
Object.keys(ip).forEach((e) => {
  const { baseDuration: t, filterFn: i, intervalInst: n, utcIntervalInst: A, multipliers: s } = ip[e];
  s.forEach((o) => {
    const r = KS(
      e,
      n,
      A,
      t,
      o,
      i
    );
    WS.push(r);
  });
});
function O3(e, t) {
  const { tickInterval: i } = t, { step: n, multiplier: A } = i;
  if (!n)
    return;
  if (!Object.keys(JS).includes(n)) {
    t.tickInterval.step = null;
    return;
  }
  const o = isFinite(A) ? Math.floor(+A) : 1;
  t.tickInterval.multiplier = Math.max(o, 1);
}
function H3(e, t) {
  e = e.slice().map((f) => /* @__PURE__ */ new Date(+f));
  let i = 0, n = e.length - 1, A = e[i], s = e[n], o;
  s < A && (o = i, i = n, n = o, o = A, A = s, s = o);
  let r = A, a = s;
  const l = t.floor(A), c = t.ceil(A);
  Math.abs(c - A) / Math.abs(c - l) >= 0.5 ? r = l : r = A;
  const h = t.floor(s), u = t.ceil(s);
  return Math.abs(s - h) / Math.abs(u - h) >= 0.5 ? a = u : a = s, e[i] = r, e[n] = a, e;
}
function P3(e) {
  const t = e.getTickSkippingInterval(), { nice: i } = e.config();
  let n = e.scale();
  if (i) {
    const o = H3(
      e.originalDomain(),
      t
    );
    n.domain(o), e._domain = o;
  }
  let A = n.ticks(t);
  const s = A.length;
  if (nM(e, A)) {
    const o = Math.floor(s / 2);
    A = [A[o]];
  } else
    A = zc(
      e,
      e.axis(),
      A,
      s
    );
  return A;
}
const Y3 = (e) => {
  const t = P3(e);
  e.renderConfig({
    tickValues: t
  });
}, J3 = (...e) => jS(...e), VS = (...e) => jS(...e), jS = (e, t, {
  canTicksShift: i = !0,
  spaceBetweenTicks: n = 0,
  allowExtremeLabelsOverflow: A = !0,
  preserveLastTick: s = !0
} = {
  canTicksShift: !0,
  spaceBetweenTicks: 0,
  allowExtremeLabelsOverflow: !0,
  preserveLastTick: !0
}) => {
  const o = e.config(), [r, a] = e.range();
  let l = Number.isFinite(o.labels.rotation) ? o.labels.rotation : 0;
  const { orientation: c } = e.config();
  let g;
  const h = e._interpolator, u = e.dependencies().labelManager;
  u.setStyle(e._tickLabelStyle);
  const d = e._tickFormatter(t), f = t.map(
    (I, C) => u.getOriSize(d(I, C))
  );
  if (c === "bottom" || c === "top") {
    const I = l ? f.map((D) => {
      const { width: Q, height: p } = Ri(
        l,
        D.width,
        D.height
      );
      return { width: Q + n, height: p };
    }) : f.map(({ width: D, height: Q }) => ({
      width: D + n,
      height: Q
    })), C = e.isBinnedAxis() ? 0 : Math.max(0, e.getUnitWidth() - 1) / 2;
    let E = t.map((D, Q) => ({
      position: e.getScaleValue(D) + C,
      dimension: I[Q].width,
      crossDimension: I[Q].height,
      tickRawValue: t[Q],
      isTickShifted: i ? Q === 0 : !1
    }));
    const B = A ? 0 : E.findIndex(({ position: D, dimension: Q, isTickShifted: p }) => (p ? D + Q / 2 : D - Q / 2) > r), m = A ? E.length - 1 : E.length - 1 - E.slice().reverse().findIndex(
      ({ position: D, dimension: Q }) => D + Q / 2 < a
    ), y = h.skipTicks(
      E.slice(
        B,
        m + 1
      ),
      { preserveLastTick: s },
      l,
      e,
      c
    );
    g = t.slice(B, m + 1).filter((D, Q) => y.includes(Q));
  } else {
    const I = l ? f.map((x) => {
      const { width: S, height: _ } = Ri(
        l,
        x.width,
        x.height
      );
      return { width: S, height: _ + n };
    }) : f.map(({ width: x, height: S }) => ({
      width: x,
      height: S + n
    })), C = e.isBinnedAxis() ? 0 : Math.max(0, e.getUnitWidth() - 1) / 2, B = t.map((x, S) => ({
      position: e.getScaleValue(x) + C,
      dimension: I[S].height,
      crossDimension: Math.floor(I[S].width),
      tickRawValue: t[S],
      originalIdx: S,
      isTickShifted: i ? S === 0 : !1
    })).slice().reverse(), m = A ? 0 : B.findIndex(
      ({ position: x, dimension: S }) => x - S / 2 > a
    ), y = B.slice().reverse().findIndex(({ position: x, dimension: S, isTickShifted: _ }) => (_ ? x - S / 2 : x + S / 2) < r), D = A ? B.length - 1 : y === -1 ? y : B.length - 1 - y, Q = h.skipTicks(
      B.slice(
        m,
        D + 1
      ),
      { preserveLastTick: s },
      l,
      e,
      c
    ), w = B.slice(m, D + 1).filter((x, S) => Q.includes(S)).map(
      (x) => x.originalIdx
    );
    g = t.filter(
      (x, S) => w.includes(S)
    );
  }
  return g;
}, qS = "wholeRange", Jg = "startValue", zS = "continuous", Qu = "center", ZS = "start", np = (e, t) => (e[0] += t[0], e[1] -= t[1], e), Ap = (e, t, i) => (e[0] -= i[0], e[1] += t[1], e), K3 = {
  [ie]: np,
  [Ce]: np,
  [Se]: Ap,
  [vi]: Ap
}, es = (e, t, i, n) => {
  e.range(i), n && e.renderConfig({ [`${t}Offset`]: n });
}, W3 = (e, t, i) => {
  const n = Math.abs(t[1] - t[0]), A = Math.abs(i[1] - i[0]);
  let s, o;
  if (i[0] instanceof Date && isNaN(i[0]))
    o = 0;
  else {
    s = n / (A || i[0]);
    const r = s * e, a = n / r, l = n / (a + 1);
    o = (n - l * a) / 2;
  }
  return o;
}, Kg = (e, t, i, n, A) => {
  const { orientation: s, adjustRange: o } = A;
  let r;
  if (o) {
    const c = W3(e, t, i);
    r = n.map((g) => Math.max(g, c));
  } else
    r = n;
  const a = r.map(
    (c) => Math.max(c, c3)
  );
  return K3[s](
    t,
    a,
    n
  );
}, Ri = (e = 0, t, i) => {
  let n = i, A = t;
  if (e) {
    const s = (e || 0) * Math.PI / 180;
    A = Math.abs(i * Math.sin(s)) + Math.abs(t * Math.cos(s)), n = Math.abs(t * Math.sin(s)) + Math.abs(i * Math.cos(s));
  }
  return { width: A, height: n };
}, V3 = (e, t, i, n, A) => {
  const s = Math.PI / 180 * A, o = Math.cos(s), r = Math.sin(s);
  return [
    o * (i - e) + r * (n - t) + e,
    o * (n - t) - r * (i - e) + t
  ];
}, Dl = (e) => {
  let t = 0, i = 0;
  const n = e.logicalSpace(), A = e.config(), { orientation: s, xOffset: o, yOffset: r } = A;
  s === Se && (t = o === void 0 ? n.width : o), s === ie && (i = r === void 0 ? n.height : r), e.renderConfig({ xOffset: t, yOffset: i });
}, qc = (e, t, i) => {
  const n = e.axis(), A = i || e.binSize(), { bins: s, fieldInstance: o, field: r } = e.config();
  let a, l;
  return e._config.alignZeroLine ? [a, l] = e._domain : [a, l] = o.data().getField(r).domain(), s.display === zS ? i ? Oo(a, l + A / 2, A) : t == null ? n.scale().ticks() : n.scale().ticks(t) : s.position === ZS ? Oo(a, l + A / 2, A) : s.position === Qu ? Oo(a + A / 2, l + A / 2, A) : t == null ? n.scale().ticks() : n.scale().ticks(t);
};
function j3(e, t) {
  let i = Math.floor(e / t);
  return t * (i + 1);
}
const q3 = (e, t) => {
  let i = e[0], n = 1;
  for (n; n < t; n++) {
    let A = e[n];
    if (A == i)
      return !0;
    i = A;
  }
  return !1;
}, zc = (e, t, i, n) => {
  const A = e._tickFormatter(i);
  let s = 0;
  for (; n > 0; ) {
    if (i.length !== s) {
      let o = i.map((a, l) => A(a, l));
      if (s = o.length, e instanceof kr && !q3(o, s) || [...new Set(o)].length === s)
        break;
    }
    n -= 1, i = t.scale().ticks(n);
  }
  return i;
}, z3 = (e, t, i, n) => {
  let A = 0, s = [], { numberOfTicks: o, fieldInstance: r } = n.config();
  const a = r.subtype() === fi;
  let l;
  if (a) {
    l = qc(n), l = zc(n, i, l, l.length);
    const c = n.config();
    let g;
    J.isInvalid(l[l.length - 1]) && l.length >= 2 ? g = n.getFormattedText(
      l[l.length - 2],
      l.length - 2,
      l
    ) : g = n.getFormattedText(
      l[l.length - 1],
      l.length - 1,
      l
    );
    const h = n._dependencies.labelManager.getOriSize(g);
    let u = Number.isFinite(c.labels.rotation) ? c.labels.rotation : 0;
    const { bins: d } = n.config(), { width: f, height: I } = Ri(
      u,
      h.width,
      h.height
    ), C = n.isYAxis() ? I : f, E = 5;
    let B = n.getValueFromPixels(C + E);
    return B = Number.isInteger(n.binSize()) ? Math.ceil(B) : B.toFixed(2), n instanceof ui && B > n.binSize() && (d.display === zS ? l = qc(n, null, B) : l = qc(
      n,
      null,
      j3(B, n.binSize())
    ), l = zc(n, i, l, l.length)), l;
  } else {
    l = i.scale().ticks();
    const c = l.length, g = n._minTickDistance.width;
    return A = c, c * (t + g) > e && (A = Math.floor(
      e / (t + g)
    )), o = o || A, A = Math.min(
      o,
      Math.max(Pg, A)
    ), l = i.scale().ticks(A), s = zc(n, i, l, A), s.length > A && (s = s.filter((h, u) => h === 0 ? !0 : u % 2 === 0)), A === Pg && (s = i.scale().ticks(wS), s = [s[0], s[s.length - 1]]), s;
  }
}, $S = (e) => {
  let t = "", i = { width: 0, height: 0 }, n = {}, A;
  const s = [], o = e.scale(), { tickValues: r, showAxisName: a, labels: l } = e.renderConfig(), {
    name: c,
    labels: { rotation: g },
    fieldSubtype: h,
    fieldAs: u,
    hyperlink: d
  } = e.config(), { labelManager: f } = e.dependencies();
  let I = o.ticks || o.quantile || o.domain;
  h === fi && u === z8 && (I = () => qc(e)), f.setStyle(e._tickLabelStyle), A = r || I();
  let C = l.rotation || g;
  C && C < 0 && (C = 360 + C);
  const E = [];
  let B = () => {
  };
  return d?.enabled && (B = e.getHyperLinkInfo), A = A.map((y, D) => {
    const Q = e.getFormattedText(y, D, A), p = f.getOriSize(Q);
    return s.push(p), e.constructor.type() === DS && A.length > 1 && C && // Skip the last tick if rotation meets the range.
    ((C > 0 && C < 90 || C > 180 && C < 270) && D === A.length - 1 || // Skip the first tick if rotation meets the range.
    (C > 90 && C < 180 || C > 270 && C < 360) && D === 0) || p.width > i.width && (t = Q, n = e.smartTicks() ? e.smartTicks()[D] : {}, i = p, n = n || p), E.push(
      B(e, y, Q, D, A)
    ), Q;
  }), f.setStyle(e._axisNameStyle), {
    axisNameDimensions: a ? f.getOriSize(c) : { width: 0, height: 0 },
    largestTick: t,
    largestTickDimensions: i,
    allTickDimensions: s,
    axisTicks: A,
    smartTick: n,
    hyperlinksInfo: E,
    hyperLinkConfig: d,
    tickSize: e.getTickSize()
  };
}, Z3 = (e, t) => {
  let i = {};
  const { labels: n } = e.renderConfig(), { smartTicks: A, rotation: s } = n, {
    largestTickDimensions: o,
    axisTicks: r,
    smartTick: a,
    axisNameDimensions: l,
    allTickDimensions: c,
    tickSize: g
  } = $S(e), { height: h, width: u } = o;
  return e.domain().length === 0 ? {
    allTickDimensions: c,
    tickSize: 0,
    tickDimensions: { height: 0, width: 0 },
    axisNameDimensions: l,
    largestTickDimensions: o,
    axisTicks: r
  } : (A && !t ? i = a : i = { width: u, height: h }, i = Ri(
    s,
    i.width,
    i.height
  ), {
    allTickDimensions: c,
    tickSize: g,
    tickDimensions: i,
    axisNameDimensions: l,
    largestTickDimensions: o,
    axisTicks: r
  });
}, XS = (e, t, i) => {
  let n, A;
  const s = e.domain(), o = e._minTickDistance.width, { tickSize: r, tickDimensions: a, axisNameDimensions: l } = t, { axisNamePadding: c, tickValues: g, labels: h } = e.config(), { showAxisName: u } = e.renderConfig(), { height: d } = l, { height: f, width: I } = a;
  if (n = i && i.length ? i[1] - i[0] : (I + o) * 3, A = 0, g) {
    const C = e.getMinTickDifference(), [E, B] = [
      Math.min(...g, ...s),
      Math.max(...g, ...s)
    ];
    n = (B - E) / Math.abs(C) * (I + e._minTickDistance.width);
  }
  return (!i || !i.length) && h.rotation !== 0 ? A = Math.max(I, f) : A = f, A += (u ? d + c : 0) + r, {
    width: n,
    height: A
  };
}, tM = (e, t) => {
  let i, n;
  const A = e.domain(), {
    tickSize: s,
    tickDimensions: o,
    axisNameDimensions: r,
    largestTickDimensions: a
  } = t, { axisNamePadding: l, tickValues: c, metaInf: g } = e.config(), { showAxisName: h, labels: u } = e.renderConfig(), { height: d } = r, { height: f, width: I } = o;
  let C = 0;
  if (i = 0, n = I, e.constructor.type() === DS) {
    const { width: E, height: B } = a, { rotation: m } = u;
    let y = m;
    m > 90 && m < 270 && (y = (180 + m) % 360);
    let D;
    if (y >= 0 && y < 90) {
      const Q = ls(y);
      D = E * Math.cos(Q);
    } else if (y === 90 || y === 270)
      D = B;
    else if (y > 270 && y <= 360) {
      const Q = ls(360 - y);
      D = E * Math.cos(Q);
    }
    g.canvasDimensions.width ? n = Math.min(D, g.canvasDimensions.width * 0.5) : n = D, n = Math.max(n, B), C = bS;
  }
  if (c) {
    const E = e.getMinTickDifference(), [B, m] = [
      Math.min(...c, ...A),
      Math.max(...c, ...A)
    ];
    i = (m - B) / Math.abs(E) * f;
  }
  return n += (h ? C + d + l : 0) + s, {
    height: i,
    width: n
  };
}, eM = (e, t) => {
  const i = e.range(), n = e.getAxisDimensions(t), A = e.overrideDimension && e.overrideDimension();
  let {
    orientation: s,
    bandwidth: o = 0,
    labels: { rotation: r }
  } = e.config();
  const { show: a } = e.renderConfig(), {
    // largestTickDimensions,
    allTickDimensions: l
  } = n, c = e._minTickDistance.width, g = e._minTickDistance.height, h = a;
  if (s === ie || s === Ce) {
    let { width: f, height: I } = XS(
      e,
      n,
      i
    );
    if (A.width)
      f = A.width;
    else if (!i || !i.length)
      if (e instanceof qt) {
        const C = l.length ? Cn(l.map((B) => B.width)) : 0, E = e._dependencies.labelManager.getOriSize("WWWWWWWWWW...");
        f = l.length * Math.min(
          C + c,
          E.width + c
        );
      } else
        f = l.reduce((C, E) => {
          const B = r === 0 || r === 180 || r === 360 ? Math.max(E.width, E.height) : Math.min(E.width, E.height);
          return C + (o ? Math.max(E.width, E.height, o) : B + c);
        }, 0);
    return h === !1 && (I = 0), { width: f, height: I };
  }
  let { width: u, height: d } = tM(e, n);
  return A.height ? d = A.height : d || (d = l.reduce((f, I) => {
    const C = r === 90 || r === 270 ? Math.max(I.width, I.height) : Math.min(I.width, I.height);
    return f + (o ? Math.max(I.width, I.height, o) : C + g);
  }, 0)), h === !1 && (u = 0), { width: u, height: d };
}, fE = (e, t = !1) => {
  const i = e.range(), n = e.getAxisDimensions(), { orientation: A } = e.config(), { show: s, showAxisName: o } = e.renderConfig(), { axisNameDimensions: r, largestTickDimensions: a, axisTicks: l } = n;
  if (s === !1)
    return {
      width: 0,
      height: 0
    };
  const { width: c } = r;
  if (A === ie || A === Ce) {
    const { width: d, height: f } = XS(
      e,
      n,
      i
    );
    return {
      width: Math.max(d, o ? c : 0),
      height: f
    };
  }
  let { width: g, height: h } = tM(e, n);
  t && !h && (h = l.length * (a.height + e._minTickDistance.height));
  const u = Math.max(h, o ? c : 0);
  return {
    width: g,
    height: u
  };
}, $3 = (e, t) => {
  let i = e.slice(0, 2);
  return e.length || (i = t), i.forEach((n, A) => {
    (n === null || isNaN(n)) && (i[A] = t[A]);
  }), i.sort((n, A) => n - A);
}, iM = (e, t) => {
  const { domain: i } = e.config();
  return i && (t = $3(i, t)), ft(t, []);
}, nM = (e, t) => {
  let i = e.getFormattedText(t[0], 0, t), n = 1;
  for (n; n < t.length; n++) {
    let A = e.getFormattedText(t[n], n, t);
    if (A != i)
      break;
    i = A;
  }
  return n === t.length;
}, X3 = (e, t) => {
  const i = e.scale.bind(e);
  let n = i().domain();
  i().domain(t);
  let A = i().ticks();
  return i().domain(n), nM(e, A) ? [t[0], Math.ceil(t[1])] : t;
}, t4 = (e, t) => {
  let i = t;
  e instanceof $i && (i = X3(e, t));
  const { nice: n } = e.config(), A = e.scale.bind(e);
  A().domain(i), n && A().nice(), e._domain = A().domain();
}, e4 = (e, t) => {
  e.scale().domain(t), e._domain = t, e.originalDomain(t), e.resetTickSkippingInterval();
}, i4 = (e = {}, t = {}, i) => !Object.keys(e).length || !Object.keys(t).length ? !1 : i.some((n) => e[n] !== t[n]), n4 = (e, t) => {
  const { orientation: i, isOffset: n } = e.config(), A = e._minDiff;
  if (e.range().length && (i === ie || i === Ce)) {
    e.applyTickSkipping();
    const { largestTickDimensions: s } = e.getAxisDimensions(), o = e.getTickValues().length, { width: r, height: a, padding: l } = e.availableSpace(), { left: c, right: g } = l, h = Math.min(
      s.width,
      (r - (o - 1) * e._minTickDistance.width) / o
    );
    e.maxTickSpaces({
      width: h
    });
    let u = [0, r - c - g];
    const d = Kg(
      A,
      u,
      t,
      [h / 2, h / 2],
      e.config()
    );
    es(e, "y", d, n ? a : null), e.setTickConfig();
  }
}, A4 = (e, t, i) => {
  const n = i.getOriSize(e);
  return i.useEllipsesOnOverflow(!0), i.getSmartText(e, t, n.height, !0);
}, s4 = (e) => {
  (e.paddingInner === null || e.paddingInner === void 0) && (e.paddingInner = e.padding), (e.paddingOuter === null || e.paddingOuter === void 0) && (e.paddingOuter = e.padding), e.padding = Math.min(1, Math.max(0, Number.parseFloat(e.padding))), e.paddingInner = Math.min(
    1,
    Math.max(0, Number.parseFloat(e.paddingInner))
  ), e.paddingOuter = Math.min(
    1,
    Math.max(0, Number.parseFloat(e.paddingOuter))
  );
}, o4 = (e) => {
  if (!e.tickFormat) {
    const t = e.numberFormat || ((i) => i);
    e.tickFormat = (i) => t(i.rawValue);
  }
}, r4 = (e) => {
  const { domain: t } = e;
  !e.nice && t && t.length && t.filter((i) => i === null).length !== 2 && (e.nice = !1);
}, a4 = (e, t) => {
  e instanceof $i || delete t.tickValues;
}, sp = (e, t) => {
  const { orientation: i } = e.config(), n = W(t, "axisDomainRanges", e.axisType()) || [];
  return (i === Se || i === Ce ? n[0] : n[1]) || null;
}, AM = (e, t, i, n, A, s) => {
  const o = e.scale(), r = o.range();
  o.range(t);
  const a = [
    [i, n],
    [A, s]
  ].map(([l, c], g) => {
    const h = e.getScaleValue(l), u = t[g], d = Math.abs(h - u), f = c / 2;
    return f >= d ? f - d : 0;
  });
  return o.range(r), a;
}, l4 = (e, t, i, n, A, s) => {
  const o = e.scale(), r = o.range(), a = [...t];
  o.range(t);
  const l = e.getScaleValue(i), c = e.getScaleValue(A), g = n / 2, h = s / 2, u = e.availableSpace().height, d = l + g, f = c - h;
  return d > u && (a[0] -= d - u), f < 0 && (a[1] += Math.abs(f)), o.range(r), a;
}, pu = (e) => (e < 0 && (e = 360 + e), e);
function c4(e, t, i) {
  let n = 0, A, s;
  i ? (A = e.length - 2, s = t - 1) : (A = e.length - 1, s = t);
  const o = [];
  if (s > 0) {
    const r = Math.ceil((A - n) / s);
    for (let a = 0; a < e.length; a += r)
      o.push(e[a]);
  }
  return i && o.push(e[e.length - 1]), o;
}
function op(e) {
  if (e && e.labels) {
    const { rotation: t } = e.labels;
    t != null && (e.labels.rotation = pu(t));
  }
}
const wn = {
  resolveTickLabelOverflowDirection: (e, t) => {
    const i = e % 360, n = Math.sign(i), A = Math.abs(i);
    return Math.abs(i) === 90 || Math.abs(i) === 270 || Math.abs(i) === 180 || n === 0 ? 0 : t === Ce ? n > 0 ? i > 0 && i < 90 || i > 180 && i < 270 ? -1 : 1 : A > 0 && A < 90 || A > 180 && A < 270 ? 1 : -1 : t === ie || t === Se ? n > 0 ? i > 0 && i < 90 || i > 180 && i < 270 ? 1 : -1 : A > 0 && A < 90 || A > 180 && A < 270 ? -1 : 1 : t === vi ? n > 0 ? i > 0 && i < 90 || i > 180 && i < 270 ? -1 : 1 : A > 0 && A < 90 || A > 180 && A < 270 ? 1 : -1 : 0;
  },
  getVisibleDimensionsForTickLabels: (e, t, i) => {
    const {
      labels: { rotation: n = 0 }
    } = e.renderConfig(), { orientation: A } = e.config(), { width: s, height: o } = e.availableSpace(), { height: r, width: a } = e.maxTickSpaces(), { height: l, width: c } = Ri(
      n,
      a,
      r
    ), { labelManager: g } = e._dependencies, h = e.getUnitWidth(), u = e.resolveTickLabelOverflowDirection(
      n,
      A
    ), d = n % 360, f = Math.abs(d) === 90 || Math.abs(d) === 270;
    return t.map((I, C) => {
      const E = e.getScaleValue(I), B = i(I, C), { width: m, height: y } = g.getOriSize(B), { width: D, height: Q } = Ri(
        n,
        m,
        y
      );
      if (e.isXAxis()) {
        let w = u < 0 ? E + h / 2 : u > 0 ? s - (E + h / 2) : D;
        w = Math.min(w, D);
        let x = f ? D : l;
        return {
          width: f ? r : Math.abs(d) === 180 ? Math.min(w - 5, h) : Math.abs(
            (w - 5) / Math.cos((180 - d) * Math.PI / 180)
          ),
          height: x
        };
      } else {
        let p = u < 0 ? E + h / 2 : u > 0 ? o - (E + h / 2) : Q, w = f ? Q : c;
        return {
          width: f ? D : Math.abs(d) === 180 ? c : Math.abs(
            p / Math.cos((180 - d) * Math.PI / 180)
          ),
          height: w
        };
      }
    });
  },
  setTickConfig: (e) => {
    let t, i, n = e.domain(), { labels: A, tickValues: s, showAxisName: o } = e.renderConfig();
    const r = e.getTickValues(), { labelManager: a } = e._dependencies;
    let {
      paddingInner: l,
      paddingOuter: c,
      renderer: g,
      isCompact: h,
      orientation: u,
      axisNamePadding: d,
      name: f,
      bins: I
    } = e.config(), {
      height: C,
      width: E,
      noWrap: B
    } = e.maxTickSpaces();
    const m = u === "top" || u === "bottom", y = !m;
    s && e.axis().tickValues(s), t = s || r || n, a.setStyle(e._axisNameStyle);
    const D = o ? a.getOriSize(f).height : 0;
    a.setStyle(e._tickLabelStyle), e.scale().paddingInner(l), e.scale().paddingOuter(c);
    const Q = y && h ? !0 : !!(A.rotation % 360);
    Q && (B = !0);
    let p, w;
    if (n && n.length) {
      const x = s || r || n, S = e._tickFormatter(x), _ = Q ? e.getVisibleDimensionsForTickLabels(x, S) : x.map(() => ({ width: E, height: C })), M = e.range(), k = A.rotation, T = Math.abs(k) === 90 || Math.abs(k) === 270, G = Math.abs(k) === 45 || Math.abs(k) === 315;
      let N = k > 90 ? 360 - k : k;
      N = 90 - N, N = N * Math.PI / 180;
      const { height: b } = e.maxTickSpaces();
      t = x.map((F, R, v) => {
        const { width: O, height: L } = _[R];
        if (a.useEllipsesOnOverflow(!0), e.isBinnedAxis() && g !== "html") {
          const { display: U, position: H } = I;
          if (G || T) {
            const z = e.getUnitWidth();
            let et, Z;
            if (Number.isInteger(F) && !Ee(F)) {
              et = `${v[R]}${Rg}${v[R] + e.binSize()}`;
              const { width: q } = a.getOriSize(
                U === "wholeRange" ? et : F
              );
              Z = q;
            } else if (!Ee(F)) {
              et = `${v[R].toFixed(2)}${Rg}${(v[R] + e.binSize()).toFixed(2)}`;
              const { width: q } = a.getOriSize(
                U === "wholeRange" ? et : F.toFixed(2)
              );
              Z = q;
            }
            let Y = y ? H === "center" ? e.getScaleValue(F) + z / 2 : e.getScaleValue(F) + z : H === "center" ? e.getScaleValue(F) + z / 2 : e.getScaleValue(F);
            if (u === "left") {
              const q = Z * Math.cos(N), $ = k > 90 ? Y - M[1] : M[0] - Y, P = Math.trunc(Y);
              p = P == M[0] || P == M[1] || $ < q, (R === 0 ? p && k !== 315 : p) && (w = P == M[0] || P == M[1] ? 0 : $ / Math.cos(N));
            }
            if (u === "right") {
              const q = Z * Math.cos(N), $ = k > 90 ? M[0] - Y : Y - M[1], P = Math.trunc(Y);
              p = P == M[0] || P == M[1] || $ < q, (R === 0 ? p && k !== 45 : p) && (w = P == M[0] || P == M[1] ? 0 : $ / Math.cos(N));
            }
            if (u === "bottom") {
              const q = Z * Math.cos(N), $ = k > 90 ? M[1] - Y : Y - M[0], P = Math.trunc(Y);
              p = P == M[0] || P == M[1] || $ > q, (R === 0 ? p && k !== 315 : p) && (w = P == M[0] || P == M[1] ? 0 : $ / Math.cos(N));
            }
            if (u === "top") {
              const q = Z * Math.cos(N), $ = k > 90 ? Y - M[0] : M[1] - Y, P = Math.trunc(Y);
              p = P == M[0] || P == M[1] || $ > q, (R === 0 ? p && k !== 45 : p) && (w = P == M[0] || P == M[1] ? 0 : $ / Math.cos(N));
            }
          }
          i = a.getSmartText(
            S(F, R),
            p ? w : h && v.length > 2 && !Q ? 1 / 0 : m ? O : Q ? L : O,
            m ? L : O,
            B
          );
        } else {
          if (u === "bottom" && (G || T)) {
            const { width: U } = a.getOriSize(F), H = e.getScaleValue(F), z = U * Math.sin(N), et = k > 90 ? M[0] - H : H - M[0], Z = k > 90 ? z < et : z > et, Y = U * Math.cos(N), q = b + a3 - l3, $ = Y > q;
            Z && !T ? w = et / Math.sin(N) : $ && (w = q / Math.cos(N)), p = Z || $;
          }
          if (y) {
            const { width: U, height: H } = e.availableSpace(), z = e.getTickSize();
            let et = U;
            g === "html" ? et = U - Sa : et = U - (o ? bS + D + d : 0) - z;
            const { rotation: Z } = A;
            let Y = Z;
            Z > 90 && Z < 270 && (Y = (180 + Z) % 360);
            const q = ls(Y), $ = 10, P = 10, st = Math.max(...M), nt = e.getScaleValue(F);
            let ot = et;
            if (Y >= 0 && Y < 90) {
              const Et = Math.abs(st - nt), ct = et * Math.tan(q);
              if (Et >= ct)
                ot = et / Math.cos(q);
              else {
                const ht = ls(90 - Y);
                ot = Math.max(Et - $, 0) / Math.cos(ht);
              }
            } else if (Y === 90 || Y === 270)
              ot = h ? H : e.getScaleStep() - P;
            else if (Y > 270 && Y <= 360) {
              const Et = nt, ct = ls(360 - Y), ht = et * Math.tan(ct);
              if (Et >= ht)
                ot = et / Math.cos(ct);
              else {
                const Mt = ls(
                  90 - (360 - Y)
                );
                ot = Et / Math.cos(Mt);
              }
            }
            i = a.getSmartText(
              S(F, R),
              ot,
              ot,
              !0
            );
          } else
            i = a.getSmartText(
              S(F, R),
              p ? w : g === "html" ? O - Sa : h && v.length > 2 && !Q ? 1 / 0 : m ? O : Q ? L : O,
              m ? L : O,
              B
            );
        }
        if (R === 0 && g !== "html" && e.isBinnedAxis()) {
          const { position: U } = I;
          if (U === "start" && !p) {
            const H = e._tickFormatter(n), z = v[0], et = v[1], Z = H(z, 0), Y = H(et, 1);
            let { width: q, height: $ } = a.getOriSize(Z), { width: P } = a.getOriSize(Y);
            const st = e.getScaleValue(z), nt = e.getScaleValue(et);
            st + q + P / 2 > nt && (q = nt - P / 2), i = a.getSmartText(
              S(F, R),
              q,
              $,
              B
            );
          }
        }
        return a.constructor.textToLines(i);
      });
    }
    return e.smartTicks(t), e;
  },
  getTickValues(e) {
    e._config.labels = e._renderConfig.labels;
    const t = e.axis().scale().domain();
    if (e._config.renderer === "html" || !e._config.isCompact)
      return t;
    if (e instanceof qt && e._config.isCompact) {
      const i = e.dependencies().labelManager;
      i.setStyle(e._tickLabelStyle);
      const n = e._tickFormatter(t);
      let A = "", s = !1;
      Ee(t[t.length - 1]) ? (A = n(
        t[t.length - 2],
        t.length - 2
      ), s = !0) : A = n(
        t[t.length - 1],
        t.length - 1
      );
      const o = i.getOriSize(A);
      let r = Number.MIN_VALUE;
      t.forEach((d, f) => {
        const I = n(d, f), C = i.getOriSize(I).width;
        C > r && (r = C);
      });
      const a = Number.isFinite(e.config().labels.rotation) ? e.config().labels.rotation : 0, { width: l, height: c } = Ri(
        a,
        Math.max(r, o.width),
        o.height
      ), g = e.isYAxis() ? c : l, h = Math.floor(
        Math.abs(e.range()[1] - e.range()[0]) / (g + 5)
      );
      let u = c4(
        t,
        h,
        s
      );
      if (e.isXAxis() && u.length > 2) {
        if (s) {
          const D = u[u.length - 2], Q = u[u.length - 1], p = n(
            D,
            u.length - 2
          ), w = i.getOriSize(
            p
          ).width, x = e.getScaleValue(D), S = e.getScaleValue(Q);
          x + w > S && u.splice(-2, 1);
        }
        const d = u[0], f = u[1], I = n(d, 0), C = n(f, 1), E = i.getOriSize(I).width, B = i.getOriSize(C).width, m = e.getScaleValue(d), y = e.getScaleValue(f);
        m + E + B / 2 > y && u.splice(0, 1);
      }
      return u;
    } else
      return J3(e, t, {
        canTicksShift: !1,
        spaceBetweenTicks: 4,
        allowExtremeLabelsOverflow: e.isXAxis() ? !(e._config.isFacet || e._config.isGrandTotalsEnabled) : !1,
        preserveLastTick: !1
      });
  },
  getIndex(e, t, i) {
    const n = e.domain(), A = J.isInvalid(t) ? t.value() : t, s = e.config().orientation;
    let o;
    return s === Se || s === vi ? o = n.length - n.findIndex(
      (r) => A == (J.isInvalid(r) ? r.value() : r)
    ) - 1 : o = n.findIndex(
      (r) => A == (J.isInvalid(r) ? r.value() : r)
    ), i && (o -= i.startIdx), o;
  }
}, Ko = {
  getTickValues: (e) => {
    let t = 0;
    const { orientation: i } = e.config(), { tickValues: n } = e.renderConfig(), A = e.range(), s = e.axis(), o = Math.abs(A[0] - A[1]), r = e.axisComponentDimensions().largestTickDimensions;
    if (n)
      return n;
    t = r[i === Ce || i === ie ? "width" : "height"];
    const a = z3(
      o,
      t,
      s,
      e
    );
    return VS(
      e,
      a,
      e.isBinnedAxis() ? {
        allowExtremeLabelsOverflow: e.isXAxis() ? !(e._config.isFacet || e._config.isGrandTotalsEnabled) : !1
      } : {}
    );
  },
  setTickConfig: (e) => {
    const { tickValues: t, showInnerTicks: i } = e.renderConfig(), n = e.axis();
    if (!i) {
      const a = n.tickValues() || [];
      let l = [];
      return a.length >= 2 && !e.config().belongsToTouchedColumn ? (l.push(a[0]), l.push(a[a.length - 1])) : l = [], n.tickValues(l), e;
    }
    t && t instanceof Array && e.axis().tickValues(t);
    const A = e.getTickValues();
    n.tickValues(A);
    const s = e.dependencies().labelManager;
    s.setStyle(e._tickLabelStyle);
    const o = e._tickFormatter(A), r = A.map((a, l) => {
      const c = o(a, l), g = s.getOriSize(c);
      return g.text = c, g;
    });
    return e.smartTicks(r), e;
  },
  /**
   * Sets a fixed baseline for the first ticks so that they can render effectively within
   * the given area
   *
   * @param {*} tickText
   * @param {*} config
   * @param {*} labelManager
   */
  setFixedBaseline(e, t) {
    const { orientation: i } = e.config(), { labels: n } = e.renderConfig(), { rotation: A } = n, s = e.axis(), o = s.tickValues(), r = e.smartTicks();
    if (r && r.length) {
      const { width: a, height: l } = e.smartTicks()[0];
      s.tickTransform((c) => {
        if (c === o[0]) {
          if (i === Se || i === vi)
            return `translate(0, -${l / 3}px)`;
          if ((i === ie || i === Ce) && !A)
            return `translate(${a / 2}px,  0px)`;
        }
        return "";
      });
    }
    return t;
  }
}, g4 = (e, t, i) => {
  const { orientation: n, fixedBaseline: A } = i.config(), s = i.renderConfig(), r = i.axis().tickSize(), {
    labels: { rotation: a }
  } = s;
  let l = a;
  return l < 0 && (l = 360 + l), l = 360 - l, e.map((c, g) => {
    const h = g === 0 && A, { height: u, width: d } = t[g], { height: f, width: I } = Ri(
      a,
      d,
      u
    );
    let C = i.getScaleValue(c);
    i.isYAxis() && (C = i.availableSpace().height - C);
    let E = [0], B = [0];
    if (n === "left") {
      const m = l > 0 && l < 180 ? 1 : l > 180 && l < 360 ? -1 : l === 0 ? 0.5 : l === 180 ? -0.5 : -1, y = l > 90 && l <= 135 ? -1 : l >= 135 && l < 225 ? -2 : l >= 225 && l < 270 ? -1 : 0;
      E.push(-1 * r), h ? m < 0 && B.push(m * f) : B.push(m * (f / 2)), E.push(y * I / 2);
    } else if (n === "right") {
      const m = l > 0 && l < 180 ? -1 : l > 180 && l < 360 ? 1 : l === 0 ? 0.5 : l === 180 ? -0.5 : -1, y = l > 90 && l <= 135 ? 1 : l > 135 && l < 225 ? 2 : l >= 225 && l < 270 ? 1 : 0;
      E.push(r), h ? m < 0 && B.push(m * f) : B.push(m * (f / 2)), E.push(y * I / 2);
    } else if (n === "bottom") {
      const m = l === 270 ? 0.5 : l > 0 && l < 180 ? -0.5 : l >= 180 && l < 360 ? 0 : 1, y = l > 0 && l < 180 || l > 180 && l < 360 ? 1 : 0;
      B.push(r), h ? m > 0 ? E.push(m * I / 2) : E.push(-1 * m * I / 2) : E.push(m * (I / 2)), B.push(y * f / 2), l === 270 && h && E.push(3), l >= 180 && l < 360 && h && E.push(I / 2), l === 0 && !h && E.push(-1 * I / 2);
    } else if (n === "top") {
      const m = l > 0 && l < 90 ? 0 : l >= 90 && l < 180 ? -0.5 : l >= 180 && l < 270 ? 0.5 : l >= 270 && l < 360 ? 0 : 1, y = -1;
      B.push(y * r), h ? E.push(m * I) : E.push(m * (I / 2)), B.push(y * (f / 2)), h && (l > 0 && l < 90 ? E.push(1 * I / 2) : l >= 90 && l < 180 ? E.push(1 * I) : l >= 270 && l < 360 && E.push(1 * I / 2));
    }
    return [E, B] = V3(
      0,
      0,
      rp(E),
      rp(B),
      l
    ), {
      position: C,
      rotation: l,
      xShift: E,
      yShift: B
    };
  });
}, rp = (e) => e.reduce((t, i) => t + i, 0), h4 = (e, t, i, n) => {
  const A = e.config(), s = e.axis(), o = e.renderConfig(), r = e.smartTicks(), a = s.scale(), c = (a.ticks || a.quantile || a.domain)(), h = s.tickValues() || c, u = e.axis().tickSize(), { tickStartIdx: d } = n, { orientation: f } = A, { labels: I } = o;
  let C = I.rotation;
  if (C < 0 && (C = 360 + C), C = 360 - C, e instanceof $i || e instanceof ui) {
    let E;
    E = h.slice(d);
    const B = g4(
      E,
      r.slice(d),
      e
    );
    return t.each(function(m, y) {
      const { xShift: D, yShift: Q, rotation: p } = B[y], w = String(
        r[d + y] ? r[d + y].text : m
      );
      let x = "", S = 0, _ = 0;
      f === ie ? x = `translate(0, -${u}) rotate(${p}, 0, 0)` : f === Ce ? x = `translate(0, ${u}) rotate(${p}, 0, 0)` : f === Se ? x = `translate(-${u}, 0) rotate(${p}, 0, 0)` : f === vi && (x = `translate(${u}, 0) rotate(${p}, 0, 0)`), V(this).attr("x", D).attr("y", Q).attr("dx", S).attr("dy", _).attr("transform", x).text(w).style("transform", "");
    }), t;
  }
  return t.each(function(E, B) {
    const m = String(
      r[d + B] ? r[d + B].text : E
    ), y = i.getOriSize(m), D = y.width, Q = y.width / 2;
    let p = 0, w = 0, x = 0, S = 0, _ = "";
    f === ie ? (_ = `translate(0, -${u}) rotate(${C}, 0, 0)`, S = 3, C >= 180 && C <= 360 ? p = Q : p = -Q, C === 0 || C === 360 ? (p = 0, S = 0) : C === 180 && (p = 0, S = 6)) : f === Ce ? (_ = `translate(0, ${u}) rotate(${C}, 0, 0)`, S = 3, C >= 180 && C <= 360 ? (p = -Q, x = -3) : (p = Q, x = 3), C === 0 || C === 360 ? (p = 0, S = u + 3, x = 0) : C === 180 && (p = 0, S = -3, x = 0)) : f === Se ? (_ = `translate(-${u}, 0) rotate(${C}, 0, 0)`, S = "0.3em", C < 90 ? x = 0 : C === 90 ? (p = Q, S = 9) : C > 90 && C <= 180 || C > 180 && C < 270 ? x = D : C === 270 ? (p = Q, S = -5) : x = 0) : f === vi && (_ = `translate(${u}, 0) rotate(${C}, 0, 0)`, S = "0.3em", C < 90 ? x = 0 : C === 90 ? (p = -Q, S = -5) : C > 90 && C <= 180 ? x = -D : C > 180 && C < 270 ? x = D : C === 270 ? (p = -Q, S = 5) : x = 0), V(this).attr("x", p).attr("y", w).attr("dx", x).attr("dy", S).attr("transform", _).text(m).style("transform", "");
  }), t;
}, u4 = (e, t, i, n) => {
  if (t instanceof qt) {
    const {
      bins: { position: A },
      orientation: s
    } = t.config();
    if (A === Qu)
      return "";
    const o = i.text, r = t.dependencies().labelManager, a = t.range(), l = r.getOriSize(o), c = t.getScaleValue(e);
    if ((s === cn || s === Vi) && n === 0 && c <= a[0])
      return `translate(${l.width / 2}, 0)`;
    if ((s === Se || s === vi) && n === 0 && c >= a[1])
      return `translate(0, ${-l.height / 2})`;
  }
  return "";
}, d4 = (e, t, i, n, A, s) => {
  const { _smartTicks: o } = t, r = t.config(), a = t.renderConfig(), l = t.dependencies().labelManager, { orientation: c, classPrefix: g } = r, h = ft(n, r.transition), { labels: u } = a, { rotation: d, smartTicks: f } = u, { tickStartIdx: I } = A, C = e.selectAll(".tick text");
  if (C.selectAll("tspan").remove(), d)
    h4(t, C, l, A);
  else if (!d && !f)
    C.attr("transform", "");
  else if (C.text(""), C.attr("transform", function(E, B) {
    return u4(
      E,
      t,
      o[B],
      B
    );
  }), c === cn || c === Vi) {
    C.attr("y", 0).attr("x", 0).text("");
    const E = j(
      C,
      "tspan",
      (m, y) => o[I + y] ? o[I + y].lines : [],
      `${g}-smart-text`
    );
    E.attr("dy", "0").style("opacity", "0");
    let B = E;
    h.disabled || (B = E.transition().duration(h.duration).on("end", s.newCallback())), C.each(function(m, y) {
      const D = V(this).selectAll("tspan"), Q = I + y;
      D.attr("dy", (p, w) => {
        if (o[Q])
          return c === Vi || w !== 0 ? o[Q].oriTextHeight : -o[Q].oriTextHeight * (o[Q].lines.length - 1) - i;
      });
    }), B.style("opacity", 1).text((m) => m).attr("x", 0);
  } else
    j(
      C,
      "tspan",
      (B, m) => o[I + m].lines,
      `${g}-smart-text`
    ).text((B) => B);
  return C;
}, f4 = (e) => {
  const { fixedBaseline: t } = e.config(), { showInnerTicks: i } = e.renderConfig(), n = e.domain();
  t && n.length && i && e.setFixedBaseline();
}, I4 = (e, t, i) => {
  const { axisNameHeight: n, availableSpace: A } = i;
  switch (t) {
    case Se:
      e.attr(
        "transform",
        `translate(${-(A.width - n)},${A.height / 2})rotate(-90)`
      );
      break;
    case vi:
      e.attr(
        "transform",
        `translate(${A.width - n},${A.height / 2})rotate(90)`
      );
      break;
    case ie:
      e.attr(
        "transform",
        `translate(${A.width / 2},${-A.height + n})`
      );
      break;
    case Ce:
      e.attr(
        "transform",
        `translate(${A.width / 2},${A.height - n / 2})`
      );
      break;
  }
  return e;
};
function C4(e, t, i) {
  const n = tt(
    e.renderConfig(),
    t
  ), A = e.config(), { show: s, xOffset: o, yOffset: r, showAxisName: a, labels: l, smartAxisName: c } = n, g = e.mount(), {
    orientation: h,
    axisNamePadding: u,
    className: d,
    id: f,
    classPrefix: I,
    labels: { className: C }
  } = A;
  let E = ft(n.transition, A.transition);
  if (!s)
    return;
  const B = j(
    V(g),
    "g",
    [e],
    `${d.split(" ")[0]}`,
    {},
    (_) => _.config().id
  );
  B.attr("class", d), B.attr("transform", `translate(${o},${r})`);
  let m = [], y, D, Q, p;
  if (e.domain().length > 0) {
    const _ = e.dependencies().labelManager, M = e.range(), k = e.axis(), T = e.scale(), {
      _tickLabelStyle: G,
      _tickFormatter: N
    } = e;
    p = e.getTickSize(), _.setStyle(G);
    const b = T.ticks || T.quantile || T.domain;
    if (e instanceof ee || e instanceof qt) {
      const R = B4(
        e,
        n
      );
      let v, O, L;
      R ? (v = R.visibleTicks, O = R.tickStartIdx, L = R.tickEndIdx) : (v = k.tickValues(), O = 0, L = v.length - 1), m = v, k.tickValues(m), y = { tickStartIdx: O, tickEndIdx: L };
    } else
      m = k.tickValues() || b(), y = { tickStartIdx: 0, tickEndIdx: m.length - 1 };
    if (k.tickFormat(N(m)), D = Math.abs(M[0] - M[1]), Q = e.axisComponentDimensions().largestTickDimensions, f4(e), !l.rotation && l.smartTicks === !1) {
      const R = E.disabled;
      let v = B;
      R || (v = B.transition().duration(1e3).on("end", i.newCallback())), v.call(k);
    } else {
      if (B.call(k), e instanceof qt) {
        const {
          bins: { position: R }
        } = e.config();
        R === "start" && B.selectAll(".tick").each(function() {
          const v = V(this), O = e.getUnitWidth(), U = v.attr("transform").match(
            /translate\(([^,]+),([^)]+)\)/
          );
          if (U) {
            const H = parseFloat(U[1]), z = parseFloat(U[2]), et = e.config().orientation;
            v.attr(
              "transform",
              `translate(${et === cn || et === Vi ? H - O / 2 : H}, ${et === Se || et === vi ? z + O / 2 : z})`
            );
          }
        });
      }
      d4(
        B,
        e,
        p,
        null,
        y,
        i
      );
    }
    B.selectAll(".tick").classed(`${I}-ticks`, !0), B.selectAll(".tick line").classed(`${I}-tick-lines`, !0);
    const F = B.selectAll(".tick text");
    F.classed(`${I}-ticks`, !0).classed(`${I}-ticks-${f}`, !0).classed(C, !0), A.useExternalCSS || Object.entries(A.ticks.labels.style).forEach(([R, v]) => {
      F.style(R, v);
    });
  } else
    B.selectAll(".tick").remove();
  const w = j(
    B,
    "text",
    [c],
    `${I}-axis-name`
  ).attr("text-anchor", "middle").classed(`${I}-axis-name-${f}`, !0).text((_) => _.text);
  A.useExternalCSS || Object.entries(A.title.style).forEach(
    ([_, M]) => w.style(_, M)
  ), w.classed(i3, !a);
  const x = D / 2, S = {
    labelProps: Q,
    tickSize: p,
    axisNameHeight: c.height,
    yOffset: r,
    xOffset: o,
    labelOffset: x,
    availableSpace: e.availableSpace()
  };
  I4(w, h, S), a && w.style("padding", `${u}px`), E4(e, {
    visibleTicks: m,
    ticksRange: y,
    tickSize: p,
    ticksContainer: B,
    showAxisName: a
  });
}
const E4 = (e, t) => {
  const { visibleTicks: i, ticksContainer: n, showAxisName: A } = t;
  if (!(e instanceof ee || e instanceof qt || e instanceof $i && A))
    return;
  const s = e.mount(), o = V(V(s).node().parentElement);
  o.style("position", "relative");
  const { orientation: r } = e.config(), { x: a, y: l } = Sd(
    n.attr("transform")
  ), c = [];
  if (e instanceof $i) {
    const h = n.selectAll("text.muze-axis-name"), { x: u, y: d } = Sd(
      h.attr("transform")
    ), f = e.config().field, I = a + u, C = l + d, E = e.isXAxis() ? {
      left: `${I}px`,
      top: `${C + 3}px`,
      transform: "translateX(-50%)"
    } : {
      left: `${I + 5}px`,
      top: `${C}px`,
      transform: "translateY(-50%)"
    };
    c.push({
      key: `direct-sort-container-measure-axis-${f}`,
      targetElem: h,
      targetData: {
        fieldName: f,
        getDataPath: () => [
          ...e.config().metaInf.facets,
          {
            field: e.config().fieldInstance,
            value: e.config().field,
            sourceType: e.config().metaInf.sourceType
          }
        ]
      },
      boxStyle: E
    });
  } else {
    const h = e.domain(), u = Symbol("Invalid value"), d = /* @__PURE__ */ new Map(), f = (I) => Ee(I) ? u : I;
    i.forEach((I) => {
      const C = Wa(
        h[h.length - 1],
        I
      );
      d.set(f(I), {
        rawValue: I,
        isLastValueInDomain: C,
        getDataPath: () => [
          ...e.config().metaInf.facets,
          {
            field: e.config().fieldInstance,
            value: I,
            sourceType: e.config().metaInf.sourceType
          }
        ]
      });
    }), n.selectAll("g.tick.muze-ticks").each(function() {
      const I = V(this), C = I.data()[0], E = I.node().textContent, { x: B, y: m } = Sd(
        I.attr("transform")
      ), y = d.get(f(C)), D = a + B, Q = l + m;
      let p = {};
      r === Se ? p = {
        right: "0px",
        top: `${Q}px`,
        transform: "translateY(-50%)"
      } : r === vi ? p = {
        left: "0px",
        top: `${Q}px`,
        transform: "translateY(-50%)"
      } : r === cn ? p = {
        left: `${D}px`,
        bottom: "0px",
        transform: "translateX(-50%)"
      } : r === Vi && (p = {
        left: `${D}px`,
        top: "0px",
        transform: "translateX(-50%)"
      }), c.push({
        key: `direct-sort-container-${C}`,
        targetElem: I,
        targetData: {
          value: E,
          ...y
        },
        boxStyle: p
      });
    });
  }
  j(
    o,
    "div",
    c,
    "muze-direct-sort-box",
    {},
    (h) => h.key
  ).each(function(h, u, d) {
    const f = V(this), { targetElem: I, targetData: C, boxStyle: E } = h;
    Pt(f, {
      ...E,
      background: "white",
      position: "absolute"
    });
    const B = j(
      f,
      "div",
      [1],
      "muze-direct-sort-container",
      {},
      null
    );
    I.node()[MS] = B.node(), B.node()[_S] = I.node(), GS({
      axisInst: e,
      directSortContainer: B,
      targetElemData: C,
      allTargetElems: d,
      textInfo: null,
      isOverlay: !1,
      cellRender: "svg"
    });
  });
}, B4 = (e, t) => {
  const i = vS(e, t);
  if (!i)
    return null;
  const n = e.domain(), A = e.getTickValues();
  let s, o, r;
  if (n.length === A.length)
    s = A.slice(i.absStartIdx, i.absEndIdx + 1), o = i.absStartIdx, r = i.absEndIdx;
  else {
    const a = n.slice(
      i.absStartIdx,
      i.absEndIdx + 1
    ), l = /* @__PURE__ */ new Map();
    for (let g = 0; g < a.length; g++) {
      const h = a[g];
      l.set(h, g);
    }
    o = Math.max(
      0,
      A.findIndex((g) => l.get(g) != null)
    );
    const c = Math.max(
      0,
      A.slice().reverse().findIndex((g) => l.get(g) != null)
    );
    r = A.length - 1 - c, s = A.slice(o, r + 1);
  }
  return {
    visibleTicks: s,
    tickStartIdx: o,
    tickEndIdx: r
  };
};
function Sd(e) {
  let t = 0, i = 0;
  const n = e.match(/translate\(([^()]+)\)/);
  if (n) {
    const A = n[1].split(",").map((s) => s.trim()).map((s) => +s);
    t = A[0], i = A[1];
  }
  return { x: t, y: i };
}
const Md = (e) => pu(e), _d = (e) => pu(e), ap = (e, t) => {
  let i, n;
  const A = e.config(), {
    width: s,
    height: o,
    padding: r
  } = e.availableSpace(), { top: a, left: l, bottom: c, right: g } = r, { isOffset: h } = t, { labels: u } = e.renderConfig(), { rotation: d } = u, {
    fixedBaseline: f,
    axisNamePadding: I,
    tickValues: C,
    labels: { rotation: E }
  } = A, { tickDimensions: B, allTickDimensions: m, axisNameDimensions: y, tickSize: D } = e.getAxisDimensions(), { height: Q, width: p } = B, x = (e instanceof ee || e instanceof qt ? !1 : e.renderConfig().showAxisName) ? I : 0, S = { smartTicks: !0, rotation: u.rotation }, _ = e._minTickDistance, M = e._minTickSpace, k = e._minDiff, T = e.domain(), G = y.height, N = _.width, b = Math.min(M.width, p), F = Math.min(M.height, Q);
  return {
    [LA]: {
      x: () => {
        !C && e.applyTickSkipping();
        const R = e.getTickValues(), v = R.length;
        i = (s - (v - 1) * N) / v, n = o - G - D - x, i < b && d !== 0 && (S.rotation = d, i < F && (n = o, i = F, e.renderConfig({
          showInnerTicks: !1,
          showOuterTicks: !1
        }))), o < G && e.renderConfig({ show: !1 });
        let O = [0, s - l - g];
        const L = e._dependencies.labelManager, U = e._tickFormatter(R), H = R.length ? L.getOriSize(U(R[0], 0)) : { width: 0, height: 0 }, z = R.length ? L.getOriSize(
          U(R[R.length - 1], R.length - 1)
        ) : { width: 0, height: 0 }, et = A.labels && Number.isFinite(A.labels.rotation) ? A.labels.rotation : 0, [Z, Y] = [
          H,
          z
        ].map((st) => Ri(et, st.width, st.height).width), q = AM(
          e,
          O,
          R[0],
          Z,
          R[R.length - 1],
          Y
        );
        let $ = [...O];
        const P = A.adjustRange ? Kg(k, O, T, q, A) : O;
        return $[0] += q[0], $[1] -= q[1], P[0] = Math.max($[0], P[0]), P[1] = Math.min($[1], P[1]), es(
          e,
          "y",
          P,
          h ? o : null
        ), e.maxTickSpaces({
          width: i,
          height: n,
          noWrap: d !== null
        }), E != null && (S.rotation = Md(E)), S;
      },
      y: () => {
        !C && e.applyTickSkipping();
        let R = s, v = [o - a - c, 0];
        const O = e.getTickValues(), L = e._dependencies.labelManager, U = e._tickFormatter(O), H = O.length ? L.getOriSize(U(O[0], 0)) : { width: 0, height: 0 }, z = O.length ? L.getOriSize(
          U(O[O.length - 1], O.length - 1)
        ) : { width: 0, height: 0 }, et = A.labels && Number.isFinite(A.labels.rotation) ? A.labels.rotation : 0, [Z, Y] = [
          H,
          z
        ].map((P) => Ri(et, P.width, P.height).height), q = l4(
          e,
          v,
          O[0],
          Z,
          O[O.length - 1],
          Y
        ), $ = A.adjustRange ? Kg(
          k,
          v,
          T,
          [Q / 2, Q / 2],
          A
        ) : v;
        return $[0] = Math.min(q[0], $[0]), $[1] = Math.max(q[1], $[1]), es(e, "x", $, h ? s : null), s - G - x <= N && (R = 0, e.renderConfig({
          showInnerTicks: !1,
          showOuterTicks: !1
        })), e.maxTickSpaces({
          width: R,
          height: o,
          noWrap: !0
        }), s < G && e.renderConfig({ show: !1 }), E != null && (S.rotation = _d(E)), S;
      }
    },
    [bn]: {
      x: () => {
        const R = e.config().renderer;
        es(
          e,
          "y",
          [0, s - l - g],
          h ? o : null
        );
        const v = e.range(), O = e.getTickValues();
        return i = (v[1] - v[0]) / (C || T).length - N, n = o - G - D - x, i < b && d !== 0 ? (S.rotation = d === null ? 45 : d, S.smartTicks = !1, i = Math.max(n, b), n < b && e.renderConfig({ showAxisName: !1 })) : (C || R === "svg" && O) && s / (R === "svg" && O ? O.length : T.length) - N < b && e.range([F / 2, s - F / 2]), o < G && e.renderConfig({ show: !1 }), i = (v[1] - v[0]) / (C || O || T).length - N, e.maxTickSpaces({
          width: i,
          height: n,
          noWrap: d !== null
        }), E != null && (S.rotation = Md(E)), S;
      },
      y: () => {
        es(
          e,
          "x",
          [o - c, a],
          h ? s : null
        );
        const R = e.range(), v = e.getTickValues();
        i = (R[0] - R[1]) / (C || T).length - N;
        let O = s - G - D - x;
        return O <= N && (O = 0, e.renderConfig({
          showInnerTicks: !1,
          showOuterTicks: !1
        })), i = (R[0] - R[1]) / (C || v || T).length - N, e.maxTickSpaces({
          width: O,
          height: d === 0 ? o : i,
          noWrap: !0
        }), s < G && e.renderConfig({ show: !1 }), E != null && (S.rotation = _d(E)), S;
      }
    },
    [ce]: {
      x: () => {
        S.smartTicks = !1;
        const R = p / 2, O = [(f ? 0 : R) + l, s - g - R];
        es(e, "y", O, h ? o : null);
        const L = e.range(), U = m.length * (p + N), H = L[1] - L[0], { showAxisName: z } = e.config();
        return H < U && u.rotation !== null && (o - p - x - D > G ? (S.rotation = null, e.renderConfig({
          showInnerTicks: !0,
          showAxisName: z
        })) : (S.rotation = -90, e.renderConfig({
          showInnerTicks: !0,
          showAxisName: !1
        }))), o < G && e.renderConfig({ show: !1 }), E != null && (S.rotation = Md(E)), S;
      },
      y: () => {
        S.smartTicks = !1;
        const R = Q / 2, v = f ? 1 : R, O = [o - c - v, R + a];
        return es(e, "x", O, h ? s : null), s < p + G + x && (e.renderConfig({ showInnerTicks: !1 }), s < G && e.renderConfig({ show: !1 })), E != null && (S.rotation = _d(E)), S;
      }
    }
  };
}, m4 = {
  availableSpace: {},
  axisDimensions: {},
  axisComponentDimensions: {},
  config: {
    sanitization: (e, t) => {
      const i = Object.assign({}, e._config || {}), n = tt({}, i);
      t = tt(n, t), a4(e, t), O3(e, t), t.axisNamePadding = Math.max(t.axisNamePadding, 0);
      const A = i4(t, i, [
        "interpolator",
        "exponent",
        "base",
        "orientation"
      ]), s = e.sanitizeTickFormatter(t);
      return A && (e._scale = e.createScale(t), e._axis = e.createAxis(t)), e._tickFormatter = (o) => s(o), e.resetRenderConfig(t), s4(t), t.ordering = Nr(
        t.ordering,
        Cu.ordering
      ), t.field === bt && (t.show = !1), op(t), t = e.resolveConfig(t), t;
    }
  },
  renderConfig: {
    sanitization: (e, t) => {
      const i = Object.assign({}, e._renderConfig || {});
      return t = tt(i, t), op(t), t;
    }
  },
  logicalSpace: {},
  mount: {},
  range: {
    sanitization: (e, t) => (e.scale().range(t), e.logicalSpace(null), t)
  },
  smartTicks: {},
  tickSize: {},
  maxTickSpaces: {
    sanitization: (e, t) => {
      const i = Object.assign({}, e._maxTickSpaces || {});
      return t = tt(i, t), t;
    }
  },
  valueParser: {
    defaultValue: (e) => e
  }
}, wl = "x", yu = "y", Q4 = "width", p4 = "height", y4 = "measurement", sM = "config", D4 = "minUnitWidth", w4 = "minUnitHeight", x4 = "dimensions", S4 = "measures", Bs = "dimension", _o = "measure", Wg = "continuous", Vg = "binned", M4 = "pivot", _4 = "format", b4 = "mount", N4 = "hasDataUpdated", oM = "rows", rM = "columns", F4 = "data", gs = "col", Ai = "row", xl = "column", UA = "color", Ts = "shape", OA = "size", jg = "detail", aM = "layers", lM = "transform", qg = "ordinal", IE = "linear", le = "left", De = "right", re = "top", Zt = "bottom", cM = "retinal", R4 = "cell", CE = "xAxes", EE = "yAxes", k4 = "entryCell", T4 = "initialized", v4 = "exitCell", G4 = "axis", L4 = "unit", U4 = "updated", O4 = "beforeupdate", H4 = "valueMatrix", P4 = "facet-headers", Y4 = "radius", J4 = "angle", gM = "angle0", K4 = "arc", W4 = "categorical", Br = "temporal", Du = "bar", hM = "line", uM = "point", V4 = "Primary", j4 = "Secondary", q4 = "both", dM = "interaction", fM = "gridLines", IM = "gridBands", CM = "header", zg = "headerTitle", Za = "rowFacetHeader", Zg = "columnFacetHeader", BE = "facet", EM = "table", z4 = "default", Z4 = "asc", $4 = "desc", Ke = "dark", dA = "none", $g = "normal", Wo = "darker", BM = 70, wu = "muze", vf = "headerTitlePadding", Gf = "textAlign", Lf = "start", X4 = "end", is = "header-type-field-name", Uf = "header-type-totals-title", xi = "normal", Ae = "total", Jn = "sub-total", $a = "backgroundColor", mM = "composedMark", t5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ANGLE: J4,
  ANGLE0: gM,
  ARC: K4,
  ASCENDING: Z4,
  AXIS: G4,
  BACKGROUND_COLOR: $a,
  BAR: Du,
  BEFORE_UPDATE: O4,
  BINNED: Vg,
  BOTH: q4,
  BOTTOM: Zt,
  CATEGORICAL: W4,
  CELL: R4,
  CELL_SOURCE_TYPE_NORMAL: xi,
  CELL_SOURCE_TYPE_SUB_TOTAL: Jn,
  CELL_SOURCE_TYPE_TOTAL: Ae,
  COL: gs,
  COLOR: UA,
  COLUMN: xl,
  COLUMNS: rM,
  COLUMN_FACET_HEADER: Zg,
  COMPOSED_MARK: mM,
  CONFIG: sM,
  CONTINUOUS: Wg,
  DARK: Ke,
  DARKER: Wo,
  DATA: F4,
  DEFAULT: z4,
  DEFAULT_BANDWIDTH_ARC_MARK: BM,
  DESCENDING: $4,
  DETAIL: jg,
  DIMENSION: Bs,
  DIMENSIONS: x4,
  END: X4,
  ENTRY_CELLS: k4,
  EXIT_CELLS: v4,
  FACET: BE,
  FACET_HEADERS: P4,
  FORMAT: _4,
  GRID_BANDS: IM,
  GRID_LINES: fM,
  HAS_DATA_UPDATED: N4,
  HEADER: CM,
  HEADER_TITLE: zg,
  HEADER_TITLE_PADDING: vf,
  HEADER_TYPE_FIELD_NAME: is,
  HEADER_TYPE_TOTALS_TITLE: Uf,
  HEIGHT: p4,
  INITIALIZED: T4,
  INTERACTION: dM,
  LAYERS: aM,
  LEFT: le,
  LINE: hM,
  LINEAR: IE,
  MEASURE: _o,
  MEASUREMENT: y4,
  MEASURES: S4,
  MIN_UNIT_HEIGHT: w4,
  MIN_UNIT_WIDTH: D4,
  MOUNT: b4,
  MUZE_CLASSNAME_PREFIX: wu,
  NONE: dA,
  NORMAL: $g,
  ORDINAL: qg,
  PIVOT: M4,
  POINT: uM,
  PRIMARY: V4,
  RADIUS: Y4,
  RETINAL: cM,
  RIGHT: De,
  ROW: Ai,
  ROWS: oM,
  ROW_FACET_HEADER: Za,
  SECONDARY: j4,
  SHAPE: Ts,
  SIZE: OA,
  START: Lf,
  TABLE: EM,
  TEMPORAL: Br,
  TEXT_ALIGN: Gf,
  TOP: re,
  TRANSFORM: lM,
  UNIT: L4,
  UPDATED: U4,
  VALUE_MATRIX: H4,
  WIDTH: Q4,
  X: wl,
  X_AXES: CE,
  Y: yu,
  Y_AXES: EE
}, Symbol.toStringTag, { value: "Module" }));
class xu extends _e().with(zs) {
  /**
   * Creates an instance of SimpleAxis.
   * @memberof SimpleAxis
   */
  constructor(t, i, n) {
    super(), this.eventManager(n), this._id = Ut(), this._dependencies = i, this._mount = null, this._range = [], this._domain = [], this._domainLock = !1, this._axisDimensions = {}, this._smartTicks = [], this._overriddenDimension = {}, this._directSortInfo = {
      currentNestedSortInfo: null,
      directSortEnabled: !0
    };
    const A = this.getDefaultConfig();
    t.className?.includes("muze-pivot-table-axis") && (A.showAxisName = !1);
    const s = tt(A, t), o = V("body"), r = s.classPrefix;
    s.useExternalCSS ? (this._tickLabelStyle = zn(
      o,
      `${r}-ticks`
    ), this._axisNameStyle = zn(
      o,
      `${r}-axis-name`
    )) : (this._tickLabelStyle = s.ticks.labels.style, this._axisNameStyle = s.title.style), i.labelManager.setStyle(this._tickLabelStyle), ge(this, m4), this.config(s), this.calculateMinTickSpaceAndTickDistance(i), this._scale = this.createScale(this._config), this._axis = this.createAxis(this._config), this._cachedExtendedDomainDiffs = null, this.emitSelfHooks(gt.INITIALIZED);
  }
  getDefaultConfig() {
    return tt({}, Cu);
  }
  calculateMinTickSpaceAndTickDistance(t) {
    if (this.config().renderer === "html")
      this._minTickDistance = {
        width: 0,
        height: 0
      };
    else {
      const i = t.labelManager.getOriSize("w");
      this._minTickDistance = {
        width: i.width * 3 / 4,
        height: i.height / 2
      };
    }
    this._minTickSpace = t.labelManager.getOriSize("www...");
  }
  axisType() {
    const { orientation: t } = this.config();
    return t === ie || t === Ce ? "x" : "y";
  }
  resolveConfig(t) {
    return t;
  }
  /**
   * Sets a fixed baseline for the first ticks so that they can render effectively within
   * the given area
   *
   * @param {*} tickText
   * @param {*} config
   * @param {*} labelManager
   */
  setFixedBaseline() {
    return this;
  }
  /**
   *
   *
   * @readonly
   * @memberof SimpleAxis
   */
  scale(...t) {
    return t.length ? (this._scale = t[0], this) : this._scale;
  }
  resetDomain() {
    return this._domain = [], this;
  }
  /**
   *
   *
   * @readonly
   * @memberof SimpleAxis
   */
  axis(...t) {
    return t.length ? (this._axis = t[0], this) : this._axis;
  }
  /**
   *
   *
   * @param {*} d
   *
   * @memberof SimpleAxis
   */
  domain(...t) {
    if (t.length) {
      const i = this.getValidDomain(t[0]);
      return this.scale().domain(i), this._domain = this.scale().domain(), this.setAxisComponentDimensions(), this.logicalSpace(null), this;
    }
    return this._domain;
  }
  extendDomain(t, i = { fieldToShowInPercentage: !1 }) {
    const n = [...this.range()].sort(xf), A = this.invert(n[0] - t[0]), s = this.invert(n[1] + t[1]), o = [A, s].sort(xf);
    this.domain(o, {
      overrideUserDomain: !!i.fieldToShowInPercentage
    });
  }
  cachedExtendedDomainDiffs(...t) {
    return t.length ? (this._cachedExtendedDomainDiffs = t[0], this) : this._cachedExtendedDomainDiffs;
  }
  /**
   * Overwrites domain with user defined domain (if present)
   * @param {Object} context reference to current axes
   * @param {Array} domain default domain
   *
   * @return {Array} domain
   */
  getValidDomain(t) {
    const { domain: i } = this.config();
    return i && (t = i), ft(t, []);
  }
  setAxisComponentDimensions() {
    this.axisComponentDimensions($S(this));
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  dependencies() {
    return this._dependencies;
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  createScale(t) {
    const { base: i, padding: n, interpolator: A, exponent: s } = t, o = this.range();
    return YA({
      padding: n,
      interpolator: A,
      exponent: s,
      base: i,
      range: o,
      type: this.constructor.type()
    });
  }
  formatTickValue(t, i) {
    const n = i(t);
    return Ei(n);
  }
  sanitizeTickFormatter(t) {
    const { tickFormat: i, format: n } = t;
    return i ? (A) => (s, o) => i(
      { formattedValue: this.formatTickValue(s, n), rawValue: s },
      { context: this, tickIndex: o, allRawTicks: A }
    ) : () => (A) => this.formatTickValue(A, n);
  }
  resetRenderConfig(t) {
    const {
      labels: i,
      show: n,
      showInnerTicks: A,
      showOuterTicks: s,
      showAxisName: o,
      xOffset: r,
      yOffset: a,
      tickValues: l,
      smartAxisName: c
    } = t;
    return this.renderConfig({
      labels: i,
      show: n,
      showInnerTicks: A,
      showOuterTicks: s,
      showAxisName: o,
      xOffset: r,
      yOffset: a,
      tickValues: l,
      smartAxisName: c
    }), this;
  }
  resetLogicalSpace() {
    this.logicalSpace(null), this.range([]), this.resetRenderConfig(this.config());
  }
  getFormattedText(t, i, n) {
    const A = this._tickFormatter;
    return A(n)(t, i);
  }
  getHyperLinkInfo(t, i, n, A, s) {
    const { hyperlink: o } = t.config();
    let r = o.generateHref(
      {
        formattedValue: n,
        rawValue: i
      },
      { context: t, tickIndex: A, allRawTicks: s }
    );
    const a = t.config().fieldInstance.data(), [l, c, g] = o.sanitizeHyperlink ? a.sanitiseStrings([
      r.target,
      r.rel,
      r.url
    ]) : [r.target, r.rel, r.url], h = g || n;
    return {
      target: l || Hs,
      rel: c || Ps,
      url: o.encode ? encodeURI(h) : h,
      classNames: r.classNames ? r.classNames : Js,
      styles: r.styles ? r.styles : Ys
    };
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  createAxis(t) {
    const { orientation: i } = t, n = W8[i];
    return n ? n(this.scale()) : null;
  }
  setTickValues(t) {
    const i = this.renderConfig();
    this.config({ ...i, tickValues: t }), this.tickValues = t, this.axis().tickValues(t);
  }
  /**
   * This method is used to set the space availiable to render
   * the SimpleCell.
   *
   * @param {number} width The width of SimpleCell.
   * @param {number} height The height of SimpleCell.
   * @memberof AxisCell
   */
  setAvailableSpace(t = 0, i, n, A) {
    let s = {};
    const { orientation: o } = this.config(), r = this.constructor.type();
    if (r === Iu) {
      const a = this.availableSpace();
      (!a || a.width !== t || a.height !== i) && this.resetTickSkippingInterval();
    }
    return this.availableSpace({ width: t, height: i, padding: n }), o === ie || o === Ce ? s = ap(this, { isOffset: A })[r].x() : s = ap(this, { isOffset: A })[r].y(), this.renderConfig({
      labels: s
    }), this.isBinnedAxis() || this.setTickConfig(), this.setSmartAxisName(), this;
  }
  setSmartAxisName() {
    const { orientation: t, name: i } = this.config(), n = t === ie || t === Ce ? "width" : "height", A = this.availableSpace()[n], s = this.dependencies().labelManager;
    return s.setStyle(this._axisNameStyle), this.renderConfig({
      smartAxisName: A4(i, A, s)
    }), this;
  }
  /**
   *
   *
   * @memberof SimpleAxis
   */
  setTickConfig() {
    return this;
  }
  getScaleValue(t) {
    if (t != null)
      return this.scale()(t);
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  getTickSize() {
    return this.axis().tickSize();
  }
  /**
   * Gets the space occupied by the parts of an axis
   *
   * @return {Object} object with details about sizes of the axis.
   * @memberof SimpleAxis
   */
  getAxisDimensions(...t) {
    return this.axisDimensions(Z3(this, ...t)), this.axisDimensions();
  }
  /**
   * Gets the space occupied by the axis.
   *
   * @param {Object} config The config.
   * @param {boolean} config.useRawSpace Whether to consider the original dimensions without any smartTick.
   *
   * @return {Object} object with details about size of the axis.
   * @memberof SimpleAxis
   */
  getLogicalSpace() {
    if (!this.logicalSpace()) {
      const t = fE(this);
      this.logicalSpace(t), this._implicitSpace = t;
    }
    return Dl(this), this.logicalSpace();
  }
  /**
   * Returns the value from the domain when given a value from the range.
   * @param {number} value Value from the range.
   * @return {number} Value
   */
  invert(t) {
    return this.scale().invert(t);
  }
  getNearestInvertedValue(t) {
    return this.invert(t);
  }
  getValueFromPixels(t) {
    return 1 / this.getPixelToValueRatio() * t;
  }
  /**
   * Gets the nearest range value from the given range values.
   * @param {number} v1 Start range value
   * @param {number} v2 End range value
   *
   * @return {Array} range values
   */
  getNearestRange(t, i) {
    return [t, i];
  }
  invertExtent(t, i) {
    return [this.invert(t), this.invert(i)];
  }
  getMinTickDifference() {
    return this.domain();
  }
  getFormattedTickValues(t) {
    return t;
  }
  /**
   * This method returns the width in pixels for one
   * unit along the axis. It is only applicable to band scale
   * and returns undefined for other scale type.
   *
   * @return {number} the width of one band along band scale axis
   * @memberof SimpleAxis
   */
  getUnitWidth() {
    return 0;
  }
  /**
   * This method returns an object that can be used to
   * reconstruct this instance.
   *
   * @return {Object} the serializable props of axis
   * @memberof SimpleAxis
   */
  serialize() {
    return {
      name: this.name,
      type: this.type,
      range: this.range(),
      config: this.config()
    };
  }
  /**
   * Returns the id of the axis.
   * @return {string} Unique identifier of the axis.
   */
  get id() {
    return this._id;
  }
  renderAsHTML(t) {
    const i = this.mount(), {
      className: n,
      orientation: A,
      classPrefix: s,
      id: o,
      useExternalCSS: r,
      ticks: {
        labels: { style: a }
      },
      labels: { align: l, className: c },
      isBold: g,
      firstRowZebraType: h
    } = this.config(), { show: u } = this.renderConfig(), d = A === Se, f = A === vi, I = d || f;
    if (!u)
      return;
    const C = vS(this, t), E = C ? C.translate : 0;
    let B;
    I ? B = `translateY(${E}px)` : B = `translateX(${E}px)`;
    const { _smartTicks: m } = this, y = this.domain();
    let D = m;
    C && (D = m.slice(
      C.absStartIdx,
      C.absEndIdx + 1
    ));
    const Q = this.getScaleStep(), p = C ? C.visibleCellDimension : D.length * Q + this.getScalePaddingOuter(), w = j(
      V(i),
      "div",
      [this],
      `${n.split(" ")[0]}`,
      {},
      (G) => G.config().id
    );
    w.attr("class", n).style("float", "none").style("display", "grid").style("grid-auto-flow", I ? "row" : "column").style("justify-content", "stretch").style("width", I ? "100%" : `${p}px`).style("height", I ? `${p}px` : "100%").style("transform", B), w.style(
      `grid-auto-${I ? "rows" : "columns"}`,
      "1fr"
    );
    const { hyperlinksInfo: x, hyperLinkConfig: S } = this.axisComponentDimensions() ?? {}, _ = I ? x.slice().reverse() : x, M = (I ? D.slice().reverse() : D).map(({ text: G, oriText: N }, b) => {
      const F = this.domain(), R = F.slice(
        C.absStartIdx,
        C.absEndIdx + 1
      ), v = R[this.isYAxis() ? R.length - 1 - b : b], O = F[F.length - 1] === v;
      return {
        value: G.replace(/<br \/>/g, " "),
        originalText: N,
        rawValue: v,
        isLastValueInDomain: O,
        type: this.isXAxis() ? CE : EE,
        hyperlinkInfo: _[b],
        hyperLinkConfig: S,
        getDataPath: () => {
          const U = F.slice(
            C.absStartIdx,
            C.absEndIdx + 1
          ), H = U[this.isYAxis() ? U.length - 1 - b : b];
          return [
            ...this.config().metaInf.facets,
            {
              field: this.config().fieldInstance,
              value: H,
              sourceType: this.config().metaInf.sourceType
            }
          ];
        }
      };
    }), k = (G, N, b) => {
      GS({
        axisInst: this,
        directSortContainer: G,
        targetElemData: N,
        allTargetElems: b,
        textInfo: {
          label: N.value,
          originalText: N.originalText,
          align: l || (d ? "end" : f ? "start" : "center")
        },
        hyperlinkInfo: N.hyperlinkInfo,
        hyperLinkConfig: N.hyperLinkConfig,
        isOverlay: !I,
        cellRender: "html"
      });
    }, T = j(
      w,
      "div",
      M,
      "tick",
      {
        enter: (G, N, b, F) => {
          k(G, N, F);
        },
        update: (G, N, b, F) => {
          k(G, N, F);
        }
      }
    );
    r || Object.entries(a).forEach(([G, N]) => {
      T.style(G, g && G === "font-weight" ? "600" : N);
    }), T.style("white-space", "nowrap").style(
      `${Pi}-${cn}`,
      T.size() > 1 ? uc[A][Pi][cn] : g3 + "px"
    ).style(
      `${Pi}-${Vi}`,
      uc[A][Pi][Vi] + "px"
    ).style(
      `${Pi}-${ss}`,
      uc[A][Pi][ss] + "px"
    ).style(
      `${Pi}-${As}`,
      uc[A][Pi][As] + "px"
    ).style("line-height", 1).classed(`${s}-ticks`, !0).classed(`${s}-ticks-${o}`, !0).classed(c, !0), I ? T.each(function(G, N) {
      const b = C ? y.length - C.absEndIdx - 1 + N : N;
      let F = "";
      h === "odd" ? F = `${s}-text-row-${(b + 1) % 2 === 0 ? "even" : "odd"}` : F = `${s}-text-row-${(b + 1) % 2 === 0 ? "odd" : "even"}`, V(this).classed(`${s}-text-row-even`, !1).classed(`${s}-text-row-odd`, !1).classed(F, !0).style(
        `padding-${d ? "right" : "left"}`,
        `${Sa}px`
      );
    }) : (T.style("overflow", "hidden"), T.style(
      "padding-left",
      `${Sa}px`
    ), T.style(
      "padding-right",
      `${Sa}px`
    ));
  }
  associatedHookComponentPaths() {
    return [
      [xt.AXIS, this.axisType()],
      [xt.AXIS]
    ];
  }
  /**
   * This method is used to render the axis inside
   * the supplied svg container.
   *
   * @param {SVGElement} svg the svg element in which to render the path
   * @memberof SimpleAxis
   */
  /* istanbul ignore next */
  render(t, i = {}) {
    if (this.mount()) {
      const n = {
        viewportRange: W(i, "viewportRange") || null,
        partialRange: sp(this, i) || null
      }, A = eA();
      this.emitSelfHooks(gt.BEFORE_RENDERED, {
        virtualScrolling: n
      }), this.setTickConfig(), this.config().renderer === "html" ? this.renderAsHTML(i) : C4(this, i, A), this.emitSelfHooks(gt.AFTER_RENDERED, {
        virtualScrolling: n
      }), A.onAllCallbacksCalled().then(() => {
        this.emitSelfHooks(gt.ANIMATION_END, {
          virtualScrolling: n
        });
      });
    }
    return this;
  }
  emitAllRenderHooksWhenRenderSkipped(t) {
    const i = {
      viewportRange: W(t, "viewportRange") || null,
      partialRange: sp(this, t) || null
    };
    this.emitSelfHooks(
      [
        gt.BEFORE_RENDERED,
        gt.AFTER_RENDERED,
        gt.ANIMATION_END
      ],
      { virtualScrolling: i }
    );
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  remove() {
    return V(this.mount()).remove(), this._dependencies = null, this._mount = null, this._range = null, this._domain = null, this._domainLock = null, this._axisDimensions = null, this._smartTicks = null, this._overriddenDimension = null, this._directSortInfo = null, this._tickLabelStyle = null, this._axisNameStyle = null, this._scale = null, this._axis = null, this._cachedExtendedDomainDiffs = null, this;
  }
  /**
   *
   *
   * @memberof SimpleAxis
   */
  unsubscribe() {
    return this;
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  isReverse() {
    const t = this.range();
    return t[0] > t[1];
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  getPixelToValueRatio() {
    const t = this.scale(), i = t.range(), n = t.domain();
    return Math.abs(i[1] - i[0]) / (n[1] - n[0]);
  }
  _getRawTickValue(t) {
    return J.getActualValue(t);
  }
  getTicksBasedOnData(t) {
    const i = V(this.mount()).selectAll(".tick");
    let n = null, A = null;
    return t && (n = i.filter(
      (s) => J.getActualValue(t) === this._getRawTickValue(
        s.getDataPath ? s.getDataPath().pop().value : s
      )
    ), A = i.filter(
      (s) => J.getActualValue(t) !== this._getRawTickValue(
        s.getDataPath ? s.getDataPath().pop().value : s
      )
    )), {
      selectionSet: n,
      rejectionSet: A || i
    };
  }
  getIndex() {
    return null;
  }
  getLastTickElement() {
    return this.mount().querySelector(".tick:last-child");
  }
  isXAxis() {
    const { orientation: t } = this.config();
    return t === ie || t === Ce;
  }
  isYAxis() {
    const { orientation: t } = this.config();
    return t === Se || t === vi;
  }
  currentNestedSortInfo(...t) {
    return t.length ? (this._directSortInfo.currentNestedSortInfo = t[0], this) : this._directSortInfo.currentNestedSortInfo;
  }
  directSortEnabled(...t) {
    return t.length ? (this._directSortInfo.directSortEnabled = t[0], this) : this._directSortInfo.directSortEnabled;
  }
  isBinnedAxis() {
    return !1;
  }
}
const mE = (e, { preserveLastTick: t } = { preserveLastTick: !0 }, i, n, A) => {
  const s = [];
  if (n) {
    if (A === "bottom" || A === "top") {
      if (i = i < 0 ? 360 - Math.abs(i) : i, i !== 0 && i !== 180 && i !== 360)
        return lp(e, i, n, A);
    } else if (i -= 90, i = i < 0 ? 360 - Math.abs(i) : i, i !== 0 && i !== 180)
      return lp(e, i, n, A);
  }
  let o = 0, r = "replace";
  const a = () => {
    r = r === "push" ? "replace" : "push";
  };
  let l = 0;
  for (; l < e.length; ) {
    if (l === 0 || t && l === e.length - 1) {
      s.push(l), l++;
      continue;
    }
    const c = s[s.length - 1], g = dc(
      e[c],
      e[l]
    ), h = e[l + 1] ? dc(e[l], e[l + 1]) : !0;
    g && h ? (o > 0 && e[l].crossDimension > e[o].crossDimension && (o = l), l++) : r === "push" ? (s.push(l), o = l, l++, a()) : (s[s.length - 1] = o, l = o + 1, a());
  }
  return s.filter((c, g) => {
    if (g === 0 || t && g === s.length - 1)
      return !0;
    const h = dc(
      e[s[g - 1]],
      e[s[g]]
    ), u = e[s[g + 1]] ? dc(
      e[s[g]],
      e[s[g + 1]]
    ) : !1;
    return !(h || u);
  });
}, dc = (e, t) => {
  const i = e.isTickShifted ? e.position + e.dimension : e.position + e.dimension / 2, n = t.isTickShifted ? t.position - t.dimension : t.position - t.dimension / 2;
  return i > n;
}, lp = (e, t, i, n) => {
  const [A, s] = i.range();
  let o;
  const r = n === "bottom" || n === "top" ? "dimension" : "crossDimension", a = n === "bottom" || n === "top" ? "crossDimension" : "dimension";
  let l = [];
  const c = e.length;
  if (c) {
    if (t > 0 && t <= 30) {
      let h = Number.MIN_VALUE, u = Number.MAX_VALUE;
      e.forEach((f, I) => {
        const C = e[I][r];
        h = Math.max(h, C), u = Math.min(u, C);
      }), o = (h + u) / 2 + kf;
    }
    (t > 30 && t <= 160 || t > 170) && (o = e[0][a] + kf);
    const g = Math.floor(Math.abs(s - A) / o);
    if (g < c) {
      const h = Math.floor(c / g);
      e.forEach((u, d) => {
        (d === 0 || d === c - 1 || d > 0 && d <= c - h && d % h === 0) && l.push(d);
      });
    } else
      e.forEach((h, u) => {
        l.push(u);
      });
  }
  return l;
};
class QE {
  skipTicks(t, i) {
    return mE(t, i);
  }
}
class QM extends QE {
  createScale(t) {
    const { range: i } = t, n = Es.linear;
    return this._scale = n().range(i), this._scale;
  }
  getScaleValue(t) {
    return this._scale(t) + 0.5;
  }
  sanitizeDomain(t) {
    return t.length && (t = Cl(t)), t;
  }
}
class e5 extends QE {
  createScale(t) {
    const { range: i, base: n } = t, A = Es.log;
    return this._scale = A().range(i).base(n), this._scale;
  }
  getScaleValue(t) {
    const i = this._scale;
    return t <= 0 ? i(i.domain()[0]) : i(t) + 0.5;
  }
  sanitizeDomain(t) {
    return t[0] <= 0 && (t[0] = Math.max(1, t[0])), t[1] <= 0 && (t[1] = Math.max(1, t[1])), t;
  }
  isTickOverlapping(t, i) {
    const n = t.position + t.dimension / 2, A = i.position - i.dimension / 2;
    return n > A;
  }
}
class i5 extends QE {
  createScale(t) {
    const { range: i, exponent: n } = t, A = Es.pow;
    return this._scale = A().range(i).exponent(n), this._scale;
  }
  getScaleValue(t) {
    return this._scale(t) + 0.5;
  }
  sanitizeDomain(t) {
    return t;
  }
}
const n5 = {
  [uu]: e5,
  [du]: i5,
  [ce]: QM
};
class $i extends xu {
  constructor(t, ...i) {
    o4(t), r4(t), super(t, ...i);
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  createScale(t) {
    const { base: i, padding: n, interpolator: A, exponent: s } = t, o = this.range(), r = n5[A];
    this._interpolator = new r();
    let a = this._interpolator.createScale({
      padding: n,
      exponent: s,
      base: i,
      range: o
    });
    return a = a.nice(), a;
  }
  /**
   *
   *
   * @static
   *
   * @memberof ContinousAxis
   */
  static type() {
    return ce;
  }
  getScaleValue(t) {
    if (t != null)
      return this._interpolator.getScaleValue(t);
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  getTickSize() {
    const { showInnerTicks: t, showOuterTicks: i } = this.renderConfig(), n = this.axis();
    return n.tickSizeInner(t === !1 ? 0 : this.config().tickSize), n.tickSizeOuter(i === !1 ? 0 : this.config().tickSize), n.tickSize();
  }
  /**
   *
   *
   * @param {*} d
   *
   * @memberof SimpleAxis
   */
  domain(...t) {
    if (t.length) {
      const i = t[0], n = t.length > 1 && t[t.length - 1] || {
        overrideUserDomain: !1
      }, A = this._interpolator.sanitizeDomain(
        n.overrideUserDomain ? i : iM(this, i)
      );
      return t4(this, A), this.setAxisComponentDimensions(), this.logicalSpace(null), this;
    }
    return this._domain;
  }
  /**
   * This method is used to set the space availiable to render
   * the SimpleCell.
   *
   * @param {number} width The width of SimpleCell.
   * @param {number} height The height of SimpleCell.
   * @memberof AxisCell
   */
  setAvailableSpace(...t) {
    return super.setAvailableSpace(...t), this.getTickSize(), this;
  }
  /**
   *
   *
   * @param {*} tickValues
   *
   * @memberof SimpleAxis
   */
  setTickConfig() {
    return Ko.setTickConfig(this);
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  getTickValues() {
    return Ko.getTickValues(this);
  }
  getMinTickDifference() {
    return Au(this.renderConfig().tickValues);
  }
  /**
   * Sets a fixed baseline for the first ticks so that they can render effectively within
   * the given area
   *
   * @param {*} tickText
   * @param {*} config
   * @param {*} labelManager
   */
  setFixedBaseline(t) {
    return Ko.setFixedBaseline(this, t);
  }
}
class ee extends xu {
  constructor(...t) {
    super(...t), this._interpolator = {
      skipTicks: mE
    };
  }
  /**
   *
   *
   * @static
   *
   * @memberof BandAxis
   */
  static type() {
    return bn;
  }
  resolveTickLabelOverflowDirection(t, i) {
    return wn.resolveTickLabelOverflowDirection(
      t,
      i
    );
  }
  getVisibleDimensionsForTickLabels(t, i) {
    return wn.getVisibleDimensionsForTickLabels(
      this,
      t,
      i
    );
  }
  setTickConfig() {
    return wn.setTickConfig(this);
  }
  overrideDimension(t) {
    return t == null ? this._overriddenDimension : (this._overriddenDimension = t, this);
  }
  /**
   * Gets the space occupied by the axis
   *
   * @param {Object} config The config.
   * @param {boolean} config.useRawSpace Whether to consider the original dimensions without any smartTick.
   *
   * @return {Object} object with details about size of the axis.
   * @memberof SimpleAxis
   */
  getLogicalSpace(t) {
    if (t = t || {}, !this.logicalSpace()) {
      const i = eM(
        this,
        t.useRawSpace
      );
      this.logicalSpace(i), this._implicitSpace = i;
    }
    return Dl(this), this.logicalSpace();
  }
  /**
   *
   * The return tick values must be data instead of formatted ticks.
   * @memberof BandAxis
   */
  getTickValues() {
    return wn.getTickValues(this);
  }
  formatTickValue(t, i, n, A) {
    let s;
    return n === J.FieldSubtype.TEMPORAL && A === oe ? s = Ee(t) ? t : i.rawFormat()(t) : s = t, Ei(s);
  }
  getScaleStep() {
    return this.scale().step();
  }
  getScalePaddingOuter() {
    const t = this.scale();
    return t.step() * t.paddingOuter();
  }
  getScalePaddingInner() {
    const t = this.scale();
    return t.step() * t.paddingInner();
  }
  getScaleBandwidth() {
    return this.scale().bandwidth();
  }
  sanitizeTickFormatter(t) {
    const {
      internalFormat: i = ({ rawValue: c }) => c,
      tickFormat: n,
      fieldAs: A,
      fieldSubtype: s,
      fieldInstance: o,
      grandTotalFormatter: r,
      metaInf: a
    } = t, l = (c, g, h, u) => {
      const d = i(
        { rawValue: g },
        { context: this, tickIndex: h, allRawTicks: u }
      );
      return c(
        {
          formattedValue: this.formatTickValue(
            d,
            o,
            s,
            A
          ),
          rawValue: g
        },
        { context: this, tickIndex: h, allRawTicks: u }
      );
    };
    return r && a.sourceType === "total" ? (c) => (g, h) => l(r, g, h, c) : n ? (c) => (g, h) => l(n, g, h, c) : (c) => (g, h) => {
      const u = i(
        { rawValue: g },
        { context: this, tickIndex: h, allRawTicks: c }
      );
      return this.formatTickValue(
        u,
        o,
        s,
        A
      );
    };
  }
  /**
   *
   *
   *
   * @memberof BandAxis
   */
  getUnitWidth() {
    return this.scale().bandwidth();
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  getTickSize() {
    const { showInnerTicks: t, showOuterTicks: i } = this.renderConfig(), n = this.axis();
    return n.tickSizeInner(t ? this.config().tickSize : 0), n.tickSizeOuter(i ? this.config().tickSize : 0), n.tickSize();
  }
  invertExtent(t, i) {
    return this.scale().invertExtent(t, i);
  }
  /**
   * It accepts a range value and returns one of axis
   * domain values. It assumes that a range value will
   * be associated with a domain value if the range value is in this range:
   *    [domainValPosition - innerPadding / 2, domainValPosition + bandwidth + innerPadding / 2]
   */
  getNearestInvertedValue(t) {
    const i = this.isXAxis() ? this.domain() : [...this.domain()].reverse(), n = this.getUnitWidth(), A = this.getScalePaddingInner();
    let s = this.invert(t);
    s === void 0 && (s = i[0]);
    const o = i.indexOf(s), r = this.getScaleValue(s), a = [
      r - A / 2,
      r + n + A / 2
    ];
    return cr(t, a) ? s : t < a[0] ? i[o - 1] : t > a[1] ? i[o + 1] : void 0;
  }
  /**
   * Gets the nearest range value from the given range values.
   * @param {number} v1 Start range value
   * @param {number} v2 End range value
   * @return {Array} range values
   */
  getNearestRange(t, i) {
    const n = this.scale(), A = n.range(), s = A[0] > A[1], o = this.invertExtent(t, i), r = n(s ? o[o.length - 1] : o[0]), a = n(s ? o[0] : o[o.length - 1]) + n.bandwidth();
    return [r, a];
  }
  getValidDomain(t) {
    let i = super.getValidDomain(t);
    const n = this.config().orientation;
    return (n === "left" || n === "right") && i.reverse(), i;
  }
  extendDomain() {
  }
  getIndex(t, i) {
    return wn.getIndex(this, t, i);
  }
}
function A5(e) {
  const t = e.originalDomain(), i = e._minDiff, n = e._dependencies.labelManager, {
    width: A,
    height: s,
    padding: o
  } = e.availableSpace();
  let r = e._minTickSpace.width, a = e._minTickSpace.height;
  const l = e.config(), c = e.config().useUTC, g = pu(l.labels.rotation), h = Ri(
    g,
    r,
    a
  );
  r = h.width, a = h.height;
  let u, d, f, I, C;
  e.isXAxis() ? (u = "width", d = e._minTickDistance.width, f = A, I = r, C = { left: o.left, right: o.right }) : (u = "height", d = e._minTickDistance.height, f = s, I = a, C = { left: o.top, right: o.bottom });
  let E = Math.floor(
    (f + d) / (I + d)
  );
  const B = WS.slice();
  let m = B.length - 1;
  const {
    step: y,
    multiplier: D,
    start: Q
  } = l.tickInterval;
  if (t.length >= 2 && t.every(
    (x) => x != null && !Number.isNaN(x)
  )) {
    if (y) {
      const [
        x,
        S,
        _,
        M,
        k,
        T
      ] = JS[y], G = S(Q), N = _(Q);
      let b, F = 1;
      for (; b = D * F, !(b > k || Math.abs(t[1] - t[0]) === 0 || b * x > Math.abs(t[1] - t[0])); ) {
        if (T(b)) {
          const v = KS(
            y,
            G,
            N,
            x,
            b,
            M
          );
          if (cp(e, v, {
            maxPossibleTicks: E,
            useUTC: c,
            labelManager: n,
            tickDimensionType: u,
            minDistanceBetweenTicks: d,
            availableSpaceDimen: f,
            padding: C,
            minDiff: i,
            domain: t,
            axisConfig: l
          }))
            return v[c ? 3 : 2];
        }
        F++;
      }
    }
    for (let x = 0; x < B.length; x++) {
      const S = B[x];
      if (cp(e, S, {
        maxPossibleTicks: E,
        useUTC: c,
        labelManager: n,
        tickDimensionType: u,
        minDistanceBetweenTicks: d,
        availableSpaceDimen: f,
        padding: C,
        minDiff: i,
        domain: t,
        axisConfig: l
      })) {
        m = x;
        break;
      }
    }
  }
  return B[m][c ? 3 : 2];
}
function cp(e, t, i) {
  const {
    maxPossibleTicks: n,
    useUTC: A,
    labelManager: s,
    tickDimensionType: o,
    minDistanceBetweenTicks: r,
    availableSpaceDimen: a,
    padding: l,
    minDiff: c,
    domain: g,
    axisConfig: h
  } = i, { labels: u } = h, d = Math.abs(g[1] - g[0]);
  if (Math.floor(
    d / t[1] + 1
  ) <= n) {
    const I = e.scale().ticks(t[A ? 3 : 2]), C = I.length, E = e._tickFormatter(I), B = I.map((x, S) => {
      const { width: _, height: M } = s.getOriSize(E(x, S));
      return Ri(
        u.rotation,
        _,
        M
      )[o];
    }), y = Math.max(...B) * C + (C - 1) * r;
    let D = [0, a - l.left - l.right];
    const Q = AM(
      e,
      D,
      I[0],
      B[0],
      I[I.length - 1],
      B[B.length - 1]
    ), p = Kg(
      c,
      D,
      g,
      Q,
      e.config()
    ), w = Math.abs(p[0] - p[1]);
    return y <= w;
  }
  return !1;
}
class kr extends xu {
  constructor(...t) {
    super(...t), this._minDiff = 1 / 0, this._originalDomain = null, this._tickSkippingInterval = null;
  }
  /**
   *
   *
   *
   * @memberof TimeAxis
   */
  createScale(t) {
    const { base: i, padding: n, interpolator: A, exponent: s } = t, o = this.range();
    return YA({
      padding: n,
      interpolator: A,
      exponent: s,
      base: i,
      range: o,
      type: t.useUTC ? nE : LA
    });
  }
  /**
   *
   *
   * @static
   *
   * @memberof TimeAxis
   */
  static type() {
    return LA;
  }
  formatTickValue(t) {
    const i = this.scale().tickFormat()(t);
    return Ei(i);
  }
  sanitizeTickFormatter(t) {
    const { tickFormat: i } = t;
    return i ? (n) => (A, s) => i(
      {
        formattedValue: this.formatTickValue(A),
        rawValue: A.getTime()
      },
      {
        context: this,
        tickIndex: s,
        allRawTicks: n.map((o) => o.getTime())
      }
    ) : () => (n) => this.formatTickValue(n);
  }
  /**
   *
   *
   *
   * @memberof SimpleAxis
   */
  getTickSize() {
    const { showInnerTicks: t, showOuterTicks: i } = this.renderConfig(), n = this.axis();
    return n.tickSizeInner(t === !1 ? 0 : 6), n.tickSizeOuter(i === !1 ? 0 : 6), super.getTickSize();
  }
  /**
   *
   *
   *
   * @memberof TimeAxis
   */
  getTickValues() {
    return this.renderConfig().tickValues || this.scale().ticks();
  }
  /**
   *
   *
   * @param {*} diff
   *
   * @memberof TimeAxis
   */
  minDiff(t) {
    return this._minDiff = Math.min(this._minDiff, t), this;
  }
  applyTickSkipping() {
    Y3(this);
  }
  /**
   *
   *
   * @param {*} d
   *
   * @memberof SimpleAxis
   */
  domain(...t) {
    if (t.length) {
      const i = iM(this, t[0]);
      return e4(this, i), this.setAxisComponentDimensions(), this.logicalSpace(null), n4(this, i), this;
    }
    return this._domain;
  }
  overrideDimension(t) {
    return t == null ? this._overriddenDimension : (this._overriddenDimension = t, this);
  }
  getMinTickDifference() {
    return Au(this.config().tickValues);
  }
  /**
   * This method is used to set the space availiable to render
   * the SimpleCell.
   *
   * @param {number} width The width of SimpleCell.
   * @param {number} height The height of SimpleCell.
   * @memberof AxisCell
   */
  setAvailableSpace(...t) {
    return super.setAvailableSpace(...t), this.getTickSize(), this;
  }
  /**
   *
   *
   * @returns
   * @memberof BandAxis
   */
  setTickConfig() {
    let t, i;
    const { labels: n, tickValues: A } = this.renderConfig(), {
      height: s,
      width: o,
      noWrap: r
    } = this.maxTickSpaces(), { labelManager: a } = this._dependencies, l = this.getTickValues();
    A && this.axis().tickValues(A);
    const { width: c, height: g } = Ri(
      n.rotation,
      o,
      s
    );
    if (t = A || l, a.setStyle(this._tickLabelStyle), l && l.length) {
      const h = A || l, u = this._tickFormatter(h);
      t = h.map((d, f) => (a.useEllipsesOnOverflow(!0), i = a.getSmartText(
        u(d, f),
        c,
        g,
        r
      ), a.constructor.textToLines(i)));
    }
    return this.smartTicks(t), this;
  }
  originalDomain(...t) {
    return t.length ? (this._originalDomain = t[0], this) : this._originalDomain || this.domain();
  }
  getTickSkippingInterval() {
    return this._tickSkippingInterval || (this._tickSkippingInterval = A5(this)), this._tickSkippingInterval;
  }
  resetTickSkippingInterval() {
    this._tickSkippingInterval = null;
  }
  _getRawTickValue(t) {
    return new Date(t).getTime();
  }
}
function s5(e) {
  const { fieldInstance: t, field: i } = e.config();
  return t.data().getField(i).getBinSize();
}
function Xg(e, t) {
  return Ee(t) ? t : +t + +e.binSize();
}
class fn extends xu {
  constructor(...t) {
    super(...t), this.binSize(s5(this));
  }
  binSize(...t) {
    return t.length ? (this._binSize = t[0], this) : this._binSize;
  }
  isBinnedAxis() {
    return !0;
  }
}
const o5 = tt(
  {},
  Cu,
  {
    bins: {
      display: qS,
      position: Qu
    },
    labels: {
      rotation: null
    },
    padding: 0,
    paddingInner: 0,
    paddingOuter: 0
  }
), r5 = tt(
  {},
  Cu,
  {
    bins: {
      display: Jg,
      position: Qu
    }
  }
);
class qt extends fn {
  constructor(...t) {
    super(...t), this._interpolator = {
      skipTicks: mE
    };
  }
  getDefaultConfig() {
    return tt({}, o5);
  }
  createScale(t) {
    const { padding: i } = t, n = this.range();
    return YA({
      padding: i,
      range: n,
      type: "band"
    });
  }
  static type() {
    return bn;
  }
  resolveConfig(t) {
    const { bins: i, orientation: n } = t, A = n === "top" || n === "bottom";
    let s = {};
    return (t.labels.rotation === void 0 || t.labels.rotation === null) && (s = {
      labels: {
        rotation: A ? -45 : 0
      }
    }), i.display === Jg && !i.position && (s.bins = {
      position: "start"
    }), tt({}, t, s);
  }
  getIndex(t, i) {
    return wn.getIndex(this, t, i);
  }
  getTickValues() {
    return wn.getTickValues(this);
  }
  getUnitWidth() {
    return this.scale().bandwidth();
  }
  formatTickValue(t) {
    const i = this.config().bins.display;
    return typeof t == "string" ? t : Ee(t) ? Ei(t) : i === Jg ? Ei(Number.isInteger(t) ? t : t.toFixed(2)) : _r([t, Xg(this, t)]);
  }
  sanitizeTickFormatter(t) {
    const { tickFormat: i, grandTotalFormatter: n, metaInf: A } = t, s = (o, r, a, l) => o(
      {
        formattedValue: this.formatTickValue(r),
        rawValue: Ee(r) ? r : [r, Xg(this, r)]
      },
      { context: this, tickIndex: a, allRawTicks: l }
    );
    return n && A.sourceType === "total" ? (o) => (r, a) => s(n, r, a, o) : i ? (o) => (r, a) => s(i, r, a, o) : () => (o) => this.formatTickValue(o);
  }
  setTickConfig() {
    return wn.setTickConfig(this);
  }
  resolveTickLabelOverflowDirection(t, i) {
    return wn.resolveTickLabelOverflowDirection(
      t,
      i
    );
  }
  getVisibleDimensionsForTickLabels(t, i) {
    return wn.getVisibleDimensionsForTickLabels(
      this,
      t,
      i
    );
  }
  overrideDimension(t) {
    return t == null ? this._overriddenDimension : (this._overriddenDimension = t, this);
  }
  /**
   * Gets the space occupied by the axis
   *
   * @param {Object} config The config.
   * @param {boolean} config.useRawSpace Whether to consider the original dimensions without any smartTick.
   *
   * @return {Object} object with details about size of the axis.
   * @memberof SimpleAxis
   */
  getLogicalSpace(t) {
    if (t = t || {}, !this.logicalSpace()) {
      const i = eM(
        this,
        t.useRawSpace
      );
      this.logicalSpace(i), this._implicitSpace = i;
    }
    return Dl(this), this.logicalSpace();
  }
  getValidDomain(t) {
    const { domain: i, orientation: n } = this.config(), A = i || t;
    return n === "left" || n === "right" ? A.slice().reverse() : A;
  }
  getScaleStep() {
    return this.scale().step();
  }
  getScalePaddingOuter() {
    const t = this.scale();
    return t.step() * t.paddingOuter();
  }
  getScalePaddingInner() {
    const t = this.scale();
    return t.step() * t.paddingInner();
  }
  getScaleBandwidth() {
    return this.scale().bandwidth();
  }
  getScaleValue(t) {
    if (t != null)
      return this.scale()(t);
  }
  extendDomain() {
  }
}
class ui extends fn {
  static type() {
    return ce;
  }
  getDefaultConfig() {
    return tt({}, r5);
  }
  resolveConfig(t) {
    const i = t.bins, n = {};
    return i.display === Jg && (n.bins = {
      position: ZS
    }), tt({}, t, n);
  }
  createScale(t) {
    const { base: i, padding: n, exponent: A } = t, s = this.range(), o = QM;
    this._interpolator = new o();
    let r = this._interpolator.createScale({
      padding: n,
      exponent: A,
      base: i,
      range: s
    });
    return r = r.nice(), r;
  }
  sanitizeTickFormatter(t) {
    const { tickFormat: i, format: n } = t;
    return i ? (A) => (s, o) => {
      const r = [s, Xg(this, s)];
      return i(
        { formattedValue: this.formatTickValue(r, n), rawValue: r },
        { context: this, tickIndex: o, allRawTicks: A }
      );
    } : () => (A) => {
      const s = [A, Xg(this, A)];
      return this.formatTickValue(s, n);
    };
  }
  formatTickValue(t, i) {
    const { bins: n } = this.config();
    if (n.display === qS)
      return Ei(i(_r(t)));
    {
      const A = i(t[0]);
      return Ei(
        Number.isInteger(A) ? A : A && A.toFixed(2)
      );
    }
  }
  getTickValues() {
    return Ko.getTickValues(this);
  }
  setTickConfig() {
    return Ko.setTickConfig(this);
  }
  getUnitWidth() {
    return this.getBinWidth();
  }
  getBinWidth() {
    return Math.abs(
      this.getScaleValue(this.domain()[0] + this.binSize()) - this.getScaleValue(this.domain()[0])
    );
  }
  /**
   * Sets a fixed baseline for the first ticks so that they can render effectively within
   * the given area
   *
   * @param {*} tickText
   * @param {*} config
   * @param {*} labelManager
   */
  setFixedBaseline(t) {
    return Ko.setFixedBaseline(this, t);
  }
}
const gp = {
  Pink: { hex: "ffc0cb", rgb: "255,192,203" },
  LightPink: { hex: "ffb6c1", rgb: "255,182,193" },
  HotPink: { hex: "ff69b4", rgb: "255,105,180" },
  DeepPink: { hex: "ff1493", rgb: "255,20,147" },
  PaleVioletRed: { hex: "db7093", rgb: "219,112,147" },
  MediumVioletRed: { hex: "c71585", rgb: "199,21,133" },
  LightSalmon: { hex: "ffa07a", rgb: "255,160,122" },
  Salmon: { hex: "fa8072", rgb: "250,128,114" },
  DarkSalmon: { hex: "e9967a", rgb: "233,150,122" },
  LightCoral: { hex: "f08080", rgb: "240,128,128" },
  IndianRed: { hex: "cd5c5c", rgb: "205,92,92" },
  Crimson: { hex: "dc143c", rgb: "220,20,60" },
  FireBrick: { hex: "b22222", rgb: "178,34,34" },
  DarkRed: { hex: "8b0000", rgb: "139,0,0" },
  Red: { hex: "ff0000", rgb: "255,0,0" },
  OrangeRed: { hex: "ff4500", rgb: "255,69,0" },
  Tomato: { hex: "ff6347", rgb: "255,99,71" },
  Coral: { hex: "ff7f50", rgb: "255,127,80" },
  DarkOrange: { hex: "ff8c00", rgb: "255,140,0" },
  Orange: { hex: "ffa500", rgb: "255,165,0" },
  Gold: { hex: "ffd700", rgb: "255,215,0" },
  Yellow: { hex: "ffff00", rgb: "255,255,0" },
  LightYellow: { hex: "ffffe0", rgb: "255,255,224" },
  LemonChiffon: { hex: "fffacd", rgb: "255,250,205" },
  LightGoldenrodYellow: { hex: "fafad2", rgb: "250,250,210" },
  PapayaWhip: { hex: "ffefd5", rgb: "255,239,213" },
  Moccasin: { hex: "ffe4b5", rgb: "255,228,181" },
  PeachPuff: { hex: "ffdab9", rgb: "255,218,185" },
  PaleGoldenrod: { hex: "eee8aa", rgb: "238,232,170" },
  Khaki: { hex: "f0e68c", rgb: "240,230,140" },
  DarkKhaki: { hex: "bdb76b", rgb: "189,183,107" },
  Cornsilk: { hex: "fff8dc", rgb: "255,248,220" },
  BlanchedAlmond: { hex: "ffebcd", rgb: "255,235,205" },
  Bisque: { hex: "ffe4c4", rgb: "255,228,196" },
  NavajoWhite: { hex: "ffdead", rgb: "255,222,173" },
  Wheat: { hex: "f5deb3", rgb: "245,222,179" },
  BurlyWood: { hex: "deb887", rgb: "222,184,135" },
  Tan: { hex: "d2b48c", rgb: "210,180,140" },
  RosyBrown: { hex: "bc8f8f", rgb: "188,143,143" },
  SandyBrown: { hex: "f4a460", rgb: "244,164,96" },
  Goldenrod: { hex: "daa520", rgb: "218,165,32" },
  DarkGoldenrod: { hex: "b8860b", rgb: "184,134,11" },
  Peru: { hex: "cd853f", rgb: "205,133,63" },
  Chocolate: { hex: "d2691e", rgb: "210,105,30" },
  SaddleBrown: { hex: "8b4513", rgb: "139,69,19" },
  Sienna: { hex: "a0522d", rgb: "160,82,45" },
  Brown: { hex: "a52a2a", rgb: "165,42,42" },
  Maroon: { hex: "800000", rgb: "128,0,0" },
  DarkOliveGreen: { hex: "556b2f", rgb: "85,107,47" },
  Olive: { hex: "808000", rgb: "128,128,0" },
  OliveDrab: { hex: "6b8e23", rgb: "107,142,35" },
  YellowGreen: { hex: "9acd32", rgb: "154,205,50" },
  LimeGreen: { hex: "32cd32", rgb: "50,205,50" },
  Lime: { hex: "00ff00", rgb: "0,255,0" },
  LawnGreen: { hex: "7cfc00", rgb: "124,252,0" },
  Chartreuse: { hex: "7fff00", rgb: "127,255,0" },
  GreenYellow: { hex: "adff2f", rgb: "173,255,47" },
  SpringGreen: { hex: "00ff7f", rgb: "0,255,127" },
  MediumSpringGreen: { hex: "00fa9a", rgb: "0,250,154" },
  LightGreen: { hex: "90ee90", rgb: "144,238,144" },
  PaleGreen: { hex: "98fb98", rgb: "152,251,152" },
  DarkSeaGreen: { hex: "8fbc8f", rgb: "143,188,143" },
  MediumSeaGreen: { hex: "3cb371", rgb: "60,179,113" },
  SeaGreen: { hex: "2e8b57", rgb: "46,139,87" },
  ForestGreen: { hex: "228b22", rgb: "34,139,34" },
  Green: { hex: "008000", rgb: "0,128,0" },
  DarkGreen: { hex: "006400", rgb: "0,100,0" },
  MediumAquamarine: { hex: "66cdaa", rgb: "102,205,170" },
  Aqua: { hex: "00ffff", rgb: "0,255,255" },
  Cyan: { hex: "00ffff", rgb: "0,255,255" },
  LightCyan: { hex: "e0ffff", rgb: "224,255,255" },
  PaleTurquoise: { hex: "afeeee", rgb: "175,238,238" },
  Aquamarine: { hex: "7fffd4", rgb: "127,255,212" },
  Turquoise: { hex: "40e0d0", rgb: "64,224,208" },
  MediumTurquoise: { hex: "48d1cc", rgb: "72,209,204" },
  DarkTurquoise: { hex: "00ced1", rgb: "0,206,209" },
  LightSeaGreen: { hex: "20b2aa", rgb: "32,178,170" },
  CadetBlue: { hex: "5f9ea0", rgb: "95,158,160" },
  DarkCyan: { hex: "008b8b", rgb: "0,139,139" },
  Teal: { hex: "008080", rgb: "0,128,128" },
  LightSteelBlue: { hex: "b0c4de", rgb: "176,196,222" },
  PowderBlue: { hex: "b0e0e6", rgb: "176,224,230" },
  LightBlue: { hex: "add8e6", rgb: "173,216,230" },
  SkyBlue: { hex: "87ceeb", rgb: "135,206,235" },
  LightSkyBlue: { hex: "87cefa", rgb: "135,206,250" },
  DeepSkyBlue: { hex: "00bfff", rgb: "0,191,255" },
  DodgerBlue: { hex: "1e90ff", rgb: "30,144,255" },
  CornflowerBlue: { hex: "6495ed", rgb: "100,149,237" },
  SteelBlue: { hex: "4682b4", rgb: "70,130,180" },
  RoyalBlue: { hex: "4169e1", rgb: "65,105,225" },
  Blue: { hex: "0000ff", rgb: "0,0,255" },
  MediumBlue: { hex: "0000cd", rgb: "0,0,205" },
  DarkBlue: { hex: "00008b", rgb: "0,0,139" },
  Navy: { hex: "000080", rgb: "0,0,128" },
  MidnightBlue: { hex: "191970", rgb: "25,25,112" },
  Lavender: { hex: "e6e6fa", rgb: "230,230,250" },
  Thistle: { hex: "d8bfd8", rgb: "216,191,216" },
  Plum: { hex: "dda0dd", rgb: "221,160,221" },
  Violet: { hex: "ee82ee", rgb: "238,130,238" },
  Orchid: { hex: "da70d6", rgb: "218,112,214" },
  Fuchsia: { hex: "ff00ff", rgb: "255,0,255" },
  Magenta: { hex: "ff00ff", rgb: "255,0,255" },
  MediumOrchid: { hex: "ba55d3", rgb: "186,85,211" },
  MediumPurple: { hex: "9370db", rgb: "147,112,219" },
  BlueViolet: { hex: "8a2be2", rgb: "138,43,226" },
  DarkViolet: { hex: "9400d3", rgb: "148,0,211" },
  DarkOrchid: { hex: "9932cc", rgb: "153,50,204" },
  DarkMagenta: { hex: "8b008b", rgb: "139,0,139" },
  Purple: { hex: "800080", rgb: "128,0,128" },
  Indigo: { hex: "4b0082", rgb: "75,0,130" },
  DarkSlateBlue: { hex: "483d8b", rgb: "72,61,139" },
  SlateBlue: { hex: "6a5acd", rgb: "106,90,205" },
  MediumSlateBlue: { hex: "7b68ee", rgb: "123,104,238" },
  White: { hex: "ffffff", rgb: "255,255,255" },
  Snow: { hex: "fffafa", rgb: "255,250,250" },
  Honeydew: { hex: "f0fff0", rgb: "240,255,240" },
  MintCream: { hex: "f5fffa", rgb: "245,255,250" },
  Azure: { hex: "f0ffff", rgb: "240,255,255" },
  AliceBlue: { hex: "f0f8ff", rgb: "240,248,255" },
  GhostWhite: { hex: "f8f8ff", rgb: "248,248,255" },
  WhiteSmoke: { hex: "f5f5f5", rgb: "245,245,245" },
  Seashell: { hex: "fff5ee", rgb: "255,245,238" },
  Beige: { hex: "f5f5dc", rgb: "245,245,220" },
  OldLace: { hex: "fdf5e6", rgb: "253,245,230" },
  FloralWhite: { hex: "fffaf0", rgb: "255,250,240" },
  Ivory: { hex: "fffff0", rgb: "255,255,240" },
  AntiqueWhite: { hex: "faebd7", rgb: "250,235,215" },
  Linen: { hex: "faf0e6", rgb: "250,240,230" },
  LavenderBlush: { hex: "fff0f5", rgb: "255,240,245" },
  MistyRose: { hex: "ffe4e1", rgb: "255,228,225" },
  Gainsboro: { hex: "dcdcdc", rgb: "220,220,220" },
  LightGray: { hex: "d3d3d3", rgb: "211,211,211" },
  Silver: { hex: "c0c0c0", rgb: "192,192,192" },
  DarkGrey: { hex: "a9a9a9", rgb: "169,169,169" },
  Grey: { hex: "808080", rgb: "128,128,128" },
  DimGrey: { hex: "696969", rgb: "105,105,105" },
  LightSlateGrey: { hex: "778899", rgb: "119,136,153" },
  SlateGrey: { hex: "708090", rgb: "112,128,144" },
  DarkSlateGrey: { hex: "2f4f4f", rgb: "47,79,79" },
  Black: { hex: "000000", rgb: "0,0,0" }
}, Of = [
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#d62728",
  "#9467bd",
  "#8c564b",
  "#e377c2",
  "#7f7f7f",
  "#bcbd22",
  "#17becf"
], a5 = "#eaeaea", Xa = {
  range: Of,
  value: Of[0],
  step: !1,
  stops: 5,
  type: oE,
  repeatRange: !1,
  domainRangeMap: {},
  ordering: tt({}, xr),
  splitBy: {
    field: null,
    values: {}
  },
  invalidValueColor: null,
  domain: []
}, pE = (e) => `hsla(${e[0] * 360},${e[1] * 100}%,${e[2] * 100}%,${e[3] || 1})`, hp = (e) => (e.split(" ") || []).reduce(
  (t, i) => `${t}${i.charAt(0).toUpperCase()}${i.slice(1)}`,
  ""
), Hf = (e, t) => {
  let i = "";
  if (typeof e == "string")
    if (e = e.replace(/ /g, ""), e = e.toLowerCase(), fa(e) === o3 || fa(e) === s3)
      i = e.match(/(\d+(\.\d+)?)/g), i = [
        i[0] / 360,
        i[1] / 100,
        i[2] / 100,
        ft(Number(i[3]), 1)
      ];
    else if (fa(e) === A3)
      i = ix(e);
    else if (fa(e) === n3) {
      const n = e.substring(e.indexOf("(") + 1, e.lastIndexOf(")")).split(/,\s*/);
      i = Ho(...n);
    } else
      gp[hp(e)] && (i = Ho(...gp[hp(e)].rgb.split(",")));
  else
    e instanceof Array ? i = e : i = Ho(t);
  return i;
}, l5 = {
  config: {
    sanitization: (e, t) => {
      const i = tt({}, e.constructor.defaultConfig());
      t.type === oE && (t.range = t.range || [i.range[0]], t.range = t.range.length > 1 ? t.range : [a5, ...t.range]);
      const n = tt(i, e.config()), A = tt(n, t);
      return Array.isArray(A.range) && (A.range = A.range.map(
        (s, o) => Hf(s, Of[o])
      ), A.stops = t.stops ? t.stops : t.range && t.range.length > 2 ? t.range.length : null), A.value = Hf(A.value, A.value), A.ordering = Nr(
        A.ordering,
        Xa.ordering
      ), t.subtype === fi ? (A.step = typeof t.step != "boolean" ? !0 : t.step, A.stops = t.stops ? t.stops : null) : A.stops = A.stops ? A.stops : Xa.stops, A;
    }
  },
  domain: {},
  scale: {},
  uniqueValues: {},
  isGlobal: {}
}, c5 = (e) => Array.isArray(e) ? e.length >= 2 : Number.isFinite(e), pM = (e, t, i, n, A) => {
  let s = [];
  if (Array.isArray(t))
    if (s = t.slice().sort((o, r) => o - r), c5(s))
      e[0] < s[0] && s.unshift(e[0]), e[1] > s[s.length - 1] && s.push(e[1]);
    else
      throw new Zi("Invalid stops provided in config", {
        cause: "Invalid `stops` provided in config (typeof `stops`: (Array && Array.length > 1) || Number)."
      });
  else
    s = Sr(e, t, i, n, A);
  return { domain: e, newStops: s };
}, g5 = (e, t) => {
  let i = [];
  const n = Math.min(t.length, 18);
  if (e > n) {
    const A = SC()(
      Xw(),
      t.map((s) => pE(s))
    );
    for (let s = 0; s < e; s++)
      i[s] = A(s / (e - 1));
  } else
    i = t.slice(0, e);
  return { newRange: i };
}, h5 = (e) => ({ domain: e.map((i, n) => n / (e.length - 1)), uniqueVals: e, scaleDomain: [0, 1] }), up = (e, t, i) => ({
  domain: e,
  uniqueVals: e,
  scaleDomain: [0, 1],
  range: i
}), u5 = (e, t, i) => ({
  uniqueVals: e,
  domain: e,
  nice: !0,
  range: i
}), d5 = (e, t, i, n, A, s) => {
  const o = Cl(e), r = n && s && !t ? _C(o, s) : pM(o, t, !0, i, A)?.newStops, { newRange: a } = g5(r.length - 1, i);
  return { uniqueVals: o, domain: r, nice: A, range: a };
}, f5 = (e, t, i) => {
  const { domain: n, newStops: A } = pM(
    Cl(e),
    i.length > 2 ? t : i.length - 1,
    !1,
    i
  ), s = i.map((o) => pE(o));
  return { uniqueVals: n, domain: A, nice: !0, range: s };
}, I5 = (e, t, i, n) => {
  const A = n.indexOf(e), s = i[A];
  return t(s);
}, dp = (e, t, i) => {
  const n = (e - i[0]) / (i[i.length - 1] - i[0]);
  return Bu(e, t(n), t(0));
}, bd = (e, t, i) => Bu(e, t(e), t(i[0])), C5 = () => ({
  [`${ci}-${ci}-${hA}`]: {
    scale: hA,
    domainRange: () => up,
    value: () => dp
  },
  [`${ci}-${oe}-${hA}`]: {
    scale: hA,
    domainRange: () => up,
    value: () => dp
  },
  [`${oe}-${oe}-${hA}`]: {
    scale: hA,
    domainRange: () => h5,
    value: () => I5
  },
  [`${oe}-${oe}-${Mo}`]: {
    scale: Mo,
    domainRange: () => u5,
    value: () => bd
  },
  [`${ci}-${ci}-${Mo}`]: {
    scale: ce,
    domainRange: () => f5,
    value: () => bd
  },
  [`${ci}-${oe}-${Mo}`]: {
    scale: AE,
    domainRange: () => d5,
    value: () => bd
  }
}), E5 = (e, t, i) => C5()[`${e}-${t}-${i || ""}`];
class yE extends _e().with(
  zs
) {
  constructor(t) {
    super(), this.eventManager(t), this._valuesSorter = null;
  }
  setupValuesSorter(t) {
    const { field: i, ordering: n } = this.config();
    i && (this._valuesSorter = ru(
      { name: i },
      n,
      t
    ));
  }
  sortValues(t) {
    return this._valuesSorter ? this._valuesSorter(t) : t;
  }
}
class mr extends yE {
  /**
   * Creates an instance of SimpleAxis.
   * @param {Object} config input parameters.
   * @param {Object | undefined} params.range Type of color range.
   * @param {string} params.name the label to show on axis.
   * @param {string} params.type The type of scale to handle.
   * @memberof ColorAxis
   */
  constructor(t, i) {
    super(i), ge(this, l5), this.config(t), this._domainType = this._config.type === "linear" ? ci : oe, this._rangeType = this._config.type === "linear" && !this._config.step ? ci : oe, this._schemeType = p3(this._config.range), this._colorStrategy = this.setColorStrategy(
      this._domainType,
      this._rangeType,
      this._schemeType
    ), this._scale = this.createScale(this._colorStrategy), this._scaleRange = this._scale.range(), this._id = Ut(), this.updateDomain(t.domain), this.emitSelfHooks(gt.INITIALIZED);
  }
  associatedHookComponentPaths() {
    return [
      [xt.AXIS, "color"],
      [xt.AXIS]
    ];
  }
  /**
   *
   *
   * @static
   *
   * @memberof ColorAxis
   */
  static defaultConfig() {
    return Xa;
  }
  /**
   *
   *
   * @static
   *
   * @memberof ColorAxis
   */
  static type() {
    return X8;
  }
  /**
   *
   *
   * @param {*} colorStrategy
   *
   * @memberof ColorAxis
   */
  createScale(t) {
    const { range: i } = this.config();
    return i && typeof i == "string" ? Q3(i) : YA({
      type: t.scale,
      range: i
    });
  }
  /**
   *
   *
   * @param {*} domainType
   * @param {*} rangeType
   * @param {*} schemeType
   *
   * @memberof ColorAxis
   */
  setColorStrategy(t, i, n, A) {
    return E5(t, i, n);
  }
  /**
   *
   *
   * @param {*} domainVal
   *
   * @memberof ColorAxis
   */
  getHslString(t) {
    return pE(t);
  }
  /**
   * @param {*} domainVal
   *
   * @memberof ColorAxis
   */
  getColor(t) {
    if (this.config().metaInfo?.isTotalsAxis)
      return this.getHslString(this.config().range[0]);
    const { domainRangeMap: i, invalidValueColor: n } = this.config();
    return i[t] ? i[t] : Ee(t) && n ? n : this.getHslString(this.getRawColor(t));
  }
  getScaleRange() {
    return this._scaleRange;
  }
  /**
   *
   *
   * @param {*} domainVal
   *
   * @memberof ColorAxis
   */
  getRawColor(t) {
    const i = this.domain();
    if (i && t !== void 0) {
      const n = [...i].sort((l, c) => l < c), A = Math.min(...n), s = Math.max(...n);
      t < A ? t = A : t > s && (t = s);
      const o = this.scale(), r = o.range ? o.range() : null, a = this._colorStrategy.value(r)(
        t,
        o,
        this.domain(),
        this.uniqueValues()
      );
      if (a) {
        if (typeof a == "string") {
          const l = a.substring(a.indexOf("(") + 1, a.lastIndexOf(")")).split(/,\s*/);
          return Ho(...l);
        }
        return [...a];
      }
    }
    return [...this.config().value];
  }
  setRangeWithInterpolatedColors(t, i) {
    const { domain: n, range: A } = i, s = n.length, o = A.length, { repeatRange: r } = this.config();
    if (t === Tf && s > o && !r) {
      const a = [], l = n.map((c, g) => g / s);
      this._linearScale = Es.linear().range(this._config.range).domain(l);
      for (let c = 0, g = s; c < g; c++) {
        const h = 1 / g * c;
        a.push([...this._linearScale(h)]);
      }
      this.scale().range(a);
    }
  }
  updateDomain(t = []) {
    if (t.length) {
      const i = this._scaleRange || null, n = this._colorStrategy.domainRange(), A = this._colorStrategy.scale, { domain: s, stops: o } = this.config(), r = !!(Array.isArray(o) && o.length), a = !r && !!(Array.isArray(s) && s.length);
      r && (t = o.map((c) => c));
      const l = n(
        t,
        o,
        i,
        this._config.subtype === fi ? this._config.binSize : null,
        !(r || a || this._config.subtype === fi),
        this._config.subtype === fi ? this._config.bins.filter((c) => !Ee(c)) : null
      );
      this.domain(l.domain), l.range && this.scale().range(l.range), this.uniqueValues(l.uniqueVals), this.scale().domain(l.scaleDomain || this.domain()), this.setRangeWithInterpolatedColors(A, l);
    }
    return this;
  }
  /**
   * This method returns an object that can be used to
   * reconstruct this instance.
   *
   * @return {Object} the serializable props of axis
   * @memberof ShapeAxis
   */
  serialize() {
    return {
      type: this.constructor.type(),
      scale: this.scale(),
      domain: this.domain(),
      config: this.config()
    };
  }
  transformColor(t, i) {
    const n = t[0] * 360, A = t[1] * 100, s = t[2] * 100, o = Math.min(ft(t[3], 0), 1), r = n + i[0], a = A + i[1], l = s + i[2], c = Math.min(o + i[3] || 0, 1);
    return {
      color: `hsla(${r},${a}%,${l}%,${c})`,
      hsla: [r / 360, a / 100, l / 100, c]
    };
  }
  /**
   * Returns the id of the axis.
   * @return {string} Unique identifier of the axis.
   */
  id() {
    return this._id;
  }
  getHslArray(t) {
    return Hf(t);
  }
}
const th = {
  value: 4,
  range: [2, 50],
  ordering: tt({}, xr)
}, B5 = (e) => {
  const t = e;
  return { domain: e.map((n, A) => A / (e.length - 1)), uniqueVals: t, scaleDomain: [0, 1] };
}, m5 = (e) => ({ uniqueVals: e, domain: e }), Q5 = (e, t) => {
  let i = [];
  return t instanceof Array ? i = t.slice().sort((A, s) => A - s) : i = Sr(e, t), { uniqueVals: i, domain: i, nice: !0 };
}, p5 = (e, t, i) => {
  const n = (e - i[0]) / (i[i.length - 1] - i[0]), A = xC()(...t.range());
  return Bu(
    e,
    A(n),
    A(i[0])
  );
}, y5 = (e, t, i, n) => {
  const A = n.findIndex((r) => J.isInvalid(r) ? r.value() === e : r === e), s = i[A];
  return SC()(xC(), [...t.range()])(s);
}, D5 = (e, t, i) => Bu(e, t(e), t(i[0])), w5 = {
  [`${oe}-${ci}`]: {
    scale: ce,
    domain: B5,
    range: y5
  },
  [`${ci}-${ci}`]: {
    scale: ce,
    domain: m5,
    range: D5
  },
  [`${ci}-${oe}`]: {
    scale: sE,
    domain: Q5,
    range: p5
  }
}, x5 = (e, t) => w5[`${e}-${t}`], S5 = {
  config: {
    sanitization: (e, t) => {
      e._userRange = t.range;
      const i = tt(
        {},
        th,
        e._config || {},
        t
      );
      return i.ordering = Nr(
        i.ordering,
        th.ordering
      ), i;
    }
  },
  domain: {
    sanitization: (e, t) => (e.scale().domain(t), t)
  },
  range: {},
  scale: {},
  uniqueValues: {},
  isGlobal: {}
};
class M5 extends yE {
  /**
   * Creates an instance of SimpleAxis.
   * @param {Object} config input parameters.
   * @memberof SizeAxis
   */
  constructor(t, i) {
    super(i), ge(this, S5), this._id = Ut(), this.config(this.constructor.defaultConfig()), this.config(t), this._domainType = this._config.type === "linear" ? ci : oe, this._config.range = this._userRange ? this._userRange : this._config.range, this._config.stops = F3(this._config.stops), this._rangeType = this._config.type === "linear" && this._config.stops ? oe : ci, this._sizeStrategy = this.setStrategy(this._domainType, this._rangeType), this._scale = this.createScale(this._sizeStrategy), this._range = this._config.range, this.updateDomain(t.domain), this.emitSelfHooks(gt.INITIALIZED);
  }
  associatedHookComponentPaths() {
    return [
      [xt.AXIS, "size"],
      [xt.AXIS]
    ];
  }
  /**
   *
   *
   * @param {*} domainType
   * @param {*} rangeType
   * @param {*} schemeType
   *
   * @memberof ColorAxis
   */
  setStrategy(t, i) {
    return x5(t, i);
  }
  /**
   *
   *
   *
   * @memberof SizeAxis
   */
  createScale(t) {
    const { range: i } = this.config();
    return YA({
      type: t.scale,
      range: i
    });
  }
  /**
   *
   *
   * @static
   *
   * @memberof ColorAxis
   */
  static defaultConfig() {
    return th;
  }
  /**
   *
   *
   * @static
   *
   * @memberof ColorAxis
   */
  static type() {
    return e3;
  }
  /**
   *
   *
   * @param {*} domainVal
   *
   * @memberof SizeAxis
   */
  getSize(t = 0) {
    let i = 1;
    const { value: n, as: A } = this.config(), s = this.scale(), o = this.domain() || [1, 1];
    if (this.config().metaInfo?.isTotalsAxis) {
      const { range: r } = this.config();
      return r[r.length - 1];
    }
    if (!s || o[0] === o[1] || o.length === 1 || t === null || t === void 0 || A === lt.CONTINUOUS && J.isInvalid(t))
      i = n;
    else {
      const r = J.getActualValue(t);
      return A === "discrete" && this.uniqueValues().findIndex(
        (a) => J.getActualValue(a) === r
      ) === -1 ? 0 : this._sizeStrategy.range(
        r,
        s,
        this.domain(),
        this.uniqueValues()
      );
    }
    return i;
  }
  /**
   * This method is used to assign a domain to the axis.
   *
   * @param {Array} domain the domain of the scale
   * @memberof SizeAxis
   */
  updateDomain(t) {
    if (t) {
      const i = this._sizeStrategy.domain, n = i(this.sortValues(t), this.config().stops);
      this.domain(n.domain), this.uniqueValues(n.uniqueVals), this.scale().domain(n.scaleDomain || this.domain());
    }
    return this;
  }
  /**
   * This method returns an object that can be used to
   * reconstruct this instance.
   *
   * @return {Object} the serializable props of axis.
   * @memberof ShapeAxis
   */
  serialize() {
    return {
      type: this.constructor.type(),
      scale: this.scale(),
      domain: this.domain(),
      range: this.range(),
      config: this.config()
    };
  }
  /**
   * Returns the id of the axis.
   * @return {string} Unique identifier of the axis.
   */
  id() {
    return this._id;
  }
  scaleType() {
    return this._domainType;
  }
}
const eh = {
  generator: null,
  value: "circle",
  range: ["circle", "diamond", "star", "cross", "square", "wye", "triangle"],
  ordering: tt({}, xr)
}, _5 = (e, t) => {
  const i = {};
  return e.forEach((n) => {
    i[n] = t(n);
  }), i;
}, b5 = {
  config: {
    sanitization: (e, t) => {
      const i = tt(
        {},
        eh,
        e.config(),
        t
      );
      return i.ordering = Nr(
        i.ordering,
        eh.ordering
      ), i;
    }
  },
  domain: {},
  scale: {},
  uniqueValues: {},
  generator: {},
  isGlobal: {}
};
class N5 extends yE {
  /**
   * Creates an instance of SimpleAxis.
   * @param {Object} params input parameters.
   * @param {Object | undefined} params.range Type of color scheme.
   * @memberof ShapeAxis
   */
  constructor(t, i) {
    super(i), ge(this, b5), this._id = Ut(), this._config = Object.assign({}, this.constructor.defaultConfig()), this._config = tt(this._config, t), this._scale = YA({
      type: "ordinal",
      range: this._config.range
    }), this.updateDomain(t.domain), this.emitSelfHooks(gt.INITIALIZED);
  }
  associatedHookComponentPaths() {
    return [
      [xt.AXIS, "shape"],
      [xt.AXIS]
    ];
  }
  /**
   *
   *
   * @static
   *
   * @memberof ColorAxis
   */
  static defaultConfig() {
    return eh;
  }
  /**
   *
   *
   * @static
   *
   * @memberof ColorAxis
   */
  static type() {
    return t3;
  }
  /**
   *
   *
   * @param {*} value
   *
   * @memberof ShapeAxis
   */
  getShape(t) {
    if (!this.scale() || !this.domain() || !t || J.isInvalid(t))
      return this.config().value;
    if (this._generatedShapes)
      return this._generatedShapes[t];
    const i = this.scale()(t);
    return i === "string" ? Bl(i) : i;
  }
  /**
   * This method is used to assign a domain to the axis.
   *
   * @param {Array} domain the domain of the scale
   * @memberof ShapeAxis
   */
  updateDomain(t = []) {
    if (t.length) {
      const i = this.config().generator;
      this.uniqueValues(t), this.domain(t), this.scale().domain(t), i && (this._generatedShapes = _5(t, i));
    }
    return this;
  }
  /**
   * This method returns an object that can be used to
   * reconstruct this instance.
   *
   * @return {Object} the serializable props of axis
   * @memberof ShapeAxis
   */
  serialize() {
    return {
      type: this.constructor.type(),
      scale: this.scale(),
      domain: this.domain(),
      range: this.config().range,
      config: this.config()
    };
  }
  /**
   * Returns the id of the axis.
   * @return {string} Unique identifier of the axis.
   */
  id() {
    return this._id;
  }
}
const yM = {
  config: {
    sanitization: (e, t) => tt(e.config(), t),
    preset: (e, t) => {
      const { range: i, domain: n } = t;
      i && e.range(i), n && e.domain(n);
    }
  },
  domain: {},
  range: {}
}, { pie: F5 } = _i, fp = (e) => {
  const t = e._angleFn(e._domain);
  t.forEach((i) => {
    i.startAngle -= Math.PI / 2, i.endAngle -= Math.PI / 2;
  }), e._angleValues = t.reduce((i, n) => {
    const A = n.data;
    return !i[A] && (i[A] = []), i[A].push(n), i;
  }, {});
};
class R5 {
  /**
   * Creates an instance of AngleAxis.
   * @param {Object} config input parameters.
   * @memberof AngleAxis
   */
  constructor(t = {}) {
    this._id = Ut(), ge(this, yM), this._config = tt({}, this.constructor.defaultConfig()), this.config(t), this._range = [0, 360];
    const { angle: i, fieldInst: n } = this._config;
    this._angleFn = F5().value((A) => n && n.subtype() === fi || i && i.as === oe ? 1 : J.isInvalid(A) ? 0 : A).sortValues(null), this._angleValues = {};
  }
  static defaultConfig() {
    return {};
  }
  createScale(t) {
    const { range: i } = this.config();
    return YA({
      type: t.scale,
      range: i
    });
  }
  getScaleValue(t) {
    return this._angleValues[t];
  }
  padAngle(t) {
    this._angleFn = this._angleFn.padAngle(t);
  }
  domain(...t) {
    if (t.length) {
      const { domain: i } = this.config(), n = t[0].length ? t[0] : r3;
      return this._domain = Yg(i, n, this), fp(this), this;
    }
    return this._domain;
  }
  range(...t) {
    if (t.length) {
      const { range: i } = this.config();
      this._range = Yg(i, t[0], this);
      const n = this.domain(), [A, s] = this._range;
      return this._angleFn.startAngle(A / 180 * Math.PI).endAngle(Math.PI * s / 180), n && n.length && fp(this), this;
    }
    return this._range;
  }
}
const Ip = (e) => {
  const t = e.config().minOuterRadius, i = e._domain;
  if (e._range.length) {
    const n = e._scale, A = n.invert(t) - n.invert(0);
    e._domain = [i[0] - A, i[1]], n.domain(e._domain);
  }
};
class k5 {
  /**
   * Creates an instance of RadiusAxis.
   * @param {Object} config input parameters.
   * @memberof RadiusAxis
   */
  constructor(t = {}) {
    this._id = Ut(), ge(this, yM), this._range = [], this._radiusFactor = 1, this._config = tt({}, this.constructor.defaultConfig()), this.config(t), this._scale = this.createScale({
      scale: IE
    });
  }
  static defaultConfig() {
    return {
      padding: [0, 1],
      minOuterRadius: 10
    };
  }
  config(...t) {
    if (t.length) {
      const i = tt(this.config(), t[0]);
      return this._config = i, this;
    }
    return this._config;
  }
  createScale(t) {
    return YA({
      type: t.scale,
      range: this.range()
    });
  }
  domain(...t) {
    if (t.length) {
      const { domain: i } = this.config();
      let n = Yg(i, t[0], this);
      n = Cl(n), this._scale.domain(n), this._domain = n, Ip(this);
    }
    return this._domain;
  }
  getInnerRadius(t) {
    return t === void 0 ? this.range()[0] : this._scale(t);
  }
  getOuterRadius(t) {
    return t === void 0 ? this.range()[1] : this._scale(t) * this._radiusFactor;
  }
  range(...t) {
    if (t.length) {
      const { padding: i, range: n } = this.config(), A = t[0].map(
        (o, r) => o + (r ? -i[r] : i[r])
      ), s = Yg(n, A, this);
      this._range = s, this._scale.range(s), Ip(this);
    }
    return this._range;
  }
  setRadiusFactor(t) {
    return this._radiusFactor = t, this;
  }
}
class Su {
  _data;
  _sourceDm;
  _config;
  _domain;
  constructor(t, i) {
    this._sourceDm = t, t.isEmpty() ? this._data = [
      {
        values: [],
        keys: []
      }
    ] : this._data = [
      {
        values: t.getData().data,
        keys: []
      }
    ], this._config = i, this._domain = {};
  }
  getDomain(t, i) {
    const { field: n, fieldAs: A } = t, s = this._sourceDm.getDomain(
      n,
      A.toString()
    );
    if (i) {
      const { field: o, fieldAs: r } = i, a = this._sourceDm.getDomain(
        o,
        r.toString()
      );
      return [
        Math.min(
          s[0],
          a[0]
        ),
        Math.max(
          s[1],
          a[1]
        )
      ];
    }
    return s;
  }
  getData() {
    return this._data;
  }
  getUniqueValues() {
    return this._data.filter((t) => t.keys).map((t) => t.keys.join(","));
  }
  isSortedDomain() {
    return !1;
  }
}
const T5 = "group", v5 = "stack100percent", G5 = "A retinal or detail dimension encoding is required to stack the mark", DM = "Either rows or columns must contain a measure field to stack the mark", Cp = (e, t, i) => {
  const n = e.getData().data, A = e.getSchema().findIndex((l) => l.name === t), s = e.getSchema().findIndex((l) => l.name === i), o = {};
  n.forEach((l) => {
    const c = l[A];
    o[c] || (o[c] = 0), o[c] += J.isInvalid(l[s]) ? 0 : l[s];
  });
  const r = Cn(Object.values(o));
  return [Zn(Object.values(o)), r];
};
class DE extends Su {
  _sortedValues;
  constructor(t, i) {
    super(t, i);
    const {
      uniqueField: n,
      value: A,
      sortConfig: s
    } = i, o = n?.field, r = n?.as, a = A?.field;
    if (t.isEmpty())
      this._data = [
        {
          values: []
        }
      ], this._domain[o] = [];
    else {
      if (!i.groupBy.length)
        throw new Zi(G5);
      if (!a)
        throw new Zi(DM);
      const { DataWranglers: l } = t.constructor.DataModel(), c = s.fields.map(({ field: E }) => E), g = W(
        s.fields,
        "0",
        "values"
      );
      let h = t, u = !1;
      if (i.groupBy.length > 2) {
        const E = i.groupBy.map((B) => [B, "asc"]);
        h = h.sort(E), u = !0;
      }
      const d = l.stackBy(
        h.model,
        o,
        c[0],
        a,
        null,
        g,
        // @todo make it generalized
        c[1],
        W(s.fields, "1", "values"),
        ""
      ), f = /* @__PURE__ */ new Map(), I = h.getUidMap(), { data: C } = h.getData();
      d.y0.forEach((E, B) => {
        const m = d.id[B], y = I[m], D = h.getValueAtIndex(o, y), Q = i.groupBy.reduce(
          (w, x) => (w[x] = h.getValueAtIndex(x, y), w),
          {}
        ), p = Object.values(Q).join("-");
        f.has(p) ? f.get(p).values.push({
          values: [d.y0[B], d.y1[B]],
          rowId: m,
          data: C[y],
          uniqueVal: D
        }) : f.set(p, {
          values: [
            {
              values: [d.y0[B], d.y1[B]],
              rowId: m,
              data: C[y],
              uniqueVal: D
            }
          ],
          key: p,
          keys: Object.values(Q),
          groupKey: Q
        });
      }), this._data = [...f.values()], this._domain[o] = h.getDomain(
        o,
        r.toString()
      ), this._domain[a] = [
        Math.min(Zn(d.y0), Zn(d.y1)),
        Math.max(Cn(d.y0), Cn(d.y1))
      ], this._sortedValues = g, u && h.dispose();
    }
  }
  getDomain({ field: t }) {
    return this._domain[t];
  }
  isSortedDomain() {
    return !!this._config.sort;
  }
  getSortedGroupByValues() {
    return this._sortedValues;
  }
  getSortField() {
    return W(this._config.sortConfig, "fields", "0", "field");
  }
  static getFieldDomainFromData(t, i, n) {
    const A = t.select({
      field: n,
      operator: ni.LESS_THAN_EQUAL,
      value: 0
    }), s = t.select({
      field: n,
      operator: ni.GREATER_THAN_EQUAL,
      value: 0
    }), o = s.isEmpty() ? [] : Cp(s, i, n), r = A.isEmpty() ? [] : Cp(A, i, n);
    return A.dispose(), s.dispose(), [
      Math.min(...r, ...o),
      Math.max(...r, ...o)
    ];
  }
  static getStackSumFromData(t, i, n, A) {
    const s = t.getData().data, o = t.getSchema().findIndex((c) => c.name === i), r = t.getSchema().findIndex((c) => c.name === n), a = t.getSchema().findIndex((c) => c.name === A), l = /* @__PURE__ */ new Map();
    return s.forEach((c) => {
      let g = c[o];
      J.isInvalid(g) && (g = g.value()), l.has(g) || l.set(g, {
        posStackSum: 0,
        negStackSum: 0,
        textFieldPosStackSum: 0,
        textFieldNegStackSum: 0
      });
      let h = l.get(g).posStackSum, u = l.get(g).negStackSum, d = l.get(g).textFieldPosStackSum, f = l.get(g).textFieldNegStackSum;
      +c[r] > 0 ? l.set(g, {
        posStackSum: h += J.isInvalid(
          c[r]
        ) ? 0 : c[r],
        negStackSum: u,
        textFieldPosStackSum: d += J.isInvalid(
          c[a]
        ) ? 0 : c[a],
        textFieldNegStackSum: f
      }) : l.set(g, {
        posStackSum: h,
        negStackSum: u += J.isInvalid(
          c[r]
        ) ? 0 : c[r],
        textFieldPosStackSum: d,
        textFieldNegStackSum: f += J.isInvalid(
          c[a]
        ) ? 0 : c[a]
      });
    }), l;
  }
}
class Mu extends Su {
  _sortedValues;
  constructor(t, i) {
    super(t, i);
    const {
      uniqueField: n,
      value: A,
      sortConfig: s
    } = i, o = n?.field, r = n?.as, a = A?.field;
    if (t.isEmpty())
      this._data = [
        {
          values: []
        }
      ], this._domain[o] = [];
    else {
      if (!a)
        throw new Zi(DM);
      const { DataWranglers: l } = t.constructor.DataModel(), c = s.fields.map(({ field: E }) => E), g = W(
        s.fields,
        "0",
        "values"
      );
      let h = t, u = !1;
      if (i.groupBy.length > 2) {
        const E = i.groupBy.map((B) => [B, "asc"]);
        h = h.sort(E), u = !0;
      }
      const d = l.stackBy(
        h.model,
        o,
        c[0],
        a,
        null,
        g,
        // @todo make it generalized
        c[1],
        W(s.fields, "1", "values"),
        "normalize"
      ), f = /* @__PURE__ */ new Map(), I = h.getUidMap(), { data: C } = h.getData();
      d.y0.forEach((E, B) => {
        const m = d.id[B], y = I[m], D = h.getValueAtIndex(o, y), Q = i.groupBy.reduce(
          (w, x) => (w[x] = h.getValueAtIndex(x, y), w),
          {}
        ), p = Object.values(Q).join("-");
        f.has(p) ? f.get(p).values.push({
          values: [d.y0[B], d.y1[B]],
          rowId: m,
          data: C[y],
          uniqueVal: D
        }) : f.set(p, {
          values: [
            {
              values: [d.y0[B], d.y1[B]],
              rowId: m,
              data: C[y],
              uniqueVal: D
            }
          ],
          key: p,
          keys: Object.values(Q),
          groupKey: Q
        });
      }), this._data = [...f.values()], this._domain[o] = h.getDomain(
        o,
        r.toString()
      ), this._domain[a] = [
        Math.min(Zn(d.y0), Zn(d.y1)),
        Math.max(Cn(d.y0), Cn(d.y1))
      ], this._sortedValues = g, u && h.dispose();
    }
  }
  getDomain({ field: t }) {
    return this._domain[t];
  }
  isSortedDomain() {
    return !!this._config.sort;
  }
  getSortedGroupByValues() {
    return this._sortedValues;
  }
  getSortField() {
    return W(this._config.sortConfig, "fields", "0", "field");
  }
  static getFieldDomainFromData() {
    return [0, 1];
  }
  static getStackSumFromData(t, i, n, A) {
    const s = t.getData().data, o = t.getSchema().findIndex((c) => c.name === i), r = t.getSchema().findIndex((c) => c.name === n), a = t.getSchema().findIndex((c) => c.name === A), l = /* @__PURE__ */ new Map();
    return s.forEach((c) => {
      let g = c[o];
      J.isInvalid(g) && (g = g.value()), l.has(g) || l.set(g, {
        posStackSum: 0,
        textFieldPosStackSum: 0
      });
      let h = l.get(g).posStackSum, u = l.get(g).textFieldPosStackSum;
      l.set(g, {
        posStackSum: h += J.isInvalid(c[r]) ? 0 : Math.abs(c[r]),
        textFieldPosStackSum: u += J.isInvalid(
          c[a]
        ) ? 0 : Math.abs(c[a])
      });
    }), l;
  }
}
class L5 extends Su {
  _sortedValues;
  constructor(t, i) {
    if (super(t, i), t.isEmpty())
      this._data = [
        {
          values: []
        }
      ];
    else {
      const n = i.groupBy instanceof Array ? i.groupBy : [i.groupBy], A = t.getSchema();
      if (n.map(
        (c) => A.findIndex((g) => g.name === c)
      ).find((c) => c === -1) !== void 0)
        throw new Error(`Groupby field ${n} not found in schema`);
      const o = t.splitByRow(n), r = W(
        i.sortConfig.fields,
        "0",
        "field"
      ), a = i.groupBy.includes(r) ? r : null;
      this._data = o.map((c) => {
        const g = c.getData().data, h = i.groupBy.map(
          (f) => c.getValueAtIndex(f, 0)
        );
        g.keys = h.map((f) => J.getActualValue(f));
        let u;
        i.groupBy.length && (u = c.getValueAtIndex(i.groupBy[0], 0), g.key = J.getActualValue(u));
        const d = a ? c.getValueAtIndex(a, 0) : null;
        return c.dispose(), {
          keys: h,
          // @todo: Use "keys" instead of "key".
          key: u,
          values: g,
          sortKey: d
        };
      });
      const l = i.sortConfig;
      if (a) {
        const c = l.fields[0].values.reduce(
          (g, h, u) => (g[h] = u, g),
          {}
        );
        this._data.sort((g, h) => c[g.sortKey] - c[h.sortKey]), this._sortedValues = l.fields[0].values;
      }
    }
  }
  getSortedGroupByValues() {
    return this._sortedValues;
  }
  getSortField() {
    return W(this._config.sortConfig.fields, "0", "field");
  }
}
class U5 extends Su {
  getUniqueValues() {
    return [0];
  }
  getSortedGroupByValues() {
    return null;
  }
  getSortField() {
    return null;
  }
}
var bo = /* @__PURE__ */ ((e) => (e.IDENTITY = "identity", e.GROUP = "group", e.STACK = "stack", e.STACK100PERCENT = "stack100percent", e.FRACTURE = "fracture", e))(bo || {});
const O5 = {
  [bo.IDENTITY]: U5,
  [bo.GROUP]: L5,
  [bo.STACK]: DE,
  [bo.STACK100PERCENT]: Mu
};
function H5(e, t, i) {
  const n = O5[e];
  if (typeof n != "function")
    throw new Error("Invalid transform type supplied.");
  return new n(t, i);
}
const { BAND: Sl, LINEAR: P5, TIME: wE } = yS, { DISCRETE: Y5 } = lt, J5 = (e, t, i, n, A) => {
  const s = t.meta, o = ft(
    s.currentState[A][i],
    s.originalState[i]
  ), r = e.transformColor(o, n);
  return s.currentState[A][i] = r.hsla, r;
}, wM = (e, t, i) => {
  const n = {};
  return i.forEach((A) => {
    const s = W(e, A, "field"), o = W(e, A, "as"), r = s && t.getField(s);
    n[`${A}Field`] = s, n[`${A}FieldAs`] = o, n[`${A}FieldIndex`] = t.getFieldIndex(s), n[`${A}FieldType`] = r && r.type(), n[`${A}FieldSubType`] = r && r.subtype();
  }), n;
}, xM = (e, t) => {
  const i = [
    yt.X,
    yt.Y,
    yt.X0,
    yt.Y0,
    yt.RADIUS,
    yt.RADIUS0,
    yt.ANGLE,
    yt.ANGLE0,
    KC,
    VC,
    JC,
    jC,
    WC
  ];
  return wM(e, t, i);
}, Ml = (e, t, i) => {
  const { connectNullData: n } = t, {
    type: A,
    groupBy: s,
    sort: o,
    offset: r,
    orderBy: a,
    value: l,
    uniqueField: c,
    sortField: g,
    sortedValues: h
  } = i;
  return H5(A, e, {
    groupBy: s,
    sortConfig: o,
    offset: r,
    orderBy: a,
    uniqueField: c,
    connectNullData: n,
    value: l,
    sortedValues: h,
    sortField: g
  });
}, iA = (e, t, i, n) => {
  const A = n.config().individualClassName;
  let s = "";
  return A instanceof Function && (s = A(e, t, i, n)), s;
}, SM = (e, t, i, n) => {
  const {
    xField: A,
    yField: s,
    xFieldIndex: o,
    yFieldIndex: r,
    x0FieldIndex: a,
    y0FieldIndex: l,
    radiusFieldIndex: c,
    angleFieldIndex: g,
    angleField: h,
    colorField: u,
    colorFieldIndex: d,
    radius0FieldIndex: f,
    angle0FieldIndex: I
  } = t, { type: C, uniqueField: E } = n, B = [
    [A, o, "x"],
    [s, r, "y"]
  ].find((Q) => Q[0] === (E && E.field)), m = W(B, 1), y = W(B, 2), D = i.getFieldNames();
  return e.getData().map((Q) => Q.values.map((p) => {
    let w, x = {};
    if (C === Nt || C === Lt) {
      w = p.data || [];
      let _, M, k, T;
      const [G, N] = p.values;
      N >= G ? (_ = T = N, k = M = G) : (_ = T = G, k = M = N), y === "y" ? x = {
        x: k,
        x0: T,
        y: w[m],
        y0: w[m]
      } : y === "x" && (x = {
        x: w[m],
        x0: w[m],
        // @todo Removing this condition. This was done for null value handling. Check why this was required.
        // If we uncomment this line, negative values in bar chart gets positioned incorrectly.
        // y: y === 0 ? tuple[yFieldIndex] : y,
        y: _,
        y0: M
      }), x.source = w, x.rowId = p.rowId;
    } else
      w = p, x = {
        x: p[o],
        x0: p[a],
        y: p[r],
        y0: p[l]
      }, x.source = p, x.rowId = p[p.length - 1];
    x = {
      ...x,
      radius: p[c],
      angle: h ? p[g] : u ? p[d] : 1,
      radius0: p[f],
      angle0: p[I]
    }, [KC, VC, JC, jC, WC].forEach((_) => {
      const M = w[t[`${_}FieldIndex`]];
      x[_] = M;
    });
    const S = x.source;
    return x.dataObj = D.reduce((_, M) => (_[M] = S[i.getFieldIndex(M)], _), {}), x;
  })).filter((Q) => Q.length);
}, MM = (e, t) => {
  const i = t.encodingFieldsInf();
  return SM(
    e,
    i,
    t.data(),
    t._transformConfig,
    t.axes()
  );
}, _M = (e, t) => {
  const i = t.encodingFieldsInf(), {
    xField: n,
    xFieldAs: A,
    yField: s,
    yFieldAs: o,
    x0Field: r,
    x0FieldAs: a,
    y0Field: l,
    y0FieldAs: c
  } = i, g = {};
  return n && (g.x = e.getDomain(
    { field: n, fieldAs: A },
    { field: r, fieldAs: a }
  )), s && (g.y = e.getDomain(
    { field: s, fieldAs: o },
    { field: l, fieldAs: c }
  )), g;
}, K5 = (e) => {
  const { x: t, y: i } = e.update;
  return {
    x: t,
    y: i
  };
}, _l = (e, t, i = K5) => {
  e.data(
    [].concat(...t).map((n) => {
      const { x: A, y: s } = i(n);
      return {
        x: A,
        y: s,
        data: n
      };
    })
  );
}, ih = (e, t, i) => {
  for (const n in t)
    ({}).hasOwnProperty.call(t, n) && e.style(n, i ? null : t[n]);
}, W5 = (e, t) => {
  let i, n;
  const { transition: A, groupAnimateStyle: s } = t, { duration: o, effect: r, disabled: a } = A;
  s && (Pt(e.node(), s.enter), n = s.update, a ? i = e : i = e.transition().ease(El[r]).duration(o).on("end", function() {
    ih(V(this), n, !0);
  }), ih(i, n));
}, Zs = (e, t) => {
  const i = e.encodingTransform();
  return i ? i(t, e, {
    smartLabel: e._dependencies.smartLabel
  }) : t;
}, xE = (e, t) => {
  let i;
  const n = e instanceof ui ? e.getBinWidth() : e.getUnitWidth(), A = e.scale(), s = A.range(), o = A.domain();
  return n ? i = n : i = Math.abs(s[1] - s[0]) / (Math.abs(o[1] - o[0]) || o[0]) * t, Math.max(i, 1);
}, Pf = (e, t) => {
  const i = e.encodingFieldsInf(), n = e.axes(), A = e.transformType(), s = e.config(), { TEMPORAL: o } = J.FieldSubtype, r = [n.x, n.y].filter((a) => a instanceof fn).length === 1;
  return ["x", "y"].map((a) => {
    let l = 0, c = 0, g = 0, h = [];
    if (n[a] && n[a].constructor.type() === bn || i[`${a}FieldSubType`] === o || i[`${a}FieldSubType`] === it.BINNED) {
      let u;
      const f = i[`${a}FieldSubType`] === o ? e.dataProps().timeDiffs[a] : 0, I = n[a], C = s[`pad${a.toUpperCase()}`], E = s.innerPadding, B = t, m = I.scale();
      c = xE(I, f);
      const y = I.constructor.type() === Sl, D = I.config().padding || 0, Q = r ? s.outerPadding : 0;
      if (A === "group") {
        const p = e.getBandScale();
        I instanceof fn ? g = Q : g = y ? 0 : D * c;
        const w = I instanceof ui || y ? 0 : g * c / 2;
        p.range([w, c - w]).domain(B).paddingInner(E), l = p.bandwidth(), u = c - g, h = B.map((x) => p(x) - (y ? 0 : I instanceof ui ? -c / 2 : c / 2));
      } else if (C !== void 0) {
        let p;
        if (y) {
          const w = m.step();
          p = m.padding() * w, l = m.bandwidth() + p;
        } else
          l = c;
        I instanceof ui ? h = B.map(() => 0) : h = B.map(
          () => y ? -(p / 2) : -(l / 2)
        );
      } else
        I instanceof fn ? g = Q : g = y ? 0 : D * c, l = c - g, u = l, I instanceof ui ? h = B.map(() => 0) : h = B.map(() => y ? 0 : -(l / 2));
      c = u, g = y ? D * I.scale().step() : D * c;
    }
    return {
      span: l,
      offsetValues: h,
      groupSpan: c,
      padding: g
    };
  });
}, Yf = (e, t) => {
  const i = e.encodingFieldsInf(), n = e.axes(), A = e.reducedDataMap(), s = e.transformType(), o = e.config(), { TEMPORAL: r } = J.FieldSubtype, a = [n.x, n.y].filter((l) => l instanceof fn).length === 1;
  return ["x", "y"].map((l) => {
    let c = 0, g = 0, h = 0, u = [];
    if (n[l] && n[l].constructor.type() === bn || i[`${l}FieldSubType`] === r || i[`${l}FieldSubType`] === it.BINNED) {
      let d;
      const I = i[`${l}FieldSubType`] === r ? e.dataProps().timeDiffs[l] : 0, C = n[l], E = o[`pad${l.toUpperCase()}`];
      let B = o.innerPadding;
      const m = t, y = C.scale();
      g = xE(C, I);
      const D = C.constructor.type() === Sl, Q = C.config().padding || 0, p = a || s === "group" ? o.outerPadding : 0;
      if (s === "group") {
        let w;
        u = /* @__PURE__ */ new Map();
        const x = e.getBandScale();
        C instanceof fn ? (h = p, B = 0) : h = D ? 0 : Q * g, d = g - h;
        let S = Number.MIN_VALUE;
        Array.from(A.values()).forEach((M) => {
          S = Math.max(S, M[0]);
        });
        const _ = (d - (S - 1) * B) / S;
        A.forEach((M, k) => {
          const T = Array.from(M[1]);
          M[0] % 2 === 0 ? w = (M[0] * (B + _) - B) / 2 : w = M[0] * _ / 2 + Math.floor(_ / 2) * B, x.range([d / 2 - w, d / 2 + w]).domain(T).paddingInner(B), c === 0 && (c = x.bandwidth()), c = Math.min(c, x.bandwidth());
          let G;
          T.map((N) => {
            D ? G = 0 : C instanceof ui ? G = -g / 2 : G = d / 2;
            let b = x(N) - G;
            if (u.has(k))
              u.get(k).set(N, b);
            else {
              const F = /* @__PURE__ */ new Map();
              u.set(k, F.set(N, b));
            }
          });
        }), c = Math.max(1, c);
      } else if (E !== void 0) {
        let w;
        if (D) {
          const x = y.step();
          w = y.padding() * x, c = y.bandwidth() + w;
        } else
          c = g;
        C instanceof ui ? u = m.map(() => 0) : u = m.map(
          () => D ? -(w / 2) : -(c / 2)
        );
      } else
        C instanceof fn ? h = p : h = D ? 0 : Q * g, c = g - h, d = c, C instanceof ui ? u = m.map(() => 0) : u = m.map(() => D ? 0 : -(c / 2));
      g = d, h = D ? Q * C.scale().step() : Q * g;
    }
    return {
      span: c,
      offsetValues: u,
      groupSpan: g,
      padding: h
    };
  });
}, bM = (e) => {
  const t = e.mount();
  t && e.render(t);
}, V5 = (e, t, i, n) => {
  const { DIMENSION: A } = J.FieldType, {
    xField: s,
    yField: o,
    xFieldAs: r,
    yFieldAs: a,
    xFieldType: l,
    yFieldType: c,
    sizeField: g
  } = e, h = ["xField", "yField"].find(
    (f) => e[`${f}Type`] === A
  ), u = g && e.sizeFieldType === A, d = !!(Array.isArray(n) && n.length);
  return [
    !s,
    !o,
    !(i || u || d),
    !!(i && t.data().isMeasure(i)),
    l === A && c === A,
    h && e[h] === i,
    h && e[h] === g && u,
    [r, a].every((f) => f === Y5)
  ];
}, SE = (e) => {
  const t = e.config(), i = e.encodingFieldsInf(), n = t.transform.groupBy, A = e.resolveDetailEncodingFields();
  return V5(
    i,
    e,
    n,
    A
  ).some((s) => s) ? En : null;
}, NM = (e) => SE(e) || e.config().transform.type, ME = (e) => {
  const t = SE(e);
  if (t)
    return t;
  const { xField: i, yField: n, xFieldType: A, yFieldType: s } = e.encodingFieldsInf(), { MEASURE: o } = J.FieldType, r = e.config().transform.groupBy, a = !!W(
    e._customConfig,
    "transform",
    "type"
  );
  let l = e.config().transform.type;
  if (!a && r && A !== s) {
    const c = A === o ? i : n, { [c]: g } = Ql(
      e.data(),
      [c]
    );
    l = g === qC ? Nt : gn;
  }
  return l;
}, FM = (e, t) => {
  const { DIMENSION: i } = J.FieldType;
  return e.filter((n, A) => t[A] && t[A].type === i).join();
}, nA = (e, t) => {
  const { translatedValues: i, datum: n, datumIdx: A, groupData: s, groupIdx: o, layerData: r } = t, a = {};
  for (const l in i)
    a[l] = _E(e, {
      translatedValue: i[l],
      datum: n,
      datumIdx: A,
      groupData: s,
      groupIdx: o,
      layerData: r,
      encodingName: l
    });
  return a;
}, _E = (e, t) => {
  const {
    translatedValue: i,
    datum: n,
    datumIdx: A,
    groupData: s,
    groupIdx: o,
    layerData: r,
    encodingName: a
  } = t, { encoding: l } = e.config(), c = W(l, a, "value");
  return typeof c == "function" ? c({
    translatedValue: i,
    datum: n,
    datumIdx: A,
    groupData: s,
    groupIdx: o,
    layerData: r
  }, { context: e, encoding: a }) : i;
}, vs = (e, t, i, n) => {
  const A = n.config().encoding.text.rotation;
  let s;
  return typeof A == "function" ? s = A(
    {
      x: e.x,
      y: e.y,
      text: e.text
    },
    t,
    i,
    n
  ) : A === XC ? s = n.getTextAutoRotationAngle() : s = A, s;
}, Nn = (e, t = {}) => ({
  originalStyle: Object.assign(
    {},
    {
      styles: { ...e, ...t }
    }
  ),
  currentState: /* @__PURE__ */ new Map(),
  lastInteraction: []
}), Ep = (e, t, i, n) => e * Math[t](i) + n, Nd = (e, t, i, n) => ({
  x: Ep(e, "cos", t, i),
  y: Ep(e, "sin", t, n)
}), j5 = (e, t, i = !1) => {
  const n = t.width / 2, A = t.height / 2;
  for (let s = 0, o = e.length; s < o; s++) {
    const r = e[s], { angle: a, radius: l, radius0: c, angle0: g } = r.update;
    if (r.update = Nd(l, a, n, A), i) {
      const h = r.update = Nd(
        c,
        g,
        n,
        A
      ), { x: u, y: d } = Nd(
        l,
        a,
        n,
        A
      );
      h.x0 = u, h.y0 = d;
    }
  }
  return e;
}, Bp = (e) => e.constructor.type() === Sl, mp = (e) => e.constructor.type() === wE, q5 = ({ x: e, y: t }) => {
  let i = e, n = "x";
  return (Bp(t) && !Bp(e) || mp(t) && !mp(e) || t.isBinnedAxis()) && (i = t, n = "y"), { sortAxis: i, sortCoord: n };
}, bl = (e, t, i = {}) => {
  const { sortAxis: n, sortCoord: A } = i.sortAxis && i.sortCoord ? i : q5(t);
  if (n.constructor.type() === Sl) {
    const s = n.domain().reduce((o, r, a) => (o[r] = a, o), {});
    e.sort((o, r) => s[o[A]] - s[r[A]]);
  } else
    (n.constructor.type() === P5 || n.constructor.type() === wE) && e.sort((s, o) => {
      const r = Number.parseFloat(s[A]), a = Number.parseFloat(o[A]);
      return r !== r ? -a : a !== a ? r : r - a;
    });
  return e;
}, bE = (e) => e.map((t) => {
  const { x: i, y: n } = t.update, A = t.data;
  return {
    minX: i,
    maxX: i,
    minY: n,
    maxY: n,
    data: A
  };
}), Ma = (e, t, i) => {
  const { width: n, height: A } = i.getOriSize(e);
  if (!t)
    return { width: n, height: A };
  const s = t * (Math.PI / 180), o = Math.abs(Math.cos(s)), r = Math.abs(Math.sin(s)), a = A * o + n * r;
  return { width: A * r + n * o, height: a };
}, _u = (e, t, i) => {
  const n = i || V(
    t.sourceEvent ? t.sourceEvent.target : t.target
  ).data()[0];
  if (we(n) && W(n, "meta", "layerId") === e.id()) {
    const A = n && n.source;
    let s = null;
    return A && (s = e.getIdentifiersFromData(A, n.rowId)), {
      point: n,
      id: s,
      layerId: e.id()
    };
  }
  return null;
}, z5 = (e) => e.update.y === null || e.update.x === null, NE = (e, t = {}) => {
  const i = t.isNull || z5;
  return e.filter((n, A) => n.isLine ? !0 : !e[A] || i(e[A]) ? !1 : A === 0 ? !!(!e[A + 1] || i(e[A + 1])) : A === e.length - 1 ? !!(!e[A - 1] || i(e[A - 1])) : !!(i(e[A + 1]) && i(e[A - 1])));
}, Z5 = [
  "stroke-width",
  "stroke",
  "stroke-opacity",
  "opacity",
  "fill-opacity",
  "fill"
], Nl = (e, t) => Z5.reduce((i, n) => (n in e && !t.includes(n) && (i[n] = W(e, n, "value")), i), {}), Gs = (e, t, i) => {
  const n = [0, 0], A = e.constructor.type() === Sl, s = e.constructor.type() === wE;
  if (!A && !s && t) {
    const o = e.range(), r = e.domain(), a = o[0] > o[1];
    let l = e.invert(o[0] + i[0]) - r[0], c = e.invert(o[0] + i[1]) - r[0];
    a && (l = -l, c = -c), t[0] - l < r[0] && r[0] !== 0 && (n[a ? 1 : 0] = Math.abs(
      o[0] - e.scale()(t[0] - l)
    )), t[1] + c > r[1] && r[1] !== 0 && (n[a ? 0 : 1] = Math.abs(
      o[1] - e.scale()(t[1] + c)
    ));
  }
  return n;
}, RM = new mr({
  type: "discrete",
  value: "black"
}), In = (e, t) => {
  const i = e.axes().color, A = e.config().encoding.color.splitBy, s = e.metaInf(), o = Object.values(t.dataObj).some(
    (a) => a === s.rowTotalString || s.colTotalString
  ), r = e.metaInf().totalsAxis?.color;
  return o && r ? r : A ? i instanceof mr ? i : i[t.dataObj[A]] || RM : i;
}, kM = (e, t) => {
  const i = e.axes().backgroundColor, A = e.config().encoding.backgroundColor.splitBy, s = e.metaInf(), o = Object.values(t.dataObj).some(
    (a) => a === s.rowTotalString || s.colTotalString
  ), r = e.metaInf().totalsAxis?.backgroundColor;
  return o && r ? r : A ? i instanceof mr ? i : i[t.dataObj[A]] || RM : i;
}, Fl = (e, t) => {
  const i = e.axes().size, n = e.metaInf(), A = Object.values(t.dataObj).some(
    (o) => o === n.rowTotalString || n.colTotalString
  ), s = e.metaInf().totalsAxis?.size;
  return A && s ? s : i;
}, $5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  animateGroup: W5,
  attachDataToVoronoi: _l,
  dataNormalizers: SM,
  domainCalculator: _M,
  encodingFieldInfRetriever: xM,
  getAxisRangeDiffs: Gs,
  getBackgroundColorAxis: kM,
  getBarPlotMeasurement: Yf,
  getBoundBoxes: bE,
  getColorAxis: In,
  getColorMetaInf: Nn,
  getDataFromEvent: _u,
  getDisconnectedPoints: NE,
  getGroupSpan: xE,
  getIndividualClassName: iA,
  getMarkId: FM,
  getNormalizedData: MM,
  getPlotMeasurement: Pf,
  getSizeAxis: Fl,
  getStylesFromEncoding: Nl,
  getTextBounds: Ma,
  getValidTransform: NM,
  getValidTransformForAggFn: ME,
  positionPoints: Zs,
  renderLayer: bM,
  resolveEncodingValues: nA,
  resolveInvalidTransformType: SE,
  resolveRotation: vs,
  resolveSingleEncodingValue: _E,
  retrieveEncodingInf: wM,
  sortData: bl,
  toCartesianCoordinates: j5,
  transformColor: J5,
  transformData: Ml,
  updateStyle: ih
}, Symbol.toStringTag, { value: "Module" })), bu = {
  baseTextStyle: {
    "stroke-width": 0,
    "fill-opacity": 1
  },
  margin: 3,
  textColor: "black"
}, $s = {
  value: "",
  formatter: (e) => e.formattedValue,
  filter: () => !0,
  background: {
    padding: 10
  },
  rotation: 0,
  alignmentBaseline: "middle",
  textAnchor: "middle",
  labelPlacement: {
    anchors: [Je, mn]
  },
  charsAcross: {
    min: 7,
    max: 18
  },
  removeCollision: !0,
  hyperlink: {
    enabled: !1,
    sanitizeHyperlink: !0,
    encode: !0,
    defaultClassName: `${en}-hyperlink-text`,
    generateHref: (e) => ({
      target: Hs,
      rel: Ps,
      url: e.formattedValue,
      styles: Ys,
      classNames: Js
    })
  }
}, X5 = (e, t, i, n, A, s, o, r) => {
  if (!i)
    return e;
  const a = r._dependencies.canvasActions.getRootData(), l = a.getField(i).subtype();
  if (o === Er)
    return Number.isInteger(e) ? `${t(String(e))}%` : `${t(String(e.toFixed(2)))}%`;
  const { TEMPORAL: c, CONTINUOUS: g, BINNED: h } = J.FieldSubtype, { useUTC: u } = A;
  let d = s.getField(i), f = d.schema(), I = f.subtype, C = f.format;
  if (J.isInvalid(e)) {
    let E = t(e);
    return !s.isMeasure(i) && J.isInvalid(E) && (E = J.getActualValue(E)), E;
  }
  if (l !== I && I === it.CATEGORICAL && (l === it.TEMPORAL ? (e = qn(e), I = it.TEMPORAL, d = a.getField(i)) : l === it.BINNED && (e = qn(e), I = it.BINNED, d = a.getField(i)), f = a.getField(i).schema()), I === c) {
    const E = n.x || n.y;
    return E ? Vs(Number(e), E, { useUTC: u }) : js(e, f.format, { useUTC: u });
  } else {
    if (I === g)
      return C(tJ(e));
    if (I === h) {
      if (typeof e == "string")
        return e;
      const E = d.getBinSize();
      return _r([e, e + E]);
    } else
      return t(String(e));
  }
}, Qp = (...e) => {
  const t = X5(...e);
  return Ei(t);
}, tJ = (e) => e == null ? "" : `${e === 0 || e % e.toFixed(0) === 0 ? e : e.toFixed(2)}`, TM = (e, t) => {
  const [i, n, A, s] = ex(
    ...e.getRawColor(t)
  ), [o, r, a] = [i, n, A].map((c) => (c = c / 255, c <= 0.03928 ? c = c / 12.92 : c = (c + 0.055) / 1.055 ^ 2.4, c)), l = 0.2126 * o + 0.7152 * r + 0.0722 * a;
  return (l + 0.05) / (0 + 0.05) > (1 + 0.05) / (l + 0.05) ? `rgba(0, 0, 0, ${s})` : `rgba(255, 255, 2555, ${s})`;
}, pp = (e) => !(typeof e == "number" && !Number.isNaN(e)), Jf = (e) => !e || !e.labelPlacement || !e.labelPlacement.anchors ? mn : e.labelPlacement.anchors[0], vM = (e) => !e || !e.labelPlacement || !e.labelPlacement.anchors || e.labelPlacement.anchors.length === 0 ? [Je, mn] : e.labelPlacement.anchors, FE = (e) => tE.includes(e), Kf = (e) => eE.includes(e), Xs = (e, t, i, n, A, s = { show: !0 }) => {
  if (pp(t.x) || pp(t.y))
    return null;
  const { text: o } = e.config().encoding, {
    background: r,
    alignmentBaseline: a,
    rotation: l,
    textAnchor: c
  } = o, g = r.padding, h = r.value;
  let u, d, f;
  typeof a == "function" ? u = a(
    t,
    n,
    A,
    e
  ) : u = a, typeof l == "function" ? d = l(t, n, A, e) : l === XC ? d = e.getTextAutoRotationAngle() : d = l, typeof c == "function" ? f = c(t, n, A, e) : f = c;
  let I = t.formattedText;
  if (t.maxWidth !== void 0 && t.maxHeight !== void 0) {
    const { smartLabel: E } = e._dependencies, B = E.getSmartText(
      I,
      t.maxWidth,
      t.maxHeight,
      !0
    );
    I = B.isTruncated && !B.text.endsWith("...") ? "" : B.text;
  }
  const C = {
    enter: {},
    update: {
      x: t.x,
      y: t.y
    },
    text: s.show ? I : "",
    color: t.color,
    backgroundColor: t.backgroundColor,
    background: {
      value: h instanceof Function ? h(i, n, A, e) : null,
      padding: g
    },
    alignmentBaseline: u,
    rotation: d,
    textAnchor: f,
    meta: {
      layerId: e.id(),
      ...Nn({
        fill: t.color,
        backgroundColor: t.backgroundColor,
        "border-color": t["border-color"]
      })
    },
    style: {},
    source: i.source,
    rowId: i.rowId,
    data: i.dataObj,
    hyperlinkInfo: i.hyperlinkInfo,
    ...s
  };
  return C.className = iA(i, n, A, e), C;
}, GM = (e, t, i, n) => {
  const A = V(t).selectAll("g").data(i), {
    encoding: {
      text: { hyperlink: s }
    }
  } = e.config(), { smartLabel: o } = e._dependencies, r = {}, a = A.enter().append("g").each(function(g) {
    wA(this, g.enter), n.groupClassName && V(this).attr("class", n.groupClassName(g));
  }).merge(A), l = e.cssStyle();
  o.setStyle(l);
  const c = parseInt(l.fontSize, 10);
  return a.each(function(g) {
    const h = V(this);
    r[g.rowId] = h;
    const { update: u, text: d, labelSmartText: f, color: I, textAnchor: C, background: E } = g, B = f || d, m = Object.assign(
      {},
      bu.baseTextStyle,
      g.style
    );
    let y;
    if (y = E.value) {
      const w = E.padding;
      let x;
      const { width: S, height: _ } = o.getOriSize(B), M = j(h, "rect", [1]);
      C === "end" ? x = S : C === "start" ? x = 0 : x = S / 2, wA(M.node(), {
        x: u.x - x - w / 2,
        y: u.y - c - w / 2,
        width: S + w,
        height: _ + w
      }), E && Pt(M, {
        background: y
      });
    }
    let D = h;
    s.enabled && (D = j(h, "a", (w) => [w]), yl(D, g, s));
    const Q = j(D, "text", (w) => [w]).text(
      B
    ), p = Q.node();
    m && Pt(p, m), I && Pt(p, {
      fill: I
    }), g.className && Q.classed(g.className, !0), wA(p, u), Q.attr("text-anchor", C), Q.attr("alignment-baseline", g.alignmentBaseline), Q.attr(
      "transform",
      `rotate(${g.rotation} ${u.x} ${u.y})`
    );
  }), A.exit().remove(), {
    selection: A,
    elems: r
  };
}, RE = (e, t, i, n) => {
  const { positionAt: A, rotation: s, mirror: o } = i, r = o !== void 0 ? eJ(A, o) : A;
  return n.getLabelPosition(
    e,
    t,
    r,
    s
  );
}, eJ = (e, t) => {
  const i = t.vertical ? iJ(e) : e;
  return t.horizontal ? nJ(i) : i;
}, iJ = (e) => {
  switch (e) {
    case Je:
      return Xn;
    case Xn:
      return Je;
    case dr:
      return Ir;
    case Ir:
      return dr;
    default:
      return e;
  }
}, nJ = (e) => {
  switch (e) {
    case ji:
      return hi;
    case hi:
      return ji;
    case Cr:
      return fr;
    case fr:
      return Cr;
    default:
      return e;
  }
}, AJ = (e, t) => {
  const i = FE(e) ? tE : eE.slice(1);
  let n = i.indexOf(e) + (t === ZC ? -1 : 1);
  return n = n < 0 ? i.length - 1 : n >= i.length ? 0 : n, i[n];
}, aA = 5;
class kE {
  constructor(t) {
    this._smartLabel = t;
  }
  getLabelPosition(t, i, n, A) {
    let s, o;
    const { x: r, y: a, width: l, height: c } = this.getAsRectangle(i), { width: g, height: h } = Ma(
      t,
      A,
      this._smartLabel
    );
    switch (n) {
      case Je:
        s = r + l / 2, o = a - h / 2 - (A ? aA : 0);
        break;
      case hi:
        s = r + l + aA + g / 2, o = a + c / 2;
        break;
      case ji:
        s = r - aA - g / 2, o = a + c / 2;
        break;
      case Xn:
        s = r + l / 2, o = a + c + h / 2 + (A ? aA : 0);
        break;
      case dr:
        s = r + l / 2, o = a + h / 2 + aA;
        break;
      case fr:
        s = r + l - g / 2 - aA, o = a + c / 2;
        break;
      case Cr:
        s = r + g / 2 + aA, o = a + c / 2;
        break;
      case Ir:
        s = r + l / 2, o = a + c - h / 2 - aA;
        break;
      case mn:
      default:
        s = r + l / 2, o = a + c / 2;
        break;
    }
    return { xPos: s, yPos: o };
  }
  getAsRectangle(t) {
    const { x: i, y: n, width: A, height: s, size: o } = t;
    return A === void 0 && s === void 0 && o === void 0 ? { x: i - 0.5, y: n - 0.5, width: 1, height: 1 } : o !== void 0 ? { x: i - o, y: n - o, width: 2 * o, height: 2 * o } : A !== void 0 && s !== void 0 ? { x: i, y: n, width: A, height: s } : { x: i, y: n, width: 0, height: 0 };
  }
}
const xA = ({
  yField: e,
  xField: t,
  yFieldAs: i,
  xFieldAs: n,
  dm: A,
  transformConf: s
}) => {
  if (s.type === Nt || s.type === Lt)
    return s.value?.field === e;
  const o = A.getField(e) && A.getField(e).type(), r = A.getField(t) && A.getField(t).type(), a = A.getField(t) && A.getField(t).subtype(), l = A.getField(e) && A.getField(e).subtype();
  return i === lt.CONTINUOUS && o === Ct.MEASURE || n === lt.CONTINUOUS && (r === Ct.DIMENSION || a === it.TEMPORAL) && i === it.CONTINUOUS && l == it.CONTINUOUS || n === lt.DISCRETE && i === lt.CONTINUOUS;
}, sJ = {
  center: () => ({
    M: { x: 0, y: 0 },
    L1: { x: 0, y: 0 },
    L2: { x: 0, y: 0 },
    L3: { x: 0, y: 0 }
  }),
  inside: (e) => ({
    M: { x: +e, y: +e },
    L1: { x: -e, y: +e },
    L2: { x: -e, y: -e },
    L3: { x: +e, y: -e }
  }),
  outside: (e) => ({
    M: { x: -e, y: -e },
    L1: { x: +e, y: -e },
    L2: { x: +e, y: +e },
    L3: { x: -e, y: +e }
  })
}, oJ = ({ width: e, position: t }) => {
  const i = e / 2;
  return sJ[t](i);
}, rJ = (e, t, i, n, A) => {
  let s = [], o;
  const r = e.config().encoding, a = e.axes(), l = e.transformedData(), c = r.size || {}, { x0Field: g, y0Field: h, textField: u } = e.encodingFieldsInf(), d = e.encodingFieldsInf(), f = e.measurement(), I = e.transformType(), C = xA({
    yField: r.y.field,
    yFieldAs: r.y.as,
    xField: r.x.field,
    xFieldAs: r.x.as,
    dm: e.data(),
    transformConf: e._transformConfig
  }), E = e._stackedSum.size;
  for (let B = 0, m = t.length; B < m; B++) {
    const y = t[B], D = In(e, y);
    I === gn ? o = aJ(
      d,
      C,
      y,
      l,
      n,
      i
    ) : o = i;
    const Q = e.config().encoding, p = Q.size && typeof Q.size.value == "function" ? Q.size.value(
      {
        data: t[B],
        datumIdx: B,
        layerData: e.data()
      },
      {
        context: e,
        encoding: "size"
      }
    ) : void 0, w = hJ({
      data: y,
      config: {
        x0Field: g,
        y0Field: h,
        transformType: I,
        measurement: f,
        sizeConfigModified: o,
        sizeEncoding: c
      },
      axes: a,
      encoding: r,
      context: e,
      sizeValue: p
    });
    let x = D.getColor(y.color);
    const S = w.update, _ = nA(e, {
      translatedValues: {
        x: S.x,
        y: S.y,
        width: S.width,
        height: S.height,
        color: x,
        text: y.text,
        formattedText: y.formattedText
      },
      datum: y,
      datumIdx: B,
      groupData: t,
      groupIdx: n,
      layerData: A
    });
    x = _.color;
    const { x: M, y: k, width: T, height: G } = _, N = {
      fill: x,
      ...Nl(r, [e._mainColorProp])
    }, b = {
      strokePosition: W(r, "strokePosition", "value")
    };
    if (!isNaN(M) && !isNaN(k)) {
      const F = vs(
        { x: M, y: k, text: _.text },
        B,
        y,
        e
      ), R = e.resolveBestLabelAnchor(
        e.createKey(y, C),
        {
          width: _.width,
          height: _.height,
          text: y.formattedText
        },
        F
      ), v = C ? y.y0 === void 0 && y.y < 0 || y.y0 < 0 : y.x0 === void 0 && y.x < 0 || y.x < 0;
      let O = _.formattedText, L, U;
      if (Kf(R) && yp(C, F))
        L = C ? Math.max(0, G - 8) : Math.max(0, T - 8), U = C ? T : G;
      else if (FE(R) && yp(C, F)) {
        const q = (C ? a.y : a.x).range(), $ = 8;
        if (C) {
          const P = v ? _.y + _.height : _.y, st = v ? q[0] - P - $ : P - q[1] - $;
          U = Math.max(T, 20), L = st;
        } else {
          const P = v ? _.x : _.width + _.x;
          L = v ? P - q[0] - $ : q[1] - P - $, U = Math.max(G, 20);
        }
      }
      if (L !== void 0 && U !== void 0) {
        const { smartLabel: Y } = e._dependencies, q = Y.getSmartText(
          O,
          L,
          U,
          !0
        );
        O = q.isTruncated && !q.text.endsWith("...") ? "" : q.text;
      }
      const { xPos: H, yPos: z } = UM(
        O,
        e,
        _,
        R !== void 0 ? R : mn,
        F,
        v
      );
      let et;
      u && !E && (et = Xs(
        e,
        {
          x: H,
          y: z,
          text: _.text,
          formattedText: O,
          color: TM(D, y.color)
        },
        y,
        B,
        t
      ), et && (et.text = R === void 0 ? "" : et.text));
      const Z = {
        enter: w.enter,
        update: {
          x: M,
          y: k,
          width: T,
          height: G
        },
        text: et,
        source: y.source,
        rowId: y.rowId,
        data: y.dataObj,
        style: N,
        meta: Object.assign(
          {
            layerId: e.id()
          },
          Nn(N, b)
        )
      };
      Z.className = iA(y, B, t, e), s.push(Z), e.cachePoint(y.rowId, Z);
    }
  }
  return s = Zs(e, s), s;
}, aJ = (e, t, i, n, A, s) => {
  let o;
  const r = n[A].keys.join(",");
  e.xFieldAs === "discrete" && e.yFieldAs === "discrete" || e.xFieldSubType === "binned" && e.yFieldSubType === "binned" ? o = J.getActualValue(i.x) + "-" + J.getActualValue(i.y) : t ? o = J.getActualValue(i.x) : o = J.getActualValue(i.y);
  const a = s.barWidthOffset instanceof Map ? s.barWidthOffset?.get(o)?.get(r) : 0, l = s.barHeightOffset instanceof Map ? s.barHeightOffset?.get(o)?.get(r) : 0;
  return {
    barWidth: s.barWidth,
    barWidthOffset: a,
    barHeightOffset: l,
    barHeight: s.barHeight
  };
}, yp = (e, t) => e && Math.abs(t) === 90 || !e && (t === 0 || Math.abs(t) === 180), lJ = (e, t, i) => ([bn, LA].includes(
  e.x ? e.x.constructor.type() : null
) || t) && ([bn, LA].includes(
  e.y ? e.y.constructor.type() : null
) || i), LM = (e, t, i, n, A, { data: s, context: o }) => {
  let r, a;
  const { x: l, y: c } = e, g = Fl(o, s), h = i.orientation;
  a = i.offset;
  const u = h === "x" ? l : c, d = e.x instanceof fn, f = e.y instanceof fn, I = d && f, C = lJ(
    e,
    d,
    f
  );
  let E;
  if (g.scaleType() === lt.DISCRETE ? E = J.isInvalid(t) ? t.value() : t : E = J.isInvalid(t) ? 0 : t, n.size.field && [LA, bn].includes(u.constructor.type())) {
    r = g.getSize(E);
    const B = i.size - r;
    a += B / 2;
  } else if (d ^ f && n.size.field) {
    A ? r = h === "x" ? g.getSize(E) : 0 : r = h === "x" ? 0 : g.getSize(E);
    const B = i.size - r;
    a += B / 2;
  } else if (I && n.size.field) {
    r = g.getSize(E);
    const B = i.size - r;
    a += B / 2;
  } else
    C || I ? r = i.size || n.size.value : A ? r = h === "x" ? i.size || n.size.value : 0 : r = h === "x" ? 0 : i.size || n.size.value;
  return {
    offset: a,
    span: r
  };
}, cJ = (e, t, i, n, A, { data: s, context: o }) => LM(
  e,
  t,
  {
    offset: i.barWidthOffset,
    size: i.barWidth,
    orientation: "x"
  },
  n,
  A,
  {
    data: s,
    context: o
  }
), gJ = (e, t, i, n, A, { data: s, context: o }) => LM(
  e,
  t,
  {
    offset: i.barHeightOffset,
    size: i.barHeight,
    orientation: "y"
  },
  n,
  A,
  {
    data: s,
    context: o
  }
), hJ = ({
  data: e,
  sizeValue: t,
  config: i,
  axes: n,
  encoding: A,
  context: s
}) => {
  const o = i.sizeConfigModified, r = xA({
    yField: A.y.field,
    yFieldAs: A.y.as,
    xField: A.x.field,
    xFieldAs: A.x.as,
    dm: s.data(),
    transformConf: s._transformConfig
  }), a = cJ(
    n,
    e.size,
    o,
    A,
    r,
    {
      data: e,
      context: s
    }
  ), l = gJ(
    n,
    e.size,
    o,
    A,
    r,
    {
      data: e,
      context: s
    }
  );
  let c = uJ(n.x, {
    d: e,
    ...a,
    measurement: s.measurement()
  }), g = dJ(n.y, {
    d: e,
    ...l,
    measurement: s.measurement()
  });
  const h = IJ(n, {
    d: e,
    ...l,
    measurement: s.measurement(),
    isVertical: r
  }), u = fJ(n, {
    d: e,
    ...a,
    measurement: s.measurement(),
    isVertical: r
  });
  let d = Math.abs(c - u), f = Math.abs(g - h);
  if (t) {
    const C = (t - (r ? d : f)) / 2;
    r ? (c = c - C, d = t) : (g = g - C, f = t);
  }
  return c = Math.min(c, u), g = Math.min(g, h), {
    enter: {
      x: r ? c : n.x ? n.x.getScaleValue(n.x.domain()[0]) : 0,
      y: r ? n.y ? n.y.getScaleValue(n.y.domain()[0]) : 0 : g,
      width: r ? d : 0,
      height: r ? 0 : f
    },
    update: {
      x: c,
      y: g,
      width: d,
      height: f
    }
  };
}, uJ = (e, t) => {
  if (!e)
    return 0;
  const { d: i, offset: n } = t;
  return e.getScaleValue(i.x) + n;
}, dJ = (e, t) => {
  const { d: i, offset: n } = t;
  return e ? e instanceof ui ? e.getScaleValue(i.y + e.binSize()) + n : e.getScaleValue(i.y) + n : 0;
}, fJ = (e, t) => {
  if (!e.x)
    return t.measurement.width;
  const { d: i, isVertical: n } = t;
  let A = i.x0, { span: s, offset: o } = t;
  return A == null && (n ? A = i.x : A = e.x.constructor.type() === ce && !(e.x instanceof fn) ? 0 : i.x), e.x.getScaleValue(A) + s + o;
}, IJ = (e, t) => {
  if (!e.y)
    return t.measurement.height;
  const { d: i, isVertical: n } = t;
  let A = i.y0, { span: s, offset: o } = t;
  return A == null && (n && e.y.constructor.type() === ce && !(e.y instanceof ui) ? A = 0 : A = i.y), e.y instanceof ui && (A = i.y + e.y.binSize()), e.y.getScaleValue(A) + s + o;
}, UM = (e, t, i, n, A, s) => {
  const o = t.config().encoding, { smartLabel: r } = t._dependencies, a = new kE(r), l = xA({
    yField: o.y.field,
    yFieldAs: o.y.as,
    xField: o.x.field,
    xFieldAs: o.x.as,
    dm: t.data(),
    transformConf: t._transformConfig
  });
  return RE(
    e,
    i,
    {
      positionAt: n,
      rotation: A,
      mirror: {
        vertical: l && s,
        horizontal: !l && s
      }
    },
    a
  );
}, CJ = (e, t, i) => {
  const { originalStyle: n, currentState: A } = e, s = {};
  for (let o in i) {
    for (let r = t.length - 1; r >= 0; r--) {
      const a = A.get(t[r]).styles;
      if (o in a) {
        s[o] = a[o];
        break;
      }
    }
    o in s || (s[o] = ft(
      n.styles[o],
      ""
    ));
  }
  return s;
}, EJ = (e, { datumStyle: t, colorMap: i }, n) => {
  let A = e;
  if (typeof e == "object") {
    if (t === "none")
      return "none";
    const s = bA(t);
    return A = lx(s, e, n, i), A;
  }
  return A;
}, ms = (e, t, i, n) => {
  const { interactionType: A, apply: s } = n, o = t.data()[0], { currentState: r, lastInteraction: a } = o.meta, l = r.get(A);
  if (s === !!l)
    return !1;
  let c = {};
  const { style: g, strokePosition: h, className: u } = i;
  if (e.colorMap || (e.colorMap = /* @__PURE__ */ new Map()), s) {
    const d = {
      styles: {},
      strokePosition: h,
      className: u
    };
    for (const f in g) {
      const I = t.style(f), C = EJ(
        g[f],
        {
          datum: o,
          datumStyle: I,
          colorMap: e.colorMap
        },
        s
      );
      d.styles[f] = C;
    }
    r.set(A, d), a.push(A), c = d;
  } else {
    const d = r.get(A);
    r.delete(A), a.splice(a.indexOf(A), 1), c = {
      styles: CJ(
        o.meta,
        a,
        d.styles
      ),
      className: d.className
    };
  }
  e.applyStyles(
    {
      styleObj: c,
      elem: t,
      datum: o
    },
    n
  );
}, fc = (e, t) => {
  const { x: i, y: n } = e.axes(), A = W(t, "axisDomainRanges") || {};
  let s, o;
  return i ? s = i.config().orientation === "bottom" ? W(A, "x", 0) || null : W(A, "x", 1) || null : s = null, n ? o = n.config().orientation === "left" ? W(A, "y", 0) || null : W(A, "y", 1) || null : o = null, { xRange: s, yRange: o };
}, Rl = ({
  dm: e,
  valueField: t,
  uniqueField: i,
  fieldAs: n
}) => e.isEmpty() ? [] : DE.getFieldDomainFromData(
  e,
  i,
  t,
  n
), nh = (e) => {
  const t = Math.abs(e[0] - e[1]);
  return t === 0 ? [e[0] - 1, e[1] + 1] : [e[0] - 0.01 * t, e[1] + 0.01 * t];
}, tl = (e) => [
  Math.min(e[0], 0),
  Math.max(0, e[1])
], TE = ({ dm: e }) => e.isEmpty() ? [] : Mu.getFieldDomainFromData(), BJ = (e, t, i) => {
  const {
    encoding: {
      text: { hyperlink: n }
    }
  } = e.config();
  let A = n.generateHref(
    {
      formattedValue: t.formattedText,
      rawValue: t.text
    },
    {
      context: e,
      dataPoint: t,
      dataPointIdx: i
    }
  );
  const [s, o, r] = n.sanitizeHyperlink ? e.data().sanitiseStrings([
    A.target,
    A.rel,
    A.url
  ]) : [A.target, A.rel, A.url], a = r || t.formattedText;
  return {
    target: s || Hs,
    rel: o || Ps,
    url: n.encode ? encodeURI(a) : a,
    classNames: A.classNames ? A.classNames : Js,
    styles: A.styles ? A.styles : Ys
  };
}, Fd = (e, t, i) => {
  const {
    encoding: {
      text: { formatter: n, showStackSum: A, displayAs: s }
    },
    mark: o
  } = e.config(), { type: r, originalType: a } = e._transformConfig, c = o === zC && (a || r) === Lt && s === Er, g = { ...t.dataObj }, h = () => g, u = () => {
    const { getGrandTotalsInfo: y } = e._dependencies.canvasActions, { unitRowIndex: D, facets: Q } = e.metaInf(), {
      dataStore: p,
      rowFacets: w = [],
      colFacets: x = [],
      discreteColumnProjections: S = [],
      discreteRowProjections: _ = []
    } = y("rowGrandTotals", D, Q), M = [
      ...w,
      ...x,
      ...S,
      ..._
    ].map((v) => `${v}`), k = e.encodingFieldsInf(), T = [], { yField: G, y0Field: N } = k;
    [G, N].forEach((v) => {
      v && t.dataObj[v] && T.push({
        field: v,
        value: t.dataObj[v],
        operator: "eq"
      });
    });
    const { data: b, schema: F } = (T.length ? p.select({
      operator: "and",
      conditions: T
    }) : p).groupBy(M).getData();
    return F.reduce((v, O, L) => (v[O.name] = b?.[0]?.[L] ?? null, v), {});
  }, d = () => {
    const { getGrandTotalsInfo: y } = e._dependencies.canvasActions, { unitColIndex: D, facets: Q } = e.metaInf(), {
      dataStore: p,
      rowFacets: w = [],
      colFacets: x = [],
      discreteColumnProjections: S = [],
      discreteRowProjections: _ = []
    } = y("columnGrandTotals", D, Q), M = [
      ...w,
      ...x,
      ...S,
      ..._
    ].map((v) => `${v}`), k = e.encodingFieldsInf(), T = [], { xField: G, x0Field: N } = k;
    [G, N].forEach((v) => {
      v && t.dataObj[v] && T.push({
        field: v,
        value: t.dataObj[v],
        operator: "eq"
      });
    });
    const { data: b, schema: F } = (T.length ? p.select({
      operator: "and",
      conditions: T
    }) : p).groupBy(M).getData();
    return F.reduce((v, O, L) => (v[O.name] = b?.[0]?.[L] ?? null, v), {});
  }, f = () => {
    const { getGrandTotalsInfo: y } = e._dependencies.canvasActions, { facets: D } = e.metaInf(), {
      dataStore: Q,
      rowFacets: p = [],
      colFacets: w = [],
      discreteColumnProjections: x = [],
      discreteRowProjections: S = []
    } = y("greatGrandTotals", null, D), _ = [
      ...p,
      ...w,
      ...x,
      ...S
    ].map((G) => `${G}`), { data: M, schema: k } = Q.groupBy(_).getData();
    return k.reduce((G, N, b) => (G[N.name] = M?.[0]?.[b] ?? null, G), {});
  }, I = () => {
    const { getSubTotalsInfo: y } = e._dependencies.canvasActions, D = e.metaInf(), {
      dataStore: Q,
      rowFacets: p = [],
      colFacets: w = [],
      discreteColumnProjections: x = [],
      discreteRowProjections: S = [],
      selectRequiredOnDataStore: _,
      colSubTotalsSplitField: M,
      columnTotalString: k
    } = y("column", D, t), T = [
      ...p,
      ...w,
      ...x,
      ...S
    ].map((L) => `${L}`), G = e.encodingFieldsInf(), N = [], { xField: b, x0Field: F } = G;
    [b, F].forEach((L) => {
      L && t.dataObj[L] && N.push({
        field: L,
        value: t.dataObj[L],
        operator: "eq"
      });
    }), _ && S.forEach((L) => {
      L && t.dataObj[L] && N.push({
        field: L,
        value: L === M ? t.dataObj[L] : k,
        operator: "eq"
      });
    });
    const { data: R, schema: v } = (N.length ? Q.select({
      operator: "and",
      conditions: N
    }) : Q).groupBy(T).getData();
    return v.reduce((L, U, H) => (L[U.name] = R?.[0]?.[H] ?? null, L), {});
  }, C = () => {
    const { getSubTotalsInfo: y } = e._dependencies.canvasActions, D = e.metaInf(), {
      dataStore: Q,
      rowFacets: p = [],
      colFacets: w = [],
      discreteColumnProjections: x = [],
      discreteRowProjections: S = [],
      selectRequiredOnDataStore: _,
      rowSubTotalsSplitField: M,
      rowTotalString: k
    } = y("row", D, t), T = [
      ...p,
      ...w,
      ...x,
      ...S
    ].map((L) => `${L}`), G = e.encodingFieldsInf(), N = [], { yField: b, y0Field: F } = G;
    [b, F].forEach((L) => {
      L && t.dataObj[L] && N.push({
        field: L,
        value: t.dataObj[L],
        operator: "eq"
      });
    }), _ && x.forEach((L) => {
      L && t.dataObj[L] && N.push({
        field: L,
        value: L === M ? t.dataObj[L] : k,
        operator: "eq"
      });
    });
    const { data: R, schema: v } = (N.length ? Q.select({
      operator: "and",
      conditions: N
    }) : Q).groupBy(T).getData();
    return v.reduce((L, U, H) => (L[U.name] = R?.[0]?.[H] ?? null, L), {});
  }, E = () => {
    if (!A)
      throw new Zi(
        "Stacked sum labels are not supported when showStackSum is false",
        {
          cause: "Unsupported Layer Config: showStackSum must be true"
        }
      );
    return g;
  }, B = c ? e.formatTextLabelWithDisplayAsFormatter(t.percentageText * 100) : e.formatTextLabelWithDefaultFormatter(t.text);
  return n(
    {
      formattedValue: B,
      rawValue: t.text,
      getRowData: h,
      getStackSumData: E,
      getColumnGrandTotalsData: d,
      getRowGrandTotalsData: u,
      getGreatGrandTotalsData: f,
      getColumnSubTotalData: I,
      getRowSubTotalData: C
    },
    {
      context: e,
      dataPoint: t,
      dataPointIdx: i
    }
  );
}, mJ = ({
  dm: e,
  valueField: t,
  uniqueField: i,
  textField: n,
  transformType: A
}) => e.isEmpty() ? [] : (A === Nt ? DE : Mu).getStackSumFromData(
  e,
  i,
  t,
  n
), QJ = (e) => Object.keys(e).reduce((t, i) => {
  let n;
  return typeof e[i] == "string" ? n = { [i]: "" } : typeof e[i] == "number" ? n = { [i]: -1 } : typeof e[i] == "object" ? n = { [i]: {} } : n = { [i]: null }, t = { ...t, ...n }, t;
}, {}), Dp = (e, t, i, n, A, s) => {
  const o = e.config().encoding.text.formatter, r = e.config().encoding.text.showStackSum, a = e.config().encoding.text.displayAs, l = n === Lt && a === Er, c = () => {
    if (r)
      throw new Zi(
        "Individual labels are not supported when showStackSum is true",
        {
          cause: "Unsupported Layer Config: showStackSum must be false"
        }
      );
    return { ...t.dataObj };
  }, g = () => {
    if (!r)
      throw new Zi(
        "Stacked sum labels are not supported when showStackSum is false",
        {
          cause: "Unsupported Layer Config: showStackSum must be true"
        }
      );
    const f = e.isVerticalBar() ? "x" : "y";
    let I = [];
    return s.forEach((C) => {
      C[f] === t[f] && I.push({ ...t.dataObj });
    }), I;
  }, h = l ? e.formatTextLabelWithDisplayAsFormatter(t.percentageText * 100) : e.formatTextLabelWithDefaultFormatter(t[A]);
  return o(
    {
      formattedValue: h,
      rawValue: t[A],
      getRowData: c,
      getStackSumData: g
    },
    {
      context: e,
      dataPoint: QJ(t),
      dataPointIdx: i
    }
  );
}, go = (e, t) => e === null || t.length > e.length ? t : e, ho = (e, t) => e === null || t.length < e.length ? t : e, Ah = (e, t, i, n, A) => {
  const { textField: s } = e.encodingFieldsInf(), o = e.axes(), r = n ? o.y : o.x, a = A === "posStackSum", l = a ? t.formattedTextPosSum : t.formattedTextNegSum, c = t.update.x, g = t.update.y, h = t.update.width, u = t.update.height, d = a ? n ? Je : hi : n ? Xn : ji, f = vs({ x: c, y: g, text: t.text }, i, t, e), I = e._transformType;
  let C = 1, E = t.stackSumLabelCoords;
  E ? C = a ? E.pos : E.neg : I === Nt ? C = r.getScaleValue(t[A]) : C = r.getScaleValue(a ? 1 : 0);
  let B;
  if (s && t[A]) {
    const { xPos: y, yPos: D } = UM(
      l,
      e,
      n ? { x: c, y: C, height: 0, width: h } : { x: C, y: g, height: u, width: 0 },
      d,
      f,
      !1
    );
    B = Xs(
      e,
      {
        x: y,
        y: D,
        text: t.text,
        formattedText: l
      },
      t,
      i,
      e._normalizedData
    );
  }
  const m = {
    enter: t.enter,
    update: t.update,
    text: B,
    source: t.source,
    rowId: -1,
    data: t.dataObj,
    style: t.style,
    meta: t.meta
  };
  return m.className = iA(t, i, t, e), m;
}, pJ = (e, t, i) => {
  if (e.legend[t] && e.legend[t].fields && e.legend[t].fields[i]) {
    const n = e.legend[t].fields[i].step, A = e.legend[t].step, s = typeof stepInField == "boolean" ? n : typeof A == "boolean" ? A : !1, { stops: o } = e.legend[t].fields[i];
    return s && Array.isArray(o) && o.length ? { domain: o } : e.legend[t].fields[i];
  }
  return {};
}, OM = (e, t, i = {
  field: null,
  fieldAs: null,
  uniqueField: null,
  isIndependentEncoding: !0
}) => {
  const { field: n, fieldAs: A, uniqueField: s, isIndependentEncoding: o } = i;
  if (!n || !A || !s || !((h) => h === !0 || h === !1)(o) || t.every((h) => h === null))
    return [0, 1];
  let a = Rl({
    dm: e,
    fieldAs: A,
    valueField: n,
    uniqueField: s.field
  });
  o ? a = nh(a) : a = tl(a);
  let l = Math.min(...a), c = Math.max(...a);
  const g = Mu.getFieldDomainFromData().map((h) => h);
  for (let h = 0; h < t.length; h++) {
    const u = t[h];
    if (u !== null) {
      const d = c - l, f = (u - l) / d;
      g[h] = f;
    }
  }
  return g;
}, HM = (e) => Array.isArray(e) && e.length > 1, vE = "drag", Vo = "hover", _a = "selectiondrag", el = "click", ba = "longtouch", PM = "touchdrag", sh = "contextmenu", yJ = "*", DJ = (e, t) => {
  const i = e._sideEffects;
  return t = t instanceof Array ? t : Object.values(t), t.forEach((n) => {
    const A = n.formalName(), s = n.target() instanceof Array ? n.target() : [n.target()];
    if (s.includes(e.target()) || s.includes("all")) {
      const o = i[A];
      i[A] = o || new n(e);
    }
  }), i;
}, wJ = (e, t) => {
  const i = {};
  return t = t instanceof Array ? t : Object.values(t), t.forEach((n) => {
    const A = n.formalName();
    i[A] = new n(e), e.registerPropagationBehaviourMap({
      [A]: [A]
    });
  }), i;
}, xJ = (e, t) => {
  const i = {};
  for (const n in t)
    ({}).hasOwnProperty.call(n, t) || (i[n] = t[n](e));
  return i;
}, Mn = (e, t) => {
  let i;
  t[0] instanceof Set || t[0] instanceof Array ? i = t : i = [t], e = Fi(e);
  const n = i.map(
    (s) => s instanceof Set ? s : new Set(s)
  ), A = /* @__PURE__ */ new Set();
  return e.forEach((s) => {
    for (const o of s)
      n.every((r) => !r.has(o)) && A.add(o);
  }), A;
}, SJ = (e, t) => {
  const i = {};
  return Object.keys(t.actions().behavioural).forEach((A) => {
    const s = ft(e[A], e["*"]);
    s && (i[A] = s);
  }), i;
}, MJ = (e, t) => {
  const i = {};
  return Object.keys(t.sideEffects()).forEach((A) => {
    const s = ft(e[A], e["*"]);
    s && (i[A] = s);
  }), i;
}, _J = (e, { behaviours: t, sideEffects: i }) => {
  const n = SJ(t, e);
  for (const s in n)
    e.getBehaviouralAction(s).setApplyChecker({
      [s]: n[s],
      "*": t["*"]
    });
  const A = MJ(i, e);
  for (const s in A)
    e.getSideEffectInstance(s).setApplyChecker({
      [s]: A[s],
      "*": i["*"]
    });
}, GE = ({ action: e, sourceCanvas: t, targetActions: i }, n) => {
  let A;
  return t === n.sourceCanvas() ? A = W(i, "layer", e, "sideEffects") || {} : A = W(
    i,
    "interCanvas",
    n.sourceCanvas(),
    e,
    "sideEffects"
  ) || {}, Object.keys(A || {}).map((o) => ({
    name: o,
    ...A[o]
  })).filter((o) => o.enabled !== !1);
}, bJ = (e, t) => {
  const i = e[0], n = i.reduce((a, l, c) => (a[l] = c, a), {}), A = /* @__PURE__ */ new Set(), s = i, o = i.find(
    (a) => a === St.ROW_ID
  ), r = t(s);
  for (let a = 1, l = e.length; a < l; a++) {
    const c = e[a];
    if (o)
      A.add(c[n[o]]);
    else {
      const g = s.map((u) => c[n[u]]), h = r[g];
      h && h.forEach((u) => {
        A.add(u);
      });
    }
  }
  return [...A];
}, NJ = (e, t) => {
  if (e) {
    const i = t.data();
    let n = [];
    const { range: A, dimensions: s, uids: o } = e;
    if (o)
      n = o;
    else if (A) {
      const r = i.getFilterRangeQuery(A), a = i.select(r);
      n = a.getUids(), a.dispose();
    } else
      s && (n = bJ(s, t._dimsMapGetter));
    return n;
  }
  return null;
}, FJ = (e, t, i) => {
  const n = i._actionBehaviourMap;
  for (const A in n)
    if (A === t) {
      const s = n[A];
      s.behaviours = s.behaviours.filter(
        (o) => o !== e
      );
    }
}, RJ = (e, t, i) => {
  const n = i._behaviourEffectMap;
  n[t] = n[t].filter(
    (A) => (A.name || A) !== e
  );
};
class to {
  constructor(t, i, n, A) {
    this.context = t, this._childFirebolts = [], this._onMatrixCreated = [], this._sideEffectDefinitions = {}, this._sideEffects = {}, this._actions = {
      behavioural: {},
      physical: {},
      physicalActionDefs: {},
      behaviourDefs: {}
    }, this._propagationBehaviourMap = {}, this._actionBehaviourMap = {}, this._propagationInf = {}, this._config = {}, this._behaviourEffectMap = {}, this._queuedSideEffects = {}, this._handlers = {}, this._payloadGenerators = {}, this._propagationHandler = null, this._lastInteraction = /* @__PURE__ */ new Map(), this._metaData = {}, this.mapSideEffects(A), this.registerBehaviouralActions(i.behavioural), this.registerSideEffects(n), this.registerPhysicalBehaviouralMap(i.physicalBehaviouralMap), this.registerPhysicalActions(i.physical);
    const s = {};
    for (const o in this._actions.behavioural)
      s[o] = [o];
    this.registerPropagationBehaviourMap(s);
  }
  config(...t) {
    return t.length ? (this._config = tt(this._config, t[0]), this) : this._config;
  }
  mapSideEffects(t, i = !0) {
    const n = this._behaviourEffectMap;
    for (const A in t) {
      let s = t[A] || [];
      s = s.map(
        (o) => we(o) ? tt({}, o) : { name: o }
      ), !n[A] && (n[A] = []), n[A] = [
        ...new Set(
          i ? bg(
            [...n[A], ...s],
            (o) => o.name || o
          ) : s
        )
      ];
    }
    return this._childFirebolts.forEach((A) => {
      A.mapSideEffects(t);
    }), this;
  }
  registerBehaviouralActions(t) {
    Object.assign(this._actions.behaviourDefs, t);
    const i = wJ(this, t);
    return Object.assign(this._actions.behavioural, i), this;
  }
  registerSideEffects(t) {
    for (const i in t)
      this._sideEffectDefinitions[t[i].formalName()] = t[i];
    return this.initializeSideEffects(), this;
  }
  isVisible() {
    return !0;
  }
  applySideEffects(t, i, n) {
    return t.forEach((A) => {
      const s = A.name;
      this.dispatchSideEffect(s, i, n, A);
    }), this;
  }
  dispatchSideEffect(t, i, n, A) {
    const o = this.sideEffects()[t], { setTransform: r } = A, a = ft(
      r,
      o.setTransform()
    );
    i = a ? a(i, n, o) : i, o.apply(i, n, A);
  }
  disposeSelectionSets() {
    const t = this._actions.behavioural;
    for (const i in t)
      t[i].dispose();
  }
  dispose() {
    Object.entries(this._sideEffects).forEach(([t, i]) => {
      (t === "tooltip" || t === "fragmented-tooltip") && i.dispose();
    });
  }
  registerPropagationBehaviourMap(t) {
    const i = this._propagationBehaviourMap;
    for (const n in t)
      if (n in i) {
        const A = t[n] instanceof Array ? t[n] : [t[n]];
        i[n] = [
          .../* @__PURE__ */ new Set([...i[n], ...A])
        ];
      } else
        i[n] = t[n];
    return this;
  }
  dispatchBehaviour(t, i, n = {}, A = !1) {
    const s = n.propagate !== void 0 ? n.propagate : !0, o = this.getBehaviouralAction(t);
    return this._propagationInf = n, o && (o.shouldApply(i, n) || A) ? (i.action = t, o.dispatch(i), s && o.propagate() && this.propagate(t, i, o.propagationIdentifiers()), this.dispatchSideEffects(
      t,
      i,
      n,
      A
    ), this._lastInteraction.set(t, {
      behaviour: t,
      sideEffects: i.sideEffects
    }), !0) : !1;
  }
  dispatchSideEffects(t, i, n, A) {
    const s = this._behaviourEffectMap[t] || [], o = this.getApplicableSideEffects(
      s,
      i,
      n,
      A
    );
    this.applySideEffects(
      o,
      this.getEntryExitSet(t),
      i,
      t
    );
  }
  saveInteractionState({ action: t, payload: i, propagationInf: n, forceDispatch: A }) {
    return t !== "highlight" && this._interactionStates.set(t, {
      action: t,
      payload: i,
      propagationInf: n,
      forceDispatch: A
    }), this;
  }
  removeInteractionState({ action: t }) {
    this._interactionStates.delete(t);
  }
  clearInteractionState() {
    this._interactionStates.clear();
  }
  propagate() {
    return this;
  }
  sideEffects(...t) {
    return t.length ? (this._sideEffects = t[0], this) : this._sideEffects;
  }
  dissociateBehaviour(...t) {
    return t.forEach((i) => {
      FJ(...i, this);
    }), this._childFirebolts.forEach((i) => {
      i.dissociateBehaviour(...t);
    }), this;
  }
  dissociateSideEffect(...t) {
    return t.forEach((i) => {
      RJ(...i, this);
    }), this._childFirebolts.forEach((i) => {
      i.dissociateSideEffect(...t);
    }), this;
  }
  getApplicableSideEffects(t = [], i, n, A) {
    const s = this.sideEffects();
    return (i.sideEffects ? i.sideEffects : t).filter(
      (r) => s[r.name] && (A ? s[r.name]._enabled : s[r.name].shouldApply(i, n))
    );
  }
  attachPropagationListener(t, i = this.onDataModelPropagation()) {
    return t.unsubscribe(this._propagationHandler), t.onPropagation(i), this._propagationHandler = i, this;
  }
  onDataModelPropagation() {
    return (t) => {
      const i = t.payload, n = i.action;
      this.dispatchBehaviour(n, i, {
        propagate: !1
      });
    };
  }
  createSelectionSet(t) {
    const i = this._actions.behavioural;
    for (const n in i)
      i[n].createSelectionSet(t);
    return this;
  }
  initializeSideEffects() {
    const t = this._sideEffectDefinitions;
    return this.sideEffects(DJ(this, t)), this;
  }
  target() {
    return "all";
  }
  registerPhysicalActions(t, i = this) {
    Object.assign(this._actions.physicalActionDefs, t);
    const n = xJ(i, t);
    return Object.assign(this._actions.physical, n), this;
  }
  /**
   * Allows to propagate the datamodel with only the supplied fields. When propagation is done, then the fields
   * which are supplied for the specified behavioural action is propagated.
   *
   * @public
   *
   * @param {string} action Name of behavioural action. If '*' is specified, then for all behavioural actions it is
   * applied.
   * @param {Array} fields Array of field names which will be propagated.
   * @param {boolean} append If true, then it is appended to the existing propagation data model fields else only
   * those fields are projected from propagation data model and propagated.
   *
   * @return {Firebolt} Instance of firebolt
   */
  setPropagationFields(t, i, n = !1) {
    const A = this._actions.behavioural;
    if (t === yJ)
      for (const s in A)
        A[s].propagateWith(i, n);
    else
      A[t].propagateWith(i, n);
    return this;
  }
  propagateWith(t, i, n = !1) {
    const A = this._childFirebolts;
    this.setPropagationFields(t, i, n), A.forEach((s) => {
      s.propagateWith(t, i, n);
    });
  }
  /**
   * Map actions and behaviours
   * @return {Firebolt} Firebolt instance
   */
  mapActionsAndBehaviour(t, i) {
    const n = this._actions.physical, A = i || this._actionBehaviourMap;
    for (const s in A)
      if (!{}.hasOwnProperty.call(s, A) && s === (t || s)) {
        let o;
        const r = A[s];
        o = r.target;
        const a = r.touch;
        o || (o = this.context.getDefaultTargetContainer()), (YC() ? a === !0 || a === void 0 : !a) && this.bindActionWithBehaviour(
          n[s],
          o,
          r.behaviours
        );
      }
    return this.registerPhysicalActionHandlers(), this;
  }
  registerPhysicalBehaviouralMap(t) {
    return this._actionBehaviourMap = tt(this._actionBehaviourMap, t), this._childFirebolts.forEach((i) => {
      i.registerPhysicalBehaviouralMap(t);
    }), this;
  }
  /**
   * Binds a target element with an action.
   *
   * @param {Function} action Action method
   * @param {string} target Class name of element
   * @param {Array} behaviourList Array of behaviours
   * @return {FireBolt} Instance of firebolt
   */
  bindActionWithBehaviour(t, i, n) {
    return typeof i == "string" && (i = [i]), i.forEach((A) => {
      const s = this.context.mount(), o = A.node instanceof Function ? A : V(s).selectAll(A);
      o.empty() || (o instanceof Array ? o.forEach((r) => {
        t(V(r), n);
      }) : t(o, n));
    }), this;
  }
  getPropagationInf() {
    return this._propagationInf;
  }
  getAddSetFromCriteria(t, i = {}) {
    return t === null ? {
      model: null,
      uids: null
    } : W(t, "uids", "length") === 0 ? {
      model: i.data,
      uids: []
    } : {
      model: i.data ? i.data : null,
      uids: NJ(t, this)
    };
  }
  getFullData() {
    return this.context.data();
  }
  data() {
    return this.context.data();
  }
  currentData() {
    return this.data();
  }
  triggerPhysicalAction(t, i) {
    const n = this._handlers[t] || [], A = this._handlers["*"];
    return [
      ...Object.values(n),
      ...Object.values(A)
    ].forEach((o) => {
      o(t, i);
    }), this;
  }
  onPhysicalActionTrigger({ payload: t, behaviours: i }) {
    i.forEach((n) => {
      this.dispatchBehaviour(n, t);
    });
  }
  onPhysicalAction(t, i, n) {
    return !this._handlers[t] && (this._handlers[t] = {}), this._handlers[t][n] = i, this;
  }
  registerPhysicalActionHandlers() {
    this.onPhysicalAction("*", (t, i) => {
      const n = this._actionBehaviourMap[t];
      if (n) {
        const { behaviours: A } = n;
        this.onPhysicalActionTrigger({
          event: t,
          payload: i,
          behaviours: A
        }), this._criteria = i.criteria;
      }
    });
  }
  beforeDispatchBehaviour() {
    return this;
  }
  id() {
    return this.context.id();
  }
  payloadGenerators(...t) {
    return t.length && Object.assign(this._payloadGenerators, t[0]), this._payloadGenerators;
  }
  getPayloadGeneratorFor(t) {
    const i = this._payloadGenerators.__default, n = this._payloadGenerators[t];
    return ft(n, i);
  }
  getPayload(t) {
    return this._actions.behavioural[t].getPayload();
  }
  actions() {
    return this._actions;
  }
  getBehaviouralAction(t) {
    return this._actions.behavioural[t];
  }
  getSideEffectInstance(t) {
    return this._sideEffects[t];
  }
  getEntryExitSet(t) {
    return this.getBehaviouralAction(t).entryExitSet();
  }
  getSelectionSet(t) {
    return this.getBehaviouralAction(t).getSelectionSet();
  }
  onPropagationDone(t) {
    this._onPropagationDone = t;
  }
  applyPropagationPolicy({ behaviours: t, sideEffects: i }) {
    _J(this, { behaviours: t, sideEffects: i }), this._childFirebolts.forEach((n) => {
      n.applyPropagationPolicy({ behaviours: t, sideEffects: i });
    });
  }
  sourceCanvas() {
    return this.context.sourceCanvas();
  }
  metaData(...t) {
    return t.length && (this._metaData = tt(this._metaData, t[0])), this._metaData;
  }
}
const wp = (e, t) => {
  if (Array.isArray(e))
    e.forEach(t);
  else
    for (const n of e)
      t(n);
};
class Nu {
  /**
   * Creates an instance of selection set
   *
   * @param {Array.<string>} completeSet Set of unique ids.
   */
  constructor({ keys: t, entrySet: i, exitSet: n }) {
    this._set = t instanceof Set ? t : new Set(t), this._entrySet = i || /* @__PURE__ */ new Set(), this._exitSet = n || /* @__PURE__ */ new Set(), this._resetted = !1;
  }
  /**
   * Adds a set of ids to the selection set. This also moves the other rows to exit set.
   *
   * @public
   * @param {Array.<number|string>} ids Array of unique ids.
   *
   * @return {SelectionSet} Instance of selection set.
   */
  add(t) {
    const i = this._entrySet, n = this._exitSet;
    return wp(t, (A) => {
      i.add(A), n.has(A) && n.delete(A);
    }), this;
  }
  updateEntrySet() {
    const [t, i] = this._entrySet;
    for (const n of i)
      i.delete(n), t.add(n);
  }
  updateExitSet() {
    const [t, i] = this._exitSet;
    for (const n of i)
      t.add(n), i.delete(n);
  }
  getEntrySet() {
    return this._entrySet;
  }
  getExitSet() {
    return this._exitSet;
  }
  /**
   * Removes an array of ids from the selection set. It also moves the remaining row ids to entry set.
   *
   * @public
   * @param {Array.<string>} ids Array of unique ids
   *
   * @return {SelectionSet}  Instance of selection set
   */
  remove(t) {
    const i = this._exitSet, n = this._entrySet;
    return wp(t, (A) => {
      i.add(A), n.has(A) && n.delete(A);
    }), this;
  }
  /**
   * Resets an array of ids in the selection set to initial state. It sets the value of every unique id value to
   * null in the selection set which means they are neither in entry set nor in exit set. If no ids are passed,
   * then it resets all the ids to null.
   *
   * @public
   *
   * @param {Array} ids Array of unique ids.
   * @return {SelectionSet} Instance of selection set.
   */
  reset() {
    return this._entrySet.clear(), this._exitSet.clear(), this;
  }
  resetted() {
    return !this.getEntrySetLength() && !this.getExitSetLength();
  }
  getEntrySetLength() {
    return this._entrySet.size;
  }
  getExitSetLength() {
    return this._exitSet.size;
  }
  /**
   * Gets all the ids which are either in exit or entry set.
   *
   * @public
   * @return {Array} Array of unique ids
   */
  getCompleteSet() {
    return this._set;
  }
  getCompleteSetLength() {
    return this._set.size;
  }
  clone({ entrySet: t, exitSet: i }) {
    return new Nu({ keys: new Set(this._set), entrySet: t, exitSet: i });
  }
}
const xp = (e, t, i) => {
  if (e = e.filter((g) => g && g.getRowsCount()), !e.length)
    return null;
  const n = /* @__PURE__ */ new Map();
  let A;
  for (let g = 0; g < e.length; g++)
    e[g].getSchema().forEach((d) => {
      d.name !== St.ROW_ID && n.set(d.name, d);
    });
  const s = [];
  for (let g = 0; g < e.length; g++) {
    const h = e[g];
    A = { ...h._model._config };
    const u = h.getRowsCount();
    for (let d = 0; d < u; d++) {
      let f = [];
      n.forEach((I, C) => {
        const E = h.getValueAtIndex(C, d);
        f.push(E);
      }), s.push(f);
    }
  }
  const o = s.length ? ae(s) : [[]], r = [...n.values()], a = [], l = [];
  if (o.forEach((g, h) => {
    g.every((d) => d === null) || (a.push(r[h]), l.push(g));
  }), t && l.length) {
    const g = l[0].length;
    for (let h in t.data)
      a.find((u) => u.name === h) || (l.push(
        new Array(g).fill().map(() => t.data[h])
      ), a.push(t.schema.find(({ name: u }) => u === h)));
  }
  const c = new J(
    {
      data: l.length ? l : [[]],
      schema: a
    },
    A
  );
  return c.model._alias = i, c;
}, kJ = (e, t) => e.size === t.size && [...e].every((i) => t.has(i)), Sp = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((i) => {
    i.forEach((n) => {
      t.add(n);
    });
  }), t;
}, Mp = (e, t) => e.reduce((i, n) => i + t(n), 0);
class YM {
  constructor({ data: t, uids: i, length: n }) {
    this._uids = i, this._model = t, this._length = n;
  }
  get uids() {
    return typeof this._uids == "function" && (this._uids = this._uids()), this._uids;
  }
  get model() {
    if (typeof this._model == "function") {
      const t = this._model();
      return this._model = t, this._model;
    }
    return this._model;
  }
  get length() {
    return this._length;
  }
  get aggFns() {
    return Ql(this._model);
  }
  dispose() {
    this._model && !(this._model instanceof Function) && this._model.dispose(!1);
  }
  intersect(t) {
    return {
      uids: RC(t.uids, this.uids)
    };
  }
  difference(t) {
    return {
      uids: ou(t.uids, this.uids)
    };
  }
}
class LE {
  constructor({ entrySet: t, exitSet: i, completeSet: n, context: A }, s = {}) {
    this._context = A, this._id = Ut(), this._name = s.name, this._sets = {
      entrySet: this.createAtomicSet({
        uids: t.uids instanceof Function ? t.uids : new Set(t.uids),
        model: t.data,
        length: t.uids.size
      }),
      exitSet: this.createAtomicSet({
        uids: i.uids instanceof Function ? i.uids : new Set(i.uids),
        model: i.data,
        length: i.uids.size
      }),
      completeSet: this.createAtomicSet({
        uids: n.uids,
        model: n.data,
        length: n.uids.size
      })
    };
  }
  createAtomicSet({ uids: t, model: i, length: n }) {
    return new YM({
      uids: t,
      data: i,
      length: n
    });
  }
  get entrySet() {
    return this._sets.entrySet;
  }
  get exitSet() {
    return this._sets.exitSet;
  }
  get completeSet() {
    return this._sets.completeSet;
  }
  dispose() {
    this._disposed = !0, this._sets.entrySet.dispose(), this._sets.exitSet.dispose(), this._sets = null;
  }
  filter(t) {
    const [i, n] = this.entrySet.model.select(t, {
      mode: "all"
    }), A = i.getUids(), s = /* @__PURE__ */ new Set([n.getUids(), ...this.entrySet.uids]), o = new Nu({
      keys: this.completeSet.uids,
      entrySet: new Set(A),
      exitSet: new Set(s)
    }), r = (a, l, c) => () => {
      const g = c.data();
      return a === "complete" ? g : a === "entrySet" ? i : g.select(t, {
        mode: "all"
      })[1];
    };
    return new LE({
      entrySet: {
        uids: o.getEntrySet(),
        data: () => r("entrySet", o.getEntrySet(), this._context)
      },
      exitSet: {
        uids: o.getExitSet(),
        data: () => r("exitSet", o.getExitSet(), this._context)
      },
      completeSet: {
        uids: o.getCompleteSet(),
        data: this._context.data()
      },
      context: this._context
    });
  }
}
class JM {
  constructor(t, { extraData: i, name: n }) {
    this._entryExitSets = t, this._entrySet = null, this._exitSet = null, this._extraData = i, this._name = n, this._id = Ut();
  }
  composeSet(t) {
    const i = this._entryExitSets.map((r) => r[t].uids), n = i.length === 2 ? kJ(i[0], i[1]) : !1, A = Sp(i), s = Mp(
      this._entryExitSets.map((r) => r[t]),
      (r) => r.length
    ), o = xp(
      this._entryExitSets.map((r) => r[t].model),
      this._extraData
    );
    return o && (o.model._alias = this._alias), new YM({
      uids: A,
      data: A.size && n && Array.isArray(this._entryExitSets) ? this._entryExitSets.find((r) => r[t].model)[t].model : xp(
        this._entryExitSets.map((r) => r[t].model),
        this._extraData,
        this._alias
      ),
      length: s
    });
  }
  get entrySet() {
    return this._entrySet || (this._entrySet = this.composeSet("entrySet", this._extraData)), this._entrySet;
  }
  get exitSet() {
    return this._exitSet || (this._exitSet = this.composeSet("exitSet", this._extraData)), this._exitSet;
  }
  get completeSet() {
    const t = "completeSet";
    return this._completeSet || (this._completeSet = {
      uids: Sp(this._entryExitSets.map((n) => n[t].uids)),
      length: Mp(
        this._entryExitSets.map((n) => n[t]),
        (n) => n.length
      )
    }), this._completeSet;
  }
  dispose() {
    this._disposed = !0, this._entrySet && this._entrySet.model && this._entrySet.model.dispose(!1), this._entrySet && this._entrySet.model && this._entrySet.model.dispose(!1), this._entryExitSets.length = 0, this._entrySet = null, this._exitSet = null;
  }
}
class Qi {
  constructor(t, i) {
    this.formalName(ft(i, this.constructor.formalName())), this.context = t, this._selectionSet = null, this._applyChecker = {}, this._appendPropFields = !1, this._propagationIdentifiers = null, this._entryExitSet = null, this._prevEntryExitSet = null, this.propagate(!0), this._enabled = !0, this.setApplyChecker({
      source: () => !0
    });
  }
  shouldResetOtherActionsOnTrigger() {
    return !0;
  }
  isImplicit() {
    return !1;
  }
  static formalName() {
    throw new Error("Method not implemented");
  }
  formalName(...t) {
    return t.length ? (this._formalName = t[0], this) : this._formalName;
  }
  /**
   * Returns entry and exit set information. This method is called by firebolt when ```dispatchBehaviour``` is called
   * dynamically or when any physical action is triggered on the chart.
   *
   * @param {Object} payload Payload information.
   * @param {Object|Array} payload.criteria Identifiers of data interacted with.
   *
   * @return {Array} Entry and exit set information.
   */
  dispatch(t) {
    const i = t.criteria, n = this.context, A = this.getSelectionSet(), s = n.getPropagationInf(), { model: o, uids: r } = this.getAddSetFromCriteria(
      i,
      n.getPropagationInf(),
      t
    );
    this._payload = t, t.uids = r || [], this.setSelectionSet(r, A, {
      filteredDataModel: o,
      payload: t
    }), s.propagate !== !1 && this.propagationIdentifiers(A, t), A.resetted() && (this._propagationIdentifiers = null), this.entryExitSet(A, o, t);
  }
  getSelectionSet() {
    return this._selectionSet;
  }
  createSelectionSet(t) {
    return this._selectionSet = new Nu(t), this;
  }
  getAddSetFromCriteria(...t) {
    return this.context.getAddSetFromCriteria(...t);
  }
  /**
   * Updates the selection set by adding uids to the instance of {@link SelectionSet} or removing them.
   * {@link SelectionSet} keeps the information of which rows are in the entry set and exit set.
   *
   * @public
   * @param {Array} addSet Array of row ids which got affected during interaction.
   * @param {SelectionSet} selectionSet Instance of selection set.
   *
   * @return {GenericBehaviour} Instance of behaviour.
   */
  setSelectionSet() {
    return this;
  }
  entryExitSet(...t) {
    if (t.length) {
      const [i, n] = t, A = W(
        this.context.getPropagationInf(),
        "propPayload",
        "sourceId"
      ), s = (l, c, g) => () => {
        const h = g.data();
        let u = null;
        if (l === "complete")
          return h;
        if (l === "entrySet" && A)
          [...c].length ? u = n ? n.replica() : null : u = n ? n.createEmptyDm() : null;
        else {
          const d = [...c];
          u = d.length ? h.select({
            field: St.ROW_ID,
            value: d,
            operator: "in"
          }) : h.createEmptyDm(), u && h.removeChild(u);
        }
        return u;
      }, o = this.context, r = o.data(), a = W(this._entryExitSet, "entrySet", "_model");
      return this._entryExitSet && ![n, r].includes(a) && this._entryExitSet.dispose(), this._entryExitSet = new LE(
        {
          entrySet: {
            uids: i.getEntrySet(),
            data: s("entrySet", i.getEntrySet(), o)
          },
          exitSet: {
            uids: i.getExitSet(),
            data: s("exitSet", i.getExitSet(), o)
          },
          completeSet: {
            uids: i.getCompleteSet(),
            data: o.data()
          },
          context: {
            data: () => this.context.data()
          }
        },
        {
          name: `visual-layer:${this._payload.action}`
        }
      ), this;
    }
    return this._entryExitSet;
  }
  propagationIdentifiers(...t) {
    if (t.length) {
      let i = null;
      const [n, A] = t, { criteria: s } = A, o = this._propagationFields;
      if (s === null || n.resetted())
        i = null;
      else if (s.range)
        i = {
          interpolated: !0,
          identifiers: s.range,
          fields: Object.keys(s.range)
        };
      else {
        let r = A.fields;
        o && (r = this._appendPropFields ? [...A.fields, ...o] : o);
        const a = [...n.getEntrySet()];
        i = {
          fields: r,
          identifiers: a
        };
      }
      return this._propagationIdentifiers = i, this;
    }
    return this._propagationIdentifiers;
  }
  static mutates() {
    return !1;
  }
  propagateWith(t, i) {
    return this._appendPropFields = !!i, this._propagationFields = t, this;
  }
  propagate(...t) {
    return t.length ? (this._propagate = t[0], this) : this._propagate;
  }
  runApplyChecker(t, i) {
    const n = this._applyChecker[t];
    return n(
      {
        ...i.sourceInfo,
        fields: i.fields
      },
      {
        canvasId: this.context.sourceCanvas(),
        unitId: this.context.sourceUnit ? this.context.sourceUnit() : null,
        layerId: this.context.id(),
        fields: this.context.data() ? this.context.data().getFieldNames() : null
      },
      i
    );
  }
  shouldApply(t) {
    let i = !0;
    const n = this._applyChecker;
    for (const A in n)
      i = i && this.runApplyChecker(A, t);
    return i && this._enabled;
  }
  setApplyChecker(t) {
    return Object.assign(this._applyChecker, t), this;
  }
  removeApplyChecker(t) {
    delete this._applyChecker[t];
  }
  getPayload() {
    return this._payload;
  }
  reset() {
    return this.getSelectionSet().reset(), this._propagationIdentifiers = null, this;
  }
  dispose() {
    this._cachedSets.length = 0, this._selectionSet && this._selectionSet.reset();
    const t = this._entryExitSet;
    return t && (t.dispose(), this._entryExitSet = null), this;
  }
  getDiffSet(t, i) {
    return Mn(t, i);
  }
  disposeEntryExitSet() {
    this._entryExitSet && this._entryExitSet.dispose();
  }
  isReactionBehaviour(...t) {
    return t.length ? (this._isReactionBehaviour = t[0], this) : this._isReactionBehaviour;
  }
  generatePayloadFromPropagationInf({ propagationData: t, propPayload: i }) {
    let n;
    return t ? n = {
      criteria: {
        uids: t.getUids()
      }
    } : n = {
      criteria: null
    }, Object.assign({}, i, n);
  }
  enable() {
    this._enabled = !0;
  }
  disable() {
    this._enabled = !1;
  }
  getInteractedSet() {
    return this.entryExitSet().entrySet.uids;
  }
}
class kl extends Qi {
  setSelectionSet(t, i) {
    const n = i.getEntrySet();
    if (t === null)
      i.reset();
    else if (t.length) {
      let A = Mn(n, [t]);
      i.remove(A), i.add(t), A = Mn(
        [i.getCompleteSet()],
        [i.getEntrySet(), i.getExitSet()]
      ), i.remove(A);
    } else {
      const A = Mn(
        [i.getCompleteSet()],
        [i.getExitSet()]
      );
      i.remove(A);
    }
  }
}
const il = "brush", UE = "highlight", TJ = "filter", Wf = "select", KM = "contextMenu";
let WM = class extends kl {
  constructor(...t) {
    super(...t), this.setApplyChecker({
      source: (i, n, A) => {
        const s = this._payload ? this._payload.criteria : null, o = this._payload ? this._payload.target : null, r = this._payload ? this._payload.metaData : null, a = this._payload && this._payload.metaData && A.metaData ? A.metaData.borderId === r.borderId : !0;
        return !(Ja(s, A.criteria) && Ja(o, A.target) && a);
      }
    });
  }
  static formalName() {
    return UE;
  }
  shouldResetOtherActionsOnTrigger() {
    return !1;
  }
};
function vJ(e, t) {
  return class extends t {
    static formalName() {
      return e;
    }
  };
}
const VM = vJ(il, kl);
class GJ extends kl {
  static formalName() {
    return TJ;
  }
  static mutates() {
    return !0;
  }
  isImplicit() {
    return !0;
  }
}
class Tl extends Qi {
  setSelectionSet(t, i) {
    return t === null ? i.reset() : t.length ? (this.context.getPropagationInf().sourceId && i.reset(), i.add(t)) : i.remove(i.getCompleteSet()), this;
  }
}
let LJ = class extends Tl {
  constructor(...t) {
    super(...t), this._applyChecker = {
      source: () => !0
    };
  }
  static formalName() {
    return Wf;
  }
  setSelectionSet(t, i) {
    const n = this._payload;
    if (W(n, "sourceInfo", "layerId") !== this.context.id() && t !== null && i.getEntrySetLength())
      return this.getTotalEntrySetLength() || (i.reset(), this.resetGlobalState()), this;
    if (t === null)
      i.reset(), this.resetGlobalState();
    else if (t.length) {
      const A = i.getEntrySet(), s = t.filter((r) => A.has(r));
      if (s.length)
        i.remove(s);
      else if (i.add(t), !i.getExitSetLength()) {
        const r = Mn(
          [i.getCompleteSet()],
          [i.getEntrySet(), i.getExitSet()]
        );
        i.remove(r);
      }
      this.updateGlobalState(), this.getTotalEntrySetLength() || (i.reset(), this.resetGlobalState());
    } else
      i.remove(i.getCompleteSet()), this.updateGlobalState(), this.getTotalEntrySetLength() || (i.reset(), this.resetGlobalState());
    return this;
  }
  resetGlobalState() {
    const t = this.context.store();
    t.commit("interactions.select.entrySet", null), t.commit("interactions.select.exitSet", null);
  }
  updateGlobalState() {
    const t = this.context.store(), i = this.getSelectionSet(), n = i.getEntrySetLength(), A = i.getExitSetLength(), s = this.context.getStateKey();
    t.commit("interactions.select.entrySet", (o) => ({ ...o, [s]: n })), t.commit("interactions.select.exitSet", (o) => ({ ...o, [s]: A }));
  }
  getTotalEntrySetLength() {
    const t = this.context.store().get("interactions.select.entrySet");
    return Object.values(t || {}).reduce((i, n) => i + n, 0);
  }
  getAddSetFromCriteria(t, i, n) {
    if (n.sourceInfo && n.sourceInfo.layerId && n.sourceInfo.layerId !== this.context.id()) {
      const A = this.entryExitSet();
      return A && A.entrySet.length ? {
        model: A.entrySet.model,
        uids: n.criteria === null ? null : [...A.entrySet.uids]
      } : {
        model: null,
        uids: n.criteria === null ? null : []
      };
    }
    return this.context.getAddSetFromCriteria(t, i, n);
  }
}, jM = class extends Tl {
  static formalName() {
    return "inverse-select";
  }
  setSelectionSet(t, i) {
    if (t === null)
      i.reset();
    else if (t.length) {
      const n = this.context.getPropagationInf(), A = i._exitSet, s = t.filter((o) => A.has(o));
      if (n.sourceId)
        i.reset(), i.add(t);
      else {
        if (s.length)
          i.add(s);
        else if (i.remove(t), !i.getEntrySetLength()) {
          const r = Mn(
            [i.getCompleteSet()],
            [i.getEntrySet(), i.getExitSet()]
          );
          i.add(r);
        }
        const o = i.getCompleteSetLength();
        (i.getExitSetLength() === o || i.getEntrySetLength() === o) && i.reset();
      }
    } else
      i.remove(i.getCompleteSet());
    return this;
  }
  getInteractedSet() {
    const t = this.entryExitSet().exitSet.uids;
    return t.size ? t : null;
  }
}, UJ = class extends kl {
  static formalName() {
    return KM;
  }
  static mutates() {
    return !1;
  }
  isImplicit() {
    return !0;
  }
};
const OE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BrushBehaviour: VM,
  ContextMenuBehaviour: UJ,
  FilterBehaviour: GJ,
  HighlightBehaviour: WM,
  InverseSelectBehaviour: jM,
  SelectBehaviour: LJ
}, Symbol.toStringTag, { value: "Module" })), qM = (e, t, i, n) => {
  let A = {}, s = {}, o;
  const r = Fr();
  let a;
  e.call(
    r().on("start", () => {
      const l = Bt();
      A = {
        x: l.x,
        y: l.y
      }, i.context.isCanvasDisposed() !== !0 && (o = i.context.getDrawingContext(), a = (/* @__PURE__ */ new Date()).getTime());
    }).on("drag", () => {
      const l = Bt();
      if (s = {
        x: l.x,
        y: l.y
      }, n && Math.abs(A.x - s.x) <= 5)
        return;
      s.x = Math.max(0, Math.min(s.x, o.width)), s.y = Math.max(0, Math.min(s.y, o.height));
      const c = Object.assign({}, A), g = Object.assign({}, s);
      if (A.x > s.x && (c.x = s.x, g.x = A.x), A.y > s.y) {
        const u = A.y;
        c.y = s.y, g.y = u;
      }
      if (i.context.isCanvasDisposed() === !0)
        return;
      const h = i.getPayloadFromEvent(
        "drag",
        {
          startPos: c,
          endPos: g
        },
        {
          event: l,
          isDragging: !0
        }
      );
      i.triggerPhysicalAction(t, h);
    }).on("end", () => {
      if (i.context.isCanvasDisposed() === !0)
        return;
      const l = Bt();
      s = {
        x: l.x,
        y: l.y
      };
      const c = (/* @__PURE__ */ new Date()).getTime() - a;
      if (n && c > 100 && Math.abs(A.x - s.x) <= 5)
        return;
      if (s.x = Math.max(0, Math.min(s.x, o.width)), s.y = Math.max(0, Math.min(s.y, o.height)), A.x > s.x) {
        const h = A.x;
        A.x = s.x, s.x = h;
      }
      if (A.y > s.y) {
        const h = A.y;
        A.y = s.y, s.y = h;
      }
      const g = i.getPayloadFromEvent(
        "drag",
        {
          startPos: A,
          endPos: s
        },
        {
          event: l,
          dragEnd: !0
        }
      );
      g.target && g.dragDiff === 0 || i.triggerPhysicalAction(t, g);
    })
  );
}, OJ = (e) => (t) => {
  qM(t, vE, e);
}, HJ = (e) => (t) => {
  const i = function(n) {
    const A = Bt(), s = e.context, o = Cs(s.getDrawingContext().svgContainer, A), r = e.getPayloadFromEvent(Vo, o, {
      data: n,
      event: A
    });
    e.triggerPhysicalAction(Vo, r);
  };
  t.on("mouseover", i).on("mousemove", i).on("mouseout", () => {
    e.triggerPhysicalAction(Vo, {
      criteria: null
    });
  });
}, zM = function(e, t, i, n) {
  const A = i.context, s = Cs(A.getDrawingContext().svgContainer, t.touches ? t.touches[0] : t);
  return i.getPayloadFromEvent(n, s, {
    data: e,
    event: t
  });
}, PJ = (e) => (t) => {
  let i, n;
  const A = function(s) {
    const o = zM(
      s,
      i,
      e,
      ba
    );
    e.triggerPhysicalAction(ba, o);
  };
  n = !1, i = Bt(), t.on("touchstart", (s) => {
    i = Bt(), n = !1, setTimeout(() => {
      n ? e.triggerPhysicalAction(ba, {
        criteria: null
      }) : A(s);
    }, 100);
  }).on("touchend", () => {
    n = !0;
  });
}, YJ = (e) => (t, i) => {
  qM(t, i, e, !0);
}, ZM = (e) => (t) => {
  let i, n;
  const A = e.context, s = (r) => {
    e.triggerPhysicalAction(_a, r);
  }, o = Fr();
  t.call(
    o().on("start", () => {
      const r = Bt();
      n = A.getDrawingContext(), i = r.subject;
    }).on("drag", () => {
      const r = Bt();
      i.x += r.dx, i.y += r.dy;
      const a = n.width, l = n.height, c = Math.min(a - i.width, Math.max(i.x, 0)), g = Math.min(l - i.height, Math.max(i.y, 0)), h = g + i.height, u = c + i.width;
      if (c >= 0 && u <= a && g >= 0 && h <= l) {
        const d = e.getPayloadFromEvent(
          _a,
          {
            startPos: {
              x: c,
              y: g
            },
            endPos: {
              x: u,
              y: h
            }
          },
          {
            event: r,
            isDragging: !0
          }
        );
        s(d);
      }
    }).on("end", () => {
      const r = n.width, a = n.height, l = Math.min(r - i.width, Math.max(i.x, 0)), c = Math.min(a - i.height, Math.max(i.y, 0)), g = c + i.height, h = l + i.width;
      if (l >= 0 && h <= r && c >= 0 && g <= a) {
        const u = e.getPayloadFromEvent(
          _a,
          {
            startPos: {
              x: l,
              y: c
            },
            endPos: {
              x: h,
              y: g
            }
          },
          {
            event,
            dragEnd: !0
          }
        );
        s(u);
      }
    })
  );
}, JJ = (e) => (t) => {
  const i = function(n) {
    const A = Bt();
    if (A.metaKey)
      return;
    A.preventDefault();
    const s = zM(
      n,
      A,
      e,
      el
    );
    s.uniquePropagationId = Ut(), e.triggerPhysicalAction(el, s);
  };
  t.on("click", i);
}, KJ = (e) => (t) => {
  t.on("contextmenu", function(i) {
    const n = e.context, s = n._canvasHelpers.getCanvasConfig()?.interaction?.contextMenu;
    if (!s || !s.enabled)
      return;
    const r = s.hook;
    if (!r)
      return;
    const a = Bt();
    a.preventDefault();
    const l = Cs(
      n.getDrawingContext().svgContainer,
      a
    ), c = e.getPayloadFromEvent(
      sh,
      l,
      {
        data: i,
        event: a
      }
    );
    e.triggerPhysicalAction(sh, c);
    const { targetData: g, metaInfo: h } = c, u = h?.colFacets || [], d = h?.rowFacets || [];
    r({ type: "geom", event: a, colFacets: u, rowFacets: d, targetPoint: g || null });
  });
}, $M = {
  [vE]: OJ,
  [Vo]: HJ,
  [el]: JJ,
  [ba]: PJ,
  [PM]: YJ,
  [_a]: ZM,
  [sh]: KJ
}, WJ = "tooltip", VJ = "crossline", jJ = "fragmented-tooltip", HE = "axis-label-highlighter", qJ = "show-context-menu", zJ = {
  valueParser: {
    defaultValue: (e) => e
  }
};
class Fu {
  constructor(t) {
    this.firebolt = t, this._strategy = "default", this._config = {}, this._id = Ut(), this._strategies = {}, this._enabled = !0, ge(this, zJ), this.config(this.constructor.defaultConfig()), this._applyChecker = {}, this.setApplyChecker({
      source: () => !0
    });
  }
  /**
   * Returns the default configuration of the side effect.
   *
   * @public
   * @return {Object} Default configuration of side effect.
   */
  static defaultConfig() {
    return {};
  }
  /**
   * Returns the formal name of a side effect. This method must be implemented by all side effects which changes
   * or adds any element in the visualization.
   *
   * @return {string} Formal name of side effect.
   */
  static formalName() {
    return "generic";
  }
  static target() {
    return "all";
  }
  /**
   * Returns true if the side effects mutates the data of chart.
   *
   * @public
   *
   * @return {boolean} If the side effect mutates the data of chart.
   */
  static mutates() {
    return !1;
  }
  /**
   * Sets or gets the configuration of side effect.
   *
   * When setter,
   * @param {Object} config Configuration of side effect.
   * @return {GenericSideEffect} Side effect instance.
   *
   * When getter,
   * @return {Object} Side effect configuration.
   */
  config(...t) {
    return t.length ? (this._config = tt(this._config, t[0]), this) : this._config;
  }
  /**
   * Applies the interaction effect on the chart. This is where the implemntation of the side effect is defined.
   *
   * @param {Object} selectionSet Contains the entry and exit set of data which got affected during interaction.
   * @param {Object} selectionSet.mergedEnter Combined previous entry and new entry set.
   * @param {DataModel} selectionSet.mergedEnter.model Instance of data model containing all rows which got
   * affected during interaction.
   * @param {Array} selectionSet.mergedEnter.uids Ids of all rows which were affected during interaction.
   * @param {Object} selectionSet.mergedExit Combined previous exit and new exit set.
   * @param {DataModel} selectionSet.mergedExit.model Instance of data model containing rows which were not affected
   * during interaction.
   * @param {Array} selectionSet.mergedExit.uids Ids of all rows which were not affected during interaction.
   * @param {Object} selectionSet.entrySet Entry set information.
   * @param {Array} selectionSet.entrySet[0].uids All row ids which got affected during previous interaction.
   * @param {Array} selectionSet.entrySet[1].uids All row ids which got affected during current interaction.
   * @param {Array} selectionSet.exitSet[0].uids All row ids which were not affected during previous interaction.
   * @param {Array} selectionSet.exitSet[1].uids All row ids which were not affected during current interaction.
   * @param {Object} payload Payload information of the behavioural action on trigger of which this side effect
   * is applied.
   * @param {Object} options Optional information for side effect like strategy, etc.
   */
  apply() {
    return this;
  }
  /**
   * Adds a new strategy method for this side effect. The strategy method is implemented by side effect class.
   *
   * @param {string} name Name of the strategy.
   * @param {Function} fn Strategy method.
   *
   * @return {GenericSideEffect} Instance of side effect.
   */
  setStrategy(t, i) {
    return i && (this._strategies[t] = i), this;
  }
  enable() {
    this._enabled = !0;
  }
  disable() {
    this._enabled = !1;
  }
  sourceInfo() {
    return this.firebolt.getSourceInfo();
  }
  layers() {
    return this.firebolt.layers();
  }
  plotPointsFromIdentifiers(...t) {
    return this.firebolt.getPlotPointsFromIdentifiers(...t);
  }
  shouldApply(t) {
    let i = !0;
    const n = this._applyChecker;
    for (const A in n) {
      const s = n[A];
      i = i && s(
        {
          ...t.sourceInfo,
          fields: t.fields
        },
        {
          canvasId: this.firebolt.sourceCanvas(),
          unitId: this.firebolt.id(),
          layerId: this.firebolt.id(),
          fields: this.firebolt.data() ? this.firebolt.data().getFieldNames() : null
        },
        t
      );
    }
    return i && this._enabled;
  }
  setApplyChecker(t) {
    return Object.assign(this._applyChecker, t), this;
  }
  removeApplyChecker(t) {
    delete this._applyChecker[t];
  }
  setLayerData(t, i) {
    const A = this.layers().find((s) => s.alias() === i);
    return t ? (A && A.enableCaching().data(t), this) : (this.resetLayerData(i), this);
  }
  resetLayerData(t) {
    const n = this.layers().find((A) => A.alias() === t);
    n && n.resetData();
  }
  setTransform() {
    return null;
  }
  shouldApplyOnRenderAfterScrolling() {
    return !0;
  }
  dispose() {
    return this;
  }
}
class $t extends Fu {
  /**
   * Applies or removes interaction styles from plot elements. An array of row ids needs to be passed
   * which identifies the plot elements and applies styles to them.
   *
   * To apply the interaction style,
   * ```
   *      const entryRowIds = entrySet[0].uids;
   *      const interactionStyle = [{
   *          type: 'fill',
   *          intensity: [0, 0, 15, 0] // hsla configuration
   *      }];
   *
   *      this.applyInteractionStyle(entryRowIds, interactionStyle, 'brighten', true);
   * ```
   * @public
   * @param {Array} set Array of row ids.
   * @param {Array} config Style configuration.
   * @param {Object} config[0] fill or stroke configuration.
   * @param {string} config[0].type Type of style - fill or stroke.
   * @param {Array} config[0].intensity hsla configuration.
   * @param {string} interactionType Type of interaction. This is needed for storing the styles for
   * each type of interaction in the plot elements.
   * @param {boolean} apply Whether to apply or remove the interaction style.
   *
   * @return {SurrogateSideEffect} Instance of surrogate side effect.
   */
  applyInteractionStyle(t, i = {}) {
    const n = this.firebolt.context;
    return n.config().interactive !== !1 && n.applyInteractionStyle(i, t.uids), this;
  }
}
class Tr extends Fu {
  /**
   * Creates a html or svg element in the container.
   *
   * @public
   * @param {SVGElement|HTMLElement} container Container where the dom element will be rendered.
   * @param {string} elemType Type of dom element.
   * @param {Array} data Array of objects with which the dom elements will be binded.
   * @param {string} className class name of the element.
   *
   * @return {Selection} D3 Selection of the element.
   */
  createElement(t, i, n, A, s) {
    return j(t, i, n, A, s);
  }
  /**
   * Returns the drawing information for side effect like svg container, dimensions of the visual unit.
   *
   * @public
   * @return {Object} Drawing information for side effect.
   * ```
   *      sideEffectGroup: // svg container where the side effect needs to be appended.
   *      svgContainer: // svg container of the {@link VisualUnit}.
   *      htmlContainer: // html div container of the {@link VisualUnit}.
   *      width: // Width of the {@link VisualUnit}
   *      height: // Height of the {@link VisualUnit}
   * ```
   */
  drawingContext() {
    return this.firebolt.getDrawingContext();
  }
  show() {
    return this;
  }
  hide() {
    return this;
  }
  static target() {
    return ["visual-group", "visual-unit"];
  }
}
const Zc = "muze", ZJ = "binned", $J = "arc";
const XJ = (e, t, i) => {
  let n, A, s, o;
  const r = e.criteria, a = e.dimensions || {}, { x: l, y: c } = a;
  if (!r)
    return null;
  if (t.x && t.y) {
    let g, h;
    const u = `${i.x[0]}`, d = `${i.y[0]}`, f = r.range, I = t.x[0], C = t.y[0], E = I.constructor.type() === "linear", B = C.constructor.type() === "linear", m = I.constructor.type() === "band", y = I.constructor.type() === "band", D = r.dimensions;
    if (D) {
      let Q = D[0].findIndex((p) => p === u);
      Q !== -1 && (g = D.slice(1, D.length).map((p) => p[Q])), Q = D[0].findIndex((p) => p === d), Q !== -1 && (h = D.slice(1, D.length).map((p) => p[Q]));
    } else
      g = f[u], h = f[d];
    if (g && g.length) {
      const Q = I.domain();
      let p = g[0], w = g[g.length - 1];
      if (m) {
        let x = Q.indexOf(g[0]), S = Q.indexOf(g[g.length - 1]);
        [x, S] = [x, S].sort((_, M) => _ - M), p = Q[x], w = Q[S];
      }
      n = I.getScaleValue(p), A = I.getScaleValue(w), A += m ? I.getUnitWidth() : 0;
    }
    if (h && h.length) {
      const Q = C.domain();
      let p = h[0], w = h[h.length - 1];
      if (y) {
        let x = Q.indexOf(h[0]), S = Q.indexOf(h[h.length - 1]);
        [x, S] = [x, S].sort((_, M) => M - _), p = Q[x], w = Q[S];
      }
      s = C.getScaleValue(p), o = C.getScaleValue(w), o += y ? C.getUnitWidth() : 0;
    }
    (B && E || !e.dragEnd) && (l && ([n, A] = l), c && ([s, o] = c));
  }
  return {
    dimension: {
      x1: n,
      x2: A,
      y1: s,
      y2: o
    }
  };
}, _p = (e, t, i) => {
  const n = e.config(), A = n.defClassName, s = n.classPrefix;
  V(t).selectAll(`.${s}-${A}`).style("display", i ? "block" : "none");
};
let t9 = class extends Tr {
  constructor(...t) {
    super(...t), this.setApplyChecker(() => !0);
  }
  /**
   * It returns the default configuration needed by selectionbox.
   * @return {Object} Default configuration of the selection box.
   */
  static defaultConfig() {
    return {
      defClassName: "selection-box-group",
      className: "",
      classPrefix: Zc,
      box: {
        defClassName: "selection-box",
        className: ""
      },
      transition: {
        duration: 200
      },
      brush: "xy",
      persistent: !1
    };
  }
  static formalName() {
    return "selectionBox";
  }
  static target() {
    return "visual-unit";
  }
  /**
   * Draws the selectionbox with the specified dimensions.
   * @param {Object} dimension Dimensions of the selection box.
   * @param {number} dimension.x1 Starting x position
   * @param {number} dimension.x2 Ending x position
   * @param {number} dimension.y1 Starting y position
   * @param {number} dimension.y2 Ending y position
   * @param {Object} conf Configuration needed to draw the selection box
   * @param {number} unitWidth Width of the visual unit.
   * @param {number} unitHeight Height of the visual unit.
   */
  apply(t, i) {
    let n = 0, A = 0, s, o;
    const r = this._config, a = r.box, l = this.firebolt, c = this.drawingContext(), g = c.sideEffectGroup, h = c.width, u = c.height, d = r.classPrefix, f = r.defClassName, I = r.brush, C = i.criteria;
    if (s = h, o = u, !W(C, "range") && !W(C, "dimensions") || i.hideSelBox && !r.persistent || i.dragEnd)
      return this.hide(c), this;
    const E = this.sourceInfo(), { dimension: B } = XJ(
      i,
      E.axes,
      E.fields
    ), m = i.dragEnd && r.transition;
    I === "xy" ? (n = Math.min(B.x1, B.x2), A = Math.min(B.y1, B.y2), s = Math.abs(B.x2 - B.x1), o = Math.abs(B.y2 - B.y1)) : I === "x" ? (n = Math.min(B.x1, B.x2), A = 0, s = Math.abs(B.x2 - B.x1), o = u) : (n = 0, A = Math.min(B.y1, B.y2), s = h, o = Math.abs(B.y2 - B.y1)), this.show(c);
    const y = [
      {
        x: n,
        y: A,
        width: s,
        height: o
      }
    ], D = j(
      V(g),
      "g",
      [1],
      `.${d}-${f}`
    ), Q = this, p = D.selectAll("rect").data(y), w = p.enter().append("rect").each(function() {
      l.registerPhysicalBehaviouralMap({
        [_a]: {
          target: [V(this)],
          behaviours: [il]
        }
      }), ZM(l)(V(this), ["brush"], Q);
    }).merge(p).each(function(S) {
      let _ = V(this);
      m && (_ = _.transition().duration(m.duration));
      for (const M in S)
        ({}).hasOwnProperty.call(S, M) && nx(S[M]) && _.attr(M, S[M]);
    }), x = _n(
      a.defClassName,
      this._id,
      d
    );
    return w.classed(x.join(" "), !0), w.classed(a.className, !0), this;
  }
  hide(t) {
    _p(this, t.sideEffectGroup, !1);
  }
  show(t) {
    _p(this, t.sideEffectGroup, !0);
  }
};
const e9 = "muze", i9 = "left", n9 = "right", A9 = "bottom", s9 = "top", o9 = "table", Vf = {
  classPrefix: e9,
  defClassName: "tooltip-box",
  parentClassName: "tooltip-parent-container",
  connectorClassName: "tooltip-connectors",
  pointerArrow: "tooltip-arrow-box",
  className: "",
  row: {
    margin: 0
  },
  spacing: 5,
  content: {
    spacing: 5,
    iconContainerSize: 10,
    iconScale: 1,
    iconShape: "circle",
    iconColor: "#ff0000",
    rowMargin: "4px 0 4px 0",
    rowPadding: "6px 0px",
    firstRowPadding: "0px 0px 6px 0px",
    firstRowMargin: "4px 0px 0px 0px",
    lastRowPadding: "6px 0px 6px 0px",
    lastRowMargin: "0px 0px 4px 0px",
    margin: 10,
    separator: ":",
    className: "tooltip-content-container",
    parentClassName: "tooltip-content-parent-container"
  },
  arrow: {
    size: 10,
    disabled: !1,
    defClassName: "tooltip-arrow",
    className: "",
    color: "rgba(195,195,195,0.85)"
  }
}, r9 = (e, t) => {
  e.selectAll(t).sort((i, n) => i - n);
}, a9 = (e = { entryExitSetsByLayerId: {} }) => (e.layers || []).map((t) => {
  const { entryExitSetsByLayerId: i } = e;
  if (i) {
    const n = i[t.id()], A = t.getAllEncodingFields();
    if (Object.keys(i).length && n)
      return n.entrySet.model.project(A);
  }
  return null;
}).filter((t) => !!t);
let l9 = class {
  /**
   * Creates an instance of content.
   */
  constructor() {
    this._model = null, this._secondaryModels = [], this._formatter = null, this._config = this.constructor.defaultConfig();
  }
  /**
   * Returns the default configuration of tooltip
   * @return {Object} Configuration of tooltip.
   */
  static defaultConfig() {
    const t = Vf.content;
    return t.classPrefix = Vf.classPrefix, t;
  }
  config(...t) {
    return t.length > 0 ? (this._config = tt(this._config, t[0]), this) : this._config;
  }
  /**
   * Update model. The format contains presentation strategy which determines how to show the content.
   * If no strategy is mentioned then default is to show key value pair
   */
  update(t) {
    return this._model = t.model, this._formatter = t.formatter, this._secondaryModels = t.secondaryModels, this;
  }
  context(t) {
    return this._context = t, this;
  }
  hide() {
    this._mount && this._mount.style("visiblity", "hidden");
  }
  render(t) {
    let i;
    const n = this._config, A = n.iconContainerSize, s = this._formatter, {
      rowMargin: o,
      rowPadding: r,
      firstRowPadding: a,
      firstRowMargin: l,
      lastRowPadding: c,
      lastRowMargin: g
    } = n, h = this._model, { classPrefix: u } = n;
    if (this._mount = t, h instanceof Array ? i = h : i = s(
      { dataModel: this._model, secondaryDatamodels: this._secondaryModels },
      { context: this._context, metaInfo: this.config() }
    ), i instanceof Function)
      j(
        t,
        "div",
        [1],
        `${u}-tooltip-html-container`
      ).html(i());
    else {
      let d = i, f = "default";
      we(i) && (d = i.content, f = i.displayFormat);
      const I = j(
        t,
        "div",
        [f],
        `${u}-tooltip-content`,
        {},
        (C) => C
      );
      if (f === o9) {
        const C = j(
          I,
          "table",
          [1],
          `${u}-tooltip-table`
        ), E = j(
          C,
          "tbody",
          [1],
          `${u}-tooltip-table-tbody`
        ), B = j(
          E,
          "tr",
          d,
          `${u}-tooltip-table-row`
        );
        B.each(function(y, D) {
          V(this).classed(
            `${u}-tooltip-table-row-${D}`,
            !0
          );
        }), j(
          B,
          "td",
          (y) => y,
          `${u}-tooltip-table-cell`
        ).each(function(y) {
          V(this).html(y);
        });
      } else {
        const C = j(I, "div", d, "", {
          update: (y, D) => y.attr("class", D.className)
        }), E = j(
          C,
          "span",
          (y) => y.data,
          `${u}-tooltip-content`
        );
        E.attr("class", `${u}-tooltip-content`);
        const B = C.size() - 1, m = { margin: o };
        if (!r)
          Pt(C, m);
        else {
          const y = {
            padding: a,
            margin: l
          }, D = {
            padding: c,
            margin: g
          }, Q = {
            padding: r
          };
          C.each(function(p, w) {
            p.className === `${u}-tooltip-stacked-row` ? Pt(this, m) : w === 0 ? Pt(
              this,
              w === B ? m : y
            ) : w === B ? Pt(this, D) : Pt(this, Q);
          });
        }
        Pt(E, {
          display: "inline-block"
          // 'margin-right': `${config.spacing}px`
        }), E.each(function(y) {
          const D = V(this);
          if (y instanceof Object)
            if (y.type === "icon") {
              const Q = j(D, "svg", [1]), p = j(Q, "path", [1]), w = y.shape instanceof Function ? y.shape : Bl(y.shape);
              wA(Q, {
                x: 0,
                y: 0,
                width: A,
                height: A
              }), wA(p, {
                d: w.size(y.size * y.size * Math.PI)(),
                transform: `translate(${A / 2}, ${A / 2})`
              }), Pt(p, {
                fill: y.color
              }), Pt(Q, {
                width: `${A}px`,
                height: `${A}px`
              });
            } else
              D.node().textContent = y.value, y.className && D.classed(y.className, !0), Pt(D, y.style);
          else
            D.node().textContent = y;
        });
      }
    }
    return this;
  }
  clear() {
    return this._model = null, this;
  }
  remove() {
    this._mount && this._mount.remove();
  }
}, vl = class {
  /**
   * Initializes the tooltip with the container element and configuration
   * @param {HTMLElement} container container where the tooltip will be mounted.
   * @param {string} className Class name for the tooltip.
   * @param {object}  options consist different configuration options for tooltip
   */
  constructor(t, { creatorName: i = "content-tooltip" } = {}, n = {}) {
    this._id = Ut(), this._config = {}, this.config({});
    const A = this._config, s = A.classPrefix, o = A.content.parentClassName, { showPointerArrow: r } = n, a = Array.isArray(i) ? i : [i], l = a.map(
      (d) => `${s}-${d}-container`
    ), c = a.map(
      (d) => `${s}-${d}-box`
    );
    this._tooltipContainer = j(
      t,
      "div",
      [1],
      `${s}-tooltip-container ${s}-group-container ${l.join(
        " "
      )}`
    ), this._tooltipContainerNode = this._tooltipContainer.node(), this._contentContainer = this._tooltipContainer.append("div").attr(
      "class",
      `${s}-${A.defClassName} ${s}-${o}
            ${A.className} ${c.join(" ")}`
    ), r && (this._tooltipArrowBox = this._tooltipContainer.append("div").attr("class", `${s}-${A.pointerArrow}`)), this._contentContainerNode = this._contentContainer.node(), this._contents = {};
    const g = this._id, h = A.parentClassName, u = _n(
      h,
      g,
      A.classPrefix
    );
    this.addClass(u.join(" ")), this.hide();
  }
  /**
   * Sets the configuration of tooltip.
   * @param {Object} config Configuration of tooltip
   * @return {Tooltip} Instance of tooltip
   */
  config(...t) {
    if (t.length > 0) {
      const i = tt({}, this.constructor.defaultConfig());
      return this._config = tt(i, t[0]), this;
    }
    return this._config;
  }
  /**
   * Returns the default configuration of tooltip
   * @return {Object} Configuration of tooltip.
   */
  static defaultConfig() {
    return Vf;
  }
  /**
   * Sets the class name of tooltip
   * @param {string} className tooltip class name
   * @return {Tooltip} Instance of tooltip.
   */
  addClass(t) {
    return this._tooltipContainer.classed(t, !0), this;
  }
  context(...t) {
    return t.length ? (this._context = t[0], this) : this._context;
  }
  content(t, i, n = {}) {
    const A = this.config(), { classPrefix: s } = A, o = A.content.className, r = `${s}-${o}-${t}`, a = n.className ? `${s}-${n.className}` : "", l = this._contents[t] = this._contents[t] || new l9(), c = j(
      this._contentContainer,
      "div",
      [n.order],
      r
    );
    c.attr(
      "class",
      `${s}-${o} ${r} ${a}`
    ), r9(
      this._contentContainer,
      `.${s}-${o}`
    );
    const g = A.content;
    n.classPrefix = this._config.classPrefix, l.config(g);
    const h = n.formatter || A.formatter, u = this.context(), d = a9({
      ...u
    });
    return i === null ? (l.clear(), l.remove(), delete this._contents[t]) : (l.update({
      model: i,
      formatter: h,
      secondaryModels: d
    }), l.context(this._context), l.render(c)), Object.keys(this._contents).length || this.hide(), this;
  }
  hideContent(t) {
    const i = this._contents[t];
    i && i.hide();
  }
  getContents() {
    return Object.values(this._contents);
  }
  /**
   * Positions the tooltip at the given x and y position.
   * @param {number} x x position
   * @param {number} y y position
   * @return {Tooltip} Instance of tooltip.
   */
  position(t, i) {
    if (!Object.keys(this._contents).length)
      return this.hide(), this;
    this.show();
    const n = this._offset || {
      x: 0,
      y: 0
    };
    return this._tooltipContainer.style(
      "transform",
      `translate(${n.x + t}px,${n.y + i}px`
    ), this;
  }
  /**
   * Positions the tooltip relative to a rectangular box. It takes care of tooltip overflowing the
   * boundaries.
   * @param {Object} dim Dimensions of the plot.
   */
  positionRelativeTo(t, i = {}) {
    let n;
    const A = i.orientation, s = i.priority;
    if (!t)
      return this.hide(), this;
    const o = this._extent, r = this._contentContainerNode, a = r.offsetWidth + 4, l = r.offsetHeight + 4, c = this._config, g = this._offset, h = c.spacing + (this._tooltipArrowBox ? 3 : 0), u = i.draw !== void 0 ? i.draw : !0, d = t.y, f = t.x + t.width + g.x, I = o.width - f, C = t.x + g.x - o.x, E = o.height - (t.y + t.height + g.y), B = h, m = l + B, y = a + B, { classPrefix: D } = this.config(), Q = [
      {
        position: "top",
        value: d - m
      },
      {
        position: "right",
        value: I - y
      },
      {
        position: "left",
        value: C - y
      },
      {
        position: "bottom",
        value: E - m
      }
    ], p = (M) => {
      let k, T = t.x + t.width, G = t.y;
      return M === "right" ? (k = i9, T += B) : M === "left" && (T = t.x - a, k = n9, T -= B), t.height < l && (G = Math.max(0, t.y + t.height / 2 - l / 2)), {
        position: k,
        x: T,
        y: G
      };
    }, w = (M) => {
      let k, T, G = t.x - a / 2 + t.width / 2;
      return o.width - (t.x + g.x) < a ? G = o.width - a - g.x : G + g.x < o.x && (G = o.x), M === "top" ? (T = t.y - l - B, k = A9, this._tooltipArrowBox?.classed(`${D}-tooltip-arrow-top`, !0).classed(`${D}-tooltip-arrow-bottom`, !1)) : (T = t.y + t.height + B + (this._tooltipArrowBox ? 3 : 0), k = s9, this._tooltipArrowBox?.classed(`${D}-tooltip-arrow-top`, !1).classed(`${D}-tooltip-arrow-bottom`, !0)), {
        position: k,
        x: G,
        y: T
      };
    }, x = (M, k) => {
      const T = M[0].value > M[1].value ? M[0] : M[1], G = M.filter((N) => N.position === k)[0];
      return G && G.value > 0 ? G : T;
    };
    this._target = t;
    const S = x(
      Q.filter((M) => M.position === "left" || M.position === "right"),
      s
    ), _ = x(
      Q.filter((M) => M.position === "top" || M.position === "bottom"),
      s
    );
    if (A)
      if (A === "horizontal") {
        const M = S.position;
        n = p(M);
      } else {
        const M = _.position;
        n = w(M);
      }
    else if (S.value > 0) {
      const M = S.position;
      n = p(M);
    } else {
      const M = _.position;
      n = w(M);
    }
    return this._position = {
      x: n.x,
      y: n.y
    }, this._tooltipArrowBox?.style(
      "left",
      `${t.x + t.width / 2 - this._position.x}px`
    ), this._orientation = n.position, u && this.position(n.x, n.y), this;
  }
  /**
   * Hides the tooltip element.
   * @return {Tooltip} Instance of tooltip.
   */
  hide() {
    return this._tooltipContainer.style("visibility", "hidden"), this;
  }
  /**
   * Shows the tooltip element.
   * @return {Tooltip} Instance of tooltip.
   */
  show() {
    return this._tooltipContainer.style("visibility", "visible"), this;
  }
  extent(t) {
    return this._extent = t, this;
  }
  offset(t) {
    return this._offset = t, this;
  }
  remove() {
    return this._tooltipContainer.remove(), this;
  }
  dispose() {
    return this.remove(), this;
  }
};
const XM = "muze", c9 = "left", g9 = "right", h9 = "bottom", u9 = "top", bp = "invoke-menu-item-callback", t_ = {
  classPrefix: XM,
  padding: 5,
  iconSize: 10
}, d9 = {
  classPrefix: XM,
  contextName: null,
  containerClassName: null,
  spacing: 5,
  arrow: {
    size: 10,
    disabled: !1,
    defClassName: "dropdown-arrow",
    className: "",
    color: "rgba(195,195,195,0.85)"
  },
  content: t_
};
class f9 {
  /**
   * Initializes the Content.
   *
   * @param {Object} data - The data to render.
   * @param {Array<Object>} data.menuItems - The menu items to render.
   * @param {string} data.activeMenuItem - The key of the active menu item.
   * @param {string} data.disabledMenuItems - List of keys which are disabled.
   * @param {Object} config - The config.
   */
  constructor(t, i) {
    this._menuItems = t.menuItems || [], this._activeMenuItem = t.activeMenuItem || null, this._disabledMenuItems = t.disabledMenuItems || [], this.config(i);
  }
  static defaultConfig() {
    return t_;
  }
  config(...t) {
    return t.length > 0 ? (this._config = tt(
      {},
      this.constructor.defaultConfig(),
      this._config,
      t[0]
    ), this) : this._config;
  }
  /**
   * It updates the content data.
   *
   * @param {Object} data - The content.
   * @param {Array<Object>} data.menuItems - The list of menu items. Here each menu item contains these props:
   *  1. key: The key identifier
   *  2. label: The text label
   *  3. icon: The icon
   *  4. onClick: The onClick listener
   * @param {string} data.activeMenuItem - The key for the active menu item.
   * @param {string} data.disabledMenuItems - List of keys which are disabled.
   */
  updateData(t) {
    "menuItems" in t && (this._menuItems = t.menuItems || []), "activeMenuItem" in t && (this._activeMenuItem = t.activeMenuItem || null), "disabledMenuItems" in t && (this._disabledMenuItems = t.disabledMenuItems || []);
  }
  render(t) {
    const i = this._menuItems, n = this._activeMenuItem, A = this._disabledMenuItems, { classPrefix: s } = this.config(), o = `${s}-dropdown-content`, r = j(
      t,
      "div",
      [1],
      `${o}-wrapper`
    ), a = i.map((g) => ({
      ...g,
      isActive: g.key === n,
      isDisabled: A.includes(g.key)
    })), l = j(
      r,
      "div",
      a,
      `${o}-menu-item`,
      {},
      (g) => g.key
    );
    l.each(function(g) {
      const h = V(this);
      h.classed("active", g.isActive), h.classed("disabled", g.isDisabled);
    }), j(
      l,
      "div",
      (g) => [
        {
          type: "icon",
          key: `${g.key}-icon`,
          data: g.isActive ? M3 : g.icon
        },
        { type: "label", key: `${g.key}-label`, data: g.label }
      ],
      `${o}-menu-item-cell`,
      {
        enter: c,
        update: c
      },
      (g) => g.key
    );
    function c(g, h) {
      const { type: u, data: d } = h;
      u === "icon" ? (g.classed(`${o}-menu-item-icon-holder`, !0), j(
        g,
        "img",
        d ? [d] : [],
        `${o}-menu-item-icon`
      ).attr("src", (f) => f).style("width", "6px")) : u === "label" && (g.classed(`${o}-menu-item-label-holder`, !0), j(
        g,
        "span",
        [d],
        `${o}-menu-item-label`
      ).text((f) => f));
    }
  }
}
const I9 = (e) => (t) => {
  t.selectAll(".muze-dropdown-box .muze-dropdown-content-menu-item").on("click", C9.bind(void 0, e));
}, C9 = (e) => {
  const t = Bt(), n = V(t.currentTarget).datum(), A = e.context.metaInfo();
  e.triggerPhysicalAction("menuItemClick", {
    data: n,
    metaInfo: A
  });
};
class E9 {
  /**
   * Initializes the Dropdown with the container element and configurations.
   *
   * @param {HTMLElement} htmlContainer - The container where the Dropdown will be mounted.
   * @param {string} config - The config.
   * @param {string} config.contextName - The context name where this Dropdown is being created.
   * @param {Object} content - The context name where this Dropdown is being created.
   */
  constructor(t, i, n) {
    this._id = Ut(), this.config(i), this._content = new f9(n, this._config.content), this._firebolt = new to(
      this,
      {
        behavioural: {
          menuItemSelect: G9
        },
        physical: {
          menuItemClick: I9
        },
        physicalBehaviouralMap: {
          menuItemClick: {
            behaviours: ["menuItemSelect"]
          }
        }
      },
      {
        [bp]: L9
      },
      {}
    ), this.mount(t), this.mapSideEffects();
  }
  mount(...t) {
    return t.length > 0 ? (this._mount = t[0], this.init(), this.render(), this) : this._mount;
  }
  init() {
    const t = this.mount(), { classPrefix: i, contextName: n, containerClassName: A } = this.config();
    let s = `${i}-dropdown-container ${i}-dropdown-container-${this._id} ${i}-group-container`;
    n && (s += ` ${i}-${n}-container`), A && (s += ` ${i}-${A}`), this._dropdownContainer = j(
      t,
      "div",
      [1],
      s
    ), this._dropdownBox = this._dropdownContainer.append("div").attr("class", `${i}-dropdown-box`), this._dropdownContentContainer = this._dropdownBox.append("div").attr("class", `${i}-dropdown-content-container`), this.hide();
  }
  static defaultConfig() {
    return d9;
  }
  content(...t) {
    return t.length > 0 ? (this._content.updateData(t[0]), this.render(), this) : this._content;
  }
  render() {
    this._content.render(this._dropdownContentContainer), this.mapActionsAndBehaviour();
  }
  config(...t) {
    return t.length > 0 ? (this._config = tt(
      {},
      this.constructor.defaultConfig(),
      this._config,
      t[0]
    ), this._content && this._content.config(this._config.content), this) : this._config;
  }
  addClass(t) {
    return this._dropdownContainer.classed(t, !0), this;
  }
  position(t, i) {
    this.show();
    const n = this._offset || {
      x: 0,
      y: 0
    };
    return this._dropdownContainer.style(
      "transform",
      `translate(${n.x + t}px,${n.y + i}px`
    ), this;
  }
  /**
   * Positions the Dropdown relative to a rectangular box. It takes care of Dropdown overflowing the
   * boundaries.
   * @param {Object} dim - Dimensions of the relative box.
   */
  positionRelativeTo(t, i) {
    i = i || {};
    const { orientation: n, draw: A } = i || {};
    let s;
    if (!t)
      return this.hide(), this;
    const o = this._extent, r = this._dropdownBox.node(), a = r.offsetWidth + 4, l = r.offsetHeight + 4, c = this._config, g = this._offset, h = c.spacing, u = A !== void 0 ? A : !0, d = t.y, f = t.x + t.width + g.x, I = o.width - f, C = t.x + g.x - o.x, E = o.height - (t.y + t.height + g.y), B = h, m = l + B, y = a + B, D = [
      {
        position: "top",
        value: d - m
      },
      {
        position: "right",
        value: I - y
      },
      {
        position: "left",
        value: C - y
      },
      {
        position: "bottom",
        value: E - m
      }
    ], Q = (S) => {
      let _, M = t.x + t.width, k = t.y;
      return S === "right" ? (_ = c9, M += B) : S === "left" && (M = t.x - a, _ = g9, M -= B), t.height < l && (k = Math.max(0, t.y + t.height / 2 - l / 2)), {
        position: _,
        x: M,
        y: k
      };
    }, p = (S) => {
      let _, M, k = t.x - a / 2 + t.width / 2;
      return o.width - (t.x + g.x) < a ? k = o.width - a - g.x : k + g.x < o.x && (k = o.x), S === "top" ? (M = t.y - l - B, _ = h9) : (M = t.y + t.height + B, _ = u9), {
        position: _,
        x: k,
        y: M
      };
    };
    this._target = t;
    const w = pf(
      D.filter((S) => S.position === "left" || S.position === "right"),
      "value"
    ), x = pf(
      D.filter((S) => S.position === "top" || S.position === "bottom"),
      "value"
    );
    if (n)
      if (n === "horizontal") {
        const S = w.position;
        s = Q(S);
      } else {
        const S = x.position;
        s = p(S);
      }
    else if (w.value > 0) {
      const S = w.position;
      s = Q(S);
    } else {
      const S = x.position;
      s = p(S);
    }
    return this._position = {
      x: s.x,
      y: s.y
    }, this._orientation = s.position, u && this.position(s.x, s.y), this;
  }
  extent(t) {
    return this._extent = t, this;
  }
  offset(t) {
    return this._offset = t, this;
  }
  hide() {
    return this._dropdownContainer.style("visibility", "hidden"), this;
  }
  show() {
    return this._dropdownContainer.style("visibility", "visible"), this;
  }
  isVisible() {
    return this._dropdownContainer.style("visibility") === "visible";
  }
  getDefaultTargetContainer() {
    const { classPrefix: t } = this.config();
    return `.${t}-dropdown-container-${this._id}`;
  }
  mapActionsAndBehaviour() {
    const t = this._firebolt._actionBehaviourMap, i = {};
    for (let n in t) {
      const A = t[n].behaviours, s = this._firebolt._actions.behavioural;
      A.some(
        (r) => s[r]._enabled
      ) && (i[n] = {
        ...t[n],
        behaviours: []
      });
    }
    this._firebolt.mapActionsAndBehaviour(null, i);
  }
  sourceCanvas() {
    return "canvas0";
  }
  id() {
    return this._id;
  }
  data() {
    return null;
  }
  mapSideEffects() {
    const t = {
      menuItemSelect: [
        {
          name: bp
        }
      ]
    };
    this._firebolt.mapSideEffects(t, !1);
  }
  metaInfo(...t) {
    return t.length > 0 ? (this._metaInfo = t[0], this) : this._metaInfo;
  }
  dispose() {
    this._dropdownContainer && this._dropdownContainer.remove();
  }
}
const B9 = "selectionSummary", PE = "highlightSummary", m9 = "10px", e_ = "stack", Ru = 10, YE = (e) => J.isInvalid(e) ? `${e}` : `${e % e.toFixed(0) === 0 ? e : e.toFixed(2)}`, Np = (e, t, i, n = {}, A) => {
  const { TEMPORAL: s, CONTINUOUS: o, CATEGORICAL: r } = J.FieldSubtype;
  return {
    [s]: (a) => {
      const l = qn(a);
      return typeof l == "string" ? l : J.isInvalid(a) ? i(a) : Vs(Number(a), t, { useUTC: n.useUTC });
    },
    [o]: (a) => {
      const l = qn(a);
      return typeof l == "string" ? l : J.isInvalid(a) ? i(a) : e(YE(a));
    },
    [r]: (a) => i(a),
    [ZJ]: (a) => {
      const l = qn(a);
      return typeof l == "string" ? l : J.isInvalid(a) ? i(a) : _r([l, l + A.getBinSize()]);
    }
  };
}, i_ = (e) => {
  const { field: t, value: i, classPrefix: n } = e;
  return {
    className: `${n}-tooltip-stacked-row`,
    data: [
      {
        value: t,
        className: `${n}-tooltip-stacked-row-key`
      },
      {
        value: `${i}`,
        className: `${n}-tooltip-stacked-row-value`
      }
    ]
  };
}, sn = (e) => {
  const {
    field: t,
    value: i,
    classPrefix: n,
    margin: A,
    isSelected: s,
    showFieldName: o = !0,
    stackPercent: r,
    showStackPercentage: a
  } = e;
  if (o) {
    const l = {
      value: t,
      className: `${n}-tooltip-key`
    }, c = {
      value: i,
      className: `${n}-tooltip-value`
    }, g = {
      value: r,
      className: `${n}-tooltip-stacked-percentage`
    };
    return A !== void 0 && (l.style = {
      "margin-left": `${A}px`
    }, c.style = {
      "margin-left": `${A}px`
    }, g.style = {
      "margin-left": `${A}px`
    }), {
      className: s ? `${n}-tooltip-row ${n}-tooltip-selected-row` : `${n}-tooltip-row`,
      data: a ? [l, g, c] : [l, c]
    };
  }
  return {
    data: [
      {
        className: "",
        value: i,
        style: {
          "margin-left": m9
        }
      }
    ],
    className: `${n}-tooltip-first`
  };
}, jo = (e, t, i = (n) => n) => {
  const n = t.getRowsCount();
  let A = 0;
  for (let s = 0; s < n; s++) {
    const o = t.getValueAtIndex(e, s);
    A += typeof o == "number" && i(o) ? o : 0;
  }
  return A;
}, n_ = (e) => {
  const {
    dataModel: t,
    config: i,
    fieldInf: n,
    isStacked: A,
    target: s,
    positiveStackSum: o,
    negStackSum: r,
    showStackPercentage: a,
    retinalAndDetailFieldsObj: l,
    data: c,
    axes: g,
    valueField: h,
    encoding: u
  } = e, { classPrefix: d, separator: f } = i, I = g.color, C = g.shape, E = g.size, B = Object.keys(c)[0], m = t.getRowsCount(), y = 1, D = 0, Q = W(l, "shape", 0), p = W(l, "color", 0), w = W(l, "size", 0), x = W(l, "text", 0), S = W(l, "detail") || [], _ = c[p], M = c[Q];
  let k = Ru, T;
  if (u.color.splitBy) {
    const Y = c[u.color.splitBy];
    T = I[Y];
  } else
    T = I;
  let G = {
    type: "icon",
    color: T.getColor(_),
    size: E.config().value,
    shape: C.getShape(M)
  };
  const N = [
    ...new Set(
      [p, Q, w, ...S, x].filter(
        (Y) => Y
      )
    )
  ], [b, F] = ax(
    N,
    (Y) => Y && t.getField(Y).type() === "dimension"
  ), R = (Y, q, $) => {
    Y.forEach((P) => {
      if (q.includes(P)) {
        const st = sn({
          field: `${P}${f}`,
          value: `${c[P]}`,
          classPrefix: d,
          isSelected: H
        });
        st.data = [G, ...st.data], $.push(st);
      } else {
        const st = sn({
          field: `${P}${f}`,
          value: `${c[P]}`,
          classPrefix: d,
          isSelected: H,
          margin: k
        });
        $.push(st);
      }
    });
  };
  let v, O, L = [], U, H;
  const { fn: z } = n[h], et = c[h], Z = z(et);
  if (b.length === 0)
    if (F.length === 0) {
      v = B, U = s && s[y][s[D].indexOf(v)], H = U === c[v];
      const Y = sn({
        field: `${v}${f}`,
        value: Z,
        classPrefix: d,
        isSelected: H,
        margin: k
      });
      return Y.data = [...Y.data], L.push(Y), L;
    } else
      return v = h, U = s && s[y][s[D].indexOf(v)], H = m === 1 ? !1 : U === c[v], O = sn({
        field: `${v}${f}`,
        value: Z,
        classPrefix: d,
        isSelected: H,
        margin: k
      }), L.push(O), R(F, p, L), L;
  else if (v = b.reduce((Y, q) => {
    if (q in c) {
      const $ = c[q], { fn: P } = n[q];
      Y.push(P ? P($) : $);
    }
    return Y;
  }, []).join(", "), U = b.reduce((Y, q) => {
    const $ = s && s[y][s[D].indexOf(q)];
    let P;
    if (q in c) {
      const { fn: nt } = n[q];
      P = nt;
    }
    const st = P && P.name === "temporal" ? P($) : $;
    return $ && Y.push(J.getActualValue(st)), Y;
  }, []).join(", "), H = m === 1 ? !1 : U === v, A) {
    const q = `(${(et >= 0 ? et * 100 / o : et * 100 / r).toFixed(2)} %)`;
    return O = sn({
      field: `${v}${f}`,
      value: Z,
      classPrefix: d,
      isSelected: H,
      stackPercent: q,
      showStackPercentage: a
    }), O.data = [G, ...O.data], L.push(O), k += 15, F.forEach(($) => {
      const P = sn({
        field: `${$}${f}`,
        value: `${c[$]}`,
        classPrefix: d,
        isSelected: H,
        margin: k
      });
      L.push(P);
    }), L;
  } else
    return O = sn({
      field: `${v}${f}`,
      value: Z,
      classPrefix: d,
      isSelected: H,
      margin: k
    }), b.includes(p) && (O = sn({
      field: `${v}${f}`,
      value: Z,
      classPrefix: d,
      isSelected: H
    }), O.data = [G, ...O.data]), L.push(O), R(F, p, L), L;
}, Q9 = (e) => e === it.TEMPORAL || e === it.BINNED || e === it.CONTINUOUS, JE = (e, t, i) => {
  const n = i.targetLayer._dependencies.canvasActions.getRootData(), { CATEGORICAL: A, TEMPORAL: s } = J.FieldSubtype, { valueParser: o, timeDiffs: r, useUTC: a } = i, l = Np(null, null, o)[A];
  return e.reduce((c, g) => {
    let { subtype: h, name: u } = g, d = h === s ? r[u] : 0;
    const I = n.getField(u).subtype();
    let C;
    I !== h && h === it.CATEGORICAL && Q9(I) ? (C = n.getField(u), h = I, d = h === s ? r[u] : 0) : C = t.getField(u);
    const E = C.schema().format;
    return c[u] = {
      fn: ft(
        Np(E, d, o, { useUTC: a }, C)[h],
        l
      ),
      displayName: `${pl(t, u)}`
    }, c;
  }, {});
}, Fp = (e) => e.as === "continuous", Rp = (e) => e.as === "discrete", oh = (e, t) => e.find((i) => i.name === t), A_ = (e, t, i) => {
  const { x: n, y: A } = e;
  let s = t[0].name;
  const o = oh(t, n.field), r = oh(t, A.field);
  return o && !i.isTemporal(o.name) && Fp(n) ? s = n.field : r && !i.isTemporal(r.name) && Fp(A) && (s = A.field), s;
}, KE = (e, t, i) => {
  const { x: n, y: A } = e;
  let s = null;
  const o = oh(t, n.field), r = oh(t, A.field);
  return o && (i.isTemporal(o.name) || Rp(n) && o.type === "dimension") ? s = n.field : r && (i.isTemporal(r.name) || Rp(A) && r.type === "dimension") && (s = A.field), s;
}, s_ = (e) => {
  const t = {};
  return [
    "color",
    "shape",
    "size",
    "detail",
    "text"
  ].forEach((n) => {
    const A = W(e[n], "field");
    if (A) {
      const s = Fi(A);
      t[n] = s;
    }
  }), t;
}, o_ = (e, t, i = {}) => {
  const n = e.getRowsCount(), A = [];
  for (let s = 0; s < n; s++) {
    const o = {};
    t.forEach((r) => {
      o[r] = e.getValueAtIndex(r, s);
    }), A.push(o);
  }
  if (i.sortedValues) {
    const s = i.sortedValues.reduce(
      (o, r, a) => (o[r] = a, o),
      {}
    );
    A.sort(
      (o, r) => s[o[i.sortField]] - s[r[i.sortField]]
    );
  }
  return A;
}, p9 = (e, t = {}, i) => {
  const n = e.getSchema({
    excludeFields: [St.ROW_ID, bt]
  });
  if (n.length === 0)
    return {
      content: [],
      displayFormat: "normal"
    };
  const A = i.targetLayer, { classPrefix: s, separator: o } = t, r = A.config().encoding, a = A.axes(), c = A.transformType() === e_, { showStackSum: g = !0 } = i.config || {}, h = A.config().mark === Du && c, u = A_(r, n, e, i.config), d = e.getRowsCount(), f = Array.from(Object.keys(i.payload.metaData.rowFacets)) || [], I = Array.from(Object.keys(i.payload.metaData.colFacets)) || [], C = s_(r), E = Object.values(
    C
  ).flat(), B = [
    ...I,
    ...f,
    a.x.config().field,
    a.y.config().field,
    ...E
  ];
  let m = KE(r, n, e, i.config);
  const y = JE(n, e, i), D = (M, k, T) => {
    const { displayName: G, fn: N } = y[M];
    return sn({
      field: `${G}${o}`,
      value: N(k),
      classPrefix: s,
      margin: Ru,
      showFieldName: T
    });
  }, Q = () => {
    const M = [];
    let k, T;
    return n.forEach(({ name: G }) => {
      k = B.indexOf(G);
      const N = D(
        G,
        e.getValueAtIndex(G, 0)
      );
      m ? m && (f.length !== 0 || I.length !== 0) ? M.splice(k, 0, N) : G === m ? M.unshift(N) : M.length === 2 && k < T ? M.splice(1, 0, N) : M.push(N) : M.push(N), T = k;
    }), M;
  };
  let p, w = !1;
  for (let M of E)
    (M === r.x.field || M === r.y.field) && (w = !0);
  let x = i.layers.find((M) => M.id() === i.payload.layerId) ?? i.layers?.[0];
  const S = W(C, "color", 0);
  if (d === 1 && (c ? c && S === void 0 : E.length === 0 || w || x.constructor.formalName() === $J || r.text.field))
    p = Q();
  else {
    p = [];
    const M = [];
    [
      ...n.filter(
        (R) => !E.includes(R.name) && R.name !== u && R.name !== m
      ).map((R) => R.name),
      m
    ].filter((R) => R).forEach((R) => {
      p.push(
        D(R, e.getValueAtIndex(R, 0), !0)
      );
    });
    let T = 0, G = 0, N = 0;
    if (c && g) {
      T = jo(u, e), G = jo(u, e, (v) => v >= 0), N = jo(u, e, (v) => v < 0);
      const R = y[u].fn;
      p.push(
        i_({
          field: `Total${o}`,
          value: R(T),
          classPrefix: s
        })
      );
    }
    const b = r.color.splitBy;
    o_(
      e,
      [...E, u, b].filter((R) => R),
      {
        sortedValues: A._transformedData.getSortedGroupByValues(),
        sortField: A._transformedData.getSortField()
      }
    ).forEach((R) => {
      const v = n_({
        retinalAndDetailFieldsObj: C,
        valueField: u,
        axes: a,
        isStacked: c,
        data: R,
        dataModel: e,
        config: t,
        target: i.payload.target,
        stackedSum: T,
        positiveStackSum: G,
        negStackSum: N,
        fieldInf: y,
        showStackPercentage: h,
        encoding: r
      });
      M.push(...v);
    }), p.push(...M);
  }
  return {
    content: p,
    displayFormat: "normal"
  };
}, y9 = (e, t = {}, i) => {
  let n = [], A = null;
  const s = i.layers;
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    if (r._disposed)
      return {
        content: [],
        displayFormat: "normal"
      };
    const a = r.getSchema({
      excludeFields: [St.ROW_ID, bt]
    });
    if (a.length === 0 || o > s.length)
      return {
        content: [],
        displayFormat: "normal"
      };
    const l = s[o], { classPrefix: c, separator: g } = t, h = l.config().encoding, u = l.axes(), f = l.transformType() === e_, { showStackSum: I = !0 } = i.config || {}, C = l.config().mark === Du && f, E = A_(
      h,
      a,
      r,
      i.config
    ), B = JE(a, r, i), m = (S, _, M) => {
      const { displayName: k, fn: T } = B[S];
      return sn({
        field: `${k}${g}`,
        value: T(_),
        classPrefix: c,
        margin: Ru,
        showFieldName: M
      });
    }, y = KE(
      h,
      a,
      r,
      i.config
    ), D = r.getRowsCount();
    if (!A) {
      const S = r.getValueAtIndex(y, 0);
      S && (A = m(y, S, !0));
    }
    const Q = s_(h), p = Object.values(
      Q
    ).flat(), w = [], x = () => {
      const S = [];
      return a.filter(({ name: _ }) => !y || _ !== y).forEach(({ name: _ }) => {
        const {
          encoding: {
            color: { value: M }
          }
        } = l.config();
        let k;
        if (typeof M == "function") {
          const G = u.size;
          k = {
            type: "icon",
            color: M,
            size: G.config().value,
            shape: "circle"
          };
        }
        const T = m(
          _,
          r.getValueAtIndex(_, 0)
        );
        S.push({
          ...T,
          data: k ? [
            k,
            ...T.data.map((G) => ({
              ...G,
              style: { ...G.style, "margin-left": "0px" }
            }))
          ] : T.data
        });
      }), S;
    };
    if (D === 1)
      n.push(...x());
    else {
      let S = 0, _ = 0, M = 0;
      if (I) {
        S = jo(E, r), _ = jo(E, r, (N) => N >= 0), M = jo(E, r, (N) => N < 0);
        const G = B[E].fn;
        n.push(
          i_({
            field: `Total (${E})${g}`,
            value: G(S),
            classPrefix: c
          })
        );
      }
      const k = h.color.splitBy;
      o_(
        r,
        [...p, E, k].filter(
          (G) => G
        ),
        {
          sortedValues: l._transformedData.getSortedGroupByValues(),
          sortField: l._transformedData.getSortField()
        }
      ).forEach((G) => {
        const N = n_({
          retinalAndDetailFieldsObj: Q,
          valueField: E,
          axes: u,
          isStacked: f,
          data: G,
          dataModel: r,
          config: t,
          target: i.payload.target,
          stackedSum: S,
          positiveStackSum: _,
          negStackSum: M,
          fieldInf: B,
          showStackPercentage: C,
          encoding: h
        });
        w.push(...N);
      }), n.push(...w);
    }
  }
  return {
    content: [A, ...n].filter((o) => !!o),
    displayFormat: "normal"
  };
}, D9 = (e, t = {}, i) => {
  let n = [], A = null;
  const s = i.layers;
  if (t.isCompositeTooltip)
    return y9(e, t, i);
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    if (r._disposed)
      return {
        content: [],
        displayFormat: "normal"
      };
    const a = r.getSchema({
      excludeFields: [St.ROW_ID, bt]
    });
    if (a.length === 0 || o > s.length)
      return {
        content: [],
        displayFormat: "normal"
      };
    const { classPrefix: l, separator: c } = t, g = JE(a, r, i), h = (I, C, E) => {
      const { displayName: B, fn: m } = g[I];
      return sn({
        field: `${B}${c}`,
        value: m(C),
        classPrefix: l,
        margin: Ru,
        showFieldName: E
      });
    }, u = i.targetLayer.config().encoding, d = KE(
      u,
      a,
      r,
      i.config
    );
    if (!A) {
      const I = r.getValueAtIndex(d, 0);
      I && (A = h(d, I, !0));
    }
    const f = () => {
      const I = [];
      return a.filter(({ name: C }) => !d || C !== d).forEach(({ name: C }) => {
        I.push(
          h(C, r.getValueAtIndex(C, 0))
        );
      }), I;
    };
    n.push(...f());
  }
  return {
    content: [A, ...n].filter((o) => !!o),
    displayFormat: "normal"
  };
}, w9 = (e, t, { showMultipleMeasures: i, fields: n }) => {
  const A = e.getMeasures(), s = i ? A : n || A.slice(0, 1), o = {};
  if (s.length) {
    const r = e.groupBy([]);
    r.isEmpty() || s.forEach((a) => {
      const l = r.getValueAtIndex(a, 0);
      o[a] = YE(l);
    }), r.dispose();
  }
  return o;
}, kp = (e, t) => {
  const { TEMPORAL: i, CONTINUOUS: n, CATEGORICAL: A, BINNED: s } = J.FieldSubtype, o = e.targetLayer, r = Object.keys(o.metaInf().facets || {}), { encoding: a } = o.config(), l = Object.values(yt).map((u) => W(a, u, "field")).filter((u) => !!u).flat(), c = t.getSchema().reduce((u, d) => (u.set(d.name, d.subtype), u), /* @__PURE__ */ new Map()), g = [r, l].reduce(
    (u, d) => (d.forEach(
      (f) => c.get(f) === A && u.add(f)
    ), d.forEach(
      (f) => c.get(f) === i && u.add(f)
    ), d.forEach(
      (f) => c.get(f) === n && u.add(f)
    ), d.forEach(
      (f) => c.get(f) === s && u.add(f)
    ), u),
    /* @__PURE__ */ new Set()
  ), h = a.color.splitBy;
  return [...g, h].filter((u) => u);
}, x9 = {
  [B9]: (e, t) => {
    const i = e.dataModel.project(
      kp(t.context, e.dataModel)
    ), { selectionSet: n, config: A } = t.context, { classPrefix: s } = t.metaInfo, { showMultipleMeasures: o } = A, r = n.entrySet.length, a = w9(
      i,
      n.entrySet,
      A
    ), l = [
      {
        className: `${s}-tooltip-row`,
        data: [
          {
            value: `${r}`,
            style: {
              "font-weight": "bold"
            }
          },
          "Items Selected"
        ]
      }
    ];
    return Object.keys(a).forEach((g) => {
      const { format: h = YE, defAggFn: u } = i.getField(g).schema(), d = a[g], f = [
        `(${u.toUpperCase()})`,
        `${pl(i, g)}:`,
        {
          value: h(d),
          style: {
            "font-weight": "bold"
          },
          className: `${s}-tooltip-value`
        }
      ];
      o ? l.push({
        className: `${s}-tooltip-row`,
        data: f
      }) : l[0].data.push(...f);
    }), l;
  },
  [PE]: (e, t) => {
    const { layers: i, includeDataFromAllLayers: n, hasPointsInBackground: A } = t.context, s = i.some(
      (o) => o._transformedData._config && o._transformedData._config.groupBy && o._transformedData._config.groupBy.length
    );
    if (n && (A || s))
      return D9(
        e.secondaryDatamodels,
        { ...t.metaInfo, isCompositeTooltip: s },
        t.context
      );
    {
      const o = e.dataModel.project(
        kp(t.context, e.dataModel)
      );
      return p9(
        o,
        t.metaInfo,
        t.context
      );
    }
  }
};
const Tp = {
  [PE]: (e, t) => ft(e, t),
  default: (e) => ft(e, {})
}, S9 = (e) => ["formatter", "dataTransform", "order", "fields"].reduce(
  (t, i) => (i in e && (t[i] = e[i]), t),
  {}
), M9 = (e, t) => {
  const i = t._strategies, n = Object.assign({}, e);
  for (const A in i)
    n[A] = ft(
      Tp[A],
      Tp.default
    )(e[A], e);
  return n.highlightSummary = tt(
    n.highlightSummary,
    S9(e)
  ), n;
};
class r_ extends Tr {
  constructor(...t) {
    super(...t), this._tooltips = {}, this._strategies = tt({}, x9), this._strategy = PE;
  }
  static defaultConfig() {
    return {
      padding: 5,
      offset: {
        x: 0,
        y: 0
      },
      highlightSummary: {
        order: 1,
        dataTransform: (t, i) => i ? t.project(i) : t
      },
      selectionSummary: {
        order: 0,
        dataTransform: (t) => t
      },
      valueParser: (t) => t
    };
  }
  static formalName() {
    return WJ;
  }
  config(...t) {
    if (t.length) {
      const i = this._config = tt(
        this._config,
        M9(t[0], this)
      ), n = this._strategies;
      for (const A in n) {
        const s = i[A].formatter;
        this.setStrategy(A, s);
      }
      return this;
    }
    return this._config;
  }
  apply(t, i, n) {
    const A = t && t.entrySet.model;
    return i.criteria === null || !A ? (this.hide(n, null), this) : (this.createTooltip(
      Object.assign(
        {},
        {
          payload: i,
          selectionSet: t,
          options: n
        }
      ),
      null,
      0
    ), this);
  }
  static target() {
    return "all";
  }
  hide(t) {
    const i = this._tooltips;
    for (const n in i)
      if ({}.hasOwnProperty.call(i, n)) {
        const A = i[n];
        t.contents.forEach(({ name: o }) => {
          A.content(o, null);
        }), Object.keys(A._contents).length || A.hide();
      }
  }
  getPlotPointsFromIdentifiers(t, i = {}) {
    const n = super.plotPointsFromIdentifiers(
      t,
      {
        getBBox: !0,
        target: this.firebolt.sourceCanvas() !== i.sourceInfo.canvasId ? null : i.target
      },
      i.sourceInfo.layerId
    );
    return n && n[0];
  }
  createTooltip(t = {}, i, n, A) {
    const s = this.drawingContext(), o = this.sourceInfo(), r = this.config(), { payload: a, selectionSet: l, options: c } = t, g = document.body, h = s.htmlContainer.getBoundingClientRect(), u = document.querySelector("html").clientWidth, d = document.querySelector("html").clientHeight, f = window.pageXOffset || document.documentElement.scrollLeft, I = window.pageYOffset || document.documentElement.scrollTop, C = h.left + f, E = h.top + I, B = this._tooltips[n] = this._tooltips[n] || new vl(g, s.svgContainer), { entrySet: m } = l, y = m.uids, D = this.getPlotPointsFromIdentifiers(y, a);
    i = ft(i, D, B._target);
    const Q = r.padding, { showInPosition: p, position: w } = a, { contents: x = [{ name: "highlightSummary" }] } = c;
    x.forEach(({ name: S, setTransform: _, formatter: M }) => {
      const {
        includeDataFromAllLayers: k,
        entryExitSetsByLayerId: T,
        hasPointsInBackground: G
      } = a.metaData || {}, { fields: N, dataTransform: b } = r[S], F = _ ? _(l, a, this) : l;
      if (F && F.entrySet.model) {
        const R = A || F.entrySet.model, v = b(R, N, this), O = Object.assign({}, o, {
          payload: a,
          firebolt: this.firebolt,
          detailFields: [],
          timeDiffs: o.timeDiffs,
          selectionSet: F,
          config: r[S],
          valueParser: r.valueParser,
          useUTC: o.useUTC,
          hasPointsInBackground: G,
          entryExitSetsByLayerId: T,
          includeDataFromAllLayers: k
        }), L = M || this._strategies[S];
        B.context(O), B.content(S, v, {
          formatter: L,
          order: r[S].order,
          className: r[S].className
        });
      } else
        B.content(S, null);
    }), B.config(this.config()).extent({
      x: 0,
      y: 0,
      width: u,
      height: d
    }).offset({
      x: C + (r.offset.x || 0),
      y: E + (r.offset.y || 0)
    }), p ? B.position(w.x + Q, w.y + Q) : i ? B.positionRelativeTo(
      {
        x: i.x,
        y: i.y,
        width: i.width || 0,
        height: i.height || 0
      },
      {
        orientation: r.orientation
      }
    ) : B.hide();
  }
  dispose() {
    Object.values(this._tooltips).forEach((t) => t.remove());
  }
  shouldApplyOnRenderAfterScrolling() {
    return !1;
  }
}
const _9 = (e, t, i) => {
  let n, A, s, o, r;
  const l = e.length, c = (g, h, u) => {
    s = g.x, o = g.width, n = g.y, A = g.height;
    const d = n + A, f = s + o;
    i ? (u ? n < h.y + h.height : d > h.y) && (h.y = u ? g.y - h.height - 5 : d + 5) : (u ? s < h.x + h.width : f > h.x) && (h.x = u ? g.x - h.width - 5 : f + 5);
  };
  for (e.sort((g, h) => i ? g.y - h.y : g.x - h.x), r = 0, r = 0; r < l - 1; r++)
    c(e[r], e[r + 1]);
  if (e[r].y + e[r].height > t.height || e[r].x + e[r].width > t.width)
    for (i ? e[r].y -= e[r].height + e[r].y - t.height : e[r].x -= e[r].width + e[r].x - t.width, r = l - 1; r > 0; r--)
      c(e[r], e[r - 1], !0);
  return e;
};
class b9 extends r_ {
  static formalName() {
    return jJ;
  }
  static target() {
    return "visual-unit";
  }
  createTooltip(t) {
    let i = 0, n = 0;
    const A = this.config(), { strategy: s = "highlightSummary", selectionSet: o, payload: r } = t, { DIMENSION: a } = J.FieldType, l = o.entrySet.model, c = this.firebolt.context, g = this.drawingContext(), h = this._tooltips, u = {
      width: g.width,
      height: g.height
    }, d = A.padding, f = [], C = c.getSourceInfo().fields, B = !!(C.x[0] ? C.x[0].type() === a : !1), m = [], y = l.getUids();
    f.push(
      ...y.map(
        (Q) => l.select({
          field: St.ROW_ID,
          value: Q,
          operator: "eq"
        })
      )
    );
    const D = {};
    for (let Q = 0, p = f.length; Q < p; Q++) {
      const w = f[Q], x = this.getPlotPointsFromIdentifiers(
        o.entrySet.uids,
        r
      );
      super.createTooltip(t, x, Q, w);
      const S = this._tooltips[Q];
      D[Q] = this._tooltips[Q];
      const _ = S._position, M = S._tooltipContainer.node().getBoundingClientRect();
      if (i += M.height + d, n += M.width + d, B ? i > g.height : n > g.width)
        break;
      _ && m.push({
        x: _.x,
        y: _.y,
        width: M.width,
        height: M.height,
        tooltip: S
      });
    }
    for (const Q in h)
      if (!D[Q]) {
        const p = h[Q];
        p.content(s, null), p.getContents().length || (p.remove(), delete h[Q]);
      }
    return m.length && _9(m, u, B), m.forEach(
      (Q) => Q.tooltip.position(Q.x, Q.y, {
        repositionArrow: !0
      })
    ), this;
  }
  hide(t) {
    const i = this._tooltips;
    for (const n in i)
      if ({}.hasOwnProperty.call(i, n)) {
        const A = t.strategy || this._strategy;
        i[n].content(A, null), i[n].hide();
      }
  }
}
class N9 extends Tr {
  static defaultConfig() {
    return {
      className: `${Zc}-crossline-group`,
      bandClass: `${Zc}-crossband`,
      lineClass: `${Zc}-crossline`
    };
  }
  static formalName() {
    return VJ;
  }
  apply(t, i) {
    let n, A, s, o;
    const { className: r, bandClass: a, lineClass: l } = this.config(), { DIMENSION: c } = J.FieldType, g = t.entrySet.length, h = t.entrySet.model, u = this.drawingContext();
    if (i.criteria === null || !g)
      return this.hide(), this;
    const d = this.firebolt.context.getSourceInfo(), f = d.axes, I = d.fields, C = su(i.fields, h.getFieldNames()), E = u.sideEffectGroup, B = h.getRowsCount(), m = [];
    if (C.forEach((y) => {
      const D = [];
      for (let p = 0; p < B; p++)
        D.push(h.getValueAtIndex(y, p));
      const Q = [
        ["x", 0],
        ["x", 1],
        ["y", 0],
        ["y", 1]
      ].find((p) => {
        const w = I[p[0]][p[1]];
        return w && w.type() === c && w.getMembers().indexOf(y) !== -1;
      });
      if (Q !== void 0 && D.length) {
        const p = Q[0], w = f[p][Q[1]], x = D[0];
        A = w.getUnitWidth() || 0;
        const S = w.isYAxis() && w.constructor.type() === "linear" ? -(A / 2) : A / 2;
        s = w.getScaleValue(x) + S + u.xOffset;
        let _ = this.firebolt.context.layers();
        if (_ = _.filter((M) => !!M.config().crossline), _.length) {
          const M = Math.max(
            ..._.map((b) => b.getPlotSpan()[p])
          ), k = Math.max(
            ..._.map((b) => b.getPlotPadding()[p])
          );
          n = u.height, o = u.width;
          const T = s - M / 2 - k / 2, G = s + M / 2 + k / 2, N = {};
          p === "y" ? N.d = `M 0 ${T} L 0 ${G} L ${o} ${G} L ${o} ${T} Z` : N.d = `M ${T} 0 L ${G} 0 L ${G} ${n} L ${T} ${n} Z`, N.className = M ? a : l, !isNaN(s) && m.push(N);
        }
      }
    }), m.length) {
      const y = this.createElement(E, "g", [1], r);
      this.createElement(y, "path", m).attr("d", (Q) => Q.d).style("pointer-events", "none").attr("class", (Q) => Q.className);
    }
    return this;
  }
  hide() {
    const t = this.config().className, i = this.drawingContext();
    V(i.sideEffectGroup).selectAll(`.${t}`).remove();
  }
  static target() {
    return "visual-unit";
  }
}
class F9 extends $t {
  constructor(...t) {
    super(...t), this._entryModel = null;
  }
  static formalName() {
    return "filter";
  }
  static target() {
    return "visual-group";
  }
  static mutates() {
    return !0;
  }
  apply(t, i, n = {}) {
    const A = this.firebolt, s = A.getUnitDataModels(i.action), o = A.getLayerDataModels(i.action), r = t.entrySet.model;
    return this._entryModel === r ? this : (this._entryModel = r, r ? A.data(
      r,
      {
        unitDataModels: s,
        layerDataModels: o
      },
      n
    ) : A.resetData(n), this);
  }
  shouldApplyOnRenderAfterScrolling() {
    return !1;
  }
}
class R9 extends $t {
  static formalName() {
    return HE;
  }
  static target() {
    return "visual-unit";
  }
  apply(t, i) {
    const n = this.firebolt.context, A = t && t.entrySet.model, s = A && A.getData().data;
    let o = s && s.length ? s[0] : [];
    if (i.target) {
      const l = i.target, c = l[0], g = A && A.getRowsCount();
      for (let h = 0; h < g; h++)
        if (c.every((d, f) => J.getActualValue(
          A.getValueAtIndex(d, h)
        ) === J.getActualValue(l[1][f]))) {
          o = s[h];
          break;
        }
    }
    const { x: r = [], y: a = [] } = n.axes();
    return [...r, ...a].forEach((l) => {
      if (l.constructor.type() === "band") {
        const {
          useExternalCSS: c,
          ticks: {
            labels: {
              style: g,
              "&:highlight": { style: h }
            }
          }
        } = l.config();
        let u = null;
        A && (u = o[A.getFieldIndex(l.config().field)]);
        const { selectionSet: d, rejectionSet: f } = l.getTicksBasedOnData(u);
        if (d) {
          const C = d.selectAll("text");
          C.classed("muze-axis-ticks-highlight", !0), c || Object.entries(h).forEach(([E, B]) => {
            C.style(E, B);
          });
        }
        const I = f.selectAll("text");
        I.classed("muze-axis-ticks-highlight", !1), c || Object.entries(g).forEach(([C, E]) => {
          I.style(C, E);
        });
      }
    }), this;
  }
  shouldApplyOnRenderAfterScrolling() {
    return !1;
  }
}
const vp = (e, t, i = "muze-facet-fadeout") => {
  e.forEach((n, A) => {
    const s = t[A];
    n.forEach((o) => {
      V(o.mount()).classed(
        i,
        !s.length
      );
    });
  });
}, Ic = (e, t, i = "muze-axis-fadeout") => {
  e.forEach((n, A) => {
    const s = t[A], o = n.source().domain();
    n.source().constructor.type() === "band" ? o.forEach((r) => {
      n.source().getTicksBasedOnData(r).selectionSet?.each(function() {
        V(this).classed(
          i,
          !s.includes(r)
        );
      });
    }) : V(n.mount()).classed(
      i,
      !t[A].length
    );
  });
};
class k9 extends $t {
  static formalName() {
    return "facet-axis-highlighter";
  }
  static target() {
    return "visual-group";
  }
  apply(t, i, n) {
    const s = this.firebolt.context.composition().visualGroup.matrix(), o = s.geom().getXYDomains({
      unionAxisDomainPerPage: !0
    }), r = Ka(o.x), a = r.map((u) => u[0]), l = r.map((u) => u[1]);
    vp(
      s.column()._matrices.headers._cells.top,
      a,
      n.className
    ), Ic(s.column()._matrices.axes._cells.bottom, a), Ic(s.column()._matrices.axes._cells.top, l);
    const c = Ka(o.y), g = c.map((u) => u[0]), h = c.map((u) => u[1]);
    vp(
      s.row()._matrices.headers._cells.left,
      g,
      n.className
    ), Ic(
      s.row()._matrices.axes._cells.left,
      g,
      n.className
    ), Ic(
      s.row()._matrices.axes._cells.right,
      h,
      n.className
    );
  }
  shouldApplyOnRenderAfterScrolling() {
    return !0;
  }
}
class T9 extends $t {
  static formalName() {
    return qJ;
  }
  static target() {
    return "visual-unit";
  }
  apply() {
    return this;
  }
  shouldApplyOnRenderAfterScrolling() {
    return !1;
  }
}
const WE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AxisLabelHighLighter: R9,
  Crossline: N9,
  FacetAxisHighlighter: k9,
  FilterEffect: F9,
  FragmentedTooltip: b9,
  SHOW_CONTEXT_MENU: T9,
  SelectionBox: t9,
  Tooltip: r_
}, Symbol.toStringTag, { value: "Module" })), Gp = (e) => {
  const t = {};
  for (const i in e) {
    const n = e[i];
    t[n.formalName()] = n;
  }
  return t;
}, v9 = {
  behaviours: wa(Gp(OE)),
  physicalActions: wa($M),
  sideEffects: wa(Gp(WE))
};
class G9 extends Qi {
  static formalName() {
    return "menuItemSelect";
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
class L9 extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return "invoke-menu-item-callback";
  }
  apply(t, { data: i, metaInfo: n }) {
    i.isDisabled || i.onClick(i, n);
  }
}
const U9 = (e, t) => {
  let i = e._cacheMap = {};
  return (n) => {
    if (i = e._cacheMap, !i[n]) {
      const A = t.getUids(), s = t.getRowsCount(), o = {};
      for (let r = 0; r < s; r++) {
        const a = n.map((l) => t.getValueAtIndex(l, r));
        !o[a] && (o[a] = []), o[a].push(A[r]);
      }
      i[n] = o;
    }
    return i[n];
  };
};
class O9 extends to {
  constructor(...t) {
    super(...t);
    const i = this._actions.behavioural, n = [
      i.highlight,
      i.filter
    ];
    for (const A in i)
      i[A].isImplicit() || n.forEach((s) => {
        const o = `${A}:${s.formalName()}`;
        i[o] = new s.constructor(
          this,
          o
        ), i[o].isReactionBehaviour(!0);
      });
    this._sideEffects.tooltip.disable(), this._propagationDms = {}, this._interactionStates = /* @__PURE__ */ new Map(), this._appliedInteractions = /* @__PURE__ */ new Map();
  }
  target() {
    return "visual-layer";
  }
  createSelectionSet(...t) {
    return super.createSelectionSet(...t), this._dimsMapGetter = U9(this, this.context.data()), this;
  }
  getStateKey() {
    const { unitRowIndex: t, unitColIndex: i } = this.context.metaInf();
    return `${t}-${i}-${this.context.id()}`;
  }
  getPropagationActions(t) {
    let i;
    return t.sourceInfo.canvasId === this.sourceCanvas() ? i = W(t.targetActions, "layer") || {} : i = W(t.targetActions, "interCanvas", this.sourceCanvas()) || {}, (Object.keys(i) || {}).map(
      (s) => ({
        actionName: t.sourceAction ? `${t.sourceAction}:${s}` : s,
        sideEffects: GE(
          {
            action: s,
            sourceCanvas: t.sourceInfo.canvasId,
            targetActions: t.targetActions
          },
          this
        )
      })
    );
  }
  onDataModelPropagation() {
    return (t, i) => {
      const n = W(i, "applyOnVisibleUnits") ? this.isVisible() : !0;
      if (!t && !i.propagateDm && i.criteria !== null && i.sourcePropQuery && n) {
        const r = this.context.metaInf().facets;
        Object.keys(i.targetFacets).every(
          (a) => r[a] === i.targetFacets[a]
        ) ? t = this.data().select(i.sourcePropQuery) : t = this.data().createEmptyDm();
      }
      if (this._propagationDms[i.sourceAction] && this._propagationDms[i.sourceAction].dispose(!1), i.criteria === null && i.resetAllInteractions)
        return this.resetAllInteractions(i), this;
      this._propagationDms[i.sourceAction] = t;
      const A = this.getPropagationActions(i), s = t ? this.context.getAllAssociatedFields() : [], o = s.length && i.fields.length ? su(i.fields, s).length : !0;
      A.forEach(({ actionName: r, sideEffects: a }) => {
        const l = this.getBehaviouralAction(r);
        if (l) {
          const c = tt(
            {},
            l.generatePayloadFromPropagationInf({
              propPayload: i,
              propagationData: t
            })
          );
          o || (c.criteria = {
            uids: []
          }), i.sourceId = i.propagationSourceId;
          const g = {
            propagate: !1,
            data: t,
            propPayload: i,
            sourceId: i.sourceId
          };
          (n ? this.dispatchBehaviour(
            r,
            Object.assign({}, c, { sideEffects: a }),
            Object.assign({}, g, {
              data: c.criteria === null ? null : g.data
            }),
            i.forceDispatch
          ) : !1) && (this.actions().behavioural[r].getSelectionSet().resetted() ? this.removeInteractionState({ action: r }) : this.saveInteractionState({
            action: r,
            payload: Object.assign({}, c, {
              sideEffects: a,
              action: r
            }),
            propagationInf: Object.assign({}, g, {
              data: c.criteria === null ? null : g.data
            }),
            forceDispatch: !1
          })), this._onPropagationDone(
            { ...i, action: r },
            t,
            g
          );
        }
      });
    };
  }
  applyExistingInteractions() {
    this._interactionStates.forEach(({ action: i, payload: n, propagationInf: A }) => {
      const s = n.sideEffects.filter((o) => this.sideEffects()[o.name] && this.sideEffects()[o.name].shouldApplyOnRenderAfterScrolling());
      this.actions().behavioural[i].entryExitSet() && this.dispatchSideEffects(
        i,
        { ...n, sideEffects: s },
        A,
        !0
      );
    });
  }
  resetAllInteractions(t) {
    const i = this._lastInteraction, n = [];
    i.forEach(({ behaviour: A, sideEffects: s }, o) => {
      if (A.includes("filter") && !t.resetFilterAction)
        return;
      const a = {
        action: A,
        criteria: null,
        sideEffects: s,
        forceDispatch: !0,
        sourceInfo: {},
        resetAllInteractions: !0,
        resetFilterAction: t.resetFilterAction
      }, l = {
        propagate: !1
      };
      this.dispatchBehaviour(A, a, l, !0), this._onPropagationDone(a, null, l), n.push(o);
    }), n.forEach((A) => i.delete(A));
  }
  remove() {
    return this.context._cachedData[0] && this.context._cachedData[0].unsubscribe(this._propagationHandler), this;
  }
  sourceCanvas() {
    return this.context.metaInf().canvasAlias;
  }
  sourceUnit() {
    return this.context.metaInf().unitId;
  }
  data(...t) {
    if (t.length) {
      const i = t[0];
      return this.context.enableCaching().data(i), this;
    }
    return this.context.data();
  }
  resetData() {
    return this.context.clearCaching(), this;
  }
  getTargetActions(t) {
    const i = this.context.config().interaction;
    return W(i, t, "target") || {};
  }
  getSideEffectsForSourceAction({ action: t }) {
    const i = this.context.config().interaction, n = W(i, t, "sideEffects") || {};
    return Object.keys(n).map((A) => ({
      name: A,
      ...n[A]
    })).filter((A) => A.enabled !== !1);
  }
  store() {
    return this.context.store();
  }
  isVisible() {
    const t = this.context.store(), i = this.context.metaInf(), { unitRowIndex: n, unitColIndex: A } = i, { rowStart: s, rowEnd: o, colStart: r, colEnd: a } = t.get(
      "virtualScrolling.viewport"
    );
    return cr(n, [s, o]) && cr(A, [r, a]);
  }
}
class H9 extends $t {
  constructor(...t) {
    super(...t), this._styles = /* @__PURE__ */ new Map();
  }
  static formalName() {
    return "plot-highlighter";
  }
  static target() {
    return "visual-layer";
  }
  setTransform() {
    return (t, i) => {
      const n = i.sourceInfo.layerId === this.firebolt.id(), A = (W(i.target, 0) || []).filter(
        (r) => r !== St.ROW_ID
      );
      let s = i.target;
      if (!n && s && (s = [
        A,
        i.target[1].filter((r, a) => i.target[0][a] !== St.ROW_ID)
      ]), i.criteria === null || !n || i.action !== "highlight")
        return t;
      const o = Mr(
        s,
        t.entrySet.model
      );
      return t.filter(o);
    };
  }
  apply(t, i, { rules: n }) {
    const A = (s) => {
      let o;
      return s instanceof Function ? o = s(
        {
          payload: i,
          entryExitSet: t
        },
        this.firebolt
      ) : typeof s == "string" && (o = s === "entrySet" ? t.entrySet : t.exitSet), o = this.firebolt.context._hasSingleElementForMultipleDataPoints ? this.firebolt.context.getTargetSet(o, s) : o, o;
    };
    n.forEach((s) => {
      const o = A(s.target);
      if (!o)
        return;
      const r = `${i.action}-${s.target instanceof Function ? s.key : s.target}`;
      if (i.criteria === null || !t.entrySet.length && !t.exitSet.length)
        this.applyInteractionStyle(t.completeSet, {
          apply: !1,
          interactionType: r,
          className: s.className,
          style: s.style
        }), this._styles.delete(r);
      else {
        const a = {
          apply: !0,
          interactionType: r,
          className: s.className,
          style: s.style,
          targetSet: s.target
        }, l = this._styles.get(r);
        l && this.applyInteractionStyle(
          {
            uids: ou(l.targetSet.uids, o.uids)
          },
          { ...l.config, apply: !1 }
        ), this.applyInteractionStyle(o, a), this._styles.set(r, {
          targetSet: o,
          config: a
        });
      }
    });
  }
}
const P9 = (e, t) => t.length > 1 ? t.slice(0, t.length - 1).every(({ field: i, value: n }) => e[i] === n) : !0;
class Y9 extends $t {
  constructor(...t) {
    super(...t), this._styles = /* @__PURE__ */ new Map();
  }
  static formalName() {
    return "pivot-cell-highlighter";
  }
  static target() {
    return "visual-layer";
  }
  apply(t, i) {
    const n = i.data && i.data.contextData.data ? i.data.contextData.data.getDataPath() : null, A = this.firebolt.context, s = A.metaInf().facets;
    if (n && P9(s, n)) {
      const o = n[n.length - 1].value, r = n[n.length - 1].field, a = A.axes().y.config().field === `${r}` ? "y" : "x", l = a === "y" ? A.axes().y.domain().length - 1 - A.axes().y.domain().indexOf(o) : A.axes()[a].domain().indexOf(o), c = V(A.mount()).selectAll(
        a === "y" ? `.muze-text-row-${l}` : `.muze-text-col-${l}`
      );
      this._interactedCells && this._interactedCells.classed("muze-pivot-cell-highlight", !1), c.classed("muze-pivot-cell-highlight", !0), this._interactedCells = c;
    } else
      this._interactedCells && this._interactedCells.classed("muze-pivot-cell-highlight", !1);
  }
}
class Si {
  static getUniquePositionedPoints(t, i) {
    const n = /* @__PURE__ */ new Set();
    return t.filter((s) => {
      const [o, r] = Si.getLabelPosition(s, i), a = `${o}_${r}`;
      return n.has(a) ? (s.isLabelThinned = !0, !1) : (n.add(a), !0);
    });
  }
  /**
   * Returns text label position.
   *
   * @static
   * @param {Object} point point
   * @param {String|undefined} location label location, one of: "point", "text", "sum"; or "sum" if undefined
   * @return {number[]} [ x, y ] coordinates, in pixels
   */
  static getLabelPosition(t, i = "sum") {
    return i === "point" ? [t.update.x, t.update.y] : i === "text" ? [t.text.update.x, t.text.update.y] : [t.update.x + t.text.update.x, t.update.y + t.text.update.y];
  }
  /**
   * Returns text label area.
   *
   * @static
   * @param {Object} point point
   * @param {String|undefined} location label location, one of: "point", "text", "sum"; or "sum" if undefined
   * @param {Object} smartLabel smart label
   * @return {number[]} [ x, y, width, height ] coordinates and dimensions, in pixels
   */
  static getLabelArea(t, i = "sum", n) {
    const [A, s] = this.getLabelPosition(t, i), { text: o, labelSmartText: r, textAnchor: a, rotation: l } = t.text && t.text.text ? t.text : t, c = n.getOriSize(r || o), g = c.width, h = 0.8 * c.height, u = h / 2, d = a === "start" ? 0 : a === "middle" ? g / 2 : g;
    return l === -90 ? [A - u, s - g + d, h, g] : [A - d, s - u, g, h];
  }
  /**
   * Returns whether two text labels intersect.
   *
   * @static
   * @param {number[]} r0 x, y, width, and height of first labels, in pixels
   * @param {number[]} r1 x, y, width, and height of second labels, in pixels
   * @return {boolean} true iff labels intersect
   */
  static isIntersect(t, i) {
    const [A, s, o, r] = t, [a, l, c, g] = i;
    return A + o >= a + 2 && A + 2 <= a + c && s + r >= l + 2 && s + 2 <= l + g;
  }
  /**
   * Shifts text labels as needed to keep them inside the drawing area.
   *
   * Shifting may cause label collisions.  After using this method, use the thinFinally method.
   *
   * @static
   * @param {number} width drawing area width, in pixels
   * @param {number} height drawing area height, in pixels
   * @param {Object} smartLabel smart label
   * @param {Object[]} points points containing text labels to be shifted
   * @param {String|undefined} location label location, one of: "point", "text", "sum"; or "sum" if undefined
   */
  static placeInside(t, i, n, A, s = "sum") {
    A.forEach((o) => {
      if (o && o.text && !o.isLabelThinned && !Number.isNaN(o.update.x) && !Number.isNaN(o.update.y) && (!o.text.update || !Number.isNaN(o.text.update.x) && !Number.isNaN(o.text.update.y))) {
        const { text: r, textAnchor: a, rotation: l, labelSmartText: c } = o.text && o.text.text ? o.text : o, { width: g, height: h } = n.getOriSize(
          c || r
        ), u = a === "start" ? 0 : a === "middle" ? g / 2 : g, d = 0.4 * h, f = 2, I = s === "point" || s === "text" ? { x: 0, y: 0 } : o.update, C = s === "point" ? o.update : o.text.update;
        l === 0 ? (C.x < u - I.x + f ? C.x = u - I.x + f : C.x > t - g + u - I.x && (C.x = t - g + u - I.x - f), C.y < h - d - I.y + f ? C.y = h - d - I.y + f : C.y > i - d - I.y && (C.y = i - d - I.y - f)) : l === -90 && (C.x < h - d - I.x + f ? C.x = h - d - I.x + f : C.x > t - d - I.x && (C.x = t - d - I.x - f), C.y < g - u - I.y + f ? C.y = g - u - I.y + f : C.y > i - u - I.y && (C.y = i - u - I.y - f));
      }
    });
  }
  /**
   * Flags points for text label thinning using Voronoi tiling.
   *
   * This method sets the "isLabelThinned" boolean in each point so that rendering code can omit it from the display.
   *
   * The Voronoi algorithm reduces collisions but does not eliminate them.  After using this method, use the thinFinally method.
   *
   * @static
   * @param {number} width drawing area width, in pixels
   * @param {number} height drawing area height, in pixels
   * @param {Object} smartLabel smart label
   * @param {Object[]} points points, containing text labels to be thinned (returned with "isLabelThinned: boolean" flag set)
   * @param {String|undefined} location label location, one of: "point", "text", "sum"; or "sum" if undefined
   * @param {Object|undefined} container container for drawing Voronoi diagram, for debugging; not drawn if undefined
   * @return {number[][]} Voronoi cells containing the specified points
   */
  static thinVoronoi(t, i, n, A, s = "sum", o = void 0) {
    const r = A.map((g) => this.getLabelPosition(g, s)), l = iu.from(r).voronoi([0, 0, t, i]), c = r.map((g, h) => l.cellPolygon(h));
    if (o) {
      const g = nu.path();
      l.render(g), V(o).append("path").attr("d", g).attr("stroke", "red").attr("stroke-width", 1);
    }
    return A.forEach((g, h) => {
      if (g.isLabelThinned = !0, g && g.text) {
        const u = c[h];
        if (u) {
          const { text: d, labelSmartText: f, rotation: I } = g.text && g.text.text ? g.text : g, { width: C, height: E } = n.getOriSize(f || d);
          if (Math.abs(Lw(u)) >= 1e3)
            g.isLabelThinned = !1;
          else {
            const [B, m] = Qf(u);
            let [y, D, Q, p] = u.reduce(
              (M, k, T, G) => {
                let [N, b, F, R] = M;
                const [v, O] = k, [L, U] = G[(T - 1 + G.length) % G.length];
                if (L <= B && B <= v || v <= B && B <= L) {
                  const H = U + (O - U) * (B - L) / (v - L);
                  F = Math.min(F, H), R = Math.max(R, H);
                }
                if (U <= m && m <= O || O <= m && m <= U) {
                  const H = L + (v - L) * (m - U) / (O - U);
                  N = Math.min(N, H), b = Math.max(b, H);
                }
                return [N, b, F, R];
              },
              [1 / 0, -1 / 0, 1 / 0, -1 / 0]
            );
            const w = D - y, x = p - Q, S = 0.5, _ = 0.2;
            I === 0 ? g.isLabelThinned = w < S * C || x < _ * E : I === -90 && (g.isLabelThinned = w < _ * E || x < S * C);
          }
        }
      }
    }), c;
  }
  /**
   * Places text labels using Voronoi tiling, minimizing overlap with associated points.
   *
   * When 'isCheckingAll' is false, only the object associated with the text label is checked for overlap,
   * and this algorithm is O( n * log( n )).  When 'isCheckingAll' is true, this method
   * checks all points for overlap, using an O( n**2 ) algorithm that performs well for small n.
   *
   * (There are better algorithms for this purpose.  This algorithm is a "quick fix" that could be replaced
   * by a real optimization algorithm, when time permits.  An alternative is to maintain this algorithm,
   * and supplement it with a direct manipulation user interface that enables the user to place the labels.)
   *
   * The Voronoi algorithm places labels inside the drawing area if they fit, but they may not always fit.
   * After using this method, use the thinFinally method.
   *
   * TODO: Place labels rotated at arbitrary angles.
   *
   * @static
   * @param {number} width drawing area width, in pixels
   * @param {number} height drawing area height, in pixels
   * @param {Object} smartLabel smart label
   * @param {Object[]} points points containing text labels (returned with "textAnchor" and "update" properties modified)
   * @param {number[][]} cells Voronoi cells containing points
   * @param {boolean} isCheckingAll true iff checking all points for overlap
   * @param {String|undefined} location label location, one of: "point", "text", "sum"; or "sum" if undefined
   * @param {Object|undefined} container container for drawing label area, for debugging; not drawn if undefined
   */
  static placeVoronoi(t, i, n, A, s, o = !1, r = "sum", a) {
    const l = n.getOriSize("X").height, c = 0.4 * l, g = 0, h = 1, u = 2, d = 3;
    A.forEach((f, I) => {
      const C = f.size === void 0 ? 0 : f.size;
      if (!f.isLabelThinned && C < l) {
        const [E, B] = this.getLabelPosition(f, r), [m, y] = Qf(s[I]), D = (Math.round(Math.atan2(y - B, m - E) / Math.PI * 2) + 4) % 4;
        let Q;
        switch (D) {
          case g:
            Q = [g, d, h, u];
            break;
          case h:
            Q = [h, g, u, d];
            break;
          case u:
            Q = [u, d, h, g];
            break;
          default:
            Q = [d, g, u, h];
            break;
        }
        const p = f.text && f.text.text ? f.text : f, w = p.rotation, x = p.update.x, S = p.update.y;
        let _ = !1;
        for (let M = 0; M < Q.length && !_; M++) {
          switch (Q[M]) {
            case g:
              w === 0 ? (p.textAnchor = "start", p.update.x = x + C + 2) : w === -90 && (p.textAnchor = "middle", p.update.x = x + C + c), p.update.y = S;
              break;
            case h:
              w === 0 ? (p.textAnchor = "middle", p.update.y = S + C + c) : w === -90 && (p.textAnchor = "end", p.update.y = S + C + 2), p.update.x = x;
              break;
            case u:
              w === 0 ? (p.textAnchor = "end", p.update.x = x - C - 2) : w === -90 && (p.textAnchor = "middle", p.update.x = x - C - c), p.update.y = S;
              break;
            default:
              w === 0 ? (p.textAnchor = "middle", p.update.y = S - C - c) : w === -90 && (p.textAnchor = "start", p.update.y = S - C - 2), p.update.x = x;
              break;
          }
          const [k, T, G, N] = this.getLabelArea(
            f,
            r,
            n
          );
          if (_ = k >= 0 && T >= 0 && k + G < t && T + N < i, o) {
            _ = _ && A.every((b) => {
              const F = b.size === void 0 ? 0 : b.size;
              return !this.isIntersect(
                [k, T, G, N],
                [
                  b.update.x - F,
                  b.update.y - F,
                  2 * F,
                  2 * F
                ]
              );
            });
            for (let b = 0; b < I && _; b++) {
              const F = A[b];
              if (!F.isLabelThinned) {
                const [R, v, O, L] = this.getLabelArea(F, r, n);
                R >= 0 && v >= 0 && R + O < t && v + L < i && (_ = !this.isIntersect(
                  [k, T, G, N],
                  [R, v, O, L]
                ));
              }
            }
          }
        }
        if (a) {
          const M = V(a), [k, T, G, N] = this.getLabelArea(
            f,
            r,
            n
          );
          M.append("rect").attr("x", k).attr("y", T).attr("width", G).attr("height", N).attr("stroke", "blue").attr("stroke-width", 1).attr("fill", "none");
        }
      }
    });
  }
  /**
   * Flags points for text label thinning to remove label collisions and labels outside the drawing area.
   *
   * This method sets the "isLabelThinned" boolean in each point so that rendering code can omit it from the display.
   *
   * Collision detection is O( n ** 2 ).  The thinVoronoi method is O( n * log( n )).
   * Therefore, only use thinFinally with a small number of points, or after using thinVoronoi first.
   *
   * @static
   * @param {number} width drawing area width, in pixels
   * @param {number} height drawing area height, in pixels
   * @param {Object} smartLabel smart label
   * @param {Array.<Object>} points points containing text labels to be thinned (returned with "isLabelThinned: boolean" flag set)
   * @param {String|undefined} location label location, one of: "point", "text", "sum"; or "sum" if undefined
   */
  static thinFinally(t, i, n, A, s = "sum", o = { thinOverflowingLabels: !0 }) {
    let r = (l, c) => {
      l.forEach((g, h) => {
        if (g.isLabelThinned)
          return;
        let u = !1;
        const [d, f, I, C] = this.getLabelArea(
          g,
          s,
          n
        );
        for (let E = h + 1; E < l.length && !u; E++)
          if (!l[E].isLabelThinned) {
            const [B, m, y, D] = this.getLabelArea(
              l[E],
              s,
              n
            );
            this.isIntersect(
              [d, f, I, C],
              [B, m, y, D]
            ) ? l[E].isLabelThinned = !0 : u = c && B > d + I || !c && m > f + C;
          }
      });
    };
    A.forEach((l) => {
      if (l.isLabelThinned === void 0 ? l.isLabelThinned = !1 : (!l.update || Number.isNaN(l.update.x) || Number.isNaN(l.update.y) || s !== "point" && (!l.text || !l.text.update || Number.isNaN(l.text.update.x) || Number.isNaN(l.text.update.y))) && (l.isLabelThinned = !0), !l.isLabelThinned && o.thinOverflowingLabels) {
        const [c, g, h, u] = this.getLabelArea(
          l,
          s,
          n
        );
        (c < 0 || g < 0 || c + h > t || g + u > i) && (l.isLabelThinned = !0);
      }
    });
    let a = A.filter((l) => !l.isLabelThinned);
    a.sort(
      (l, c) => s === "point" ? l.update.x - c.update.x : s === "text" ? l.text.update.x - c.text.update.x : l.update.x + l.text.update.x - c.update.x - c.text.update.x
    ), r(a, !0), a = a.filter((l) => !l.isLabelThinned), a.sort(
      (l, c) => s === "point" ? l.update.y - c.update.y : s === "text" ? l.text.update.y - c.text.update.y : l.update.y + l.text.update.y - c.update.y - c.text.update.y
    ), r(a, !1);
  }
}
const J9 = `${lt.DISCRETE}-${it.CATEGORICAL}${Ct.DIMENSION}`, ea = `${lt.CONTINUOUS}-${it.CONTINUOUS}${Ct.MEASURE}`, K9 = `${lt.DISCRETE}-${it.CONTINUOUS}${Ct.MEASURE}`, W9 = `${lt.DISCRETE}-${it.TEMPORAL}${Ct.DIMENSION}`, V9 = `${lt.CONTINUOUS}-${it.TEMPORAL}${Ct.DIMENSION}`, j9 = `${lt.DISCRETE}-${it.CONTINUOUS}${Ct.DIMENSION}`, Rd = `${lt.CONTINUOUS}-${it.CONTINUOUS}${Ct.DIMENSION}`, q9 = `${lt.DISCRETE}-${it.BINNED}${Ct.DIMENSION}`, z9 = `${lt.CONTINUOUS}-${it.BINNED}${Ct.DIMENSION}`, Z9 = (e) => {
  let t = null, i = null;
  const n = `${e.x.as}-${e.x.subtype}${e.x.type}`, A = `${e.y.as}-${e.y.subtype}${e.y.type}`, s = [
    W9,
    J9,
    V9,
    j9,
    K9,
    q9,
    z9
  ], o = [
    ea,
    Rd
  ];
  return s.includes(n) && o.includes(A) ? (t = "x", i = "y") : s.includes(A) && o.includes(n) ? (t = "y", i = "x") : n === Rd && A === ea ? (t = "x", i = "y") : n === ea && A === Rd ? (t = "y", i = "x") : n === ea && A === ea && (t = "x", i = "y"), {
    independentField: t ? e[t] : null,
    dependentField: i ? e[i] : null
  };
};
class VE extends Qi {
  static formalName() {
    return Rs;
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
const a_ = (e) => class extends e {
  /**
   * Creates a layer using a configuration and data.
   *
   * @public
   * @constructor
   * @param {DataModel} data Instance of DataModel to be used. This DataModel instance serves as the data for a
   * layer.
   * @param {Object} axes Axes instances to be used for rendering the layer. Axes are used for mapping data from
   *      value to px.
   * @param {SimpleAxis} axes.x X axis of the layer. Based on the type of variable it gets instance of BandAxis,
   *      TimeAxis, ContinuousAxis
   * @param {SimpleAxis} axes.y X axis of the layer. Based on the type of variable it gets instance of BandAxis,
   *      TimeAxis, ContinuousAxis
   * @param {ColorAxis} axes.color Axis for coloring a layer using color interpolators
   * @param {ShapeAxis} axes.shape Axis for providing a shape
   * @param {SizeAxis} axes.size Axis for determining size of a mark using size interpolator
   * @param {LayerConfig} config Configuration of the layer
   * @param {Object} dependencies Dependencies of the layer
   * @param {SmartLabel} dependencies.smartLabel Smartlabel singleton instance
   */
  constructor(...t) {
    super(), this.eventManager(t[t.length - 1]);
    const i = Ut();
    this._axes = {}, this._alias = this.constructor.formalName() + i, this._points = [], this._pointMap = {}, this._cachedData = [], this._id = i, this._measurement = {}, this._graphicElems = {}, this._linkedElems = {}, this._customConfig = null, this._renderer = "svg", this._metaInf = null, this._largestTextLabel = "", this._shortestTextLabel = "", this._textPointsInfo = null, this._cellMaxCount = 0, this._normalizedData = null, this._viewableNormalizedData = null, this.emitSelfHooks(gt.INITIALIZED), this._stackedSum = /* @__PURE__ */ new Map();
  }
  associatedHookComponentPaths() {
    return [
      [xt.LAYER, this.constructor.formalName()],
      [xt.LAYER]
    ];
  }
  onAnimationEnd() {
    if (!this.eventManager())
      return Promise.resolve(this);
    let t;
    return this.eventManager().once(
      new Ie({
        componentPath: [xt.LAYER],
        modifier: fe.EACH,
        hookName: gt.ANIMATION_END
      }),
      (i) => {
        t(i);
      }
    ), new Promise((i) => {
      t = i;
    });
  }
  createFirebolt() {
    const t = this.interactionRegistry();
    this._firebolt = new O9(
      this,
      {
        physical: Object.assign({}, t.physicalActions),
        behavioural: Object.assign({}, t.behaviours, {
          [Rs]: VE
        }),
        physicalBehaviouralMap: Object.assign(
          {},
          t.physicalBehaviouralMap
        )
      },
      Object.assign({}, t.sideEffects, {
        PlotHighlighter: H9,
        PivotCellHighlighter: Y9,
        ...this.getSideEffects()
      }),
      Object.assign({}, t.behaviourEffectMap)
    );
  }
  firebolt() {
    return this._firebolt;
  }
  getSideEffects() {
    return {};
  }
  store(...t) {
    return t.length ? (this._store = t[0], this) : this._store;
  }
  domain(...t) {
    return t.length ? (this._domain = t[0], this) : this._domain;
  }
  largestTextLabel(...t) {
    return t.length ? (this._largestTextLabel = t[0], this) : this._largestTextLabel;
  }
  shortestTextLabel(...t) {
    return t.length ? (this._shortestTextLabel = t[0], this) : this._shortestTextLabel;
  }
  /**
   * Creates a layer instance
   * @return {BaseLayer} Instance of a layer
   */
  static create(...t) {
    return new this(...t);
  }
  /**
   * Default configuration of the layer. This configuration gets merged to the user passed configuration using a
   * plolicy. Base layer only returns part of configuraion, any layer overridding base layer should return its own
   * configuration.
   *
   * @public
   * @static
   *
   * @return {Object} Default configuration
   */
  static defaultConfig() {
    return {
      transform: {
        type: "identity"
      }
    };
  }
  /**
   * Policy defines how user config gets merged to default config. The default policy here does a deep copy
   * operation.
   * Any policy which does more than deep copying should define the policy as a static member.
   *
   * @static
   * @public
   *
   * @param {LayerConfig} conf Configuration with which the user config will be merged
   * @param {LayerConfig} userConf Configuration given by the user
   *
   * @return {LayerConfig} Merged layer configuration
   */
  static defaultPolicy(t, i) {
    return tt(t, i);
  }
  /**
   * Provides a alias for a layer. Like it's possible to have same layer (like bar) multiple times, but among
   * multiple layers of same type if one layer has to be referred, alias is used. If no alias is given then
   * `formalName` is set as the alias name.
   *
   *
   * If used as setter
   * @param  {string} alias Name of the alias
   * @return {BaseLayer} Instance of current base layer
   *
   * If used as getter
   * @return {string} Alias of the current layer
   *
   * @public
   */
  alias(...t) {
    return t.length ? (this._alias = t[0], this) : this._alias || this.constructor.formalName();
  }
  enableCaching() {
    return this._cacheEnabled = !0, this;
  }
  disableCaching() {
    return this._cacheEnabled = !1, this;
  }
  resetData() {
    return this._cacheEnabled = !1, this._cachedData[0] !== this.data() && this.data(this._cachedData[0]), this;
  }
  clearCaching() {
    this._cacheEnabled = !1, this.resetData();
  }
  /**
   * Serialize the schema. Merge config is used for serialization.
   *
   * @public
   *
   * @return {LayerConfig} Serialized schema
   */
  serialize() {
    return this.config();
  }
  /**
   * Returns the unique identifier of this layer. Id is auto generated during the creation proceess of a schema.
   *
   * @public
   *
   * @return {string} id of the layer
   */
  id(...t) {
    return t.length ? (this._id = t[0], this) : this._id;
  }
  /**
   * Returns the transformed data based on given transform type.
   * It first gets the transform method from transform factory based on type of transform. It then calls the
   * transform method with the data and passes the configuration parameters of transform such as
   * groupBy, value field, etc.
   *
   * @param {DataModel} dataModel Instance of DataModel
   * @param {Object} config Configuration for transforming data
   * @return {Array.<Array>} Transformed data.
   */
  getTransformedData(t, i, n, A) {
    return Ml(
      t,
      i,
      n
    );
  }
  /**
   * Calculates the domain from the data.
   * It checks the type of field and calculates the domain based on that. For example, if it
   * is a quantitative or temporal field, then it calculates the min and max from the data or
   * if it is a categorical field then it gets all the values from the data of that field.
   * @param {Array} data DataArray
   * @param {Object} fieldsConfig Configuration of fields
   * @return {Array} Domain values array.
   */
  calculateDomainFromData(t) {
    let i = {};
    return this.data().isEmpty() || (i = _M(t, this)), i;
  }
  static shouldDrawAnchors() {
    return !1;
  }
  /**
   * Returns the domain for the axis.
   *
   * @param {string} encodingType type of encoding x, y, etc.
   * @return {Object} Axis domains
   */
  getDataDomain(t) {
    return t !== void 0 ? this._domain[t] || [] : this._domain;
  }
  /**
   * Normalizes the transformed data and returns it.
   *
   * @param {string} encodingType type of encoding x, y, etc.
   * @return {Object} Axis domains
   */
  getNormalizedData(t) {
    return MM(t, this);
  }
  isVerticalBar() {
    const { yFieldAs: t, yField: i, xField: n, xFieldAs: A } = this.encodingFieldsInf();
    return xA({
      yField: i,
      yFieldAs: t,
      xField: n,
      xFieldAs: A,
      dm: this.data(),
      transformConf: this._transformConfig
    });
  }
  normalizeText() {
    const { showStackSum: t, displayAs: i } = this.config().encoding.text, { type: n, originalType: A } = this._transformConfig;
    t ? this.normalizeTextStackSum() : (A || n) === Lt && i === Er ? this.normalizeTextInPercentage() : this.normalizeTextData();
  }
  normalizeTextStackSum() {
    const { displayAs: t } = this.config().encoding.text, { type: i, originalType: n, uniqueField: A, value: s } = this._transformConfig, o = n || i, r = this.data(), a = this.config().encoding.text.field;
    let l;
    r && a && (l = r.getField(a).type());
    const g = this.isVerticalBar() ? "x" : "y", h = o === Lt && t === Er;
    let u = null, d = null, f = null, I = null, C = null, E = null;
    if ((o === Nt || o === Lt) && l === Ct.MEASURE) {
      let B = /* @__PURE__ */ new Map();
      B = mJ({
        dm: this.data(),
        valueField: s.field,
        uniqueField: A.field,
        textField: a,
        transformType: o
      });
      let m = [];
      this._normalizedData.flat().filter(
        (D) => B.get(
          J.isInvalid(D[g]) ? D[g].value() : D[g]
        )
      ).forEach((D) => {
        m.push({
          ...D,
          ...B.get(
            J.isInvalid(D[g]) ? D[g].value() : D[g]
          )
        });
      }), m.forEach((D) => {
        h && (D.percentageText = 1), D.formattedTextPosSum = Dp(
          this,
          D,
          -1,
          o,
          "textFieldPosStackSum",
          m
        ), D.formattedTextNegSum = o === Nt ? Dp(
          this,
          D,
          -1,
          o,
          "textFieldNegStackSum",
          m
        ) : 0, u = go(
          u,
          D.formattedTextPosSum
        ), d = ho(
          d,
          D.formattedTextPosSum
        ), f = go(
          f,
          D.formattedTextNegSum
        ), I = ho(
          I,
          D.formattedTextNegSum
        ), B.set(D[g], D);
      }), C = go(
        u,
        f
      ), E = ho(
        d,
        I
      ), this._stackedSum = B, this.largestTextLabel(C || ""), this.shortestTextLabel(E || "");
    } else {
      const { textField: B } = this.encodingFieldsInf();
      if (!B)
        return;
      let m = null, y = null;
      this._normalizedData.forEach((D) => {
        D.forEach((Q, p) => {
          Q.formattedText = Fd(this, Q, p), m = go(
            m,
            Q.formattedText
          ), y = ho(
            y,
            Q.formattedText
          );
        });
      }), this.largestTextLabel(m || ""), this.shortestTextLabel(y || "");
    }
  }
  normalizeTextInPercentage() {
    const t = this.config().encoding.text.field, n = this.isVerticalBar() ? "x" : "y";
    let A = null, s = null, o = /* @__PURE__ */ new Map(), r = 0;
    this._normalizedData.flat().forEach((a) => {
      const l = J.isInvalid(a[n]) ? a[n].value() : a[n], c = a.dataObj[t];
      if (o.has(l)) {
        let g = o.get(l);
        g += isNaN(c) ? 0 : c, r = g;
      } else
        r = isNaN(c) ? 0 : c;
      o.set(l, r);
    }), this._normalizedData.forEach((a) => {
      a.forEach((l, c) => {
        const g = J.isInvalid(l[n]) ? l[n].value() : l[n], h = o.get(g);
        h !== 0 && !isNaN(l.text) && (g === l[n] || g === l[n].value()) ? l.percentageText = l.text / h : l.percentageText = 0, l.formattedText = Fd(this, l, c), A = go(
          A,
          l.formattedText
        ), s = ho(
          s,
          l.formattedText
        );
      });
    });
  }
  normalizeTextData() {
    const { textField: t } = this.encodingFieldsInf(), { hyperlink: i } = this.config().encoding.text;
    if (!t)
      return;
    let n = null, A = null;
    this._normalizedData.forEach((s) => {
      s.forEach((o, r) => {
        o.formattedText = Fd(this, o, r), i.enabled && (o.hyperlinkInfo = BJ(this, o, r)), n = go(
          n,
          o.formattedText
        ), A = ho(
          A,
          o.formattedText
        );
      });
    }), this.largestTextLabel(n || ""), this.shortestTextLabel(A || "");
  }
  getTextPointsForStackSum() {
    const t = this.axes();
    let i = this._points.flat();
    const n = this.isVerticalBar(), A = n ? t.x.config().field : t.y.config().field, s = /* @__PURE__ */ new Map();
    i.forEach((r) => {
      const a = J.isInvalid(r) ? r.value() : r.data[A], l = this._stackedSum.get(a);
      s.has(a) || s.set(a, { ...r, ...l });
    });
    let o = [];
    return s.forEach((r, a) => {
      if (r && r.textFieldPosStackSum !== 0) {
        const l = Ah(
          this,
          r,
          a,
          n,
          "posStackSum"
        );
        o.push(l);
      }
      if (r && r.textFieldNegStackSum !== 0) {
        const l = Ah(
          this,
          r,
          a,
          n,
          "negStackSum"
        );
        o.push(l);
      }
    }), o;
  }
  getTextAutoRotationAngle() {
    return 0;
  }
  static getDomain(t, { field: i, encoding: n, layerEncodings: A, transform: s }) {
    if (!i || !t.getField(i))
      return [];
    let o;
    const r = A[n].as || t.getField(i).subtype(), a = t.getField(i)?.subtype(), l = s.type === Nt || s.type === Lt ? this.getStackConfig(t, {
      encoding: A
    }) : {};
    return s.type === Nt && r === lt.CONTINUOUS && l.value && l.value.field === i ? o = Rl({
      dm: t,
      valueField: l.value.field,
      uniqueField: l.uniqueField.field,
      fieldAs: r
    }) : s.type === Lt && r === lt.CONTINUOUS && l.value && l.value.field === i ? o = TE({ dm: t }) : r === lt.DISCRETE ? o = a === fi ? t.getField(i)?.getAllBins() : t.getField(i)?.uniques() : o = t.getDomain(i, r), o;
  }
  /**
   * Gets the nearest point closest to the given x and y coordinate. If no nearest point is found, then it returns
   * null.
   *
   * @public
   *
   * @param {number} x X Coordinate.
   * @param {number} y Y Coordinate.
   *
   * @return {Object} Information of the nearest point.
   * ```
   *      {
   *          // id property contains the field names and their corresponding values in a 2d array. This is the
   *          data // associated with the nearest point.
   *          id: // Example data: [['Origin'], ['USA']],
   *          dimensions: // Physical dimensions of the point.
   *          layerId: // Id of the layer instance.
   *      }
   * ```
   */
  getNearestPoint() {
    return null;
  }
  getDataBoundary() {
    return null;
  }
  applyInteractionStyle(t, i) {
    const n = t;
    if (t)
      for (const A of i) {
        const s = this.getElementByRowId(A);
        s && ms(this, s, n, t);
        const o = W(this._linkedElems, "text", A);
        o && t.interactionType === "select:highlight-exitSet" && ms(
          this,
          o.select("text"),
          n,
          t
        );
      }
  }
  getElementByRowId(t) {
    return this._graphicElems[t];
  }
  resolveTransformType() {
    return this._transformType = NM(this), this._transformType;
  }
  transformType() {
    return this._transformType;
  }
  /**
   * Renders the layer
   * @return {BaseLayer} Instance of the layer.
   */
  render() {
    return bM(this), this;
  }
  elemType() {
    return "g";
  }
  /**
   * Disposes the entire layer.
   *
   * @return {BaseLayer} Instance of layer.
   */
  remove() {
    return this._disposed = !0, V(this.mount()).remove(), this._prevMount && V(this._prevMount).remove(), this._prevMount = null, this._mount = null, this.firebolt() && (this.firebolt().remove(), this.firebolt().dispose()), this._data?.dispose(), this._data = null, this._alias = null, this._points = null, this._pointMap = null, this._cachedData = null, this._measurement = null, this._graphicElems = null, this._customConfig = null, this._metaInf = null, this._largestTextLabel = null, this._shortestTextLabel = null, this._textPointsInfo = null, this._encodingFieldsInf = null, this._normalizedData = null, this._viewableNormalizedData = null, this._store?.dispose && this._store?.dispose(), this._store = null, this;
  }
  /**
   * Stores point in an object with key as the categorical value or temporal value
   *
   * @param {string} key categorical value or temporal value
   * @param {Object} data Information of the data point
   * @return {BarLayer} Instance of bar layer
   */
  cachePoint(t, i) {
    if (t === null)
      return this;
    const n = this._pointMap;
    return n[t] = i, this;
  }
  addOverlayPathAndStyles() {
    return null;
  }
  getIdentifiersFromData(t, i) {
    const n = this.data(), A = n.getSchema(), s = [[], []], o = this.config().encoding, r = (a) => Object.keys(o).find((l) => W(l, "field") === a);
    return A.forEach((a, l) => {
      const c = a.name;
      (n.isDimension(c) || r(c)) && (s[0].push(c), s[1].push(t[l]));
    }), s[0].push(St.ROW_ID), s[1].push(i), s;
  }
  hasPlotSpan() {
    return !1;
  }
  getPlotSpan() {
    return {
      x: 0,
      y: 0
    };
  }
  getPlotPadding() {
    return {
      x: 0,
      y: 0
    };
  }
  /**
   * Returns the information of the marks corresponding to the supplied identifiers.
   * Identifiers are a set of field names and their corresponding values in an array.
   * It can also be an instance of datamodel.
   *
   * For example,
   * ```
   *  const identifiers = [
   *      ['Origin', 'Cylinders'],
   *      ['USA', '8']
   *  ];
   *  const points = barLayer.getPointsFromIdentifiers(identifiers);
   * ```
   * @public
   * @param {Array|DataModel} identifiers Identifiers of the marks.
   * @param {Object} config Optional configuration which describes how to get the information.
   * @param {boolean} config.getAllAttrs If true, then returns all the information of the points, else returns only
   * the positions of the points.
   * @param {boolean} config.getBBox If true, then returns the bounding box of all the marks.
   *
   * @return {Array} Array of points contains
   */
  getPointsFromIdentifiers(t, i = {}) {
    const n = i.getAllAttrs, A = i.getBBox, s = i.target;
    if (!this.data())
      return [];
    const o = this._pointMap, r = [];
    for (const a of t) {
      const l = o[a];
      if (l) {
        const c = l.data;
        if (s) {
          if (s[0].every(
            (h, u) => h in c ? c[h] === s[1][u] : !0
          )) {
            r.push(l);
            break;
          }
        } else {
          r.push(l);
          break;
        }
      }
    }
    return n ? r : r.map((a) => {
      const l = QC(a);
      return A ? this.getBoundBox(l) : l.update || l;
    }).sort((a, l) => a.y - l.y);
  }
  getBoundBox(t) {
    const i = this.measurement(), n = t.update || t;
    if (t.size !== void 0) {
      const A = Math.sqrt(t.size / Math.PI) * 2;
      n.width = A, n.height = A, n.x -= A / 2, n.y -= A / 2;
    } else
      n.width === void 0 && (n.width = 2), n.height === void 0 && (n.height = 2);
    return n.x = Math.min(i.width, Math.max(n.x, 0)), n.y = Math.min(i.height, Math.max(n.y, 0)), n;
  }
  isSortedDomain() {
    return this._transformedData.isSortedDomain();
  }
  getYfieldEncodingForTransformedData() {
    return "y";
  }
  getTransformedValueFromNormalizedData(t, i) {
    return t[i] || 0;
  }
  getTransformedDataFromIdentifiers(t, i = 0) {
    const { MEASURE: n } = J.FieldType, A = this.data(), { yField: s, xField: o, yFieldType: r, xFieldType: a } = this.encodingFieldsInf();
    let l, c;
    a === n ? (l = A.getFieldIndex(o), c = "x") : r === n && (l = A.getFieldIndex(s), c = this.getYfieldEncodingForTransformedData(i));
    const g = [], h = A.getFieldNames();
    h.forEach((d) => {
      const f = A.getFieldIndex(d);
      g[f] = [];
    });
    let u = 0;
    for (const d of t) {
      const f = this._pointMap[d];
      if (f) {
        const I = f.normalizedData, C = this.getTransformedValueFromNormalizedData(
          I,
          c
        ), E = I.source;
        h.forEach((B) => {
          const m = A.getFieldIndex(B);
          m === l ? g[m][u] = C : g[m][u] = E[m];
        }), u++;
      }
    }
    return [g, this.data().getSchema()];
  }
  /**
   * Returns the dom elements associated with the supplied set of row ids.
   * Each element in the layer is mapped with a row of the datamodel. When given an array of row ids,
   * it returns all the elements which is mapped with those row ids.
   *
   * @public
   * @param {Array} set Array of row ids
   *
   * @return {Selection} D3 Selection of dom elements.
   */
  getPlotElementsFromSet(t) {
    const i = this._graphicElems, n = [];
    for (const A of t) {
      const s = i[A];
      s && n.push(s);
    }
    return n;
  }
  createPolarAxes() {
    return this;
  }
  calculatePolarDomain(t) {
    const i = this.config(), { sort: n } = i;
    let A = t;
    n && (A = A.sort((o, r) => {
      const a = +o.radius, l = +r.radius;
      return n === Xx ? a - l : l - a;
    }));
    const s = A.map((o) => +o.radius);
    return s.length === 1 && s.push(0), {
      radius: [Zn(s), Cn(s)],
      angle: A.map((o) => o.angle)
    };
  }
  setPolarAxesRange() {
    return this;
  }
  initializeFireboltSelectionSet() {
    const t = this.data();
    this.firebolt() && this.firebolt().createSelectionSet({ keys: t.getUids() }).attachPropagationListener(
      this._cachedData[0],
      this.firebolt().onDataModelPropagation()
    );
  }
  /**
   * Called when the layer datamodel is set.
   *
   * @param {Array} arr Old and new datamodel instance.
   * @param {DataModel} arr[0] Previous datamodel instance.
   * @param {DataModel} arr[1] Current datamodel instance.
   *
   * @return {BaseLayer} Instance of layer.
   */
  dataDidSet([, t]) {
    const i = this.config();
    if (t && i) {
      if (this._cacheEnabled ? this._cachedData.push(t) : this._cachedData = [t], i.encoding) {
        if (this.initializeFireboltSelectionSet(), this._transformedData = this.getTransformedData(
          t,
          i,
          this._transformConfig,
          this._encodingFieldsInf
        ), this._normalizedData = this.getNormalizedData(this._transformedData), this.createPolarAxes(), !this.domain()) {
          const A = {};
          [yt.X, yt.Y].forEach((s) => {
            const o = this.constructor.getDomain(t, {
              field: i.encoding[s].field,
              encoding: s,
              layerEncodings: i.encoding,
              transform: i.transform
            });
            o && o.length && (A[s] = o);
          }), this.domain(A);
        }
        this.normalizeText();
      }
      this.afterDataDidSet();
    }
    return this;
  }
  static shouldShowAxisTicksInPercentage() {
    return !1;
  }
  afterDataDidSet() {
  }
  createTransformConfig(t) {
    const i = this.config();
    if (!t || !i)
      return;
    const n = i.encoding;
    if (!n)
      return;
    const A = this.retrieveEncodingFields(
      n,
      t
    );
    this.encodingFieldsInf(A);
    const s = this.resolveTransformConfig(t), o = this.resolveOverrideTransformConfig(s);
    this._transformConfig = o, this._transformType = o.type;
  }
  resolveOverrideTransformConfig(t) {
    return t;
  }
  hasRangedValueAxis() {
    return !1;
  }
  static getOverrideTransformType(t) {
    return t;
  }
  static getTransformGroupByDimensions(t, i, n) {
    const { encoding: A } = t, s = [];
    for (let o in A) {
      let { field: r } = A[o];
      Fi(r).forEach((l) => {
        n.isDimension(l) && (i.includes(o) || s.push(l));
      });
    }
    return s;
  }
  static getStackConfig(t, i) {
    const {
      x: { field: n, as: A },
      y: { field: s, as: o }
    } = i.encoding, { independentField: r, dependentField: a } = Z9({
      x: {
        field: n,
        as: A,
        type: t.getField(n)?.type(),
        subtype: t.getField(n)?.subtype()
      },
      y: {
        field: s,
        as: o,
        type: t.getField(s)?.type(),
        subtype: t.getField(s)?.subtype()
      }
    });
    return {
      uniqueField: r,
      value: a
    };
  }
  static autoDetectTransformType(t, i, n) {
    if (!t.length)
      return En;
    if (i.uniqueField && i.value) {
      const A = i.value.field, { [A]: s } = Ql(n, [
        A
      ]);
      return s === qC ? Nt : gn;
    }
    return En;
  }
  static getDefaultTransformConfig(t, i) {
    const { transform: n = {} } = t, A = this.getTransformGroupByDimensions(
      t,
      ["x", "y", "x0", "y0"],
      i
    );
    let s = n.type, o = {
      ...n,
      groupBy: ft(n.groupBy, A)
    };
    const r = this.getStackConfig(i, t);
    return s || (s = this.autoDetectTransformType(
      A,
      r,
      i
    )), (s === Nt || s === Lt) && (o = {
      ...o,
      ...r
    }), {
      type: s,
      ...o
    };
  }
  resolveTransformConfig(t) {
    const i = this.config().transform;
    let n = {
      fields: []
    };
    const A = [
      yt.COLOR,
      yt.SIZE,
      yt.SHAPE,
      yt.TEXT,
      yt.DETAIL
    ], s = [yt.COLOR, yt.SIZE, yt.SHAPE], o = /* @__PURE__ */ new Set();
    for (let r = 0; r < A.length; r++) {
      const a = A[r], { field: l } = this.config().encoding[a] || {}, c = Fi(l), g = c && c[0], h = t.getField(g);
      if (h && h.type() === "dimension" && ft(i.groupBy, []).includes(g) && !o.has(g)) {
        let u;
        s.includes(a) ? u = this.axes()[a].sortValues(h.uniques()) : u = h.uniques(), n.fields.push({
          field: g,
          values: u
        }), o.add(g);
      }
    }
    return { ...i, sort: n };
  }
  retrieveEncodingFields(t, i) {
    return xM(t, i);
  }
  applyStyles({ styleObj: t, elem: i }, n) {
    const { styles: A, className: s } = t;
    s && i.classed(s, n.apply), this.applyElementStyles(i, A);
  }
  applyElementStyles(t, i) {
    for (let n in i)
      t.style(n, i[n]);
  }
  getBoundBoxes() {
    return null;
  }
  getOverlayPathMount() {
    return this._overlayMount ? this._overlayMount : (this._overlayMount = V(this.mount()).select(".muze-overlay-paths").node(), this._overlayMount);
  }
  static getRetinalFieldsDomain(t, i, n = { config: {} }, A) {
    const { config: s } = n, o = {};
    return ["color", "shape", "size", "backgroundColor"].forEach((r) => {
      const { field: a } = i[r];
      let l = i[r].as;
      if (a) {
        const c = t.getField(a);
        if (c) {
          let g = i[r].splitBy, h;
          l || (l = Ve(c));
          const u = pJ(
            s,
            r,
            a
          );
          if (u && Array.isArray(u.domain) && u.domain.length ? g ? h = {
            splitDomains: t.splitByRow([g]).reduce((f, I) => (f[I.getField(g).data()[0]] = u.domain, f), {})
          } : h = u.domain : g ? h = {
            splitDomains: t.splitByRow([g]).reduce((f, I) => (f[I.getField(g).data()[0]] = I.getField(a).domain(), f), {})
          } : h = t.getDomain(a, l), h && ((l === lt.CONTINUOUS || l === lt.DISCRETE && n.totals == null) && (o[a] = Object.assign({}, o[a], {
            [l]: h
          })), A.getField(a).subtype() !== c.subtype() && c.subtype() === it.CATEGORICAL))
            for (let f in o[a])
              o[a][f] = o[a][f].map(
                (I) => qn(I)
              );
        }
      }
    }), o;
  }
  requiresExtendDomainDiffs() {
    return !1;
  }
  /**
   * Each layer can calculate how much domain(or domain padding for discrete axis)
   * it needs to extend so that its plot does not get clipped out.
   * The default values are zeros. Any corresponding layer can
   * extend this method with the respective logic.
   * The values should be in pixel format.
   */
  calculateExtendDomainDiffs() {
    return {
      x: [0, 0],
      // [extra left pixel, extra right pixel],
      y: [0, 0]
      // [extra top pixel, extra bottom pixel]
    };
  }
  /**
   * @todo: Replace with appropriate lifecycle manager APIs.
   */
  postLayout() {
  }
  emitAllRenderHooksWhenRenderSkipped(t) {
    const i = fc(this, t);
    this.emitSelfHooks(
      [
        gt.BEFORE_RENDERED,
        gt.AFTER_RENDERED,
        gt.ANIMATION_END
      ],
      {
        virtualScrolling: {
          viewportRange: W(t, "viewportRange") || null,
          partialRange: {
            xRange: i.xRange,
            yRange: i.yRange
          }
        }
      }
    ), this._disposed && (this._axes = null, this._linkedElems = null);
  }
  emitAnimationEndHook(t) {
    const i = fc(this, t);
    this.emitSelfHooks(gt.ANIMATION_END, {
      virtualScrolling: {
        viewportRange: W(t, "viewportRange") || null,
        partialRange: {
          xRange: i.xRange,
          yRange: i.yRange
        }
      }
    });
  }
  computeCssStyle() {
    return zn(
      V(this.mount()),
      this.config().className
    );
  }
  cssStyle(...t) {
    return t.length ? (this._cssStyle = t[0], this) : this._cssStyle;
  }
  setSmartLabelStyleForRenderLayout() {
    const t = this.cssStyle();
    if (t) {
      const { smartLabel: i } = this.dependencies();
      i.setStyle(t);
    }
  }
  preRender(t, i = !0) {
    this.setSmartLabelStyleForRenderLayout();
    const n = fc(this, t);
    this.emitSelfHooks(gt.BEFORE_RENDERED, {
      virtualScrolling: {
        viewportRange: W(t, "viewportRange") || null,
        partialRange: {
          xRange: n.xRange,
          yRange: n.yRange
        }
      }
    }), i && t && this.updateViewableNormalizedData(t);
  }
  postRender(t) {
    const i = fc(this, t);
    this.emitSelfHooks(gt.AFTER_RENDERED, {
      virtualScrolling: {
        viewportRange: W(t, "viewportRange") || null,
        partialRange: {
          xRange: i.xRange,
          yRange: i.yRange
        }
      }
    });
  }
  data(...t) {
    if (t.length) {
      let i = t[0];
      i && this.createTransformConfig(i);
      let n = this._data;
      return this._cacheEnabled || (this._cachedData.splice(1, this._cachedData.length).forEach((s) => s.dispose()), n && n !== i && n.dispose()), this._data = i, this.dataDidSet([n, this._data]), this;
    }
    return this._data;
  }
  getBandScale() {
    return this._bandScale || (this._bandScale = MC.band()), this._bandScale;
  }
  axes(...t) {
    return t.length ? (this._axes = t[0], this) : this._axes;
  }
  measurement(...t) {
    return t.length ? (this._measurement = t[0], this) : this._measurement;
  }
  encodingFieldsInf(...t) {
    return t.length ? (this._encodingFieldsInf = t[0], this) : this._encodingFieldsInf;
  }
  encodingTransform(...t) {
    return t.length ? (this._encodingTransform = t[0], this) : this._encodingTransform;
  }
  dependencies(...t) {
    return t.length ? (this._dependencies = t[0], this) : this._dependencies;
  }
  dataProps(...t) {
    return t.length ? (this._dataProps = t[0], this) : this._dataProps;
  }
  reducedDataMap(...t) {
    return t.length ? (this._reducedDataMap = t[0], this) : this._reducedDataMap;
  }
  transformedData(...t) {
    return t.length ? (this._transformedData._data = t[0], this) : this._transformedData._data;
  }
  renderer(...t) {
    return t.length ? (this._renderer = t[0], this) : this._renderer;
  }
  interactionRegistry(...t) {
    return t.length ? (this._interactionRegistry = t[0], this) : this._interactionRegistry;
  }
  metaInf(...t) {
    return t.length ? (this._metaInf ? this._metaInf = Object.assign(this._metaInf, t[0]) : this._metaInf = t[0], this) : this._metaInf;
  }
  mount(...t) {
    if (t.length) {
      if (this._prevMount = this._mount, this._mount = t[0], this._mount !== this._prevMount && this.cssStyle(this.computeCssStyle()), this.data()) {
        const i = t[1];
        this.render(this._mount, i);
      }
      return this;
    }
    return this._mount;
  }
  getRenderableNormalizedData() {
    return this._viewableNormalizedData || this._normalizedData;
  }
  calculateViewableAxisDomains(t) {
    const { axisDomainRanges: i } = t, { x: n, y: A } = this.axes();
    let s = null, o = null;
    const r = n.config().orientation === "bottom" ? i.x[0] : i.x[1], a = A.config().orientation === "left" ? i.y[0] : i.y[1];
    if (r && (s = {
      domain: n.domain().slice(r.startIdx, r.endIdx + 1),
      range: r
    }), a) {
      const l = A.domain(), c = l.length - 1 - a.endIdx, g = l.length - 1 - a.startIdx;
      o = {
        domain: l.slice(c, g + 1),
        range: a
      };
    }
    return {
      x: s,
      y: o
    };
  }
  updateViewableNormalizedData(t) {
    if (!t.axisDomainRanges)
      return;
    const { x: i, y: n } = this.calculateViewableAxisDomains(t);
    let A = this._normalizedData;
    if (i) {
      const s = i.domain;
      A = A.map(
        (o) => o.filter((r) => wf(s, r.x))
      );
    }
    n && (A = A.map(
      (s) => s.filter((o) => wf(n.domain, o.y))
    )), this._viewableNormalizedData = A;
  }
  valueParser(...t) {
    return t.length ? (this._valueParser = t[0] || ((i) => i), this) : this._valueParser;
  }
  config(...t) {
    if (t.length) {
      const i = t[0];
      this._customConfig = i;
      const n = this.constructor, A = tt({}, n.defaultConfig()), s = n.defaultPolicy(A, i);
      return this._config = s, this;
    }
    return this._config;
  }
  getPointsWithinRange(t) {
    return this._rtree.search(t);
  }
  cachedData() {
    return this._cachedData;
  }
  getPlotElementsByEffectKey(t) {
    const i = this._graphicElems, n = [];
    for (let A in i) {
      const { meta: s } = i[A].data()[0];
      s.lastInteraction.includes(t) && n.push(i[A]);
    }
    return n;
  }
  getAllEncodingFields() {
    const { encoding: t } = this.config();
    return Object.keys(t).map((n) => t[n].field).filter((n) => !!n).flat();
  }
  getAllAssociatedFields() {
    const t = this.getAllEncodingFields(), i = Object.keys(this.metaInf().facets || {});
    return [.../* @__PURE__ */ new Set([...t, ...i])];
  }
  getOverlayPathByEffectKey(t) {
    const i = this._overlayPath, n = this._graphicElems, A = [];
    for (let s in n) {
      const { meta: o, rowId: r } = n[s].data()[0];
      o.lastInteraction.includes(t) && i[r] && A.push(i[r]);
    }
    return A;
  }
  formatTextLabelWithDefaultFormatter(t) {
    const { textField: i } = this.encodingFieldsInf(), { useUTC: n } = this.config();
    return Qp(
      t,
      this.valueParser(),
      i,
      this.dataProps().timeDiffs,
      { useUTC: n },
      this.data(),
      null,
      this
    );
  }
  formatTextLabelWithDisplayAsFormatter(t) {
    const { textField: i } = this.encodingFieldsInf(), { useUTC: n } = this.config(), A = this.config().encoding.text.displayAs;
    return Qp(
      t,
      this.valueParser(),
      i,
      this.dataProps().timeDiffs,
      { useUTC: n },
      this.data(),
      A,
      this
    );
  }
  isUnivariate() {
    const t = this.encodingFieldsInf(), { xField: i, yField: n } = t;
    return i === bt && n === bt;
  }
  textPointsInfo(...t) {
    return t.length ? (this._textPointsInfo = t[0], this) : this._textPointsInfo;
  }
  hasTextEncodingField() {
    const { textField: t } = this.encodingFieldsInf();
    return !!t;
  }
  renderTextPoints(t, i) {
    const { classPrefix: n } = this.config(), { location: A } = i, s = this.filterTextPoints(i);
    s.forEach((a) => {
      const l = a.text, [c, g] = Si.getLabelPosition(a, A);
      l.originalPosition = {
        x: l.update.x,
        y: l.update.y
      }, l.update.x = c, l.update.y = g;
    });
    const o = s.map((a) => a.text), { elems: r } = GM(this, t.node(), o, {
      groupClassName: (a) => `${n}-layer-${this.constructor.formalName()}-label-${a.rowId}`
    });
    this.mergeTextLinkedElems(r), s.forEach((a) => {
      const l = a.text;
      l.originalPosition && (l.update.x = l.originalPosition.x, l.update.y = l.originalPosition.y, l.originalPosition = null);
    });
  }
  filterTextPoints(t) {
    const { points: i } = t;
    return i.filter((n) => !n.isLabelThinned && !!n.text && n.text.text !== "");
  }
  mergeTextLinkedElems(t) {
    this._linkedElems = {
      ...this._linkedElems,
      text: Object.assign({}, this._linkedElems.text, t)
    };
  }
  calculateOptimumTextLabelDimensions() {
    const { smartLabel: t } = this.dependencies(), { textFieldSubType: i } = this.encodingFieldsInf(), { style: n, encoding: A } = this.config(), { charsAcross: s } = A.text, o = Fg(s.max, "W"), r = Fg(s.min, "W");
    t.setStyle(n);
    const { width: a, height: l } = t.getOriSize(
      o
    ), c = this.largestTextLabel() || r, { width: g, height: h } = t.getOriSize(c);
    let u = g, d = h;
    return i === fu && (u = Math.min(u, a), d = Math.min(d, l)), {
      width: u,
      height: d
    };
  }
  // calculateOptimumSingleCharDimensions() {
  //   const { smartLabel } = this.dependencies();
  //   const { textFieldType } = this.encodingFieldsInf();
  //   const { style } = this.config();
  //   const optimumChar = textFieldType === "measure" ? "9" : "W";
  //   smartLabel.setStyle(style);
  //   const { width, height } = smartLabel.getOriSize(optimumChar);
  //   return {
  //     width,
  //     height,
  //   };
  // }
  /**
   * It represents the maximum number of text values in a single cell
   * of a pivot table.
   */
  cellMaxCount(...t) {
    return t.length ? (this._cellMaxCount = t[0], this) : this._cellMaxCount;
  }
  getNeighbourPointIndexForContinuationInVirtualScroll(t) {
    return t;
  }
  isVertical() {
  }
  includeDataFromAllLayersInTooltip() {
    return !1;
  }
};
class AA extends _e(BS).with(
  zs,
  a_
) {
  /**
   * Determines a name for a layer. This name of the layer is used in the input data to refer to this layer.
   * ```
   *  .layers([
   *      mark: 'bar',
   *      encoding: { ... }
   *  ])
   * ```
   *
   * @static
   * @public
   *
   * @return {string} name of layer
   */
  static formalName() {
    return AS;
  }
}
const $9 = (e) => !!(/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(e) && /[\dz]$/i.test(e) && e.length > 4), jf = function(e, t) {
  const { shape: i, size: n, update: A, style: s } = e;
  if (i instanceof Promise)
    i.then((o) => {
      e.shape = o, jf(e, t);
    });
  else if (i instanceof Element) {
    let o = i.cloneNode(!0);
    if (o.nodeName.toLowerCase() === "img") {
      const a = o.src || o.href;
      o = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "image"
      ), o.setAttribute("href", a);
    }
    const r = V(o);
    o.nodeName === "path" || o.nodeName === "image" ? r.attr("transform", `scale(${n / 100})`) : (r.attr("height", n), r.attr("width", n)), r.attr("x", -n / 2), r.attr("y", -n / 2), j(t, () => o, [1]);
  } else if (typeof i == "string") {
    let o;
    $9(i) ? o = i : o = Bl(i).size(n * n * Math.PI)(A);
    const r = j(t, "path", (a) => [a]).attr(
      "d",
      o
    );
    Pt(r, s);
  } else
    e.shape = "circle", jf(e, t);
}, Lp = (e, t) => {
  const i = e.config().encoding.text, { width: n, height: A } = e.measurement(), { smartLabel: s } = e.dependencies(), o = Si.getUniquePositionedPoints(
    t,
    "sum"
  ), r = Si.thinVoronoi(
    n,
    A,
    s,
    o,
    "sum"
  );
  if (!i.labelPlacement) {
    Si.placeInside(
      n,
      A,
      s,
      o,
      "sum"
    );
    const a = 100, l = s.getOriSize("X").height, c = o.length < a && o.every(
      (g) => (g.size === void 0 ? 0 : g.size) < l
    );
    Si.placeVoronoi(
      n,
      A,
      s,
      o,
      r,
      c,
      "sum"
    );
  }
  Si.thinFinally(
    n,
    A,
    s,
    o,
    "sum"
  );
}, l_ = (e) => {
  const {
    layer: t,
    container: i,
    points: n,
    transition: A,
    animationAggregator: s,
    className: o,
    saveGraphicElems: r = !0
    // drawText = true,
  } = e, { duration: a, effect: l, disabled: c } = A, g = V(i), h = t._graphicElems;
  if (g.attr("class", o), t.hasTextEncodingField())
    if (t._stackedSum.size) {
      const u = t.getTextPointsForStackSum();
      Lp(t, n), t.textPointsInfo({
        points: u,
        location: "text"
      });
    } else
      Lp(t, n), t.textPointsInfo({
        points: n,
        location: "sum"
      });
  else
    t.textPointsInfo(null);
  return j(
    g,
    "g",
    n,
    null,
    {
      enter: (u, d) => {
        const { enter: f } = d;
        u.attr("transform", `translate(${f.x},${f.y})`);
      },
      update: (u, d) => {
        jf(d, u), r && (h[d.rowId] = u);
        const { update: f, style: I } = d;
        yC(I, (C) => u.style(C, I[C])), u.attr("class", o), u.classed(d.className, !0), c || (u = u.transition().duration(A.duration).on("end", s.newCallback())), u.attr("transform", `translate(${f.x},${f.y})`).style("visibility", "visible");
      },
      exit: (u) => {
        c ? u.style("visibility", "hidden") : u.transition().ease(El[l]).duration(a).on("end", () => u.style("visibility", "hidden")).style("fill-opacity", 0).style("stroke-opacity", 0), u.remove();
      }
    },
    e.keyFn
  );
}, X9 = _i.line, tK = (e) => {
  const { update: t } = e;
  return t.y !== null && t.x !== null;
}, Up = (e) => {
  const { x: t, y: i } = e ? e.update : {};
  return t === null || i === null;
}, eK = (e, t, i) => {
  const n = Up(e[t - 1]), A = Up(e[t + 1]);
  !n && i.prevOfNull.push(t - 1), !A && i.nextOfNull.push(t + 1);
}, iK = (e) => {
  const t = {
    prevOfNull: [],
    nextOfNull: []
  };
  return e.forEach((i, n) => {
    const { update: A } = i;
    (A.y === null || A.x === null) && eK(e, n, t);
  }), t;
}, nK = (e, t) => {
  const i = [], { prevOfNull: n, nextOfNull: A } = t, s = n.length;
  if (!s)
    return i;
  for (let o = 0; o < s; o++) {
    const r = [], a = e[n[o]], l = e[A[o]];
    a && r.push(a), l && r.push(l), i.push(r);
  }
  return i;
}, c_ = (e) => {
  const t = iK(e);
  return nK(e, t);
}, Ea = (e, t, i) => e.id() + "-gradient-" + t._gradientId + "-" + i._gradientId, Op = (e) => e && !e.isNull && e.update.y !== e.update.y0, Hp = (e, t, i, n, A = {}) => {
  const { defsClassName: s } = A, r = j(
    i,
    "defs",
    [1],
    s || "linear-gradients-container"
  ), a = e.map(([l, c]) => {
    const g = Ea(t, l, c), h = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "linearGradient"
    ), [u, d] = [l, c].map((C) => n(C)), [f, I] = [u, d].map((C, E) => {
      const B = document.createElement("stop");
      return B.setAttribute("stop-color", `${C}`), B.setAttribute("offset", `${E === 0 ? 0 : 100}%`), B;
    });
    return [f, I].forEach((C) => h.appendChild(C)), l.update.x && c.update.x && l.update.y && c.update.y ? `<linearGradient id="${g}" x1=${l.update.x} x2=${c.update.x} y1=${l.update.y} y2=${c.update.y} gradientUnits="userSpaceOnUse">` + h.innerHTML + "</linearGradient>" : "";
  });
  r.node().innerHTML = a.join(`
`);
}, Pp = (e) => {
  const {
    mount: t,
    data: i,
    className: n,
    layer: A,
    strokeStyle: s,
    linePathFn: o,
    transition: r,
    animationAggregator: a,
    updateFns: l
  } = e;
  let c = r.disabled;
  const g = A.config().encoding.size.field;
  let h = j(
    t,
    "path",
    i.length ? [i] : [],
    n,
    l
  );
  return h.attr("class", (d, f) => d[f].className), Pt(h, { ...s, "fill-opacity": g ? 1 : 0 }), g && (c = !0), c || (h = h.transition().duration(r.duration), h.empty() || (h = h.on("end", a.newCallback()))), h.attr("d", o(i)), h;
}, AK = (e) => {
  const {
    layer: t,
    containerSelection: i,
    mount: n,
    points: A,
    linePathFn: s,
    transition: o,
    animationAggregator: r,
    strokeStyle: a,
    connectNullData: l,
    className: c,
    nullDataLineClass: g
  } = e, h = t._graphicElems, u = {
    update: (I, C) => {
      C.forEach((E) => {
        h[E.rowId] = i;
      });
    }
  }, d = Pp({
    mount: n,
    data: A,
    strokeStyle: void 0,
    layer: t,
    linePathFn: s,
    transition: o,
    animationAggregator: r,
    updateFns: u
  });
  return c_(A).map((I) => (l && I.length > 1 && Pp({
    mount: n,
    data: I,
    strokeStyle: a,
    className: `.${c}-${g}`,
    layer: t,
    linePathFn: s,
    transition: o,
    animationAggregator: r,
    updateFns: u
  }), null)), d;
}, sK = (e) => {
  const {
    layer: t,
    containerSelection: i,
    mount: n,
    points: A,
    style: s,
    linePathFn: o,
    connectNullData: r,
    getColorAxis: a
  } = e, l = [];
  A.map((u) => ({ ...u, _gradientId: Ut() })).forEach((u, d) => {
    const f = A[d + 1];
    Op(u) && Op(f) && l.push([u, f]);
  });
  const c = (u) => {
    const d = a(t, { dataObj: u.data }), { colorField: f } = t.encodingFieldsInf();
    return d.getColor(u.data[f]);
  };
  Hp(l, t, n, c);
  const g = j(i, "g", [1], ".lines");
  if (j(
    g,
    "path",
    l,
    ".muze-gradient-line-path"
  ).attr("d", (u) => o(u)).attr("fill", (u) => `url(#${Ea(t, u[0], u[1])})`).attr("stroke", (u) => `url(#${Ea(t, u[0], u[1])})`).classed("muze-gradient-line-path", !0), r) {
    const u = j(
      i,
      "g",
      [1],
      ".sanitized-point-lines"
    ), d = c_(A).map(
      (I) => Array.isArray(I) ? I.map((C) => ({ ...C, _gradientId: Ut() })) : { ...I, _gradientId: Ut() }
    ), f = d.map((I) => I).filter((I) => I.length === 2);
    Hp(f, t, n, c, {
      defsClassName: "linear-gradients-container-for-sanitized-points"
    }), d.forEach((I) => {
      I.length > 1 && u.selectAll().data(f).enter().append("path").attr("d", (C) => o(C)).attr("fill", (C) => `url(#${Ea(t, C[0], C[1])})`).attr("stroke", (C) => `url(#${Ea(t, C[0], C[1])})`).classed("muze-gradient-line-path", !0);
    });
  }
  return ih(n, s), null;
}, oK = (e, t = {}) => {
  const {
    layer: i,
    container: n,
    points: A,
    interpolate: s,
    className: o,
    style: r,
    disconnectedPointsGroupClassName: a
  } = e, l = V(n), c = i.config().nullDataLineStyle, g = i.config().nullDataLineClass, h = l.attr("class", o), u = ml[s], { isGradient: d } = t, f = NE(A).map((B) => ({
    ...B,
    enter: {
      ...B.update
    },
    style: r
  })), I = j(
    l,
    "g",
    [1],
    `.${a}`
  ).node();
  l_({
    ...e,
    points: f,
    container: I,
    className: a,
    drawText: !1,
    saveGraphicElems: !1
  });
  const C = i.config().encoding.size, E = C && C.field ? (B) => new rK().x((y) => y.update.x).y((y) => y.update.y).size((y) => y.size).defined((y) => y.update.x && y.update.y).pathStr(B) : X9().curve(u).x((B) => B.update.x).y((B) => B.update.y).defined(tK);
  return d ? sK({
    ...e,
    linePathFn: E,
    containerSelection: l,
    style: r,
    mount: h
  }) : AK({
    ...e,
    linePathFn: E,
    containerSelection: l,
    nullDataLineClass: g,
    strokeStyle: c,
    mount: h
  });
};
class rK {
  constructor() {
    this.xFn = () => 0, this.yFn = () => 0, this.sizeFn = () => 1, this.definedFn = () => !0;
  }
  x(t) {
    return this.xFn = t, this;
  }
  y(t) {
    return this.yFn = t, this;
  }
  size(t) {
    return this.sizeFn = t, this;
  }
  defined(t) {
    return this.definedFn = t, this;
  }
  point({ x1: t, y1: i, size1: n, x2: A, y2: s, size2: o, path: r }) {
    const a = n / 2, l = o / 2;
    let c = i - s, g = A - t;
    if (g || c) {
      const h = Math.sqrt(g * g + c * c), u = g / h, d = c / h, f = d * a, I = u * a, C = d * l, E = u * l, B = Math.atan2(g, c);
      r.moveTo(t - f, i - I), r.lineTo(A - C, s - E), r.arc(A, s, l, B - Math.PI, B), r.lineTo(t + f, i + I), r.arc(t, i, a, B, B + Math.PI);
    } else
      r.arc(A, s, l, 0, Math.PI * 2);
    return r.closePath(), r;
  }
  pathStr(t) {
    let i = nu.path(), n, A, s, o = !1;
    return t.forEach((r, a) => {
      let l = !1;
      if (!this.definedFn(r, a, t) === o && (o = !o, o && (l = !0)), o) {
        let c = +this.xFn(r, a, t), g = +this.yFn(r, a, t), h = +this.sizeFn(r, a, t);
        i = l ? i : this.point({
          x1: n,
          y1: A,
          size1: s,
          x2: c,
          y2: g,
          size2: h,
          path: i
        }), n = c, A = g, s = h;
      }
    }), i.toString();
  }
}
const aK = {
  classPrefix: en,
  defClassName: "layer-line",
  className: "",
  interpolate: "linear",
  transform: {},
  interaction: {
    select: {
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  {
                    target: "exitSet",
                    style: {
                      fill: { a: -0.5 }
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "exitSet",
              style: {
                stroke: { a: -0.8 }
              }
            },
            {
              target: "entrySet",
              style: {
                stroke: { a: 0.8 }
              }
            }
          ]
        },
        "persistent-line-anchors": {}
      }
    },
    highlight: {
      sideEffects: {
        "line-anchors": {}
      }
    },
    brush: {
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "exitSet",
              style: {
                stroke: { a: -0.5 }
              }
            }
          ]
        },
        "brush-line-anchors": {}
      }
    }
  },
  crossline: !0,
  nearestPointThreshold: 5,
  encoding: {
    color: {},
    x: {},
    y: {},
    size: {},
    text: {
      ...$s,
      labelPlacement: {
        anchors: [Je, Xn, ji, hi]
      }
    }
  },
  transition: {
    effect: "cubic",
    duration: 1e3
  },
  connectNullData: !1,
  nullDataLineStyle: {},
  nullDataLineClass: "null",
  highlightExactPoint: !1,
  detectHoverOnEmptyArea: !0,
  interactive: !0
};
const lK = (e, t, i, n, A, s) => {
  t = t || { x: i.x, y: i.y }, n = n || { x: i.x, y: i.y };
  const { size: o = 0, text: r } = A, a = cK(
    s,
    t,
    i,
    n,
    e
  ), { smartLabel: l } = e._dependencies, c = new kE(l), g = {
    positionAt: a,
    rotation: i.rotation
  }, { xPos: h, yPos: u } = RE(
    r,
    { x: i.x, y: i.y, size: o / 2 },
    g,
    c
  ), d = {
    x: h,
    y: u,
    textAnchor: "middle"
  }, { width: f } = e.measurement(), { width: I } = l.getOriSize(r), { x: C, textAnchor: E } = d;
  return E === "start" ? C + I > f && (d.textAnchor = "end") : E === "middle" ? C + I / 2 > f ? d.textAnchor = "end" : C - I / 2 < 0 && (d.textAnchor = "start") : E === "end" && C - I < 0 && (d.textAnchor = "start"), d;
}, cK = (e, t, i, n, A) => {
  const s = [];
  let o = e.find((r) => {
    switch (r) {
      case mn:
        return !0;
      case Je:
      case dr: {
        if (i.y <= t.y && i.y <= n.y)
          return !0;
        break;
      }
      case Xn:
      case Ir: {
        if (i.y >= t.y && i.y >= n.y)
          return !0;
        break;
      }
      case ji:
      case Cr: {
        if (i.x < t.x && i.x < n.x)
          return !0;
        s.push(ji);
        break;
      }
      case hi:
      case fr: {
        if (i.x > t.x && i.x > n.x)
          return !0;
        s.push(hi);
        break;
      }
      default:
        return !1;
    }
  });
  if (o === void 0 && s.length > 0) {
    if (!gK(s))
      return s[0];
    const { y: r } = A.axes(), a = Math.abs(
      (i.y - t.y) / (i.x - t.x)
    ), l = Math.abs(
      (n.y - i.y) / (n.x - i.x)
    );
    r instanceof ee || r instanceof qt ? o = l > a ? ji : hi : o = a > l ? ji : hi;
  }
  return o !== void 0 ? o : e[0];
}, gK = (e) => {
  let t = !1, i = !1;
  return e.every((n) => (t = t || n === ji, i = i || n === hi, !(t && i))), t && i;
}, hK = (e, t, i, n) => {
  const A = n.getUnitWidth();
  let s = i[t];
  return (t === "x" && !e || t === "y" && e) && (s = i[t] > 0 ? i[t] : i[`${t}0`]), n.isYAxis() && n.constructor.type() === ce ? n.getScaleValue(s) - A / 2 : n.getScaleValue(s) + A / 2;
}, uK = (e, t, i, n) => {
  const A = n.getUnitWidth();
  return n.isYAxis() && n.constructor.type() === ce ? n.getScaleValue(i[t]) - A / 2 : n.getScaleValue(i[t]) + A / 2;
}, g_ = (e, t, i, n) => {
  for (const A in t)
    if (Object.hasOwnProperty.call(t, A)) {
      let s, o;
      const r = t[A];
      we(r) ? (e[A] = {}, g_(e[A], r, i, n)) : typeof r == "string" && (s = r.split(".")) && s[0] === n ? (o = W(i, ...s.slice(1, s.length)), o !== void 0 && (e[A] = o)) : e[A] = r;
    }
}, kd = (e) => {
  for (const t in e) {
    const i = e[t];
    (typeof i == "string" || Array.isArray(i)) && (e[t] = {
      field: i
    });
  }
}, Bi = (() => {
  const e = {}, t = {
    setLayerRegistry: (i) => {
      t._layerRegistry = i;
    },
    getSerializedConf: (i, n) => {
      let A;
      const s = e[i], o = tt({}, n);
      if (s)
        A = s.map((r) => {
          const a = {};
          return g_(a, r, o, i), kd(a.encoding), a;
        });
      else {
        const r = o.encoding;
        kd(r), A = o;
      }
      return A;
    },
    getLayerInstance: (i, n, ...A) => {
      const s = t._layerRegistry;
      i = Array.isArray(i) ? i : [i];
      const o = i.map((r) => s[r.mark].create(
        ...A,
        n ? n() : null
      ));
      return o.length === 1 ? o[0] : o;
    },
    getLayerClass: (i) => t._layerRegistry[i],
    /**
     * Registers a new composite layer definition in the layer factory.
     *
     * @public
     *
     * @param {string} layerType Mark type of the new composite layer.
     * @param {Array} layerDefs Layer definitions of the composite layer.
     */
    composeLayers: (i, n) => {
      e[i] = n;
    },
    sanitizeLayerConfig: (i) => {
      const n = tt({}, i);
      kd(n.encoding);
      const { encoding: A } = n;
      if (A) {
        const s = A.detail && A.detail.field ? A.detail.field : void 0;
        Array.isArray(s) ? n.encoding.detail = { field: s } : typeof s == "string" ? n.encoding.detail = { field: [s] } : n.encoding.detail = {};
      } else
        n.encoding = {};
      return n;
    }
  };
  return t;
})();
class ku extends Tr {
  constructor(...t) {
    super(...t), this._layerInstances = [], this.addAnchorLayers();
  }
  static target() {
    return "visual-layer";
  }
  static defaultConfig() {
    return {
      className: "muze-anchors-group"
    };
  }
  static formalName() {
    return "line-anchors";
  }
  addAnchorLayers() {
    const i = this.firebolt.context.config().encoding, n = {
      x: i.x,
      y: i.y,
      color: i.color,
      size: {
        field: W(i, "size", "field"),
        as: i.size.as,
        value: () => this.defaultSizeValue()
      }
    }, A = this.constructor.defaultConfig().className, o = {
      name: `${this.constructor.formalName()}-upper`,
      mark: "point",
      className: `${A}-upper`,
      encoding: n,
      transform: {
        type: "identity"
      },
      transition: this.getTransitionConfig(),
      source: () => new J({ data: [[]], schema: [] }),
      interactive: !1
    };
    this._layerInstances = [this.createLayerInstance(o)];
  }
  createLayerInstance(t) {
    const i = Bi.getLayerInstance(t, null), n = this.firebolt.context, A = n.metaInf();
    return i.config(t).metaInf({
      unitRowIndex: A.rowIndex,
      unitColIndex: A.colIndex,
      namespace: `${A.parentNamespace}-${t.mark}-${Ut()}`,
      parentNamespace: A.parentNamespace
    }).dependencies(n._dependencies).store(n.store()), i;
  }
  getTransitionConfig() {
    return {
      disabled: !0
    };
  }
  /**
   * Returns the default area value of the anchor point.
   * @return { number } Default area value of anchor.
   */
  defaultSizeValue() {
    return 5;
  }
  // Default offset by which anchor size is changed
  getAnchorSizeOnInteraction({ dragEnd: t }) {
    return t ? 2 : 0;
  }
  apply(t, i, n) {
    const A = t.entrySet.model, s = A._model._config;
    if (A === null || i.criteria === null || !this.firebolt.context.mount())
      return this._layerInstances.forEach((c) => {
        c.mount() && (c.data() && c.data().dispose(), c.data(new J({ data: [[]], schema: [] })).mount(c.mount()));
      }), this;
    const o = this.constructor.formalName(), r = this.firebolt.context, { target: a } = i;
    let l = null;
    a && (l = a[1].reduce((c, g, h) => {
      const u = a[0][h];
      return c[u] = g, c;
    }, {})), this._layerInstances.forEach((c, g) => {
      const h = c.config(), u = r, d = u.constructor.formalName(), f = h.name, I = f === `${o}-upper`;
      let C = [], E = [];
      if ([C, E] = u.getTransformedDataFromIdentifiers(
        t.entrySet.uids,
        g
      ), d === "area" && a && n.behaviour === "highlight" && !I) {
        const Q = Mr(a, A), p = A.select(Q);
        [C, E] = u.getTransformedDataFromIdentifiers(
          p.getUids(),
          g
        ), p.dispose();
      }
      c.data() && c.data().dispose();
      const B = new J(
        {
          data: C,
          schema: E.filter((Q) => Q.name !== St.ROW_ID)
        },
        s
      );
      B._alias = "anchors";
      const m = {
        encoding: {
          size: {
            value: () => this.defaultSizeValue() + this.getAnchorSizeOnInteraction(i)
          },
          "stroke-width": {
            value: this.getAnchorStroke(i, l)
          },
          stroke: {
            value: "black"
          }
        }
      }, y = tt(h, m), D = j(u.mount(), "g", [1], f);
      return c.axes(u.axes()).data(B).config(y).dataProps(u.dataProps()).mount(D.node()), this;
    });
  }
  getAnchorStroke(t, i) {
    return (n) => {
      const A = n.data;
      return (i ? Object.keys(i).filter((o) => o !== St.ROW_ID).every((o) => A[o] === i[o]) : !1) ? "1px" : "0px";
    };
  }
}
class dK extends ku {
  static formalName() {
    return "persistent-line-anchors";
  }
  getAnchorSizeonInteraction() {
    return 50;
  }
  getAnchorStroke() {
    return "2px";
  }
}
class fK extends ku {
  static formalName() {
    return "brush-line-anchors";
  }
  getAnchorSizeonInteraction() {
    return 50;
  }
  getAnchorStroke(t) {
    return t.dragEnd ? "2px" : "1px";
  }
}
const Yp = _i.line, IK = (e, t) => {
  const i = `muze-${t.id()}-borders-container`, n = t.isVerticalArea(), A = n ? "y" : "x0", s = n ? "y0" : "x";
  let o = V(i);
  o.node() || (o = j(
    t.mount(),
    "g",
    [1],
    ".muze-area-borders-container"
  ), o.attr("id", i));
  const [r, a] = e, l = "positive", c = "negative", g = "upper", h = "lower", u = "area-borders", d = { [g]: A, [h]: s }, { interpolate: f } = t.config(), I = ml[f];
  [
    { points: r, id: l },
    { points: a, id: c }
  ].map(({ points: C = [], id: E }) => {
    [g, h].map((B) => {
      const m = `${t.id()}-${B}-${E}`, y = n ? Yp().curve(I).x((Q) => Q.update.x).y((Q) => Q.update[d[B]]).defined((Q) => Q.includeInBorder) : Yp().curve(I).x((Q) => Q.update[d[B]]).y((Q) => Q.update.y).defined((Q) => Q.includeInBorder);
      let D = V(`.muze-${m}`);
      D.node() || (D = j(
        o.node(),
        "path",
        C.length ? [C] : [],
        `.muze-${m}`
      ), D.attr("id", m)), D.classed(`${u}`, !0), D.classed(`${IS}`, !0), D.attr(
        "d",
        y(
          C.map((Q) => ({
            ...Q,
            includeInBorder: !Q.isNull
          }))
        )
      );
    });
  });
};
class Tu extends ku {
  static formalName() {
    return "area-anchors";
  }
  addAnchorLayers() {
    super.addAnchorLayers();
    const t = this.constructor.formalName(), n = this.firebolt.context.config().encoding, A = {
      x: n.x,
      y: n.y,
      color: n.color,
      size: {
        field: W(n, "size", "field"),
        as: n.size.as,
        value: () => this.defaultSizeValue()
      }
    }, s = this.constructor.defaultConfig().className, o = {
      name: `${t}-lower`,
      mark: "point",
      className: `${s}-lower`,
      encoding: A,
      transform: {
        type: "identity"
      },
      transition: this.getTransitionConfig(),
      source: () => new J({ data: [[]], schema: [] }),
      interactive: !1
    };
    this._layerInstances.push(this.createLayerInstance(o));
  }
}
class CK extends Tu {
  static formalName() {
    return "persistent-area-anchors";
  }
  getAnchorSizeonInteraction() {
    return 50;
  }
  getAnchorStroke() {
    return "2px";
  }
}
class EK extends Tu {
  static formalName() {
    return "brush-area-anchors";
  }
  getAnchorSizeonInteraction() {
    return 50;
  }
  getAnchorStroke(t) {
    return t.dragEnd ? "2px" : "1px";
  }
}
class BK extends Tu {
  static formalName() {
    return "area-borders";
  }
  apply(t, i) {
    const { context: n } = this.firebolt, { metaData: A } = i;
    let s = [];
    return A && A.borderPoints && (A.layerId && A.layerId === n.id()) && s.push(A.borderPoints.data), IK(s, n), this;
  }
}
const jE = (e) => class extends e {
  /**
   * Creates an instance of LineLayer.
   *
   * @param {*} args
   * @memberof LineLayer
   */
  constructor(...t) {
    super(...t), this._voronoi = new DC(), this._rtree = null, this._mainColorProp = "stroke", this._hasSingleElementForMultipleDataPoints = !0, this._pathPoints = [];
  }
  static formalName() {
    return "line";
  }
  elemType() {
    return "path";
  }
  /**
   * Default configuration of line layer
   * @return {Object} Default configuration of layer
   */
  static defaultConfig() {
    return aK;
  }
  // static defaultPolicy(conf, userConf) {
  //   const config = super.defaultPolicy(conf, userConf);
  //   const encoding = config.encoding;
  //   const transform = config.transform;
  //   const colorField = encoding.color && encoding.color.field;
  //   if (colorField && !transform.groupBy) {
  //     transform.groupBy = colorField;
  //   }
  //   return config;
  // }
  /**
   * Returns the draw method for line
   * @return {Function} Draw method of line layer
   */
  getDrawFn() {
    return oK;
  }
  static shouldDrawAnchors() {
    return !0;
  }
  optimizeTextLabelPositions(t) {
    t = t.filter((A) => !!A.text);
    const i = this.config().encoding.text, n = vM(i);
    for (let A = 0; A < t.length; A++) {
      const s = t[A], o = t[A - 1], r = t[A + 1], { x: a, y: l, textAnchor: c } = lK(
        this,
        o ? { x: o.text.update.x, y: o.text.update.y } : null,
        { x: s.text.update.x, y: s.text.update.y },
        r ? { x: r.text.update.x, y: r.text.update.y } : null,
        {
          size: s.size,
          text: s.text.text
        },
        n
      );
      s.text.update.x = a, s.text.update.y = l, s.text.textAnchor = c;
    }
    return t;
  }
  /**
   * Generates the x and y positions for each point
   * @param {Array} data Data Array
   * @param {Object} encoding Visual Encodings of the layer
   * @param {Object} axes Contains the axis
   * @param {number} seriesIndex index of series
   * @return {Array} Array of points
   */
  translatePoints(t, i, n) {
    let A = [];
    const s = this.axes(), o = this.config().encoding, r = s.x, a = s.y;
    bl(t, s);
    const l = s.x instanceof ee || s.x instanceof qt, c = s.y instanceof ee || s.y instanceof qt, g = this.isVerticalLine();
    let h;
    return this.transformType() === Nt ? h = hK : h = uK, t.forEach((u, d) => {
      const f = h(
        g,
        "x",
        {
          x: u.x,
          x0: u.x0
        },
        r
      ), I = h(
        g,
        "y",
        {
          y: u.y,
          y0: u.y0
        },
        a
      ), C = In(this, u), E = Fl(this, u), B = C.getColor(u.color), m = nA(this, {
        translatedValues: {
          x: f,
          y: I,
          color: B,
          text: u.text,
          formattedText: u.formattedText,
          size: o.size ? E.getSize(u.size) : void 0
        },
        datum: u,
        datumIdx: d,
        groupData: t,
        groupIdx: i,
        layerData: n
      }), y = {
        stroke: m.color
      };
      let D;
      this.hasTextEncodingField() && (D = Xs(
        this,
        {
          x: m.x,
          y: m.y,
          text: m.text,
          formattedText: m.formattedText,
          color: bu.textColor
        },
        u,
        d,
        t
      ));
      const Q = vs(
        {
          x: m.x,
          y: m.y,
          text: m.text
        },
        d,
        u,
        this
      ), p = {
        enter: {},
        update: {
          x: !l && J.isInvalid(u.x) ? null : m.x,
          y: !c && J.isInvalid(u.y) ? null : m.y
        },
        style: y,
        rowId: u.rowId,
        source: u.source,
        data: u.dataObj,
        meta: Nn(y),
        normalizedData: u,
        size: m.size,
        text: D,
        rotation: Q
      };
      p.className = iA(u, d, t, this), A.push(p), this.cachePoint(u.rowId, p);
    }), this.hasTextEncodingField() && (A = this.optimizeTextLabelPositions(A)), A = Zs(this, A), A = A.filter((u) => {
      const { update: d } = u;
      return !isNaN(d.x) && !isNaN(d.y);
    }), A;
  }
  getTranslatedData(t, i) {
    const n = this._transformConfig.groupBy, A = t.filter((s) => s.length);
    return A.map((s, o) => {
      let r, a = s[0].color;
      const l = n.map(
        (h) => s[0].dataObj[h]
      ), c = l.length ? l : [this.id()];
      i ? r = i(s, o, t) : (a = J.getActualValue(a), r = In(this, s[0]).getColor(a));
      const g = this.getPathStyle(r);
      return {
        data: this.translatePoints(s, o, A),
        style: g,
        meta: Nn(g),
        id: c
      };
    });
  }
  isGradientLine() {
    const {
      x: t,
      y: i,
      color: n
    } = this.config().encoding, { xFieldSubType: A, yFieldSubType: s, colorFieldSubType: o } = this.encodingFieldsInf();
    if (!n || n.value)
      return !1;
    const r = n.field, a = this.axes().color, l = a instanceof mr ? a.config().type : Object.values(a)[0].config().type, c = this.isVerticalLine(), g = c ? A : s, h = c ? t.field : i.field;
    return l === "linear" || r === h && o === g;
  }
  isPartialRenderingEnabled() {
    const { mark: t } = this.config();
    return t === "line" && this.isGradientLine();
  }
  /**
   * Renders the line plot
   * @param {SVGElement} container svg element
   * @return {LineLayer} instance of line layer
   */
  render(t, i) {
    this.preRender(i, this.isPartialRenderingEnabled());
    const n = eA(), A = this.config(), {
      encoding: s,
      interpolate: o,
      className: r,
      defClassName: a,
      transition: l
    } = A, c = this.getRenderableNormalizedData(), g = this.axes(), h = _n(
      a,
      this.id(),
      A.classPrefix
    ), u = V(t), d = ft(
      i.transition,
      l
    );
    this._points = [], this._pointMap = {}, u.attr(
      "class",
      `${h.join(" ")} ${r}`
    );
    const f = s.color.value, I = s.size ? s.size.field : void 0, C = this.isGradientLine(), E = this.getTranslatedData(
      c,
      f,
      g
    );
    this._translatedPoints = E, this._linkedElems = {}, this._pathPoints = [];
    const B = {
      isGradient: C
    };
    if (j(
      t,
      "g",
      E,
      null,
      {
        update: (p, w, x) => {
          const S = w.data, _ = `${h[0]}-${x}`.toLowerCase(), M = w.style;
          this._points.push(
            S.filter(({ isSplitPoint: T }) => !T)
          ), Pt(p, M);
          const k = this.getPathPoints(S);
          this.getDrawFn()(
            {
              layer: this,
              container: p.node(),
              interpolate: o,
              points: k,
              className: _,
              transition: d,
              animationAggregator: n,
              style: M || {},
              connectNullData: A.connectNullData,
              size: I,
              disconnectedPointsGroupClassName: `${h[0]}-disconnected-points`,
              getColorAxis: (...T) => In(...T),
              validPointCount: w.validPointCount
            },
            B
          ), this._pathPoints.push(k);
        }
      },
      (p) => p.id
    ), this.hasTextEncodingField()) {
      let p = null;
      this._stackedSum.size ? p = this.getTextPointsForStackSum() : p = this._points.flat(), this.textPointsInfo({
        points: p,
        location: "text"
      });
    } else
      this.textPointsInfo(null);
    const { width: m, height: y } = this.measurement(), { smartLabel: D } = this.dependencies(), Q = this._points.flat();
    return this.config().encoding.text.field && Si.placeInside(m, y, D, Q, "text"), this.postRender(i), n.onAllCallbacksCalled().then(() => {
      this.emitAnimationEndHook(i);
    }), this;
  }
  getPathPoints(t) {
    return t;
  }
  postRender(t) {
    if (super.postRender(t), this.config().interactive) {
      _l(this._voronoi, this._points);
      const i = this.getBoundBoxes().flat().filter((n) => n !== null);
      this._rtree = new Ns(), this._rtree.load(i);
    }
  }
  /**
   * Get the css styles need to be applied on the line path
   * @param {string} color Color value
   * @return {Object} Path styles
   */
  getPathStyle(t) {
    const i = this.config().encoding;
    return {
      stroke: t,
      fill: t,
      ...Nl(i, [this._mainColorProp])
    };
  }
  /**
   * Gets the nearest point closest to the given position
   * @param {number} x x position
   * @param {number} y y position
   * @return {Object} Nearest point information
   */
  getNearestPoint(t, i, n) {
    let A = n.searchRadius;
    const s = this.data();
    if (!s || s && s.isEmpty())
      return null;
    A = A !== void 0 ? A : this.config().nearestPointThreshold;
    const o = this._voronoi.find(t, i, A), r = W(o, "data", "data", "update");
    if (o) {
      const { source: a, rowId: l } = o.data.data;
      return {
        id: this.getIdentifiersFromData(a, l),
        dimensions: [
          {
            x: r.x,
            y: r.y,
            width: 2,
            height: 2
          }
        ],
        point: o.data.data,
        layerId: this.id()
      };
    }
    return null;
  }
  getBoundBoxes() {
    return bE(this._points.flat());
  }
  applyInteractionStyle(t, i) {
    const n = this._graphicElems, A = t;
    if (t) {
      const s = t.targetSet, o = {};
      for (const r of i) {
        const a = n[r];
        if (a) {
          const c = a.data()[0].id;
          let g = o[c];
          g || (o[c] = [0], g = o[c]), g[0] += 1, g[1] = a.data()[0].data.filter(({ isDummy: h }) => !h).length, g[2] = a;
        }
        const l = W(this._linkedElems, "text", r);
        l && ms(
          this,
          l.select("text"),
          A,
          t
        );
      }
      for (let r in o) {
        const a = o[r];
        (s === "entrySet" && a[0] >= 1 || s === "exitSet" && a[0] === a[1] || a[0] === a[1]) && a[2] && ms(
          this,
          a[2],
          A,
          t
        );
      }
    }
  }
  getSideEffects() {
    return {
      LineAnchors: ku,
      PersistentLineAnchors: dK,
      BrushLineAnchors: fK
    };
  }
  static autoDetectTransformType(t) {
    return t.length ? T5 : En;
  }
  static getTransformGroupByDimensions(t, i, n) {
    const { encoding: A, transform: s } = t, o = super.getTransformGroupByDimensions(
      t,
      i,
      n
    ), r = s && s.type === bo.GROUP ? [] : i.map((a) => W(A, a, "field")).filter((a) => a);
    return o.filter((a) => !r.includes(a));
  }
  getTargetSet(t, i) {
    const n = {};
    for (const s of t.uids) {
      const o = this._graphicElems[s];
      if (o) {
        const r = o.data()[0].id;
        let a = n[r];
        a || (n[r] = [[]], a = n[r]), a[0].push(s), a[1] = o.data()[0].data.filter(({ isDummy: l }) => !l).length, a[2] = o;
      }
    }
    let A = [];
    for (let s in n) {
      const o = n[s];
      (o[0].length === o[1] || i === "entrySet" && o[0].length > 0) && A.push(o[0]);
    }
    return t = { uids: new Set(A.flat()) }, t;
  }
  /**
   * @override
   */
  requiresExtendDomainDiffs() {
    return !0;
  }
  /**
   * @override
   */
  calculateExtendDomainDiffs() {
    const t = this.dependencies().smartLabel.getOriSize("X").height, i = Gs(this.axes().x, this.domain().x, [
      t,
      t
    ]), n = Gs(this.axes().y, this.domain().y, [
      t,
      t
    ]);
    return { x: i, y: n };
  }
  isVerticalLine() {
    const { yFieldAs: t, yField: i, xField: n, xFieldAs: A } = this.encodingFieldsInf();
    return xA({
      yField: i,
      yFieldAs: t,
      xField: n,
      xFieldAs: A,
      dm: this.data(),
      transformConf: this._transformConfig
    });
  }
  getNeighbourPointIndexForContinuationInVirtualScroll(t, i, n = (A) => A + 1) {
    const { connectNullData: A } = this.config();
    if (!A) {
      const l = n(t);
      return l > -1 && l < i.length ? l : t;
    }
    const s = this.isVerticalLine(), o = s ? "x" : "y", r = s ? "y" : "x", a = (l, c, g) => {
      if (!l[g])
        return -1;
      if (J.isInvalid(l[g])) {
        const h = n(c);
        return a(l, h, i[h]);
      }
      return c;
    };
    return this._normalizedData.map((l) => {
      const c = {};
      return l.forEach(
        (g) => c[g[o]] = g[r]
      ), a(c, n(t), i[n(t)]);
    });
  }
  static getDomain(t, { field: i, encoding: n, layerEncodings: A, transform: s }) {
    if (!i || !t.getField(i))
      return [];
    let o;
    const r = A[n].as || t.getField(i).subtype(), a = t.getField(i)?.subtype(), l = s.type === Nt ? this.getStackConfig(t, {
      encoding: A
    }) : {};
    return s.type === Nt && r === lt.CONTINUOUS && l.value && l.value.field === i ? (o = Rl({
      dm: t,
      valueField: l.value.field,
      uniqueField: l.uniqueField.field,
      fieldAs: r
    }), o = tl(o)) : r === lt.DISCRETE ? o = a === fi ? t.getField(i)?.getAllBins() : t.getField(i)?.uniques() : o = t.getDomain(i, r), o;
  }
  getTransformedValueFromNormalizedData(t, i) {
    return this.transformType() === Nt ? t[i] > 0 ? t[i] : t[`${i}0`] || 0 : t[i] || 0;
  }
}, mK = {
  classPrefix: en,
  defClassName: "layer-area",
  className: "",
  interpolate: "linear",
  transform: {},
  interaction: {
    select: {
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  {
                    target: "exitSet",
                    style: {
                      fill: { a: -0.5 }
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            // {
            //   target: "entrySet",
            //   style: {
            //     "fill-opacity": 0.7,
            //   },
            // },
            {
              target: "exitSet",
              style: {
                "fill-opacity": 0.2
              }
            }
          ]
        },
        "persistent-area-anchors": {}
      }
    },
    highlight: {
      sideEffects: {
        "area-anchors": {},
        "area-borders": {}
      }
    },
    brush: {
      sideEffects: {
        "brush-area-anchors": {}
      }
    }
  },
  crossline: !0,
  nearestPointThreshold: 10,
  encoding: {
    color: {},
    x: {},
    x0: {},
    y: {},
    y0: {},
    text: { ...$s }
  },
  transition: {
    effect: "cubic",
    duration: 1e3
  },
  connectNullData: !1,
  highlightExactPoint: !1,
  detectHoverOnEmptyArea: !0,
  interactive: !0
}, Jp = _i.area, QK = ({ mount: e, points: t = [], styles: i, selector: n, layer: A }) => {
  const [s, o] = ["enter", "update"].map((g) => {
    const h = nu.path();
    return t.forEach((u) => {
      A.isVerticalArea() ? (h.moveTo(u[g].x, u[g].y), h.lineTo(u[g].x, u[g].y0)) : (h.moveTo(u[g].x0, u[g].y), h.lineTo(u[g].x, u[g].y));
    }), h.toString();
  }), r = j(e, "g", [1], n);
  Object.keys(i).map((g) => {
    r.style(g, i[g]);
  });
  const a = r.selectAll("path").data(t.length ? [t] : []), l = a.enter().append("path").attr("d", s);
  a.merge(l).attr("d", o), a.exit().remove();
}, pK = (e) => {
  const {
    layer: t,
    container: i,
    points: n,
    transition: A,
    animationAggregator: s,
    className: o,
    interpolate: r,
    connectNullData: a,
    style: l
  } = e;
  t.transformType() !== v5 && QK({
    mount: i,
    styles: {
      ...l,
      stroke: l.fill
    },
    points: a ? [] : NE(n, {
      isNull: (Q) => Q.isNull
    }),
    selector: `.${t.config().classPrefix}-area-disconnected-points`,
    layer: t
  });
  const c = t._graphicElems, { effect: g, duration: h, disabled: u } = A, d = V(i), f = ml[r], C = j(
    d,
    "g",
    [1],
    `.${t.config().classPrefix}-area-connected-points`
  ).selectAll("path").data(n.length ? [n] : []), [E, B] = ["enter", "update"].map((Q) => t.isVerticalArea() ? Jp().curve(f).x((p) => p[Q].x).y1((p) => p[Q].y).y0((p) => p[Q].y0).defined(
    (p) => p.is100PercentNull || (p.isSplitPoint ? !1 : a ? !0 : !p.isNull)
  ) : Jp().curve(f).x1((p) => p[Q].x).x0((p) => p[Q].x0).y((p) => p[Q].y).defined(
    (p) => p.is100PercentNull || (p.isSplitPoint ? !1 : a ? !0 : !p.isNull)
  ));
  d.attr("class", o);
  let m = n;
  const y = C.enter().append("path").attr("d", E(m)).each((Q) => {
    Q.forEach((p) => {
      p.rowId !== null && !p.isSplitPoint && (c[p.rowId] = d);
    });
  });
  let D = C.merge(y);
  u || D.node() && (D = D.transition().ease(El[g]).duration(h).on("end", s.newCallback())), D.attr("d", B(m));
};
const { CONTINUOUS: yK } = lt, { TIME: DK } = yS, { CATEGORICAL: wK } = q8, Td = ({
  yField: e,
  xField: t,
  yFieldAs: i,
  xFieldAs: n,
  dm: A,
  transformConf: s
}) => {
  if (s.type === Nt || s.type === Lt)
    return s.value?.field === e;
  const o = A.getField(e) && A.getField(e).type(), r = A.getField(t) && A.getField(t).type(), a = A.getField(t) && A.getField(t).subtype(), l = A.getField(e) && A.getField(e).subtype();
  return n === lt.DISCRETE && i === lt.DISCRETE ? !0 : i === lt.CONTINUOUS && o === Ct.MEASURE || n === lt.CONTINUOUS && (r === Ct.DIMENSION || a === it.TEMPORAL) && i === it.CONTINUOUS && l == it.CONTINUOUS || n === lt.DISCRETE && i === lt.CONTINUOUS;
}, xK = (e, t) => {
  const { Y0: i } = vn(t);
  return !(e[i] < 0);
}, SK = (e, t) => e.reduce(
  (i, n) => {
    const A = [], s = [], o = i[0], r = i[1];
    return n.forEach((a) => {
      xK(a, t) ? A.push(a) : s.push(a);
    }), n.length === 1 ? [
      [...o],
      [
        ...r,
        n.map((a) => ({
          ...a,
          isLine: !0
        }))
      ]
    ] : [
      [...o, ...A.length ? [A] : []],
      [...r, ...s.length ? [s] : []]
    ];
  },
  [[], []]
).map((i) => i.reduce(
  (n, A) => {
    const s = n[0], o = n[1];
    return [[...s, A], [...o]];
  },
  [[], []]
).flat()).flat(), vn = (e) => {
  const t = e.isVerticalArea();
  return {
    X: t ? "x" : "y",
    X0: t ? "x0" : "y0",
    Y: t ? "y" : "x0",
    Y0: t ? "y0" : "x"
  };
}, qf = (e, t, i = !1, n) => {
  const { X: A, X0: s, Y: o, Y0: r } = vn(n), a = e[r] < 0, l = e.originalCoords ? e.originalCoords : {
    [o]: e[o],
    [r]: e[r],
    [A]: e[A],
    [s]: e[s]
  };
  return a ? {
    ...e,
    originalCoords: l,
    [o]: t,
    [r]: e[r] - e[o] + t,
    isDummy: i,
    isDuplicate: !0
  } : {
    ...e,
    originalCoords: l,
    [o]: e[o] - e[r] + t,
    [r]: t,
    isDummy: i,
    isDuplicate: !0
  };
}, Cc = ({
  dataPoint: e,
  dataPointIndex: t,
  dataPointArr: i,
  indexOfXByXValues: n,
  context: A
}) => {
  const { X: s } = vn(A), o = A.isVerticalArea(), r = t > 0 && n[e[s].toString()] - 1 === n[i[t - 1][s].toString()], a = o ? "yField" : "xField";
  if (r) {
    const l = i[t - 1];
    if (!J.isInvalid(
      l.dataObj[A.encodingFieldsInf()[a]]
    ))
      return !0;
  }
  return !1;
}, Ec = ({
  dataPoint: e,
  dataPointIndex: t,
  dataPointArr: i,
  indexOfXByXValues: n,
  context: A
}) => {
  const { X: s } = vn(A), o = A.isVerticalArea(), r = t < i.length - 1 && n[e[s].toString()] + 1 === n[i[t + 1][s].toString()], a = o ? "yField" : "xField";
  if (r) {
    const l = i[t + 1];
    if (!J.isInvalid(
      l.dataObj[A.encodingFieldsInf()[a]]
    ))
      return !0;
  }
  return !1;
}, MK = ({
  dataPoint: e,
  disconnectedPoints: t,
  context: i
}) => {
  const { X: n, Y: A, Y0: s } = vn(i);
  if (e.isLine)
    return { ...e };
  if (e.stackSumCalculated)
    return e;
  const o = e[s] < 0;
  let r = 0, a = 0, l = 0;
  t[e[n]] && (r = t[e[n]].filter(({ isRendered: h }) => h).reduce((h, u) => {
    const { [A]: d, [s]: f } = u, { [A]: I, [s]: C } = e;
    if (f < 0 !== o)
      return h;
    const B = Math.max(0, Math.min(d, I) - Math.max(f, C));
    return h + B;
  }, 0), a = t[e[n]].filter(({ isRendered: h }) => h).reduce((h, u) => {
    const { [A]: d, [s]: f } = u, { [A]: I, [s]: C } = e, E = f < 0;
    return E !== o ? h : Math.max(0, Math.min(d, I) - Math.max(f, C)) ? Math.max(h, Math.abs(E ? f : d)) : h;
  }, 0), l = t[e[n]].filter(({ isRendered: h }) => h).reduce((h, u) => {
    const { [A]: d, [s]: f } = u, { [A]: I, [s]: C } = e, E = f < 0;
    return E !== o ? h : !Math.max(0, Math.min(d, I) - Math.max(f, C)) && (E ? d < C : f > I) ? h + Math.abs(d - f) : h;
  }, 0));
  const g = Math.max(
    Math.abs(e[o ? [s] : [A]]),
    Math.abs(a + l)
  ) + r;
  return g ? o ? { ...e, [s]: -1 * g, stackSumCalculated: !0 } : { ...e, [A]: g, stackSumCalculated: !0 } : { ...e, stackSumCalculated: !0 };
}, _K = ({
  dataPoint: e,
  hasPointBefore: t,
  hasPointAfter: i,
  seriesDataAccumulator: n,
  maxAllocatedValueClockwise: A,
  maxAllocatedValueAntiClockwise: s,
  disconnectedPoints: o,
  context: r
}) => {
  const { Y: a } = vn(r), [l, c] = [
    qf(
      e,
      s,
      Math.abs(s - e[a]) > Math.abs(A - e[a]),
      r
    ),
    qf(
      e,
      A,
      Math.abs(s - e[a]) < Math.abs(A - e[a]),
      r
    )
  ].filter((g) => !!g).map((g) => MK({
    dataPoint: g,
    disconnectedPoints: o,
    context: r
  }));
  if (t && i)
    return n.length ? [
      ...n.slice(0, n.length - 1),
      [
        ...Array.isArray(
          n[n.length - 1]
        ) ? n[n.length - 1] : [n[n.length - 1]],
        l
      ],
      [c]
    ] : [[c]];
  if (t) {
    if (!i)
      return n.length ? [
        ...n.slice(0, n.length - 1),
        [
          ...Array.isArray(
            n[n.length - 1]
          ) ? n[n.length - 1] : [n[n.length - 1]],
          l
        ]
      ] : [[c]];
  } else
    return [...n, [c]];
  return [...n];
}, bK = ({
  dataPointsPair: e,
  splittedSeriesDataAccumulator: t,
  context: i
}) => {
  const { X: n, Y: A, Y0: s } = vn(i);
  if (Array.isArray(e) && t.length > 0 && Array.isArray(
    t[t.length - 1]
  ) && t.length) {
    const o = t[t.length - 1][t[t.length - 1].length - 1];
    if (e[0][n] === o[n] && e.length > 1 && e[0][A] === o[A] && e[0][s] === o[s])
      return [
        ...t.slice(
          0,
          t.length - 1
        ),
        [
          ...t[t.length - 1].slice(
            0,
            t[t.length - 1].length - 1
          ),
          ...e
        ]
      ];
  }
  return [...t, e];
}, h_ = ({
  uniqueFieldSubtype: e,
  uniqueAxisDomain: t,
  uniqueAxisUniqueValues: i
}) => {
  const n = (e === wK ? t : e === yK ? i.sort((A, s) => Number.isFinite(A) && Number.isFinite(s) ? A < s ? -1 : 1 : -1) : i).map((A) => A.toString());
  return e === DK && n.sort(
    (A, s) => t[0] - t[t.length - 1] > 0 ? s - A : A - s
  ), n;
}, u_ = (e, t, i) => e.map((n) => {
  const A = t.find((s) => s.dataObj);
  return A ? A.dataObj[n] : i.id();
}).join("-"), NK = (e, t) => {
  const { X: i, X0: n, Y: A, Y0: s } = vn(t), o = t.isVerticalArea();
  if (t.transformType() !== Lt || !t._transformedData._config.groupBy || !t._transformedData._sortedValues)
    return e;
  const r = t._transformedData._config.groupBy;
  if (r.length === 0)
    return e;
  const a = t._transformedData._config.groupBy[0], l = t._transformedData._sortedValues.slice().reverse().map((p) => p.toString()), c = t.encodingFieldsInf(), g = t.axes()[i], h = i === "x" ? c.xField : c.yField, u = g.domain().map((p) => p.toString()), d = t.data().getField(h).uniques(), f = {};
  l.map((p, w) => {
    f[p.toString()] = w;
  });
  const { xFieldSubType: I, yFieldSubType: C } = c, B = h_({
    uniqueFieldSubtype: o ? I : C,
    uniqueAxisDomain: u,
    uniqueAxisUniqueValues: d
  }), m = {};
  B.forEach((p) => {
    m[p] = {
      cw: 0
    };
  });
  const y = {}, Q = e.filter((p) => p.length).sort((p, w) => f[p[0].dataObj[a].toString()] - f[w[0].dataObj[a].toString()]).map((p) => {
    const { x: w, y: x } = t.axes(), S = o ? w : x, _ = o ? "x" : "y";
    return bl(p, t.axes(), { sortAxis: S, sortCoord: _ });
  }).map((p) => {
    const w = u_(r, p, t);
    return B.map((x, S) => {
      const _ = p.findIndex((G) => G[i].toString() === x || J.isInvalid(G[i]) && x.toString() === "null"), M = p[_];
      let k = null;
      if (M) {
        const G = m[x].cw + (p[_][A] - p[_][s]), N = m[x].cw;
        k = {
          ...p[_],
          [A]: Number.isNaN(G) ? 0 : G,
          [s]: Number.isNaN(N) ? 0 : N,
          dataObj: {},
          seriesId: w
        };
      } else
        k = {
          ...p[0],
          [i]: x,
          [n]: x,
          [A]: m[x].cw,
          [s]: m[x].cw,
          seriesId: w
        };
      k[A] === k[s] && (k.is100PercentNull = !0);
      const T = Math.max(
        m[x].cw,
        p[_] ? k[A] : 0
      );
      return m[x].cw = T, y[S] = T, k;
    });
  });
  return Q.forEach((p, w) => {
    Q[w] = p.filter(
      (x, S) => y[S] !== 0
    );
  }), Q;
}, FK = (e, t) => {
  const { X: i, Y: n, Y0: A } = vn(t), s = t.isVerticalArea();
  if (
    // !(context.transformType() === "stack") ||
    !t._transformedData._config.groupBy || !t._transformedData._sortedValues
  )
    return e;
  const o = t._transformedData._config.groupBy[0], r = t._transformedData._config.groupBy, a = t._transformedData._sortedValues.slice().reverse().map((M) => M.toString()), l = t.encodingFieldsInf(), c = t.axes()[i], g = i === "x" ? l.xField : l.yField, h = c.domain().map((M) => M.toString()), u = t.data().getField(g).uniques(), { xFieldSubType: d, yFieldSubType: f } = l, C = h_({
    uniqueFieldSubtype: s ? d : f,
    uniqueAxisDomain: h,
    uniqueAxisUniqueValues: u
  }), E = {};
  C.forEach((M, k) => E[M.toString()] = k);
  const B = {}, m = {};
  C.forEach((M) => {
    B[M] = {
      cw: 0,
      aw: 0
    }, m[M] = {
      cw: 0,
      aw: 0
    };
  });
  const y = {}, D = {};
  C.forEach((M) => {
    y[M] = 0, D[M] = 0;
  });
  const Q = {};
  a.map((M, k) => {
    Q[M.toString()] = k;
  });
  const p = e.filter((M) => M.length).sort((M, k) => Q[M[0].dataObj[o].toString()] - Q[k[0].dataObj[o].toString()]).map((M) => {
    const { x: k, y: T } = t.axes(), G = s ? k : T, N = s ? "x" : "y";
    return bl(M, t.axes(), { sortAxis: G, sortCoord: N });
  }), w = SK(
    p,
    t
  ), x = {}, S = {};
  return w.forEach((M) => {
    const k = M[0][A] < 0;
    M.forEach((T, G, N) => {
      const b = Ec({
        dataPoint: T,
        dataPointIndex: G,
        dataPointArr: N,
        indexOfXByXValues: E,
        context: t
      });
      if (!(Cc({
        dataPoint: T,
        dataPointIndex: G,
        dataPointArr: N,
        indexOfXByXValues: E,
        context: t
      }) || b) && T[n] !== T[A]) {
        const R = {
          [n]: T[n],
          [A]: T[A],
          groupByValue: T.dataObj[o],
          rowId: T.rowId,
          isRendered: !1
        };
        T.isLine = !0, Array.isArray(
          (k ? S : x)[T[i]]
        ) ? (k ? S : x)[T[i]].push(R) : (k ? S : x)[T[i]] = [R];
      }
    });
  }), w.reduce((M, k) => {
    const T = k[0][A] < 0, G = u_(
      r,
      k,
      t
    ), N = k.reduce((b, F, R, v) => {
      if (!F[i] && J.isInvalid(F[n]))
        return [...b];
      if (F.seriesId = G, F.isLine) {
        const { aw: z, cw: et } = (T ? m : B)[F[i]], Z = T ? Math.min(z, et) : Math.max(z, et), Y = (T ? D : y)[F[i]], q = T ? Math.min(Z, Y) : Math.max(Z, Y), $ = qf(
          F,
          q,
          !1,
          t
        );
        (T ? D : y)[F[i]] = T ? $[A] : $[n];
        const P = (T ? S : x)[$[i]];
        if (P && P.length) {
          const st = P.findIndex((nt) => nt.rowId === $.rowId);
          st >= 0 && ((T ? S : x)[$[i]][st].isRendered = !0);
        }
        return [...b, $];
      }
      const O = Ec({
        dataPoint: F,
        dataPointIndex: R,
        dataPointArr: v,
        indexOfXByXValues: E,
        context: t
      }), L = Cc({
        dataPoint: F,
        dataPointIndex: R,
        dataPointArr: v,
        indexOfXByXValues: E,
        context: t
      }), { cw: U, aw: H } = (T ? m : B)[F[i].toString()];
      return _K({
        dataPoint: F,
        hasPointBefore: L,
        hasPointAfter: O,
        seriesDataAccumulator: b,
        maxAllocatedValueClockwise: U,
        maxAllocatedValueAntiClockwise: H,
        disconnectedPoints: T ? S : x,
        context: t
      });
    }, []).reduce((b, F) => bK({
      dataPointsPair: F,
      splittedSeriesDataAccumulator: b,
      context: t
    }), []).reduce((b, F, R, v) => Array.isArray(F) ? [...b, F.flat()] : R > 0 && Array.isArray(v[R - 1]) ? [...b, [F]] : b.length ? [
      ...b.map((O, L) => L === b.length - 1 ? [...O, F] : O)
    ] : [[F]], []).map((b) => b.filter((F, R, v) => {
      const { isLine: O } = F, L = Ec({
        dataPoint: F,
        dataPointIndex: R,
        dataPointArr: v,
        indexOfXByXValues: E,
        context: t
      }), U = Cc({
        dataPoint: F,
        dataPointIndex: R,
        dataPointArr: v,
        indexOfXByXValues: E,
        context: t
      });
      return O || U || L;
    })).filter((b) => b.length > 1 || b[0] && b[0].isLine);
    return N.forEach((b) => {
      b.forEach((F, R, v) => {
        const O = Ec({
          dataPoint: F,
          dataPointIndex: R,
          dataPointArr: v,
          indexOfXByXValues: E,
          context: t
        }), L = Cc({
          dataPoint: F,
          dataPointIndex: R,
          dataPointArr: v,
          indexOfXByXValues: E,
          context: t
        });
        F.hasPointAfter = O, F.hasPointBefore = O;
        const U = T ? A : n, H = (T ? m : B)[F[i].toString()].cw, z = (T ? m : B)[F[i].toString()].aw, et = (T ? m : B)[F[i].toString()].groupedByValue;
        let Z, Y;
        if (Z = H, Y = z, L && O)
          Z = F[U], Y = F[U];
        else {
          if (!L && !O)
            return;
          L ? Y = F[U] : O && (Z = F[U]);
        }
        et === G && Math.abs(Z) < Math.abs(H) && (Z = H), et === G && Math.abs(Y) < Math.abs(z) && (Y = z), (T ? m : B)[F[i].toString()].cw = Z, (T ? m : B)[F[i].toString()].aw = Y, (T ? m : B)[F[i].toString()].groupedByValue = G;
      });
    }), [...M, N];
  }, []);
}, { CONTINUOUS: VA } = lt, d_ = (e) => class extends e {
  constructor(...t) {
    super(...t), this._dimensionMap = {}, this._mainColorProp = "fill";
  }
  /** Default configuration of area layer.
   *
   * @return {Object} Default configuration of layer
   */
  static defaultConfig() {
    return mK;
  }
  /**
   * Calculates the domain from data. It calls its parent class's method which is line layer
   * to get the domain and overwrites the domain according to its need.
   * @return {Array} Domain values
   */
  calculateDomainFromData(t, i) {
    const n = super.calculateDomainFromData(t), { MEASURE: A } = J.FieldType;
    return [yt.X, yt.Y].forEach((s) => {
      const { [`${s}FieldType`]: o } = i;
      o === A && W(n[s], "length") && (n[s][0] = Math.min(n[s][0], 0), n[s][1] = Math.max(0, n[s][1]));
    }), n;
  }
  static getDomain(t, {
    field: i,
    encoding: n,
    layerEncodings: A,
    transform: s,
    userDomain: o,
    hasRangedEncodingInValueAxis: r = !1
  }) {
    if (!i || !t.getField(i))
      return [];
    const a = A[n].as || t.getField(i).subtype(), l = Td({
      yField: A.y.field,
      yFieldAs: A.y.as,
      xField: A.x.field,
      xFieldAs: A.x.as,
      dm: t,
      transformConf: s
    });
    if (!Number.isFinite(t.getFieldIndex(i)))
      return [];
    const c = t.getField(i).subtype(), g = l && n === "x" || !l && n === "y";
    let h;
    const { value: u, uniqueField: d } = s.type === Nt || s.type === Lt ? this.getStackConfig(t, {
      encoding: A
    }) : {}, f = this.getOverrideTransformType(s.type, {
      isRanged: r
    });
    if (f === Nt && a === VA && u && (r || u.field === i))
      h = Rl({
        dm: t,
        valueField: u.field,
        uniqueField: d.field,
        fieldAs: a
      });
    else if (f === Lt && a === VA && u && (r || u.field === i)) {
      if (HM(o))
        return OM(
          t,
          o,
          { field: i, uniqueField: d, fieldAs: a, isIndependentEncoding: g }
        );
      h = TE({ dm: t });
    } else if (a === lt.DISCRETE)
      h = c !== ug ? t.getField(i).uniques() : t.getField(i).getAllBins();
    else {
      const I = A[`${n}0`];
      if (t.isEmpty())
        h = null;
      else if (W(I, "field")) {
        const C = I.as, E = I.field, B = t.getDomain(i, a), m = t.getDomain(
          E,
          C
        );
        h = [
          Math.min(...B, ...m),
          Math.max(...B, ...m)
        ];
      } else
        h = t.getDomain(i, a);
    }
    return a === VA && c !== Iu && c !== ug && W(h, "length") && (W(A[`${n}0`], "field") ? h.sort((I, C) => I - C) : g ? h = nh(h) : h = tl(h)), h;
  }
  static shouldShowAxisTicksInPercentage(t, i, n) {
    const A = n.def.encoding, s = n.def.transform;
    let o;
    if (A) {
      const r = Td({
        yField: A.y.field,
        yFieldAs: A.y.as,
        xField: A.x.field,
        xFieldAs: A.x.as,
        dm: t,
        transformConf: s
      });
      return ["x", "y"].forEach((a) => {
        !(r && a === "x" || !r && a === "y") && s.type === Lt && (o = A[a].field);
      }), i === o;
    }
    return !1;
  }
  resolveOverrideTransformConfig(t) {
    const i = this.hasRangedValueAxis();
    return i ? {
      ...t,
      originalType: t.type,
      type: this.constructor.getOverrideTransformType(
        t.type,
        { isRanged: i }
      )
    } : t;
  }
  hasRangedValueAxis() {
    const { x: t, y: i } = this.axes(), n = this.encodingFieldsInf(), { x0Field: A, x0FieldAs: s, xFieldAs: o, y0Field: r, y0FieldAs: a, yFieldAs: l } = n, c = r && (a === VA || l === VA) ? !0 : A && (s === VA || o === VA) ? !1 : null;
    if (c === null)
      return !1;
    const g = c ? i : t, { fieldInstance: h } = g.config();
    let u = !1;
    return br(h) && (u = h.vars().map((f) => f.toString()).some(
      (f) => f === (c ? r : A)
    )), u;
  }
  static getOverrideTransformType(t, { isRanged: i }) {
    return t === Nt && i ? gn : t;
  }
  getTransformedData(t, i, n, A) {
    return Ml(
      t,
      i,
      n
    );
  }
  requiresExtendDomainDiffs() {
    return !1;
  }
  /**
   * Returns the drawing method of this layer
   * @return {Function} Draw method
   */
  getDrawFn() {
    return pK;
  }
  // Compute map of the unique values for the given dimensional value
  getDimensionMap(t) {
    return this._dimensionMap[t] ? this._dimensionMap[t] : (this._dimensionMap[t] = Object.keys(this._pointMap).reduce(
      (i, n) => {
        const A = this._pointMap[n].data[t];
        return i[A] || (i[A] = []), i[A].push(this._pointMap[n]), i;
      },
      {}
    ), this._dimensionMap[t]);
  }
  postRender(t) {
    if (super.postRender(t), this.config().interactive) {
      _l(this._voronoi, this._points);
      const i = this.getBoundBoxes().flat().filter((n) => n !== null);
      this._rtree = new Ns(), this._rtree.load(i);
    }
  }
  getNearestPoint(t, i, n) {
    let A = n.searchRadius;
    const s = this.data();
    if (!s || s && s.isEmpty())
      return null;
    A = A !== void 0 ? A : this.config().nearestPointThreshold;
    let o = this._voronoi.find(t, i, A), r, a = null;
    if (!o && n.dimValue && this._pointMap) {
      const c = n.dimValue[1][0], h = this.getDimensionMap(n.dimValue[0][0])[c] || [];
      for (let u = 0, d = h.length; u < d; u++) {
        const { y: f, y0: I } = h[u].update;
        if (f < i && i < I) {
          r = u, a = h[u];
          break;
        }
      }
      r !== void 0 && (o = {
        index: r,
        data: {
          x: t,
          y: i,
          data: a
        }
      });
    }
    const l = W(o, "data", "data", "update");
    if (o) {
      const { source: c, rowId: g } = o.data.data;
      return {
        id: this.getIdentifiersFromData(c, g),
        dimensions: [
          {
            x: l.x,
            y0: l.y0,
            y: l.y,
            width: 2,
            height: 2
          }
        ],
        point: o.data.data,
        layerId: this.id()
      };
    }
    return null;
  }
  getDataBoundary(t, i) {
    let n = null;
    if (this._graphicElems)
      for (let s in this._graphicElems) {
        const o = this._graphicElems[s], r = o.node().ownerSVGElement;
        if (r) {
          const a = r.createSVGPoint();
          if (a.x = t, a.y = i, o.node().querySelector(".muze-area-connected-points path").isPointInFill(a)) {
            n = o.datum();
            break;
          }
        }
      }
    const A = n && n.data && n.data.length ? (n.data.find((s) => s.seriesId) || {
      seriesId: this.id()
    }).seriesId : this.id();
    return n ? {
      layerId: this.id(),
      points: n,
      id: A
    } : null;
  }
  getTextPointsCoords(t) {
    const i = this.isVerticalArea(), n = this.transformType(), { x: A, y: s, x0: o } = t;
    return !i && (n === Nt || n === Lt) ? {
      x: o,
      y: s
    } : {
      x: A,
      y: s
    };
  }
  /**
   * Generates the x and y positions for each point
   * @param {Array} data Data Array
   * @param {Object} encoding Visual Encodings of the layer
   * @param {Object} axes Contains the axis
   * @return {Array} Array of points
   */
  translatePoints(t, i, n) {
    let A = [];
    const s = this.transformType(), o = this.axes(), r = this.config(), { y0Field: a, x0Field: l, textField: c, yField: g, xField: h } = this.encodingFieldsInf(), { x: u, y: d } = o, f = r.individualClassName, I = u.domain()[0], C = d.domain()[0], E = I < 0 ? u.getScaleValue(0) : u.getScaleValue(I), B = C < 0 ? d.getScaleValue(0) : d.getScaleValue(C), m = this.isVerticalArea(), y = m ? o.x : o.y;
    bl(t, o, { sortAxis: y, sortCoord: m ? "x" : "y" });
    const Q = /* @__PURE__ */ new Set();
    return A = t.map((p, w) => {
      let x, S, _, M, k;
      u.isBinnedAxis(), S = m ? u.getScaleValue(p.x) + u.getUnitWidth() / 2 : u.getScaleValue(p.x), M = l || s === Nt || s === Lt ? u.getScaleValue(p.x0) : E, d.isBinnedAxis() ? (_ = m ? d.getScaleValue(p.y) : d.getScaleValue(p.y) + (d.constructor.type() === ce ? -1 * d.getUnitWidth() / 2 : d.getUnitWidth() / 2), k = a || s === Nt || s === Lt ? d.getScaleValue(p.y0) + (d.constructor.type() === ce ? -1 * d.getUnitWidth() / 2 : d.getUnitWidth() / 2) : B) : (_ = m ? d.getScaleValue(p.y) : d.getScaleValue(p.y) + d.getUnitWidth() / 2, k = a || s === Nt || s === Lt ? d.getScaleValue(p.y0) : B);
      const T = In(this, p);
      x = T.getColor(J.getActualValue(p.color));
      const G = J.isInvalid(p.x), N = J.isInvalid(p.x0), b = J.isInvalid(p.y), F = J.isInvalid(p.y0), R = nA(this, {
        translatedValues: {
          x: S,
          y: _,
          x0: M,
          y0: k,
          color: x,
          text: p.text,
          formattedText: p.formattedText
        },
        datum: p,
        datumIdx: w,
        groupData: t,
        groupIdx: i,
        layerData: n
      });
      x = R.color;
      const v = {
        fill: x
      };
      let O;
      c && (O = Xs(
        this,
        {
          ...this.getTextPointsCoords(R),
          text: R.text,
          formattedText: R.formattedText,
          color: TM(T, p.color)
        },
        p,
        w,
        t,
        {
          show: !p.isDummy
        }
      ));
      const L = m ? {
        x: S,
        x0: N ? null : E,
        y: b ? null : B,
        y0: F ? null : B
      } : {
        x: G ? null : E,
        x0: N ? null : E,
        y: _,
        y0: F ? null : B
      }, U = m ? {
        x: S,
        x0: N ? null : R.x0,
        y: b ? null : R.y,
        y0: F ? null : R.y0
      } : {
        x: G ? null : R.x,
        x0: N ? null : R.x0,
        y: _,
        y0: F ? null : R.y0
      }, H = {
        enter: L,
        update: U,
        source: p.source,
        rowId: p.rowId,
        data: p.dataObj,
        normalizedData: p,
        className: f ? f(p, w, t, this) : "",
        style: v,
        meta: Nn(v),
        text: O,
        isNull: p.isSplitPoint || p.isLine || J.isInvalid(p.dataObj[m ? g : h]),
        isLine: p.isLine,
        isSplitPoint: p.isSplitPoint,
        isDummy: p.isDummy,
        is100PercentNull: p.is100PercentNull,
        includeInBorder: p.includeInBorder,
        seriesId: p.seriesId
      };
      return H.className = iA(p, w, t, this), Q.add(p.rowId), !H.isSplitPoint && !H.is100PercentNull && this.cachePoint(p.rowId, H), H;
    }), c && (A = this.optimizeTextLabelPositions(A)), A = Zs(this, A), A = A.filter((p) => {
      const w = p.update;
      return m ? !isNaN(w.x) : !isNaN(w.y);
    }), {
      points: A,
      validPointCount: Q.size
    };
  }
  transformNormalizedDataForStack(t) {
    const { X: i, Y: n, X0: A, Y0: s } = vn(this), r = this.axes()[i].domain(), a = FK(
      t,
      this
    ), l = (c, g) => ({
      ...c,
      [n]: 0,
      [s]: 0,
      [i]: g,
      [A]: g,
      isNull: !0,
      isDummy: !0,
      isSplitPoint: !0
    });
    return a.reduce((c, g) => {
      let h = [];
      return g.length && Array.isArray(g[0]) ? g.forEach((u) => {
        if (h = h.concat(u), h.length && h[h.length - 1].hasPointAfter === !1) {
          const d = u[u.length - 1][i], f = d === r[r.length - 1] ? null : d;
          h.push(
            l(u[u.length - 1], f)
          );
        }
      }) : h = h.concat(g), [...c, h];
    }, []).filter((c) => c.length);
  }
  transformNormalizedDataFor100PercentStack(t) {
    return NK(t, this);
  }
  getTranslatedData(t, i) {
    const n = this._transformConfig.groupBy;
    let A;
    switch (this.transformType()) {
      case Lt:
        A = this.transformNormalizedDataFor100PercentStack(t);
        break;
      case Nt:
        A = this.transformNormalizedDataForStack(t);
        break;
      default:
        A = t;
        break;
    }
    return this._normalizedData = t, this._transformedNormalizedData = A, A.map((s, o) => {
      if (!s.length)
        return null;
      let r, a = s[0].color;
      const l = n.map(
        (d) => s[0].dataObj[d]
      ), c = l.length ? l + o : [this.id()];
      i ? r = i(s, o, t) : (a = J.getActualValue(a), r = In(this, s[0]).getColor(a));
      const g = this.getPathStyle(r), { points: h, validPointCount: u } = this.translatePoints(
        s,
        o,
        A
      );
      return {
        data: h,
        validPointCount: u,
        style: g,
        meta: Nn(g),
        id: c
      };
    }).filter((s) => s !== null);
  }
  getPathPoints(t) {
    return t;
  }
  resolveTransformType() {
    return this._transformType = ME(this), this._transformType;
  }
  /**
   * Get the css styles need to be applied on the line path
   * @param {string} color Color value
   * @return {Object} Path styles
   */
  getPathStyle(t) {
    const i = this.config().encoding;
    return {
      fill: t,
      ...Nl(i, [this._mainColorProp])
    };
  }
  getSideEffects() {
    return {
      AreaAnchors: Tu,
      PersistentAreaAnchors: CK,
      BrushAreaAnchors: EK,
      AreaBorders: BK
    };
  }
  static autoDetectTransformType(t, i) {
    return i.value && t.length ? Nt : En;
  }
  isVerticalArea() {
    const { yFieldAs: t, yField: i, xField: n, xFieldAs: A } = this.encodingFieldsInf();
    return Td({
      yField: i,
      yFieldAs: t,
      xField: n,
      xFieldAs: A,
      dm: this.data(),
      transformConf: this._transformConfig
    });
  }
  isVertical() {
    return this.isVerticalArea();
  }
  static getStackConfig(t, i) {
    const {
      y: { field: n, as: A },
      x: { field: s, as: o }
    } = i.encoding, r = t.getField(s)?.type(), a = t.getField(n)?.type(), l = t.getField(s)?.subtype(), c = t.getField(n)?.subtype();
    let g, h;
    const u = A === lt.CONTINUOUS && a === Ct.MEASURE || o === lt.CONTINUOUS && (r === Ct.DIMENSION || l === it.TEMPORAL) && A === it.CONTINUOUS && c == it.CONTINUOUS || o === lt.DISCRETE && A === lt.CONTINUOUS, d = u ? s : n, f = u ? o : A, I = u ? n : s, C = u ? A : o, E = u ? c : l;
    return C === lt.CONTINUOUS && E !== it.TEMPORAL && (g = {
      field: d,
      as: f,
      subtype: t.getField(d)?.subtype(),
      type: t.getField(d)?.type()
    }, h = {
      field: I,
      as: C,
      subtype: t.getField(I)?.subtype(),
      type: t.getField(I)?.type()
    }), {
      uniqueField: g,
      value: h
    };
  }
  static getDefaultTransformConfig(t, i) {
    const {
      transform: n,
      encoding: {
        x: { field: A },
        y: { field: s },
        color: { field: o }
      }
    } = t, r = A === o ? ["y", "y0"] : s === o ? ["x", "x0"] : ["x", "y", "x0", "y0"], a = this.getTransformGroupByDimensions(
      t,
      r,
      i
    );
    let l = n.type, c = {
      ...n,
      groupBy: ft(n.groupBy, a)
    };
    const g = this.getStackConfig(i, t);
    return l || (l = this.autoDetectTransformType(
      a,
      g,
      i
    )), (l === Nt || l === Lt) && (c = {
      ...c,
      ...g
    }), {
      ...c,
      type: l
    };
  }
  resolveTransformConfig(t) {
    const { transform: i } = this.config();
    let n = i.type, A = {
      fields: []
    };
    const s = [
      yt.COLOR,
      yt.SIZE,
      yt.SHAPE,
      yt.TEXT,
      yt.DETAIL
    ], o = [yt.COLOR, yt.SIZE, yt.SHAPE], r = /* @__PURE__ */ new Set();
    for (let a = 0; a < s.length; a++) {
      const l = s[a], { field: c } = this.config().encoding[l] || {}, g = Fi(c), h = g && g[0], u = t.getField(h);
      if (u && u.type() === "dimension" && i.groupBy.includes(h) && !r.has(h)) {
        let d;
        o.includes(l) ? d = this.axes()[l].sortValues(u.uniques()) : d = u.uniques(), A.fields.push({
          field: h,
          values: d
        }), r.add(h);
      }
    }
    return { ...i, type: n, sort: A };
  }
  applyInteractionStyle(t, i) {
    const n = this._graphicElems, A = t;
    if (t) {
      const s = t.targetSet, o = {};
      for (const r of i) {
        const a = n[r];
        if (a) {
          const l = a.data()[0].id;
          let c = o[l];
          c || (o[l] = [0], c = o[l]), c[0] += 1, c[1] = a.data()[0].validPointCount, c[2] = a;
        }
      }
      for (let r in o) {
        const a = o[r];
        s === "entrySet" && a[0] >= 1 ? a[2] && ms(
          this,
          a[2],
          A,
          t
        ) : s === "exitSet" && a[0] === a[1] ? a[2] && ms(
          this,
          a[2],
          A,
          t
        ) : a[0] === a[1] && a[2] && ms(
          this,
          a[2],
          A,
          t
        );
      }
    }
  }
  getTargetSet(t, i) {
    const n = {};
    for (const s of t.uids) {
      const o = this._graphicElems[s];
      if (o) {
        const r = o.data()[0].id;
        let a = n[r];
        a || (n[r] = [[]], a = n[r]), a[0].push(s), a[1] = o.data()[0].validPointCount, a[2] = o;
      }
    }
    let A = [];
    for (let s in n) {
      const o = n[s];
      (o[0].length === o[1] || i === "entrySet" && o[0].length > 0) && A.push(o[0]);
    }
    return t = { uids: new Set(A.flat()) }, t;
  }
  getYfieldEncodingForTransformedData(t) {
    return t % 2 === 0 ? "y" : "y0";
  }
  transformType() {
    const { type: t } = this._transformConfig;
    return t;
  }
};
class f_ extends _e(AA).with(
  jE,
  d_
) {
  static formalName() {
    return tS;
  }
}
const RK = {
  classPrefix: en,
  defClassName: "layer-arc",
  padding: { top: 1, bottom: 1, left: 1, right: 1 },
  className: "",
  interaction: {
    highlight: {
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                "stroke-width": "1px",
                stroke: "black"
              }
            }
          ]
        }
      }
    },
    brush: {},
    select: {
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  {
                    target: "exitSet",
                    style: {
                      fill: { a: -0.5 }
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                "stroke-width": "1px",
                stroke: "black"
              }
            }
          ]
        }
      }
    }
  },
  height: 100,
  width: 100,
  sort: "",
  colors: ["#F44336", "blue", "green", "yellow", "orange", "purple"],
  transform: {
    type: "group"
  },
  encoding: {
    "stroke-width": {
      value: "0px"
    },
    stroke: {
      value: ""
    },
    "stroke-linejoin": {
      value: "round"
    },
    angle: {
      value: "1"
    },
    radius: {
      value: "1",
      range: (e) => e
    },
    opacity: {
      value: "1"
    },
    color: {
      value: "1"
    },
    shape: {
      value: "1"
    },
    size: {
      value: "1"
    },
    text: { ...$s }
  },
  transition: {
    effect: "cubic",
    duration: 500
  }
}, kK = (e, t, i) => {
  const n = e[t - 1], A = e[t], [s, o] = i.angle.range();
  return n && A ? {
    update: {
      angle0: W(n, "update", "angle"),
      angle: W(A, "update", "angle0")
    }
  } : A ? {
    update: {
      angle0: (s - 90) * Math.PI * 2 / 360,
      angle: (s - 90) * Math.PI * 2 / 360
    }
  } : {
    update: {
      angle0: (o - 90) * Math.PI * 2 / 360,
      angle: (o - 90) * Math.PI * 2 / 360
    }
  };
}, TK = (e, t) => {
  const i = t[0];
  return function(n) {
    return e($w()(i._previousInfo, i)(n));
  };
}, Xi = (e) => e + Math.PI / 2;
const vK = (e, t, i) => {
  const { handleTextLabelClipping: n, availableDimen: A } = i;
  if (t = t.filter((h) => !!h.text), !t.length)
    return;
  if (t.length === 1) {
    const h = t[0].text;
    h.update.x = 0, h.update.y = 0, h.textAnchor = "middle", h.isVisible = !0, h.connector = null;
    return;
  }
  const s = WK(t), { width: o, height: r } = e.dependencies().smartLabel.getOriSize("X"), a = oS, l = rS;
  for (let h = 0; h < s.length; h++) {
    const u = s[h];
    if (!u.length)
      continue;
    const d = Math.max.apply(
      void 0,
      u.map((B) => B.update.radius)
    ), f = Math.max(
      Math.min(d * cS, lS),
      aS
    ), I = d + f, C = I;
    KK({
      points: u,
      availableHeight: C,
      fontHeight: r,
      padding: a
    });
    const E = u.filter((B) => B.text.isVisible);
    UK({
      quadrantIdx: h,
      points: E,
      availableHeight: C,
      outerRadius: I,
      fontHeight: r,
      padding: a
    }), YK({
      qIdx: h,
      points: E,
      connectorCrookDistance: l
    }), JK({
      qIdx: h,
      points: E,
      maxRadius: d
    });
  }
  const { shouldUpdateRadius: c, radiusChangeInPercentage: g } = GK(e, t, {
    handleTextLabelClipping: n,
    fontWidth: o,
    availableDimen: A
  });
  return {
    shouldUpdateRadius: c,
    radiusChangeInPercentage: g
  };
}, GK = (e, t, i) => {
  t.forEach((f) => {
    f.text.labelSmartText = null;
  });
  const { handleTextLabelClipping: n, fontWidth: A, availableDimen: s } = i, { width: o, height: r } = s, { x: a, y: l } = t[0].update, c = {
    leftX: a - o / 2,
    rightX: a + o / 2,
    topY: l - r / 2,
    bottomY: l + r / 2
  }, g = Math.max.apply(
    void 0,
    t.map((f) => f.update.radius)
  ), h = g * uS, d = t.filter((f) => f.text.isVisible).map((f) => {
    const I = f.update.x + f.text.update.x, C = f.update.y + f.text.update.y, E = e.dependencies().smartLabel.getOriSize(f.text.text), B = Xi(f.update.angle0), m = Xi(f.update.angle), y = B + (m - B) / 2;
    let D;
    return y >= 0 && y <= Math.PI ? D = "right" : D = "left", {
      absTextPosX: I,
      absTextPosY: C,
      dimens: E,
      halfType: D,
      point: f
    };
  });
  if (n) {
    const f = d.map((E) => {
      const { absTextPosX: B, dimens: m, halfType: y } = E;
      let D;
      if (y === "right") {
        const Q = B + m.width;
        D = Math.max(Q - c.rightX, 0);
      } else {
        const Q = B - m.width;
        D = Math.max(
          c.leftX - Q,
          0
        );
      }
      return Math.abs(D);
    }), I = Math.max.apply(void 0, f), C = Math.min(I, h);
    return {
      shouldUpdateRadius: C > 0,
      radiusChangeInPercentage: -(C / g)
    };
  } else
    return d.forEach((f) => {
      const { absTextPosX: I, dimens: C, halfType: E, point: B } = f;
      let m;
      E === "right" ? m = Math.max(
        c.rightX - I,
        0
      ) : m = Math.max(
        I - c.leftX,
        0
      );
      const y = LK({
        text: B.text.text,
        textDimen: C,
        availableWidth: m,
        fontWidth: A,
        minCharCount: 3
      });
      B.text.labelSmartText = y;
    }), {
      shouldUpdateRadius: !1,
      radiusChangeInPercentage: 0
    };
}, LK = ({
  text: e,
  textDimen: t,
  availableWidth: i,
  fontWidth: n,
  minCharCount: A
}) => {
  if (A = A || 0, i >= t.width)
    return e;
  const s = "...", o = n * 2, r = Math.floor(
    (i - o) / n
  );
  return `${e.slice(0, Math.max(r, A))}${s}`;
}, UK = (e) => {
  const {
    quadrantIdx: t,
    points: i,
    availableHeight: n,
    outerRadius: A,
    fontHeight: s,
    padding: o
  } = e;
  let r = !0, a = i.map((c) => {
    const g = c.update, h = Xi(g.angle0), u = Xi(g.angle), d = h + (u - h) / 2, f = A * Math.sin(d), I = -A * Math.cos(d), C = f, E = I - s / 2 - o;
    return {
      x: C,
      y: E,
      height: s + o * 2,
      points: [c]
    };
  }), l = 0;
  for (; r; ) {
    let { isOverlapping: c, groups: g } = OK({
      qIdx: t,
      groupedPoints: a,
      fontHeight: s,
      padding: o,
      availableHeight: n
    });
    if (a = g, r = c, l++, l >= sS)
      break;
  }
  a.forEach((c) => {
    const { y: g, height: h, points: u } = c, d = h / u.length;
    u.forEach((f, I) => {
      const C = g + d * I + d / 2, E = PK(C, A, t);
      f.text.update.x = E, f.text.update.y = C, f.text.textAnchor = t === 0 || t === 1 ? "start" : "end";
    });
  });
}, OK = ({
  qIdx: e,
  groupedPoints: t,
  availableHeight: i
}) => {
  const n = [];
  let A = null, s = !1;
  for (let o = 0; o < t.length; o++) {
    const r = t[o];
    if (!A) {
      A = r;
      continue;
    }
    if (HK(r, A)) {
      s = !0, A.height += r.height, A.points = [...A.points, ...r.points];
      let l;
      e === 0 || e === 3 ? A.height > Math.abs(A.y) ? l = Math.abs(A.height - Math.abs(A.y)) : l = 0 : A.y + A.height > i ? l = A.y + A.height - i : l = 0, A.y -= l;
    } else
      n.push(A), A = r;
  }
  return A && n.push(A), {
    isOverlapping: s,
    groups: n
  };
}, HK = (e, t) => !(e.y + e.height > t.y) || t.y + t.height > e.y, PK = (e, t, i) => {
  const n = Math.abs(e / t);
  let A = Math.sqrt(1 - Math.pow(n, 2));
  return A = isNaN(A) ? 0 : A, t * A * (i === 0 || i === 1 ? 1 : -1);
}, YK = ({
  qIdx: e,
  points: t,
  connectorCrookDistance: i
}) => {
  for (let n = 0; n < t.length; n++) {
    const A = t[n], s = A.update, o = Xi(s.angle0), r = Xi(s.angle), a = o + (r - o) / 2, l = 180 / Math.PI * a;
    e === 0 || e === 1 ? (l >= 0 && l <= 5 || l >= 175 && l <= 180) && (A.text.update.x += 10) : (l > 180 && l <= 185 || l >= 355 && l <= 360) && (A.text.update.x -= 10);
    const { x: c, y: g } = A.text.update, h = s.radius * Math.sin(a), u = -s.radius * Math.cos(a), d = (s.radius + i) * Math.sin(a), f = -(s.radius + i) * Math.cos(a), I = e === 0 || e === 1 ? c - 5 : c + 5, C = g;
    A.text.connector = {
      start: [h, u],
      crook: [d, f],
      end: [I, C]
    };
  }
}, JK = ({ points: e, maxRadius: t }) => {
  for (let i = 0; i < e.length; i++) {
    const n = e[i], { crook: A, end: s } = n.text.connector, o = Math.sqrt(
      Math.pow(A[0] - s[0], 2) + Math.pow(A[1] - s[1], 2)
    ), r = jK(
      { x1: A[0], y1: -A[1], x2: s[0], y2: -s[1] },
      { cx: 0, cy: 0, radius: t }
    );
    o >= t * gS || r && o >= t * hS ? n.text.isVisible = !1 : n.text.isVisible = !0;
  }
}, KK = ({
  points: e,
  availableHeight: t,
  fontHeight: i,
  padding: n
}) => {
  if (e.forEach((a) => {
    a.text.isVisible = !1;
  }), e.length * (i + 2 * n) <= t) {
    e.forEach((a) => {
      a.text.isVisible = !0;
    });
    return;
  }
  const o = e.map((a, l) => {
    const c = Xi(a.update.angle0);
    return {
      sliceAngle: Xi(a.update.angle) - c,
      idx: l
    };
  }).sort(
    (a, l) => l.sliceAngle - a.sliceAngle
  );
  let r = 0;
  for (let a = 0; a < o.length; a++) {
    const l = o[a];
    if (r += i + 2 * n, r <= t)
      e[l.idx].text.isVisible = !0;
    else
      break;
  }
}, WK = (e) => {
  const t = e.reduce(
    (i, n) => {
      const A = n.update, s = Xi(A.angle0), o = Xi(A.angle), r = s + (o - s) / 2;
      let a;
      return r >= 0 && r <= Math.PI / 2 ? a = 0 : r > Math.PI / 2 && r <= Math.PI ? a = 1 : r > Math.PI && r <= Math.PI * 3 / 2 ? a = 2 : a = 3, i[a] || (i[a] = []), i[a].push(n), i;
    },
    new Array(4).fill(0).map(() => [])
  );
  return t.forEach((i, n) => {
    (n === 2 || n === 3) && i.reverse();
  }), t;
}, VK = (e, t) => {
  if (e.selectAll("path").remove(), !t.text || !t.text.isVisible || !t.text.connector)
    return;
  const { start: i, crook: n, end: A } = t.text.connector, s = j(e, "path", [1]);
  s.attr(
    "d",
    [
      "M",
      i[0],
      i[1],
      "L",
      n[0],
      n[1],
      "L",
      A[0],
      A[1]
    ].join(" ")
  ), s.style("stroke", t.color), s.style("fill-opacity", 0), s.style("stroke-width", "1px");
}, jK = (e, t) => {
  const { x1: i, y1: n, x2: A, y2: s } = e, { cx: o, cy: r, radius: a } = t, l = (s - n) / (A - i), c = l, g = -1, h = n - l * i;
  let u = Math.abs(c * o + g * r + h) / Math.sqrt(c * c + g * g);
  return a >= u;
}, Kp = {
  radiusDomain: [0, 50],
  radiusRange: [0, 24]
}, qK = _i.arc, I_ = (e) => class extends e {
  constructor(...t) {
    super(...t), this._prevPieData = {}, this._doneSettingPolarAxesRangeOnPostLayout = !1, this._mainColorProp = "fill";
  }
  /**
   * returns the default configuration of the layer
   *
   * @static
   * @return {Object} Default configuration for arc layer
   * @memberof ArcLayer
   */
  static defaultConfig() {
    return RK;
  }
  static formalName() {
    return "arc";
  }
  static defaultPolicy(t, i) {
    const n = tt(t, i);
    let A = n.encoding.radius.range, s = A;
    return s || (s = (o) => o), typeof s != "function" && (s = () => A), n.encoding.radius.range = s, n;
  }
  elemType() {
    return "path";
  }
  resolveTransformType() {
    return this._transformType = gn, this._transformType;
  }
  getTransformedData(t, i, n, A) {
    const { xField: s, yField: o } = A, r = [];
    return s && r.push(s), o && r.push(o), this.config(i), Ml(
      t,
      this.config(),
      { ...n, groupBy: r }
    );
  }
  getNearestPoint(t, i, n = {}) {
    let A = n.event;
    return A || (A = Bt()), this.getDataFromEvent(A);
  }
  getDataFromEvent(t) {
    const i = t.sourceEvent ? t.sourceEvent.target : t.target, n = V(i).data()[0];
    if (we(n) && n.source && this.mount().contains(i)) {
      const { source: A, rowId: s } = n;
      return {
        id: this.getIdentifiersFromData(A, s),
        layerId: this.id(),
        point: n
      };
    }
    return null;
  }
  translateSinglePoint(t, i, n, A, s, o, r) {
    const { x: a, y: l } = this.axes(), { angle: c, radius: g } = s;
    A = A || {};
    const h = c.getScaleValue(t.angle);
    if (h) {
      !A[t.angle] && (A[t.angle] = 0);
      const { startAngle: u, endAngle: d } = h[A[t.angle]++], f = In(this, t), I = nA(this, {
        translatedValues: {
          x: a.getScaleValue(t.x),
          y: l.getScaleValue(t.y),
          radius: g.getOuterRadius(t.radius),
          radius0: g.getInnerRadius(t.radius0),
          color: f.getColor(t.color),
          angle0: u,
          angle: d,
          startAngle: u,
          endAngle: d,
          startAngle0: u,
          endAngle0: d,
          text: t.text,
          formattedText: t.formattedText
        },
        datum: t,
        datumIdx: i,
        groupData: n,
        groupIdx: o,
        layerData: r
      }), C = this.axes();
      return ["x", "y"].forEach((E) => {
        const B = C[E], m = B.getUnitWidth();
        B.isYAxis() && B.constructor.type() === ce ? I[E] -= m / 2 : I[E] += m / 2;
      }), I;
    }
  }
  translatePoints(t, i, n, A, s) {
    n = tt(
      {},
      {
        handleTextLabelClipping: !1
      },
      n
    );
    const { textField: o } = this.encodingFieldsInf(), r = {}, a = this._points[0] || [];
    let l = [];
    const c = {};
    this._prevPieData = {}, a.forEach((u, d) => {
      this._prevPieData[u.rowId] = [u, d], r[u.index] = u;
    });
    const g = this.config().encoding["stroke-width"].value, h = this.config().encoding.stroke.value;
    if (t.forEach((u, d) => {
      const f = this.translateSinglePoint(
        u,
        d,
        t,
        c,
        i,
        A,
        s
      );
      if (f) {
        const I = u.rowId;
        let C;
        o && (C = Xs(
          this,
          {
            x: f.x,
            y: f.y,
            text: f.text,
            formattedText: f.formattedText,
            color: bu.textColor
          },
          u,
          d,
          t
        ));
        const E = f.color, B = {
          source: u.source,
          index: d,
          enter: {},
          update: {
            x: f.x,
            y: f.y,
            angle0: f.angle0,
            angle: f.angle,
            radius0: f.radius0,
            radius: f.radius
          },
          color: E,
          text: C,
          meta: Nn({
            fill: E,
            stroke: h,
            "stroke-width": g
          }),
          rowId: I,
          data: u.dataObj,
          _previousInfo: this._prevPieData[I] ? this._prevPieData[I][0] : kK(r, d, i)
        };
        l.push(B), this.cachePoint(I, B);
      }
    }), o) {
      let u;
      if (this.isUnivariate())
        u = this.measurement();
      else {
        const { x: f, y: I } = this.axes();
        (f instanceof ee || f instanceof qt) && (I instanceof ee || I instanceof qt) ? u = {
          width: f.getScaleBandwidth() + f.getScalePaddingInner(),
          height: I.getScaleBandwidth() + I.getScalePaddingInner()
        } : u = this.measurement();
      }
      const d = vK(this, l, {
        handleTextLabelClipping: n.handleTextLabelClipping,
        availableDimen: u
      });
      if (n.handleTextLabelClipping && d && d.shouldUpdateRadius) {
        const { radius: f } = i;
        f.range(
          f.range().map((I) => I + I * d.radiusChangeInPercentage)
        ), l = this.translatePoints(
          t,
          i,
          {
            handleTextLabelClipping: !1
          },
          A,
          s
        );
      }
    }
    return l;
  }
  render(t, i) {
    this.preRender(i, !0), this._doneSettingPolarAxesRangeOnPostLayout ? this._doneSettingPolarAxesRangeOnPostLayout = !1 : this.setPolarAxesRange();
    const {
      classPrefix: n,
      defClassName: A,
      className: s,
      cornerRadius: o,
      padAngle: r,
      padRadius: a,
      transition: l
    } = this.config(), c = _n(
      A,
      this.id(),
      n
    ), g = V(t);
    g.classed(c.join(" "), !0), g.classed(s, !0);
    const h = eA(), u = ft(
      i.transition,
      l
    ), d = _n(
      A,
      this.id(),
      n
    ), f = this._arcFn = qK().cornerRadius(o).startAngle((D) => Xi(D.update.angle0)).endAngle((D) => Xi(D.update.angle)).padAngle(r).padRadius(a).outerRadius((D) => D.update.radius).innerRadius((D) => D.update.radius0), I = this.getRenderableNormalizedData();
    this._points = I.map((D, Q) => this.translatePoints(
      D,
      this._polarAxes[Q],
      {
        // If it is an isUnivariate chart(single pie chart), then handle
        // text label clipping by reducing the radius, otherwise, just use
        // ellipsis.
        handleTextLabelClipping: this.isUnivariate()
      },
      Q,
      I
    )).reduce((D, Q) => {
      const p = Q.filter(
        (w) => !Number.isNaN(w.update.x) && !Number.isNaN(w.update.y)
      );
      return p.length ? [...D, p] : D;
    }, []);
    const C = this._graphicElems = {};
    this._linkedElems = {};
    const E = j(
      V(t),
      "g",
      this._points,
      `${d[0]}-group`
    ).classed(`${d[1]}-group`, !0).attr("transform", ([D]) => `translate(${D.update.x},${D.update.y})`), B = `${d[0]}-labels`, m = (D) => {
      let Q = j(
        D,
        "path",
        (p) => [p],
        `${d[0]}-path`
      ).style("fill", (p) => p.color).each(function(p) {
        C[p.rowId] = V(this);
      });
      u.disabled ? Q.attr("d", f) : Q = Q.transition().duration(u.duration).on("end", h.newCallback()).attrTween("d", (...p) => TK(f, p)), Q.attr("class", (p, w) => {
        const x = iA(
          p,
          w,
          this._points,
          this
        );
        return `${d[0]}-path ${d[1]}-path-${p.index}
                        ${x}`;
      });
    }, y = j(E, "g", (D) => D, `${d[0]}`, {
      update: m
    }).attr(
      "class",
      (D, Q) => `${d[0]} ${d[1]}-${Q}`
    );
    if (this.onAnimationEnd().then(() => {
      y.each(function(D) {
        const Q = V(this), p = j(
          Q,
          "g",
          [1],
          `.${B}`
        );
        D.text && VK(p, D);
      });
    }), this.hasTextEncodingField())
      if (this._stackedSum.size) {
        const D = this.getTextPointsForStackSum();
        this.textPointsInfo({
          points: D,
          location: "text"
        });
      } else {
        const D = this._points.flat();
        this.textPointsInfo({
          points: D,
          location: "sum"
        });
      }
    else
      this.textPointsInfo(null);
    return this.postRender(i), h.onAllCallbacksCalled().then(() => {
      this.emitAnimationEndHook(i);
    }), this;
  }
  filterTextPoints(t) {
    const { points: i } = t;
    return this._stackedSum.size ? super.filterTextPoints(t) : i.filter((n) => !!n.text && n.text.isVisible);
  }
  getPointsFromIdentifiers(t) {
    if (!this.data())
      return [];
    const i = [];
    for (const A of t)
      this._pointMap[A] && i.push(this._pointMap[A]);
    const n = i[0];
    return n ? [this.getCartesianCoordinatesFromPointInfo(n)] : [];
  }
  getCartesianCoordinatesFromPointInfo(t) {
    const i = this._arcFn.centroid(t);
    return {
      x: i[0] + t.update.x,
      y: i[1] + t.update.y,
      width: 2,
      height: 2
    };
  }
  static autoDetectTransformType() {
    return gn;
  }
  /**
   * @override
   */
  postLayout() {
    this.setPolarAxesRange(), this._doneSettingPolarAxesRangeOnPostLayout = !0;
  }
  /**
   * @override
   */
  requiresExtendDomainDiffs() {
    return !0;
  }
  createPolarAxes() {
    const t = this._normalizedData, i = [], { radiusField: n } = this.encodingFieldsInf();
    t.forEach((A) => {
      const s = this.calculatePolarDomain(A);
      let o = new k5();
      n ? o.domain(s.radius) : o.domain(Kp.radiusDomain);
      const r = this.config().encoding, a = ft(
        W(r.angle, "field"),
        W(r.color, "field")
      );
      let l = oe;
      const c = this.data().getField(a);
      a && c && (l = c.subtype() === fu || c.subtype() === fi ? oe : "continuous");
      let g = new R5({
        angle: { as: l, ...this.config().encoding.angle },
        fieldInst: c
      });
      g.domain(s.angle), i.push({
        radius: o,
        angle: g
      });
    }), this._polarAxes = i;
  }
  setPolarAxesRange() {
    const t = this.encodingFieldsInf(), i = this.axes();
    let A = this.config().encoding.radius.range;
    const { xField: s, yField: o, sizeField: r, sizeFieldType: a, textField: l } = t, { x: c, y: g, size: h } = i, u = c.scale().range()[1], d = g.scale().range()[0];
    this._normalizedData.forEach((f, I) => {
      const { radius: C } = this._polarAxes[I];
      if (!C)
        return;
      let E;
      if (s === bt && o === bt)
        E = l ? Math.min(u / 3, d / 3) : Math.min(u / 2, d / 2);
      else if (h && r) {
        const y = f.map((D) => D.size);
        a === J.FieldType.MEASURE ? E = h.getSize(Math.max(...y)) : E = h.getSize(y[0]);
      } else {
        const y = [c, g].map((D) => D instanceof ee ? D.getScaleBandwidth() - D.getScalePaddingInner() : D instanceof qt ? D.getUnitWidth() / 2 : Kp.radiusRange[1]);
        E = Math.min(...y);
      }
      const m = [0, _E(this, {
        translatedValue: E,
        datum: f[0],
        datumIdx: 0,
        groupData: f,
        groupIdx: I,
        layerData: this._normalizedData,
        encodingName: "size"
      })];
      C.range(A(m));
    });
  }
  /**
   * @override
   */
  calculateExtendDomainDiffs() {
    const { x: t, y: i } = this.axes();
    if ((t instanceof ee || t instanceof qt) && (i instanceof ee || i instanceof qt))
      return {
        x: [0, 0],
        y: [0, 0]
      };
    const n = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, A = Math.abs(t.range()[1] - t.range()[0]), s = Math.abs(i.range()[1] - i.range()[0]), o = this._normalizedData;
    return o.forEach((r, a) => {
      const l = {}, c = this._polarAxes[a];
      r.forEach((g, h) => {
        const u = this.translateSinglePoint(
          g,
          h,
          r,
          l,
          c,
          a,
          o
        );
        if (u) {
          const { x: d, y: f, radius: I } = u, C = d - I;
          C < 0 && (n.left = Math.max(
            Math.abs(C),
            n.left
          ));
          const E = A - (d + I);
          E < 0 && (n.right = Math.max(
            Math.abs(E),
            n.right
          ));
          const B = f - I;
          B < 0 && (n.top = Math.max(Math.abs(B), n.top));
          const m = s - (f + I);
          m < 0 && (n.bottom = Math.max(
            Math.abs(m),
            n.bottom
          ));
        }
      });
    }), {
      x: [n.left, n.right],
      y: [n.top, n.bottom]
    };
  }
  getPointsWithinRange() {
    return [];
  }
};
class C_ extends _e(AA).with(I_) {
  static formalName() {
    return "arc";
  }
}
class E_ extends _e(AA).with(jE) {
  static formalName() {
    return iS;
  }
}
const B_ = {
  name: "muze-light",
  className: "muze-light-theme",
  font: {
    fontSize: "12px",
    fontFamily: "'Source Sans Pro','Helvetica Neue', Helvetica, Arial, sans-serif",
    fontWeight: "400",
    fontStyle: "normal",
    components: {
      axis: {
        name: {
          fontSize: "14px",
          fontFamily: "'Source Sans Pro','Helvetica Neue', Helvetica, Arial, sans-serif",
          fontWeight: "400",
          fontStyle: "normal"
        }
      }
    }
  },
  loadCSS: () => {
  }
};
const zK = {
  name: "mode-light",
  className: "mode-light-theme",
  font: {
    // As the ModeTheme uses `font-variant-numeric: tabular-nums`, so, here
    // the fontSize should be a little bit larger than the applied CSS style to make
    // the labelManager to work properly.
    fontSize: "14px",
    fontFamily: '"Graphik", Helvetica, sans-serif',
    fontWeight: "400",
    fontStyle: "normal",
    components: {
      axis: {
        name: {
          fontSize: "15px",
          fontFamily: '"Graphik", Helvetica, sans-serif',
          fontWeight: "400",
          fontStyle: "normal"
        }
      },
      facets: {
        fontSize: "12px"
      }
    }
  },
  loadCSS: () => {
  }
};
const ZK = {
  name: "dummy-light",
  className: "dummy-light-theme",
  font: {
    fontSize: "12px",
    fontFamily: "'Source Sans Pro','Helvetica Neue', Helvetica, Arial, sans-serif",
    fontWeight: "400",
    fontStyle: "normal",
    components: {
      axis: {
        name: {
          fontSize: "14px",
          fontFamily: "'Source Sans Pro','Helvetica Neue', Helvetica, Arial, sans-serif",
          fontWeight: "400",
          fontStyle: "normal"
        }
      }
    }
  },
  loadCSS: () => {
  }
}, Wp = /* @__PURE__ */ new Set();
function $K(e) {
  Wp.has(e.name) || (e.loadCSS(e), Wp.add(e.name));
}
function XK(e, t) {
  V(t).classed(String(e.className), !0);
}
function BA(e) {
  if (!e)
    return {};
  const t = {};
  return [
    ["font-size", "fontSize"],
    ["font-family", "fontFamily"],
    ["font-weight", "fontWeight"],
    ["font-style", "fontStyle"]
  ].forEach(([i, n]) => {
    e[n] && (t[i] = e[n]);
  }), t;
}
const t6 = (e, t, i, n) => {
  const A = t.filter((r) => !!r && !r.isLabelThinned), { selection: s, elems: o } = GM(
    n,
    e,
    A,
    i
  );
  return n._graphicElems = o, n._linkedElems = {
    ...n._linkedElems,
    text: Object.assign({}, n._linkedElems.text, o)
  }, s;
}, e6 = {
  defClassName: "layer-text",
  classPrefix: en,
  className: "",
  transform: {},
  interaction: {
    highlight: {
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                "text-decoration": "underline",
                // "font-weight": "bold",
                cursor: "pointer"
                // "border-color": "black",
              }
            }
          ]
        }
      }
    },
    select: {
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "1px",
                // "border-color": "black",
                "text-decoration": "underline"
                // "font-weight": "bold",
              }
            }
          ]
        }
      }
    },
    brush: {
      sideEffects: {}
    },
    [Rs]: {
      sideEffects: {
        [hu]: {}
      }
    }
  },
  crossline: !1,
  transition: {
    effect: "cubic",
    duration: 1e3
  },
  encoding: {
    color: {},
    size: {},
    radius: {},
    angle: {},
    text: { ...$s },
    "border-color": {
      value: ""
    }
  },
  align: mn,
  style: {
    "font-size": "12px",
    "font-family": '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
    "font-weight": "400",
    "font-style": "normal",
    "font-variant": "tabular-nums"
  }
};
function i6(e, t, i, n) {
  const { width: A, height: s } = t, { textDistance: o, xIndex: r, yIndex: a } = n, { smartLabel: l } = e.dependencies(), { width: c, height: g } = e.calculateOptimumTextLabelDimensions(), h = Math.min(
    c,
    A - 2 * o
  ), u = Math.min(
    g,
    s - 2 * o
  ), d = u + 2 * o, f = Math.max(Math.floor(s / d), 1), I = "...", { width: C } = l.getOriSize(I);
  let E = [], B = A, m = 0;
  for (let y = 0; y < i.length; y++) {
    const D = i[y], { text: Q } = D, p = Q ? l.getOriSize(Q).width : 0, w = Math.min(p, h), x = u, S = w + 2 * o, _ = m === f - 1;
    if (S > B)
      if (_) {
        let M;
        C > B ? (E.pop(), M = i.slice(y - 1)) : M = i.slice(y), E.push({
          xIndex: r,
          yIndex: a,
          text: I,
          allocatedDimens: {
            text: { width: C, height: u },
            cell: {
              width: C + 2 * o,
              height: d
            }
          },
          moreData: M
        });
        break;
      } else
        m++, B = A;
    B -= S, D.allocatedDimens = {
      text: { width: w, height: x },
      cell: { width: S, height: d }
    }, E.push(D);
  }
  return E;
}
class n6 extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return hu;
  }
  apply(t, { target: i, isActive: n }) {
    i && (n ? i.classed("highlight", !0) : i.classed("highlight", !1));
  }
}
const Vp = (e, t, i, n, A, s) => {
  let o = [];
  const r = n.axes(), l = n.config().encoding.text, { field: c, value: g } = l, h = c ? n.data().getFieldIndex(c) : -1, u = yt.X, d = yt.Y, f = (I, C) => {
    if (!r[I])
      return 0;
    const E = r[I], { fieldSubtype: B, fieldAs: m } = E.config();
    let y = E.getScaleValue(C[I]);
    return I === yt.Y && B === fi && m === lt.CONTINUOUS ? y -= E.getUnitWidth() / 2 : y += E.getUnitWidth() / 2, y;
  };
  for (let I = 0, C = e.length; I < C; I++) {
    const E = e[I], B = E.source, m = c ? B[h] : g, [y, D] = [u, d].map((k) => f(k, E)), Q = In(n, E), p = Q.getColor(E.color, Q), x = kM(n, E).getColor(E.backgroundColor);
    let S = c ? E.formattedText : m;
    (S instanceof Function || typeof S == "function") && (S = S(
      {
        x: y,
        y: D,
        color: p,
        backgroundColor: x
      },
      I,
      e,
      n
    ));
    const _ = nA(n, {
      translatedValues: {
        x: y,
        y: D,
        text: m,
        formattedText: S,
        color: p,
        backgroundColor: x
      },
      datum: E,
      datumIdx: I,
      groupData: e,
      groupIdx: A,
      layerData: s
    }), M = Xs(
      n,
      {
        x: _.x,
        y: _.y,
        color: _.color,
        backgroundColor: _.backgroundColor,
        text: _.text,
        formattedText: _.formattedText
      },
      E,
      I,
      e
    );
    M && !J.isInvalid(M.text) && (M.xIndex = r.x ? r.x.getIndex(
      E.x,
      i.x ? i.x.range : null
    ) : null, M.yIndex = r.y ? r.y.getIndex(
      E.y,
      i.y ? i.y.range : null
    ) : null, o.push(M), n.cachePoint(E.rowId, M));
  }
  return o = Zs(n, o), o = o.filter((I) => {
    const C = I.update;
    return !isNaN(C.x) && !isNaN(C.y);
  }), o;
}, m_ = (e) => class extends e {
  constructor(...t) {
    super(...t), this._rtree = new Ns();
  }
  /**
   * Returns the default configuration of the text layer
   * @return {Object} Default configuration of the text layer
   */
  static defaultConfig() {
    return e6;
  }
  static defaultPolicy(t, i) {
    let n = tt(t, i);
    return n = tt(n, {
      style: tt(
        {},
        BA(W(n.theme, "font")),
        BA(
          W(n.theme, "font", "components", "textLayer")
        )
      )
    }), n;
  }
  static formalName() {
    return "text";
  }
  getSideEffects() {
    return {
      [hu]: n6
    };
  }
  elemType() {
    return "text";
  }
  getPointTranslator() {
    return Vp;
  }
  /**
   * Generates an array of objects containing x, y, width and height of the points from the data
   * @param  {Array.<Array>} data Data Array
   * @param  {Object} encoding  Config
   * @param  {Object} axes     Axes object
   * @return {Array.<Object>}  Array of points
   */
  translatePoints(t, i = {}, n, A, s) {
    return Vp(
      t,
      i,
      n,
      this,
      A,
      s
    );
  }
  /**
   * Renders the plot in the given container
   * @param  {SVGElement} container SVGElement which will hold the plot
   * @return {textLayer} Instance of text layer
   */
  render(t, i) {
    this.preRender(i, !0);
    const n = this.dependencies().smartLabel, A = this.calculateViewableAxisDomains(i), s = this.getRenderableNormalizedData(), o = eA(), r = this.config(), {
      encoding: {
        text: { hyperlink: a }
      }
    } = r, l = r.className, c = _n(
      r.defClassName,
      this.id(),
      r.classPrefix
    );
    if (V(t).classed(`${c.join(" ")} ${l}`, !0).style("width", "inherit").style("height", "inherit"), this._linkedElems = {}, this.renderer() === "html") {
      const d = s.length ? this.translatePoints(
        s[0],
        {},
        A,
        0,
        s
      ) : [];
      this._points = d;
      const { style: f } = this.config();
      n.setStyle(f), this.renderHTML(t, d, A, a);
    } else
      this._graphicElems = {}, this._points = [], PC({
        data: s,
        append: "g",
        selector: "g",
        container: t,
        each: (d, f, I) => {
          const C = f.node(), E = this.translatePoints(
            d,
            {},
            A,
            I,
            s
          );
          this._points.push(E), Pt(C, {
            "text-anchor": $x
          }), t6(
            C,
            E,
            {
              className: c[0]
            },
            this
          );
        }
      });
    n.setStyle(
      zn(V(t), c[0])
    );
    const u = this._points.flat().filter((d) => d !== null).map((d) => {
      const { x: f, y: I } = d.update, { width: C, height: E } = n.getOriSize(d.text), B = d.data;
      return {
        minX: f - C / 2,
        maxX: f + C / 2,
        minY: I - E / 2,
        maxY: I + E / 2,
        width: C,
        height: E,
        data: B,
        point: d,
        x: f,
        y: I
      };
    });
    return this._rtree = new Ns(), this._rtree.load(u), this.postRender(i), o.onAllCallbacksCalled().then(() => {
      this.emitAnimationEndHook(i);
    }), this;
  }
  renderHTML(t, i, n, A) {
    const { enabled: s } = A, { textFieldSubType: o } = this.encodingFieldsInf();
    let r = n.x ? n.x.range.translate : 0, a = n.y ? n.y.range.translate : 0;
    const l = {}, { x: c, y: g } = this.axes(), { classPrefix: h, align: u, isBold: d, firstRowZebraType: f, style: I } = this.config(), { smartLabel: C } = this.dependencies();
    C.setStyle(I);
    const E = [];
    i.forEach((Z) => {
      const { xIndex: Y, yIndex: q } = Z;
      E[q] || (E[q] = []), E[q][Y] || (E[q][Y] = []), E[q][Y].push(Z);
    });
    const B = this.cellMaxCount(), { field: m, value: y } = this.config().encoding.color, { field: D, value: Q } = this.config().encoding.backgroundColor, p = n.y ? n.y.domain.length : g.domain().length, w = n.x ? n.x.domain.length : c.domain().length, x = c.getScaleStep(), S = g.getScaleStep();
    let _ = n.x ? n.x.range.visibleCellDimension : w * x + c.getScalePaddingOuter(), M = n.y ? n.y.range.visibleCellDimension : p * S + g.getScalePaddingOuter();
    const k = V(t);
    k.select(".muze-layer-text-grid-container").remove();
    const T = j(
      k,
      "div",
      [1],
      "muze-layer-text-grid-container"
    );
    T.style("width", `${_}px`).style("height", `${M}px`).style("display", "grid").style("grid-template-columns", `repeat(${w}, 1fr)`).style("grid-template-rows", `repeat(${p}, 1fr)`).style("transform", `translate(${r}px, ${a}px)`), T.classed("bold", d), C.useEllipsesOnOverflow(!0);
    const G = [];
    for (let Z = 0; Z < p; Z++)
      for (let Y = 0; Y < w; Y++) {
        const q = E[Z] && E[Z][Y];
        q && q.length ? G.push(q) : G.push([
          {
            xIndex: Y,
            yIndex: Z
          }
        ]);
      }
    const N = `${h}-layer-text-outer-cell`, b = j(T, "div", G, N);
    b.style("display", "flex").style("flex-direction", "row").style("justify-content", u).style("flex-wrap", "wrap").style("align-content", "start").style("position", "relative"), B > 1 && (u === ZC ? b.style(
      "padding-right",
      `${ns}px`
    ) : u === $C ? b.style(
      "padding-left",
      `${ns}px`
    ) : u === mn && (b.style(
      "padding-left",
      `${ns / 2}px`
    ), b.style(
      "padding-right",
      `${ns / 2}px`
    )));
    const F = _ / w, R = M / p, v = F - ns - 2 * za, O = R - 2 * za, L = `${h}-text-row-${f === "odd" ? "odd" : "even"}`, U = `${h}-text-row-${f === "odd" ? "even" : "odd"}`;
    this._graphicElems = {};
    const H = this, z = `${h}-layer-text-inner-cell`, et = s ? "a" : "div";
    b.each(function(Z) {
      const Y = V(this), { yIndex: q, xIndex: $ } = Z[0], P = n.y ? n.y.range.startIdx + q : q, st = n.x ? n.x.range.startIdx + $ : $, nt = `${N} ${(P + 1) % 2 === 0 ? U : L} ${h}-text-row-${P} ${h}-text-col-${st}`;
      Y.attr("class", nt);
      const ot = i6(
        H,
        { width: v, height: O },
        Z,
        {
          textDistance: Jo,
          xIndex: $,
          yIndex: q
        }
      );
      j(
        Y,
        et,
        ot,
        z
      ).each(function(ct) {
        const ht = V(this), { text: Mt, rowId: Ue } = ct, at = (Q || D) && ct.backgroundColor;
        if (at && (ht.style("background-color", ct.backgroundColor), B <= 1 && Y.style("background-color", ct.backgroundColor)), (m || y) && ct.color)
          ht.style("color", ct.color);
        else if (at) {
          const { l: Ot } = bA(ct.backgroundColor);
          Ot <= 0.5 ? ht.classed(fS, !0) : ht.classed(dS, !0);
        }
        if (B > 1) {
          const { height: Ot } = ct.allocatedDimens.cell;
          ht.style("padding", `0 ${Jo}px`).style("height", `${Ot}px`).style("display", "grid");
        } else
          ht.style("display", "grid").style("width", "100%").style("height", "100%").style("padding", `0 ${Jo}px`).style("text-align", u);
        if (s && ct.hyperlinkInfo && yl(ht, ct, A), Mt) {
          const Ot = W(ct, "text");
          if (o === fu) {
            let Vt, pi;
            B > 1 ? (Vt = ct.allocatedDimens.text.width, pi = ct.allocatedDimens.text.height) : (Vt = v, pi = O);
            const he = C.getSmartText(
              Ot,
              Vt,
              pi,
              !0
            );
            this.textContent = `${he.text}`;
          } else
            this.textContent = `${Ot}`;
        } else
          this.textContent = null;
        l[Ue] = ht;
      });
    }), this._graphicElems = l;
  }
  getNearestPoint(t, i, { event: n }) {
    if (n || (n = Bt()), this.renderer() !== "html") {
      const A = this._rtree.search({
        minX: Math.max(t - 1, 0),
        minY: Math.max(i - 1, 0),
        maxX: t + 1,
        maxY: i + 1
      });
      if (A.length)
        return this.getDataFromEvent(n, A[0].point);
    } else
      return this.getDataFromEvent(n);
    return null;
  }
  getDataFromEvent(t, i) {
    return _u(this, t, i);
  }
  static autoDetectTransformType() {
    return En;
  }
  getBoundBox(t) {
    if (this.renderer() !== "html") {
      const { x: c, y: g } = t.update, h = this._rtree.search({
        minX: Math.max(c - 1, 0),
        minY: Math.max(g - 1, 0),
        maxX: c + 1,
        maxY: g + 1
      });
      return {
        x: h[0].x,
        y: h[0].y,
        width: h[0].width,
        height: h[0].height
      };
    }
    const { update: i } = t, { x: n, y: A } = this.axes(), s = n.getScaleStep(), o = A.getScaleStep(), r = i.x - s / 2, a = i.y - o / 2, l = this._graphicElems[t.rowId];
    if (l && l.node()) {
      const c = l.node(), g = c.getBoundingClientRect();
      return {
        x: r + c.offsetLeft,
        y: a + c.offsetTop,
        width: g.width,
        height: g.height
      };
    } else
      return {
        x: r,
        y: a,
        width: s,
        height: o
      };
  }
  /**
   * @override
   */
  requiresExtendDomainDiffs() {
    return !0;
  }
  /**
   * @override
   */
  calculateExtendDomainDiffs() {
    const t = this.dependencies().smartLabel.getOriSize("X").height, i = Gs(this.axes().x, this.domain().x, [
      t,
      t
    ]), n = Gs(this.axes().y, this.domain().y, [
      t,
      t
    ]);
    return { x: i, y: n };
  }
  getElementByRowId(t) {
    return this.renderer() === "html" ? this._graphicElems[t] : this._graphicElems[t] ? this._graphicElems[t].select("text") : null;
  }
};
class Q_ extends _e(AA).with(m_) {
  static formalName() {
    return "text";
  }
}
const A6 = {
  defClassName: "layer-point",
  className: "",
  classPrefix: en,
  defColorStyle: "stroke",
  interaction: {
    highlight: {
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "1px"
              }
            },
            {
              target: (e, t) => {
                const {
                  entryExitSet: { entrySet: i }
                } = e, n = t.getEntryExitSet("select");
                return n ? i.intersect(n.entrySet) : null;
              },
              key: "commonSet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "2px"
              }
            }
          ]
        }
      }
    },
    select: {
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  {
                    target: "exitSet",
                    style: {
                      fill: { a: -0.7 }
                      // strokePosition: "center",
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "1px"
              }
            }
          ]
        }
      }
    },
    brush: {
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  // {
                  //   target: "entrySet",
                  //   style: {
                  //     fill: { a: +0.3 },
                  //     strokePosition: "center",
                  //   },
                  // },
                  {
                    target: "exitSet",
                    style: {
                      fill: { a: -0.5 }
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              // target: (interactionInf, firebolt) => {
              //   if (interactionInf.payload.sourceInfo.layerId !== firebolt.id()) {
              //     return null;
              //   } else {
              //     return interactionInf.entryExitSet.entrySet;
              //   }
              // },
              target: "entrySet",
              style: {
                stroke: "black",
                "stroke-width": "1px",
                strokePosition: "outside"
              }
            }
          ]
        }
      }
    }
  },
  innerPadding: 0.1,
  outerPadding: 0,
  nearestPointThreshold: 5,
  transform: {},
  transition: {
    effect: "cubic",
    duration: 1e3,
    disabled: !0
  },
  encoding: {
    size: {
      value: 30
    },
    color: {},
    // stroke: {
    //   value: "#000",
    // },
    // "stroke-width": {
    //   value: 0,
    // },
    fill: {},
    shape: {
      value: "circle"
    },
    x: {},
    y: {},
    text: {
      ...$s,
      labelPlacement: void 0
    },
    // "stroke-opacity": {
    //   value: 1,
    // },
    // "fill-opacity": {
    //   value: 0.5,
    // },
    strokePosition: {
      value: "center"
    }
  },
  interactive: !0
};
const p_ = ({
  data: e,
  datum: t,
  i,
  layerInst: n,
  xPx: A,
  yPx: s,
  groupIdx: o,
  layerData: r
}) => {
  const a = n.axes(), l = n.config().encoding, { shape: c } = a, g = Fl(n, t), h = In(n, t);
  let u = c.getShape(t.shape), d = g.getSize(t.size), f = h.getColor(t.color);
  const I = n.config().encoding, { textField: C } = n.encodingFieldsInf(), E = nA(n, {
    translatedValues: {
      x: A,
      y: s,
      color: f,
      size: d,
      shape: u,
      data: t,
      text: t.text
    },
    datum: t,
    datumIdx: i,
    groupData: e,
    groupIdx: o,
    layerData: r
  }), { rowId: B, source: m } = t;
  ({ shape: u, size: d, color: f } = E);
  const y = {
    fill: f,
    ...Nl(l, [n._mainColorProp])
  }, { x: D, y: Q } = E;
  let p;
  if (C) {
    const x = vs(
      { x: 0, y: 0, text: E.text },
      i,
      e,
      n
    ), { smartLabel: S } = n._dependencies, _ = new kE(S), M = {
      positionAt: Jf(n.config().encoding.text),
      rotation: x
    }, k = t.formattedText, { xPos: T, yPos: G } = RE(
      k,
      { x: 0, y: 0, size: E.size },
      M,
      _
    );
    p = Xs(
      n,
      {
        x: T,
        y: G,
        text: E.text,
        formattedText: k,
        color: bu.textColor
      },
      t,
      i,
      e
    );
  }
  const w = { x: D, y: Q };
  return {
    enter: w,
    update: w,
    shape: u,
    source: m,
    rowId: B,
    style: y,
    data: t.dataObj,
    meta: Object.assign(
      {
        layerId: n.id()
      },
      Nn(y, {
        strokePosition: I.strokePosition.value
      })
    ),
    size: d,
    text: p
  };
}, y_ = (e, t, i, n, A) => {
  let s = [];
  const o = i.config().encoding, r = i.axes(), a = i.measurement(), { x: l, y: c } = t.offset;
  for (let g = 0, h = e.length; g < h; g++) {
    const u = e[g];
    let [d, f] = [yt.X, yt.Y].map((I) => {
      const C = u[I] === null ? void 0 : u[I], E = I === yt.X ? a.width : a.height;
      return o[I].field ? r[I].getScaleValue(C) : E / 2;
    });
    if (d += l, f = r.y.constructor.type() === ce ? f - c : f + c, !isNaN(d) && !isNaN(f)) {
      const I = p_({
        data: e,
        datum: u,
        i: g,
        layerInst: i,
        xPx: d,
        yPx: f,
        groupIdx: n,
        layerData: A
      });
      I.className = iA(u, g, e, i), s.push(I), i.cachePoint(u.rowId, I);
    }
  }
  return s = Zs(i, s), s;
}, D_ = "center", w_ = "inside", s6 = "outside", o6 = (e, t) => e === D_ ? -t : e === w_ ? -(t * Math.PI) : +(t * Math.PI), r6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CENTER: D_,
  INSIDE: w_,
  OUTSIDE: s6,
  getStrokeWidthByPosition: o6,
  pointTranslators: y_,
  prepareDrawingInf: p_
}, Symbol.toStringTag, { value: "Module" })), qE = (e) => class extends e {
  /**
   * Creates an instance of PointLayer.
   * @param {*} args
   * @memberof PointLayer
   */
  constructor(...t) {
    super(...t), this._voronoi = new DC(), this._bandScale = MC.band(), this.formattedUids = [], this._rtree = null, this._mainColorProp = "fill";
  }
  elemType() {
    return "g";
  }
  /**
   * Returns the default configuration of the point layer
   * @return {Object} Default configuration of the point layer
   */
  static defaultConfig() {
    return A6;
  }
  // static defaultPolicy(conf, userConf) {
  //   const config = super.defaultPolicy(conf, userConf);
  //   const encoding = config.encoding;
  //   const transform = config.transform;
  //   const colorField = encoding.color && encoding.color.field;
  //   if (colorField) {
  //     transform.groupBy = colorField;
  //   }
  //   return config;
  // }
  static drawFn() {
    return l_;
  }
  /**
   * Generates an array of objects containing x, y, width and height of the points from the data
   * @param  {Array.<Array>} data Data Array
   * @param  {Object} encoding  Config
   * @param  {Object} axes     Axes object
   * @return {Array.<Object>}  Array of points
   */
  translatePoints(t, i = {}, n, A) {
    return y_(t, i, this, n, A);
  }
  /**
   * Renders the plot in the given container.
   *
   * @param  {SVGElement} container SVGElement which will hold the plot
   * @return {BarLayer} Instance of bar layer
   */
  render(t, i) {
    this.preRender(i, !0);
    const n = eA();
    let A = 0, s;
    const o = this.config(), r = this._transformedData.getUniqueValues(), { transition: a, className: l, defClassName: c, classPrefix: g } = o, h = this.getRenderableNormalizedData(), u = V(t), d = _n(
      c,
      this.id(),
      g
    );
    this._points = [], this._pointMap = {}, u.classed(d.join(" "), !0).classed(l, !0), this._points = this.generateDataPoints(h, r), this._graphicElems = {}, this._linkedElems = {};
    const f = this.data().getSchema();
    return j(
      t,
      "g",
      this._points,
      null,
      {
        update: (I, C) => {
          A = Cn([A, ...C.map((E) => E.size || 0)]), s = `${d[0]}`, this.constructor.drawFn()({
            layer: this,
            container: I.node(),
            points: C,
            interpolate: o.interpolate,
            className: s,
            transition: a,
            animationAggregator: n,
            keyFn: (E) => FM(E.source, f)
          });
        }
      },
      (I) => I[0].rowId
    ), this._maxSize = A * 2, this.postRender(i), n.onAllCallbacksCalled().then(() => {
      this.emitAnimationEndHook(i);
    }), this;
  }
  postRender(t) {
    if (super.postRender(t), this.config().interactive) {
      this.attachDataToVoronoi(this._points);
      const i = this.getBoundBoxes().flat().filter((n) => n !== null);
      this._rtree = new Ns(), this._rtree.load(i);
    }
  }
  attachDataToVoronoi(t) {
    _l(this._voronoi, t);
  }
  generateDataPoints(t, i) {
    const [n, A] = Pf(this, i), s = n.offsetValues || [], o = A.offsetValues || [];
    return t.map((r, a) => {
      const l = this.getMeasurementConfig(
        s[a],
        o[a],
        n.span,
        A.span
      );
      return this.translatePoints(
        r,
        l,
        a,
        t
      );
    }).filter((r) => r.length);
  }
  getMeasurementConfig(t, i, n, A) {
    return {
      offset: {
        x: (t || 0) + n / 2,
        y: (i || 0) + A / 2
      },
      span: {
        x: n,
        y: A
      }
    };
  }
  getShapeRadius(t) {
    return t ? t.data.data.size : 0;
  }
  /**
   * Gets the nearest point from a position.
   * @param {number} x x position
   * @param {number} y y position
   * @return {Object} Point details
   */
  getNearestPoint(t, i) {
    const n = this.config().nearestPointThreshold, A = Math.max(this._maxSize, n);
    if (!this.data())
      return null;
    const s = this._voronoi.find(t, i, A), o = s && s.data.data.update, r = this.getShapeRadius(s);
    if (s && cx(
      {
        x: o.x,
        y: o.y,
        r: r + n
      },
      { x: t, y: i }
    )) {
      const { source: l, rowId: c } = s.data.data;
      return {
        id: this.getIdentifiersFromData(l, c),
        dimensions: [
          {
            x: o.x,
            y: o.y,
            width: r,
            height: r
          }
        ],
        point: s.data.data,
        layerId: this.id()
      };
    }
    return null;
  }
  getBoundBoxes() {
    return bE(this._points.flat());
  }
  applyElementStyles(t, i) {
    super.applyElementStyles(t, i);
    const n = t.select("path");
    super.applyElementStyles(n, i);
  }
  getOverlayPathMount() {
    return null;
  }
  static autoDetectTransformType() {
    return En;
  }
  /**
   * @override
   */
  requiresExtendDomainDiffs() {
    return !0;
  }
  /**
   * @override
   */
  calculateExtendDomainDiffs() {
    const { x: t, y: i } = this.axes(), n = this.config().encoding;
    if ((t instanceof ee || t instanceof qt) && (i instanceof ee || i instanceof qt))
      return {
        x: [0, 0],
        y: [0, 0]
      };
    const A = this.dependencies().smartLabel.getOriSize("X").height, s = Gs(this.axes().x, this.domain().x, [
      A,
      A
    ]), o = Gs(this.axes().y, this.domain().y, [
      A,
      A
    ]), r = {
      left: s[0],
      right: s[1],
      top: o[0],
      bottom: o[1]
    }, a = Math.abs(t.range()[1] - t.range()[0]), l = Math.abs(i.range()[1] - i.range()[0]), c = this._transformedData.getUniqueValues(), [g, h] = Pf(this, c), u = g.offsetValues || [], d = h.offsetValues || [], f = this._normalizedData;
    return f.forEach((I, C) => {
      const E = this.getMeasurementConfig(
        u[C],
        d[C],
        g.span,
        h.span
      ), { x: B, y: m } = E.offset;
      for (let y = 0, D = I.length; y < D; y++) {
        const Q = I[y];
        let [p, w] = [yt.X, yt.Y].map((x) => {
          const S = Q[x] === null ? void 0 : Q[x], _ = x === yt.X ? a : l;
          return n[x].field ? this.axes()[x].getScaleValue(S) : _ / 2;
        });
        if (p += B, w = i.constructor.type() === ce ? w - m : w + m, !isNaN(p) && !isNaN(w)) {
          const x = Fl(this, Q), S = nA(this, {
            translatedValues: {
              x: p,
              y: w,
              size: x.getSize(Q.size)
            },
            datum: Q,
            datumIdx: y,
            groupData: I,
            groupIdx: C,
            layerData: f
          }), { x: _, y: M, size: k } = S, T = _ - k;
          T < 0 && (r.left = Math.max(
            Math.abs(T),
            r.left
          ));
          const G = a - (_ + k);
          G < 0 && (r.right = Math.max(
            Math.abs(G),
            r.right
          ));
          const N = M - k;
          N < 0 && (r.top = Math.max(Math.abs(N), r.top));
          const b = l - (M + k);
          b < 0 && (r.bottom = Math.max(
            Math.abs(b),
            r.bottom
          ));
        }
      }
    }), {
      x: [r.left, r.right],
      y: [r.top, r.bottom]
    };
  }
};
class x_ extends _e(AA).with(qE) {
  static formalName() {
    return nS;
  }
}
const a6 = (e, t, i, n, A) => {
  const { transition: s } = A, { duration: o, disabled: r, effect: a } = s, l = t, c = r ? l : l.transition().duration(o).ease(El[a]).on("end", A.animationAggregator.newCallback()), g = i.update || i, h = i.style || {};
  i.className && l.classed(i.className, !0), Object.entries(g).forEach(
    (u) => !isNaN(u[1]) && c.attr(u[0], u[1])
  ), Object.entries(h).forEach(
    (u) => l.style(u[0], u[1])
  );
}, l6 = (e, t) => {
  const i = e, n = t.enter || {};
  Object.entries(n).forEach(
    (A) => !isNaN(A[1]) && i.attr(A[0], A[1])
  );
}, c6 = (e) => {
  const { layer: t, points: i, container: n, keyFn: A, className: s } = e, o = t._graphicElems, r = {
    enter(a, l) {
      l6(a, l);
    },
    update(a, l, c) {
      o[l.rowId] = a, a6(t, a, l, c, e);
    }
  };
  return j(
    n,
    "g",
    i,
    null,
    {
      update: (a, l) => {
        j(
          a.node(),
          "rect",
          (c) => [c],
          null,
          r,
          A
        ), a.attr("class", `${s}-${l.rowId}`), a.classed(l.className, !0);
      }
    },
    A
  );
}, g6 = {
  classPrefix: en,
  defClassName: "layer-bar",
  className: "",
  interaction: {
    highlight: {
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "1px"
              }
            },
            {
              target: (e, t) => {
                const {
                  entryExitSet: { entrySet: i }
                } = e, n = t.getEntryExitSet("select");
                return n ? i.intersect(n.entrySet) : null;
              },
              key: "commonSet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "2px"
              }
            }
          ]
        }
      }
    },
    select: {
      // propagationFields:
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  {
                    target: "exitSet",
                    style: {
                      fill: {
                        a: -0.5
                      }
                      // strokePosition: "center",
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                strokePosition: "outside",
                stroke: "black",
                "stroke-width": "1px"
              }
            }
          ]
        }
      }
    },
    brush: {
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  {
                    target: "entrySet",
                    style: {
                      fill: { a: 0.3 }
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                stroke: "black",
                "stroke-width": "1px",
                strokePosition: "center"
              }
            },
            {
              target: "exitSet",
              style: {
                "fill-opacity": 0.3
              }
            }
          ]
        }
      }
    }
  },
  transform: {},
  transition: {
    effect: "cubic",
    duration: 1e3
  },
  innerPadding: 0.1,
  outerPadding: 1,
  // This is in pixels
  encoding: {
    color: {},
    detail: {},
    x: {},
    y: {},
    x0: {},
    y0: {},
    size: {
      value: 10
    },
    // stroke: {},
    // 'stroke-width': {},
    // strokePosition: {},
    text: {
      ...$s,
      showStackSum: !1,
      displayAs: "value"
    }
  },
  highlightExactPoint: !1
};
const vd = ["stroke-width", "stroke", "stroke-opacity"], { CONTINUOUS: lA } = lt, S_ = (e) => class extends e {
  /**
   * Creates an instance of bar layer
   */
  constructor(...t) {
    super(...t), this._plotPadding = {
      x: 0,
      y: 0
    }, this._plotSpan = {
      x: 0,
      y: 0
    }, this._pointMap = {}, this._overlayPath = {}, this._rtree = null, this._mainColorProp = "fill", this._reducedDataMap = void 0, this._maxPositive = {
      key: void 0,
      value: 0,
      text: void 0
    }, this._maxNegative = {
      key: void 0,
      value: 0,
      text: void 0
    }, this._autoRotationAngle = 0, this._stackedSum = /* @__PURE__ */ new Map();
  }
  elemType() {
    return "rect";
  }
  /**
   * Returns the default configuration of the bar layer
   * @return {Object} Default configuration of the bar layer
   */
  static defaultConfig() {
    return g6;
  }
  static shouldShowAxisTicksInPercentage(t, i, n) {
    const A = n.def.encoding, s = n.def.transform;
    let o;
    if (A) {
      const r = xA({
        yField: A.y.field,
        yFieldAs: A.y.as,
        xField: A.x.field,
        xFieldAs: A.x.as,
        dm: t,
        transformConf: s
      });
      return ["x", "y"].forEach((a) => {
        !(r && a === "x" || !r && a === "y") && s.type === Lt && (o = A[a].field);
      }), i === o;
    }
    return !1;
  }
  // static defaultPolicy(conf, userConf) {
  //   const config = BaseLayer.defaultPolicy(conf, userConf);
  //   const encoding = config.encoding;
  ////   const colorField = encoding.color.field;
  //   const transform = config.transform;
  //   if (colorField) {
  //     transform.groupBy = colorField;
  //   }
  //   return config;
  // }
  afterDataDidSet() {
    this.reduceNormalizedDataMap();
  }
  calculateDomainFromData(t, i) {
    const n = super.calculateDomainFromData(t, i), { TEMPORAL: A } = J.FieldSubtype;
    return ["x", "y"].forEach((s) => {
      const o = this.isVerticalBar() && s === "x" || !this.isVerticalBar() && s === "y";
      i[`${s}FieldAs`] === lA && i[`${s}FieldSubType`] !== A && W(n[s], "length") && (i[`${s}0Field`] ? n[s] = n[s].sort((r, a) => r - a) : o ? n[s] = nh(n[s]) : n[s] = tl(n[s]));
    }), n;
  }
  /**
   * @override
   */
  requiresExtendDomainDiffs() {
    const { textField: t } = this.encodingFieldsInf(), i = this.config().encoding.text, n = Jf(i);
    return t && n === Je;
  }
  calculateExtendDomainDiffs() {
    if (!this.requiresExtendDomainDiffs())
      return { x: [0, 0], y: [0, 0] };
    const { smartLabel: t } = this._dependencies, i = [0, 0], n = [0, 0], A = this.isVerticalBar(), s = 5, [o] = Yf(
      this,
      this._transformedData.getUniqueValues()
    );
    this.calculateAutoRotationAngle(o);
    const r = this.axes(), a = r.y && r.y.scale().range()[0], l = r.x && r.x.scale().range()[1], c = a != null ? a / 2 : 0, g = l != null ? l / 2 : 0;
    if (this._reducedDataMap.size === 0) {
      const h = this.config().encoding.text;
      if (Jf(h) === Je) {
        const d = vs(
          { x: 0, y: 0, text: this.largestTextLabel() },
          0,
          [],
          this
        ), { width: f, height: I } = Ma(
          this.largestTextLabel(),
          d,
          t
        );
        A && this._domain.y != null ? (n[0] = this._domain.y[1] >= 0 ? I + s : 0, n[1] = this._domain.y[0] < 0 ? I + s : 0) : this._domain.x != null && (i[0] = this._domain.x[0] < 0 ? f + s : 0, i[1] = this._domain.x[1] >= 0 ? f + s : 0);
      }
    } else {
      const h = (u, d, f) => {
        const I = { x: 0, y: 0 }, C = vs(
          A ? { x: u, y: f, text: d } : { x: f, y: u, text: d },
          0,
          [],
          this
        ), { width: E, height: B } = Ma(
          d,
          C,
          t
        );
        let m;
        return this._stackedSum.size ? A ? m = Je : m = hi : m = this.resolveBestLabelAnchor(
          u,
          {
            width: Number.MAX_SAFE_INTEGER,
            height: Number.MAX_SAFE_INTEGER,
            text: d
          },
          C
        ), A && m === Je ? I.y = B + s : !A && m === hi && (I.x = E + s), I;
      };
      if (this._maxPositive.key !== void 0) {
        const u = h(
          this._maxPositive.key,
          this._maxPositive.text,
          this._maxPositive.value
        );
        n[0] = u.y, i[1] = u.x;
      }
      if (this._maxNegative.key !== void 0) {
        const u = h(
          this._maxNegative.key,
          this._maxNegative.text,
          this._maxNegative.value
        );
        n[1] = u.y, i[0] = u.x;
      }
    }
    return {
      x: [
        Math.min(i[0], g),
        Math.min(i[1], g)
      ],
      // [extra left pixel, extra right pixel],
      y: [
        Math.min(n[0], c),
        Math.min(n[1], c)
      ]
      // [extra top pixel, extra bottom pixel]
    };
  }
  /**
   * Generates an array of objects containing x, y, width and height of the bars from the data
   * @param  {Array.<Array>} data Data Array
   * @param  {Object} encoding  Config
   * @param  {Object} axes     Axes object
   * @param {Object} conf config object for point generation
   * @return {Array.<Object>}  Array of points
   */
  translatePoints(t, i, n, A) {
    return rJ(this, t, i, n, A);
  }
  /**
   * Renders the plot in the given container
   * @param  {SVGGroup} container SVGGroup where plot will be rendered.
   * @return {BarLayer} Instance of bar layer.
   */
  render(t, i = {}) {
    this.preRender(i, !0);
    const n = eA(), { transition: A } = i, s = this.config(), o = ft(A, s.transition), a = this._transformedData.getUniqueValues(), l = this.axes(), c = l.y && l.y.scale().range()[0] || 0, g = l.x && l.x.scale().range()[1] || 0, h = s.defClassName, u = _n(
      h,
      this.id(),
      s.classPrefix
    ), d = s.className, f = V(t);
    f.classed(u.join(" "), !0), f.classed(d, !0), Yx(
      t,
      {
        x: 0,
        y: 0,
        width: g,
        height: c
      },
      `id-${this.id()}`
    ), this._points = this.generateDataPoints(
      this.getRenderableNormalizedData(),
      a
    ), this._graphicElems = {}, this._linkedElems = {}, Object.keys(this._overlayPath).forEach((B) => this._overlayPath[B].remove()), this._overlayPath = {};
    const C = j(
      f,
      "g",
      [1],
      `${s.classPrefix}-layer-bars`,
      {},
      null
    );
    if (this._overlayMount = j(
      f,
      "g",
      [1],
      `${s.classPrefix}-layer-overlay-path-group`,
      {},
      null
    ).node(), this.hasTextEncodingField()) {
      let B = null;
      this._stackedSum.size ? B = this.getTextPointsForStackSum() : B = this._points.flat(), this.textPointsInfo({
        points: B,
        location: "text"
      });
    } else
      this.textPointsInfo(null);
    PC({
      data: this._points,
      container: C.node(),
      selector: "g",
      append: "g",
      each: (B, m, y) => {
        const D = `${u[0]}-${y}`.toLowerCase();
        m.style("display", "block"), m.attr("class", D), c6({
          layer: this,
          container: m.node(),
          points: B,
          className: D,
          transition: o,
          style: {},
          keyFn: (Q) => Q.rowId,
          animationAggregator: n
        });
      }
    });
    const E = this.getBoundBoxes().flat().filter((B) => B !== null);
    return this._rtree = new Ns(), this._rtree.load(E), this.postRender(i), n.onAllCallbacksCalled().then(() => {
      this.emitAnimationEndHook(i);
    }), this;
  }
  generateDataPoints(t, i) {
    const [n, A] = Yf(
      this,
      i
    ), s = n.offsetValues || [], o = A.offsetValues || [];
    return this._plotSpan = {
      x: n.groupSpan || 0,
      y: A.groupSpan || 0
    }, this._plotPadding = {
      x: n.padding || 0,
      y: A.padding || 0
    }, this._pointMap = {}, t.map((a, l) => this.translatePoints(
      a,
      {
        barWidth: n.span,
        barWidthOffset: (this._transformType === gn ? s : s[l]) || 0,
        barHeight: A.span,
        barHeightOffset: (this._transformType === gn ? o : o[l]) || 0
      },
      l,
      t
    ));
  }
  getPlotPadding() {
    return this._plotPadding;
  }
  calculateAutoRotationAngle(t) {
    if (this.isVerticalBar()) {
      const { smartLabel: i } = this._dependencies, { width: n } = i.getOriSize(
        this.largestTextLabel()
      ), A = Math.max(
        ...Object.values(t.offsetValues).map(
          (s) => Object.keys(s).length
        )
      );
      this._autoRotationAngle = n > t.padding / (A + 1) + t.span ? -90 : 0;
    }
  }
  getTextAutoRotationAngle() {
    return this._autoRotationAngle;
  }
  resolveTransformType() {
    return this._transformType = ME(this), this._transformType;
  }
  /**
   * Gets the nearest point of the position passed.
   * @param {number} x x position
   * @param {number} y y position
   * @return {Object} Nearest point.
   */
  getNearestPoint(t, i) {
    if (!this.data())
      return null;
    const n = this._rtree.search({
      minX: Math.max(t - 1, 0),
      minY: Math.max(i - 1, 0),
      maxX: t + 1,
      maxY: i + 1
    });
    return n.length ? this.getDataFromEvent(null, n[0].point) : null;
  }
  getNearestPointInRange({ minX: t, minY: i, maxX: n, maxY: A }) {
    if (!this.data())
      return null;
    const s = this._rtree.search({
      minX: t - 1,
      minY: i - 1,
      maxX: n + 1,
      maxY: A + 1
    });
    return s.length ? this.getDataFromEvent(null, s[0].point) : null;
  }
  includeDataFromAllLayersInTooltip() {
    return !0;
  }
  static getDomain(t, {
    field: i,
    encoding: n,
    layerEncodings: A,
    transform: s,
    userDomain: o,
    hasRangedEncodingInValueAxis: r = !1
  }) {
    if (!i || !t.getField(i))
      return [];
    const a = A[n].as || t.getField(i).subtype(), l = xA({
      yField: A.y.field,
      yFieldAs: A.y.as,
      xField: A.x.field,
      xFieldAs: A.x.as,
      dm: t,
      transformConf: s
    });
    if (!Number.isFinite(t.getFieldIndex(i)))
      return [];
    const c = t.getField(i).subtype(), g = l && n === "x" || !l && n === "y";
    let h;
    const { value: u, uniqueField: d } = s.type === Nt || s.type === Lt ? this.getStackConfig(t, {
      encoding: A
    }) : {}, f = this.getOverrideTransformType(s.type, {
      isRanged: r
    });
    if (f === Nt && a === lA && u && (r || u.field === i))
      h = Rl({
        dm: t,
        valueField: u.field,
        uniqueField: d.field,
        fieldAs: a
      });
    else if (f === Lt && a === lA && (r || u.field === i)) {
      if (HM(o))
        return OM(
          t,
          o,
          { field: i, uniqueField: d, fieldAs: a, isIndependentEncoding: g }
        );
      h = TE({ dm: t });
    } else if (a === lt.DISCRETE)
      h = c !== fi ? t.getField(i).uniques() : t.getField(i).getAllBins();
    else {
      const I = A[`${n}0`];
      if (t.isEmpty())
        h = null;
      else if (W(I, "field")) {
        const C = I.as, E = I.field, B = t.getDomain(i, a), m = t.getDomain(
          E,
          C
        );
        h = [
          Math.min(...B, ...m),
          Math.max(...B, ...m)
        ];
      } else
        h = t.getDomain(i, a);
    }
    return a === lA && c !== Iu && c !== fi && W(h, "length") && (W(A[`${n}0`], "field") ? h.sort((I, C) => I - C) : g ? h = nh(h) : h = tl(h)), h;
  }
  resolveOverrideTransformConfig(t) {
    const i = this.hasRangedValueAxis();
    return i ? {
      ...t,
      originalType: t.type,
      type: this.constructor.getOverrideTransformType(
        t.type,
        { isRanged: i }
      )
    } : t;
  }
  hasRangedValueAxis() {
    const { x: t, y: i } = this.axes(), n = this.encodingFieldsInf(), { x0Field: A, x0FieldAs: s, xFieldAs: o, y0Field: r, y0FieldAs: a, yFieldAs: l } = n, c = r && (a === lA || l === lA) ? !0 : A && (s === lA || o === lA) ? !1 : null;
    if (c === null)
      return !1;
    const g = c ? i : t, { fieldInstance: h } = g.config();
    let u = !1;
    return br(h) && (u = h.vars().map((f) => f.toString()).some(
      (f) => f === (c ? r : A)
    )), u;
  }
  static getOverrideTransformType(t, { isRanged: i }) {
    return t === Nt && i ? En : t;
  }
  getTextPointsForStackSum() {
    const t = this.axes();
    let i = this._points.flat();
    const n = this.isVertical(), { type: A, originalType: s } = this._transformConfig, o = n ? t.x.config().field : t.y.config().field, r = /* @__PURE__ */ new Map(), a = {};
    i.forEach((c) => {
      const g = J.isInvalid(c) ? c.value() : c.data[o], h = this._stackedSum.get(g);
      if (r.has(g) || r.set(g, { ...c, ...h }), h && A === En && s === Nt) {
        let { pos: u, neg: d } = a[g] || {
          pos: null,
          neg: null
        };
        if (h.textFieldPosStackSum !== 0) {
          const f = n ? c.update.y : c.update.x + c.update.width;
          u = u ? (n ? Math.min : Math.max)(u, f) : f;
        }
        if (h.textFieldNegStackSum !== 0) {
          const f = n ? c.update.y + c.update.height : c.update.x;
          d = d ? (n ? Math.max : Math.min)(d, f) : f;
        }
        a[g] = { pos: u, neg: d };
      }
    });
    let l = [];
    return r.forEach((c, g) => {
      const h = {
        ...c,
        stackSumLabelCoords: a[n ? c.x : c.y]
      };
      if (c && c.textFieldPosStackSum !== 0) {
        const u = Ah(
          this,
          h,
          g,
          n,
          "posStackSum"
        );
        l.push(u);
      }
      if (c && c.textFieldNegStackSum !== 0) {
        const u = Ah(
          this,
          h,
          g,
          n,
          "negStackSum"
        );
        l.push(u);
      }
    }), l;
  }
  getTransformedData(t, i, n, A) {
    return Ml(
      t,
      i,
      n
    );
  }
  getDataFromEvent(t, i) {
    return _u(this, t, i);
  }
  getPlotSpan() {
    return this._plotSpan;
  }
  hasPlotSpan() {
    return !0;
  }
  applyStyles({ styleObj: t, elem: i, datum: n }, A) {
    const { styles: s, className: o } = t, r = Object.keys(s);
    let a = s;
    const c = vd.some((g) => g in s) ? s.strokePosition || "center" : null;
    c && (this.addOverlayPathAndStyles(
      i,
      n,
      vd.reduce((g, h) => (g[h] = s[h], g), {}),
      c,
      A
    ), a = r.filter((g) => !vd.includes(g)).reduce((g, h) => (g[h] = s[h], g), {})), o && i.classed(o, A.apply), this.applyElementStyles(i, a);
  }
  addOverlayPathAndStyles(t, i, n, A, s) {
    const o = this.getOverlayPathMount(), r = this.config().classPrefix;
    let a;
    if (this._overlayPath[i.rowId])
      a = this._overlayPath[i.rowId];
    else if (s.apply)
      a = j(
        o,
        "path",
        [i],
        `.${r}-layer-overlay-path-${i.rowId}`,
        {},
        (c) => c.rowId
      ), this._overlayPath[i.rowId] = a;
    else
      return;
    const l = parseInt(n["stroke-width"], 10);
    if (l && A) {
      const { L1: c, L2: g, L3: h, M: u } = oJ({
        width: l,
        position: A
      });
      a.attr(
        "d",
        (d) => `M ${d.update.x + u.x} ${d.update.y + u.y}
            L ${d.update.x + d.update.width + c.x} ${d.update.y + c.y}
            L ${d.update.x + d.update.width + g.x} ${d.update.y + d.update.height + g.y}
            L${d.update.x + h.x} ${d.update.y + d.update.height + h.y} Z`
      );
    } else
      a.attr("d", "");
    for (let c in n)
      c !== "strokePosition" && a.style(c, n[c]);
  }
  getBoundBoxes() {
    return this._points.flat().map((i) => {
      const { x: n, y: A, width: s, height: o } = i.update, r = i.data;
      return {
        minX: n,
        maxX: n + s,
        minY: A,
        maxY: A + o,
        data: r,
        point: i
      };
    });
  }
  getBoundBox(t) {
    const i = this.measurement(), n = t.update;
    return n.x = Math.max(n.x, 0), n.y = Math.max(n.y, 0), n.x + n.width > i.width && (n.width = i.width - n.x), n.y + n.height > i.height && (n.height = i.height - n.y), n;
  }
  isVerticalBar() {
    const { yFieldAs: t, yField: i, xField: n, xFieldAs: A } = this.encodingFieldsInf();
    return xA({
      yField: i,
      yFieldAs: t,
      xField: n,
      xFieldAs: A,
      dm: this.data(),
      transformConf: this._transformConfig
    });
  }
  isVertical() {
    return this.isVerticalBar();
  }
  resolveBestLabelAnchor(t, i, n) {
    const A = this.config().encoding.text, s = vM(A), { textField: o } = this.encodingFieldsInf();
    if (!o)
      return;
    const r = this.isVerticalBar();
    let a = s.find((l) => this.isAnchorViable(
      t,
      l,
      i,
      r,
      n
    ));
    return a !== void 0 && a !== mn && !r && (a = AJ(a, $C)), a;
  }
  isAnchorViable(t, i, n, A, s) {
    const { xFieldAs: o, yFieldAs: r, xFieldSubType: a, yFieldSubType: l } = this.encodingFieldsInf();
    if ((o === lt.DISCRETE || a === it.BINNED) && (r === lt.DISCRETE || l === it.BINNED))
      return Kf(i);
    if (Kf(i)) {
      if (A && Math.abs(s) === 90 || !A && (s === 0 || Math.abs(s) === 180))
        return !0;
      const { smartLabel: c } = this._dependencies, { width: g, height: h, text: u } = n, { width: d, height: f } = Ma(
        u,
        s,
        c
      );
      return A ? f <= h : d <= g;
    }
    return this._transformType === Lt && FE(i) ? !1 : i !== Je && i !== Xn || this._transformType === gn ? !0 : (this._reducedDataMap === void 0 && this.reduceNormalizedDataMap(), !((this._reducedDataMap.get(t) instanceof Array ? this._reducedDataMap.get(t)[0] : this._reducedDataMap.get(t)) > 1));
  }
  reduceNormalizedDataMap() {
    this._reducedDataMap = /* @__PURE__ */ new Map();
    const { xField: t, x0Field: i, yField: n, y0Field: A } = this.encodingFieldsInf(), s = this.isVerticalBar();
    if (!(s ? A !== void 0 && n !== void 0 : i !== void 0 && t !== void 0) && ![Nt, Lt, gn].includes(this._transformType))
      return;
    const r = (g, h, u, d) => {
      const f = g ? Math.max(h.y || 0, h.y0 || 0) : Math.max(h.x || 0, h.x0 || 0);
      (f > 0 && f > this._maxPositive.value || f === this._maxPositive.value && this._reducedDataMap.get(u) < this._reducedDataMap.get(this._maxPositive.key)) && (this._maxPositive.key = u, this._maxPositive.value = f, this._maxPositive.text = d);
    }, a = (g, h, u, d) => {
      const f = g ? Math.min(h.y || 0, h.y0 || 0) : Math.min(h.x || 0, h.x0 || 0);
      (f < 0 && f < this._maxNegative.value || f === this._maxNegative.value && this._reducedDataMap.get(u) < this._reducedDataMap.get(this._maxNegative.key)) && (this._maxNegative.key = u, this._maxNegative.value = f, this._maxNegative.text = d);
    }, l = (g, h, u) => {
      const d = g.textFieldPosStackSum || g.textFieldNegStackSum;
      d > 0 && d > this._maxPositive.value && (this._maxPositive.key = h, this._maxPositive.value = d, this._maxPositive.text = u);
    }, c = (g, h, u) => {
      const d = g.textFieldPosStackSum || g.textFieldNegStackSum;
      d < 0 && d < this._maxNegative.value && (this._maxNegative.key = h, this._maxNegative.value = d, this._maxNegative.text = u);
    };
    if (this._stackedSum.size)
      this._stackedSum.forEach((g) => {
        const h = this.createKey(g, s);
        g.textFieldPosStackSum && g.textFieldNegStackSum ? this._reducedDataMap.set(h, 2) : this._reducedDataMap.set(h, 1);
        const u = g.formattedTextPosSum !== "0" ? g.formattedTextPosSum : g.formattedTextNegSum;
        l(g, h, u), c(g, h, u);
      });
    else {
      let g;
      const h = this._normalizedData, d = this._transformedData.getData();
      h.forEach((f, I) => {
        f.filter((C) => s ? !isNaN(C.y) || !isNaN(C.y0) : this.encodingFieldsInf().xFieldType === "measure" && this.encodingFieldsInf().xFieldAs === "continuous" ? !isNaN(C.x) || !isNaN(C.x0) : !0).forEach((C) => {
          const E = this.createKey(C, s), B = /* @__PURE__ */ new Set();
          g = d[I].keys.join(","), this._reducedDataMap.has(E) ? this._reducedDataMap.set(E, [
            this._reducedDataMap.get(E)[0] + 1,
            this._reducedDataMap.get(E)[1].add(g)
          ]) : this._reducedDataMap.set(E, [1, B.add(g)]), r(s, C, E, C.formattedText), a(s, C, E, C.formattedText);
        });
      });
    }
  }
  createKey(t, i) {
    let n;
    if (this.encodingFieldsInf().xFieldAs === "discrete" && this.encodingFieldsInf().yFieldAs === "discrete" || this.encodingFieldsInf().xFieldSubType === "binned" && this.encodingFieldsInf().yFieldSubType === "binned")
      return `${J.getActualValue(t.x)}-${J.getActualValue(t.y)}`;
    const A = i ? t.x : t.y, s = i ? t.x0 : t.y0;
    return A !== void 0 ? n = A : n = "", s !== void 0 && s !== A && (typeof n == typeof s ? n += s : n = s), J.getActualValue(n);
  }
};
class h6 extends _e(AA).with(S_) {
  static formalName() {
    return zC;
  }
}
const u6 = {
  defClassName: "layer-tick",
  className: "",
  classPrefix: en,
  nearestPointThreshold: 10,
  interaction: {
    highlight: {
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "1px"
              }
            },
            {
              target: (e, t) => {
                const {
                  entryExitSet: { entrySet: i }
                } = e, n = t.getEntryExitSet("select");
                return n ? i.intersect(n.entrySet) : null;
              },
              key: "commonSet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "2px"
              }
            }
          ]
        }
      }
    },
    select: {
      // propagationFields:
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  {
                    target: "exitSet",
                    style: {
                      fill: { a: -0.7 }
                      // strokePosition: "center",
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "entrySet",
              style: {
                strokePosition: "center",
                stroke: "black",
                "stroke-width": "1px"
              }
            }
          ]
        }
      }
    },
    brush: {
      target: {
        layer: {
          highlight: {
            sideEffects: {
              "plot-highlighter": {
                rules: [
                  {
                    target: "entrySet",
                    style: {
                      fill: { a: 0.3 },
                      strokePosition: "center"
                    }
                  }
                ]
              }
            }
          }
        }
      },
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: (e, t) => e.payload.sourceInfo.layerId !== t.id() ? null : e.entryExitSet.entrySet,
              key: "commonSet",
              style: {
                stroke: "black",
                "stroke-width": "1px",
                strokePosition: "outside"
              }
            },
            {
              target: "exitSet",
              style: {
                fill: { a: -0.5 }
              }
            }
          ]
        }
      }
    }
  },
  innerPadding: 0.1,
  transform: {},
  transition: {
    effect: "cubic",
    duration: 1e3
  },
  interpolate: "linear",
  encoding: {
    color: {},
    x: {},
    y: {},
    x0: {},
    y0: {},
    radius: {},
    radius0: {},
    angle: {},
    angle0: {},
    text: { ...$s }
  },
  interactive: !0
}, d6 = _i.line, f6 = (
  /* istanbul ignore next */
  (e) => {
    const {
      points: t,
      container: i,
      keyFn: n,
      className: A,
      interpolate: s,
      layer: o,
      transition: r,
      animationAggregator: a
    } = e, { disabled: l } = r, c = V(i), g = o._graphicElems;
    return c.attr("class", A), j(
      c,
      "g",
      t,
      null,
      {
        enter: (h, u) => {
          const d = u.enter || {};
          Object.entries(d).forEach(
            (f) => !isNaN(f[1]) && h.attr(f[0], f[1])
          );
        },
        update: (h, u) => {
          const d = j(h, "path", [1]);
          g[u.rowId] = h;
          const { update: f, style: I } = u;
          h.attr("class", A), h.classed(u.className, !0);
          const C = f.x0 !== void 0 ? f.x0 : f.x, E = f.y0 !== void 0 ? f.y0 : f.y, B = ml[s], m = d6().curve(B).x((y) => y[0]).y((y) => y[1]);
          u.className && h.classed(u.className, !0), d.attr(
            "d",
            m([
              [f.x, f.y],
              [C, E]
            ])
          ), l || (h = h.transition().duration(r.duration).on("end", a.newCallback())), Object.entries(I).forEach(
            (y) => h.style(y[0], y[1])
          );
        },
        exit: (h) => {
          h.remove();
        }
      },
      n
    );
  }
);
const I6 = {
  center: () => ({
    M: { x: 0, y: 0 },
    L: { x: 0, y: 0 }
  }),
  inside: (e) => ({
    M: { x: +e, y: +e },
    L: { x: -e, y: +e }
  }),
  outside: (e) => ({
    M: { x: -e, y: -e },
    L: { x: +e, y: -e }
  })
}, C6 = ({ width: e, position: t = "center" }) => {
  const i = e ? e / 2 : 1;
  return I6[t](i);
}, E6 = (e, t = {}, i, n, A) => {
  const s = i.axes();
  let o = [];
  const { x: r, y: a } = s, { xField: l, yField: c, x0Field: g, y0Field: h } = i.encodingFieldsInf(), u = i.measurement(), { x: d, y: f } = t.offset, { x: I, y: C } = t.span;
  for (let E = 0, B = e.length; E < B; E++) {
    let m, y, D, Q;
    const p = e[E], w = p.source;
    l && (m = r.getScaleValue(p.x) + d, y = m + I), c && (Q = a.getScaleValue(p.y) + f, D = Q !== null ? Q + C : null), l || (m = 0, y = u.width, isNaN(Q) || (Q += C / 2, D = Q)), c || (Q = 0, D = u.height, y = m += I / 2), g && (y = r.getScaleValue(p.x0) + I, Q += C / 2, D -= C / 2), h && (D = a.getScaleValue(p.y0) + C, m += I / 2, y -= I / 2);
    const S = In(i, p).getColor(p.color), _ = nA(i, {
      translatedValues: {
        x: m,
        y: Q,
        x0: y,
        y0: D,
        color: S
      },
      datum: p,
      datumIdx: E,
      groupData: e,
      groupIdx: n,
      layerData: A
    }), M = {
      stroke: _.color
    };
    if (!isNaN(m) && !isNaN(Q)) {
      const k = {
        enter: {},
        update: {
          x: _.x,
          y: _.y,
          x0: _.x0,
          y0: _.y0
        },
        style: M,
        source: w,
        rowId: p.rowId,
        data: p.dataObj,
        meta: { layerId: i.id(), ...Nn(M) }
      };
      k.className = iA(p, E, e, i), o.push(k), i.cachePoint(p.rowId, k);
    }
  }
  return o = Zs(i, o), o;
}, M_ = (e) => class extends e {
  constructor(...t) {
    super(...t);
  }
  static defaultConfig() {
    return u6;
  }
  static formalName() {
    return "tick";
  }
  static drawFn() {
    return f6;
  }
  elemType() {
    return "path";
  }
  /**
   * Generates an array of objects containing x, y, width and height of the points from the data
   * @param  {Array.<Array>} data Data Array
   * @param  {Object} encoding  Config
   * @param  {Object} axes     Axes object
   * @return {Array.<Object>}  Array of points
   */
  translatePoints(t, i, n, A) {
    return E6(t, i, this, n, A);
  }
  attachDataToVoronoi(t) {
    _l(this._voronoi, t, (i) => {
      const { x: n, x0: A, y: s, y0: o } = i.update;
      return {
        x: n + (A - n) / 2,
        y: s + (o - s) / 2
      };
    });
  }
  getMeasurementConfig(t, i, n, A) {
    return {
      offset: {
        x: t || 0,
        y: i || 0
      },
      span: {
        x: n,
        y: A
      }
    };
  }
  addOverlayPathAndStyles(t, i, n, A) {
    let s;
    this._overlayPath[i.rowId] ? s = this._overlayPath[i.rowId] : (s = j(
      t,
      "path",
      [i.update],
      null,
      {},
      (l) => `${l.x} ${i.rowId}`
    ), s.style("fill", "none"), s.style("fill-opacity", 0), s.attr("id", i.rowId), this._overlayPath[i.rowId] = s);
    let o = { x: 0, y: 0 }, r = { x: 0, y: 0 };
    if (n.type === "stroke-width") {
      const { L: l, M: c } = C6({
        width: parseInt(n.value, 10),
        position: A
      });
      o = c, r = l;
    }
    s.attr("d", (l) => l.update ? `M ${l.update.x + o.x} ${l.update.y + o.y}
                    L ${l.update.x0 + r.x} ${l.update.y0 + r.y}` : `M ${l.x + o.x} ${l.y + o.y}
                L ${l.x0 + r.x} ${l.y0 + r.y}`);
    let a = n.value;
    if (typeof a == "function") {
      const l = s.style(n.type);
      a = a(l);
    }
    s.style(n.type, a), i.isPathPresent || (Px(t, s.node()), i.isPathPresent = !0);
  }
  getShapeRadius(t) {
    if (t) {
      const { update: i } = t.data.data, n = Math.abs(i.x - i.x0), A = Math.abs(i.y - i.y0);
      return Math.max(n, A) / 2;
    }
    return 0;
  }
  static autoDetectTransformType() {
    return En;
  }
  getNearestPoint(t, i, { event: n }) {
    if (!this.data())
      return null;
    const A = this._rtree.search({
      minX: Math.max(t - 1, 0),
      minY: Math.max(i - 1, 0),
      maxX: t + 1,
      maxY: i + 1
    });
    return A.length ? _u(this, n, A[0].point) : null;
  }
  getBoundBoxes() {
    return this._points.flat().map((i) => {
      const n = this.getBoundBox(i), { x: A, y: s, width: o, height: r } = n, a = i.data;
      return {
        minX: A,
        maxX: A + o + 2,
        minY: s - 2,
        maxY: s + r + 2,
        data: a,
        point: i
      };
    });
  }
  getBoundBox(t) {
    const { x: i, y: n, x0: A, y0: s } = t.update;
    return {
      x: i,
      y: n,
      width: A - i,
      height: s - n
    };
  }
};
class __ extends _e(AA).with(
  qE,
  M_
) {
  static formalName() {
    return "tick";
  }
}
const b_ = "area", N_ = "arc", F_ = "line", R_ = "text", k_ = "point", T_ = "bar", v_ = "tick", B6 = "simple", G_ = "base", L_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARC_LAYER: N_,
  AREA_LAYER: b_,
  BAR_LAYER: T_,
  BASE_LAYER: G_,
  LINE_LAYER: F_,
  POINT_LAYER: k_,
  SIMPLE_LAYER: B6,
  TEXT_LAYER: R_,
  TICK_LAYER: v_
}, Symbol.toStringTag, { value: "Module" })), m6 = {
  [b_]: f_,
  [N_]: C_,
  [F_]: E_,
  [R_]: Q_,
  [k_]: x_,
  [v_]: __,
  [T_]: h6,
  [G_]: AA
}, U_ = (e = m6) => {
  const t = Object.assign({}, e), i = {
    register: (n) => {
      const A = n.formalName();
      return t[A] = n, i;
    },
    get: () => t
  };
  return i;
}, Q6 = "data", p6 = "config", y6 = "measurement", D6 = "domain", w6 = "mount", x6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CONFIG: p6,
  DATA: Q6,
  DOMAIN: D6,
  MEASUREMENT: y6,
  MOUNT: w6
}, Symbol.toStringTag, { value: "Module" })), S6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CONSTANTS: O8,
  LAYER_TYPES: L_,
  PROPS: x6
}, Symbol.toStringTag, { value: "Module" }));
class jp extends Tl {
  constructor(...t) {
    super(...t), this.setApplyChecker({
      source: (i, n, A) => {
        if (i.unitId === n.unitId) {
          const s = this._payload ? this._payload.criteria : null;
          return !Ja(s, A.criteria) || A.dragDiff !== 0;
        }
        return !0;
      }
    });
  }
  static formalName() {
    return il;
  }
  dispatch(...t) {
    return this.active = t[0].dragging, this.start = t[0].dragStart, super.dispatch(...t);
  }
  setSelectionSet(t, i) {
    if (t === null)
      i.reset();
    else if (t.length) {
      i.reset(), i.add(t);
      const n = Mn(
        [i.getCompleteSet()],
        [i.getEntrySet()]
      );
      i.remove(n);
    } else {
      const n = Mn(
        [i.getCompleteSet()],
        [i.getExitSet()]
      );
      i.remove(n);
    }
  }
}
const M6 = Object.assign({}, $5, {
  pointLayerHelpers: r6
}), _6 = {
  BarLayerMixin: S_,
  BaseLayerMixin: a_,
  LineLayerMixin: jE,
  AreaLayerMixin: d_,
  PointLayerMixin: qE,
  TextLayerMixin: m_,
  TickLayerMixin: M_,
  ArcLayerMixin: I_
}, O_ = (e, t) => {
  const i = {};
  e.forEach((n) => {
    const { colorField: A, sizeField: s, shapeField: o, xField: r, yField: a } = n.encodingFieldsInf(), { encoding: l } = n.config(), c = ["x", "y"], g = [r, a].filter(
      (h, u) => l[c[u]] && l[c[u]].as === "continuous"
    );
    [A, s, o].forEach((h) => {
      t.isDimension(h) && g.length && (!i[h] && (i[h] = []), i[h].push(...g));
    });
  });
  for (const n in i)
    ({}).hasOwnProperty.call(i, n) && (i[n] = [
      ...new Set(i[n])
    ]);
  return i;
}, b6 = (e, t) => {
  const i = {};
  for (const n in e)
    if ({}.hasOwnProperty.call(e, n)) {
      const A = e[n];
      i[n] = A(t);
    }
  return i;
}, H_ = (e, t, i, n, A = {}) => {
  let s = i;
  const o = e._dependencies, r = e.metaInf(), a = e.facetFieldsMap();
  if (!i) {
    s = Bi.getLayerInstance(
      t,
      () => e.createChildEventManager()
    );
    const g = e.store();
    Fi(s).forEach((h) => {
      h.dependencies(o).store(g);
    });
  }
  const l = {}, c = Fi(s);
  return t = Fi(t), t.reduce((g, h, u) => {
    const d = c[u];
    return W(h.encoding.color, "field") in a && (h.transform.type = ft(h.transform.type, "identity")), d.id(h.id), h.theme = e.config().theme, d.config(h), d.renderer(n), d.valueParser(e.valueParser()), d.interactionRegistry(e.registry().interactions), d.dataProps({
      timeDiffs: e._timeDiffs
    }), P_(e, d, r), h.name && d.alias(h.name), !A.skipLayerFireboltCreation && d.createFirebolt(), l[d.alias()] = d, g;
  }, {}), l;
}, P_ = (e, t, i) => {
  t.metaInf({
    unitRowIndex: i.rowIndex,
    unitColIndex: i.colIndex,
    rowFacets: i.rowFacets,
    colFacets: i.colFacets,
    canvasAlias: e.parentAlias(),
    unitId: e.id(),
    facets: e.facetFieldsMap(),
    totals: i.totals || null,
    rowTotalString: i.rowTotalString,
    colTotalString: i.colTotalString
  });
}, Y_ = (e, t) => {
  const i = e.config().encodingTransform || {}, n = i.resolvable;
  let A = [];
  if (n) {
    const s = n(t);
    A = s.depArr, e.encodingTransform(s.fn);
  } else
    i instanceof Function && e.encodingTransform(i);
  return A;
}, zf = (e) => {
  const t = [];
  return e.forEach((i, n) => {
    const A = i.def, s = i.mark;
    if (A)
      A.name || (A.name = `${s}-${n}`), t.push(i);
    else {
      const o = Bi.getSerializedConf(i.mark, i);
      o.name || (o.name = `${s}-${n}`), t.push({
        mark: i.mark,
        def: o
      });
    }
  }), t;
}, zE = (e, t, i, n) => {
  let A = typeof i == "function" ? i(e) : e;
  const s = Object.keys(t.encoding).map((l) => t.encoding[l].field).filter((l) => !!l).flat(), o = e.getDimensions();
  let r = !1;
  const a = [];
  return o.forEach((l) => {
    s.includes(l) ? a.push(l) : r = !0;
  }), r && !n.disabled && (A = A.groupBy(a)), A;
}, J_ = (e, t, i) => {
  const n = e._cache, { autoGroupBy: A } = e.config(), s = e._customLayerDataModels, o = e._layerDataModels;
  t.forEach((r) => {
    let { encoding: a, source: l } = r.config(), c;
    if (W(a, "detail", "field") || (a.detail = tt({}, a.detail, {
      field: e.detailFields()
    })), s)
      c = s[r.id()];
    else {
      const h = o[r.id()];
      if (h)
        c = h || i;
      else {
        const u = W(e.transform(), l) || l;
        c = zE(
          i,
          r.config(),
          u,
          A
        );
      }
    }
    n ? r.enableCaching() : r.disableCaching(), e.layerDomains()[r.id()] && r.domain(e.layerDomains()[r.id()]), r.data(c);
  });
}, K_ = (e, t, i) => {
  t.forEach((n) => {
    const A = {}, s = n.config();
    yC(e, (o) => {
      let r;
      const a = e[o] || [], l = W(s.encoding, o, "field"), c = W(s.encoding, o, "splitBy"), g = a.find(
        (h) => h.config().metaInfo?.isTotalsAxis
      );
      if (l) {
        const h = W(s.encoding, o, "as") || Ve(i.data().getField(l)), u = W(s.encoding, o, "var");
        r = a.filter((C) => {
          const E = C.config(), B = E.fieldInstance;
          return B && u ? B === u : B ? B.getMembers().includes(l) && E.fieldAs === h : E.field === l && E.fieldAs === h;
        }), c ? r = r.reduce((C, E) => (C[E.config().splitFieldValue] = E, C), {}) : r = r[0];
        const d = i.metaInf(), f = i.fields(), I = {
          field: l,
          type: h,
          subtype: i.data().getField(l).subtype()
        };
        g && dx(I, d, f) && (r = g);
      } else {
        let h;
        const u = a.findIndex(
          (d) => d.isGlobal && d.isGlobal()
        );
        u !== -1 ? h = u : h = 0, r = e[o][h];
      }
      e[o] && (A[o] = ft(r));
    }), Object.keys(A).length && n.axes(A), n.metaInf({
      totalsAxis: {
        color: s.encoding.color.field && e.color?.find((o) => o.config().metaInfo?.isTotalsAxis),
        backgroundColor: s.encoding.backgroundColor.field && e.backgroundColor?.find((o) => o.config().metaInfo?.isTotalsAxis),
        size: s.encoding.size.field && e.size?.find((o) => o.config().metaInfo?.isTotalsAxis)
      }
    });
  });
}, { X: N6, Y: F6, RADIUS: qp, ANGLE: W_, ANGLE0: V_, RADIUS0: R6 } = yt, k6 = (e, t) => {
  const i = {};
  return e.forEach((n) => {
    const { axis: A, encoding: s } = n.config(), o = n.id();
    [N6, F6, W_, V_, qp].forEach((r) => {
      let a;
      const l = W(s, r, "field"), c = r === qp ? ft(l, W(s, R6, "field")) : W(s, r, "field"), g = ft(W(A, r), c);
      t[r] && t[r].length ? a = t[r].findIndex(
        (h) => h.getMembers().indexOf(g) !== -1
      ) : a = 0, !i[o] && (i[o] = {}), i[o][r] = a;
    });
  }), i;
}, T6 = (e, t, i, n) => i === W_ || i === V_ ? e.concat(t.filter((A) => e.indexOf(A) === -1)) : te([e, t], n), No = (e, t, i) => {
  let n = [];
  return e.forEach((A) => {
    [A.def].flat().forEach((s) => {
      const o = i.encoding, r = t[s.id], a = i.field.has(
        s.encoding[o].field
      ) ? r[i.encoding] : null;
      if (a !== null && s.calculateDomain !== !1) {
        const l = s.encoding, c = W(l, o, "field"), g = W(l, o, "as");
        c && (n = T6(n, a, o, g));
      }
    });
  }), n;
}, j_ = (e, t, i, n, A) => {
  const s = e.renderer(), o = e.config().classPrefix, r = i.sort(
    (u, d) => u.config().order - d.config().order
  ), a = s === "html" ? "div" : "g", l = j(
    t,
    a,
    [1],
    `${o}-layer-group`
  );
  l.style("width", "inherit").style("height", "inherit");
  const c = jw(e._layerDepOrder), g = {};
  return j(l, a, r, null, {
    update: (u, d) => {
      g[d.alias()] = {
        group: u,
        layer: d
      };
    }
  }), c.map((u) => g[u]).filter((u) => u !== void 0).forEach((u) => {
    const d = u.layer, f = u.group;
    d.measurement(n), d.dataProps({
      timeDiffs: e._timeDiffs
    }), d.config().render !== !1 && d.mount(f.node(), A);
  }), globalThis;
}, Zf = (e, t) => {
  const { CONTINUOUS: i, TEMPORAL: n } = J.FieldSubtype, A = e.fields();
  if (!A.x.length || !A.y.length)
    return null;
  const s = e.data(), o = e.axes(), r = W(A, "x", 0), a = W(A, "y", 0), l = { value: null }, c = [
    ["x", r],
    ["y", a]
  ].find(
    ([, d]) => d.as() === "discrete" || d.subtype() === "temporal"
  );
  if (!c || r.subtype() !== i && a.subtype() !== i)
    return l;
  const g = c[1], h = br(g);
  let u = o[c[0]][0].getNearestInvertedValue(t[c[0]]);
  if (h)
    return c[1].subtype() === n && c[1].as() === i && (u = g.vars().map((f) => [...new Set(s.getFieldData(f.toString()))]).map((f) => yf(f, u))), u !== void 0 && (l.value = [g.vars().map((d) => d.toString()), u]), { ...l, multipleDimFields: !0 };
  if (c[1].subtype() === n && c[1].as() === i) {
    const d = [...new Set(s.getFieldData(g.toString()))];
    u = yf(d, u);
  }
  return u !== void 0 && (l.value = [[g.toString()], [u]]), l;
}, $f = (e, t, i) => e.filter((n) => (t === "type" ? n.constructor.formalName() : n.alias()) === i), Xf = (e, t, i) => {
  e.filter((n) => (t === "type" ? n.config().mark : n.alias()) === i ? (n.remove(), !1) : !0);
}, q_ = (e, t) => j(e, "g", [1], t).node(), z_ = (e, t, i = {}) => {
  const { innerRadius: n, outerRadius: A } = i;
  return [n || 0, A || Math.min(t, e) / 2];
}, Z_ = (e) => {
  const t = e.axes(), { radius: i } = t;
  i && i.forEach((n) => {
    n.range(z_(e.width(), e.height()));
  });
}, v6 = (e) => {
  (e.node().__on || []).forEach(({ type: i }) => {
    e.on(i, null);
  });
}, $_ = (e) => {
  const t = e._graphics.rootSvg, i = e.config().classPrefix, n = e._graphics;
  if (!e.layers().find((A) => A.config().mark === eS) && e.renderer() !== "html") {
    const A = `${i}-tracker`;
    n.trackerGroup = j(
      n.rootSvg,
      "g",
      [1],
      `${A}-group`
    ), n.tracker = j(
      n.trackerGroup,
      "rect",
      [1],
      A
    ), wA(n.tracker, {
      x: 0,
      y: 0,
      width: e.width(),
      height: e.height(),
      class: A
    }), v6(t);
  } else
    n.tracker && n.tracker.remove(), n.tracker = null;
}, G6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attachAxisToLayers: K_,
  attachDataToLayers: J_,
  createSideEffectGroup: q_,
  createTrackerElement: $_,
  getDimensionMeasureMap: O_,
  getLayerAxisIndex: k6,
  getLayerFromDef: H_,
  getLayersBy: $f,
  getNearestDimensionalValue: Zf,
  getRadiusRange: z_,
  getTransformedLayerDataModel: zE,
  removeLayersBy: Xf,
  renderLayers: j_,
  resolveEncodingTransform: Y_,
  sanitizeLayerDef: zf,
  setAxisRange: Z_,
  transformDataModels: b6,
  unionDomainFromLayers: No,
  updateLayerMetaInf: P_
}, Symbol.toStringTag, { value: "Module" })), L6 = "config", X_ = "data", U6 = "axes", tb = "layerDef", O6 = "width", H6 = "height", P6 = "mount", Y6 = "transform", J6 = "transformedData", K6 = "dataDomain", W6 = "fields", V6 = "layers", eb = "domain", j6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AXES: U6,
  CONFIG: L6,
  DATA: X_,
  DATADOMAIN: K6,
  DOMAIN: eb,
  FIELDS: W6,
  HEIGHT: H6,
  LAYERDEFS: tb,
  LAYERS: V6,
  MOUNT: P6,
  TRANSFORM: Y6,
  TRANSFORMEDDATA: J6,
  WIDTH: O6
}, Symbol.toStringTag, { value: "Module" })), ib = "muze", q6 = "__id__", nb = "grid-lines", Ab = "grid-bands", sb = "grid-parent-group", z6 = "band", Z6 = "tick", fA = "gridBands", ob = "gridLines", rb = "consolidated", $6 = "fragmented", ab = "facetByFields", lb = "retinalFields", cb = "parentAlias", X6 = "layers", gb = "cachedData", tW = "store", eW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAND: z6,
  CACHED_DATA: gb,
  CLASSPREFIX: ib,
  CONSOLIDATED: rb,
  FACET_BY_FIELDS: ab,
  FRAGMENTED: $6,
  GRID_BAND: fA,
  GRID_BAND_PARENT_GROUP_CLASS: Ab,
  GRID_LINE: ob,
  GRID_LINE_PARENT_GROUP_CLASS: nb,
  GRID_PARENT_GROUP: sb,
  IDFIELD: q6,
  LAYERS: X6,
  PARENT_ALIAS: cb,
  RETINAL_FIELDS: lb,
  STORE: tW,
  TICK: Z6
}, Symbol.toStringTag, { value: "Module" })), iW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CONSTANTS: eW,
  REACTIVE_PROPS: j6
}, Symbol.toStringTag, { value: "Module" })), nW = (e, t, i) => {
  const n = e.context.getNearestPoint(t.x, t.y, {
    data: i.data,
    event: i.event
  });
  return {
    criteria: n.id ? {
      dimensions: n.id
    } : null,
    target: (n || {}).target,
    position: t,
    layerId: (n || {}).layerId,
    targetData: W(n, "targetData"),
    metaInfo: e.context.metaInf()
  };
}, AW = {
  [Xo.CARTESIAN]: (e, { startPos: t, endPos: i }) => {
    if (t.x === i.x && t.y === i.y)
      return {
        criteria: null
      };
    const n = e.context.getRangeFromPositions(
      {
        startPos: t,
        endPos: i
      },
      {
        brush: W(e.config().brush, "mode")
      }
    ), A = {};
    return A.x = [t.x, i.x], A.y = [t.y, i.y], {
      criteria: n,
      dimensions: A
    };
  },
  [Xo.POLAR]: () => ({
    criteria: null
  })
}, zp = (e, t) => {
  const n = e.context.coord();
  return AW[n](e, t);
};
class hb extends to {
  constructor(...t) {
    super(...t), this._propagationDms = {}, this._entryExitSet = {}, this._payloads = {}, this._interactionStates = /* @__PURE__ */ new Map(), this._actionPayloadMap = {
      hover: (i, n, A) => {
        const s = i.context.layers(), r = s.find((C) => C.config().highlightExactPoint !== !1) ? {} : {
          getAllPoints: !0,
          detectEmptyArea: !!s.find(
            (C) => C.config().detectHoverOnEmptyArea
          ) && s.length === 1
        }, { tooltip: a } = i.config();
        let l = null, c = [], g = null;
        const h = a.includeDataFromAllLayers && s.length > 1 && s.every((C) => C.includeDataFromAllLayersInTooltip());
        if (h) {
          const C = i.context.getNearestPointsFromAllLayers(
            n.x,
            n.y,
            Object.assign(r, {
              data: A.data,
              event: A.event
            })
          );
          l = C[0], l.id && (g = {
            dimensions: l.id
          }), c = C.slice(1).filter((E) => {
            const { point: B, isVertical: m } = E, y = l.point.update, D = B.update, Q = m ? D.y : D.x, p = m ? D.y + D.height : D.x + D.width, w = m ? y.y : y.x, x = m ? y.y + y.height : y.x + y.width;
            return w >= Q && x <= p || w <= Q && x >= p;
          });
        } else
          l = i.context.getNearestPoint(
            n.x,
            n.y,
            Object.assign(r, {
              data: A.data,
              event: A.event
            })
          ), l.id && (g = {
            dimensions: l.id
          });
        const u = i.context.layers().map((C) => C.getDataBoundary(n.x, n.y)).filter((C) => !!C), d = u[u.length - 1], f = i.context.metaInf();
        return {
          criteria: g,
          target: (l || {}).target,
          position: n,
          layerId: (l || {}).layerId,
          targetData: W(l, "targetData"),
          metaData: {
            layersInfo: s,
            isTotals: f.totals,
            isCollapsed: f.isCollapsed,
            includeTotalDomain: f.includeTotalDomain,
            rowFacets: i.context.metaInf().rowFacets,
            colFacets: i.context.metaInf().colFacets,
            ...h ? { includeDataFromAllLayers: h } : {},
            ...h ? { hasPointsInBackground: !!c.length } : {},
            ...d ? {
              borderPoints: d.points,
              borderId: d.id,
              layerId: d.layerId
            } : {}
          }
        };
      },
      drag: (i, n, A) => {
        const { startPos: s, endPos: o } = n, r = i.context.getNearestPoint(
          s.x,
          s.y,
          {
            data: A.data,
            event: A.event
          }
        ), a = zp(i, n);
        return a.dragging = A.isDragging, a.dragDiff = Math.abs(s.x - o.x) + Math.abs(s.y - o.y), a.dragEnd = A.dragEnd, a.dragEnd && (a.hideSelBox = !0), a.dragStart = A.dragStart, a.target = r.id, a;
      },
      selectiondrag: (i, n, A) => {
        const { startPos: s, endPos: o } = n, r = zp(i, n);
        return r.dragging = A.isDragging, r.dragDiff = Math.abs(s.x - o.x) + Math.abs(s.y - o.y), r.dragEnd = A.dragEnd, r.dragEnd && (r.hideSelBox = !0), r;
      }
    };
  }
  data(...t) {
    if (t.length) {
      const i = t[0] === null ? this.context.cachedData()[0] : t[0], n = t[1], A = this.context;
      return A.setCustomLayerData(n), A.enableCaching().data(i), A.clearCustomLayerData(), this;
    }
    return this.context.data();
  }
  disposeBehaviours({ exclude: t }) {
    const i = this._actions.behavioural;
    for (const n in i)
      n !== t && i[n].dispose();
  }
  resetData() {
    const { context: t } = this, i = t.layers().reduce((n, A) => (n[A.id()] = A.cachedData()[0], n), {});
    return t.setCustomLayerData(i), t.clearCaching().resetData(), this;
  }
  target() {
    return "visual-unit";
  }
  remove() {
    return this.context.cachedData()[0].unsubscribe("propagation"), this;
  }
  id() {
    return this.context.id();
  }
  getPropagationSource() {
    return this.context.cachedData()[0];
  }
  sourceCanvas() {
    return this.context.parentAlias();
  }
  groupFirebolt(...t) {
    return t.length ? (this._groupFirebolt = t[0], this) : this._groupFirebolt;
  }
  onPhysicalActionTrigger(t) {
    this.groupFirebolt().onPhysicalActionTrigger({
      ...t,
      sourceUnit: this.id(),
      unitMetaInf: this.context.metaInf()
    });
  }
  dispatchBehaviour(t, i, n = {}) {
    const A = this._childFirebolts;
    let s = !0;
    const o = A.find(
      (c) => c.id() === i.sourceInfo.layerId
    );
    (o ? [
      o,
      ...A.filter(
        (c) => c !== o
      )
    ] : A).forEach((c) => {
      let g = i.criteria;
      const h = c.getSideEffectsForSourceAction({
        action: t
      }), u = ft(
        i.sideEffects ? i.sideEffects : h,
        []
      ), d = i.sourceInfo.layerId, { includeDataFromAllLayers: f, hasPointsInBackground: I } = i.metaData || {}, C = this.layers().some(
        (B) => B._transformedData._config && B._transformedData._config.groupBy && B._transformedData._config.groupBy.length
      );
      if (!(f && (I || C)) && i.isExplicitAction && i.criteria !== null && (d && d !== c.id() || i.sourceInfo.unitId !== this.id()) && (g = {
        uids: []
      }), c.dispatchBehaviour(
        t,
        {
          ...i,
          sideEffects: u,
          criteria: g
        },
        n
      )) {
        const B = c.actions().behavioural[t].getSelectionSet().resetted();
        B ? c.removeInteractionState({
          action: t
        }) : c.saveInteractionState({
          action: t,
          payload: {
            ...i,
            sideEffects: u,
            criteria: g
          },
          propagationInf: n
        }), s = s && B;
      }
    }), this.createEntryExitSet(i);
    const a = this.getSideEffectsForSourceAction({
      action: i.action
    }), { tooltip: l } = this.config();
    this.metaData(
      l && l.includeDataFromAllLayers ? {
        entryExitSetsByLayerId: A.reduce((c, g) => {
          const h = g.context.id(), u = g.getEntryExitSet(i.action);
          return { ...c, [h]: u };
        }, {})
      } : {}
    ), this.dispatchSideEffects(
      t,
      { ...i, sideEffects: a },
      n
    ), s ? this.removeInteractionState({
      action: t
    }) : this.saveInteractionState({
      action: t,
      payload: { ...i, sideEffects: a },
      propagationInf: n
    }), this._lastInteraction.set(t, {
      behaviour: t,
      sideEffects: a
    });
  }
  applyExistingInteractions() {
    this._childFirebolts.forEach((i) => {
      i.applyExistingInteractions();
    }), this._interactionStates.forEach(({ action: i, payload: n, propagationInf: A }) => {
      const s = n.sideEffects.filter((o) => this.sideEffects()[o.name] && this.sideEffects()[o.name].shouldApplyOnRenderAfterScrolling());
      this.dispatchSideEffects(
        i,
        { ...n, sideEffects: s },
        A
      );
    });
  }
  shouldResetAllInteractions(t) {
    return this._childFirebolts[0].getBehaviouralAction(t).shouldResetOtherActionsOnTrigger();
  }
  addChildFirebolts(t) {
    this._childFirebolts = t, this._propagationCount = /* @__PURE__ */ new Map(), t.forEach((i) => {
      i.onPropagationDone((n, A, s) => {
        let o = this._propagationCount.get(n.action) || 0;
        o++, this._propagationCount.set(n.action, o), o === t.length && (this.onLayerPropagationComplete({
          payload: n,
          propagationData: A,
          propagationInf: s
        }), this._propagationCount.set(n.action, 0));
      });
    });
  }
  createEntryExitSet(t) {
    const i = this._childFirebolts, n = t.action, A = i.map((s) => s.getEntryExitSet(n)).filter((s) => s);
    return this._entryExitSet[n] && this._entryExitSet[n].dispose(!1), this._entryExitSet[n] = new JM(A, {
      extraData: {
        data: this.context.facetFieldsMap(),
        schema: this.context.facetSchema()
      },
      name: `visual-unit-${t.action}`
    }), this._entryExitSet[n];
  }
  getSideEffectsForSourceAction({ action: t }) {
    const i = this.config()[t] || {};
    return Object.keys(i.sideEffects || {}).map((A) => ({
      name: A,
      ...i.sideEffects[A]
    })).filter((A) => A.enabled !== !1);
  }
  onLayerPropagationComplete({ payload: t, propagationData: i, propagationInf: n }) {
    const A = t.action;
    let s;
    t.resetAllInteractions ? (s = W(this._lastInteraction.get(A), "sideEffects") || [], this._lastInteraction.delete(A)) : (s = GE(
      {
        action: t.action.split(":")[1],
        targetActions: t.targetActions,
        sourceCanvas: t.sourceInfo.canvasId
      },
      this
    ), this._lastInteraction.set(A, {
      behaviour: A,
      sideEffects: s
    })), (t.applyOnVisibleUnits ? this.isVisible() : !0) && (this.createEntryExitSet(t), this._payloads[A] = t, this.dispatchSideEffects(
      A,
      { ...t, sideEffects: s },
      n
    )), this.saveInteractionState({
      action: A,
      payload: { ...t, sideEffects: s },
      propagationInf: n
    }), this._onPropagationDone(t, i, n);
  }
  getEntryExitSet(t) {
    return this._entryExitSet[t];
  }
  getSourceInfo() {
    const { layers: t } = this.context.getSourceInfo();
    return Object.assign({}, this.context.getSourceInfo(), {
      targetLayer: t.find((i) => i.id() === this._targetLayer)
    });
  }
  layers() {
    return this.context.layers();
  }
  getPlotPointsFromIdentifiers(...t) {
    return this.context.getPlotPointsFromIdentifiers(...t);
  }
  getDrawingContext() {
    return this.context.getDrawingContext();
  }
  getPayloadFromEvent(t, i, n) {
    const A = this._actionPayloadMap[t];
    return A ? A(this, i, n) : nW(this, i, n);
  }
  getPropagationIdentifiers(t) {
    const n = this.context.layers().filter((a) => a.config().interactive !== !1).map((a) => a.firebolt()), A = {
      conditions: [],
      operator: "or"
    };
    let s = !0, o = !1, r = /* @__PURE__ */ new Set();
    return n.forEach((a) => {
      const l = a.getBehaviouralAction(t).propagationIdentifiers(), c = W(
        a.context.config().interaction,
        t,
        "propagationFields"
      );
      if (l) {
        o = l.interpolated || o;
        let g = {};
        const h = a.context.data(), u = c || l.fields.filter((d) => h.isFieldPresent(d)).filter(
          (d) => c ? c.includes(d) : d !== St.ROW_ID
        );
        if (l.interpolated)
          g = h.getFilterRangeQuery(
            l.identifiers
          ), r.add(...l.fields);
        else if (l.identifiers.length) {
          const d = this.context.facetFieldsMap();
          r.add(...l.fields), g = h.getQueryFromIds(
            l.identifiers,
            u,
            !0
          );
          const f = [];
          for (let I in d)
            f.push({
              value: d[I],
              operator: "eq",
              field: I
            });
          g = {
            conditions: [g, ...f],
            operator: "and"
          };
        }
        g.conditions && g.conditions.length && (A.conditions = [...A.conditions, g]);
      }
      s = s && l === null;
    }), s ? null : {
      query: A,
      interpolated: o,
      fields: [...r]
    };
  }
  isVisible() {
    const t = this.context.store(), i = this.context.metaInf(), { rowIndex: n, colIndex: A } = i, { rowStart: s, rowEnd: o, colStart: r, colEnd: a } = t.get(
      "virtualScrolling.viewport"
    );
    return cr(n, [s, o]) && cr(A, [r, a]);
  }
}
const sW = {
  [vE]: {
    behaviours: [il],
    touch: !1
  },
  [Vo]: {
    behaviours: [UE]
  },
  [ba]: {
    behaviours: [Wf],
    touch: !0
  },
  [PM]: {
    behaviours: [il],
    touch: !0
  },
  [el]: {
    behaviours: [Wf],
    touch: !1
  },
  [sh]: {
    behaviours: [KM],
    touch: !1
  }
}, { BAR_LAYER: oW, TICK_LAYER: rW } = L_, { DISCRETE: aW } = lt, ub = ce, lW = (e, t, i, n) => {
  let A;
  const s = e.config(), { classPrefix: o, gridLines: r, gridBands: a } = s, l = r.color, c = r.zeroLineColor, g = i === fA ? a.defClassName : r.defClassName, h = a[n].color, u = t[n][0], d = u.constructor.type() === ub;
  i === fA && d ? A = {
    [n]: `${n}value`,
    [`${n}0`]: `${n}value0`
  } : A = {
    [n]: d ? `${n}value` : `${n}dim`
  }, A.color = {
    value: (E) => {
      const { datum: B, datumIdx: m } = E, y = d && u.domain()[0] < 0;
      return i === fA ? h[m % 2] : y && B[n] === 0 ? c : l;
    }
  };
  const { color: f, shape: I, size: C } = e.axes();
  return {
    definition: {
      defClassName: `${g}-${n}`,
      className: s.className,
      name: n,
      calculateDomain: !1,
      individualClassName: (E, B) => {
        let m;
        return d && u.domain()[0] < 0 && E.y === 0 && i !== fA ? m = `${o}-axis-zero-line` : m = `${o}-grid-${i}-${n}-${B % 2}`, m;
      },
      [`pad${n.toUpperCase()}`]: i === fA ? 0 : void 0,
      encoding: A,
      interactive: !1,
      transform: {
        type: "identity"
      }
    },
    axes: {
      [n]: u,
      color: f[0],
      shape: I[0],
      size: C[0]
    }
  };
}, cW = (e, t) => t.constructor.type() === ub && t.config().fieldSubtype != "binned" ? e : !1, gW = (e, t, i) => ["x", "y"].map((n) => {
  const A = e.axes();
  return !A[n] || !A[n].length ? null : ft(
    t[n] && t[n].show,
    cW(t.show, A[n][0])
  ) ? lW(e, A, i, n) : null;
}).filter((n) => n !== null), Zp = (e, t, i) => i[e] ? e : t.CATEGORICAL, hW = (e, t) => {
  const i = t.fields(), { DataStore: n } = t._dependencies, { MEASURE: A, DIMENSION: s } = n.FieldType, o = n.FieldSubtype, { ...r } = o, a = {};
  return ["x", "y"].forEach((l) => {
    let c = e[l][0].getTickValues();
    const g = i[l][0].subtype(), h = i[l][0].as(), u = i[l][0].data()?._model._config, d = [
      {
        name: "yvalue",
        type: A
      },
      {
        name: "xvalue",
        type: A
      },
      {
        name: "yvalue0",
        type: A
      },
      {
        name: "xvalue0",
        type: A
      },
      {
        name: "xdim",
        type: s,
        subtype: Zp(g, o, r)
      },
      {
        name: "ydim",
        type: s,
        subtype: Zp(g, o, r)
      }
    ], f = Math.max(c.length);
    c = g === o.TEMPORAL && h !== aW ? c.map((B) => B.getTime()) : c;
    const I = {
      [`${l}value`]: [],
      [`${l}value0`]: [],
      [`${l}dim`]: []
    };
    for (let B = 0; B < f; B += 1)
      I[`${l}value`].push(c[B]), I[`${l}value0`].push(c[B + 1]), I[`${l}dim`].push(c[B]);
    const C = Object.keys(I), E = d.filter((B) => C.includes(B.name));
    a[l] = new n(
      {
        data: Object.values(I),
        schema: E
      },
      u
    );
  }), a;
}, uW = (e, t) => {
  const i = e.config(), n = e.metaInf(), A = e.store(), s = e._timeDiffs;
  [fA, ob].forEach((o) => {
    let r, a;
    o === fA ? (r = oW, a = i.gridBands) : (r = rW, a = i.gridLines);
    const l = gW(e, a, o), c = `_${o}Selection`;
    t[c] || (e[c] = Zw(
      e[c],
      (g) => {
        const h = Bi.getLayerInstance({ mark: r }, null);
        h.dependencies(e._dependencies);
        const u = g.definition.name;
        return h.metaInf({
          unitRowIndex: n.rowIndex,
          unitColIndex: n.colIndex,
          namespace: `${n.namespace}${o}${u}`,
          parentNamespace: n.namespace
        }).store(A), h;
      },
      l,
      (g) => g.definition.name
    ), e[c].each((g, h) => {
      const u = h.definition, d = Bi.getSerializedConf(r, u), f = h.axes;
      g.config(d).dataProps({
        timeDiffs: s
      }).axes(f);
    }), e[`_${o}`] = e[c].getObjects());
  });
}, dW = (e, t) => {
  const i = e.axes(), n = e._gridLines, A = e._gridBands;
  if (n.length || A.length) {
    let s = t;
    t || (s = hW(i, e), t = s), [].concat(...A, ...n).forEach((o) => {
      o.data(o.axes().x ? s.x : s.y);
    });
  }
  return t;
}, fW = (e, t) => {
  const n = e.config().classPrefix, A = e._gridLines, s = e._gridBands, o = {
    width: e.width(),
    height: e.height()
  };
  if (e.renderer() !== "svg")
    return;
  const r = j(
    t,
    "g",
    [1],
    `${n}-${sb}`
  );
  A.length === 0 && s.length === 0 || [
    [A, `${n}-${nb}`],
    [s, `${n}-${Ab}`]
  ].forEach((a) => {
    const [l, c] = a, g = j(
      r,
      "g",
      [1],
      `.${c}`
    ), h = `${c}-group`;
    j(g, "g", l, `.${h}`, {
      update: (u, d) => {
        d.dataProps({ timeDiffs: e._timeDiffs }).measurement(o).mount(u.node());
      }
    });
  });
}, { DISCRETE: IW } = lt, CW = (e, t) => {
  const i = t._layersMap, n = {};
  e.forEach((A, s) => {
    const o = ft(A.name, `${A.mark}-${s}`);
    n[o] = !0;
  });
  for (const A in i)
    A in n || (i[A].forEach((s) => s.remove()), delete i[A]);
}, EW = (e) => [
  {
    props: tb,
    listener: (t, i, n = {}) => {
      const A = e.fields();
      if (i && A) {
        CW(i, e);
        const s = e._queuedLayerDefs;
        let o = i;
        s.forEach((a) => {
          o = [...o, ...a(i)];
        }), e.addLayer(o, n), e.registerHookAggEvents();
        const r = e.layers().some((a) => a.hasPlotSpan());
        ["x", "y"].forEach((a) => {
          ft(W(e.axes(), a), []).forEach((c) => {
            c.config({
              adjustRange: r
            });
          });
        });
      }
    }
  },
  {
    props: X_,
    listener: (t, i, n = {}) => {
      if (i) {
        e.transform();
        const A = e.axes(), s = {}, { timeDiffObj: o } = e.metaInf();
        Object.entries(e.fields()).forEach(([l, [c]]) => {
          if (c) {
            const h = br(c) ? Math.min(...c.vars().map((u) => o[`${u}`])) : o[`${c}`];
            h != null && !Number.isNaN(h) && c.as() !== IW && (s[l] = h, A[l].forEach((u) => {
              u.minDiff && u.minDiff(h);
            }));
          }
        }), e._timeDiffsByField = o, e._timeDiffs = s, e.layers().forEach((l) => {
          l.dataProps({
            timeDiffs: e._timeDiffs
          });
        });
        const r = e.axes(), a = e.layers();
        a && r && (K_(r, a, e), n.skipAttachLayerData || J_(e, a, i), e._createGridLinesAndBands = e.createGridLinesAndBands(), e._dimensionMeasureMap = O_(
          e.layers(),
          e.data(),
          e.retinalFields()
        ));
      }
    }
  }
], BW = {
  [ab]: {
    onset: (e, t) => {
      const i = t[0].reduce((n, A, s) => (n[`${A}`] = t[1][s], n), {});
      e.facetFieldsMap(i);
    }
  },
  facetSchema: {},
  facetFieldsMap: {},
  [lb]: {},
  [cb]: {},
  [gb]: {},
  detailFields: {},
  axes: {
    defaultValue: {
      x: [],
      y: []
    }
  },
  fields: {
    defaultValue: {
      x: [],
      y: []
    },
    sanitization: (e, t) => tt(
      {
        x: [],
        y: []
      },
      t
    )
  },
  metaInf: {},
  registry: {},
  parentContainerInf: {},
  valueParser: {
    defaultValue: (e) => e
  },
  coord: {},
  renderer: {
    defaultValue: "svg"
  }
};
const mW = {
  classPrefix: ib,
  defClassName: "visual-unit",
  className: "",
  trackerClassName: "visual-unit-tracker",
  minOuterRadius: 10,
  gridLines: {
    defClassName: "axis-grid-lines",
    className: "",
    show: !0,
    color: "#efefef",
    zeroLineColor: "#b6b6b6"
  },
  gridBands: {
    defClassName: "axis-grid-bands",
    className: "",
    show: !1,
    y: {
      color: ["#fff", "#fbfbfb"]
    },
    x: {
      color: ["#fff", "#f9f9f9"]
    }
  },
  arcLayerClassName: "layer-arc",
  interaction: {
    tooltip: {
      mode: rb
    }
  },
  sideEffectClassName: "side-effect-container"
}, QW = (e) => (t) => {
  const i = ".muze-layer-text-grid-container .muze-layer-text-outer-cell";
  t.selectAll(i).on("pointerover", pW.bind(void 0, e)), t.selectAll(i).on("pointermove", yW.bind(void 0, e)), t.selectAll(i).on("pointerout", DW.bind(void 0, e));
}, pW = (e) => {
  ZE(e, !0);
}, yW = (e) => {
  ZE(e, !0);
}, DW = (e) => {
  ZE(e, !1);
}, ZE = (e, t) => {
  const i = Bt(), n = V(i.currentTarget);
  e.triggerPhysicalAction(Hg, {
    target: n,
    isActive: t
  });
}, wW = "VisualUnit";
class rh extends _e().with(zs) {
  /**
   * Creates instance of visualization unit.
   *
   * @param {Object} registry  Component registry
   * @param {Object} dependencies  Dependencies required by visual unit.
   */
  constructor(t, i, n) {
    super(), this.eventManager(n), this._id = Ut(), this._listeners = {}, EW(this).forEach((A) => {
      this._listeners[A.props] = A.listener;
    }), this._dependencies = i, this._canvasHelpers = i.canvasActions, Bi.setLayerRegistry(t.layerRegistry), this._layersMap = {}, this._gridLinesSelection = null, this._gridBandsSelection = null, this._gridLines = [], this._gridBands = [], this._queuedLayerDefs = [], this._graphics = {}, ge(this, this.constructor.getterSetters()), this.registry(t), this.cachedData([]), this.emitSelfHooks(gt.INITIALIZED);
  }
  static formalName() {
    return wW;
  }
  static getState() {
    return [
      {
        domain: null
      }
    ];
  }
  static getterSetters() {
    return BW;
  }
  associatedHookComponentPaths() {
    return [[xt.UNIT]];
  }
  store(...t) {
    return t.length ? (this._store = t[0], this) : this._store;
  }
  initializeInteractionModel() {
    const t = this.firebolt();
    t.addChildFirebolts(this.layers().map((i) => i.firebolt())), t.config(this.config().interaction);
  }
  createFireboltInstance() {
    const { interactions: t } = this.registry(), i = this.getFireboltCls();
    return this.firebolt(
      new i(
        this,
        {
          physical: Object.assign({}, t.physicalActions, {
            [Hg]: QW
          }),
          behavioural: Object.assign({}, t.behaviours, {
            [Rs]: VE
          }),
          physicalBehaviouralMap: Object.assign(
            {},
            t.physicalBehaviouralMap,
            {
              [Hg]: {
                behaviours: [Rs],
                touch: !1
              }
            }
          )
        },
        Object.assign({}, t.sideEffects),
        Object.assign({}, t.behaviourEffectMap)
      )
    ), this;
  }
  getFireboltCls() {
    return hb;
  }
  /**
   * Static helper for creates a unit instance
   *
   * @param {Object} [id] optional unique identifier for a unit; , id is calculated internally
   * @param {DataModel} data instance of datamodel
   * @param {Array.<Layer>} layers layer configuration
   * @param {Object} config configurtion for the visual unit
   * @return {VisualUnit} Instance of a unit
   */
  static create(...t) {
    return new this(...t);
  }
  /**
   * Returns the instance of firebolt associated with this visual unit. Firebolt dispatches the behavioural actions
   * when any physical action happens on the elements of visual unit.
   *
   * @public
   *
   * @return {Firebolt} Instance of firebolt.
   */
  firebolt(...t) {
    return t.length ? (this._firebolt = t[0], this) : this._firebolt;
  }
  /**
   * Returns the unique id of this visual unit.
   *
   * @public
   * @return {string} Unique identifier.
   */
  id() {
    return this._id;
  }
  lockModel() {
    return this.store().lockModel(), this;
  }
  unlockModel() {
    return this.store().unlockModel(), this;
  }
  lockLocalModel() {
    return this._locked = !0, this;
  }
  unlockLocalModel(t = {}) {
    return this._locked = !1, this.triggerAllListeners(t), this.initializeInteractionModel(), this;
  }
  timeDiffsByField(...t) {
    return t.length ? this : this._timeDiffsByField;
  }
  /**
   * Renders the visual unit. It creates the layout and renders the axes and layers.
   *
   * @return {VisualUnit} Instance of visual unit.
   */
  render(t, i = {}) {
    this.emitSelfHooks(gt.BEFORE_RENDERED, {
      virtualScrolling: {
        viewportRange: W(i, "viewportRange") || null
      }
    }), t || (t = this.mount()), this.createRootContainers(t), Z_(this), this.renderLayers(i), this.thinAndRenderTextPoints();
    const n = this._graphics.rootSvg.node(), { sideEffectClassName: A, classPrefix: s } = this.config();
    return $_(this), this._sideEffectGroup = q_(
      n,
      `${s}-${A}`
    ), this.firebolt().mapActionsAndBehaviour(), this;
  }
  thinAndRenderTextPoints() {
    const t = this.layers(), i = t.map((h) => {
      const u = h.textPointsInfo();
      return u ? { layer: h, pointsInfo: u } : null;
    }).filter((h) => !!h);
    let n = [];
    i.forEach(({ layer: h, pointsInfo: u }) => {
      const { location: d, points: f } = u, { filter: I } = h.config().encoding.text, C = h.data(), E = (B) => {
        if (B.isLabelThinned || !B.text)
          return !1;
        const m = { rowData: B.data, rowId: B.rowId };
        return I(m, { context: h, dm: C });
      };
      f.forEach((B) => {
        const m = B.text;
        if (!m)
          return;
        if (E(B)) {
          const [D, Q] = Si.getLabelPosition(B, d);
          m.originalPosition = {
            x: m.update.x,
            y: m.update.y
          }, m.update.x = D, m.update.y = Q, n.push(B);
        } else
          B.isLabelThinned = !0;
      });
    });
    const A = this.width(), s = this.height(), { smartLabel: o } = this._dependencies;
    n = Si.getUniquePositionedPoints(
      n,
      "text"
    ), t.map((h) => {
      const { encoding: u } = h.config();
      return u.text.removeCollision;
    }).every((h) => h) && (Si.thinVoronoi(
      A,
      s,
      o,
      n,
      "text"
    ), Si.thinFinally(
      A,
      s,
      o,
      n,
      "text",
      { thinOverflowingLabels: !0 }
    )), i.forEach(({ pointsInfo: h }) => {
      const { points: u } = h;
      u.forEach((d) => {
        const f = d.text;
        f && (f.originalPosition && (f.update.x = f.originalPosition.x, f.update.y = f.originalPosition.y, f.originalPosition = null), f.isVisible && (f.isVisible = !d.isLabelThinned));
      });
    });
    const { classPrefix: a } = this.config(), l = this._graphics.rootSvg, c = j(
      l,
      "g",
      [1],
      `${a}-layer-labels-group`
    );
    j(
      c,
      "g",
      i,
      `${a}-layer-labels`,
      {},
      (h) => h.layer.id()
    ).each(function(h) {
      const u = V(this), { layer: d, pointsInfo: f } = h;
      u.classed(
        `${a}-layer-${d.constructor.formalName()}-labels`,
        !0
      ), d.onAnimationEnd().then(() => {
        d.renderTextPoints(u, f);
      });
    });
  }
  emitAllRenderHooksWhenRenderSkipped(t) {
    this.emitSelfHooks(gt.BEFORE_RENDERED, {
      virtualScrolling: {
        viewportRange: W(t, "viewportRange") || null
      }
    }), this.layers().forEach(
      (i) => i.emitAllRenderHooksWhenRenderSkipped(t)
    );
  }
  registerHookAggEvents() {
    const t = this.layers().reduce((n, A) => {
      const { mark: s } = A.config();
      return n.has(s) ? n.get(s).push(A) : n.set(s, [A]), n;
    }, /* @__PURE__ */ new Map());
    [
      {
        componentPath: [xt.LAYER],
        target: this.layers()
      },
      ...[...t.keys()].map((n) => ({
        componentPath: [xt.LAYER, n],
        target: t.get(n)
      }))
    ].forEach((n) => {
      [
        gt.BEFORE_RENDERED,
        gt.AFTER_RENDERED,
        gt.ANIMATION_END
      ].forEach((A) => {
        const s = new Ie({
          componentPath: n.componentPath,
          modifier: fe.EACH,
          hookName: A
        });
        n.target.forEach((o) => {
          if (o) {
            const r = o.eventManager().listeners(s).find(
              (a) => W(a, "meta", "tag") === gc
            );
            r && o.eventManager().off(s, r.listener);
          }
        }), K8(
          new Ie({
            componentPath: n.componentPath,
            modifier: fe.EACH,
            hookName: A
          }),
          n.target,
          (o) => {
            const { rowStart: r, rowEnd: a, colStart: l, colEnd: c } = this.store().get(
              `${Yt}.viewport`
            );
            this.emitEvent({
              name: new Ie({
                componentPath: [
                  xt.UNIT,
                  ...n.componentPath
                ],
                modifier: fe.ALL,
                hookName: A
              }),
              target: n.target,
              data: { aggEventObjects: o },
              virtualScrolling: {
                viewportRange: {
                  rowRange: [r, a],
                  colRange: [l, c]
                }
              }
            });
          },
          { tag: gc }
        );
      });
    }), [
      gt.AFTER_RENDERED,
      gt.ANIMATION_END
    ].forEach((n) => {
      const A = new Ie({
        componentPath: [
          xt.UNIT,
          xt.LAYER
        ],
        modifier: fe.ALL,
        hookName: n
      }), s = this.eventManager().listeners(A).find(
        (o) => W(o, "meta", "tag") === gc
      );
      s && this.eventManager().off(A, s.listener), this.eventManager().on(
        A,
        () => {
          const { rowStart: o, rowEnd: r, colStart: a, colEnd: l } = this.store().get(
            `${Yt}.viewport`
          );
          this.emitSelfHooks(n, {
            virtualScrolling: {
              viewportRange: {
                rowRange: [o, r],
                colRange: [a, l]
              }
            }
          });
        },
        { tag: gc },
        {
          executePostPropagation: !0
        }
      );
    });
  }
  createRootContainers(t) {
    const i = this.config(), { defClassName: n } = i, A = _n(
      n,
      this.id(),
      i.classPrefix
    ), s = this.renderer(), o = this.width(), r = this.height();
    this._container = V(t);
    const a = V(t).style(
      "position",
      "relative"
    ), l = s === "html" ? "div" : "svg", c = this._graphics.rootSvg && this._graphics.rootSvg.node();
    (l === "svg" && c instanceof HTMLElement || l === "div" && c instanceof SVGElement) && this._graphics.rootSvg.remove(), this._graphics.rootSvg = j(
      a,
      l,
      [1],
      A[1]
    ).style("left", "0px").style("top", "0px").style("position", "absolute").style("width", "inherit").style("height", "inherit");
    const g = this._graphics.rootSvg.node();
    return wA(g, {
      width: o,
      height: r,
      class: A.join(" ")
    }), this;
  }
  renderLayers(t) {
    const i = this.width(), n = this.height(), A = this._graphics.rootSvg.node();
    return this._createGridLinesAndBands(), fW(this, A), j_(
      this,
      A,
      this.layers(),
      {
        width: i,
        height: n
      },
      t
    ), this;
  }
  /**
   * Caches all the datamodels in an array from the next `data()` call on visual unit until `clearCaching()` or
   * `resetData()` is called on it.
   *
   * @public
   * @return {VisualUnit} Instance of visual unit.
   */
  enableCaching() {
    return this._cache = !0, this;
  }
  /**
   * Clears all the previous cached data.
   *
   * @public
   * @segment VisualUnit
   * @return {VisualUnit} Instance of visual unit.
   */
  clearCaching() {
    return this._cache = !1, this.cachedData([this.cachedData()[0]]), this;
  }
  clearCachedLayerData() {
    return (this.layers() || []).forEach((i) => {
      i._cachedData.forEach((n) => {
        n.dispose();
      }), i._cachedData.length = 0;
    }), this;
  }
  /**
   * Returns the drawing information from visual unit.Drawing context contains the dimensions of unit and the svg
   * container of the visual unit.
   *
   * @public
   *
   * @return {Object} Drawing information.
   *      ```
   *          {
   *              htmlContainer: // Html container of svg container of the visual unit
   *              svgContainer: // Root svg container
   *              width: // Width of the visual unit
   *              height: // Height of the visual unit
   *              sideEffectGroup: // Svg group for drawing side effect elements.
   *              parentContainer: // Parent html container of the visual unit.
   *              xOffset: // x offset space from the starting x position of the container,
   *              yOffset: // y offset space from the starting y position of the container
   *          }
   *      ```
   */
  getDrawingContext() {
    const t = this._graphics.rootSvg && this._graphics.rootSvg.node(), i = this.width(), n = this.height(), { el: A, dimensions: s } = this.parentContainerInf();
    return {
      htmlContainer: this.mount(),
      svgContainer: t,
      width: i,
      height: n,
      sideEffectGroup: this._sideEffectGroup,
      parentContainer: A,
      parentContainerDimensions: s,
      xOffset: 0,
      yOffset: 0
    };
  }
  /**
   * Returns the serialized configuration of visual unit.
   *
   * @return {Object} serialized configuration
   */
  serialize() {
    return {
      layers: this.layers().map((t) => t.serialize()),
      config: this.config(),
      axes: this.axes().map((t) => t.serialize())
    };
  }
  mount(...t) {
    return t.length ? (this._mount = t[0], this) : this._mount;
  }
  /**
   * Adds a new layer to the visual unit. It takes a layer definition and creates layer instances from them. It does
   * not render the layers. It returns the layer instances in an array. If the layer definition is a composite layer,
   * then multiple layer instances will be returned in the array.
   *
   * To add a layer in the unit,
   * ```
   *      unit.addLayer({
   *          name: 'bullet',
   *          mark: 'bar',
   *          encoding: {
   *              x: 'Year',
   *              y: 'Acceleration',
   *              color: 'Origin'
   *          }
   *      });
   * ```
   * @public
   * @param {Object} layerDef Definition of new layer.
   *
   * @return {Array} Array of layer instances.
   */
  addLayer(t, i = {}) {
    if (t instanceof Function)
      return this._queuedLayerDefs.push(t), this;
    const n = this.renderer(), A = zf(Fi(t)), s = this._layersMap, o = {
      layers: {},
      components: {
        unit: this
      }
    };
    let r = 0;
    const a = A.sort((g, h) => g.order - h.order).reduce((g, h) => {
      const u = h.def, d = u.name, f = Fi(u);
      f.forEach((E) => {
        E.order = h.order + r;
      }), r += f.length;
      const I = H_(
        this,
        u,
        s[d],
        // namespaces,
        n,
        i
      );
      o.layers = Object.assign(o.layers, I);
      const C = Object.values(I);
      return g = g.concat(...C), s[d] = C, g;
    }, []);
    o.unit = this;
    const l = {}, c = [].concat(...Object.values(this._layersMap));
    return c.forEach((g) => {
      const h = g.alias();
      o.layers[h] = g, l[h] = [];
    }), a.forEach((g) => {
      const h = Y_(g, o);
      l[g.alias()] = h;
    }), this._layerDepOrder = l, this.layers(c), a;
  }
  remove() {
    const t = this.layers();
    return V(this.mount()).remove(), this.firebolt().remove(), this.firebolt().dispose(), this._firebolt = null, this.data().dispose(), this._data = null, [...t, ...this._gridLines, ...this._gridBands].forEach(
      (i) => i.remove()
    ), this._layers.length = 0, this._gridLines.length = 0, this._gridBands.length = 0, this._fields = null, this;
  }
  /**
   * Resets the data of visual unit to original data model. It also clears the cached data.
   *
   * @public
   * @segment VisualUnit
   * @return {VisualUnit} Instance of visual unit.
   */
  resetData() {
    return this.data(this.cachedData()[0]), this;
  }
  getSourceInfo() {
    return {
      dimensionMeasureMap: this._dimensionMeasureMap,
      fields: this.fields(),
      data: this.data(),
      axes: this.axes(),
      retinalFields: this.retinalFields(),
      layers: this.layers(),
      timeDiffs: this.timeDiffsByField(),
      useUTC: this.config().useUTC
    };
  }
  dataDomain(...t) {
    const { namespace: i } = this.metaInf(), n = this.store(), A = `${$h}.${eb}`;
    if (t.length) {
      const o = t[0];
      n.commit(A, (r) => Object.assign(r || {}, {
        [i]: o
      }));
    }
    const s = n.get(A);
    return W(s, i);
  }
  getDefaultTargetContainer() {
    const { classPrefix: t, defClassName: i, sideEffectClassName: n } = this.config();
    return this._graphics.tracker ? [
      `.${t}-tracker-group`,
      `.${t}-${n}`
    ] : [`.${t}-${i}`];
  }
  /**
   * Returns an array of layer instances which matches the supplied mark type.
   *
   * @public
   *
   * @param {string} type Mark type of layer.
   *
   * @return {Array} Array of layer instances.
   */
  getLayersByType(t) {
    return $f(this.layers(), "type", t);
  }
  /**
   * Returns the layer instance which matches the supplied layer name. If no layer is found, then it returns
   * undefined.
   *
   * @public
   * @param {string} name Name of layer.
   *
   * @return {VisualUnit} Layer instance.
   */
  getLayerByName(t) {
    return $f(this.layers(), "name", t)[0];
  }
  getLayerById(t) {
    return this.layers().find((i) => i.id() === t);
  }
  /**
   * Returns the point located nearest to the supplied x and y position. It returns the unique identifiers of the
   * point. This function also accepts an additional configuration `getAllPoints` inside `config` object in the third
   * argument which if set to true, then it returns the identifiers of all the points which falls on the nearest
   * x value or y value if any one of the field is a dimension. Additionally, a target property is also returned
   * which contains the identifier of the nearest point. If no nearest point is found, then it returns identifier
   * as null.
   *
   * @public
   *
   * @param {number} x X Position of the point from where nearest point is to be found.
   * @param {number} y Y Position of the point from where nearest point is to be found.
   * @param {Object} config Additional configuration options.
   * @param {boolean} config.getAllPoints If true, then returns all the points nearest to the x value or y value if
   * it is dimension.
   * @param {Object} config.data Data associated with the nearest point.
   * @return {Object} Nearest point information
   * ```
   *      {
   *          id: [['Origin'], ['USA'], ['Japan']], // Identifiers of all the points closest to the x value.
   *          target: [['Origin'], ['Japan']] // Identifier of the nearest point.
   *      }
   * ```
   */
  getNearestPoint(t, i, n = { includeFromAllLayers: !1 }) {
    const A = ft(n.getAllPoints, !1), s = ft(n.detectEmptyArea, !1), { value: o, multipleDimFields: r } = Zf(this, {
      x: t,
      y: i
    });
    let a = this.getMarkInfFromLayers(t, i, {
      ...n,
      dimValue: o
    });
    return this.getPointsDataFromMarkInf(a, {
      getAllPoints: A,
      detectEmptyArea: s,
      multipleDimFields: r,
      dimValue: o
    });
  }
  getNearestPointsFromAllLayers(t, i, n) {
    const A = ft(n.getAllPoints, !1), s = ft(n.detectEmptyArea, !1), { value: o, multipleDimFields: r } = Zf(this, {
      x: t,
      y: i
    }), a = this.getMarkInfFromAllLayers(t, i, {
      ...n,
      dimValue: o
    });
    return a.length || a.push(null), a.map((l) => this.getPointsDataFromMarkInf(l, {
      getAllPoints: A,
      detectEmptyArea: s,
      multipleDimFields: r,
      dimValue: o
    }));
  }
  getPointsDataFromMarkInf(t, i) {
    const { getAllPoints: n, dimValue: A, multipleDimFields: s, detectEmptyArea: o } = i;
    t || (t = {
      id: null,
      target: null,
      layerId: null
    });
    const r = t.layerId;
    if (s) {
      const g = Array.isArray(t.id) && Array.isArray(t.id[0]) ? t.id[0][0] : this.layers().length ? this.layers()[0].encodingFieldsInf().xField : void 0;
      if (g) {
        const h = A[0].findIndex((u) => u === g);
        A[0] = [A[0][h]], A[1] = [A[1][h]];
      }
    }
    const a = t.point && t.point.data ? Object.keys(t.point.data).reduce(
      (g, h) => [
        [...g[0], h],
        [...g[1], t.point.data[h]]
      ],
      [[], []]
    ) : t.id, l = t.id;
    if (!n)
      return { id: t.id, target: l, targetData: a, layerId: r };
    const c = Object.assign({}, t);
    if (o && A)
      c.id = A, t.id && t.id[0].length === 1 && (t.id[1][0] = A[1][0]), c.target = l;
    else if (t.id) {
      if (A) {
        const g = A[0][0], h = t.id[1][t.id[0].indexOf(g)];
        c.id = h === A[1][0] ? A : t.id;
      } else
        c.id = t.id;
      c.target = l;
    } else
      c.id = c.target = null;
    return c.layerId = r, c.targetData = a, c;
  }
  getMarkInfFromLayers(t, i, n = {}) {
    const A = this.layers();
    let s = null;
    for (let o = A.length - 1; o >= 0; o--) {
      const r = A[o];
      if (r.config().interactive !== !1 && (s = r.getNearestPoint(t, i, n)), s)
        return s;
    }
    return s;
  }
  getMarkInfFromAllLayers(t, i, n = {}) {
    const A = this.layers(), s = [];
    let o = !1, r = {
      minX: null,
      minY: null,
      maxX: null,
      maxY: null
    };
    for (let a = A.length - 1; a >= 0; a--) {
      const l = A[a];
      if (l.config().interactive !== !1)
        if (l.includeDataFromAllLayersInTooltip()) {
          const g = o ? l.getNearestPointInRange(r) : l.getNearestPoint(t, i, n);
          if (g) {
            const h = l.isVertical();
            s.push({ ...g, isVertical: h });
            const { point: u } = g;
            let { X: d, Y: f, X0: I, Y0: C } = {
              X: u.update.x + u.update.width,
              Y: u.update.y + u.update.height,
              X0: u.update.x,
              Y0: u.update.y
            };
            r = {
              minX: Number.isFinite(r.minX) ? Math.min(r.minX, I) : I,
              minY: Number.isFinite(r.minY) ? Math.min(r.minY, C) : C,
              maxX: Number.isFinite(r.maxX) ? Math.min(r.maxX, d) : d,
              maxY: Number.isFinite(r.maxY) ? Math.min(r.maxY, f) : f
            }, o = !0;
          }
        } else {
          const g = l.getNearestPoint(t, i, n);
          if (g)
            return [g];
        }
    }
    return s;
  }
  /**
   * Get the information of all the marks such as x, y position and size from supplied identifiers. It
   * returns an array of points whose data matches the given identifiers.
   *
   * @public
   *
   * @param {Array|Object} identifiers Field names and their corresponding values.
   * ```
   * identifiers can be given in an array of array,
   *      ['Origin', 'Name'], // Names of the fields supplied in first array
   *      ['USA', 'ford'], // Data values of each field supplied in rest of the arrays.
   *      ['Japan', 'ford']
   * or in an object,
   *      {
   *          Origin: ['USA']
   *      }
   * ```
   * @param {Object} config Optional configurations which decides which information of the mark will
   * be retrieved.
   * @param {boolean} [config.getAllAttrs = false] If true, then returns all the information of each mark.
   * @param {boolean} [config.getBBox = false] If true, then returns the bounding box of each mark.
   *
   * @return {Array} Array of objects containing the information of each point.
   * ```
   * By default, the method returns the array of points in this structure,
   *      [
   *          {
   *              x: 20,
   *              y: 100,
   *              width: 200,
   *              height: 100
   *          }
   *      ]
   * If 'config.getAllAttrs' is true, then it returns all the information of each mark,
   *      [
   *      // Positions of mark on initial state of transition.
   *          enter: {
   *              x: 0,
   *              y: 0
   *          },
   *          // Final positions of the mark
   *          update: {
   *              x: 20,
   *              y: 10
   *          },
   *          style: // css styles of each mark
   *          source: [200, 'USA'] // Row information of each mark
   *          id: 20 // Row id of each mark
   *      ]
   * ```
   */
  getPlotPointsFromIdentifiers(t, i = {}, n) {
    let A = [];
    if (t === null)
      return [];
    const s = this.layers(), o = s.find((a) => a.id() === n), r = o ? [o] : s;
    for (let a = 0, l = r.length; a < l; a++) {
      const c = r[a];
      c.config().interactive !== !1 && (A = [
        ...A,
        ...c.getPointsFromIdentifiers(t, i)
      ]);
    }
    return A;
  }
  /**
   * Removes the layer instance which matches the supplied layer name.
   *
   * @public
   * @param {string} name Name of layer
   *
   * @return {VisualUnit} Instance of visual unit.
   */
  removeLayerByName(t) {
    return Xf("name", t), this;
  }
  /**
   * Removes all the layer instances which matches the supplied mark type.
   *
   * @public
   * @param {string} type Mark type of layer.
   *
   * @return {VisualUnit} Instance of visual unit.
   */
  removeLayersByType(t) {
    return Xf("type", t), this;
  }
  calculateDomainFromData() {
    return No(this.layers(), this.fields());
  }
  getRangeFromIdentifiers({ criteria: t, fields: i }) {
    return i.reduce((n, A) => (n[A] = t[A], n), {});
  }
  getRangeFromPositions({ startPos: t, endPos: i }, n = {}) {
    const { x: A, y: s } = this.fields(), o = this.axes(), r = A[0], a = s[0], l = this.data().getDimensions(), { brush: c } = n;
    if (c === "x") {
      let g = o.x[0].invertExtent(t.x, i.x).sort((d, f) => d - f);
      g = r.subtype() === "temporal" && r.as() !== oe ? g.map((d) => d.getTime()) : g;
      const h = r.getMembers(), u = {};
      return h.forEach((d) => {
        u[d] = g;
      }), { range: u };
    } else if (c === "y") {
      let g = o.y[0].invertExtent(t.y, i.y).sort((d, f) => d - f);
      g = a.subtype() === "temporal" && a.as() !== oe ? g.map((d) => d.getTime()) : g;
      const h = a.getMembers(), u = {};
      return h.forEach((d) => {
        u[d] = g;
      }), { range: u };
    } else if (r.isContinuous() && a.isContinuous()) {
      const g = {
        x: o.x[0].invertExtent(t.x, i.x).sort((u, d) => u - d),
        y: o.y[0].invertExtent(t.y, i.y).sort((u, d) => u - d)
      }, h = {};
      if (`${r}` == `${a}`) {
        const u = g.x, d = g.y, f = u[0] > d[0] ? d : u, I = f === d ? u : d;
        f[1] < I[0] ? h[r] = [] : h[r] = [I[0], f[1] < I[1] ? f[1] : I[1]];
      } else
        r.getMembers().forEach((f) => {
          h[f] = g.x;
        }), a.getMembers().forEach((f) => {
          h[f] = g.y;
        });
      return { range: h };
    } else if (r.isDiscrete() || a.isDiscrete()) {
      const g = this.getPointsWithinRange({
        minX: t.x,
        minY: t.y,
        maxX: i.x,
        maxY: i.y
      }), h = [[]];
      return l.forEach((u) => {
        h[0].push(`${u}`);
      }), g.forEach((u) => {
        const d = u.data, f = [];
        l.forEach((I) => {
          f.push(d[I]);
        }), h.push(f);
      }), {
        dimensions: h
      };
    }
    return null;
  }
  getPointsWithinRange(t) {
    return this.layers().filter(
      (n) => n.config().interactive !== !1
    ).map((n) => n.getPointsWithinRange(t)).flat();
  }
  isSortedDomain() {
    return this.layers().some((t) => t.isSortedDomain());
  }
  getRetinalFieldsDomain() {
    const t = this.layers().map(
      (n) => n.getRetinalFieldsDomain()
    );
    return _g(t);
  }
  calculateExtendDomainDiffs() {
    const t = {
      topAxis: [],
      bottomAxis: [],
      leftAxis: [],
      rightAxis: []
    };
    let i, n;
    if (this.layers().forEach((A) => {
      const s = A.axes();
      if (s.x && s.y) {
        const o = s.x.config().alignZeroLine, r = s.y.config().alignZeroLine, a = s.x.config().orientation, l = s.y.config().orientation, { x: c, y: g } = A.calculateExtendDomainDiffs();
        i = i == null ? o || !1 : i && o, n = n == null ? r || !1 : n && r, a === "top" ? t.topAxis.push(c) : t.bottomAxis.push(c), l === "left" ? t.leftAxis.push(g) : t.rightAxis.push(g);
      }
    }), i || n) {
      const A = {};
      return i ? (A.topAxis = yi(
        t.topAxis.concat(t.bottomAxis)
      ), A.bottomAxis = A.topAxis.slice()) : (A.topAxis = yi(t.topAxis), A.bottomAxis = yi(t.bottomAxis)), n ? (A.leftAxis = yi(
        t.leftAxis.concat(t.rightAxis)
      ), A.rightAxis = A.leftAxis.slice()) : (A.leftAxis = yi(t.leftAxis), A.rightAxis = yi(t.rightAxis)), A;
    } else
      return {
        topAxis: yi(t.topAxis),
        bottomAxis: yi(t.bottomAxis),
        leftAxis: yi(t.leftAxis),
        rightAxis: yi(t.rightAxis)
      };
  }
  setCustomLayerData(t) {
    this._customLayerDataModels = t;
  }
  clearCustomLayerData() {
    return this._customLayerDataModels = null, this;
  }
  layers(...t) {
    return t.length ? (this._layers = t[0], this) : this._layers;
  }
  transform(...t) {
    return t.length ? (this._transform = t[0], this) : this._transform;
  }
  layerDef(...t) {
    return t.length ? (this._layerDef = zf(t[0]), this.triggerListener("layerDef", this._prevLayerDef, this._layerDef), this) : this._layerDef;
  }
  width(...t) {
    return t.length ? (this._width = t[0], this) : this._width;
  }
  height(...t) {
    return t.length ? (this._height = t[0], this) : this._height;
  }
  setSize(t, i) {
    this.width(t), this.height(i), this._createGridLinesAndBands = this.createGridLinesAndBands();
  }
  transformedData(...t) {
    return t.length ? (this._transformedData = t[0], this) : this._transformedData;
  }
  config(...t) {
    if (t.length) {
      const i = this._config, n = t[0], A = tt(
        i || tt({}, mW),
        n
      );
      return this.renderer() === "html" && (A.gridLines.show = !1, A.gridBands.show = !1), this._prevconfig = i, this._config = A, this.triggerListener("config", i, this._config), this;
    }
    return this._config;
  }
  data(...t) {
    if (t.length) {
      let i = this._data;
      this._data = t[0];
      const n = this._data;
      if (this._prevdata = i, this._cache) {
        const A = this.cachedData();
        this.cachedData([...A, n]);
      } else {
        const A = this.cachedData()[0];
        A && A.unsubscribe("propagation"), this.cachedData([n]);
      }
      return this.triggerListener("data", this._prevdata, this._data), this;
    }
    return this._data;
  }
  triggerListener(t, i, n) {
    this._locked || this._listeners[t](i, n);
  }
  triggerAllListeners(t) {
    const i = this._listeners;
    for (let n in i)
      i[n](this[`_prev${n}`], this[`_${n}`], t);
  }
  createGridLinesAndBands() {
    let t = null, i = null, n = null;
    return () => {
      uW(this, {
        gridLinesSelection: t,
        gridBandsSelection: i
      }), n = dW(this, n), t = this._gridLinesSelection, i = this._gridBandsSelection;
    };
  }
  layerDataModels(...t) {
    return t.length ? (this._layerDataModels = t[0], this) : this._layerDataModels;
  }
  layerDomains(...t) {
    return t.length ? (this._layerDomains = t[0], this) : this._layerDomains;
  }
  isCanvasDisposed() {
    return this._canvasHelpers.isDisposed();
  }
}
class $E {
  /**
   *
   *
   * @memberof Variable
   */
  type() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   *
   *
   * @memberof Variable
   */
  toString() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  varType() {
    return null;
  }
}
class ah extends $E {
  /**
   * Creates an instance of ComposeVars.
   *
   * @param {Array} vars Array of SimpleVars.
   */
  constructor(...t) {
    super(), this.vars(t);
  }
  varType() {
    return HI;
  }
  vars(...t) {
    return t.length ? (this._vars = t[0], this) : this._vars;
  }
  as(t) {
    return t ? (this.vars().forEach((i) => i.as(t)), this) : this.vars()[0].as();
  }
  data(...t) {
    return t.length ? (this.vars().forEach((i) => i.data(t[0])), this._data = t[0], this) : this._data;
  }
  /**
   * Get all the field names from composed variable instance.
   *
   * @public
   * @return {Array} Array of field names.
   */
  getMembers() {
    return this.vars().map((i) => i.getMembers()[0]);
  }
  /**
   * Type of field associated with this composed variable.
   *
   * @return {string} Type of variable (Measure/Dimension).
   */
  type() {
    return this.vars()[0].type();
  }
  toString() {
    return this.vars().map((t) => t.toString()).join(",");
  }
  /**
   * Returns the number formatter function of the variable.
   *
   * @return {Function} Number formatter function of the variable.
   */
  numberFormat() {
    return this.vars()[0].numberFormat();
  }
  format(t) {
    return this.vars()[0].format(t);
  }
  getSchemaDef() {
    return this.vars()[0].getSchemaDef();
  }
  /**
   * Returns the subtype of the fields associated with this variable instance.
   *
   * @public
   * @return {string} Subtype of the variable.
   */
  subtype() {
    return this.vars()[0].subtype();
  }
  /**
   * Returns the consecutive minimum difference of the field values.
   *
   * @public
   * @return {number} Minimum consecutive difference.
   */
  getMinDiff() {
    return this.vars()[0].getMinDiff();
  }
  /**
   * Returns the display name of the fields.
   *
   * @return {string} returns the display name.
   */
  displayName() {
    return this.vars().map((t) => t.displayName()).join(",");
  }
  isContinuous() {
    return this.as() === "continuous";
  }
  isDiscrete() {
    return this.as() === "discrete";
  }
  has(t) {
    return this.getMembers().find((i) => `${i}` === t);
  }
}
class XE extends $E {
  /**
   * Creates an instance of simple variable instance.
   *
   * @param {string} name Field name.
   * @param {as} name Field will used as discrete or continuous.
   */
  constructor(t, i) {
    super(), this.oneVar(t), this.as(i);
  }
  varType() {
    return BD;
  }
  /**
   * Gets the field name associated with this variable instance.
   *
   * @public
   * @return {string} Name of the field.
   */
  oneVar(...t) {
    return t.length ? (this._oneVar = t[0], this) : this._oneVar;
  }
  as(t) {
    return t ? (this._as = t, this) : this._as;
  }
  data(...t) {
    return t.length ? (this._data = t[0], this) : this._data;
  }
  toString() {
    return this._oneVarString || (this._oneVarString = this.oneVar()), this._oneVarString;
  }
  /**
   * Gets the number formatter function of this variable.
   *
   * @public
   * @return {Function} Number formatter function.
   */
  numberFormat() {
    return this.type() === "measure" ? this.data().getField(this.oneVar()).schema().format : (t) => t;
  }
  format(t) {
    const { FieldSubtype: i, DateTimeFormatter: n } = J;
    if (t && this.subtype() === i.TEMPORAL) {
      const A = this.data().getField(this.oneVar()).schema().format;
      if (typeof A == "function")
        t = t.map((s) => A(s));
      else {
        const s = new n(A);
        t = t.map((o) => s.getNativeDate(o));
      }
    }
    return t;
  }
  /**
   * Returns a formatter function which transforms the input value to its original form.
   *
   * @public
   * @return {Function} Returns raw formatter function.
   */
  rawFormat() {
    const { FieldSubtype: t } = J;
    if (this.subtype() === t.TEMPORAL) {
      const i = this.data().getField(this.oneVar()).schema().format;
      return (n) => js(n, i);
    }
    return (i) => i;
  }
  /**
   * Return the field names associated with this variable instance.
   *
   * @public
   * @return {Array} Array of fields.
   */
  getMembers() {
    return [this.oneVar()];
  }
  /**
   * Returns the type of the variable. Whether it is measure or dimension.
   *
   * @public
   * @return {string} Type of variable.
   */
  type() {
    const t = this.data().getField(this.oneVar());
    if (!t)
      throw new Zi(`Field '${this.oneVar()}' not found in DataModel`, {
        cause: "Trying to read the type of a field that does not exist in DataModel schema"
      });
    return t.type();
  }
  /**
   * Returns the subtype of the variable. Subtype can be categorical or temporal. If no subtype is found, then it
   * returns the type of the variable.
   *
   * @public
   * @return {string} Subtype of variable.
   */
  subtype() {
    const t = this.data().getField(this.oneVar());
    return t.subtype() || t.type();
  }
  /**
   * Returns the minimum consecutive difference between the data values of this variable.
   *
   * @return {number} Minimum consecutive difference.
   */
  getMinDiff() {
    return this.data().getFieldspace().fieldsObj()[this.oneVar()].minimumConsecutiveDifference();
  }
  /**
   * Returns true if two variable instances are same.If both variable has the same field names, they are equal.
   *
   * @return {Boolean} Whether two variable instances are same.
   */
  equals(t) {
    return this.oneVar() === t.oneVar();
  }
  /**
   * Returns the display name of the field.
   *
   * @return {string} returns the display name.
   */
  displayName() {
    return pl(this.data(), this.oneVar());
  }
  /**
   * Returns the schema defination of the field.
   *
   * @return {Object} schema def
   */
  getSchemaDef() {
    return this.data().getField(this.oneVar()).schema();
  }
  isContinuous() {
    return this.as() === "continuous";
  }
  isDiscrete() {
    return this.as() === "discrete";
  }
  has(t) {
    return this.getMembers().find((i) => `${i}` === t);
  }
  getBinSize() {
    return this.subtype() === it.BINNED ? this.data().getField(this.oneVar()).getBinSize() : null;
  }
}
class db extends XE {
  type() {
    return "measure";
  }
  subtype() {
    return "continuous";
  }
  varType() {
    return mD;
  }
}
const hn = (e) => e instanceof db, { SCALES: tB } = wD, lh = (e) => e.filter((t) => t.as() === tB.DISCRETE), ch = (e) => e.filter((t) => t.as() === tB.CONTINUOUS), fb = (e, t) => {
  const i = [], n = [], A = Math.max(e.length, t.length);
  for (let s = 0; s < A; s++) {
    let o = e[s], r = t[s];
    hn(o) && hn(r) || (o && i.push(o), r && n.push(r));
  }
  return [i, n];
}, xW = (e) => {
  const t = e[0], i = e[1];
  let n = ch(t), A = ch(i);
  const s = lh(t), o = lh(i);
  [n, A] = fb(
    n,
    A
  );
  const r = [];
  return n.length + A.length ? (r[0] = [...s, ...o, ...n], r[1] = [...A]) : (r[0] = s, r[1] = o), r;
}, SW = (e) => {
  const t = e[0], i = e[1];
  let n = ch(t), A = ch(i);
  const s = lh(t), o = lh(i), r = [];
  return [n, A] = fb(
    n,
    A
  ), n.length + A.length ? (r[0] = [...s, ...o, ...n], r[1] = [...A]) : (r[0] = [
    ...s,
    ...o.slice(0, o.length - 1)
  ], r[1] = [
    ...o.slice(
      o.length - 1,
      o.length
    )
  ]), r;
}, MW = (e, t) => {
  const i = [];
  return Array.isArray(e[0]) ? (i[0] = e[0] || [], i[1] = e[1] || []) : (i[0] = t === "column" ? [] : e, i[1] = t === "column" ? e : []), i;
}, $p = (e, t) => {
  const i = [];
  let n;
  return e.forEach((A) => {
    if (n = A && (A.field || A), n === null)
      i.push(new db(null, tB.CONTINUOUS));
    else if (n instanceof ah) {
      const s = Ve(
        t.model.getField(n.vars()[0].oneVar())
      );
      n.as(s), n.data(t), i.push(n);
    } else {
      let s;
      typeof A == "string" ? (n = A, s = Ve(t.model.getField(A))) : (n = A.field, s = typeof A.as == "string" ? A.as : Ve(t.model.getField(A.field))), i.push(new XE(n, s).data(t));
    }
  }), i;
}, Xp = (e, t, i) => {
  const n = MW(t, e), A = [
    $p(n[0], i),
    $p(n[1], i)
  ];
  return e === "row" ? xW(A) : SW(A);
}, _W = (e, { rows: t, columns: i }) => ({
  rows: Xp("row", t, e),
  columns: Xp("column", i, e)
}), bW = (e, t) => {
  if (t)
    for (let i = 0; i < e.length; i++)
      i !== 0 ? e[i].config({
        externalClassname: [`${Ke}`]
      }) : e[i].config({
        externalClassname: [`${dA}-${le}`, `${Ke}`]
      });
  else
    for (let i = 0; i < e.length; i++)
      for (let n = 0; n < e[0].length; n++)
        e[i][n].config({
          externalClassname: [`${Ke}`]
        });
}, { POLAR: NW } = Xo, { DISCRETE: t0, CONTINUOUS: tI } = lt, eI = (e) => [...e[0], ...e[1]].reduce((t, i) => (i.as() === tI && (t = !0), t), !1), Ib = (e) => {
  const t = {};
  return [
    dM,
    fM,
    IM,
    "autoGroupBy",
    "useUTC"
  ].forEach((n) => {
    e[n] !== void 0 && (t[n] = e[n]);
  }), t;
}, Cb = (e) => {
  let t = !1;
  return t = Object.keys(e).some((n) => e[n].length > 0), t;
}, Eb = (e, t, i) => {
  let n = "";
  if (t === i - 1 && e.length > i) {
    for (let A = t; A < e.length - 1; A++)
      n += `${e[A].toString()} / `;
    return n += e[e.length - 1].toString(), n;
  } else if (e[t])
    return e[t].toString();
  return "";
}, iI = (e, t, i, { classPrefix: n, labelManager: A, sanitizeCheck: s }) => {
  const o = e.length > 0 ? e[0].map(
    (r, a) => new i(
      {
        type: CM,
        className: `${n}-grid-headers`
      },
      {
        labelManager: A
      }
    ).source(Eb(t, a, e[0].length)).config({ show: r.config().show })
  ) : [];
  return s && bW(o, !0), o;
}, nI = (e = {}) => {
  const { isBorderPresent: t } = e;
  return !t || [
    "color",
    "showRowBorders",
    "showColBorders",
    "showValueBorders"
  ].every((n) => !t[n]);
}, AI = (e = {}, t) => {
  const [i, n] = ["row", "column"].map((A) => {
    const s = {};
    return Object.keys(e[A].fields || {}).map((o) => {
      e[A].fields[o] && e[A].fields[o].formatter && (s[o] = {
        format: qo(
          e[A].fields[o].formatter,
          t
        )
      });
    }), {
      format: qo(
        e[A].formatter,
        t
      ),
      fields: s
    };
  });
  return {
    row: i,
    column: n,
    format: qo(e.formatter, t)
  };
}, e0 = (e, t) => {
  const { generateHref: i } = e;
  return i ? (n, A, s) => {
    let o = i(
      {
        formattedValue: A,
        rawValue: n
      },
      {
        fieldName: s,
        dateTimeFormatter: J.DateTimeFormatter.formatAs,
        dataModel: t
      }
    );
    const [r, a, l] = e.sanitizeHyperlink ? t.sanitiseStrings([
      o.target,
      o.rel,
      o.url
    ]) : [o.target, o.rel, o.url], c = l || A;
    return {
      target: r || Hs,
      rel: a || Ps,
      url: e.encode ? encodeURI(c) : c,
      classNames: o.classNames ? o.classNames : Js,
      styles: o.styles ? o.styles : Ys
    };
  } : null;
}, i0 = (e, t) => {
  const { generateHref: i } = e;
  if (!i)
    return {
      target: Hs,
      rel: Ps,
      url: DD,
      classNames: Js,
      styles: Ys
    };
}, sI = (e = {}, t) => {
  const [i, n] = ["row", "column"].map((A) => {
    const s = {};
    return Object.keys(e[A].fields || {}).map((o) => {
      e[A].fields[o] && e[A].fields[o].hyperlink && e[A].fields[o].hyperlink.enabled && (s[o] = {
        format: e0(
          e[A].fields[o].hyperlink,
          t
        ),
        hyperlink: i0(
          e[A].fields[o].hyperlink
        )
      });
    }), {
      format: e[A]?.hyperlink?.enabled && e[A]?.hyperlink?.generateHref ? e0(
        e[A]?.hyperlink,
        t
      ) : null,
      hyperlink: e[A]?.hyperlink?.enabled && e[A]?.hyperlink?.generateHref ? i0(
        e[A]?.hyperlink
      ) : null,
      fields: s
    };
  });
  return {
    row: i,
    column: n
  };
}, gh = (e, t, i) => {
  const n = i.getField(t).schema();
  let A;
  if (n.subtype === J.FieldSubtype.TEMPORAL)
    A = J.isInvalid(e) ? e : js(e, n.format);
  else if (n.subtype === J.FieldSubtype.BINNED) {
    if (e = qn(e), typeof e == "string")
      return e;
    A = J.isInvalid(e) ? e : _r([
      e,
      e + i.getField(t).getBinSize()
    ]);
  } else
    A = e;
  return Ei(A);
}, qo = (e, t) => e ? (i, n, A) => e(
  {
    formattedValue: gh(
      i,
      n,
      t
    ),
    rawValue: i
  },
  {
    fieldName: n,
    dateTimeFormatter: J.DateTimeFormatter.formatAs,
    dataPath: A,
    dataModel: t
  }
) : (i, n) => gh(i, n, t), Bb = (e, t) => {
  let i = null;
  return [UA, OA, Ts].forEach((n) => {
    globalThis.store.get(n) && e === globalThis.store.get(n)[0] && (i = n);
  }), i ? { channel: i } : ([Ai, gs].forEach((n) => {
    t[`${n}Facets`].forEach((A) => {
      A.toString() === e && (i = { channel: BE, type: n === gs ? xl : Ai });
    });
  }), i || ([Ai, gs].forEach((n) => {
    t[`${n}Projections`].forEach((A) => {
      A.forEach((s) => {
        s.toString() === e && (i = n === gs ? wl : yu);
      });
    });
  }), i ? { channel: i } : null));
}, mb = (e, t, i) => {
  let n = qg;
  const A = e.getField(t);
  return A && ((i || Ve(A)) === lt.CONTINUOUS ? n = IE : n = qg), n;
}, Qb = () => new EN(), oI = (e, t, i) => {
  let n = i[e], A = "";
  const s = e === Ai ? [le, De] : [Zt, re], [o, r] = t, a = (c) => o.length ? o[c].type() : null, l = (c) => r.length ? r[c].type() : null;
  return a(o.length - 1) === Bs && l(0) === Bs ? (A = n ? s[1 - s.indexOf(n)] : s[1], e === xl && o[o.length - 1].toString() === r[0].toString() ? n = re : n = n || s[0]) : l(r.length - 1) === Bs ? (A = e === Ai ? De : Zt, n = e === Ai ? De : Zt) : (A = e === Ai ? le : re, n = e === Ai ? le : re), a(o.length - 1) === _o && l(0) === _o ? n = e === Ai ? le : re : l(0) === _o ? n = e === Ai ? De : Zt : a(o.length - 1) === _o && (n = e === Ai ? le : re), [A, n];
}, FW = (e, t, { cellRenderer: i, topColumns: n, bottomColumns: A }) => {
  const s = {
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  };
  return e.length > 1 || t.length > 1 ? (s.top = !0, s.bottom = !0, s.left = !0, s.right = !0) : i === "html" && (s.top = !!n.length, s.bottom = !!A.length, s.left = !0, s.right = !0), s;
}, RW = (e, t, { cellRenderer: i, leftRows: n }) => {
  const A = {
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  };
  if (e.length || t.length) {
    if (e[0] && e[0].length > 1 || t[0] && t[0].length > 1)
      A.top = !0, A.bottom = !0, A.left = !0, A.right = !0;
    else if (i === "html") {
      A.top = !0, A.bottom = !0, A.left = !!n.length, A.right = !0;
    }
  }
  return A;
}, kW = (e, t, i) => {
  const n = { top: !0, left: !0, bottom: !0, right: !0 }, A = [le, De], s = [re, Zt];
  return e.forEach((o, r) => {
    o[0] && o[0].length ? n[A[r]] = !(!i.showYAxesLine && o.length === 1) : n[A[r]] = !1;
  }), t.forEach((o, r) => {
    o.length ? n[s[r]] = !(!i.showXAxesLine && o.length === 1) : n[s[r]] = !1;
  }), n;
}, rI = (e, t, i) => {
  let n = { top: !1, bottom: !1, left: !1, right: !1 }, A = { top: !1, bottom: !1, left: !1, right: !1 }, s = {
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  };
  const { rows: o, columns: r, values: a, cellRenderer: l } = e, [c, g] = o, [h, u] = r, { rows: d, columns: f } = t.fieldInfo(), I = [
    ...d.flat().filter((B) => B.as() === t0),
    ...f.flat().filter((B) => B.as() === t0)
  ].length, C = [
    ...d.flat().filter((B) => B.as() === tI),
    ...f.flat().filter((B) => B.as() === tI)
  ].length, E = [
    ...d.flat().filter((B) => B.subtype() === Br),
    ...f.flat().filter((B) => B.subtype() === Br)
  ].length;
  if (t.constructor.type() === NW) {
    if (!I)
      return { showRowBorders: n, showColBorders: A, showValueBorders: s };
  } else if (!C && !E && l !== "html" && I <= 2)
    return { showRowBorders: n, showColBorders: A, showValueBorders: s };
  return n = FW(c, g, {
    cellRenderer: l,
    topColumns: h,
    bottomColumns: u
  }), A = RW(h, u, {
    cellRenderer: l,
    leftRows: c,
    rightRows: g
  }), s = kW(
    [c, g],
    [h, u],
    i
  ), a.length > 1 && (s.top = !0, s.bottom = !0), a.length && (a[0].length > 1 || l === "html") && (s.left = !0, s.right = !0), { showRowBorders: n, showColBorders: A, showValueBorders: s };
}, eB = (e) => {
  const t = e.map((n) => n.encoding || {}), i = [].concat(
    ...t.map((n) => Object.values(n).flatMap((A) => {
      const s = typeof A == "object" ? A.field : A;
      return Array.isArray(s) ? s : [s];
    }))
  );
  return [...new Set(i.filter((n) => n))];
}, pb = (e, t) => {
  const i = Object.values(e).map((n) => {
    const A = [].concat(...n);
    return [].concat(...A);
  });
  return [].concat(...i, ...t);
}, yb = (e, t) => {
  for (let i = 0; i < e.length; i++) {
    const n = e[i];
    Array.isArray(n) ? t.push(n) : yb(n.values, t);
  }
}, aI = (e) => {
  const t = ox({
    data: e,
    keys: e[0].map((n, A) => A)
  }), i = [];
  return yb(t, i), i;
}, TW = (e) => {
  e.autoSort.disabled && Object.keys(e).forEach((t) => {
    t !== "autoSort" && delete e[t];
  });
}, Db = (e, t, i) => {
  let n;
  const A = i.data(), { suppliedLayers: s, facetsAndProjections: o, globalConfig: r } = t, a = r.autoGroupBy;
  A instanceof J && A.dispose();
  const l = e.getDimensions(), c = eB(s).filter(
    (I) => l.includes(I)
  ), g = Array.from(pb(o, c)), h = [
    ...new Set(
      g.flatMap(
        (I) => I instanceof $E ? I.getMembers() : I
      )
    )
  ], u = e.project(
    e.getFieldNames().filter((I) => I !== St.ROW_ID)
  );
  if (i.data(u), a.disabled)
    n = u;
  else {
    const I = h.filter(
      (D) => e.isDimension(D)
    ), C = a.measures, E = e.getMeasures(), B = Ql(
      e,
      E
    ), m = tt(B, C), y = Object.keys(m).map((D) => ({
      aggn: m[D],
      field: D
    }));
    n = u.groupBy(I, y);
  }
  const d = r.sort;
  TW(d);
  const f = Object.entries(d).filter(
    (I) => I[0] !== "autoSort"
  );
  return n = n.sort(f), i.transformedData(n), n;
}, Ba = (e, t) => e.filter((i) => i.as() === t).map((i) => i.getMembers()).flat(), wb = (e) => {
  const t = Ba(
    e.colProjections,
    "discrete"
  ), i = Ba(
    e.rowProjections,
    "discrete"
  ), n = e.optionalProjections.filter((r) => r.as === "discrete").map((r) => r.field), A = Ba(
    e.colProjections,
    "continuous"
  ), s = Ba(
    e.rowProjections,
    "continuous"
  ), o = e.optionalProjections.filter((r) => r.as === "continuous").map((r) => r.field);
  return {
    discreteColumnProjections: t,
    discreteRowProjections: i,
    discreteOptionalProjections: n,
    continuousColumnProjections: A,
    continuousRowProjections: s,
    continuousOptionalProjections: o
  };
}, $c = {
  getRowHeaderSortingHook(e) {
    return (i, n) => {
      const A = e._matrix.row(), s = A._axisFields.flat(), o = A._facetFields.flat();
      let r = {};
      s.find((a) => `${a}` == `${i.field}`) ? r = {
        axes: {
          y: {
            fields: {
              [i.field]: {
                ordering: n === "clearSort" ? null : {
                  type: "alphabetical",
                  direction: n === "sortAscending" ? "asc" : "desc"
                }
              }
            }
          }
        }
      } : o.find((a) => `${a}` == `${i.field}`) && (r = {
        rows: {
          facets: {
            fields: {
              [i.field]: {
                ordering: n === "clearSort" ? null : {
                  type: "alphabetical",
                  direction: n === "sortAscending" ? "asc" : "desc"
                }
              }
            }
          }
        }
      }), e.context()._canvasHelpers.setCanvasConfig(r);
    };
  },
  getYAxisSortingHook(e) {
    return (t, i) => {
      const n = e._matrix.row()._axisFields.flat(), A = e._matrix.column()._axisFields.flat()[0];
      let s = null;
      n.find((o) => `${o}` == `${t.field}`) && (s = {
        axes: {
          x: {
            fields: {
              [A]: {
                ordering: i === "clearSort" ? null : {
                  type: "nested",
                  direction: i === "sortAscending" ? "asc" : "desc",
                  nested: {
                    field: {
                      name: e.units()[0][0].layers()[0].config().encoding.text.field
                    },
                    filters: [
                      ...t.facetPath,
                      {
                        field: t.field,
                        value: t.value
                      }
                    ]
                  }
                }
              }
            }
          }
        }
      }), s && e.context()._canvasHelpers.setCanvasConfig(s);
    };
  },
  getXAxisSortingHook(e) {
    return (t, i) => {
      const n = e._matrix.row()._axisFields.flat()[0], A = e._matrix.column()._axisFields.flat();
      let s = null;
      A.find((o) => `${o}` == `${t.field}`) && (s = {
        axes: {
          y: {
            fields: {
              [n]: {
                ordering: i === "clearSort" ? null : {
                  type: "nested",
                  direction: i === "sortAscending" ? "asc" : "desc",
                  nested: {
                    field: {
                      name: e.units()[0][0].layers()[0].config().encoding.text.field
                    },
                    filters: [
                      ...t.facetPath,
                      {
                        field: t.field,
                        value: t.value
                      }
                    ]
                  }
                }
              }
            }
          }
        }
      }), s && e.context()._canvasHelpers.setCanvasConfig(s);
    };
  }
}, xb = (e, {
  rowGrandTotalDataMatrix: t,
  greatGrandTotalDataMatrix: i,
  columnGrandTotalDataMatrix: n
}, A = "start", s = "end") => (i && t ? A === "start" ? e = [
  ...n.map((o, r) => s === "start" ? [...i[r], ...o] : [...o, ...i[r]]),
  ...e
] : e = [
  ...e,
  ...n.map((o, r) => s === "start" ? [...i[r], ...o] : [...o, ...i[r]])
] : A === "start" ? e = [
  ...n,
  ...e
] : e = [
  ...e,
  ...n
], e), Sb = (e, t, i = "start") => (i === "start" ? e = [
  ...e.map((n, A) => [
    ...t[A],
    ...n
  ])
] : e = [
  ...e.map((n, A) => [
    ...n,
    ...t[A]
  ])
], e), Mb = (e, t) => {
  const i = e.columns.totals.grandTotals;
  return i.enabled && i.position === "start" ? t : 0;
}, _b = (e, t) => {
  const i = e.rows.totals.grandTotals;
  return i.enabled && i.position === "start" ? t : 0;
}, vW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  extractFields: pb,
  extractUnitConfig: Ib,
  filterProjectionFields: Ba,
  findInGroup: Bb,
  getAxisType: mb,
  getBorders: rI,
  getColOffset: _b,
  getDefaultFormattedFacetLabel: gh,
  getDetailedProjectionInfo: wb,
  getEncoder: Qb,
  getFieldsFromSuppliedLayers: eB,
  getHeaderAxisFrom: oI,
  getHeaderText: Eb,
  getRowOffset: Mb,
  groupFacetKeys: aI,
  hasContinuousAxis: eI,
  hasOneField: Cb,
  headerCreator: iI,
  mergeColumnGrandTotalMatrices: xb,
  mergeRowGrandTotalMatrices: Sb,
  resolveFacetFormatters: AI,
  resolveFacetHyperlinkFormatters: sI,
  resolveSingleFacetFormatter: qo,
  sanitizeCheck: nI,
  sortingHooks: $c,
  transformDataModel: Db
}, Symbol.toStringTag, { value: "Module" })), GW = {
  layers: {},
  data: {},
  globalConfig: {}
};
class iB {
  constructor() {
    ge(this, GW);
  }
  createAxis() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  setCommonDomain() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  getLayerConfig() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  fieldInfo(...t) {
    return t.length ? (this._fieldInfo = tt(this._fieldInfo || {}, t[0]), this) : this._fieldInfo;
  }
  sanitizeFields(t, i) {
    return this.fieldInfo(_W(t, i)), this.fieldInfo();
  }
  axisFrom(...t) {
    return t.length ? (this._axisFrom = t[0], this) : this._axisFrom;
  }
  headerFrom(...t) {
    return t.length ? (this._headerFrom = t[0], this) : this.__headerFrom;
  }
  setAxisAndHeaders(t = {}, i) {
    const [n, A] = oI(Ai, i.rows, t), [s, o] = oI(xl, i.columns, t);
    return this.axisFrom({
      row: A,
      column: o
    }), this.headerFrom({
      row: n,
      column: s
    }), this;
  }
  getProjectionFields(t) {
    return eB(t);
  }
  hasMandatoryFields(t) {
    return Cb(t);
  }
}
const bb = {
  linear: $i,
  band: ee,
  temporal: kr,
  size: M5,
  color: mr,
  backgroundColor: mr,
  shape: N5
}, Yi = "All", n0 = (e, t, i, n, A, s, o, r) => {
  let a = [], l = [], c = !1;
  const g = t.length, h = t.findIndex((d) => d === r);
  for (let d = 0; d < g; d++) {
    const f = t[d], I = e.getValueAtIndex(f, 0);
    if (l.push(I), !c) {
      a.push(I);
      const C = o(a);
      d < g - 1 && C && (c = C, h >= 0 ? a = [
        ...a,
        ...new Array(h - d - 1).fill(Yi),
        e.getValueAtIndex(r, 0),
        ...new Array(g - (h + 1)).fill(Yi)
      ] : a = a.concat(new Array(g - (d + 1)).fill(Yi))), d === g - 1 && (c = !!C);
    }
  }
  const u = a.join(",");
  return i[u] === void 0 && (i[u] = s++, n.push(a)), A.push(l), {
    rowKey: a,
    allKeys: l,
    isCollapsed: c
  };
}, uo = (e, t) => e.map((i) => t.getValueAtIndex(i, 0)), A0 = (e) => e.map((t) => ({
  keyArr: t,
  joinedKey: t.join(",")
})), ia = (e) => e.getMembers(), LW = ({ name: e }) => e, UW = (e) => ae(e).flat(), s0 = (e, t, i) => e.map(
  () => Array.from(lr(t, i))
), o0 = (e, t) => J.isInvalid(e.data[0]) ? t : e.data[0], r0 = (e, t, i) => {
  const n = t(
    [...e.data[1].keys()],
    e.ancestors().map(({ data: [o] }) => o).reverse().filter((o) => o != null).map((o, r) => ({ field: i[r], value: o }))
  ), A = Symbol(), s = n.reduce((o, r, a) => (J.isInvalid(r) ? o.set(A, a) : o.set(r, a), o), /* @__PURE__ */ new Map());
  e.sort((o, r) => {
    const a = o0(o, A), l = o0(r, A);
    return s.get(a) - s.get(l);
  });
}, a0 = (e, t, i, n, A = {}) => {
  const { row: s = {}, column: o = {} } = A;
  t = aI(t), e = aI(e);
  const r = J.Invalid(), a = J.Invalid(), l = Uo(
    e,
    ...i.map((u, d) => (f) => J.isInvalid(f[d]) ? r : f[d])
  ), c = Uo(
    t,
    ...n.map((u, d) => (f) => J.isInvalid(f[d]) ? a : f[d])
  ), g = Mi(
    l,
    (u) => Array.isArray(u) && !Array.isArray(u[1]) ? u[1] : null
  ), h = Mi(
    c,
    (u) => Array.isArray(u) && !Array.isArray(u[1]) ? u[1] : null
  );
  return g.each((u) => {
    const { depth: d } = u;
    if (d < i.length) {
      const f = s[i[d]];
      f && r0(u, f, i);
    }
  }), h.each((u) => {
    const { depth: d } = u;
    if (d < n.length) {
      const f = o[n[d]];
      f && r0(u, f, n);
    }
  }), {
    treeRowKeys: g,
    treeColumnKeys: h
  };
}, OW = (e, t, i, { allRowHeaderKeys: n, allColumnHeaderKeys: A }) => {
  const s = e.map((o) => o.value).join("-");
  if (i === "row") {
    const o = t.findIndex(
      (r, a) => n[a].config?.sourceType !== "total" && r[0].rowFacetValues.join("-") === s
    );
    return t[o].map((r, a) => [o, a]);
  } else {
    const o = t[0].findIndex(
      (r, a) => A[a].config?.sourceType !== "total" && r.columnFacetValues.join("-") === s
    );
    return t.map((r, a) => [a, o]);
  }
}, HW = (e, { allRowHeaderKeys: t, allColumnHeaderKeys: i }, n) => {
  const A = e.map((r) => r.value).join("-");
  let s = -1, o = -1;
  return n === "row" ? t.forEach((r, a) => {
    const l = r.keys.slice(0, e.length).map((g) => `${g}`).join("-"), c = r.config?.sourceType === "total";
    l === A && !c && (s = s === -1 ? a : s, o = s !== -1 ? a : o);
  }) : i.forEach((r, a) => {
    const l = r.keys.slice(0, e.length).map((g) => `${g}`).join("-"), c = r.config?.sourceType === "total";
    l === A && !c && (s = s === -1 ? a : s, o = s !== -1 ? a : o);
  }), {
    startIndex: s,
    endIndex: o
  };
}, PW = (e, t, i) => {
  const n = {};
  return e.forEach((A) => {
    const s = A.mark === mM;
    return [A.def || A].flat().forEach((o) => {
      const r = {};
      ["x", "y"].forEach((a) => {
        const l = t[o.id], c = Bi.getLayerClass(o.mark), g = o.encoding[a], h = o.encoding[`${a}0`], { field: u, as: d, var: f } = g, I = h ? h.field : null, C = i.axes[a].fields || {}, { domain: E } = C[u] || {}, B = f && br(f) ? f.vars().some(
          (y) => y && I && y.toString() === I
        ) : !1, m = {
          layerEncodings: o.encoding,
          transform: o.transform,
          userDomain: E,
          encoding: a,
          fieldAs: d
        };
        if (s && I) {
          const y = [u, I].map((D) => c.getDomain(l, {
            ...m,
            field: D.toString(),
            hasRangedEncodingInValueAxis: !0
          }));
          r[a] = te(y, d);
        } else if (B) {
          const { domain: y } = C[f.vars().toString()] || {}, D = f.vars().map((Q) => c.getDomain(l, {
            ...m,
            userDomain: y,
            field: Q.toString(),
            hasRangedEncodingInValueAxis: B
          }));
          r[a] = te(D, d);
        } else
          r[a] = c.getDomain(l, {
            ...m,
            field: u
          });
      }), n[o.id] = r;
    }), A;
  }), n;
}, IA = (e, t) => e.map((i) => i.map((n) => {
  const { layerDataModels: A, layerConfig: s } = n, o = PW(
    s,
    A,
    t
  );
  return {
    ...n,
    layerDomainsById: o
  };
})), os = (e, t, i, n) => {
  const A = e.config();
  return i.map((s) => s.map((o) => {
    const {
      rowProjections: r,
      columnProjections: a,
      suppliedLayers: l,
      dataStore: c
    } = o, g = t.getResolvedEncodings(
      {
        rowFields: r,
        columnFields: a,
        dataStore: c
      },
      l || n,
      e.config(),
      e
    ), h = e.getAllRetinalEncodings(
      g.flatMap(
        ({ def: I }) => Array.isArray(I) ? I.map(({ encoding: C }) => C) : I.encoding
      )
    ), u = t.setRetinalFieldsInLayers(
      h,
      g
    ), d = {}, f = u.map((I) => ([I.def].flat().map((C) => {
      const E = e.transform(), B = C.mark, m = C.encoding, y = Bi.getLayerClass(B);
      W(m, "detail", "field") || (m.detail = tt({}, m.detail, {
        field: e.detail()
      }));
      const Q = y.getDefaultTransformConfig(
        C,
        c
      );
      C.transform = {
        ...Q,
        ...C.transform
      };
      const p = C.source, w = W(E, p) || p, x = A.autoGroupBy, S = zE(
        c,
        C,
        w,
        x
      );
      C.id = `${I.mark}-${Ut()}`, d[C.id] = hh(
        S,
        c
      );
    }), I));
    return {
      ...o,
      layerConfig: f,
      layerDataModels: d
    };
  }));
}, hh = (e, t) => e.project(
  t.getSchema().filter((i) => i.name !== St.ROW_ID).map((i) => i.name)
), l0 = (e, t) => J.isInvalid(e) && J.isInvalid(t) || e === t, c0 = (e, t) => {
  let i;
  return t.forEach((n) => {
    i = i ? i.find((A) => l0(A.data?.[0], n.value)) : e.find((A) => l0(A.data?.[0], n.value));
  }), i.leaves().map((n) => n.data[1] == null ? [] : n.data[1][0]) ?? [];
}, uA = (e) => {
  const {
    rows: {
      facets: t,
      totals: {
        grandTotals: {
          splitTotal: { field: i } = {},
          position: n
        } = {},
        subTotals: {
          text: A,
          splitTotal: { field: s } = {},
          position: o
        } = {},
        data: { totalString: r } = {}
      } = {}
    } = {},
    columns: {
      facets: a,
      totals: {
        grandTotals: {
          splitTotal: { field: l } = {},
          position: c
        } = {},
        subTotals: {
          text: g,
          splitTotal: { field: h } = {},
          position: u
        } = {},
        data: { totalString: d } = {}
      } = {}
    } = {}
  } = e;
  return {
    rowFacetsConfig: t,
    rowTotalsSplitField: i,
    rowSubTotalsText: A,
    colFacetsConfig: a,
    columnTotalsSplitField: l,
    columnSubTotalsText: g,
    columnTotalString: d,
    rowTotalString: r,
    rowGrandTotalsPosition: n,
    columnGrandTotalsPosition: c,
    colSubTotalsSplitField: h,
    rowSubTotalsSplitField: s,
    rowSubTotalsPosition: o,
    columnSubTotalsPosition: u
  };
}, g0 = {
  default: 2,
  facet: 1,
  table: 1
}, YW = {
  className: `${wu}-facet-header`
}, JW = tt(
  {},
  xr
), KW = {
  [re]: {
    [vf]: {
      [le]: 5,
      [De]: 5,
      [re]: 3,
      [Zt]: 2
    },
    [Gf]: [Lf]
  },
  [Zt]: {
    [vf]: {
      [le]: 5,
      [De]: 5,
      [re]: 5,
      [Zt]: 2
    },
    [Gf]: [Lf]
  }
}, WW = {
  dependencies: {},
  layerConfig: {},
  encoder: {},
  valueParser: {},
  data: {},
  transformedData: {},
  store: {}
}, { DISCRETE: h0 } = lt, VW = (e, t, i, n) => (e.forEach(({ type: A, domains: s }) => {
  const o = {
    primary: te(
      [
        ...s.filter(({ primary: r }) => r.domain.length).map(({ primary: r }) => r.domain)
      ],
      A
    ),
    secondary: te(
      [
        ...s.filter(({ secondary: r }) => r.domain.length).map(({ secondary: r }) => r.domain)
      ],
      A
    )
  };
  s.forEach(({ primary: r, secondary: a }) => {
    const { field: l, domain: c } = r, { field: g, domain: h } = a, u = W(i, "fields", l) || {};
    if ((u.uniformAxisDomains !== void 0 ? u.uniformAxisDomains : n) && (t[l] = te(
      [c, t[l] || []],
      A
    ), g && (t[g] = te(
      [h, t[g] || []],
      A
    ), i.alignZeroLine))) {
      let f = t[l][1], I = t[l][0], C = t[g][1], E = t[g][0];
      f = Number.isFinite(f) ? f : C, I = Number.isFinite(I) ? I : E, C = Number.isFinite(C) ? C : f, E = Number.isFinite(E) ? E : C, [f, I, C, E].some((m) => m !== 0 && !m) && (f = o.primary[1], I = o.primary[0], C = o.secondary[1], E = o.secondary[1]);
      const B = uN([f, C], [I, E]);
      t[l] = B[0], t[g] = B[1];
    }
  });
}), t), jW = (e, t, i) => {
  const { x: n, y: A } = e;
  let s = [], o = [];
  return n[0].type !== h0 ? s = u0(
    n,
    t.x,
    i
  ) : s = Ka(n, i), A[0].type !== h0 ? o = u0(
    A,
    t.y,
    i
  ) : o = Ka(A, i), {
    x: s,
    y: o
  };
}, u0 = (e, t, i) => {
  const n = {};
  VW(
    e,
    n,
    t,
    i
  );
  let A = [];
  return e.forEach(({ type: s, domains: o }) => {
    const r = o[0].primary.field, a = o[0].secondary.field, l = W(t, "fields", r) || {};
    if (l.uniformAxisDomains !== void 0 ? l.uniformAxisDomains : i)
      A.push([
        n[r],
        a ? n[a] : []
      ]);
    else {
      const g = o.map((f) => f.primary.domain), h = o.map((f) => f.secondary.domain), u = te(g, s), d = te(h, s);
      A.push([u, d]);
    }
  }), A;
}, d0 = (e, t) => e.length ? e.map((i, n) => {
  const A = t.length ? t[n] : [];
  return [...i, ...A];
}) : t, lI = (e, t, i, n) => {
  const { format: A, subtype: s } = t.getSchemaDef(), o = t.getMembers()[0];
  let r;
  return typeof i == "function" ? r = i(e, o) : i.fields[o] && typeof i.fields[o].format == "function" ? r = i.fields[o].format(e, o, n) : i.format ? r = i.format(e, o, n) : s === "temporal" && A ? r = js(e, A) : r = e, { formattedValue: r, rawValue: e };
}, Nb = (e, t, i) => {
  const n = t.getMembers()[0];
  let A;
  return i.fields[n] && typeof i.fields[n].format == "function" ? A = i.fields[n].format(
    e.rawValue,
    e.formattedValue,
    n
  ) : i.format && typeof i.format == "function" && (A = i.format(
    e.rawValue,
    e.formattedValue,
    n
  )), i.fields[n] && i.fields[n].hyperlink && (A = i.fields[n].hyperlink), A;
};
function f0(e, t, i) {
  const n = { fields: {}, ...e };
  return [t, i].forEach((A) => {
    Object.keys(A.fields || {}).forEach((s) => {
      const o = A.fields[s];
      n.fields[s] = {
        ...e.fields ? e.fields[s] : {},
        // IF headers.fields[k].show is false, then don't show header | ELSE IF
        // facets/axis.fields.show is not true, then show; and if false, don't
        show: e.fields[s] && e.fields[s].show === !1 ? !!e.fields[s] && e.fields[s].show : o && o.show !== void 0 ? o.show : A.show
      };
    });
  }), n;
}
class sA {
  constructor(t) {
    this._dependencies = t, this.config({});
  }
  // /**
  //  * Iterates through the two dimensional matrix array and calls the given callback function with the cell instance,
  //  * row index, column index and the matrix array.
  //  *
  //  * @param {Function} fn Callback function which will get called for every cell.
  //  */
  // each (fn) {
  //     const matrix = this.cells();
  //     matrix.forEach((row, rIndex) => {
  //         row.forEach((col, cIndex) => {
  //             fn(col, rIndex, cIndex, matrix);
  //         });
  //     });
  //     return this;
  // }
  config(...t) {
    return t.length ? (this._config = t[0], this) : this._config;
  }
  clear() {
    this._dependencies = {}, this.config({});
  }
}
const Fb = (e, t, i, n) => e.map(
  ({
    formattedValue: A,
    rawValue: s,
    key: o,
    sourceType: r = "normal",
    overrideConfig: a = {},
    metaInf: l,
    fieldName: c,
    hyperlinkInfo: g
  }) => {
    a.style = {
      ...a.labels ? a.labels.style : {},
      ...a.labels && a.labels.align ? {
        "text-align": a.labels.align
      } : {}
    };
    const h = new i.TextCell(
      {
        className: `${t.className} ${a.className}`,
        useExternalCSS: t.useExternalCSS,
        style: t.style,
        ...t.charsAcross ? { numChars: t.charsAcross } : {}
      },
      { labelManager: n }
    );
    return h.key(o || s).source(A).rawSource(s).config({
      ...t,
      ...a,
      metaInf: { ...l, sourceType: r, hyperlinkInfo: g },
      fieldName: c
    }), h;
  }
);
class qW extends sA {
  constructor(t) {
    super(t), this._cells = {
      left: [],
      right: []
    };
  }
  props(t) {
    this._props = t;
  }
  createPlaceHolders(t) {
    this._cells = {
      left: [],
      right: []
    };
    const {
      takeHeaderFrom: i,
      facet: n,
      facetFields: A,
      useExternalCSS: s,
      facetConfig: {
        labels: { style: o },
        hyperlink: r
      },
      facetsConfig: a,
      show: l,
      globalConfig: c
    } = this.config(), g = {
      ...o,
      ...a.labels.style,
      "justify-content": a.labels.align
    }, h = this.createHeaders(t, {
      ...n,
      facetFields: A,
      facetsConfig: a,
      useExternalCSS: s,
      style: g,
      show: l,
      className: `${this.config().className || ""} ${a.className || ""} ${n.className || ""}`,
      globalConfig: c,
      hyperlinkConfig: r
    });
    i === "left" ? this._cells.left = h : this._cells.right = h;
  }
  createHeaders(t, i) {
    const { cellRegistry: n, smartLabel: A } = this._dependencies, s = { ...i, type: Za }, { facetFields: o, facetsConfig: r } = i;
    return t = t.map(({ keys: a, config: l = {} }) => a.map((c, g) => {
      const h = o[g].toString(), u = W(r, "fields", h) || {}, d = tt(
        { ...l },
        tt({}, r),
        u
      );
      return d.className = `${r.className || ""} ${u.className || ""} ${l.className || ""}`, {
        ...c,
        fieldName: h,
        overrideConfig: {
          ...d,
          show: ft(d.show, !0)
        },
        metaInf: {
          type: Za,
          canvasHelpers: this.config().canvasHelpers,
          getDataPath: () => a.slice(0, g + 1).map((f, I) => {
            const C = o[I];
            let E = f.rawValue;
            return {
              field: C,
              value: E,
              sourceType: f.sourceType
            };
          })
        }
      };
    })), t.map((a) => Fb(a, s, n, A));
  }
  clear() {
    super.clear(), this._cells = {
      left: [],
      right: []
    };
  }
}
class zW extends sA {
  constructor(t) {
    super(t), this._cells = {
      top: [],
      bottom: []
    };
  }
  createPlaceHolders(t) {
    this._cells = {
      top: [],
      bottom: []
    };
    const {
      takeHeaderFrom: i,
      facet: n,
      facetFields: A,
      useExternalCSS: s,
      facetConfig: {
        labels: { style: o },
        charsAcross: r
      },
      facetsConfig: a,
      show: l
    } = this.config(), c = {
      ...o,
      ...a.labels.style,
      "justify-content": a.labels.align
    }, g = this.createHeaders(t, {
      ...n,
      facetFields: A,
      facetsConfig: a,
      useExternalCSS: s,
      style: c,
      show: l,
      charsAcross: r,
      className: `${this.config().className || ""} ${a.className || ""} ${n.className || ""}`
    });
    i === "top" ? this._cells.top = g : this._cells.bottom = g;
  }
  createHeaders(t, i) {
    const { cellRegistry: n, smartLabel: A } = this._dependencies, s = {
      ...i,
      type: Zg
    }, { facetFields: o, facetsConfig: r } = i;
    return t = t.map(({ keys: a, config: l = {} }) => a.map((c, g) => {
      const h = o[g].toString(), u = W(r, "fields", h) || {}, d = tt(
        { ...l },
        tt({}, r),
        u
      );
      return d.className = `${r.className || ""} ${u.className || ""} ${l.className || ""}`, d.labels.style = tt(
        tt({}, d.labels.style),
        {
          display: "flex",
          "justify-content": d.labels.align === le ? "flex-start" : d.labels.align === De ? "flex-end" : d.labels.align
        }
      ), {
        ...c,
        fieldName: h,
        overrideConfig: {
          ...d,
          show: ft(d.show, !0),
          verticalAlign: "middle"
        },
        metaInf: {
          type: Zg,
          canvasHelpers: this.config().canvasHelpers,
          getDataPath: () => a.slice(0, g + 1).map((f, I) => ({
            field: o[I],
            value: f.rawValue,
            sourceType: f.sourceType
          }))
        }
      };
    })), t.map((a) => Fb(a, s, n, A));
  }
  clear() {
    super.clear(), this._cells = {
      top: [],
      bottom: []
    };
  }
}
const { DISCRETE: I0 } = lt, uh = (e, t) => e.map(
  (i) => (
    // Create axis cell
    // @todo check why do we need to send configuration to axis cell from axisinstance
    ZW(
      i,
      i ? i.config() : {},
      t
    )
  )
), ZW = (e, t, i) => {
  const { orientation: n, show: A, renderer: s } = t;
  return e ? new i.AxisCell().source(e).config({
    isOffset: n === Se || n === ie,
    show: A,
    renderer: s
  }) : new i.BlankCell().config({ show: !1 });
}, $W = (e, t, i, n, A, s) => {
  const o = {
    fieldInstance: t,
    id: t.toString(),
    name: t.displayName(),
    field: t.toString(),
    fieldAs: t.as(),
    fieldType: t.type(),
    fieldSubtype: t.subtype(),
    numberFormat: t.numberFormat(),
    // tickFormat: field.getSchemaDef().format,
    orientation: i,
    useExternalCSS: n.useExternalCSS,
    useUTC: n.useUTC,
    renderer: n.renderer,
    isBold: n.isBold,
    isCompact: n.isCompact,
    isFacet: n.isFacet,
    isGrandTotalsEnabled: n[e === "x" ? "rows" : "columns"].totals.grandTotals.enabled,
    grandTotalFormatter: n[e === "x" ? "rows" : "columns"].totals.grandTotals.formatter
  };
  let r;
  n.renderer === "html" ? (o.labels = {
    rotation: 0,
    align: e === "x" && n.firstSuppliedTextLayerInfo != null ? n.firstSuppliedTextLayerInfo.as === Wg ? "right" : "left" : i === "left" ? "left" : "right"
  }, o.paddingInner = 0, o.paddingOuter = 0, r = `${n.classPrefix}-axis ${n.classPrefix}-pivot-table-axis`) : r = `${n.classPrefix}-axis ${n.classPrefix}-discrete-axis`;
  const a = W(n, "axes", e) || {}, l = W(a, "fields", t) || {};
  !a.tickFormat && !n.tickFormat && !l.tickFormat && o.field === `${s}` && (o.tickFormat = (h) => `${Math.trunc(h.formattedValue * 100)}%`), n.tickFormat && n.tickFormat[o.fieldAs] && (o.tickFormat = n.tickFormat[o.fieldAs]), typeof n == "function" && (n = n(t));
  let c = tt(
    o.tickFormat ? o : tt(o, a),
    l
  );
  n.renderer === "html" && (c.labels.rotation = 0), c.show = c.show !== !1;
  const g = c.className || A.className || "";
  return {
    ...c,
    ...A,
    className: r ? `${r} ${g}` : g
  };
}, Rb = (e) => {
  const t = e.as(), i = e.subtype();
  return i === Vg ? t === I0 ? qt : ui : t === I0 ? ee : i === Br ? kr : $i;
}, XW = (e, t, i, n, A = {}, s) => {
  let o = $W(
    e,
    t,
    i,
    n,
    A,
    s
  );
  const r = Rb(t);
  return e === wl && (r === ee || r === kr) && n.columnTitle && n.columnTitle.show && ("showAxisName" in o || (o = Object.assign(o, { showAxisName: !1 }))), o;
}, kb = (e, t, i, n, A, s = {}, o, r) => {
  const { smartLabel: a } = A, l = Rb(t);
  let c = XW(
    e,
    t,
    i,
    n,
    s,
    r
  );
  return c = tt({}, c, {
    ticks: {
      labels: {
        style: tt(
          {},
          BA(W(n.theme, "font")),
          BA(
            W(n.theme, "font", "components", "axis", "ticks")
          )
        )
      }
    },
    title: {
      style: tt(
        {},
        BA(W(n.theme, "font")),
        BA(
          W(n.theme, "font", "components", "axis", "name")
        )
      )
    }
  }), new l(
    c,
    { labelManager: a },
    o
  );
};
class tV extends sA {
  constructor(t) {
    super(t), this._cells = {
      top: [],
      bottom: []
    };
  }
  createAxisInstances(t, i, n, A, s) {
    return t.map(
      ({ field: r, config: a = {}, metaInf: l = {} }) => r && !hn(r) ? kb(
        wl,
        r,
        i,
        { ...n, ...a },
        this._dependencies,
        { ...a, metaInf: l },
        A(),
        s
      ) : null
    );
  }
  createPlaceHolders(t, i, n) {
    this._cells = {
      top: [],
      bottom: []
    };
    const {
      axisFrom: A,
      globalConfig: s,
      renderer: o,
      isBold: r,
      isCompact: a,
      tickFormat: l,
      show: c,
      firstSuppliedTextLayerInfo: g,
      interaction: h
    } = this.config(), {
      columnAxisInfo: { topAxisInfo: u, bottomAxisInfo: d }
    } = t;
    s.columnTitle = t.columnTitle;
    const f = tt(
      {},
      {
        axes: {
          x: {
            interaction: h
          }
        }
      },
      Object.assign(
        {},
        s,
        {
          isBold: r,
          isCompact: a,
          renderer: o,
          tickFormat: l,
          firstSuppliedTextLayerInfo: g,
          columnTitle: t.columnTitle
        },
        c != null ? { show: c } : {}
      )
    ), I = this.createAxisInstances(
      u,
      A === "bottom" ? "bottom" : "top",
      f,
      i,
      n
    ), C = this.createTopAxisCells(I), E = this.createAxisInstances(
      d,
      "bottom",
      s,
      i,
      n
    ), B = E.every((y) => !y), m = this.createBottomAxisCells(
      B ? [] : E
    );
    this._cells = {
      top: A === "bottom" ? m : C,
      bottom: A === "bottom" ? C : m
    };
  }
  createTopAxisCells(t) {
    return uh(t, this._dependencies.cellRegistry);
  }
  createBottomAxisCells(t) {
    return uh(t, this._dependencies.cellRegistry);
  }
  setDomains(t, i, n) {
    const { AxisCell: A } = this._dependencies.cellRegistry, { axisFrom: s } = this.config(), { top: o, bottom: r } = this._cells;
    let a = [];
    s === "top" ? a = [o, r] : a = [r, o];
    const l = {};
    a.forEach((c, g) => {
      c.forEach((h, u) => {
        if (!(h instanceof A))
          return;
        const d = h.source();
        let f = t[u][g];
        d.domain(f, n), l[`${u}-${g}`] = f;
      });
    }), i.commit(
      `${rr}.domain.x`,
      l
    );
  }
  clear() {
    super.clear(), this._cells = {
      top: [],
      bottom: []
    };
  }
  getCells() {
    return this._cells;
  }
}
class eV extends sA {
  constructor(t) {
    super(t), this._cells = {
      left: [],
      right: []
    };
  }
  dependencies(t) {
    this._dependencies = t;
  }
  createAxisInstances(t, i, n, A, s) {
    return t.map(
      ({ field: r, config: a = {}, metaInf: l = {} }) => r && !hn(r) ? kb(
        yu,
        r,
        i,
        n,
        this._dependencies,
        { ...a, metaInf: l },
        A(),
        s
      ) : null
    );
  }
  createPlaceHolders(t, i, n) {
    this._cells = {
      left: [],
      right: []
    };
    const {
      globalConfig: A,
      renderer: s,
      isBold: o,
      isCompact: r,
      tickFormat: a,
      show: l,
      interaction: c
    } = this.config(), {
      rowAxisInfo: { leftAxisInfo: g, rightAxisInfo: h }
    } = t;
    A.rowTitle = t.rowTitle;
    const u = tt(
      {},
      {
        axes: {
          y: {
            interaction: c
          }
        }
      },
      Object.assign(
        {},
        A,
        {
          isBold: o,
          isCompact: r,
          renderer: s,
          tickFormat: a,
          rowTitle: t.rowTitle
        },
        l != null ? { show: l } : {}
      )
    ), d = this.createAxisInstances(
      g,
      "left",
      u,
      i,
      n
    ), f = this.createLeftAxisCells(d), I = this.createAxisInstances(
      h,
      "right",
      u,
      i,
      n
    ), C = I.every((B) => !B), E = this.createRightAxisCells(
      C ? [] : I
    );
    this._cells = {
      left: f,
      right: E
    };
  }
  createLeftAxisCells(t) {
    return uh(t, this._dependencies.cellRegistry);
  }
  createRightAxisCells(t) {
    return uh(t, this._dependencies.cellRegistry);
  }
  setDomains(t, i, n) {
    const { AxisCell: A } = this._dependencies.cellRegistry, { left: s, right: o } = this._cells, r = {};
    [s, o].forEach((a, l) => {
      a.forEach((c, g) => {
        if (!(c instanceof A))
          return;
        const h = c.source();
        let u = t[g][l];
        h.domain(u, n), r[`${g}-${l}`] = u;
      });
    }), i.commit(
      `${rr}.domain.y`,
      r
    );
  }
  clear() {
    super.clear(), this._cells = {
      left: [],
      right: []
    };
  }
  getCells() {
    return this._cells;
  }
}
const Gd = `${wu}-column-guideline`, C0 = `${wu}-column-drag-pointer`, nB = "column-dimension-changer", AB = "column-header-tooltip", Qs = "toggle-sort-menu-btn", ps = "toggle-sort-dropdown", ys = "toggle-sort-tooltip", Xc = "row-cell-highlighter", tg = "col-cell-highlighter", Ds = "expand-collapse-effect", ws = "context-menu-effect", xs = "ctrl-click-effect";
class Tb extends $t {
  static formalName() {
    return nB;
  }
  apply(t, i, n) {
    const { dimensions: A, el: s } = this.firebolt.context.parentContainerInf(), o = i.showMarker;
    let r, a;
    if (i.targetData && i.targetElem) {
      const l = i.dimensions.x, c = j(
        s,
        "div",
        [1],
        `.${Gd}`
      );
      c.attr(
        "class",
        `${Gd} ${i.className || ""}`
      );
      const g = Wi(s);
      let {
        x: h,
        width: u,
        y: d
      } = Wi(i.targetElem);
      const f = i.resizeDelta == null ? n.draggableOutsideChart ? V("html").node().offsetWidth : g.x + g.width : h + u - g.x + Math.floor(i.resizeDelta);
      a = i.targetData.path.map((x) => ({
        field: x.field === null ? x.field : `${x.field}`,
        value: x.value,
        sourceType: x.sourceType
      }));
      const { minWidth: C } = this.firebolt.context._canvasHelpers.getMinTargetDimensions(
        a,
        i.isHeaderCell
      );
      h -= g.x;
      const E = Math.min(h + C || 0, h + u), B = i.markerPositionAtTarget ? h + u : Math.min(Math.max(l, E), f), m = d - g.y, y = A.height - (m - A.top), D = i.targetElem.closest(".muze-grid-bottom"), Q = this.firebolt.context._canvasHelpers.getMatrixDimensions().heights[0], p = D ? A.top + Q : m, w = this.firebolt.context._canvasHelpers.getMatrixDimensions().heights[2];
      Pt(c, {
        position: "absolute",
        transform: `translate(${B}px, ${p}px)`,
        width: "0px",
        height: `${D ? A.height - Q : y - w}px`
      }), r = B - h, i.updateColumnWidth && (this.firebolt.context._canvasHelpers.getColumnWidthState(
        n.widths,
        i.isHeaderCell
      ), this.firebolt.context.updateColumnWidths([
        {
          target: a,
          width: r
        }
      ]));
    }
    o || V(s).selectAll(`.${Gd}`).remove();
  }
}
const vb = (e) => e === "" || e === " ";
class Gb extends $t {
  constructor(...t) {
    super(...t), this._tooltipRenderer = null;
  }
  static formalName() {
    return AB;
  }
  apply(t, { tooltext: i, tooltipAnchorBox: n, rotation: A }) {
    i = J.isInvalid(i) ? i.value() : i, this._tooltipRenderer == null && (this._tooltipRenderer = new vl(document.body, {
      creatorName: "header-tooltip"
    }), this._tooltipRenderer.extent({
      x: 0,
      y: 0,
      width: this.firebolt.context.parentContainerInf().dimensions.width,
      height: this.firebolt.context.parentContainerInf().dimensions.height
    }), this._tooltipRenderer.config({
      content: {
        rowMargin: "0 10px 5px 10px",
        className: this.firebolt.context._className
      }
    })), vb(i) ? this._tooltipRenderer.hide() : (this._tooltipRenderer.content("tooltip", [{ data: [i] }]), A ? (this._tooltipRenderer.offset({
      x: -20,
      y: -20
    }), this._tooltipRenderer.position(
      n.x,
      n.y + n.height
    )) : (this._tooltipRenderer.offset({
      x: 0,
      y: 0
    }), this._tooltipRenderer.positionRelativeTo(n)));
  }
  dispose() {
    this._tooltipRenderer && this._tooltipRenderer.dispose();
  }
}
class Lb extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return Qs;
  }
  apply(t, { target: i, showMenuButton: n, isActive: A }) {
    cI(i, n, A);
  }
}
const cI = (e, t, i) => {
  const n = cE(e);
  if (!(n && n.node()))
    return;
  const A = n.datum();
  if (!A.directSortEnabled)
    return;
  const s = A.sortStatus;
  if (t ? n.classed("highlight", !0) : n.classed("highlight", !1), t = !!s || t, t && TS(e), !s) {
    iV(e, t);
    const o = i ? S3 : RS;
    n.select("img").attr("src", o);
  }
}, iV = (e, t) => {
  cE(e).style("display", t ? "flex" : "none");
}, E0 = "sortAscending", B0 = "sortDescending", m0 = "clearSort", nV = "asc", Q0 = "sort-active";
class Ub extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return ps;
  }
  apply(t, { data: i, anchorBox: n, target: A }) {
    let s = this.firebolt.context._sortDropdown;
    if (s == null) {
      const r = {
        menuItems: [
          {
            key: E0,
            label: "Sort ascending",
            onClick: this.onClickMenuItem.bind(this)
          },
          {
            key: B0,
            label: "Sort descending",
            onClick: this.onClickMenuItem.bind(this)
          },
          {
            key: m0,
            label: "Clear sort",
            onClick: this.onClickMenuItem.bind(this)
          }
        ],
        activeMenuItem: null
      };
      s = new E9(
        document.body,
        { contextName: "direct-sort" },
        r
      ), s.extent({
        x: 0,
        y: 0,
        width: this.firebolt.context.parentContainerInf().dimensions.width,
        height: this.firebolt.context.parentContainerInf().dimensions.height
      }), this.firebolt.context._sortDropdown = s;
    }
    if (!i) {
      this.onResetEffect();
      return;
    }
    this.firebolt.context.resetDirectSort(), s.metaInfo({ data: i }), s.offset({
      x: -5,
      y: 43
    }), s.positionRelativeTo(n);
    const { sortStatus: o } = i;
    if (o) {
      const r = o.sortInfo.direction === nV ? E0 : B0;
      s.content({
        activeMenuItem: r,
        disabledMenuItems: []
      });
    } else
      s.content({
        activeMenuItem: null,
        disabledMenuItems: [m0]
      });
    this.firebolt.context._activeSortTarget = A, A.classed(Q0, !0), cI(A, !0, !0);
  }
  onClickMenuItem(t, i) {
    const n = this.firebolt.context, {
      type: A,
      data: s,
      meta: o
    } = i.data.contextData, r = t.key;
    let a, l;
    if (A === rE) {
      const c = W(n.config().headers, "interaction");
      l = W(
        c,
        "directSortSelect",
        "sideEffects",
        "toggle-sort-dropdown",
        "hook"
      );
      const g = s.getDataPath(), h = g[g.length - 1];
      a = {
        field: h.field,
        value: h.field
      };
    } else if (A === aE || A === lE || A === xS || A === SS) {
      const { axisFieldName: c } = o, h = (n.getAxes() || []).find(
        (E) => E.config().field === c
      ).config().interaction;
      l = W(
        h,
        "directSortSelect",
        "sideEffects",
        "toggle-sort-dropdown",
        "hook"
      );
      const u = s.getDataPath(), d = u[u.length - 1], f = d.field.getMembers()[0], I = d.value, C = u.slice(0, u.length - 1).map((E) => ({
        field: E.field.getMembers()[0],
        value: Ee(E.value) ? null : E.value
      }));
      a = {
        field: f,
        value: Ee(I) ? null : I,
        facetPath: C
      };
    } else
      throw new Error(`Direct sort is not yet implemented for: ${A}`);
    l && l(a, r);
  }
  onResetEffect() {
    const { context: t } = this.firebolt;
    t._sortDropdown && t._sortDropdown.hide();
    const i = t._activeSortTarget;
    i && (i.classed(Q0, !1), cI(i, !1, !1), t._activeSortTarget = null);
  }
  dispose() {
    this.firebolt.context._sortDropdown && this.firebolt.context._sortDropdown.dispose();
  }
}
class Ob extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return ys;
  }
  apply(t, { showTooltip: i, currentSortStatus: n, tooltipAnchorBox: A }) {
    if (this._tooltipRenderer == null && (this._tooltipRenderer = new vl(document.body, {
      creatorName: ["direct-sort-tooltip", "header-tooltip"]
    }), this._tooltipRenderer.extent({
      x: 0,
      y: 0,
      width: this.firebolt.context.parentContainerInf().dimensions.width,
      height: this.firebolt.context.parentContainerInf().dimensions.height
    }), this._tooltipRenderer.config({
      content: {
        rowMargin: "0 10px 5px 10px",
        className: this.firebolt.context._className
      }
    })), !(i && n && n.sortInfo)) {
      this._tooltipRenderer.hide();
      return;
    }
    const s = this.genTooltipTextFromSortInfo(n);
    this._tooltipRenderer.content("tooltip", [{ data: [s] }]), this._tooltipRenderer.offset({
      x: 0,
      y: 0
    }), this._tooltipRenderer.positionRelativeTo(A);
  }
  genTooltipTextFromSortInfo(t) {
    const { sortInfo: i, targetField: n, metaInfo: A, formatterByFields: s } = t, { type: o, direction: r } = i, a = r === "asc" ? "ascending" : "descending";
    let l = "";
    if (o === "natural")
      l = `Sorted ${a} by data value`;
    else if (o === "alphabetical")
      l = `Sorted ${a} alphabetically`;
    else if (o === "nested") {
      const c = i.nested || {}, g = this.resolveFieldDisplayName(
        W(c, "field", "name")
      ), h = W(c, "field", "aggregation") || "SUM", u = W(c, "filters") || [], d = h.toUpperCase(), { field: f, value: I } = u[u.length - 1], C = this.resolveFieldDisplayName(n.name);
      l = `Sorted ${a} by ${d}(${g}) within ${C}`;
      const E = s[f] || ((B) => B);
      A.sourceType !== "total" && (l += `, based on ${E(I)}`);
    } else
      throw new Error(`Unsupported sort type: ${o}`);
    return l;
  }
  resolveFieldDisplayName(t) {
    const { context: i } = this.firebolt;
    t = t || "";
    const n = i._canvasHelpers.getFieldInfo(t);
    return n ? n.displayName() : t;
  }
  dispose() {
    this._tooltipRenderer && this._tooltipRenderer.dispose();
  }
}
const AV = (e, t, i = 4) => {
  const n = V(e.currentTarget).datum();
  let A, s, o, r, a = !1, l;
  if (W(n.placeholder, "type") === "text" || W(n.placeholder, "type") === "blank")
    s = e.currentTarget, o = n.placeholder.config().metaInf.getDataPath(), r = "facet", l = Og(s, e).x, a = !0;
  else if (W(n.placeholder, "type") === "axis")
    if (e.target.classList.value.includes("muze-ticks") && e.target.closest(".muze-pivot-table-axis")) {
      s = e.target;
      const c = V(s).datum();
      o = c.getDataPath(), r = "ticklabel", l = e.offsetX, a = c.isLastValueInDomain;
    } else
      s = e.currentTarget, o = n.placeholder.getDataPath(), r = "axis", a = !0, l = Og(s, e).x;
  if (s) {
    const c = s.getBoundingClientRect();
    let g = o;
    if (c.width - l <= i)
      A = {
        element: s,
        path: g,
        isLastCell: a
      };
    else if (l < i) {
      const h = V(e.currentTarget).datum().placeholder;
      let u;
      if (h.type === "text" || h.type === "blank" ? u = h.mount().previousElementSibling : u = t.context.getPreviousAxisElem({
        cell: h,
        axisElem: s
      }), u) {
        if (r === "ticklabel") {
          const d = V(u).datum();
          g = d.getDataPath(), a = d.isLastValueInDomain;
        } else
          r === "axis" ? (g = V(u).datum().placeholder.getDataPath(), a = !0) : g = V(u).datum().placeholder.getDataPath();
        A = {
          element: u,
          path: g,
          isLastCell: a
        };
      }
    }
  }
  return A;
}, Hb = (e) => (t) => {
  let i = !1, n, A, s = !1, o = !1;
  const r = "html", a = () => {
    V(r).classed(C0, !0);
  }, l = () => {
    V(r).classed(C0, !1);
  }, c = function() {
    if (i)
      return;
    const E = Bt();
    if (V(E.currentTarget).datum()) {
      const { path: m, element: y, isLastCell: D } = AV(E, e) || {};
      if (m) {
        n = {
          path: m
        }, A = y, a();
        const Q = e.context.parentContainerInf().el, p = Cs(Q, Bt()).x;
        D || (e.triggerPhysicalAction("columnDrag", {
          dimensions: {
            x: p
          },
          className: "muze-column-guideline-hover",
          targetData: n,
          showMarker: !0,
          markerPositionAtTarget: !0,
          targetElem: A
        }), o = !0), s = !0;
      } else
        l(), e.triggerPhysicalAction("columnDrag", {
          showMarker: !1,
          targetData: null
        }), s = !1;
    }
    E.preventDefault();
  }, g = () => {
    i || (l(), e.triggerPhysicalAction("columnDrag", {
      showMarker: !1,
      targetData: null
    }), o = !1, s = !1);
  };
  let h = null;
  const u = () => {
    if (i) {
      const E = e.context.parentContainerInf().el, B = Cs(E, Bt()).x, m = V(A).datum().placeholder == null || V(A).datum().placeholder._resizeDelta == null ? 1 / 0 : V(A).datum().placeholder._resizeDelta, y = V(A).datum().placeholder != null && V(A).datum().placeholder.config().type === "headerTitle";
      return e.triggerPhysicalAction("columnDrag", {
        dimensions: {
          x: B
        },
        resizeDelta: m,
        targetData: n,
        showMarker: !0,
        targetElem: A,
        isHeaderCell: y,
        className: "muze-column-guideline-drag"
      }), Bt().preventDefault(), B;
    }
  }, d = () => {
    s && (e.context._canvasHelpers.disableBehaviour(["highlight", "hover"]), e.context._canvasHelpers.disableLegendBehaviour([
      "highlight",
      "hover"
    ]), i = !0, h = u());
  }, f = () => {
    if (i) {
      const E = e.context.parentContainerInf().el, B = Cs(E, Bt()).x, m = V(A).datum().placeholder == null || V(A).datum().placeholder._resizeDelta == null ? 1 / 0 : V(A).datum().placeholder._resizeDelta, y = V(A).datum().placeholder != null && V(A).datum().placeholder.config().type === "headerTitle";
      e.triggerPhysicalAction("columnDrag", {
        showMarker: !1,
        updateColumnWidth: Math.abs(h - B) > 1,
        dimensions: {
          x: B
        },
        resizeDelta: m,
        isHeaderCell: y,
        targetData: n,
        targetElem: A,
        className: "muze-column-guideline-drag"
      }), i = !1, s = !1, l(), e.context._canvasHelpers.enableBehaviour("highlight"), e.context._canvasHelpers.enableLegendBehaviour("highlight");
    }
  }, I = t.selectAll(function() {
    const E = V(this);
    return E.classed("muze-grid-top-1") || E.classed("muze-grid-top-2") || E.classed("muze-grid-bottom-1") || E.classed("muze-grid-bottom-2") ? E.selectAll(".muze-grid-td").nodes() : [null];
  });
  I.on("mouseover", c), I.on("mousemove", c), I.on("mouseout", g);
  const C = e.context.sourceCanvas();
  V(r).on(
    `mousedown.${C}-${e.context.id()}`,
    d
  ), V(r).on(
    `mousemove.${C}-${e.context.id()}`,
    u
  ), V(r).on(
    `mouseup.${C}-${e.context.id()}`,
    f
  ), e.context._canvasHelpers.afterDisposed(() => {
    V(r).on(
      `mousedown.${C}-${e.context.id()}`,
      null
    ), V(r).on(
      `mousemove.${C}-${e.context.id()}`,
      null
    ), V(r).on(
      `mouseup.${C}-${e.context.id()}`,
      null
    );
  }), e.context._canvasHelpers.onHScroll(() => {
    o && e.triggerPhysicalAction("columnDrag", {
      showMarker: !1,
      targetData: null
    }), o = !1;
  });
}, sV = (e) => Yn(e, "source") && typeof e.source == "function" && Yn(e, "type") && Yn(e, "config") && typeof e.config == "function" && Yn(e, "mount") && typeof e.mount == "function", Pb = (e) => (t) => {
  let i = 0, n = 0, A = 0, s = 0, o = !1;
  const r = () => {
    const { currentTarget: c, target: g } = Bt();
    let h = "", u = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }, d = 0;
    if (c instanceof HTMLTableCellElement) {
      const f = V(c).datum();
      if (Yn(f, "placeholder") && sV(f.placeholder)) {
        const I = f.placeholder, C = I.source(), E = I.type, B = I.config();
        if (E === "text") {
          const m = J.getActualValue(C);
          if (typeof m == "string" && !vb(m)) {
            const y = V(I.mount()).select(
              ".muze-text-cell"
            );
            y.select("span").node() ? g === y.select("span").node() && (h = m, u = Wi(g)) : g === y.select(".muze-facet-inner-text").node() && (h = m, u = Wi(g));
          }
        } else if (E === "axis") {
          const m = C.constructor.type() === "band";
          if (B.renderer === "html" && m) {
            if (g instanceof HTMLSpanElement) {
              const D = V(g).datum();
              Yn(D, "originalText") && typeof D.originalText == "string" && (h = D.originalText, u = Wi(g));
            }
          } else if (B.renderer === "svg" && (g instanceof SVGTextElement || g instanceof SVGTSpanElement)) {
            const [y, D] = LC(c), Q = C.config().orientation;
            let p = !1;
            if (o && (Q === "bottom" ? p = D > i : Q === "top" ? p = D < n : Q === "left" ? p = y < s : Q === "right" && (p = y > A)), p)
              h = C.renderConfig().smartAxisName.oriText, u = Wi(g);
            else if (m) {
              let w = V(g);
              g instanceof SVGTSpanElement && g.parentElement instanceof SVGTextElement && (w = V(g.parentElement));
              const x = w.datum();
              h = C.axis().tickFormat()(x), d = C.config().labels.rotation == null ? 0 : C.config().labels.rotation, u = Wi(g);
            }
          }
        }
      }
    }
    e.triggerPhysicalAction("columnHeaderHover", {
      tooltext: h,
      tooltipAnchorBox: u,
      rotation: d
    });
  }, a = () => {
    const { currentTarget: c, target: g } = Bt();
    if (c instanceof HTMLTableCellElement) {
      const u = V(c).datum();
      if (Yn(u, "placeholder")) {
        const d = u.placeholder;
        if (Yn(d, "source") && typeof d.source == "function") {
          const f = d.source();
          if (f && !(typeof f == "string" || J.isInvalid(f)) && !(g instanceof HTMLDivElement)) {
            o = f.config().showAxisName;
            const I = f.mount();
            if (I instanceof SVGSVGElement) {
              const B = V(I).select(".muze-axis-name").node();
              if (B instanceof SVGElement) {
                const { height: m } = B.getBBox(), {
                  e: y,
                  f: D
                } = B.getCTM();
                i = D - m / 2, n = D + m / 2, A = y - m / 2, s = y + m / 2;
              }
            }
          }
        }
      }
    }
  }, l = () => {
    e.triggerPhysicalAction("columnHeaderHover", {
      tooltext: "",
      tooltipAnchorBox: { x: 0, y: 0, width: 0, height: 0 },
      rotation: 0
    });
  };
  t.selectAll(".muze-grid-td").on("pointerover", a), t.selectAll(".muze-grid-td").on("pointermove", r), t.selectAll(".muze-grid-td").on("pointerout", l);
}, Yb = (e) => (t) => {
  const { directSortEnabledInfo: i } = e.context.config();
  gE({
    baseTargets: {
      rowsHeaders: "div.muze-text-cell.muze-grid-headers",
      axis: [
        "div.muze-ticks",
        "g.tick.muze-ticks",
        "div.muze-direct-sort-container",
        "text.muze-axis-name"
      ]
    },
    directSortEnabledInfo: i
  }).forEach((A) => {
    t.selectAll(A).on("pointerover", oV.bind(void 0, e)), t.selectAll(A).on("pointermove", rV.bind(void 0, e)), t.selectAll(A).on("pointerout", aV.bind(void 0, e));
  });
}, oV = (e) => {
  const t = oB(e);
  sB(e, !0, t);
}, rV = (e) => {
  const t = oB(e);
  sB(e, !0, t);
}, aV = (e) => {
  const t = Bt(), { context: i } = e, n = Eu(V(t.currentTarget)), A = i._sortDropdown, s = A && A.isVisible(), o = i._activeSortTarget, r = s && n.node() === o.node() || !1, a = oB(e);
  sB(e, r, a);
}, sB = (e, t, i) => {
  const n = Bt(), A = Eu(V(n.currentTarget));
  e.triggerPhysicalAction("directSortHover", {
    target: A,
    showMenuButton: t,
    isActive: i
  });
}, oB = (e) => {
  const t = Bt(), i = Eu(V(t.currentTarget)), n = e.context, A = n._sortDropdown, s = n._activeSortTarget;
  return A && A.isVisible() && i.node() === s.node();
}, Jb = (e) => (t) => {
  const { directSortEnabledInfo: i } = e.context.config();
  gE({
    baseTargets: {
      rowsHeaders: "div.muze-text-cell.muze-grid-headers .sort-menu",
      axis: [
        "div.muze-ticks .sort-menu",
        "div.muze-direct-sort-container .sort-menu"
      ]
    },
    directSortEnabledInfo: i
  }).forEach((s) => {
    t.selectAll(s).on("click", lV.bind(void 0, e));
  });
  const A = Ld.bind(void 0, e);
  document.addEventListener("click", A), e.context._canvasHelpers.afterDisposed(() => {
    document.removeEventListener("click", A);
  }), e.context._canvasHelpers.onHScroll(
    Ld.bind(void 0, e)
  ), e.context._canvasHelpers.onVScroll(
    Ld.bind(void 0, e)
  );
}, lV = (e) => {
  const t = Bt();
  t.stopPropagation();
  const i = V(t.currentTarget), n = i.datum(), A = Wi(i.node()), s = Eu(
    V(i.node().parentElement)
  );
  e.triggerPhysicalAction("directSortClick", {
    data: n,
    anchorBox: A,
    target: s
  });
}, Ld = (e) => {
  const t = e.context._sortDropdown;
  t && t.isVisible() && Kb(e);
}, Kb = (e) => {
  e.triggerPhysicalAction("directSortClick", {
    data: null,
    anchorBox: null,
    target: null
  });
}, Wb = (e) => (t) => {
  const { directSortEnabledInfo: i } = e.context.config();
  gE({
    baseTargets: {
      rowsHeaders: "div.muze-text-cell.muze-grid-headers .sort-menu",
      axis: [
        "div.muze-ticks .sort-menu",
        "div.muze-direct-sort-container .sort-menu"
      ]
    },
    directSortEnabledInfo: i
  }).forEach((A) => {
    t.selectAll(A).on("pointerover", cV.bind(void 0, e)), t.selectAll(A).on("pointermove", gV.bind(void 0, e)), t.selectAll(A).on("pointerout", hV.bind(void 0, e));
  });
}, cV = (e) => {
  rB(e, !0);
}, gV = (e) => {
  rB(e, !0);
}, hV = (e) => {
  rB(e, !1);
}, rB = (e, t) => {
  const i = Bt(), n = V(i.currentTarget), A = n.datum().sortStatus;
  t = !!(t && A);
  const s = Wi(n.node());
  e.triggerPhysicalAction("directSortBtnHover", {
    showTooltip: t,
    currentSortStatus: A,
    tooltipAnchorBox: s
  });
};
class Vb extends Qi {
  static formalName() {
    return "resize";
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
class jb extends Qi {
  static formalName() {
    return "headerTooltip";
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
const Na = (e, t = !0, i) => {
  e.forEach((n) => {
    const A = n.source(), { renderer: s } = n.config();
    s === "html" ? A.getTicksBasedOnData(i)[i !== void 0 ? "selectionSet" : "rejectionSet"].each(
      function() {
        V(this).classed("muze-axis-cell-highlight", t);
      }
    ) : s === "svg" && i === void 0 && V(n.mount()).selectAll(".muze-axis-cell").classed("muze-axis-cell-highlight", t);
  });
}, p0 = (e, t) => {
  e.forEach((i) => {
    V(i.mount()).classed("muze-facet-cell-highlight", t);
  });
}, y0 = (e, t) => {
  e.forEach((i) => {
    V(i.mount()).classed("muze-row-header-cell-highlight", t);
  });
};
class uV extends $t {
  constructor(...t) {
    super(...t), this._interactedCells = {
      rowHeader: null,
      axis: null,
      facet: null
    };
  }
  static formalName() {
    return Xc;
  }
  apply(t, i) {
    const n = i.data && i.data.contextData.data ? i.data.contextData.data.getDataPath() : null;
    if (this._interactedCells && (Na(this._interactedCells.axis || [], !1), p0(this._interactedCells.facet || [], !1), y0(this._interactedCells.rowHeader || [], !1), this._interactedCells = {}), !n)
      return this;
    const A = n[n.length - 1];
    if ("value" in A) {
      const o = this.firebolt.context._matrices.axes._cells.left.find((r) => {
        const a = r.source().config().metaInf.facets;
        return `${n.slice(0, n.length - 1).map(({ value: l }) => l)}` == `${a.map(({ value: l }) => l)}` && (r.source().config().sourceType || "normal") === A.sourceType;
      });
      o && (Na([o], !0, A.value), this._interactedCells = [o], this._interactedCellType = "axis", this._interactedCells.axis = [o]);
    } else {
      const s = [
        ...this.firebolt.context._headerTitleMatrices._matrices.topLeft,
        ...this.firebolt.context._headerTitleMatrices._matrices.bottomLeft
      ].flat(), o = A.field, r = this.firebolt.context._matrices.axes._cells.left, a = this.firebolt.context._matrices.headers._cells.left, l = r[0].source().config().field === o ? 0 : -1, c = (a[0] || []).findIndex(
        (h) => h && h.config().fieldName === o
      ), g = s.find((h) => h.config().fieldName === o);
      if (y0([g], !0), this._interactedCells.rowHeader = [g], l !== -1)
        Na(r, !0), this._interactedCells.axis = r;
      else if (c !== -1) {
        const h = a.map((u) => u[c]).flat();
        p0(h, !0), this._interactedCellType = "facet", this._interactedCells.facet = h;
      }
    }
  }
}
class dV extends $t {
  static formalName() {
    return tg;
  }
  apply(t, i) {
    const n = i.data && i.data.contextData.data ? i.data.contextData.data.getDataPath() : null;
    if (this._interactedCells && this._interactedCellType === "axis" && Na(this._interactedCells || [], !1), !n)
      return this;
    const A = n[n.length - 1];
    if ("value" in A) {
      const s = this.firebolt.context._matrices.axes._cells, r = [...s.bottom, ...s.top].find((a) => {
        const l = a.source().config().metaInf.facets;
        return `${n.slice(0, n.length - 1).map(({ value: g }) => g)}` == `${l.map(({ value: g }) => g)}` && (a.source().config().sourceType || "normal") === A.sourceType;
      });
      r && (Na([r], !0, A.value), this._interactedCells = [r], this._interactedCellType = "axis");
    }
  }
}
class qb extends to {
  dispatchBehaviour(t, i, ...n) {
    super.dispatchBehaviour(t, i, ...n), W(
      this.context.config().interaction,
      t,
      "propagate"
    ) && this.context._canvasHelpers.propagateIdentifiers({
      payload: {
        ...i,
        targetActions: this.context.config().interaction[t].target
      },
      action: t
    });
  }
}
class zb extends Qi {
  static formalName() {
    return "directSortHighlight";
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
class Zb extends Qi {
  static formalName() {
    return "directSortSelect";
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
class $b extends Qi {
  static formalName() {
    return "directSortBtnHighlight";
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
const Xb = (e) => (t) => {
  t.selectAll(
    "div.muze-text-cell .muze-facet-expand-icon,div.muze-text-cell .muze-facet-collapse-icon"
  ).on("click", function() {
    fV.call(this, e);
  });
}, D0 = (e, t) => e.map((i, n) => ({
  field: `${i.field}`,
  value: i.value,
  collapsed: n === e.length - 1 ? !t : null
})), fV = function(e) {
  const t = V(this).datum();
  if (t) {
    const i = t.getDataPath(), n = t.type, A = t.canvasHelpers.getCanvasConfig(), s = i.map((o) => o.value);
    if (n === Za) {
      const o = A.rows.facets.interaction.collapse.handleClick, r = t.canvasHelpers.getRowCollapseState(s), a = D0(i, r);
      e.context._canvasHelpers.setRowCollapseState(a), o && o({
        targetPath: a,
        state: e.context._canvasHelpers.getRowCollapseState()
      });
    } else {
      const o = A.columns.facets.interaction.collapse.handleClick, r = t.canvasHelpers.getColumnsCollapseState(s), a = D0(i, r);
      e.context._canvasHelpers.setColumnsCollapseState(a), o && o({
        targetPath: a,
        state: e.context._canvasHelpers.getColumnsCollapseState()
      });
    }
  }
};
class tN extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return Ds;
  }
  apply() {
  }
}
class eN extends Qi {
  static formalName() {
    return "expandCollapse";
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
const iN = (e, t, i) => {
  let n = "";
  i?.splitTotal.field && (n = i.splitTotal.field);
  const A = t.interaction.collapse, s = e._facetFields;
  A.fields = {};
  for (let o = 0; o < s.length; o++)
    o === s.length - 1 ? A.fields[s[o]] = {
      enabled: e._axisFields.flat().find((r) => r.as() === oe && `${r}` !== n) ? A.enabled : !1
    } : A.fields[s[o]] = {
      enabled: n !== `${s[o + 1]}` ? A.enabled : !1
    };
  return A;
};
class nN extends Qi {
  static formalName() {
    return "contextMenu";
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
const AN = (e) => (t) => {
  t.selectAll(
    // @TODO: Add axis ticks of SVG elements for line, bar, point etc layers.
    "div.muze-text-cell .muze-facet-cell-container, div.tick.muze-ticks"
  ).on("contextmenu", function() {
    IV.call(this, e);
  });
};
function IV(e) {
  const t = V(this).datum();
  if (!t)
    return;
  const i = t.type, n = e.context._canvasHelpers.getCanvasConfig();
  let A;
  if (i === Za ? A = n?.rows?.facets?.interaction?.contextMenu : i === Zg ? A = n?.columns?.facets?.interaction?.contextMenu : i === CE ? A = n?.axes?.x?.interaction?.contextMenu : i === EE && (A = n?.axes?.y?.interaction?.contextMenu), !A || !A.enabled)
    return;
  const o = A.hook;
  if (!o)
    return;
  const r = Bt();
  r.preventDefault();
  const a = typeof t.getDataPath == "function" ? t.getDataPath().map((l) => ({ field: l.field.oneVar(), value: l.value })) : [];
  o({ type: i, event: r, dataPath: a });
}
class sN extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return ws;
  }
  apply() {
  }
}
const oN = (e) => (t) => {
  t.selectAll("a.muze-hyperlink-text").on("click", function() {
    CV.call(this, e);
  });
}, CV = function() {
  const e = Bt();
  e.metaKey || e.preventDefault();
};
class rN extends Qi {
  static formalName() {
    return "ctrlClickOpen";
  }
  dispatch() {
    return this;
  }
}
class aN extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return xs;
  }
  apply() {
  }
}
const w0 = (e, t, i, { renderer: n } = {}) => {
  const A = t === `${De}` ? `${Ke}` : `${$g}`, s = e.length;
  let o = e[0][0].source();
  const r = e[e.length - 1][0].source(), a = {};
  for (let l = 0; l < e.length; l++) {
    const c = l === e.length - 1;
    for (let g = 0; g < e[0].length; g++)
      n === "html" && c ? e[l][g].config({
        externalClassname: [`${$g}`]
      }) : e[l][g].config({
        externalClassname: [A]
      });
    e[l][0].source() !== o && (a[l] = l, o = e[l][0].source());
  }
  for (let l = 0; l < e.length; l++)
    for (let c = 0; c < e[0].length; c++)
      c === 0 ? (e[l][0].config().externalClassname.push(`${dA}-${t}`), e[l][c].source() === r && l !== 0 ? n === "svg" && e[l][c].config().externalClassname.push(`${Wo}-${Zt}`) : e[l][0].config().externalClassname.push(`${Ke}-${Zt}`), e[l][c] instanceof i && (e[l][c].config().externalClassname.push(`${dA}-${re}`), e[l][c].config().externalClassname.push(`${dA}-${Zt}`))) : c !== e[l].length - 1 && e[l][c].config().externalClassname.push(`${Ke}-${t}`), l === 0 ? e[0][c].config().externalClassname.push(`${Wo}-${re}`) : l === s - 1 && n === "svg" && e[l][c].config().externalClassname.push(`${Wo}-${Zt}`), l === 0 && e.length === 1 && e[l][c].config().externalClassname.push(`${Ke}-${Zt}`), a[l] && e[l - 1][c].config().externalClassname.push(`${Ke}-${Zt}`), e[l][c] instanceof i && (e[l][c].config().externalClassname.push(`${dA}-${le}`), e[l][c].config().externalClassname.push(`${dA}-${De}`));
  return a;
};
class EV extends sA {
  constructor(...t) {
    super(...t), this._borderConfig = {}, this._mergedMatrices = { leftMatrix: [], rightMatrix: [] }, this._matrices = {
      headers: new qW(this._dependencies),
      axes: new eV(this._dependencies)
    }, this._facetFields = null, this._axisFields = null, this._className = "row-header", this._firebolt = new qb(
      this,
      {
        behavioural: {
          resize: Vb,
          headerTooltip: jb,
          directSortHighlight: zb,
          directSortSelect: Zb,
          directSortBtnHighlight: $b,
          expandCollapse: eN,
          contextMenu: nN,
          ctrlClickOpen: rN
        },
        physical: {
          columnDrag: Hb,
          columnHeaderHover: Pb,
          directSortHover: Yb,
          directSortClick: Jb,
          directSortBtnHover: Wb,
          expandCollapseClick: Xb,
          contextMenuClick: AN,
          ctrlClick: oN
        },
        physicalBehaviouralMap: {
          columnDrag: {
            behaviours: ["resize"]
          },
          columnHeaderHover: {
            behaviours: ["headerTooltip"]
          },
          directSortHover: {
            behaviours: ["directSortHighlight"]
          },
          directSortClick: {
            behaviours: ["directSortSelect"]
          },
          directSortBtnHover: {
            behaviours: ["directSortBtnHighlight"]
          },
          expandCollapseClick: {
            behaviours: ["expandCollapse"]
          },
          contextMenuClick: {
            behaviours: ["contextMenu"]
          },
          ctrlClick: {
            behaviours: ["ctrlClickOpen"]
          }
        }
      },
      {
        [nB]: Tb,
        [AB]: Gb,
        [Qs]: Lb,
        [ps]: Ub,
        [ys]: Ob,
        [Xc]: uV,
        [Ds]: tN,
        [ws]: sN,
        [xs]: aN
      },
      {}
    );
  }
  config(...t) {
    if (t.length) {
      const i = t[0], n = tt({}, this._config, i);
      return this._config = n, this;
    }
    return this._config;
  }
  generateHeaders(t, i, n) {
    const A = this._matrices.headers;
    A.config({
      ...this.config().headers,
      facetsConfig: n,
      facetFields: i.rowFacets,
      canvasHelpers: this._canvasHelpers,
      globalConfig: this.config().axes.globalConfig
    }), A.createPlaceHolders(t);
  }
  generateAxes(t, i) {
    const {
      axes: n,
      renderer: A,
      isBold: s,
      tickFormat: o,
      show: r,
      isRowsCompact: a,
      fieldToShowInPercentage: l
    } = this.config(), c = this._matrices.axes;
    c.config({
      show: r,
      isBold: s,
      isCompact: a,
      tickFormat: o,
      renderer: A,
      fieldToShowInPercentage: l,
      ...n
    }), c.createPlaceHolders(
      t,
      i,
      l
    );
  }
  updateMatrices({
    axesInfo: t,
    headers: i,
    facets: n,
    rowFacetsConfig: A,
    facetFormatters: s,
    facetHyperLinkFormatters: o
  }) {
    this._facetFields = n.rowFacets, this._axisFields = t.axisFields;
    const { leftAxisInfo: r, rightAxisInfo: a } = t.rowAxisInfo, l = this.getAxesInfos([r, a], i);
    t.rowAxisInfo.leftAxisInfo = l[0], t.rowAxisInfo.rightAxisInfo = l[1], this._matrices.axes._cells.left.forEach((f) => {
      f.remove();
    }), this._matrices.axes._cells.right.forEach((f) => {
      f.remove();
    }), this._matrices.axes._cells.left.length = 0, this._matrices.axes._cells.right.length = 0, this.generateAxes(t, this._eventManager), this._matrices.headers._cells.left.forEach((f) => {
      f.forEach((I) => {
        I.remove();
      });
    }), this._matrices.headers._cells.right.forEach((f) => {
      f.forEach((I) => {
        I.remove();
      });
    }), this._matrices.headers._cells.left.length = 0, this._matrices.headers._cells.right.length = 0;
    const c = this.getHeaderKeys(
      i,
      n,
      s,
      o
    );
    this.generateHeaders(c, n, A), this._mergedMatrices = this.merge();
    const { sanitizeCheckBorder: g } = this.config();
    this._borderConfig = g ? this._sanitiseBorderMatrix() : {};
    const h = Object.assign(
      {},
      this.config().interaction,
      {
        directSortHighlight: {
          enabled: !0,
          sideEffects: { [Qs]: {} }
        },
        directSortSelect: {
          enabled: !0,
          propagate: !0,
          sideEffects: {
            [ps]: {},
            [Xc]: {}
          },
          target: {
            layer: {
              highlight: {
                sideEffects: {
                  "pivot-cell-highlighter": {}
                }
              }
            }
          }
        },
        directSortBtnHighlight: {
          enabled: !0,
          sideEffects: { [ys]: {} }
        },
        expandCollapse: {
          enabled: !0,
          sideEffects: {
            [Ds]: {}
          }
        },
        ctrlClickOpen: {
          enabled: !0,
          sideEffects: {
            [xs]: {}
          }
        },
        contextMenu: {
          enabled: !0,
          sideEffects: {
            [ws]: {}
          }
        }
      }
    );
    this.config({ interaction: h });
    const u = Object.keys(h).reduce(
      (f, I) => {
        const C = h[I].sideEffects;
        return f[I] = Object.keys(C).map((E) => ({
          name: E,
          ...C[E]
        })), f;
      },
      {}
    );
    this._firebolt.mapSideEffects(u, !1);
    const d = this._firebolt.actions().behavioural;
    Object.keys(d).forEach((f) => {
      h[f] && h[f].enabled ? d[f].enable() : d[f].disable();
    });
  }
  generateMatrices({
    axesInfo: t,
    headers: i,
    facets: n,
    rowFacetsConfig: A,
    columnSubTotalsConfig: s,
    facetFormatters: o,
    facetHyperLinkFormatters: r,
    childEventManagerCreator: a,
    canvasActions: l
  }) {
    this._canvasHelpers = l, this._facetFields = n.rowFacets, this._axisFields = t.axisFields, this._eventManager = a;
    const { leftAxisInfo: c, rightAxisInfo: g } = t.rowAxisInfo, h = this.getAxesInfos([c, g], i);
    t.rowAxisInfo.leftAxisInfo = h[0], t.rowAxisInfo.rightAxisInfo = h[1], this.generateAxes(t, a);
    const { sanitizeCheckBorder: u } = this.config(), d = this.getHeaderKeys(
      i,
      n,
      o,
      r
    );
    iN(
      this,
      A,
      s
    ), this.generateHeaders(d, n, A), this._mergedMatrices = this.merge(), this._borderConfig = u ? this._sanitiseBorderMatrix() : {};
    const f = Object.assign(
      {},
      this.config().interaction,
      {
        directSortHighlight: {
          enabled: !0,
          sideEffects: { [Qs]: {} }
        },
        directSortSelect: {
          enabled: !0,
          propagate: !0,
          sideEffects: {
            [ps]: {},
            [Xc]: {}
          },
          target: {
            layer: {
              highlight: {
                sideEffects: {
                  "pivot-cell-highlighter": {}
                }
              }
            }
          }
        },
        directSortBtnHighlight: {
          enabled: !0,
          sideEffects: { [ys]: {} }
        },
        expandCollapse: {
          enabled: !0,
          sideEffects: {
            [Ds]: {}
          }
        },
        ctrlClickOpen: {
          enabled: !0,
          sideEffects: {
            [xs]: {}
          }
        },
        contextMenu: {
          enabled: !0,
          sideEffects: {
            [ws]: {}
          }
        }
      }
    );
    this.config({ interaction: f });
    const I = Object.keys(f).reduce(
      (E, B) => {
        const m = f[B].sideEffects;
        return E[B] = Object.keys(m).map((y) => ({
          name: y,
          ...m[y]
        })), E;
      },
      {}
    );
    this._firebolt.mapSideEffects(I, !1);
    const C = this._firebolt.actions().behavioural;
    Object.keys(C).forEach((E) => {
      f[E] && f[E].enabled ? C[E].enable() : C[E].disable();
    });
  }
  getAxesInfos(t, i) {
    return t.map((n) => n.map((A, s) => ({
      ...A,
      metaInf: {
        sourceType: ft(
          W(A, "config", "sourceType"),
          xi
        ),
        facets: ft(W(i[s], "keys"), []).map(
          (o, r) => ({
            field: this._facetFields[r],
            value: we(o) ? o.rawValue : o,
            sourceType: we(o) ? o.sourceType : xi
          })
        )
      }
    })));
  }
  getHeaderKeys(t, i, n, A) {
    return t.map(({ keys: s, config: o, ...r }) => ({
      keys: s.map((a, l, c) => {
        let g, h, u, d = xi;
        we(a) ? (g = a.value, h = a.format, u = a.key, d = a.sourceType) : (g = a, h = n.row, u = `${i.rowFacets[l]}-${a}`);
        const f = lI(
          g,
          i.rowFacets[l],
          h,
          c.slice(0, l + 1).map((C) => ({
            field: i.rowFacets[l],
            value: C,
            sourceType: d
          }))
        ), I = Nb(
          f,
          i.rowFacets[l],
          A.row
        );
        return {
          ...f,
          key: u,
          sourceType: d,
          hyperlinkInfo: I
        };
      }),
      config: o,
      ...r
    }));
  }
  _sanitiseBorderMatrix() {
    const { leftMatrix: t, rightMatrix: i } = this.getMergedMatrices(), {
      cellRegistry: { BlankCell: n }
    } = this._dependencies, { renderer: A } = this.config();
    let s = {};
    return i.length && (s = w0(
      i,
      `${De}`,
      n,
      { renderer: A }
    )), t.length && (s = w0(t, `${le}`, n, {
      renderer: A
    })), s;
  }
  getPriority() {
    const t = this._matrices.axes, { left: i, right: n } = t._cells;
    let A = n.length ? 1 : -1;
    return i.length && A++, A;
  }
  merge() {
    const { headers: t, axes: i } = this._matrices, { left: n, right: A } = t._cells, { left: s, right: o } = i._cells, r = d0(
      n,
      s.map((l) => [l])
    ), a = d0(
      o.map((l) => [l]),
      A
    );
    return {
      leftMatrix: r,
      rightMatrix: a
    };
  }
  getMergedMatrices() {
    return this._mergedMatrices;
  }
  getBorderConfig() {
    return this._borderConfig;
  }
  getAxes() {
    const { left: t, right: i } = this._matrices.axes._cells;
    return [
      ...t.map((n) => n.source()).filter((n) => n),
      ...i.map((n) => n.source()).filter((n) => n)
    ];
  }
  getLeftAxes() {
    const { left: t } = this._matrices.axes._cells;
    return t;
  }
  getRightAxes() {
    return this._matrices.axes._cells.right;
  }
  clear() {
    super.clear();
    const { axes: t, headers: i } = this._matrices;
    t.clear(), i.clear(), this._borderConfig = {}, this._mergedMatrices = { leftMatrix: [], rightMatrix: [] };
  }
  matrices() {
    return this._matrices;
  }
  getFacetFields() {
    return this._facetFields;
  }
  getAxisFields() {
    return this._axisFields;
  }
  getDefaultTargetContainer() {
    return ".muze-grid-center-1, .muze-grid-top-1, .muze-grid-top-3, .muze-grid-center-3, .muze-grid-bottom-1";
  }
  mount() {
    return this.parentContainerInf().el;
  }
  sourceCanvas() {
    return this.config().sourceCanvasAlias;
  }
  data() {
    return null;
  }
  id() {
    return "row-matrix";
  }
  parentContainerInf(...t) {
    return t.length ? (this._parentContainerInf = t[0], this) : this._parentContainerInf;
  }
  updateColumnWidths(t) {
    this._canvasHelpers.updateColumnWidths(t, "rows");
  }
  mapActionsAndBehaviour() {
    const t = this._firebolt._actionBehaviourMap, i = {};
    for (let n in t) {
      const A = t[n].behaviours, s = this._firebolt._actions.behavioural;
      A.some(
        (r) => s[r]._enabled
      ) && (i[n] = {
        ...t[n],
        behaviours: []
      });
    }
    Object.keys(i).length && this._firebolt.mapActionsAndBehaviour(null, i);
  }
  directSortResetter(...t) {
    return t.length ? (this._directSortResetter = t[0], this) : this._directSortResetter;
  }
  resetDirectSort() {
    const t = this.directSortResetter();
    t && t();
  }
}
function gI(e, t) {
  if (t)
    for (let i = 0; i < e.length; i++)
      i !== 0 ? e[i].config({
        externalClassname: [`${Ke}`]
      }) : e[i].config({
        externalClassname: [`${dA}-${le}`, `${Ke}`]
      });
  else
    for (let i = 0; i < e.length; i++)
      for (let n = 0; n < e[0].length; n++)
        e[i][n].config({
          externalClassname: [`${Ke}`]
        });
}
class BV extends sA {
  constructor(...t) {
    super(...t), this._mergedMatrices = { topMatrix: [], bottomMatrix: [] }, this._matrices = {
      headers: new zW(this._dependencies),
      axes: new tV(this._dependencies)
    }, this._title = null, this._facetFields = null, this._axisFields = null, this._className = "column-header", this._firebolt = new qb(
      this,
      {
        behavioural: {
          resize: Vb,
          headerTooltip: jb,
          directSortHighlight: zb,
          directSortSelect: Zb,
          directSortBtnHighlight: $b,
          expandCollapse: eN,
          contextMenu: nN,
          ctrlClickOpen: rN
        },
        physical: {
          columnDrag: Hb,
          columnHeaderHover: Pb,
          directSortHover: Yb,
          directSortClick: Jb,
          directSortBtnHover: Wb,
          expandCollapseClick: Xb,
          contextMenuClick: AN,
          ctrlClick: oN
        },
        physicalBehaviouralMap: {
          columnDrag: {
            behaviours: ["resize"]
          },
          columnHeaderHover: {
            behaviours: ["headerTooltip"]
          },
          directSortHover: {
            behaviours: ["directSortHighlight"]
          },
          directSortClick: {
            behaviours: ["directSortSelect"]
          },
          directSortBtnHover: {
            behaviours: ["directSortBtnHighlight"]
          },
          expandCollapseClick: {
            behaviours: ["expandCollapse"]
          },
          contextMenuClick: {
            behaviours: ["contextMenu"]
          },
          ctrlClick: {
            behaviours: ["ctrlClickOpen"]
          }
        }
      },
      {
        [nB]: Tb,
        [AB]: Gb,
        [Qs]: Lb,
        [ps]: Ub,
        [ys]: Ob,
        [tg]: dV,
        [Ds]: tN,
        [ws]: sN,
        [xs]: aN
      },
      {}
    );
  }
  generateColumnMatrixTitle() {
    const {
      columnVariables: t = [],
      axes: { globalConfig: i }
    } = this.config(), n = i.columns.headers.formatter, A = i.columns.headers, s = i.columns.facets, o = i.axes.x, r = this.getFacetFields().map((c) => c.toString()), a = this.getAxisFields().map((c) => c.toString()), l = t.reduce(
      (c, g = []) => [
        ...c,
        ...g.filter(
          // @todo: Filter only discrete and temporal fields to show header.
          (h) => {
            const u = ft(
              W(A, "fields", h.toString()),
              ...(r || []).indexOf(h.toString()) >= 0 ? [W(s, "fields", h.toString())] : [],
              ...(a || []).indexOf(h.toString()) >= 0 ? [W(o, "fields", h.toString())] : []
            );
            return u && u.show === !1 ? !1 : (h.as() === "discrete" && h.toString() !== bt || h.subtype() === "temporal") && A.show;
          }
        ).map((h) => h.displayName())
      ],
      []
    );
    this._title = n({ fieldNames: l }, { context: this });
  }
  getColumnTitle() {
    return this._title;
  }
  generateHeaders(t, i, n) {
    const A = this._matrices.headers, s = this.config();
    A.config({
      ...s.headers,
      facetsConfig: n,
      facetFields: i.colFacets,
      canvasHelpers: this._canvasHelpers
    }), A.createPlaceHolders(t);
  }
  config(...t) {
    if (t.length) {
      const i = t[0], n = tt({}, this._config, i);
      return this._config = n, this;
    }
    return this._config;
  }
  generateAxes(t, i) {
    const {
      axes: n,
      renderer: A,
      isBold: s,
      isColumnsCompact: o,
      tickFormat: r,
      show: a,
      firstSuppliedTextLayerInfo: l,
      fieldToShowInPercentage: c
    } = this.config(), g = this._matrices.axes;
    g.config({
      show: a,
      isBold: s,
      isCompact: o,
      tickFormat: r,
      renderer: A,
      firstSuppliedTextLayerInfo: l,
      fieldToShowInPercentage: c,
      ...n
    }), g.createPlaceHolders(
      t,
      i,
      c
    );
  }
  getAxesInfo(t, i) {
    return t.map((n) => n.map((A, s) => ({
      ...A,
      metaInf: {
        sourceType: ft(
          W(A, "config", "sourceType"),
          xi
        ),
        facets: ft(W(i[s], "keys"), []).map(
          (o, r) => ({
            field: this._facetFields[r],
            value: we(o) ? o.rawValue : o,
            sourceType: we(o) ? o.sourceType : xi
          })
        )
      }
    })));
  }
  getHeaderKeys(t, i, n, A) {
    return t.map(({ keys: s, config: o, ...r }) => ({
      keys: s.map((a, l, c) => {
        let g, h, u, d = xi;
        const f = c.slice(0, l + 1).map((I) => ({
          field: i.rowFacets[l],
          value: I,
          sourceType: d
        }));
        if (we(a))
          return g = a.value, h = a.format, u = a.key, d = a.sourceType, {
            ...lI(
              a.rawValue,
              i.colFacets[l],
              h,
              f
            ),
            key: u,
            sourceType: d
          };
        {
          g = a, h = n.column, u = `${i.colFacets[l]}-${a}`;
          const I = lI(
            g,
            i.colFacets[l],
            h,
            f
          ), C = Nb(
            I,
            i.colFacets[l],
            A.column
          );
          return {
            ...I,
            key: u,
            hyperlinkInfo: C,
            sourceType: d
          };
        }
      }),
      config: o,
      ...r
    }));
  }
  updateMatrices({
    axesInfo: t,
    headers: i,
    facets: n,
    colFacetsConfig: A,
    facetFormatters: s,
    facetHyperLinkFormatters: o
  }) {
    this._facetFields = n.colFacets, this._axisFields = t.axisFields;
    const { topAxisInfo: r, bottomAxisInfo: a } = t.columnAxisInfo, l = this.getAxesInfo([r, a], i);
    t.columnAxisInfo.topAxisInfo = l[0], t.columnAxisInfo.bottomAxisInfo = l[1], this._matrices.axes._cells.top.forEach((f) => {
      f.remove();
    }), this._matrices.axes._cells.bottom.forEach((f) => {
      f.remove();
    }), this._matrices.axes._cells.top.length = 0, this._matrices.axes._cells.bottom.length = 0, this.generateAxes(t, this._eventManager);
    const { sanitizeCheckBorder: c } = this.config();
    this._matrices.headers._cells.top.forEach((f) => {
      f.forEach((I) => {
        I.remove();
      });
    }), this._matrices.headers._cells.bottom.forEach((f) => {
      f.forEach((I) => {
        I.remove();
      });
    }), this._matrices.headers._cells.top.length = 0, this._matrices.headers._cells.bottom.length = 0;
    const g = this.getHeaderKeys(
      i,
      n,
      s,
      o
    );
    this.generateHeaders(g, n, A), this.generateColumnMatrixTitle(), this._mergedMatrices = this.merge(), c && this._sanitiseBorderMatrix();
    const h = Object.assign(
      {},
      this.config().interaction,
      {
        directSortHighlight: {
          enabled: !0,
          sideEffects: { [Qs]: {} }
        },
        directSortSelect: {
          enabled: !0,
          propagate: !0,
          sideEffects: {
            [ps]: {},
            [tg]: {}
          },
          target: {
            layer: {
              highlight: {
                sideEffects: {
                  "pivot-cell-highlighter": {}
                }
              }
            }
          }
        },
        directSortBtnHighlight: {
          enabled: !0,
          sideEffects: { [ys]: {} }
        },
        expandCollapse: {
          enabled: !0,
          sideEffects: {
            [Ds]: {}
          }
        },
        ctrlClickOpen: {
          enabled: !0,
          sideEffects: {
            [xs]: {}
          }
        },
        contextMenu: {
          enabled: !0,
          sideEffects: {
            [ws]: {}
          }
        }
      }
    );
    this.config({ interaction: h });
    const u = Object.keys(h).reduce(
      (f, I) => {
        const C = h[I].sideEffects;
        return f[I] = Object.keys(C).map((E) => ({
          name: E,
          ...C[E]
        })), f;
      },
      {}
    );
    this._firebolt.mapSideEffects(u, !1);
    const d = this._firebolt.actions().behavioural;
    Object.keys(d).forEach((f) => {
      h[f] && h[f].enabled ? d[f].enable() : d[f].disable();
    });
  }
  generateMatrices({
    axesInfo: t,
    headers: i,
    facets: n,
    colFacetsConfig: A,
    rowSubTotalsConfig: s,
    facetFormatters: o,
    facetHyperLinkFormatters: r,
    childEventManagerCreator: a,
    canvasActions: l
  }) {
    this._eventManager = a, this._canvasHelpers = l, this._facetFields = n.colFacets, this._axisFields = t.axisFields;
    const { topAxisInfo: c, bottomAxisInfo: g } = t.columnAxisInfo, h = this.getAxesInfo([c, g], i);
    t.columnAxisInfo.topAxisInfo = h[0], t.columnAxisInfo.bottomAxisInfo = h[1], this.generateAxes(t, a);
    const { sanitizeCheckBorder: u } = this.config(), d = this.getHeaderKeys(
      i,
      n,
      o,
      r
    );
    iN(
      this,
      A,
      s
    ), this.generateHeaders(d, n, A), this.generateColumnMatrixTitle(), this._mergedMatrices = this.merge(), u && this._sanitiseBorderMatrix();
    const f = Object.assign(
      {},
      this.config().interaction,
      {
        directSortHighlight: {
          enabled: !0,
          sideEffects: { [Qs]: {} }
        },
        directSortSelect: {
          enabled: !0,
          propagate: !0,
          sideEffects: {
            [ps]: {},
            [tg]: {}
          },
          target: {
            layer: {
              highlight: {
                sideEffects: {
                  "pivot-cell-highlighter": {}
                }
              }
            }
          }
        },
        directSortBtnHighlight: {
          enabled: !0,
          sideEffects: { [ys]: {} }
        },
        expandCollapse: {
          enabled: !0,
          sideEffects: {
            [Ds]: {}
          }
        },
        ctrlClickOpen: {
          enabled: !0,
          sideEffects: {
            [xs]: {}
          }
        },
        contextMenu: {
          enabled: !0,
          sideEffects: {
            [ws]: {}
          }
        }
      }
    );
    this.config({ interaction: f });
    const I = Object.keys(f).reduce(
      (E, B) => {
        const m = f[B].sideEffects;
        return E[B] = Object.keys(m).map((y) => ({
          name: y,
          ...m[y]
        })), E;
      },
      {}
    );
    this._firebolt.mapSideEffects(I, !1);
    const C = this._firebolt.actions().behavioural;
    Object.keys(C).forEach((E) => {
      f[E] && f[E].enabled ? C[E].enable() : C[E].disable();
    });
  }
  _sanitiseBorderMatrix() {
    const { topMatrix: t, bottomMatrix: i } = this.getMergedMatrices();
    t.length && gI(t), i.length && gI(i);
  }
  getPriority() {
    const t = this._matrices.axes, { top: i, bottom: n } = t._cells;
    let A = n.length ? 1 : -1;
    return i.length && A++, A;
  }
  merge() {
    const { cellRegistry: t } = this._dependencies, { headers: i, axes: n } = this._matrices, { top: A, bottom: s } = i._cells, o = [], r = (C) => {
      const E = new t.TextCell(
        {},
        { labelManager: this._dependencies.smartLabel }
      ).rawSource(Da).source(Da);
      return E.config({
        externalClassname: ["empty-column-cell-container"],
        className: "muze-empty-column-cell",
        fieldName: null,
        metaInf: {
          sourceType: C === "total" ? Ae : xi,
          getDataPath: () => [
            {
              field: null,
              sourceType: C === "total" ? Ae : xi,
              value: Da
            }
          ]
        }
      }), E;
    };
    A && A.forEach((C) => {
      C.forEach((E, B) => {
        o[B] = o[B] || [], o[B].push(E);
      });
    });
    const { top: a, bottom: l } = n._cells;
    a.length && o.push(a);
    let c = [];
    l.length && c.push(l);
    const g = c.length;
    s && s.forEach((C) => {
      C.forEach((E, B) => {
        c[B + g] = c[B + g] || [], c[B + g].push(E);
      });
    });
    const { axes: h, rowHeadersConfig: u, renderer: d } = this.config(), f = !!(Object.keys(u.fields || {}).some(
      (C) => u.fields[C].show
    ) || u.show), I = h.globalConfig.columns.headers.position;
    if (!o.length && (f || d === "html") && I !== "bottom" && (o.push(
      c[0].map(
        (C) => r(C.source().config().metaInf.sourceType)
      )
    ), (!c.length || !c[0].length) && c.push([[new t.BlankCell()]])), (!c.length || !c[0].length) && (f || d === "html") && I === "bottom") {
      const C = f && I === "bottom" ? r() : new t.BlankCell();
      c.push([C]);
    }
    return {
      topMatrix: o,
      bottomMatrix: c
    };
  }
  getAxes() {
    const { top: t, bottom: i } = this._matrices.axes._cells;
    return [
      ...t.map((n) => n.source()).filter((n) => n),
      ...i.map((n) => n.source()).filter((n) => n)
    ];
  }
  getTopAxes() {
    const { top: t } = this._matrices.axes._cells;
    return t;
  }
  getBottomAxes() {
    return this._matrices.axes._cells.bottom;
  }
  getMergedMatrices() {
    return this._mergedMatrices;
  }
  matrices() {
    return this._matrices;
  }
  clear() {
    super.clear();
    const { axes: t, headers: i } = this._matrices;
    t.clear(), i.clear(), this._title = null, this._mergedMatrices = { topMatrix: [], bottomMatrix: [] };
  }
  getFacetFields() {
    return this._facetFields;
  }
  getAxisFields() {
    return this._axisFields;
  }
  getDefaultTargetContainer() {
    return ".muze-grid-top-2, .muze-grid-bottom-2";
  }
  mount() {
    return this.parentContainerInf().el;
  }
  sourceCanvas() {
    return this.config().sourceCanvasAlias;
  }
  data() {
    return null;
  }
  id() {
    return "column-matrix";
  }
  parentContainerInf(...t) {
    return t.length ? (this._parentContainerInf = t[0], this) : this._parentContainerInf;
  }
  updateColumnWidths(t) {
    this._canvasHelpers.updateColumnWidths(t, "columns");
  }
  mapActionsAndBehaviour() {
    const t = this._firebolt._actionBehaviourMap, i = {};
    for (let n in t) {
      const A = t[n].behaviours, s = this._firebolt._actions.behavioural;
      A.some(
        (r) => s[r]._enabled
      ) && (i[n] = {
        ...t[n],
        behaviours: []
      });
    }
    Object.keys(i).length && this._firebolt.mapActionsAndBehaviour(null, i);
  }
  getPreviousAxisElem({ cell: t, axisElem: i }) {
    let n;
    if (i.previousElementSibling === null) {
      const { top: A, bottom: s } = this._matrices.axes._cells;
      [A, s].forEach((o) => {
        const r = o.findIndex((a) => a === t);
        if (r > 0) {
          const a = o[r - 1];
          n = a ? a.source().getLastTickElement() : null;
        }
      });
    } else
      n = i.previousElementSibling;
    return n;
  }
  directSortResetter(...t) {
    return t.length ? (this._directSortResetter = t[0], this) : this._directSortResetter;
  }
  resetDirectSort() {
    const t = this.directSortResetter();
    t && t();
  }
}
const x0 = (e, t, i, n, A, { type: s, subtype: o }) => {
  const r = o[0] ? hn(o[0]) ? null : o[0] : null, a = o[1] ? hn(o[1]) ? null : o[1] : null;
  !e[t] && (e[t] = {
    type: i,
    fieldType: s,
    fieldSubType: {
      primary: r,
      secondary: a
    },
    domains: []
  });
  const l = A[0] ? hn(A[0]) ? null : A[0] : null, c = A[1] ? hn(A[1]) ? null : A[1] : null;
  e[t].domains.push({
    primary: {
      field: l,
      domain: n[`${A[0]}`] || []
    },
    secondary: {
      field: c,
      domain: n[`${A[1]}`] || []
    }
  });
}, S0 = (e) => {
  const t = {};
  return e.forEach((i) => {
    i.forEach(({ dataStore: n }) => {
      n.getTemporalFields().forEach((A) => {
        const s = n.getFieldData(A);
        if (s.length) {
          let o = n.getField(A).minimumConsecutiveDifference();
          (o === 0 || Number.isNaN(o)) && (o = s[0]), t[A] = Math.min(
            t[A] || 1 / 0,
            o
          );
        }
      });
    });
  }), t;
}, mV = (e, t, i) => {
  let n = [];
  return e.length > t && (n = n.concat(e.splice(t))), e[0].length > i && e.forEach((A, s) => {
    n = n.concat(e[s].splice(i));
  }), n;
}, M0 = [`${Ke}-${De}`], dh = [`${$g}`], _0 = dh.concat(`${Wo}-${re}`), b0 = dh.concat(`${Wo}-${Zt}`);
class QV extends sA {
  constructor(...t) {
    super(...t), this._matrix = [], this._cellMap = [], this._rootMatrixInfo = null, this._totalsData = null, this._layerDomains = null;
  }
  _createVisualUnit({
    rowIndex: t,
    columnIndex: i,
    timeDiffObj: n,
    renderer: A,
    dataStore: s,
    axisFields: o,
    xAxes: r,
    yAxes: a,
    unitConfig: l,
    theme: c,
    layerConfig: g,
    facets: h,
    metaInfo: u,
    colFacets: d,
    rowFacets: f,
    layerDataModels: I,
    layerDomainsById: C,
    columnTotalString: E,
    rowTotalString: B
  }, m, y, D) {
    const {
      store: Q,
      throwback: p,
      smartLabel: w,
      layerRegistry: x,
      VisualUnit: S,
      DataStore: _
    } = this._dependencies, { interactions: M } = this.config(), { alias: k, coord: T, valueParser: G, retinalConfig: N, fireboltDeps: b } = this.config(), F = `unit${t}-${i}-${Ut()}`;
    m || (m = S.create(
      { layerRegistry: x, interactions: M },
      {
        DataStore: _,
        throwback: p,
        smartLabel: w,
        fireboltDeps: b,
        canvasActions: D
      },
      y
    ), m.metaInf({
      colIndex: i,
      rowIndex: t,
      namespace: F
    }), m.createFireboltInstance());
    const R = Object.values(f).filter(
      (et) => et !== Yi
    ), v = Object.values(d).filter(
      (et) => et !== Yi
    ), O = R.length ? this._canvasActions.getRowCollapseState(R) : !1, L = v.length ? this._canvasActions.getColumnsCollapseState(v) : !1;
    m.store(Q).coord(T).parentAlias(k).valueParser(G).coord(T).renderer(A).metaInf({
      ...m.metaInf(),
      timeDiffObj: n,
      ...u,
      includeTotalDomain: this.config().visualGroupConfig.legend.includeTotalDomain,
      colFacets: d,
      rowFacets: f,
      isRowCollapsed: O,
      isColCollapsed: L,
      isCollapsed: O || L,
      columnTotalString: E,
      rowTotalString: B
    }).retinalFields(N);
    const { retinalAxes: U, detailFields: H, dataModelTransform: z } = this.config();
    return l.theme = c, m.clearCaching().clearCustomLayerData().clearCachedLayerData().lockLocalModel().data(s).config(l).layerDef(g).layerDataModels(I).layerDomains(C).fields({ x: o.x, y: o.y }).transform(z).detailFields(H).facetByFields(h.data).facetSchema(h.schema).axes(Object.assign({ x: r, y: a }, U)).unlockLocalModel();
  }
  _createGeomCell({ visualUnit: t }, i) {
    const { GeomCell: n } = this._dependencies.cellRegistry;
    return i || (i = new n()), i.source(t);
  }
  _updateMatrixUsingUpdateInfo(t) {
    const [i, n] = t.exitSet;
    let A = [];
    i[0] !== -1 && i[1] !== -1 && (this._matrix.splice(i[0], i[1] - i[0] + 1), A = this._cellMap.splice(
      i[0],
      i[1] - i[0] + 1
    )), n[0] !== -1 && n[1] !== -1 && this._matrix.forEach((s, o) => {
      this._matrix[o].splice(
        n[0],
        n[1] - n[0] + 1
      ), A = A.concat(
        this._cellMap[o].splice(
          n[0],
          n[1] - n[0] + 1
        )
      );
    }), this.removeExitCells(A);
  }
  updateMatrix({
    axes: t,
    borderConfig: i,
    dataModelMatrix: n,
    facets: { rowFacets: A, colFacets: s },
    rootMatrixInfo: o,
    paginatedMatrixInfo: r,
    rootGroupedData: a,
    canvasActions: l,
    updateInfo: c,
    facetType: g,
    paginated: h,
    targetPath: u,
    subTotalsInfo: { rowSplitSubtotalsField: d, colSplitSubtotalsField: f }
  } = {
    isColSubTotalsEnabled: !1,
    isRowSubTotalsEnabled: !1,
    rowSplitSubtotalsField: void 0,
    colSplitSubtotalsField: void 0,
    rowSubTotalsDS: null,
    colSubTotalsDS: this._columnSubTotalsDataModel
  }) {
    const { store: I } = this._dependencies;
    this._rootMatrixInfo = o, this._paginatedMatrixInfo = r, this._rootGroupedData = a;
    const C = s.concat(A);
    I.lockModel();
    const E = S0(n);
    this._updateMatrixUsingUpdateInfo(c);
    const B = this.getUpdatedMatrixFromCoordinates(
      c.updateSet,
      n,
      C,
      t,
      i,
      l,
      E,
      A,
      s,
      h
    );
    let m = [];
    if (g === "row") {
      const Q = A.map((w) => `${w}`).indexOf(f), p = c.splitFieldUniques;
      if (this._matrix.splice(
        c.updateSet[0][0],
        Q >= 0 && u.length != A.length ? p.length : 1,
        ...B.map((w) => w.map((x) => x))
      ), m = this._cellMap.splice(
        c.updateSet[0][0],
        Q >= 0 && u.length != A.length ? p.length : 1,
        ...B.map((w) => w.map((x) => x))
      ), c.entrySet.length && h) {
        const w = this.getUpdatedMatrixFromCoordinates(
          c.entrySet,
          n,
          C,
          t,
          i,
          l,
          E,
          A,
          s,
          h
        );
        this._matrix.splice(c.entrySet[0][0], 0, ...w), this._cellMap.splice(
          c.entrySet[0][0],
          0,
          ...w.map((x) => x.map((S) => S))
        );
      }
    } else if (g === "column") {
      const Q = s.map((w) => `${w}`).indexOf(d), p = c.splitFieldUniques;
      this._matrix.forEach((w, x, S) => {
        S[x].splice(
          c.updateSet[0][1],
          Q >= 0 && u.length != s.length ? p.length : 1,
          ...B[x]
        ), m = m.concat(
          this._cellMap[x].splice(
            c.updateSet[0][1],
            Q >= 0 && u.length != s.length ? p.length : 1,
            ...B[x]
          )
        );
      });
    }
    const { retinalAxes: y } = this.config(), D = c.updateSet.reduce((Q, p) => (Q.set(`${p[0]}-${p[1]}`, !0), Q), /* @__PURE__ */ new Map());
    this._matrix.forEach((Q, p) => {
      Q.forEach((w, x) => {
        if (!D.has(`${p}-${x}`)) {
          if (w.source().lockLocalModel(), w.source().metaInf({
            ...w.source().metaInf(),
            colIndex: x,
            rowIndex: p,
            namespace: `unit${p}-${x}-${Ut()}`
          }), w.source().axes(
            Object.assign(
              {
                x: [t.x.top[x], t.x.bottom[x]].filter(
                  (S) => S
                ),
                y: [t.y.left[p], t.y.right[p]].filter(
                  (S) => S
                )
              },
              y
            )
          ), i[p]) {
            const S = this._matrix[p - 1][x], _ = S.config(), k = {
              externalClassname: (S.config().externalClassname ?? []).concat(
                `${Ke}-${Zt}`
              )
            };
            S.config(Object.assign({}, _, k));
          }
          w.source().unlockLocalModel({
            skipAttachLayerData: !0,
            skipLayerFireboltCreation: !0
          });
        }
      });
    }), I.unlockModel(), m.length && this.removeExitCells(m);
  }
  getUpdatedMatrixFromCoordinates(t, i, n, A, s, o, r, a, l, c) {
    const {
      renderer: g,
      unitConfig: h,
      sanitizeCheckBorder: u,
      theme: d,
      columnTotalString: f,
      rowTotalString: I
    } = this.config(), C = [];
    let E = -1, B = -1;
    return t.forEach(([m, y]) => {
      const {
        rowFacetValues: D,
        columnFacetValues: Q,
        rowProjections: p,
        columnProjections: w,
        metaInfo: x = {},
        layerConfig: S,
        layerDomainsById: _
      } = i[m][y];
      let { dataStore: M, layerDataModels: k } = i[m][y];
      c || (M = hh(M, M)), k = Object.keys(k).reduce((U, H) => (U[H] = hh(k[H], M), U), {}), E !== m && (E = m, B += 1);
      const T = Q.concat(D), G = m === 0, { length: N } = i, b = m === N - 1, F = i[m].length, R = y === F - 1, v = this._createVisualUnit(
        {
          renderer: g,
          rowIndex: m,
          columnIndex: y,
          layerConfig: S,
          layerDataModels: k,
          layerDomainsById: _,
          timeDiffObj: r,
          metaInfo: x,
          dataStore: M,
          facets: {
            data: [n, T],
            schema: n.map((U) => M.getField(`${U}`).schema())
          },
          colFacets: l.reduce((U, H, z) => (U[H] = Q[z], U), {}),
          rowFacets: a.reduce((U, H, z) => (U[H] = D[z], U), {}),
          // rowFacets,
          axisFields: {
            x: w,
            y: p
          },
          unitConfig: h,
          theme: d,
          // Note: The order of the axes being passed matter. For x-axes,
          // first top, then bottom. For y-axes, first left and then right.
          xAxes: [A.x.top[y], A.x.bottom[y]].filter(
            (U) => U
          ),
          yAxes: [A.y.left[m], A.y.right[m]].filter(
            (U) => U
          ),
          columnTotalString: f,
          rowTotalString: I
        },
        null,
        this._childEventManagerCreator(),
        o
      ), O = this._createGeomCell(
        {
          visualUnit: v
        },
        null
      ), L = () => {
        let U = [];
        return u && (U = dh, G ? U = _0 : b && g === "svg" && (U = b0), R && (U = U.concat(M0))), U;
      };
      C[B] || (C[B] = []), C[B].push(
        O.config(
          Object.assign({}, h, {
            externalClassname: L()
          })
        )
      );
    }), C;
  }
  generateMatrix({
    axes: t,
    borderConfig: i,
    dataModelMatrix: n,
    facets: { rowFacets: A, colFacets: s },
    childEventManagerCreator: o,
    totalsData: r,
    rootMatrixInfo: a,
    paginatedMatrixInfo: l,
    rootGroupedData: c,
    canvasActions: g
  }) {
    const { store: h } = this._dependencies;
    this._totalsData = r, this._rootMatrixInfo = a, this._paginatedMatrixInfo = l, this._rootGroupedData = c, this._canvasActions = g, this._childEventManagerCreator = o;
    const {
      renderer: u,
      unitConfig: d,
      sanitizeCheckBorder: f,
      theme: I,
      columnTotalString: C,
      rowTotalString: E
    } = this.config(), B = s.concat(A);
    h.lockModel();
    const m = S0(n), y = n.map((Q, p) => (this._cellMap[p] || (this._cellMap[p] = []), Q.map(
      ({
        rowFacetValues: w,
        columnFacetValues: x,
        rowProjections: S,
        columnProjections: _,
        metaInfo: M = {},
        dataStore: k,
        layerDataModels: T,
        layerConfig: G,
        layerDomainsById: N
      }, b) => {
        const F = x.concat(w);
        let R = this._cellMap?.[p]?.[b];
        const v = this._createVisualUnit(
          {
            renderer: u,
            rowIndex: p,
            columnIndex: b,
            layerConfig: G,
            layerDataModels: T,
            layerDomainsById: N,
            timeDiffObj: m,
            metaInfo: M,
            dataStore: k,
            facets: {
              data: [B, F],
              schema: B.map((O) => k.getField(`${O}`).schema())
            },
            colFacets: s.reduce((O, L, U) => (O[L] = x[U], O), {}),
            rowFacets: A.reduce((O, L, U) => (O[L] = w[U], O), {}),
            // rowFacets,
            axisFields: {
              x: _,
              y: S
            },
            unitConfig: d,
            theme: I,
            // Note: The order of the axes being passed matter. For x-axes,
            // first top, then bottom. For y-axes, first left and then right.
            xAxes: [
              t.x.top[b],
              t.x.bottom[b]
            ].filter((O) => O),
            yAxes: [t.y.left[p], t.y.right[p]].filter(
              (O) => O
            ),
            columnTotalString: C,
            rowTotalString: E
          },
          R ? R.source() : null,
          o(),
          g
        );
        return R = this._createGeomCell(
          {
            visualUnit: v
          },
          R
        ), this._cellMap[p][b] = R, R;
      }
    )));
    this._matrix = y.map((Q, p, w) => {
      const x = p === 0, { length: S } = w, _ = p === S - 1;
      return Q.map((M, k, { length: T }) => {
        const G = k === T - 1, N = () => {
          let b = [];
          if (f && (b = dh, x ? b = _0 : _ && u === "svg" && (b = b0), G && (b = b.concat(M0)), i[p])) {
            const F = w[p - 1][k], R = F.config(), O = {
              externalClassname: F.config().externalClassname.concat(
                `${Ke}-${Zt}`
              )
            };
            F.config(Object.assign({}, R, O));
          }
          return b;
        };
        return M.config(
          Object.assign({}, d, {
            externalClassname: N()
          })
        );
      });
    });
    const D = mV(
      this._cellMap,
      this._matrix.length,
      this._matrix?.[0]?.length
    );
    h.unlockModel(), D.length && this.removeExitCells(D);
  }
  removeExitCells(t) {
    t.forEach((i) => {
      Array.isArray(i) ? i.forEach((n) => {
        n.source().eventManager().remove(), n.source()._eventManager = null, n.remove();
      }) : (i?.source()?.eventManager()?.remove(), i && (i.source()._eventManager = null), i?.remove());
    });
  }
  forEach(t) {
    const i = this._matrix;
    i && i.forEach((n, A) => {
      n.forEach((s, o) => {
        t(s, A, o);
      });
    });
  }
  /**
   * Returns an array of x and y axis domains
   *
   * {
   *    x: [
   *      // Domains of the first column index
   *      {
   *          type: 'linear',
   *          domains: [
   *              {
   *                  primary: {
   *                      field: fieldInst,
   *                      domain: [0, 100]
   *                  },
   *                  secondary: {
   *                      field: fieldInst,
   *                      domain: [0, 200]
   *                  }
   *              },
   *          ]
   *      }
   *    ],
   *    y: []
   * }
   */
  getXYDomains(t = {}) {
    const i = [], n = [], A = this._paginatedMatrixInfo, { completeDataModelMatrix: s } = A, o = this._rootMatrixInfo, { leftAxisInfo: r } = t.unionAxisDomainPerPage ? A.allRowAxisInfo : o.allRowAxisInfo, { topAxisInfo: a, bottomAxisInfo: l } = o.allColumnAxisInfo;
    for (let u = 0; u < a.length; u++) {
      const { field: d } = a[u], { field: f } = l[u];
      r.forEach((I, C) => {
        const { layerConfig: E, dataStore: B, layerDomainsById: m } = t.unionAxisDomainPerPage ? A.dataModelMatrix[C][u] : s[C][u], y = d && d.getMembers().every((Q) => B.getField(Q)) ? No(E, m, {
          field: d,
          encoding: "x"
        }) : [], D = f && f.getMembers().every((Q) => B.getField(Q)) ? No(E, m, {
          field: f,
          encoding: "x"
        }) : [];
        x0(
          n,
          u,
          d.as(),
          {
            [d]: y,
            [f]: D
          },
          [d, f],
          {
            type: d.type(),
            subtype: [d.subtype(), f?.subtype()]
          }
        );
      });
    }
    const c = t.calculateUniformAxisDomains && !t.unionAxisDomainPerPage, g = c ? o.allRowAxisInfo.leftAxisInfo : A.allRowAxisInfo.leftAxisInfo, h = c ? o.allRowAxisInfo.rightAxisInfo : A.allRowAxisInfo.rightAxisInfo;
    for (let u = 0; u < g.length; u++) {
      const { field: d } = g[u], { field: f } = h[u];
      l.forEach((I, C) => {
        const { layerConfig: E, dataStore: B, layerDomainsById: m } = c ? A.completeDataModelMatrix[u][C] : A.dataModelMatrix[u][C], y = d && d.getMembers().every((Q) => B.getField(Q)) ? No(E, m, {
          field: d,
          encoding: "y"
        }) : [], D = f && f.getMembers().every((Q) => B.getField(Q)) ? No(E, m, {
          field: f,
          encoding: "y"
        }) : [];
        x0(
          i,
          u,
          d.as(),
          {
            [d]: y,
            [f]: D
          },
          [d, f],
          {
            type: d.type(),
            subtype: [d.subtype(), f?.subtype()]
          }
        );
      });
    }
    return {
      x: n,
      y: i
    };
  }
  count() {
    let t = 0;
    return this.forEach(() => {
      t++;
    }), t;
  }
  getMatrix() {
    return this._matrix;
  }
  findPlaceHolderById(t) {
    let i = null;
    return this.forEach((n) => {
      n.source().id() === t && (i = n.source());
    }), i;
  }
  getAllDataModelIds() {
    const t = [];
    return this.forEach((i) => {
      t.push(i.source().data().id());
    }), t;
  }
  getUnits() {
    const t = [];
    return this.forEach((i) => {
      t.push(i.source());
    }), t;
  }
  findUnitByPayload(t) {
    let i;
    if (t.sourceInfo && t.sourceInfo.unitId) {
      if (t.sourceInfo.unitRowIndex !== void 0 && t.sourceInfo.unitColIndex !== void 0)
        return this._cellMap[t.sourceInfo.unitRowIndex][t.sourceInfo.unitColIndex].source();
      const n = this.findPlaceHolderById(t.sourceInfo.unitId);
      if (n)
        return n;
    } else {
      const n = t.facets || {}, A = Object.keys(n);
      this.forEach((s) => {
        const o = s.source(), r = o.facetFieldsMap();
        A.every((a) => n[a] === r[a]) && (i = o);
      });
    }
    return i = i || this.getUnits()[0], i;
  }
  findCellsByFacets(t) {
    const i = [];
    return this.forEach((n) => {
      const s = n.source().facetFieldsMap();
      Object.keys(t).every(
        (r) => s[r] === t[r]
      ) && i.push(n);
    }), i;
  }
  findCellsByFacetsAndAxis({ facets: t = {}, axis: i = {} }) {
    return this.findCellsByFacets(t).filter((A) => {
      const s = A.source();
      return Object.keys(i).every((o) => {
        const r = s.axes()[o];
        return i[o] === r[0].config().field || i[o] === (r[1] && r[1].config().field);
      });
    });
  }
  getRetinalFieldsDomain(t = {}) {
    let i = {};
    const n = this._paginatedMatrixInfo, { completeDataModelMatrix: A, dataModelMatrix: s } = n, { unionAxisDomainPerPage: o } = this.config().visualGroupConfig.pagination, r = [];
    return (o ? s : A).forEach((l) => {
      l.forEach((c) => {
        const { layerConfig: g, layerDataModels: h } = c, u = g.map((d) => [d.def].flat().map((f) => {
          const I = h[f.id], { encoding: C } = f;
          return Bi.getLayerClass(f.mark).getRetinalFieldsDomain(
            I,
            C,
            {
              config: t
            },
            this._rootGroupedData
          );
        })).flat().filter((d) => d !== null);
        r.push(_g(u));
      });
    }), i = _g(r), i;
  }
  clear() {
    super.clear(), this._matrix = [], this._cellMap = [];
  }
  parentContainerInf(...t) {
    if (t.length) {
      this._parentContainerInf = t[0];
      const { el: i, dimensions: n } = t[0];
      return this.forEach((A) => {
        A.valueOf().parentContainerInf({
          el: i,
          dimensions: n
        });
      }), this;
    }
    return this._parentContainerInf;
  }
}
function pV(e, t, i) {
  let n = "";
  if (e = e.filter((A) => !hn(A)), t === i - 1 && e.length > i) {
    for (let A = t; A < e.length - 1; A++)
      n += `${e[A].displayName()} / `;
    return n += e[e.length - 1].displayName(), n;
  } else if (e[t])
    return e[t].displayName();
  return "";
}
function N0(e = [], t = [], {
  classPrefix: i,
  sanitizeCheckBorder: n,
  textAlign: A = "center",
  dependencies: s,
  renderer: o,
  isDummyFieldFoundInAxis: r
}, a = {}) {
  const { charsAcross: l, charsAlong: c } = a, g = e.length > 0 ? e.map((h, u, d) => {
    const f = yV(h, t[u]), C = d.slice(0, u + 1).map((Q) => ({
      field: Q.type === "axis" ? Q.source().config().field : Q.config().fieldName,
      sourceType: xi
    })), {
      smartLabel: E,
      cellRegistry: { TextCell: B, BlankCell: m }
    } = s;
    if (r)
      return new m();
    a.show = a.show === null ? o === "html" : !!a.show;
    let y = {};
    if (a.fields) {
      if (y = a.fields[t[u] ? t[u].toString() : {}] || {}, y.show = y.show === !0 ? !0 : y.show === !1 ? !1 : a.show, y.show === !1)
        return new m().config({
          type: zg,
          fieldName: h.type === "axis" ? h.source().config().field : h.config().fieldName,
          metaInf: {
            getDataPath: () => C,
            sourceType: xi
          }
        });
    } else if (!a.show)
      return new m();
    const D = pV(t, u, e.length);
    return new B(
      {
        ...KW[a.position === re ? re : Zt],
        verticalAlign: a.position === Zt ? re : "middle",
        textAlign: A,
        type: zg,
        className: `${i}-grid-headers ${a.className || ""} ${y.className || ""}`,
        metaInf: {
          getDataPath: () => C,
          sourceType: xi,
          sortStatus: f,
          directSortEnabled: h.type === "axis" ? h.source().config().fieldInstance.as() === lt.DISCRETE : !0
        },
        fieldName: h.type === "axis" ? h.source().config().field : h.config().fieldName
      },
      {
        labelManager: E
      }
    ).key(D).source(D).rawSource(D).config({
      show: h.config().show,
      numLines: { max: c.max, min: c.min },
      numChars: { max: l.max, min: l.min }
    });
  }) : [];
  return n && gI(g, !0), g;
}
function yV(e, t) {
  const i = e.type;
  if (i === "axis") {
    const { ordering: n } = e.source().config();
    return n && n.type === gi.ALPHABETICAL_ORDER ? {
      sortInfo: n,
      targetField: {
        name: t.getMembers()[0]
      },
      metaInfo: {}
    } : null;
  } else if (i === "text") {
    const { ordering: n } = e.config();
    return n && n.type === gi.ALPHABETICAL_ORDER ? {
      sortInfo: n,
      targetField: {
        name: t.getMembers()[0]
      },
      metaInfo: {}
    } : null;
  } else
    return null;
}
class DV extends sA {
  constructor(...t) {
    super(...t), this._matrices = {
      topLeft: [],
      topRight: [],
      bottomLeft: [],
      bottomRight: []
    };
  }
  getMatrices() {
    return this._matrices;
  }
  generateMatrices({ leftMatrix: t, rightMatrix: i, topMatrix: n, bottomMatrix: A }) {
    const s = {}, {
      cellRegistry: { BlankCell: o }
    } = this._dependencies, {
      renderer: r,
      classPrefix: a,
      rowHeaders: l,
      sanitizeCheckBorder: c,
      rowHeadersConfig: g
      // rowFacetsConfig,
      // yAxisConfig,
      // rowFacetFields,
    } = this.config(), h = (Q, p, w) => {
      const S = w.slice(0, p + 1).map((_) => ({
        field: _.type === "axis" ? _.source().config().field : _.config().fieldName,
        sourceType: xi
      }));
      return new o().config({
        show: Q.config().show,
        type: zg,
        metaInf: {
          getDataPath: () => S
        }
      });
    }, u = W(l, 0, 0);
    let d = !1;
    u && (d = u.getMembers().includes(bt));
    const f = l, I = {
      left: N0(
        t[0],
        f[0],
        {
          classPrefix: a,
          sanitizeCheckBorder: c,
          textAlign: g.align ? g.align : "start",
          dependencies: this._dependencies,
          renderer: r,
          isDummyFieldFoundInAxis: d
        },
        g
      ),
      right: N0(
        i[0],
        f[1],
        {
          classPrefix: a,
          sanitizeCheckBorder: c,
          textAlign: g.align ? g.align : "start",
          dependencies: this._dependencies,
          renderer: r,
          isDummyFieldFoundInAxis: d
        },
        g
      )
    }, C = {
      left: t[0] != null ? t[0].map(h) : [],
      right: i[0] != null ? i[0].map(h) : []
    };
    let E, B, m, y, D;
    (D = n.length - A.length) > 0 ? Array(D).fill([]).map((Q) => {
      A.push(Q);
    }) : Array(-1 * D).fill([]).map((Q) => {
      n.push(Q);
    }), g.position === "bottom" ? (E = n.map(
      () => t[0] != null ? t[0].map(h) : []
    ), B = n.map(
      () => i[0] != null ? i[0].map(h) : []
    ), [m, y] = [le, De].map(
      (Q) => A.map((p, w) => w === 0 ? I[Q] : C[Q])
    )) : ([E, B] = [le, De].map(
      (Q) => n.map((p, w) => w === n.length - 1 ? I[Q] : C[Q])
    ), m = A.map(
      () => t[0] != null ? t[0].map(h) : []
    ), y = A.map(
      () => i[0] != null ? i[0].map(h) : []
    )), s.topLeft = E, s.topRight = B, s.bottomLeft = m, s.bottomRight = y, this._matrices = s;
  }
  clear() {
    super.clear(), this._matrices = {
      topLeft: [],
      topRight: [],
      bottomLeft: [],
      bottomRight: []
    };
  }
}
const wV = (e, t) => {
  if (e.length !== t.length)
    return !1;
  const i = e.length;
  for (let n = 0; n < i; n++) {
    const A = e[n], s = t[n];
    if (A.field !== s.field || !Wa(A.value, s.value))
      return !1;
  }
  return !0;
};
class xV extends sA {
  constructor(t) {
    super(t), this._matrices = {
      row: new EV(t),
      column: new BV(t),
      geom: new QV(t),
      headerTitle: new DV(t)
    }, this.registerDirectSortResets();
  }
  context(...t) {
    return t.length ? (this._context = t[0], this) : this._context;
  }
  updateMatrices({
    axesInfo: t,
    headers: i,
    dataModelMatrix: n,
    layerDomains: A,
    facets: s,
    rowFacetsConfig: o,
    colFacetsConfig: r,
    facetFormatters: a,
    facetHyperLinkFormatters: l,
    canvasActions: c,
    rootGroupedData: g,
    totalsData: h,
    rootMatrixInfo: u,
    paginatedMatrixInfo: d,
    updateInfo: f,
    facetType: I,
    paginated: C,
    targetPath: E,
    subTotalsInfo: B = {
      isColSubTotalsEnabled: !1,
      isRowSubTotalsEnabled: !1,
      rowSplitSubtotalsField: void 0,
      colSplitSubtotalsField: void 0,
      rowSubTotalsDS: null,
      colSubTotalsDS: this._columnSubTotalsDataModel
    }
  }) {
    this._paginatedMatrixInfo = d;
    const { x: m, y } = t, { rowKeys: D, columnKeys: Q } = i, p = this.config(), w = p.rows.axes.globalConfig, x = f0(
      w.rows.headers,
      w.rows.facets,
      w.axes.y
    ), S = this._matrices.row, _ = this._matrices.column;
    I === "row" ? S.updateMatrices({
      axesInfo: y,
      headers: D,
      facets: s,
      rowFacetsConfig: o,
      facetFormatters: a,
      facetHyperLinkFormatters: l
    }) : _.updateMatrices({
      axesInfo: m,
      headers: Q,
      facets: s,
      colFacetsConfig: r,
      facetFormatters: a,
      facetHyperLinkFormatters: l
    });
    const { bottom: M, top: k } = _._matrices.axes._cells, { left: T, right: G } = S._matrices.axes._cells, N = S.getBorderConfig();
    this._matrices.geom.updateMatrix({
      axes: {
        x: {
          bottom: M.map((L) => L.source()),
          top: k.map((L) => L.source())
        },
        y: {
          left: T.map((L) => L.source()),
          right: G.map((L) => L.source())
        }
      },
      facets: s,
      borderConfig: N,
      dataModelMatrix: n,
      layerDomains: A,
      rootGroupedData: g,
      totalsData: h,
      rootMatrixInfo: u,
      paginatedMatrixInfo: d,
      canvasActions: c,
      updateInfo: f,
      facetType: I,
      paginated: C,
      targetPath: E,
      subTotalsInfo: B
    });
    const { topMatrix: F, bottomMatrix: R } = _.getMergedMatrices(), { leftMatrix: v, rightMatrix: O } = S.getMergedMatrices();
    this.generateHeaderTitleMatrices({
      topMatrix: F,
      leftMatrix: v,
      rightMatrix: O,
      bottomMatrix: R,
      config: {
        ...p.headerTitle,
        rowHeadersConfig: x,
        rowFacetsConfig: o,
        yAxisConfig: w.axes.y,
        rowFacetFields: this._matrices.row.getFacetFields().map((L) => L.toString())
      }
    }), S._headerTitleMatrices = this._matrices.headerTitle, this.extractNestedSortStatusForAxis(), this.disableDirectSortForAxisIfNeeded();
  }
  generateMatrices({
    axesInfo: t,
    headers: i,
    dataModelMatrix: n,
    layerDomains: A,
    facets: s,
    rowFacetsConfig: o,
    colFacetsConfig: r,
    facetFormatters: a,
    facetHyperLinkFormatters: l,
    childEventManagerCreator: c,
    canvasActions: g,
    rootGroupedData: h,
    totalsData: u,
    rootMatrixInfo: d,
    paginatedMatrixInfo: f
  }) {
    this._paginatedMatrixInfo = f;
    const { x: I, y: C } = t, { rowKeys: E, columnKeys: B } = i, m = this.config(), y = m.rows.axes.globalConfig;
    this._globalConfig = y;
    const D = f0(
      y.rows.headers,
      y.rows.facets,
      y.axes.y
    );
    let Q = !1, p;
    n.forEach((R) => {
      R.forEach((v) => {
        const { layerConfig: O } = v;
        O.forEach((L) => {
          [L.def || L].flat().forEach((U) => {
            ["x", "y"].forEach((H) => {
              Q = Bi.getLayerClass(U.mark).shouldShowAxisTicksInPercentage(
                v.dataStore,
                U.encoding[H].field,
                L
              ), Q && (p = U.encoding[H].var);
            });
          });
        });
      });
    }), this.generateRowMatrix({
      axesInfo: C,
      config: {
        ...m.rows,
        rowHeadersConfig: D,
        fieldToShowInPercentage: p
      },
      headers: E,
      facets: s,
      rowFacetsConfig: o,
      columnSubTotalsConfig: y.columns.totals.subTotals,
      facetFormatters: a,
      facetHyperLinkFormatters: l,
      childEventManagerCreator: c,
      canvasActions: g
    }), this.generateColumnMatrix({
      axesInfo: I,
      config: {
        ...m.columns,
        columnVariables: m.headerTitle.columnHeaders || [],
        rowHeadersConfig: D,
        fieldToShowInPercentage: p
      },
      headers: B,
      facets: s,
      colFacetsConfig: r,
      rowSubTotalsConfig: y.rows.totals.subTotals,
      facetFormatters: a,
      facetHyperLinkFormatters: l,
      childEventManagerCreator: c,
      canvasActions: g
    });
    const w = this.row(), x = this.column(), { bottom: S, top: _ } = x._matrices.axes._cells, { left: M, right: k } = w._matrices.axes._cells, T = w.getBorderConfig();
    this.generateGeomMatrix({
      facets: s,
      borderConfig: T,
      dataModelMatrix: n,
      layerDomains: A,
      config: {
        ...m.geoms,
        theme: y.theme
      },
      axes: {
        x: {
          bottom: S.map((R) => R.source()),
          top: _.map((R) => R.source())
        },
        y: {
          left: M.map((R) => R.source()),
          right: k.map((R) => R.source())
        }
      },
      childEventManagerCreator: c,
      rootGroupedData: h,
      totalsData: u,
      rootMatrixInfo: d,
      paginatedMatrixInfo: f,
      canvasActions: g
    });
    const { topMatrix: G, bottomMatrix: N } = x.getMergedMatrices(), { leftMatrix: b, rightMatrix: F } = w.getMergedMatrices();
    this.generateHeaderTitleMatrices({
      topMatrix: G,
      leftMatrix: b,
      rightMatrix: F,
      bottomMatrix: N,
      config: {
        ...m.headerTitle,
        rowHeadersConfig: D,
        rowFacetsConfig: o,
        yAxisConfig: y.axes.y,
        rowFacetFields: this._matrices.row.getFacetFields().map((R) => R.toString())
        // yAxisFields: this._matrices.row
        //   .getAxisFields()
        //   .map((f) => f.toString()),
      }
    }), w._headerTitleMatrices = this._matrices.headerTitle, this.extractNestedSortStatusForAxis(), this.disableDirectSortForAxisIfNeeded();
  }
  extractNestedSortStatusForAxis() {
    const t = this._matrices.row, i = this._matrices.column, { facetConfig: n } = t.config().headers, { facetConfig: A } = i.config().headers, s = [], o = [], r = this._matrices.geom._rootGroupedData;
    [
      [t, o],
      [i, s]
    ].forEach(([c, g]) => {
      const h = new Set(
        c.getAxisFields().flat(1 / 0).map((C) => C.getMembers()).flat(2)
      ), u = c.getAxes(), d = [];
      for (let C = 0; C < u.length; C++) {
        const E = u[C], B = E.config().field;
        if (h.has(B) && (d.push({
          fieldName: B,
          ordering: E.config().ordering
        }), h.delete(B), h.size === 0))
          break;
      }
      const f = c._matrices.headers._cells, I = [
        f.left,
        f.right,
        f.top,
        f.bottom
      ].filter((C) => C && C.length > 0);
      if (I.length > 0) {
        const C = I[0];
        if (C.length > 0) {
          const E = C[0];
          if (E.length > 0) {
            const B = E[E.length - 1], { fieldName: m, ordering: y } = B.config();
            d.push({
              fieldName: m,
              ordering: y
            });
          }
        }
      }
      d.filter((C) => C.ordering && C.fieldName).forEach(({ fieldName: C, ordering: E }) => {
        if (E.type === gi.NESTED_ORDER) {
          const B = W(E, "nested", "filters") || [];
          g.push({
            sortInfo: E,
            targetField: {
              name: C
            },
            path: B
          });
        }
      });
    });
    const a = i.getAxes(), l = t.getAxes();
    [
      [a, o, A],
      [l, s, n]
    ].forEach(([c, g, h]) => {
      for (let u = 0; u < c.length; u++) {
        const d = c[u], { fields: f } = h;
        if (!(d instanceof ee || d instanceof qt || d instanceof $i))
          continue;
        const I = d.config().metaInf.facets.map((E) => {
          const B = E.field.getMembers()[0], m = E.value, y = B && f && f[B] && f[B].formatter ? f[B].formatter : h.formatter || (({ rawValue: D }) => D);
          return {
            field: B,
            value: m,
            formatter: (D) => y(
              {
                formattedValue: gh(
                  D,
                  B,
                  r
                ),
                rawValue: D
              },
              {
                fieldName: B,
                dateTimeFormatter: J.DateTimeFormatter.formatAs,
                dataModel: r
              }
            )
          };
        });
        let C = null;
        for (let E = 0; E < g.length; E++) {
          const B = g[E], { sortInfo: m, targetField: y, path: D } = B;
          if (!D.length)
            continue;
          let Q, p;
          if (d instanceof ee || d instanceof qt ? (Q = D.slice(0, D.length - 1), p = D[D.length - 1].value) : (Q = D.slice(), p = W(m, "nested", "field", "name")), wV(I, Q)) {
            C = {
              sortInfo: m,
              targetField: y,
              facetsPath: I,
              axisTarget: {
                value: p
              }
            };
            break;
          }
        }
        d.currentNestedSortInfo(C);
      }
    });
  }
  disableDirectSortForAxisIfNeeded() {
    const t = this._matrices.row, i = this._matrices.column, [n, A] = [t, i].map(
      (s) => [
        ...new Set(
          [...s.getAxisFields(), ...s.getFacetFields()].flat(4)
        )
      ].filter((a) => a.getMembers()[0] !== bt).some(
        (a) => a.as() === lt.DISCRETE
      )
    );
    [
      [t, A],
      [i, n]
    ].forEach(([s, o]) => {
      s.getAxes().forEach((r) => {
        r.directSortEnabled(o);
      });
    });
  }
  generateRowMatrix({
    axesInfo: t,
    config: i,
    headers: n,
    facets: A,
    rowFacetsConfig: s,
    columnSubTotalsConfig: o,
    facetFormatters: r,
    facetHyperLinkFormatters: a,
    childEventManagerCreator: l,
    canvasActions: c
  }) {
    const g = this._matrices.row;
    g.config(i), g.generateMatrices({
      axesInfo: t,
      headers: n,
      facets: A,
      rowFacetsConfig: s,
      columnSubTotalsConfig: o,
      facetFormatters: r,
      facetHyperLinkFormatters: a,
      childEventManagerCreator: l,
      canvasActions: c
    });
  }
  generateColumnMatrix({
    axesInfo: t,
    config: i,
    headers: n,
    facets: A,
    colFacetsConfig: s,
    rowSubTotalsConfig: o,
    facetFormatters: r,
    facetHyperLinkFormatters: a,
    childEventManagerCreator: l,
    canvasActions: c
  }) {
    const g = this._matrices.column;
    g.config(i), g.generateMatrices({
      axesInfo: t,
      headers: n,
      facets: A,
      colFacetsConfig: s,
      rowSubTotalsConfig: o,
      facetFormatters: r,
      facetHyperLinkFormatters: a,
      childEventManagerCreator: l,
      canvasActions: c
    });
  }
  generateHeaderTitleMatrices({
    leftMatrix: t,
    rightMatrix: i,
    topMatrix: n,
    bottomMatrix: A,
    config: s = {}
  }) {
    const o = this.headerTitle();
    o.config(s), o.generateMatrices({
      leftMatrix: t,
      rightMatrix: i,
      topMatrix: n,
      bottomMatrix: A
    });
  }
  generateGeomMatrix({
    axes: t,
    facets: i,
    borderConfig: n,
    dataModelMatrix: A,
    layerDomains: s,
    config: o = {},
    childEventManagerCreator: r,
    rootGroupedData: a,
    totalsData: l,
    rootMatrixInfo: c,
    paginatedMatrixInfo: g,
    paginatedLayerDomains: h,
    canvasActions: u
  }) {
    const d = this._matrices.geom;
    d.config(o), d.generateMatrix({
      axes: t,
      facets: i,
      borderConfig: n,
      dataModelMatrix: A,
      layerDomains: s,
      childEventManagerCreator: r,
      rootGroupedData: a,
      totalsData: l,
      rootMatrixInfo: c,
      paginatedMatrixInfo: g,
      paginatedLayerDomains: h,
      canvasActions: u
    });
  }
  setPaginatedMatrixInfo(t) {
    this._paginatedMatrixInfo = t, this.geom()._paginatedMatrixInfo = t;
  }
  getMatrices() {
    const { row: t, column: i, geom: n, headerTitle: A } = this._matrices, { leftMatrix: s, rightMatrix: o } = t.merge(), { topMatrix: r, bottomMatrix: a } = i.merge();
    return {
      rows: [s, o],
      columns: [r, a],
      values: n.getMatrix(),
      headerTitles: A.getMatrices(),
      priority: {
        row: t.getPriority(),
        col: i.getPriority()
      }
    };
  }
  row() {
    return this._matrices.row;
  }
  column() {
    return this._matrices.column;
  }
  geom() {
    return this._matrices.geom;
  }
  headerTitle() {
    return this._matrices.headerTitle;
  }
  // sortAxisDomainsBasedOnRootData(groupedModel, union) {
  //   const { row, column } = this._matrices;
  //   ["x", "y"].forEach((axisType) => {
  //     let axes;
  //     if (axisType === "x") {
  //       axes = [
  //         column._matrices.axes._cells.bottom,
  //         column._matrices.axes._cells.top,
  //       ];
  //     } else {
  //       axes = [
  //         row._matrices.axes._cells.left,
  //         row._matrices.axes._cells.right,
  //       ];
  //     }
  //     union[axisType] = union[axisType].map((domains, axisIdx) => {
  //       return domains.map((domain, domainTypeIdx) => {
  //         const axisCell = axes[domainTypeIdx][axisIdx];
  //         if (axisCell && axisCell.source() instanceof BandAxis) {
  //           const field = axisCell.source().config().field;
  //           const rootUniques = groupedModel.getField(field).uniques();
  //           const invalidValIndx = domain.findIndex((d) =>
  //             DataStore.isInvalid(d)
  //           );
  //           const domainSet = new Set(domain);
  //           const sortedDomain = [];
  //           for (let i = 0; i < rootUniques.length; i++) {
  //             const val = rootUniques[i];
  //             if (
  //               (!DataStore.isInvalid(val) && domainSet.has(val)) ||
  //               (DataStore.isInvalid(val) && invalidValIndx !== -1)
  //             ) {
  //               sortedDomain.push(val);
  //             }
  //             if (sortedDomain.length === domain.length) {
  //               break;
  //             }
  //           }
  //           return sortedDomain;
  //         } else {
  //           return domain;
  //         }
  //       });
  //     });
  //   });
  // }
  /**
   * Unions the x and y axis domains and sets it on the axis
   *
   * @param {boolean} calculateUniformAxisDomains
   */
  setAxisDomains(t = !0, i, n = {}) {
    const A = this._dependencies.store, { row: s, column: o, geom: r } = this._matrices, a = this.column().config().axes, l = this.row().config().axes, c = {
      x: a.globalConfig.axes.x,
      y: l.globalConfig.axes.y
    }, g = r.getXYDomains({
      ...n,
      calculateUniformAxisDomains: t
    }), h = jW(
      g,
      c,
      t
    ), { pageStartIndex: u, pageEndIndex: d } = this._paginatedMatrixInfo;
    h.y.length >= d && (h.y = h.y.slice(u, d)), this.sortAxisDomains(i, h), A.lockModel();
    const f = [h.x, h.y];
    [o, s].forEach((I, C) => {
      const E = I._matrices.axes;
      E.setDomains(f[C], A, {
        overrideUserDomain: !!E.config().fieldToShowInPercentage
      });
    }), A.unlockModel();
  }
  registerHooksEvents(t) {
    const i = this._matrices, n = this._dependencies.store, A = [
      i.column.getBottomAxes().map((o) => o.source()),
      i.column.getTopAxes().map((o) => o.source())
    ].reduce((o, r) => (r.length && o.push(r), o), []), s = [
      i.row.getLeftAxes().map((o) => o.source()),
      i.row.getRightAxes().map((o) => o.source())
    ].reduce((o, r) => (r.length && r.forEach((a, l) => {
      const c = o[l] || [];
      c.push(a), o[l] = c;
    }), o), []);
    [
      ["x", A],
      ["y", s]
    ].forEach(([o, r]) => {
      [[xt.AXIS, o]].forEach((a) => {
        [
          gt.BEFORE_RENDERED,
          gt.AFTER_RENDERED,
          gt.ANIMATION_END
        ].forEach((l) => {
          this.registerAggHooksEvents(
            t,
            r,
            { componentPath: a, hookName: l },
            () => {
              const { rowStart: c, rowEnd: g, colStart: h, colEnd: u } = n.get(
                `${Yt}.viewport`
              );
              return {
                rowRange: o === "x" ? [0, r.length - 1] : [c, g],
                colRange: o === "x" ? [h, u] : [0, r[0].length - 1]
              };
            }
          );
        });
      });
    }), this.registerAggHooksEventsForLayers(t), [
      gt.BEFORE_RENDERED,
      gt.AFTER_RENDERED,
      gt.ANIMATION_END
    ].forEach((o) => {
      this.registerAggHooksEvents(
        t,
        i.geom._matrix.map((r) => r.map((a) => a.source())),
        { componentPath: [xt.UNIT], hookName: o },
        () => {
          const { rowStart: r, rowEnd: a, colStart: l, colEnd: c } = n.get(
            `${Yt}.viewport`
          );
          return {
            rowRange: [r, a],
            colRange: [l, c]
          };
        }
      );
    });
  }
  setCanvasDimensionsToAxes(t, i) {
    const n = this._matrices;
    let A = [];
    switch (i) {
      case "row":
        A = [
          ...n.row.getLeftAxes().map((o) => o.source()),
          ...n.row.getRightAxes().map((o) => o.source())
        ];
        break;
      case "column":
        A = [
          ...n.column.getBottomAxes().map((o) => o.source()),
          ...n.column.getTopAxes().map((o) => o.source())
        ];
        break;
      default:
        A = [
          ...n.row.getLeftAxes().map((o) => o.source()),
          ...n.row.getRightAxes().map((o) => o.source()),
          ...n.column.getBottomAxes().map((o) => o.source()),
          ...n.column.getTopAxes().map((o) => o.source())
        ];
        break;
    }
    const s = t._canvasHelpers.getCanvasDimensions();
    A.forEach((o) => {
      o && o.config({
        metaInf: {
          canvasDimensions: s
        }
      });
    });
  }
  registerAggHooksEvents(t, i, n, A) {
    const s = new Ie({
      componentPath: n.componentPath,
      modifier: fe.EACH,
      hookName: n.hookName
    });
    i.forEach((o) => {
      o.forEach((r) => {
        if (r) {
          const a = r.eventManager().listeners(s).find(
            (l) => W(l, "meta", "tag") === cc
          );
          a && r.eventManager().off(s, a.listener);
        }
      });
    }), ZQ(
      s,
      i,
      ({ eventObjects: o, ranges: { rowRange: r, colRange: a } }) => {
        let l = i.slice(r[0], r[1] + 1).map((c) => c.slice(a[0], a[1] + 1));
        t.emitEvent({
          name: new Ie({
            componentPath: s.componentPath,
            modifier: fe.ALL,
            hookName: s.hookName
          }),
          target: l.flat(1).filter((c) => !!c),
          data: { aggEventObjects: o },
          virtualScrolling: { viewportRange: { rowRange: r, colRange: a } }
        });
      },
      A,
      { tag: cc }
    );
  }
  registerAggHooksEventsForLayers(t) {
    const i = this._matrices, n = this._dependencies.store, A = i.geom._matrix.map(
      (o) => o.map((r) => r.source())
    );
    ["all", ...[
      ...A.flat().map((o) => o.layers()).flat(1).reduce((o, r) => (o.add(r.config().mark), o), /* @__PURE__ */ new Set())
    ]].forEach((o) => {
      [
        gt.BEFORE_RENDERED,
        gt.AFTER_RENDERED,
        gt.ANIMATION_END
      ].forEach((r) => {
        const a = new Ie({
          componentPath: o === "all" ? [
            xt.UNIT,
            xt.LAYER
          ] : [
            xt.UNIT,
            xt.LAYER,
            o
          ],
          modifier: fe.ALL,
          hookName: r
        });
        A.forEach((l) => {
          l.forEach((c) => {
            const g = c.eventManager().listeners(a).find(
              (h) => W(h, "meta", "tag") === cc
            );
            g && c.eventManager().off(a, g.listener);
          });
        }), ZQ(
          a,
          A,
          ({ eventObjects: l, ranges: { rowRange: c, colRange: g } }) => {
            let h = A.slice(c[0], c[1] + 1).map((u) => u.slice(g[0], g[1] + 1)).flat(1).map(
              (u) => o === "all" ? u.layers() : u.layers().filter((d) => d.config().mark === o)
            ).flat(1);
            t.emitEvent({
              name: new Ie({
                componentPath: o === "all" ? [xt.LAYER] : [xt.LAYER, o],
                modifier: fe.ALL,
                hookName: r
              }),
              target: h,
              data: {
                aggEventObjects: l.map((u) => u.data.aggEventObjects).flat(1)
              },
              virtualScrolling: { viewportRange: { rowRange: c, colRange: g } }
            });
          },
          () => {
            const { rowStart: l, rowEnd: c, colStart: g, colEnd: h } = n.get(
              `${Yt}.viewport`
            );
            return {
              rowRange: [l, c],
              colRange: [g, h]
            };
          },
          { tag: cc },
          !0
        );
      });
    });
  }
  sortAxisDomains({ rootModel: t, columnGTRootModel: i, rowGTRootModel: n }, A) {
    const { row: s, column: o } = this._matrices, r = {
      x: /* @__PURE__ */ new Map(),
      y: /* @__PURE__ */ new Map()
    }, a = this._globalConfig, l = a.rows.totals.data.totalString, c = a.rows.totals.subTotals.position, g = a.columns.totals.data.totalString, h = a.columns.totals.subTotals.position;
    ["x", "y"].forEach((u) => {
      let d, f, I = t, { totalString: C } = u === "y" ? o._matrices.axes.config().globalConfig.columns.totals.data : s._matrices.axes.config().globalConfig.rows.totals.data;
      const E = (B) => B.value === C;
      if (u === "x") {
        const { axisFrom: B } = o._matrices.axes.config(), { takeHeaderFrom: m } = o._matrices.headers.config();
        B === "top" ? d = [
          o._matrices.axes._cells.top,
          o._matrices.axes._cells.bottom
        ] : d = [
          o._matrices.axes._cells.bottom,
          o._matrices.axes._cells.top
        ], m === "top" ? f = [
          o._matrices.headers._cells.top,
          o._matrices.headers._cells.bottom
        ] : f = [
          o._matrices.headers._cells.bottom,
          o._matrices.headers._cells.top
        ];
      } else
        d = [
          s._matrices.axes._cells.left,
          s._matrices.axes._cells.right
        ], f = [
          s._matrices.headers._cells.left,
          s._matrices.headers._cells.right
        ];
      A[u] = A[u].map((B, m) => B.map((y, D) => {
        const Q = d[D][m], p = f[D][m];
        if (Q && (Q.source() instanceof ee || Q.source() instanceof qt)) {
          const x = Q.source().config(), S = x.field, _ = p == null ? [] : p.map((G, N) => ({
            field: G.config().facetFields[N].getMembers()[0],
            value: G.rawSource()
          }));
          let M = x.ordering;
          if (M.type === gi.NESTED_ORDER && M[gi.NESTED_ORDER]) {
            const G = M[gi.NESTED_ORDER];
            (G.filters == null ? [] : G.filters).some(E) && (I = u === "x" ? i : n);
          }
          const k = r[u];
          return k.has(S) || k.set(
            S,
            ru(
              { name: S },
              { ...M, totalString: C },
              I,
              u === "x" ? {
                totalString: l,
                subTotalsPosition: c
              } : {
                totalString: g,
                subTotalsPosition: h
              }
            )
          ), k.get(S)(y, _);
        } else
          return y;
      }));
    });
  }
  checkIfExtendDomainNeeded() {
    return !!this.geom().getUnits().find((i) => !!i.layers().find((A) => A.requiresExtendDomainDiffs()));
  }
  checkIfExtendedAxisDomainCachePresent() {
    return [...this.row().getAxes(), ...this.column().getAxes()].every((i) => i.cachedExtendedDomainDiffs());
  }
  clearExtendedAxisDomainCache() {
    [...this.row().getAxes(), ...this.column().getAxes()].forEach((i) => {
      i.cachedExtendedDomainDiffs(null);
    });
  }
  extendAxisDomainsIfNeeded() {
    if (!this.checkIfExtendDomainNeeded())
      return;
    const { AxisCell: t } = this._dependencies.cellRegistry, { row: i, column: n } = this._matrices, A = this.checkIfExtendedAxisDomainCachePresent();
    let s;
    A || (s = this._matrices.geom._matrix.map(
      (o) => o.map((r) => r.source().calculateExtendDomainDiffs())
    )), ["top", "bottom"].forEach((o) => {
      const r = n._matrices.axes, { fieldToShowInPercentage: a } = r.config();
      n._matrices.axes._cells[o].forEach((l, c) => {
        if (!(l instanceof t))
          return;
        const g = l.source();
        let h;
        A ? h = g.cachedExtendedDomainDiffs() : h = yi(
          s.map((u) => u[c][`${o}Axis`])
        ), (h[0] || h[1]) && g.extendDomain(h, { fieldToShowInPercentage: a }), g.cachedExtendedDomainDiffs(h);
      });
    }), ["left", "right"].forEach((o) => {
      const r = n._matrices.axes, { fieldToShowInPercentage: a } = r.config();
      i._matrices.axes._cells[o].forEach((l, c) => {
        if (!(l instanceof t))
          return;
        const g = l.source();
        let h;
        A ? h = g.cachedExtendedDomainDiffs() : h = yi(
          s[c].map(
            (u) => u[`${o}Axis`]
          )
        ), (h[0] || h[1]) && g.extendDomain(h, { fieldToShowInPercentage: a }), g.cachedExtendedDomainDiffs(h);
      });
    });
  }
  clear() {
    super.clear(), Object.values(this._matrices).forEach((t) => {
      t.clear();
    });
  }
  parentContainerInf(...t) {
    return t.length ? (this._parentContainerInf = t[0], this.row().parentContainerInf(t[0]), this.column().parentContainerInf(t[0]), this.geom().parentContainerInf(t[0]), this) : this._parentContainerInf;
  }
  registerDirectSortResets() {
    this.row().directSortResetter(this.resetDirectSort.bind(this)), this.column().directSortResetter(this.resetDirectSort.bind(this));
  }
  resetDirectSort() {
    [this.row(), this.column()].forEach((t) => {
      const i = t._firebolt, n = t._sortDropdown;
      i && n && n.isVisible() && Kb(i);
    });
  }
  dispose() {
    [this.row(), this.column()].forEach((t) => {
      const n = t._firebolt.sideEffects();
      for (let A in n)
        n[A].dispose();
    });
  }
}
const SV = (e, t, i, n, A, s, o, r) => {
  const a = [], l = [], c = e.length || 1, g = s.findIndex(
    (h) => `${h}` === o
  );
  for (let h = 0; h < c; h++)
    for (let u = 0; u < t.length; u++) {
      const [d, f] = t[u], I = i(e[h]), C = o != null && g > 0 && e[h][g - 1] === A;
      a.push(
        I && d?.isDiscrete() && `${d}` !== o ? {
          field: d,
          config: {
            internalFormat: () => n,
            showAxisName: !1,
            sourceType: Jn
          }
        } : {
          field: d,
          config: {
            internalFormat: ({ rawValue: E }) => C ? r : E === A ? n : E
          }
        }
      ), l.push(
        I && f?.isDiscrete() && `${f}` !== o ? {
          field: f,
          config: {
            internalFormat: () => n,
            showAxisName: !1,
            sourceType: Jn
          }
        } : {
          field: f,
          config: {
            internalFormat: ({ rawValue: E }) => C ? r : E === A ? n : E
          }
        }
      );
    }
  return {
    leftAxisInfo: a,
    rightAxisInfo: l
  };
}, MV = (e, t, i, n, A, s, o, r) => {
  const a = [], l = [], c = e.length ? e[e.length - 1].length : 1, g = s.findIndex(
    (h) => `${h}` === o
  );
  for (let h = 0; h < c; h++)
    for (let u = 0; u < t.length; u++) {
      const [d, f] = t[u], I = e.map((B) => B[h]), C = i(I), E = o != null && g > 0 && I[g - 1] === A;
      a.push(
        C && d?.isDiscrete() && `${d}` !== o ? {
          field: d,
          config: {
            internalFormat: () => n,
            showAxisName: !1,
            sourceType: Jn
          }
        } : {
          field: d,
          config: {
            internalFormat: ({ rawValue: B }) => E ? r : B === A ? n : B
          }
        }
      ), l.push(
        C && f?.isDiscrete() && `${f}` !== o ? {
          field: f,
          config: {
            internalFormat: () => n,
            showAxisName: !1,
            sourceType: Jn
          }
        } : {
          field: f,
          config: {
            internalFormat: ({ rawValue: B }) => E ? r : B === A ? n : B
          }
        }
      );
    }
  return {
    topAxisInfo: a,
    bottomAxisInfo: l
  };
}, lN = (e, { bottomAxisInfo: t, topAxisInfo: i }, n, A, s, o, r, a) => {
  const l = i.length ? i : t, c = e.length ? e[0].map((u, d) => e.map((f) => f[d])) : [], g = l.length / c.length;
  return c.length ? l.map(
    (u, d) => gN(
      c[Math.floor(d / g)],
      n,
      A,
      s,
      o,
      r,
      a
    )
  ) : [];
}, cN = (e, { leftAxisInfo: t }, i, n, A, s, o, r) => {
  const a = t.length / e.length;
  return e.length ? t.map(
    (l, c) => gN(
      e[Math.floor(c / a)],
      i,
      n,
      A,
      s,
      o,
      r
    )
  ) : [];
}, gN = (e, t, i, n, A, s = [], o) => {
  let r = [];
  const a = s.findIndex(
    (l) => `${l}` === A
  );
  for (let l = 0; l < e?.length; l++) {
    const c = A != null && a > 0 && e[a - 1] === o;
    if (r.push(
      e[l] === o ? c ? n : i : e[l]
    ), t && t(r)) {
      const g = e.slice(l + 1);
      if (!g.every((u) => u === o)) {
        const u = g.findIndex(
          (d, f, I) => f === 0 && d !== o || f > 0 && d !== o && I[f - 1] === o
        );
        r = [
          ...r,
          ...g.slice(0, u).map(() => ({
            value: o,
            format: () => i,
            sourceType: Jn,
            rawValue: o
          })),
          {
            value: g[u],
            format: () => g[u],
            sourceType: Jn,
            rawValue: g[u]
          },
          ...g.slice(u + 1).map(() => ({
            value: o,
            format: () => i,
            sourceType: Jn,
            rawValue: o
          }))
        ];
      } else
        r = r.concat(
          new Array(e.length - (l + 1)).fill({
            value: o,
            format: () => i,
            sourceType: Jn,
            rawValue: o
          })
        );
      break;
    }
  }
  return r;
}, F0 = ({
  rowKeys: e,
  columnKeys: t,
  rowFacets: i,
  colFacets: n,
  rowProjections: A,
  colProjections: s,
  rowCollapseStatus: o,
  columnCollapseStatus: r,
  globalConfig: a
}) => {
  const {
    rowSubTotalsText: l,
    columnSubTotalsText: c,
    columnTotalString: g,
    rowTotalString: h
  } = uA(a), {
    columns: {
      totals: {
        subTotals: {
          splitTotal: {
            field: u,
            text: d
          }
        }
      }
    },
    rows: {
      totals: {
        subTotals: {
          splitTotal: {
            field: f,
            text: I
          }
        }
      }
    }
  } = a, C = MV(
    t,
    s,
    r,
    l,
    h,
    n,
    f,
    I
  ), E = SV(
    e,
    A,
    o,
    c,
    g,
    i,
    u,
    d
  );
  let B = cN(
    e,
    E,
    o,
    c,
    d,
    u,
    i,
    g
  ), m = lN(
    t,
    C,
    r,
    l,
    I,
    f,
    n,
    h
  );
  return {
    rowHeaderKeys: B,
    columnHeaderKeys: m,
    columnAxisInfo: C,
    rowAxisInfo: E
  };
}, hN = (e, t, i, n, A, { totalString: s = "All", aggregations: o = {}, isRow: r }, a, l, c) => {
  const g = J.DataModel(), h = e._model._config, { data: u, schema: d } = e.getData({
    shouldSanitize: !0,
    excludeFields: [St.ROW_ID]
  }), f = d.map(
    (Q) => o[Q.name] ? { ...Q, defAggFn: o[Q.name] } : { ...Q }
  ), I = f.map(
    (Q, p) => (
      // rootDmData.map((r) => (DataStore.isInvalid(r[idx]) ? null : r[idx]))
      u.map((w) => w[p])
    )
  ), C = new g(
    {
      data: I,
      schema: f
    },
    h
  ), E = t.concat(c), B = C.project([
    .../* @__PURE__ */ new Set([
      ...E,
      ...A,
      ...n
    ])
  ]).splitByRow(E.filter((Q) => Q != bt));
  let m = B.reduce((Q, p) => {
    const w = {};
    (r === !0 ? E : E.filter(
      (G) => !i.includes(G) || G === a
    )).forEach((G) => {
      const N = p.getField(G).data(void 0, !0)[0];
      w[G] = N;
    }), (r === !0 ? i.filter((G) => !E.includes(G)) : i.filter((G) => G !== a)).forEach((G) => {
      w[G] = s;
    });
    const _ = p.groupBy([...n]), { data: M, schema: k } = _.getData(
      void 0,
      { shouldSanitize: !0 }
    ), T = M.map((G, N) => k.filter(
      ({ name: b, type: F }) => F === "measure" || n.includes(b)
    ).reduce(
      (b, { name: F }) => {
        const R = _.getField(F).data(void 0, !0)[N];
        return {
          ...b,
          // [name]: typeof value === "object" ? null : value,
          [F]: R
        };
      },
      { ...w }
    ));
    return [...Q, ...T];
  }, []).flat();
  const y = [
    ...new Set(
      [
        ...t,
        ...i,
        ...A,
        ...n
      ].filter(
        (Q) => Q != null && c.indexOf(Q) === -1
      )
    )
  ].map((Q) => {
    let p = f.find((w) => w.name === Q);
    return o[p.name] && (p = { ...p, defAggFn: o[p.name] }), p.subtype === "temporal" ? { ...p, subtype: "categorical" } : { ...p };
  });
  if (c?.forEach((Q) => {
    let p = f.find((w) => w.name === Q);
    o[p.name] ? y.push({ ...p, defAggFn: o[p.name] }) : y.push({ ...p });
  }), t.filter((Q) => Q != bt).length > 0) {
    const Q = {}, p = C.groupBy([
      .../* @__PURE__ */ new Set([
        ...n,
        ...c,
        a,
        l
      ])
    ]);
    [...t, ...i].filter((x) => x !== a || x !== l).forEach((x) => {
      Q[x] = s;
    });
    const w = p.getData(void 0, { shouldSanitize: !0 }).data.map((x, S) => y.filter(
      ({ name: _, type: M }) => M === "measure" || n.includes(_) || c.includes(_) || a === _ || l === _
    ).reduce(
      (_, { name: M }) => {
        const k = p.getField(M).data(void 0, !0);
        return {
          ..._,
          [M]: J.isInvalid(k[S]) ? null : k[S]
        };
      },
      { ...Q }
    ));
    m.push(...w);
  }
  m = y.map(({ name: Q }) => m.map((p) => p[Q]));
  const D = new g({ data: m, schema: y }, h);
  return B.length = 0, C.dispose(), D;
}, aB = (e, t, i, n, A) => {
  const s = [
    ...[
      ...t.discreteRowProjections,
      ...t.rowFacets
    ].filter((r) => `${r}` !== n),
    ...[
      ...t.discreteColumnProjections,
      ...t.colFacets
    ].filter((r) => `${r}` !== i)
  ], o = [
    ...new Set(
      s.flatMap(
        (r) => typeof r == "string" ? r : r.getMembers()
      ).filter((r) => r !== bt)
    )
  ];
  return o.length ? Mr(
    [o, o.map(() => A)],
    e,
    "neq",
    "or"
  ) : null;
};
const mo = "columnGrandTotals", Qo = "rowGrandTotals", na = "greatGrandTotals", _V = (e, t, i) => e ? e.select({
  conditions: i.map((s) => ({
    field: s.field,
    value: s.value,
    operator: "eq"
  })),
  operator: "or"
}).getField(t)?.uniques() ?? [] : [];
class vu {
  constructor() {
    this._rowCollapseStatus = () => !1, this._columnCollapseStatus = () => !1, this._rowFacets = null, this._columnFacets = null, this._mainFacetedDataStoreMatrixMap = /* @__PURE__ */ new Map();
  }
  /**
   * Gets Matrixes for corresponding datamodel, facets and projections.
   *
   * @param {Object} mainDataStore input datamodel
   * @param {Object} fieldInformation Information about the fields
   * @param {Object} sortConfig Information about how to sort the facet fields
   *
   * @return {Array<Array<Object>>} A 2D array of value matrices
   */
  getMatrixModel(t, i, {
    facetSortConfig: n,
    globalConfig: A,
    rowTotalsDM: s,
    columnTotalsDM: o,
    greatTotalsDM: r,
    canvasHelpers: a,
    detailedFacetProjectionInfo: l,
    isGrandTotals: c,
    totalsType: g
  } = {
    globalConfig: {}
  }) {
    const {
      rows: {
        totals: {
          subTotals: {
            enabled: h,
            splitTotal: { field: u }
          } = { enabled: !1, splitTotal: {} }
        } = {}
      } = {},
      columns: {
        totals: {
          subTotals: {
            enabled: d,
            splitTotal: { field: f }
          } = { enabled: !1, splitTotal: {} }
        } = {}
      } = {}
    } = A, {
      colFacets: I = [],
      rowFacets: C = [],
      optionalProjections: E = [],
      colProjections: B = [],
      rowProjections: m = []
    } = i, y = {}, D = {};
    let Q = [], p = [];
    const x = t.getSchema({
      excludeFields: [St.ROW_ID]
    }).map(LW);
    this._rowFacets = C.flatMap(ia), this._columnFacets = I.flatMap(ia);
    const S = this._rowFacets.concat(this._columnFacets), _ = m.map(
      (Z) => B.map((Y) => ({
        rowProjections: Z,
        colProjections: Y,
        combinedProjections: [...Z, ...Y].flatMap(
          ia
        )
      }))
    );
    if (this._colProjectionMatrix = B?.flat()?.flatMap(ia), this._rowProjectionMatrix = m?.flat()?.flatMap(ia), S.length === 0)
      return m.length && B.length ? {
        dataModelMatrix: _.map((Z) => {
          const Y = s0(
            Z,
            x,
            E
          );
          return t.splitByColumn(Y, E).map((q, $) => ({
            dataStore: q,
            rowFacetValues: [],
            columnFacetValues: [],
            rowProjections: Z[$].rowProjections,
            columnProjections: Z[$].colProjections
          }));
        }),
        rowKeys: [],
        columnKeys: []
      } : {
        getDataModelMatrix: () => [
          [
            {
              dataStore: t,
              rowProjections: [...m.flat()],
              columnProjections: [...B.flat()],
              columnFacetValues: [],
              rowFacetValues: []
            }
          ]
        ],
        rowKeys: [],
        columnKeys: []
      };
    t = this.generateTotalsMatrixMaps(
      s,
      o,
      r,
      a,
      A,
      l,
      c,
      t,
      g
    ) ?? t;
    let k;
    const T = (Z, Y) => {
      const q = Z.getSchema(), $ = Y.getSchema(), P = /* @__PURE__ */ new Map();
      return q.forEach(({ name: nt, ...ot }) => {
        P.set(nt, {
          name: nt,
          subtype: ot.subtype,
          ...ot
        });
      }), $.forEach(({ name: nt, ...ot }) => {
        const Et = P.get(nt)?.subtype;
        Et === it.TEMPORAL || ot.subtype === it.TEMPORAL && Et !== ot.subtype || ot.subtype === it.CONTINUOUS && Et !== ot.subtype || ot.subtype === it.BINNED && Et !== ot.subtype ? P.set(nt, {
          name: nt,
          type: Ct.DIMENSION,
          subtype: it.CATEGORICAL
        }) : P.set(nt, {
          name: nt,
          subtype: ot.subtype,
          ...ot
        });
      }), [...P.values()];
    };
    if (d && h && !c) {
      const Z = Ji(
        [t, s, o, r],
        void 0,
        {
          preserveNullColumns: !0,
          dmSchema: s && o ? T(s, o) : null
        }
      );
      Z.openBroadcastChannel(), k = Z.splitByRow(S);
    } else if (d && !c) {
      const Z = Ji([t, o], void 0, {
        preserveNullColumns: !0,
        dmSchema: o ? o.getSchema() : null
      });
      Z.openBroadcastChannel(), k = Z.splitByRow(S);
    } else if (h && !c) {
      const Z = Ji([t, s], void 0, {
        preserveNullColumns: !0,
        dmSchema: s ? s.getSchema() : null
      });
      Z.openBroadcastChannel(), k = Z.splitByRow(S);
    } else
      k = t.splitByRow(S);
    this._emptyDm = t.createEmptyDm();
    let G = 0;
    const N = [], b = [], F = ({
      rowCollapsed: Z,
      colCollapsed: Y,
      facetedDataStore: q,
      rowKey: $,
      colKey: P,
      isRowSubTotalsEnabled: st,
      isColSubTotalsEnabled: nt,
      context: ot
    }) => {
      const Et = ot._rowTotalsMatrixMap, ct = ot._colTotalsMatrixMap, ht = ot._greatTotalsMatrixMap, Mt = Z && Y, at = [
        {
          collapsed: Z && !Mt,
          dm: ct?.get(`${P}-${$}`)
        },
        {
          collapsed: Y && !Mt,
          dm: Et?.get(`${$}-${P}`)
        },
        {
          collapsed: Mt || Z && st || Y && nt,
          dm: ht?.get(`${P}-${$}`)
        }
      ].map(({ collapsed: Ot, dm: Vt }) => Ot ? Vt : null).filter((Ot) => Ot != null);
      return at.length ? at.length > 1 ? Ji(at, void 0, {
        preserveNullColumns: !0
      }) : at[0] : q;
    }, R = [...k].reduce(
      (Z, Y) => {
        const {
          rowKey: q,
          allKeys: $,
          isCollapsed: P
        } = n0(
          Y,
          this._rowFacets,
          y,
          Q,
          N,
          0,
          this._rowCollapseStatus,
          f
        ), {
          rowKey: st,
          allKeys: nt,
          isCollapsed: ot
        } = n0(
          Y,
          this._columnFacets,
          D,
          p,
          b,
          1,
          this._columnCollapseStatus,
          u
        );
        return G += P + ot, this._mainFacetedDataStoreMatrixMap.set(
          `${$}-${nt}`,
          Y
        ), Z.set(
          `${q}-${st}`,
          F({
            rowCollapsed: P,
            colCollapsed: ot,
            context: this,
            rowKey: q,
            colKey: st,
            isRowSubTotalsEnabled: h,
            isColSubTotalsEnabled: d,
            facetedDataStore: Y
          })
        );
      },
      /* @__PURE__ */ new Map()
    ), { treeRowKeys: v, treeColumnKeys: O } = a0(
      Q,
      p,
      this._rowFacets,
      this._columnFacets,
      n
    );
    if (G > 0) {
      const { treeRowKeys: Z, treeColumnKeys: Y } = a0(
        N,
        b,
        this._rowFacets,
        this._columnFacets,
        n
      );
      this._allTreeRowKeys = Z, this._allTreeColKeys = Y;
    } else
      this._allTreeRowKeys = v, this._allTreeColKeys = O;
    Q = v.leaves().map((Z) => Z.data[1] == null ? [] : Z.data[1][0]), p = O.leaves().map((Z) => Z.data[1] == null ? [] : Z.data[1][0]);
    const L = A0(Q), U = A0(p);
    let H = [];
    const z = L.map(
      ({ keyArr: Z, joinedKey: Y }) => U.map(
        ({ keyArr: q, joinedKey: $ }) => {
          const P = `${Y}-${$}`, st = R.has(P) ? R.get(P) : this._emptyDm;
          return {
            rowFacetValues: Z,
            facetedDataStore: st,
            columnFacetValues: q
          };
        }
      )
    );
    return H = UW(
      _.map((Z) => {
        const Y = s0(
          Z,
          x,
          E
        );
        return z.map(
          (q) => q.flatMap(
            ({ rowFacetValues: $, columnFacetValues: P, facetedDataStore: st }) => Y.map((nt, ot) => ({
              dataStore: st,
              rowFacetValues: $,
              columnFacetValues: P,
              rowProjections: Z[ot].rowProjections,
              columnProjections: Z[ot].colProjections
            }))
          )
        );
      })
    ), {
      dataModelMatrix: H,
      rowKeys: Q,
      columnKeys: ae(p)
    };
  }
  getUpdatedDataModel(t, i, n, A, s, o, r) {
    let a;
    switch (`${t}-${i}`) {
      case "true-true":
        a = this._greatTotalsMatrixMap.get(
          `${o}-${s}`
        );
        break;
      case "true-false":
        (A || t) && n ? r ? a = this._colTotalsMatrixMap.get(
          `${o}-${s}`
        ) : a = Ji(
          [
            this._colTotalsMatrixMap.get(`${o}-${s}`),
            this._greatTotalsMatrixMap.get(`${o}-${s}`)
          ],
          void 0,
          { preserveNullColumns: !0 }
        ) : a = this._colTotalsMatrixMap.get(
          `${o}-${s}`
        );
        break;
      case "false-true":
        A && (n || i) ? r ? a = this._rowTotalsMatrixMap.get(
          `${s}-${o}`
        ) : a = Ji(
          [
            this._rowTotalsMatrixMap.get(`${s}-${o}`),
            this._greatTotalsMatrixMap.get(`${o}-${s}`)
          ],
          void 0,
          { preserveNullColumns: !0 }
        ) : a = this._rowTotalsMatrixMap.get(
          `${s}-${o}`
        );
        break;
      default:
        a = this._mainFacetedDataStoreMatrixMap.get(
          `${s}-${o}`
        );
        break;
    }
    return a ?? this._emptyDm;
  }
  updatedDataModelAtIndex(t, i, n, A, s, o, r) {
    const { rowFacetValues: a, columnFacetValues: l } = t[i][n], c = !!this._rowCollapseStatus(a), g = !!this._columnCollapseStatus(l), {
      rows: {
        totals: {
          subTotals: { enabled: h } = { enabled: !1 }
        } = {}
      } = {},
      columns: {
        totals: {
          subTotals: { enabled: u } = { enabled: !1 }
        } = {}
      } = {}
    } = A.config(), d = this.getUpdatedDataModel(
      c,
      g,
      h,
      u,
      a,
      l,
      r
    );
    return IA(
      os(
        A,
        s,
        [
          [
            {
              ...t[i][n],
              dataStore: d
            }
          ]
        ],
        o
      ),
      A.config()
    )[0][0];
  }
  updateMatrixModelForTargetPath(t, i, n, A, s, o, r, a) {
    let {
      dataModelMatrix: l,
      rowKeys: c,
      columnKeys: g,
      allRowHeaderKeys: h,
      allColumnHeaderKeys: u
    } = n;
    const d = [], f = {
      entrySet: [],
      exitSet: [
        [-1, -1],
        [-1, -1]
      ],
      // [ row: [startIndex, endIndex], col: [startIndex, endIndex] ]
      updateSet: [],
      splitFieldUniques: []
    }, {
      rows: {
        totals: {
          subTotals: {
            enabled: I,
            splitTotal: { field: C }
          } = { enabled: !1 }
        } = {}
      } = {},
      columns: {
        totals: {
          subTotals: {
            enabled: E,
            splitTotal: { field: B }
          } = { enabled: !1 }
        } = {}
      } = {}
    } = A.config(), m = i === "row" ? this._rowFacets : this._columnFacets;
    let y;
    i === "row" ? y = E ? B : null : y = I ? C : null;
    const D = i === "row" ? r : a;
    if (t.length === m.length) {
      const Q = OW(
        t,
        l,
        i,
        {
          allRowHeaderKeys: h,
          allColumnHeaderKeys: u
        }
      );
      Q.forEach(([p, w]) => {
        const { metaInfo: x } = l[p][w];
        [Qo, mo, na].includes(
          x?.totals?.type
        ) ? d.push([p, w]) : l[p][w] = this.updatedDataModelAtIndex(
          l,
          p,
          w,
          A,
          s,
          o
        );
      }), f.updateSet = Q;
    } else {
      const Q = A.config(), p = t[t.length - 1].collapsed;
      let { startIndex: w, endIndex: x } = HW(
        t,
        {
          allRowHeaderKeys: h,
          allColumnHeaderKeys: u
        },
        i
      );
      const S = Q.columns.totals.grandTotals, _ = Q.rows.totals.grandTotals, M = S.enabled && S.position === "start" ? h.length - c.length : 0, k = _.enabled && _.position === "start" ? u.length - (g[0]?.length || 0) : 0;
      let T = w - M, G = x - M, N = w - k, b = x - k;
      const F = m.indexOf(y), R = F >= 0 ? _V(D, y, t) : [];
      if (f.splitFieldUniques = R, R.length > 0 && (x = x - R.length + 1, G = i === "row" ? G - R.length + 1 : b, b = i === "row" ? b : b - R.length + 1), p)
        if (i === "row") {
          let v = l.slice(
            w,
            R.length > 0 ? w + R.length : w + 1
          ).map(([{ rowFacetValues: H }]) => [...H]);
          w !== x && (l.splice(w + 1, x - w), f.exitSet[0] = [w + 1, x], c.splice(
            T + 1,
            G - T
          ));
          const L = v.map(
            (H) => {
              const z = H.map((et, Z) => [et, Z]).splice(
                t.length,
                H.length - t.length
              );
              return H.splice(
                t.length,
                H.length - t.length
              ), z;
            }
          ).map(
            (H) => H.map(([z, et]) => F > 0 && et === F ? z : Yi)
          );
          v = If(v, L).map(
            ([H, z]) => H.concat(z)
          ), c.splice(
            T,
            v.length,
            ...v
          );
          const U = l.slice(
            w,
            w + v.length
          );
          U.forEach((H, z, et) => {
            const Z = w + z;
            H.forEach((q, $) => {
              const { metaInfo: P } = q;
              f.updateSet.push([Z, $]), [
                Qo,
                mo,
                na
              ].includes(P?.totals?.type) && d.push([Z, $]), q.rowFacetValues = v[z];
              const st = !!this._columnCollapseStatus(
                q.columnFacetValues
              );
              q.dataStore = this.getUpdatedDataModel(
                !0,
                st,
                I,
                E,
                q.rowFacetValues,
                q.columnFacetValues
              );
            });
            let Y = IA(
              os(
                A,
                s,
                [H],
                o
              ),
              A.config()
            );
            et[z] = Y[0];
          }), l.splice(
            w,
            v.length,
            ...U
          );
        } else {
          let v = l[0].slice(
            w,
            R.length > 0 ? w + R.length : w + 1
          ).map(({ columnFacetValues: U }) => [...U]);
          const L = v.map((U) => {
            const H = U.map((z, et) => [z, et]).splice(
              t.length,
              U.length - t.length
            );
            return U.splice(
              t.length,
              U.length - t.length
            ), H;
          }).map(
            (U) => U.map(([H, z]) => F > 0 && z === F ? H : Yi)
          );
          v = If(
            v,
            L
          ).map(
            ([U, H]) => U.concat(H)
          ), g = ae(g), w !== x && (f.exitSet[1] = [w + 1, x], g.splice(
            N + 1,
            b - N
          )), l.forEach((U, H) => {
            w !== x && U.splice(w + 1, x - w), v.map(
              (z, et) => {
                const Z = w + et, Y = N + et;
                U[Z].columnFacetValues = z;
                const { metaInfo: q } = U[Z];
                f.updateSet.push([H, Z]), [
                  Qo,
                  mo,
                  na
                ].includes(q?.totals?.type) && d.push([H, Z]);
                const $ = !!this._rowCollapseStatus(
                  U[Z].rowFacetValues
                );
                U[Z].dataStore = this.getUpdatedDataModel(
                  $,
                  !0,
                  I,
                  E,
                  U[Z].rowFacetValues,
                  U[Z].columnFacetValues
                );
                let P = IA(
                  os(
                    A,
                    s,
                    [[U[Z]]],
                    o
                  ),
                  A.config()
                );
                U[Z] = P[0][0], g[Y] = z;
              }
            );
          }), g = ae(g);
        }
      else if (i === "row") {
        const v = l.splice(
          w,
          F >= 0 ? R.length : 1
        );
        c.splice(
          T,
          F >= 0 ? R.length : 1
        );
        const O = c0(
          this._allTreeRowKeys,
          t
        );
        let L = [];
        const U = [];
        let H = null, z = -1;
        for (let et = 0; et < O.length; et++) {
          const Z = O[et];
          let Y = Z.slice(0, t.length), q = !1;
          for (let st = t.length; st < Z.length; st++) {
            if (Y.push(Z[st]), q = !!this._rowCollapseStatus(Y), q) {
              Y = Y.concat(
                new Array(Z.length - st - 1).fill(Yi)
              );
              break;
            }
            st === Z.length - 1 && !q && (q = !!this._rowCollapseStatus(Y));
          }
          const $ = Y.join("-");
          if (H === $)
            continue;
          H = $, z += 1, U.push(Y);
          let P = [];
          v[0]?.forEach((st, nt) => {
            const ot = !!this._columnCollapseStatus(
              st.columnFacetValues
            ), Et = this.getUpdatedDataModel(
              q,
              ot,
              I,
              E,
              Y,
              st.columnFacetValues
            );
            P.push({
              ...st,
              rowFacetValues: Y,
              dataStore: Et
            });
            const { metaInfo: ct } = st;
            f.updateSet.push([w + z, nt]), [
              Qo,
              mo,
              na
            ].includes(ct?.totals?.type) && d.push([w + z, nt]);
          }), L.push(P);
        }
        L = IA(
          os(
            A,
            s,
            L,
            o
          ),
          A.config()
        ), L.length > 1 && (f.entrySet[0] = [
          w + 1,
          w + L.length - 1
        ]), l.splice(w, 0, ...L), c.splice(T, 0, ...U);
      } else {
        let v = [];
        const O = c0(
          this._allTreeColKeys,
          t
        );
        l.forEach((L, U) => {
          let H = [];
          v = [];
          const z = L.splice(
            w,
            F >= 0 ? R.length : 1
          );
          let et = null, Z = -1;
          for (let Y = 0; Y < O.length; Y++) {
            const q = O[Y];
            let $ = q.slice(0, t.length), P = !1;
            for (let ct = t.length; ct < q.length; ct++) {
              if ($.push(q[ct]), P = !!this._columnCollapseStatus($), P) {
                $ = $.concat(
                  new Array(q.length - ct - 1).fill(Yi)
                );
                break;
              }
              ct === q.length - 1 && !P && (P = !!this._columnCollapseStatus($));
            }
            const st = $.join("-");
            if (et === st)
              continue;
            et = st, Z += 1, v.push($);
            const nt = !!this._rowCollapseStatus(
              z[0].rowFacetValues
            ), ot = this.getUpdatedDataModel(
              nt,
              P,
              I,
              E,
              z[0].rowFacetValues,
              $
            );
            H.push({
              ...z[0],
              columnFacetValues: $,
              dataStore: ot
            });
            const { metaInfo: Et } = z[0];
            [
              Qo,
              mo,
              na
            ].includes(Et?.totals?.type) && d.push([U, w + Z]), f.updateSet.push([U, w + Z]);
          }
          H.length > 1 && (f.entrySet[1] = [
            w + 1,
            w + H.length - 1
          ]), H = IA(
            os(
              A,
              s,
              [H],
              o
            ),
            A.config()
          ), L.splice(w, 0, ...H[0]);
        }), g = ae(g), g.splice(
          N,
          F >= 0 ? R.length : 1,
          ...v
        ), g = ae(g);
      }
    }
    return {
      dataModelMatrix: l,
      rowKeys: c,
      columnKeys: g,
      grandTotalsCoordinates: d,
      updateInfo: f
    };
  }
  updateGrandTotalsMatrix(t, i, n, A, s) {
    return t.forEach(([o, r]) => {
      i[o][r] = this.updatedDataModelAtIndex(
        i,
        o,
        r,
        n,
        A,
        s,
        !0
      );
    }), i;
  }
  getFilterQuery(t, i, n) {
    return {
      operator: i,
      conditions: [
        ...t.filter((A) => A !== bt).map((A) => ({
          field: A,
          value: Yi,
          operator: n
        }))
      ]
    };
  }
  generateTotalsMatrixMaps(t, i, n, A, s = {}, o, r, a, l) {
    const {
      rowFacetsConfig: c,
      rowTotalsSplitField: g,
      colFacetsConfig: h,
      columnTotalsSplitField: u
    } = uA(s), {
      rows: {
        totals: { subTotals: { enabled: d } = {} } = {}
      } = {},
      columns: {
        totals: { subTotals: { enabled: f } = {} } = {}
      } = {}
    } = s, {
      interaction: { collapse: { enabled: I } = {} } = {}
    } = c ?? {}, {
      interaction: { collapse: { enabled: C } = {} } = {}
    } = h ?? {}, E = this._rowFacets.concat(this._columnFacets);
    let B;
    if (r && l === "row") {
      const m = [
        ...this._rowFacets,
        ...o.discreteRowProjections
      ].filter((y) => `${y}` !== g);
      i = a.select(
        this.getFilterQuery(m, "or", "eq")
      ), f || (B = a.select(
        this.getFilterQuery(m, "and", "neq")
      ), t = B);
    }
    if (r && l === "column") {
      const m = [
        ...this._columnFacets,
        ...o.discreteColumnProjections
      ].filter((y) => `${y}` !== u);
      t = a.select(
        this.getFilterQuery(m, "or", "eq")
      ), d || (B = a.select(
        this.getFilterQuery(m, "and", "neq")
      ), i = B);
    }
    if ((I || f) && (this._colTotalsMatrixMap = /* @__PURE__ */ new Map(), i?.splitByRow(E)?.reduce((m, y) => {
      const D = uo(this._rowFacets, y), Q = uo(this._columnFacets, y);
      return m.set(`${Q}-${D}`, y);
    }, this._colTotalsMatrixMap), I && (this._rowCollapseStatus = (m) => A.getRowCollapseState(
      m?.filter((y) => y !== Yi)
    ))), (C || d) && (this._rowTotalsMatrixMap = /* @__PURE__ */ new Map(), t?.splitByRow(E)?.reduce((m, y) => {
      const D = uo(this._rowFacets, y), Q = uo(this._columnFacets, y);
      return m.set(`${D}-${Q}`, y);
    }, this._rowTotalsMatrixMap), C && (this._columnCollapseStatus = (m) => A.getColumnsCollapseState(
      m?.filter((y) => y !== Yi)
    ))), (I || f) && (C || d) && (this._greatTotalsMatrixMap = /* @__PURE__ */ new Map(), n?.splitByRow(E)?.reduce((m, y) => {
      const D = uo(this._rowFacets, y), Q = uo(this._columnFacets, y);
      return m.set(`${Q}-${D}`, y);
    }, this._greatTotalsMatrixMap)), B)
      return B;
  }
}
const bV = ({
  dataStore: e,
  detailedFacetProjectionInfo: t,
  columnTotalString: i,
  aggregations: n,
  splitField: A,
  rowSplitField: s
}) => {
  const o = [], r = [];
  return [
    ...t.continuousColumnProjections,
    ...t.continuousRowProjections,
    ...t.continuousOptionalProjections
  ].forEach((a) => {
    e.getSchema().find((c) => c.name === `${a}`)?.type === Ct.DIMENSION ? o.push(a) : r.push(a);
  }), hN(
    e,
    t.colFacets.flatMap((a) => a.getMembers()).concat(t.discreteColumnProjections).concat(A ? [A] : []),
    t.rowFacets.flatMap((a) => a.getMembers()).concat(t.discreteRowProjections),
    t.discreteOptionalProjections,
    r,
    { totalString: i, isRow: !1, aggregations: n },
    A,
    s,
    o
  );
}, NV = ({
  columnTotalsDSWithAll: e,
  columnTotalString: t,
  facetsAndProjections: i,
  matrixModelConfig: n,
  matrixModelInst: A,
  detailedFacetProjectionInfo: s,
  splitField: o,
  rowSplitField: r
}) => {
  const a = aB(
    e,
    s,
    r,
    o,
    t
  );
  let l = a ? e.select(a) : e;
  return l.getData().data.length === 0 && (l = e), {
    matrixModel: A.getMatrixModel(
      l,
      i,
      n
    )
  };
}, FV = ({
  facetsAndProjections: e,
  suppliedLayers: t,
  globalConfig: i,
  dataStore: n,
  detailedFacetProjectionInfo: A,
  canvasHelpers: s,
  subTotalsInfo: { rowSubTotalsDS: o, columnSubTotalsDS: r, greatSubTotalsDS: a }
}) => {
  let {
    facetSortConfig: l,
    columns: {
      totals: {
        grandTotals: {
          enabled: c,
          text: g,
          layers: h,
          splitTotal: { field: u, text: d }
        },
        data: { dataModel: f, totalString: I },
        // position: columnTotalPosition,
        aggregations: C
      },
      facets: {
        interaction: { collapse: { enabled: E } = {} } = {}
      } = {}
    },
    rows: {
      totals: {
        subTotals: {
          enabled: B,
          splitTotal: { field: m }
        } = {},
        grandTotals: { splitTotal: { field: y } } = {}
      } = {}
    } = {}
  } = i;
  const D = {
    facetSortConfig: l,
    globalConfig: i,
    canvasHelpers: s,
    detailedFacetProjectionInfo: A,
    isGrandTotals: !0,
    totalsType: "column",
    rowTotalsDM: o,
    columnTotalsDM: r,
    greatTotalsDM: a
  }, Q = (w) => w != bt, p = [
    ...A.colFacets,
    ...A.discreteColumnProjections.filter(
      Q
    ),
    ...A.discreteRowProjections.filter(
      Q
    ),
    ...A.rowFacets
  ];
  if (c && p.length > 0) {
    let w;
    if (f) {
      const O = n.getSchema().find(({ name: L }) => L === bt);
      f.setCreatorIdentifier(n.getCreatorIdentifier()).openBroadcastChannel(), O ? f = f.calculateVariable(
        {
          name: bt,
          type: Bs
        },
        f.getSchema().map(({ name: L }) => L),
        () => 1
      ) : f = f.project(
        f.getSchema().filter(({ name: L }) => L !== St.ROW_ID).map(({ name: L }) => L)
      ), f = f.select({
        operator: "and",
        conditions: [
          ...A.rowFacets,
          ...A.discreteRowProjections
        ].filter(
          (L) => `${L}` !== u && `${L}` !== m && `${L}` !== bt
        ).map((L) => ({
          field: `${L}`,
          value: I,
          operator: "eq"
        }))
      }), w = new J(f, {
        creatorIdentifier: n.getCreatorIdentifier(),
        ...n._model._config
      });
    } else {
      if (w = new J(
        bV({
          facetsAndProjections: e,
          detailedFacetProjectionInfo: A,
          dataStore: n,
          columnTotalString: I,
          aggregations: C,
          splitField: u,
          rowSplitField: y
        }),
        {
          creatorIdentifier: n.getCreatorIdentifier(),
          ...n._model._config
        }
      ), E || B) {
        const { colFacets: O } = e, L = [], U = [], H = w.getSchema();
        L.push(
          ...A.discreteOptionalProjections
        ), [
          ...A.continuousColumnProjections,
          ...A.continuousRowProjections,
          ...A.continuousOptionalProjections
        ].forEach((z) => {
          H.find(
            (Z) => Z.name === `${z}`
          )?.type === Ct.DIMENSION && L.push(z);
        }), u && L.push(`${u}`), m && L.push(`${m}`), O.forEach((z, et) => {
          L.push(`${z}`);
          const Z = [
            ...O.slice(et + 1).map((ct) => `${ct}`),
            ...A.discreteRowProjections,
            ...A.discreteColumnProjections,
            ...A.rowFacets.map((ct) => `${ct}`)
          ].filter(
            (ct) => `${ct}` !== u && `${ct}` !== m
          );
          let Y = w.groupBy([
            .../* @__PURE__ */ new Set([...L])
          ]);
          Y = Y.select({
            operator: "and",
            conditions: [
              ...L.map((ct) => `${ct}`).map((ct) => ({
                field: ct,
                value: I,
                operator: "neq"
              }))
            ]
          });
          const { data: q, schema: $ } = Y.getData({
            excludeFields: [
              St.ROW_ID,
              ...Z.map((ct) => `${ct}`)
            ],
            shouldSanitize: !0
          }), P = ae(q), st = Z.map(
            () => new Array(q.length).fill(0).map(() => I)
          ), nt = [...P, ...st], ot = [
            ...$,
            ...Z.map((ct) => ({
              name: `${ct}`,
              type: Ct.DIMENSION,
              subtype: H.find((ht) => ht.name === `${ct}`).subtype
            }))
          ], Et = new J({
            data: nt,
            schema: ot
          });
          U.push(Et);
        }), U.unshift(w), w = Ji(U, null, {
          creatorIdentifier: n.getCreatorIdentifier(),
          ...n._model._config
        }), U.forEach((z) => z.dispose()), U.length = 0;
      }
      w.openBroadcastChannel();
    }
    const x = new vu(), {
      matrixModel: {
        rowKeys: S,
        columnKeys: _,
        dataModelMatrix: M
      }
    } = NV({
      facetsAndProjections: e,
      detailedFacetProjectionInfo: A,
      columnTotalsDSWithAll: w,
      columnTotalString: I,
      matrixModelConfig: D,
      splitField: u,
      rowSplitField: y,
      matrixModelInst: x
    }), k = i.rows.facets, T = k?.fields[u], G = T ? T.formatter : k.formatter, N = h == null ? t : Gl(h), b = S.map((O) => O.map((L, U) => {
      const H = e.rowFacets[U];
      return `${H}` === u ? {
        value: L,
        format: G ? qo(G, n) : (z) => z,
        key: `${H}-${L}-Total`,
        sourceType: Ae,
        rawValue: L
      } : U === 0 ? {
        value: g,
        format: () => g,
        sourceType: Ae,
        rawValue: I
      } : {
        value: "",
        format: (z) => z,
        sourceType: Ae,
        rawValue: I
      };
    }));
    let F = [];
    for (let O = 0; O < (b.length || 1); O++)
      for (let L = 0; L < e.rowProjections.length; L++) {
        let U = {};
        const H = e.rowProjections[L][0];
        H && H.as() === "discrete" && (b[0] && b[0].length > 0 ? u ? U = {
          show: !0,
          showAxisName: !1,
          tickFormat: u === `${H}` ? (et) => et.formattedValue : () => d,
          sourceType: Ae
        } : U = {
          show: ft(
            W(i, "axes", "y", "fields", H, "show"),
            W(i, "axes", "y", "show")
          ) !== !1,
          tickFormat: () => " ",
          className: "muze-column-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        } : U = {
          tickFormat: () => g,
          className: "muze-column-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        }), F.push({
          field: H,
          config: U
        });
      }
    let R = [];
    for (let O = 0; O < (b.length || 1); O++)
      for (let L = 0; L < e.rowProjections.length; L++) {
        let U = {};
        const H = e.rowProjections[L][1];
        H && H.as() === "discrete" && (b[0] && b[0].length > 0 ? U = {
          show: !1,
          className: "muze-column-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        } : U = {
          tickFormat: () => g,
          className: "muze-column-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        }), R.push({
          field: H,
          config: U
        });
      }
    return {
      rowKeys: cN(b, { leftAxisInfo: F }),
      columnKeys: _.map(
        (O) => O.map((L, U) => U === 0 ? g : "")
      ),
      rowAxisInfo: {
        leftAxisInfo: F,
        rightAxisInfo: R
      },
      rowFacetsInfo: {
        leftFacetsInfo: F,
        rightFacetsInfo: R
      },
      dataModelMatrix: M.map((O) => O.map((L) => ({
        ...L,
        suppliedLayers: N.map((U) => ({
          className: "muze-layer-column-grand-totals",
          ...U
        })),
        metaInfo: {
          totals: {
            type: mo
          }
        }
      }))),
      columnTotalsDSWithAll: w,
      matrixModelInst: x
    };
  }
}, RV = ({
  dataStore: e,
  facetsAndProjections: t,
  rowTotalString: i,
  detailedFacetProjectionInfo: n,
  aggregations: A,
  splitField: s
}) => {
  const { rowFacets: o, colFacets: r } = t, a = [], l = [];
  return [
    ...n.continuousColumnProjections,
    ...n.continuousRowProjections,
    ...n.continuousOptionalProjections
  ].forEach((c) => {
    e.getSchema().find((h) => h.name === c)?.type === Ct.DIMENSION ? a.push(c) : l.push(c);
  }), hN(
    e,
    o.flatMap((c) => c.getMembers()).concat(n.discreteRowProjections).concat(s ? [s] : []),
    r.flatMap((c) => c.getMembers()).concat(n.discreteColumnProjections),
    n.discreteOptionalProjections,
    l,
    { totalString: i, isRow: !0, aggregations: A },
    null,
    null,
    a
  );
}, kV = ({
  rowTotalsDSWithAll: e,
  rowTotalString: t,
  facetsAndProjections: i,
  matrixModelConfig: n,
  detailedFacetProjectionInfo: A,
  matrixModelInst: s,
  splitField: o
}) => {
  const r = aB(
    e,
    A,
    o,
    null,
    t
  );
  let a = r ? e.select(r) : e;
  return a.getData().data.length === 0 && (a = e), {
    matrixModel: s.getMatrixModel(
      a,
      i,
      n
    ),
    rowTotalsDS: a
  };
}, TV = ({
  globalConfig: e,
  facetsAndProjections: t,
  suppliedLayers: i,
  dataStore: n,
  detailedFacetProjectionInfo: A,
  canvasHelpers: s,
  subTotalsInfo: { rowSubTotalsDS: o, columnSubTotalsDS: r, greatSubTotalsDS: a }
}) => {
  let {
    facetSortConfig: l,
    rows: {
      totals: {
        grandTotals: {
          enabled: c,
          text: g,
          layers: h,
          splitTotal: { field: u, text: d }
        },
        data: { dataModel: f, totalString: I },
        aggregations: C
      },
      facets: {
        interaction: { collapse: { enabled: E } = {} } = {}
      } = {}
    },
    columns: {
      totals: {
        subTotals: {
          enabled: B,
          splitTotal: { field: m }
        } = {},
        grandTotals: { splitTotal: { field: y } } = {}
      } = {}
    } = {}
  } = e;
  const D = {
    facetSortConfig: l,
    globalConfig: e,
    canvasHelpers: s,
    detailedFacetProjectionInfo: A,
    isGrandTotals: !0,
    totalsType: "row",
    rowTotalsDM: o,
    columnTotalsDM: r,
    greatTotalsDM: a
  }, Q = (w) => w != bt, p = [
    ...A.colFacets,
    ...A.discreteColumnProjections.filter(
      Q
    ),
    ...A.discreteRowProjections.filter(
      Q
    ),
    ...A.rowFacets
  ];
  if (c && p.length > 0) {
    let w;
    if (f) {
      const L = n.getSchema().find(({ name: U }) => U === bt);
      f.setCreatorIdentifier(n.getCreatorIdentifier()).openBroadcastChannel(), L ? f = f.calculateVariable(
        {
          name: bt,
          type: Bs
        },
        f.getSchema().map(({ name: U }) => U),
        () => 1
      ) : f = f.project(
        f.getSchema().filter(({ name: U }) => U !== St.ROW_ID).map(({ name: U }) => U)
      ), f = f.select({
        operator: "and",
        conditions: [
          ...A.colFacets,
          ...A.discreteColumnProjections
        ].filter(
          (U) => `${U}` !== u && `${U}` !== m && `${U}` !== bt
        ).map((U) => ({
          field: `${U}`,
          value: I,
          operator: "eq"
        }))
      }), w = new J(f, {
        creatorIdentifier: n.getCreatorIdentifier(),
        ...n._model._config
      });
    } else {
      if (w = new J(
        RV({
          facetsAndProjections: t,
          detailedFacetProjectionInfo: A,
          dataStore: n,
          rowTotalString: I,
          aggregations: C,
          splitField: u
        }),
        {
          creatorIdentifier: n.getCreatorIdentifier(),
          ...n._model._config
        }
      ), E || B) {
        const { rowFacets: L } = t, U = [], H = [], z = w.getSchema();
        U.push(
          ...A.discreteOptionalProjections
        ), [
          ...A.continuousColumnProjections,
          ...A.continuousRowProjections,
          ...A.continuousOptionalProjections
        ].forEach((et) => {
          z.find((Y) => Y.name === et)?.type === Ct.DIMENSION && U.push(et);
        }), u && U.push(`${u}`), m && U.push(`${m}`), L.forEach((et, Z) => {
          U.push(`${et}`);
          const Y = [
            ...L.slice(Z + 1).map((ht) => `${ht}`),
            ...A.discreteColumnProjections,
            ...A.discreteRowProjections,
            ...A.colFacets.map((ht) => `${ht}`)
          ].filter(
            (ht) => `${ht}` !== u && `${ht}` !== m
          ), q = w.groupBy([...new Set(U)]), { data: $, schema: P } = q.getData({
            excludeFields: [
              St.ROW_ID,
              ...Y.map((ht) => `${ht}`)
            ],
            shouldSanitize: !0
          }), st = ae($), nt = Y.map(
            () => new Array($.length).fill(0).map(() => I)
          ), ot = [...st, ...nt], Et = [
            ...P,
            ...Y.map((ht) => ({
              name: `${ht}`,
              type: Ct.DIMENSION,
              subtype: z.find((Mt) => Mt.name === `${ht}`).subtype
            }))
          ], ct = new J({
            data: ot,
            schema: Et
          });
          H.push(ct);
        }), H.unshift(w), w = Ji(H, null, {
          creatorIdentifier: n.getCreatorIdentifier(),
          ...n._model._config
        }), H.forEach((et) => et.dispose()), H.length = 0;
      }
      w.openBroadcastChannel();
    }
    const x = new vu(), {
      matrixModel: {
        rowKeys: S,
        columnKeys: _,
        dataModelMatrix: M
      }
      // rowTotalsDS
    } = kV({
      rowTotalsDSWithAll: w,
      detailedFacetProjectionInfo: A,
      rowTotalString: I,
      facetsAndProjections: t,
      matrixModelConfig: D,
      matrixModelInst: x,
      splitField: u,
      colSplitField: y
    }), k = h == null ? i : Gl(h), T = W(_[0], "length") || 1;
    let G = [];
    for (let L = 0; L < T; L++)
      t.colProjections.forEach((U) => {
        let H = {};
        const z = U[0];
        z && z.as() === "discrete" && (_[0] && _[0].length ? u ? H = {
          tickFormat: u === `${z}` ? (Z) => Z.formattedValue : () => d,
          className: "muze-row-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        } : H = {
          show: !0,
          /**
           * Giving one space reduces the row grand total column width. This is because layout takes the axis width
           * and sets it as the column width. Ideally, layout should take the maximum width of facets and the axis.
           * @todo Need to fix the layout behaviour.
           * Source issue: bcb0c8a8155ab77886102b9168cac5d3f945c308
           */
          tickFormat: () => " ".repeat(5),
          className: "muze-row-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        } : H = {
          tickFormat: () => g,
          className: "muze-row-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        }), G.push({
          field: z,
          config: H
        });
      });
    let N = [];
    for (let L = 0; L < T; L++)
      t.colProjections.forEach((U) => {
        const H = U[1];
        let z = {};
        H && H.as() === "discrete" && (_[0] && _[0].length > 0 ? z = {
          show: !1,
          className: "muze-row-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        } : z = {
          tickFormat: () => g,
          className: "muze-row-grand-totals-label",
          showAxisName: !1,
          sourceType: Ae
        }), N.push(z);
      });
    const b = lN(_, {
      topAxisInfo: G,
      bottomAxisInfo: N
    }), F = e.columns.facets, R = F?.fields[u], v = R ? R.formatter : F.formatter, O = b.map((L) => L.map((U, H) => {
      const z = t.colFacets[H];
      return `${z}` === u ? {
        value: U,
        rawValue: U,
        format: v ? qo(v, n) : () => U,
        key: `${z}-${U}-Total`,
        sourceType: Ae
      } : H === 0 ? {
        value: g,
        format: () => g,
        sourceType: Ae,
        rawValue: I
      } : {
        value: "",
        format: () => "",
        sourceType: Ae,
        rawValue: I
      };
    }));
    return {
      rowKeys: S.map(
        (L, U) => L.map(() => U === 0 ? g : "")
      ),
      columnKeys: O,
      columnAxisInfo: {
        topAxisInfo: G,
        bottomAxisInfo: N
      },
      columnFacetsInfo: {
        topFacetsInfo: G,
        bottomFacetsInfo: N
      },
      dataModelMatrix: M.map((L) => L.map((U) => ({
        ...U,
        suppliedLayers: k.map((H) => ({
          className: "muze-layer-row-grand-totals",
          ...H
        })),
        metaInfo: {
          totals: {
            type: Qo
          }
        }
      }))),
      rowTotalsDSWithAll: w,
      matrixModelInst: x
    };
  }
}, vV = ({
  columnTotalsDSWithAll: e,
  detailedFacetProjectionInfo: t,
  columnTotalString: i,
  columnTotalSplitField: n,
  rowTotalSplitField: A
}) => {
  const s = [
    ...new Set(
      [
        ...t.discreteRowProjections,
        ...t.rowFacets,
        ...t.discreteColumnProjections,
        ...t.colFacets
      ].flatMap(
        (u) => typeof u == "string" ? u : u.getMembers()
      ).filter((u) => u !== bt)
    )
  ], o = [
    ...t.continuousColumnProjections,
    ...t.continuousRowProjections,
    ...t.continuousOptionalProjections
  ].filter((u) => e.getSchema().find((f) => f.name === `${u}`)?.type === Ct.DIMENSION), r = e.getSchema().map(
    (u) => u.subtype === "temporal" && o.findIndex(
      (d) => `${d}` === u.name
    ) === -1 ? { ...u, subtype: "categorical" } : u
  ), a = e.project(
    r.map((u) => u.name)
  ), { data: l, schema: c } = a.getData({
    excludeFields: [St.ROW_ID],
    shouldSanitize: !0
  });
  a.dispose();
  const g = s.filter(
    (u) => `${u}` !== n && `${u}` !== A
  );
  return new J(
    {
      data: ae(l),
      schema: c
    },
    {
      creatorIdentifier: e.getCreatorIdentifier(),
      ...e._model._config
    }
  ).openBroadcastChannel().select(
    Mr(
      [g, g.map(() => i)],
      e
    )
  );
}, GV = ({
  globalConfig: e,
  facetsAndProjections: t,
  columnTotalsDSWithAll: i,
  detailedFacetProjectionInfo: n,
  suppliedLayers: A,
  canvasHelpers: s
}) => {
  let {
    sort: o,
    facetSortConfig: r,
    columns: {
      totals: {
        grandTotals: {
          layers: a,
          splitTotal: { field: l }
        },
        data: { totalString: c }
      }
    },
    rows: {
      totals: {
        grandTotals: {
          splitTotal: { field: g }
        }
      }
    }
  } = e;
  const h = {
    globalSortConfig: o,
    facetSortConfig: r,
    globalConfig: e,
    canvasHelpers: s
  }, u = vV({
    columnTotalsDSWithAll: i,
    detailedFacetProjectionInfo: n,
    columnTotalString: c,
    columnTotalSplitField: l,
    rowTotalSplitField: g
  });
  if (!u.isEmpty()) {
    const {
      rowKeys: d,
      columnKeys: f,
      dataModelMatrix: I
    } = new vu().getMatrixModel(
      u,
      t,
      h
    ), C = a == null ? A : Gl(a);
    return {
      rowKeys: d,
      columnKeys: f,
      dataModelMatrix: I.map((E) => E.map((B) => ({
        ...B,
        suppliedLayers: C.map((m) => ({
          className: "muze-layer-great-grand-totals",
          ...m
        })),
        metaInfo: {
          totals: {
            type: "greatGrandTotals"
          }
        }
      }))),
      greatTotalsDS: u
    };
  }
}, LV = ({
  detailedFacetProjectionInfo: e,
  facetsAndProjections: t,
  globalConfig: i,
  dataStore: n
}) => {
  const { colFacets: A } = t;
  let {
    rows: {
      totals: {
        subTotals: {
          enabled: s,
          splitTotal: { field: o }
        } = { enabled: !1, splitTotal: {} },
        grandTotals: {
          enabled: r,
          splitTotal: a
        },
        data: { dataModel: l, totalString: c }
      }
    }
  } = i;
  const g = a?.field, h = i.rows.facets?.interaction?.collapse?.enabled || i.columns.facets?.interaction?.collapse?.enabled;
  if (![
    ...e.discreteColumnProjections,
    ...A || [],
    ...e.continuousColumnProjections
  ].filter((d) => d && n.getSchema().find(({ name: f }) => f === `${d}`).type === Ct.DIMENSION && d !== bt).length)
    return null;
  if (l) {
    const d = n.getSchema().find(({ name: E }) => E === bt);
    l.setCreatorIdentifier(n.getCreatorIdentifier()).openBroadcastChannel(), d ? l = l.calculateVariable(
      {
        name: bt,
        type: Ct.DIMENSION
      },
      l.getSchema().map(({ name: E }) => E),
      () => 1
    ) : l = l.project(
      l.getSchema().filter(({ name: E }) => E !== St.ROW_ID).map(({ name: E }) => E)
    );
    const f = [
      ...e.continuousColumnProjections,
      ...e.continuousOptionalProjections
    ].map((E) => `${E}`).filter((E) => n.getSchema().find(({ name: B }) => B === E).type === Ct.DIMENSION), I = [
      ...A.map((E) => `${E}`),
      ...e.discreteColumnProjections.map(
        (E) => `${E}`
      ),
      ...f
    ].filter(
      (E) => E !== o && (r ? E !== g : !0)
    ).map((E) => ({
      field: E,
      value: c,
      operator: "eq"
    }));
    l = l.select(
      {
        operator: "and",
        conditions: I
      },
      {
        mode: "inverse"
      }
    );
    const C = J.DataModel();
    return l instanceof C ? new J(l, {
      creatorIdentifier: n.getCreatorIdentifier(),
      ...n._model._config
    }) : l;
  } else if (h || s) {
    const { rowFacets: d, colFacets: f } = t, I = [];
    for (let E = f.length - 1; E >= 0; E--) {
      const B = f.slice(0, E + 1);
      if (s && `${B[B.length - 1]}` == `${o}`)
        continue;
      const m = [
        ...e.continuousColumnProjections,
        ...e.continuousRowProjections,
        ...e.continuousOptionalProjections
      ].map((k) => `${k}`).filter((k) => n.getSchema().find(({ name: T }) => T === k).type === Ct.DIMENSION), y = n.groupBy([
        .../* @__PURE__ */ new Set([
          ...B.map((k) => `${k}`),
          ...f.map((k) => `${k}`),
          ...e.discreteRowProjections.map(
            (k) => `${k}`
          ),
          ...e.discreteOptionalProjections,
          ...d.map((k) => `${k}`),
          ...s && o ? [o] : [],
          ...m
        ])
      ]);
      let D = [
        ...lr(f, B),
        ...e.discreteColumnProjections
      ];
      if (s && `${B[B.length - 1]}` != `${o}` && (D = D.filter(
        (k) => `${k}` !== o
      )), D.length === 0)
        continue;
      const { data: Q, schema: p } = y.getData({
        excludeFields: [
          St.ROW_ID,
          ...D.map((k) => `${k}`)
        ]
      }), w = ae(Q), x = D.map(
        () => new Array(Q.length).fill(0).map(() => c)
      ), S = [...w, ...x], _ = [
        ...p,
        ...D.map((k) => ({
          name: `${k}`,
          type: Ct.DIMENSION,
          subtype: it.CATEGORICAL
        }))
      ], M = new J(
        {
          data: S,
          schema: _
        },
        {
          creatorIdentifier: n.getCreatorIdentifier(),
          ...n._model._config
        }
      );
      I.push(M);
    }
    const C = Ji(I);
    return I.forEach((E) => E.dispose()), I.length = 0, C && (C.setCreatorIdentifier(n.getCreatorIdentifier()).openBroadcastChannel(), C.model.rowSubtotal = !0), C;
  }
}, UV = ({
  facetsAndProjections: e,
  detailedFacetProjectionInfo: t,
  dataStore: i,
  globalConfig: n
}) => {
  const { rowFacets: A, colFacets: s } = e;
  let {
    columns: {
      totals: {
        subTotals: {
          enabled: o,
          splitTotal: { field: r }
        } = { enabled: !1, splitTotal: {} },
        grandTotals: {
          enabled: a,
          splitTotal: l
        },
        data: { dataModel: c, totalString: g }
      }
    }
  } = n;
  const h = l?.field, u = n.columns.facets?.interaction?.collapse?.enabled || n.rows.facets?.interaction?.collapse?.enabled;
  if (![
    ...t.discreteRowProjections,
    ...A || [],
    ...t.continuousRowProjections
  ].filter((f) => f && i.getSchema().find(({ name: I }) => I === `${f}`).type === Ct.DIMENSION && f !== bt).length)
    return null;
  if (c) {
    const f = i.getSchema().find(({ name: B }) => B === bt);
    c.setCreatorIdentifier(i.getCreatorIdentifier()).openBroadcastChannel(), f ? c = c.calculateVariable(
      {
        name: bt,
        type: Ct.DIMENSION
      },
      c.getSchema().map(({ name: B }) => B),
      () => 1
    ) : c = c.project(
      c.getSchema().filter(({ name: B }) => B !== St.ROW_ID).map(({ name: B }) => B)
    );
    const I = [
      ...t.continuousRowProjections,
      ...t.continuousOptionalProjections
    ].map((B) => `${B}`).filter((B) => i.getSchema().find(({ name: m }) => m === B).type === Ct.DIMENSION), C = [
      ...A.map((B) => `${B}`),
      ...t.discreteRowProjections.map((B) => `${B}`),
      ...I
    ].filter(
      (B) => B !== r && (a ? B !== h : !0)
    ).map((B) => ({
      field: B,
      value: g,
      operator: "eq"
    }));
    c = c.select(
      {
        operator: "and",
        conditions: C
      },
      {
        mode: "inverse"
      }
    );
    const E = J.DataModel();
    return c instanceof E ? new J(c, {
      creatorIdentifier: i.getCreatorIdentifier(),
      ...i._model._config
    }) : c;
  } else if (u || o) {
    const f = [];
    for (let C = A.length - 1; C >= 0; C--) {
      const E = A.slice(0, C + 1);
      if (o && `${E[E.length - 1]}` == `${r}`)
        continue;
      const B = [
        ...t.continuousRowProjections,
        ...t.continuousColumnProjections,
        ...t.continuousOptionalProjections
      ].map((M) => `${M}`).filter((M) => i.getSchema().find(({ name: k }) => k === M).type === Ct.DIMENSION), m = i.groupBy([
        .../* @__PURE__ */ new Set([
          ...E.map((M) => `${M}`),
          ...A.map((M) => `${M}`),
          ...t.discreteColumnProjections.map(
            (M) => `${M}`
          ),
          ...s.map((M) => `${M}`),
          ...t.discreteOptionalProjections,
          ...o && r ? [r] : [],
          ...B
        ])
      ]);
      let y = [
        ...lr(A, E),
        ...t.discreteRowProjections
      ];
      if (o && `${E[E.length - 1]}` !== r && (y = y.filter(
        (M) => `${M}` !== r
      )), y.length === 0)
        continue;
      const { data: D, schema: Q } = m.getData({
        excludeFields: [
          St.ROW_ID,
          ...y.map((M) => `${M}`)
        ]
      }), p = ae(D), w = y.map(
        () => new Array(D.length).fill(0).map(() => g)
      ), x = [...p, ...w], S = [
        ...Q,
        ...y.map((M) => ({
          name: `${M}`,
          type: Ct.DIMENSION,
          subtype: it.CATEGORICAL
        }))
      ], _ = new J(
        {
          data: x,
          schema: S
        },
        {
          creatorIdentifier: i.getCreatorIdentifier(),
          ...i._model._config
        }
      );
      f.push(_);
    }
    const I = Ji(f);
    return f.forEach((C) => C.dispose()), f.length = 0, I && (I.setCreatorIdentifier(i.getCreatorIdentifier()).openBroadcastChannel(), I.model.colSubTotal = !0), I;
  }
}, OV = ({
  facetsAndProjections: e,
  detailedFacetProjectionInfo: t,
  dataStore: i,
  columnSubTotalsDM: n,
  globalConfig: A
}) => {
  const { rowFacets: s, colFacets: o } = e;
  let {
    rows: {
      totals: {
        subTotals: {
          enabled: r,
          splitTotal: { field: a }
        } = { enabled: !1, splitTotal: {} }
      } = {}
    } = {},
    columns: {
      totals: {
        subTotals: {
          enabled: l,
          splitTotal: { field: c }
        } = { enabled: !1, splitTotal: {} },
        data: { dataModel: g, totalString: h }
      }
    }
  } = A;
  const u = A.columns.facets?.interaction?.collapse?.enabled || A.rows.facets?.interaction?.collapse?.enabled;
  if (g) {
    if (!n)
      return null;
    const d = [];
    for (let f = s.length - 1; f >= 0; f--)
      for (let I = 0; I < o.length; I++) {
        const C = s.slice(0, f + 1), E = o.slice(0, I + 1);
        let B = [
          ...lr(
            [...s, ...o],
            [...C, ...E]
          ),
          ...t.discreteRowProjections,
          ...t.discreteColumnProjections
        ];
        f < s.length - 1 && (B = B.filter(
          (Q) => `${Q}` !== a
        )), I > 0 && (B = B.filter(
          (Q) => `${Q}` !== c
        ));
        const m = [
          ...t.continuousColumnProjections,
          ...t.continuousOptionalProjections
        ].map((Q) => `${Q}`).filter((Q) => i.getSchema().find(({ name: p }) => p === Q).type === Ct.DIMENSION), y = [
          ...C.map((Q) => `${Q}`),
          ...E.map((Q) => `${Q}`),
          ...m,
          ...t.discreteOptionalProjections.filter((Q) => !B.includes(`${Q}`)).map((Q) => `${Q}`)
        ].map((Q) => ({
          field: Q,
          value: h,
          operator: "neq"
        })), D = B.map((Q) => ({
          field: `${Q}`,
          value: h,
          operator: "eq"
        }));
        d.push({
          operator: "and",
          conditions: [...y, ...D]
        });
      }
    return d.length ? n.select({
      operator: "or",
      conditions: d
    }) : n.createEmptyDm();
  } else if (u || l && r) {
    const d = i.getSchema(), f = [];
    for (let C = s.length - 1; C >= 0; C--) {
      const E = s.slice(0, C + 1);
      if (!(l && `${E[E.length - 1]}` == `${c}`))
        for (let B = 0; B < o.length; B++) {
          const m = o.slice(0, B + 1);
          if (r && `${m[m.length - 1]}` == `${a}`)
            continue;
          const y = [
            ...t.continuousRowProjections,
            ...t.continuousColumnProjections,
            ...t.continuousOptionalProjections
          ].map((T) => `${T}`).filter((T) => d.find(({ name: G }) => G === T).type === Ct.DIMENSION), D = i.groupBy([
            .../* @__PURE__ */ new Set([
              ...E.map((T) => `${T}`),
              ...m.map((T) => `${T}`),
              ...t.discreteOptionalProjections,
              ...y,
              ...r && a ? [a] : [],
              ...l && c ? [c] : []
            ])
          ]);
          let Q = [
            ...lr(
              [...s, ...o],
              [...E, ...m]
            ),
            ...t.discreteRowProjections,
            ...t.discreteColumnProjections
          ];
          if (r && `${m[m.length - 1]}` != `${a}` && (Q = Q.filter(
            (T) => `${T}` !== a
          )), l && `${E[E.length - 1]}` != `${c}` && (Q = Q.filter(
            (T) => `${T}` !== c
          )), Q.length < 2)
            continue;
          const { data: p, schema: w } = D.getData({
            excludeFields: [
              St.ROW_ID,
              ...Q.map((T) => `${T}`)
            ]
          }), x = ae(p), S = Q.map(
            () => new Array(p.length).fill(0).map(() => h)
          ), _ = [...x, ...S], M = [
            ...w,
            ...Q.map((T) => ({
              name: `${T}`,
              type: Ct.DIMENSION,
              subtype: it.CATEGORICAL
            }))
          ], k = new J(
            {
              data: _,
              schema: M
            },
            {
              creatorIdentifier: i.getCreatorIdentifier(),
              ...i._model._config
            }
          );
          f.push(k);
        }
    }
    const I = Ji(f);
    return f.forEach((C) => C.dispose()), f.length = 0, I && (I.model.setCreatorIdentifier(i.getCreatorIdentifier()).openBroadcastChannel(), I.model.greatSubTotal = !0), I;
  }
}, { CONTINUOUS: HV } = lt, R0 = (e) => e.getMembers(), k0 = (e) => (t) => {
  const i = e[t] || {}, n = Nr(
    i.ordering,
    JW
  );
  return { name: t, sortConfig: n };
}, PV = (e) => ({ name: t, sortConfig: i, totalString: n, subTotalsPosition: A }) => [
  t,
  ru({ name: t }, i, e, {
    totalString: n,
    subTotalsPosition: A
  })
];
class YV {
  /**
   * Creates an instance of MatrixResolver.
   * @param {Object} dependencies needed to run the resolver
   * @memberof MatrixResolver
   */
  constructor(t) {
    this._registry = {}, this._dependencies = t, this._facets = { rowFacets: [], colFacets: [] }, this._projections = { rowProjections: [], colProjections: [] };
    const { store: i, registry: n, smartlabel: A, throwback: s } = t, o = n.componentSubRegistry.layers.get();
    this._matrix = new xV({
      store: i,
      throwback: s,
      cellRegistry: n.componentSubRegistry.cells.get(),
      smartLabel: A,
      VisualUnit: n.components.VisualUnit,
      layerRegistry: o,
      interactions: n.interactions,
      DataStore: t.DataStore
    }), Bi.setLayerRegistry(o), this._axes = {
      radius: [],
      angle: [],
      angle0: [],
      color: [],
      shape: [],
      size: [],
      backgroundColor: []
    }, this._placeholderInfo = null, this._groupedData = null, this._rowGrandTotalsDataModel = null, this._columnGrandTotalsDataModel = null, this._greatGrandTotalsDataModel = null, this._matrixModel = new vu(), this._rowSubTotalsDataModel = null, this._columnSubTotalsDataModel = null, this._greatSubTotalsDataModel = null, ge(this, this.constructor.getterSetters());
  }
  units() {
    const t = this._matrix.geom(), i = [];
    return t.forEach((n, A, s) => {
      !i[A] && (i[A] = []), i[A][s] = n.source();
    }), i;
  }
  context(t) {
    return t ? (this._context = t, this) : this._context;
  }
  static getterSetters() {
    return WW;
  }
  /**
   * Used to set the layer config from outside or get current layer info
   *
   * @param {Object} type configuration of layer provided externally
   * @return {Object} either the layer or current instance
   * @memberof MatrixResolver
   */
  axes(...t) {
    return t.length ? (this._axes = Object.assign({}, this._axes, t[0]), this) : this._axes;
  }
  facets(...t) {
    return t.length ? (Object.entries(t[0]).forEach((i) => {
      this._facets[i[0]] = i[1];
    }), this) : this._facets;
  }
  projections(...t) {
    return t.length ? (Object.entries(t[0]).forEach((i) => {
      this._projections[i[0]] = i[1];
    }), this) : this._projections;
  }
  rowGrandTotalsDataModel(t) {
    return t == null ? this._rowGrandTotalsDataModel : (this._rowGrandTotalsDataModel = t, this);
  }
  columnGrandTotalsDataModel(t) {
    return t == null ? this._columnGrandTotalsDataModel : (this._columnGrandTotalsDataModel = t, this);
  }
  greatGrandTotalsDataModel(t) {
    return t == null ? this._greatGrandTotalsDataModel : (this._greatGrandTotalsDataModel = t, this);
  }
  optionalProjections() {
    const t = {}, i = [], n = [], A = [OA, UA, Ts], s = this.context(), o = {
      [UA]: s.color(),
      [OA]: s.size(),
      [Ts]: s.shape(),
      [jg]: s.detail()
    }, { simpleEncoder: r } = this.encoder(), a = this.layerConfig(), l = s.data(), c = l.getSchema();
    A.forEach((h) => {
      if (o[h] && o[h].field) {
        const u = o[h];
        t[h] = u.field, i.push(u.field), u.as == null ? n.push({
          ...u,
          as: Ve(l.getField(u.field))
        }) : n.push(u);
      }
    }), o[jg] && (i.push(...o.detail), o.detail.forEach(
      (h) => n.push({
        field: h,
        as: Ve(l.getField(h))
      })
    ));
    const g = r.getProjectionFields(
      a,
      c
    );
    return i.push(...g), n.push(
      ...g.map((h) => ({ field: h, as: Ve(l.getField(h)) }))
    ), this.projections({ optionalProjections: i }), this._optionalProjections = i, this._detailedOptionalProjections = n, t;
  }
  setFacetsAndProjections(t) {
    const { fields: i, type: n } = t, { simpleEncoder: A } = this.encoder(), { facets: s, projections: o } = A.getFacetsAndProjections(
      i,
      n
    );
    return this.facets({ [`${n}Facets`]: s }), this.projections({ [`${n}Projections`]: o }), { facets: s, projections: o, fields: i };
  }
  /**
   * return the normalized set of rows and facets and projections
   *
   * @param {Object} rows parameters needed to set horizontal axis consisiting of rows
   * @return {Object} facets, projections and normalized rows
   * @memberof MatrixResolver
   */
  horizontalAxis(t) {
    return t ? (this._horizontalAxis = this.setFacetsAndProjections({
      type: Ai,
      fields: t
    }), this) : this._horizontalAxis;
  }
  /**
   * return the normalized set of columns and facets and projections
   *
   * @param {Object} columns parameters needed to set vertical axis consisiting of columns
   * @return {Object} facets, projections and normalized columns
   * @memberof MatrixResolver
   */
  verticalAxis(t) {
    return t ? (this._verticalAxis = this.setFacetsAndProjections({
      type: gs,
      fields: t
    }), this) : this._verticalAxis;
  }
  getAllFields() {
    const t = this.projections();
    return Object.entries(this.facets()).forEach((i) => {
      t[i[0]] = i[1];
    }), t;
  }
  setRetinalAxisDomain() {
    const t = this.context(), i = t._encoders.retinalEncoder, n = t.getAllRetinalEncodings(
      this._resolvedEncodedLayers.flatMap(
        ({ def: s }) => Array.isArray(s) ? s.map(({ encoding: o }) => o) : s.encoding
      )
    ), A = {
      domains: t.matrix().geom().getRetinalFieldsDomain(t.config()),
      axes: this.getRetinalAxes(),
      encoding: n,
      resolver: this
    };
    return A.axes.size.forEach((s) => {
      const { field: o, type: r, as: a } = s.config(), l = W(A.domains, o, a);
      r === qg && l && (A.domains[o][a] = l.sort((c, g) => c > g ? 1 : -1));
    }), i.setCommonDomain(A), this;
  }
  getRetinalAxes() {
    const { color: t, shape: i, size: n, backgroundColor: A } = this.axes();
    return {
      color: [...t],
      backgroundColor: [...A],
      shape: [...i],
      size: [...n]
    };
  }
  /**
   * Creates the color, shape and size axes.
   *
   * @param {DataModel} dm Root DataModel instance which is passed to canvas.data method.
   * @param {object} config { color: colorFieldConfig, shape: shapeFieldConfig, size: sizeFieldConfig }.
   */
  createRetinalAxes(t, i) {
    const A = this.context()._encoders.retinalEncoder.createAxis(t, {
      config: i,
      axes: this.axes(),
      childEventManagerCreator: () => this.context().createChildEventManager(),
      globalConfig: this.context().config()
    });
    return this.axes(A), Object.entries(A).forEach(([, s]) => {
      s.forEach((o) => o.setupValuesSorter(t));
    }), this;
  }
  createHeaders(t) {
    let i = [], n = [];
    const { rows: A, columns: s } = t, o = this.context(), { smartlabel: r } = this.dependencies(), a = o.config(), { showHeaders: l, classPrefix: c, facet: g } = a, { TextCell: h, BlankCell: u } = o.registry().componentSubRegistry.cells.get(), [d, f] = A, [I, C] = s, { fields: E } = this.horizontalAxis(), B = (w) => new u().config({ show: w.config().show }), m = nI(g), y = {
      left: iI(
        d,
        E[0],
        l ? h : u,
        { classPrefix: c, labelManager: r, sanitizeCheckBorder: m }
      ),
      right: iI(
        f,
        E[1],
        l ? h : u,
        { classPrefix: c, labelManager: r, sanitizeCheckBorder: m }
      )
    }, D = {
      left: d.length > 0 ? d[0].map(B) : [],
      right: f.length > 0 ? f[0].map(B) : []
    }, [Q, p] = [le, De].map(
      (w) => I.map((x, S) => S === I.length - 1 ? y[w] : D[w])
    );
    return I.length === 0 ? [i, n] = [le, De].map(
      (w) => C.map((x, S) => S === 0 ? y[w] : D[w])
    ) : (i = C.map(
      () => d.length > 0 ? d[0].map(B) : []
    ), n = C.map(
      () => f.length > 0 ? f[0].map(B) : []
    )), { topLeft: Q, topRight: p, bottomLeft: i, bottomRight: n };
  }
  updateMatrices(t, i, n) {
    let {
      rowKeys: A,
      columnKeys: s,
      dataModelMatrix: o,
      grandTotalsCoordinates: r,
      updateInfo: a
    } = this._matrixModel.updateMatrixModelForTargetPath(
      t,
      i,
      this._matrixInfo,
      this.context(),
      this.encoder().simpleEncoder,
      this._suppliedLayers,
      this._columnSubTotalsDataModel,
      this._rowSubTotalsDataModel
    );
    const { colProjections: l, rowProjections: c, rowFacets: g, colFacets: h } = this.getAllFields();
    let { rowHeaderKeys: u, columnHeaderKeys: d, rowAxisInfo: f, columnAxisInfo: I } = F0({
      rowKeys: A,
      columnKeys: s,
      rowFacets: g,
      colFacets: h,
      rowProjections: c,
      colProjections: l,
      rowCollapseStatus: this._matrixModel._rowCollapseStatus,
      columnCollapseStatus: this._matrixModel._columnCollapseStatus,
      globalConfig: n
    }), C = u.map((N) => ({
      keys: N,
      type: is
    })), E = d.map((N) => ({
      keys: N,
      type: is
    })), B = f.leftAxisInfo.length;
    const m = {
      colHeaderKeysLength: d.length,
      colTopAxisLength: I.topAxisInfo.length,
      colBottomAxisLength: I.bottomAxisInfo.length,
      rowHeaderKeysLength: u.length,
      rowLeftAxisLength: f.leftAxisInfo.length,
      rowRightAxisLength: f.rightAxisInfo.length
    };
    r.length && (o = (i === "row" ? this._rowGrandTotalMatrixInst : this._columnGrandTotalMatrixInst).updateGrandTotalsMatrix(
      r,
      o,
      this.context(),
      this.encoder().simpleEncoder,
      this._suppliedLayers
    ));
    const {
      beforeGrandTotalsInfo: {
        rowHeaderKeysLength: y,
        colHeaderKeysLength: D,
        rowLeftAxisLength: Q,
        rowRightAxisLength: p,
        colTopAxisLength: w,
        colBottomAxisLength: x
      },
      allRowHeaderKeys: S,
      allColumnHeaderKeys: _,
      allRowAxisInfo: M,
      allColumnAxisInfo: k
    } = this._matrixInfo, T = Mb(
      this.context().config(),
      S.length - y
    ), G = _b(
      this.context().config(),
      _.length - D
    );
    S.splice(
      T,
      y,
      ...C
    ), _.splice(
      G,
      D,
      ...E
    ), M.leftAxisInfo.splice(
      T,
      Q,
      ...f.leftAxisInfo
    ), M.rightAxisInfo.splice(
      T,
      p,
      ...f.rightAxisInfo
    ), k.topAxisInfo.splice(
      G,
      w,
      ...I.topAxisInfo
    ), k.bottomAxisInfo.splice(
      G,
      x,
      ...I.bottomAxisInfo
    ), C = S, E = _, f = {
      ...M
    }, I = {
      ...k
    }, B = f.leftAxisInfo.length, this._matrixInfo = {
      allRowHeaderKeys: C,
      rowKeys: A,
      allRowAxisInfo: f,
      allColumnHeaderKeys: E,
      columnKeys: s,
      allColumnAxisInfo: I,
      totalRowItemCount: B,
      totalRowFacetCount: A.length,
      rowsPerFacet: c.length,
      dataModelMatrix: o,
      completeDataModelMatrix: o,
      updateInfo: a,
      beforeGrandTotalsInfo: m
    };
  }
  generateMatrices() {
    const t = this.getAllFields(), { fields: i } = this.horizontalAxis(), { fields: n } = this.verticalAxis(), A = this.context(), s = A.config(), {
      groupBy: o,
      facetsUserConfig: r,
      rows: {
        facets: a,
        totals: {
          data: { totalString: l }
          // subTotals: { text: rowTotalsAllString },
        }
      },
      columns: {
        facets: c,
        totals: {
          data: { totalString: g }
          // subTotals: { text: colSubTotalsAllString },
        }
      }
    } = s, { rowFacets: h, colFacets: u, colProjections: d, rowProjections: f } = t, I = d.flat(), C = f.flat(), E = h.length > 0 || u.length > 0;
    E && (s.isFacet = !0);
    const B = E && nI(r), m = A._encoders.simpleEncoder, y = m.serializeLayerConfig(this.context().layers()).map((Qt) => Object.assign({ isBold: !1 }, Qt));
    this._suppliedLayers = y;
    const D = y.length > 0 ? y.some(({ mark: Qt }) => Qt !== "text") : !0, Q = [
      ...C,
      ...I
    ].some((Qt) => Qt.as() === HV), p = [...f, ...d].some(
      (Qt) => Qt.length > 1
    ), w = D || Q || p ? "svg" : "html";
    this._cellRenderer = w;
    const x = y.flatMap((Qt) => {
      const { detail: kt } = Qt.encoding;
      return kt && Array.isArray(kt.field) ? kt.field : [];
    });
    t.optionalProjections.push(...x);
    const S = this._groupedData = Db(
      A.data(),
      {
        facetsAndProjections: t,
        suppliedLayers: y,
        groupBy: o,
        globalConfig: s
      },
      this
    );
    m.data(S), this._resolvedEncodedLayers = m.getResolvedEncodings(
      {
        columnFields: I,
        rowFields: C,
        dataStore: S
      },
      y,
      s,
      A
    );
    const _ = A.getAllRetinalEncodings(
      this._resolvedEncodedLayers.flatMap(
        ({ def: Qt }) => Array.isArray(Qt) ? Qt.map(({ encoding: kt }) => kt) : Qt.encoding
      )
    );
    this._retinalConfig = _;
    const M = k0(
      a.fields
    ), k = k0(
      c.fields
    ), T = PV(A.data()), G = s.rows.totals.subTotals.position, N = s.columns.totals.subTotals.position, b = h.flatMap(R0).map(M).map(
      ({ name: Qt, sortConfig: kt }) => T({
        name: Qt,
        sortConfig: kt,
        totalString: g,
        subTotalsPosition: N
      })
    ), F = u.flatMap(R0).map(k).map(
      ({ name: Qt, sortConfig: kt }) => T({
        name: Qt,
        sortConfig: kt,
        totalString: l,
        subTotalsPosition: G
      })
    ), R = {
      row: Object.fromEntries(b),
      column: Object.fromEntries(F)
    };
    this._detailedFacetProjectionInfo = {
      colFacets: u,
      rowFacets: h,
      ...wb({
        rowProjections: C,
        colProjections: I,
        optionalProjections: this._detailedOptionalProjections
      })
    };
    const {
      columnTotalString: v,
      rowTotalString: O,
      colSubTotalsSplitField: L,
      rowSubTotalsSplitField: U
    } = uA(A.config());
    if (this.greatGrandTotalsDataModel() && (this.greatGrandTotalsDataModel().dispose(), this._greatGrandTotalsDataModel = null), this.columnGrandTotalsDataModel() && (this.columnGrandTotalsDataModel().dispose(), this._columnGrandTotalsDataModel = null), this.rowGrandTotalsDataModel() && (this.rowGrandTotalsDataModel().dispose(), this._rowGrandTotalsDataModel = null), this._greatSubTotalsDataModel && (this._greatSubTotalsDataModel.dispose(), this._greatSubTotalsDataModel = null), this._columnSubTotalsDataModel && (this._columnSubTotalsDataModel.dispose(), this._columnSubTotalsDataModel = null), this._rowSubTotalsDataModel && (this._rowSubTotalsDataModel.dispose(), this._rowSubTotalsDataModel = null), this._rowSubTotalsDataModel = LV({
      detailedFacetProjectionInfo: this._detailedFacetProjectionInfo,
      facetsAndProjections: t,
      globalConfig: Object.assign({ facetSortConfig: R }, s),
      suppliedLayers: y,
      dataStore: A.data()
    }), this._columnSubTotalsDataModel = UV({
      detailedFacetProjectionInfo: this._detailedFacetProjectionInfo,
      facetsAndProjections: t,
      globalConfig: Object.assign({ facetSortConfig: R }, s),
      suppliedLayers: y,
      dataStore: A.data()
    }), this._greatSubTotalsDataModel = OV({
      detailedFacetProjectionInfo: this._detailedFacetProjectionInfo,
      facetsAndProjections: t,
      globalConfig: Object.assign({ facetSortConfig: R }, s),
      suppliedLayers: y,
      dataStore: A.data(),
      columnSubTotalsDM: this._columnSubTotalsDataModel
    }), this._columnSubTotalsDataModel) {
      const Qt = aB(
        this._columnSubTotalsDataModel,
        {
          discreteRowProjections: this._detailedFacetProjectionInfo.discreteRowProjections,
          discreteColumnProjections: this._detailedFacetProjectionInfo.discreteColumnProjections,
          rowFacets: [],
          colFacets: []
        },
        U,
        L,
        v
      );
      let kt = Qt ? this._columnSubTotalsDataModel.select(Qt) : null;
      kt && kt.getData().data.length === 0 ? kt = null : this._columnSubTotalsDataModel = kt;
    }
    const { rowKeys: H, columnKeys: z, dataModelMatrix: et } = this._matrixModel.getMatrixModel(S, t, {
      facetSortConfig: R,
      globalConfig: s,
      rowTotalsDM: this._rowSubTotalsDataModel,
      columnTotalsDM: this._columnSubTotalsDataModel,
      greatTotalsDM: this._greatSubTotalsDataModel,
      canvasHelpers: A._canvasHelpers
    });
    this.createRetinalAxes(A.data(), { ..._ });
    const { classPrefix: Z, showHeaders: Y } = s, q = this._matrix;
    this.resolveAxisBandwidthConfig();
    let $ = {};
    const P = y.find(({ mark: Qt }) => Qt === "text");
    if (P && P.encoding && P.encoding.text && P.encoding.text.field) {
      const Qt = P.encoding.text.field, kt = S.getField(Qt);
      $ = {
        dmField: kt,
        as: P.encoding.text.as || Ve(kt)
      };
    }
    const st = this.getDirectSortEnabledInfo({
      cellRenderer: w,
      textLayerInfo: $
    });
    q.config({
      rows: {
        isBold: !1,
        renderer: w,
        directSortEnabledInfo: st,
        sanitizeCheckBorder: B,
        isColumnsCompact: A.config().axes.x.compact,
        isRowsCompact: A.config().axes.y.compact,
        ...this.prepareRowMatrixConfig({ show: !0 })
      },
      columns: {
        isBold: !1,
        renderer: w,
        directSortEnabledInfo: st,
        sanitizeCheckBorder: B,
        firstSuppliedTextLayerInfo: $,
        isColumnsCompact: A.config().axes.x.compact,
        isRowsCompact: A.config().axes.y.compact,
        ...this.prepareColumnMatrixConfig({ show: !0 })
      },
      headerTitle: {
        renderer: w,
        rowHeaders: i,
        showHeaders: Y,
        classPrefix: Z,
        columnHeaders: n,
        sanitizeCheckBorder: B
      },
      geoms: {
        alias: A.alias(),
        coord: m.constructor.type(),
        encoder: m,
        unitConfig: Ib(s || {}),
        retinalAxes: this.getRetinalAxes(),
        valueParser: this.valueParser(),
        renderer: w,
        retinalConfig: _,
        sanitizeCheckBorder: B,
        visualGroupConfig: s,
        detailFields: A.detail(),
        dataModelTransform: A.transform(),
        interactions: A.interactionRegistry(),
        facetsAndProjections: t,
        columnTotalString: v,
        rowTotalString: O
      }
    });
    const { rowHeaderKeys: nt, columnHeaderKeys: ot, rowAxisInfo: Et, columnAxisInfo: ct } = F0({
      rowKeys: H,
      columnKeys: z,
      colFacets: u,
      rowFacets: h,
      rowProjections: f,
      colProjections: d,
      rowCollapseStatus: this._matrixModel._rowCollapseStatus,
      columnCollapseStatus: this._matrixModel._columnCollapseStatus,
      globalConfig: s
    }), ht = FV({
      detailedFacetProjectionInfo: this._detailedFacetProjectionInfo,
      facetsAndProjections: t,
      globalConfig: Object.assign({ facetSortConfig: R }, s),
      suppliedLayers: y,
      dataStore: A.data(),
      canvasHelpers: A._canvasHelpers,
      subTotalsInfo: {
        rowSubTotalsDS: this._rowSubTotalsDataModel,
        columnSubTotalsDS: this._columnSubTotalsDataModel,
        greatSubTotalsDS: this._greatSubTotalsDataModel
      }
    });
    ht && ht.columnTotalsDSWithAll && (this.columnGrandTotalsDataModel(
      ht.columnTotalsDSWithAll
    ), this._columnGrandTotalMatrixInst = ht.matrixModelInst);
    const Mt = TV({
      detailedFacetProjectionInfo: this._detailedFacetProjectionInfo,
      facetsAndProjections: t,
      globalConfig: Object.assign({ facetSortConfig: R }, s),
      suppliedLayers: y,
      dataStore: A.data(),
      canvasHelpers: A._canvasHelpers,
      subTotalsInfo: {
        rowSubTotalsDS: this._rowSubTotalsDataModel,
        columnSubTotalsDS: this._columnSubTotalsDataModel,
        greatSubTotalsDS: this._greatSubTotalsDataModel
      }
    });
    Mt && Mt.rowTotalsDSWithAll && (this.rowGrandTotalsDataModel(Mt.rowTotalsDSWithAll), this._rowGrandTotalMatrixInst = Mt.matrixModelInst);
    let Ue = nt.map((Qt) => ({
      keys: Qt,
      type: is
    })), at = ot.map((Qt) => ({
      keys: Qt,
      type: is
    })), Ot = Et, Vt = ct;
    const pi = {
      colHeaderKeysLength: ot.length,
      colTopAxisLength: ct.topAxisInfo.length,
      colBottomAxisLength: ct.bottomAxisInfo.length,
      rowHeaderKeysLength: nt.length,
      rowLeftAxisLength: Et.leftAxisInfo.length,
      rowRightAxisLength: Et.rightAxisInfo.length
    };
    if (Mt) {
      at = [
        ...ot.map(($e) => ({
          keys: $e,
          type: is
        }))
      ];
      const Qt = [
        ...Mt.columnKeys.map(($e, ue) => ({
          keys: $e,
          type: Uf,
          config: (
            // Check if rowGrandTotalMatrixInfo.columnFacetsInfo.topFacetsInfo[i] exists
            // if it is an Array check for length else just check if it's truthy
            ((Array.isArray(
              Mt.columnFacetsInfo.topFacetsInfo[ue]
            ) ? Mt.columnFacetsInfo.topFacetsInfo[ue].length : Mt.columnFacetsInfo.topFacetsInfo[ue]) ? (
              // if rowGrandTotalMatrixInfo.columnFacetsInfo.topFacetsInfo[i] exists, then
              // that else rowGrandTotalMatrixInfo.columnFacetsInfo.bottomFacetsInfo[i]
              Mt.columnFacetsInfo.topFacetsInfo[ue]
            ) : Mt.columnFacetsInfo.bottomFacetsInfo[ue]).config
          )
        }))
      ], kt = s.rows.totals.grandTotals.position;
      kt === "start" ? at.unshift(...Qt) : at.push(...Qt), kt === "start" ? (Vt.topAxisInfo = [
        ...Mt.columnAxisInfo.topAxisInfo,
        ...Vt.topAxisInfo
      ], Vt.bottomAxisInfo = [
        ...Mt.columnAxisInfo.bottomAxisInfo,
        ...Vt.bottomAxisInfo
      ]) : (Vt.topAxisInfo = [
        ...Vt.topAxisInfo,
        ...Mt.columnAxisInfo.topAxisInfo
      ], Vt.bottomAxisInfo = [
        ...Vt.bottomAxisInfo,
        ...Mt.columnAxisInfo.bottomAxisInfo
      ]);
    }
    let he;
    if (ht) {
      he = GV({
        globalConfig: Object.assign({ facetSortConfig: R }, s),
        facetsAndProjections: t,
        detailedFacetProjectionInfo: this._detailedFacetProjectionInfo,
        columnTotalsDSWithAll: ht.columnTotalsDSWithAll,
        suppliedLayers: y,
        canvasHelpers: A._canvasHelpers,
        subTotalsInfo: {
          rowSubTotalsDS: this._rowSubTotalsDataModel,
          columnSubTotalsDS: this._columnSubTotalsDataModel,
          greatSubTotalsDS: this._greatSubTotalsDataModel
        }
      }), he && he.greatTotalsDS && this.greatGrandTotalsDataModel(he.greatTotalsDS);
      const Qt = s.columns.totals.grandTotals.position;
      Ue = [
        ...nt.map(($e) => ({
          keys: $e,
          type: is
        }))
      ];
      const kt = ht.rowKeys.map(
        ($e, ue) => ({
          keys: $e,
          type: Uf,
          config: (
            // Check if columnGrandTotalMatrixInfo.columnFacetsInfo.topFacetsInfo[i] exists
            // if it is an Array check for length else just check if it's truthy
            ((Array.isArray(
              ht.rowFacetsInfo.leftFacetsInfo[ue]
            ) ? ht.rowFacetsInfo.leftFacetsInfo[ue].length : ht.rowFacetsInfo.leftFacetsInfo[ue]) ? (
              // if columnGrandTotalMatrixInfo.rowFacetsInfo.leftFacetsInfo[i] exists, then
              // that else columnGrandTotalMatrixInfo.rowFacetsInfo.rightFacetsInfo[i]
              ht.rowFacetsInfo.leftFacetsInfo[ue]
            ) : ht.rowFacetsInfo.rightFacetsInfo[ue]).config
          )
        })
      );
      Qt === "start" ? Ue.unshift(...kt) : Ue.push(...kt), Ot.leftAxisInfo = [...Ot.leftAxisInfo], Qt === "start" ? Ot.leftAxisInfo.unshift(
        ...ht.rowAxisInfo.leftAxisInfo
      ) : Ot.leftAxisInfo.push(
        ...ht.rowAxisInfo.leftAxisInfo
      ), Ot.rightAxisInfo = [
        ...Ot.rightAxisInfo,
        ...ht.rowAxisInfo.rightAxisInfo
      ];
    }
    const oA = Ot.leftAxisInfo.length;
    let rA = et, eo;
    if (Mt) {
      eo = Mt.dataModelMatrix;
      const Qt = s.rows.totals.grandTotals.position;
      rA = Sb(
        et,
        eo,
        Qt
      );
    }
    if (ht) {
      const Qt = ht.dataModelMatrix;
      let kt;
      he && (kt = he.dataModelMatrix);
      const $e = s.columns.totals.grandTotals.position, ue = s.rows.totals.grandTotals.position;
      rA = xb(
        rA,
        {
          columnGrandTotalDataMatrix: Qt,
          greatGrandTotalDataMatrix: kt,
          rowGrandTotalDataMatrix: eo
        },
        $e,
        ue
      );
    }
    let io = rA;
    (s.pagination.enabled && !s.pagination.unionAxisDomainPerPage || !s.pagination.enabled) && (io = IA(
      os(
        this.context(),
        this.encoder().simpleEncoder,
        rA,
        this._suppliedLayers
      ),
      s
    )), this._matrixInfo = {
      allRowHeaderKeys: Ue,
      rowKeys: H,
      allRowAxisInfo: Ot,
      allColumnHeaderKeys: at,
      columnKeys: z,
      allColumnAxisInfo: Vt,
      totalRowItemCount: oA,
      totalRowFacetCount: H.length,
      rowsPerFacet: t.rowProjections.length,
      dataModelMatrix: io,
      completeDataModelMatrix: io,
      beforeGrandTotalsInfo: pi
    };
  }
  handleZebraTypeConfig(t) {
    const {
      geom: { _matrix: i },
      row: {
        _matrices: {
          axes: {
            _cells: { left: n, right: A }
          }
        }
      }
    } = t._matrices, { AxisCell: s } = this.context().registry().componentSubRegistry.cells.get(), o = (r) => r instanceof s;
    n.filter(o).reduce((r, a) => {
      const l = a.source(), c = l.domain().length;
      return l.config({ firstRowZebraType: r }), c % 2 === 0 ? r : r === "odd" ? "even" : "odd";
    }, "odd"), A.filter(o).reduce((r, a) => {
      const l = a.source(), c = l.domain().length;
      return l.config({ firstRowZebraType: r }), c % 2 === 0 ? r : r === "odd" ? "even" : "odd";
    }, "odd"), i.reduce((r, a) => Ye(
      a.map((c) => (c.source().layers().forEach((u) => {
        u.config(
          Object.assign(u.config(), { firstRowZebraType: r })
        );
      }), c)).map((c) => {
        const g = c.source(), { y: h } = g.axes();
        return Ye(h.map((u) => u.domain().length));
      })
    ) % 2 === 0 ? r : r === "odd" ? "even" : "odd", "odd");
  }
  generateMatrixInstance(t) {
    this._paginatedMatrixInfo = t;
    const i = this.getAllFields(), n = this.context().config(), {
      sort: A,
      facets: s,
      rows: { facets: o },
      columns: { facets: r }
    } = n, a = this.context(), { rowFacets: l, colFacets: c, colProjections: g, rowProjections: h } = i, { fields: u } = this.horizontalAxis(), { fields: d } = this.verticalAxis(), f = l.length > 0 || c.length > 0, I = f ? AI(
      {
        row: o,
        column: r
      },
      a.data()
    ) : {}, C = f ? sI(
      {
        row: o,
        column: r
      },
      a.data()
    ) : {}, E = this._matrix, B = this._cellRenderer;
    t.dataModelMatrix = t.dataModelMatrix.map((N) => N.map((b) => ({
      ...b,
      layerDataModels: Object.keys(b.layerDataModels).reduce(
        (F, R) => (F[R] = b.layerDataModels[R].project(
          b.dataStore.getSchema().filter((v) => v.name !== St.ROW_ID).map((v) => v.name)
        ), F),
        {}
      )
    })));
    const {
      allRowHeaderKeys: m,
      rowKeys: y,
      allRowAxisInfo: D,
      allColumnAxisInfo: Q,
      allColumnHeaderKeys: p,
      columnKeys: w,
      dataModelMatrix: x
    } = t;
    E.generateMatrices({
      facets: this.facets(),
      facetsConfig: s,
      rowFacetsConfig: o,
      colFacetsConfig: r,
      facetFormatters: I,
      facetHyperLinkFormatters: C,
      headers: {
        rowKeys: m,
        columnKeys: p
      },
      axesInfo: {
        x: {
          facetKeys: w,
          axisFields: g,
          // NOTE:
          // columnTitle: context.config().axesHeaders.column,
          columnTitle: a.config().columns.headers,
          columnAxisInfo: Q
        },
        y: {
          facetKeys: y,
          axisFields: h,
          rowTitle: a.config().rows.headers,
          rowAxisInfo: D
        }
      },
      dataModelMatrix: x,
      layerDomains: this._layerDomains,
      childEventManagerCreator: () => a.createChildEventManager(),
      canvasActions: a._canvasHelpers,
      rootGroupedData: a._encoders.simpleEncoder.data(),
      rootMatrixInfo: this._matrixInfo,
      paginatedMatrixInfo: t,
      totalsData: {
        columns: this.columnGrandTotalsDataModel(),
        rows: this.rowGrandTotalsDataModel(),
        greatGrandTotals: this.greatGrandTotalsDataModel()
      },
      globalConfig: a.config()
    }), E.registerHooksEvents(a), E.setCanvasDimensionsToAxes(a), E.setAxisDomains(
      n.uniformAxisDomains,
      {
        rootModel: a.data(),
        columnGTRootModel: this.columnGrandTotalsDataModel() == null ? a.data() : this.columnGrandTotalsDataModel(),
        rowGTRootModel: this.rowGrandTotalsDataModel() == null ? a.data() : this.rowGrandTotalsDataModel()
      },
      {
        sort: A,
        unionAxisDomainPerPage: n.pagination.unionAxisDomainPerPage && n.pagination.enabled
      }
    ), B === "html" && this.handleZebraTypeConfig(E), this.setRetinalAxisDomain();
    const S = E.getMatrices(), _ = eI(u), M = eI(d), k = {}, T = S.columns, G = S.rows;
    return T && (k.columns = T), G && (k.rows = G), Object.assign(S, k, {
      // @todo get isRowSizeEqual from rows and column matrix
      values: S.values,
      cellRenderer: B,
      isRowSizeEqual: _,
      isColumnSizeEqual: M,
      priorityMinWidths: {
        row: _ ? null : 0.25
      },
      priorityMaxWidths: {
        row: _ ? null : 0.5
      }
    });
  }
  updateMatrixInstance(t, i, { targetPath: n = [] } = {}) {
    this._paginatedMatrixInfo = t;
    const A = this.getAllFields(), s = this.context().config(), {
      sort: o,
      rows: {
        facets: r,
        totals: {
          subTotals: {
            enabled: a,
            splitTotal: { field: l }
          }
        }
      },
      columns: {
        facets: c,
        totals: {
          subTotals: {
            enabled: g,
            splitTotal: { field: h }
          }
        }
      },
      pagination: { enabled: u }
    } = s, d = this.context(), { rowFacets: f, colFacets: I, colProjections: C, rowProjections: E } = A, B = f.length > 0 || I.length > 0, m = B ? AI(
      {
        row: r,
        column: c
      },
      d.data()
    ) : {}, y = B ? sI(
      {
        row: r,
        column: c
      },
      d.data()
    ) : {}, D = this._matrix, Q = this._cellRenderer, {
      allRowHeaderKeys: p,
      rowKeys: w,
      allRowAxisInfo: x,
      allColumnAxisInfo: S,
      allColumnHeaderKeys: _,
      columnKeys: M,
      dataModelMatrix: k,
      updateInfo: T
    } = t;
    D.updateMatrices({
      facets: this.facets(),
      rowFacetsConfig: r,
      colFacetsConfig: c,
      facetFormatters: m,
      facetHyperLinkFormatters: y,
      headers: {
        rowKeys: p,
        columnKeys: _
      },
      axesInfo: {
        x: {
          facetKeys: M,
          axisFields: C,
          columnTitle: d.config().columns.headers,
          columnAxisInfo: S
        },
        y: {
          facetKeys: w,
          axisFields: E,
          rowTitle: d.config().rows.headers,
          rowAxisInfo: x
        }
      },
      dataModelMatrix: k,
      layerDomains: this._layerDomains,
      canvasActions: d._canvasHelpers,
      rootGroupedData: d._encoders.simpleEncoder.data(),
      rootMatrixInfo: this._matrixInfo,
      paginatedMatrixInfo: t,
      totalsData: {
        columns: this.columnGrandTotalsDataModel(),
        rows: this.rowGrandTotalsDataModel(),
        greatGrandTotals: this.greatGrandTotalsDataModel()
      },
      subTotalsInfo: {
        isColSubTotalsEnabled: g,
        isRowSubTotalsEnabled: a,
        rowSplitSubtotalsField: a ? l : null,
        colSplitSubtotalsField: g ? h : null,
        rowSubTotalsDS: this._rowSubTotalsDataModel,
        colSubTotalsDS: this._columnSubTotalsDataModel
      },
      updateInfo: T,
      facetType: i,
      paginated: u,
      targetPath: n
    }), D.registerHooksEvents(d), D.setCanvasDimensionsToAxes(d, i), D.setAxisDomains(
      s.uniformAxisDomains,
      {
        rootModel: d.data(),
        columnGTRootModel: this.columnGrandTotalsDataModel() == null ? d.data() : this.columnGrandTotalsDataModel(),
        rowGTRootModel: this.rowGrandTotalsDataModel() == null ? d.data() : this.rowGrandTotalsDataModel()
      },
      {
        sort: o,
        unionAxisDomainPerPage: s.pagination.unionAxisDomainPerPage && s.pagination.enabled
      }
    ), Q === "html" && this.handleZebraTypeConfig(D), this.setRetinalAxisDomain();
    const G = D.getMatrices(), N = {}, b = G.columns, F = G.rows;
    return b && (N.columns = b), F && (N.rows = F), Object.assign(G, N, {
      values: G.values
    });
  }
  setPaginatedMatrixInfo(t) {
    this._paginatedMatrixInfo = t, this._matrix.setPaginatedMatrixInfo(t);
  }
  arcMarkFound() {
    return !!(this.context().layers() || []).find((i) => i.mark === "arc");
  }
  resolveAxisBandwidthConfig() {
    let t = this.context().config();
    const i = this.context().layers() || [], { size: n } = this.axes();
    let A = 0, s = 0;
    if (i.find((a) => a.mark === "arc") && (A = BM), i.find((a) => a.mark === "bar")) {
      const a = n.filter((l) => l.config().field).map((l) => l.range());
      if (a.length) {
        const l = [
          Math.min(...a.map((c) => c[0])),
          Math.max(...a.map((c) => c[1]))
        ];
        s = l[1] + l[1] / 3;
      }
    }
    const o = Math.max(A, s), r = t.axes;
    o && [wl, yu].forEach((a) => {
      r[a].bandwidth || (r[a].bandwidth = o);
    });
  }
  prepareRowMatrixConfig(t) {
    const i = this.encoder().simpleEncoder, n = this.context().config(), A = tt(
      n.rows.facets
      // globalConfig.facets.rows
    );
    return {
      headers: Object.assign(
        {
          facet: {
            ...YW,
            ...i._headerFrom
          },
          takeHeaderFrom: i._headerFrom.row,
          useExternalCSS: n.useExternalCSS,
          facetConfig: A,
          interaction: tt(
            {},
            {
              directSortSelect: {
                sideEffects: {
                  "toggle-sort-dropdown": {
                    hook: $c.getRowHeaderSortingHook(this)
                  }
                }
              }
            },
            n.rows.headers.interaction
          )
        },
        t
      ),
      axes: {
        axisFrom: i._axisFrom.row,
        // @todo Remove this global config
        globalConfig: n,
        interaction: {
          directSortSelect: {
            sideEffects: {
              "toggle-sort-dropdown": {
                hook: $c.getYAxisSortingHook(this)
              }
            }
          }
        }
      },
      interaction: n.rows.interaction,
      sourceCanvasAlias: this.context().alias(),
      globalBorderConfig: n.border
    };
  }
  prepareColumnMatrixConfig(t) {
    const i = this.encoder().simpleEncoder, n = this.context().config(), A = tt(
      n.columns.facets
      // globalConfig.facets.columns
    );
    return {
      headers: Object.assign(
        {
          facet: i._headerFrom,
          takeHeaderFrom: i._headerFrom.column,
          useExternalCSS: n.useExternalCSS,
          facetConfig: A,
          interaction: n.columns.headers.interaction
        },
        t
      ),
      axes: {
        axisFrom: i._axisFrom.column,
        globalConfig: n,
        interaction: {
          directSortSelect: {
            sideEffects: {
              "toggle-sort-dropdown": {
                hook: $c.getXAxisSortingHook(this)
              }
            }
          }
        }
      },
      interaction: n.columns.interaction,
      sourceCanvasAlias: this.context().alias()
    };
  }
  getDirectSortEnabledInfo({ cellRenderer: t, textLayerInfo: i }) {
    const A = this.context().config(), s = A.rows.headers.enableDirectSort, o = [
      A.axes.x.enableDirectSort,
      A.axes.y.enableDirectSort
    ].map((r) => r ? t === "html" ? i.as === lt.CONTINUOUS : t === "svg" : !1);
    return {
      rowsHeaders: s,
      axes: {
        x: o[0],
        y: o[1]
      }
    };
  }
  clear() {
    this._matrix.clear(), this._groupedData != null && this._groupedData.dispose(), this.greatGrandTotalsDataModel() != null && this.greatGrandTotalsDataModel().dispose(), this.columnGrandTotalsDataModel() != null && this.columnGrandTotalsDataModel().dispose(), this.rowGrandTotalsDataModel() != null && this.rowGrandTotalsDataModel().dispose(), this._greatSubTotalsDataModel && (this._greatSubTotalsDataModel.dispose(), this._greatSubTotalsDataModel = null), this._columnSubTotalsDataModel && (this._columnSubTotalsDataModel.dispose(), this._columnSubTotalsDataModel = null), this._rowSubTotalsDataModel && (this._rowSubTotalsDataModel.dispose(), this._rowSubTotalsDataModel = null);
  }
  getRowGrandTotalsDataModelInfo(t, i, n = {}) {
    const { rowTotalsSplitField: A, rowGrandTotalsPosition: s } = uA(i), o = n[A];
    let r = -1;
    const a = this._matrixInfo.completeDataModelMatrix[t];
    if (o) {
      if (s === "start") {
        for (let l = 0; l <= a.length - 1; l++)
          if (a[l].columnFacetValues.findIndex(
            (g) => `${g}` == `${o}`
          ) >= 0) {
            r = l;
            break;
          }
      } else
        for (let l = a.length - 1; l >= 0; l--)
          if (a[l].columnFacetValues.findIndex(
            (g) => `${g}` == `${o}`
          ) >= 0) {
            r = l;
            break;
          }
    }
    return r = r === -1 ? a.length - 1 : r, {
      dataStore: a[r].dataStore,
      rowFacets: this._detailedFacetProjectionInfo?.rowFacets || {},
      colFacets: this._detailedFacetProjectionInfo?.colFacets || {},
      discreteColumnProjections: this._detailedFacetProjectionInfo?.discreteColumnProjections || {},
      discreteRowProjections: this._detailedFacetProjectionInfo?.discreteRowProjections || {}
    };
  }
  getColumnGrandTotalsDataModelInfo(t, i, n = {}) {
    const { columnTotalsSplitField: A, columnGrandTotalsPosition: s } = uA(i), o = n[A];
    let r = -1;
    if (o) {
      if (s === "start") {
        for (let a = 0; a <= this._matrixInfo.completeDataModelMatrix.length - 1; a++)
          if (this._matrixInfo.completeDataModelMatrix[a][t].rowFacetValues.findIndex(
            (g) => `${g}` == `${o}`
          ) >= 0) {
            r = a;
            break;
          }
      } else
        for (let a = this._matrixInfo.completeDataModelMatrix.length - 1; a >= 0; a--)
          if (this._matrixInfo.completeDataModelMatrix[a][t].rowFacetValues.findIndex(
            (g) => `${g}` == `${o}`
          ) >= 0) {
            r = a;
            break;
          }
    }
    return r = r === -1 ? this._matrixInfo.completeDataModelMatrix.length - 1 : r, {
      dataStore: this._matrixInfo.completeDataModelMatrix[r][t].dataStore,
      rowFacets: this._detailedFacetProjectionInfo?.rowFacets || {},
      colFacets: this._detailedFacetProjectionInfo?.colFacets || {},
      discreteColumnProjections: this._detailedFacetProjectionInfo?.discreteColumnProjections || {},
      discreteRowProjections: this._detailedFacetProjectionInfo?.discreteRowProjections || {}
    };
  }
  getGreatGrandTotalsDataModelInfo(t, i = {}) {
    const {
      rowTotalsSplitField: n,
      columnTotalsSplitField: A,
      rowGrandTotalsPosition: s,
      columnGrandTotalsPosition: o
    } = uA(t);
    let r = -1, a = -1;
    const l = i[n], c = i[A];
    if (l && !c) {
      r = this._matrixInfo.completeDataModelMatrix.length - 1;
      let g = this._matrixInfo.completeDataModelMatrix[r];
      if (s === "start") {
        for (let h = 0; h <= g.length - 1; h++)
          if (g[h].columnFacetValues.findIndex(
            (d) => `${d}` == `${l}`
          ) >= 0) {
            a = h;
            break;
          }
      } else
        for (let h = g.length - 1; h >= 0; h--)
          if (g[h].columnFacetValues.findIndex(
            (d) => `${d}` == `${l}`
          ) >= 0) {
            a = h;
            break;
          }
      a = a === -1 ? g.length - 1 : a;
    } else if (!l && c) {
      if (o === "start")
        for (let g = 0; g <= this._matrixInfo.completeDataModelMatrix.length - 1; g++) {
          const h = this._matrixInfo.completeDataModelMatrix[g];
          if (h[h.length - 1].rowFacetValues.findIndex(
            (d) => `${d}` == `${c}`
          ) >= 0) {
            r = g;
            break;
          }
        }
      else
        for (let g = this._matrixInfo.completeDataModelMatrix.length - 1; g >= 0; g--) {
          const h = this._matrixInfo.completeDataModelMatrix[g];
          if (h[h.length - 1].rowFacetValues.findIndex(
            (d) => `${d}` == `${c}`
          ) >= 0) {
            r = g;
            break;
          }
        }
      r = r === -1 ? this._matrixInfo.completeDataModelMatrix.length - 1 : r, a = this._matrixInfo.completeDataModelMatrix[r].length - 1;
    } else if (l && c)
      if (o === "start" && s === "start")
        for (let g = 0; g < this._matrixInfo.completeDataModelMatrix.length; g++) {
          for (let h = 0; h < this._matrixInfo.completeDataModelMatrix[g].length; h++) {
            const u = this._matrixInfo.completeDataModelMatrix[g][h], d = u.rowFacetValues.findIndex(
              (I) => `${I}` == `${c}`
            ), f = u.columnFacetValues.findIndex(
              (I) => `${I}` == `${l}`
            );
            if (d >= 0 && f >= 0) {
              r = g, a = h;
              break;
            }
          }
          if (r !== -1 && a !== -1)
            break;
        }
      else if (o === "start" && s !== "start")
        for (let g = 0; g < this._matrixInfo.completeDataModelMatrix.length; g++) {
          for (let h = this._matrixInfo.completeDataModelMatrix[g].length - 1; h >= 0; h--) {
            const u = this._matrixInfo.completeDataModelMatrix[g][h], d = u.rowFacetValues.findIndex(
              (I) => `${I}` == `${c}`
            ), f = u.columnFacetValues.findIndex(
              (I) => `${I}` == `${l}`
            );
            if (d >= 0 && f >= 0) {
              r = g, a = h;
              break;
            }
          }
          if (r !== -1 && a !== -1)
            break;
        }
      else if (o !== "start" && s === "start")
        for (let g = this._matrixInfo.completeDataModelMatrix.length - 1; g >= 0; g--) {
          for (let h = 0; h < this._matrixInfo.completeDataModelMatrix[g].length; h++) {
            const u = this._matrixInfo.completeDataModelMatrix[g][h], d = u.rowFacetValues.findIndex(
              (I) => `${I}` == `${c}`
            ), f = u.columnFacetValues.findIndex(
              (I) => `${I}` == `${l}`
            );
            if (d >= 0 && f >= 0) {
              r = g, a = h;
              break;
            }
          }
          if (r !== -1 && a !== -1)
            break;
        }
      else
        for (let g = this._matrixInfo.completeDataModelMatrix.length - 1; g >= 0; g--) {
          for (let h = this._matrixInfo.completeDataModelMatrix[g].length - 1; h >= 0; h--) {
            const u = this._matrixInfo.completeDataModelMatrix[g][h], d = u.rowFacetValues.findIndex(
              (I) => `${I}` == `${c}`
            ), f = u.columnFacetValues.findIndex(
              (I) => `${I}` == `${l}`
            );
            if (d >= 0 && f >= 0) {
              r = g, a = h;
              break;
            }
          }
          if (r !== -1 && a !== -1)
            break;
        }
    else
      r = o === "start" ? 0 : this._matrixInfo.completeDataModelMatrix.length - 1, a = s === "start" ? 0 : this._matrixInfo.completeDataModelMatrix[r].length - 1;
    return {
      dataStore: this._matrixInfo.completeDataModelMatrix[r][a].dataStore,
      rowFacets: this._detailedFacetProjectionInfo?.rowFacets || {},
      colFacets: this._detailedFacetProjectionInfo?.colFacets || {},
      discreteColumnProjections: this._detailedFacetProjectionInfo?.discreteColumnProjections || {},
      discreteRowProjections: this._detailedFacetProjectionInfo?.discreteRowProjections || {}
    };
  }
  getColumnsubTotalsDataModelInfo(t, i, n) {
    const {
      columnTotalString: A,
      colSubTotalsSplitField: s,
      columnSubTotalsPosition: o
    } = uA(t), a = this._matrixInfo.completeDataModelMatrix[i.unitRowIndex][i.unitColIndex].rowFacetValues;
    let l = a.findIndex(
      (h) => h === A
    ), c = i.unitRowIndex;
    if (l === 0 || l === 1)
      return this.getColumnGrandTotalsDataModelInfo(
        i.unitColIndex,
        t,
        i.facets
      );
    if (l === -1 && this._detailedFacetProjectionInfo?.discreteRowProjections.every(
      (h) => n.dataObj[h] === A
    ) || l >= 0 || this._detailedFacetProjectionInfo.discreteRowProjections.findIndex(
      (h) => h === s
    ) >= 0) {
      let h = a.slice();
      for (let u = h.length - 1; u >= 0; u--)
        if (h[u] !== A && `${this._detailedFacetProjectionInfo.rowFacets[u]}` !== s) {
          h[u] = A;
          break;
        }
      if (h = h.join("-"), o === "start") {
        for (let u = i.unitRowIndex - 1; u >= 0; u--)
          if (this._matrixInfo.completeDataModelMatrix[u][i.unitColIndex].rowFacetValues.join("-") === h) {
            c = u;
            break;
          }
      } else
        for (let u = i.unitRowIndex + 1; u < this._matrixInfo.completeDataModelMatrix.length; u++)
          if (this._matrixInfo.completeDataModelMatrix[u][i.unitColIndex].rowFacetValues.join("-") === h) {
            c = u;
            break;
          }
    }
    return {
      dataStore: this._matrixInfo.completeDataModelMatrix[c][i.unitColIndex].dataStore,
      rowFacets: this._detailedFacetProjectionInfo?.rowFacets || {},
      colFacets: this._detailedFacetProjectionInfo?.colFacets || {},
      discreteColumnProjections: this._detailedFacetProjectionInfo?.discreteColumnProjections || {},
      discreteRowProjections: this._detailedFacetProjectionInfo?.discreteRowProjections || {},
      selectRequiredOnDataStore: !0,
      colSubTotalsSplitField: s,
      columnTotalString: A
    };
  }
  getRowsubTotalsDataModelInfo(t, i, n) {
    const { rowTotalString: A, rowSubTotalsSplitField: s, rowSubTotalsPosition: o } = uA(t), a = this._matrixInfo.completeDataModelMatrix[i.unitRowIndex][i.unitColIndex].columnFacetValues;
    let l = a.findIndex(
      (h) => h === A
    ), c = i.unitColIndex;
    if (l === 0 || l === 1)
      return this.getRowGrandTotalsDataModelInfo(
        i.unitRowIndex,
        t,
        i.facets
      );
    if (l === -1 && this._detailedFacetProjectionInfo?.discreteColumnProjections.every(
      (h) => n.dataObj[h] === A
    ) || l >= 0 || this._detailedFacetProjectionInfo.discreteColumnProjections.findIndex(
      (h) => h === s
    ) >= 0) {
      let h = a.slice();
      for (let u = h.length - 1; u >= 0; u--)
        if (h[u] !== A && `${this._detailedFacetProjectionInfo.colFacets[u]}` !== s) {
          h[u] = A;
          break;
        }
      if (h = h.join("-"), o === "start") {
        for (let u = i.unitColIndex - 1; u >= 0; u--)
          if (this._matrixInfo.completeDataModelMatrix[i.unitRowIndex][u].columnFacetValues.join("-") === h) {
            c = u;
            break;
          }
      } else
        for (let u = i.unitColIndex + 1; u < this._matrixInfo.completeDataModelMatrix[i.unitRowIndex].length; u++)
          if (this._matrixInfo.completeDataModelMatrix[i.unitRowIndex][u].columnFacetValues.join("-") === h) {
            c = u;
            break;
          }
    }
    return {
      dataStore: this._matrixInfo.completeDataModelMatrix[i.unitRowIndex][c].dataStore,
      rowFacets: this._detailedFacetProjectionInfo?.rowFacets || {},
      colFacets: this._detailedFacetProjectionInfo?.colFacets || {},
      discreteColumnProjections: this._detailedFacetProjectionInfo?.discreteColumnProjections || {},
      discreteRowProjections: this._detailedFacetProjectionInfo?.discreteRowProjections || {},
      selectRequiredOnDataStore: !0,
      rowSubTotalsSplitField: s,
      rowTotalString: A
    };
  }
}
const uN = (e, t) => {
  const i = e[0] / (e[0] - t[0]), n = e[1] / (e[1] - t[1]);
  let A = !1;
  return t[0] > 0 && t[1] > 0 && t[1] > 0 && e[1] > 0 && (A = !0, t[0] = 0, t[1] = 0), t[0] < 0 && t[1] < 0 && t[1] < 0 && e[1] < 0 && (A = !0, e[0] = 0, e[1] = 0), !A && i !== n && !Number.isNaN(i) && !Number.isNaN(n) && (i <= 0 && n >= 1 ? (e[0] = Math.max(e[0], -t[0]), t[1] = Math.min(t[1], -e[1])) : i >= 1 && n <= 0 ? (t[0] = Math.min(t[0], -e[0]), e[1] = Math.max(e[1], -t[1])) : i < n ? t[1] = t[0] / e[0] * e[1] : t[0] = t[1] / e[1] * e[0]), [
    [t[0], e[0]],
    [t[1], e[1]]
  ];
}, dN = (e, t) => {
  [UA, Ts, OA, $a].forEach((i) => {
    const n = e[i];
    if (n) {
      const A = n.find((s) => s.isGlobal);
      t.forEach((s) => {
        s.encoding = s.encoding || {}, !s.encoding[i] && (s.encoding[i] = {});
        let o = s.encoding[i].field;
        !o && A && (o = A.field, s.encoding[i].field = A.field, s.encoding[i].as = A.as);
        const r = [A, ...n].filter(Boolean).find((a) => a.field === o);
        s.encoding[i].splitBy = r ? W(r, "splitBy", "field") : null;
      });
    }
  });
}, fN = (e, t) => {
  const i = e.as(), n = t.as(), A = e.subtype(), s = t.subtype();
  let o;
  return i === lt.DISCRETE || n === lt.DISCRETE ? o = Du : A === Br && i === lt.CONTINUOUS || s === Br && n === lt.CONTINUOUS ? o = hM : o = uM, o;
}, JV = (e, t, i) => {
  const n = e.getField(i);
  return n && n.subtype() === Vg && (t.subtype = Vg, t.binSize = n.getBinSize(), t.bins = n.getAllBins()), t;
}, IN = (e, t, i = [], n) => {
  const { axisType: A } = t, s = [], o = bb[A];
  return i.forEach((r) => {
    const { field: a, values: l = {} } = r.splitBy || {}, c = r.field;
    if (r.type = r.type ? r.type : mb(e, c || null, r.as), r.fieldAs = r.as, r = JV(e, r, c), a)
      e.getField(a).uniques().forEach((h) => {
        const u = new o(
          {
            ...r,
            splitFieldValue: h,
            ...l[h] || {}
          },
          n()
        );
        u.isGlobal && u.isGlobal(!!r.isGlobal), s.push(u);
      });
    else {
      const g = new o(r, n());
      g.isGlobal && g.isGlobal(!!r.isGlobal), s.push(g);
    }
  }), s;
}, hI = (e, t) => {
  let i = 0, n = -1;
  for (; n === -1 && i < e.length; )
    e[i].toString() === t.toString() && (n = i), i++;
  return n;
}, CN = (e, t, i) => i.filter((n) => {
  const A = n instanceof Array ? n : [n], s = [].concat(
    ...A.map((c) => c.encoding).filter((c) => c !== void 0)
  );
  if (!s.length)
    return !0;
  const o = [].concat(...s.map((c) => [c.x && c.x.field, c.x0 && c.x0.field])).filter((c) => c != null), r = [].concat(...s.map((c) => [c.y && c.y.field, c.y0 && c.y0.field])).filter((c) => c != null);
  if (!o.length && !r.length)
    return !0;
  const a = o.length ? o.every((c) => e.indexOf(c) !== -1) : !1, l = r.length ? r.every((c) => t.indexOf(c) !== -1) : !1;
  return o.length && r.length ? a && l : a || l;
}), KV = (e, t, i) => {
  const { rowIndex: n, columnIndex: A, axesObj: s } = i, { config: o, facetFields: r, resolver: a } = e, l = a.axes(), { RADIUS: c, ANGLE: g } = yt;
  [c, g, gM].forEach((h) => {
    const u = l[h];
    u[n] || (u[n] = []), u[n][A] = s[h];
    const d = W(o.axes, h) || {};
    s[h].forEach((f, I) => {
      let C = d;
      d instanceof Function && (C = d(n, A, {
        axisFields: [t[h][I]],
        facetFields: r
      })), f.config(C);
    });
  });
}, WV = (e, t, i) => Object.keys(e.sort).filter((n) => n !== "autoSort").length !== 0 ? e.sort[t] : i.defaultSort, Gl = (e) => {
  const t = [];
  return e.length && e.forEach((i, n) => {
    const A = Bi.sanitizeLayerConfig(i);
    A.order = n, t.push(A);
  }), t;
}, VV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRetinalAxis: IN,
  getAdjustedDomain: uN,
  getDefaultMark: fN,
  getIndex: hI,
  getLayerConfFromFields: CN,
  getSortingConfig: WV,
  resolveAxisConfig: KV,
  serializeLayerConfig: Gl,
  setRetinalFieldsInLayer: dN
}, Symbol.toStringTag, { value: "Module" })), jV = Xo.CARTESIAN;
class EN extends iB {
  static type() {
    return jV;
  }
  getFacetsAndProjections(t, i) {
    let n = [], A = [], s = 0;
    const o = [], r = [], a = t[0], l = t[1], c = a.length, g = l.length, h = this.axisFrom();
    for (let u = 0; u < c; u++) {
      let d = [a[u]];
      const f = a[u];
      if (f.isContinuous()) {
        const I = l[s];
        I && I.isContinuous() && (s++, d = [f, I]), A.push(d);
      } else
        n.push(f), o.push(f);
    }
    if (g > s)
      for (let u = s; u < g; u++) {
        const d = l[u], f = [d];
        d.isContinuous() ? A.push(f) : (n.push(d), r.push(d));
      }
    if ((o.length || r.length) && !A.length)
      if (i = i === gs ? xl : i, (h[i] === le || h[i] === re) && o.length) {
        const u = o.length - 1, d = o[u];
        A = [[d]];
        const f = hI(r, d);
        f > -1 && (A = [[d, d]], r.splice(f, 1)), o.splice(u, 1);
      } else {
        const d = r[0];
        A = [[d]];
        const f = hI(o, d);
        f > -1 && (A = [[d, d]], o.splice(f, 1)), r.splice(0, 1);
      }
    return n = [...o, ...r], n = n.filter(
      (u, d, f) => d === f.findIndex((I) => I.toString() === u.toString())
    ), {
      facets: n,
      projections: A
    };
  }
  fieldSanitizer(t, i) {
    return super.fieldSanitizer(t, i);
  }
  serializeLayerConfig(t) {
    return Gl(t);
  }
  setRetinalFieldsInLayers(t, i) {
    const n = [];
    return i.forEach((A) => {
      const s = Fi(A.def);
      dN(t, s), n.push(A);
    }), n;
  }
  getResolvedEncodings(t, i, n, A) {
    const s = [], { columnFields: o, rowFields: r, dataStore: a } = t, { sort: l, useUTC: c } = n, g = ([u, d]) => d.as == null ? [
      u,
      d.field == null ? { ...d } : {
        ...d,
        as: Ve(a.getField(d.field))
      }
    ] : [u, d], h = (u) => ({
      ...u,
      encoding: Object.fromEntries(
        Object.entries(u.encoding).map(g)
      )
    });
    return o.forEach((u) => {
      if (hn(u))
        return;
      const d = u.toString(), f = u.as();
      r.forEach((I) => {
        if (hn(I))
          return;
        let C = [];
        const E = I.toString(), B = I.as(), m = {
          x: {
            field: d,
            as: f,
            var: u
          },
          y: {
            field: E,
            as: B,
            var: I
          }
        }, y = fN(u, I), D = [
          {
            mark: y,
            def: {
              mark: y,
              encoding: m,
              transform: Object.assign({}, { sort: l }),
              useUTC: c
            }
          }
        ], Q = CN(
          u.getMembers(),
          I.getMembers(),
          i || []
        );
        Q.length ? C = Q.map((p) => {
          let w = p;
          if (p.mark === "text") {
            let _;
            const M = A.data();
            if (p.encoding.text?.field) {
              _ = a.getField(p.encoding.text.field);
              const G = M.getField(p.encoding.text.field);
              M.getField(p.encoding.text.field).subtype() !== _.subtype() && _.subtype() === it.CATEGORICAL && (_ = G);
            }
            const k = Ve(_), T = _ ? p.encoding.text.as === Wg || k === Wg ? "right" : "left" : "center";
            w = Object.assign({ align: T }, p);
          }
          const x = tt(
            tt({}, D[0].def),
            w
          ), S = Bi.getSerializedConf(
            x.mark,
            x
          );
          return {
            mark: x.mark,
            order: x.order,
            def: Array.isArray(S) ? S.map(h) : S
          };
        }) : C = D, s.push(...C);
      });
    }), s.length ? s : i.map((u) => ({
      mark: u.mark,
      def: u
    }));
  }
}
const T0 = (e, { field: t, as: i, splitField: n, splitFieldValue: A }) => {
  const s = e._rowSubTotalsDataModel, o = e._columnSubTotalsDataModel, r = e._greatSubTotalsDataModel, a = e._columnGrandTotalsDataModel, l = e._rowGrandTotalsDataModel, c = e._greatGrandTotalsDataModel, g = e._groupedData;
  let h = [];
  return [
    s,
    o,
    r,
    a,
    l,
    c
  ].forEach((d) => {
    if (d) {
      let f;
      if (n) {
        const E = d.select({
          field: n,
          value: A,
          operator: "eq"
        });
        f = E.getField(t).domain(), E.dispose();
      } else
        f = d.getField(t).domain();
      const I = d.getField(t).subtype(), C = g.getField(t).subtype();
      I === it.CATEGORICAL && I !== C && (C === it.TEMPORAL || C === it.BINNED) && (f = f.map((E) => qn(E))), h.push(f);
    }
  }), te(h, i);
}, v0 = (e, { field: t, as: i, splitField: n, splitFieldValue: A }) => {
  const s = e._groupedData;
  let o;
  if (n) {
    const r = s.select({
      field: n,
      value: A,
      operator: "eq"
    });
    o = r.getDomain(t, i), r.dispose();
  } else
    o = s.getDomain(t, i);
  return o;
};
class BN extends iB {
  createAxis(t, i) {
    const { config: n, childEventManagerCreator: A, globalConfig: s } = i, o = {};
    return [UA, Ts, OA, $a].forEach((r) => {
      if (o[`${r}`] = IN(
        t,
        { axisType: r },
        n[r],
        A
      ), !s.legend.includeTotalDomain) {
        const a = bb[r], l = s.legend.totalsColor;
        switch (r) {
          case UA:
          case $a:
            o[`${r}`].push(
              new a(
                {
                  range: [l],
                  metaInfo: {
                    isTotalsAxis: !0
                  }
                },
                A()
              )
            );
            break;
          case OA:
            o[`${r}`].push(
              new a(
                {
                  metaInfo: {
                    isTotalsAxis: !0
                  }
                },
                A()
              )
            );
            break;
        }
      }
    }), o;
  }
  static type() {
    return "retinal";
  }
  setCommonDomain(t) {
    const { domains: i, axes: n, encoding: A, resolver: s } = t, r = s._context.config().legend.includeTotalDomain;
    return Object.entries(A).forEach(([a, l]) => {
      l.forEach((c) => {
        if (c.field) {
          const g = n[a].find(
            (d) => d.config().field === c.field && (c.as ? d.config().fieldAs === c.as : !0)
          );
          let h = W(i, c.field, c.as);
          const u = h && h.splitDomains;
          if (u)
            n[a].filter(
              (f) => f.config().field === c.field
            ).forEach((f) => {
              const I = f.config().splitFieldValue;
              let C = u[I], E;
              r ? E = T0(s, {
                field: c.field,
                as: c.as,
                splitField: f.config().splitBy?.field,
                splitFieldValue: I
              }) : (E = [], C = v0(s, {
                field: c.field,
                as: c.as,
                splitField: f.config().splitBy?.field,
                splitFieldValue: I
              })), C = te(
                [E, C],
                c.as
              ), f.updateDomain(C);
            });
          else if (!c.domain && h) {
            let d;
            r ? d = T0(s, {
              field: c.field,
              as: c.as
            }) : (d = [], h = v0(s, {
              field: c.field,
              as: c.as
            })), h = te([d, h], c.as), g.updateDomain(h);
          }
        }
      });
    }), n;
  }
}
const qV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CartesianEncoder: EN,
  RetinalEncoder: BN,
  VisualEncoder: iB
}, Symbol.toStringTag, { value: "Module" }));
class zV {
  /**
       * This method is used to set or get the DataModel instance.
       *
       * @param {DataModel | undefined} dataModel Instance of datamodel.
  
       * @memberof  SimpleGroup
       */
  data() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * This method is used to set or get the group specific configuration
   * properties
   *
   * @param {Object | undefined} configObj The input configuration.
   *                                or instance of visual group.
   * @memberof  SimpleGroup
   */
  config() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * This method is used to return a serialized representation of the
   * instance's properties.
   *
   * @memberof  SimpleGroup
   */
  serialize() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * This method is used to get or set the measurement object which houses
   * layout properties like width and height.
   *
   * @param {Object  | undefined} mObj The measurement properties.
   * @memberof  SimpleGroup
   */
  measurement() {
    throw new Error(dt.INTERFACE_IMPL);
  }
}
const ZV = (e) => {
  const [t] = rh.getState();
  e.store().append($h, t);
}, $V = (e) => {
  const t = e.constructor.getState()[0];
  e.store().append(rr, t);
}, XV = (e) => {
  e.store().append(Cw, {});
}, fh = (e, t = {}) => {
  const { recalculateDomains: i = !1 } = t, n = e.config(), A = e.store(), s = e._lockAxisDomain, o = e.resolver();
  let r = ft(
    t.unionAxisDomainPerPage,
    n.pagination.enabled && n.pagination.unionAxisDomainPerPage
  );
  e._unionAxisDomainPerPage = r, i && o._matrix.setPaginatedMatrixInfo({
    ...o._paginatedMatrixInfo,
    dataModelMatrix: IA(
      o._paginatedMatrixInfo.dataModelMatrix.map(
        (a, l) => a.map((c, g) => {
          const h = o.units()[l][g];
          return {
            ...c,
            layerDataModels: h.layers().reduce((u, d) => (u[d.id()] = d.data(), u), {})
          };
        })
      ),
      n
    )
  }), s || (A.lockModel(), e.matrix().setAxisDomains(
    n.uniformAxisDomains,
    {
      rootModel: e.data(),
      columnGTRootModel: o.columnGrandTotalsDataModel() == null ? e.data() : o.columnGrandTotalsDataModel(),
      rowGTRootModel: o.rowGrandTotalsDataModel() == null ? e.data() : o.rowGrandTotalsDataModel()
    },
    {
      sort: n.sort,
      unionAxisDomainPerPage: r
    }
  ), e.matrix().extendAxisDomainsIfNeeded(), A.unlockModel());
}, G0 = (e) => {
  e.store().registerChangeListener(
    [`${$h}.domain`],
    () => {
      e._triggerDomainChangeListener && fh(e), e._triggerDomainChangeListener = !0;
    },
    !1,
    "unionDomain"
  );
}, L0 = (e) => {
  e.store().unsubscribe("unionDomain");
}, tj = {
  alias: {},
  data: {
    preset: (e) => {
      e._prevData = null;
    }
  },
  cornerMatrices: {
    defaultValue: {
      topLeft: [],
      topRight: [],
      bottomLeft: [],
      bottomRight: []
    }
  },
  metaData: {
    defaultValue: {
      border: {}
    }
  },
  resolver: {},
  valueParser: {
    defaultValue: (e) => e
  },
  [sM]: {},
  [oM]: {},
  [rM]: {},
  [UA]: {},
  [Ts]: {},
  [OA]: {},
  [jg]: {},
  [aM]: {},
  [lM]: {},
  [$a]: {}
};
class ej {
  _context;
  _matrixInfo;
  _totalItemCount;
  _totalRowFacetCount;
  _pageSize;
  _currentPageIndex;
  _pageCount;
  _pages;
  constructor(t, i, n) {
    this._pageSize = 100, this._context = t, this._matrixInfo = i, this._currentPageIndex = 0, this._pages = [], this.config(n), this.createPageConfig();
  }
  config(t) {
    t && (this._pageSize = t.pageSize, this._currentPageIndex = ft(t.pageNumber, 1) - 1);
  }
  createPageConfig() {
    const t = this._matrixInfo, { totalRowItemCount: i, totalRowFacetCount: n } = t, A = Math.ceil(n / this._pageSize);
    this._totalItemCount = i, this._totalRowFacetCount = n, this._pageCount = A, this._currentPageIndex > A - 1 && (this._currentPageIndex = 0);
  }
  _updatePageConfig() {
    const t = this._matrixInfo, { totalRowItemCount: i, totalRowFacetCount: n } = t, A = Math.ceil(n / this._pageSize);
    this._totalItemCount = i, this._totalRowFacetCount = n, this._pageCount = A;
  }
  nextPage() {
    if (this._currentPageIndex === this._pageCount - 1)
      return this;
    this._currentPageIndex++;
  }
  previousPage() {
    if (this._currentPageIndex === 0)
      return this;
    this._currentPageIndex--;
  }
  goToPage(t) {
    if (t > this._pageCount)
      return this;
    this._currentPageIndex = t - 1;
  }
  goToLastPage() {
    this._currentPageIndex = this._pageCount - 1;
  }
  setMatrixInfo(t) {
    this._matrixInfo = t;
  }
  getUpdatedCurrentPageData(t, i) {
    if (i === "column") {
      this._pages = [];
      const n = this.getCurrentPageData(), A = n.updateInfo.updateSet.filter(
        ([s]) => s >= n.pageStartIndex && s < n.pageEndIndex
      ).map(([s, o]) => [
        s - n.pageStartIndex,
        o
      ]);
      return n.updateInfo.updateSet = A, {
        currentPageChanged: !1,
        matrixInfo: n
      };
    } else {
      this._updatePageConfig();
      const {
        updateInfo: { updateSet: n, exitSet: A },
        rowsPerFacet: s
      } = this._matrixInfo, [o] = n[0], r = this._pageSize * s, a = Math.floor(o / r);
      if (a === this._currentPageIndex) {
        const l = a * r, c = n.map(([C, E]) => [C - l, E]).filter((C) => C[0] < r);
        let g = A[0].map(
          (C) => C !== -1 ? C - l : -1
        );
        g = g[0] > r - 1 ? [-1, -1] : [g[0], Math.min(g[1], r - 1)];
        const h = this._pages[this._currentPageIndex].dataModelMatrix.length;
        this._pages = [];
        const u = this.getCurrentPageData(), d = u.dataModelMatrix.length, f = [];
        if (t[t.length - 1].collapsed) {
          const C = g[0] !== -1 ? g[1] - g[0] + 1 : 0, E = h - C;
          for (let B = E; B < d; B++)
            for (let m = 0; m < u.dataModelMatrix[B].length; m++)
              f.push([B, m]);
        } else {
          const C = c[c.length - 1][0] - c[0][0];
          g = C !== 0 && u.pageEndIndex < this._matrixInfo.dataModelMatrix.length ? [d - C, h - 1] : g;
        }
        return u.updateInfo = {
          ...u.updateInfo,
          updateSet: c,
          exitSet: [g, [-1, -1]],
          entrySet: f
        }, {
          currentPageChanged: !1,
          matrixInfo: u,
          currentRowIndex: c[0][0]
        };
      } else
        return this._currentPageIndex = a, this._pages = [], {
          currentPageChanged: !0,
          matrixInfo: this.getCurrentPageData(),
          currentRowIndex: o - a * r
        };
    }
  }
  getCurrentPageData() {
    if (this._pages[this._currentPageIndex])
      return this.getPageData(this._currentPageIndex);
    const t = this._matrixInfo, {
      allRowHeaderKeys: i,
      rowKeys: n,
      allRowAxisInfo: A,
      allColumnAxisInfo: s,
      allColumnHeaderKeys: o,
      columnKeys: r,
      dataModelMatrix: a,
      totalRowItemCount: l,
      rowsPerFacet: c,
      updateInfo: g
    } = t, h = t.totalRowFacetCount || 1, u = this._currentPageIndex * this._pageSize * c;
    let d = 0;
    this._currentPageIndex === this._pageCount - 1 && (d = l % h);
    const f = Math.min(
      u + this._pageSize * c + d,
      this._totalItemCount
    ), I = i.slice(u, f), C = {
      leftAxisInfo: A.leftAxisInfo.slice(u, f),
      rightAxisInfo: A.rightAxisInfo.slice(u, f)
    }, E = a.slice(u, f);
    return this._pages[this._currentPageIndex] = {
      allRowHeaderKeys: I,
      allRowAxisInfo: C,
      rowKeys: n.slice(u, f),
      allColumnAxisInfo: s,
      allColumnHeaderKeys: o,
      columnKeys: r,
      dataModelMatrix: E,
      facetCount: (E.length - d) / c,
      completeDataModelMatrix: a,
      rowsCount: E.flat().reduce(
        (B, m) => B + m.dataStore.getRowsCount(),
        0
      ),
      pageStartIndex: u,
      pageEndIndex: f,
      updateInfo: g
    }, this.getPageData(this._currentPageIndex);
  }
  getPageData(t) {
    const i = this._pages[t], { dataModelMatrix: n } = i;
    return {
      ...i,
      dataModelMatrix: n.map((A) => A.map((s) => ({
        ...s,
        dataStore: s.dataStore.project(
          s.dataStore.getSchema().filter((o) => o.name !== St.ROW_ID).map((o) => o.name)
        )
      })))
    };
  }
  getTotalPageCount() {
    return this._pageCount;
  }
  getTotalFacetCount() {
    return this._totalRowFacetCount;
  }
  getFacetCountForCurrentPage() {
    return this._pages[this._currentPageIndex].facetCount;
  }
  getCurrentPageNumber() {
    return this._currentPageIndex + 1;
  }
  getRowsCount() {
    return this._pages[this._currentPageIndex].rowsCount;
  }
  getPaginatedValues(t) {
    const { pageStartIndex: i, pageEndIndex: n } = this._pages[this._currentPageIndex];
    return t.slice(i, n);
  }
}
const ij = (e, t, i, n) => {
  let A = {};
  if (n && (e || t)) {
    const { facetsUserConfig: s = {}, border: o } = n, { isBorderPresent: r = {}, isGridLinePresent: a = {} } = s, l = Object.keys(a).length, {
      width: c,
      color: g,
      style: h,
      showValueBorders: u,
      showRowBorders: d,
      showColBorders: f
    } = o;
    let I = {}, C = {};
    Object.keys(r).length === 0 || !r.width ? C = {
      width: g0[BE]
    } : Object.assign(
      C,
      c ? { width: c } : null,
      g ? { color: g } : null,
      u ? { showValueBorders: u } : null,
      d ? { showRowBorders: d } : null,
      f ? { showColBorders: f } : null,
      h ? { style: h } : null
    ), l <= 0 && (I = {
      x: {
        show: !1
      }
    }), A = {
      border: C,
      gridLines: I
    };
  } else
    i === "html" && (A = {
      border: {
        width: g0[EM]
      }
    });
  return A;
};
class Ih extends _e(zV).with(zs) {
  /**
   * Creates an instance of VisualGroup. Requires dependencies and other registry options for placeholders
   * and layers that create individual units.
   *
   * @param {Object} registry Key value pair of compostions for the group
   * @param {Object} dependencies Dependencies needed to run the group
   * @memberof VisualGroup
   */
  constructor(t, i, n) {
    super(), this.eventManager(n), this._registry = t, this._dependencies = i, ge(this, this.constructor.getterSetters()), this.store(i.store), this._encoders = {
      simpleEncoder: this.createEncoderInstance(),
      retinalEncoder: new BN()
    }, this._data = [], this._prevData = null, this._groupedDataModel = [], this._mount = null, this._placeholderInfo = {}, this._lockAxisDomain = !1;
    const A = new YV({
      registry: t,
      ...this._dependencies,
      store: this.store()
    });
    A.encoder(this._encoders), A.context(this), this.resolver(A);
  }
  static getState() {
    return [
      {
        domain: {
          x: null,
          y: null,
          radius: null,
          angle: null,
          angle0: null
        }
      },
      {}
    ];
  }
  store(...t) {
    return t.length ? (this._store = t[0], $V(this), ZV(this), XV(this), this) : this._store;
  }
  static formalName() {
    return "VisualGroup";
  }
  static getterSetters() {
    return tj;
  }
  registry() {
    return this._registry;
  }
  /**
   * Return the instances of matrices created by the visual group.
   *
   * @return {Object} Instance of matrices.
   */
  matrixInstance(...t) {
    return t.length ? this : this.composition().matrices;
  }
  /**
   * Returns the composition of visual group.
   *
   * @public
   *
   * @return {Object} Composition of visual group. It contains instance of matrices {@link ValueMatrix}
   * and instances of axis.
   * ```
   *          {
   *              matrices: {
   *                  value: // Instance of center value matrix.
   *                  left: // Instance of left value matrix
   *                  right: // Instance of right value matrix
   *                  bottom: // Instance of bottom value matrix
   *                  top: // Instance of top value matrix.
   *              },
   *              axes: {
   *                  x: // Array of x axis.
   *                  y: // Array of y axis
   *                  color: // Array of color axis
   *                  shape: // Array of shape axis
   *                  size: // Array of size axis.
   *              }
   *          }
   * ```
   */
  composition(...t) {
    return t.length ? this : this._composition;
  }
  /**
   * Returns the channel name of the variable. Channels are rows, columns, color, shape and size.
   *
   * @public
   * @param {string} variable Name of the variable.
   *
   * @return {string} Name of the channel.
   */
  where(t) {
    return Bb(t, this.resolver().getAllFields());
  }
  /**
   * Gets the axis instances of the visual group based on the given axis type.
   *
   * @public
   * @param {string} type Type of axis. X,Y or retinal axes.
   *
   * @return {Array} Array of axis instances.
   */
  getAxes(t) {
    if (t === cM)
      return this.resolver().getRetinalAxes();
    const i = this.matrix(), n = i.row(), A = i.column();
    return t === "x" ? A.getAxes() : t === "y" ? n.getAxes() : [];
  }
  /**
   * Returns the grouped datamodel prepared by visual group. If there is no group by performed, then it returns the
   * original data model passed to visual group.
   *
   * @return {DataModel} Grouped data model.
   */
  getGroupByData() {
    return this.resolver()._groupedData;
  }
  placeholderInfo() {
    return this._placeholderInfo;
  }
  updateMatrices(t, i) {
    const n = this.resolver(), { simpleEncoder: A } = this._encoders, s = this.config();
    n.updateMatrices(t, i, s), this._paginationInstance?.setMatrixInfo(n._matrixInfo);
    const o = this._paginationInstance?.getUpdatedCurrentPageData(
      t,
      i
    ), r = o?.matrixInfo ?? n._matrixInfo;
    let a;
    o?.currentPageChanged ? (a = this.generatePlaceholderInfo(), this.cornerMatrices(this._placeholderInfo.headerTitles)) : a = this.updatePlaceholderInfo(i, r, {
      targetPath: t
    });
    const l = o?.currentRowIndex ?? r.updateInfo.updateSet?.[0]?.[0], c = r.updateInfo.updateSet?.[0]?.[1], g = rI(a, A, {
      showXAxesLine: s.axes.x.showAxisLine,
      showYAxesLine: s.axes.y.showAxisLine
    });
    return this.metaData({
      border: g
    }), {
      rowIndex: l ?? 0,
      columnIndex: c ?? 0,
      currentPageChanged: o?.currentPageChanged
    };
  }
  createMatrices() {
    const t = this.layers(), i = this.resolver(), n = this.config();
    this._triggerDomainChangeListener = !0, this._lockAxisDomain = !1;
    const { simpleEncoder: A } = this._encoders, s = A.sanitizeFields(this.data(), {
      rows: this.rows(),
      columns: this.columns()
    });
    A.setAxisAndHeaders(n.axisFrom, s), i.layerConfig(t).valueParser(this.valueParser()).horizontalAxis(s.rows).verticalAxis(s.columns).optionalProjections({
      rows: s.rows,
      columns: s.columns
    }), i.generateMatrices(), this._paginationInstance = null, n.pagination.enabled ? this._paginationInstance = new ej(
      this,
      i._matrixInfo,
      n.pagination
    ) : n.pagination.enabled = !1;
    const o = this.generatePlaceholderInfo();
    this.cornerMatrices(this._placeholderInfo.headerTitles);
    const { colFacets: r, rowFacets: a, colProjections: l, rowProjections: c } = i.getAllFields(), g = a.length > 0 || r.length > 0, h = l.length > 1 || c.length > 1;
    tt(
      n,
      ij(
        g,
        h,
        o.cellRenderer,
        n
      )
    );
    const u = rI(o, A, {
      showXAxesLine: n.axes.x.showAxisLine,
      showYAxesLine: n.axes.y.showAxisLine
    });
    return this.metaData({
      border: u
    }), !u.showValueBorders.left && !n.axes.y.showAxisLine && this.matrix()._matrices.row._matrices.axes._cells.left.forEach((d) => {
      d.source().config({
        tickSize: 0
      });
    }), !u.showValueBorders.right && !n.axes.y.showAxisLine && this.matrix()._matrices.row._matrices.axes._cells.right.forEach(
      (d) => {
        d.source().config({
          tickSize: 0
        });
      }
    ), this;
  }
  goToNextPage() {
    this.getPaginationInstance().nextPage(), this.generatePlaceholderInfo();
  }
  goToPreviousPage() {
    this.getPaginationInstance().previousPage(), this.generatePlaceholderInfo();
  }
  goToPage(t) {
    this.getPaginationInstance().goToPage(t), this.generatePlaceholderInfo();
  }
  goToLastPage() {
    this.getPaginationInstance().goToLastPage(), this.generatePlaceholderInfo();
  }
  getPaginationInstance() {
    return this._paginationInstance;
  }
  generatePlaceholderInfo(t) {
    L0(this);
    const i = this.resolver(), n = this.config(), {
      rows: { facets: A } = {},
      columns: { facets: s } = {}
    } = n, {
      interaction: { collapse: { enabled: o } = {} } = {}
    } = A ?? {}, {
      interaction: { collapse: { enabled: r } = {} } = {}
    } = s ?? {};
    let a;
    if (this._paginationInstance) {
      const l = this._paginationInstance.getCurrentPageData();
      n.pagination.enabled && n.pagination.unionAxisDomainPerPage && (l.dataModelMatrix = IA(
        os(
          i.context(),
          i.encoder().simpleEncoder,
          l.dataModelMatrix,
          i._suppliedLayers
        ),
        n
      )), a = this._placeholderInfo = i.generateMatrixInstance(
        l,
        t
      );
    } else
      o || r ? a = this._placeholderInfo = i.generateMatrixInstance(
        {
          ...i._matrixInfo,
          dataModelMatrix: i._matrixInfo.dataModelMatrix.map(
            (l) => l.map((c) => ({
              ...c,
              dataStore: hh(
                c.dataStore,
                c.dataStore
              )
            }))
          )
        }
      ) : a = this._placeholderInfo = i.generateMatrixInstance(
        i._matrixInfo
      );
    return this._dependencies.throwback.commit($o.MATRIX_CREATED, !0), G0(this), a;
  }
  updatePlaceholderInfo(t, i, { targetPath: n = [] } = {}) {
    L0(this);
    const A = this.resolver();
    return this._placeholderInfo = {
      ...this._placeholderInfo,
      ...A.updateMatrixInstance(i, t, { targetPath: n })
    }, this._dependencies.throwback.commit($o.MATRIX_CREATED, !0), G0(this), this._placeholderInfo;
  }
  remove() {
    const t = this.placeholderInfo();
    this.resolver()._matrix.dispose(), this.resolver().clear(), t.rows = null, t.columns = null, t.values = null;
  }
  createEncoderInstance() {
    return this.layers(), Qb();
  }
  groupedData(...t) {
    return t.length ? (this._groupedDataModel = t[0], this) : this.getGroupByData();
  }
  resetData() {
    const t = this._originalGroupedData;
    return t && (this._groupedDataModel = t), this;
  }
  matrix() {
    return this.resolver()._matrix;
  }
  /**
   * Get all the retinal encodings across global one and layer specific ones
   * for a specific encoding type (color, shape and size).
   *
   *  @return {Object} The encodings.
   */
  extractAllRetinalEncodingsFor(t, i) {
    const n = this[t]();
    let A;
    const s = {};
    let o = Object.keys(
      {
        color: Xa,
        shape: eh,
        size: th,
        backgroundColor: Xa
      }[t]
    );
    const r = W(this.config(), "legend", t) || {}, a = Pc(o, r);
    i.forEach((c = {}) => {
      let g = c[t];
      if (typeof g == "object" && g !== null || (g = { field: g }), g.field) {
        let h = g.as || Ve(this.data().getField(g.field));
        s[g.field] = Object.assign(
          {},
          s[g.field],
          { [h]: !0 }
        );
      }
    }), n.field && (A = n.as || Ve(this.data().getField(n.field)), s[n.field] = Object.assign(
      {},
      s[n.field],
      { [A]: !0 }
    ));
    const l = [{ field: null, ...a }];
    return Object.keys(s).forEach((c) => {
      const g = s[c];
      [lt.CONTINUOUS, lt.DISCRETE].forEach((h) => {
        if (g[h]) {
          const u = W(r, "fields", c) || {}, d = W(u, h) || {};
          let f;
          this.data().getField(c).type() !== _o ? f = o.filter((C) => C !== "splitBy") : f = o;
          const I = tt(
            { ...a },
            tt(
              Pc(f, u),
              Pc(f, d)
            )
          );
          if (!I.ordering) {
            const C = this.config();
            I.ordering = W(C.axes, "x", "fields", c, "ordering") || W(C.axes, "y", "fields", c, "ordering") || W(
              C.columns,
              "facets",
              "fields",
              c,
              "ordering"
            ) || W(
              C.rows,
              "facets",
              "fields",
              c,
              "ordering"
            ) || {};
          }
          l.push({
            field: c,
            as: h,
            isGlobal: c === n.field && h === A,
            ...I
          });
        }
      });
    }), l;
  }
  getAllColorEncodings(t) {
    return this.extractAllRetinalEncodingsFor("color", t);
  }
  getAllShapeEncodings(t) {
    return this.extractAllRetinalEncodingsFor("shape", t);
  }
  getAllSizeEncodings(t) {
    return this.extractAllRetinalEncodingsFor("size", t);
  }
  getAllBackgroundColorEncodings(t) {
    return this.extractAllRetinalEncodingsFor("backgroundColor", t);
  }
  getAllRetinalEncodings(t) {
    return {
      color: this.getAllColorEncodings(t),
      shape: this.getAllShapeEncodings(t),
      size: this.getAllSizeEncodings(t),
      backgroundColor: this.getAllBackgroundColorEncodings(t)
    };
  }
  interactionRegistry(...t) {
    return t.length ? (this._interactionRegistry = t[0], this) : this._interactionRegistry;
  }
  findUnitByPayload(t) {
    const i = this.matrix().geom();
    let n = i.findUnitByPayload(t);
    return n || (n = i.getUnits()[0]), n;
  }
}
const nj = () => {
  const e = /* @__PURE__ */ new Map();
  return {
    get: (t) => t ? e.get(t) : e,
    save: (t, i) => {
      e.set(t, i);
    },
    remove: (t) => {
      e.delete(t);
    },
    clear: () => {
      e.clear();
    }
  };
}, Aj = "@viz/muze", sj = "4.7.2", oj = "Composable visualisation library for web with a data-first approach", rj = "Mode Analytics (https://mode.com/)", aj = "src/index.js", lj = [
  "muze",
  "svg",
  "vector",
  "graphics",
  "data-visualization",
  "visualization",
  "renderer",
  "relational",
  "algebra",
  "relation"
], cj = {
  type: "git",
  url: "https://github.com/mode/muze"
}, gj = {
  "@babel/runtime": "^7.10.2",
  "@viz/layout": "^1.0.0",
  "@viz/muze-firebolt": "^1.0.0",
  "@viz/muze-legend": "^1.0.0",
  "@viz/muze-axis": "^1.0.0",
  "@viz/visual-cell": "^1.0.0",
  "@viz/visual-group": "^1.0.0",
  "@viz/visual-layer": "^1.0.0",
  "@viz/visual-unit": "^1.0.0",
  "@viz/muze-utils": "^1.0.0",
  "@viz/muze-events": "^1.0.0",
  "@viz/muze-themes": "^1.0.0"
}, hj = {
  name: Aj,
  private: !0,
  version: sj,
  description: oj,
  author: rj,
  main: aj,
  keywords: lj,
  repository: cj,
  dependencies: gj
};
const uj = "drag", dj = "hover", fj = "click", Ch = "legendTextHover", Eh = "stepLegendItemHover", mN = "brush", Gu = "highlight", QN = "select", Bh = "legendHighlight", Un = "muze", Ij = {
  [Vo]: {
    target: [
      `.${Un}-legend-columns`,
      `.${Un}-step-legend-icon`
    ],
    behaviours: [UE]
  },
  [el]: {
    target: [`.${Un}-legend-columns`],
    behaviours: ["inverse-select"]
  },
  [Ch]: {
    target: [
      `.${Un}-legend-title-text`,
      `.${Un}-legend-item-info-text`,
      `.${Un}-legend-pagination-handle`,
      `.${Un}-step-legend-ticks-v`,
      `.${Un}-step-legend-ticks-h`
    ],
    behaviours: [Bh]
  },
  [Eh]: {
    target: [`.${Un}-step-legend-icon`],
    behaviours: [Bh]
  }
}, pN = "selectionBox", lB = "marker", uI = "legendTextTooltip", dI = "stepLegendTooltip", Cj = {
  [mN]: [pN],
  [QN]: [],
  [Gu]: [],
  [Bh]: [
    uI,
    dI
  ]
}, Ej = (e) => (t) => {
  let i = {}, n = {}, A;
  const s = Fr(), o = e.context, r = o.measurement().gradientDimensions, a = o.config().align === "horizontal" ? "x" : "y", l = o.axis().source().scale(), c = l.range()[a === "x" ? 0 : 1];
  t.call(
    s().on("start", () => {
      const g = Bt();
      i = {
        x: g.x,
        y: g.y
      };
    }).on("drag", () => {
      const g = Bt();
      n = {
        x: g.x,
        y: g.y
      }, n.x = Math.max(0, Math.min(n.x, r.width)), n.y = Math.max(0, Math.min(n.y, r.height)), A = {
        criteria: {
          range: {
            [o.fieldName()]: [
              l.invert(i[a] + c * 2),
              l.invert(n[a] + c * 2)
            ].sort((h, u) => h - u)
          }
        }
      }, e.triggerPhysicalAction("drag", A);
    }).on("end", () => {
      const g = Bt();
      n = {
        x: g.x,
        y: g.y
      }, n.x = Math.max(0, Math.min(n.x, r.width)), n.y = Math.max(0, Math.min(n.y, r.height)), i[a] === n[a] ? A = {
        criteria: null
      } : A = {
        criteria: {
          range: {
            [o.fieldName()]: [
              l.invert(i[a] + c * 2),
              l.invert(n[a] + c * 2)
            ].sort((h, u) => h - u)
          }
        }
      }, e.triggerPhysicalAction("drag", A);
    })
  );
}, Bj = (e) => (t) => {
  const i = function(n) {
    const A = e.context.getCriteriaFromData(n), s = {
      criteria: {
        dimensions: A
      },
      fields: Object.keys(A)
    };
    e.triggerPhysicalAction("hover", s);
  };
  t.on("mouseover", i).on("mousemove", i).on("mouseout", () => {
    e.triggerPhysicalAction("hover", {
      criteria: null
    });
  });
}, mj = (e) => (t) => {
  const i = function(n) {
    const A = e.context.getCriteriaFromData(n), s = {
      criteria: {
        dimensions: A
      },
      fields: Object.keys(A)
    };
    e.triggerPhysicalAction("click", s);
  };
  t.on("click", i);
}, cB = "muze", Ge = "width", Be = "height", Qj = "#d8d8d8", yN = 2, mh = {
  // approximately the (size needed) * Math.PI value
  outline: 6,
  circle: 6,
  square: 6,
  default: 6
}, gB = "step", Qh = "gradient", pj = {
  size: "getSize",
  shape: "getShape",
  color: "getColor"
}, Fn = "top", mi = "left", Rn = "right", tn = "bottom", zt = "horizontal", Ze = "vertical", nl = "center", hs = "value", yj = "path", Bc = "shape", Al = "rect", Dj = "start", wj = "end", di = "size", hB = "discrete", xj = "default", Sj = "color", mc = "circle", fI = "square", Mj = "outline", ph = "continuous", _j = "visibility", DN = {
  [mi]: Ze,
  [Rn]: Ze,
  [Fn]: zt,
  [tn]: zt
}, bj = {
  [mi]: Rn,
  [Rn]: mi
}, Nj = "margin", wN = "padding", Fj = "display", xN = "max-width", Rj = "padding-right", kj = "flex", Tj = "align-items", uB = 34, U0 = 140, O0 = 140, II = 70, vj = 70, Gj = uB, Lj = uB, Uj = 0.25, SN = 30 * 4, Oj = uB, Hj = 0.3, Pj = 0.2, CI = 32, Yj = 24, Jj = 5, Kj = "WW", Wj = "WWWWWWWWWW", Vj = "WWWWWWW", jj = 5, qj = "-legend-pagination-handle", zj = "-legend-title-text", Zj = "-legend-item-info-text", $j = cB + "-legend-prop-float-left", eg = 5, Ud = 2, Xj = 3, Fo = 5, tq = 0.15, ig = "binned", eq = (e) => (t) => {
  const i = function() {
    const n = Bt(), s = V(n.currentTarget).node(), o = e.context, { classPrefix: r } = o.config(), a = s.classList?.[0] || null, c = {
      showTooltip: !0,
      tooltipText: null,
      tooltipAnchorBox: Wi(s)
    };
    switch (a) {
      case `${r}${Zj}`:
      case `${r}${zj}`:
      case `${r}-step-second-tick`:
      case `${r}-step-first-tick`:
        s.offsetWidth < s.scrollWidth && (c.tooltipText = s.innerText, e.triggerPhysicalAction(Ch, c));
        break;
    }
  };
  t.on("mouseover", i).on("mousemove", i).on("mouseout", () => {
    const n = Bt();
    e.triggerPhysicalAction(Ch, {
      showTooltip: !1
    }), n.stopPropagation();
  });
}, iq = (e) => (t) => {
  const i = function(n) {
    const A = Bt(), s = e.context.getCriteriaFromData(n);
    e.triggerPhysicalAction(Eh, {
      showTooltip: !0,
      isStepLegend: !0,
      event: A,
      firebolt: e
    }), e.triggerPhysicalAction("hover", {
      criteria: {
        dimensions: s
      },
      fields: Object.keys(s)
    });
  };
  t.on("mouseover", i).on("mousemove", i).on("mouseout", () => {
    const n = Bt();
    e.triggerPhysicalAction(Eh, {
      showTooltip: !1,
      isStepLegend: !0
    }), n.stopPropagation();
  });
}, nq = {
  [uj]: Ej,
  [dj]: Bj,
  [fj]: mj,
  [Ch]: eq,
  [Eh]: iq
}, H0 = (e, t, i) => {
  let n = [];
  const { axisScale: A, axisType: s } = t, { startPos: o, endPos: r, selectionBoxMeasure: a, drawingInfMeasure: l, offset: c } = i, g = e[s];
  return o[s] === r[s] ? n = [] : g + a >= l + c ? n = [
    A.invert(l + c - a),
    A.invert(l + c)
  ] : g - c < c ? n = [
    A.invert(c * 2),
    A.invert(a + c * 2)
  ] : n = [
    A.invert(g),
    A.invert(g + a)
  ], s === "x" || n.reverse(), n;
}, Aq = (e) => (t, i) => {
  let n = {}, A, s, o, r, a, l;
  const c = {}, g = Fr(), h = e.context;
  let u = {};
  t.call(
    g().on("start", function() {
      const d = Bt();
      n = Og(this, d.sourceEvent), u = d.subject, a = h.axis().source().scale(), l = h.config().align === zt ? "x" : "y", s = h.measurement().gradientDimensions[l === "x" ? Ge : Be], o = a.range()[l === "x" ? 0 : 1], r = {
        drawingInfMeasure: s,
        offset: o
      };
    }).on("drag", () => {
      const d = Bt(), f = u[l === "x" ? Ge : Be];
      u.x += d.dx, u.y += d.dy, r.selectionBoxMeasure = f, r.startPos = n, r.endPos = c;
      const I = H0(
        u,
        { axisScale: a, axisType: l },
        r
      );
      A = {
        criteria: {
          range: {
            [h.fieldName()]: I
          }
        },
        fadeOut: !0
      }, e.dispatchBehaviour(i[0], A);
    }).on("end", () => {
      const d = Bt(), f = u[l === "x" ? Ge : Be];
      r.selectionBoxMeasure = f, r.startPos = n, r.endPos = c;
      const I = H0(
        d,
        { axisScale: a, axisType: l },
        r
      );
      A = {
        criteria: {
          range: {
            [h.fieldName()]: I
          }
        },
        fadeOut: !0,
        config: {
          transition: {
            duration: 200
          }
        }
      }, e.dispatchBehaviour(i[0], A);
    })
  );
}, Ls = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
}, sq = {
  height: 30,
  width: 30,
  maxWidth: 1 / 0,
  maxHeight: 1 / 0,
  padding: 2,
  margin: 2,
  marginHorizontal: 3,
  paddingRight: 4,
  border: 1
}, oq = {
  text: "",
  orientation: (e) => e === mi || e === Rn ? mi : nl,
  style: {
    "font-size": "14px",
    "font-family": '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
    "font-weight": "600",
    "font-style": "normal",
    "font-variant": "tabular-nums"
  }
}, dB = {
  buffer: {
    [Ls.HORIZONTAL]: 10,
    [Ls.VERTICAL]: 10
  },
  classPrefix: "muze",
  borderStyle: "solid",
  borderColor: "rgba(0,0,0,0)",
  formatter: {
    bounds: {
      lower: "less than",
      upper: "more than"
    }
  },
  marker: {
    text: {
      // @TODO: font-variant returns wrong text width the second time
      // @TODO: multiple font-family types specified were not getting applied, so only "Source Sans Pro" is kept
      formatter: (e) => e.formattedValue,
      style: {
        "font-size": "12px",
        "font-family": '"Source Sans Pro"',
        "font-weight": "400",
        "font-style": "normal"
        // "font-variant": "tabular-nums",
      }
    }
  },
  item: {
    text: {
      orientation: "right",
      width: 10,
      formatter: (e) => e.formattedValue,
      style: {
        "font-size": "12px",
        "font-family": '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
        "font-weight": "400",
        "font-style": "normal",
        "font-variant": "tabular-nums"
      }
    },
    icon: {
      className: "legend-icon",
      height: 20,
      width: 20,
      color: "rgba(192,192,192,0.6)",
      type: "square"
    }
  },
  transition: {
    disabled: !0
  }
  // stops: 5,
}, rq = tt({}, dB, {
  buffer: {
    [Ls.HORIZONTAL]: 0
  },
  step: !0
}), aq = (e) => e && typeof e == "string" ? Bl(e) : e, us = {
  size: 8,
  BUFFER: 4,
  ROTATE_HORIZONTAL: 180,
  ROTATE_VERTICAL: 90,
  shape: "triangle"
};
class lq extends Tr {
  constructor(...t) {
    super(...t), this._graphicElems = {
      rect: null
    };
  }
  static formalName() {
    return pN;
  }
  /**
   * It returns the default configuration needed by selectionbox.
   * @return {Object} Default configuration of the selection box.
   */
  static defaultConfig() {
    return {
      className: "legend-selection-box",
      classPrefix: cB
    };
  }
  static target() {
    return "all";
  }
  /**
   * Draws the selectionbox with the specified dimensions.
   */
  /* istanbul ignore next */
  apply(t, i) {
    let n, A, s, o;
    const r = this.firebolt, a = r.context, l = this.config(), c = a.axis().source(), g = `${l.classPrefix}-${l.className}`, { criteria: h } = i, { rect: u } = this._graphicElems;
    if (h === null)
      return u && u.remove(), this;
    const { range: d } = h, f = d[r.context.fieldName()], I = c.scale(), C = f ? [c.getScaleValue(f[0]), c.getScaleValue(f[1])] : [], E = a.config().align === zt ? "x" : "y", B = r.context.measurement().gradientDimensions[E === "x" ? Be : Ge], m = I.range()[E === "x" ? 0 : 1], y = a.getDrawingContext().svgContainer, D = j(
      y,
      "g",
      [1],
      `${l.classPrefix}-selection-box-group`
    ), { size: Q, BUFFER: p } = us;
    r.context.config().align === zt ? (n = C[0] - m || 0, A = Q + p, s = C[1] - C[0] || 0, o = B) : (n = Q + p, A = C[1] - m || 0, o = C[0] - C[1] || 0, s = B);
    const x = j(
      D,
      Al,
      [{ domain: f, x: n, y: A, width: s, height: o }],
      g,
      { enter: function(S) {
        Aq(r)(S, ["brush"]);
      } }
    );
    return x.attr("y", A).attr("x", n).attr(Ge, s).attr(Be, o), this._graphicElems.rect = x, this;
  }
}
class cq extends $t {
  constructor(...t) {
    super(...t), this._styles = /* @__PURE__ */ new Map();
  }
  static formalName() {
    return "legend-highlighter";
  }
  apply(t, i, { rules: n }) {
    const A = (o) => {
      let r;
      return o instanceof Function ? r = o(
        {
          payload: i,
          entryExitSet: t
        },
        this.firebolt
      ) : typeof o == "string" && (r = o === "entrySet" ? t.entrySet : t.exitSet), r;
    };
    [
      ...n,
      {
        target: "entrySet",
        className: "muze-legend-item-hover"
      }
    ].forEach((o, r) => {
      const a = A(o.target);
      if (!a)
        return;
      const l = `${i.action}-${r}`;
      if (i.criteria === null)
        this.applyInteractionStyle(t.completeSet, {
          apply: !1,
          interactionType: l,
          className: o.className,
          style: o.style
        }), this._styles.delete(l);
      else {
        const c = {
          apply: !0,
          interactionType: l,
          className: o.className,
          style: o.style
        }, g = this._styles.get(l);
        g && this.applyInteractionStyle(
          {
            uids: ou(g.targetSet.uids, a.uids)
          },
          { ...g.config, apply: !1 }
        ), this.applyInteractionStyle(a, c), this._styles.set(l, {
          targetSet: a,
          config: c
        });
      }
    });
  }
}
const kn = (e) => {
  const t = e.constructor.type(), i = e.uniqueValues(), n = e.config(), A = n.stops, s = pj[t];
  return { scaleType: t, domain: i, steps: A, scaleFn: s, as: n.as };
}, gq = (e, t, i, n) => {
  let A, s;
  const o = n[n.length - 1], r = e.measureParam, a = e.smartLabelCalc, l = i[r] / o;
  if (i[r] >= t[r])
    return n;
  A = a.getOriSize(n[0])[r];
  for (let c = 1; c < n.length - 1; c++)
    s = Math.floor(
      A / l + n[c - 1]
    ), n[c] < s && (n.splice(c, 1), c -= 1), A = a.getOriSize(n[c])[r];
  return n;
}, hq = (e, t) => {
  let i, n, A, s = e[e.length - 1], o = Math.ceil(e[1] - e[0]);
  const r = Math.ceil(s - e[0]), { alignment: a } = t, l = t.smartLabel, c = t.measures, g = t.minTickDistance, { height: h, width: u } = l.getOriSize(s);
  return Number.isInteger(s) || (s = s.toFixed(2)), o = o < 1 ? 1 : o, n = Math.abs(r) / Math.abs(o) * (u + g.width), n -= Math.abs(r), A = Math.abs(r) / Math.abs(o) * h, A -= Math.abs(r), a === Fn || a === tn ? i = Ge : i = Be, e = gq(
    {
      smartLabelCalc: l,
      measureParam: i
    },
    {
      height: A,
      width: n
    },
    {
      height: c.maxHeight,
      width: c.maxWidth
    },
    e
  ), e;
}, uq = (e, t, i) => {
  let n = 0;
  const A = i.smartLabel, { maxWidth: s, maxHeight: o } = i.measures, { alignment: r } = i, a = A.getOriSize(e[1].toFixed(2));
  return t = Math.round(t), t = t < 1 ? t + 1 : t, r === Fn || r === tn ? n = Math.floor(s / a.width) : n = Math.floor(o / a.height), t = Math.min(t, n), Sr(e, t);
}, dq = (e, t, i, n, A) => {
  const { border: s, padding: o, availableWidth: r } = n, { align: a, buffer: l } = A, c = e.labelManager();
  c.setStyle(i.style);
  const g = j(
    t,
    "div",
    [1],
    `${A.classPrefix}-legend-title`
  );
  let { width: h } = c.getOriSize(i.text);
  h += 2 * o + 1 + l[zt];
  let u;
  return a === Ze ? (u = r, g.style(
    "border-bottom",
    `${s}px ${A.borderStyle} ${A.borderColor}`
  )) : (u = Math.min(
    Pj * r,
    h
  ), g.style(Rj, `${l[zt]}px`)), c.useEllipsesOnOverflow(!0), g.style(Ge, `${u}px`).style(Be, "auto"), g.style(
    "text-align",
    i.orientation instanceof Function ? i.orientation(A.position) : i.orientation
  ), c.setStyle(e._computedStyle), j(
    g,
    "div",
    [i],
    `${A.classPrefix}-legend-title-text`
  ).style("padding", `${o}px`).text(i.text).style("text-align", "left").style("white-space", "nowrap").style("overflow", "hidden").style("text-overflow", "ellipsis").style("line-height", "100%").node();
}, fq = (e, t, i, n) => {
  const { totalAvailableSpaceForTitle: A, padding: s } = n, o = e.labelManager();
  o.setStyle(t.style);
  let { width: r } = o.getOriSize(t.text);
  r += 2 * s + 1 + i.buffer[zt], V(e.mount()).select(`.${i.classPrefix}-legend-title`).style(
    Ge,
    `${Math.min(r, A)}px`
  ).style(Be, "auto");
}, MN = (e) => {
  const t = [], i = e.data(), n = e._labelManager;
  return i.forEach((A, s) => {
    const { height: o, width: r } = n.getOriSize(A.formattedValue);
    t[s] = { height: o, width: r };
  }), t;
}, Iq = (e, t, i) => {
  let n = 0, A = 0, s = {
    width: 0,
    height: 0
  };
  const {
    effPadding: o,
    titleWidth: r,
    labelSpaces: a,
    titleHeight: l,
    maxWidth: c,
    maxHeight: g
  } = t, h = o, { item: u, align: d } = e, { icon: f, text: I } = u, C = I.orientation, E = [], B = [];
  let m = 0;
  return a.forEach((y, D) => {
    const Q = { width: 0, height: 0 }, p = { width: 0, height: 0 }, w = i[D] || {};
    C === mi || C === Rn ? (y.width += o, p.width = (w.size ? 2 * w.size : f.width) + o, m = Math.max(p.width, m), Q.width = y.width + m, y.height = Math.max(y.height, f.height) + o, p.height = y.height, Q.height = y.height) : (y.width = Math.max(y.width, w.size ? 2 * w.size : f.width) + o, p.width = y.width, Q.width = y.width, m = Math.max(p.width, m), y.height += o, p.height = f.height + o, Q.height = y.height + p.height), d === "horizontal" ? n = Math.max(n, Q.height) : (n += Q.height, A = Math.max(A, Q.width)), s = {
      width: Math.max(Q.width, s.width),
      height: Math.max(Q.height, s.height)
    }, E.push(Q), B.push(p);
  }), E.forEach((y, D) => {
    if (d === "horizontal")
      y.height = n, C === mi || C === Rn ? (a[D].height = n, B[D].height = n, E[D].width = a[D].width + B[D].width + 2 * o) : (a[D].width = B[D].width, E[D].width = B[D].width, a[D].width = B[D].width), A += E[D].width;
    else if (C === Fn || C === tn)
      a[D].width = A, B[D].width = A, m = A;
    else {
      const Q = a[D].width, p = s.width - m;
      B[D].width = m, E[D].width = Q + m, a[D].width = Math.max(Q, p), A = Math.max(A, y.width);
    }
  }), d === Ze ? (A = Math.ceil(Math.max(A, r)) + o + h, n += l + o + h) : (A = Math.ceil(r) + Math.ceil(A) + o + h, n += o + h), d === "horizontal" ? A = A > c ? c : A : n = n > g ? g : n, n = Math.ceil(n), A = Math.ceil(A), {
    totalHeight: n,
    totalWidth: A,
    itemSpaces: E,
    iconSpaces: B,
    maxItemSpaces: s,
    maxIconWidth: m
  };
}, Cq = (e, t, i) => {
  const { maxItemSpaces: n, margin: A, itemSpaces: s } = e, { position: o, buffer: r } = i, a = DN[o];
  let l = 0;
  if (a === zt) {
    const c = r[a];
    l = s.reduce((g, h) => g + h.width + c, 0);
  } else
    n.width < t ? l = t + 2 * A : l = n.width;
  return l;
}, Eq = (e) => {
  let t = 0, i = 0;
  const n = e.logicalSpace(), A = e.config(), { orientation: s, xOffset: o, yOffset: r } = A;
  s === Se && (t = o === void 0 ? n.width : o), s === ie && (i = r === void 0 ? n.height : r), e.renderConfig({ xOffset: t, yOffset: i });
}, Bq = (e, t, i, n) => {
  let A = 0, s = [], { numberOfTicks: o } = n.config();
  const a = i.scale().ticks().length, l = n._minTickDistance.width;
  return A = a, a * (t + l) > e && (A = Math.floor(e / (t + l))), o = o || A, A = Math.min(
    o,
    Math.max(Pg, A)
  ), s = i.scale().ticks(A), s.length > A && (s = s.filter((c, g) => c === 0 ? !0 : g % 2 === 0)), A === Pg && (s = i.scale().ticks(wS), s = [s[0], s[s.length - 1]]), s;
}, mq = (e, t, i) => {
  let n, A;
  const s = e.domain(), o = e._minTickDistance.width, { tickSize: r, tickDimensions: a, axisNameDimensions: l } = t, { axisNamePadding: c } = e.config(), g = e.getTickValues(), { showAxisName: h } = e.renderConfig(), { height: u } = l, { height: d, width: f } = a;
  if (n = i && i.length ? i[1] - i[0] : (f + o) * 3, A = 0, g) {
    const I = e.getMinTickDifference(), [C, E] = [
      Math.min(...g, ...s),
      Math.max(...g, ...s)
    ];
    n = (E - C) / Math.abs(I) * (f + e._minTickDistance.width);
  }
  return !i || !i.length ? A = Math.max(f, d) : A = d, A += (h ? u + c : 0) + r, {
    width: n,
    height: A
  };
}, Qq = (e, t) => {
  let i, n;
  const A = e.domain(), { tickSize: s, tickDimensions: o, axisNameDimensions: r } = t, { axisNamePadding: a } = e.config(), l = e.getTickValues(), { showAxisName: c } = e.renderConfig(), { height: g } = r, { height: h, width: u } = o;
  if (i = 0, n = u, l) {
    const d = e.getMinTickDifference(), [f, I] = [
      Math.min(...l, ...A),
      Math.max(...l, ...A)
    ];
    i = (I - f) / Math.abs(d) * h;
  }
  return n += (c ? g + 8 : 0) + s + (l ? a : 0), {
    height: i,
    width: n
  };
}, pq = (e) => {
  const t = e.range(), i = e.getAxisDimensions(), { orientation: n } = e.config(), { show: A, showAxisName: s } = e.renderConfig(), { axisNameDimensions: o } = i;
  if (A === !1)
    return {
      width: 0,
      height: 0
    };
  const { width: r } = o;
  if (n === ie || n === Ce) {
    const { width: g, height: h } = mq(
      e,
      i,
      t
    );
    return {
      width: Math.max(g, r),
      height: h
    };
  }
  const { width: a, height: l } = Qq(
    e,
    i
  ), c = Math.max(l, s ? r : 0);
  return {
    width: a,
    height: c
  };
};
class yq extends $i {
  constructor(t, i) {
    super(t, i);
  }
  getTickValues() {
    let t = 0;
    const { orientation: i } = this.config();
    let n = this.renderConfig().tickValues || this.scale().ticks();
    const A = this.range(), s = this.axis(), o = Math.abs(A[0] - A[1]), r = this.axisComponentDimensions().largestTickDimensions;
    return n || (t = r[i === Ce || i === ie ? "width" : "height"], n = Bq(o, t, s, this)), this.availableSpace() ? VS(this, n) : n;
  }
  getMinTickDifference() {
    const t = this.getTickValues();
    return Au(t);
  }
  getLogicalSpace() {
    return this.logicalSpace() || this.logicalSpace(pq(this)), Eq(this), this.logicalSpace();
  }
}
const _N = (e) => typeof e[0].value == "number" ? e.reduce(
  (t, i) => [
    Math.min(i.value, t[0]),
    Math.max(i.value, t[1])
  ],
  [Number.MAX_VALUE, Number.MIN_VALUE]
) : e.map((t) => t.value), Dq = (e) => {
  const t = e.axis(), i = e.scale(), n = i.getScaleRange();
  let A = [];
  if (n.length > 2)
    A = i.domain();
  else {
    const o = t.source().domain(), a = [...e.data().map((l) => l.value)];
    a.unshift(+o[0]), a.push(+o[1]), A = [...new Set(a)].sort((l, c) => l - c);
  }
  const s = A.map((o) => ({
    value: o
  }));
  return s.forEach((o, r) => o.id = r), s;
}, wq = (e, t) => {
  const i = e.scale(), n = i.domain(), { scaleFn: A } = kn(i), s = Math.min(...n), o = Math.max(...n);
  return t.map((r) => ({
    ...r,
    color: i[A](
      r.value > o ? o : r.value < s ? s : r.value
    )
  }));
}, xq = (e, t, i) => {
  const n = Dq(e), A = _N(n), s = wq(e, n), o = j(t, "defs", [1]), r = j(o, "linearGradient", [1]).attr("id", `linear-gradient-${i}`).attr("x1", "0%").attr("y2", "0%");
  return j(r, "stop", s, "stop-gradient").attr(
    "offset",
    (a) => `${(a.value - A[0]) * 100 / (A[1] - A[0]) || 1}%`
  ).attr("stop-color", (a) => a.color), r;
}, Sq = (e) => {
  const t = e.fieldName(), i = e.metaData(), { subtype: n } = i.getField(t).schema(), A = e.data(), { useUTC: s } = e.config(), o = e._cells.AxisCell, { domain: r, stops: a } = e.config(), l = !!(Array.isArray(r) && r.length), c = !!(Array.isArray(a) && a.length), g = n === J.FieldSubtype.TEMPORAL ? kr : yq, h = new g(
    {
      id: `legend-${e._id}`,
      // orientation: align === ALIGN.VERTICAL ? BOTTOM : LEFT,
      // The ticks are at bottom for vertical gradient legend
      orientation: tn,
      style: e._computedStyle,
      nice: !(l || c),
      showAxisName: !1,
      tickSize: 0,
      fixedBaseline: !1,
      labels: {
        rotation: null
      },
      tickFormat: (u, d) => {
        const f = e.metaData(), I = e.fieldName(), C = f.getField(I), E = bN(
          u.rawValue,
          C,
          {
            useUTC: e.config().useUTC,
            useShortFormatter: !0
          }
        );
        return e.config().item.text.formatter(
          {
            formattedValue: E,
            rawValue: u.rawValue
          },
          {
            context: e,
            itemMeta: {},
            itemIndex: d.tickIndex,
            allItems: d.allRawTicks,
            dataModel: e.metaData()
          }
        );
      },
      useUTC: s,
      transition: e.config().transition
    },
    { labelManager: e._labelManager }
  );
  return l ? h.domain(r) : h.domain(_N(A)), n === J.FieldSubtype.TEMPORAL ? (h.minDiff(
    i.getField(t).minimumConsecutiveDifference()
  ), h.logicalSpace(fE(h, !0)), Dl(h)) : h.range([1, 1]), new o().source(h).config({
    margin: { left: 0, bottom: 0, top: 0, right: 0 }
  });
}, Mq = (e) => {
  const t = e.fieldName(), i = e.metaData(), { subtype: n } = i.getField(t).schema(), A = e.axis().source(), { _tickFormatter: s } = A, o = A.domain(), r = (+o[0] + +o[1]) / 2;
  let a = [o[0], r, o[1]];
  n === J.FieldSubtype.TEMPORAL && (a = a.map((g) => /* @__PURE__ */ new Date(+g)));
  const l = s(a);
  return a.map((g) => l(g));
};
function bN(e, t, i) {
  const { subtype: n } = t.schema();
  let A;
  return n === J.FieldSubtype.TEMPORAL ? A = Vs(
    e,
    t.minimumConsecutiveDifference(),
    {
      useUTC: i.useUTC,
      useShortFormatter: i.useShortFormatter
    }
  ) : A = e, Ei(A);
}
const _q = (e, t, i, n) => {
  const { align: A } = e.config(), s = Mq(e), o = e.fieldName(), r = e.metaData(), { subtype: a } = r.getField(o).schema(), l = j(
    t,
    "div",
    [1],
    `${i}-legend-body`
  );
  let c, g, h, u, d;
  if (A === Ls.HORIZONTAL)
    c = j(
      l,
      "div",
      [1],
      `${i}-gradient-ticks`
    ), h = j(
      c,
      "div",
      [1],
      `${i}-gradient-first-tick`
    ), h.text(s[0]), h.style("padding", "5px"), g = j(
      c,
      "svg",
      [1],
      `${i}-gradient`
    ), u = j(
      c,
      "div",
      [1],
      `${i}-gradient-second-tick`
    ), u.text(s[2]), u.style("padding", "5px");
  else if (g = j(
    l,
    "svg",
    [1],
    `${i}-gradient`
  ), c = j(
    l,
    "div",
    [1],
    `${i}-gradient-ticks`
  ), c.style("justify-content", "space-between"), h = j(
    c,
    "div",
    [1],
    `${i}-gradient-first-tick`
  ), h.text(s[0]), h.style("padding", "5px 0"), a !== J.FieldSubtype.TEMPORAL && (u = j(
    c,
    "div",
    [1],
    `${i}-gradient-second-tick`
  ), u.text(s[1]), u.style("padding", "5px 0")), d = j(
    c,
    "div",
    [1],
    `${i}-gradient-third-tick`
  ), d.text(s[2]), d.style("padding", "5px 0"), a !== J.FieldSubtype.TEMPORAL) {
    const { width: E } = e.labelManager().getOriSize(s[0]), { width: B } = e.labelManager().getOriSize(s[1]), { width: m } = e.labelManager().getOriSize(s[2]), y = c.style("width").replace("px", "");
    E + 10 + B + 10 + m > y && u.style("display", "none");
  }
  [h, u, d].forEach((E) => {
    E && E.classed(`${i}-gradient-tick`, !0);
  }), c.style("display", "flex"), c.style("align-items", "center");
  const f = j(
    g,
    "g",
    [1],
    `${i}-gradient-group`
  ), I = xq(e, g, n), C = j(
    f,
    "rect",
    [1],
    `${i}-gradient-rect`
  );
  return {
    legendContainer: l,
    legendTicksContainer: c,
    legendGradCont: f,
    legendGradSvg: g,
    linearGradient: I,
    legendRect: C
  };
}, P0 = (e, t, i, n) => {
  const A = e.axis();
  A.setAvailableSpace(n, i), A.render(t.node());
}, bq = (e, t) => {
  const { align: i, classPrefix: n, item: A } = e.config(), { legendContainer: s, legendGradSvg: o, linearGradient: r, legendRect: a } = _q(e, t, n, e._id), {
    padding: l,
    margin: c,
    border: g,
    titleSpaces: h,
    maxItemSpaces: u,
    maxHeight: d,
    maxWidth: f,
    height: I,
    width: C
  } = e.measurement(), E = {}, B = Math.floor(
    Math.min(I, d) - (h.height + 2 * c + 2 * g)
  ), m = Math.floor(
    Math.min(C, f) - (c * 2 + g * 2)
  );
  if (i === Ls.HORIZONTAL) {
    const D = m - 2 * l, Q = e.mount().style.width.replace("px", "") - 2 * l;
    E.height = A.icon.height, E.width = D, r.attr("x2", "100%").attr("y1", "0%"), e._legendContainer.style.flexDirection = "row", e._legendContainer.style.alignItems = "center";
    const p = parseFloat(s.style("width"));
    P0(
      e,
      s,
      B - A.icon.height - l,
      p
    ), li(s, {
      // height: `${maxItemSpaces.height - 2 * border - 2 * padding}px`,
      // width: `${parentWidth}px`,
      padding: `${l}px`,
      display: "flex"
    });
    const w = Q;
    a.attr("height", A.icon.height), a.attr("width", w);
    const x = A.icon.height;
    li(o, {
      height: `${x}px`
      // width: `${legendGradSvgWidth}px`,
    }), o.attr("height", x), o.attr("width", w);
  } else {
    const D = m - 2 * l, Q = e.mount().style.width.replace("px", "") - 2 * l;
    E.height = A.icon.height, E.width = D, r.attr("x2", "100%").attr("y1", "0%"), e._legendContainer.style.flexDirection = "column", P0(
      e,
      s,
      B - A.icon.height - l,
      Q
    ), li(s, {
      height: `${u.height + g + l}px`,
      // width: `${parentWidth}px`,
      padding: `${l}px`,
      margin: "5px 0"
    });
    const p = Q;
    a.attr("height", A.icon.height), a.attr("width", p);
    const w = A.icon.height;
    li(o, {
      height: `${w}px`,
      width: `${p}px`
    });
  }
  const y = s.select(`.${n}-axis-cell`);
  return li(y, {
    display: "none",
    width: "100%"
  }), li(a, {
    fill: `url(#linear-gradient-${e._id})`,
    width: "100%"
  }), e.measurement({
    gradientDimensions: E
  }), e._legendGradientSvg = o, e;
}, Nq = Math.sqrt(3) * 3, Y0 = 1, J0 = 10, Od = 6, Fq = (e, t, i) => {
  const { TextCell: n } = i, A = new n(
    {
      type: "text",
      className: `${e}-text`
    },
    {
      labelManager: t()
    }
  ).config({ maxLines: 1, padding: 0 });
  return A._minTickDiff = { height: 0, width: 0 }, A;
}, Rq = (e, t) => ({
  top: t.getBoundingClientRect().top - e.getBoundingClientRect().top,
  left: t.getBoundingClientRect().left - e.getBoundingClientRect().left
});
class kq extends Fu {
  constructor(...t) {
    super(...t), this._graphicElements = {
      legendMarkerGroup: null,
      legendMarkerElement: null,
      markerElement: null,
      legendMarkerTextContainer: null,
      legendMarkerText: null
    };
  }
  static formalName() {
    return lB;
  }
  /**
   * It returns the default configuration needed by legend-marker.
   * @return {Object} Default configuration of the legend-marker.
   */
  static defaultConfig() {
    return {
      className: "legend-marker",
      classPrefix: cB,
      size: us.size,
      shape: us.shape
    };
  }
  apply(t, i) {
    const n = `${this.config().classPrefix}-${this.config().className}`, A = this.firebolt.context.config().splitFieldInfo, s = i.targetData && i.targetData[0].findIndex(
      (o) => o === A.field
    );
    if (i.criteria && // !payload.criteria.dimensions.some((arr) =>
    //   arr.some((d) => DataStore.isInvalid(d))
    // ) &&
    i.targetData && i.targetData[0].some((o) => o === this.firebolt.context.fieldName()) && i.targetData[1][s] === A.value) {
      const o = this.firebolt, r = o.context.labelManager, a = o.context, l = o.context.config(), c = o.context.scale(), { formatter: g } = l.marker.text, h = this.config(), u = a.axis().source(), d = a.metaData(), f = c.domain(), I = a.fieldName(), C = d.getField(I), { subtype: E } = C.schema(), B = i.metaData, m = B?.layersInfo?.find(
        (Et) => Et.id() === i.layerId
      );
      if (!B.includeTotalDomain && m && fx(
        {
          axes: m.axes(),
          totalsAxis: m.metaInf().totalsAxis
        },
        i.targetData[1].some(
          (Et) => Et === m.metaInf().rowTotalString || m.metaInf().colTotalString
        )
      ))
        return;
      let y = i.targetData[0].findIndex(
        (Et) => Et === I
      ), D = null;
      if (y !== -1 && (D = parseFloat(i.targetData[1][y])), Number.isNaN(D))
        return;
      const Q = a.scale(), { scaleFn: p } = kn(Q), w = Q[p](D), x = a.getDrawingContext().svgContainer, { width: S, height: _ } = x.node().getBoundingClientRect(), M = E === "temporal" ? D : +D.toFixed(1);
      let k, T = Xj;
      M > f[f.length - 1] ? (k = f[f.length - 1], T = 1) : M < f[0] ? (k = f[0], T = 1) : k = M;
      const G = f.length > 2 && a.config().step ? ux(
        [T, S - T],
        f.length
      ) : [T, S - T];
      u.range(G);
      const N = u.getScaleValue(k), b = {
        top: 0,
        left: 0
      }, F = a.mount(), { top: R, left: v } = Rq(
        F,
        x.node()
      ), O = g(
        {
          formattedValue: bN(M, C, {
            useUTC: a.config().useUTC,
            useShortFormatter: !0
          }),
          rawValue: M
        },
        {
          context: a,
          domain: f,
          dataModel: d
        }
      );
      r().setStyle(a.config().marker.text.style);
      const { oriTextWidth: L } = r().getSmartText(O);
      let U, H, z;
      const { size: et } = h, { align: Z, position: Y } = a.config();
      U = N - Math.sqrt(et / Nq) + Y0, H = 5, z = us.ROTATE_HORIZONTAL + us.ROTATE_HORIZONTAL, b.top = R + H + 2 * J0;
      const q = L + Od, $ = U + v + Od, P = U + v - L - Od;
      Z === zt || Y === mi ? U < q ? b.left = $ : b.left = P : U < q ? S - U < q ? b.left = P : b.left = $ : b.left = P, this._graphicElements.legendMarkerTextContainer || (this._graphicElements.legendMarkerTextContainer = j(
        F,
        "div",
        [1],
        `${n}-text-container`
      ), this._graphicElements.legendMarkerTextContainer.style("position", "absolute").style("left", "0px").style("top", "0px").style("width", "100%").style("height", "100%").style("z-index", "999"), this._graphicElements.legendMarkerText = j(
        this._graphicElements.legendMarkerTextContainer,
        "div",
        [1],
        `${n}-text-${this.firebolt.id()}`
      ), this._graphicElements.legendMarkerGroup = j(
        this._graphicElements.legendMarkerTextContainer,
        "svg",
        [1],
        `${n}-group-${this.firebolt.id()}`
      ), this._graphicElements.legendMarkerGroup.attr(
        "class",
        `${n}-group ${n}-group-${this.firebolt.id()}`
      ), this._graphicElements.legendMarkerElement = j(
        this._graphicElements.legendMarkerGroup,
        "g",
        [1],
        `${n}-element`
      )), this._graphicElements.legendMarkerGroup.style("position", "absolute").style("top", `${R - Ud / 2}px`).style("left", `${v}px`).style("width", `${S}px`).style(
        "height",
        `${_ + Ud}px`
      ), this._graphicElements.markerElement || (this._graphicElements.markerElement = j(
        this._graphicElements.legendMarkerElement,
        "path",
        [{ value: null }],
        n
      ));
      const st = Fq(
        n,
        r,
        a._cells
      );
      this._graphicElements.markerElement.data([{ value: i.criteria }]).attr("transform", `translate(${U},0) rotate(${z})`).attr(
        "d",
        `M 0,0 v ${_ + Ud}`
      ).classed(`${n}-show`, !0).classed(`${n}-hide`, !1);
      const nt = bA(w).rgb(), ot = 0.2126 * (nt.r / 255) + 0.7152 * (nt.g / 255) + 0.0722 * (nt.b / 255);
      this._graphicElements.markerElement.style("stroke-width", "2px"), ot <= 0.5 ? (this._graphicElements.markerElement.style("stroke", "white"), this._graphicElements.legendMarkerText.attr(
        "class",
        `${n}-text ${n}-text-secondary ${n}-text-${this.firebolt.id()}`
      )) : (this._graphicElements.markerElement.style("stroke", "black"), this._graphicElements.legendMarkerText.attr(
        "class",
        `${n}-text ${n}-text-${this.firebolt.id()}`
      )), st.source(O), st.render(this._graphicElements.legendMarkerText.node()), this._graphicElements.legendMarkerText.style("top", `${b.top - 4 * J0 + Y0}px`).style("left", `${b.left}px`), this._graphicElements.legendMarkerTextContainer.classed(`${n}-show`, !0).classed(`${n}-hide`, !1), this._graphicElements.legendMarkerText.classed(`${n}-show`, !0).classed(`${n}-hide`, !1), this._graphicElements.legendMarkerGroup.classed(`${n}-show`, !0).classed(`${n}-hide`, !1);
    } else
      this._graphicElements.legendMarkerText && this._graphicElements.legendMarkerGroup && this._graphicElements.markerElement && (this._graphicElements.legendMarkerTextContainer.classed(`${n}-show`, !1).classed(`${n}-hide`, !0), this._graphicElements.legendMarkerText.classed(`${n}-show`, !1).classed(`${n}-hide`, !0), this._graphicElements.legendMarkerGroup.classed(`${n}-show`, !1).classed(`${n}-hide`, !0), this._graphicElements.markerElement.data([{ value: null }]).classed(`${n}-show`, !1).classed(`${n}-hide`, !0));
  }
}
class Tq extends $t {
  constructor(...t) {
    super(...t);
  }
  static formalName() {
    return uI;
  }
  apply(t, { showTooltip: i, tooltipText: n, tooltipAnchorBox: A, isStepLegend: s }) {
    if (this._tooltipRenderer == null && (this._tooltipRenderer = new vl(document.body, {
      creatorName: [uI]
    }), this._tooltipRenderer.extent({
      x: 0,
      y: 0
    }), this._tooltipRenderer.config({
      content: {
        rowMargin: "0 10px 5px 10px",
        className: this.firebolt.context._className
      }
    })), !i || s) {
      this._tooltipRenderer.hide();
      return;
    }
    const o = n;
    this._tooltipRenderer.content("tooltip", [{ data: [o] }]), this._tooltipRenderer.offset({
      x: 0,
      y: 0
    }), this._tooltipRenderer.positionRelativeTo(A);
  }
}
class vq extends $t {
  constructor(...t) {
    super(...t), this._outlineElement = null;
  }
  static formalName() {
    return dI;
  }
  apply(t, { showTooltip: i, event: n, firebolt: A }) {
    if (!this._tooltipRenderer) {
      this._tooltipRenderer = new vl(
        document.body,
        {
          creatorName: [dI]
        },
        {
          showPointerArrow: !0
        }
      );
      const d = document.querySelector("html").clientWidth, f = document.querySelector("html").clientHeight;
      this._tooltipRenderer.extent({
        x: 0,
        y: 0,
        width: d,
        height: f
      }), this._tooltipRenderer.config({
        content: {
          rowMargin: "0 10px 5px 10px",
          className: this.firebolt.context._className
        }
      });
    }
    if (!i) {
      this._tooltipRenderer.hide(), this._outlineElement?.style("display", "none");
      return;
    }
    if (!n || !A)
      return;
    const s = V(n.currentTarget), o = s.node(), r = Wi(o), a = A.context.mount(), { classPrefix: l } = A.context.config(), c = s.attr("width"), g = s.attr("x"), h = s.datum();
    if (!this._outlineElement) {
      const d = V(a).select(
        `.${l}-legend-svg-container`
      );
      this._outlineElement = j(
        d,
        "div",
        [1],
        `${l}-step-legend-item-outline`
      ).style("position", "absolute").style("width", `${c}px`).style("height", `${r.height + 2}px`).style("top", "-1px").style("pointer-events", "none").style("border", "1px solid black");
    }
    const u = `Min-Max: ${h?.formattedValue}`;
    this._tooltipRenderer.content("tooltip", [{ data: [u] }]), this._tooltipRenderer.offset({
      x: 0,
      y: 0
    }), this._tooltipRenderer.positionRelativeTo(r, {
      orientation: "vertical",
      priority: "top"
    }), this._outlineElement.style("display", "block").style("left", `${g}px`);
  }
}
const Gq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LegendHighlighter: cq,
  LegendMarker: kq,
  LegendTextTooltip: Tq,
  SelectionBox: lq,
  StepLegendTooltip: vq
}, Symbol.toStringTag, { value: "Module" }));
class Lq extends Tl {
  constructor(...t) {
    super(...t), this._applyChecker = {
      source: () => !0
    };
  }
  static formalName() {
    return QN;
  }
  setSelectionSet(t, i) {
    if (t === null)
      i.reset();
    else if (t.length) {
      const n = this.context.getPropagationInf(), A = i._entrySet, s = t.filter((o) => A.has(o));
      if (n.sourceId) {
        i.reset(), i.add(t);
        const o = Mn(
          [i.getCompleteSet()],
          [i.getEntrySet()]
        );
        i.remove(o);
      } else {
        if (s.length)
          i.remove(s);
        else if (i.add(t), !i.getExitSetLength()) {
          const r = Mn(
            [i.getCompleteSet()],
            [i.getEntrySet(), i.getExitSet()]
          );
          i.remove(r);
        }
        const o = i.getCompleteSetLength();
        (i.getExitSetLength() === o || i.getEntrySetLength() === o) && i.reset();
      }
    } else
      i.remove(i.getCompleteSet());
    return this;
  }
}
class Uq extends Qi {
  static formalName() {
    return Bh;
  }
  dispatch(t) {
    return this._payload = t, this;
  }
}
const Oq = WM, Hq = VM, Pq = jM, Yq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BrushBehaviour: Hq,
  HighlightBehaviour: Oq,
  InverseSelectBehaviour: Pq,
  LegendHighlightBehaviour: Uq,
  SelectBehaviour: Lq
}, Symbol.toStringTag, { value: "Module" })), Aa = {
  physicalBehaviouralMap: Ij,
  behaviourEffectMap: Cj,
  physicalActions: nq,
  sideEffects: Gq,
  behaviours: Yq
}, Jq = (e, t) => {
  const i = e.context, n = i.metaData(), A = i.constructor.type(), s = i.fieldName(), o = n.getField(s).type(), r = {}, a = e.actions().behavioural[t], l = a.getSelectionSet(), c = a.getPayload(), g = l.getEntrySet(), h = i.data();
  let u;
  if (c.criteria === null || l.resetted())
    u = {
      identifiers: null
    };
  else if (A === gB || A === hB && o === "measure") {
    const Q = i.data().filter((p) => g.has(p.id)).map((p) => p.range);
    u = {
      identifiers: {
        [s]: Q
      },
      interpolated: !0
    };
  } else if (A === Qh) {
    const Q = c.criteria.range;
    u = {
      identifiers: Object.keys(Q).reduce((w, x) => (w[x] = Q[x].map((S) => +S), w), {}),
      interpolated: !0
    };
  } else {
    const Q = [...g].map((p) => J.isInvalid(p) ? null : h[h.findIndex((w) => w.rawVal === p)].rawVal);
    Q.push(...i.config().hiddenDomain), u = {
      fields: Object.keys(c.criteria.dimensions),
      identifiers: Q
    };
  }
  r.sourceAction = t;
  const d = i.config().interaction;
  r.targetActions = W(d, t, "target"), r.sourceInfo = {
    canvasId: i.canvasAlias(),
    type: "legend"
  }, r.propagationSourceId = e.id();
  const f = Object.assign({}, r, {
    sourceId: e.id(),
    criteria: u.identifiers,
    sourceAction: t,
    interpolated: u.interpolated,
    fields: [s]
  }), I = Object.keys(r.targetActions).some(
    (Q) => Q.filter
  ), C = e._globalContext;
  let E = n.getPropagationQuery(u.identifiers, {
    fields: c.fields,
    interpolated: u.interpolated,
    resolveId: !1,
    type: A,
    domain: e.context.scale().domain()
  });
  if (u.interpolated && A === Qh) {
    const Q = e.context.config().splitFieldInfo;
    Q.field && (E = {
      conditions: [
        {
          field: Q.field,
          value: Q.value,
          operator: "eq"
        },
        E
      ],
      operator: "and"
    });
  }
  const B = C.interactionFilters.get(
    e.sourceCanvas()
  ), m = {
    ...B,
    legend: {
      identifiers: E,
      fields: [s]
    }
  };
  let y = !1;
  I && (!B && C.interactionFilters.size && (y = !0), !c.criteria && y ? C.interactionFilters.remove(e.sourceCanvas()) : C.interactionFilters.save(globalThis.sourceCanvas(), m));
  const D = [
    {
      criteria: m.legend.identifiers,
      fields: m.legend.fields
    }
  ];
  n.propagate(D, { ...f, resetFilterAction: y });
}, K0 = {
  __default: (e, t) => {
    if (e === null)
      return Object.assign({}, t, {
        criteria: null
      });
    const i = e.getData({
      excludeFields: [St.ROW_ID]
    });
    let n = i.schema;
    const A = Object.assign({}, t);
    n = i.schema;
    const s = i.data, o = n.map((r) => r.name);
    return A.criteria = {
      dimensions: [o, ...s]
    }, A;
  },
  brush: (e, t) => {
    const { criteria: i } = t, n = Object.assign({}, t);
    return n.criteria = i ? { range: i.range } : null, n;
  }
};
class Kq extends to {
  constructor(...t) {
    super(...t), this._propagationDms = {}, this.initializeSideEffects(), this._lastInteraction = /* @__PURE__ */ new Map(), this._interactionStates = /* @__PURE__ */ new Map();
  }
  propagate(t, i, n) {
    Jq(this, t);
  }
  getAddSetFromCriteria(t) {
    let i, n;
    const A = this.context.constructor.type(), s = this.context.fieldName(), o = this.data().getField(s).type();
    if (t === null)
      return {
        uids: null,
        model: null
      };
    const { dimensions: r } = t;
    if (A === hB && o === "measure")
      i = Object.values(r), n = this.context.data().filter((a) => i.indexOf(a.range) !== -1).map((a) => a.id);
    else if (A === gB)
      i = Object.values(r), n = this.context.data().filter((a) => i.indexOf(a.range) !== -1).map((a) => a.id);
    else if (A === Qh)
      n = [];
    else if (i = r, i instanceof Array) {
      n = [], i = i.slice(1, i.length);
      for (let a = 0; a < i.length; a++) {
        const l = i[a];
        n.push(l);
      }
    } else
      i = i[s], n = this.context.data().filter((a) => i.indexOf(a.rawVal) !== -1).map((a) => a.rawVal);
    return {
      uids: n,
      model: null
    };
  }
  onDataModelPropagation() {
    return (t, i) => {
      if (!t && i.propagateDm === !1 && i.criteria !== null && i.sourcePropQuery && (t = this.data().select(i.sourcePropQuery)), this._propagationDms[i.sourceAction] && this._propagationDms[i.sourceAction].dispose(), this._propagationDms[i.sourceAction] = t, !this.context.mount())
        return;
      const s = (K0[i.action] || K0.__default)(t, i), { propagationSourceId: o } = i, r = {
        propagate: !1,
        data: t,
        sourceId: o
      }, a = i.sourceId === this.id(), l = s.action;
      if (!a && W(i.sourceInfo, "type") !== "legend") {
        if (i.criteria === null && i.resetAllInteractions)
          return this.resetAllInteractions(i), this;
        l === "highlight" && this.dispatchBehaviour(l, s, r);
      }
    };
  }
  dispatchBehaviour(t, i, n, A) {
    i.criteria !== null ? this.saveInteractionState({
      action: t,
      payload: i,
      propagationInf: n,
      forceDispatch: A
    }) : this.removeInteractionState({
      action: t
    }), super.dispatchBehaviour(t, i, n, A), this._saveSerializedInteractionState(this.getSerializedInteractions());
  }
  applyExistingInteractions() {
    this._interactionStates.forEach(
      ({ action: i, payload: n, propagationInf: A, forceDispatch: s }) => {
        const o = this._behaviourEffectMap[i] || [], r = this.getApplicableSideEffects(
          o,
          n,
          A,
          s
        );
        this.actions().behavioural[i].entryExitSet() && this.dispatchSideEffects(
          i,
          { ...n, sideEffects: r },
          A,
          !0
        );
      }
    );
  }
  resetAllInteractions(t) {
    const i = this._lastInteraction, n = [], A = this.context.config().interaction;
    i.forEach(({ behaviour: s, sideEffects: o }, r) => {
      const a = W(A, s, "target", "layer") || {};
      (s.includes("filter") || a.filter) && !t.resetFilterAction || (this.dispatchBehaviour(
        s,
        {
          criteria: null,
          sideEffects: o,
          sourceInfo: {}
        },
        { propagate: !1 },
        !0
      ), n.push(r));
    }), n.forEach((s) => i.delete(s));
  }
  data() {
    return this.context.metaData();
  }
  id() {
    return `legend-${this.context._id}`;
  }
  sourceCanvas() {
    return this.context.canvasAlias();
  }
  beforeDispatchBehaviour(t) {
    const i = this.context.metaData();
    if (this.shouldResetAllInteractions(t)) {
      const n = this.getEntryExitSet(t);
      if (!W(n, "entrySet", "length")) {
        const A = [{ criteria: null, fields: [] }];
        i.propagate(A, { criteria: null, resetAllInteractions: !0 });
      }
    }
  }
  onPhysicalActionTrigger(t) {
    const { payload: i, behaviours: n } = t;
    n.forEach((A) => {
      this.beforeDispatchBehaviour(A), this.dispatchBehaviour(A, { ...i, action: A });
    });
  }
  shouldResetAllInteractions(t) {
    return this.getBehaviouralAction(
      t
    ).shouldResetOtherActionsOnTrigger();
  }
  getSerializedInteractions() {
    const { behavioural: t } = this._actions, i = {};
    for (let n in t) {
      const A = t[n];
      if (n !== Gu && A.entryExitSet()) {
        let s;
        if (n === mN)
          s = A._payload.criteria;
        else {
          const o = A.getInteractedSet();
          s = o ? {
            dimensions: {
              [this.context.fieldName()]: [...o]
            }
          } : null;
        }
        i[n] = {
          criteria: s,
          fields: A._payload.fields
        };
      }
    }
    return i;
  }
}
const Wq = {
  config: {
    sanitization: (e, t) => tt(
      {},
      dB,
      e._config || {},
      t
    ),
    onset: (e, t) => {
      const i = e.firebolt(), n = Object.keys(t.interaction).reduce(
        (A, s) => {
          const o = t.interaction[s].sideEffects;
          return A[s] = Object.keys(o).map((r) => ({
            name: r,
            ...o[r]
          })), A;
        },
        {}
      );
      i.mapSideEffects(n);
    }
  },
  data: {
    onset: (e, t) => {
      e.createFireboltSelectionSet({
        data: t,
        prevData: e._prevData
      }), e._prevData = t;
    }
  },
  fieldName: {},
  legendContainer: {},
  measurement: {
    sanitization: (e, t) => {
      const i = tt(e._measurement, t);
      return ["padding", "border", "margin"].forEach((n) => {
        i[n] = Math.min(
          i[n] > 0 ? i[n] : 0,
          i.maxWidth * 0.1,
          i.maxHeight * 0.1
        );
      }), i;
    }
  },
  logicalSpace: {},
  metaData: {
    onset: (e, t) => {
      const i = e.firebolt();
      i.attachPropagationListener(t), i.clearInteractionState();
    }
  },
  range: {
    sanitization: (e, t) => (e.scale().range(t), e.resetLogicalSpace(), e.store().commit("range", t), t)
  },
  scale: {},
  smartTicks: {},
  store: {},
  title: {
    sanitization: (e, t) => tt(e._title || {}, t)
  },
  labelManager: {},
  minTickDistance: {},
  valueParser: {
    defaultValue: (e) => e
  }
};
class Ll extends _e().with(
  zs
) {
  /**
   * Creates an instance of Legend.
   * @param {Object} dependencies Set of dependencies required by the legend
   * @memberof Legend
   */
  constructor(t, i, n) {
    super(), this.eventManager(n);
    const { interactions: A } = t.registry;
    this._data = [], this._metaData = [], this._mount = null, this._fieldName = null, this._title = Object.assign({}, oq), this._metaData = null, this._labelManager = t.labelManager, this._cells = t.cells, this._id = Ut(), this._measurement = Object.assign(
      {},
      this.constructor.defaultMeasurement()
    ), this._config = tt({}, this.constructor.defaultConfig());
    const s = t.labelManager.getOriSize("w");
    this._minTickDistance = {
      width: s.width * 3 / 4,
      height: s.height / 2
    }, ge(this, Wq), this._computedStyle = zn(
      V("body"),
      `${this.config().classPrefix}-legend-item-info`
    ), this._firebolt = new Kq(
      this,
      {
        behavioural: A.behaviours.get(),
        physical: A.physicalActions.get(),
        physicalBehaviouralMap: A.physicalBehaviouralMap.get()
      },
      A.sideEffects.get(),
      A.behaviourEffectMap.get()
    ), this.emitSelfHooks(
      gt.INITIALIZED,
      null,
      this.genAssociatedHookComponentPaths(i)
    );
  }
  genAssociatedHookComponentPaths(t) {
    return [
      [
        xt.LEGEND,
        t || this.scale().constructor.type()
      ],
      [xt.LEGEND]
    ];
  }
  associatedHookComponentPaths() {
    return this.genAssociatedHookComponentPaths();
  }
  id() {
    return this._id;
  }
  /**
   * Initializes an instance of the class
   *
   * @static
   * @param {Object} dependencies Set of dependencies required by the legend
   * @return {Instance} returns a new instance of Legend
   * @memberof Legend
   */
  static create(t, i) {
    return new Ll(t, i);
  }
  /**
   *
   *
   * @static
   *
   * @memberof SimpleLegend
   */
  static defaultConfig() {
    return dB;
  }
  /**
   *
   *
   * @static
   *
   * @memberof SimpleLegend
   */
  static defaultMeasurement() {
    return sq;
  }
  /**
   *
   *
   * @readonly
   * @memberof SimpleLegend
   */
  firebolt(...t) {
    return t.length ? this : this._firebolt;
  }
  /**
   *
   *
   *
   * @memberof Legend
   */
  elemType() {
    return yj;
  }
  canvasAlias(...t) {
    return t.length ? (this._canvasAlias = t[0], this) : this._canvasAlias;
  }
  /**
   *
   *
   *
   * @memberof Legend
   */
  mount(...t) {
    return t.length ? (this._mount = t[0], this.render(), this) : this._mount;
  }
  /**
   *
   *
   * @param {*} effPadding
   * @param {*} align
   *
   * @memberof Legend
   */
  getLabelSpaces() {
    const { classPrefix: t } = this.config();
    return this._labelManager.setStyle(
      zn(
        V("body"),
        `${t}-legend-item-info`
      )
    ), MN(this);
  }
  /**
   * Sets the height and width of a legend based on provided max
   * height and width and based on its contents
   *
   * @return {Instance} Current instance
   * @memberof Legend
   */
  setLegendMeasures() {
    const { width: t, height: i, maxWidth: n, maxHeight: A, padding: s, margin: o, border: r } = this.measurement(), { align: a } = this.config(), l = s * 2, c = r * 2, g = o * 2;
    this.data(this.dataFromScale());
    const h = this.getTitleSpace(), u = h.height > 0 ? h.height + l : 0, d = h.width + l, f = this.getLabelSpaces(l, a), {
      totalHeight: I,
      totalWidth: C,
      itemSpaces: E,
      iconSpaces: B,
      maxItemSpaces: m,
      maxIconWidth: y
    } = Iq(
      this.config(),
      {
        effPadding: l,
        titleWidth: d,
        labelSpaces: f,
        titleHeight: u,
        maxWidth: n * 0.8,
        // max height of legend should be 80% of the chart height/width
        maxHeight: A * 0.8
      },
      this.data()
    );
    return this.measurement({
      width: Math.max(C, t) + g + c,
      height: Math.max(I, i) + g + c,
      labelSpaces: f,
      iconSpaces: B,
      itemSpaces: E,
      maxItemSpaces: m,
      maxIconWidth: y,
      titleSpaces: {
        width: Math.min(n, this.measurement().width) - g - c,
        height: u
      }
    }), this;
  }
  /**
   * Returns the space occupied by the legend title
   *
   * @return {Object} Space occupied by title
   * @memberof Legend
   */
  getTitleSpace() {
    return this._labelManager.setStyle(
      zn(
        V("body"),
        `${this.config().classPrefix}-legend-title`
      )
    ), this._labelManager.getOriSize(
      this.title().text ? this.title().text : ""
    );
  }
  /**
   * Creates the title for the legend
   *
   * @param {DOM} container Container made for the title
   * @return {Selection} Title and it's node
   * @memberof Legend
   */
  renderTitle(t, i) {
    const { availableWidth: n } = i, { title: A } = this.config();
    if (A && A.show === !1)
      return;
    const { titleSpaces: s, border: o, padding: r, maxWidth: a } = this.measurement(), l = Cq(
      this.measurement(),
      this._labelManager.getOriSize(this._title.text).width,
      this.config()
    ), { borderStyle: c, borderColor: g } = this.config();
    return dq(
      this,
      t,
      this.title(),
      {
        height: s.height,
        width: l,
        maxWidth: a,
        border: o,
        padding: r,
        borderStyle: c,
        borderColor: g,
        alignment: DN[this.config().position],
        availableWidth: n
      },
      this.config()
    );
  }
  /**
   * Render the legend with its title
   *
   * @param {DOM} mountPoint Point where the legend and title are to be appended
   * @return {Instance} Current instance of legend
   * @memberof Legend
   */
  render() {
    const { classPrefix: t, borderStyle: i, borderColor: n, align: A } = this.config(), { border: s } = this.measurement(), o = V(this.mount()), r = j(
      o,
      "div",
      [1],
      `${t}-legend-box`
    );
    r.classed(`${t}-legend-box-${this._id}`, !0), r.style("width", "100%").style("height", "100%").style("display", "flex").style("border", `${s}px ${i} ${n}`), A === Ze ? r.style("flex-direction", "column") : r.style("flex-direction", "row").style("align-items", "center"), this.legendContainer(r.node());
    const a = parseFloat(o.style("width"));
    return this.renderTitle(r, { availableWidth: a }), this.firebolt().attachPropagationListener(this.metaData()), r;
  }
  /**
   *
   *
   * @param {*} data
   *
   * @memberof SimpleLegend
   */
  getCriteriaFromData(t) {
    const i = this.fieldName();
    return this.metaData().getSchema()[0].type === "measure" ? {
      [i]: t.range
    } : {
      [i]: [t.rawVal]
    };
  }
  getRangeFromIdentifiers({ fields: t, entrySet: i }) {
    const A = this.data().reduce((s, o) => (s[o.id] = o, s), {});
    return t.reduce((s, o) => (s[o] = i.reduce((r, a) => (a in A && r.push(A[a].range), r), []), s), {});
  }
  setParentInfo(t) {
    this._canvasMount = t.canvasRoot;
  }
  dispose() {
    this.firebolt().dispose();
  }
  applyInteractionStyle(t, i) {
    const { className: n, style: A } = t, s = this.config().classPrefix, o = V(this.mount()).selectAll(`.${s}-legend-columns`).filter((r) => i.has(r.id)).selectAll("div");
    if (o.classed(n, t.apply), A)
      for (let r in A)
        o.style(r, A[r]);
  }
}
const Qc = {
  [zt]: {
    datasets: (e) => ({
      row: [1],
      column: e
    }),
    itemContainerMeasures: (e, t) => {
      const { iconSpaces: i, itemSpaces: n, labelSpaces: A } = e, {
        padding: s,
        buffer: o,
        item: {
          text: { orientation: r }
        },
        step: a
      } = t, l = n.reduce((h, u) => h + u.width + s + o[zt], 0).toString().concat("px"), c = r === Fn || r === tn ? n.reduce((h, u, d) => {
        const f = Math.max(
          A[d].width,
          i[d].width
        );
        return Math.max(h, f);
      }, 0) : A.reduce((h, u, d) => {
        const f = A[d].width + s + i[d].width + o[zt];
        return Math.max(h, f);
      }, 0), g = a ? c.toString().concat("px") : (h, u) => `${n[u].width + s + o[zt]}px`;
      return {
        row: {
          width: l,
          padding: "0px"
        },
        column: {
          width: g,
          padding: "0px"
        }
      };
    },
    getStepSpacesInfo: (e) => {
      const { maxItemSpaces: t, height: i } = e;
      return {
        iconHeight: i,
        iconWidth: t.width,
        stepPadding: {
          horizontal: !0,
          vertical: !1
        }
      };
    }
  },
  [Ze]: {
    datasets: (e) => ({
      row: e,
      column: (t) => [t]
    }),
    itemContainerMeasures: (e, t) => {
      const { iconSpaces: i, itemSpaces: n, labelSpaces: A } = e, {
        padding: s,
        buffer: o,
        item: {
          text: { orientation: r }
        }
      } = t;
      let a = r === Fn || r === tn ? n.reduce((l, c, g) => {
        const h = Math.max(
          A[g].width,
          i[g].width
        );
        return Math.max(l, h);
      }, 0) : A.reduce((l, c, g) => {
        const h = A[g].width + s + i[g].width + o[Ze];
        return Math.max(l, h);
      }, 0);
      return {
        row: {
          // width: `${width}px`,
          width: "100%",
          padding: `${s}px`
        },
        column: {
          width: `${a}px`,
          padding: "0px"
        }
      };
    },
    getStepSpacesInfo: (e) => {
      const { maxItemSpaces: t, width: i } = e;
      return {
        iconHeight: t.height,
        iconWidth: i,
        stepPadding: {
          horizontal: !1,
          vertical: !0
        }
      };
    }
  }
}, Vq = {
  [mi]: Qc[Ze],
  [Rn]: Qc[Ze],
  [Fn]: Qc[zt],
  [tn]: Qc[zt]
}, jq = {
  [mi]: wj,
  [Rn]: Dj,
  [Fn]: nl,
  [tn]: nl
}, qq = (e) => ({
  [mi]: e.reverse(),
  [Rn]: e.reverse(),
  [Fn]: e,
  [tn]: e
}), zq = {
  [mi]: [hs, Bc],
  [Rn]: [Bc, hs],
  [Fn]: [hs, Bc],
  [tn]: [Bc, hs]
}, Zq = {
  circle: (e) => e * e * Math.PI,
  square: (e) => e * e,
  cross: (e) => e * 2 * (e * 2) * 5,
  diamond: (e) => e,
  star: (e) => {
    var t = 0.8908130915292852;
    return e * e / t;
  },
  triangle: (e) => e,
  wye: (e) => {
    var t = 1 / Math.sqrt(12), i = (t / 2 + 1) * 3;
    return e * e * i;
  }
}, fB = (e, t, i, n = null, A = 0, s) => {
  if (!n) {
    const r = V(e.mount()), a = parseFloat(r.style("width")), l = parseFloat(
      Ng(
        r.select(`.${t}-legend-title`),
        "width"
      ) || 0
    );
    n = a - l, parseFloat(s.row.width) > n && i.length > 4 && (n -= CI);
  }
  const o = i.length >= 4 ? Yj : 100 / i.length;
  return n * o / 100 - A;
};
function $q(e, t, i) {
  const { classPrefix: n } = e.config(), A = parseFloat(
    V(e.mount()).style("width")
  ), { itemSpaces: s } = e.measurement();
  let o = 0;
  const r = i.select(`.${n}-legend-title`);
  r.node() && (o = parseFloat(r.style("width")));
  let a = A - o;
  a -= CI;
  const l = fB(
    e,
    n,
    s,
    a,
    0,
    t
  ), { optimizedItemSpaces: c, rowWidth: g } = Xq(e, s, l);
  if (g <= a)
    return null;
  const h = [
    {
      type: "previous",
      icon: b3
    },
    {
      type: "next",
      icon: _3
    }
  ], u = j(
    i,
    "div",
    [1],
    `${n}-legend-pagination-container`
  );
  u.style("width", `${CI}px`).style("height", "16px").style("display", "flex").style("flex-direction", "row").style("align-items", "center");
  const d = j(
    u,
    "div",
    h,
    `${n}${qj}`
  );
  d.each(function(E) {
    V(this).classed(E.type, !0);
  }), d.style("flex", "1").style("height", "100%").style("display", "flex").style("flex-direction", "row").style("justify-content", "center").style("align-items", "center").style("cursor", "pointer"), j(
    d,
    "img",
    (E) => [E.icon],
    `${n}-legend-pagination-icon`
  ).attr("src", (E) => E);
  const I = t7(
    e,
    c,
    a
  );
  let C = 0;
  return d.on("click", (E) => {
    const { type: B } = E;
    let m = C;
    B === "previous" ? m = Math.max(C - 1, 0) : m = Math.min(C + 1, I.length - 1), C !== m && i7(e, I[m], c, i), C = m;
  }), {
    opimizedRowWidth: g,
    firstPage: I[0]
  };
}
function Xq(e, t, i) {
  const { buffer: n, padding: A } = e.config();
  let s = 0;
  return {
    optimizedItemSpaces: t.map((r) => {
      const a = s, l = r.width + n[zt] + A, c = l < i ? l : i;
      return s += c, {
        width: l,
        height: r.height,
        position: a,
        actualWidth: c
      };
    }),
    rowWidth: s
  };
}
function t7(e, t, i) {
  const n = [];
  let A = -1, s = {
    start: -1,
    end: -1
  };
  const { scaleType: o, as: r } = kn(e.scale());
  for (; !(s.end + 1 >= t.length); ) {
    A++;
    const l = e7(
      e,
      t,
      A,
      s,
      i,
      o,
      r
    );
    n.push(l), s = l;
  }
  return n;
}
function e7(e, t, i, n, A, s, o) {
  const r = n.end + 1;
  let a = r;
  const l = t[r].position, c = l + A, g = s === di && o === ph ? "width" : "actualWidth";
  for (let u = r; u < t.length; u++) {
    const d = t[u], f = d.position, I = f + d[g];
    if (!(f >= l && I <= c))
      break;
    a = u;
  }
  return {
    start: r,
    end: a
  };
}
function i7(e, t, i, n) {
  const { classPrefix: A } = e.config(), s = n.selectAll(`.${A}-legend-overflow`);
  s.selectAll(`.${A}-legend-columns`).each(function(a, l) {
    n7(t, l) ? V(this).style("visibility", "visible") : V(this).style("visibility", "hidden");
  });
  const r = i[t.start].position;
  s.style("margin-left", `-${r}px`);
}
function n7(e, t) {
  return t >= e.start && t <= e.end;
}
const A7 = (e, t, i, n, A) => {
  const { classPrefix: s, align: o } = t.config(), { itemSpaces: r } = t.measurement(), { scaleType: a, as: l } = kn(t.scale()), c = j(
    e,
    "div",
    i.row,
    `${s}-legend-row`
  );
  c.style(Be, (h, u) => `${r[u].height}px`), c.style(
    Ge,
    A && !(a === di && l === ph) ? A.opimizedRowWidth.toString().concat("px") : n.row.width
  ), c.style(wN, n.row.padding);
  const g = j(
    c,
    "div",
    i.column,
    `${s}-legend-columns`
  );
  return o === Ze ? g.style("width", "100%").style("display", "flex").style("flex-direction", "row").style("align-items", "center") : (g.style("width", n.column.width).style("padding", n.column.padding).style("display", "flex").style("flex-direction", "row").style("align-items", "center"), A && g.style(_j, (h, u) => u <= A.firstPage.end ? "visible" : "hidden"), a === di && l === ph || g.style(
    xN,
    `${fB(
      t,
      s,
      r,
      null,
      0,
      n
    )}px`
  )), g;
}, s7 = (e, t, i, n) => {
  const A = e.measurement(), { align: s } = e.config();
  let o = j(
    t,
    "div",
    [1],
    `${i}-legend-body`
  );
  s === Ze ? o.style("width", "100%").style("height", "auto").style("flex", "1").style("overflow-x", "hidden").style("overflow-y", "auto") : o.style("height", "100%").style("flex", "1").style("overflow", "hidden").style("margin", "auto 0"), o.select(`.${i}-legend-overflow`).remove();
  const r = e.config(), a = Vq[r.position], l = a.datasets(n), c = a.itemContainerMeasures(
    A,
    r,
    e
  ), g = j(
    o,
    "div",
    [1],
    `${i}-legend-overflow`
  );
  s === Ze && g.style("width", "100%");
  let h;
  return s === zt && (g.style(Be, "100%"), g.style(Fj, kj), g.style(Tj, nl), h = $q(e, c, t)), { legendItem: A7(
    g,
    e,
    l,
    c,
    h
  ), measures: c };
}, o7 = (e, t) => {
  const { classPrefix: i, item: n } = e.config(), A = n.text.orientation, s = zq[A], o = j(
    t,
    "div",
    (a, l) => s.map((c) => [
      c,
      a[c],
      a.color,
      a.size,
      a.value,
      e.fieldName(),
      l,
      a.formattedValue
    ]),
    `${i}-legend-item-info`
  );
  o.each(function(a) {
    a[0] === hs && V(this).style("overflow", "hidden").style("flex", "1");
  });
  const r = jq[A];
  return o.classed(r, !0), { itemSkeleton: o };
}, W0 = (e, t, i, n) => {
  const { padding: A, labelSpaces: s, iconSpaces: o, maxIconWidth: r } = n.measurement(), { align: a } = n.config(), l = i ? -A * 2 : 0, c = n.scale().constructor.type();
  if (e[0] === hs)
    return `${s[e[6]][t]}px`;
  if (c === di) {
    if (t === "width" && a === Ze)
      return `${r}px`;
    if (t === "width" && a === zt)
      return `${e[3]}px`;
  }
  return `${o[e[6]][t] - l}px`;
}, r7 = (e) => !!(/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(e) && /[\dz]$/i.test(e) && e.length > 4), Ro = function(e, t, i, n) {
  const A = t, s = e[1] || i, o = mh[s] || mh[xj];
  let r = e[3] || o;
  const { scaleType: a } = kn(n.scale());
  if (a === di && s === fI && (r = r * 2), s instanceof Promise)
    s.then((l) => (e.shape = l, Ro(e, t, i, n)));
  else if (s instanceof Element) {
    let l = s.cloneNode(!0);
    if (l.nodeName.toLowerCase() === "img") {
      const g = l.src || l.href;
      l = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "image"
      ), l.setAttribute("href", g);
    }
    return V(l).attr("transform", `scale(${r / 100})`), V(A.node().appendChild(l));
  } else if (typeof s == "string") {
    let l;
    if (r7(s))
      l = s;
    else {
      const c = s ? Zq[s](r) : r;
      l = aq(s).size(c)();
    }
    return j(A, "path", (c) => [c]).attr(
      "d",
      l
    );
  }
  return e[1] = "circle", Ro(e, t, "circle", n);
}, a7 = (e, t, i, n, A) => {
  const { classPrefix: s, iconHeight: o, padding: r, color: a, iconWidth: l, align: c, scale: g } = n;
  let { maxIconWidth: h } = n;
  c === zt && (h = l + 2 * r);
  const u = j(
    t,
    "svg",
    (f) => [f],
    `${s}-legend-icon-svg`
  ).attr(Ge, h).attr(Be, o).style(Ge, `${Math.ceil(h)}px`).style(Be, `${o}px`), d = h / 2 - r;
  if (e !== Al) {
    const f = j(
      u,
      "g",
      [i[1]],
      `${s}-legend-icon`
    );
    if (g === Sj && (e === mc || e === fI)) {
      e = mc;
      const I = j(
        u,
        "g",
        [i[1]],
        `${s}-legend-icon-outline`
      );
      i[3] = mh[mc] - 2, Ro(i, f, e, A).attr("transform", `translate(${d} ${o / 2})`).attr("fill", i[2] || a).attr("stroke", i[2] || a), i[3] = mh[Mj], Ro(i, I, e, A).attr("transform", `translate(${d} ${o / 2})`).attr("fill", "transparent").attr("stroke", Qj);
    } else
      g === di && c === Ze && (e === mc || e === fI) ? Ro(i, f, e, A).attr("transform", `translate(0 ${o / 2})`).attr("fill", i[2] || a).attr("stroke", i[2] || a) : Ro(i, f, e, A).attr("transform", `translate(${d} ${o / 2})`).attr("fill", i[2] || a).attr("stroke", i[2] || a);
  } else
    j(u, Al, [i[1]], `${s}-legend-icon`).attr("x", 0).attr("y", 0).attr(Ge, h).attr(Be, o).attr("fill", i[2] || a);
}, l7 = (e, t, i, n) => {
  const A = e._labelManager, { item: s, classPrefix: o, shape: r, align: a } = e.config(), {
    maxIconWidth: l,
    padding: c,
    // margin,
    // border,
    maxItemSpaces: g,
    itemSpaces: h,
    iconSpaces: u
  } = e.measurement(), { width: d, height: f, color: I, className: C } = s.icon, E = s.text.orientation;
  A.useEllipsesOnOverflow(!0), li(t, {
    width: (x) => W0(x, Ge, !1, e),
    height: (x) => W0(x, Be, !1, e),
    "text-align": nl,
    padding: `${c}px`
  });
  const B = yN;
  A.setStyle(e._computedStyle);
  const m = bj[E] || mi;
  let y = 0;
  const { scaleType: D, as: Q } = kn(e.scale()), p = !(D === di && Q === ph);
  let w;
  p && a === zt && (w = fB(
    e,
    o,
    h,
    null,
    0,
    i
  )), t.each(function(x, S) {
    if (x[0] === hs) {
      const _ = x[7], M = Jx("span", this).classed(`${o}-legend-item-info-text`, !0).text(_);
      M.style("white-space", "nowrap"), M.style("overflow", "hidden"), M.style("text-overflow", "ellipsis"), M.style("line-height", `${g.height}px`);
      const k = V(this);
      k.style(`padding-${m}`, "0px"), a === zt ? (k.style(`margin-${m}`, `${B}px`), p && k.style(
        xN,
        `${w - u[y].width - B - c}px`
      )) : k.style(`margin-${m}`, "5px"), y++;
    } else {
      V(this).classed(`${o}-${C}`, !0), V(this).classed(`${o}-${C}-${S}`, !0);
      let _ = 2 * x[3] || d;
      e.scale().constructor.type() === di && (_ = x[3]), a7(
        r,
        V(this),
        x,
        {
          classPrefix: o,
          iconWidth: _,
          iconHeight: f,
          maxIconWidth: l,
          padding: c,
          color: I,
          align: a,
          scale: n
        },
        e
      );
    }
  });
};
class ii extends Ll {
  constructor(...t) {
    super(...t);
  }
  /**
   * Initializes an instance of the class
   *
   * @static
   * @param {Object} dependencies Set of dependencies required by the legend
   * @return {Instance} returns a new instance of Legend
   * @memberof Legend
   */
  static create(...t) {
    return new ii(...t);
  }
  /**
   *
   *
   * @static
   *
   * @memberof DiscreteLegend
   */
  static type() {
    return hB;
  }
  /**
   *
   *
   * @param {*} scale
   *
   * @memberof DiscreteLegend
   */
  dataFromScale() {
    const { MEASURE: t } = J.FieldType, { TEMPORAL: i } = J.FieldSubtype, n = this.scale(), { scaleType: A, domain: s, scaleFn: o, steps: r, as: a } = kn(n), l = this.fieldName(), c = this.metaData().getField(l), { type: g, subtype: h } = c.schema();
    let u = [];
    const d = this.config();
    if (a === lt.DISCRETE)
      u = [...new Set(s)];
    else if (A === di && g === t)
      u = Array.isArray(r) ? r : Sr(s, s.length);
    else if (h === i) {
      u = [...new Set(c.data())];
      const I = u.find((C) => J.isInvalid(C));
      u = [
        ...u.filter((C) => !J.isInvalid(C))
      ], I && u.push(I);
    } else
      u = [...new Set(s)];
    const f = u.length;
    if (u = u.map((I, C) => {
      let E = 0, B = 0;
      const m = u[C];
      if (g === t) {
        E = parseFloat(u[C], 10);
        const y = parseInt(
          u[C + 1] ? u[C + 1] : u[C],
          10
        );
        B = [Math.floor(E), C === f - 1 ? y : y - 1], Number.isInteger(E) || (E = new Number(E).toFixed(2));
      } else {
        let y = J.getActualValue(m);
        h === i ? (y = Vs(
          u[C],
          c.minimumConsecutiveDifference(),
          { useUTC: d.useUTC }
        ), E = y, B = [y]) : (E = y, B = [y]);
      }
      return {
        [A]: n[o](I),
        value: E,
        id: m,
        range: B,
        rawVal: m
      };
    }).filter((I) => I.value !== null), A === di)
      u = u.sort(
        (I, C) => I[A] - C[A]
      );
    else if (a === lt.CONTINUOUS)
      u = u.sort(
        (I, C) => FC("asc", I.rawVal, C.rawVal)
      );
    else if (a === lt.DISCRETE) {
      const C = n.sortValues(
        u.map((E) => E.rawVal)
      ).reduce((E, B, m) => (E.set(B, m), E), /* @__PURE__ */ new Map());
      u = u.sort((E, B) => {
        const m = C.get(E.rawVal), y = C.get(B.rawVal);
        return m - y;
      });
    }
    return this.calculateFormattedValue(u);
  }
  setLegendMeasures() {
    super.setLegendMeasures();
    const { itemSpaces: t, padding: i, maxIconWidth: n, width: A, labelSpaces: s } = this.measurement(), o = this.getTitleSpace(), { align: r, item: a } = this.config(), l = i * 2, { scaleType: c } = kn(this.scale()), g = this._labelManager;
    let h = {};
    if (r === Ze) {
      const u = t.reduce((C, E) => C + E.height, 0), d = o.height > 0 ? o.height + l + 5 : 0, f = u + d;
      let I = g.getOriSize(
        Vj
      ).width;
      if (I = Math.min(o.width, I), h = {
        ...h,
        height: f,
        maxHeight: f,
        minHeight: SN
      }, c === di) {
        let C = A - n / 2;
        C = Math.max(I, C), h = {
          ...h,
          maxIconWidth: n / 2,
          width: C
        };
      } else {
        const C = g.getOriSize(
          Wj
        ).width, E = g.getOriSize(
          Kj
        ).width, B = s.reduce((Q, p) => Math.max(Q, p.width), Number.MIN_VALUE) + jj, m = a.icon.width + yN;
        let y = Math.min(B, C);
        y = Math.max(y, E);
        let D = y + m + Jj + eg;
        D = Math.max(I, D), h = {
          ...h,
          width: D,
          maxWidth: D,
          minWidth: D
        };
      }
    } else {
      const u = Oj;
      if (h = {
        ...h,
        height: u,
        maxHeight: u,
        minHeight: u
      }, c === di) {
        const d = this.data().map((f, I) => {
          const C = f.size, { width: E } = g.getOriSize(
            f.formattedValue
          );
          return {
            width: C + E,
            height: t[I].height
          };
        });
        h = {
          ...h,
          itemSpaces: d
        };
      }
    }
    return this.measurement(h), this;
  }
  calculateFormattedValue(t) {
    const { formatter: i } = this.config().item.text;
    return t.map((n, A) => {
      const s = Ei(n.value);
      return n.formattedValue = i(
        {
          formattedValue: s,
          rawValue: n.rawVal
        },
        {
          context: this,
          itemMeta: n,
          itemIndex: A,
          allItems: t,
          dataModel: this.metaData()
        }
      ), n;
    });
  }
  /**
   * Render the legend with its title
   *
   * @param {DOM} mountPoint Point where the legend and title are to be appended
   * @return {Instance} Current instance of legend
   * @memberof Legend
   */
  render() {
    this.emitSelfHooks(gt.BEFORE_RENDERED);
    const t = eA(), i = this.firebolt(), n = this.data(), A = this.scale().constructor.type(), { classPrefix: s, align: o, title: r } = this.config(), a = super.render(this.mount()), { legendItem: l, measures: c } = s7(
      this,
      a,
      s,
      n
    ), { itemSkeleton: g } = o7(this, l);
    if (l7(this, g, c, A), a.selectAll("div").filter(
      (h, u, d) => !d[u].classList.contains(`${s}-legend-body`)
    ).classed($j, !0), o === zt && r.show) {
      const h = parseFloat(
        Ng(
          a.select(`.${s}-legend-title`),
          "width"
        ) || 0
      ), u = parseFloat(
        Ng(
          a.select(`.${s}-legend-row`),
          "width"
        ) || 0
      ), d = parseFloat(
        V(this.mount()).style("width")
      );
      if (d - (h + u) > 0) {
        const { border: f, padding: I } = this.measurement();
        fq(this, this.title(), this.config(), {
          border: f,
          padding: I,
          totalAvailableSpaceForTitle: d - u
        });
      }
    }
    return i.mapActionsAndBehaviour(), this.emitSelfHooks(gt.AFTER_RENDERED), t.onAllCallbacksCalled().then(() => {
      this.emitSelfHooks(gt.ANIMATION_END);
    }), i.applyExistingInteractions(), a;
  }
  createFireboltSelectionSet({ data: t, prevData: i }) {
    const n = this.firebolt(), A = i ? i.map((o) => o.rawVal) : [], s = t.map((o) => o.rawVal);
    !Is("Array")(s, A) && n.createSelectionSet({
      keys: s
    });
  }
}
class sl extends Ll {
  constructor(...t) {
    super(...t);
  }
  /**
   * Initializes an instance of the class
   *
   * @static
   * @param {Object} dependencies Set of dependencies required by the legend
   * @return {Instance} returns a new instance of Legend
   * @memberof Legend
   */
  static create(...t) {
    return new sl(...t);
  }
  /**
   *
   *
   * @static
   *
   * @memberof GradientLegend
   */
  static type() {
    return Qh;
  }
  /**
   *
   *
   * @param {*} axis
   *
   * @memberof GradientLegend
   */
  axis(...t) {
    return t.length ? (this._axis = t[0], this) : this._axis;
  }
  setLegendMeasures() {
    super.setLegendMeasures();
    const { align: t } = this.config();
    if (t === "vertical") {
      const i = U0, n = II;
      this.measurement({
        width: i,
        height: n,
        maxWidth: i,
        maxHeight: n,
        minWidth: i,
        minHeight: n
      });
    } else {
      const i = U0, n = Gj;
      this.measurement({
        width: i,
        height: n,
        maxWidth: i,
        maxHeight: n,
        minWidth: i,
        minHeight: n
      });
    }
    return this;
  }
  /**
   *
   *
   * @param {*} scale
   *
   * @memberof GradientLegend
   */
  dataFromScale() {
    let t = [];
    const i = this.scale(), n = this.config(), A = this.metaData().getField(this.fieldName()), { subtype: s } = A.schema(), { scaleType: o, domain: r, steps: a, scaleFn: l } = kn(i), c = {
      smartLabel: this.labelManager(),
      measures: this.measurement(),
      alignment: this.config().position,
      minTickDistance: this.minTickDistance()
    };
    Array.isArray(n.domain) && n.domain.length >= 2 ? t = n.domain.map((h) => h) : Array.isArray(a) ? (r[0] < a[0] && (t[0] = r[0]), t = [...t, ...a], r[r.length - 1] > a[a.length - 1] && t.push(r[1]), t = [...new Set(t)].sort((h, u) => h - u), t = hq(t, c)) : t = uq(r, a - 1, c);
    const g = /* @__PURE__ */ new Set();
    return t = t.map((h, u) => {
      const d = t[u];
      return {
        [o]: o === di ? i[l](h) * i.getScaleFactor() : i[l](h),
        value: s === J.FieldSubtype.TEMPORAL ? d : +d.toFixed(1),
        id: u
      };
    }).filter((h) => h.value === null || g.has(h.value) ? !1 : (g.add(h.value), !0)).sort((h, u) => h.value - u.value), this.firebolt().createSelectionSet({
      keys: this.data().map((h) => h.id)
    }), t;
  }
  /**
   *
   *
   * @param {*} effPadding
   * @param {*} align
   *
   * @memberof Legend
   */
  getLabelSpaces(t) {
    this.config({
      item: {
        text: {
          orientation: this.config().position
        }
      }
    });
    const { subtype: i } = this.metaData().getField(this.fieldName()).schema();
    let n = [];
    const A = us.size + us.BUFFER, s = Sq(this);
    if (i === J.FieldSubtype.TEMPORAL)
      n = s.source().axisDimensions().allTickDimensions || [];
    else {
      const o = s.getLogicalSpace(), r = {
        width: o.width - t,
        height: o.height - t
      }, a = s.source().domain().length;
      n = new Array(a).fill(r);
    }
    return n = n.map((o) => ({
      width: o.width + A,
      height: o.height
    })), this.axis(s), n;
  }
  /**
   *
   *
   *
   * @memberof GradientLegend
   */
  getDrawingContext() {
    return {
      svgContainer: this._legendGradientSvg
    };
  }
  /**
   * Render the legend with its title
   *
   * @param {DOM} mountPoint Point where the legend and title are to be appended
   * @return {Instance} Current instance of legend
   * @memberof Legend
   */
  render() {
    this.emitSelfHooks(gt.BEFORE_RENDERED);
    const t = eA(), { classPrefix: i } = this.config(), n = this.firebolt(), A = super.render(this.mount());
    return bq(this, A), A.selectAll("div").style("float", mi), A.selectAll(`.${i}-legend-body`).style("display", "flex").style("float", "none").style("flex-direction", "column").style("width", "100%").style("flex", "1").style("overflow", "hidden"), n.mapActionsAndBehaviour(), n.mapSideEffects({
      [Gu]: [lB]
    }), n.applyExistingInteractions(), this.emitSelfHooks(gt.AFTER_RENDERED), t.onAllCallbacksCalled().then(() => {
      this.emitSelfHooks(gt.ANIMATION_END);
    }), A;
  }
  createFireboltSelectionSet({ data: t, prevData: i }) {
    const n = this.firebolt(), A = i ? i.map((o) => o.id) : [], s = t.map((o) => o.id);
    !Is("Array")(s, A) && n.createSelectionSet({
      keys: s
    });
  }
  /**
   *
   *
   * @param {*} data
   *
   * @memberof SimpleLegend
   */
  getCriteriaFromData(t) {
    return [[this.fieldName()], [t.value]];
  }
  getRangeFromIdentifiers({ fields: t, criteria: i }) {
    return t.reduce((n, A) => (n[A] = i[A], n), {});
  }
}
const c7 = (e) => {
  const t = e.fieldName(), i = e.metaData(), { subtype: n } = i.getField(t).schema(), A = e.axis().source(), { _tickFormatter: s } = A, o = A.domain();
  let r = [o[0], o[1]];
  n === J.FieldSubtype.TEMPORAL && (r = r.map((c) => /* @__PURE__ */ new Date(+c)));
  const a = s(r);
  return r.map((c) => a(c));
}, g7 = (e, t, i, n, A, s, o, r) => {
  let { height: a } = A.icon, l = j(
    e,
    "div",
    [1],
    `${t}-legend-body`
  );
  l.style(wN, `${s}px`).style(Nj, "5px 0");
  let c, g, h, u;
  return i === Ls.HORIZONTAL ? (l.style("flex", "1"), c = j(
    l,
    "div",
    [1],
    `${t}-step-legend-ticks`
  ).style("justify-content", "space-between"), g = j(
    c,
    "div",
    [1],
    `${t}-step-first-tick`
  ), g.text(o[0]), g.style("padding", `${Fo}px`).style("max-width", `${r}px`), g.classed(`${t}-step-legend-ticks-h`, !0), h = j(
    c,
    "div",
    [1],
    `${t}-legend-steps-container`
  ), u = j(
    c,
    "div",
    [1],
    `${t}-step-second-tick`
  ), u.text(o[1]), u.style("padding", `${Fo}px`).style("max-width", `${r}px`), u.classed(`${t}-step-legend-ticks-h`, !0)) : (l.style("width", `${n}px`), h = j(
    l,
    "div",
    [1],
    `${t}-legend-steps-container`
  ), h.style("flex", "1"), h.style("display", "flex"), c = j(
    l,
    "div",
    [1],
    `${t}-step-legend-ticks`
  ), c.style("justify-content", "space-between"), g = j(
    c,
    "div",
    [1],
    `${t}-step-first-tick`
  ), g.text(o[0]), g.style("padding-top", `${Fo}px`), g.classed(`${t}-step-legend-ticks-v`, !0), u = j(
    c,
    "div",
    [1],
    `${t}-step-second-tick`
  ), u.text(o[1]), u.style("padding-top", `${Fo}px`), u.classed(`${t}-step-legend-ticks-v`, !0)), c.style("display", "flex"), c.style("align-items", "center"), h.style("position", "relative"), j(
    h,
    "div",
    [1],
    `${t}-legend-svg-container`
  ).style(Be, `${a}px`);
}, h7 = (e, t, i, n, A, s) => {
  let { height: o, color: r } = s.icon;
  const a = n / i.length, l = j(
    t,
    "svg",
    [1],
    `${A}-step-legend-icon-svg`
  ).attr(Ge, Math.ceil(n)).attr(Be, o).style(Ge, `${Math.ceil(n)}px`).style(Be, `${o}px`), c = j(
    l,
    "g",
    [1],
    `${A}-step-legend-icon-group`
  );
  j(
    c,
    Al,
    i,
    `${A}-step-legend-icon`
  ).attr("x", (h, u) => u * a).attr("y", 0).attr(Ge, a).attr(Be, o).attr("fill", (h) => h.color || r), e._stepLegendSvg = l;
}, u7 = (e, t, i, n, A, s, o, r, a) => {
  if (r === Ls.VERTICAL)
    return {
      availableWidth: Math.min(t, i) - (s + n + 2 * A)
    };
  {
    const l = V(e.mount()), c = parseFloat(l.style("width")), g = parseFloat(
      l.select(`.${a}-legend-title`).style("width")
    ), h = c - g, u = h * tq, d = e._labelManager, f = Math.min(
      d.getOriSize(o[0]).width,
      u
    ), I = Math.min(
      d.getOriSize(o[1]).width,
      u
    );
    return {
      availableWidth: h - f - I - 4 * Fo,
      maxTickWidth: u + 2 * Fo
    };
  }
}, d7 = (e, t) => {
  const { classPrefix: i, position: n, align: A, item: s } = e.config(), o = qq(e.data())[n] ?? [], { width: r, maxWidth: a, padding: l, paddingRight: c, border: g } = e.measurement(), h = c7(e), { availableWidth: u, maxTickWidth: d } = u7(
    e,
    r,
    a,
    c,
    g,
    l,
    h,
    A,
    i
  ), f = g7(
    t,
    i,
    A,
    u,
    s,
    l,
    h,
    d
  );
  h7(
    e,
    f,
    o,
    u,
    i,
    s
  );
};
function f7(e, t, i) {
  const { subtype: n } = t.schema();
  let A;
  return n === J.FieldSubtype.TEMPORAL ? A = Vs(
    e,
    t.minimumConsecutiveDifference(),
    {
      useUTC: i.useUTC,
      useShortFormatter: i.useShortFormatter
    }
  ) : A = e, Ei(A);
}
const I7 = (e) => {
  const t = e.fieldName(), i = e.metaData(), { subtype: n } = i.getField(t).schema(), A = e.data(), { useUTC: s } = e.config(), o = e._cells.AxisCell, { domain: r, stops: a } = e.config(), l = !!(Array.isArray(a) && a.length), c = !l && !!(Array.isArray(r) && r.length), g = n === J.FieldSubtype.TEMPORAL ? kr : $i, h = new g(
    {
      id: `legend-${e._id}`,
      // orientation:  align === ALIGN.VERTICAL ? BOTTOM : LEFT,
      // The ticks are at bottom for vertical step legend
      orientation: tn,
      style: e._computedStyle,
      nice: !(c || l || n === ig),
      showAxisName: !1,
      tickSize: 0,
      fixedBaseline: !1,
      labels: {
        rotation: null
      },
      tickFormat: (u, d) => {
        const f = e.metaData(), I = e.fieldName(), C = f.getField(I), E = f7(
          u.rawValue,
          C,
          {
            useUTC: e.config().useUTC,
            useShortFormatter: !0
          }
        );
        return e.config().item.text.formatter(
          {
            formattedValue: E,
            rawValue: u.rawValue
          },
          {
            context: e,
            itemMeta: {},
            itemIndex: d.tickIndex,
            allItems: d.allRawTicks,
            dataModel: e.metaData()
          }
        );
      },
      useUTC: s,
      transition: e.config().transition
    },
    { labelManager: e._labelManager }
  );
  if (c)
    h.domain(r);
  else {
    let u;
    A && A.length ? u = [A[0]?.range?.[0], A[A.length - 1]?.range?.[1]] : u = [], h.domain(u);
  }
  return n === J.FieldSubtype.TEMPORAL ? (h.minDiff(
    i.getField(t).minimumConsecutiveDifference()
  ), h.logicalSpace(fE(h, !0)), Dl(h)) : h.range([1, 1]), new o().source(h).config({
    margin: { left: 0, bottom: 0, top: 0, right: 0 }
  });
};
class yh extends Ll {
  constructor(...t) {
    super(...t);
  }
  /**
   * Initializes an instance of the class
   *
   * @static
   * @param {Object} dependencies Set of dependencies required by the legend
   * @return {Instance} returns a new instance of Legend
   * @memberof Legend
   */
  static create(...t) {
    return new yh(...t);
  }
  /**
   *
   *
   * @static
   *
   * @memberof StepLegend
   */
  static type() {
    return gB;
  }
  /**
   *
   *
   * @static
   *
   * @memberof StepLegend
   */
  static defaultConfig() {
    return rq;
  }
  /**
   * function to recalculate steps on providing more number of stops than canvas can accomodate.
   * @param  {Array} domain - Array
   * @param  {Array} steps - Array
   * @param  {Array} range - range from scale
   * @return {Array} - recalculated Step Array
   */
  getInterpolatedData(t, i, n) {
    if (i instanceof Array)
      return i;
    const { domain: A, stops: s } = this.config(), o = !!(Array.isArray(s) && s.length), r = !o && !!(Array.isArray(A) && A.length);
    return Sr(
      t,
      i,
      !0,
      n,
      !(o || r)
    );
  }
  /**
   *
   *
   * @param {*} scale
   *
   * @memberof StepLegend
   */
  dataFromScale() {
    let t = [];
    const i = this.scale(), { scaleType: n, domain: A, steps: s, scaleFn: o } = kn(i), r = this.metaData().getField(this.fieldName()), { subtype: a } = r.schema(), l = this.config(), c = i.getScaleRange();
    Array.isArray(l.stops) && l.stops.length >= 2 ? t = l.stops.map((u) => u) : Array.isArray(s) && a !== ig ? (A[0] < s[0] && (t[0] = A[0]), t = [...t, ...s], A[A.length - 1] > s[s.length - 1] && t.push(A[1]), t = [...new Set(t)].sort((u, d) => u - d)) : a === ig && !s ? t = _C(A, r.getAllBins()) : (t = this.getInterpolatedData(A, s, c), t = [...new Set(t)].sort((u, d) => u - d)), t.length === 1 && t.push(J.createInvalid(a)), t = [...new Set(t)].sort((u, d) => u - d);
    const h = [];
    for (let u = 0; u < t.length - 1; u++) {
      let d = t[u];
      const f = d, I = t[u + 1];
      let C = [f, I];
      if (a === ig && !s && I - f > r._schema.binSize) {
        const B = f + r._schema.binSize;
        C = [f, B];
      }
      const E = C.map((B) => a === J.FieldSubtype.TEMPORAL ? Vs(B, r.minimumConsecutiveDifference(), {
        useUTC: l.useUTC
      }) : `${+Number(B).toFixed(1)}`).join(Rg);
      h.push({
        [n]: n === di ? i[o](d) * i.getScaleFactor() : i[o](d),
        value: E,
        id: u + 1,
        range: C
      });
    }
    return this.calculateFormattedValue(h);
  }
  calculateFormattedValue(t) {
    const { formatter: i } = this.config().item.text;
    return t.map((n, A) => {
      const s = Ei(n.value);
      return n.formattedValue = i(
        {
          formattedValue: s,
          rawValue: n.range
        },
        {
          context: this,
          itemMeta: n,
          itemIndex: A,
          allItems: t,
          dataModel: this.metaData()
        }
      ), n;
    });
  }
  /**
   *
   *
   * @param {*} effPadding
   * @param {*} align
   *
   * @memberof Legend
   */
  getLabelSpaces() {
    return this.config({
      item: {
        text: {
          orientation: this.config().position
        }
      }
    }), MN(this);
  }
  setLegendMeasures() {
    super.setLegendMeasures();
    const { align: t } = this.config();
    if (t === "vertical") {
      const i = O0, n = vj;
      this.measurement({
        width: i,
        height: n,
        maxWidth: i,
        maxHeight: n,
        minWidth: i,
        minHeight: n
      });
    } else {
      const i = O0, n = Lj;
      this.measurement({
        width: i,
        height: n,
        maxWidth: i,
        maxHeight: n,
        minWidth: i,
        minHeight: n
      });
    }
    return this;
  }
  /**
   *
   *
   *
   * @memberof Legend
   */
  elemType() {
    return Al;
  }
  axis(...t) {
    return t.length ? (this._axis = t[0], this) : this._axis;
  }
  getDrawingContext() {
    return {
      svgContainer: this._stepLegendSvg
    };
  }
  /**
   * Render the legend with its title
   *
   * @param {DOM} mountPoint Point where the legend and title are to be appended
   * @return {Instance} Current instance of legend
   * @memberof Legend
   */
  render() {
    this.emitSelfHooks(gt.BEFORE_RENDERED);
    const t = eA(), i = this.firebolt(), n = super.render(this.mount());
    return this.axis(I7(this)), d7(this, n), this.axis().source().domain(this.scale().domain()), i.mapActionsAndBehaviour(), i.mapSideEffects({
      [Gu]: [lB]
    }), this.emitSelfHooks(gt.AFTER_RENDERED), t.onAllCallbacksCalled().then(() => {
      this.emitSelfHooks(gt.ANIMATION_END);
    }), i.applyExistingInteractions(), n;
  }
  createFireboltSelectionSet({ data: t, prevData: i }) {
    const n = this.firebolt(), A = i ? i.map((o) => o.id) : [], s = t.map((o) => o.id);
    !Is("Array")(s, A) && n.createSelectionSet({
      keys: s
    });
  }
  getCriteriaFromData(t) {
    return {
      [this.fieldName()]: t.range
    };
  }
}
const ol = "rows", rl = "columns", NN = "data", Kn = "color", ko = "backgroundColor", Ss = "shape", Wn = "size", FN = "detail", RN = "layers", kN = "transform", Ii = "width", Ci = "height", TN = "padding", vN = "border", GN = "margin", C7 = "config", EI = "legend", IB = "topLegend", CB = "bottomLegend", EB = "leftLegend", BB = "rightLegend", je = "title", un = "subtitle", al = "columnHeader", jA = "linear", cA = "ordinal", ds = "muze", pc = "show", E7 = ["script", "style"], V0 = {
  SQUARE: "square",
  CIRCLE: "circle"
}, B7 = {
  true: V0.CIRCLE,
  false: V0.SQUARE
}, m7 = {
  [`${cA}-${!0}-${Kn}`]: ii,
  [`${cA}-${!0}-${ko}`]: ii,
  [`${cA}-${!0}-${Wn}`]: ii,
  [`${cA}-${!0}-${Ss}`]: ii,
  [`${cA}-${!1}-${Kn}`]: ii,
  [`${cA}-${!1}-${ko}`]: ii,
  [`${cA}-${!1}-${Ss}`]: ii,
  [`${cA}-${!1}-${Wn}`]: ii,
  [`${jA}-${!1}-${Wn}`]: ii,
  [`${jA}-${!0}-${Wn}`]: ii,
  [`${jA}-${!1}-${Ss}`]: ii,
  [`${jA}-${!0}-${Kn}`]: yh,
  [`${jA}-${!0}-${ko}`]: yh,
  [`${jA}-${!1}-${Kn}`]: sl,
  [`${jA}-${!1}-${ko}`]: sl
}, Me = "left", Tn = "right", mA = "bottom", Q7 = "center", se = "top", yc = "group", j0 = "layout", p7 = "retinal", ll = "vertical", Qr = "horizontal", y7 = "h-center", D7 = "extended-h-center", q0 = "extended-v-center", z0 = "hidden", Hd = "overflow", Z0 = "auto", w7 = "visible", LN = "verticalScrollBar", UN = "horizontalScrollBar", pr = "grid", x7 = "point", Dh = "message", S7 = "Insufficient data or incorrect configurations", ON = "area", HN = "line", M7 = (...e) => new ah(...e.map((t) => new XE(t)));
function PN(e) {
  if (e.nodeType === Node.ELEMENT_NODE)
    if (E7.indexOf(e.tagName.toLowerCase()) !== -1)
      e.parentNode.removeChild(e);
    else
      for (const t of e.childNodes)
        PN(t);
}
function _7(e, ...t) {
  let i = "";
  const n = t.length;
  let A = 0;
  for (; A < n; ++A)
    i += e[A] + t[A];
  i += e[A];
  const s = document.createDocumentFragment(), o = document.createElement("div");
  s.appendChild(o), o.innerHTML = i, PN(o);
  const { innerHTML: r } = o;
  return () => r;
}
const b7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  html: _7,
  share: M7
}, Symbol.toStringTag, { value: "Module" })), $0 = {
  // Action on source canvas
  highlight: {
    // Action on target canvas
    highlight: {
      sideEffects: {
        "plot-highlighter": {
          rules: [
            {
              target: "exitSet",
              style: {
                fill: {
                  a: -0.3
                }
              }
            }
          ]
        }
      }
    }
  },
  select: {
    filter: {
      sideEffects: ["filter"]
    }
  }
}, N7 = (e) => {
  let t = e;
  return Array.isArray(e) && (t = e.reduce((i, n) => {
    let A;
    return typeof n == "string" ? (A = n, i[A] = {}) : (A = n.name, i[A] = n), i;
  }, {})), t;
}, F7 = (e) => {
  let t = {};
  for (let i in $0) {
    t[i] = {
      target: {}
    };
    const n = $0[i];
    e.forEach((A) => {
      t[i].target[A.alias()] = n;
    });
  }
  return t;
}, R7 = (e, t) => {
  const i = zw({}, t, e);
  for (let n in i) {
    const { target: A } = i[n];
    for (let s in A) {
      const o = A[s];
      for (let r in o)
        o[r].sideEffects = N7(
          o[r].sideEffects
        );
    }
  }
  return i;
}, k7 = (e) => {
  const t = e.map((i) => i.alias());
  return {
    behaviours: {
      "*": (i) => i.canvasId ? t.indexOf(i.canvasId) !== -1 : !0
    },
    sideEffects: {
      "*": (i) => i.canvasId ? t.indexOf(i.canvasId) !== -1 : !0
    }
  };
}, fo = (e) => {
  const t = {};
  for (const i in e) {
    const n = e[i];
    t[n.formalName()] = n;
  }
  return t;
};
class T7 {
  constructor() {
    this._registrableComponents = [], this._registry = {
      visualGroup: {
        behaviours: {
          ...fo(OE),
          [jp.formalName()]: jp
        },
        physicalActions: $M,
        sideEffects: fo(WE),
        behaviourEffectMap: {},
        physicalBehaviouralMap: sW
      },
      legend: {
        behaviours: {
          ...fo(Aa.behaviours)
        },
        physicalActions: Aa.physicalActions,
        sideEffects: fo(Aa.sideEffects),
        behaviourEffectMap: Aa.behaviourEffectMap,
        physicalBehaviouralMap: Aa.physicalBehaviouralMap
      }
    };
  }
  /**
   * Takes an array of canvases on which the physical and behavioural actions will get registered.
   *
   * @public
   * @param  {Canvas} components Array of canvases
   *
   * @return {ActionModel} Instance of action model.
   */
  for(...t) {
    return this._registrableComponents = t, this._registrableComponents.forEach((i) => {
      i.once("afterDisposed", () => {
        this._registrableComponents = this._registrableComponents.filter(
          (n) => n !== i
        );
      });
    }), this;
  }
  /**
   * Registers physical actions on the canvases. It takes an object with key as the name of action and value having
   * the definition of the action.
   *
   * To register a {@link PhysicalAction},
   * ```
   *  const ActionModel = muze.ActionModel;
   *  ActionModel
   *       // Physical actions will be registered on these canvases.
   *      .for(canvas)
   *      .registerPhysicalActions({
   *          // Key is the name of physical action.
   *          ctrlClick: (firebolt) => (targetEl, behaviours) => {
   *              targetEl.on('click', function (data) {
   *                  const event = utils.getEvent();
   *                  const pos = utils.getClientPoint(event, this);
   *                  // Get the data point nearest to the mouse position.
   *                  const nearestPoint = firebolt.context.getNearestPoint(pos, {
   *                      data
   *                  });
   *                  // Prepare the payload
   *                  const payload = {
   *                      criteria: nearestPoint.id
   *                  };
   *                  behaviours.forEach((behaviour) => firebolt.dispatchBehaviour(behaviour, payload));
   *              });
   *          }
   *      });
   * ```
   * @public
   *
   * @param {Object} action Names of physical actions and their definitions.
   *
   * @return {ActionModel} Instance of the action model.
   */
  registerPhysicalActions(t) {
    return this._registrableComponents.forEach((n) => {
      n._registry.interactions.visualGroup.physicalActions.register(
        t
      );
    }), this;
  }
  /**
   * Registers behavioural actions on the canvases. It takes definitions of the behavioural actions and registers
   * them on the canvases. Every behavioural action must inherit the {@link GenericBehaviour} class.
   *
   * To register a behavioural action
   * ```
   *  // Define a new behavioural action
   *  class SingleSelectBehaviour extends GenericBehaviour {
   *      static formalName () {
   *          return 'singleSelect';
   *      }
   *
   *      setSelectionSet (addSet, selectionSet) {
   *          if (addSet === null) {
   *              selectionSet.reset();
   *          } else if (addSet.length) {
   *              const existingAddSet = selectionSet.getExistingEntrySet(addSet);
   *              if (existingAddSet.length){
   *                  selectionSet.reset();
   *              } else {
   *               selectionSet.add(addSet);
   *              }
   *          } else {
   *              selectionSet.reset();
   *          }
   *      }
   * }
   * muze.ActionModel.registerBehaviouralActions(SingleSelectBehaviour);
   * ```
   *
   * @public
   *
   * @param {GenericBehaviour} actions Definition of behavioural actions.
   *
   * @return {ActionModel} Instance of action model.
   */
  registerBehaviouralActions(...t) {
    return this._registrableComponents.forEach((n) => {
      n._registry.interactions.visualGroup.behaviours.register(
        fo(t)
      );
    }), this;
  }
  /**
   * Registers the mapping of physical and behavioural actions. This mapping is used to establish which behavioural
   * actions should be dispatched on any triggering of physical actions.
   *
   * To map physical actions with behavioural actions,
   * ```
   *  muze.ActionModel.registerPhysicalBehaviouralMap({
   *      ctrlClick: {
   *          behaviours: ['select'] // This array must be the formal names of the behavioural actions.
   *      }
   *  });
   * ```
   *
   * @public
   * @param {Object} map Contains the physical and behavioural action map.
   * ```
   *   {
   *      // Name of the physical action
   *      click: {
   *          // Target element selector. This is an optional field. If not passed, then by default takes the
   *          // container element of visual unit.
   *          target: '.muze-layers-area path',
   *          // Behaviours which should be dispatched on triggering of the mapped physical action.
   *          behaviours: ['select']
   *      }
   *   }
   * ```
   *
   * @return {ActionModel} Instance of action model.
   */
  registerPhysicalBehaviouralMap(t, i = "visualGroup") {
    return this._registrableComponents.forEach((n) => {
      if (i === "legend") {
        const A = n._registry.interactions.legend.physicalBehaviouralMap.get();
        for (let s in t) {
          const o = A[s];
          o && (o.behaviours = [
            .../* @__PURE__ */ new Set([...o.behaviours, ...t[s].behaviours])
          ]);
        }
      } else
        n.firebolt().registerPhysicalBehaviouralMap(t);
    }), this;
  }
  /**
   * Registers what behaviour to propagate on dispatch of a certain behavioural action. By default, when any
   * behavioural action is dispatched, then the same behavioural action gets propagated to all the other canvases.
   * This can be changed using this api.
   *
   * To register what behaviour should be propagated on dispatch of any behavioural action,
   * ```
   *  ActionModel.for(canvas1, canvas2).registerPropagationBehaviourMap({
   *      select: 'filter',
   *      brush: 'filter'
   *  });
   * ```
   *
   * @public
   * @param {Object} map Propagation behaviour map.
   *
   * @return {ActionModel} Instance of action model.
   */
  registerPropagationBehaviourMap(t) {
    return this._registrableComponents.forEach(
      (i) => i.firebolt().registerPropagationBehaviourMap(t)
    ), this;
  }
  /**
   * Registers the mapping of side effects and behavioural actions. It takes an object which contains key as the
   * name of behavioural action and the side effects which will be linked to it.
   *
   * To map side effects to select behaviour,
   * ```
   *  muze.ActionModel.mapSideEffects({
   *      select: ['infoBox'] // This array must be the formal names of the side effects
   *  });
   * ```
   *
   * To map side effects to select behaviour, but disable all the default side effects attached with this behaviour,
   * ```
   *  muze.ActionModel.mapSideEffects({
   *      select: {
   *          effects: ['infoBox'],
   *          preventDefaultActions: true
   *      }
   *  });
   * @public
   * @param {Object} map Mapping of behavioural actions and side effects.
   * ```
   *     {
   *          select: ['infoBox']
   *     }
   * ```
   * @return {ActionModel} Instance of action model.
   */
  mapSideEffects(t) {
    return this._registrableComponents.forEach((i) => {
      i.firebolt().mapSideEffects(t);
    }), this;
  }
  registry() {
    return this._registry;
  }
  /**
   * Registers the side effects on the registered canvases. It takes definitions of side effects and registers them
   * on the canvases. Every side effect must inherit the base class {@link GenericSideEffect} or
   * {@link SpawnableSideEffect} or {@link SurrogateSideEffect} class.
   *
   * ```
   * // Define a custom side effect
   *  class InfoBox extends SpawnableSideEffect {
   *      static formalName () {
   *          return 'infoBox';
   *      }
   *
   *      apply (selectionSet) {
   *      }
   *  }
   *  muze.ActionModel.registerSideEffects(InfoBox);
   * ```
   * @public
   * @param  {GenericSideEffect} sideEffects Definition of side effects.
   *
   * @return {ActionModel} Instance of action model.
   */
  registerSideEffects(...t) {
    return this._registrableComponents.forEach((n) => {
      n._registry.interactions.visualGroup.sideEffects.register(
        fo(t)
      );
    }), this;
  }
  /**
   * Breaks the link between behavioural actions and physical actions. It takes an array of behavioural action
   * and it's physical action.
   *
   * To dissociate behavioural actions from physical actions
   * ```
   *  muze.ActionModel.dissociateBehaviour(['select', 'click'], ['highlight', 'hover']);
   * ```
   * @public
   * @param  {Array} maps Array of behavioural action and physical action.
   *
   * @return {ActionModel} Instance of action model.
   */
  dissociateBehaviour(...t) {
    return this._registrableComponents.forEach((i) => {
      t.forEach(([n, A, s]) => {
        if (s === "legend") {
          const r = i._registry.interactions.legend.physicalBehaviouralMap.get()[A];
          r && (r.behaviours = r.behaviours.filter(
            (a) => a !== n
          ));
        } else
          i.firebolt().dissociateBehaviour([n, A]);
      });
    }), this;
  }
  /**
   * Breaks the link between side effects and behavioural actions. It takes an array of formal names of the side
   * effects and it's linked behavioural action.
   *
   * To dissociate side effects from behavioural actions
   * ```
   *  muze.ActionModel.dissociateSideEffect(['crossline', 'highlight'], ['selectionBox', 'brush']);
   * ```
   * @public
   * @param  {Array} maps Array of side effects and behavioural actions.
   *
   * @return {ActionModel} Instance of action model.
   */
  dissociateSideEffect(...t) {
    return this._registrableComponents.forEach(
      (i) => i.firebolt().dissociateSideEffect(...t)
    ), this;
  }
  /**
   * By default cross interactivity is disabled between canvases. This enables cross interaction between the canvases
   * so that any action happening in one canvas gets dispatched on other canvases as well. An optional policy can also
   * be passed in this method. The policy can be used to control on which canvases the behavioural actions and
   * side effects gets dispatched.
   *
   * To just enable cross interactivity between two canvases,
   * ```
   *  ActionModel.for(canvas1, canvas2)
   *      .enableCrossInteractivity();
   * ```
   *
   * To enable cross interactivity but enable any behavioural action only when it is triggered from canvas1.
   * ```
   *  ActionModel.for(canvas1, canvas2)
   *      .enableCrossInteractivity({
   *          behaviours: {
   *              // Here * stands for any behavioural action name. We can also give any name of behavioural action
   *              // in place of this.
   *              '*': (propPayload, context) => {
   *                  return propPayload.sourceCanvas === canvas1.alias();
   *              }
   *          }
   *      });
   * ```
   *
   * To enable cross interactivity but enable tooltip effect if the action is propagated from canvas1,
   * ```
   *  ActionModel.for(canvas1, canvas2)
   *      .enableCrossInteractivity({
   *          sideEffects: {
   *              tooltip: (propPayload, context) => {
   *                  return propPayload.sourceCanvas === canvas1.alias();
   *              }
   *          }
   *      });
   * ```
   * @public
   * @param {Object} policy Policy definition.
   *
   * @return {ActionModel} Instance of action model.
   */
  enableCrossInteractivity(t = {}) {
    const i = this._registrableComponents, n = tt(
      {},
      k7(i)
    );
    return i.forEach((A) => {
      const s = F7(
        i.filter((o) => o.alias() !== A.alias())
      );
      A.firebolt().interactionPolicy(n).crossInteractionConfig(
        R7(
          t[A.alias()],
          s
        )
      );
    }), this;
  }
}
const YN = (() => new T7())();
class v7 {
  height;
  width;
  top;
  left;
}
class Us {
  _seed;
  _boundBox = new v7();
  _renderAt;
  _alignWith;
  _alignment;
  _target;
  _position;
  _componentName;
  _className;
  _shouldRender;
  constructor(t, i, n) {
    this._seed = n, this._boundBox = {
      height: i.height,
      width: i.width,
      top: null,
      left: null
    }, this._renderAt = null, this._alignWith = null, this._alignment = null, this._target = null, this._position = null, this._componentName = t, this._className = null, this._shouldRender = !0;
  }
  getLogicalSpace() {
    throw new Error("getLogicalSpace is not defined");
  }
  // eslint-disable-next-line no-unused-vars
  setSpatialConfig() {
    throw new Error("setSpatialSpace is not defined");
  }
  name(t) {
    return t && (this._componentName = t), this._componentName;
  }
  target(t) {
    return t && (this._target = t), this._target;
  }
  position(t) {
    return t && (this._position = t), this._position;
  }
  alignment(t) {
    return t && (this._alignment = t), this._alignment;
  }
  alignWith(t) {
    return t && (this._alignWith = t), this._alignWith;
  }
  renderAt(t = null) {
    return t && (this._renderAt = t), this._renderAt;
  }
  boundBox(t = null) {
    return t && Object.assign(this._boundBox, t), this._boundBox;
  }
  className(t) {
    return t && (this._className = t), this._className;
  }
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  draw(t) {
    throw new Error("draw is not defined");
  }
  attachListener() {
    return this;
  }
  shouldRender(...t) {
    return t.length ? (this._shouldRender = t[0], this) : this._shouldRender;
  }
}
class G7 extends Us {
  getLogicalSpace() {
    return {
      width: this.boundBox().width,
      height: this.boundBox().height
    };
  }
  setSpatialConfig(t) {
    return this.boundBox({ top: t.y, left: t.x }), this.newDimensions = {
      width: t.width,
      height: t.height
    }, this.renderAt(t.renderAt), this;
  }
  draw() {
    if (!this.component)
      throw new Error(`Component not set for ${this.componentName}`);
    return this.component.mount(document.getElementById(this.renderAt)), this;
  }
}
const X0 = {
  enabled: !1,
  collapseAll: !1,
  state: []
}, mB = {
  classPrefix: ds,
  theme: B_,
  pagination: {
    enabled: !0,
    pageSize: 100,
    pageNumber: 1,
    unionAxisDomainPerPage: !1
  },
  interaction: {
    sideEffects: {
      tooltip: {
        common: !0
      },
      selectionBox: {}
    },
    highlight: {
      propagateDm: !1,
      applyOnVisibleUnits: !0,
      sideEffects: {
        tooltip: {
          // enabled: false,
          contents: [
            {
              name: "highlightSummary",
              setTransform: (e, t, i) => W(
                i.firebolt.getPayload("brush"),
                "dragging"
              ) ? null : e
            },
            {
              name: "selectionSummary",
              setTransform: (e, t, i) => {
                if (W(
                  i.firebolt.getPayload("brush"),
                  "dragging"
                ))
                  return null;
                const n = i.firebolt.getEntryExitSet("select"), A = i.firebolt.getEntryExitSet("brush");
                if (n || A) {
                  let s = /* @__PURE__ */ new Set(), o = null;
                  if (W(n, "entrySet", "length") ? (s = n.entrySet.uids, o = n) : W(A, "entrySet", "length") && (s = A.entrySet.uids, o = A), RC(e.entrySet.uids, s).size)
                    return o;
                }
                return null;
              }
            }
          ]
        },
        crossline: {},
        [HE]: {}
      }
    },
    select: {
      propagateDm: !0,
      sideEffects: {
        tooltip: {
          contents: [
            {
              name: "selectionSummary"
            }
          ]
        }
      }
    },
    contextMenu: {
      enabled: !1
    },
    brush: {
      propagateDm: !0,
      sideEffects: {
        selectionBox: {}
      }
    },
    tooltip: {
      includeDataFromAllLayers: !1
    }
  },
  scrollBar: {
    thickness: 10,
    speed: 2,
    buttons: {
      show: !0
    },
    vertical: {
      align: "right",
      initialScrollPercent: 0
    },
    horizontal: {
      align: "bottom",
      initialScrollPercent: 0
    }
  },
  legend: {
    includeTotalDomain: !0,
    show: !0,
    position: "right",
    height: 20,
    width: 20,
    interaction: {
      "inverse-select": {
        target: {
          layer: {
            // highlight: {
            //   sideEffects: {
            //     "plot-highlighter": {
            //       rules: [
            //         {
            //           target: "exitSet",
            //           style: {
            //             fill: { a: -0.8 },
            //             stroke: { a: -0.8 },
            //           },
            //         },
            //       ],
            //     },
            //   },
            // },
            filter: {
              sideEffects: {
                filter: {}
              }
            }
          }
        },
        sideEffects: {
          "legend-highlighter": {
            rules: [
              {
                target: "exitSet",
                className: "muze-legend-fadeout"
              }
            ]
          }
        }
      },
      brush: {
        target: {
          layer: {
            highlight: {
              sideEffects: {
                "plot-highlighter": {
                  rules: [
                    {
                      target: "exitSet",
                      style: {
                        fill: { a: -0.8 },
                        stroke: { a: -0.8 }
                      }
                    }
                  ]
                }
              }
            }
          }
        },
        sideEffects: {}
      },
      highlight: {
        target: {
          layer: {
            highlight: {
              sideEffects: {
                "plot-highlighter": {
                  rules: [
                    {
                      target: "exitSet",
                      style: {
                        fill: { a: -0.3 }
                      }
                    }
                  ]
                }
              }
            }
          }
        },
        sideEffects: {
          "legend-highlighter": {
            rules: [
              {
                target: "entrySet",
                className: "muze-legend-brighten"
              }
            ]
          }
        }
      },
      legendHighlight: {
        target: {
          //   layer: {
          //     highlight: {
          //       sideEffects: {
          //         "plot-highlighter": {
          //           rules: [
          //             {
          //               target: "exitSet",
          //               style: {
          //                 fill: { a: -0.3 },
          //               },
          //             },
          //           ],
          //         },
          //       },
          //     },
          //   },
        },
        sideEffects: {
          legendTextTooltip: {
            // rules: [
            //   {
            //     target: "entrySet",
            //     className: "muze-legend-brighten",
            //   },
            // ],
          }
        }
      }
    },
    totalsColor: "#6b7e6b",
    color: {
      padding: 1,
      margin: 3,
      border: 1,
      title: {
        show: !0
      }
    },
    shape: {
      padding: 1,
      margin: 3,
      border: 1,
      title: {
        show: !0
      }
    },
    size: {
      padding: 1,
      margin: 3,
      border: 1,
      title: {
        show: !0
      }
    },
    backgroundColor: {
      padding: 1,
      margin: 3,
      border: 1,
      title: {
        show: !0
      }
    }
  },
  showHeaders: !1,
  minWidth: 100,
  minHeight: 100,
  border: {
    style: "solid",
    color: "#d6d6d6",
    width: 2,
    collapse: !0,
    spacing: 0
  },
  autoGroupBy: {
    disabled: !1
  },
  invalidValues: {},
  sort: {
    autoSort: {
      disabled: !1
    }
  },
  axisFrom: {},
  axes: {
    x: {
      show: !0,
      compact: !1,
      enableDirectSort: !0,
      showAxisLine: !0,
      interaction: {
        contextMenu: {
          enabled: !1
        }
      }
    },
    y: {
      show: !0,
      compact: !1,
      enableDirectSort: !0,
      showAxisLine: !1,
      interaction: {
        contextMenu: {
          enabled: !1
        }
      }
    }
  },
  useExternalCSS: !1,
  useUTC: !1,
  rows: {
    totalMaxWidthRatio: 0.5,
    interaction: {
      resize: {
        enabled: !0,
        sideEffects: {
          "column-dimension-changer": {
            draggableOutsideChart: !0
          }
        }
      },
      headerTooltip: {
        enabled: !0,
        sideEffects: {
          "column-header-tooltip": {}
        }
      }
    },
    minWidth: 25,
    layout: [],
    totals: {
      subTotals: {
        enabled: !1,
        splitTotal: {
          text: "All"
        },
        text: "All"
      },
      grandTotals: {
        position: "end",
        interaction: {
          select: {
            sideEffects: {}
          }
        },
        enabled: !1,
        text: "Grand Total",
        splitTotal: {
          text: "Total"
        }
      },
      data: { totalString: "All" },
      position: "end",
      aggregations: {}
    },
    facets: {
      show: !0,
      format: null,
      className: "",
      labels: {
        align: Me,
        style: {
          "font-size": "12px",
          "line-height": "15px",
          color: "#5f5f5f",
          "font-weight": "400",
          "font-family": "'Source Sans Pro','Helvetica Neue', Helvetica, Arial, sans-serif",
          "white-space": "nowrap",
          "transform-origin": "0 0"
        }
      },
      fields: {},
      interaction: {
        collapse: X0,
        contextMenu: {
          enabled: !1
        }
      },
      hyperlink: {
        enabled: !1,
        sanitizeHyperlink: !0,
        encode: !0,
        defaultClassName: `${ds}-hyperlink-text`,
        generateHref: (e) => ({
          target: "_blank",
          rel: "nofollow",
          url: e.formattedValue,
          styles: {},
          classNames: ""
        })
      }
    },
    headers: {
      // by default show === null, because for renderer === "html" ... to be continued
      show: null,
      position: se,
      fields: {},
      charsAcross: {
        min: 4,
        max: 8
      },
      charsAlong: {
        min: 1,
        max: 1
      },
      enableDirectSort: !0,
      interaction: {
        directSortSelect: {
          sideEffects: {
            "toggle-sort-dropdown": {}
          }
        }
      }
    }
  },
  columns: {
    interaction: {
      resize: {
        enabled: !0,
        sideEffects: {
          "column-dimension-changer": {
            draggableOutsideChart: !0
          }
        }
      },
      headerTooltip: {
        enabled: !0,
        sideEffects: {
          "column-header-tooltip": {}
        }
      }
    },
    layout: [],
    minWidth: 16,
    totals: {
      subTotals: {
        enabled: !1,
        splitTotal: {
          text: "All"
        },
        text: "All"
      },
      grandTotals: {
        position: "top",
        enabled: !1,
        text: "Grand Total",
        splitTotal: {
          text: "Total"
        }
      },
      data: { totalString: "All" },
      position: "end",
      aggregations: {}
    },
    facets: {
      show: !0,
      format: null,
      className: "",
      labels: {
        align: Me,
        style: {
          "font-size": "12px",
          "line-height": "15px",
          color: "#5f5f5f",
          "font-weight": "400",
          "font-family": "'Source Sans Pro','Helvetica Neue', Helvetica, Arial, sans-serif",
          "white-space": "nowrap",
          "transform-origin": "0 0"
        }
      },
      fields: {},
      interaction: {
        collapse: X0,
        contextMenu: {
          enabled: !1
        }
      },
      charsAcross: {
        min: 4
      },
      hyperlink: {
        enabled: !1,
        sanitizeHyperlink: !0,
        encode: !0,
        defaultClassName: `${ds}-hyperlink-text`,
        generateHref: (e) => ({
          target: "_blank",
          rel: "nofollow",
          url: e.formattedValue,
          styles: {},
          classNames: ""
        })
      }
    },
    headers: {
      show: !0,
      position: se,
      align: Q7,
      padding: 4,
      maxLines: 1,
      className: `${ds}-column-header-container`,
      formatter: (e) => e.fieldNames.join(" / "),
      fields: {},
      charsAcross: {
        min: 4,
        max: 8
      },
      charsAlong: {
        min: 4,
        max: 8
      },
      interaction: {
        directSortSelect: {
          sideEffects: {
            "toggle-sort-dropdown": {}
          }
        }
      }
    }
  }
}, L7 = ["sort"], U7 = 600, O7 = 400, ty = `${mB.classPrefix}-layout-container-component`, H7 = `${mB.classPrefix}-layout-container`;
class BI {
  constructor(t) {
    this._host = t.host || null, this._cut = t.cut || null, this._ratioWeight = t.ratioWeight === 0 ? 0 : t.ratioWeight || 1, this._preferred = t.preferred || !1, this._lanes = t.lanes || [], this._remainingHeight = 0, this._remainingWidth = 0;
  }
  host(t) {
    return t && (this._host = t), this._host;
  }
  preferred(t) {
    return t && (this._preferred = t), this._preferred;
  }
  cut(t) {
    return t && (this._cut = t), this._cut;
  }
  ratioWeight(t) {
    return t && (this._ratioWeight = t), this._ratioWeight;
  }
  lanes(t) {
    return t && (this._lanes = t), this._lanes;
  }
  remainingHeight(t) {
    return t && (this._remainingHeight = t), this._remainingHeight;
  }
  remainingWidth(t) {
    return t && (this._remainingWidth = t), this._remainingWidth;
  }
}
const P7 = (() => {
  let e = 0;
  return () => `${H7}-${++e}`;
})();
function QB(e) {
  let t = 0;
  if (e.getCutType() === "v")
    t = Y7(e);
  else if (e.getCutType() === "h")
    e.children().forEach((i) => {
      t += QB(i);
    });
  else if (e.model().host() && e.model().host().getLogicalSpace) {
    const i = e.boundBox().height, n = e.model().host().getLogicalSpace().height;
    t = i - n, t < 0 && (t = 0);
  } else
    t = 0;
  return t;
}
function Y7(e) {
  let t = Number.MAX_SAFE_INTEGER;
  return e.children().forEach((i) => {
    const n = QB(i);
    n < t && (t = n);
  }), t;
}
function pB(e) {
  let t = 0;
  if (e.getCutType() === "h")
    t = J7(e);
  else if (e.getCutType() === "v")
    e.children().forEach((i) => {
      t += pB(i);
    });
  else if (e.model().host() && e.model().host().getLogicalSpace) {
    const i = e.boundBox().width, n = e.model().host().getLogicalSpace().width;
    t = i - n, t < 0 && (t = 0);
  } else
    t = 0;
  return t;
}
function J7(e) {
  let t = Number.MAX_SAFE_INTEGER;
  return e.children().forEach((i) => {
    const n = pB(i);
    n < t && (t = n);
  }), t;
}
function K7(e, t, i, n) {
  if (t) {
    const o = i[t - 1], { top: r, left: a, height: l, width: c } = o.boundBox();
    return {
      width: e.width,
      height: e.height,
      top: n.parentCut() === "h" ? r + l : r,
      left: n.parentCut() === "h" ? a : a + c
    };
  }
  const { top: A, left: s } = n.parent().boundBox();
  return {
    width: e.width,
    height: e.height,
    top: A,
    left: s
  };
}
function W7(e) {
  e.targetComponentMap(/* @__PURE__ */ new Map()), e.componentMap().forEach((t) => {
    if (e.targetComponentMap().has(t.target()))
      e.targetComponentMap().get(t.target()).push(t);
    else {
      const i = [];
      i.push(t), e.targetComponentMap().set(t.target(), i);
    }
  });
}
function V7(e, t) {
  const i = e.find((n) => n.name() === t);
  return i && i !== -1 ? i : null;
}
function j7(e, t, i) {
  const n = new G7(0, { height: e, width: t });
  return n.name("placeHolder"), n.position(i), n;
}
function mI(e, t, i = !1, n = !1) {
  let A = "", s = 1, o = 1, r = 0, a = 0;
  if (!t)
    return { first: e, second: e };
  const { height: l, width: c } = t.getLogicalSpace(), g = t.position();
  g === "top" || g === "bottom" ? (A = "h", s = l / e.remainingHeight(), r = e.remainingHeight() - l, a = e.remainingWidth()) : (A = "v", s = c / e.remainingWidth(), a = e.remainingWidth() - c, r = e.remainingHeight()), o = 1 - s, e.cut(A);
  const h = {
    host: t.name(),
    cut: null,
    ratioWeight: s,
    preferred: n ? !1 : i,
    lanes: []
  }, u = new BI(h);
  u.remainingHeight(l), u.remainingWidth(c);
  const d = {
    host: null,
    cut: null,
    ratioWeight: o,
    preferred: n ? !1 : !i,
    lanes: []
  }, f = new BI(d);
  return f.remainingHeight(r), f.remainingWidth(a), i ? e.lanes([u]) : g === "top" || g === "left" ? e.lanes([u, f]) : e.lanes([f, u]), { first: u, second: f };
}
function q7(e, t) {
  let i = e;
  const n = t.length, A = n ? t[0].length : 0, s = t.reduce((o, r) => o + r[0].getLogicalSpace().height, 0);
  for (let o = 0; o < A; o++) {
    const r = o === A - 1, a = j7(
      s,
      t[0][o].getLogicalSpace().width,
      "left"
    ), { first: l, second: c } = mI(i, a, r);
    i = l;
    for (let g = 0; g < n; g++) {
      const h = g === n - 1;
      i = mI(i, t[g][o], h, !0).second;
    }
    i = c;
  }
  return i;
}
function QI(e) {
  let t, i = 0, n, A;
  const s = e.children().length;
  for (let o = 0; o < s; o++) {
    let r, a;
    const l = e.children()[o];
    if (l.parentCut() === "h" ? (r = QB, n = "height", A = "width") : (r = pB, n = "width", A = "height"), l.isPreferred()) {
      t = l;
      continue;
    }
    i += a = r(l), l.boundBox()[n] -= a, l.boundBox()[A] = l.parent().boundBox()[A], QI(l);
  }
  t && (t.boundBox()[n] += i, t.boundBox()[A] = t.parent().boundBox()[A], QI(t));
}
function JN(e) {
  e.children().forEach((t, i, n) => {
    const A = K7(t.boundBox(), i, n, t);
    t.boundBox(A), JN(t);
  });
}
function KN(e) {
  const t = e.children().map((i) => i.model().ratioWeight()).reduce((i, n) => i + n, 0);
  e.children().forEach((i, n, A) => {
    const s = A[n - 1], o = i.model().ratioWeight() / t;
    i.parentCut() === "h" ? i.boundBox({
      top: n ? s.boundBox().top + s.boundBox().height : 0,
      left: i.parent().boundBox().left,
      height: i.parent().boundBox().height * o,
      width: i.parent().boundBox().width
    }) : i.boundBox({
      top: i.parent().boundBox().top,
      left: n ? s.boundBox().left + s.boundBox().width : 0,
      height: i.parent().boundBox().height,
      width: i.parent().boundBox().width * o
    }), KN(i);
  });
}
let z7 = class {
  constructor(t) {
    this._model = t, this._parent = null, this._children = [], this._parentCut = null, this._boundBox = {
      top: null,
      left: null,
      height: null,
      width: null
    }, this._id = this._model.host() instanceof Us && this._model.host().renderAt() ? this._model.host().renderAt() : P7();
  }
  addChildren(t) {
    this._children.push(...t), t.forEach((i) => {
      i.parent(this);
    });
  }
  isRoot() {
    return this._parent === null;
  }
  isLeaf() {
    return !this._children.length;
  }
  getCutType() {
    return this._model.cut();
  }
  isPreferred() {
    return !!this._model.preferred();
  }
  children(t) {
    return t && (this._children = t), this._children;
  }
  parent(t) {
    return t && (this._parent = t), this._parent;
  }
  parentCut(t) {
    return t && (this._parentCut = t), this._parentCut;
  }
  id(t) {
    return t && (this._id = t), this._id;
  }
  model(t) {
    return t && (this._model = t), this._model;
  }
  boundBox(t) {
    return t && (this._boundBox = {
      top: t.top,
      left: t.left,
      height: t.height,
      width: t.width
    }), this._boundBox;
  }
  /**
     * function to search a node and update it with the config provided.
     * @param  {Object} nodeconfig
     */
  updateNode(t) {
    this._id === t._id ? (this._model.cut(t.cut), this._model.ratioWeight(t.ratioWeight)) : this._children.forEach((i) => {
      if (i._id === t._id) {
        i.model.cut(t.cut), i.model.ratioWeight(t.ratioWeight);
        return;
      }
      this.searchNode(i, t);
    });
  }
  // Recursive function to search a node
  searchNode(t, i) {
    t.children().forEach((n) => {
      n.id() === i._id ? (n.model().cut(i.cut), n.model().ratioWeight(i.ratioWeight)) : this.searchNode(n, i);
    });
  }
  /**
     * function to delete a node from tree Structure.
     * @param  {String} nodeId - node Id of the Node
     */
  delete(t) {
    this._children.forEach((i) => {
      if (i.id() === t) {
        const n = this._children.indexOf(i);
        this._model.lanes().splice(n, 1);
      }
      this.deleteSearchNode(i, t);
    });
  }
  // Recursive function to search a node
  deleteSearchNode(t, i) {
    t.children().forEach((n) => {
      if (n.id() === i) {
        const A = t.children().indexOf(n);
        t.model().lanes().splice(A, 1);
      } else
        this.deleteSearchNode(n, i);
    });
  }
};
class yB {
  constructor(t, i) {
    this._measurements = t, this._config = i, this._root = this.createTree(this._config, null), this.setBoundBox();
  }
  createTree(t, i) {
    const n = new z7(t);
    i ? (n.parentCut(i.getCutType()), i.addChildren([n])) : this._root = n;
    for (const A of t.lanes())
      this.createTree(A, n);
    return this._root;
  }
  setBoundBox() {
    this._root.boundBox({
      top: 0,
      left: 0,
      width: this._measurements.width,
      height: this._measurements.height
    }), KN(this._root);
  }
  setHostPosition(t) {
    t.children().forEach((i) => {
      yB.setHostSpatialConfig(i), this.setHostPosition(i);
    });
  }
  static setHostSpatialConfig(t) {
    const i = t.boundBox(), n = t.model().host();
    if (n && n.setSpatialConfig) {
      const A = {
        x: i.left,
        y: i.top,
        width: i.width,
        height: i.height,
        renderAt: t.id()
      };
      n.setSpatialConfig(A);
    }
  }
  negotiate() {
    return QI(this._root), JN(this._root), this;
  }
  broadcast() {
    return this.setHostPosition(this._root), this;
  }
  tree() {
    return this._root;
  }
}
const Z7 = {
  top: 0,
  center: 1,
  bottom: 2
}, SA = {
  0: "top",
  1: "center",
  2: "bottom"
}, vr = {
  0: "left",
  1: "middle",
  2: "right"
}, $7 = "width", X7 = "height", tz = "border", ez = "rowPointer", iz = "columnPointer", nz = "isRowSizeEqual", Az = "isColumnSizeEqual", sz = "unitWidth", oz = "unitHeight", rz = "style", az = "color", HA = "width", lz = "collapse", cz = "spacing", gz = "distribution", hz = "gutterSpace", uz = "breakPage", wh = "height", on = "column", rn = "row", bi = "top", an = "left", ln = "right", Ni = "bottom", ye = "center", pI = "rowSpan", yI = "colSpan", dz = "rowRoot", fz = "columnRoot", gA = "primary", Io = "secondary", WN = "vertical", VN = "horizontal", Iz = "grid", Cz = "pagination", Ez = "buffer", Bz = "holistic", mz = "scroll", Pd = "middle", Dc = null, Qz = "maxWidthAvailableForColumnMatrix", pz = "columnMatrix", yz = "maxHeightAvailableForRowMatrix", Dz = "rowMatrix", wz = 3, xz = 3;
class DI {
  static isDOMElement(t) {
    return t instanceof Element;
  }
  static getID(t) {
    return t.id;
  }
  static getElement(t) {
    return document.getElementById(t);
  }
  static findContainer(t) {
    return t.filter((i) => i.parent == null)[0];
  }
  /**
   * static method to remove the div
   * @param  {} divId - div ID to be removed.
   */
  static removeDiv(t) {
    document.getElementById(t) !== null && document.getElementById(t).remove();
  }
}
class Sz {
  constructor(t) {
    this._node = t, this._className = t.model().host() instanceof Us ? t.model().host().className() : ty;
  }
  node() {
    return this._node;
  }
  hasHost() {
    return this._node.model().host() instanceof Us;
  }
  className() {
    return this._className || ty;
  }
}
const jN = (e, t) => {
  const i = new Sz(e);
  t.push(i), e.children().forEach((n) => {
    jN(n, t);
  });
};
class Mz {
  constructor(t) {
    this._data = t;
  }
  defaultDataPointLogic() {
    const t = [];
    return jN(this._data, t), t;
  }
}
class _z extends Mz {
  getCoordinates() {
    return super.defaultDataPointLogic();
  }
}
class bz {
  initRenderer() {
  }
}
class Nz extends bz {
  constructor(t) {
    super(), this._data = t, this._coordinates = new _z(this._data).getCoordinates();
  }
  createhtml(t, i) {
    const n = t;
    super.initRenderer(n, this._data), this.parentDiv = this.createAndCustomiseParent(i), this._coordinates.forEach((A) => {
      if (A.hasHost()) {
        const s = A.node();
        this.parentDiv.appendChild(
          this.createAndPositionDiv({
            ...s.boundBox(),
            id: s.id(),
            className: A.className()
          })
        );
      }
    }), n.appendChild(this.parentDiv);
  }
  createAndPositionDiv(t) {
    const { top: i, left: n, height: A, width: s, className: o, id: r } = t, l = document.getElementById(r) || document.createElement("div");
    return l.style.position = "absolute", l.style.left = `${n}px`, l.style.top = `${i}px`, l.style.height = `${A}px`, l.style.width = `${s}px`, l.id = r, l.className = o, l;
  }
  createAndCustomiseParent(t) {
    const i = DI.findContainer(this._coordinates), n = i.node(), A = this.createAndPositionDiv({
      ...n.boundBox(),
      id: n.id(),
      className: i.className()
    });
    return A.className = t, A.style.position = "relative", A;
  }
  destroyParent() {
    this.parentDiv.remove();
  }
  coordinates() {
    return this._coordinates;
  }
}
const Fa = (e, t) => e.renderer().coordinates().find((i) => i.node().id() === t), Fz = (e) => {
  e.renderer(new Nz(e.data())), e.renderer().createhtml(e.mount(), e.className());
}, Rz = (e) => Fz(e), qN = (e) => {
  e.children().forEach((t) => {
    const i = t.model().host();
    i instanceof Us && i.shouldRender() && i.draw(), qN(t);
  });
}, kz = (e) => {
  e && V(`#${e}`).remove();
}, Tz = (e, t, i) => {
  let n = {};
  const { node: A, refNode: s } = i;
  switch (t) {
    case "left":
      n = {
        top: A.top,
        left: s.left,
        height: A.height,
        width: Math.abs(A.width - Math.abs(s.left - A.left))
      };
      break;
    case "right":
      n = {
        top: A.top,
        left: A.left,
        height: A.height,
        width: Math.abs(
          A.width - Math.abs(A.left + A.width - (s.left + s.width))
        )
      };
      break;
    case "top":
      n = {
        top: s.top,
        left: A.left,
        height: Math.abs(A.height - Math.abs(s.top - A.top)),
        width: A.width
      };
      break;
    case "bottom":
      n = {
        top: A.top,
        left: A.left,
        height: Math.abs(A.top - s.top + s.height),
        width: A.width
      };
      break;
    case "h-center":
      n = {
        top: A.top,
        left: s.left,
        height: A.height,
        width: s.width
      };
      break;
    case "v-center":
      n = {
        top: s.top,
        left: A.left,
        height: s.height,
        width: A.width
      };
      break;
    case "extended-h-center": {
      const o = e.componentMap().get(`${SA[1]}-${vr[0]}`), r = o && Fa(e, o.renderAt()).node().boundBox(), a = e.data().boundBox(), l = e.componentMap().get("rightLegend"), c = l && Fa(e, l.renderAt()).node().boundBox(), g = c && !Number.isNaN(c.width) ? c.width : 0, h = a.width - r.left - g;
      n = {
        top: A.top,
        left: r.left,
        height: A.height,
        width: h
      };
      break;
    }
    case "extended-v-center": {
      let r = e.data().boundBox().height - s.top;
      const a = e.componentMap().get("title");
      if (a && a.position() === Ni) {
        const l = Fa(e, a.renderAt()).node().boundBox();
        r -= Number.isNaN(l.height) ? 0 : l.height;
      }
      n = {
        top: s.top,
        left: A.left,
        height: r,
        width: A.width
      };
      break;
    }
  }
  return n;
}, zN = (e, t) => {
  t.children().forEach((i) => {
    const n = i.model().host();
    if (n instanceof Us && n.alignWith()) {
      const A = e.componentMap().get(n.alignWith());
      if (A) {
        const s = Fa(e, i.id()).node(), o = s.boundBox(), r = Fa(e, A.renderAt()).node().boundBox(), a = Tz(e, n.alignment(), {
          node: o,
          refNode: r
        });
        Object.assign(a, {
          id: s.id(),
          className: n.className()
        }), e.renderer().createAndPositionDiv(a), e.componentMap().get(n.name()).setSpatialConfig({
          x: a.left,
          y: a.top,
          height: a.height,
          width: a.width
        });
      }
    }
    zN(e, i);
  });
};
class vz {
  constructor(t, i, n) {
    this._data = t.tree, this._componentMap = t.componentMap, this._layoutClassName = t.layoutClassName, this._renderer = i, this._mount = DI.isDOMElement(n) ? n : DI.getElement(n);
  }
  destroyRoot() {
    this.renderer().destroyParent && this.renderer().destroyParent();
  }
  draw() {
    return Rz(this), zN(this, this._data), qN(this._data), this;
  }
  data(t) {
    return t ? (this._data = t, this) : this._data;
  }
  componentMap(t) {
    return t ? (this._componentMap = t, this) : this._componentMap;
  }
  className(t) {
    return t ? (this._layoutClassName = t, this) : this._layoutClassName;
  }
  renderer(t) {
    return t && (this._renderer = t), this._renderer;
  }
  mount(t) {
    return t && (this._mount = t), this._mount;
  }
}
class Gz {
  constructor(t, i, n, A) {
    this._componentMap = t, this._prioritySequence = i, this._totalHeight = n, this._totalWidth = A, this._targetComponentMap = null;
  }
  // create the config model
  generateConfigModel() {
    W7(this);
    const t = this._targetComponentMap.get("canvas"), i = new BI({});
    let n = i;
    i.remainingHeight(this._totalHeight), i.remainingWidth(this._totalWidth);
    let A = null;
    return this._prioritySequence.forEach((s) => {
      A = V7(t, s), s !== "grid" ? n = mI(n, A).second : n = q7(n, A.component);
    }), i;
  }
  componentMap(t) {
    return t && (this._componentMap = t), this._componentMap;
  }
  targetComponentMap(t) {
    return t && (this._targetComponentMap = t), this._targetComponentMap;
  }
}
function ZN(e, t) {
  const i = t.host();
  t.lanes() && t.lanes().length && t.lanes().forEach((n) => ZN(e, n)), i != null && typeof i == "string" && e.componentMap().get(i) !== void 0 && t.host(e.componentMap().get(i));
}
function Lz(e) {
  const { height: t, width: i } = e.dimension();
  return new Gz(
    e.layoutDef().componentMap(),
    e.prioritySequence(),
    t,
    i
  ).generateConfigModel();
}
class Uz {
  constructor() {
    this._componentMap = /* @__PURE__ */ new Map(), this._layoutDefinition = null;
  }
  addComponent(t) {
    this._componentMap.set(t.name(), t);
  }
  layoutDefinition(t) {
    return t && (this._layoutDefinition = t), this._layoutDefinition;
  }
  addMultipleComponent(t) {
    t.forEach((i) => {
      this.addComponent(i);
    });
  }
  sanitizedDefinition() {
    return ZN(this, this._layoutDefinition), this.layoutDefinition();
  }
  componentMap() {
    return this._componentMap;
  }
  resetComponentMap() {
    this._componentMap.clear();
  }
}
class Oz {
  constructor(t) {
    this._renderAt = t.renderAt, this._layoutClassName = t.className, this._dimension = {
      width: t.width || U7,
      height: t.height || O7
    }, this._skeletonType = t.skeletonType || "html", this._layoutDefinition = null, this._layoutDef = new Uz(), this._drawingManager = null, this._prioritySequence = [], this.tree = null, this._rootNodeID = null;
  }
  layoutDef(t) {
    return t && (this._layoutDef = t), this._layoutDef;
  }
  prioritySequence(t) {
    return t && (this._prioritySequence = t), this._prioritySequence;
  }
  dimension(t) {
    return t && Object.assign(this._dimension, t), this._dimension;
  }
  addComponent(t) {
    this._layoutDef.addComponent(t);
  }
  addMultipleComponent(t) {
    this._layoutDef.addMultipleComponent(t);
  }
  resetNode(t) {
    this.con && this.con.resetNode(t);
  }
  /**
   * function to update the node and rerender the layout.
   * @param  {} config - node configuration to change.
   */
  updateNode(t) {
    this.tree.updateNode(t), this._layoutDefinition = this.tree.model, this.compute();
  }
  compute() {
    this._layoutDefinition = Lz(this), this._layoutDef.layoutDefinition(this._layoutDefinition), this._layoutDefinition = this._layoutDef.sanitizedDefinition(), this._layout = new yB(
      {
        width: this._dimension.width,
        height: this._dimension.height
      },
      this._layoutDefinition
    ), this.tree = this._layout.negotiate().tree(), this._layout.broadcast(), this._drawingManager ? this._drawingManager.data(this.tree).componentMap(this._layoutDef.componentMap()).className(this._layoutClassName) : this._drawingManager = new vz(
      {
        tree: this.tree,
        componentMap: this._layoutDef.componentMap(),
        layoutClassName: this._layoutClassName
      },
      this._skeletonType,
      this._renderAt
    ), this._rootNodeID ? this.tree.id(this._rootNodeID) : this._rootNodeID = this.tree.id();
  }
  render() {
    this._drawingManager.draw();
  }
  getRootNodeId() {
    return this._rootNodeID;
  }
  /**
   * This function takes the LayoutComponents and Register them in component store
   * @param {Array<LayoutComponent>} layoutComponents
   */
  registerComponents(t) {
    return this._prioritySequence.length = 0, this._layoutDef.resetComponentMap(), t.forEach((i) => {
      i && (this._prioritySequence.push(i.name()), this.addComponent(i), i.name() === "grid" && i.component.forEach((n) => {
        n.forEach((A) => {
          this.addComponent(A);
        });
      }));
    }), this;
  }
  getComponent(t) {
    return this._layoutDef.componentMap().get(t);
  }
  deleteElement(t, i) {
    this._layoutDef.componentMap().delete(i);
    const n = t.renderAt();
    return t.remove(), kz(n);
  }
  removeComponent(t) {
    const i = this.getComponent(t);
    return i ? t === Iz ? i.component.map(
      (n) => n.map((A) => this.deleteElement(A, A.name()))
    ) : this.deleteElement(i, t) : this;
  }
  removeAllComponents() {
    const t = this.layoutDef().componentMap().keys();
    this._drawingManager != null && this._drawingManager.destroyRoot();
    for (const i of t)
      this.removeComponent(i);
  }
  renderAt(t) {
    return t && (this._renderAt = t), this._renderAt;
  }
}
class Os extends Us {
  newDimensions;
  getLogicalSpace() {
    const { width: t, height: i } = this.boundBox();
    return { width: t, height: i };
  }
  // @ts-expect-error
  setSpatialConfig(t) {
    this.boundBox({ top: t.y, left: t.x }), this.newDimensions = {
      width: t.width,
      height: t.height
    }, this.renderAt(t.renderAt);
  }
  getBoundBox() {
    return this.boundBox();
  }
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  updateWrapper(t) {
    throw Error("Update is not implemented");
  }
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  setParams(t) {
    throw Error("set params is not implemented");
  }
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  setComponentInfo(t) {
    throw Error("setComponentInfo is not implemented");
  }
  remove() {
    return this;
  }
}
const ey = (e) => Array.from(Array(e.length).keys()), iy = (e, t, i = {}) => {
  let { order: n, keyFn: A } = i;
  const s = t.slice(), o = e.slice(), r = o.slice();
  if (n = n || Array.from(Array(s.length).keys()), A = A || ((h) => h), o.length === 0) {
    const h = [];
    return n.forEach((u) => {
      h.push(s[u]);
    }), { prevStack: r, currStack: s, arr: h };
  }
  let a = "", l = "";
  const c = [];
  for (let h = n.length - 1; h >= 0; h--) {
    const u = n[h];
    if (a += A(s[u]), l += A(o[u]), a === l)
      c[u] = null;
    else {
      l = "";
      for (let d = h; d < n.length; d++) {
        const f = n[d], I = s[f];
        c[f] = I, o[f] = I, l = a;
      }
    }
  }
  const g = [];
  return n.forEach((h) => {
    g.push(c[h]);
  }), { prevStack: r, currStack: o, arr: g };
}, ny = (e, t, i, n) => {
  if (!e)
    return () => null;
  const A = {
    row: (s) => i[n + s] && i[n + s][t],
    column: (s) => i[n][t + s]
  };
  return (s) => {
    let o = 1, r = !1;
    for (; !r; )
      A[s](o) === null ? o += 1 : r = !0;
    return o;
  };
}, wc = (e, t) => ({
  row: () => {
    let i = [];
    return e.map((n) => {
      const { currStack: A, arr: s } = iy(i, n, {
        keyFn: (o) => o.key(),
        order: t
      });
      return i = A, s;
    });
  },
  column: () => {
    let i = [];
    const n = [];
    return e.length && e[0].forEach((A, s) => {
      const o = [];
      e.forEach((l) => {
        o.push(l[s]);
      });
      const { currStack: r, arr: a } = iy(i, o, {
        keyFn: (l) => l.key(),
        order: t
      });
      i = r, e.forEach((l, c) => {
        n[c] = n[c] || [], n[c][s] = a[c];
      });
    }), n;
  }
}), xc = (e) => ({
  row: () => {
    const t = [];
    return e.forEach((i, n) => {
      t[n] = t[n] || [], i.forEach((A, s) => {
        if (e[n][s]) {
          const o = ny(A, s, e, n)("row");
          o && t[n].push(o);
        }
      });
    }), t;
  },
  column: () => e.map(
    (t, i) => t.map((n, A) => ny(n, A, e, i)("column")).filter((n) => n !== null)
  )
}), Sc = () => ({
  row: (e) => ey(e[0]),
  column: (e) => ey(e)
}), Hz = {
  [`${bi}-1`]: {
    orderGetter: Sc()[on],
    viewMatrixMaker: (...e) => wc(...e)[on],
    spanMaker: (...e) => xc(...e)[on]
  },
  [`${Ni}-1`]: {
    orderGetter: Sc()[on],
    viewMatrixMaker: (...e) => wc(...e)[on],
    spanMaker: (...e) => xc(...e)[on]
  },
  [`${ye}-0`]: {
    orderGetter: Sc()[rn],
    viewMatrixMaker: (...e) => wc(...e)[rn],
    spanMaker: (...e) => xc(...e)[rn]
  },
  [`${ye}-2`]: {
    orderGetter: Sc()[rn],
    viewMatrixMaker: (...e) => wc(...e)[rn],
    spanMaker: (...e) => xc(...e)[rn]
  }
}, Pz = (e) => {
  const t = Hz[e];
  return t || {
    orderGetter: () => null,
    viewMatrixMaker: (i) => () => i,
    spanMaker: () => () => null
  };
};
function $N(e, t, i) {
  let n = null, A = e;
  const { orderGetter: s, viewMatrixMaker: o, spanMaker: r } = Pz(
    `${t}-${i}`
  );
  if (e.length) {
    const a = s(e);
    A = o(e, a)(), n = r(A)();
  }
  return { viewMatrix: A, spans: n };
}
const Yz = (e = 1, t, i, n, A) => {
  const s = t.availHeight(), o = t.availWidth(), r = i.border.width, { unitWidths: a, unitHeights: l } = i.dimensions, { row: c, col: g } = n, { startRowIdx: h = 0, startColIdx: u = 0 } = A;
  return {
    [pI]() {
      const d = l.primary[h + c];
      if (e > 1) {
        let f = 0;
        for (let I = c; I < c + e; I++)
          f += l.primary[h + I] - r;
        t.setAvailableSpace(o, f + r);
      } else
        d && (t.setAvailableSpace(o, d - r), V(this).style("height", `${d}px`));
      V(this).style("width", `${o}px`);
    },
    [yI]() {
      const d = a.primary[u + g];
      if (e > 1) {
        let f = 0;
        for (let I = g; I < g + e; I++)
          f += a.primary[u + I] - r;
        t.setAvailableSpace(f + r, s);
      } else
        d && t.setAvailableSpace(d - r, s);
      V(this).style("height", `${s}px`);
    }
  };
}, Mc = (e, t, i, n, A) => {
  let s = 0;
  e.attr(A, function(o, r) {
    r === 0 && (s = 0);
    const a = t[o.rowIndex][r], l = o.placeholder, c = {
      row: o.rowIndex,
      col: s
    };
    return Yz(a, l, i, c, n)[A].bind(this)(), s += a, a;
  });
}, Jz = {
  [`${bi}-0`]: null,
  [`${bi}-1`]: (...e) => Mc(...e, yI),
  [`${bi}-2`]: null,
  [`${ye}-0`]: (...e) => Mc(...e, pI),
  [`${ye}-1`]: null,
  [`${ye}-2`]: (...e) => Mc(...e, pI),
  [`${Ni}-0`]: null,
  [`${Ni}-1`]: (...e) => Mc(...e, yI),
  [`${Ni}-2`]: null
}, XN = (e, t, i, n, A) => {
  const s = Jz[n];
  s && s(e, t, i, A || {});
}, Kz = (e, t) => ({
  [`${bi}-${an}`]: e && t ? an : Dc,
  [`${bi}-${Pd}`]: on,
  [`${bi}-${ln}`]: e && t ? ln : Dc,
  [`${ye}-${an}`]: e ? `${ye}${an}` : rn,
  [`${ye}-${Pd}`]: ye,
  [`${ye}-${ln}`]: e ? `${ye}${ln}` : rn,
  [`${Ni}-${an}`]: Dc,
  [`${Ni}-${Pd}`]: on,
  [`${Ni}-${ln}`]: Dc
}), Wz = (e) => {
  const { type: t, borderWidth: i, borderStyle: n, cells: A, color: s } = e;
  A.style(`border-${t}`, `${i}px ${n} ${s}`);
}, qA = (e) => {
  const { borderTypes: t, showBorders: i, cells: n, borderInfo: A, name: s, isFacet: o } = e, {
    color: r,
    style: a,
    width: l
  } = A;
  t.forEach((c) => {
    Wz({
      cells: n,
      color: i[c] ? r : "transparent",
      type: c,
      borderWidth: l,
      borderStyle: a,
      name: s,
      isFacet: o
    });
  });
}, Vz = (e, t, i, n) => {
  const {
    showRowBorders: A,
    showColBorders: s,
    showValueBorders: o
  } = t;
  return {
    [rn]: () => qA({
      borderTypes: [bi, Ni],
      showBorders: A,
      cells: e,
      borderInfo: t,
      name: i,
      isFacet: n
    }),
    [on]: () => qA({
      borderTypes: [an, ln],
      showBorders: s,
      cells: e,
      borderInfo: t,
      name: i,
      isFacet: n
    }),
    [ye]: () => qA({
      borderTypes: [an, ln, bi, Ni],
      showBorders: o,
      cells: e,
      borderInfo: t,
      name: i,
      isFacet: n
    }),
    [an]: () => qA({
      borderTypes: [an],
      showBorders: A,
      cells: e,
      borderInfo: t,
      name: i,
      isFacet: n
    }),
    [ln]: () => qA({
      borderTypes: [ln],
      showBorders: A,
      cells: e,
      borderInfo: t,
      name: i,
      isFacet: n
    }),
    [`${ye}${an}`]: () => qA({
      borderTypes: [an, bi, Ni],
      showBorders: A,
      cells: e,
      borderInfo: t,
      name: i,
      isFacet: n
    }),
    [`${ye}${ln}`]: () => qA({
      borderTypes: [ln, bi, Ni],
      showBorders: A,
      cells: e,
      borderInfo: t,
      name: i,
      isFacet: n
    })
  };
}, t1 = (e) => {
  const { cells: t, border: i, row: n, column: A, isFacet: s, showHeaders: o } = e, r = `${SA[Z7[n]]}-${vr[A]}`, a = Vz(t, i, r, s), l = Kz(s, o)[r];
  l && a[l]();
};
const jz = (e) => {
  e.each(function(t) {
    t.placeholder.render(this);
  });
};
class e1 extends Os {
  constructor(t) {
    super(t.name, t.config.dimensions, 0), this.setParams(t), this.className(t.config.className), this._mount = null;
  }
  mount(...t) {
    return t.length ? (this._mount = t[0], this) : this._mount;
  }
  applyScroll(t) {
    const i = this.params.config.row, n = this.params.config.column, { horizontal: A, vertical: s } = this.params.config.scrollInfo;
    t.style(Hd, w7), t.style(Ii, Z0), t.style(Ci, Z0), A && n === 1 && (t.style(Hd, z0), t.style(Ii, "100%")), s && i === ye && (t.style(Hd, z0), t.style(Ci, "100%"));
  }
  render() {
    const {
      classPrefix: t,
      row: i,
      column: n,
      dimensions: A,
      border: s,
      isFacet: o,
      showHeaders: r
    } = this.params.config, a = this.mount(), l = j(
      a,
      "div",
      [1],
      `${t}-grid-${i}-${n + 1}`
    ).classed(`${t}-grid-${i}`, !0).classed(`${t}-grid`, !0);
    this.applyScroll(l);
    const { viewMatrix: c, spans: g } = $N(this.component, i, n), { cells: h } = this.renderTable(
      l,
      `${t}-grid`,
      c
    );
    XN(h, g, { dimensions: A, border: s }, `${i}-${n}`), jz(h), h.exit().each((u) => {
      u.placeholder.remove();
    }), t1({ cells: h, border: s, row: i, column: n, isFacet: o, showHeaders: r });
  }
  renderTable(t, i, n) {
    const A = j(t, "table", ["layout"], `${i}-table`), s = j(A, "tbody", ["layout"], `${i}-body`), o = j(s, "tr", n, `${i}-tr`), r = j(
      o,
      "td",
      (a, l) => a.map((c, g) => ({ placeholder: c, rowIndex: l, colIndex: g })).filter((c) => c.placeholder !== null),
      `${i}-td`,
      {
        update: (a, l) => {
          const { externalClassname: c } = l.placeholder.config();
          c && c.map(
            (g) => a.classed(`${i}-${g}`, !0)
          );
        }
      },
      (a) => a.placeholder.id
    );
    return { table: A, body: s, rows: o, cells: r };
  }
  draw(t) {
    this.mount(t || document.getElementById(this.renderAt())), this.render();
  }
  updateWrapper(t) {
    return this.name(t.name), this.boundBox(t.config.dimensions), this.setParams(t), this;
  }
  setParams(t) {
    this.component = t.component, this.params = t, this.target(t.config.target), this.position(bi), this.className(t.config.className);
  }
}
const qz = "margin", si = "left", oi = "right", ri = "bottom", ai = "top", zz = "spaceFixer", qi = "muze", Zz = "verticalAlign", $z = "textAlign", Xz = "isOffset", tZ = "show", eZ = "center", wI = "header", i1 = "headerTitle", po = "rowFacetHeader", ma = "columnFacetHeader", Ra = "height", zo = "width", iZ = "maxLines", nZ = "minCharacters", AZ = "rotation", sZ = "text-cell", Ay = "axis-cell", oZ = "geom-cell", rZ = "blank-cell", aZ = "padding", lZ = "headerPadding", cZ = "titlePadding", xh = "headerTitlePadding", xI = "facetHeaderPadding", n1 = "facetHeaderPadding", A1 = "facetHeaderPadding", gZ = "title", DB = "subtitle", rs = 5, sy = "total", hZ = "simple", Qa = "text", ng = "axis", Ag = "geom", sg = "blank", s1 = "SimpleCell", o1 = "TextCell", r1 = "AxisCell", a1 = "BlankCell", l1 = "GeomCell";
class Ul {
  /**
   * Creates an instance of SimpleCell.
   *
   * @param {*} config The input configuration.
   * @memberof SimpleCell
   */
  constructor(t) {
    this._id = Ut();
    const i = tt({}, this.constructor.defaultConfig());
    this._config = tt(i, t || {}), this._mount = null, this._source = null;
  }
  /**
   * Returns the type of the placehlder.
   *
   * @memberof SimpleCell
   */
  get type() {
    return hZ;
  }
  static formalName() {
    return s1;
  }
  /**
   * Returns the type of the placehlder.
   *
   * @memberof SimpleCell
   * @return {Object} Default config for the placeholder
   */
  static defaultConfig() {
    return {};
  }
  /**
   * Returns the value contained by the SimpleCell.
   *
   * @memberof SimpleCell
   */
  valueOf() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Returns a unique identifier for the instance used
   * to control selective rendering.
   *
   * @memberof SimpleCell
   */
  get id() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  mount(t) {
    if (t == null)
      return this._mount;
    this._mount = t;
  }
  config(t) {
    if (t == null)
      return this._config;
    this._config = t;
  }
  source(t) {
    if (t == null)
      return this._source;
    this._source = t;
  }
  /**
   * Returns a serialized representation of the instance.
   *
   * @memberof SimpleCell
   */
  serialize() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Returns an object with width and height fields
   * specifying the space taken up by this method.
   *
   * @param {Object} config The config.
   * @param {boolean} config.useRawSpace Whether to consider the original dimensions without any smartTick.
   * @memberof SimpleCell
   */
  getLogicalSpace() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Method used to set the space available to render the SimpleCell
   *
   * @param {number} width The available width.
   * @param {number} height The available height.
   * @memberof SimpleCell
   */
  setAvailableSpace() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Render the SimpleCell inthe supplied mount point.
   *
   * @param {HTMLElement} mount The mount point to render in.
   * @memberof SimpleCell
   */
  render() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Render the SimpleCell inthe supplied mount point.
   *
   * @param {HTMLElement} mount The mount point to render in.
   * @memberof SimpleCell
   */
  remove() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  getMinMeasures(t = 0) {
    return t;
  }
  emitAllRenderHooksWhenRenderSkipped(t) {
    const i = this.source();
    !hx(i) && i.emitAllRenderHooksWhenRenderSkipped && i.emitAllRenderHooksWhenRenderSkipped(t);
  }
}
const Lu = {
  [qz]: {
    [si]: 0,
    [oi]: 0,
    [ai]: 0,
    [ri]: 0
  },
  [zz]: 2,
  [Xz]: !1,
  [Zz]: null,
  [$z]: eZ,
  [tZ]: !0,
  [iZ]: 0,
  [nZ]: 0,
  [AZ]: null,
  [aZ]: {
    [si]: 8,
    [oi]: 8,
    [ai]: 3,
    [ri]: 0
  },
  [xh]: {
    [si]: 8,
    [oi]: 5,
    [ai]: 2,
    [ri]: 3
  },
  [xI]: {
    [si]: 8,
    [oi]: 5,
    [ai]: 5,
    [ri]: 0
  },
  [n1]: {
    [si]: 5,
    [oi]: 5,
    [ai]: 5,
    [ri]: 0
  },
  [A1]: {
    [si]: 3,
    [oi]: 3,
    [ai]: PI,
    [ri]: 0
  },
  [lZ]: {
    [si]: 8,
    [oi]: 5,
    [ai]: 2,
    [ri]: 5
  },
  [cZ]: {
    [si]: 0,
    [oi]: 0,
    [ai]: 0,
    [ri]: 0
  },
  numLines: {},
  numChars: {}
}, _c = {
  mount: {},
  availHeight: {},
  availWidth: {},
  config: {
    sanitization: (e, t) => tt(e._config, t)
  },
  logicalSpace: {},
  minSpacing: {},
  source: {}
}, uZ = {
  caption: {},
  config: {}
}, dZ = {
  smartText: {},
  rawSource: {}
}, Uu = {
  [Ag]: tt(uZ, _c),
  [Qa]: tt(dZ, _c),
  [ng]: _c,
  [sg]: _c
}, fZ = (e, t) => {
  let i, n;
  const A = e.source(), { spaceFixer: s, margin: o } = e.config(), r = e.overrideDimension();
  A.overrideDimension && A.overrideDimension(r);
  const { width: a, height: l } = A.getLogicalSpace(t), { show: c, orientation: g } = A.config();
  return c === !0 ? (r.height ? n = l : n = Math.floor(
    l + o.top + o.bottom + s
  ), r.width ? i = a : i = Math.floor(
    a + o.left + o.right + s
  ), e.config().renderer === "svg" && (g === ai || g === ri ? n += rs : (g === si || g === oi) && (i += rs))) : [i, n] = [a, l], {
    width: i,
    height: n
  };
};
class wB extends Ul {
  /**
   * Creates an instance of AxisCell.
   *
   * @param {Object} config The input config.
   * @memberof AxisCell
   */
  constructor(t) {
    super(t), this._axis = null, this._availHeight = null, this._availWidth = null, this._logicalSpace = null, this._overriddenDimension = {}, ge(this, Uu[ng]);
  }
  /**
   * return the type pf SimpleCell cell.
   *
   * @memberof AxisCell
   */
  get type() {
    return ng;
  }
  /**
   * This method return the value conatined by this SimpleCell.
   *
   * @return {SimpleAxis | ColorAxis} Instance of SimpleAxis or ColorAxis.
   * @memberof AxisCell
   */
  valueOf() {
    return this.source().id;
  }
  key() {
    return this.source().id;
  }
  /**
   * This method return the unique identififer of the axis
   *
   * @return {string} Id of the axis.
   * @memberof AxisCell
   */
  get id() {
    return this._id;
  }
  static formalName() {
    return r1;
  }
  /**
   * Retrns the serialized representation of this cell.
   *
   * @return {Object}Object with serializable props.
   * @memberof AxisCell
   */
  serialize() {
    return {
      type: ng,
      axis: this.source().serialize()
    };
  }
  /**
   * return the default configuration for the text cell
   *
   * @static
   * @return {Object} Default configuration of the cell
   * @memberof AxisCell
   */
  static defaultConfig() {
    return Lu;
  }
  overrideDimension(t) {
    return t == null ? this._overriddenDimension : (this._overriddenDimension = t, this);
  }
  /**
   * Return the space taken up by an axis element in the dom.
   *
   * @param {Object} config The config.
   * @param {boolean} config.useRawSpace Whether to consider the original dimensions without any smartTick.
   *
   * @return {Object} Object with width and height fields.
   * @memberof AxisCell
   */
  getLogicalSpace(t) {
    if (t = t || {}, !this.logicalSpace()) {
      const i = fZ(this, t);
      this.logicalSpace(i), this._implicitSpace = i;
    }
    return this.logicalSpace();
  }
  /**
   * This method is used to set the space availiable to render
   * the SimpleCell.
   *
   * @param {number} width The width of SimpleCell.
   * @param {number} height The height of SimpleCell.
   * @return {AxisCell} Returns current Instance
   * @memberof AxisCell
   */
  setAvailableSpace(t, i) {
    this.availWidth(t), this.availHeight(i);
    const { margin: n, isOffset: A } = this.config(), s = this.source(), { show: o, orientation: r } = s.config();
    if (t || i) {
      let a = t, l = i;
      o && this.config().renderer === "svg" && (r === ai || r === ri ? l = i > rs ? i - rs : i : (r === si || r === oi) && (a = t > rs ? t - rs : t)), s.setAvailableSpace(a, l, n, A), s.logicalSpace(null);
    } else
      s.resetLogicalSpace();
    return this.logicalSpace(null), this;
  }
  /**
   * This method is used to render the axis inside the axis cell.
   *
   * @param {HTMLElement} mount The mount point.
   * @return {Selection} node where axis mounted
   * @memberof AxisCell
   */
  /* istanbul ignore next */
  render(t, i) {
    if (!t)
      return this;
    let n = 0, A = 0;
    const s = this.source(), o = this.availHeight(), r = this.availWidth(), { margin: a } = this.config(), { top: l, bottom: c, left: g, right: h } = a, { show: u, orientation: d } = s.config();
    this._wrapperDiv = j(
      V(t),
      "div",
      [this],
      `${qi}-${Ay}`
    );
    const f = j(
      this._wrapperDiv,
      this.config().renderer === "html" ? "div" : "svg",
      [1],
      `${qi}-axis-container`
    );
    return this._wrapperDiv.classed(
      `${qi}-${Ay}-${d}`,
      !0
    ), f.classed(`${qi}-axis-container-${d}`, !0), this.mount(t), f.attr(zo, "100%").attr(Ra, "100%").style(zo, "100%").style(Ra, "100%").style("overflow", "visible"), n = r, A = o, u || (n = d === ai || d === ri ? r : 0, A = d === ai || d === ri ? 0 : o), this._wrapperDiv.style(zo, `${n}px`).style(Ra, `${A}px`).style("margin-top", l).style("margin-bottom", c).style("margin-left", g).style("margin-right", h), u && this.config().renderer === "svg" && this._wrapperDiv.style(
      `padding-${d}`,
      `${rs}px`
    ), s.mount(f.node()), s.render(s.mount(), i), f;
  }
  /**
   * Disposes the cell
   *
   * @return {AxisCell} Current instance of AxisCell
   * @memberof AxisCell
   */
  remove() {
    return this._wrapperDiv?.datum(null), this._wrapperDiv?.remove(), this._wrapperDiv = null, this.source() && this.source().remove(), this.mount() && this.mount().remove(), this;
  }
  getMinWidth() {
    return this.getLogicalSpace().width;
  }
  getDataPath() {
    return [
      ...this.source().config().metaInf.facets,
      {
        field: this.source().config().fieldInstance,
        sourceType: this.source().config().metaInf.sourceType
      }
    ];
  }
}
class IZ extends Ul {
  /**
   * Creates an instance of BLANK.
   * @param {Object} config The input configuration.
   * @memberof BLANK
   */
  constructor(t) {
    super(t), this._overriddenDimension = {}, ge(this, Uu[sg]);
  }
  /**
   * return the type pf SimpleCell cell.
   *
   * @readonly
   * @memberof BlankCell
   */
  get type() {
    return sg;
  }
  /**
   * This method return the value contained by this SimpleCell.
   *
   * @return {string} The text value contained by this cell.
   * @memberof BlankCell
   */
  valueOf() {
    return this.id;
  }
  key() {
    return this.id;
  }
  /**
   * return the default configuration for the text cell
   *
   * @static
   * @return {Object} Default configuration of the cell
   * @memberof BlankCell
   */
  static defaultConfig() {
    return Lu;
  }
  /**
   * This method is used to return a unique identifier for
   * the BLANK cell.
   *
   * @return {string} The unique identifier for the BLANK.
   * @memberof BlankCell
   */
  get id() {
    return this._id;
  }
  static formalName() {
    return a1;
  }
  /**
   * This method is used to obtain a serialized representation of this instance.
   *
   * @return {Object} Object with serilizable props.
   * @memberof BLANK
   */
  serialize() {
    return {
      type: sg
    };
  }
  overrideDimension(t) {
    return t == null ? this._overriddenDimension : (this._overriddenDimension = t, this);
  }
  /**
   * This method return the space taken up
   * by the text with the style applied.
   *
   * @return {Object} width and height taken up by the text.
   * @memberof BLANK
   */
  getLogicalSpace() {
    if (!this.logicalSpace()) {
      const t = {
        width: this.width || 0,
        height: this.height || 0
      };
      return this._implicitSpace = t, t;
    }
    return this.logicalSpace();
  }
  /**
   * This method is used to set the available space.
   *
   * @param {number} width The available width.
   * @param {number} height The available height.
   * @return {Instance} Returns current Instance
   * @memberof BlankCell
   */
  setAvailableSpace(t, i) {
    return this.availWidth(t), this.availHeight(i), this.logicalSpace(null), this;
  }
  /**
   * This method is used to render the BLANK cell inside
   * the provided mount point.
   *
   * @param {HTMLElement} mount The mount point for this cell.
   * @return {Instance} Returns current Instance
   * @memberof BLANK
   */
  /* istanbul ignore next */
  render(t) {
    if (t) {
      const { style: i } = this.config();
      this.mount(t);
      const n = V(t), A = j(n, "div", [this.id]);
      A.classed(`${qi}-${rZ}`, !0), A.style("width", `${this.availWidth()}px`), A.style("height", `${this.availHeight()}px`), A.html(""), i && li(A, i);
    }
    return this;
  }
  /**
   * Removes the cell(Disposal)
   *
   * @return {Instance} Returns current Instance
   * @memberof BlankCell
   */
  remove() {
    return this.mount() && this.mount().remove(), this;
  }
  getMinMeasures() {
    return 0;
  }
  getMinWidth() {
    return 0;
  }
  getDataPath() {
    const { metaInf: t } = this.config();
    return t == null || t.getDataPath == null ? [] : t.getDataPath();
  }
}
const CZ = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"> <rect width="24" height="24" fill="none" stroke="black"/> <path fill="currentColor" d="M5 11h14v2H5z"/> </svg>', EZ = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"> <rect width="24" height="24" stroke="black" fill="none"/><path fill="currentColor" d="M12 5v6H6v2h6v6h2v-6h6v-2h-6V5h-2z"/></svg>', og = 18, oy = (e) => {
  const t = e.source(), { height: i, width: n } = e.minSpacing(), { margin: A, rotation: s } = e.config(), { left: o, right: r, top: a, bottom: l } = A, c = a + l + i, g = e.config().interaction?.collapse?.enabled, h = o + r + n + (g ? og : 0), u = e.availHeight() - c, d = e.availWidth() - h, f = e.dependencies().labelManager;
  return f.setStyle(e._computedStyle), !s && e.smartText(
    f.getSmartText(t, d, u, !0)
  ), s && e.smartText(
    f.getSmartText(t, u, d, !0)
  ), e;
}, xB = (e) => {
  let t = !1;
  return (e === `${gZ}` || e === `${DB}` || e === "columnHeader") && (t = !0), t;
}, BZ = (e) => {
  const { labelManager: t } = e.dependencies(), { height: i, width: n } = e.minSpacing();
  let {
    margin: A,
    padding: s,
    show: o,
    numChars: { min: r, max: a },
    numLines: { max: l }
  } = e.config();
  const { left: c, right: g, top: h, bottom: u } = A, d = e.overrideDimension(), f = d.height ? 0 : h + u + i + s.top + s.bottom, I = d.width ? 0 : c + g + n + s.left + s.right, C = e.availHeight() - f, E = e.availWidth() - I, B = e.source(), m = e.smartText(), y = new Array(r).fill("W").join(""), D = t.getOriSize(y);
  let Q;
  if (a != null) {
    const x = Array.from({ length: a }).fill("W").join("");
    Q = t.getOriSize(x);
  }
  if (e.config({ rotation: !1 }), m.width > (E || 0) && l && (m.height = m.oriTextHeight * l), E && E < m.width && (m.width = D.width), E && E < Math.min(D.width, m.oriTextWidth)) {
    const x = t.getSmartText(
      B,
      C,
      D.height,
      !0
    ), { height: S, width: _ } = x;
    m.width = _, m.height = S, e.smartText(x);
  }
  if (!E && Q) {
    let x = m.width;
    x > Q.width && (x = Q.width), x < D.width && (x = D.width);
    const S = t.getSmartText(
      B,
      x,
      m.height,
      !0
    ), { maxWidth: _ } = S;
    m.width = _, e.smartText(S);
  }
  const { subType: p, headerPadding: w } = e.config();
  return xB(p) || (m.width += w[si] + w[oi]), o ? (d.height && (m.height = d.height), d.width && (m.width = d.width), {
    width: Math.ceil(m.width) + I,
    height: Math.ceil(m.height) + f
  }) : {
    width: 0,
    height: 0
  };
}, mZ = (e) => {
  const { className: t, headerPadding: i, padding: n, type: A, titlePadding: s, availWidth: o } = e;
  let r;
  return xB(t) ? r = s : A === wI ? r = i : A === i1 ? r = e[xh] : A === ma ? r = e[A1] : A === po ? r = e[n1] : A === "rowFacetHeader" ? (r = Object.assign({}, n), o < r.left + r.right && (r.left = 0, r.right = 0)) : r = n, r;
}, QZ = (e, t) => ([ai, ri, si, oi].forEach((i) => {
  e.style(`padding-${i}`, `${t[i]}px`);
}), e);
class Ou extends Ul {
  /**
   * Creates an instance of Text.
   * @param {Object} config The input configuration.
   * @param {string} dependencies Dependencies for the class(labelManager)
   * @memberof Text
   */
  constructor(t, i) {
    super(t), this._config.isCollapseIconVisible = !0, this._dependencies = i, this._overriddenDimension = {}, this._className = this._config.className || (this._config.type === wI ? `${qi}-${wI}-cell` : `${qi}-${Qa}-cell`), this._config.useExternalCSS === !1 ? this._computedStyle = this._config.style : this._computedStyle = zn(
      V("body"),
      this._className
    ), this._dependencies.labelManager.setStyle(this._computedStyle), ge(this, Uu[Qa]);
    const n = Array.from({
      length: this._config?.numChars?.min ?? 1
    }).fill("w").join("");
    this._minTextSpace = this._dependencies.labelManager.getOriSize(n)?.width;
    const A = this._dependencies.labelManager.getOriSize("w");
    this.minSpacing({
      width: Math.floor(A.width * 3 / 4),
      height: Math.floor(A.height / 2)
    }), oy(this);
  }
  hideCollapseIcon() {
    return this._config.isCollapseIconVisible = !1, this;
  }
  /**
   * return the type pf SimpleCell cell.
   *
   * @memberof TextCell
   */
  get type() {
    return Qa;
  }
  /**
   * This method return the value contained by this SimpleCell.
   *
   * @return {string} The text value contained by this cell.
   * @memberof TextCell
   */
  valueOf() {
    return this.source();
  }
  key(...t) {
    return t.length ? (this._key = t[0], this) : (this._key || this.key(Ut()), this._key);
  }
  /**
   * This method is used to return a unique identifier for
   * the Text cell.
   *
   * @return {string} The unique identifier for the Text.
   * @memberof TextCell
   */
  get id() {
    return this._id;
  }
  /**
   * Returns the dependencies of the instance
   *
   * @return {Object} Dependencies needed by the class
   * @memberof TextCell
   */
  dependencies() {
    return this._dependencies;
  }
  /**
   * This method is used to obtain a serialized representation of this instance.
   *
   * @return {Object} Object with serilizable props.
   * @memberof TextCell
   */
  serialize() {
    return {
      text: this.source(),
      type: Qa
    };
  }
  /**
   * return the default configuration for the text cell
   *
   * @static
   * @return {Object} Default configuration of the cell
   * @memberof TextCell
   */
  static defaultConfig() {
    return Lu;
  }
  static formalName() {
    return o1;
  }
  overrideDimension(t) {
    return t == null ? this._overriddenDimension : (this._overriddenDimension = t, this);
  }
  /**
   * This method return the space taken up
   * by the text with the style applied.
   *
   * @return {Object} width and height taken up by the text.
   * @memberof Text
   */
  getLogicalSpace() {
    if (!this.logicalSpace()) {
      let t = BZ(this);
      this.config().interaction?.collapse?.enabled && (t.width += og), t.width = Math.max(
        this.getMinWidth(),
        t.width
      ), this.logicalSpace(t), this._implicitSpace = t;
    }
    return this.logicalSpace();
  }
  /**
   * This method is used to set the available space.
   *
   * @param {number} width The available width.
   * @param {number} height The available height.
   * @return {TextCell} Returns current Instance
   * @memberof TextCell
   */
  setAvailableSpace(t, i) {
    return this.availWidth(t), this.availHeight(i), oy(this), this.logicalSpace(null), this;
  }
  /**
   * This method is used to render the Text cell inside
   * the provided mount point.
   *
   * @param {HTMLElement} mount The mount point for this cell.
   * @return {TextCell} Returns current Instance
   * @memberof Text
   */
  render(t) {
    const i = this.availWidth(), n = this.availHeight(), A = this.config(), {
      margin: s,
      show: o,
      verticalAlign: r,
      textAlign: a,
      rotation: l,
      padding: c,
      type: g,
      headerPadding: h,
      className: u,
      titlePadding: d,
      useExternalCSS: f,
      subType: I,
      isCollapseIconVisible: C,
      facetsConfig: { hyperlink: E } = {}
    } = A, { display: B } = this._computedStyle;
    if (this.mount(t), o) {
      const m = V(t), y = Object.assign(
        {
          value: this.source()
        },
        this.config().metaInf
      );
      this._elem = j(
        m,
        "div",
        [y],
        `${qi}-${sZ}`
      );
      const D = r || l ? "middle" : "top", { width: Q, height: p } = this.smartText(), { height: w } = this.minSpacing(), x = {
        top: Q + w / 2,
        middle: Q / 2 + w,
        bottom: w
      };
      m.style("vertical-align", D), this._elem.classed(this._className, !0), f === !1 && Object.entries(this._computedStyle).forEach(([k, T]) => {
        this._elem.style(k, T);
      }), !B || B === "flex" ? this._elem.classed(`${qi}-text-cell-prop-display-flex`, !0) : this._elem.style("display", B), this._elem.style(
        "transform",
        l ? `translate(${p / 2}px,
                ${x[D]}px) rotate(-90deg)` : ""
      ), this._elem.style(zo, i ? `${i}px` : "100%"), [ai, ri, si, oi].forEach((k) => {
        m.style(`margin-${k}`, `${s[k]}px`);
      });
      const S = mZ({
        className: u,
        headerPadding: h,
        padding: c,
        type: g,
        titlePadding: d,
        [xh]: A[xh],
        [xI]: A[xI]
      });
      this._elem = QZ(this._elem, S), this._className.split(" ").some((k) => k === "muze-grid-headers") && this._elem.style("justify-content", a), this._dependencies.labelManager.setStyle(this._computedStyle);
      const _ = this.config().interaction?.collapse, M = this._dependencies.labelManager.getSmartText(
        this.source(),
        // The content width = [element width] - [left padding] - [right padding].
        i - S[si] - S[oi] - (_?.enabled ? og : 0),
        n,
        !0
      ).text;
      if (xB(I))
        this._elem.style("justify-content", a), this._elem.text(M);
      else if (g === i1) {
        const { sortStatus: k, directSortEnabled: T } = this.config().metaInf;
        kS(this, {
          target: {
            type: rE,
            data: this._elem.datum(),
            meta: {}
          },
          targets: [this._elem.datum()],
          container: this._elem,
          sortStatus: k || null,
          text: {
            label: M,
            originalText: this.source(),
            align: "start"
          },
          isOverlay: !1,
          cellRender: "html",
          directSortEnabled: T
        });
      } else {
        if (this._divElem = j(
          this._elem,
          "div",
          [y],
          ".muze-facet-cell-container"
        ), this._divElem.style("display", "flex"), y?.sourceType !== sy && (g === po || g === ma)) {
          const G = _.expandIcon, N = _.collapseIcon, b = _.fields[this.config().fieldName].enabled, F = this.config().metaInf.canvasHelpers.getCanvasConfig(), R = ft(
            F.rows.totals.data.totalString,
            F.columns.totals.data.totalString
          ), v = A.metaInf.getDataPath().map((L) => `${L.value}`), O = g === po ? A.metaInf.canvasHelpers.getRowCollapseState(
            v.slice(0, -1)
          ) : A.metaInf.canvasHelpers.getColumnsCollapseState(
            v.slice(0, -1)
          );
          if (b && !v.includes(R) && !O) {
            let L;
            g === po ? L = A.metaInf.canvasHelpers.getRowCollapseState(v) : g === ma && (L = A.metaInf.canvasHelpers.getColumnsCollapseState(v)), L ? (this._iconElem = j(
              this._divElem,
              "div",
              [y],
              ".muze-facet-expand-icon"
            ), this._iconElem.html(N || EZ)) : C && (this._iconElem = j(
              this._divElem,
              "div",
              [y],
              ".muze-facet-collapse-icon"
            ), this._iconElem.html(G || CZ)), this._iconElem?.style("display", "inline-block"), this._iconElem?.style("padding-right", "4px");
          }
        }
        let k = this._divElem;
        (E?.enabled || this.config().metaInf?.hyperlinkInfo) && (k = j(k, "a", (G) => [G]), yl(
          k,
          {
            hyperlinkInfo: this.config().metaInf.hyperlinkInfo
          },
          E
        ));
        const T = j(
          k,
          "div",
          [null],
          ".muze-facet-inner-text"
        );
        g === ma ? (T.text(M), this._divElem.style("position", "sticky"), this._divElem.style("left", "0")) : g === po ? (T.text(M), this._elem.style("position", "sticky"), this._elem.style("top", "0")) : T.text(M);
      }
    }
    return this;
  }
  /**
   * Disposes the cell
   *
   * @return {TextCell} Returns current Instance
   * @memberof TextCell
   */
  remove() {
    return this._iconElem?.datum(null), this._iconElem?.remove(), this._iconElem = null, this._divElem?.datum(null), this._divElem?.remove(), this._divElem = null, this._elem?.datum(null), this._elem?.remove(), this._elem = null, this.mount() && this.mount().remove(), this._mount = null, this._source = null, this;
  }
  getMinWidth() {
    const {
      padding: { left: t, right: i } = {},
      type: n,
      metaInf: { sourceType: A } = {},
      facetsConfig: {
        interaction: { collapse: { enabled: s } = {} } = {}
      } = {}
    } = this.config(), o = s && A !== sy && (n === po || n === ma) ? og : 0;
    if (!this.config().show)
      return 0;
    const r = t + i + this._minTextSpace;
    return (this._implicitSpace?.width ? Math.min(r, this._implicitSpace.width) : r) + o;
  }
  getDataPath() {
    return this.config().metaInf.getDataPath();
  }
}
const pZ = (e) => {
  const t = e.source().config(), { width: i, height: n } = t;
  return {
    width: Math.ceil(i),
    height: Math.ceil(n + e.getCaptionSpace().height)
  };
};
class yZ extends Ul {
  /**
   * Creates an instance of GeomCell.
   * @param {Object} config The input configuration.
   * @memberof GeomCell
   */
  constructor(t) {
    super(t), this._unit = null, this._caption = null, ge(this, Uu[Ag]);
  }
  /**
   * return the type pf SimpleCell cell.
   *
   * @readonly
   * @memberof GeomCell
   */
  get type() {
    return Ag;
  }
  /**
   * This method return the value contained by this cell.
   *
   * @return {VisualUnit} Instance of visual unit contained by visual unit.
   * @memberof GeomCell
   */
  valueOf() {
    return this.source();
  }
  key() {
    return this.source().id;
  }
  /**
   * This method is used to return the id of the
   * visual unit housed by this cell.
   *
   * @return {string} The unique id of the visual unit.
   * @memberof GeomCell
   */
  get id() {
    return this.source().id();
  }
  static formalName() {
    return l1;
  }
  /**
   * This method return a serialized representation of
   * this instance.
   *
   * @return {Object} Object with serializable props.
   * @memberof GeomCell
   */
  serialize() {
    return {
      type: Ag,
      unit: this.source().serialize(),
      caption: this.caption()
    };
  }
  /**
   * return the default configuration for the geom cell
   *
   * @static
   * @return {Object} Default configuration of the cell
   * @memberof GeomCell
   */
  static defaultConfig() {
    return Lu;
  }
  /**
   * It gives the space taken by the caption of the unit
   *
   * @return {Object} return the space taken by caption
   * @memberof GeomCell
   */
  getCaptionSpace() {
    const t = this.caption();
    let i = { width: 0, height: 0 };
    return t && (i = t.getLogicalSpace()), i;
  }
  /**
   * return the space taken up by the element in the dom.
   *
   * @return {Object} Object with width and height fields.
   * @memberof GeomCell
   */
  getLogicalSpace() {
    return this.logicalSpace() || this.logicalSpace(pZ(this)), this.logicalSpace();
  }
  /**
   * This method is used to set the space available to
   * render the SimpleCell.
   *
   * @param {number} width The available width.
   * @param {number} height The available height.
   * @return {Instance} Returns current Instance
   * @memberof GeomCell
   */
  setAvailableSpace(t, i) {
    const n = this.source();
    return this.availWidth(t), this.availHeight(i), n.setSize(t, i - this.getCaptionSpace().height), this.logicalSpace(null), this;
  }
  /**
   * his method is used to render the visual unit inside the provided cell.
   *
   * @param {HTMLElement} mount The mountpoint in the table.
   * @return {Instance} Returns current Instance
   * @memberof GeomCell
   */
  render(t, i) {
    if (t) {
      this.mount(t);
      const n = this.availHeight(), A = this.availWidth(), s = this.caption(), o = j(
        V(t),
        "div",
        [1],
        `${qi}-${oZ}`
      );
      if (s) {
        const a = j(
          o,
          "div",
          [s],
          `${qi}-unit-caption`
        ).node();
        s.render(a);
      }
      const r = j(
        o,
        "div",
        [1],
        `${qi}-unit`
      );
      o.style(zo, `${A}px`).style(Ra, `${n}px`), r.style(zo, `${A}px`).style(Ra, `${n - this.getCaptionSpace().height}px`), this.source().mount(r.node()).render(this.source().mount(), i);
    }
    return this;
  }
  /**
   * Disposes the cell
   *
   * @return {Object} Current instance
   * @memberof GeomCell
   */
  remove() {
    return V(this.mount()).datum(null), this.mount() && this.mount().remove(), this.source().remove(), this._mount = null, this._source = null, this;
  }
}
const DZ = {
  [s1]: Ul,
  [o1]: Ou,
  [r1]: wB,
  [l1]: yZ,
  [a1]: IZ
}, SB = () => {
  const e = DZ;
  return {
    register: (t) => {
      const i = t.formalName();
      return i in e && (e[i] = t), SB;
    },
    get: () => e
  };
}, wZ = 250, ry = 50, ay = {
  leading: !0,
  trailing: !0
}, Sh = "vScrollPercent", Mh = "hScrollPercent", QA = "virtualScrolling", xZ = 3, SZ = (e, t, i, n, A, s, o, r, a, l, c, g, h, u) => {
  t.each(function(d) {
    const { placeholder: f, rowIndex: I, colIndex: C } = d, { startRowIdx: E, startColIdx: B } = i, { xDomainRanges: m, yDomainRanges: y } = r;
    let D, Q, p, w, x, S;
    const _ = {
      rowIndex: E + I,
      colIndex: B + C
    };
    u.row === "center" && (p = l[_.rowIndex], x = h[_.rowIndex]), u.column === 1 && (w = c[_.colIndex], S = g[_.colIndex]);
    const M = m ? m[C] : [null, null], k = y ? y[I] : [null, null], T = { x: M, y: k };
    f instanceof Ou ? D = !0 : (_Z(n, A) ? D = !cy(
      f._prevAxisDomainRanges,
      T
    ) : MZ(
      _,
      n
    ) ? (Q = !0, D = !cy(
      f._prevAxisDomainRanges,
      T
    )) : D = !0, D = s || D), D = D || f.mount() !== this;
    const G = {
      transition: o.transition,
      axisDomainRanges: T,
      rowUnitPosition: p,
      colUnitPosition: w,
      scrollLeft: a.scrollLeft,
      scrollTop: a.scrollTop,
      unitWidth: S,
      unitHeight: x,
      viewport: e.getBoundBox(),
      viewportRange: A
    };
    D ? (f.render(this, G), f._prevAxisDomainRanges = T) : Q && f.emitAllRenderHooksWhenRenderSkipped(G);
  });
}, MZ = (e, t) => {
  const { rowIndex: i, colIndex: n } = e, { rowRange: A, colRange: s } = t;
  return i >= A[0] && i <= A[1] && n >= s[0] && n <= s[1];
}, ly = (e, t) => {
  const [i, n] = e, [A, s] = t;
  return [
    [i, A],
    [n, s]
  ].every(([o, r]) => o === null && r === null ? !0 : o === null && r !== null || o !== null && r === null ? !1 : o.startIdx === r.startIdx && o.endIdx === r.endIdx);
}, cy = (e, t) => {
  const { x: i, y: n } = e, { x: A, y: s } = t;
  return e && t && ly(A, i) && ly(s, n);
}, _Z = (e, t) => e.rowRange[0] === t.rowRange[0] && e.rowRange[1] === t.rowRange[1] && e.colRange[0] === t.colRange[0] && e.colRange[1] === t.colRange[1], bZ = (e, t) => {
  e.lockModel(), e.commit(
    `${Yt}.viewport.rowStart`,
    t.rowRange[0]
  ), e.commit(
    `${Yt}.viewport.rowEnd`,
    t.rowRange[1]
  ), e.commit(
    `${Yt}.viewport.colStart`,
    t.colRange[0]
  ), e.commit(
    `${Yt}.viewport.colEnd`,
    t.colRange[1]
  ), e.unlockModel();
}, c1 = (e, { scrollLeft: t, viewPortInfo: i }) => {
  e.commit(
    `${Yt}.scrollLeft`,
    t
  ), e.commit(
    `${Yt}.viewport.colStart`,
    i?.colStart ?? 0
  ), e.commit(
    `${Yt}.viewport.colEnd`,
    i?.colEnd ?? 0
  );
}, g1 = (e, { scrollTop: t, viewPortInfo: i }) => {
  e.commit(
    `${Yt}.scrollTop`,
    t
  ), e.commit(
    `${Yt}.viewport.rowStart`,
    i?.rowStart ?? 0
  ), e.commit(
    `${Yt}.viewport.rowEnd`,
    i?.rowEnd ?? 0
  );
}, gy = (e, { scrollLeft: t = 0, scrollTop: i = 0, viewPortInfo: n }) => {
  e.lockModel(), c1(e, {
    scrollLeft: t,
    viewPortInfo: n
  }), g1(e, {
    scrollTop: i,
    viewPortInfo: n
  }), e.unlockModel();
}, hy = (e, t, i, n) => {
  const A = t - i;
  return A > 0 && Math.round(e) >= A ? n : 0;
}, h1 = (e, t) => {
  e.lockModel(), e.commit(
    `${QA}.${Sh}`,
    t
  ), e.unlockModel();
}, u1 = (e, t) => {
  e.lockModel(), e.commit(
    `${QA}.${Mh}`,
    t
  ), e.unlockModel();
}, NZ = (e) => {
  h1(e, 0);
}, FZ = (e) => {
  u1(e, 0);
}, d1 = (e) => e.get(`${QA}.${Sh}`), f1 = (e) => e.get(`${QA}.${Mh}`), RZ = (e) => e.get(`${Yt}.viewport`), uy = (e, t) => {
  const i = new Array(t);
  let n = 0;
  for (let A = 0; A < t; A++)
    i[A] = n, n += e[A];
  return {
    positions: i,
    totalMatrixContentDim: n
  };
}, dy = (e, t, i) => {
  let n = null, A = null, s = 0;
  for (let o = 0; o < e.length; o++) {
    const r = e[o], a = e[o + 1];
    if (o === e.length - 1) {
      n === null && (n = o), A === null && (A = o);
      break;
    }
    if (r <= t && a > t && (n = o), r < i + t && a >= i + t) {
      A = o;
      break;
    }
  }
  return n = n === null ? 0 : n, A = A === null ? e.length - 1 : A, s = t - e[n], {
    startIdx: n,
    endIdx: A,
    shift: s
  };
}, kZ = (e, t, i, n) => {
  const A = [];
  n.composition().visualGroup.matrix().geom().forEach((c) => {
    c.source().layers().filter((h) => {
      const { x: u, y: d } = h.axes();
      return u.id === i.id || d.id === i.id;
    }).forEach((h) => {
      (h.config().mark === HN || h.config().mark === ON) && A.push(h);
    });
  });
  const { domain: s } = i, o = A.map((c) => c.getNeighbourPointIndexForContinuationInVirtualScroll(
    e,
    s,
    (g) => g - 1
  )).filter((c) => c >= 0), r = A.map((c) => c.getNeighbourPointIndexForContinuationInVirtualScroll(
    t,
    s,
    (g) => g + 1
  )).filter((c) => c >= 0), a = Math.min(...o, e), l = Math.max(...r, t);
  return { newStartIdx: a, newEndIdx: l };
}, fy = (e, t, i, n, A, s, o = { includePointForLineContinuation: !1 }) => {
  const { step: r, paddingOuter: a, domain: l } = e;
  let c, g;
  if (t >= n)
    c = 0;
  else {
    let I = Math.floor(
      Math.max(n - t - a, 0) / r
    );
    I = Math.min(I, l.length - 1), c = I;
  }
  if (t + i <= n + A)
    g = l.length - 1;
  else {
    let I = l.length - Math.floor(
      Math.max(
        t + i - (n + A) - a,
        0
      ) / r
    ) - 1;
    I = Math.max(I, 0), g = I;
  }
  const u = Math.max(g - c + 1, 0) * r + a;
  let d = a + c * r;
  const { includePointForLineContinuation: f } = o;
  if (f) {
    const { newStartIdx: I, newEndIdx: C } = kZ(
      c,
      g,
      e,
      s
    );
    c = I, g = C;
  }
  return { startIdx: c, endIdx: g, translate: d, visibleCellDimension: u };
}, Iy = (e, t, i, n, A, s, o, r, a = { includePointForLineContinuation: !1 }) => {
  const l = [];
  for (let c = e; c <= t; c++) {
    const g = i[0][c], h = i[1][c], u = [];
    g && g.constructor.type() === "band" ? u.push(
      fy(
        {
          id: g.id,
          field: g.config().field,
          step: g.getScaleStep(),
          paddingOuter: g.getScalePaddingOuter(),
          domain: g.domain()
        },
        n[c],
        A[c],
        s,
        o,
        r,
        a
      )
    ) : u.push(null), h && h.constructor.type() === "band" ? u.push(
      fy(
        {
          id: h.id,
          field: h.config().field,
          step: h.getScaleStep(),
          paddingOuter: h.getScalePaddingOuter(),
          domain: h.domain()
        },
        n[c],
        A[c],
        s,
        o,
        r,
        a
      )
    ) : u.push(null), l.push(u);
  }
  return l;
};
class To extends e1 {
  constructor(t) {
    super(t), this.renderingState = {
      rowPositions: [],
      colPositions: [],
      unitWidths: [],
      unitHeights: [],
      totalContentWidth: 0,
      totalContentHeight: 0,
      prevViewportRanges: {
        rowRange: [0, -1],
        colRange: [0, -1]
      }
    };
  }
  draw(t) {
    this.mount(t || document.getElementById(this.renderAt())), this.initializeRenderingState();
  }
  initializeRenderingState() {
    const { config: t, gridLayout: i } = this.params, { row: n, column: A } = t, s = i.viewInfo(), { layoutDimensions: o } = s, r = o.unitWidths.primary, a = o.unitHeights.primary, l = this.component;
    let c = [], g = [], h = 0, u = 0;
    if (l.length && n === "center") {
      const { positions: d, totalMatrixContentDim: f } = uy(
        a,
        l.length
      );
      c = d, u = f;
    }
    if (l.length && A === 1) {
      const { positions: d, totalMatrixContentDim: f } = uy(
        r,
        l[0].length
      );
      g = d, h = f;
    }
    this.renderingState = {
      rowPositions: c,
      colPositions: g,
      unitWidths: r,
      unitHeights: a,
      totalContentWidth: h,
      totalContentHeight: u,
      prevViewportRanges: {
        rowRange: [0, -1],
        colRange: [0, -1]
      }
    };
  }
  updateVirtualScrollContent(t, i, n, A, s) {
    const { row: o, column: r } = this.params.config, a = this.calculateViewableMatrix(
      i,
      n,
      s,
      t
    );
    o === "center" && r === 1 && bZ(this.params.store, a), this.render({ ...a, ...A }, { scrollLeft: i, scrollTop: n }), this.renderingState.prevViewportRanges = {
      rowRange: a.rowRange,
      colRange: a.colRange
    };
  }
  calculateViewableMatrix(t, i, n, A) {
    const { row: s, column: o, border: r } = this.params.config, {
      rowPositions: a,
      colPositions: l,
      unitWidths: c,
      unitHeights: g,
      totalContentWidth: h,
      totalContentHeight: u
    } = this.renderingState, { width: d, height: f } = this.getBoundBox(), I = this.component, C = r.width, { xAxes: E, yAxes: B } = n;
    let m = 0, y = I.length - 1, D = 0, Q = I.length ? I[0].length - 1 : -1, p = 0, w = 0, x = null, S = null;
    const _ = !!(A.layers() && A.layers().filter(({ mark: M }) => M === HN || M === ON).length);
    if (I.length && s === "center") {
      const { startIdx: M, endIdx: k, shift: T } = dy(
        a,
        i,
        f
      );
      m = M, y = k, p = T + hy(
        i,
        u,
        f,
        C
      ), S = Iy(
        m,
        y,
        B,
        a,
        g,
        i,
        f,
        A,
        {
          includePointForLineContinuation: _
        }
      );
    }
    if (I.length && o === 1) {
      const { startIdx: M, endIdx: k, shift: T } = dy(
        l,
        t,
        d
      );
      D = M, Q = k, w = T + hy(
        t,
        h,
        d,
        C
      ), x = Iy(
        D,
        Q,
        E,
        l,
        c,
        t,
        d,
        A,
        {
          includePointForLineContinuation: _
        }
      );
    }
    return {
      rowRange: [m, y],
      colRange: [D, Q],
      shifts: [p, w],
      xDomainRanges: x,
      yDomainRanges: S
    };
  }
  render(t, i) {
    const {
      classPrefix: n,
      row: A,
      column: s,
      dimensions: o,
      border: r,
      isFacet: a,
      showHeaders: l
    } = this.params.config, {
      rowPositions: c,
      colPositions: g,
      unitWidths: h,
      unitHeights: u,
      prevViewportRanges: d
    } = this.renderingState, f = j(
      this.mount(),
      "div",
      [1],
      `${n}-grid-${A}-${s + 1}`
    ).classed(`${n}-grid-${A}`, !0).classed(`${n}-grid`, !0);
    this.applyScroll(f);
    const I = `${n}-grid`, C = j(
      f,
      "table",
      ["layout"],
      `${I}-table`
    ), E = j(C, "tbody", ["layout"], `${I}-body`), {
      rowRange: B,
      colRange: m,
      shifts: y,
      xDomainRanges: D,
      yDomainRanges: Q,
      transition: p,
      forceRender: w
    } = t, [x, S] = B, [_, M] = m, [k, T] = y;
    let G = this.component.slice(x, S + 1).map((L, U) => {
      const H = L.slice(_, M + 1);
      return H._key = x + U, H;
    }), { viewMatrix: N, spans: b } = $N(G, A, s);
    N = N.map((L, U) => (L._key = x + U, L));
    const F = j(
      E,
      "tr",
      N,
      `${I}-tr`,
      {},
      (L) => L._key
    ), R = j(
      F,
      "td",
      (L, U) => L.map((H, z) => ({ placeholder: H, rowIndex: U, colIndex: z })).filter((H) => H.placeholder !== null),
      `${I}-td`,
      {
        update: (L, U) => {
          let { externalClassname: H } = U.placeholder.config();
          H = [...new Set(H)], H && H.map(
            (z) => L.classed(`${I}-${z}`, !0)
          );
        }
      },
      (L) => L.placeholder.id
    );
    XN(R, b, { dimensions: o, border: r }, `${A}-${s}`, {
      startRowIdx: x,
      startColIdx: _
    }), SZ(
      this,
      R,
      {
        startRowIdx: x,
        startColIdx: _
      },
      d,
      {
        rowRange: B,
        colRange: m
      },
      w,
      {
        transition: p
      },
      {
        xDomainRanges: D,
        yDomainRanges: Q
      },
      i,
      c,
      g,
      h,
      u,
      this.params.config
    ), R.exit().each((L) => {
      L.placeholder.remove();
    });
    let v = R;
    const O = {};
    R.each((L) => {
      const { placeholder: U, colIndex: H } = L;
      O[H] === void 0 && (O[H] = !1), O[H] = O[H] || U.config().show;
    }), v = R.filter((L) => O[L.colIndex]), this.params.gridLayout.config().cellRenderer === "html" && (A === "center" && f.style(
      "border-bottom",
      `${r.width}px ${r.style} ${r.color}`
    ), r.showValueBorders.bottom = !1, r.showRowBorders.bottom = !1), t1({
      cells: v,
      border: r,
      row: A,
      column: s,
      isFacet: a,
      showHeaders: l
    }), A === "center" && f.property("scrollTop", k), s === 1 && f.property("scrollLeft", T);
  }
}
const Cy = (e, t, i, n) => {
  V(e).selectAll(`.${t}-grid`).property(n, i);
}, TZ = (e, t) => {
  const i = t.params.config.classPrefix;
  return {
    horizontal: () => {
      [0, 1, 2].forEach((n) => {
        const A = t.component[n][1];
        A instanceof To || Cy(
          `#${A.renderAt()}`,
          i,
          e,
          "scrollLeft"
        );
      });
    },
    vertical: () => {
      [0, 1, 2].forEach((n) => {
        const A = t.component[1][n];
        A instanceof To || Cy(
          `#${A.renderAt()}`,
          i,
          e,
          "scrollTop"
        );
      });
    }
  };
};
class MB extends Os {
  constructor(t) {
    super(t.name, t.config.dimensions, 0), this.gridComponents = [], this.setParams(t), this._prevScrollLeft = null, this._prevScrollTop = null;
  }
  sanitizeGrid() {
    let t = 0, i = 0;
    const { viewMatricesInfo: n, layoutDimensions: A } = this.layout.viewInfo(), s = this.layout.scrollInfo(), { viewHeight: o, viewWidth: r, unitHeights: a, unitWidths: l } = A;
    for (let c = 0; c < 3; c++) {
      this.gridComponents.length && this.gridComponents[c] instanceof Array || (this.gridComponents[c] = []);
      for (let g = 0; g < 3; g++) {
        let h = {
          height: o[c],
          width: r[g],
          unitHeights: a,
          unitWidths: l
        };
        const u = n.matrices[`${SA[c]}`][g], d = `${SA[c]}-${vr[g]}`, f = SA[c], I = g, C = {
          dimensions: h,
          border: A.border,
          classPrefix: this.params.config.classPrefix,
          scrollInfo: s,
          row: f,
          column: I
        };
        if ((f === "center" || I === 1) && (h = {
          height: o[c],
          width: r[g] + (s.horizontal || !A.border.showValueBorders.right ? 0 : A.border.width),
          unitHeights: a,
          unitWidths: l
        }, C.dimensions = h), this.gridComponents[c][g] instanceof Os) {
          const { isFacet: E, showHeaders: B } = this.params.component.config();
          C.isFacet = E, C.showHeaders = B, this.gridComponents[c][g].updateWrapper({
            name: d,
            component: u,
            config: C,
            gridLayout: this.params.component,
            store: this.params.store
          });
        } else {
          const { isFacet: E, showHeaders: B } = this.params.component.config();
          C.isFacet = E, C.showHeaders = B;
          const m = f === "center" || I === 1 ? To : e1, y = new m({
            name: d,
            component: u,
            config: C,
            gridLayout: this.params.component,
            store: this.params.store
          });
          this.gridComponents[c].push(y);
        }
        c === 0 && (i += h.width), g === 0 && (t += h.height);
      }
    }
    this.boundBox({ height: t, width: i }), this.component = this.gridComponents, this.allComponents = this.gridComponents;
  }
  scrollBarManager(...t) {
    return t.length ? (this._scrollBarManager = t[0], this) : this._scrollBarManager;
  }
  /**
   * Attaches a mousewheel listener to the center matrix, based on which the scrolling can occur.
   * It uses the scroll component to change the position of the scroller, which ultimately scrolls the center matrix
   *
   *
   * @return {GridComponent} Instance of the GridComponent
   */
  attachScrollListener(t) {
    const { layoutRootNodeId: i, scrollableBoundBox: n } = t, A = this.scrollBarManager();
    let s = null, o = null;
    if (n)
      return V(`#${i}`).on("wheel", () => {
        const r = Bt();
        s || (o = r.currentTarget.getBoundingClientRect()), clearTimeout(s), s = setTimeout(() => {
          s = null, o = null;
        }, wZ);
        const { deltaX: a, deltaY: l, clientX: c, clientY: g } = r;
        let { left: h, top: u } = o;
        const d = c - h, f = g - u;
        if (d >= n.left && d <= n.left + n.width && f >= n.top && f <= n.top + n.height) {
          if (a !== 0 && Math.abs(a) > Math.abs(l)) {
            const C = A._scrollBarComponents.horizontal;
            if (C) {
              const E = C.component.logicalSpace().totalLength, B = A._dependencies.store.get(
                "virtualScrolling.scrollLeft"
              ), m = A._attachedComponents.grid.layout.viewInfo().layoutDimensions.viewWidth[1];
              (a > 0 && B >= 0 && Math.round(B) < E - m || a < 0 && B > 0 && Math.round(B) <= E - m) && A.preventBrowserScroll("horizontal", r);
            }
            A.triggerScrollBarAction("horizontal", a);
          }
          if (l !== 0 && Math.abs(a) < Math.abs(l)) {
            const C = A._scrollBarComponents.vertical;
            if (C) {
              const E = C.component.logicalSpace().totalLength, B = A._dependencies.store.get(
                "virtualScrolling.scrollTop"
              ), m = A._attachedComponents.grid.layout.viewInfo().layoutDimensions.viewHeight[1];
              (l > 0 && B >= 0 && Math.round(B) < E - m || l < 0 && B > 0 && Math.round(B) <= E - m) && A.preventBrowserScroll("vertical", r);
            }
            A.triggerScrollBarAction("vertical", l);
          }
        }
      }), this;
  }
  performScrollAction(t, i) {
    return TZ(i, this)[t](), this;
  }
  getBoundBox() {
    const { top: t, left: i } = this.component[0][0].boundBox(), { height: n, width: A } = this.boundBox();
    return {
      top: t,
      left: i,
      height: n,
      width: A
    };
  }
  updateWrapper(t) {
    return this._prevScrollLeft = null, this._prevScrollTop = null, this.name(t.name), this.boundBox(t.config.dimensions), this.setParams(t), this;
  }
  setParams(t) {
    return this.component = t.component, this.params = t, this.layout = t.layout, this.target(t.config.target), this.className(t.config.className), this.sanitizeGrid(), this;
  }
  attachListener(t) {
    return this.attachScrollListener(t), this;
  }
  updateScrollableRowsCompsContent(t, i, n, A, s) {
    [1, 0, 2].forEach((o) => {
      const r = this.allComponents[1][o];
      r instanceof To && r.updateVirtualScrollContent(
        t,
        i,
        n,
        A,
        s
      );
    });
  }
  updateScrollableColumnsCompsContent(t, i, n, A, s) {
    [1, 0, 2].forEach((o) => {
      const r = this.allComponents[o][1];
      r instanceof To && r.updateVirtualScrollContent(
        t,
        i,
        n,
        A,
        s
      );
    });
  }
  updateScrollableAllCompsContent(t, i, n, A, s) {
    [1, 0, 2].forEach((o) => {
      [1, 0, 2].forEach((r) => {
        const a = this.allComponents[o][r];
        a instanceof To && a.updateVirtualScrollContent(
          t,
          i,
          n,
          A,
          s
        );
      });
    });
  }
  updateScrollableCompsContent(t, i, n, A = !1, s) {
    const o = this._prevScrollLeft, r = this._prevScrollTop, a = i !== o || n !== r, l = {
      forceRender: A
    };
    a && (o !== null || r !== null) && (l.transition = {
      disabled: !0
    }), i !== o && n !== r || A ? this.updateScrollableAllCompsContent(
      t,
      i,
      n,
      l,
      s
    ) : i !== o ? this.updateScrollableColumnsCompsContent(
      t,
      i,
      n,
      l,
      s
    ) : n !== r && this.updateScrollableRowsCompsContent(
      t,
      i,
      n,
      l,
      s
    ), this._prevScrollLeft = i, this._prevScrollTop = n;
  }
}
const I1 = {
  position: "top",
  align: "left",
  padding: 4,
  className: `${ds}-title-container`
}, C1 = {
  position: "top",
  align: "left",
  padding: 4,
  maxLines: 2,
  className: `${ds}-subtitle-container`
}, ka = {
  className: `${ds}-message-container`,
  baseFontLimit: 16,
  upperFontLimit: 24,
  baseSizeLimit: 100,
  upperSizeLimit: 300,
  fractionImage: 0.8,
  fractionChild: 0.7
}, Ol = "canvas", vZ = {
  color: {},
  size: {},
  shape: {},
  backgroundColor: {}
}, Ey = {
  [ol]: {
    value: null,
    meta: {
      typeCheck: "constructor",
      typeExpected: "Array"
    }
  },
  [rl]: {
    value: null,
    meta: {
      typeCheck: "constructor",
      typeExpected: "Array"
    }
  },
  [Kn]: {
    value: null,
    meta: {
      typeCheck: "constructor",
      typeExpected: "Object",
      sanitization: (e) => typeof e == "string" || !e ? {
        field: e
      } : e
    }
  },
  [ko]: {
    value: null,
    meta: {
      typeCheck: "constructor",
      typeExpected: "Object",
      sanitization: (e) => typeof e == "string" || !e ? {
        field: e
      } : e
    }
  },
  [Ss]: {
    value: null,
    meta: {
      typeCheck: "constructor",
      typeExpected: "Object",
      sanitization: (e) => typeof e == "string" || !e ? {
        field: e
      } : e
    }
  },
  [Wn]: {
    value: null,
    meta: {
      typeCheck: "constructor",
      typeExpected: "Object",
      sanitization: (e) => typeof e == "string" || !e ? {
        field: e
      } : e
    }
  },
  [FN]: {
    value: [],
    meta: {
      typeCheck: "constructor",
      typeExpected: "Array"
    }
  },
  [RN]: {
    value: [],
    meta: {
      typeCheck: "constructor",
      typeExpected: "Array"
    }
  },
  [kN]: {
    value: null,
    meta: {
      typeCheck: "constructor",
      typeExpected: "Object"
    }
  }
}, SI = {
  [je]: {
    value: [null, null],
    meta: {
      takesMultipleParams: !0,
      typeCheck: ([e, t]) => typeof e == "function" && typeof t == "object",
      sanitization: ([e, t]) => {
        let i = e;
        (typeof e == "string" || typeof e == "number" || !e) && (i = () => e);
        const n = tt({}, I1);
        return [i, tt(n, t)];
      }
    }
  },
  [un]: {
    value: [null, null],
    meta: {
      takesMultipleParams: !0,
      typeCheck: ([e, t]) => typeof e == "function" && typeof t == "object",
      sanitization: ([e, t]) => {
        let i = e;
        (typeof e == "string" || typeof e == "number" || !e) && (i = () => e);
        const n = tt({}, C1);
        return [i, tt(n, t)];
      }
    }
  }
};
class _B extends Os {
  components;
  params;
  constructor(t) {
    const i = t.config.position;
    super(t.name, t.config.measurement.legendSpace[i], 0), this.setParams(t);
  }
  renderLegend(t) {
    throw new Error(
      `It should be implemented by the child class: ${t}`
    );
  }
  draw(t) {
    this.renderLegend(t || document.getElementById(this.renderAt()));
  }
  updateWrapper(t) {
    const i = t.config.position;
    return this.name(t.name), this.boundBox(t.config.measurement.legendSpace[i]), this.setParams(t), this;
  }
  setParams(t) {
    this.components = t.component, this.params = t, this.target(t.config.target), this.position(t.config.position);
    const { alignWith: i, alignment: n } = GZ(
      t.config.position
    );
    this.className(t.config.className), this.alignWith(t.config.alignWith || i), this.alignment(t.config.alignment || n);
  }
  setComponentInfo(t) {
    const { rootNode: i } = t;
    this.components.forEach((n) => {
      n.legend.setParentInfo({ canvasRoot: i });
    });
  }
}
function GZ(e) {
  let t = null;
  const i = `${SA[1]}-${vr[1]}`;
  switch (e) {
    case se:
    case mA:
      t = D7;
      break;
    case Me:
    case Tn:
      t = q0;
      break;
    default:
      t = q0;
  }
  return { alignment: t, alignWith: i };
}
const By = (e) => {
  const { DIMENSION: t } = J.FieldType;
  return e.some((i) => i.type() === t);
}, LZ = (e) => {
  const { rowFacets: t, colFacets: i, rowProjections: n, colProjections: A } = e;
  if (t.length || i.length)
    return !0;
  const s = A.flat(), o = n.flat();
  return !!((By(s) || By(o)) && (s.length > 1 || o.length > 1));
}, UZ = ({ firebolts: e, action: t }) => {
  let i;
  const n = {
    operator: "or",
    conditions: []
  };
  let A = !0;
  return e.forEach((s) => {
    const o = s.getPropagationIdentifiers(t);
    if (o) {
      const { query: r } = o;
      i = o.interpolated, n.conditions = [
        ...n.conditions,
        ...r.conditions
      ];
    }
    A = A && o === null;
  }), {
    propIdentifiers: A ? null : n.conditions.length ? n : null,
    interpolated: i
  };
}, my = (e) => {
  if (e.context.composition().visualGroup) {
    const n = e.interactionPolicy(), A = n.behaviours, s = n.sideEffects;
    e.applyPropagationPolicy({
      behaviours: A,
      sideEffects: s
    });
  }
}, Qy = {
  tooltip: (e, t) => {
    const i = t.context.composition().visualGroup.resolver().getAllFields();
    return LZ(i) ? {
      selectionSummary: {
        order: 1,
        className: "tooltip-content-container-selectionSummary-crosstab",
        showMultipleMeasures: !0
      },
      highlightSummary: {
        order: 0,
        className: "tooltip-content-container-highlightSummary-crosstab"
      }
    } : {
      selectionSummary: {
        order: 0,
        className: "tooltip-content-container-selectionSummary-default",
        showMultipleMeasures: !1
      },
      highlightSummary: {
        order: 1,
        className: "tooltip-content-container-highlightSummary-default"
      }
    };
  },
  selectionBox: (e, t) => {
    const i = t.context.composition().visualGroup.resolver().getAllFields(), n = W(
      e.sideEffects,
      "selectionBox",
      "persistent"
    ), A = {};
    return n === void 0 && (l$(i) ? A.persistent = !0 : A.persistent = !1), A;
  }
}, py = (e, t, i) => {
  const n = ft(
    t[e],
    t.sideEffects[e]
  );
  if (e in Qy) {
    const A = Qy[e](t, i);
    return tt(A, n);
  }
  return n || {};
}, OZ = (e, t, i) => {
  const n = t.context.composition().visualGroup, A = t.sideEffects();
  for (const s in A) {
    const o = A[s], r = py(s, e, t);
    o.config(r);
  }
  n.matrix().geom().forEach((s) => {
    const o = s.source().firebolt();
    o.groupFirebolt(t), o.config(
      Object.assign({}, e, {
        valueParser: n.valueParser()
      })
    );
    const r = o.sideEffects();
    for (const a in r) {
      const l = r[a], c = py(a, e, t);
      l.config(c);
    }
    i && o.sideEffects().tooltip.disable();
  });
}, HZ = (e) => {
  const t = e.context.config().interaction, i = e.context.composition().visualGroup, { rowProjections: n, colProjections: A } = i.resolver().getAllFields(), s = n.flat(), o = A.flat(), r = o.flat().filter(
    (h) => h.subtype() === "temporal" && h.as() === "continuous"
  ), a = s.flat().filter(
    (h) => h.subtype() === "temporal" && h.as() === "continuous"
  );
  if (r.length && bh(s) || a.length && bh(o)) {
    const h = t.brush, u = t.sideEffects.selectionBox;
    h.mode = ft(h.mode, r.length ? "x" : "y"), u.persistent = ft(u.persistent, !0);
  }
  e.config(
    Object.assign({}, t, {
      valueParser: i.valueParser()
    })
  );
  const l = e.sideEffects(), c = t.sideEffects.tooltip.common;
  let g = !1;
  c ? (l.tooltip.enable(), g = !0) : l.tooltip.disable(), OZ(t, e, g);
}, Yd = (e, t) => {
  const i = t.context.composition();
  return i ? i.visualGroup.findUnitByPayload(e) : null;
}, yy = (e, t) => {
  e.dissociateBehaviour(t);
}, Dy = (e, t) => {
  e.registerPhysicalBehaviouralMap({
    hover: {
      behaviours: [t]
    }
  });
}, _h = (e, t, i) => (i.set(`${e}`, t), i), wy = (e) => {
  if (e) {
    const t = (n) => {
      const { field: A, value: s, collapsed: o, children: r } = n, a = /* @__PURE__ */ new Map();
      return r && r.length > 0 && r.forEach((l) => {
        _h(l.value, t(l), a);
      }), { field: A, value: s, collapsed: o, children: a };
    }, i = /* @__PURE__ */ new Map();
    return e.forEach((n) => {
      _h(n.value, t(n), i);
    }), i;
  }
  return null;
}, xy = (e, t) => {
  let i = e;
  for (let n = 0; n < t.length; n++) {
    const { field: A, collapsed: s } = t[n];
    let { value: o } = t[n];
    o = J.getActualValue(o);
    const r = i.get(o);
    if (r)
      r.field === A && r.value === o && (typeof s == "boolean" && _h(o, { ...i.get(o), collapsed: s }, i), i = r.children);
    else {
      const a = /* @__PURE__ */ new Map();
      _h(
        o,
        {
          field: A,
          value: o,
          collapsed: s,
          children: a
        },
        i
      ), i = a;
    }
  }
}, E1 = (e, t) => {
  let i = null, n = e;
  t = t.map(
    (A) => J.isInvalid(A) ? J.getActualValue(A) : A.toString()
  );
  for (let A = 0; A < t.length; A++) {
    const s = t[A], o = n.get(s);
    if (o)
      i = o, n = o.children;
    else {
      i = null;
      break;
    }
  }
  return i ? i.collapsed : null;
}, PZ = (e, t) => {
  const i = e.props.rows.expandCollapseState || /* @__PURE__ */ new Map();
  if (!t)
    return i;
  if (!t.length)
    return !1;
  const n = E1(i, t), { collapseAll: A } = e.config().rows.facets.interaction.collapse;
  return n === null && A ? !0 : n;
}, YZ = (e, t) => {
  const i = e.props.columns.expandCollapseState || /* @__PURE__ */ new Map();
  if (!t)
    return i;
  if (!t.length)
    return !1;
  const n = E1(i, t), { collapseAll: A } = e.config().columns.facets.interaction.collapse;
  return n === null && A ? !0 : n;
}, JZ = (e, t) => {
  if (!(e && t.getField(e)))
    return !0;
  const i = t.getField(e).subtype();
  return !(i === it.CONTINUOUS || i === it.TEMPORAL);
}, Sy = (e, t) => e === "" || e && !t.getField(e), KZ = (e, t) => {
  let i, n, A;
  const s = [e.columns(), e.rows()].flat(2).map((r) => we(r) ? r.field instanceof ah ? r.field.getMembers() : r.field : r instanceof ah ? r.getMembers() : r);
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    if (Array.isArray(s[r]))
      for (let c = 0; c < a.length; c++) {
        const g = a[c];
        if (Sy(g, e.data())) {
          A = g;
          break;
        }
        if (JZ(g, e.data())) {
          n = g;
          break;
        }
      }
    else if (Sy(a, e.data())) {
      A = a;
      break;
    }
  }
  const o = A || A === "";
  return t.forEach((r) => {
    const a = e[r]();
    switch (r) {
      case ol:
      case rl:
        (o || n) && (i = {
          message: o ? "Field not found in DataModel schema" : n ? "Unsupported field in shared axis" : "",
          cause: `Unsupported field name: ${A || n ? A || n : ""}`
        });
        break;
      case NN: {
        const l = a instanceof J ? a.isEmpty() : !a.hasOneValue(), c = a.isDisposed();
        (l || c) && (i = {
          message: "Insufficient data passed",
          cause: "Insufficient data passed"
        });
        break;
      }
      default:
        return {};
    }
  }), i;
}, WZ = (e) => {
  const t = e.config(), i = e.props;
  t.rows.layout && (i.rows.layout = t.rows.layout), t.columns.layout && (i.columns.layout = t.columns.layout);
  const { enabled: n, state: A } = t.rows.facets.interaction.collapse;
  n ? !i.rows.expandCollapseState && A && (i.rows.expandCollapseState = wy(
    A
  )) : i.rows.expandCollapseState = null;
  const { enabled: s, state: o } = t.columns.facets.interaction.collapse;
  s ? !i.columns.expandCollapseState && o && (i.columns.expandCollapseState = wy(
    o
  )) : i.columns.expandCollapseState = null, i.legend = tt({}, vZ);
}, VZ = (e) => {
  const t = e._registry.components;
  return [new t.VisualGroup(
    e._registry,
    Object.assign(
      {
        throwback: e._throwback,
        store: e._store
      },
      e.dependencies()
    ),
    e.createChildEventManager()
  )];
}, jZ = (e) => {
  if (e) {
    const t = {}, { border: i, gridLines: n } = e;
    return n && (t.x = !!n.x, t.y = !!n.y), {
      facetsUserConfig: {
        isBorderPresent: i || {},
        isGridLinePresent: t,
        format: e.facets && e.facets.format ? e.facets.format : (s) => s
      },
      isFacet: !1
    };
  }
  return {};
}, qZ = (e) => (e.scrollBar.thickness = Math.min(
  50,
  Math.max(
    e.scrollBar.buttons.show ? 10 : 4,
    e.scrollBar.thickness
  )
), e), zZ = (e) => {
  ["color", "shape", "size"].forEach((t) => {
    e.legend?.[t]?.fields && (e.legend[t].fields = {});
  });
}, ZZ = (e, t) => {
  const i = {};
  return t.forEach((n) => {
    e && e[n] && Object.keys(e[n]).length && (i[n] = {});
  }), i;
}, $Z = (e) => {
  const t = e._layoutManager, i = t.getComponent(pr), n = t.getComponent(EI), A = i && i.getBoundBox(), s = e.composition().visualGroup, o = V(
    `#${t.getRootNodeId()}`
  ).node();
  n && n.setComponentInfo({ rootNode: o }), s.matrix().parentContainerInf({
    el: o,
    dimensions: A
  });
}, XZ = (e) => (t, i) => {
  const n = [...t].reduce((o, r) => {
    const { target: a } = r, l = `${a.map((c) => `${c.field}-${c.value}`)}`;
    return o.set(l, r), o;
  }, /* @__PURE__ */ new Map());
  e.props[i].layout = [...n.values()], (i === "rows" ? e.yAxes() : e.xAxes()).forEach((o) => o.resetRenderConfig(o.config())), e.computeLayout({
    recomputeGridSpace: !1,
    extendDomain: !1,
    skipPeripheralComponentsLayout: !0
  }), e.composition().componentWrappers.forEach((o) => {
    o instanceof _B && o.shouldRender(!1);
  });
}, t$ = (e) => {
  const t = Object.keys(e).filter((i) => i !== Ii && i !== Ci).reduce((i, n) => (i[n] = [e[n][0], e[n][1]], i), {});
  return !B1(Object.keys(t), Object.values(t)) && (e[Ii][1] !== e[Ii][0] || e[Ci][1] !== e[Ci][0]);
}, e$ = (e) => {
  if (e.composition() == null)
    return;
  const t = e.composition().visualGroup, i = e.registry().interactions.visualGroup;
  e.firebolt().registerPhysicalActions(i.physicalActions.get()).registerBehaviouralActions(i.behaviours.get()).registerSideEffects(i.sideEffects.get());
  const n = e._allOptions;
  for (const s in n)
    if (Object.prototype.hasOwnProperty.call(n, s)) {
      const o = e[s]();
      o !== null && t[s] && t[s](o);
    }
  const { invalidValues: A } = e.config();
  t.valueParser(bC(A)), t.interactionRegistry(e.firebolt().getInteractions()), t._canvasHelpers = {
    updateColumnWidths: XZ(e),
    getColumnWidthState: (s, o) => {
      const r = e.composition().layout[o ? "_rowMatrix" : "_columnMatrix"];
      e.once("afterLayout", () => {
        s && s({
          serialize: () => r.blueprints()
        });
      });
    },
    getMinTargetDimensions: (s, o) => {
      const r = e.config()[o ? "rows" : "columns"].minWidth;
      return e.composition().layout[o ? "_rowMatrix" : "_columnMatrix"].getMinTargetDimensions(s, { minWidth: r });
    },
    isDisposed: () => !!e._disposed,
    afterDisposed: (s) => e.on("afterDisposed", s),
    disableBehaviour: (s) => {
      yy(e.firebolt(), s);
    },
    disableLegendBehaviour: (s) => {
      const { color: o, shape: r, size: a } = e.composition().legend;
      [o, r, a].forEach((l = []) => {
        l.forEach((c) => {
          yy(c.firebolt(), s);
        });
      });
    },
    enableBehaviour: (s) => {
      Dy(e.firebolt(), s);
    },
    enableLegendBehaviour: (s) => {
      const { color: o, shape: r, size: a } = e.composition().legend;
      [o, r, a].forEach((l = []) => {
        l.forEach((c) => {
          Dy(c.firebolt(), s);
        });
      });
    },
    getMatrixDimensions: () => {
      const s = e.composition().layout.viewInfo().layoutDimensions;
      return {
        heights: s.viewHeight,
        widths: s.viewWidths
      };
    },
    onHScroll: (s) => {
      const { hScrollBar: o } = e.composition();
      o && o.component.onScroll(s);
    },
    propagateIdentifiers: ({ payload: s }) => {
      const o = e.composition().visualGroup.resolver(), r = o.columnGrandTotalsDataModel(), a = o.rowGrandTotalsDataModel(), l = o.greatGrandTotalsDataModel(), c = e.data(), g = s.data && s.data.contextData.data ? s.data.contextData.data.getDataPath() : null, h = g ? g.map(({ field: u }) => `${u}`) : [];
      [c, a, r, l].forEach(
        (u) => {
          u && u.propagate(
            [
              {
                criteria: g ? {
                  conditions: g.map(({ field: d, value: f }) => ({
                    field: `${d}`,
                    value: f,
                    operator: "eq"
                  })),
                  operator: "and"
                } : null,
                fields: h
              }
            ],
            {
              sourceInfo: {
                canvasId: e.alias()
              },
              fields: h,
              targetActions: {
                layer: s.targetActions.layer
              },
              ...s,
              forceDispatch: !0
            }
          );
        }
      );
    },
    onVScroll: (s) => {
      const { vScrollBar: o } = e.composition();
      o && o.component.onScroll(s);
    },
    setCanvasConfig: (s) => {
      e.config(s);
    },
    getCanvasConfig: () => e.config(),
    getFieldInfo: (s) => e.data().getField(s),
    getCanvasDimensions: () => ({
      width: e.width(),
      height: e.height()
    }),
    getRowCollapseState: (s) => PZ(e, s),
    getColumnsCollapseState: (s) => YZ(e, s),
    setRowCollapseState: (s) => {
      e.setRowCollapseState(s);
    },
    setColumnsCollapseState: (s) => {
      e.setColumnsCollapseState(s);
    },
    getRootData: () => e.data(),
    getGrandTotalsInfo: (s, o, r) => {
      const a = e.composition().visualGroup, l = e.config();
      switch (s) {
        case "rowGrandTotals":
          return a.resolver().getRowGrandTotalsDataModelInfo(o, l, r);
        case "columnGrandTotals":
          return a.resolver().getColumnGrandTotalsDataModelInfo(o, l, r);
        case "greatGrandTotals":
          return a.resolver().getGreatGrandTotalsDataModelInfo(l, r);
      }
    },
    getSubTotalsInfo: (s, o, r) => {
      const a = e.composition().visualGroup, l = e.config();
      switch (s) {
        case "column":
          return a.resolver().getColumnsubTotalsDataModelInfo(l, o, r);
        case "row":
          return a.resolver().getRowsubTotalsDataModelInfo(l, o, r);
      }
    }
  }, t.createMatrices(), e._cachedProps = {};
}, B1 = (e, t) => {
  let i = () => !1;
  return !e.every((n, A) => {
    switch (n) {
      case ol:
      case rl:
      case FN:
      case je:
      case DB:
      case RN:
        i = Is("Array");
        break;
      case Ss:
      case Wn:
      case Kn:
      case NN:
      case kN:
      case C7:
        i = Is("Object");
        break;
      case Ii:
      case Ci:
        i = Is("number");
        break;
      default:
        i = () => !0;
        break;
    }
    const s = t[A][0], o = t[A][1];
    return i(s, o);
  });
}, i$ = (e) => {
  const t = e._store, i = Object.keys(e._allOptions), n = [...i, ...Object.keys(SI)], A = [...i, ...Object.keys(SI)].map(
    (s) => `${dC}.${s}`
  );
  t.registerChangeListener(
    A,
    (...s) => {
      let o = !1;
      const r = e.data();
      if (r) {
        if ([ol, rl].forEach((l) => {
          const c = e[l]();
          r$(c) && (e[l]([bt]), o = !0);
        }), !![ol, rl].find((l) => {
          const c = e[l]();
          return !!a$(c);
        }) && !r.getField(bt)) {
          const l = r.calculateVariable(
            {
              name: bt,
              type: Bs
            },
            [dg],
            () => 1
          );
          e.data(l);
        }
      } else
        o = !0;
      if (!o) {
        const a = B1(
          n,
          n.map((g, h) => [e._prevProps[g], s[h][1]])
        ), l = t$(
          n.reduce((g, h, u) => (g[h] = [e._prevProps[h], s[u][1]], g), {})
        );
        n.forEach((g, h) => {
          e._prevProps[g] = s[h][1];
        });
        const c = KZ(e, n);
        if (c && c.message)
          throw new Zi(c.message, {
            cause: `${c.cause}`
          });
        l ? e.updateSize() : a && e.mount() && (WZ(e), e$(e), e.reflow());
      }
    },
    !0
  );
}, n$ = (e) => {
  const t = e.composition().visualGroup.matrix(), i = [
    t.column().getBottomAxes().map((A) => A.source()),
    t.column().getTopAxes().map((A) => A.source())
  ], n = [
    t.row().getLeftAxes().map((A) => A.source()),
    t.row().getRightAxes().map((A) => A.source())
  ];
  return { xAxes: i, yAxes: n };
}, A$ = (e, { forceRender: t, scrollLeft: i, scrollTop: n }) => {
  const A = s$(e);
  if (A) {
    const s = n$(e);
    A.updateScrollableCompsContent(
      e,
      i,
      n,
      t,
      s
    );
  }
}, s$ = (e) => e.composition().componentWrappers?.find((t) => t instanceof MB), o$ = (e) => {
  e._store.registerChangeListener(
    [
      `${Yt}.scrollLeft`,
      `${Yt}.scrollTop`,
      `${rr}.domain.x`,
      `${rr}.domain.y`
    ],
    (...i) => {
      const n = i[0][1], A = i[1][1], s = i[2][1], o = i[3][1], r = e._prevDomainX === s && e._prevDomainY === o;
      e.render({
        gridRenderConfig: {
          scrollLeft: n,
          scrollTop: A,
          forceRender: !r
        }
      }), e._prevDomainX = i[2][1], e._prevDomainY = i[3][1];
    },
    !1
  );
}, r$ = (e) => e === null ? !0 : Array.isArray(e) ? !e.flat().length : !1, a$ = (e) => !!(Array.isArray(e) ? e.flat() : []).find((i) => i === bt), bh = (e) => e.every((t) => t.isContinuous()), l$ = (e) => {
  const { rowProjections: t, colProjections: i } = e, n = i.flat(), A = t.flat();
  return !!(bh(n) && bh(A));
}, c$ = (e) => {
  let t = 0;
  const i = e.xAxes() || [];
  for (let n = 0; n < i.length; n++) {
    const A = i[n].renderConfig().labels.rotation;
    if (A && A !== 0) {
      t = A;
      break;
    }
  }
  t && i.forEach((n) => {
    n.renderConfig({ labels: { rotation: t } }), n.smartTicks(n.setTickConfig());
  });
}, g$ = (e) => {
  const [t, i] = Ih.getState(), n = e._store;
  n.append("app.group", t), n.append("local.group", i);
}, h$ = () => new Oz({
  className: "muze-group-container"
}), Hu = (e) => e === Me || e === Tn ? ll : Qr, u$ = (e) => e === re ? IB : e === Zt ? CB : e === Me ? EB : BB, d$ = (e) => {
  const { legend: t } = e.props;
  [Kn, ko, Wn, Ss].forEach((i) => {
    (e.composition().legend[i] || []).forEach((A) => {
      const s = A.fieldName(), o = A.config().splitFieldInfo;
      let r;
      if (o.field ? r = W(
        t[i],
        s,
        "splitLegends",
        o.value
      ) : r = t[i][s], r)
        for (let a in r.interaction)
          A.firebolt().dispatchBehaviour(a, r.interaction[a]);
    });
  });
}, f$ = (e) => {
  e.once("afterRendered", () => {
    d$(e);
  });
};
class I$ {
  /**
   * Creates an instance of TableLayout.
   * @param {HTMLElement} mountPoint DOM element/d3 selection where the layout is to be mounted
   * @param {Object} measurement The dimensions of the layout
   * @param {Object} config configuration to be given for the layout
   * @param {Object} dependencies external dependencies.
   *
   * @memberof GenericLayout
   *
   */
  constructor(t, i, n, A) {
    this._config = {}, this._measurement = {}, this._matrices = [], this._dependencies = A, this.measurement(i), this.mountPoint(t), this.config(n);
  }
  /**
   * Returns an object which is used to recreate the layout.
   * @return {Object} the serialized components
   */
  serialize() {
    return {
      measurement: this.measurement(),
      config: this.config(),
      matrices: this.matrices()
    };
  }
  /**
  * Sets/Gets the config for the layout
  * @param {Object} config configuration for the layout
  * @return {Layout|Object} Gets the Config/ Returns this instance when set
  */
  config(t) {
    return t ? (this._config = tt(this._config || {}, t), this._config.border.width = Math.max(0, this._config.border.width), this) : this._config;
  }
  /**
   * Sets/Gets the measurement for the layout
   * @param {Object} measurement measurement for the layout
   * @return {Layout|Object} Gets the measurement/ Returns this instance when set
   */
  measurement(t) {
    return t ? (this._measurement = tt(this._measurement || {}, t), this) : this._measurement;
  }
  /**
   * Sets/Gets the matrices for the layout
   * @param {Object} matrices matrices for the layout
   * @return {Layout|Object} Gets the matrices/ Returns this instance when set
   */
  matrices(t) {
    return t ? (this._matrices = Jw.typeObj([bi, ye, Ni], t), this) : this._matrices;
  }
  /**
   * Sets/Gets the matrix for row
   * @param {Object} matrix matrices for the layout
   * @return {Layout|Object} Gets the matrix/ Returns this instance when set
   */
  rowMatrix(t) {
    return t ? (this._rowMatrix = t, this) : this._rowMatrix;
  }
  /**
   * Sets/Gets the matrix for columns
   * @param {Object} matrix matrices for the layout
   * @return {Layout|Object} Gets the matrix/ Returns this instance when set
   */
  columnMatrix(t) {
    return t ? (this._columnMatrix = t, this) : this._columnMatrix;
  }
  /**
    * Sets/Gets the matrix for value
    * @param {Object} matrix matrices for the layout
    * @return {Layout|Object} Gets the matrix/ Returns this instance when set
    */
  centerMatrix(t) {
    return t ? (this._centerMatrix = t, this) : this._centerMatrix;
  }
  /**
   * Sets/Gets the mountPoint for the layout
   * @param {Object} mountPoint mountPoint for the layout
   * @return {Layout|Object} Gets the mountPoint/ Returns this instance when set
   */
  mountPoint(t) {
    return t ? (this._mountPoint = t, this) : this._mountPoint;
  }
}
const C$ = {
  [tz]: {
    [rz]: "solid",
    [az]: "#d6d6d6",
    [HA]: 2,
    [lz]: !0,
    [cz]: 0
  },
  [Cz]: "scroll",
  [Ez]: 20,
  [hz]: { rows: [], columns: [] },
  [gz]: { rows: [], columns: [] },
  [uz]: { rows: [], columns: [] },
  [nz]: !1,
  [Az]: !1,
  [iz]: 0,
  [ez]: 0
}, E$ = {
  [$7]: 100,
  [X7]: 100,
  [sz]: 100,
  [oz]: 100
}, B$ = 0.2, m$ = 0.8, Q$ = _i.nest, p$ = (e) => e ? {
  firstMeasure: wh,
  secondMeasure: HA
} : {
  firstMeasure: HA,
  secondMeasure: wh
}, My = (e, t) => {
  let i = 0;
  for (const n in t)
    if (e < t[n]) {
      i = n;
      break;
    }
  return i;
}, m1 = (e, t) => {
  const { isTransposed: i } = t;
  let n = e[0].length > 0 ? e[0] : e[1];
  return i ? (n = e[0].length > 0 ? [...e[0]] : [], n = e[1].length > 0 ? [...n, ...e[1]] : n) : n = n.map((A, s) => {
    let o = [];
    return e[0].length > 0 && (o = [...e[0][s]]), e[1].length > 0 && (o = [...o, ...e[1][s]]), o;
  }), n;
}, y$ = (e) => {
  let t = {}, i = 0, n = gA;
  const A = Q$(), s = [], o = e._layoutMatrix, r = e.primaryMatrix(), a = e.secondaryMatrix(), { isTransposed: l, breakPage: c } = e.config();
  if (l) {
    if (r.length === 0 ? n = gA : a.length === 0 ? n = Io : n = r.length >= a.length ? gA : Io, r.length > 0) {
      for (let h = 0; h < r.length - 1; h++)
        s.push(h);
      s.push(r.length - 1), n === Io && (i = r.length - 1);
    }
    if (a.length > 0) {
      const h = r.length;
      for (let u = a.length - 1; u > 0; u--)
        s.push(u + h);
      s.push(h), n === gA && (i = h);
    }
    s.forEach((h) => {
      let u = -1;
      return A.key((d) => (u++, `${d[h].key()}-${My(u, c)}`));
    });
    let g = [];
    g = o[0].map(
      (h, u) => o.map((d) => d[u])
    ), t = A.entries(g);
  } else {
    if (r.length === 0 ? n = gA : a.length === 0 ? n = Io : n = r.length >= a.length ? gA : Io, r.length > 0) {
      for (let g = 0; g < r[0].length - 1; g++)
        s.push(g);
      s.push(r[0].length - 1), (n === Io || a.length === 0) && (i = r[0].length - 1);
    }
    if (a.length > 0) {
      const g = r.length > 0 ? r[0].length : 0;
      for (let h = a[0].length - 1; h > 0; h--)
        s.push(h + g);
      s.push(g), n === gA && (i = g);
    } else
      i = r.length > 0 ? r[0].length - 1 : 0;
    s.forEach((g) => {
      let h = -1;
      return A.key((u) => (h++, `${u[g].key()}-${My(h, c)}`));
    }), t = A.entries(o);
  }
  return { tree: t, lastLevelKey: i };
}, D$ = (e, t) => e ? {
  height: 0,
  width: t.width
} : {
  height: t.height,
  width: 0
}, w$ = (e, t, i, n = [], A = {}) => {
  const { firstMeasure: s, secondMeasure: o } = t;
  let r = 0, a = 0;
  return e.values.forEach((l) => {
    let c = 0, g = 0;
    l.forEach((h, u) => {
      h.setAvailableSpace();
      let d = {
        ...h.getLogicalSpace({ useRawSpace: !0 }),
        ...A.calculateSecondMeasure === !1 ? { [o]: 0 } : {}
      };
      const f = A.calculateSecondMeasure === !1 ? 0 : h.getMinMeasures(i[o]);
      g = Math.max(g, +d[o], f), n[u] = Math.max(
        n[u] || 0,
        d[s]
      ), c += +n[u];
    }), a += g, r = Math.max(r, c), e.space = {
      [o]: Math.ceil(a),
      [s]: Math.ceil(r)
    };
  }), {
    [o]: a,
    [s]: r
  };
}, bB = (e = {}, t, i, n) => {
  const { isTransposed: A = !1, unitMeasures: s } = t, { firstMeasure: o, secondMeasure: r } = p$(A), { values: a } = e, l = D$(A, s), { extraCellLengths: c } = t;
  let g = a;
  if (g.length && g[0].key) {
    const h = { [o]: 0, [r]: 0 };
    return g.forEach((u, d) => {
      const f = bB(
        u,
        t,
        i,
        n !== void 0 ? n : d
      );
      h[o] = Math.max(
        h[o],
        f[o],
        l[o]
      ), h[r] += +f[r];
    }), e.space = h, h;
  }
  return w$(
    e,
    { firstMeasure: o, secondMeasure: r },
    l,
    i,
    { calculateSecondMeasure: n >= c[0] }
  );
}, x$ = (e) => {
  let t = 0, i = 0;
  return e.forEach((n) => {
    const A = n.getLogicalSpace();
    t = Math.max(t, A.height), i += A.width;
  }), {
    width: i,
    height: t
  };
}, S$ = (e, t) => {
  let i = 0, n = 0;
  return e.forEach((A) => {
    const o = A[t].getLogicalSpace();
    n = Math.max(n, o.width), i += o.height;
  }), {
    width: n,
    height: i
  };
}, Nh = (e, t) => {
  if (e.values[0].key) {
    const i = [];
    return e.values.forEach((n) => {
      t ? Nh(n, t).forEach((s, o) => {
        i[o] = i[o] || [], i[o].push(...s);
      }) : i.push(...Nh(n, t));
    }), e.matrix = i, i;
  }
  return t ? e.matrix = e.values[0].map(
    (i, n) => e.values.map((A) => A[n])
  ) : e.matrix = e.values, e.matrix;
}, M$ = (e, t, i) => {
  const n = [], A = [];
  return t ? e.forEach((s, o) => {
    o >= i ? A.push(s) : n.push(s);
  }) : e.forEach((s, o) => {
    s.forEach((r, a) => {
      a >= i ? (A[o] = A[o] || [], A[o].push(r)) : (n[o] = n[o] || [], n[o].push(r));
    });
  }), [n, A];
}, _$ = (e, t) => {
  const { availableWidth: i, width: n, row: A, innerMostColFacets: s, columnMaxWidth: o } = e, { isDistributionEqual: r, isTransposed: a, distribution: l, cellRenderer: c } = t;
  let g = 0;
  return l && l[0] && (g = l.reduce((u, d) => (u += d, u))), A.map((u, d) => {
    let f = u.getLogicalSpace().width;
    const I = u.overrideDimension != null && u.overrideDimension() != null ? u.overrideDimension().width : null, C = Math.max(
      s[d]?.getMinWidth() ?? 0,
      f
    );
    let E = c === "html" || u.config().touched ? f : C + (i - o) * (f / n);
    if (a) {
      if (l.length > 0)
        E = i * l[d] / g;
      else if ((r || n === 0) && I == null) {
        const B = A.length;
        E = i / B;
      }
    }
    return Math.floor(E);
  });
}, Jd = (e) => J.isInvalid(e) ? null : e, Q1 = (e) => {
  const {
    unitMeasures: { border: t },
    priority: i,
    isTransposed: n
  } = e.config(), A = i === 2, s = Mi(e.tree(), (h) => h.values), o = (h) => n ? h.data.matrix[h.depth - 1][0] : h.data.matrix[0][h.depth - 1], r = (h, u) => {
    n ? h.width = u : h.height = u;
  }, a = (h, u) => {
    n ? h.height = u : h.width = u;
  }, l = (h) => n ? h.width - t : h.height, c = (h) => n ? h.height : h.width - t, g = [];
  return s.each((h) => {
    if (h.depth > 0 && h.height > 0 && h.data.touched && h.data.isPersistent) {
      const u = {}, d = h.ancestors().slice(0, -1).reverse().map((m) => {
        if (m.height <= (A ? 2 : 1)) {
          const y = h.height > 1 ? h.children[0].children[0].data[h.children[0].children[0].data.length - 2].source() : h.children[0].data[h.children[0].data.length - 1].source();
          if (typeof y == "object" && y !== null) {
            const D = {
              field: y.config().field,
              sourceType: y.config().metaInf.sourceType
            };
            return typeof h.data.touchedValue < "u" && (D.value = Jd(h.data.touchedValue)), D;
          } else {
            const D = e.getNodeInfo(m, "muze-row-header");
            return {
              ...D,
              value: typeof D.value > "u" ? D.value : Jd(o(m).rawSource())
            };
          }
        } else {
          const y = e.getNodeInfo(m, "muze-corner");
          return {
            ...y,
            value: typeof y.value > "u" ? y.value : Jd(o(m).rawSource())
          };
        }
      }).filter((m) => m != null);
      u.target = d.length > 0 && Va(d[d.length - 1]) ? d : d.filter((m) => !Va(m));
      const I = o(h).source(), C = o(h)._overriddenDimension, E = l(C), B = c(C);
      if (E != null && n) {
        const m = u.target[u.target.length - 1].value;
        h.height === 1 && typeof I == "object" && I !== null && I.constructor.type() === "band" && typeof m < "u" ? Tg(I.domain(), m) && r(u, E / I.domain().length) : r(u, E);
      }
      B != null && !n && a(u, B), g.push(u);
    }
  }), g;
}, p1 = (e, t, { minWidth: i = 8, minHeight: n = 8 } = {}) => {
  const A = Mi(e.tree(), (f) => f.values), s = e.config().priority === 2, o = e.config().isTransposed, r = xa(e), a = (f, I) => {
    o ? f.nodeWidth = I : f.nodeHeight = I;
  }, l = (f, I) => {
    o ? f.nodeHeight = I : f.nodeWidth = I;
  }, c = (f) => o ? f.nodeWidth : f.nodeHeight, g = () => o ? i : n, h = () => o ? n : i, u = (f, I) => o ? I[f][0] : I[0][f], d = A.find((f) => {
    if (f.depth > 0 && f.height > 0) {
      const I = r(f);
      return So(t, I);
    }
  });
  if (d == null)
    return { minHeight: null, minWidth: null };
  if (d.height <= (s ? 2 : 1)) {
    const f = u(
      d.depth - 1,
      d.data.matrix
    ), I = f.source();
    f.type === "axis" && I.constructor.type() === "band" ? t[t.length - 1].value == null ? a(d, I.domain().length * g()) : I.domain().find((E) => E === t[t.length - 1].value) ? a(d, g()) : a(d, null) : a(d, g());
  } else
    d.eachAfter((f) => {
      if (f.height > 0)
        if (f.height === 1) {
          const I = u(f.depth - 1, f.data.matrix), C = I.source();
          I.type === "axis" ? C.constructor.type() === "band" && t[t.length - 1].value == null ? a(f, g()) : a(f, C.domain().length * g()) : a(f, g());
        } else
          a(
            f,
            f.children.reduce((I, C) => I + c(C), 0)
          );
    });
  return l(d, h()), {
    minHeight: d.nodeHeight,
    minWidth: d.nodeWidth
  };
}, b$ = (e) => {
  let t = 0, i = 0, n = 0;
  const {
    isTransposed: A,
    distribution: s,
    availableHeight: o,
    height: r,
    isDistributionEqual: a,
    gutter: l,
    matrix: c,
    cIdx: g,
    cellRenderer: h
  } = e;
  s && s[0] !== void 0 && (t = s.reduce((d, f) => (d += f, d))), l && l[0] !== void 0 && (i = l.reduce((d, f) => (d += f, d))), n = o - Math.floor(o * i);
  const u = c.length;
  return c.map((d, f) => {
    const I = d[g], C = I.getLogicalSpace().height, E = I.overrideDimension != null && I.overrideDimension() != null ? I.overrideDimension().height : null;
    let B = h === "html" || I.config().touchedHeight ? C : C + (n - r) * (C / r);
    return A || (s.length > 0 && u === s.length ? B = n * s[f] / t : (a || e.height === 0) && E == null && (B = n / u)), Math.floor(B);
  });
}, pA = (e, t, i) => e.slice(t, -i), y1 = (e = [], t, i, n) => {
  const A = n._breakPointer, s = n.config(), { isTransposed: o } = s, { tree: r, layoutMatrix: a } = i;
  if (t === 0) {
    const c = M$(r.matrix, o, A);
    return e.push({
      matrix: r.matrix,
      primaryMatrix: c[0],
      secondaryMatrix: c[1],
      space: r.space
    }), e;
  }
  const l = t - 1;
  return r.values.forEach((c) => {
    y1(
      e,
      l,
      {
        tree: c,
        layoutMatrix: a
      },
      n
    );
  }), e;
}, N$ = (e, t) => {
  const { style: i, encoding: n } = e.config(), { smartLabel: A } = e.dependencies(), { geomMatrixSize: s, availableSpace: o } = t, { width: r, height: a } = e.calculateOptimumTextLabelDimensions(), { x: l, y: c } = e.axes(), g = [];
  let h = 0;
  e._normalizedData.forEach((_) => {
    _.forEach((M) => {
      const k = l.getIndex(M.x, null), T = c.getIndex(M.y, null);
      g[T] || (g[T] = []), g[T][k] || (g[T][k] = []), g[T][k].push(M), h = Math.max(h, g[T][k].length);
    });
  }), e.cellMaxCount(h);
  const u = l.domain(), d = c.domain(), f = r + 2 * Jo, I = a + 2 * Jo, C = Math.max(
    Math.floor(
      o.height / s.rows / d.length / I
    ),
    wz
  ), E = Math.max(
    Math.floor(
      o.width / s.columns / u.length / f
    ),
    xz
  );
  let B, m;
  h >= C * E ? (B = C, m = E) : (m = Math.min(E, Math.floor(Math.sqrt(h))), B = Math.floor(h / m), B > C && (B = C, m = Math.floor(h / B)));
  const y = m * B;
  let D, Q;
  y > 1 ? (D = m * f, Q = B * I) : (D = r, Q = a);
  const { charsAcross: p } = n.text, w = Fg(p.min, "W");
  A.setStyle(i);
  const { width: x, height: S } = A.getOriSize(
    w
  );
  return D = Math.max(D, x), Q = Math.max(Q, S), h > 1 && (D += ns), D += za * 2, Q += za * 2, {
    width: D,
    height: Q
  };
}, F$ = {
  config: {
    sanitization: (e, t) => tt(e._config || {}, t)
  },
  maxMeasures: {},
  availableSpace: {},
  logicalSpace: {}
}, R$ = {
  distribution: [],
  classPrefix: "muze",
  isDistributionEqual: !0,
  unitMeasures: {
    height: 100,
    width: 100,
    border: 1
  },
  isTransposed: !1,
  facet: gA,
  extraCellLengths: []
};
class NB {
  /**
   *Creates an instance of VisualMatrix.
   * @param {any} matrix Two set of matrices
   * @param {any} [config={}] Configuration for VisualMatrix
   * @memberof VisualMatrix
   */
  constructor(t, i = {}) {
    this._lastLevelKey = 0, this._primaryMatrix = t[0] || [], this._secondaryMatrix = t[1] || [], this._maxMeasures = [], this._availableSpace = {}, this._overriddenDimension = {}, ge(this, F$);
    const n = Object.assign({}, this.constructor.defaultConfig());
    this.config(tt(n, i)), this._layoutMatrix = m1(
      [t[0] || [], t[1] || []],
      this.config()
    );
  }
  /**
   * Computes the logical space taken by the entire matrixTree
   *
   * @return {Object} Logical space taken
   * @memberof VisualMatrix
   */
  computeLogicalSpace() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  computeViewableSpaces() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   *
   *
   * @return
   * @memberof VisualMatrix
   */
  removeExtraCells() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  getPriorityDistribution() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Calculates the depth of the tree that can be viewed
   *
   * @param {Array} widthMeasures array of widths
   * @param {Array} heightMeasures array of heights
   * @return {number} depth of the tree
   * @memberof VisualMatrix
   */
  calculateDepth() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Redistributes the provied space to all cells
   *
   * @param {*} viewableMatrix current viewport matrix
   * @param {*} width provied width
   * @param {*} height provied height
   * @return {Object} current viewports matrixes with measures
   * @memberof VisualMatrix
   */
  redistributeSpaces() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Distibutes the given space row wisely
   *
   * @param {Object} measures Redistribution information
   * @memberof VisualMatrix
   */
  redistributeViewSpaces() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Dispatch the calculated cell dimensions to all the cells
   *
   * @param {Object} measures cell dimension information
   * @return {Object} row and column heights / widths
   * @memberof VisualMatrix
   */
  getCellDimensions() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   *
   *
   * @param {*} params
   * @returns
   * @memberof VisualMatrix
   */
  primaryMatrix(...t) {
    return t.length ? this : this._primaryMatrix;
  }
  secondaryMatrix(...t) {
    return t.length ? this : this._secondaryMatrix;
  }
  tree(...t) {
    return t.length ? this : this._tree;
  }
  static defaultConfig() {
    return R$;
  }
  createTree() {
    const { tree: t, lastLevelKey: i } = y$(this);
    return this._lastLevelKey = i, t;
  }
  overrideDimension(t) {
    return t == null ? this._overriddenDimension : (t.width != null && (this._overriddenDimension.width = t.width), t.height != null && (this._overriddenDimension.height = t.height), this);
  }
  /**
   * Returns the space taken by visual matrix
   *
   * @return {Object} space taken by the matrix
   * @memberof VisualMatrix
   */
  getLogicalSpace() {
    const t = {}, i = this.logicalSpace(), n = this.overrideDimension();
    return n.width ? t.width = n.width : t.width = i.width, n.height ? t.height = n.height : t.height = i.height, i.detail && (t.detail = i.detail), t;
  }
  /**
   * Sets the provied space to the visual matrix
   *
   * @param {number} width width provided
   * @param {number} height height provided
   * @memberof VisualMatrix
   */
  setAvailableSpace(t, i) {
    this.availableSpace({ width: t, height: i });
    const n = this.tree(), A = this.populateMaxMeasures(wh, n), s = this.populateMaxMeasures(HA, n), o = this.calculateDepth(s, A);
    return this.viewableMatrix = this.createViewPortMatrix(o), this.viewableMeasures = this.redistributeSpaces(t, i), this;
  }
  /**
   * Populate the max measures in the array
   *
   * @param {Array} measures array to be filled with max measures
   * @param {Object} matrixTree matrix tree of visual matrix
   * @param {number} measure width or height
   * @param {number} [depth=0] depth of the tree that to be calculated
   * @memberof VisualMatrix
   */
  populateMaxMeasures(t, i, n = 0, A = []) {
    if (A[n] = Math.max(A[n] || 0, i.space[t]), i.values) {
      const s = n + 1;
      i.values.forEach((o) => {
        o.space && (A = this.populateMaxMeasures(
          t,
          o,
          s,
          A
        ));
      });
    }
    return A;
  }
  /**
   * Gets the viewable measures for the current viewable matrix
   *
   * @return {Object} Set of viewable measures
   * @memberof VisualMatrix
   */
  getViewableSpaces() {
    return this.viewableMeasures;
  }
  /**
   * Returns the matrix that can be viewed in the current viewport
   *
   * @return {Array} Set of matrices that can be viewed
   * @memberof VisualMatrix
   */
  getViewableMatrices() {
    return this.viewableMatrix;
  }
  /**
   * Creates the viewport that can be viewed together
   *
   * @param {number} depth maxDepth that can be viewed in the viewport
   * @return {Array<Object>} Set of matrices that can be viewed
   * @memberof VisualMatrix
   */
  createViewPortMatrix(t) {
    const i = [];
    return y1(i, t, this.removeExtraCells(), this), i;
  }
}
class k$ extends NB {
  /**
   *Creates an instance of VisualMatrix.
   * @param {any} matrix Two set of matrices
   * @param {any} [config={}] Configuration for VisualMatrix
   * @memberof VisualMatrix
   */
  constructor(t, i = {}) {
    super(t, i);
    const n = this.config();
    this._breakPointer = t[0].length > 0 ? t[0][0].length : 0, this._layoutMatrix = m1(
      [t[0] || [], t[1] || []],
      n
    ), this._tree = {
      key: dz,
      values: this.createTree()
    }, this._hierarchy = Mi(this.tree(), (A) => A.values);
  }
  compute(t) {
    const i = this.config(), {
      cellRenderer: n,
      extraCellLengths: [A, s]
    } = i;
    t && n === "html" && this._layoutMatrix.slice(A, this._layoutMatrix.length - s).forEach((o, r) => {
      o[o.length - 1].overrideDimension({ height: t[r] });
    }), this._logicalSpace = this.computeLogicalSpace();
  }
  /**
   * Computes the logical space taken by the entire matrixTree
   *
   * @return {Object} Logical space taken
   * @memberof VisualMatrix
   */
  computeLogicalSpace() {
    const t = this.tree();
    return Nh(t, !1), bB(
      t,
      { ...this.config(), matrixType: "row" },
      this.maxMeasures()
    );
  }
  getMinTargetDimensions(...t) {
    return p1(this, ...t);
  }
  getNodeInfo(t, i) {
    const n = t.data.matrix[0][t.depth - 1], A = n.config().fieldName || i, s = n.rawSource && n.rawSource(), o = n.config().type === "headerTitle" || s === A;
    return {
      field: A,
      // header cells do not represent a value, just the field name - which is
      // already available in the field property of this returned object
      value: o ? void 0 : s,
      sourceType: W(n.config(), "metaInf", "sourceType")
    };
  }
  computeViewableSpaces(t) {
    const { maxHeights: i, maxWidths: n, height: A } = t;
    return this.viewableMatrix.map((s, o) => {
      const r = {
        matrixInst: s,
        maxWidths: n,
        maxHeights: i,
        matrixIndex: o
      }, { widths: a, rowHeights: l, columnWidths: c } = this.getCellDimensions(r), g = [A, A], h = a;
      return {
        rowHeights: {
          primary: l[0],
          secondary: l[1]
        },
        columnWidths: {
          primary: c[0],
          secondary: c[1]
        },
        height: {
          primary: g[0],
          secondary: g[1]
        },
        width: {
          primary: h[0],
          secondary: h[1]
        }
      };
    });
  }
  /**
   *
   *
   * @return
   * @memberof VisualMatrix
   */
  removeExtraCells() {
    const { isTransposed: t, extraCellLengths: i } = this.config(), n = this._layoutMatrix, A = tt({}, this.tree()), s = i[0], o = i[1] || Number.NEGATIVE_INFINITY, r = t ? n.slice(0).map((a) => pA(a, s, o)) : pA(n, s, o);
    return A.values = pA(A.values, s, o), A.matrix = pA(A.matrix, s, o), {
      tree: A,
      layoutMatrix: r
    };
  }
  getPriorityDistribution(t) {
    let i, n, A = [], s = [];
    const {
      matrix: o,
      width: r,
      maxMeasures: a,
      maxWidth: l,
      height: c
    } = t, g = this.primaryMatrix(), h = ae(this._layoutMatrix), u = h.map(
      (N) => N.some((b) => b.config().touched)
    ), d = (N) => u[N], f = u[g[0].length - 1] === !0 ? -1 : g[0].length - 1, I = Te(
      h.filter((N, b) => !d(b)).map((N) => Ye(N.map((b) => b.getMinWidth())))
    ), { priority: C, priorityMinWidths: E, priorityMaxWidths: B } = this.config(), m = g.length ? g[0].length : 0, y = [];
    i = r, n = l;
    const { touchedColumnWidths: D, untouchedColumnWidths: Q } = a.map((N, b) => ({ width: N, originalIdx: b })).reduce(
      ({ touchedColumnWidths: N, untouchedColumnWidths: b }, F, R) => d(R) ? {
        touchedColumnWidths: N.concat(F),
        untouchedColumnWidths: b.slice()
      } : {
        touchedColumnWidths: N.slice(),
        untouchedColumnWidths: b.concat(F)
      },
      {
        touchedColumnWidths: [],
        untouchedColumnWidths: []
      }
    ), p = Te(
      D,
      ({ width: N }) => N
    ), w = Te(
      Q,
      ({ width: N }) => N
    ), x = this._maxPossibleWidth - I;
    let S = [];
    if (p > x) {
      const b = (p - x) / p;
      S = D.map(
        ({ width: F, originalIdx: R }) => ({
          width: Math.round(F * (1 - b)),
          originalIdx: R
        })
      );
    } else
      S = D.slice();
    S.forEach(({ width: N, originalIdx: b }) => {
      A[b] = N;
    });
    const _ = S.reduce(
      (N, { width: b, originalIdx: F }) => ({ ...N, [F]: b }),
      {}
    );
    i -= Te(
      S,
      ({ width: N }) => N
    ), n = w, C === 2 ? s = [f, m] : s = C === 0 ? [f] : [m], s = s.filter(
      (N, b, F) => N != null && N >= 0 && F.indexOf(N) === b
    ), s.forEach((N) => {
      if (!d(N)) {
        y[N] = a[N];
        let b;
        E !== null && i < n ? y[N] === 0 ? b = 0 : b = Math.min(
          Math.max(
            a[N] / n,
            E / s.length
          ),
          B / s.length
        ) * i : b = a[N], y[N] = b, i -= b, n -= a[N];
      }
    }), o[0].forEach((N, b) => {
      d(b) || s.indexOf(b) === -1 && (y[b] = i * (a[b] / n));
    });
    const M = [];
    o.forEach(
      (N) => N.forEach((b, F) => {
        if (!d(F))
          if (s.indexOf(F) === -1) {
            b.setAvailableSpace(y[F], c);
            const R = b.getMinWidth();
            A[F] = _[F] == null ? Math.max(
              A[F] || 0,
              Math.floor(b.getLogicalSpace().width)
            ) : _[F], M[F] = Math.max(R, M[F] || 0);
          } else
            A[F] = y[F];
      })
    );
    let k = M.reduce((N, b) => N + (b || 0), 0);
    i -= k, A.forEach((N, b) => {
      if (!d(b) && s.indexOf(b) === -1 && a[b]) {
        const F = a[b] / n, R = Math.min(
          F * i,
          a[b]
        );
        A[b] = Math.max(R + M[b], 0), n -= a[b], i -= R;
      }
    });
    const T = Math.max(
      r - A.reduce((N, b) => N + b),
      0
    );
    s.forEach((N) => {
      d(N) || (A[N] = Math.floor(y[N] + T / s.length));
    });
    const G = this._maxPossibleWidth - Te(A);
    return o.map((N) => {
      N.map((b) => {
        b._resizeDelta = G;
      });
    }), A;
  }
  /**
   * Calculates the depth of the tree that can be viewed
   *
   * @param {Array} widthMeasures array of widths
   * @param {Array} heightMeasures array of heights
   * @return {number} depth of the tree
   * @memberof VisualMatrix
   */
  // calculateDepth(widthMeasures, heightMeasures) {
  calculateDepth() {
    return 0;
  }
  /**
   * Redistributes the provied space to all cells
   *
   * @param {*} viewableMatrix current viewport matrix
   * @param {*} width provied width
   * @param {*} height provied height
   * @return {Object} current viewports matrixes with measures
   * @memberof VisualMatrix
   */
  redistributeSpaces(t, i) {
    let n = [], A = [];
    const s = this.maxMeasures(), o = s.reduce((a, l) => (a += l, a)), r = this.getPriorityDistribution({
      matrix: this._layoutMatrix,
      maxWidth: o,
      maxMeasures: s,
      width: t,
      height: i
    });
    return this.viewableMatrix.forEach((a) => {
      const h = {
        mWidth: 0,
        mHeight: 0,
        matrix: a.matrix,
        width: t,
        height: i,
        maxHeights: n,
        maxWidths: A,
        logicalWidths: r
      }, u = this.redistributeViewSpaces(h);
      A = u.maxWidths, n = u.maxHeights;
    }), this.computeViewableSpaces({ height: i, width: t, maxHeights: n, maxWidths: A });
  }
  blueprints() {
    return Q1(this);
  }
  /**
   * Distibutes the given space row wisely
   *
   * @param {Object} measures Redistribution information
   * @memberof VisualMatrix
   */
  redistributeViewSpaces(t) {
    let i = [], n = [], A = 0;
    const s = this.maxMeasures(), {
      isDistributionEqual: o,
      distribution: r,
      isTransposed: a,
      gutter: l,
      cellRenderer: c
    } = this.config(), { matrix: g, height: h, maxHeights: u, maxWidths: d, logicalWidths: f } = t;
    A = S$(g, this._lastLevelKey).height;
    const I = s.reduce((C, E) => (C += E, C));
    t.maxMeasures = s, t.maxWidth = I, I > 0 ? i = f : i = s.map(() => 0), n = b$({
      matrix: g,
      cIdx: this._lastLevelKey,
      height: A,
      availableHeight: h,
      isDistributionEqual: o,
      distribution: r,
      isTransposed: a,
      gutter: l,
      cellRenderer: c
    }), d.length > 0 && (i = i.map((C, E) => Math.max(C, d[0][E] || 0))), d.push(i);
    for (let C = 0; C < d.length; C++)
      d[C] = i;
    return u.push(n), { maxWidths: d, maxHeights: u };
  }
  /**
   * Dispatch the calculated cell dimensions to all the cells
   *
   * @param {Object} measures cell dimension information
   * @return {Object} row and column heights / widths
   * @memberof VisualMatrix
   */
  getCellDimensions(t) {
    const { unitMeasures: i } = this.config(), n = i.border, { matrixInst: A, maxWidths: s, maxHeights: o, matrixIndex: r } = t, a = A.matrix, l = [[0], [0]], c = [[0], [0]], g = [0, 0], h = [0, 0], u = this._breakPointer;
    return a.forEach((d, f) => {
      d.forEach((I, C) => {
        const E = o[r][f] || 0, B = s[r][C];
        I.setAvailableSpace(B - n, E - n), f === 0 && C < u ? (c[0][C] = B, h[0] = (h[0] || 0) + B) : f === 0 && C >= u && (c[1][C - u] = B, h[1] = (h[1] || 0) + B), C === this._lastLevelKey && (l[0][f] = E, l[1][f] = E);
      });
    }), {
      heights: g,
      widths: h,
      rowHeights: l,
      columnWidths: c
    };
  }
}
class T$ extends NB {
  /**
   * Creates an instance of VisualMatrix.
   * @param {any} matrix Two set of matrices
   * @param {any} [config={}] Configuration for VisualMatrix
   * @memberof VisualMatrix
   */
  constructor(t, i = {}) {
    super(t, i);
    const n = this.config();
    this._breakPointer = t[0].length, this._cornerMatrices = {
      ...n.cornerMatrices
    }, this._tree = {
      key: fz,
      values: this.createTree()
    }, this._hierarchy = Mi(this.tree(), (A) => A.values);
  }
  compute(t) {
    const i = this.config(), {
      cellRenderer: n,
      extraCellLengths: [A, s]
    } = i;
    if (t && n === "html") {
      const o = this._layoutMatrix[this._layoutMatrix.length - 1];
      o.slice(A, o.length - s).forEach((r, a) => {
        r.overrideDimension({ width: t[a] });
      });
    }
    this._logicalSpace = this.computeLogicalSpace();
  }
  /**
   * Computes the logical space taken by the entire matrixTree
   *
   * @return {Object} Logical space taken
   * @memberof VisualMatrix
   */
  computeLogicalSpace() {
    const t = this.tree();
    return Nh(t, !0), bB(
      t,
      { ...this.config(), matrixType: "column" },
      this.maxMeasures()
    );
  }
  getMinTargetDimensions(...t) {
    return p1(this, ...t);
  }
  getNodeInfo(t, i) {
    return {
      field: typeof t.data.matrix[t.depth - 1][0].config().fieldName > "u" ? i : t.data.matrix[t.depth - 1][0].config().fieldName,
      value: t.data.matrix[t.depth - 1][0].rawSource && t.data.matrix[t.depth - 1][0].rawSource(),
      sourceType: W(
        t.data.matrix[t.depth - 1][0].config(),
        "metaInf",
        "sourceType"
      )
    };
  }
  computeViewableSpaces(t) {
    const { maxHeights: i, maxWidths: n, height: A, width: s } = t, o = this.cornerMatrixSpaces();
    return this.viewableMatrix.map((r, a) => {
      const l = {
        matrixInst: r,
        maxWidths: n,
        maxHeights: i,
        matrixIndex: a,
        height: A
      }, { heights: c, rowHeights: g, columnWidths: h } = this.getCellDimensions(l), u = c, d = [s, s];
      return {
        rowHeights: {
          primary: g[0].map((f, I) => Math.max(
            f,
            o.topLeft.rowHeights[I],
            o.topRight.rowHeights[I]
          )),
          secondary: g[1].map((f, I) => Math.max(
            f,
            o.bottomLeft.rowHeights[I],
            o.bottomRight.rowHeights[I]
          ))
        },
        columnWidths: {
          primary: h[0],
          secondary: h[1]
        },
        height: {
          primary: Math.max(
            u[0],
            o.topLeft.height,
            o.topRight.height
          ),
          secondary: Math.max(
            u[1],
            o.bottomLeft.height,
            o.bottomRight.height
          )
        },
        width: {
          primary: d[0],
          secondary: d[1]
        }
      };
    });
  }
  cornerMatrices() {
    return this._cornerMatrices;
  }
  cornerMatrixSpaces() {
    const t = {};
    return Object.keys(this._cornerMatrices).map((i) => {
      const A = this._cornerMatrices[i].map((s) => s.map((o) => o.getLogicalSpace()).reduce((o, r) => Math.max(o, r.height), 0));
      t[i] = {
        rowHeights: A,
        height: A.reduce((s, o) => s + o, 0)
      };
    }), t;
  }
  /**
   *
   *
   * @return
   * @memberof VisualMatrix
   */
  removeExtraCells() {
    const { isTransposed: t, extraCellLengths: i } = this.config(), n = this._layoutMatrix, A = tt({}, this.tree()), s = i[0], o = i[1] || Number.NEGATIVE_INFINITY, r = t ? n.slice(0).map((a) => pA(a, s, o)) : pA(n, s, o);
    return A.values = pA(A.values, s, o), A.matrix = A.matrix.map(
      (a) => pA(a, s, o)
    ), {
      tree: A,
      layoutMatrix: r
    };
  }
  getPriorityDistribution(t) {
    const { height: i, maxHeights: n } = t;
    let A = i, s = [], o = [], r = 2;
    const a = this.config().priority, l = this.primaryMatrix().length;
    return a === 2 ? (o = [l - 1, l], r = 2) : (o = a === 0 ? [l - 1] : [l], r = 1), n.forEach((c, g) => {
      o.indexOf(g) === -1 && (s[g] = c, A -= c);
    }), A < 0 ? s = s.map(() => 0) : o.forEach((c) => {
      s[c] = Math.min(
        n[c],
        A / r
      );
    }), s;
  }
  /**
   * Calculates the depth of the tree that can be viewed
   *
   * @param {Array} widthMeasures array of widths
   * @param {Array} heightMeasures array of heights
   * @return {number} depth of the tree
   * @memberof VisualMatrix
   */
  // calculateDepth(widthMeasures) {
  calculateDepth() {
    return 0;
  }
  blueprints() {
    return Q1(this);
  }
  /**
   * Redistributes the provied space to all cells
   *
   * @param {*} viewableMatrix current viewport matrix
   * @param {*} width provied width
   * @param {*} height provied height
   * @return {Object} current viewports matrixes with measures
   * @memberof VisualMatrix
   */
  redistributeSpaces(t, i) {
    let n = [], A = [];
    return this.viewableMatrix.forEach((s) => {
      const l = {
        mWidth: 0,
        mHeight: 0,
        matrix: s.matrix,
        width: t,
        height: i,
        maxHeights: n,
        maxWidths: A
      }, c = this.redistributeViewSpaces(l);
      A = c.maxWidths, n = c.maxHeights;
    }), this.computeViewableSpaces({ height: i, width: t, maxHeights: n, maxWidths: A });
  }
  /**
   * Distibutes the given space column wisely
   *
   * @param {Object} measures Redistribution information
   * @memberof VisualMatrix
   */
  redistributeViewSpaces(t) {
    let i = [];
    const { matrix: n, width: A, maxHeights: s, maxWidths: o, height: r } = t, a = this.config().unitMeasures.border, l = x$(n[this._lastLevelKey]).width, c = this._lastLevelKey > 0 ? n[this._lastLevelKey - 1] : [];
    let g = 0;
    c.forEach((u, d) => {
      const I = n[this._lastLevelKey][d].getLogicalSpace(), C = u.getMinWidth(), E = Math.max(I.width, C);
      g += E;
    });
    const h = _$(
      {
        row: n[this._lastLevelKey],
        width: l,
        availableWidth: A,
        innerMostColFacets: c,
        columnMaxWidth: g || l
      },
      this.config()
    );
    n.forEach(
      (u, d) => u.forEach((f, I) => {
        const C = f.getLogicalSpace();
        f.setAvailableSpace(
          h[I] - a,
          C.height
        ), i[d] = Math.max(
          i[d] || 0,
          Math.floor(f.getLogicalSpace().height)
        );
      })
    ), s.length > 0 && (i = i.map((u, d) => Math.max(u, s[0][d]))), r > 0 && qw(i) === 0 && (i[i.length - 1] = r), s.push(i);
    for (let u = 0, d = s.length; u < d; u++)
      s[u] = i;
    return o.push(h), { maxHeights: s, maxWidths: o };
  }
  /**
   * Dispatch the calculated cell dimensions to all the cells
   *
   * @param {Object} measures cell dimension information
   * @return {Object} row and column heights / widths
   * @memberof VisualMatrix
   */
  getCellDimensions(t) {
    const { unitMeasures: i } = this.config(), n = i.border, { matrixInst: A, height: s, maxWidths: o, maxHeights: r, matrixIndex: a } = t, l = A.matrix, c = [[0], [0]], g = [[0], [0]], h = [0, 0], u = [0, 0], d = this._breakPointer, f = this.getPriorityDistribution({
      height: s,
      maxHeights: r[0] || []
    });
    return l.forEach((I, C) => {
      I.forEach((E, B) => {
        const m = f[C] || 0, y = o[a][B];
        E.setAvailableSpace(y - n, m), B === 0 && C < d ? (c[0][C] = m, h[0] = (h[0] || 0) + m) : B === 0 && C >= d && (c[1][C - d] = m, h[1] = (h[1] || 0) + m), C === this._lastLevelKey && (g[0][B] = y, g[1][B] = y);
      });
    }), {
      heights: h,
      widths: u,
      rowHeights: c,
      columnWidths: g
    };
  }
}
const _y = 12;
class v$ extends NB {
  constructor(t, i = {}) {
    super([t], i);
  }
  compute(t) {
    const i = this.config();
    this._logicalSpace = i.cellRenderer === "html" ? this.computeLogicalSpace(t) : { detail: {} };
  }
  computeLogicalSpace(t) {
    const i = this.primaryMatrix(), n = {
      rows: i.length,
      columns: i.length ? i[0].length : 0
    }, A = i.map((r) => r.map((a) => {
      const c = a.source().layers(), { width: g, height: h } = c.reduce(
        (u, d) => {
          const { width: f, height: I } = N$(d, {
            ...t,
            geomMatrixSize: n
          }), { x: C, y: E } = d.axes();
          return {
            width: Math.max(
              u.width,
              (f + _y) * C.domain().length
            ),
            height: u.height + (I + _y) * E.domain().length
          };
        },
        { width: 0, height: 0 }
      );
      return {
        width: g,
        height: h
      };
    })), s = A.map((r) => {
      const a = r.map(({ height: l }) => l);
      return Math.max(...a);
    }), o = ae(A).map(
      (r) => {
        const a = r.map(({ width: l }) => l);
        return Math.max(...a);
      }
    );
    return {
      width: Te(o),
      height: Te(s),
      detail: { rowHeights: s, columnWidths: o }
    };
  }
}
const G$ = (e, t) => {
  let i = [], n = [], A = [], s = [], o, r;
  const {
    isRowSizeEqual: a,
    isColumnSizeEqual: l,
    gutterSpace: c,
    distribution: g,
    border: h,
    breakPage: u,
    priority: d,
    cellRenderer: f,
    priorityMinWidths: I,
    priorityMaxWidths: C,
    rows: { totalMaxWidthRatio: E }
  } = e.config(), { minUnitHeight: B, minUnitWidth: m } = e.measurement(), { top: y, center: D, bottom: Q } = t, [p, w, x] = y, [S, _, M] = D, [k, T, G] = Q;
  S.length > 0 && (i = [...p, ...S, ...k]), M.length > 0 && (n = [...x, ...M, ...G]), w.length > 0 && w[0].length > 0 && (A = w.map((R, v) => [...p[v], ...R, ...x[v]])), T.length > 0 && T[0].length > 0 && (s = T.map((R, v) => [
    ...k[v],
    ...R,
    ...G[v]
  ]));
  const N = {
    topLeft: p,
    topRight: x,
    bottomLeft: k,
    bottomRight: G
  }, b = new v$(_, { cellRenderer: f });
  e.centerMatrix(b);
  const F = Math.min(
    m$,
    Math.max(B$, E)
  );
  return e.rowMatrix(
    new k$([i, n], {
      totalMaxWidthRatio: F,
      isDistributionEqual: a,
      distribution: g.rows,
      gutter: c.rows,
      unitMeasures: {
        width: m,
        height: B,
        border: h.width
      },
      priority: d.row,
      breakPage: u.rows.map(
        (R) => R + Math.max(p.length, x.length)
      ),
      extraCellLengths: [p.length, k.length],
      // centerMatrixDetails: rowHeights,
      cellRenderer: f,
      priorityMinWidths: I.row,
      priorityMaxWidths: C.row
    })
  ), p.length > 0 ? o = p[0].length : o = k.length > 0 ? k[0].length : 0, x.length > 0 ? r = x[0].length : r = G.length > 0 ? G[0].length : 0, e.columnMatrix(
    new T$([A, s], {
      isDistributionEqual: l,
      distribution: g.columns,
      gutter: c.columns,
      isTransposed: !0,
      unitMeasures: {
        width: m,
        height: B,
        border: h.width
      },
      priority: d.col,
      breakPage: u.columns,
      extraCellLengths: [o, r],
      // centerMatrixDetails: columnWidths,
      cellRenderer: f,
      cornerMatrices: N
    })
  ), t;
};
function Fh(e, t) {
  return e ? e.getLogicalSpace()[t] : 0;
}
const bc = (e, t, i) => {
  e.forEach((n, A) => {
    n.forEach((s, o) => {
      s.setAvailableSpace(t[o], i[A]);
    });
  });
}, by = (e, t, i) => {
  let n = e.config()[`${t}Pointer`];
  return i.length - 1 < n && (n = 0, e.config({ [`${t}Pointer`]: n })), n;
}, L$ = {
  column: {
    maxMeasure: Qz,
    matrix: pz,
    measureType: HA,
    scrollType: VN
  },
  row: {
    maxMeasure: yz,
    matrix: Dz,
    measureType: wh,
    scrollType: WN
  }
}, U$ = (e, t, i, n) => {
  const { pagination: A, cellRenderer: s } = e.config(), { matrix: o, measureType: r, scrollType: a } = t;
  switch (A) {
    case Bz:
      return i;
    default: {
      const l = Fh(e[o](), r) + n;
      return s === "html" ? e.centerMatrix().getLogicalSpace()[r] + n > i && e.scrollInfo({ [a]: !0 }) : Math.ceil(l) > Math.ceil(i) && e.scrollInfo({ [a]: !0 }), Math.max(i, l);
    }
  }
}, D1 = (e, t, i, n) => U$(
  e,
  L$[t],
  i,
  n
), O$ = (e) => {
  const t = e.rowMatrix(), i = t.config().totalMaxWidthRatio, n = e.columnMatrix(), { width: A } = e.measurement(), {
    border: s,
    buffer: o,
    axes: {
      x: { compact: r }
    }
  } = e.config(), a = r ? 0 : s.width, l = Fh(t, HA), c = Fh(n, HA), g = Math.max(
    1 - c / A,
    i
  ), h = Math.min(
    l + o,
    A * g
  ), u = A - h - a, d = D1(
    e,
    on,
    u,
    0
  );
  return {
    rowMatrixWidth: l,
    maxRowMatrixWidth: h,
    columnMatrixWidth: d,
    maxWidthAvailableForColumnMatrix: u
  };
}, H$ = (e, t) => {
  const { height: i } = e.measurement(), n = e.columnMatrix(), A = Math.min(
    n.getLogicalSpace().height,
    i / 2
  );
  n.setAvailableSpace(t, A);
  const o = n.getViewableSpaces()[e.config().columnPointer];
  return {
    columnMatrixHeight: o.height.primary + o.height.secondary,
    maxColumnMatrixHeight: A
  };
}, P$ = (e, t) => {
  const { height: i } = e.measurement(), { buffer: n } = e.config(), { columnMatrixHeight: A, maxColumnMatrixHeight: s } = H$(e, t), o = i - Math.min(s, A), r = D1(
    e,
    rn,
    o,
    n
  );
  return {
    columnMatrixHeight: A,
    maxColumnMatrixHeight: s,
    rowMatrixHeight: r,
    maxHeightAvailableForRowMatrix: o
  };
}, Y$ = (e, t, i) => {
  const n = e.centerMatrix().primaryMatrix(), { border: A } = e.config(), s = e.matrices(), { top: o, bottom: r } = s, a = A.width, l = [].concat(
    ...t.map((f) => f.rowHeights.primary)
  ), c = [].concat(
    ...t.map((f) => f.columnWidths.primary)
  ), g = [].concat(
    ...t.map((f) => f.columnWidths.secondary)
  ), h = [].concat(
    ...i.map((f) => f.columnWidths.primary)
  ), u = i[0].rowHeights.primary, d = [].concat(
    ...i.map((f) => f.rowHeights.secondary)
  );
  n.forEach((f, I) => {
    f.forEach((C, E) => {
      C.setAvailableSpace(
        h[E] - a,
        l[I] - a
      );
    });
  }), bc(o[0], c, u), bc(o[2], g, u), bc(r[0], c, d), bc(r[2], g, d);
}, Ny = {
  isScroll: !0,
  pagination: mz
}, J$ = (e, t) => {
  const i = e.scrollInfo(), { pagination: n } = e.config(), A = {
    pagination: n,
    isScroll: i[t]
  };
  return Object.keys(Ny).every(
    (s) => Ny[s] === A[s]
  );
}, K$ = (e) => {
  const { buffer: t } = e.config(), [i, n] = [VN, WN].map(
    (A) => J$(e, A) ? t : 0
  );
  return {
    horizontalBuffer: i,
    verticalBuffer: n
  };
}, W$ = (e) => {
  const t = e.rowMatrix(), i = t.config().totalMaxWidthRatio, n = e.columnMatrix(), { width: A } = e.measurement(), {
    rowMatrixWidth: s,
    maxRowMatrixWidth: o,
    maxWidthAvailableForColumnMatrix: r,
    columnMatrixWidth: a
  } = O$(e), {
    columnMatrixHeight: l,
    rowMatrixHeight: c,
    maxHeightAvailableForRowMatrix: g
  } = P$(e, a), { horizontalBuffer: h, verticalBuffer: u } = K$(e), d = Math.max(
    1 - Fh(n, HA) / A,
    i
  );
  t._maxPossibleWidth = A * d - u, t.setAvailableSpace(
    o - u,
    c - h
  );
  const f = t.getViewableSpaces(), I = n.getViewableSpaces();
  return by(e, rn, f), by(e, on, I), Y$(e, f, I), {
    rowMatrixHeight: c - h,
    rowMatrixWidth: s - u,
    maxHeightAvailableForRowMatrix: g - h,
    columnMatrixHeight: l,
    columnMatrixWidth: a,
    maxWidthAvailableForColumnMatrix: r
  };
}, V$ = (e, t, i) => {
  const n = e.rowMatrix(), A = e.columnMatrix(), s = e.centerMatrix().primaryMatrix(), o = e.matrices(), r = n.getViewableMatrices(), a = A.getViewableMatrices(), l = {
    row: 0,
    column: 0
  };
  for (let h = t - 1; h >= 0; h--) {
    const u = Math.max(
      r[h].primaryMatrix.length,
      r[h].secondaryMatrix.length
    );
    l.row += u;
  }
  for (let h = i - 1; h >= 0; h--) {
    const u = a[h], { primaryMatrix: d, secondaryMatrix: f } = u, I = Math.max(
      d[0] ? d[0].length : 0,
      f[0] ? f[0].length : 0
    );
    l.column += I;
  }
  o.top[1] = a[i].primaryMatrix, o.bottom[1] = a[i].secondaryMatrix, o.center[0] = r[t].primaryMatrix, o.center[2] = r[t].secondaryMatrix;
  const c = Math.max(
    o.center[0].length,
    o.center[2].length
  ), g = Math.max(
    o.top[1][0] ? o.top[1][0].length : 0,
    o.bottom[1][0] ? o.bottom[1][0].length : 0
  );
  return o.center[1] = s.slice(l.row, l.row + c).map(
    (h) => h.slice(
      l.column,
      l.column + g
    )
  ), {
    matrices: o,
    rowPages: r.length,
    columnPages: a.length
  };
}, Nc = (e) => e.reduce((t, i) => t + i, 0), j$ = (e, t, i) => {
  const n = e.rowMatrix(), A = e.columnMatrix(), { columnPointer: s, rowPointer: o } = e.config(), r = n.getViewableSpaces()[o], a = A.getViewableSpaces()[s], { rowHeights: l, width: c } = r, { columnWidths: g, height: h } = a, { primary: u, secondary: d } = c, { primary: f, secondary: I } = h, C = Nc(l.primary), E = Nc(g.primary), B = [u, Math.min(E, i), d], m = [
    f,
    Math.min(C, t),
    I
  ];
  return {
    viewWidth: B,
    viewHeight: m,
    actualCenterMeasures: {
      height: C,
      width: E
    },
    totalMeasures: {
      width: Nc(B),
      height: Nc(m)
    },
    unitHeights: l,
    unitWidths: g
  };
};
class FB extends I$ {
  /**
   * Creates an instance of TableLayout.
   * @param {HTMLElement} matrices Set of upto 9 matrices containing the cells to be rendered
   * @param {HTMLElement} mountPoint DOM element/d3 selection where the layout is to be mounted
   * @param {Object} measurement The dimensions of the layout
   * @param {Object} config external configurations.
   * @memberof GenericLayout
   */
  constructor(t, i, n, A) {
    super(i, n, A), this.matrices(t), this.config(this.constructor.defaultConfig()), this._layoutId = Ut(), this._scrollInfo = { horizontal: !1, vertical: !1 };
  }
  static defaultViewInfo() {
    return Object.assign(
      {},
      {
        layoutDimensions: {
          border: this.defaultConfig().border,
          viewHeight: [0, 0, 0],
          viewWidth: [0, 0, 0]
        },
        viewMatricesInfo: {
          columnPages: 0,
          rowPages: 0,
          matrices: { top: [], center: [], bottom: [] }
        }
      }
    );
  }
  /**
   * Returns initial set of measurements for the grid layout
   *
   * @static
   * @return {Object} Returns initial set of measurements
   * @memberof GridLayout
   */
  static defaultMeasurement() {
    return E$;
  }
  /**
   * Returns initialconfiguration for grid layout
   *
   * @static
   * @return {Object} Returns initial configuration for grid layout
   * @memberof GridLayout
   */
  static defaultConfig() {
    return C$;
  }
  /**
   * This function is used to return an instance of GridLayout
   *
   * @return {GridLayout} Instance of grid layout.
   * @static
   * @memberof GridLayout
   */
  static create() {
    return new FB(
      null,
      null,
      this.defaultMeasurement(),
      this.defaultConfig()
    );
  }
  /**
   * Sets/Gets the matrices for the layout
   *
   * @param {Array} matrices Set of matrices
   * @return {Object} Getter/Setter
   * @memberof GridLayout
   */
  matrices(t) {
    return t ? (this._matrices = G$(this, t), this) : super.matrices(t);
  }
  compute() {
    const { width: t, height: i } = this.measurement();
    this.centerMatrix().compute({
      availableSpace: { width: t, height: i }
    });
    const {
      detail: { rowHeights: n, columnWidths: A }
    } = this._centerMatrix.getLogicalSpace();
    this._rowMatrix.compute(n), this._columnMatrix.compute(A);
  }
  /**
   * Triggers the computations for the layout based on the matrices available
   * This causes a reflow in the entire layout system.
   *
   * @return {Object} Layout instance
   * @memberof GridLayout
   */
  triggerReflow() {
    this.scrollInfo({ horizontal: !1, vertical: !1 });
    const { maxHeightAvailableForRowMatrix: t, maxWidthAvailableForColumnMatrix: i } = W$(this);
    return this.setViewInformation(
      t,
      i
    ), this;
  }
  gotoPage(t, i) {
    const n = t.toLowerCase(), { viewMatricesInfo: A } = this.viewInfo(), s = A[`${n}Pages`], o = Math.min(Math.max(1, i), s);
    return this.config({
      [`${n}Pointer`]: o - 1
    }), this.setViewInformation(), this.renderGrid(), this;
  }
  pages(t) {
    const { viewMatricesInfo: i } = this.viewInfo(), n = t.toLowerCase();
    return {
      totalPages: i[`${n}Pages`],
      currentPage: this.config()[`${n}Pointer`] + 1
    };
  }
  viewInfo(...t) {
    return t.length ? (this._viewInfo = t[0], this) : this._viewInfo;
  }
  scrollInfo(...t) {
    return t.length ? (this._scrollInfo = tt(this._scrollInfo, t[0]), this) : this._scrollInfo;
  }
  /**
   *
   *
   * @returns
   * @memberof GridLayout
   */
  setViewInformation(t, i) {
    const { rowPointer: n, columnPointer: A, border: s } = this.config(), o = V$(this, n, A), r = j$(
      this,
      t,
      i
    );
    return r.border = s, this.viewInfo({
      viewMatricesInfo: o,
      layoutDimensions: r
    }), this;
  }
  remove() {
    Object.values(this.matrices()).forEach((t) => {
      t.forEach((i) => {
        i.forEach((n) => {
          n.forEach((A) => {
            A.remove();
          });
        });
      });
    });
  }
}
class q$ {
  /**
   * Property accessor for data member of the class. Data is passed to the system by calling this method.
   */
  data() {
    throw new Error(dt.INTERFACE_IMPl);
  }
  /**
   * Property accessor for width of the class. Width is passed as an integer.
   */
  width() {
    throw new Error(dt.INTERFACE_IMPl);
  }
  /**
   * Property accessor for height of the class. Height is passed as an integer.
   */
  height() {
    throw new Error(dt.INTERFACE_IMPl);
  }
  /**
   * Property accessor for config of the class. Config is passed as an object.
   */
  config() {
    throw new Error(dt.INTERFACE_IMPl);
  }
}
const z$ = (e) => {
  const t = e.config().legend, i = e.title()[1], n = e.subtitle()[1], A = {
    [`${se}-${se}`]: [je, un, yc],
    [`${mA}-${mA}`]: [yc, un, je],
    [`${se}-${mA}`]: [je, yc, un],
    [`${mA}-${se}`]: [un, yc, je]
  }, s = [
    [EI, j0],
    [j0, EI]
  ], o = i.position || se, r = n.position || se;
  return {
    headers: A[`${o}-${r}`],
    legends: t.position === Me || t.position === se ? s[0] : s[1]
  };
}, Fy = (e) => typeof e == "function" && !e._sanitize ? e() : Ax(e()), Z$ = (e, t, i, n) => {
  let A = {};
  const { content: s, classPrefix: o, maxLines: r } = e, a = n || new Ou(
    {
      type: t === je ? "header" : "text",
      className: `${o}-${t}-cell`,
      subType: t,
      textAlign: e.align
    },
    {
      labelManager: i
    }
  ).config({ maxLines: r }).minSpacing({ width: 0, height: 0 });
  return a.source(s), a._minTickDiff = { height: 0, width: 0 }, e.position === se ? A = { top: 0, bottom: e.padding } : A = { top: e.padding, bottom: 0 }, a.config({ margin: A }), a;
}, $$ = (e, t, i, n) => e ? Z$(e, t, i, n) : "", X$ = (e) => {
  const t = {}, i = e.subtitle(), n = Fy(i[0]);
  return (e.config().columns.headers.show ? [je, un, al] : [je, un]).forEach((s) => {
    let o = {}, r = "";
    if (s === al ? (o = e.config().columns.headers, r = e.composition().visualGroup.matrix().column().getColumnTitle()) : (o = e[s](), r = Fy(o[0])), r) {
      const a = s === je || s === un ? o[1] : o;
      a.classPrefix = e.config().classPrefix, a.content = r, a.padding = s === je && n && !n.length ? i[1].padding : a.padding;
      const l = $$(
        a,
        s,
        e.dependencies().smartlabel,
        e[`${s}Cell`]
      );
      t[`${s}Cell`] = l, e._composition[s] = l;
    }
  }), t;
}, tX = (e, t) => {
  const { width: i, height: n } = t;
  let A = 0;
  if (n >= 200 && i >= 200) {
    for (let s in e) {
      const o = e[s], r = {};
      r.width = i, r.height = n, o.config(r);
      const a = o.getLogicalSpace().height;
      A += a;
    }
    return A;
  }
  return A;
}, eX = (e) => {
  const t = [], i = e.getRetinalAxes();
  return Object.entries(i).forEach((n) => {
    const A = n[0], s = n[1], o = e.data();
    s.forEach((r) => {
      if (!r)
        return;
      const { field: a, type: l, step: c, splitFieldValue: g, splitBy: h } = r.config(), u = o.getFieldIndex(a), d = Number.isFinite(u) && u >= 0;
      if (a && d && r.domain()) {
        const I = m7[`${l}-${typeof c == "boolean" ? c : !1}-${A}`];
        t.push({
          scale: r,
          canvas: e,
          fieldName: a,
          splitFieldInfo: {
            field: h ? h.field : null,
            value: h ? g : null
          },
          title: g || pl(e.data(), a),
          LegendCls: I,
          scaleType: A
        });
      }
    });
  }), t;
}, iX = (e, t) => {
  const i = e.map((A) => A.config().mark);
  return B7[(t === Kn || t === Wn) && i.includes(x7)];
}, nX = ({ legend: e, scaleType: t }, i) => (n) => {
  const A = e.fieldName(), s = e.config().splitFieldInfo;
  s.field ? (i.props.legend[t][A] || (i.props.legend[t][A] = {
    splitLegends: {}
  }), i.props.legend[t][A].splitLegends[s.value] = {
    interaction: n
  }) : i.props.legend[t][A] = {
    interaction: n
  };
}, AX = (e, t) => {
  const i = [], n = eX(t), { invalidValues: A, useUTC: s } = t.config(), o = t.registry().interactions.legend, r = bC(A);
  return n.forEach((a) => {
    const {
      LegendCls: l,
      scale: c,
      fieldName: g,
      splitFieldInfo: h,
      title: u,
      scaleType: d
    } = a;
    e[d][pc] = e[d][pc] !== void 0 ? e[d][pc] : e[pc];
    const f = tt(
      { ...gx([Kn, Ss, Wn], e) },
      e[d] || {}
    ), I = W(f, "fields", g) || {}, C = W(I, c.config().as) || {}, E = W(
      I,
      "splitBy",
      "values",
      h.value
    ) || {}, B = tt(
      {},
      f,
      I,
      C,
      E
    );
    B.align = Hu(B.position), delete B.splitBy, delete B.ordering, B.useUTC = s;
    const m = B.title || {};
    if (m.text = m.text || u, B.show) {
      const y = l.create(
        {
          labelManager: t._dependencies.smartlabel,
          cells: {
            AxisCell: wB,
            TextCell: Ou
          },
          registry: {
            interactions: o
          }
        },
        d,
        t.createChildEventManager()
      );
      [TN, vN, GN].forEach((k) => {
        B[k];
      });
      const D = y.metaData();
      D instanceof J && D.dispose();
      const Q = t.composition().visualGroup.matrix().geom().getMatrix()[0][0].source().layers(), { colFacets: p, rowFacets: w, rowProjections: x, colProjections: S } = t.composition().visualGroup.resolver().projections();
      B.shape = iX(Q, d), B.splitFieldInfo = h;
      const _ = [
        ...p,
        ...w,
        ...x,
        ...S
      ].flat().find((k) => `${k}` === g), M = t.config().rows.totals.subTotals.enabled || t.config().rows.facets.interaction.collapse.enabled || t.config().columns.totals.subTotals.enabled || t.config().columns.facets.interaction.collapse.enabled;
      B.hiddenDomain = t.config().legend.includeTotalDomain === !1 && _ && M ? [
        .../* @__PURE__ */ new Set([
          t.config().rows.totals.data.totalString,
          t.config().columns.totals.data.totalString
        ])
      ] : [], y.scale(c).valueParser(r).title(m).fieldName(g).config(B).metaData(
        t.composition().visualGroup.getGroupByData().project(
          [g, h.field].filter((k) => k)
        )
      ).canvasAlias(t.alias()).setParentInfo({ canvasRoot: t.mount() }), y._globalContext = t._globalContext, y.firebolt()._globalContext = t._globalContext, y.firebolt()._saveSerializedInteractionState = nX(
        {
          scaleType: d,
          legend: y
        },
        t
      ), i.push({ canvas: t, legend: y, scaleType: d });
    }
  }), i;
}, sX = (e, t, i) => {
  const { height: n, width: A, headerHeight: s } = t, { legend: o } = i;
  e.forEach((h) => {
    const u = h.config(), d = {}, { align: f } = u;
    d.maxHeight = f === ll ? n - s : n * 0.2, d.maxWidth = f === Qr ? A : A * 0.2, d.width = Math.min(d.maxWidth, u.width), d.height = Math.min(d.maxHeight, u.height), [TN, vN, GN].forEach((E) => {
      d[E] = u[E];
    });
    const { legend: I } = i, { show: C } = I;
    I.show = C && (f === ll && A > 200 || f === Qr && n > 200), h.config({
      show: I.show
    }).measurement(d).setLegendMeasures(d);
  });
  const r = [se, mA, Me, Tn].reduce(
    (h, u) => (h[u] = {
      legends: [],
      config: tt(
        { ...o },
        { position: u, align: Hu(u) }
      )
    }, h),
    {}
  ), a = e.reduce((h, u) => {
    const d = u.config().position;
    return h[d] && h[d].legends.push(u), h;
  }, r), l = Object.keys(a).reduce((h, u) => {
    const { legends: d, config: f } = a[u];
    let I = { width: 0, height: 0 };
    return d.length > 0 && (I = oX(d, f, n, A)), h[u] = I, h;
  }, {}), c = l[Me].width + l[Tn].width, g = l[se].height + l[mA].height;
  return {
    legendSpace: l,
    legendWidth: c,
    legendHeight: g
  };
}, oX = (e, t, i, n) => {
  const A = e.map((r) => r.measurement()), s = { width: 0, height: 0 };
  let o = 0;
  return A.forEach((r) => {
    const a = Math.min(r.width, r.maxWidth), l = Math.min(r.height, r.maxHeight);
    t.align === Qr ? (s.width = n, o < xZ && (s.height += l), s.height = Math.min(
      s.height,
      i * Hj
    ), o++) : (s.width = Math.min(
      Math.max(s.width, a),
      n * Uj
    ), s.height = i);
  }), s;
}, rX = (e) => {
  const t = e.config(), { legend: i } = t, { position: n } = i;
  i.classPrefix = e.config().classPrefix;
  const A = Hu(n);
  return i.align = A, AX(
    i,
    e,
    // measurement,
    e.composition().legend || {}
  );
};
class aX extends Os {
  constructor(t) {
    super(t.name, t.component.getLogicalSpace(), 0), this.setParams(t);
  }
  renderHeader(t) {
    const i = this.params.config;
    t = V(t);
    const { align: n } = i, A = t.selectAll(`.${i.classPrefix}-inner-container`).data([this.name]);
    A.exit().remove();
    const o = A.enter().append("div").merge(A);
    o.classed(`${i.classPrefix}-inner-container`, !0);
    const { height: r, width: a } = this.boundBox();
    this.component.setAvailableSpace(a, r), this.component && this.component.render(o.node()), o.selectAll("div").classed(`${i.classPrefix}-inner-content`, !0), o.style("width", "100%"), i && this.component && o.style("float", Me).style("text-align", n);
  }
  draw(t) {
    this.renderHeader(t || document.getElementById(this.renderAt()));
  }
  updateWrapper(t) {
    return this.setParams(t), this.name(t.name), this.boundBox(t.component.getLogicalSpace()), this;
  }
  setParams(t) {
    this.component = t.component, this.params = t, this.target(t.config.target), this.position(t.config.position), this.className(t.config.className), this.alignWith(t.config.alignWith), this.alignment(t.config.alignment);
  }
  setSpatialConfig(t) {
    this.boundBox({
      top: t.y,
      left: t.x,
      width: t.width,
      height: t.height
    }), this.renderAt(t.renderAt);
  }
}
const lX = Fr(), cX = {
  left: Ii,
  right: Ii,
  top: Ci,
  bottom: Ci
}, w1 = (e, t, i) => {
  let n = 0;
  return (e.primary && e.primary.length ? e.primary : e.secondary).map((s) => {
    const o = n * 100 / (t - i);
    return n += s, o;
  });
}, Rh = (e, t, i) => {
  const { classPrefix: n, thickness: A } = i, s = j(
    e,
    "div",
    [t],
    `${n}-scroll-arrow-${t}`
  );
  return s.classed(`${n}-scroll-arrow`, !0), s.style(cX[t], `${A}px`), j(
    s,
    "div",
    [1],
    `${n}-scroll-arrow-chevron`
  ).attr("id", `${n}-scroll-arrow-chevron-${t}`), s;
}, x1 = (e, t) => {
  const { classPrefix: i } = t, n = j(e, "div", [1], `${i}-scroll-rect`), A = j(n, "div", [1], `${i}-scroll-mover`);
  return { rect: n, mover: A };
}, gX = (e, t) => {
  const { rect: i } = t;
  i.on("click", () => {
    const n = Bt();
    e.emptyScrollAreaClick(n);
  });
}, hX = (e, t) => {
  let i = {}, n = 0, A = 0, s = {};
  const { mover: o, rect: r } = t;
  o.call(
    lX().on("start", () => {
      const a = Bt();
      n = o.node().getBoundingClientRect(), A = r.node().getBoundingClientRect(), i = {
        x: a.x,
        y: a.y
      };
    }).on("drag", () => {
      const a = Bt(), l = Vw();
      s = {
        x: a.x,
        y: a.y
      };
      const c = {
        x: s.x - i.x,
        y: s.y - i.y
      }, g = l.pageXOffset || document.documentElement.scrollLeft, h = l.pageYOffset || document.documentElement.scrollTop, u = {
        x: n.x + g + c.x - (A.x + g),
        y: n.y + h + c.y - (A.y + h)
      };
      e.changeMoverPosition(u);
    })
  ), e._onRemoveListeners.push(() => {
    o.on(".drag", null), V(window).on(".drag", null);
  });
}, Ry = (e, t, i) => {
  const { mover: n, rect: A } = e, { x: s, y: o } = n.node().getBoundingClientRect(), { x: r, y: a } = A.node().getBoundingClientRect();
  t.changeMoverPosition({
    x: s - r + i,
    y: o - a + i
  });
}, ky = (e, t, i, n) => {
  let A = "";
  const s = e._components[i];
  if (!s)
    return;
  const o = YC();
  s.on(o ? "touchstart" : "mousedown", () => {
    Bt().preventDefault(), clearInterval(A), A = setInterval(() => {
      Ry(t, e, n);
    }, 100);
  }).on(o ? "touchend" : "mouseup", () => {
    Bt().preventDefault(), clearInterval(A);
  }).on("click", () => {
    clearInterval(A), Ry(t, e, n);
  }).on("mouseout", () => {
    clearInterval(A);
  }), e._onRemoveListeners.push(() => {
    clearInterval(A);
  });
}, uX = (e) => {
  const { moverRect: t } = e._components, i = e.config().speed;
  e.clearOnRemoveListeners(), ky(e, t, "prevArrow", -i), hX(e, t), gX(e, t), ky(e, t, "nextArrow", i);
}, dX = (e, t, i, n) => {
  const { classPrefix: A } = t, s = j(
    V(e),
    "div",
    [1],
    `#${A}-scroll-bar-${n}`
  );
  return s.classed(`${A}-scroll-bar`, !0), s.style(Ii, `${i.width}px`), s.style(Ci, `${i.height}px`), s;
}, fX = {
  config: {
    sanitization: (e, t) => (t = tt(e._config, t), t)
  },
  manager: {},
  unitPositions: {},
  logicalSpace: {}
};
class S1 {
  constructor() {
    this._components = {}, this._logicalSpace = {}, this._attachedScrollAction = () => {
    }, this._config = {
      thickness: 10,
      speed: 2
    }, this._unitPositions = null, this._scrollPercent = 0, ge(this, fX), this._props = {}, this._stateManager = null, this._scrollListeners = [], this._onRemoveListeners = [];
  }
  props(t) {
    return t && (this._props = t), this._props;
  }
  static type() {
    throw new dt("Method not implemented");
  }
  emptyScrollAreaClick() {
    throw new dt("Method not implemented");
  }
  changeMoverPosition() {
    throw new dt("Method not implemented");
  }
  scrollTo() {
    throw new dt("Method not implemented");
  }
  scrollDeltaTo() {
    throw new dt("Method not implemented");
  }
  createScroll(t) {
    const i = this.config();
    return {
      scrollBarContainer: dX(
        t,
        i,
        this.logicalSpace(),
        this.constructor.type()
      )
    };
  }
  attachScrollAction(t) {
    return this._attachedScrollAction = t, this;
  }
  detachScrollAction() {
    return this._attachedScrollAction = () => {
    }, this;
  }
  getLogicalSpace() {
    return this.logicalSpace();
  }
  registerListeners() {
    return uX(this), this;
  }
  remove() {
    const t = this._components.scrollBarContainer;
    return t && t.remove(), this.clearOnRemoveListeners(), this;
  }
  stateManager(t) {
    return t && (this._stateManager = t), this._stateManager;
  }
  onScroll(t) {
    this._scrollListeners.push(t);
  }
  clearOnRemoveListeners() {
    this._onRemoveListeners.forEach((t) => t()), this._onRemoveListeners.length = 0;
  }
}
class IX extends S1 {
  /**
   * Describes the type of the ScrollMaker
   *
   * @public
   *
   * @return {String} Returns the type of scroll maker: horizontal
   */
  static type() {
    return Qr;
  }
  createScroll(t, i = this.logicalSpace()) {
    const n = this.config(), { scrollBarContainer: A } = super.createScroll(
      t,
      n,
      i
    ), s = n.buttons.show, o = s ? Rh(A, "left", n) : void 0, r = x1(A, n), a = s ? Rh(A, "right", n) : void 0, { mover: l, rect: c } = r, { height: g, width: h, totalLength: u, viewLength: d, unitWidths: f } = this.logicalSpace(), I = h - (s ? g * 2 : 0);
    c.style(Ii, `${I}px`), c.style(Ci, "100%"), l.style(
      Ii,
      `${d * I / u}px`
    ), l.style(Ci, "100%");
    const C = this.getMoverPosFromScrollPercent(this.getScrollPercent());
    l.style(Me, `${C}px`), this._components = {
      prevArrow: o,
      nextArrow: a,
      moverRect: r,
      scrollBarContainer: A
    }, this.unitPositions(w1(f, u, d)), this.registerListeners();
  }
  emptyScrollAreaClick(t) {
    const { mover: i, rect: n } = this._components.moverRect, A = this.config().speed, { x: s, y: o } = i.node().getBoundingClientRect(), { x: r, y: a } = n.node().getBoundingClientRect();
    let l = A * 10;
    t.x < s && (l = -A * 10), this.changeMoverPosition({
      x: s - r + l,
      y: o - a + l
    });
  }
  // This function is called on every scroll events.
  changeMoverPosition(t, i = !0) {
    let n;
    const { mover: A, rect: s } = this._components.moverRect, o = s.node().getBoundingClientRect(), r = A.node().getBoundingClientRect(), { totalLength: a } = this.logicalSpace();
    t.x < 0 ? n = 0 : t.x + r.width > o.width ? n = o.width - r.width : n = t.x, A.style(Me, `${n}px`);
    const l = this.getScrollBarWithoutArrowLength(), c = n * a / l, g = n * 100 / (this.getScrollBarWithoutArrowLength() - r.width);
    this.setScrollPercent(
      Number.isNaN(g) ? 0 : g
    ), this.manager().performAttachedScrollFunction(
      this.constructor.type(),
      c
    ), i && this._scrollListeners.forEach((h) => h());
  }
  getScrollPercent() {
    return this.manager().getHorizontalScrollPercent();
  }
  setScrollPercent(t) {
    this.manager().updateHorizontalScrollPercent(t);
  }
  scrollDeltaTo(t) {
    const { mover: i, rect: n } = this._components.moverRect, A = i.node().getBoundingClientRect(), s = n.node().getBoundingClientRect(), { totalLength: o } = this.logicalSpace(), r = A.x - s.x, a = this.getScrollBarWithoutArrowLength(), l = r * o / a, g = Math.max(l + t, 0) * a / o;
    return this.changeMoverPosition({ y: 0, x: g }), this;
  }
  /**
   * Scrolls to the specific point in the page. The input is provided as a percentage (0 - 100)
   *
   * @public
   *
   * @param {number} scrollPercentage Its the percentage based on which the scroll action will occur
   * @return {HorizontalScrollMaker} Instance of the HorizontalScrollMaker
   */
  scrollTo(t, i) {
    const n = this.getMoverPosFromScrollPercent(t);
    return this.changeMoverPosition({ y: 0, x: n }, i), this;
  }
  getScrollPixelsFromScrollPercent(t) {
    const { totalLength: i } = this.logicalSpace(), n = this.getMoverPosFromScrollPercent(t), A = this.getScrollBarWithoutArrowLength();
    return n * i / A;
  }
  getMoverPosFromScrollPercent(t) {
    const i = this.getScrollBarWithoutArrowLength(), { width: n } = this.logicalSpace(), A = this.getMoverWidth(), s = t * (i - A) / 100;
    let o;
    return s < 0 ? o = 0 : s + A > n ? o = n - A : o = s, o;
  }
  getMoverWidth() {
    const { viewLength: t, totalLength: i } = this.logicalSpace(), n = this.getScrollBarWithoutArrowLength();
    return t * n / i;
  }
  getScrollBarWithoutArrowLength() {
    const { width: t, height: i } = this.logicalSpace(), n = this.config().buttons.show;
    return t - (n ? i * 2 : 0);
  }
}
class CX extends S1 {
  constructor(...t) {
    super(...t);
  }
  /**
   * Describes the type of the ScrollMaker
   *
   * @public
   *
   * @return {String} Returns the type of scroll maker: vertical
   */
  static type() {
    return ll;
  }
  createScroll(t, i = this.logicalSpace()) {
    const n = this.config(), { scrollBarContainer: A } = super.createScroll(t, i), s = n.buttons.show, o = s ? Rh(A, "top", n) : void 0, r = x1(A, n), a = s ? Rh(A, "bottom", n) : void 0, { mover: l, rect: c } = r, { height: g, width: h, totalLength: u, viewLength: d, unitHeights: f } = this.logicalSpace(), I = g - (s ? h * 2 : 0);
    c.style(Ci, `${I}px`), c.style(Ii, "100%"), l.style(Ii, "100%"), l.style(
      Ci,
      `${d * I / u}px`
    );
    const C = this.getMoverPosFromScrollPercent(this.getScrollPercent());
    l.style(se, `${C}px`), this._components = {
      prevArrow: o,
      nextArrow: a,
      moverRect: r,
      scrollBarContainer: A
    }, this.unitPositions(w1(f, u, d)), this.registerListeners();
  }
  emptyScrollAreaClick(t) {
    const { mover: i, rect: n } = this._components.moverRect, A = this.config().speed, { x: s, y: o } = i.node().getBoundingClientRect(), { x: r, y: a } = n.node().getBoundingClientRect();
    let l = A * 10;
    t.y < o && (l = -A * 10), this.changeMoverPosition({
      x: s - r + l,
      y: o - a + l
    });
  }
  changeMoverPosition(t, i = !0) {
    let n;
    const { mover: A, rect: s } = this._components.moverRect, { totalLength: o } = this.logicalSpace(), r = s.node().getBoundingClientRect(), a = A.node().getBoundingClientRect();
    t.y < 0 ? n = 0 : t.y + a.height > r.height ? n = r.height - a.height : n = t.y, A.style(se, `${n}px`);
    const l = this.getScrollBarWithoutArrowLength(), c = n * o / l, g = n * 100 / (this.getScrollBarWithoutArrowLength() - a.height);
    this.setScrollPercent(
      Number.isNaN(g) ? 0 : g
    ), this.manager().performAttachedScrollFunction(
      this.constructor.type(),
      c
    ), i && this._scrollListeners.forEach((h) => h());
  }
  getScrollPercent() {
    return this.manager().getVerticalScrollPercent();
  }
  setScrollPercent(t) {
    this.manager().updateVerticalScrollPercent(t);
  }
  /**
   * Scrolls based on the actual pixel value provided. Since it's a delta change, the input will be
   * a delta between (-Infinity, Infinity), based on which the scroll will occur. Only a delta movement in
   * scroll occurs
   *
   * @public
   *
   * @param {number} delta Based on which the scroll will have a delta change in position
   * @return {VerticalScrollMaker} Instance of the VerticalScrollMaker
   */
  scrollDeltaTo(t) {
    const { mover: i, rect: n } = this._components.moverRect, A = i.node().getBoundingClientRect(), s = n.node().getBoundingClientRect(), { totalLength: o } = this.logicalSpace(), r = A.y - s.y, a = this.getScrollBarWithoutArrowLength(), l = r * o / a, g = Math.max(l + t, 0) * a / o;
    return this.changeMoverPosition({ y: g, x: 0 }), this;
  }
  /**
   * Scrolls to the specific point in the page. The input is provided as a percentage (0 - 100)
   *
   * @public
   *
   * @param {number} scrollPercentage Its the percentage based on which the scroll action will occur
   * @return {VerticalScrollMaker} Instance of the VerticalScrollMaker
   */
  scrollTo(t, i) {
    const { mover: n } = this._components.moverRect, A = n.node().getBoundingClientRect(), s = t * (this.getScrollBarWithoutArrowLength() - A.height) / 100;
    return this.changeMoverPosition({ x: 0, y: s }, i), this;
  }
  getScrollPixelsFromScrollPercent(t) {
    const { totalLength: i } = this.logicalSpace(), n = this.getMoverPosFromScrollPercent(t), A = this.getScrollBarWithoutArrowLength();
    return n * i / A;
  }
  getMoverPosFromScrollPercent(t) {
    const i = this.getScrollBarWithoutArrowLength(), { height: n } = this.logicalSpace(), A = this.getMoverHeight(), s = t * (i - A) / 100;
    let o;
    return s < 0 ? o = 0 : s + A > n ? o = n - A : o = s, o;
  }
  getMoverHeight() {
    const { viewLength: t, totalLength: i } = this.logicalSpace(), n = this.getScrollBarWithoutArrowLength();
    return t * n / i;
  }
  getScrollBarWithoutArrowLength() {
    const { width: t, height: i } = this.logicalSpace(), n = this.config().buttons.show;
    return i - (n ? t * 2 : 0);
  }
}
const EX = {
  horizontal: IX,
  vertical: CX
};
class BX extends Os {
  constructor(t) {
    const i = EX[t.config.type];
    t.component = new i(), t.component.config(t.config.scrollBarComponentConfig), t.component.logicalSpace(t.dimensions), super(t.name, t.component.getLogicalSpace(), 0), this.setParams(t);
  }
  manager(...t) {
    return t.length ? (this.component.manager(t[0]), this) : this.component.manager();
  }
  /**
   * Scrolls based on the actual pixel value provided. Since it's a delta change, the input will be
   * a delta between (-Infinity, Infinity), based on which the scroll will occur. Only a delta movement in
   * scroll occurs
   *
   * @public
   *
   * @param {number} delta Based on which the scroll will have a delta change in position
   * @return {ScrollComponent} Instance of the ScrollComponent
   */
  scrollDeltaTo(t) {
    return this.component.scrollDeltaTo(t), this;
  }
  /**
   * Scrolls to the specific point in the page. The input is provided as a percentage (0 - 100)
   *
   * @public
   *
   * @param {number} scrollPercentage Its the percentage based on which the scroll action will occur
   * @return {ScrollComponent} Instance of the ScrollComponent
   */
  scrollTo(t, i) {
    return this.component.scrollTo(t, i), this;
  }
  /**
   * Scrolls to the specific point in the page based on the unit index.
   * The input is provided as a number represting the index for the unit.
   * For vertical scroll, it's the row index that will be required.
   * For horizontal scroll, it's the column index that will be required.
   *
   * @public
   *
   * @param {number} unitIndex Index of the unit appearing in the grid
   * @return {ScrollComponent} Instance of the ScrollComponent
   */
  scrollToUnitIndex(t) {
    const i = this.getUnitScrollPosition(t);
    return this.component.scrollTo(i), this;
  }
  getUnitScrollPosition(t) {
    const i = this.component.unitPositions(), n = Math.min(
      Math.max(0, t),
      i.length - 1
    );
    return i[n];
  }
  /**
   * Provides the positions of the units(either horizontal or vertical based on the type
   * of scroll bar it wraps) relative to it's container. The position of the first unit starts at 0
   *
   *
   * @public
   *
   * @return {Array} Positions of units either horizontal or vertical
   */
  getScrollPositionsForUnits() {
    return this.component.unitPositions();
  }
  draw(t) {
    return this.component.createScroll(
      t || document.getElementById(this.renderAt())
    ), this;
  }
  /**
   * Can be used to attach a scroll action whenever scrolling occurs in the canvas
   *
   * @public
   * @param {number} externalAction Action to be attached during scroll
   * @return {ScrollComponent} Instance of the ScrollComponent
   */
  attachScrollAction(t) {
    return this.component.attachScrollAction(t), this;
  }
  /**
   * Can be used to detach the scroll action already bound to the scroll bar
   *
   * @public
   * @return {ScrollComponent} Instance of the ScrollComponent
   */
  detachScrollAction() {
    return this.component.detachScrollAction(), this;
  }
  updateWrapper(t) {
    return this.name(t.name), this.component.config(t.config.scrollBarComponentConfig), this.component.logicalSpace(t.dimensions), this.boundBox(this.component.getLogicalSpace()), this.setParams(t), this;
  }
  getScrollPercent() {
    return this.component.getScrollPercent();
  }
  getScrollPixelsFromScrollPercent(t) {
    return this.component.getScrollPixelsFromScrollPercent(t);
  }
  setScrollPercent(t) {
    return this.component.setScrollPercent(t), this;
  }
  setParams(t) {
    this.component = t.component || this.component, this.params = t, this.target(t.config.target), this.position(t.config.position), this.className(t.config.className), this.alignWith(t.config.alignWith), this.alignment(t.config.alignment);
  }
  remove() {
    this.component.remove();
  }
}
const mX = `<svg width="215px" height="199px" viewBox="0 0 215 199" 
version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->

<title>Group 23</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <polygon id="path-1" points="0.149161328 0.420711883 72.119 0.420711883 
        72.119 71.9995421 0.149161328 71.9995421"></polygon>
        <polygon id="path-3" points="0 0.08 186.190753 0.08 186.190753 88.592 0 88.592"></polygon>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-23" transform="translate(0.000000, -1.000000)">
            <g id="Group-3" transform="translate(142.000000, 127.920000)">
                <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                </mask>
                <g id="Clip-2"></g>
                <path d="M0.163,36.1555 C0.163,28.8495 0.126,21.5445 0.173,14.2395 
                C0.226,6.1165 4.776,0.7895 12.76,0.6405 C28.362,0.3505 43.979,0.3335 
                59.58,0.6735 C67.574,0.8475 72.079,6.2375 72.096,14.3735 C72.125,28.9835 
                72.129,43.5935 72.094,58.2045 C72.074,66.4205 67.223,71.7225 58.955,71.8405 
                C43.682,72.0565 28.4,72.0515 13.128,71.8315 C4.928,71.7135 0.221,66.4315 
                0.172,58.0705 C0.129,50.7655 0.163,43.4605 0.163,36.1555" id="Fill-1" 
                fill="#8c8d8e" mask="url(#mask-2)"></path>
            </g>
            <g id="Group-6" transform="translate(0.000000, 0.920000)">
                <mask id="mask-4" fill="white">
                    <use xlink:href="#path-3"></use>
                </mask>
                <g id="Clip-5"></g>
                <path d="M183.4677,4.615 C174.5697,3.72 165.6917,2.607 156.8037,1.597 C152.7477,1.136 
                147.5417,-0.986 144.9347,0.755 C142.0737,2.664 143.7187,8.515 142.6187,12.488 C141.7057,
                15.785 143.1607,16.531 146.0297,16.716 C149.3127,16.928 152.5717,17.483 156.6277,17.987 
                C137.8927,32.589 119.9087,46.473 102.1267,60.61 C99.4257,62.757 98.2077,62.204 96.1947,
                60.05 C85.5357,48.644 74.6947,37.409 64.0607,25.979 C61.8547,23.608 60.5757,23.002 57.8627,
                25.586 C51.9777,31.188 45.6137,36.286 39.4547,41.6 C26.7597,52.553 14.0947,63.54 1.3487,
                74.433 C-0.2963,75.838 -0.4833,76.732 1.0457,78.354 C4.1127,81.609 6.9717,85.061 10.0567,
                88.592 C26.7507,74.17 43.3037,59.87 59.9757,45.469 C71.5287,57.708 82.9977,69.719 94.2677,
                81.914 C96.5347,84.368 98.0097,84.604 100.6707,82.492 C116.3907,70.016 132.2397,57.704 
                148.0587,45.353 C153.9727,40.736 159.9197,36.162 165.9517,31.491 C167.0647,36.458 163.2367,
                42.055 165.8357,44.513 C168.4597,46.994 174.2387,46.065 178.6037,46.814 C180.5447,47.148 
                181.1657,46.627 181.4047,44.671 C182.9067,32.336 184.5297,20.016 186.1377,7.696 C186.4127,
                5.593 185.6327,4.833 183.4677,4.615" id="Fill-4" fill="#8c8d8e" mask="url(#mask-4)"></path>
            </g>
            <path d="M68.7436,89.5418 C63.2716,89.6988 57.7836,89.7768 52.3196,89.5178 C49.1866,89.3688 
            48.3926,90.4028 48.4386,93.4328 C48.6076,104.5468 48.5056,115.6668 48.5056,126.7838 C48.5056,
            138.0668 48.5916,149.3518 48.4436,160.6328 C48.4076,163.4118 49.1436,164.3578 52.0056,164.2518 
            C57.8066,164.0398 63.6226,164.0938 69.4276,164.2338 C71.7586,164.2898 72.5516,163.6408 72.5416,
            161.1938 C72.4536,138.4608 72.4326,115.7288 72.556775,92.9968 C72.5736,89.9318 71.3526,89.4668 
            68.7436,89.5418" id="Fill-7" fill="#8c8d8e"></path>
            <path d="M144.3769,91.2962 C138.9019,91.4772 133.4019,91.5912 127.9409,91.2652 C124.4229,91.0562 
            123.8999,92.4662 123.9449,95.5182 C124.1039,106.3102 124.0069,117.1072 124.0069,127.9012 C124.0079,
            137.3672 124.0079,146.8332 124.0079,156.3002 C124.0079,164.4422 124.0079,164.3082 132.1549,
            164.2632 C134.9749,164.2472 135.8559,163.4702 135.7569,160.6292 C135.5449,154.6582 135.6479,
            148.6742 135.6999,142.6952 C135.7679,135.0662 138.3559,128.6922 145.3599,124.8822 C147.2959,
            123.8292 147.7519,122.5322 147.7349,120.5452 C147.6649,111.9092 147.6109,103.2722 147.7569,
            94.6382 C147.8009,92.0132 146.9799,91.2102 144.3769,91.2962" id="Fill-9" fill="#8c8d8e"></path>
            <path d="M110.3095,117.074 C110.3265,114.616 109.4485,113.950948 107.1345,113.998 C101.3365,
            114.117 95.5265,114.204 89.7365,113.96 C86.7245,113.833 86.2185,115.041 86.2735,117.672 C86.4225,
            124.795 86.3255,131.923 86.3245,139.049 C86.3245,146.34 86.4355,153.634 86.2645,160.922 C86.2035,
            163.546 86.9745,164.336 89.6015,164.249 C95.3955,164.057 101.2015,164.133 107.0005,164.217 C109.1175,
            164.247 110.3385,163.986 110.3185,161.321 C110.2015,146.573 110.2115,131.823 110.3095,117.074" 
            id="Fill-11" fill="#8c8d8e"></path>
            <path d="M31.1347,116.1951 C25.3367,116.4001 19.5237,116.3591 13.7217,116.2131 C11.2637,116.1521 
            10.6717,117.0871 10.6857,119.3921 C10.7747,133.3221 10.7877,147.2541 10.6847,161.1851 C10.6667,163.6601 
            11.5637,164.2771 13.8597,164.2291 C19.6617,164.1061 25.4757,164.0161 31.2717,164.2601 C34.2827,164.3871 
            34.7937,163.2071 34.7267,160.5531 C34.5597,153.9241 34.6717,147.2871 34.6717,140.6531 C34.6717,133.6881 
            34.5377,126.7181 34.7367,119.7581 C34.8177,116.9131 33.9317,116.0961 31.1347,116.1951" id="Fill-13" 
            fill="#8c8d8e"></path>
            <path d="M182.5937,62.2083 C175.8157,62.4493 169.0307,62.4883 162.2477,62.6073 L162.2467,62.6073 
            C161.0087,63.1583 161.4327,64.2813 161.4317,65.1903 C161.4087,83.2963 161.4087,101.4033 161.4347,
            119.5103 C161.4357,120.4033 160.9787,121.5473 162.2837,122.0423 C169.0747,122.1203 175.8697,122.1063 
            182.6567,122.3223 C185.0277,122.3973 185.2947,121.3543 185.2887,119.3853 C185.2347,101.3103 
            185.2377,83.2343 185.290773,65.1593 C185.2967,63.1633 184.9367,62.1253 182.5937,62.2083" 
            id="Fill-15" fill="#8c8d8e"></path>
            <path d="M178.6747,133.095 C186.1527,133.096 193.6297,133.02 201.1057,133.12 C206.6837,133.197 
            209.9207,136.107 209.9837,141.656 C210.1537,156.606 210.1427,171.56 209.9877,186.51 C209.9317,
            192.015 206.6527,195.159 201.1977,195.197 C185.9127,195.303 170.6257,195.306 155.3397,195.216 
            C149.4057,195.182 146.3497,192.185 146.3107,186.367 C146.2127,171.582 146.2197,156.795 146.3047,
            142.01 C146.3387,136.149 149.3577,133.194 155.2477,133.118 C163.0557,133.019 170.8657,133.094 
            178.6747,133.095" id="Fill-17" fill="#fbc0af"></path>
            <path d="M186.1288,150.0833 C184.6798,156.9563 182.9098,165.3223 181.1508,173.6913 C180.7868,
            175.4293 179.7388,176.1553 177.9798,176.1143 C176.1458,176.0713 175.3328,175.0033 174.9608,
            173.4093 C173.0558,165.2363 171.0608,157.0593 170.2818,148.6993 C169.8138,143.6663 173.1078,
            140.3553 177.7748,140.2323 C182.7748,140.1013 186.1058,143.4083 186.1288,150.0833" 
            id="Fill-19" fill="#FDFDFC"></path>
            <path d="M177.7314,188.0823 C175.7614,187.9153 174.3044,186.6683 174.3184,184.3533 C174.3334,
            182.0403 175.8334,180.6253 178.1304,180.6793 C180.3624,180.7313 182.0564,182.0443 181.9314,
            184.4023 C181.8194,186.5383 180.5864,188.1203 177.7314,188.0823" id="Fill-21" fill="#FCF6F3"></path>
        </g>
    </g>
    </svg>`, QX = (e, t) => {
  const { baseFontLimit: i, upperFontLimit: n, baseSizeLimit: A, upperSizeLimit: s } = ka, o = (s - A) / (n - i);
  let r = n;
  const a = e < t && e !== 0 ? e : t;
  return a === 0 ? r = 0 : a <= A ? r = i : a > A && a < s && (r = i + (s - a) / o), r;
};
class pX extends Os {
  constructor(t) {
    super(t.name, t.config.dimensions, 0), this.setParams(t);
  }
  render(t) {
    const i = V(t), { config: n } = this.params, { className: A } = n.classPrefix, s = j(i, "div", [1], A), { height: o, width: r } = n.dimensions, a = o > ka.baseSizeLimit ? ka.fractionChild * o : 0, { message: l } = n;
    li(s, { width: `${r}px`, height: `${o}px` });
    const c = j(s, "div", [1], `${A}-child`), g = j(c, "div", [1], `${A}-child-img`), h = j(c, "div", [1], `${A}-child-message`);
    li(c, { width: r, height: `${a}px` }), li(g, { width: r, height: `${a * ka.fractionImage}px` }), g.html(mX);
    const u = j(h, "text", [1]);
    li(h, { "font-size": `${QX(r, o)}px` }), u.html(l);
  }
  draw(t) {
    this.render(t || document.getElementById(this.renderAt()));
  }
  updateWrapper(t) {
    return this.name(t.name), this.boundBox(t.config.dimensions), this.setParams(t), this;
  }
  setParams(t) {
    const { target: i, className: n } = t.config;
    return this.component = t.component, this.params = t, this.target(i), this.className(n), this.position(t.config.position), this;
  }
}
class yX extends _B {
  renderLegend(t) {
    const i = V(t);
    if (!this.components.length)
      return;
    const n = [], A = [], s = [];
    this.components.forEach((d) => {
      const { width: f, height: I } = d.legend.measurement();
      d.legend.scaleType === "shape" ? n.push({
        ...d,
        width: f,
        height: I
      }) : d.legend.scaleType === "size" ? A.push({
        ...d,
        width: f,
        height: I
      }) : s.push({
        ...d,
        width: f,
        height: I
      });
    }), s.push(...n), s.push(...A);
    const { height: o } = this.newDimensions;
    let r = o, a = s.length;
    const l = s.map((d) => {
      let f = 0;
      if (d.legend instanceof ii) {
        const { height: I } = d, C = Math.min(
          I,
          SN
        );
        if (r > 0) {
          const E = r / a;
          f = Math.max(
            Math.min(I, E),
            C
          );
        } else
          f = C;
      } else
        d.legend instanceof sl, f = II;
      return r -= f, a--, {
        legend: d.legend,
        scaleType: d.scaleType,
        width: d.width,
        height: f
      };
    }), { classPrefix: c, position: g } = this.params.config;
    i.style("overflow-x", "hidden"), i.style("overflow-y", "auto"), g === Tn ? i.style("padding-left", `${eg}px`) : i.style(
      "padding-right",
      `${eg}px`
    );
    const h = j(
      i,
      "div",
      l,
      `${c}-legend-container`,
      {},
      (d) => d.legend.id()
    );
    h.style("width", "100%").style("height", (d) => `${d.height}px`).style("overflow", "hidden").style("position", "relative"), h.each(function(d) {
      V(this).classed(
        `${c}-${d.legend.config().position}-legend-container`,
        !0
      );
    });
    const u = i.node().clientWidth - eg;
    h.each(function(d) {
      V(this).style("width", `${u}px`), d.legend.mount(this);
    });
  }
}
class DX extends _B {
  renderLegend(t) {
    const i = V(t);
    if (!this.components.length)
      return;
    const A = this.components.map((a) => {
      const { width: l, height: c } = a.legend.measurement();
      return {
        ...a,
        width: l,
        height: c
      };
    }).map((a) => {
      const { height: l, width: c } = a;
      return {
        legend: a.legend,
        scaleType: a.scaleType,
        width: c,
        height: l
      };
    }), { classPrefix: s } = this.params.config;
    i.style("overflow-x", "hidden"), i.style("overflow-y", "auto");
    const o = j(
      i,
      "div",
      A,
      `${s}-legend-container`,
      {},
      (a) => a.legend.id()
    );
    o.style("width", "100%").style("height", (a) => `${a.height}px`).style("overflow", "hidden").style("position", "relative"), o.each(function(a) {
      V(this).classed(
        `${s}-${a.legend.config().position}-legend-container`,
        !0
      );
    });
    const r = i.node().clientWidth;
    o.each(function(a) {
      V(this).style("width", `${r}px`), a.legend.mount(this);
    });
  }
}
const wX = {
  title: {
    headerCell: "titleCell",
    configType: I1
  },
  subtitle: {
    headerCell: "subtitleCell",
    configType: C1
  },
  columnHeader: {
    headerCell: "columnHeaderCell",
    configType: {}
  }
}, xX = {
  [Me]: Me,
  [Tn]: Tn,
  [ye]: y7
}, SX = (e) => Object.keys(e).every((t) => e[t]), MX = (e) => {
  const { rows: t, columns: i, values: n } = e.components;
  return SX({ rows: t, columns: i, values: n });
}, Kd = (e, t, i) => {
  let n = null;
  const { components: A, layoutConfig: s } = i, { headerCell: o, configType: r } = wX[e], a = { target: Ol };
  if (A.headers && A.headers[o] && i.measurement.headerHeight > 0) {
    let l = e === je || e === un ? s[e] : s.axesHeaders.column;
    const c = A.headers[o];
    l = Object.assign({}, l, {
      classPrefix: s.classPrefix,
      ...a,
      alignWith: `${SA[0]}-${vr[1]}`,
      alignment: xX[l.align],
      className: r.className || l.className
    });
    const g = {
      name: e,
      component: c,
      config: l
    }, h = t.getComponent(e);
    h ? n = h.updateWrapper(g) : n = new aX(g);
  }
  return n;
}, _X = (e, t, i) => {
  const { components: n, measurement: A } = t, s = Object.values(n.headers || {});
  let o = 0, r = null;
  for (const a of s) {
    const l = a.logicalSpace();
    o += l ? l.height : 0;
  }
  if (!i) {
    const a = {
      height: A.canvasHeight - o,
      width: A.canvasWidth
    }, l = e.getComponent(pr), { height: c, width: g } = l && l.getBoundBox() || a, u = {
      ...{ target: Ol },
      dimensions: { height: c, width: g },
      message: S7,
      classPrefix: ka,
      position: se
    }, d = {
      name: Dh,
      component: null,
      config: u
    }, f = e.getComponent(Dh);
    return f ? r = f.updateWrapper(d) : r = new pX(d), r;
  }
  return null;
}, bX = (e) => ({
  vertical: {
    componentName: "verticalScrollBar",
    width: "thickness",
    height: "layoutBasedMeasure",
    layoutBasedMeasure: Ci,
    viewMeasure: "viewHeight",
    rowAlign: 1,
    colAlign: e.align === "right" ? 2 : 0,
    position: e.align,
    alignment: se
  },
  horizontal: {
    componentName: "horizontalScrollBar",
    width: "layoutBasedMeasure",
    layoutBasedMeasure: Ii,
    viewMeasure: "viewWidth",
    height: "thickness",
    rowAlign: e.align === "top" ? 0 : 2,
    colAlign: 1,
    position: e.align,
    alignment: Me
  }
}), Ty = (e, t, i, n, A, s) => {
  if (A) {
    let o = null;
    const { layoutConfig: r } = i, a = { target: Ol }, { scrollBar: l } = r, { layoutDimensions: c } = n.viewInfo(), { actualCenterMeasures: g, unitHeights: h, unitWidths: u } = c, {
      componentName: d,
      layoutBasedMeasure: f,
      width: I,
      height: C,
      rowAlign: E,
      colAlign: B,
      viewMeasure: m,
      position: y,
      alignment: D
    } = bX(l[e])[e], Q = {
      thickness: l.thickness,
      layoutBasedMeasure: c[m][1]
    }, p = n.scrollInfo()[e], w = g[f], x = c[m][1], S = Object.assign(
      {},
      {
        classPrefix: r.classPrefix,
        ...a,
        scrollBarComponentConfig: {
          ...l,
          classPrefix: r.classPrefix
        },
        type: e,
        alignWith: `${SA[E]}-${vr[B]}`,
        alignment: D,
        position: y
      }
    ), _ = {
      name: d,
      config: S,
      dimensions: {
        width: Q[I],
        height: Q[C],
        totalLength: w,
        viewLength: x,
        unitHeights: h,
        unitWidths: u
      }
    }, M = t.getComponent(d);
    return p ? (M ? o = M.updateWrapper(_) : o = new BX(_), o.component.stateManager(i.scrollStateManager), o) : (M && M.remove(), e === "vertical" ? NZ(s._store) : FZ(s._store), null);
  }
  return null;
}, Fc = (e, t, i, n) => {
  if (i) {
    let A = null;
    const { components: s, measurement: o } = t, r = { target: Ol }, { legends: a, config: l } = s.mappedLegends[n];
    if (a && a.length) {
      const c = { ...l, ...r, measurement: o }, g = u$(n), h = {
        name: g,
        component: a,
        config: c
      }, u = e.getComponent(g);
      u ? A = u.updateWrapper(h) : A = n === Me || n === Tn ? new yX(h) : new DX(h);
    }
    return A;
  }
  return null;
}, NX = (e, t, i, n, A) => {
  if (n) {
    let s = null;
    const o = { target: Ol }, { layoutConfig: r } = t, a = {
      ...o,
      pagination: "scroll",
      classPrefix: r.classPrefix,
      dimensions: { height: 0, width: 0 }
    }, l = {
      name: pr,
      component: i,
      config: a,
      store: A,
      layout: i
    }, c = e.getComponent(pr);
    return c ? s = c.updateWrapper(l) : s = new MB(l), s;
  }
  return null;
}, FX = (e, t, i) => {
  const n = e._layoutManager, A = MX(i);
  return {
    [je]: Kd(je, n, i),
    [DB]: Kd(un, n, i),
    [al]: Kd(
      al,
      n,
      i
    ),
    [Dh]: _X(n, i, A),
    [IB]: Fc(
      n,
      i,
      A,
      se
    ),
    [CB]: Fc(
      n,
      i,
      A,
      Zt
    ),
    [EB]: Fc(
      n,
      i,
      A,
      Me
    ),
    [BB]: Fc(
      n,
      i,
      A,
      Tn
    ),
    [pr]: NX(
      n,
      i,
      t,
      A,
      e._store
    ),
    [LN]: Ty(
      ll,
      n,
      i,
      t,
      A,
      e
    ),
    [UN]: Ty(
      Qr,
      n,
      i,
      t,
      A,
      e
    )
  };
};
class RX {
  constructor(t) {
    this._scrollBarComponents = {}, this._attachedComponents = {}, this._dependencies = t, this.updateStoreHorizontalScroll = Vd(
      this.updateStoreHorizontalScroll.bind(this),
      ry,
      ay
    ), this.updateStoreVerticalScroll = Vd(
      this.updateStoreVerticalScroll.bind(this),
      ry,
      ay
    );
  }
  dependencies(...t) {
    return t.length ? (this._dependencies = t[0], this) : this._dependencies;
  }
  scrollBarComponents(...t) {
    return t.length ? (this._scrollBarComponents = t[0], this) : this._scrollBarComponents;
  }
  attachedComponents(...t) {
    return t.length ? (this._attachedComponents = t[0], this) : this._attachedComponents;
  }
  preventBrowserScroll(t, i) {
    return this.scrollBarComponents()[t] && i.preventDefault(), this;
  }
  updateStoreHorizontalScroll(t) {
    const { store: i } = this._dependencies;
    i.commit(
      `${Yt}.scrollLeft`,
      t
    );
  }
  updateStoreVerticalScroll(t) {
    const { store: i } = this._dependencies;
    i.commit(
      `${Yt}.scrollTop`,
      t
    );
  }
  performAttachedScrollFunction(t, i) {
    return t === "horizontal" ? this.updateStoreHorizontalScroll(i) : this.updateStoreVerticalScroll(i), Object.values(this.attachedComponents()).forEach((n) => {
      n.performScrollAction(t, i);
    }), this;
  }
  triggerScrollBarAction(t, i) {
    return this.scrollBarComponents()[t] && this.scrollBarComponents()[t].scrollDeltaTo(i), this;
  }
  updateVerticalScrollPercent(t) {
    const { store: i } = this._dependencies;
    i.lockModel(), i.commit(
      `${QA}.${Sh}`,
      t
    ), i.unlockModel();
  }
  updateHorizontalScrollPercent(t) {
    const { store: i } = this._dependencies;
    i.lockModel(), i.commit(
      `${QA}.${Mh}`,
      t
    ), i.unlockModel();
  }
  getVerticalScrollPercent() {
    return this._dependencies.store.get(
      `${QA}.${Sh}`
    );
  }
  getHorizontalScrollPercent() {
    return this._dependencies.store.get(
      `${QA}.${Mh}`
    );
  }
  resetVerticalScrollPercent() {
    this.updateVerticalScrollPercent(0);
  }
  resetHorizontalScrollPercent() {
    this.updateHorizontalScrollPercent(0);
  }
}
const kX = (e, t) => {
  const { components: i, layoutConfig: n, measurement: A } = t, { rows: s, columns: o, values: r, cornerMatrices: a } = i, { topLeft: l, topRight: c, bottomLeft: g, bottomRight: h } = a;
  if (s && o) {
    const [u, d] = s, [f, I] = o;
    e.measurement(A).config(n).matrices({
      top: [l, f, c],
      center: [u, r, d],
      bottom: [g, I, h]
    });
  }
}, TX = (e) => {
  e.triggerReflow();
}, vX = (e, t) => {
  let i = tt({}, e.config());
  const n = e.composition().visualGroup, {
    isColumnSizeEqual: A,
    isRowSizeEqual: s,
    priority: o,
    rows: r,
    columns: a,
    values: l,
    cellRenderer: c,
    priorityMaxWidths: g,
    priorityMinWidths: h
  } = n.placeholderInfo(), {
    // minWidth,
    // minHeight,
    classPrefix: u,
    showHeaders: d,
    legend: f,
    scrollBar: I,
    // axesHeaders,
    rows: { headers: C },
    columns: { headers: E }
  } = e.config(), B = e.title()[1], m = e.subtitle()[1], y = z$(e), D = X$(e), Q = rX(e), p = [se, mA, Me, Tn].reduce(
    (S, _) => (S[_] = {
      legends: [],
      config: tt(
        { ...f },
        { position: _, align: Hu(_) }
      )
    }, S),
    {}
  ), w = Q.reduce((S, _) => {
    const M = _.legend.config().position;
    return S[M] && S[M].legends.push(_), S;
  }, p);
  e._composition.legend = {}, Q.forEach((S) => {
    const _ = e._composition.legend[S.scaleType] || [];
    _.push(S.legend), e._composition.legend[S.scaleType] = _;
  });
  const x = {
    headers: D,
    mappedLegends: w,
    canvases: [e],
    rows: r,
    columns: a,
    values: l,
    cornerMatrices: n.cornerMatrices()
  };
  return i = tt(i, {
    classPrefix: u,
    showHeaders: d,
    border: tt(n.metaData().border, e.config().border),
    layoutArrangement: y,
    legend: f,
    buffer: I.thickness,
    title: B,
    subtitle: m,
    axesHeaders: {
      row: C,
      column: E
    },
    // axesHeaders,
    isColumnSizeEqual: A,
    isRowSizeEqual: s,
    mount: t,
    priority: o,
    cellRenderer: c,
    priorityMaxWidths: g,
    priorityMinWidths: h,
    pagination: "scroll"
  }), {
    layoutConfig: i,
    components: x
  };
}, GX = (e) => {
  const t = e.mount(), { minWidth: i, minHeight: n } = e.config();
  let { height: A, width: s } = t.getBoundingClientRect();
  const o = e.height(), r = e.width();
  A = Math.floor(A), s = Math.floor(s);
  const a = Math.max(
    o > 0 ? o : A,
    n
  ), l = Math.max(
    r > 0 ? r : s,
    i
  ), c = tX(
    e._renderDetails.components.headers,
    {
      height: a,
      width: l
    }
  ), g = e.composition().legend, h = Object.keys(e.composition().legend).map((C) => g[C]).flat(), { legendSpace: u, legendWidth: d, legendHeight: f } = sX(
    h,
    {
      headerHeight: c,
      height: a,
      width: l
    },
    e.config()
  );
  return {
    mountSpace: {
      height: A,
      width: s
    },
    headerHeight: c,
    legendSpace: u,
    canvasWidth: l,
    canvasHeight: a,
    width: l - d,
    height: a - c - f,
    minUnitHeight: e.minUnitHeight(),
    minUnitWidth: e.minUnitWidth()
  };
}, M1 = [
  je,
  un,
  IB,
  CB,
  al,
  EB,
  BB,
  LN,
  UN,
  pr,
  Dh
], MI = M1.reduce((e, t, i) => (e[t] = i, e), {}), LX = M1.reduce((e, t, i) => (e[i] = t, e), {}), UX = (e, t) => {
  const i = {
    layoutRootNodeId: t.getLayoutRootNodeId(),
    scrollableBoundBox: t.getScrollableBoundBox(e)
  };
  e.forEach((n) => {
    n && n.attachListener(i);
  });
}, OX = (e, t) => {
  const { horizontalScrollBar: i, verticalScrollBar: n, grid: A } = MI, s = e[i], o = e[n], r = e[A], a = new RX({
    store: t._store
  }), l = {};
  o && (l.vertical = o), s && (l.horizontal = s), a.scrollBarComponents(l).attachedComponents({
    grid: r
  }), t.composition().hScrollBar = s, t.composition().vScrollBar = o, t.composition().scrollBarManager = a, [s, o].forEach((c) => {
    c && c.manager(a);
  }), r.scrollBarManager(a);
}, HX = (e, t) => {
  const i = e.layout(), { grid: n } = MI, A = FX(e, i, t), s = Object.keys(MI).map(
    (r) => A[r]
  );
  return s[n] && OX(s, e), s;
}, PX = (e, t) => {
  t.forEach((i, n) => {
    if (!i) {
      const A = LX[n];
      e.removeComponent(A);
    }
  }), e.registerComponents(t).compute();
}, Xt = 25, vy = 10, Rc = (e) => {
  const t = e._overriddenDimension != null && e._overriddenDimension.width, i = e._implicitSpace.width;
  let n = 0;
  if (t != null ? n = t : i != null && (n = i), e instanceof wB) {
    const A = e.availWidth();
    A && (n = Math.min(n, A));
  }
  return n;
}, kc = (e) => {
  const t = e._overriddenDimension != null && e._overriddenDimension.height, i = e._implicitSpace.height;
  let n = 0;
  return t != null ? n = t : i != null && (n = i), n;
}, Gy = (e) => e.ancestors().slice(0, -1).filter(
  (t) => t.height === 0 ? !0 : t.leaves()[0].data[t.depth - 1].source() !== " "
).length, Co = (e) => e.data.space.width, Eo = (e) => e.data.space.height, YX = (e, t) => {
  let {
    columns: { layout: i },
    rows: { layout: n }
  } = t;
  const {
    border: { width: A },
    axes: {
      x: { compact: s },
      y: { compact: o }
    },
    rows: {
      totals: {
        grandTotals: { enabled: r }
      }
    },
    columns: {
      totals: {
        grandTotals: { enabled: a }
      }
    }
  } = e.config(), {
    legendSpace: {
      left: { width: l },
      right: { width: c },
      top: { height: g },
      bottom: { height: h }
    }
  } = e.measurement();
  if (s) {
    if (!e.columnMatrix().config().isCompacted) {
      e.columnMatrix().config().isCompacted = !0;
      const u = Mi(
        e.columnMatrix().tree(),
        (Q) => Q.values
      ), [d, f] = e.columnMatrix().config().extraCellLengths, I = e.measurement().canvasWidth, C = u.leaves(), E = Math.max(
        I - e.rowMatrix().logicalSpace().width - l - c,
        I / 2
      ) - A * (C.length + 2) - vy - (r ? Xt : 0);
      if (i.length) {
        const Q = xa(
          e.columnMatrix()
        ), p = Uo(
          i,
          (w) => w.target.length
        );
        u.eachBefore((w) => {
          if (w.depth > 0 && w.height > 0)
            if (w.parent.data.preventCompaction)
              w.data.preventCompaction = !0;
            else {
              const x = Q(w), S = (M) => M.filter(
                (k) => So(k.target, x)
              ).reverse().find((k) => k.width != null || k.height != null), _ = p.get(x.length);
              if (_ != null)
                if (w.height === 1) {
                  const k = ei(w).source();
                  typeof k == "object" && k !== null && S(
                    _
                  ) != null && (w.data.preventCompaction = !0);
                } else
                  S(
                    _
                  ) != null && (w.data.preventCompaction = !0);
            }
        });
      }
      const B = C.slice(d, C.length - f).map((Q) => Q.parent), m = ei(B[0]).source().constructor.type() === "band";
      let y = 0;
      m ? y = B.reduce((Q, p) => {
        const w = ei(p).source();
        return typeof w == "object" && w !== null ? Q + w.domain().length : Q;
      }, 0) : y = B.length;
      const { blueprints: D } = B.filter((Q) => !Q.data.preventCompaction).reduce(
        ({ blueprints: Q, remainingWidth: p, remainingDiscreteUnitCount: w }, x) => {
          const S = p / w, _ = ei(x), M = _.source(), k = _.getDataPath().map(({ field: N, value: b, sourceType: F }) => ({
            field: N.getMembers()[0],
            value: b,
            sourceType: F
          }));
          let T = 0, G = 0;
          if (m && typeof M == "object" && M !== null) {
            const N = M.domain().length;
            T = Math.max(
              Xt,
              N * (e.config().cellRenderer === "html" ? Math.max(S, Xt) : S)
            ), G = w - N;
          } else
            T = Math.max(S, Xt), G = w - 1;
          return {
            blueprints: Q.concat({
              target: k,
              width: T,
              isTransient: !0
            }),
            remainingWidth: p - T,
            remainingDiscreteUnitCount: G
          };
        },
        {
          blueprints: [],
          remainingWidth: E,
          remainingDiscreteUnitCount: y
        }
      );
      i = i.concat(D);
    }
  } else
    e.columnMatrix().config().isCompacted = !1;
  if (o) {
    if (e.config().cellRenderer === "svg" && !e.rowMatrix().config().isCompacted) {
      e.rowMatrix().config().isCompacted = !0;
      const u = Mi(
        e.rowMatrix().tree(),
        (Q) => Q.values
      ), [d, f] = e.rowMatrix().config().extraCellLengths, I = e.measurement().canvasHeight, C = u.leaves(), E = Math.max(
        I - e.columnMatrix().logicalSpace().height - g - h,
        I / 2
      ) - A * (C.length + 2) - vy - (a ? Xt : 0), B = C.slice(d, C.length - f).map((Q) => Q.parent), m = ei(B[0]).source().constructor.type() === "band";
      let y = 0;
      m ? y = B.reduce((Q, p) => {
        const w = ei(p).source();
        return typeof w == "object" && w !== null ? Q + w.domain().length : Q;
      }, 0) : y = B.length;
      const { blueprints: D } = B.reduce(
        ({ blueprints: Q, remainingHeight: p, remainingDiscreteUnitCount: w }, x) => {
          const S = p / w, _ = ei(x), M = _.source(), k = _.getDataPath().map(({ field: N, value: b, sourceType: F }) => ({
            field: N.getMembers()[0],
            value: b,
            sourceType: F
          }));
          let T = 0, G = 0;
          if (m && typeof M == "object" && M !== null) {
            const N = M.domain().length;
            T = Math.max(
              Xt,
              N * (e.config().cellRenderer === "html" ? Math.max(S, Xt) : S)
            ), G = w - N;
          } else
            T = Math.max(S, Xt), G = w - 1;
          return {
            blueprints: Q.concat({
              target: k,
              height: T,
              isTransient: !0
            }),
            remainingHeight: p - T,
            remainingDiscreteUnitCount: G
          };
        },
        {
          blueprints: [],
          remainingHeight: E,
          remainingDiscreteUnitCount: y
        }
      );
      n = n.concat(D);
    }
  } else
    e.rowMatrix().config().isCompacted = !1;
  if (i.length) {
    const u = e.columnMatrix(), d = e.centerMatrix(), f = xa(u), I = Uo(
      i,
      (D) => D.target.length
    ), C = Mi(u.tree(), (D) => D.values);
    C.each((D) => {
      const Q = Gy(D);
      if (D.depth > 0 && D.height > 0) {
        const p = f(D), w = (S) => S.filter(
          (_) => So(_.target, p)
        ).reverse().find((_) => _.width != null || _.height != null), x = I.get(p.length);
        if (x != null)
          if (D.height === 1) {
            const S = ei(D), _ = S.source();
            if (typeof _ == "object" && _ !== null) {
              const M = w(
                x
              );
              if (M != null) {
                const k = M.isTransient !== !0, T = M.target[Q - 1] != null && M.target[Q - 1].value;
                if (_.constructor.type() === "band" && typeof T < "u") {
                  if (Tg(
                    _.domain(),
                    T
                  )) {
                    const G = _.domain().length;
                    M.width != null && (D.data.specifiedWidth = M.width * G, D.data.touchedValue = T), M.height != null && (D.data.specifiedHeight = M.height * G, D.data.touchedValue = T), S.config().touched = !0, D.data.isPersistent = k, D.data.touched = !0;
                  }
                } else
                  M.width != null && S.config().type !== "headerTitle" && (D.data.specifiedWidth = M.width), M.height != null && (D.data.specifiedHeight = M.height), S.config().touched = !0, D.data.isPersistent = k, D.data.touched = !0;
              }
            }
          } else {
            const S = w(
              x
            );
            if (S != null) {
              const _ = S.isTransient !== !0;
              S.width != null && (D.data.specifiedWidth = S.width), S.height != null && (D.data.specifiedHeight = S.height), D.leaves().forEach((M) => {
                M.data[M.data.length - 1].config().touched = !0;
              }), D.data.isPersistent = _, D.data.touched = !0;
            }
          }
      }
    }), C.each((D) => {
      D.find((p) => p !== D && p.data.specifiedWidth != null) != null && (D.data.specifiedWidth = null);
    }), C.each((D) => {
      D.depth > 0 && D.height > 0 && (D.parent.data.specifiedWidth != null && (D.data.specifiedWidth = D.parent.data.specifiedWidth / D.parent.children.length), D.data.specifiedHeight == null && (D.data.specifiedHeight = Ye(
        D.data.matrix[D.depth - 1].map(kc)
      )));
    }), C.eachAfter((D) => {
      if (D.height > 0) {
        if (D.height === 1) {
          if (D.data.specifiedWidth == null) {
            const Q = ei(D), p = Q.source();
            typeof p == "object" && p !== null && (D.data.space.width = Rc(Q));
          } else
            D.data.space.width = D.data.specifiedWidth > Xt ? D.data.specifiedWidth : Xt;
          D.data.space.height = Te(
            D.ancestors().slice(0, -1),
            (Q) => Q.data.specifiedHeight > Xt ? Q.data.specifiedHeight : Xt
          );
        } else if (D.data.space)
          if (D.depth === 0)
            D.data.space.width = Te(D.children, Co), D.data.space.height = Ye(D.children.map(Eo));
          else {
            const Q = D.data.matrix[D.depth - 1][0], p = Te(D.children, Co);
            D.data.specifiedWidth == null ? D.data.space.width = s ? p : Ye([Rc(Q), p]) : D.data.space.width = Ye([
              D.data.specifiedWidth > Xt ? D.data.specifiedWidth : Xt,
              p
            ]), D.data.space.height = Ye([
              kc(Q),
              ...D.children.map(Eo)
            ]);
          }
      }
    });
    const [E, B] = u.config().extraCellLengths, m = Te(
      C.children.slice(
        E,
        C.children.length - B
      ),
      Co
    );
    u.overrideDimension({
      width: m,
      height: C.data.space.height
    }), d.overrideDimension({ width: m });
    const y = C.leaves();
    y.slice(E, y.length - B).forEach((D) => {
      const Q = D.ancestors().slice(1, -1).reverse(), p = Q.map(Co), w = Q.map((S) => S.data.specifiedHeight);
      D.data.forEach((S, _) => {
        S.type !== "blank" && (S.logicalSpace() == null && S.logicalSpace({}), S.overrideDimension() != null && S.overrideDimension({
          width: p[_] + A,
          height: w[_]
        }), S.logicalSpace({
          width: p[_] + A,
          height: w[_]
        }), S.type === "axis" && (S.source().logicalSpace() == null && S.source().logicalSpace({}), S.source().overrideDimension && S.source().overrideDimension() != null && S.source().overrideDimension({
          width: p[_] + A,
          height: w[_]
        }), S.source().logicalSpace({
          width: p[_] + A,
          height: w[_]
        })));
      }), Q.forEach((S) => {
        S.data.specifiedWidth = null, S.data.specifiedHeight = null;
      });
    });
  }
  if (n.length) {
    const u = e.rowMatrix(), d = e.rowMatrix().config().isCompacted, f = u.config().cellRenderer === "html" || d ? Xt : u.config().unitMeasures.height, I = e.centerMatrix(), C = xa(u), E = Mi(u.tree(), (x) => x.values), B = u.config().priority === 2, m = Uo(
      n,
      (x) => x.target.length
    ), y = /* @__PURE__ */ new Map();
    E.each((x) => {
      const S = Gy(x);
      if (x.depth > 0 && x.height > 0) {
        const _ = C(x), M = (G) => G.filter(
          (N) => So(N.target, _)
        ).reverse().find((N) => N.width != null || N.height != null), k = (G) => G.filter(
          (N) => So(N.target, _, { strict: !0 })
        ).reverse().find((N) => N.width != null || N.height != null), T = m.get(_.length);
        if (T != null)
          if (x.height <= (B ? 2 : 1)) {
            const G = ei(x, x.height > 1), N = G.source(), b = M(
              T
            ), F = k(
              T
            ) != null;
            if (b != null) {
              const R = b.isTransient !== !0;
              if (typeof N == "object" && N !== null && N.constructor.type() === "band" && b.target[S - 1] != null && typeof b.target[S - 1].value < "u") {
                const v = b.target[S - 1].value;
                if (Tg(
                  N.domain(),
                  v
                )) {
                  const O = N.domain().length;
                  b.width != null && (x.data.specifiedWidth = b.width * O, F && (x.data.touchedValue = v, y.set(_.length - 1, !0))), b.height != null && (x.data.specifiedHeight = b.height * O, F && (x.data.touchedValue = v, y.set(_.length - 1, !0))), F && (G.config().touched = !0, x.data.isPersistent = R, x.data.touched = !0, y.set(_.length - 1, !0));
                }
              } else
                typeof N == "object" && N != null && (N.config().belongsToTouchedColumn = !0), b.width != null && (x.data.specifiedWidth = b.width), b.height != null && N != null && G.config().type !== "headerTitle" && (x.data.specifiedHeight = b.height, F && (G.config().touchedHeight = !0)), F && (G.config().touched = !0, x.data.isPersistent = R, x.data.touched = !0, y.set(_.length - 1, !0));
            }
          } else {
            const G = M(
              T
            ), N = k(
              T
            ) != null;
            if (G != null) {
              const b = G.isTransient !== !0;
              G.width != null && (x.data.specifiedWidth = G.width), G.height != null && (x.data.specifiedHeight = G.height, N && x.leaves().forEach((F) => {
                F.data[S - 1].config().touchedHeight = !0;
              })), N && (x.leaves().forEach((F) => {
                F.data[S - 1].config().touched = !0;
              }), x.data.isPersistent = b, x.data.touched = !0, y.set(_.length - 1, !0));
            }
          }
      }
    }), E.each((x) => {
      x.find((_) => _ !== x && _.data.specifiedHeight != null) != null && (x.data.specifiedHeight = null);
    }), E.each((x) => {
      x.depth > 0 && x.height > 0 && (x.parent.data.specifiedHeight != null && (x.data.specifiedHeight = x.parent.data.specifiedHeight / x.parent.children.length), x.data.specifiedWidth == null && (x.data.specifiedWidth = Ye(
        x.data.matrix.flatMap((S) => S[x.depth - 1]).map(Rc)
      )));
    }), E.eachAfter((x) => {
      if (x.height > 0) {
        if (x.height === 1) {
          if (x.data.specifiedHeight == null) {
            const S = ei(x, x.height > 1), _ = S.source();
            if (typeof _ == "object" && _ !== null) {
              const M = kc(S);
              x.data.space.height = M > f ? M : f;
            }
          } else
            x.data.space.height = x.data.specifiedHeight > Xt ? x.data.specifiedHeight : Xt;
          x.data.space.width = Te(
            x.ancestors().slice(0, -1),
            (S) => S.data.specifiedWidth > Xt ? S.data.specifiedWidth : Xt
          );
        } else if (x.data.space)
          if (x.depth === 0)
            x.data.space.height = Te(x.children, Eo), x.data.space.width = Ye(x.children.map(Co));
          else {
            const S = x.data.matrix[0][x.depth - 1], _ = Te(x.children, Eo);
            x.data.specifiedHeight == null ? x.data.space.height = o ? _ : Ye([kc(S), _]) : x.data.space.height = Ye([
              x.data.specifiedHeight > Xt ? x.data.specifiedHeight : Xt,
              _
            ]), x.data.space.width = Ye([
              Rc(S),
              ...x.children.map(Co)
            ]);
          }
      }
    });
    const [D, Q] = u.config().extraCellLengths, p = Te(
      E.children.slice(
        D,
        E.children.length - Q
      ),
      Eo
    );
    u.overrideDimension({
      width: E.data.space.width,
      height: p
    }), I.overrideDimension({ height: p }), E.leaves().forEach((x) => {
      const S = x.ancestors().slice(1, -1).reverse(), _ = S.map(Eo), M = S.map((T) => T.data.specifiedWidth);
      x.data.forEach((T, G) => {
        (T.type !== "blank" || T.type === "blank" && T.config().type === "headerTitle") && (T.logicalSpace() == null && T.logicalSpace({}), T.overrideDimension() != null && T.overrideDimension({
          height: _[G],
          width: M[G]
        }), T.logicalSpace({
          height: _[G],
          width: M[G]
        }), T.type === "axis" && (T.source().logicalSpace() == null && T.source().logicalSpace({}), T.source().overrideDimension && T.source().overrideDimension() != null && T.source().overrideDimension({
          height: _[G],
          width: M[G]
        }), T.source().logicalSpace({
          height: _[G],
          width: M[G]
        })));
      }), S.forEach((T) => {
        T.data.specifiedWidth = null, T.data.specifiedHeight = null;
      });
    });
    const w = e.rowMatrix().maxMeasures();
    e.rowMatrix().maxMeasures(
      ae(E.leaves().map((x) => x.data)).map(
        (x, S) => Ye(
          x.map(
            (_) => _.logicalSpace() != null && y.get(S) ? _.logicalSpace().width : w[S]
          )
        )
      )
    );
  }
}, Ly = (e, t) => t.canvasId ? e.canvasId === t.canvasId : !0, sa = (e, t, i) => {
  const n = i.fields || [], A = t.fields;
  return e.canvasId === t.canvasId ? !0 : n.length ? su(n, A).length : !0;
}, JX = {
  behaviours: {
    "*": Ly,
    // brush: (source, target, payload) => {
    //   if (isSameCanvas(source, target, payload) && source.type === "canvas") {
    //     if (source.layerId) {
    //       return source.layerId === target.layerId;
    //     }
    //     if (source.unitId) {
    //       return source.unitId === target.unitId;
    //     }
    //     return true;
    //   }
    //   return true;
    // },
    // highlight: (source, target, payload) => {
    //   if (isSameCanvas(source, target, payload) && source.type === "canvas") {
    //     if (source.layerId) {
    //       return source.layerId === target.layerId;
    //     }
    //     if (source.unitId) {
    //       return source.unitId === target.unitId;
    //     }
    //     return true;
    //   }
    //   return true;
    // },
    filter: (e, t) => e.type === "canvas" ? e.canvasId !== t.canvasId : !0
  },
  sideEffects: {
    "*": Ly,
    selectionBox: (e, t) => e.unitId === t.unitId,
    tooltip: sa,
    highlighter: sa,
    [HE]: sa,
    anchors: sa,
    crossline: sa
  }
};
class KX extends to {
  constructor(...t) {
    super(...t), this._entryExitSet = /* @__PURE__ */ new Map(), this._payloads = {}, this.interactionPolicy(this.constructor.defaultInteractionPolicy());
    const i = this.context._throwback;
    this._crossInteractionConfig = {}, this._propagationDms = {}, this._interactionStates = /* @__PURE__ */ new Map();
    let n, A = !1, s = !1;
    this.context.on("afterLayout", () => {
      const o = () => {
        A || (A = !0, this._actionBehaviourMap.hover.behaviours.includes("highlight") && (s = !0, this.dispatchBehaviour("highlight", {
          criteria: null
        }), this.dissociateBehaviour(["highlight", "hover"])), clearTimeout(n), n = setTimeout(() => {
          s && this.registerPhysicalBehaviouralMap({
            hover: {
              behaviours: ["highlight"]
            }
          }), A = !1;
        }, 250));
      }, { vScrollBar: r, hScrollBar: a } = this.context.composition();
      r && r.component.onScroll(o), a && a.component.onScroll(o);
    }), this.context.on("afterRendered", () => {
      this.applyExistingInteractions();
    }), i.registerImmediateListener([$o.MATRIX_CREATED], () => {
      const o = this.context.composition().visualGroup;
      if (o) {
        HZ(this), this._propagationCount = /* @__PURE__ */ new Map();
        const r = [];
        o.matrix().geom().forEach((l) => {
          const c = l.source();
          r.push(c.firebolt());
        }), this.childFirebolts(r), my(this), r.forEach((l) => {
          l.onPropagationDone(
            (c, g, h) => {
              let u = r.length;
              const d = c.sourceId, f = d ? `${d}-${c.action}` : c.action;
              let I = this._propagationCount.get(f) || 0;
              const C = ++I;
              this._propagationCount.set(f, C), C === u && (this._targetUnit = Yd(c, this), this.onUnitPropagationComplete({
                payload: c,
                propagationData: g,
                propagationInf: h
              }), this._propagationCount.set(f, 0));
            }
          );
        });
      }
    });
  }
  applyExistingInteractions() {
    this._interactionStates.forEach(({ action: i, payload: n, propagationInf: A }) => {
      const s = n.sideEffects.filter((o) => this.sideEffects()[o.name] && this.sideEffects()[o.name].shouldApplyOnRenderAfterScrolling());
      this.dispatchSideEffects(
        i,
        { ...n, sideEffects: s },
        A
      );
    }), this.childFirebolts().forEach((i) => {
      i.applyExistingInteractions();
    });
  }
  childFirebolts(t) {
    return t ? (this._childFirebolts.length = 0, this._childFirebolts = t, this) : this._childFirebolts;
  }
  createEntryExitSet(t) {
    const i = this.childFirebolts(), n = t.action, A = i.map((s) => s.getEntryExitSet(n)).filter((s) => s);
    return this._entryExitSet[n] && this._entryExitSet[n].dispose(!1), A.length ? this._entryExitSet[n] = new JM(A, {
      extraData: {},
      name: `visual-group-${t.action}`
    }) : this._entryExitSet[n] = null, this._entryExitSet[n];
  }
  getSideEffectsForSourceAction({ action: t }) {
    const i = this.config()[t] || {};
    return Object.keys(i.sideEffects || {}).map((A) => ({
      name: A,
      ...i.sideEffects[A]
    })).filter((A) => A.enabled !== !1);
  }
  onUnitPropagationComplete({ payload: t, propagationInf: i }) {
    const n = Yd(t, this);
    if (n) {
      this._targetUnit = n;
      const A = n.getLayerById(t.sourceInfo.layerId);
      this._targetLayer = A || n.layers()[0];
      let s = [];
      t.resetAllInteractions ? (s = W(
        this._lastInteraction.get(t.action),
        "sideEffects"
      ) || [], this._lastInteraction.delete(t.action)) : (s = GE(
        {
          action: t.action.split(":")[1],
          targetActions: t.targetActions,
          sourceCanvas: t.sourceInfo.canvasId
        },
        this
      ), this._lastInteraction.set(t.action, {
        behaviour: t.action,
        sideEffects: s
      })), this.createEntryExitSet(t), this.dispatchSideEffects(
        t.action,
        { ...t, sideEffects: s },
        i,
        t.forceDispatch
      ), this.saveInteractionState({
        action: t.action,
        payload: { ...t, sideEffects: s },
        propagationInf: i,
        forceDispatch: t.forceDispatch
      });
    }
  }
  static defaultInteractionPolicy() {
    return JX;
  }
  interactionPolicy(...t) {
    return t.length ? (this._interactionPolicy = tt(
      tt({}, this.constructor.defaultInteractionPolicy()),
      t[0] || {}
    ), my(this), this) : this._interactionPolicy;
  }
  registerSideEffects(t) {
    for (const i in t)
      this._sideEffectDefinitions[t[i].formalName()] = t[i];
    return this.initializeSideEffects(), this;
  }
  target() {
    return "visual-group";
  }
  id() {
    return this.context.alias();
  }
  data(t, i = {}, n = {}) {
    const A = this.context.composition().visualGroup;
    if (t) {
      const { unitDataModels: s, layerDataModels: o } = i, r = this.context.store();
      r.lockModel();
      const a = t;
      return A.groupedData(a), A.matrix().geom().forEach((c, g, h) => {
        c.source().firebolt().data(
          s[g][h],
          o[g][h]
        );
      }), r.unlockModel(), A._triggerDomainChangeListener = !1, A._lockAxisDomain = n.lockDomain, fh(A, {
        recalculateDomains: !0,
        unionAxisDomainPerPage: !0
      }), this.context.render({
        gridRenderConfig: {
          forceRender: !0,
          scrollLeft: r.get(
            `${Yt}.scrollLeft`
          ),
          scrollTop: r.get(
            `${Yt}.scrollTop`
          )
        }
      }), this;
    }
    return A.getGroupByData();
  }
  resetData() {
    const t = this.context.composition().visualGroup, i = this.context.store();
    return i.lockModel(), t.resetData(), t.matrix().geom().forEach((A) => {
      A.source().firebolt().resetData();
    }), i.unlockModel(), t._triggerDomainChangeListener = !1, t._lockAxisDomain = !1, fh(this.context.composition().visualGroup, {
      recalculateDomains: !0
    }), this.context.render({
      gridRenderConfig: {
        forceRender: !0,
        scrollLeft: i.get(
          `${Yt}.scrollLeft`
        ),
        scrollTop: i.get(
          `${Yt}.scrollTop`
        )
      }
    }), this;
  }
  getPropagationDetails(t, i, n) {
    const A = this._globalContext, s = W(this.crossInteractionConfig()[t], "target") || {}, { propIdentifiers: o, interpolated: r } = UZ({
      action: t,
      firebolts: this._childFirebolts
    }), a = this.getPropagationSource(), l = a ? a.getPropagationQuery(o, {
      fields: i.fields,
      interpolated: r,
      isQuery: !0
    }) : null, c = Object.keys(s).some(
      (I) => s[I].filter
    ), g = A.interactionFilters.get(
      this.sourceCanvas()
    ), h = {
      ...g,
      layer: {
        identifiers: l,
        fields: i.fields || []
      }
    };
    let u = !1;
    c && (!g && A.interactionFilters.get().size && (u = !0), !i.criteria && u && A.interactionFilters.clear(), A.interactionFilters.save(this.sourceCanvas(), h));
    const d = Object.values(h).map(({ identifiers: I, fields: C }) => ({
      criteria: I,
      fields: C
    })), f = {
      sourceAction: t,
      propagationSourceId: this.id(),
      interpolated: r,
      targetActions: {
        ...n.targetActions,
        interCanvas: s
      },
      resetAllInteractions: n.resetAllInteractions,
      resetFilterAction: u
    };
    return {
      queries: d,
      payload: { ...i, ...f },
      sourcePropQuery: l
    };
  }
  propagate(t, i, n) {
    const {
      queries: A,
      payload: s,
      sourcePropQuery: o
    } = this.getPropagationDetails(t, i, n), r = this.getPropagationSource();
    r && r.propagate(A, {
      ...s,
      sourcePropQuery: o,
      propagateDm: n.propagateDm,
      applyOnVisibleUnits: n.applyOnVisibleUnits,
      targetFacets: this._targetUnit ? this._targetUnit.facetFieldsMap() : {}
    });
  }
  onPhysicalActionTrigger(t) {
    const i = (A) => {
      if (A !== "highlight") {
        const s = this.getEntryExitSet(A);
        W(s, "entrySet", "length") || this.propagate(
          A,
          {
            criteria: null
          },
          {
            sourceId: this.id(),
            resetAllInteractions: !0
          }
        );
      }
    }, { behaviours: n } = t;
    n.forEach((A) => {
      i(A);
      const { payload: s } = t;
      s.sourceInfo = {
        layerId: s.layerId,
        canvasId: this.sourceCanvas(),
        unitId: t.sourceUnit,
        type: "layer",
        unitRowIndex: t.unitMetaInf.rowIndex,
        unitColIndex: t.unitMetaInf.colIndex
      }, this._payloads[A] = { ...s, action: A }, this.dispatchBehaviour(A, {
        ...s,
        action: A,
        isExplicitAction: !0
      });
    });
  }
  getPropagationBehaviour(t) {
    return this._propagationBehaviourMap[t] || t;
  }
  getPropagationSource() {
    return this.context.composition().visualGroup.resolver()._groupedData;
  }
  sourceCanvas() {
    return this.context.alias();
  }
  getEntryExitSet(t) {
    return this._entryExitSet[t];
  }
  getPlotPointsFromIdentifiers(...t) {
    return this._targetUnit.getPlotPointsFromIdentifiers(
      ...t,
      this._targetLayer.id()
    );
  }
  getDrawingContext() {
    return this._targetUnit.getDrawingContext();
  }
  getSourceInfo() {
    return Object.assign({}, this._targetUnit.getSourceInfo(), {
      targetLayer: this._targetLayer
    });
  }
  layers() {
    return this._targetUnit.layers();
  }
  getPayload(t) {
    return this._payloads[t];
  }
  dispatchBehaviour(t, i) {
    const n = Yd(i, this);
    if (!n)
      return;
    if (i.sourceInfo || (i.sourceInfo = {
      unitId: n.id(),
      canvasId: this.sourceCanvas()
    }), i.action = t, !i.fields)
      if (i.criteria) {
        i.fields = W(i.criteria, "dimensions", 0) || [];
        const u = Object.keys(
          W(i.criteria, "range") || {}
        );
        i.fields.push(...u);
      } else
        i.fields = [];
    const A = i.sourceInfo.unitId, s = this._childFirebolts, o = this.config()[i.action] || {};
    [
      n.firebolt(),
      ...s.filter(
        (u) => u !== n.firebolt()
      )
    ].forEach((u) => {
      (o.applyOnVisibleUnits ? u.isVisible() : !0) && (u.dispatchBehaviour(t, {
        ...i,
        isExplicitAction: i.isExplicitAction
      }), this.metaData(u.metaData()));
    });
    const a = s.find(
      (u) => u.id() === A
    ), l = a._childFirebolts.find(
      (u) => u.id() === i.sourceInfo.layerId
    );
    let c;
    l ? c = l.getTargetActions(t) : c = a._childFirebolts[0].getTargetActions(t), i.metaData = tt(this.metaData(), i.metaData), this.createEntryExitSet(i);
    const g = this.getSideEffectsForSourceAction({
      action: i.action
    }), h = n.getLayerById(i.sourceInfo.layerId);
    this._targetUnit = n, this._targetLayer = h || n.layers()[0], this.dispatchSideEffects(
      t,
      { ...i, sideEffects: g },
      {},
      i.forceDispatch
    ), this.saveInteractionState({
      action: t,
      payload: Object.assign({}, i, { sideEffects: g }),
      propagationInf: {},
      forceDispatch: !1
    }), this._lastInteraction.set(t, {
      behaviour: t,
      sideEffects: g
    }), this.propagate(
      t,
      { ...i },
      {
        targetActions: c,
        sourceId: A,
        propagateDm: o.propagateDm,
        applyOnVisibleUnits: o.applyOnVisibleUnits
      }
    ), i.criteria === null && (this._entryExitSet[i.action] = null);
  }
  getInteractions() {
    return {
      physicalActions: this._actions.physicalActionDefs,
      behaviours: this._actions.behaviourDefs,
      sideEffects: this._sideEffectDefinitions,
      behaviourEffectMap: this._behaviourEffectMap,
      physicalBehaviouralMap: this._actionBehaviourMap
    };
  }
  getUnitDataModels(t) {
    const n = this.context.composition().visualGroup.matrix().geom(), A = [];
    return n.forEach((s, o, r) => {
      A[o] || (A[o] = []), A[o][r] = s.source().firebolt().getEntryExitSet(t)?.entrySet?.model;
    }), A;
  }
  getLayerDataModels(t) {
    const n = this.context.composition().visualGroup.matrix().geom(), A = [];
    return n.forEach((s, o, r) => {
      A[o] || (A[o] = []), A[o][r] || (A[o][r] = {}), s.source().layers().forEach((l) => {
        const c = l.firebolt().getEntryExitSet(t).entrySet.model;
        A[o][r][l.id()] = c;
      });
    }), A;
  }
  crossInteractionConfig(...t) {
    return t.length ? (this._crossInteractionConfig = t[0] || {}, this) : this._crossInteractionConfig;
  }
}
const WX = {
  app: {
    group: {},
    units: {},
    layers: {},
    canvas: {}
  },
  local: {
    canvas: {},
    group: {},
    units: {},
    layers: {}
  },
  interactions: {
    select: {
      entrySet: null,
      exitSet: null
    }
  },
  virtualScrolling: {
    scrollLeft: 0,
    scrollTop: 0,
    vScrollPercent: 0,
    hScrollPercent: 0,
    viewport: {
      rowStart: 0,
      rowEnd: 0,
      colStart: 0,
      colEnd: 0
    }
  }
}, VX = {
  columns: {
    expandCollapseState: null,
    layout: []
  },
  rows: {
    expandCollapseState: null,
    layout: []
  }
}, jX = (e) => !Ee(e) && typeof e == "object" && e.constructor.type() === "band", qX = (e, t) => {
  t.leaves().map((n) => n.ancestors()).forEach((n) => {
    const A = [];
    n.every((s) => {
      if (A.push(s), s.height > 0 && s.depth > 0 && s.height <= (e ? 2 : 1)) {
        const r = ei(s, s.height > 1).source();
        return jX(r) ? r.domain().length <= 1 : s.parent.children.length <= 1;
      } else
        return (s.parent?.children.length ?? 0) <= 1;
    }), A.filter((s) => s.height > 0 && s.depth > 0).forEach((s, o) => {
      s.leaves()[0].data.toReversed && s.leaves()[0].data.toReversed()[o].hideCollapseIcon?.();
    });
  });
}, zX = (() => () => Ut())();
class Hl extends _e(q$).with(
  ES("canvas")
) {
  /**
   * Creates reactive property accessors.
   * - data
   * - height
   * - width
   * - config
   * This configs are retrieved from options
   */
  constructor(t, i) {
    super(), this.eventManager(i), this._allOptions = Object.assign({}, _I, Ey), this._registry = {}, this._composition = {}, this._cachedProps = {}, this._prevProps = {}, this._alias = null, this._globalContext = null, this._composition.layout = new FB(), this._store = new qa(WX), this._throwback = new qa({
      [$o.MATRIX_CREATED]: !1
    }), this._disposed = null;
    const n = dC, A = Object.assign({}, _I, Ey, SI);
    Wx(this, A, this._store, {
      namespace: n
    }), this.dependencies(
      Object.assign({}, t, this._dependencies)
    ), this.props = VX, this.alias(`canvas-${zX()}`), this.title("", {}), this.subtitle("", {}), this.legend({}), this.color({}), this.backgroundColor({}), this.shape({}), this.size({}), i$(this), this._layoutManager = h$(), this._deregisterDMPreDisposeTask = void 0, this._scrollState = null;
  }
  associatedHookComponentPaths() {
    return [[xt.CANVAS]];
  }
  store() {
    return this._store;
  }
  /**
   * Retrieves an instance of layout which is responsible for layouting. Layout is responsible for creating faceted
   * presentation using table layout.
   *
   * @public
   *
   * @return {GridLayout} Instance of layout attached to canvas.
   */
  layout(...t) {
    return t.length ? this : this.composition().layout;
  }
  /**
   * Retrieves the composition for a canvas
   *
   * @public
   *
   * @return {object} Instances of the components which canvas requires to draw the full visualization.
   *      ```
   *          {
   *              layout: // Instance of {@link GridLayout}
   *              legend: // Instance of {@link Legend}
   *              subtitle: // Instance of {@link TextCell} using which the title is rendered
   *              title: // Instance of {@link TextCell} using which the title is rendered
   *              visualGroup: // Instance of {@link visualGroup}
   *          }
   *      ```
   */
  composition(...t) {
    return t.length ? this : this._composition;
  }
  /**
   * Sets or gets the alias of the canvas. Alias is a name by which the canvas can be referred.
   *
   * When setter
   * @param {string} alias Name of the alias.
   *
   * @return {Canvas} Instance of the canvas.
   *
   * When getter
   *
   * @return {string} Alias of canvas.
   *
   * @public
   */
  alias(...t) {
    if (t.length) {
      const i = this.composition().visualGroup;
      return this._alias = t[0], i && i.alias(this.alias()), this;
    }
    return this._alias;
  }
  /**
   * Creates an instance initiated with given settings.
   *
   * @param {Object} initialSettings Initial settings to be populated in the model
   * @param {Object} regEntry newly created instance with the initial settings
   * @param {Object} globalDependencies dependencies which will be created only once in the page
   *
   * @return {Object} newly created instance with the initial settings
   */
  static withSettings(t, i, n, A, s) {
    const o = new Hl(n, s);
    for (const a in t)
      o[a](t[a]);
    o.registry(i);
    const r = i.interactions.visualGroup;
    return o.firebolt(
      new KX(
        o,
        {
          behavioural: Object.assign({}, r.behaviours.get(), {
            [Rs]: VE
          }),
          physical: Object.assign(
            {},
            r.physicalActions.get()
          ),
          physicalBehaviouralMap: Object.assign(
            {},
            r.physicalBehaviouralMap.get()
          )
        },
        Object.assign({}, r.sideEffects.get()),
        Object.assign({}, r.behaviourEffectMap.get())
      )
    ), o._globalContext = A, o.firebolt()._globalContext = A, o$(o), o;
  }
  /**
   *
   *
   * @static
   *
   * @memberof Canvas
   */
  static formalName() {
    return "canvas";
  }
  /**
   * Returns the instance of firebolt associated with this canvas. The firebolt instance can be used to dispatch a
   * behaviour dynamically on the canvas. This firebolt does not handle any physical actions. It is just used to
   * propagate the action to all the visual units in it's composition.
   *
   * @public
   *
   * @return {GroupFireBolt} Instance of firebolt associated with canvas.
   */
  firebolt(...t) {
    return t.length ? (this._firebolt = t[0], this) : this._firebolt;
  }
  /**
   * Registry peoperty accessor
   *
   * @param {Object} reg plain old javascript object keyvalue pairs. Key containing module name and value contains
   * module definition class. The reg object has to be flat object of level 1.
   */
  registry(...t) {
    if (t.length) {
      const i = t[0], n = Object.assign({}, i.components), A = Object.assign(
        {},
        i.componentSubRegistry
      ), s = Object.assign({}, i.interactions);
      this._registry = {
        components: n,
        componentSubRegistry: A,
        interactions: s
      }, g$(this);
      const o = VZ(this);
      return this._composition.visualGroup = o[0], this.composition().visualGroup.alias(this.alias()), this;
    }
    return this._registry;
  }
  /*
   * Prepare dependencies for top level elements
   */
  dependencies(...t) {
    return t.length ? (this._dependencies = t[0], this) : this._dependencies;
  }
  legend(...t) {
    return t.length ? this : this.composition().legend;
  }
  /**
   * Internal function to trigger reflow, this method is cognizant of all the properties of the core modules and
   * establish a passive reactivity. Passive reactivity is not always a bad thing :)
   * @internal
   */
  reflow() {
    this.composition() != null && (this.prepareRenderDetails(), this.registerLegendHookAggEvents(), this.computeLayout({
      hScrollPercent: 0
    }), this.composition() != null && ([this.layout().rowMatrix(), this.layout().columnMatrix()].forEach(
      (t) => qX(t.config().priority, t._hierarchy)
    ), this.registerAnimationEndEvent(), f$(this)));
  }
  updateSize() {
    if (this.composition() == null)
      return;
    const t = this.composition().visualGroup;
    fh(t, {
      recalculateDomains: !0,
      unionAxisDomainPerPage: t._unionAxisDomainPerPage
    }), this.computeLayout({
      hScrollPercent: 0,
      extendDomain: !this.composition().visualGroup._lockAxisDomain
    });
  }
  computeLayout(t = {}) {
    if (this.emitSelfHooks(gt.BEFORE_LAYOUT), $K(this.config().theme), this.composition() == null)
      return;
    const i = this._renderDetails, n = this.layout(), A = {
      rows: this.props.rows,
      columns: this.props.columns
    };
    if (!t.skipPeripheralComponentsLayout) {
      const o = GX(this);
      i.measurement = o;
    }
    i.components.rows && i.components.columns && (t.recomputeGridSpace !== !1 && (kX(this.layout(), i), n.compute()), YX(n, A), TX(n)), this._layoutManager.dimension({
      height: i.measurement.canvasHeight,
      width: i.measurement.canvasWidth
    }), this._layoutManager.renderAt(this.mount());
    const s = HX(this, {
      ...i
    });
    this._composition.componentWrappers = s, s.forEach((o) => {
      o && o.shouldRender(!0);
    }), PX(this._layoutManager, s), this.emitSelfHooks(gt.AFTER_LAYOUT), this.composition() != null && this.postLayout(t);
  }
  prepareRenderDetails() {
    const t = this.mount(), i = vX(this, t);
    this._renderDetails = i;
  }
  postLayout(t = {}) {
    const { vScrollBar: i, hScrollBar: n } = this.composition(), A = d1(this._store), s = f1(this._store), o = i ? i.component.getScrollPixelsFromScrollPercent(A) : 0, r = n ? n.component.getScrollPixelsFromScrollPercent(s) : 0;
    this._scrollState ? (this._scrollState = {
      ...this._scrollState,
      scrollTop: o,
      scrollLeft: r,
      viewPortInfo: RZ(this._store)
    }, n || c1(this._store, {
      scrollLeft: r
    }), i || g1(this._store, {
      scrollTop: o
    })) : gy(this._store, {
      scrollTop: o,
      scrollLeft: r
    });
    const a = this.composition().visualGroup;
    a.matrix().geom().forEach((l) => {
      l.source().layers().forEach((g) => {
        g.postLayout();
      });
    }), t.extendDomain !== !1 && (a.matrix().clearExtendedAxisDomainCache(), a.matrix().extendAxisDomainsIfNeeded()), c$(this);
  }
  render({ gridRenderConfig: t = {} }) {
    if (!this.isRenderableInMountPoint() || (this.emitSelfHooks(gt.BEFORE_RENDERED), this.composition() == null))
      return;
    if (this.composition().componentWrappers !== this._prevComponentWrappers) {
      if (this._layoutManager.render(), XK(
        this.config().theme,
        document.getElementById(this.getLayoutRootNodeId())
      ), this.composition() == null)
        return;
      UX(this.composition().componentWrappers, this);
    }
    if (this.renderGridComponent(t), this.composition() == null)
      return;
    this._prevComponentWrappers = this.composition().componentWrappers, $Z(this), this._scrollState && this.handleVirtualScrollAfterCollapse(), this._scrollState = null;
    const i = this._store, { rowStart: n, rowEnd: A, colStart: s, colEnd: o } = i.get(
      `${Yt}.viewport`
    );
    if (this.emitSelfHooks(gt.AFTER_RENDERED, {
      virtualScrolling: {
        viewportRange: {
          rowRange: [n, A],
          colRange: [s, o]
        }
      }
    }), this.composition() == null)
      return;
    this.composition().visualGroup.matrix().column().mapActionsAndBehaviour(), this.composition().visualGroup.matrix().row().mapActionsAndBehaviour();
  }
  handleVirtualScrollAfterCollapse() {
    const t = this.composition() ?? {}, { vScrollBar: i, hScrollBar: n } = t;
    let A = i?.getScrollPercent(), s = n?.getScrollPercent();
    if (this._scrollState.rowIndex >= 0 && i) {
      const o = i.getUnitScrollPosition(
        this._scrollState.rowIndex
      ), r = (o - this._scrollState.vScrollUnit) / this._scrollState.vScrollUnit;
      A = this._scrollState.currentPageChanged || this._scrollState.vScroll > this._scrollState.vScrollUnit || isNaN(r) ? o : A + A * r;
    }
    if (this._scrollState.columnIndex >= 0 && n) {
      const o = n.getUnitScrollPosition(
        this._scrollState.columnIndex
      ), r = (o - this._scrollState.hScrollUnit) / this._scrollState.hScrollUnit;
      s = this._scrollState.hScroll > this._scrollState.hScrollUnit || isNaN(r) ? o : s + s * r;
    }
    this._scrollState?.vScroll >= 0 || this._scrollState?.hScroll >= 0 ? (i?.scrollTo(A, !1), n?.scrollTo(s, !1)) : gy(this._store, {
      scrollTop: this._scrollState.scrollTop,
      scrollLeft: this._scrollState.scrollLeft,
      viewPortInfo: this._scrollState.viewPortInfo
    });
  }
  renderGridComponent(t) {
    A$(this, t);
  }
  registerAnimationEndEvent() {
    if (this.composition().componentWrappers[10]) {
      this.eventManager().once(
        new Ie({
          componentPath: [xt.CANVAS],
          modifier: fe.EACH,
          hookName: gt.AFTER_RENDERED
        }),
        () => {
          this.emitSelfHooks(gt.ANIMATION_END);
        }
      );
      return;
    }
    let t = {}, i = !1;
    const n = !!Object.values(this.legend()).flat().length, A = [
      { label: "xAxes", componentPath: [xt.AXIS, "x"] },
      { label: "yAxes", componentPath: [xt.AXIS, "y"] },
      { label: "units", componentPath: [xt.UNIT] }
    ];
    n && A.push({
      label: "legends",
      componentPath: [xt.LEGEND]
    }), A.forEach(({ label: s, componentPath: o }) => {
      const r = new Ie({
        componentPath: o,
        modifier: fe.ALL,
        hookName: gt.ANIMATION_END
      }), a = this.eventManager().listeners(r).find(
        (l) => W(l, "meta", "tag") === lc
      );
      a && this.eventManager().off(r, a.listener), this.eventManager().on(
        r,
        () => {
          t[s] = !0;
          let l = !1;
          if (i ? l = t.xAxes && t.units || t.yAxes && t.units : (l = t.xAxes && t.yAxes && t.units, n && (l = l && t.legends)), l) {
            const { rowStart: c, rowEnd: g, colStart: h, colEnd: u } = this.store().get(
              `${Yt}.viewport`
            );
            this.emitSelfHooks(gt.ANIMATION_END, {
              virtualScrolling: {
                viewportRange: {
                  rowRange: [c, g],
                  colRange: [h, u]
                }
              }
            }), i = !0, t = {};
          }
        },
        { tag: lc }
      );
    });
  }
  registerLegendHookAggEvents() {
    const t = this.composition().legend, i = [
      {
        componentPath: [xt.LEGEND],
        targets: Object.values(t).flat(1)
      },
      ...Object.keys(t).map((n) => ({
        componentPath: [xt.LEGEND, n],
        targets: t[n]
      }))
    ];
    [
      gt.BEFORE_RENDERED,
      gt.AFTER_RENDERED,
      gt.ANIMATION_END
    ].forEach((n) => {
      i.forEach(({ componentPath: A, targets: s }) => {
        let o = [];
        const r = s.filter((a) => !!a);
        r.forEach((a) => {
          const l = new Ie({
            componentPath: A,
            modifier: fe.EACH,
            hookName: n
          }), c = a.eventManager().listeners(l).find(
            (g) => W(g, "meta", "tag") === lc
          );
          c && this.eventManager().off(l, c.listener), a.eventManager().on(
            l,
            (g) => {
              o.push(g), o.length >= r.length && (this.emitEvent({
                name: new Ie({
                  componentPath: A,
                  modifier: fe.ALL,
                  hookName: n
                }),
                target: r,
                data: { aggEventObjects: o }
              }), o = []);
            },
            { tag: lc },
            {
              executePostPropagation: !0
            }
          );
        });
      });
    });
  }
  /**
   * Returns the instances of x axis of the canvas. It returns the instances in a two dimensional array form.
   *
   * ```
   *   // The first element in the sub array represents the top axis and the second element represents the bottom
   *   // axis.
   *   [
   *      [X1, X2],
   *      [X3, X4]
   *   ]
   * ```
   * @public
   *
   * @return {Array.<Array>} Instances of x axis.
   */
  xAxes() {
    return this.composition().visualGroup.getAxes("x");
  }
  /**
   * Returns the instances of y axis of the canvas. It returns the instances in a two dimensional array form.
   *
   * ```
   *   // The first element in the sub array represents the left axis and the second element represents the right
   *   // axis.
   *   [
   *      [Y1, Y2],
   *      [Y3, Y4]
   *   ]
   * ```
   * @public
   * @return {Array.<Array>} Instances of y axis.
   */
  yAxes() {
    return this.composition().visualGroup.getAxes("y");
  }
  /**
   * Returns all the retinal axis of the canvas. Color, shape and size axis are combinedly called retinal axis.
   *
   * @public
   * @return {Object} Instances of retinal axis.
   *          ```
   *              {
   *                  color: [ColorAxis], // Array of color axis.
   *                  shape: [ShapeAxis], // Array of shape axis.
   *                  size: [SizeAxis] // Array of size axis.
   *              }
   *          ```
   */
  getRetinalAxes() {
    return this.composition().visualGroup.getAxes(p7);
  }
  mount(...t) {
    if (t.length) {
      let i = t[0];
      return typeof t[0] == "string" && (i = V(t[0]).node()), this._mount = i, this;
    }
    return this._mount;
  }
  isRenderableInMountPoint() {
    const t = this.mount();
    return t && t instanceof Element && window.document.contains(t);
  }
  getLayoutRootNodeId() {
    return this._layoutManager.getRootNodeId();
  }
  getScrollableBoundBox(t) {
    const i = (t || this.composition().componentWrappers).find((r) => r instanceof MB);
    if (!i)
      return null;
    const { left: n, top: A } = i.getBoundBox(), { width: s, height: o } = this.composition().layout.measurement();
    return {
      left: n,
      top: A,
      width: s,
      height: o
    };
  }
  dispose() {
    if (this.emitSelfHooks(gt.BEFORE_DISPOSED), this.composition() == null)
      return;
    const { columnHeader: t, layout: i, legend: n, visualGroup: A } = this.composition();
    this._composition = null, this._store.unsubscribeAll(), this._throwback.unsubscribeAll(), this.firebolt().dispose(), A.remove(), t && t.remove(), i.remove(), this._layoutManager.removeAllComponents(), n != null && Object.values(n).forEach(
      (s) => s.forEach((o) => o.dispose())
    ), this.emitSelfHooks(gt.AFTER_DISPOSED), this._disposed = !0;
  }
  goToNextPage() {
    this.composition().visualGroup.goToNextPage(), this.reflow();
  }
  goToPreviousPage() {
    this.composition().visualGroup.goToPreviousPage(), this.reflow();
  }
  goToPage(t) {
    this.composition().visualGroup.goToPage(t), this.reflow();
  }
  goToLastPage() {
    this.composition().visualGroup.goToLastPage(), this.reflow();
  }
  getPaginationMetaInfo() {
    const i = this.composition().visualGroup.getPaginationInstance();
    return i ? {
      pageCount: i.getTotalPageCount(),
      totalFacetCount: i.getTotalFacetCount(),
      facetCountForCurrentPage: i.getFacetCountForCurrentPage(),
      currentPageNumber: i.getCurrentPageNumber(),
      rowsCountForCurrentPage: i.getRowsCount()
    } : null;
  }
  setRowCollapseState(t) {
    xy(this.props.rows.expandCollapseState, t);
    const { visualGroup: i, vScrollBar: n } = this.composition(), A = i.updateMatrices(t, "row");
    this._scrollState = {
      vScrollUnit: n?.getUnitScrollPosition(A.rowIndex),
      rowIndex: A.rowIndex,
      vScroll: n?.getScrollPercent(),
      columnIndex: -1,
      currentPageChanged: A.currentPageChanged
    }, this.reflow();
  }
  setColumnsCollapseState(t) {
    xy(this.props.columns.expandCollapseState, t);
    const { visualGroup: i, hScrollBar: n } = this.composition(), A = i.updateMatrices(t, "column");
    this._scrollState = {
      columnIndex: A.columnIndex,
      hScrollUnit: n?.getUnitScrollPosition(A.columnIndex),
      hScroll: n?.getScrollPercent(),
      rowIndex: -1,
      currentPageChanged: !1
    }, this.reflow();
  }
}
const _I = {
  data: {
    value: null,
    meta: {
      typeCheck: (e) => e && (e instanceof J.DataModel() || e instanceof J),
      sanitization: (e, t, i) => e && (e = e instanceof J ? e : new J(e, e._config), i instanceof Hl && (e.setCreatorIdentifier(i.alias()), e.openBroadcastChannel(), i._deregisterDMPreDisposeTask && i._deregisterDMPreDisposeTask(), e._model && (i._deregisterDMPreDisposeTask = e._model.registerPreDisposeTask(() => {
        i.dispose();
      }))), e)
    }
  },
  width: {
    value: 0,
    meta: {
      sanitization: da,
      typeCheck: Number.isInteger
    }
  },
  height: {
    value: 0,
    meta: {
      sanitization: da,
      typeCheck: Number.isInteger
    }
  },
  minUnitWidth: {
    value: 50,
    meta: {
      sanitization: da,
      typeCheck: Number.isInteger
    }
  },
  minUnitHeight: {
    value: 60,
    meta: {
      sanitization: da,
      typeCheck: Number.isInteger
    }
  },
  config: {
    value: [null, null],
    meta: {
      typeCheck: "constructor",
      typeExpected: "Object",
      takesMultipleParams: !0,
      sanitization: ([e, t = {}], i, n) => {
        const A = (h) => ["rows", "columns"].reduce((u, d) => (u[d] = {
          facets: {
            labels: {
              style: tt(
                {},
                BA(W(h, "theme", "font")),
                BA(
                  W(
                    h,
                    "theme",
                    "font",
                    "components",
                    "facets"
                  )
                )
              )
            }
          }
        }, u), {});
        n.layers()[0]?.mark === "text" && e && (e.axes?.x?.showAxisName && (e.axes.x.showAxisName = !1), e.axes?.y?.showAxisName && (e.axes.y.showAxisName = !1)), e = tt({}, e, A(e)), i = tt({}, i, A(i));
        const { reset: s = !1 } = t;
        let o = {};
        e && e.scrollBar && (e.scrollBar.horizontal && !Number.isNaN(e.scrollBar.horizontal.initialScrollPercent) && e.scrollBar.horizontal.initialScrollPercent !== f1(n._store) && u1(
          n._store,
          e.scrollBar.horizontal.initialScrollPercent || 0
        ), e.scrollBar.vertical && !Number.isNaN(e.scrollBar.vertical.initialScrollPercent) && e.scrollBar.vertical.initialScrollPercent !== d1(n._store) && h1(
          n._store,
          e.scrollBar.vertical.initialScrollPercent || 0
        ));
        const r = jZ(e);
        e = tt(e, r), s || (o = tt({}, e === null ? {} : i), o = Object.assign(
          o,
          ZZ(e, L7)
        ), zZ(o));
        const a = tt({}, mB, o), l = W(
          e,
          "axesHeaders",
          "column",
          "className"
        );
        l && (e.axesHeaders.column.className = `${a.axesHeaders.column.className} ${l}`);
        const c = tt(a, e), g = c.axes;
        return g.x.alignZeroLine && (g.x.nice = !1), g.y.alignZeroLine && (g.y.nice = !1), qZ(c);
      }
    }
  }
}, _1 = {
  [Ih.formalName()]: Ih,
  [rh.formalName()]: rh
}, ZX = {
  cells: SB,
  layers: U_
}, b1 = (e = _1) => {
  const t = Object.assign({}, e);
  return {
    register: (i) => {
      const n = i.formalName();
      return t[n] = i, b1;
    },
    get: () => t
  };
}, kh = {
  components: b1(_1),
  cells: SB(),
  layers: U_(),
  interactions: v9
};
class $X extends _e().with(ES("env")) {
  constructor(t) {
    super(), this.eventManager(t), this._eventAggMap = /* @__PURE__ */ new Map();
  }
  /**
   * Sets the data configuration property.
   * This is a getter-setter function.
   *
   * @param {DataModel} data Instance of datamodel to be visualized
   * @return {Env} Instance of the environment
   */
  data() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Sets the width configuration property. Width in px is total horizontal space each canvas should take.
   * This is a getter-setter function.
   *
   * @param {Number} width Width of the visualization area
   * @return {Env} Instance of the environment
   */
  width() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Sets the height configuration property. Height in px is total horizontal space each canvas should take.
   * This is a getter-setter function.
   *
   * @param {Number} width Height of the visualization area
   * @return {Env} Instance of the environment
   */
  height() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Sets the configuration property for setting minimum unit width. *Unit* here is {@link VisualUnit} component of
   * Muze.
   *
   * This is a getter-setter function.
   *
   * @param {Number} [minWidth = 150] Min width of a {@link VisualUnit}
   * @return {Env} Instance of the environment
   */
  minUnitWidth() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Sets the configuration property for setting minimum unit height. *Unit* here is {@link VisualUnit} component of
   * Muze.
   *
   * This is a getter-setter function.
   *
   * @param {Number} [minWidth = 150] Min height of a {@link VisualUnit}
   * @return {Env} Instance of the environment
   */
  minUnitHeight() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Sets the configuration for canvases. User passed configuration is merged with default configuration and then
   * set to canvas
   *
   * This is a getter-setter function.
   *
   * @param {Object} config Partial or full configuration of canvas.
   * @param {AxisConfig} config.axes.x X Axis configuration {@link AxisConfig}.
   * @param {AxisConfig} config.axes.y Y Axis configuration {@link AxisConfig}.
   * @param {GridLineConfig} config.gridLines Grid line configuration {@link GridLineConfig}.
   * @param {GridBandConfig} config.gridBands Grid band configuration {@link GridBandConfig}.
   * @param {GlobalLegendConfig} config.legend Legend configuration {@link GlobalLegendConfig}.
   * @param {InteractionConfig} config.interaction Interaction configuration {@link InteractionConfig}
   * @param {Object} config.autoGroupBy Group by configuration.
   * @param {boolean} config.autoGroupBy.disabled If true, then disables automatic group by of datamodel in the
   * chart. By default, set to false.
   * @return {Env} Instance of the environment
   */
  config() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   *  Creates an instance of {@link Canvas}
   *
   * @return {Canvas} Instance of canvas
   */
  canvas() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Components of Muze are loaded from registry. User can override the default component by overriding the registry
   * with new component definition.
   *
   * Muze creates multiple cells to house the visualization components. Those are called {@link Cells}.
   * `cellRegistry` is the registry for those cells.
   * - {@link SimpleCell}
   * - {@link TextCell}
   * - {@link AxisCell}
   * - {@link GeomCell}
   * - {@link BlankCell}
   *
   * This funciton acts as getter and setter.
   * When acts as a getter this returns the list of registries you can extend.
   * When acts as a setter this allows user to register a component for a existing key. During the process of setting
   * a new component in registry, it is not allowed to create a new key.
   *
   * ```
   *  const GeomCell = env.cellRegistry().GeomCell;
   *  env.cellRegistry({
   *      GeomCell: class NewGeomCell extends GeomCell {
   *          render () {
   *              // override the render
   *          }
   *      }
   * });
   * ```
   *
   * When called as a setter
   * @param {Object} override Key value pair where keys are the name of the cells user with to override. Allowed keys
   *      are
   *      - `SimpleCell`
   *      - `TextCell`
   *      - `AxisCell`
   *      - `GeomCell`
   *      - `BlankCell`
   *      And value being the overridden class definition.
   *
   * @return {Env} Instance of current environment
   *
   * When called as a getter
   * @return {object} Object containing the registration key and class definition
   *      ```
   *          {
   *              SimpleCell: SimpleCell,
   *              TextCell: TextCell,
   *              AxisCell: AxisCell,
   *              GeomCell: GeomCell,
   *              BlankCell: BlankCell
   *          }
   *      ```
   */
  cellRegistry() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  /**
   * Components of Muze are loaded from registry. User can override the default component by overriding the registry
   * with new component definition.
   *
   * Muze composes layers to create a visualization. Each layer contain one mark (plot) type. Superposition of
   * one or multiple such layers create one visulization. Muze provides definition of atomic layers. A new layer can
   * be created and used as a mark type. `layerRegistry` handles the registrtion process. Atomic layers are
   *      - {@link AreaLayer}
   *      - {@link ArcLayer}
   *      - {@link LineLayer}
   *      - {@link TextLayer}
   *      - {@link PointLayer}
   *      - {@link TickLayer}
   *      - {@link BarLayer}
   *      - {@link BaseLayer}
   *
   * For `layerRegistry` a new layer can be registered by using a new key.
   *
   * ```
   *  const PointLayer = env.layerRegistry().point;
   *  env.layerRegistry({
   *      grass: class GrassLayer extends PointLayer {
   *          render () {
   *              // renders layer here
   *          }
   *      }
   *  });
   * ```
   * Access the new layer type by mentioning it as a mark type
   * ```
   *  .layers([{
   *      mark: 'bar',
   *      encoding: {
   *          y: 'Acceleration'
   *      }
   *  }, {
   *      mark: 'grass', // new mark type
   *      encoding: {
   *          y: 'Displacement'
   *      }
   *  }])
   * ```
   *
   * When called as a setter
   * @param {Object} override Key value pair where keys are the name of the cells user with to override. Allowed keys
   *      are
   *      - `Area`
   *      - `Arc`
   *      - `Line`
   *      - `Text`
   *      - `Point`
   *      - `Tick`
   *      - `Bar`
   *      And value being the overridden class definition.
   *
   * @return {Env} Instance of current environment
   *
   * When called as a getter
   * @return {object} Object containing the registration key and class definition
   *      ```
   *          {
   *              Area: AreaLayer,
   *              Text: TextLayer,
   *              Arc: ArcLayer,
   *              Line: LineLayer,
   *              Bar: BarLayer,
   *              Line: LineLayer,
   *              Point: PointLayer,
   *              Tick: TickLayer
   *          }
   *      ```
   */
  layerRegistry() {
    throw new Error(dt.INTERFACE_IMPL);
  }
  registerAggHooks(t) {
    [
      gt.BEFORE_RENDERED,
      gt.AFTER_RENDERED,
      gt.BEFORE_LAYOUT,
      gt.AFTER_LAYOUT,
      gt.BEFORE_DISPOSED,
      gt.AFTER_DISPOSED,
      gt.ANIMATION_END
    ].forEach((n) => {
      t.eventManager().once(
        new Ie({
          componentPath: [xt.CANVAS],
          modifier: fe.EACH,
          hookName: n
        }),
        (A) => {
          const s = this._eventAggMap.get(n);
          s.eventObjects.push(A), s.eventObjects.length === s.canvases.length && (this.emitEvent({
            name: new Ie({
              componentPath: [xt.CANVAS],
              modifier: fe.ALL,
              hookName: n
            }),
            target: s.canvases,
            data: { aggEventObjects: s.eventObjects }
          }), s.eventObjects = [], s.canvases = []);
        }
      ), this._eventAggMap.has(n) ? this._eventAggMap.get(n).canvases.push(t) : this._eventAggMap.set(n, {
        canvases: [t],
        eventObjects: []
      });
    });
  }
  dispose() {
    this._eventAggMap.clear();
  }
}
const { transactor: XX, LabelManager: ttt, getDataStore: ett } = Zx, Wd = {}, itt = kh.components, Uy = (e, t) => {
  e.forEach((i) => {
    t.register(i);
  });
}, Oy = (e) => {
  const t = {};
  for (let i in e)
    t[i] = wa(e[i]);
  return t;
}, ntt = (e) => ({
  ...e
}), nn = () => {
  const e = ett(), t = new $X(new iE(null)), i = XX(t, _I)[1], n = Object.assign({}, kh.components.get()), A = Object.assign({}, ZX), s = {};
  for (const r in A)
    s[r] = A[r](
      kh[r].get()
    );
  const o = ntt({
    interactionFilters: nj()
  });
  return t.canvas = () => {
    const r = i.serialize(), { visualGroup: a, legend: l } = YN.registry(), c = Hl.withSettings(
      r,
      {
        /* registry */
        components: n,
        componentSubRegistry: s,
        interactions: {
          visualGroup: Oy(a),
          legend: Oy(l)
        }
      },
      t.globalDependencies(),
      o,
      t.createChildEventManager()
    );
    return t.registerAggHooks(c), c;
  }, t.globalDependencies = () => (Wd.smartlabel || (Wd.smartlabel = new ttt(1, "body")), {
    smartlabel: Wd.smartlabel,
    DataStore: e
  }), t.settings = () => i.serialize(), t.registry = (...r) => r.length ? (r.forEach((a) => {
    const l = a.formalName();
    l in itt && (n[l] = a);
  }), t) : n, t.cellRegistry = (...r) => {
    const a = s.cellRegistry;
    return r.length ? (Uy(r, a), t) : a.get();
  }, t.layerRegistry = (...r) => {
    const a = s.layerRegistry;
    return r.length ? (Uy(r, a), t) : a.get();
  }, t;
};
nn.registry = kh;
nn.Components = {
  VisualLayer: {
    layers: {
      BaseLayer: AA,
      LineLayer: E_,
      TextLayer: Q_,
      TickLayer: __,
      PointLayer: x_,
      SimpleLayer: BS,
      AreaLayer: f_,
      ArcLayer: C_
    },
    helpers: M6,
    enums: S6,
    layerMixins: _6
  },
  VisualUnit: {
    constructor: rh,
    helpers: G6,
    enums: iW,
    UnitFireBolt: hb
  },
  VisualGroup: {
    constructor: Ih,
    Encoders: qV,
    encoderHelpers: VV,
    groupUtils: vW,
    enums: t5
  },
  Canvas: {
    constructor: Hl
  },
  Firebolt: {
    constructor: to
  }
};
const Att = {
  sideEffects: WE,
  standards: {
    SurrogateSideEffect: $t,
    SpawnableSideEffect: Tr,
    GenericSideEffect: Fu
  }
}, stt = {
  behaviouralActions: OE,
  standards: {
    GenericBehaviour: Qi,
    PersistentBehaviour: Tl,
    VolatileBehaviour: kl
  }
}, ott = {
  MuzeLight: B_,
  ModeLight: zK,
  DummyLight: ZK
};
nn.DataStore = J;
nn.DataModel = Ht;
nn.version = hj.version;
nn.SideEffects = Att;
nn.ActionModel = YN;
nn.layerFactory = Bi;
nn.Operators = b7;
nn.Behaviours = stt;
nn.utils = Zx;
nn.Themes = ott;
export {
  nn as default
};
